(function(window){
  'use strict';

  window.zoid.create({
    tag: 'bluemoon-login',
    buildUrl: function () {
      var hostPath = '//' + location.host + location.pathname;
      var hostPathMap = {
        '//localhost:8080/': '//localhost:9000/', // local dev hostPath
        '//cswebdev.int.thomsonreuters.com/register/': '//demo.onvio.us/',
        '//cswebqa.int.thomsonreuters.com/register/': '//qed.onvio.us/',
        '//cs.thomsonreuters.com/register/': '//onvio.us/'
      };
      return location.href.replace(hostPath, hostPathMap[hostPath] || hostPath);
    },
    dimensions: {
      width: '100%',
      height: '100%'
    },
    scrolling: true,
    defaultLogLevel: 'error'
  });
})(window);

/**
 * @license AngularJS v1.8.0
 * (c) 2010-2020 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

var minErrConfig = {
  objectMaxDepth: 5,
  urlErrorParamsEnabled: true
};

/**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */
function errorHandlingConfig(config) {
  if (isObject(config)) {
    if (isDefined(config.objectMaxDepth)) {
      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
    }
    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
    }
  } else {
    return minErrConfig;
  }
}

/**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
function isValidObjectMaxDepth(maxDepth) {
  return isNumber(maxDepth) && maxDepth > 0;
}


/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace'). Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;

  var url = 'https://errors.angularjs.org/1.8.0/';
  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
  var errRegExp = new RegExp(regex, 'g');

  return function() {
    var code = arguments[0],
      template = arguments[1],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
      paramPrefix, i;

    // A minErr message has two parts: the message itself and the url that contains the
    // encoded message.
    // The message's parameters can contain other error messages which also include error urls.
    // To prevent the messages from getting too long, we strip the error urls from the parameters.

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1);

      if (index < templateArgs.length) {
        return templateArgs[index].replace(errRegExp, '');
      }

      return match;
    });

    message += '\n' + url + (module ? module + '/' : '') + code;

    if (minErrConfig.urlErrorParamsEnabled) {
      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
      }
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,
  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (key !== '__proto__') {
            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
            baseExtend(dst[key], [src], true);
          }
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest using another, similar library for all-purpose merging,
* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* `angular.merge` also does not support merging objects with circular references.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
function isArray(arr) {
  return Array.isArray(arr) || arr instanceof Array;
}

/**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
function isError(value) {
  var tag = toString.call(value);
  switch (tag) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
 * function, and has several limitations (see below).
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 *
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * <div class="alert alert-warning">
 *   `angular.copy` does not check if destination and source are of the same type. It's the
 *   developer's responsibility to make sure they are compatible.
 * </div>
 *
 * @knownIssue
 * This is a non-exhaustive list of object types / features that are not handled correctly by
 * `angular.copy`. Note that since this functions is used by the change detection code, this
 * means binding or watching objects of these types (or that include these types) might not work
 * correctly.
 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
 *
 * @param {*} source The source that will be used to make a copy. Can be any type, including
 *     primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
 *     must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination, maxDepth) {
  var stackSource = [];
  var stackDest = [];
  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination, maxDepth);
  }

  return copyElement(source, maxDepth);

  function copyRecurse(source, destination, maxDepth) {
    maxDepth--;
    if (maxDepth < 0) {
      return '...';
    }
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i], maxDepth));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key], maxDepth);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source, maxDepth) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination, maxDepth)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


// eslint-disable-next-line no-self-compare
function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone().empty();
  var elemHtml = jqLite('<div></div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;

  if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
    return true;
  }

  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
    return false;
  }

  var attributes = script.attributes;
  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

  return srcs.every(function(src) {
    if (!src) {
      return true;
    }
    if (!src.value) {
      return false;
    }

    var link = document.createElement('a');
    link.href = src.value;

    if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for non-whitelisted schemes.
      return true;
    }
    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
    // content security policy in web pages and other browser extensions.
    switch (link.protocol) {
      case 'http:':
      case 'https:':
      case 'ftp:':
      case 'blob:':
      case 'file:':
      case 'data:':
        return true;
      default:
        return false;
    }
  });
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: /** @type {?} */ (JQLitePrototype).controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });
  } else {
    jqLite = JQLite;
  }

  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
  // the $destroy event on all removed nodes.
  originalCleanData = jqLite.cleanData;
  jqLite.cleanData = function(elems) {
    var events;
    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
      events = (jqLite._data(elem) || {}).events;
      if (events && events.$destroy) {
        jqLite(elem).triggerHandler('$destroy');
      }
    }
    originalCleanData(elems);
  };

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * @ngdoc function
 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
 * @module ng
 * @kind function
 *
 * @description
 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
 * your code for this change and remove your use of this function as soon as possible.

 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 */
function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
  JQLite.legacyXHTMLReplacement = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {

      var info = {};

      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
          info: function(value) {
            if (isDefined(value)) {
              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
              info = value;
              return this;
            }
            return info;
          },

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* exported toDebugString */

function serializeObject(obj, maxDepth) {
  var seen = [];

  // There is no direct way to stringify object until reaching a specific depth
  // and a very deep object can cause a performance issue, so we copy the object
  // based on this specific depth and then stringify it.
  if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
    obj = angular.copy(obj, null, maxDepth);
  }
  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj, maxDepth) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj, maxDepth);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  hiddenInputBrowserCacheDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.8.0',
  major: 1,
  minor: 8,
  dot: 0,
  codeName: 'nested-vaccination'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'errorHandlingConfig': errorHandlingConfig,
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$lowercase': lowercase,
    '$$stringify': stringify,
    '$$uppercase': uppercase
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRef: ngRefDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective,
          input: hiddenInputBrowserCacheDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $$intervalFactory: $$IntervalFactoryProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ])
  .info({ angularVersion: '1.8.0' });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
 * ```js
 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
 * ```
 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

// Table parts need to be wrapped with `<table>` or they're
// stripped to their contents when put in a div.
// XHTML parsers do not magically insert elements in the
// same way that tag soup parsers do, so we cannot shorten
// this by omitting <tbody> or other required elements.
var wrapMap = {
  thead: ['table'],
  col: ['colgroup', 'table'],
  tr: ['tbody', 'table'],
  td: ['tr', 'tbody', 'table']
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <10 only
// IE 9 requires an option wrapper & it needs to have the whole table structure
// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
var wrapMapIE9 = {
  option: [1, '<select multiple="multiple">', '</select>'],
  _default: [0, '', '']
};

for (var key in wrapMap) {
  var wrapMapValueClosing = wrapMap[key];
  var wrapMapValue = wrapMapValueClosing.slice().reverse();
  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
}

wrapMapIE9.optgroup = wrapMapIE9.option;

function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap, finalHtml,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    finalHtml = JQLite.legacyXHTMLReplacement ?
      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
      html;

    if (msie < 10) {
      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];

      // Descend through wrappers to the right content
      i = wrap[0];
      while (i--) {
        tmp = tmp.firstChild;
      }
    } else {
      wrap = wrapMap[tag] || [];

      // Create wrappers & descend into them
      i = wrap.length;
      while (--i > -1) {
        tmp.appendChild(window.document.createElement(wrap[i]));
        tmp = tmp.firstChild;
      }

      tmp.innerHTML = finalHtml;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

  if (element.querySelectorAll) {
    jqLite.cleanData(element.querySelectorAll('*'));
  }
}

function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }
  return true;
}

function removeIfEmptyData(element) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  var events = expandoStore && expandoStore.events;
  var data = expandoStore && expandoStore.data;

  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }

  removeIfEmptyData(element);
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
    } else {
      expandoStore.data = {};
    }

    removeIfEmptyData(element);
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
        newClasses += cssClass + ' ';
      }
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: function jqLiteCleanData(nodes) {
    for (var i = 0, ii = nodes.length; i < ii; i++) {
      jqLiteRemoveData(nodes[i]);
      jqLiteOff(nodes[i]);
    }
  }
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

// A minimal ES2015 Map implementation.
// Should be bug/feature equivalent to the native implementations of supported browsers
// (for the features required in Angular).
// See https://kangax.github.io/compat-table/es6/#test-Map
var nanKey = Object.create(null);
function NgMapShim() {
  this._keys = [];
  this._values = [];
  this._lastKey = NaN;
  this._lastIndex = -1;
}
NgMapShim.prototype = {
  _idx: function(key) {
    if (key !== this._lastKey) {
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
    }
    return this._lastIndex;
  },
  _transformKey: function(key) {
    return isNumberNaN(key) ? nanKey : key;
  },
  get: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx !== -1) {
      return this._values[idx];
    }
  },
  has: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    return idx !== -1;
  },
  set: function(key, value) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      idx = this._lastIndex = this._keys.length;
    }
    this._keys[idx] = key;
    this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
  },
  delete: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      return false;
    }
    this._keys.splice(idx, 1);
    this._values.splice(idx, 1);
    this._lastKey = NaN;
    this._lastIndex = -1;
    return true;
  }
};

// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
// implementations get more stable, we can reconsider switching to `window.Map` (when available).
var NgMap = NgMapShim;

var $$MapProvider = [/** @this */function() {
  this.$get = [function() {
    return NgMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  return Function.prototype.toString.call(fn);
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */


/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
/**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */


/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  instanceInjector.modules = providerInjector.modules = createMap();
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  instanceInjector.loadNewModules = function(mods) {
    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
  };


  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.set(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          instanceInjector.modules[module] = moduleFn;
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new NgMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.delete(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.set(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;
  var classNameFilter = null;
  var customFilter = null;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
  this.customFilter = function(filterFn) {
    if (arguments.length === 1) {
      customFilter = isFunction(filterFn) ? filterFn : null;
    }

    return customFilter;
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (classNameFilter) {
        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
        if (reservedRegex.test(classNameFilter.toString())) {
          classNameFilter = null;
          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */
      cancel: function(runner) {
        if (runner.cancel) {
          runner.cancel();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global getHash: true, stripHash: false */

function getHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? '' : url.substr(index);
}

function trimEmptyHash(url) {
  return url.replace(/#$/, '');
}

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {},
      taskTracker = $$taskTrackerFactory($log);

  self.isMock = false;

  //////////////////////////////////////////////////////////////
  // Task-tracking API
  //////////////////////////////////////////////////////////////

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = taskTracker.completeTask;
  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;

  // TODO(vojta): prefix this method with $$ ?
  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Normalize the inputted URL
      url = urlResolve(url).href;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      return trimEmptyHash(pendingLocation || location.href);
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    fireStateOrUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }

    lastCachedState = cachedState;
    lastHistoryState = cachedState;
  }

  function fireStateOrUrlChange() {
    var prevLastHistoryState = lastHistoryState;
    cacheState();

    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireStateOrUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay, taskType) {
    var timeoutId;

    delay = delay || 0;
    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;

    taskTracker.incTaskCount(taskType);
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      taskTracker.completeTask(fn, taskType);
    }, delay);
    pendingDeferIds[timeoutId] = taskType;

    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds.hasOwnProperty(deferId)) {
      var taskType = pendingDeferIds[deferId];
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      taskTracker.completeTask(noop, taskType);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
  }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance.)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that are defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // Configure new 'compile' directive by passing a directive
        // factory function. The factory function injects '$compile'.
        $compileProvider.directive('compile', function($compile) {
          // The directive factory creates a link function.
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                // Watch the 'compile' expression for changes.
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // When the 'compile' expression changes
                // assign it into the current DOM.
                element.html(value);

                // Compile the new DOM and link it to the current scope.
                // NOTE: we only compile '.childNodes' so that we
                // don't get into an infinite loop compiling ourselves.
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
 *        elements (e.g. SVG elements). See also the `directive.controller` property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to `$digest`, which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = angular.element('<p>{{total}}</p>');
 *     $compile(element)(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
 *   linking function:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>');
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       // Attach the clone to DOM document at the right place.
 *     });
 *
 *     // Now we have reference to the cloned DOM via `clonedElement`.
 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
 *     //       `clonedElement` passed to `cloneAttachFn`.
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */

/**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist()}
 * and {@link $sceDelegateProvider#resourceUrlBlacklist resourceUrlBlacklist()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-whitelisted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */

/** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      definition = definition.trim();

      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
   *    are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    if (!isString(name)) {
      forEach(name, reverseParams(bind(this, registerComponent)));
      return this;
    }

    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */
  var strictComponentBindingsEnabled = false;
  this.strictComponentBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      strictComponentBindingsEnabled = enabled;
      return this;
    }
    return strictComponentBindingsEnabled;
  };

  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };


  /**
   * The security context of DOM Properties.
   * @private
   */
  var PROP_CONTEXTS = createMap();

  /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */
  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());

    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
    }

    PROP_CONTEXTS[key] = ctx;
    return this;
  };

  /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */
  (function registerNativePropertyContexts() {
    function registerContext(ctx, values) {
      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
    }

    registerContext(SCE_CONTEXTS.HTML, [
      'iframe|srcdoc',
      '*|innerHTML',
      '*|outerHTML'
    ]);
    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
    registerContext(SCE_CONTEXTS.URL, [
      'area|href',       'area|ping',
      'a|href',          'a|ping',
      'blockquote|cite',
      'body|background',
      'del|cite',
      'input|src',
      'ins|cite',
      'q|cite'
    ]);
    registerContext(SCE_CONTEXTS.MEDIA_URL, [
      'audio|src',
      'img|src',    'img|srcset',
      'source|src', 'source|srcset',
      'track|src',
      'video|src',  'video|poster'
    ]);
    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
      '*|formAction',
      'applet|code',      'applet|codebase',
      'base|href',
      'embed|src',
      'frame|src',
      'form|action',
      'head|profile',
      'html|manifest',
      'iframe|src',
      'link|href',
      'media|src',
      'object|codebase',  'object|data',
      'script|src'
    ]);
  })();


  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
        });
      } finally {
        onChangesTtl++;
      }
    }


    function sanitizeSrcset(value, invokeType) {
      if (!value) {
        return value;
      }
      if (!isString(value)) {
        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
      }

      // Such values are a bit too complex to handle automatically inside $sce.
      // Instead, we sanitize each of the URIs individually, which works, even dynamically.

      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
      // `ng-bind-html` directive.

      var result = '';

      // first check if there are spaces because it's not the same pattern
      var trimmedSrcset = trim(value);
      //                (   999x   ,|   999w   ,|   ,|,   )
      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

      // split srcset into tuple of uri and descriptor except for the last item
      var rawUris = trimmedSrcset.split(pattern);

      // for each tuples
      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
      for (var i = 0; i < nbrUrisWith2parts; i++) {
        var innerIdx = i * 2;
        // sanitize the uri
        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
        // add the descriptor
        result += ' ' + trim(rawUris[innerIdx + 1]);
      }

      // split the last item into uri and descriptor
      var lastTuple = trim(rawUris[i * 2]).split(/\s/);

      // sanitize the last uri
      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));

      // and add the last descriptor if any
      if (lastTuple.length === 2) {
        result += (' ' + trim(lastTuple[1]));
      }
      return result;
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        // is set through this function since it may cause $updateClass to
        // become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        // Sanitize img[srcset] values.
        if (nodeName === 'img' && key === 'srcset') {
          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              // jQuery skips special boolean attrs treatment in XML nodes for
              // historical reasons and hence AngularJS cannot freely call
              // `.attr(attrName, false) with such attributes. To avoid issues
              // in XHTML, call `removeAttr` in such cases instead.
              // See https://github.com/jquery/jquery/issues/4249
              if (booleanKey && value === false) {
                this.$$element.removeAttr(attrName);
              } else {
                this.$$element.attr(attrName, value);
              }
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            var isNgAttr = false, isNgProp = false, isNgEvent = false;
            var multiElementMatch;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            nName = directiveNormalize(name.toLowerCase());

            // Support ng-attr-*, ng-prop-* and ng-on-*
            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
              isNgAttr = ngPrefixMatch[1] === 'Attr';
              isNgProp = ngPrefixMatch[1] === 'Prop';
              isNgEvent = ngPrefixMatch[1] === 'On';

              // Normalize the non-prefixed name
              name = name.replace(PREFIX_REGEXP, '')
                .toLowerCase()
                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });

            // Support *-start / *-end multi element directives
            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            if (isNgProp || isNgEvent) {
              attrs[nName] = value;
              attrsMap[nName] = attr.name;

              if (isNgProp) {
                addPropertyDirective(node, directives, nName, name);
              } else {
                addEventDirective(directives, nName, name);
              }
            } else {
              // Update nName for cases where a prefix was removed
              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
              nName = directiveNormalize(name.toLowerCase());
              attrsMap[nName] = name;

              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
              }

              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                            attrEndName);
            }
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = window.document.createDocumentFragment();

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
                  slots[slotName].appendChild(node);
                } else {
                  $template.appendChild(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                }
              }

              $template = jqLite($template.childNodes);
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          controller.instance = controller();
          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
          controller.bindingInfo =
            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';

          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
            // inheritedData() uses the documentElement when it finds the document, so we would
            // require from the element itself.
            value = null;
          } else {
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedAttrContext(nodeName, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      // All nodes with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media nodes, which require the MEDIA_URL context.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
          return $sce.RESOURCE_URL;
        }
        return $sce.MEDIA_URL;
      } else if (attrNormalizedName === 'xlinkHref') {
        // Some xlink:href are okay, most aren't
        if (nodeName === 'image') return $sce.MEDIA_URL;
        if (nodeName === 'a') return $sce.URL;
        return $sce.RESOURCE_URL;
      } else if (
          // Formaction
          (nodeName === 'form' && attrNormalizedName === 'action') ||
          // If relative URLs can go where they are not expected to, then
          // all sorts of trust issues can arise.
          (nodeName === 'base' && attrNormalizedName === 'href') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (nodeName === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
                                 attrNormalizedName === 'ngHref')) {
        return $sce.URL;
      }
    }

    function getTrustedPropContext(nodeName, propNormalizedName) {
      var prop = propNormalizedName.toLowerCase();
      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
    }

    function sanitizeSrcsetPropertyValue(value) {
      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
    }
    function addPropertyDirective(node, directives, attrName, propName) {
      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
      }

      var nodeName = nodeName_(node);
      var trustedContext = getTrustedPropContext(nodeName, propName);

      var sanitizer = identity;
      // Sanitize img[srcset] + source[srcset] values.
      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
        sanitizer = sanitizeSrcsetPropertyValue;
      } else if (trustedContext) {
        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
      }

      directives.push({
        priority: 100,
        compile: function ngPropCompileFn(_, attr) {
          var ngPropGetter = $parse(attr[attrName]);
          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
            return $sce.valueOf(val);
          });

          return {
            pre: function ngPropPreLinkFn(scope, $element) {
              function applyPropValue() {
                var propValue = ngPropGetter(scope);
                $element[0][propName] = sanitizer(propValue);
              }

              applyPropValue();
              scope.$watch(ngPropWatch, applyPropValue);
            }
          };
        }
      });
    }

    function addEventDirective(directives, attrName, eventName) {
      directives.push(
        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
      );
    }

    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var nodeName = nodeName_(node);
      var trustedContext = getTrustedAttrContext(nodeName, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }

    function strictBindingsCheck(attrName, directiveName) {
      if (strictComponentBindingsEnabled) {
        throw $compileMinErr('missingattr',
          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
          attrName, directiveName);
      }
    }

    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;

      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
              destination[scopeName] = attrs[attrName] = undefined;

            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = simpleCompare;
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var isLiteral = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            });

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
            }
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {};

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  this.$get = ['$injector', function($injector) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value) || isFunction(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          if (isFunction(toSerialize)) {
            toSerialize = toSerialize();
          }
          parts.push(encodeUriQuery(prefix) + '=' +
              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

      if (hasJsonContentType || isJsonLike(tempData)) {
        try {
          data = fromJson(tempData);
        } catch (e) {
          if (!hasJsonContentType) {
            return data;
          }
          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
          'Parse error: "{1}"', data, e);
        }
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */
  var interceptorFactories = this.interceptors = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to whitelist specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfWhitelistedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfWhitelistedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */
  var xsrfWhitelistedOrigins = this.xsrfWhitelistedOrigins = [];

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * A function to check request URLs against a list of allowed origins.
     */
    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfWhitelistedOrigins);

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can whitelist additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfWhitelistedOrigins xsrfWhitelistedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfWhitelistedOrigins $httpProvider.xsrfWhitelistedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only whitelist origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must whitelist the JSONP endpoint that we are using to show that we trust it
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount('$http');

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop, '$http');
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the whitelist via
     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
            : isObject(/** @type {?} */ (defaults).cache)
              ? /** @type {?} */ (defaults).cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsAllowedOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText, xhrStatus) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText, xhrStatus);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText, xhrStatus) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText,
          xhrStatus: xhrStatus
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, cbKey) {
      var parts = url.split('?');
      if (parts.length > 2) {
        // Throw if the url contains more than one `?` query indicator
        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
      }
      var params = parseKeyValue(parts[1]);
      forEach(params, function(value, key) {
        if (value === 'JSON_CALLBACK') {
          // Throw if the url already contains a reference to JSON_CALLBACK
          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
        }
        if (key === cbKey) {
          // Throw if the callback param was already provided
          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
        }
      });

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text, 'complete');
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);
      var abortedByTimeout = false;

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            'complete');
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'error');
      };

      var requestAborted = function() {
        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
      };

      var requestTimeout = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'timeout');
      };

      xhr.onerror = requestError;
      xhr.ontimeout = requestTimeout;
      xhr.onabort = requestAborted;

      forEach(eventHandlers, function(value, key) {
        xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    // Since we are using xhr.abort() when a request times out, we have to set a flag that
    // indicates to requestAborted if the request timed out or was aborted.
    //
    // http.timeout = numerical timeout   timeout
    // http.timeout = $timeout            timeout
    // http.timeout = promise             abort
    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
    //                                    can be exposed with the xhrFactory)
    if (timeout > 0) {
      var timeoutId = $browserDefer(function() {
        timeoutRequest('timeout');
      }, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(function() {
        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
      });
    }

    function timeoutRequest(reason) {
      abortedByTimeout = reason === 'timeout';
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText, xhrStatus);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    }
    return startSymbol;
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    }
    return endSymbol;
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;

      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        if (mustHaveExpression) return;

        var unescapedText = unescapeText(text);
        if (contextAllowsConcatenation) {
          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
        }
        var constantInterp = valueFn(unescapedText);
        constantInterp.exp = text;
        constantInterp.expressions = [];
        constantInterp.$$watchDelegate = constantWatchDelegate;

        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns,
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [],
          singleExpression;


      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      singleExpression = concat.length === 1 && expressionPositions.length === 1;
      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
      // objects rather than simple strings
      // (we don't modify the expression if the input consists of only a single trusted input)
      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
      // that is more testable or make it obvious that you bound the value to some user controlled
      // value.  This helps reduce the load when auditing for XSS issues.

      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
      // or on the overall concatenated string (losing trusted types used in the mix, by design).
      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
      // only used in srcdoc attributes, this would not be very useful.

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }

          if (contextAllowsConcatenation) {
            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
          } else if (trustedContext && concat.length > 1) {
            // This context does not allow more than one part, e.g. expr + string or exp + exp.
            $interpolateMinErr.throwNoconcat(text);
          }
          // In an unprivileged context or only one part: just concatenate and return.
          return concat.join('');
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
          // parts of a full URL. We don't care about losing the trustedness here.
          // In non-concatenable contexts, where there is only one expression, this interceptor is
          // not applied to the expression.
          value = (trustedContext && !contextAllowsConcatenation) ?
                    $sce.getTrusted(trustedContext, value) :
                    $sce.valueOf(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

var $intervalMinErr = minErr('$interval');

/** @this */
function $IntervalProvider() {
  this.$get = ['$$intervalFactory', '$window',
       function($$intervalFactory,   $window) {
    var intervals = {};
    var setIntervalFn = function(tick, delay, deferred) {
      var id = $window.setInterval(tick, delay);
      intervals[id] = deferred;
      return id;
    };
    var clearIntervalFn = function(id) {
      $window.clearInterval(id);
      delete intervals[id];
    };

    /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */
    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);

    /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */
    interval.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$intervalId')) {
        throw $intervalMinErr('badprom',
            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
      }

      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;

      var id = promise.$$intervalId;
      var deferred = intervals[id];

      // Interval cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      clearIntervalFn(id);

      return true;
    };

    return interval;
  }];
}

/** @this */
function $$IntervalFactoryProvider() {
  this.$get = ['$browser', '$q', '$$q', '$rootScope',
       function($browser,   $q,   $$q,   $rootScope) {
    return function intervalFactory(setIntervalFn, clearIntervalFn) {
      return function intervalFn(fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

        count = isDefined(count) ? count : 0;

        function callback() {
          if (!hasParams) {
            fn(iteration);
          } else {
            fn.apply(null, args);
          }
        }

        function tick() {
          if (skipApply) {
            $browser.defer(callback);
          } else {
            $rootScope.$evalAsync(callback);
          }
          deferred.notify(iteration++);

          if (count > 0 && iteration >= count) {
            deferred.resolve(iteration);
            clearIntervalFn(promise.$$intervalId);
          }

          if (!skipApply) $rootScope.$apply();
        }

        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);

        return promise;
      };
    };
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = function() {
    var callbacks = angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  };
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

/* global stripHash: true */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    // decode forward slashes to prevent them from being double encoded
    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
  }

  return segments.join('/');
}

function decodePath(path, html5Mode) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = decodeURIComponent(segments[i]);
    if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
      segments[i] = segments[i].replace(/\//g, '%2F');
    }
  }

  return segments.join('/');
}

function normalizePath(pathValue, searchValue, hashValue) {
  var search = toKeyValue(searchValue),
    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
    path = encodePath(pathValue);

  return path + (search ? '?' + search : '') + hash;
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj, html5Mode) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
  locationObj.$$path = decodePath(path, html5Mode);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}

function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, true);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  this.$$normalizeUrl = function(url) {
    return appBaseNoFile + url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          /** @type {?} */ (this).replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this, false);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  this.$$normalizeUrl = function(url) {
    return appBase + (url ? hashPrefix + url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$normalizeUrl = function(url) {
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    return appBase + hashPrefix + url;
  };
}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */
  $$compose: function() {
    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
    this.$$absUrl = this.$$normalizeUrl(this.$$url);
    this.$$urlUpdatedByLocation = true;
  },

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;
    this.$$urlUpdatedByLocation = true;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    // Determine if two URLs are equal despite potentially having different encoding/normalizing
    //  such as $location.absUrl() vs $browser.url()
    // See https://github.com/angular/angular.js/issues/16592
    function urlsEqual(a, b) {
      return a === b || urlResolve(a).href === urlResolve(b).href;
    }

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the AngularJS application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if ($location.absUrl() !== initialUrl) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      if (initializing || $location.$$urlUpdatedByLocation) {
        $location.$$urlUpdatedByLocation = false;

        var oldUrl = $browser.url();
        var newUrl = $location.absUrl();
        var oldState = $browser.state();
        var currentReplace = $location.$$replace;
        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

        if (initializing || urlOrStateChanged) {
          initializing = false;

          $rootScope.$evalAsync(function() {
            var newUrl = $location.absUrl();
            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
                $location.$$state, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
            } else {
              if (urlOrStateChanged) {
                setBrowserUrlWithFallback(newUrl, currentReplace,
                                          oldState === $location.$$state ? null : $location.$$state);
              }
              afterLocationChange(oldUrl, oldState);
            }
          });
        }
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (isError(arg)) {
        if (arg.stack && formatStackTrace) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop;

      return function() {
        var args = [];
        forEach(arguments, function(arg) {
          args.push(formatError(arg));
        });
        // Support: IE 9 only
        // console methods don't inherit from Function.prototype in IE 9 so we can't
        // call `logFn.apply(console, args)` directly.
        return Function.prototype.apply.call(logFn, console, args);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing AngularJS Expressions
// ------------------------------
// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following AngularJS expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

var PURITY_ABSOLUTE = 1;
var PURITY_RELATIVE = 2;

// Detect nodes which could depend on non-shallow state of objects
function isPure(node, parentIsPure) {
  switch (node.type) {
    // Computed members might invoke a stateful toString()
    case AST.MemberExpression:
      if (node.computed) {
        return false;
      }
      break;

    // Unary always convert to primative
    case AST.UnaryExpression:
      return PURITY_ABSOLUTE;

    // The binary + operator can invoke a stateful toString().
    case AST.BinaryExpression:
      return node.operator !== '+' ? PURITY_ABSOLUTE : false;

    // Functions / filters probably read state from within objects
    case AST.CallExpression:
      return false;
  }

  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
}

function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;

  var astIsPure = ast.isPure = isPure(ast, parentIsPure);

  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
      allConstants = allConstants && property.value.constant;
      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      if (property.computed) {
        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
        allConstants = allConstants && property.key.constant;
        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler($filter) {
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(ast) {
    var self = this;
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var inputs = this.state.inputs;
    var self = this;
    forEach(inputs, function(input) {
      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
      if (input.isPure) {
        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
      }
    });
    if (inputs.length) {
      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter($filter) {
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(ast) {
    var self = this;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        input.isPure = watch.isPure;
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
function Parser(lexer, $filter, options) {
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
                                   new ASTCompiler($filter);
}

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    var ast = this.getAst(text);
    var fn = this.astCompiler.compile(ast.ast);
    fn.literal = isLiteral(ast.ast);
    fn.constant = isConstant(ast.ast);
    fn.oneTime = ast.oneTime;
    return fn;
  },

  getAst: function(exp) {
    var oneTime = false;
    exp = exp.trim();

    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
      oneTime = true;
      exp = exp.substring(2);
    }
    return {
      ast: this.ast.ast(exp),
      oneTime: oneTime
    };
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    $parse.$$getAst = $$getAst;
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);

            cache[cacheKey] = addWatchDelegate(parsedExpression);
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function $$getAst(exp) {
      var lexer = new Lexer($parseOptions);
      var parser = new Parser(lexer, $filter, $parseOptions);
      return parser.getAst(exp).ast;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object' && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
      var unwatch, lastValue;

      var exp = parsedExpression.$$intercepted || parsedExpression;
      var post = parsedExpression.$$interceptor || identity;

      var useInputs = parsedExpression.inputs && !exp.inputs;

      // Propogate the literal/inputs/constant attributes
      // ... but not oneTime since we are handling it
      oneTimeWatch.literal = parsedExpression.literal;
      oneTimeWatch.constant = parsedExpression.constant;
      oneTimeWatch.inputs = parsedExpression.inputs;

      // Allow other delegates to run on this wrapped expression
      addWatchDelegate(oneTimeWatch);

      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);

      return unwatch;

      function unwatchIfDone() {
        if (isDone(lastValue)) {
          unwatch();
        }
      }

      function oneTimeWatch(scope, locals, assign, inputs) {
        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
        if (isDone(lastValue)) {
          scope.$$postDigest(unwatchIfDone);
        }
        return post(lastValue);
      }
    }

    function isAllDefined(value) {
      var allDefined = true;
      forEach(value, function(val) {
        if (!isDefined(val)) allDefined = false;
      });
      return allDefined;
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addWatchDelegate(parsedExpression) {
      if (parsedExpression.constant) {
        parsedExpression.$$watchDelegate = constantWatchDelegate;
      } else if (parsedExpression.oneTime) {
        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
      } else if (parsedExpression.inputs) {
        parsedExpression.$$watchDelegate = inputsWatchDelegate;
      }

      return parsedExpression;
    }

    function chainInterceptors(first, second) {
      function chainedInterceptor(value) {
        return second(first(value));
      }
      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
      chainedInterceptor.$$pure = first.$$pure && second.$$pure;

      return chainedInterceptor;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;

      // Extract any existing interceptors out of the parsedExpression
      // to ensure the original parsedExpression is always the $$intercepted
      if (parsedExpression.$$interceptor) {
        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
        parsedExpression = parsedExpression.$$intercepted;
      }

      var useInputs = false;

      var fn = function interceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value);
      };

      // Maintain references to the interceptor/intercepted
      fn.$$intercepted = parsedExpression;
      fn.$$interceptor = interceptorFn;

      // Propogate the literal/oneTime/constant attributes
      fn.literal = parsedExpression.literal;
      fn.oneTime = parsedExpression.oneTime;
      fn.constant = parsedExpression.constant;

      // Treat the interceptor like filters.
      // If it is not $stateful then only watch its inputs.
      // If the expression itself has no inputs then use the full expression as an input.
      if (!interceptorFn.$stateful) {
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];

        if (!interceptorFn.$$pure) {
          fn.inputs = fn.inputs.map(function(e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) { return e(s); };
              }
              return e;
            });
        }
      }

      return addWatchDelegate(fn);
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        markQStateExceptionHandled(state);
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
          // This error is explicitly marked for being passed to the $exceptionHandler
          if (e && e.$$passToExceptionHandler === true) {
            exceptionHandler(e);
          }
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!isStateExceptionHandled(toCheck)) {
        markQStateExceptionHandled(toCheck);
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (isError(toCheck.value)) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function isStateExceptionHandled(state) {
  return !!state.pur;
}
function markQStateExceptionHandled(state) {
  state.pur = true;
}
function markQExceptionHandled(q) {
  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
  // (Currently, this is the only method that might be called with a promise, even if it is not
  // created by the built-in `$q`.)
  if (q.$$state) {
    markQStateExceptionHandled(q.$$state);
  }
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
      this.$$suspended = false;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$suspended = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);
        var fn = isFunction(listener) ? listener : noop;

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
            newValues[i] = value;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          try {
            if (firstRun) {
              firstRun = false;
              listener(newValues, newValues, self);
            } else {
              listener(newValues, oldValues, self);
            }
          } finally {
            for (var i = 0; i < watchExpressions.length; i++) {
              oldValues[i] = newValues[i];
            }
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        // Mark the interceptor as
        // ... $$pure when literal since the instance will change when any input changes
        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
        // ... $stateful when non-literal since we must read the state of the collection
        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = asyncQueue.length ? $rootScope : this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              fn = asyncTask.fn;
              fn(asyncTask.scope, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = !current.$$suspended && current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            // (though it differs due to having the extra check for $$suspended and does not
            // check $$listenerCount)
            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;

        // Check for changes to browser url that happened during the $digest
        // (for which no event is fired; e.g. via `history.pushState()`)
        $browser.$$checkUrlChange();
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */
      $suspend: function() {
        this.$$suspended = true;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */
      $isSuspended: function() {
        return this.$$suspended;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */
      $resume: function() {
        this.$$suspended = false;
      },

      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          }, null, '$evalAsync');
        }

        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            // Use delete in the hope of the browser deallocating the memory for the array entry,
            // while not shifting the array indexes of other listeners.
            // See issue https://github.com/angular/angular.js/issues/16135
            delete namedListeners[indexOfListener];
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            break;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount and
          // does not check $$suspended)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        }, null, '$applyAsync');
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {

  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationWhitelist` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `aImgSanitizationWhitelist` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isMediaUrl) {
      // if (!uri) return uri;
      var regex = isMediaUrl ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal = urlResolve(uri && uri.trim()).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
  HTML: 'html',

  // Style statements or stylesheets. Currently unused in AngularJS.
  CSS: 'css',

  // An URL used in a context where it refers to the source of media, which are not expected to be run
  // as scripts, such as an image, audio, video, etc.
  MEDIA_URL: 'mediaUrl',

  // An URL used in a context where it does not refer to a resource that loads code.
  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
  URL: 'url',

  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
  // code. (e.g. ng-include, script src binding, templateUrl)
  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
  RESOURCE_URL: 'resourceUrl',

  // Script. Currently unused in AngularJS.
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
 * places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
 * and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty whitelist will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
 * for instance attacker-controlled `ng-includes`.
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set whitelist array.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
   * with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} The currently set blacklist array.
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#resourceUrlWhitelist
     * `$sceDelegateProvider.resourceUrlWhitelist`} and {@link ng.$sceDelegateProvider#resourceUrlBlacklist
     * `$sceDelegateProvider.resourceUrlBlacklist`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
      // as-is.
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }

      // If maybeTrusted is a trusted class instance but not of the correct trusted type
      // then unwrap it and allow it to pass through to the rest of the checks
      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
      }

      // If we get here, then we will either sanitize the value or throw an exception.
      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
        // we attempt to sanitize non-resource URLs
        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
        return htmlSanitizer(maybeTrusted);
      }
      // Default error when the $sce service has no way to make the input safe.
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
 * can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider#resourceUrlWhitelist()} and {@link $sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider#resourceUrlBlacklist()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

/**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */
function $$TaskTrackerFactoryProvider() {
  this.$get = valueFn(function(log) { return new TaskTracker(log); });
}

function TaskTracker(log) {
  var self = this;
  var taskCounts = {};
  var taskCallbacks = [];

  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';

  /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */
  self.completeTask = completeTask;

  /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */
  self.incTaskCount = incTaskCount;

  /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */
  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;

  function completeTask(fn, taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;

    try {
      fn();
    } finally {
      decTaskCount(taskType);

      var countForType = taskCounts[taskType];
      var countForAll = taskCounts[ALL_TASKS_TYPE];

      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
      if (!countForAll || !countForType) {
        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
        var nextCb;

        while ((nextCb = getNextCallback(taskType))) {
          try {
            nextCb();
          } catch (e) {
            log.error(e);
          }
        }
      }
    }
  }

  function decTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    if (taskCounts[taskType]) {
      taskCounts[taskType]--;
      taskCounts[ALL_TASKS_TYPE]--;
    }
  }

  function getLastCallback() {
    var cbInfo = taskCallbacks.pop();
    return cbInfo && cbInfo.cb;
  }

  function getLastCallbackForType(taskType) {
    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
      var cbInfo = taskCallbacks[i];
      if (cbInfo.type === taskType) {
        taskCallbacks.splice(i, 1);
        return cbInfo.cb;
      }
    }
  }

  function incTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
  }

  function notifyWhenNoPendingTasks(callback, taskType) {
    taskType = taskType || ALL_TASKS_TYPE;
    if (!taskCounts[taskType]) {
      callback();
    } else {
      taskCallbacks.push({type: taskType, cb: callback});
    }
  }
}

var $templateRequestMinErr = minErr('$templateRequest');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through whitelisting again for keys that already
        // are included in there. This also makes AngularJS accept any script
        // directive, no matter its name. However, we still need to unwrap trusted
        // types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            return $templateCache.put(tpl, response.data);
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

var $timeoutMinErr = minErr('$timeout');

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


    /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay, '$timeout');

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


    /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */
    timeout.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$timeoutId')) {
        throw $timeoutMinErr('badprom',
            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
      }

      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;

      var id = promise.$$timeoutId;
      var deferred = deferreds[id];

      // Timeout cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      delete deferreds[id];

      return $browser.defer.cancel(id);
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);
var baseUrlParsingNode;

urlParsingNode.href = 'http://[::1]';

// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
// when parsed out of an anchor element.
var ipv6InBrackets = urlParsingNode.hostname === '[::1]';

/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */
function urlResolve(url) {
  if (!isString(url)) return url;

  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  var hostname = urlParsingNode.hostname;

  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
    hostname = '[' + hostname + ']';
  }

  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  return urlsAreSameOrigin(requestUrl, originUrl);
}

/**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */
function urlIsSameOriginAsBaseUrl(requestUrl) {
  return urlsAreSameOrigin(requestUrl, getBaseUrl());
}

/**
 * Create a function that can check a URL's origin against a list of allowed/whitelisted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} whitelistedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */
function urlIsAllowedOriginFactory(whitelistedOriginUrls) {
  var parsedAllowedOriginUrls = [originUrl].concat(whitelistedOriginUrls.map(urlResolve));

  /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of whitelisted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */
  return function urlIsAllowedOrigin(requestUrl) {
    var parsedUrl = urlResolve(requestUrl);
    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
  };
}

/**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */
function urlsAreSameOrigin(url1, url2) {
  url1 = urlResolve(url1);
  url2 = urlResolve(url2);

  return (url1.protocol === url2.protocol &&
          url1.host === url2.host);
}

/**
 * Returns the current document base URL.
 * @returns {string}
 */
function getBaseUrl() {
  if (window.document.baseURI) {
    return window.document.baseURI;
  }

  // `document.baseURI` is available everywhere except IE
  if (!baseUrlParsingNode) {
    baseUrlParsingNode = window.document.createElement('a');
    baseUrlParsingNode.href = '.';

    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
    // suitable here because we need to track changes to the base URL.
    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
  }
  return baseUrlParsingNode.href;
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
          if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // If the currency symbol is empty, trim whitespace around the symbol
    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(currencySymbolRe, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = (type1 === 'undefined') ? 1 :
        (type2 === 'undefined') ? -1 :
        (type1 === 'null') ? 1 :
        (type2 === 'null') ? -1 :
        (type1 < type2) ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        // We need to sanitize the url at least once, in case it is a constant
        // non-interpolated attribute.
        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set might have sanitized the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  }];
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $getControls: valueFn([]),
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop,
  $$setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */
  $getControls: function() {
    return shallowCopy(this.$$controls);
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */
  $setSubmitted: function() {
    var rootForm = this;
    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
      rootForm = rootForm.$$parentForm;
    }
    rootForm.$$setSubmitted();
  },

  $$setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    forEach(this.$$controls, function(control) {
      if (control.$$setSubmitted) {
        control.$$setSubmitted();
      }
    });
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium, which may not fulfill your app's requirements.
   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
   * modify the built-in validators (see the {@link guide/forms Forms guide}).
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    // Support: IE9+
    element.on('compositionupdate', function(ev) {
      // End composition when ev.data is empty string on 'compositionupdate' event.
      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
      // instead of 'compositionend'.
      if (isUndefined(ev.data) || ev.data === '') {
        composing = false;
      }
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut drop', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, previousDate) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (previousDate) {
          map = {
            yyyy: previousDate.getFullYear(),
            MM: previousDate.getMonth() + 1,
            dd: previousDate.getDate(),
            HH: previousDate.getHours(),
            mm: previousDate.getMinutes(),
            ss: previousDate.getSeconds(),
            sss: previousDate.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });

        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        if (map.yyyy < 100) {
          // In the constructor, 2-digit years map to 1900-1999.
          // Use `setFullYear()` to set the correct year.
          date.setFullYear(map.yyyy);
        }

        return date;
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    badInputChecker(scope, element, attr, ctrl, type);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var isTimeType = type === 'time' || type === 'datetimelocal';
    var previousDate;
    var previousTimezone;

    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;

      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
      }
      ctrl.$$parserName = type;
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        var timezone = ctrl.$options.getOption('timezone');

        if (timezone) {
          previousTimezone = timezone;
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }

        return formatter(value, timezone);
      } else {
        previousDate = null;
        previousTimezone = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal = attr.min || $parse(attr.ngMin)(scope);
      var parsedMinVal = parseObservedDateValue(minVal);

      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
      };
      attr.$observe('min', function(val) {
        if (val !== minVal) {
          parsedMinVal = parseObservedDateValue(val);
          minVal = val;
          ctrl.$validate();
        }
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal = attr.max || $parse(attr.ngMax)(scope);
      var parsedMaxVal = parseObservedDateValue(maxVal);

      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
      };
      attr.$observe('max', function(val) {
        if (val !== maxVal) {
          parsedMaxVal = parseObservedDateValue(val);
          maxVal = val;
          ctrl.$validate();
        }
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
    }

    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
      var timezone = ctrl.$options.getOption('timezone');

      if (previousTimezone && previousTimezone !== timezone) {
        // If the timezone has changed, adjust the previousDate to the default timezone
        // so that the new date is converted with the correct timezone offset
        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
      }

      var parsedDate = parseDate(value, previousDate);

      if (!isNaN(parsedDate) && timezone) {
        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
      }
      return parsedDate;
    }

    function formatter(value, timezone) {
      var targetFormat = format;

      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
        targetFormat = format
          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
          .replace(/:$/, '');
      }

      var formatted =  $filter('date')(value, targetFormat, timezone);

      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
      }

      return formatted;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl, parserName) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      if (validity.badInput || validity.typeMismatch) {
        ctrl.$$parserName = parserName;
        return undefined;
      }

      return value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);

    ctrl.$$parserName = 'number';
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  var isNonIntegerValue = !isNumberInteger(value);
  var isNonIntegerStepBase = !isNumberInteger(stepBase);
  var isNonIntegerStep = !isNumberInteger(step);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;

    if (isNonIntegerValue) value = Math.round(value);
    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
    if (isNonIntegerStep) step = Math.round(step);
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  badInputChecker(scope, element, attr, ctrl, 'number');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var parsedMinVal;

  if (isDefined(attr.min) || attr.ngMin) {
    var minVal = attr.min || $parse(attr.ngMin)(scope);
    parsedMinVal = parseNumberAttrVal(minVal);

    ctrl.$validators.min = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
    };

    attr.$observe('min', function(val) {
      if (val !== minVal) {
        parsedMinVal = parseNumberAttrVal(val);
        minVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    var maxVal = attr.max || $parse(attr.ngMax)(scope);
    var parsedMaxVal = parseNumberAttrVal(maxVal);

    ctrl.$validators.max = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
    };

    attr.$observe('max', function(val) {
      if (val !== maxVal) {
        parsedMaxVal = parseNumberAttrVal(val);
        maxVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal = attr.step || $parse(attr.ngStep)(scope);
    var parsedStepVal = parseNumberAttrVal(stepVal);

    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
    };

    attr.$observe('step', function(val) {
      // TODO(matsko): implement validateLater to reduce number of validations
      if (val !== stepVal) {
        parsedStepVal = parseNumberAttrVal(val);
        stepVal = val;
        ctrl.$validate();
      }

    });

  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl, 'range');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    minVal = parseNumberAttrVal(attr.min);

    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    maxVal = parseNumberAttrVal(attr.max);

    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    stepVal = parseNumberAttrVal(attr.step);

    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    var oldVal = attr[htmlAttrName];
    attr.$observe(htmlAttrName, function wrappedObserver(val) {
      if (val !== oldVal) {
        oldVal = val;
        changeFn(val);
      }
    });
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (!supportsRange) {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    } else if (ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('change', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('change', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];


var hiddenInputBrowserCacheDirective = function() {
  var valueProperty = {
    configurable: true,
    enumerable: false,
    get: function() {
      return this.getAttribute('value') || '';
    },
    set: function(val) {
      this.setAttribute('value', val);
    }
  };

  return {
    restrict: 'E',
    priority: 200,
    compile: function(_, attr) {
      if (lowercase(attr.type) !== 'hidden') {
        return;
      }

      return {
        pre: function(scope, element, attr, ctrls) {
          var node = element[0];

          // Support: Edge
          // Moving the DOM around prevents autofillling
          if (node.parentNode) {
            node.parentNode.insertBefore(node, node.nextSibling);
          }

          // Support: FF, IE
          // Avoiding direct assignment to .value prevents autofillling
          if (Object.defineProperty) {
            Object.defineProperty(node, 'value', valueProperty);
          }
        }
      };
    }
  };
};



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
    element.prop('value', propValue);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClassWatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClassWatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    if (!classValue) return classValue;

    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    } else if (!isString(classValue)) {
      classString = classValue + '';
    }

    return classString;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
    }];
  }
);

function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
  return {
    restrict: 'A',
    compile: function($element, attr) {
      // NOTE:
      // We expose the powerful `$event` object on the scope that provides access to the Window,
      // etc. This is OK, because expressions are not sandboxed any more (and the expression
      // sandbox was never meant to be a security feature anyway).
      var fn = $parse(attr[directiveName]);
      return function ngEventHandler(scope, element) {
        element.on(eventName, function(event) {
          var callback = function() {
            fn(scope, {$event: event});
          };

          if (!$rootScope.$$phase) {
            scope.$apply(callback);
          } else if (forceAsync) {
            scope.$evalAsync(callback);
          } else {
            try {
              callback();
            } catch (error) {
              $exceptionHandler(error);
            }
          }
        });
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;
  this.$$updateEvents = '';
  // Attach the correct context to the event handler function for updateOn
  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;
  this.$$parserName = 'parse';

  this.$$currentValidationRunId = 0;

  this.$$scope = $scope;
  this.$$rootScope = $scope.$root;
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {

    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName;

      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }

        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    // Reset any previous parse error
    this.$setValidity(this.$$parserName, null);
    this.$$parserName = 'parse';

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default']) &&
      this.$options.getOption('updateOn').indexOf(trigger) === -1
    ) {
      debounceDelay = debounceDelay['default'];
    } else if (isNumber(debounceDelay['*'])) {
      debounceDelay = debounceDelay['*'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$rootScope.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  },

  /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
  $overrideModelOptions: function(options) {
    this.$options = this.$options.createChild(options);
    this.$$setUpdateOnEvents();
  },

  /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
  $processModelValue: function() {
    var viewValue = this.$$format();

    if (this.$viewValue !== viewValue) {
      this.$$updateEmptyClasses(viewValue);
      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
      this.$render();
      // It is possible that model and view value have been updated during render
      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
    }
  },

  /**
   * This method is called internally to run the $formatters on the $modelValue
   */
  $$format: function() {
    var formatters = this.$formatters,
        idx = formatters.length;

    var viewValue = this.$modelValue;
    while (idx--) {
      viewValue = formatters[idx](viewValue);
    }

    return viewValue;
  },

  /**
   * This method is called internally when the bound scope value changes.
   */
  $$setModelValue: function(modelValue) {
    this.$modelValue = this.$$rawModelValue = modelValue;
    this.$$parserValid = undefined;
    this.$processModelValue();
  },

  $$setUpdateOnEvents: function() {
    if (this.$$updateEvents) {
      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
    }

    this.$$updateEvents = this.$options.getOption('updateOn');
    if (this.$$updateEvents) {
      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    }
  },

  $$updateEventHandler: function(ev) {
    this.$$debounceViewValueCommit(ev && ev.type);
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch(scope) {
    var modelValue = ctrl.$$ngModelGet(scope);

    // if scope model value and ngModel value are out of sync
    // This cannot be moved to the action function, because it would not catch the
    // case where the model is changed in the ngChange function or the model setter
    if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$$setModelValue(modelValue);
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          modelCtrl.$$setUpdateOnEvents();

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /** @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */

var ngRefMinErr = minErr('ngRef');

var ngRefDirective = ['$parse', function($parse) {
  return {
    priority: -1, // Needed for compatibility with element transclusion on the same element
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      // Get the expected controller name, converts <data-some-thing> into "someThing"
      var controllerName = directiveNormalize(nodeName_(tElement));

      // Get the expression for value binding
      var getter = $parse(tAttrs.ngRef);
      var setter = getter.assign || function() {
        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
      };

      return function(scope, element, attrs) {
        var refValue;

        if (attrs.hasOwnProperty('ngRefRead')) {
          if (attrs.ngRefRead === '$element') {
            refValue = element;
          } else {
            refValue = element.data('$' + attrs.ngRefRead + 'Controller');

            if (!refValue) {
              throw ngRefMinErr(
                'noctrl',
                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
                attrs.ngRefRead,
                tAttrs.ngRef
              );
            }
          }
        } else {
          refValue = element.data('$' + controllerName + 'Controller');
        }

        refValue = refValue || element;

        setter(scope, refValue);

        // when the element is removed, remove it (nullify it)
        element.on('$destroy', function() {
          // only remove it if value has not changed,
          // because animations (and other procedures) may duplicate elements
          if (getter(scope) === refValue) {
            setter(scope, null);
          }
        });
      };
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };

  var trackByIdArrayFn = function($scope, key, value) {
    return hashKey(value);
  };

  var trackByIdObjFn = function($scope, key) {
    return key;
  };

  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByIdExpFn;

      if (trackByExp) {
        var hashFnLocals = {$id: hashKey};
        var trackByExpGetter = $parse(trackByExp);

        trackByIdExpFn = function($scope, key, value, index) {
          // assign key, value, and $index to the locals so that they can be used in hash functions
          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
          hashFnLocals[valueIdentifier] = value;
          hashFnLocals.$index = index;
          return trackByExpGetter($scope, hashFnLocals);
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - clone: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn($scope, key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
          // being leaked into the ngRepeatCompile function scope
          if (hashFnLocals) {
            hashFnLocals[valueIdentifier] = undefined;
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, ''); });
    }
    if (newStyles) element.css(newStyles);
  });
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function setOptionSelectedStatus(optionEl, value) {
  optionEl.prop('selected', value);
  /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
  optionEl.attr('selected', value);
}

/**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new NgMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that the application developer can
  // provide inside the select. It is always selectable and indicates that a "null" selection has
  // been made by the user.
  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
  // the empty option is selected.
  // If the model is set to a different unmatched value, the unknown option is rendered and
  // selected, i.e both are present, because a "null" selection and an unknown value are different.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionSelectedStatus(self.emptyOption, true);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      setOptionSelectedStatus(self.emptyOption, false);
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionSelectedStatus(jqLite(selectedOption), true);
    } else {
      self.selectUnknownOrEmptyOption(value);
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.set(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.delete(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.set(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
  self.$hasEmptyOption = function() {
    return self.hasEmptyOption;
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
  self.$isUnknownOptionSelected = function() {
    // Presence of the unknown option means it is selected
    return $element[0].options[0] === self.unknownOption[0];
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
  self.$isEmptyOptionSelected = function() {
    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
  };

  self.selectUnknownOrEmptyOption = function(value) {
    if (value == null && self.emptyOption) {
      self.removeUnknownOption();
      self.selectEmptyOption();
    } else if (self.unknownOption.parent().length) {
      self.updateUnknownOption(value);
    } else {
      self.renderUnknownOption(value);
    }
  };

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      scheduleRender();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function(option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      // For boolean attributes like required, presence means true
      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);

      if (!attr.ngRequired) {
        // force truthy in case we are on non input element
        // (input elements do this automatically for boolean attributes like required)
        attr.required = true;
      }

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !value || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function(newVal) {

        if (value !== newVal) {
          value = newVal;
          ctrl.$validate();
        }
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    compile: function(tElm, tAttr) {
      var patternExp;
      var parseFn;

      if (tAttr.ngPattern) {
        patternExp = tAttr.ngPattern;

        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
        // We get value of the attribute here, so we can compare the old and the new value
        // in the observer to avoid unnecessary validations
        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
          parseFn = function() { return tAttr.ngPattern; };
        } else {
          parseFn = $parse(tAttr.ngPattern);
        }
      }

      return function(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var attrVal = attr.pattern;

        if (attr.ngPattern) {
          attrVal = parseFn(scope);
        } else {
          patternExp = attr.pattern;
        }

        var regexp = parsePatternAttr(attrVal, patternExp, elm);

        attr.$observe('pattern', function(newVal) {
          var oldRegexp = regexp;

          regexp = parsePatternAttr(newVal, patternExp, elm);

          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
            ctrl.$validate();
          }
        });

        ctrl.$validators.pattern = function(modelValue, viewValue) {
          // HTML5 pattern constraint validates the input value, so we validate the viewValue
          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
        };
      };
    }

  };
}];

/**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
      var maxlengthParsed = parseLength(maxlength);

      attr.$observe('maxlength', function(value) {
        if (maxlength !== value) {
          maxlengthParsed = parseLength(value);
          maxlength = value;
          ctrl.$validate();
        }
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
      var minlengthParsed = parseLength(minlength) || -1;

      attr.$observe('minlength', function(value) {
        if (minlength !== value) {
          minlengthParsed = parseLength(value) || -1;
          minlength = value;
          ctrl.$validate();
        }

      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
      };
    }
  };
}];


function parsePatternAttr(regex, patternExp, elm) {
  if (!regex) return undefined;

  if (isString(regex)) {
    regex = new RegExp('^' + regex + '$');
  }

  if (!regex.test) {
    throw minErr('ngPattern')('noregexp',
      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
      regex, startingTag(elm));
  }

  return regex;
}

function parseLength(val) {
  var intVal = toInt(val);
  return isNumberNaN(intVal) ? -1 : intVal;
}

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load AngularJS more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
/**
 * @license AngularJS v1.8.0
 * (c) 2010-2020 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing
   * Depending upon browser support we use one of three strategies for doing this.
   * Support: Safari 10.x -> XHR strategy
   * Support: Firefox -> DomParser strategy
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    var inertDocument;
    if (document && document.implementation) {
      inertDocument = document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');

    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
    if (!inertBodyElement.querySelector('svg')) {
      return getInertBodyElement_XHR;
    } else {
      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
      if (inertBodyElement.querySelector('svg img')) {
        return getInertBodyElement_DOMParser;
      } else {
        return getInertBodyElement_InertDocument;
      }
    }

    function getInertBodyElement_XHR(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        html = encodeURI(html);
      } catch (e) {
        return undefined;
      }
      var xhr = new window.XMLHttpRequest();
      xhr.responseType = 'document';
      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
      xhr.send(null);
      var body = xhr.response.body;
      body.firstChild.remove();
      return body;
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.8.0' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

/**
 * @license AngularJS v1.8.0
 * (c) 2010-2020 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * The `ngTouch` module provides helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)). *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * @deprecated
 * sinceVersion="1.7.0"
 * The ngTouch module with the {@link ngTouch.$swipe `$swipe`} service and
 * the {@link ngTouch.ngSwipeLeft} and {@link ngTouch.ngSwipeRight} directives are
 * deprecated. Instead, stand-alone libraries for touch handling and gesture interaction
 * should be used, for example [HammerJS](https://hammerjs.github.io/) (which is also used by
 * Angular).
 */

// define ngTouch module
/* global ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.info({ angularVersion: '1.8.0' });

function nodeName_(element) {
  return angular.$$lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @deprecated
     * sinceVersion="1.7.0"
     *
     * See the {@link ngTouch module} documentation for more information.
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        if (eventHandlers['start']) {
          eventHandlers['start'](startCoords, event);
        }
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          if (eventHandlers['move']) {
            eventHandlers['move'](coords, event);
          }
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        if (eventHandlers['end']) {
          eventHandlers['end'](getCoordinates(event), event);
        }
      });
    }
  };
}]);

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);

/**
 * @license AngularJS v1.7.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var forEach;
var isArray;
var isString;
var jqLite;

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
 *
 * ## Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritize messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, AngularJS may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
 * more about ngAnimate.
 *
 * ## Displaying a default message
 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
 * keys are matched by a defined message), then it will render a default message
 * using the {@link ngMessageDefault} directive.
 * Note that matched messages will always take precedence over unmatched messages. That means
 * the default message will not be displayed when another message is matched. This is also
 * true for `ng-messages-multiple`.
 *
 * ```html
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 *   <div ng-message-default>This field has an input error</div>
 * </div>
 * ```
 *

 */
angular.module('ngMessages', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  forEach = angular.forEach;
  isArray = angular.isArray;
  isString = angular.isString;
  jqLite = angular.element;
})
  .info({ angularVersion: '1.7.9' })

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
   * reusability and messages can also be overridden.
   *
   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
   * {@link ngMessageDefault} directive.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *         <div ng-message-default>This field has an input error</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var truthyKeys = 0;
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (truthy(value) && !messageUsed) {
                  truthyKeys++;

                  if (messageCtrl.test(key)) {
                    // this is to prevent the same error name from showing up twice
                    if (matchedKeys[key]) return;
                    matchedKeys[key] = true;

                    messageUsed = true;
                    messageCtrl.attach();
                  }
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          var messageMatched = unmatchedMessages.length !== totalMessages;
          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;

          if (attachDefault) {
            ctrl.default.attach();
          } else if (ctrl.default) {
            ctrl.default.detach();
          }

          if (messageMatched || attachDefault) {
            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
          } else {
            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
          }
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater && cachedCollection) {
                ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl, isDefault) {
          if (isDefault) {
            ctrl.default = messageCtrl;
          } else {
            var nextKey = latestKey.toString();
            messages[nextKey] = {
              message: messageCtrl
            };
            insertMessageNode($element[0], comment, nextKey);
            comment.$$ngMessageNode = nextKey;
            latestKey++;
          }

          ctrl.reRender();
        };

        this.deregister = function(comment, isDefault) {
          if (isDefault) {
            delete ctrl.default;
          } else {
            var key = comment.$$ngMessageNode;
            delete comment.$$ngMessageNode;
            removeMessageNode($element[0], comment, key);
            delete messages[key];
          }
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          // This message node may have already been removed by a call to deregister()
          if (!messageNode) return;

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   * @priority 1
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory())

  /**
   * @ngdoc directive
   * @name ngMessageDefault
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
   * {@link directive:ngMessages}, when none of provided messages matches.
   *
   * More information about using `ngMessageDefault` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   *
  */
  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));

function ngMessageDirectiveFactory(isDefault) {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode, records, staticExp, dynamicExp;

        if (!isDefault) {
          commentNode = element[0];
          staticExp = attrs.ngMessage || attrs.when;
          dynamicExp = attrs.ngMessageExp || attrs.whenExp;

          var assignRecords = function(items) {
            records = items
                ? (isArray(items)
                      ? items
                      : items.split(/[\s,]+/))
                : null;
            ngMessagesCtrl.reRender();
          };

          if (dynamicExp) {
            assignRecords(scope.$eval(dynamicExp));
            scope.$watchCollection(dynamicExp, assignRecords);
          } else {
            assignRecords(staticExp);
          }
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  // If the message element was removed via a call to `detach` then `currentElement` will be null
                  // So this handler only handles cases where something else removed the message element.
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode, isDefault);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        }, isDefault);

        // We need to ensure that this directive deregisters itself when it no longer exists
        // Normally this is done when the attached element is destroyed; but if this directive
        // gets removed before we attach the message to the DOM there is nothing to watch
        // in which case we must deregister when the containing scope is destroyed.
        scope.$on('$destroy', function() {
          ngMessagesCtrl.deregister(commentNode, isDefault);
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));

;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

		// AMD. Register as an anonymous module.
		define(function() {
			return FastClick;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());

/**
 * Bento v4.1.1
 * Built on: 2020-06-23T19:45:31+0000
 * Copyright 2020 Thomson Reuters
 * Maintained by Chi Gao, Joe Huang, Aaron Mendez
 */
(function(angular) {
'use strict';
// Register Bento.UI
window.bento = angular
                   .module(
                       'bento.ui',
                       [
                         'ngAnimate',
                         'ngSanitize',
                         'bento.modern.ui',
                         'bento.services',
                         'bento.positioning',
                         'bento.checkbox',
                         'bento.busyloader',
                         'bento.append.to.parent',
                         'bento.carousel',
                         'bento.combobox',
                         'bento.contextualheader',
                         'bento.cookie',
                         'bento.fileselector',
                         'bento.inputblur',
                         'bento.numberinput',
                         'bento.off.canvas.menu',
                         'bento.pagination',
                         'bento.reset',
                         'bento.scrollablebar',
                         'bento.scrollabletoolbar',
                         'bento.select',
                         'bento.splittergroup',
                         'bento.tagsinput',
                         'bento.test',
                         'bento.translate',
                         'bento.table',
                         'bento.tileribbon',
                         'bento.toggle',
                         'bento.toolbar',
                         'bento.tree',
                         'bento.tree.view',
                         'bento.wizard',
                         'bento.progressbar',
                         'bento.tabs',
                         'bento.transferbox',
                         'bento.transferbox.basic',
                         'bento.transition',
                         'bento.multiselectoverlay',
                         'bento.dropdown.append.to.parent',
                         'bento.alert',
                         'bento.megamenu',
                         'bento.universeFilter',
                         'bento.uib.datepicker.addon',
                         'bento.uib.timepicker.addon',
                         'bento.sticky.footer',
                         'bento.smartbadge',
                         'bento.skiplinks',
                         'bento.prevent.overflow.scroll'
                       ])
                   .config([
                     '$logProvider',
                     function($logProvider) {
                       $logProvider.debugEnabled(false);
                     }
                   ]);

angular.module('bento.modern', ['bento.ui']);

bento.version = {
  release: '4.1.1',
  codeName: 'shuumaku'
};
})(window.angular);

angular.module('bento.modern.ui', ['../templates/alerts/bento_alert_container.html', '../templates/alerts/bento_alert.html', '../templates/carousel/bento-carousel-card-default.html', '../templates/combobox/bento-combobox-container.html', '../templates/combobox/bento-combobox-header-template.html', '../templates/combobox/bento-combobox.html', '../templates/contextual_header/bento-contextual-header.html', '../templates/file_selector/bento-file-selector.html', '../templates/multiselect_list/bento-multiselect-list.html', '../templates/multiselect_overlay/bento-multiselect-overlay.html', '../templates/pagination/bento-pagination.html', '../templates/progressbar/bento-progressbar.html', '../templates/scrollable-bar/bento-scrollable-bar.html', '../templates/scrollable-toolbar/bento-scrollable-toolbar-item.html', '../templates/scrollable-toolbar/bento-scrollable-toolbar.html', '../templates/side_nav/bento-side-nav.html', '../templates/skip_links/bento-skip-links.html', '../templates/spread/bento-spread.html', '../templates/tags_input/bento-tags-input-pill.html', '../templates/tags_input/bento-tags-input.html', '../templates/tile-ribbon/bento_tile_ribbon_tile.html', '../templates/tile-ribbon/bento_tile_ribbon.html', '../templates/toggle/bento-toggle.html', '../templates/toolbar/bento-toolbar.html', '../templates/transfer_box_basic/bento-transferbox-base.html', '../templates/transfer_box_basic/bento-transferbox-grid.html', '../templates/transfer_box/bento-flexgrid-transferbox-base.html', '../templates/transfer_box/bento-flexgrid-transferbox-grid.html', '../templates/tree-view/bento-tree-view.html', '../templates/tree/bento-tree.html', 'uib/template/accordion/accordion-group.html', '../templates/universe_filter/bento-universe-filter-dropdown.html', '../templates/universe_filter/bento-universe-filter.html']);

angular.module("../templates/alerts/bento_alert_container.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/alerts/bento_alert_container.html",
    "<div class=\"alert-container refresh-data\"\n" +
    "     aria-label=\"{{'BENTO_UI_ALERT_DESCRIPTION' | bentoTranslate}}\"\n" +
    "     tabindex=\"-1\">\n" +
    "  <div ng-repeat=\"alert in bentoAlertObject\"\n" +
    "       bento-alert-message=\"alert\"\n" +
    "       bento-alert-message-index=\"$index\"\n" +
    "       rel=\"bento-alert-{{$index}}\"\n" +
    "       bento-test=\"alert-{{$index}}\"\n" +
    "  >\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/alerts/bento_alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/alerts/bento_alert.html",
    "<div class=\"bento-alert-container bento-animate\">\n" +
    "    <div class=\"alert bento-alert\"\n" +
    "         bento-alert-index=\"{{bentoAlertMessageIndex}}\"\n" +
    "         ng-class=\"['alert-' + (bentoAlertMessage.type || 'warning'), bentoAlertMessage.closeable ? 'alert-dismissable' : null]\"\n" +
    "         role=\"alert\"\n" +
    "         tabindex=\"0\"\n" +
    "        >\n" +
    "      <button ng-show=\"bentoAlertMessage.closeable\"\n" +
    "              type=\"button\"\n" +
    "              class=\"bento-alert-close\"\n" +
    "              ng-click=\"closeBentoAlert()\"\n" +
    "              bento-test=\"button-close\"\n" +
    "              aria-label=\"{{ 'BENTO_UI_ALERT_CLOSE_BUTTON' | bentoTranslate}}\"\n" +
    "      >\n" +
    "        <span aria-hidden=\"true\"><i class=\"bento-icon-close-thick\"></i></span>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("../templates/carousel/bento-carousel-card-default.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/carousel/bento-carousel-card-default.html",
    "<div class=\"bento-carousel-card-recent\">\n" +
    "  <i class=\"bento-icon-newtab carousel-newtab-cta\" \n" +
    "     ng-click=\"newTabClick($event)\"\n" +
    "     ng-if=\"!hideNewTabIcon\"></i>\n" +
    "  <div ng-if=\"enablePopover &&\n" +
    "   ((cardName && cardName.length>0) || (cardSecondaryName && cardSecondaryName.length>0))\"\n" +
    "       class=\"bento-carousel-card-recent-header\"\n" +
    "       uib-popover=\"{{cardSecondaryName + ' '}}\"\n" +
    "       popover-title=\"{{cardName}}\"\n" +
    "       popover-placement=\"top\"\n" +
    "       popover-trigger=\"outsideClick\"\n" +
    "       ng-click=\"onHeaderClick($event)\">\n" +
    "    <!-- Content -->\n" +
    "    <h4 ng-if=\"cardName && cardName.length>0\" class=\"label\" ng-bind=\"cardName\"></h4>\n" +
    "    <h4 ng-if=\"cardSecondaryName && cardSecondaryName.length>0\" class=\"label\" ng-bind=\"cardSecondaryName\"></h4>\n" +
    "  </div>\n" +
    "  <div ng-if=\"!enablePopover &&\n" +
    "    ((cardName && cardName.length>0) || (cardSecondaryName && cardSecondaryName.length>0))\"\n" +
    "       class=\"bento-carousel-card-recent-header\" \n" +
    "       ng-click=\"onHeaderClick($event)\">\n" +
    "    <!-- Content -->\n" +
    "    <h4 ng-if=\"cardName && cardName.length>0\" class=\"label\" ng-bind=\"cardName\"></h4>\n" +
    "    <h4 ng-if=\"cardSecondaryName && cardSecondaryName.length>0\" class=\"label\" ng-bind=\"cardSecondaryName\"></h4>\n" +
    "  </div>\n" +
    "  <div class=\"content\" ng-include=\"cardTemplateUrl\"></div>\n" +
    "  <div class=\"foot\">\n" +
    "    <div ng-if=\"date\" class=\"time\" ng-bind=\"date | bentoTranslate | bentoStringReplace: '_NUMBER_' : dDay\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "        ");
}]);

angular.module("../templates/combobox/bento-combobox-container.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox-container.html",
    "<div class=\"bento-combobox-container\">\n" +
    "  <ul class=\"bento-combobox-container-header\"\n" +
    "      ng-if=\"!!headers\"\n" +
    "  >\n" +
    "    <li bento-combobox-header-template=\"headerTemplate\"\n" +
    "        ng-repeat=\"header in headers track by $index\"\n" +
    "        $header=\"header\"\n" +
    "        $index=\"{{$index}}\"\n" +
    "        bento-test=\"header-{{$index}}\"\n" +
    "    >\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  <div class=\"bento-combobox-container-body\"\n" +
    "\n" +
    "  >\n" +
    "    <ul ng-if=\"!isTable\"\n" +
    "        class=\"bento-combobox-container-list\">\n" +
    "      <li ng-repeat=\"item in data track by $index\"\n" +
    "          class=\"bento-combobox-container-item\" tabindex=\"-1\"\n" +
    "      >\n" +
    "        <bento-combobox-row-template\n" +
    "            ng-class=\"{selected: selectedIndex == $index}\"\n" +
    "            ng-click=\"selectItem($index)\"\n" +
    "            rel=\"row-{{$index}}\"\n" +
    "            $item=\"item\"\n" +
    "            $index=\"$index\"\n" +
    "            $label-name=\"labelName\"\n" +
    "            row-template=\"rowTemplate()\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "            tabindex=\"-1\"\n" +
    "        ></bento-combobox-row-template>\n" +
    "      </li>\n" +
    "\n" +
    "    </ul>\n" +
    "    <ul ng-if=\"isTable\"\n" +
    "        class=\"bento-combobox-container-list\">\n" +
    "      <li ng-repeat=\"item in data track by $index\"\n" +
    "          class=\"bento-combobox-container-item\" tabindex=\"-1\"\n" +
    "      >\n" +
    "        <bento-combobox-row-template\n" +
    "            ng-class=\"{selected: selectedIndex == $index}\"\n" +
    "            ng-click=\"selectItem($index)\"\n" +
    "            rel=\"row-{{$index}}\"\n" +
    "            $item=\"item\"\n" +
    "            $index=\"$index\"\n" +
    "            $label-name=\"labelName\"\n" +
    "            headers=\"headers\"\n" +
    "            row-template=\"rowTemplate()\"\n" +
    "            tabindex=\"-1\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "        ></bento-combobox-row-template>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <bento-combobox-footer\n" +
    "      ng-if=\"$parent.footerOptions() && $parent.footerOptions().buttons\"\n" +
    "      class=\"bento-combobox-container-list\"\n" +
    "      template-url=\"{{footerTemplateUrl()}}\"\n" +
    "  ></bento-combobox-footer>\n" +
    "</div>");
}]);

angular.module("../templates/combobox/bento-combobox-header-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox-header-template.html",
    "<li class=\"bento-combobox-container-header-label\"></li>");
}]);

angular.module("../templates/combobox/bento-combobox.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox.html",
    "<div class=\"bento-combobox bento-select form-control\"\n" +
    "     ng-class=\"{'open': isContainerVisible, 'no-value': !inputValue}\"\n" +
    "     tabindex = '-1'\n" +
    "     role=\"combobox\"\n" +
    "    >\n" +
    "  <input class=\"form-control {{inputClasses}}\"\n" +
    "         type=\"text\"\n" +
    "         placeholder=\"{{placeholder}}\"\n" +
    "         autocomplete=\"off\"\n" +
    "         aria-autocomplete=\"none\"\n" +
    "         aria-label=\"Select Here\"\n" +
    "         ng-keyup=\"onInputKeyup($event);\"\n" +
    "         ng-keypress=\"onInputKeypress($event)\"\n" +
    "         ng-keydown=\"onInputKeyDown($event);\"\n" +
    "         ng-change=\"onInputChange($event)\"\n" +
    "         ng-show=\"searchable()\"\n" +
    "         ng-readonly=\"attrs.readonly\"\n" +
    "         ng-disabled=\"ngDisabled()\"\n" +
    "         ng-model=\"inputLabel\"\n" +
    "         bento-test=\"input\"\n" +
    "         />\n" +
    "\n" +
    "  <div class=\"input-label form-control\"\n" +
    "       ng-class=\"{'disabled': ngDisabled()}\"\n" +
    "       ng-if=\"!searchable()\"\n" +
    "       ng-keyup=\"onInputKeyup($event);\"\n" +
    "       ng-keydown=\"onInputKeyDown($event);\"\n" +
    "       ng-disabled=\"ngDisabled()\"\n" +
    "       ng-click=\"onButtonClick($event)\"\n" +
    "       tabindex=\"0\"\n" +
    "      >\n" +
    "    {{inputLabel}}\n" +
    "  </div>\n" +
    "  <div class=\"placeholder\"\n" +
    "       ng-class=\"{'disabled': ngDisabled()}\"\n" +
    "       ng-if=\"!searchable() && (!inputLabel || inputLabel.length === 0)\"\n" +
    "       ng-disabled=\"ngDisabled()\"\n" +
    "       ng-click=\"onButtonClick($event)\"\n" +
    "       >\n" +
    "    {{placeholder}}\n" +
    "  </div>\n" +
    "  <div bento-busy-loader=\"loadingData\"\n" +
    "       bento-busy-loader-size=\"small\"\n" +
    "       non-blocking=\"true\"\n" +
    "       class=\"preloader\"\n" +
    "       bento-test=\"busy-loader\"></div>\n" +
    "\n" +
    "  <div class=\"btn\"\n" +
    "       tabindex=\"-1\"\n" +
    "       ng-class=\"{'disabled':ngDisabled()}\"\n" +
    "       ng-show=\"!attrs.readonly\"\n" +
    "       ng-click=\"onButtonClick($event)\"\n" +
    "       aria-label=\"Dropdown Arrow\"\n" +
    "      >\n" +
    "    <i ng-class=\"{'bento-icon-caret-up':isContainerVisible,'bento-icon-caret-down':!isContainerVisible}\"></i>\n" +
    "  </div>\n" +
    "  <div bento-combobox-container\n" +
    "       id=\"{{uid}}\"\n" +
    "       class=\"bento-append-to-parent\"\n" +
    "       append-to-offset=\"-1\"\n" +
    "       data=\"data\"\n" +
    "       columns-width=\"columnsWidth()\"\n" +
    "       selected-index=\"selectedIndex\"\n" +
    "       headers=\"headers\"\n" +
    "       header-template=\"headerTemplate\"\n" +
    "       is-table=\"!!headers\"\n" +
    "       label-name=\"labelName\"\n" +
    "       on-item-click=\"onItemClick(index)\"\n" +
    "       controller=\"containerCtrl\"\n" +
    "       row-template=\"rowTemplate()\"\n" +
    "       on-end-of-scroll=\"onEndOfScroll()\"\n" +
    "       footer-template-url=\"footerOptions().templateUrl\"\n" +
    "      ></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/contextual_header/bento-contextual-header.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/contextual_header/bento-contextual-header.html",
    "<header class=\"bento-contextual-header-inner\">\n" +
    "  <button class=\"bch-back-button\"\n" +
    "          ng-if=\"!hideBackBtn()\"\n" +
    "          ng-click=\"onBackBtnClick()\"\n" +
    "          ng-disabled=\"backBtnDisabled()\"\n" +
    "  >\n" +
    "    <i class=\"bento-icon-arrow-left\"></i>\n" +
    "  </button>\n" +
    "\n" +
    "  <main class=\"bch-main-container\">\n" +
    "    <section ng-repeat=\"header in contextualHeaderData().headers track by $index\" class=\"bch-header\">\n" +
    "      <figure class=\"bch-header-icon\" ng-if=\"header.icon\" ng-switch=\"isImage(header.icon)\">\n" +
    "        <img ng-switch-when=\"true\" ng-src=\"{{header.icon}}\" class=\"bch-header-img\" />\n" +
    "        <i ng-switch-default ng-class=\"header.icon\"></i>\n" +
    "      </figure>\n" +
    "      <aside class=\"bch-header-title-container\">\n" +
    "        <div class=\"bch-header-title\">{{header.title}}</div>\n" +
    "        <div ng-if=\"header.subtitle!=undefined\" \n" +
    "             data-subtitle-id=\"{{$index}}\"\n" +
    "             class=\"bch-header-subtitle\"\n" +
    "             uib-tooltip=\"{{header.subtitle}}\"\n" +
    "             tooltip-placement=\"bottom\"\n" +
    "             tooltip-enable=\"isTooltipEnabled($index)\"\n" +
    "        >\n" +
    "          {{header.subtitle}}\n" +
    "        </div>\n" +
    "      </aside>\n" +
    "    </section>\n" +
    "  </main>\n" +
    "\n" +
    "  <aside class=\"bch-right-container\" ng-if=\"contextualHeaderData().button\">\n" +
    "    <button class=\"btn btn-primary btn-sm\"\n" +
    "            ng-click=\"onRightButtonClick()\"\n" +
    "            ng-disabled=\"contextualHeaderData().button.disabled\"\n" +
    "    >\n" +
    "      {{contextualHeaderData().button.text}}\n" +
    "    </button>\n" +
    "  </aside>\n" +
    "</header>\n" +
    "");
}]);

angular.module("../templates/file_selector/bento-file-selector.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/file_selector/bento-file-selector.html",
    "<div>\n" +
    "  <div  class=\"bento-file-selector\" ng-class=\"{'bento-file-selector-progress-percentage':showProgressPercentage}\">\n" +
    "    <div class=\"sr-only\" tabindex=\"0\">\n" +
    "        {{'BENTO_UI_FILE_SELECTOR_DESCRIPTION' | bentoTranslate}}\n" +
    "      </div>\n" +
    "      <span class=\"header\">{{'BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL' | bentoTranslate : dropFieldLabel}}</span><br/>\n" +
    "      <button class=\"btn btn-primary\"\n" +
    "              ng-click=\"onBrowseClick($event)\"\n" +
    "              role=\"button\"\n" +
    "              type=\"button\"\n" +
    "              bento-test=\"browse-button\"\n" +
    "              aria-label=\"{{ 'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON' | bentoTranslate }}\"\n" +
    "              ng-disabled=\"disableBrowseButton || ngDisabled()\"\n" +
    "          >\n" +
    "        <span>{{'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL' | bentoTranslate : browseButtonLabel}}</span>\n" +
    "        <i class=\"bento-icon-chevron-right\"></i>\n" +
    "      </button>\n" +
    "      <span id=\"truncated-filename-placeholder\" class=\"bento-truncated-filename-placeholder hidden\"></span>\n" +
    "      <div class=\"filename-container\">\n" +
    "        <div class=\"sr-only bento-file-selector-post-removal-message\" tabindex=\"-1\">\n" +
    "        {{'BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE' | bentoTranslate | bentoStringReplace: '_FILE_NAME_' :fileRemoved}}\n" +
    "      </div>\n" +
    "        <div  ng-if=\"showSelected\"\n" +
    "              class=\"btn btn-default bento-file-selector-filename\"\n" +
    "              ng-repeat=\"file in ngModel track by $index\"\n" +
    "              ng-disabled=\"disabledFiles[$index] && disableFilesDuringUpload\"\n" +
    "              ng-class=\"{loading:disabledFiles[$index]}\"\n" +
    "              rel=\"file_{{$index}}\">\n" +
    "          <span\n" +
    "            tabindex=\"0\"\n" +
    "            class=\"bento-file-selector-filename-label\"\n" +
    "            aria-label=\"{{'BENTO_UI_FILE_SELECTOR_FILE_NAME' | bentoTranslate | bentoStringReplace:'_FILE_NAME_': file.displayFilename | bentoStringReplace:'_NUM_FILES_':ngModel.length | bentoStringReplace:'_FILE_NUMBER_':($index+1)}} {{showFileSize? '(' + (file.size | bentoFileSizeFilter) + ')' : ''}} {{(fileProgresses[$index] >= 0 && fileProgresses[$index] < 100)? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS' | bentoTranslate) : (fileProgresses[$index]) ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE' | bentoTranslate) : ''}}\"\n" +
    "            >{{file.displayFilename}}{{showFileSize? ' (' + (file.size | bentoFileSizeFilter) + ')' : ''}}</span>\n" +
    "          <button ng-click=\"onRemoveClick($index)\"\n" +
    "              role=\"button\"\n" +
    "              aria-label=\"{{'BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON' | bentoTranslate | bentoStringReplace:'_FILE_NAME_':file.displayFilename}}\"\n" +
    "              tabindex=\"0\"\n" +
    "              class=\"bento-icon-close-x\"\n" +
    "              ng-disabled=\"disabledFiles[$index] && disableFilesDuringUpload\"\n" +
    "              >\n" +
    "          </button>\n" +
    "          <div class=\"bento-file-selector-file-progress-bg\" ng-style=\"{width: fileProgresses[$index] + '%'}\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"bento-progressbar\">\n" +
    "        <div uib-progressbar value=\"uploadProgressPercentage\" type=\"success\"></div>\n" +
    "      </div>\n" +
    "      <div class=\"bento-file-selector-progress-percentage-label\">{{uploadProgressPercentage}}%</div>\n" +
    "  </div>\n" +
    "  <div class=\"file-selection-error\" \n" +
    "       ng-repeat=\"file in errorFiles\">\n" +
    "    <i class=\"bento-icon-warning accept-error-message\"></i>\n" +
    "    <span class=\"accept-error-message\">\n" +
    "          The {{file.displayType}} <i>{{file.name}}</i> could not be uploaded.\n" +
    "          <span ng-if=\"accept\">\n" +
    "            Only files with the following extensions are allowed: <i>{{accept}}</i>\n" +
    "          </span>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/multiselect_list/bento-multiselect-list.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/multiselect_list/bento-multiselect-list.html",
    "<div class=\"bento-multiselect-list\">\n" +
    "  <div class=\"bento-multiselect-list-item bento-multiselect-search\">\n" +
    "    <div class=\"pills\">\n" +
    "      <ul class=\"nav nav-pills\" role=\"tablist\">\n" +
    "        <li ng-class=\"{active:!showSelected}\"><a ng-click=\"setShowSelected(false)\" role=\"tab\"\n" +
    "                                                 bento-test=\"show-all\" href>\n" +
    "          {{'BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate:showAllText}}\n" +
    "        </a></li>\n" +
    "        <li ng-class=\"{active:showSelected}\"><a ng-click=\"setShowSelected(true)\" role=\"tab\"\n" +
    "                                                bento-test=\"show-selected\" href>\n" +
    "          {{'BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate:showSelectedText}}\n" +
    "        </a></li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <input bento-reset\n" +
    "           type=\"text\"\n" +
    "           class=\"form-control\"\n" +
    "           ng-model=\"searchTerm\"\n" +
    "           ng-change=\"onSearchChange()\"\n" +
    "           aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL' | bentoTranslate}}\"\n" +
    "    />\n" +
    "  </div>\n" +
    "  <div class=\"bento-multiselect-list-scroll-pane\"\n" +
    "       bento-busy-loader=\"!listData()\"\n" +
    "       bento-busy-loader-size=\"small\"\n" +
    "  >\n" +
    "    <button type=\"button\"\n" +
    "            class=\"bento-multiselect-list-item\"\n" +
    "            ng-click=\"onSelectAllClick($event)\"\n" +
    "            ng-class=\"{selected:selectAll}\"\n" +
    "            ng-show=\"!showSelected && filteredItems && filteredItems.length > 0\"\n" +
    "            bento-test=\"select-all\"\n" +
    "            aria-label=\"select all\"\n" +
    "            role=\"checkbox\"\n" +
    "            aria-checked=\"{{selectAll? true : false}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-multiselect-checkbox\"\n" +
    "         ng-class=\"{'bento-icon-checkmark':selectAll}\">\n" +
    "      </i>\n" +
    "      <span>({{'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL' | bentoTranslate:selectAllText}})</span>\n" +
    "    </button>\n" +
    "    <button type=\"button\"\n" +
    "            class=\"bento-multiselect-list-item\"\n" +
    "            ng-click=\"onItemClick(item, $event)\"\n" +
    "            ng-repeat=\"item in filteredItems | multiselectShowSelected:showSelected:checkedUid track by $index\"\n" +
    "            ng-class=\"{selected:item[checkedUid]}\"\n" +
    "            title=\"{{item.name}}\"\n" +
    "            role=\"checkbox\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "            aria-label=\"{{item.name}}\"\n" +
    "            aria-checked=\"{{item[checkedUid]? true : false}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-multiselect-checkbox\"\n" +
    "         ng-class=\"{'bento-icon-checkmark':item[checkedUid]}\">\n" +
    "      </i>\n" +
    "      <span ng-bind-html=\"htmlEntities(item.name) | highlight:searchTerm.name\"></span>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/multiselect_overlay/bento-multiselect-overlay.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/multiselect_overlay/bento-multiselect-overlay.html",
    "<div class=\"bento-multiselect-overlay-inner\">\n" +
    "  <div bento-side-overlay side=\"{{!!side? side : 'right'}}\"\n" +
    "       on-done=\"onDoneClick()\" overlay-height=\"multiselectListMaxHeight\"\n" +
    "       done-button-text=\"{{doneButtonText}}\" tabindex=\"-1\"\n" +
    "       bento-append-to-parent=\"{{!!bentoAppendToParent ? bentoAppendToParent : ''}}\">\n" +
    "    <button bento-side-overlay-toggle class=\"btn btn-default\"\n" +
    "            uib-tooltip-html=\"tooltip\" tooltip-trigger=\"mouseover\"\n" +
    "            tooltip-append-to-body=\"true\" tooltip-enable=\"!!tooltip\"\n" +
    "            ng-disabled=\"isDisabled\" bento-test=\"button-toggle\"\n" +
    "            aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_DESCRIPTION' | bentoTranslate}}\"\n" +
    "            ng-bind-html=\"selectedItemCount === 0 ?\n" +
    "            ('BENTO_UI_MULTISELECT_OVERLAY_SELECT' | bentoTranslate:selectButtonText)\n" +
    "            :\n" +
    "            ('BENTO_UI_MULTISELECT_OVERLAY_EDIT' | bentoTranslate:editButtonText)\"\n" +
    "            type=\"button\"></button>\n" +
    "    <div bento-side-overlay-content tabindex=\"-1\" aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_CONTENT_DESCRIPTION' | bentoTranslate}} {{\n" +
    "      selectedItemCount === 0 ?\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_SELECT' | bentoTranslate:selectButtonText)\n" +
    "      :\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_EDIT' | bentoTranslate:editButtonText)\n" +
    "      }}\">\n" +
    "      <div bento-multiselect-list list-data=\"listData()\"\n" +
    "           on-change=\"onListChange()\" selected-items=\"selectedItems\"\n" +
    "           max-allowed-height=\"multiselectListMaxHeight\"\n" +
    "           select-all-text=\"{{selectAllText}}\" show-all-text=\"{{showAllText}}\"\n" +
    "           show-selected-text=\"{{showSelectedText}}\" sort=\"sort\"\n" +
    "           sort-reverse=\"sortReverse\" class=\"fill\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <span bento-test=\"label\" ng-show=\"!hideSelectedInfo()\"\n" +
    "        class=\"bento-multiselect-overlay-label\" tabindex=\"-1\">{{\n" +
    "    selectedItemCount === 0 ?\n" +
    "    ''\n" +
    "    :\n" +
    "    (selectedItemCount === 1 ?\n" +
    "      firstItemName\n" +
    "      :\n" +
    "    selectedItemCount === listData().length ?\n" +
    "        ('BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO' | bentoTranslate:allSelectedInfoText\n" +
    "        | bentoStringReplace:'NUMBER':ngModel.length)\n" +
    "        :\n" +
    "        ('BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO' | bentoTranslate:selectedInfoText\n" +
    "        | bentoStringReplace:'NUMBER':selectedItemCount)\n" +
    "    ) + '&nbsp;&nbsp;&nbsp;'\n" +
    "    }}</span>\n" +
    "</div>");
}]);

angular.module("../templates/pagination/bento-pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/pagination/bento-pagination.html",
    "<ul class=\"bento-pagination\" ng-class=\"{'is-narrow':VM.goIconVisible}\">\n" +
    "  <li ng-if=\"VM.boundaryLinks!==false\" class=\"paginate_button first first_button\"\n" +
    "      ng-disabled=\"currentPage <= 1||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{disabled: currentPage <= 1||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"first-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(1)\" ng-keypress=\"goToPage(1)\" class=\"btn btn-default paginate_child_button\"><span class=\"bento-icon-chevron-first-left\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"directionLinks()!==false\" class=\"paginate_button previous\"\n" +
    "      ng-disabled=\"currentPage <= 1||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{first_button: !VM.boundaryLinks, disabled: currentPage <= 1||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"previous-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(currentPage-1)\" ng-keypress=\"goToPage(currentPage-1)\" class=\"btn btn-default paginate_child_button\"><span class=\"bento-icon-chevron-left\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"directionLinks()!==false\" class=\"paginate_button next\"\n" +
    "      ng-disabled=\"currentPage === VM.maxPage||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{last_button: !VM.boundaryLinks, small_margin: VM.lastButtonSmallMargin, disabled: currentPage === VM.maxPage||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"next-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(currentPage+1)\" ng-keypress=\"goToPage(currentPage+1)\" class=\"btn btn-default paginate_child_button\"><span class=\"bento-icon-chevron-right\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"VM.boundaryLinks!==false\" class=\"paginate_button last last_button\"\n" +
    "      ng-disabled=\"currentPage === VM.maxPage||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{disabled: currentPage === VM.maxPage||VM.maxPage <= 1,small_margin: VM.lastButtonSmallMargin}\"\n" +
    "      bento-test=\"last-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage('max')\" ng-keypress=\"goToPage('max')\" class=\"btn btn-default paginate_child_button\"><span class=\"bento-icon-chevron-last-right\"></span></a>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_input_wrap\" ng-if=\"VM.goBtnVisible && VM.maxPage > 1\">\n" +
    "        <span class=\"input-group paginate-input-group\">\n" +
    "            <input type=\"text\" class=\"form-control\" placeholder=\"{{currentPage}}\" ng-model=\"VM.tgtPage\"\n" +
    "                   ng-keypress=\"keySelectPage($event, VM.tgtPage)\"\n" +
    "                   bento-test=\"page-input\"\n" +
    "            >\n" +
    "            <span class=\"input-group-btn paginate_input_wrap\">\n" +
    "            <button class=\"go btn btn-default btn-sq\" ng-click=\"goToPage(VM.tgtPage)\"\n" +
    "                    bento-test=\"go-button\"\n" +
    "            >\n" +
    "              <i class=\"bento-icon-arrow-curved-right\" ng-if=\"VM.goIconVisible\"></i>\n" +
    "              {{VM.goIconVisible ? '':'BENTO_UI_PAGINATION_GO_BUTTON' | bentoTranslate:goToText}}\n" +
    "              </button>\n" +
    "            </span>\n" +
    "        </span>\n" +
    "  </li>\n" +
    "  <li class=\"paginate-bento-select\">\n" +
    "    <div data-bento-select>\n" +
    "      <select class=\"form-control\" ng-model=\"itemsPerPage\"\n" +
    "              ng-options=\"item.value as item.label for item in itemsArray\"\n" +
    "              bento-test=\"items-per-page-select\"\n" +
    "      >\n" +
    "      </select>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_info\" ng-if=\"VM.maxPage > 0\">\n" +
    "        <span class=\"ng-scope ng-binding\" bento-test=\"info-label\">{{\n" +
    "            'BENTO_UI_PAGINATION_INFO_PAGE_TEXT'\n" +
    "            | bentoTranslate:infoPageText\n" +
    "            | bentoStringReplace:'_PAGE_':currentPage\n" +
    "            | bentoStringReplace:'_PAGES_': Math.ceil(totalItems / itemsPerPage)\n" +
    "            }} </span>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_info_select\" ng-if=\"VM.maxPage > 0\">\n" +
    "        <span class=\"ng-scope ng-binding\" bento-test=\"info-select-label\">{{\n" +
    "            'BENTO_UI_PAGINATION_INFO_TEXT'\n" +
    "            | bentoTranslate:infoText\n" +
    "            | bentoStringReplace:'_START_':(currentPage - 1) * itemsPerPage + 1\n" +
    "            | bentoStringReplace:'_END_':(totalItems < (itemsPerPage * currentPage)) ? totalItems : (itemsPerPage * currentPage)\n" +
    "            | bentoStringReplace:'_MAX_':totalItems\n" +
    "            }} </span>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../templates/progressbar/bento-progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/progressbar/bento-progressbar.html",
    "<div class=\"progressbar-cell\"><uib-progressbar animate=\"animate\" value=\"dynamic\" type=\"{{barType}}\"></uib-progressbar></div>\n" +
    "<div class=\"value-cell\">{{dynamic}}%</div>\n" +
    "");
}]);

angular.module("../templates/scrollable-bar/bento-scrollable-bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/scrollable-bar/bento-scrollable-bar.html",
    "<button class=\"bento-scrollable-bar-side-arrow left\" type=\"button\" tabindex=\"-1\" ng-disabled=\"$ctrl._isLeftArrowDisabled\"\n" +
    "        ng-click=\"$ctrl.scrollBack()\">\n" +
    "  <i class=\"bento-icon-chevron-large-left\"></i>\n" +
    "</button>\n" +
    "<div class=\"bento-scrollable-bar-inner\" ng-transclude></div>\n" +
    "<button class=\"bento-scrollable-bar-side-arrow right\" type=\"button\" tabindex=\"-1\" ng-disabled=\"$ctrl._isRightArrowDisabled\"\n" +
    "        ng-click=\"$ctrl.scrollForward()\">\n" +
    "  <i class=\"bento-icon-chevron-large-right\"></i>\n" +
    "</button>\n" +
    "<div class=\"bento-scrollable-bar-cover left\" ng-hide=\"$ctrl._isLeftArrowDisabled\"></div>\n" +
    "<div class=\"bento-scrollable-bar-cover right\" ng-hide=\"$ctrl._isRightArrowDisabled\"></div>");
}]);

angular.module("../templates/scrollable-toolbar/bento-scrollable-toolbar-item.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/scrollable-toolbar/bento-scrollable-toolbar-item.html",
    "<div uib-dropdown ng-if=\"$ctrl.item.dropdown\" bento-dropdown-append-to-parent\n" +
    "     auto-realign=\"true\" bento-append-to-parent=\"#{{$ctrl.scrollableToolbar.id}}\"\n" +
    "     bento-busy-loader=\"$ctrl.item.isBusy\" bento-busy-loader-size=\"small\" ng-hide=\"$ctrl.item.hidden\"\n" +
    "     >\n" +
    "  <button uib-dropdown-toggle type=\"button\" class=\"dropdown-toggle\" role=\"menuitem\"\n" +
    "          ng-attr-id=\"{{$ctrl.item.id}}\" ng-class=\"$ctrl.item.className\"\n" +
    "          ng-click=\"$ctrl.item.action && $ctrl.item.action()\" ng-disabled=\"$ctrl.item.disabled\">\n" +
    "    <i ng-if=\"$ctrl.item.icon\" ng-class=\"$ctrl.item.icon\"></i>\n" +
    "    {{$ctrl.item.label}}\n" +
    "  </button>\n" +
    "  <ul class=\"dropdown-menu bento-scrollable-toolbar-dropdown-menu\"\n" +
    "      ng-attr-ariaLabelledby=\"{{'toggleDropdown'+$ctrl.item.label}\">\n" +
    "    <li ng-repeat=\"dropdownItem in $ctrl.item.dropdown\">\n" +
    "      <a class=\"dropdown-item\" role=\"menuitem\" ng-disabled=\"menuitem.disabled\" \n" +
    "         ng-class=\"menuItem.className\" ng-click=\"dropdownItem.action && dropdownItem.action()\"\n" +
    "         href ng-attr-id=\"{{dropdownItem.id}}\">\n" +
    "        <i ng-if=\"dropdownItem.icon\" ng-class=\"dropdownItem.icon\"></i>\n" +
    "        {{dropdownItem.label}}\n" +
    "      </a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "\n" +
    "<div uib-dropdown ng-if=\"$ctrl.item.megamenu\" bento-dropdown-append-to-parent\n" +
    "     auto-realign=\"true\" bento-append-to-parent=\"#{{$ctrl.scrollableToolbar.id}}\"\n" +
    "     bento-busy-loader=\"$ctrl.item.isBusy\" bento-busy-loader-size=\"small\" ng-hide=\"$ctrl.item.hidden\"\n" +
    "     >\n" +
    "  <button uib-dropdown-toggle type=\"button\" class=\"dropdown-toggle\" role=\"menuitem\"\n" +
    "          ng-attr-id=\"{{$ctrl.item.id}}\" ng-class=\"$ctrl.item.className\"\n" +
    "          ng-click=\"$ctrl.item.action && $ctrl.item.action()\" ng-disabled=\"$ctrl.item.disabled\">\n" +
    "    <i ng-if=\"$ctrl.item.icon\" ng-class=\"$ctrl.item.icon\"></i>\n" +
    "    {{$ctrl.item.label}}\n" +
    "  </button>\n" +
    "  <ul class=\"dropdown-menu megamenu\" ng-attr-ariaLabelledby=\"{{'toggleDropdown'+$ctrl.item.label}\">\n" +
    "    <li ng-repeat=\"column in $ctrl.item.megamenu\" class=\"column\">\n" +
    "      <h5 ng-if=\"column.label\">{{column.label}}</h5>\n" +
    "      <a role=\"\n" +
    "      menuitem\" ng-repeat=\"item in column.menu\" click=\".item.action && .item.action()\"\n" +
    "      ng-class=\"item.className\" href ng-disabled=\"item.disabled\" ng-attr-id=\"{{item.id}}\">\n" +
    "    <i ng-if=\"item.icon\" ng-class=\"item.icon\"></i>\n" +
    "    {{item.label}}\n" +
    "    </a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"$ctrl.item.template\" class=\"bento-toolbar-custom-item\" ng-include  ng-hide=\"$ctrl.item.hidden\"\n" +
    "     src=\"$ctrl.item.template\" bento-busy-loader=\"$ctrl.item.isBusy\" bento-busy-loader-size=\"small\">\n" +
    "</div>\n" +
    "\n" +
    "<div bento-busy-loader=\"$ctrl.item.isBusy\" bento-busy-loader-size=\"small\" ng-hide=\"$ctrl.item.hidden\">\n" +
    "  <button ng-if=\"!$ctrl.item.dropdown && !$ctrl.item.megamenu && !$ctrl.item.template\"\n" +
    "  type=\"button\" role=\"menuitem\" ng-class=\"$ctrl.item.className\" ng-click=\"$ctrl.item.action && $ctrl.item.action()\"\n" +
    "  ng-disabled=\"$ctrl.item.disabled\" ng-attr-id=\"{{$ctrl.item.id}}\">\n" +
    "<i ng-if=\"$ctrl.item.icon\" ng-class=\"$ctrl.item.icon\"></i>\n" +
    "{{$ctrl.item.label}}\n" +
    "<span ng-if=\"$ctrl.item.smartbadge\">\n" +
    "  <span bento-smart-badge details=$ctrl.item.smartbadge></span>\n" +
    "</span>\n" +
    "</button></div>\n" +
    "");
}]);

angular.module("../templates/scrollable-toolbar/bento-scrollable-toolbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/scrollable-toolbar/bento-scrollable-toolbar.html",
    "<div class=\"bento-scrollable-toolbar-wrapper bento-toolbar\">\n" +
    "  <div class=\"bento-scrollable-toolbar-inner\">\n" +
    "    <div ng-transclude=\"navbarLeft\"></div>\n" +
    "    <div class=\"navbar-nav\">\n" +
    "      <bento-scrollable-bar role=\"menu\" controller=\"$ctrl.scrollableBarController\">\n" +
    "        <bento-scrollable-toolbar-item ng-repeat=\"item in $ctrl.toolbarData\" item=\"item\"></bento-scrollable-toolbar-item>\n" +
    "      </bento-scrollable-bar>\n" +
    "    </div>\n" +
    "    <div ng-transclude=\"navbarRight\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/side_nav/bento-side-nav.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/side_nav/bento-side-nav.html",
    "<div class=\"bento-side-nav\">\n" +
    "    <span ng-if=\"!nav.hideSearch\" class=\"bento-search force-desktop\">\n" +
    "    <input bento-reset\n" +
    "           class=\"form-control input-sm\"\n" +
    "           type=\"text\"\n" +
    "           placeholder=\"Search\"\n" +
    "           ng-change=\"nav.onSearchChange()\"\n" +
    "           ng-model=\"nav.search\"\n" +
    "    />\n" +
    "    </span>\n" +
    "    <div class=\"bento-side-nav-container\">\n" +
    "      <div class=\"bento-side-nav-item\"\n" +
    "           ng-repeat=\"navItem in nav._data\" ng-if=\"!navItem.hidden\"\n" +
    "           ng-class=\"{active: nav.activeLinkLabel === navItem.link}\"\n" +
    "      >\n" +
    "        <h3 ng-if=\"navItem.is_eyebrow\" class=\"bento-eyebrow-header\">{{navItem.title}}</h3>\n" +
    "        <a ng-if=\"!navItem.is_eyebrow\" ng-href=\"#/{{navItem.link}}\" ng-bind-html=\"navItem.title\"></a>\n" +
    "        <span ng-repeat=\"label in navItem.labels\" class=\"label\" ng-class=\"{'label-{{label.type}}':label.type!==undefined}\">{{label.title}}</span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  \n" +
    "  </div>\n" +
    "  ");
}]);

angular.module("../templates/skip_links/bento-skip-links.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/skip_links/bento-skip-links.html",
    "<div ng-repeat=\"link in $ctrl.links track by $index\">\n" +
    "  <div class=\"bui-skip-link-divider\" ng-if=\"$index > 0\"></div>\n" +
    "  <a href=\"#\" ng-click=\"$ctrl.onLinkClick($event, link)\">{{link.text}}</a>\n" +
    "</div>");
}]);

angular.module("../templates/spread/bento-spread.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/spread/bento-spread.html",
    "<div id=\"ss\" class=\"bento-spreadjs\"></div>");
}]);

angular.module("../templates/tags_input/bento-tags-input-pill.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tags_input/bento-tags-input-pill.html",
    "<div tabindex=\"-1\"\n" +
    "     class=\"bento-tags-input-pill\"\n" +
    "     ng-class=\"getClass()\"\n" +
    "     title=\"{{label}}\"\n" +
    "    >\n" +
    "  <i class=\"bento-icon-edit\"\n" +
    "     ng-mousedown=\"onEditClick($event)\"\n" +
    "     tabindex=\"-1\"\n" +
    "     ng-if=\"!isEditing && editable && !ngReadonly\"\n" +
    "     bento-test=\"edit-icon\"\n" +
    "     ></i>\n" +
    "  <span\n" +
    "      class=\"bento-tags-input-pill-label\"\n" +
    "      ng-hide=\"isEditing\"\n" +
    "      bento-test=\"label\"\n" +
    "      >{{label}}</span>\n" +
    "  <i class=\"bento-icon-close-x\"\n" +
    "     tabindex=\"-1\"\n" +
    "     ng-click=\"onCloseClick($event)\"\n" +
    "     ng-if=\"!isEditing && !ngReadonly\"\n" +
    "     bento-test=\"close\"\n" +
    "     ></i>\n" +
    "  <input ng-model=\"editLabel\"\n" +
    "         ng-trim=\"false\"\n" +
    "         ng-keydown=\"onKeydown($event)\"\n" +
    "         ng-blur=\"onInputBlur($event)\"\n" +
    "         type=\"text\"\n" +
    "         ng-show=\"isEditing\"\n" +
    "         bento-test=\"input-edit\"\n" +
    "         tabindex=\"-1\"\n" +
    "         />\n" +
    "    <span class=\"bento-tags-input-pill-size-ref\">{{editLabel | bentoTagsInputPillFilter}}</span>\n" +
    "</div>");
}]);

angular.module("../templates/tags_input/bento-tags-input.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tags_input/bento-tags-input.html",
    "<div class=\"bento-tags-input form-control\"\n" +
    "     ng-class=\"getClass()\"\n" +
    "     ng-keydown=\"onKeydown($event)\">\n" +
    "  <div ng-repeat=\"tag in ngModel track by $index\"\n" +
    "       tag=\"tag\"\n" +
    "       bento-tags-input-pill\n" +
    "       editable=\"editable\"\n" +
    "       index=\"$index\"\n" +
    "       is-active=\"$index === activePill\"\n" +
    "       label=\"tag[propertyName]\"\n" +
    "       length=\"ngModel.length\"\n" +
    "       ng-blur=\"onPillBlur($index)\"\n" +
    "       ng-disabled=\"ngDisabled\"\n" +
    "       ng-focus=\"onPillFocus($index)\"\n" +
    "       on-close=\"onPillClose(index)\"\n" +
    "       on-delete-left=\"onPillDeleteLeft(index)\"\n" +
    "       on-delete-right=\"onPillDeleteRight(index)\"\n" +
    "       on-edit=\"onPillEdit(index)\"\n" +
    "       on-move-left=\"onPillMoveLeft(index)\"\n" +
    "       on-move-right=\"onPillMoveRight(index)\"\n" +
    "       on-pill-change=\"onPillChange(index,label, oldLabel)\"\n" +
    "       on-redundant-tag=\"onPillRedundant(index, isRedundant)\"\n" +
    "       on-tag-length=\"onPillTagLength(index, isValidLength)\"\n" +
    "       resize-callback=\"resizeInput(rect)\"\n" +
    "       ng-readonly=\"ngReadonly\"\n" +
    "       add-on-comma=\"addOnComma\"\n" +
    "       add-on-space=\"addOnSpace\"\n" +
    "       bento-test=\"tag-pill-{{$index}}\"\n" +
    "      ></div>\n" +
    "  <input class=\"bento-tags-input-text\"\n" +
    "         ng-disabled=\"ngDisabled\"\n" +
    "         ng-model=\"inputText\"\n" +
    "         ng-focus=\"onInputFocus()\"\n" +
    "         ng-keypress=\"onKeypress($event)\"\n" +
    "         ng-keyup=\"onKeyup($event)\"\n" +
    "         ng-show=\"!ngReadonly && !disableKeyInput\"\n" +
    "         placeholder=\"{{(!ngModel || ngModel.length === 0)? placeholder: ''}}\"\n" +
    "         type=\"text\"\n" +
    "         bento-test=\"input-tag\"\n" +
    "      />\n" +
    "  <input class=\"bento-tags-input-text-hidden\"\n" +
    "         ng-disabled=\"ngDisabled\"\n" +
    "         ng-show=\"!ngReadonly && !disableKeyInput\"\n" +
    "         ng-focus=\"onHiddenInputFocus()\"\n" +
    "         tabindex=\"-1\"\n" +
    "      />\n" +
    "</div>");
}]);

angular.module("../templates/tile-ribbon/bento_tile_ribbon_tile.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tile-ribbon/bento_tile_ribbon_tile.html",
    "<div class=\"bento-ribbon-tile-inner\"\n" +
    "     title=\"{{$ctrl.item.value ? $ctrl.item.value : $ctrl.item.header ? $ctrl.item.header : null}}\">\n" +
    "  <div ng-if=\"!$ctrl.template\">\n" +
    "    <div class=\"bento-ribbon-tile-value-wrapper\">\n" +
    "      <div class=\"bento-ribbon-tile-value\">{{$ctrl.item.value}}</div>\n" +
    "      <a ng-if=\"$ctrl.item.linkTitle\"\n" +
    "         ng-click=\"$ctrl.onLinkClick($event)\"\n" +
    "         class=\"bento-ribbon-tile-link\"\n" +
    "         tabindex=\"0\">{{$ctrl.item.linkTitle}}</a>\n" +
    "    </div>\n" +
    "    <div class=\"bento-ribbon-tile-header-wrapper\">\n" +
    "      <div ng-if=\"$ctrl.item.indicator\"\n" +
    "           class=\"bento-ribbon-tile-indicator\"\n" +
    "           ng-class=\"$ctrl.item.indicator\"></div>\n" +
    "      <p class=\"bento-ribbon-tile-header\">{{$ctrl.item.header}}</p>\n" +
    "    </div>\n" +
    "    <div ng-if=\"$ctrl.item.description\"\n" +
    "         class=\"bento-ribbon-tile-description\">{{$ctrl.item.description}}</div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../templates/tile-ribbon/bento_tile_ribbon.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tile-ribbon/bento_tile_ribbon.html",
    "<div class=\"bento-tile-ribbon-header\"\n" +
    "     ng-class=\"!$ctrl.title && !$ctrl.showCollapseToggle ? 'btrh-hidden' : (!$ctrl.title && $ctrl.showCollapseToggle? 'btrh-collapse' : 'btrh-title')\" title> <!-- intentionally empty title -->\n" +
    "  <h1 ng-if=\"$ctrl.title\">{{$ctrl.title}}</h1>\n" +
    "  <div ng-if=\"$ctrl.showCollapseToggle\"\n" +
    "       class=\"bento-tile-ribbon-visibility-toggle btn btn-link\"\n" +
    "       ng-click=\"$ctrl.toggleVisibility()\">\n" +
    "    <i ng-class=\"$ctrl.ribbonHidden ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"></i>\n" +
    "    <span>{{ ($ctrl.ribbonHidden? 'BENTO_UI_TILE_RIBBON_TOGGLE_SHOW'\n" +
    "          : 'BENTO_UI_TILE_RIBBON_TOGGLE_HIDE') | bentoTranslate }}</span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"bento-tile-ribbon-container\"\n" +
    "     ng-class=\"{hidden: $ctrl.ribbonHidden}\" title> <!-- intentionally empty title -->\n" +
    "  <button class=\"bento-tile-ribbon-arrow left\"\n" +
    "          ng-click=\"$ctrl.onArrowClick(false)\"\n" +
    "          ng-disabled=\"$ctrl.disableLeftArrow\">\n" +
    "    <i class=\"bento-icon-chevron-large-left\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"bento-tile-ribbon-wrapper\">\n" +
    "    <div class=\"bento-tile-ribbon-inner\">\n" +
    "      <div class=\"bento-tile-ribbon-panel\">\n" +
    "        <bento-tile-ribbon-tile ng-repeat=\"item in $ctrl.items\"\n" +
    "                                item=\"item\"\n" +
    "                                width=\"$ctrl.itemWidth\"\n" +
    "                                on-select=\"$ctrl.onTileSelect(tile)\"\n" +
    "                                template=\"$ctrl.tileTemplate\">\n" +
    "        </bento-tile-ribbon-tile>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <button class=\"bento-tile-ribbon-arrow right\"\n" +
    "          ng-click=\"$ctrl.onArrowClick(true)\"\n" +
    "          ng-disabled=\"$ctrl.disableRightArrow\">\n" +
    "    <i class=\"bento-icon-chevron-large-right\"></i>\n" +
    "  </button>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("../templates/toggle/bento-toggle.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/toggle/bento-toggle.html",
    "<div class=\"bento-toggle\"\n" +
    "     tabindex=\"0\"\n" +
    "     ng-class=\"{on : ngModel}\"\n" +
    "     aria-label=\"{{ngModel? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)}}\"\n" +
    "     ng-keydown=\"onKeydown($event)\"\n" +
    "  >\n" +
    "  <div class=\"bento-toggle-nob\"></div>\n" +
    "</div>");
}]);

angular.module("../templates/toolbar/bento-toolbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/toolbar/bento-toolbar.html",
    "<div ng-transclude=\"navbarLeft\" class=\"toolbar-navbar-left\" role=\"group\">\n" +
    "</div>\n" +
    "<ul class=\"nav navbar-nav\" role=\"menu\">\n" +
    "  <li ng-disabled=\"button.disabled\" \n" +
    "      role=\"menuitem\"\n" +
    "      aria-checked=\"{{button.active}}\"\n" +
    "      ng-attr-uib-dropdown=\"{{angular.isDefined(button.dropdown) || undefined}}\" \n" +
    "      ng-attr-uib-tooltip=\"{{button.tooltip}}\"\n" +
    "      tooltip-placement=\"{{button.tooltipPlacement || 'bottom'}}\"\n" +
    "      ng-if=\"!button.hidden && button.isVisible\"\n" +
    "      bento-toolbar-button\n" +
    "      ng-class=\"[button.className,{'transparent':button.isTransparent===true,'active':button.active}]\"\n" +
    "      ng-repeat=\"button in bentoToolbarCtrl.tData\"\n" +
    "      data-button-id=\"{{$index}}\"\n" +
    "      bento-busy-loader-size=\"small\"\n" +
    "      ng-attr-bento-busy-loader=\"button.isBusy\"\n" +
    "      bento-toolbar-ng-repeat-complete\n" +
    "      >\n" +
    "    <!-- if no dropdown, and regular button -->\n" +
    "    <a ng-if=\"!button.dropdown\" \n" +
    "       href=\"\" \n" +
    "       role=\"button\"\n" +
    "       ng-attr-id=\"{{button.id}}\" \n" +
    "       ng-class=\"{'disabled':button.disabled}\"\n" +
    "       ng-click=\"button.disabled||button.action($event)\"\n" +
    "       tabindex=\"{{button.disabled ? -1: 0}}\">\n" +
    "      <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>\n" +
    "      {{button.label}}\n" +
    "      <span class=\"toolbar-smart-badge\" bento-smart-badge details=button.smartbadge></span>\n" +
    "    </a>\n" +
    "    <!-- if there's a dropdown -->\n" +
    "    <a ng-if=\"button.dropdown\" \n" +
    "       href=\"\"\n" +
    "       class=\"dropdown-toggle\" \n" +
    "       role=\"button\"\n" +
    "       ng-disabled=\"button.disabled\"\n" +
    "       ng-attr-id=\"{{button.id}}\" \n" +
    "       ng-click=\"button.disabled||button.action?button.action($event):$event.preventDefault()\"\n" +
    "       tabindex=\"{{button.disabled ? -1: 0}}\"\n" +
    "       uib-dropdown-toggle>\n" +
    "       <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>\n" +
    "       {{button.label}}\n" +
    "       <span class=\"toolbar-smart-badge\" bento-smart-badge details=button.smartbadge></span>\n" +
    "    </a>\n" +
    "    <ul ng-if=\"button.dropdown\" class=\"dropdown-menu\" role=\"menu\">\n" +
    "      <li ng-disabled=\"subBtn.disabled\" \n" +
    "          ng-repeat=\"subBtn in button.dropdown\"\n" +
    "          role=\"menuitem\"\n" +
    "          >\n" +
    "        <span ng-if=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "        <a href=\"\" \n" +
    "           role=\"button\"\n" +
    "           ng-click=\"subBtn.disabled||subBtn.action($event)\"\n" +
    "           ng-attr-id=\"{{subBtn.id}}\" \n" +
    "           tabindex=\"{{subBtn.disabled ? -1: 0}}\">\n" +
    "           <i ng-if=\"subBtn.icon\" class=\"{{subBtn.icon}}\"></i>\n" +
    "           {{subBtn.label}}\n" +
    "           <span class=\"toolbar-smart-badge\" bento-smart-badge details=subBtn.smartbadge></span>\n" +
    "        </a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <!-- more button -->\n" +
    "  <li ng-if=\"bentoToolbarCtrl.moreVisible\" style=\"opacity:0;\" class=\"more-button dropdown\" data-more-buttons=\"true\" role=\"menuitem\" bento-toolbar-button uib-dropdown>\n" +
    "    <a href=\"\" \n" +
    "       class=\"dropdown-toggle\"\n" +
    "       uib-dropdown-toggle\n" +
    "       role=\"button\"\n" +
    "       tabindex=\"0\"\n" +
    "    >{{ bentoToolbarCtrl.moreButtonLabel || \"BENTO_UI_TOOLBAR_MORE\" | bentoTranslate }}\n" +
    "    </a>\n" +
    "    <ul class=\"more-dropdown-menu dropdown-menu\" ng-click=\"$event.stopPropagation()\" role=\"menu\">\n" +
    "      <li ng-disabled=\"button.disabled\" \n" +
    "          ng-repeat=\"button in bentoToolbarCtrl.tData\"\n" +
    "          ng-if=\"!button.hidden && !button.isVisible\"\n" +
    "          ng-class=\"[button.className,{'toolbar-dropdown-close':bentoToolbarDropdownCtrl.isOpen!=undefined&&bentoToolbarDropdownCtrl.isOpen===false,'toolbar-dropdown-open':bentoToolbarDropdownCtrl.isOpen===true, 'dropdown':button.dropdown}]\"\n" +
    "          ng-attr-bento-toolbar-dropdown=\"{{angular.isDefined(button.dropdown) || undefined}}\" \n" +
    "          role=\"menuitem\"\n" +
    "          bento-busy-loader-size=\"small\"\n" +
    "          ng-attr-bento-busy-loader=\"button.isBusy\"\n" +
    "          >\n" +
    "        <!-- if no dropdown, and regular button -->\n" +
    "        <span ng-if=\"button.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "        <a ng-if=\"!button.dropdown\" \n" +
    "           href=\"\" \n" +
    "           role=\"button\"\n" +
    "           ng-attr-id=\"{{button.id}}\" \n" +
    "           ng-click=\"button.disabled||button.action($event)\"\n" +
    "           tabindex=\"{{button.disabled ? -1: 0}}\">\n" +
    "           <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>\n" +
    "           {{button.label}}\n" +
    "           <span class=\"toolbar-smart-badge\" bento-smart-badge details=button.smartbadge></span>\n" +
    "        </a>\n" +
    "        <!-- if there's a dropdown -->\n" +
    "        <a ng-if=\"button.dropdown\" \n" +
    "           href=\"\"\n" +
    "           role=\"button\"\n" +
    "           class=\"toolbar-dropdown-toggle\" \n" +
    "           ng-disabled=\"button.disabled\"\n" +
    "           ng-attr-id=\"{{button.id}}\" \n" +
    "           aria-haspopup=\"true\"\n" +
    "           aria-expanded=\"{{bentoToolbarDropdownCtrl.isOpen}}\"\n" +
    "           ng-attr-tabindex=\"{{button.disabled ? -1: 0}}\"\n" +
    "           ng-click=\"$event.preventDefault();bentoToolbarDropdownCtrl.toggle(button)\">\n" +
    "           <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>\n" +
    "           {{button.label}}\n" +
    "           <span class=\"toolbar-smart-badge\" bento-smart-badge details=button.smartbadge></span>\n" +
    "        </a>\n" +
    "        <ul ng-if=\"button.dropdown\" class=\"toolbar-dropdown-menu\" role=\"menu\">\n" +
    "          <li ng-disabled=\"subBtn.disabled\" \n" +
    "              ng-repeat=\"subBtn in button.dropdown\"\n" +
    "              role=\"menuitem\"\n" +
    "              >\n" +
    "            <span ng-if=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "            <a href=\"\" \n" +
    "               role=\"button\"\n" +
    "               ng-attr-id=\"{{subBtn.id}}\"\n" +
    "               ng-click=\"subBtn.disabled||subBtn.action($event)\"\n" +
    "               tabindex=\"{{subBtn.disabled ? -1: 0}}\">\n" +
    "               <i ng-if=\"subBtn.icon\" class=\"{{subBtn.icon}}\"></i>\n" +
    "               {{subBtn.label}}\n" +
    "               <span class=\"toolbar-smart-badge\" bento-smart-badge details=subBtn.smartbadge></span>\n" +
    "            </a>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div ng-transclude class=\"toolbar-navbar-right\" role=\"group\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/transfer_box_basic/bento-transferbox-base.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/transfer_box_basic/bento-transferbox-base.html",
    "<div class=\"bento-transferlist-container\" ng-style=\"$ctrl.style\" >\n" +
    "  <bento-basic-tbox\n" +
    "    class=\"transferlist\"\n" +
    "    column-definitions=\"$ctrl.columnDefinitions\"\n" +
    "    grid-data=\"$ctrl.boxOneItemSource\"\n" +
    "    transfer-items=\"$ctrl.transferItemsOne(selectedItems,remainingItems)\"\n" +
    "    transfer-btn-text=\"$ctrl.transferBtnTextOne\"\n" +
    "    disable-transfer=\"$ctrl.disableTransfer\"\n" +
    "    info-shown=\"$ctrl.infoShown===undefined?true:$ctrl.infoShown\"\n" +
    "    box-title=\"$ctrl.boxOneTitle\"\n" +
    "    sub-title=\"$ctrl.boxOneSubTitle\"\n" +
    "    pagination-info-text=\"$ctrl.paginationInfoText\"\n" +
    "    pagination-info-page-text=\"$ctrl.paginationInfoPageText\"\n" +
    "    pagination-go-text=\"$ctrl.paginationGoText\"\n" +
    "    search-text=\"$ctrl.searchText\"\n" +
    "    height=\"$ctrl.height || 512\"\n" +
    "    control=\"$ctrl.box1\"\n" +
    "    box-one=\"true\">\n" +
    "  </bento-basic-tbox>\n" +
    "  <bento-basic-tbox\n" +
    "    class=\"transferlist\"\n" +
    "    column-definitions=\"$ctrl.columnDefinitions\"\n" +
    "    grid-data=\"$ctrl.boxTwoItemSource\"\n" +
    "    transfer-btn-text=\"$ctrl.transferBtnTextTwo\"\n" +
    "    transfer-items='$ctrl.transferItemsTwo(selectedItems,remainingItems)'\n" +
    "    disable-transfer=\"$ctrl.disableTransfer\"\n" +
    "    info-shown=\"$ctrl.infoShown===undefined?true:$ctrl.infoShown\"\n" +
    "    box-title=\"$ctrl.boxTwoTitle\"\n" +
    "    sub-title=\"$ctrl.boxTwoSubTitle\"\n" +
    "    pagination-info-text=\"$ctrl.paginationInfoText\"\n" +
    "    pagination-info-page-text=\"$ctrl.paginationInfoPageText\"\n" +
    "    pagination-go-text=\"$ctrl.paginationGoText\"\n" +
    "    search-text=\"$ctrl.searchText\"\n" +
    "    height=\"$ctrl.height || 512\"\n" +
    "    control=\"$ctrl.box2\">\n" +
    "  </bento-basic-tbox>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/transfer_box_basic/bento-transferbox-grid.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/transfer_box_basic/bento-transferbox-grid.html",
    "<div ng-if=\"$ctrl.boxOne\" class=\"transferbox-toolbar\">\n" +
    "  <span class=\"bento-search force-desktop\">\n" +
    "    <input type=\"text\" bento-reset ng-change=\"$ctrl.onFilterInput()\" ng-model=\"$ctrl.filterValue\" placeholder=\"{{'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' |\n" +
    "    bentoTranslate:searchText}}\">\n" +
    "  </span>\n" +
    "  <button class=\"btn transferbox-btn\"\n" +
    "        ng-class=\"{'btn-primary':$ctrl.hasSelection,'btn-default':!$ctrl.hasSelection}\"\n" +
    "        ng-disabled=\"!$ctrl.hasSelection || $ctrl.disableTransfer\"\n" +
    "        ng-click=\"$ctrl.transferItemsClick()\">{{'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD' |\n" +
    "      bentoTranslate:$ctrl.transferBtnText}}<span class=\"bento-icon-chevron-right\"></span></button>  \n" +
    "</div>\n" +
    "<div ng-if=\"!$ctrl.boxOne\" class=\"transferbox-toolbar\">\n" +
    "  <button class=\"btn transferbox-btn\"\n" +
    "        ng-class=\"{'btn-primary':$ctrl.hasSelection,'btn-default':!$ctrl.hasSelection}\"\n" +
    "        ng-disabled=\"!$ctrl.hasSelection || $ctrl.disableTransfer\"\n" +
    "        ng-click=\"$ctrl.transferItemsClick()\"><span class=\"bento-icon-chevron-left\"></span>{{'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE' |\n" +
    "      bentoTranslate:$ctrl.transferBtnText}}</button>  \n" +
    "  <span class=\"bento-search force-desktop\">\n" +
    "    <input type=\"text\" bento-reset ng-change=\"$ctrl.onFilterInput()\" ng-model=\"$ctrl.filterValue\" placeholder=\"{{'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' |\n" +
    "    bentoTranslate:searchText}}\">\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div class=\"transferlist-header\">\n" +
    "  <div class=\"transferlist-header-info\" ng-if=\"$ctrl.infoShown\">\n" +
    "    <h5 class=\"transferlist-header-title\">{{$ctrl.boxTitle}}</h5>\n" +
    "    <div class=\"transferlist-select-info\">{{\n" +
    "      $ctrl.totalSelected > 0 ?\n" +
    "      ('BENTO_UI_TRANSFER_BOX_INFO_TEXT'\n" +
    "      | bentoTranslate:$ctrl.subTitle\n" +
    "      | bentoStringReplace:'_SELECTED_':$ctrl.totalSelected\n" +
    "      | bentoStringReplace:'_TOTAL_':$ctrl.pagination.totalItems)\n" +
    "      : $ctrl.pagination.totalItems\n" +
    "      }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"bento-table-grid\">\n" +
    "  <div class=\"bento-table-header-row\">\n" +
    "    <input type=\"checkbox\"\n" +
    "     class=\"bento-checkbox\"\n" +
    "     id=\"header-checkbox\"\n" +
    "     ng-model=\"$ctrl.headerCheckboxModel\">\n" +
    "    <span ng-repeat=\"col in $ctrl.columnDefinitions\" class=\"bento-table-column-header\" ng-click=\"$ctrl.onHeaderClick(col)\">{{col.header}}<i class=\"sort-icon\" ng-class=\"{'bento-icon-chevron-up':$ctrl.colHeaderSort[col.binding].sortDirection==='asc','bento-icon-chevron-down':$ctrl.colHeaderSort[col.binding].sortDirection==='desc'}\"></i></span>\n" +
    "  </div>\n" +
    "  <div class=\"bento-table-body\" ng-style=\"$ctrl.tableStyle\">\n" +
    "    <div class=\"bento-table-row\" ng-class=\"{'selected':$ctrl.selection[item[$ctrl.uniqueKey]]}\" ng-click=\"$ctrl.onRowClick(item)\" ng-repeat=\"item in $ctrl.renderData track by $index\">\n" +
    "      <input type=\"checkbox\"\n" +
    "       class=\"bento-checkbox\"\n" +
    "       id=\"row-checkbox\"\n" +
    "       ng-click=\"$event.stopPropagation()\"\n" +
    "       ng-change=\"$ctrl.onCheckboxChange()\"\n" +
    "       ng-model=\"$ctrl.selection[item[$ctrl.uniqueKey]]\">\n" +
    "      <span ng-repeat=\"col in $ctrl.columnDefinitions\">{{item[col.binding]}}</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div bento-pagination\n" +
    "     ng-if=\"!hidePagination\"\n" +
    "     page=\"$ctrl.pagination.currentPage\"\n" +
    "     items-array=\"ctrl.pagination.itemsArray\"\n" +
    "     total-items=\"$ctrl.pagination.totalItems\"\n" +
    "     info-text=\"{{$ctrl.paginationInfoText}}\"\n" +
    "     info-page-text=\"{{$ctrl.paginationInfoPageText}}\"\n" +
    "     go-to-text=\"{{$ctrl.paginationGoText}}\"\n" +
    "     items-per-page=\"$ctrl.pagination.pageSize\"\n" +
    "     on-change=\"$ctrl.onPageChanged(page)\"\n" +
    "     on-change-size=\"$ctrl.onSizeChanged(size)\"\n" +
    "     class=\"\">\n" +
    "</div>");
}]);

angular.module("../templates/transfer_box/bento-flexgrid-transferbox-base.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/transfer_box/bento-flexgrid-transferbox-base.html",
    "<div class=\"bento-transferbox\" ng-class=\"{'force-desktop':desktopMode,'no-pagination':hidePagination}\" ng-style=\"bentoTransferBoxCtrl.style\" >\n" +
    "  <div id=\"main-splitter-group\"\n" +
    "       data-bento-splitter-group\n" +
    "       data-left-width=\"{{leftWidth || '60%'}}\"\n" +
    "       data-is-left-collapsed=\"toggleRight\"\n" +
    "       data-collapsed=\"false\"\n" +
    "       data-resizable=\"true\"\n" +
    "       data-on-resize=\"bentoTransferBoxCtrl.onSplitterResize()\"\n" +
    "       data-no-collapse=\"true\"\n" +
    "       class=\"\">\n" +
    "    <div data-bento-splitter-group-left>\n" +
    "        <div bento-flexgrid-tbox\n" +
    "          column-definitions=\"bentoTransferBoxCtrl.columnDefinitions\"\n" +
    "          grid-data=\"bentoTransferBoxCtrl.gridDataOne\"\n" +
    "          config=\"bentoTransferBoxCtrl.config\"\n" +
    "          transfer-items=\"bentoTransferBoxCtrl.checkItemsOne(items,gridData)\"\n" +
    "          show-filters=\"showFilters\"\n" +
    "          hide-pagination=\"hidePagination\"\n" +
    "          desktop-mode=\"desktopMode\"\n" +
    "          control=\"bentoTransferBoxCtrl.box1\"\n" +
    "          child-items-path=\"childItemsPath\"\n" +
    "          disable-transfer=\"bentoTransferBoxCtrl.config.disableTransfer\"\n" +
    "          grid-template-url=\"gridTemplateUrl\"\n" +
    "          box-one=\"true\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <section data-bento-splitter-group-main>\n" +
    "        <div bento-flexgrid-tbox\n" +
    "          column-definitions=\"bentoTransferBoxCtrl.columnDefinitions\"\n" +
    "          grid-data=\"bentoTransferBoxCtrl.gridDataTwo\"\n" +
    "          config=\"bentoTransferBoxCtrl.config\"\n" +
    "          show-filters=\"showFilters\"\n" +
    "          hide-pagination=\"hidePagination\"\n" +
    "          desktop-mode=\"desktopMode\"\n" +
    "          transfer-items='bentoTransferBoxCtrl.checkItemsTwo(items,gridData)'\n" +
    "          child-items-path=\"childItemsPath\"\n" +
    "          disable-transfer=\"bentoTransferBoxCtrl.config.disableTransfer\"\n" +
    "          grid-template-url=\"gridTemplateUrl\"\n" +
    "          control=\"bentoTransferBoxCtrl.box2\">\n" +
    "        </div>\n" +
    "    </section>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/transfer_box/bento-flexgrid-transferbox-grid.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/transfer_box/bento-flexgrid-transferbox-grid.html",
    "<div class=\"no-padding\">\n" +
    "  <!-- Show Info only once -->\n" +
    "  <p class=\"hidden container-info\"\n" +
    "     ng-if=\"bentoFlexgridTboxCtrl.boxOne\">\n" +
    "     The Transferbox is a tool to move items between two lists, typically from the source side to the destination side.\n" +
    "  </p>\n" +
    "\n" +
    "  <p class=\"hidden container-title\">\n" +
    "    {{bentoFlexgridTboxCtrl.tBoxAriaLabel.tboxSelectedAriaLabel}}\n" +
    "  </p>\n" +
    "  <!-- box one header -->\n" +
    "  <bento-scrollable-bar ng-if=\"bentoFlexgridTboxCtrl.boxOne\" class=\"tbox-sbar\" role=\"menu\" controller=\"bentoFlexgridTboxCtrl.scrollableBarControllerLeft\">\n" +
    "    <div class=\"bento-toolbar transferbox-header tbox-container left\">\n" +
    "      <ul class=\"transferbox-header-info\"\n" +
    "            ng-show=\"bentoFlexgridTboxCtrl.config.boxOneInfoShown\">\n" +
    "        <li class=\"bento-search transferbox-searchbox force-desktop\">\n" +
    "          <!-- <wj-input-mask ng-model=\"bentoFlexgridTboxCtrl.globalFilterText\" value-changed=\"bentoFlexgridTboxCtrl.globalFilterTextChange()\"></wj-input-mask> -->\n" +
    "          <input type=\"text\" \n" +
    "                bento-reset\n" +
    "                ng-change=\"bentoFlexgridTboxCtrl.globalFilterTextChange()\"\n" +
    "                ng-model=\"bentoFlexgridTboxCtrl.globalFilterText\"\n" +
    "                placeholder=\"{{'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate:searchText}}\">\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <h5 class=\"transferbox-header-title\">\n" +
    "            {{bentoFlexgridTboxCtrl.config.boxOneTitle}}\n" +
    "          </h5>\n" +
    "          <!-- INFO TEXT ONE -->\n" +
    "          <div class=\"transferbox-select-info\">\n" +
    "            {{\n" +
    "              bentoFlexgridTboxCtrl.selectedItems.length > 0 ?\n" +
    "              (BENTO_UI_TRANSFER_BOX_INFO_TEXT\n" +
    "              | bentoTranslate:bentoFlexgridTboxCtrl.config.infoText\n" +
    "              | bentoStringReplace:'_SELECTED_':bentoFlexgridTboxCtrl.selectedItems.length\n" +
    "              | bentoStringReplace:'_TOTAL_':bentoFlexgridTboxCtrl.config.totalItems)\n" +
    "              :\n" +
    "              bentoFlexgridTboxCtrl.config.totalItems;\n" +
    "            }}\n" +
    "          </div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "\n" +
    "      <!-- IE 11 Fix for ScrollableBar - Do not remove this empty DIV container -->\n" +
    "      <div class=\"\">\n" +
    "        <ul class=\"nav navbar-right transferbox-buttons\" role=\"group\">\n" +
    "          <li class=\"toggle-button-order\">\n" +
    "            <button class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "                    ng-class=\"{active:filter.showFilterIcons}\"\n" +
    "                    ng-click=\"bentoFlexgridTboxCtrl.toggleFilter()\">\n" +
    "              <i class=\"bento-icon-filter-az\"></i>\n" +
    "            </button>\n" +
    "          </li>\n" +
    "          <li class=\"transfer-button-order\">\n" +
    "            <button class=\"btn transferbox-btn\"\n" +
    "                    ng-class=\"{'btn-primary':bentoFlexgridTboxCtrl.selectedItems.length>0,'btn-default':!bentoFlexgridTboxCtrl.selectedItems.length}\"\n" +
    "                    ng-disabled=\"bentoFlexgridTboxCtrl.selectedItems.length<=0 || disableTransfer\"\n" +
    "                    ng-click=\"bentoFlexgridTboxCtrl.transferItems()\">\n" +
    "                    {{\n" +
    "                      bentoFlexgridTboxCtrl.config.transferBtnTextOne ? \n" +
    "                      ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnTextOne) :\n" +
    "                      ('BENTO_UI_TRANSFER_BOX_BTN_TEXT' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnText)\n" +
    "                    }}\n" +
    "                <span class=\"bento-icon-chevron-right\"></span>\n" +
    "              </button>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </bento-scrollable-bar>\n" +
    "\n" +
    "  <!-- box two header -->\n" +
    "  <bento-scrollable-bar ng-if=\"!bentoFlexgridTboxCtrl.boxOne\" class=\"tbox-sbar\" role=\"menu\" controller=\"bentoFlexgridTboxCtrl.scrollableBarControllerRight\">\n" +
    "    <div class=\"bento-toolbar transferbox-header tbox-container right\">\n" +
    "      <div class=\"\">\n" +
    "        <ul class=\"nav navbar-right transferbox-buttons\" role=\"group\">\n" +
    "          <li class=\"transfer-button-order\">\n" +
    "            <button class=\"btn transferbox-btn\"\n" +
    "                    ng-disabled=\"bentoFlexgridTboxCtrl.selectedItems.length<=0 || disableTransfer\"\n" +
    "                    ng-click=\"bentoFlexgridTboxCtrl.transferItems()\"\n" +
    "                    ng-class=\"{'btn-primary':bentoFlexgridTboxCtrl.selectedItems.length>0,'btn-default':!bentoFlexgridTboxCtrl.selectedItems.length}\">\n" +
    "              <span class=\"bento-icon-chevron-left\"></span>\n" +
    "              {{\n" +
    "                bentoFlexgridTboxCtrl.config.transferBtnTextTwo ?\n" +
    "                ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnTextTwo) :\n" +
    "                ('BENTO_UI_TRANSFER_BOX_BTN_TEXT' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnText)\n" +
    "              }}\n" +
    "            </button>\n" +
    "          </li>\n" +
    "          <li class=\"toggle-button-order\">\n" +
    "            <button class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "                    ng-class=\"{active:filter.showFilterIcons}\"\n" +
    "                    ng-click=\"bentoFlexgridTboxCtrl.toggleFilter()\">\n" +
    "              <i class=\"bento-icon-filter-az\"></i>\n" +
    "            </button>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </div>\n" +
    "      <ul class=\"transferbox-header-info\"\n" +
    "          ng-show=\"bentoFlexgridTboxCtrl.config.boxTwoInfoShown\">\n" +
    "        <li>\n" +
    "          <h5 class=\"transferbox-header-title\">\n" +
    "            {{bentoFlexgridTboxCtrl.config.boxTwoTitle}}\n" +
    "          </h5>\n" +
    "\n" +
    "          <!-- INFO TEXT TWO -->\n" +
    "          <div class=\"transferbox-select-info\">{{\n" +
    "            bentoFlexgridTboxCtrl.selectedItems.length > 0 ?\n" +
    "            ('BENTO_UI_TRANSFER_BOX_INFO_TEXT'\n" +
    "            | bentoTranslate:bentoFlexgridTboxCtrl.config.infoText\n" +
    "            | bentoStringReplace:'_SELECTED_':bentoFlexgridTboxCtrl.selectedItems.length\n" +
    "            | bentoStringReplace:'_TOTAL_':bentoFlexgridTboxCtrl.config.totalItems)\n" +
    "            :\n" +
    "            bentoFlexgridTboxCtrl.config.totalItems\n" +
    "            }}\n" +
    "          </div>\n" +
    "        </li>\n" +
    "        <li class=\"bento-search transferbox-searchbox right force-desktop\">\n" +
    "          <input type=\"text\"\n" +
    "                bento-reset\n" +
    "                ng-change=\"bentoFlexgridTboxCtrl.globalFilterTextChange()\"\n" +
    "                ng-model=\"bentoFlexgridTboxCtrl.globalFilterText\"\n" +
    "                placeholder=\"{{'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate:searchText}}\">\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </bento-scrollable-bar>\n" +
    "\n" +
    "  <wj-flex-grid\n" +
    "        control=\"bentoFlexgridTboxCtrl.flexGrid\"\n" +
    "        items-source=\"bentoFlexgridTboxCtrl.config.collectionView\"\n" +
    "        initialized=\"bentoFlexgridTboxCtrl.initialized(s,e)\"\n" +
    "        class=\"bento-flex-grid has-row-hover\"\n" +
    "        ng-attr-child-items-path=\"{{childItemsPath}}\"\n" +
    "        sort-row-index=\"0\"\n" +
    "        item-formatter=\"bentoFlexgridTboxCtrl.itemFormatter\"\n" +
    "        ng-style=\"{'height':bentoFlexgridTboxCtrl.config.height+(bentoFlexgridTboxCtrl.desktopMode ? 10 : 0)-bentoFlexgridTboxCtrl.config.offsetHeight+bentoFlexgridTboxCtrl.config.paginationOffsetHeight+'px'}\"\n" +
    "        selection-mode=\"None\"\n" +
    "        >\n" +
    "      <wj-flex-grid-filter initialized=\"bentoFlexgridTboxCtrl.initFilter(s)\" filter-applied=\"bentoFlexgridTboxCtrl.filterApplied(s)\"></wj-flex-grid-filter>\n" +
    "      <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "          <i \n" +
    "            ng-if=\"$row.index === 0\"\n" +
    "            ng-click=\"bentoFlexgridTboxCtrl.onHeaderCheckBoxChange()\"\n" +
    "            class=\"bento-flex-grid-checkbox\"\n" +
    "            ng-class=\"{'bento-icon-checkmark':bentoFlexgridTboxCtrl.headerCheckBoxMode === bentoFlexgridTboxCtrl.CHECKBOX_SELECTED,'bento-icon-minus-plain':bentoFlexgridTboxCtrl.headerCheckBoxMode === bentoFlexgridTboxCtrl.CHECKBOX_INDETERMINATE}\">\n" +
    "          </i>\n" +
    "      </wj-flex-grid-cell-template>\n" +
    "      <wj-flex-grid-cell-template\n" +
    "          cell-type=\"RowHeader\">\n" +
    "            <i \n" +
    "              ng-click=\"$item.disabled||bentoFlexgridTboxCtrl.onCheckBoxChange($item);\" \n" +
    "              ng-model=\"$item.bentoTboxSelect\" \n" +
    "              class=\"bento-flex-grid-checkbox\"\n" +
    "              ng-class=\"{'bento-icon-checkmark':$item.bentoTboxSelect,'disabled':$item.disabled === true}\">\n" +
    "            </i>\n" +
    "      </wj-flex-grid-cell-template>\n" +
    "      <wj-flex-grid-column \n" +
    "          ng-repeat=\"col in bentoFlexgridTboxCtrl.config.columnDefinitions\" \n" +
    "          ng-if=\"col.binding != 'bentoTboxSelect'\"\n" +
    "          min-width=\"{{col.minWidth || '80'}}\" \n" +
    "          width=\"{{col.width || '*'}}\" \n" +
    "          header=\"{{col.header}}\" \n" +
    "          binding=\"{{col.binding}}\"\n" +
    "          visible=\"{{col.visible || true}}\"\n" +
    "          data-type=\"{{col.dataType}}\"\n" +
    "          format=\"{{col.format}}\"\n" +
    "          allow-sorting=\"{{col.allowSorting || true}}\"\n" +
    "          allow-dragging=\"{{col.allowDragging || true}}\"\n" +
    "          is-read-only=\"{{col.isReadOnly || false}}\">\n" +
    "          <wj-flex-grid-cell-template\n" +
    "            ng-repeat=\"ct in col.cellTemplates\"\n" +
    "            ng-if=\"col.cellTemplates\"\n" +
    "            cell-type=\"{{ct.type}}\">\n" +
    "            <ng-include src=\"ct.templateUrl\">\n" +
    "            </ng-include>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "      </wj-flex-grid-column>\n" +
    "  </wj-flex-grid>\n" +
    "  <div bento-pagination\n" +
    "        ng-if=\"!hidePagination\"\n" +
    "        page=\"bentoFlexgridTboxCtrl.config.page\"\n" +
    "        items-array=\"ctx.itemPerPageOptions\"\n" +
    "        total-items=\"bentoFlexgridTboxCtrl.config.totalItems\"\n" +
    "        items-per-page=\"bentoFlexgridTboxCtrl.config.pageSize\"\n" +
    "        info-text=\"{{bentoFlexgridTboxCtrl.config.paginationInfoText}}\"\n" +
    "        info-page-text=\"{{bentoFlexgridTboxCtrl.config.paginationInfoPageText}}\"\n" +
    "        go-text=\"{{bentoFlexgridTboxCtrl.config.paginationGoText}}\"\n" +
    "        class=\"\">\n" +
    "  </div>\n" +
    "  <div ng-if=\"showFilters!=false\" class=\"input-filter-container\"></div>\n" +
    "</div>");
}]);

angular.module("../templates/tree-view/bento-tree-view.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tree-view/bento-tree-view.html",
    "<div class=\"bento-tree-view-container\">\n" +
    "  <style>\n" +
    "  </style>\n" +
    "  <div\n" +
    "    class=\"bento-expand-collapse-button-group\"\n" +
    "    ng-if=\"$treeViewCtrl.showExpandCollapseAllButtons\"\n" +
    "  >\n" +
    "    <button\n" +
    "      class=\"btn btn-default btn-xs btn-icon\"\n" +
    "      ng-click=\"$treeViewCtrl.expandAll()\"\n" +
    "      title=\"{{'BENTO_UI_TREE_EXPAND_ALL' | bentoTranslate}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"bento-expand-divider\"></div>\n" +
    "    <button\n" +
    "      class=\"btn btn-default btn-xs btn-icon\"\n" +
    "      ng-click=\"$treeViewCtrl.collapseAll()\"\n" +
    "      title=\"{{'BENTO_UI_TREE_COLLAPSE_ALL' | bentoTranslate}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <div class=\"bento-tree-view-wrapper\">\n" +
    "    <div\n" +
    "      bento-table\n" +
    "      bento-table-control=\"$treeViewCtrl.btControl\"\n" +
    "      column-definitions=\"$treeViewCtrl.btColumnDefinitions\"\n" +
    "      source-data-callback=\"$treeViewCtrl.feedTreeData\"\n" +
    "      source-data-ready-callback=\"$treeViewCtrl.onBTReady\"\n" +
    "      options=\"$treeViewCtrl.btOptions\"\n" +
    "    ></div>\n" +
    "    <script type=\"text/ng-template\" id=\"tree-view-default-cell-template\">\n" +
    "      <div class=\"bui-tree-view-item {{($row[$treeViewCtrl.nodeChildren] ? 'has-children' : '') +\n" +
    "      ($row[$treeViewCtrl.selectModel] ? ' bui-tree-view-item-selected' : '')}}\"\n" +
    "           rel=\"{{$index}}\"\"\n" +
    "           role=\"treeitem\">\n" +
    "        <div class=\"bui-tree-view-item-inner\"\n" +
    "             ng-style=\"$treeViewCtrl.getIndentation($row)\">\n" +
    "          <button ng-if=\"$row[$treeViewCtrl.nodeChildren] && !$row.hideCheckbox\"\n" +
    "                  aria-expanded=\"{{!$row.collapsed}}\"\n" +
    "                  ng-click=\"$treeViewCtrl.toggleCollapse($row)\"\n" +
    "                  type=\"button\" class=\"bui-tree-view-expand-btn\"></button>\n" +
    "          <div class=\"bui-tree-view-item-content\" >\n" +
    "            <i ng-if=\"!!$treeViewCtrl.treeIcon && !!$row[$treeViewCtrl.treeIcon]\"\n" +
    "               class=\"{{$row[$treeViewCtrl.treeIcon]}}\"></i>\n" +
    "            <input ng-if=\"$treeViewCtrl.checkboxModel && !$row.hideCheckbox\"\n" +
    "                   type=\"checkbox\"\n" +
    "                   class=\"bento-checkbox\"\n" +
    "                   ng-indeterminate=\"$row[$treeViewCtrl.indeterminateProp]\"\n" +
    "                   ng-model=\"$row[$treeViewCtrl.checkboxModel]\"\n" +
    "                   ng-change=\"$treeViewCtrl.onCheckChange($row)\">\n" +
    "            <ng-include src=\"$treeViewCtrl.rowTemplate\" ></ng-include>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </script>\n" +
    "    <script type=\"text/ng-template\" id=\"tree-view-default-row-template\">\n" +
    "      <span class=\"bui-tree-view-item-label\" ng-click=\"$treeViewCtrl.onItemSelect($row, $event)\">\n" +
    "          <i ng-if=\"!!$treeViewCtrl.secondTreeIcon && !!$row[$treeViewCtrl.secondTreeIcon]\"\n" +
    "          ng-class=\"$row[$treeViewCtrl.secondTreeIcon]\"></i>\n" +
    "        <span ng-bind-html=\"$row[$treeViewCtrl.treeLabel]\"></span>\n" +
    "      </span>\n" +
    "    </script>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/tree/bento-tree.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/tree/bento-tree.html",
    "<div>\n" +
    "  <div class=\"bento-search force-desktop\" ng-if=\"$ctrl.isRoot && searchable()\">\n" +
    "      <input bento-reset class=\"form-control\" type=\"text\" ng-model=\"$ctrl.search\" ng-change=\"$ctrl.onSearchChange($event)\"/>\n" +
    "  </div>\n" +
    "  <div class=\"bento-expand-collapse-button-group\" ng-if=\"showExpandCollapseAllButtons()\">\n" +
    "    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "            ng-click=\"expandAll()\"\n" +
    "            title=\"{{'BENTO_UI_TREE_EXPAND_ALL' | bentoTranslate}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"bento-expand-divider\"></div>\n" +
    "    <button class=\"btn btn-default btn-xs btn-icon\"\n" +
    "            ng-click=\"collapseAll()\"\n" +
    "            title=\"{{'BENTO_UI_TREE_COLLAPSE_ALL' | bentoTranslate}}\"\n" +
    "    >\n" +
    "      <i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <div class=\"bento-tree-branch\">\n" +
    "    <ul class=\"bento-tree-branch-base\">\n" +
    "      <li ng-repeat=\"node in treeModel\"\n" +
    "          class=\"bento-tree-node\"\n" +
    "          ng-class=\"getNodeSelectionClass(node)\"\n" +
    "          id=\"{{getTreeId(node)}}\"\n" +
    "          ng-hide=\"node.$$bentoNodeHidden || node.hidden\"\n" +
    "          ng-if=\"$ctrl.branchReady\"\n" +
    "          role=\"treeitem\">\n" +
    "        <div class=\"bento-tree-node-content\">\n" +
    "          <div class=\"expand-button-compiled\"\n" +
    "               ng-if=\"node[nodeChildren]\"\n" +
    "               ng-hide=\"navMode()\"\n" +
    "               ng-click=\"toggleCollapse(node)\"\n" +
    "               ng-attr-tabindex=\"{{node.disabled ||treeDisabled ? '-1' : '0'}}\"\n" +
    "               >\n" +
    "            <div\n" +
    "                ng-class=\"{'bento-icon-minus-plain':!node.collapsed,'bento-icon-plus-plain':node.collapsed}\"></div>\n" +
    "          </div>\n" +
    "          <i ng-class=\"node[treeIcon]\" ng-if=\"!!node[treeIcon]\"></i>\n" +
    "          <input type=\"checkbox\"\n" +
    "                 id=\"{{getTreeId(node)}}-checkbox\"\n" +
    "                 class=\"bento-tree-check-box bento-checkbox\"\n" +
    "                 ng-if=\"useCheckbox && !node.hideCheckbox\"\n" +
    "                 ng-model=\"node[checkboxModel]\"\n" +
    "                 ng-click=\"checkboxClick(node)\"\n" +
    "                 ng-disabled=\"node.disabled || treeDisabled\"\n" +
    "                 tabindex=\"{{selectAsCheck || nopde.disabled ||treeDisabled ? '-1' : '0'}}\"\n" +
    "                 aria-labelledby=\"{{getTreeId(node)}}-label\"\n" +
    "          />\n" +
    "          <i class=\"{{node[secondTreeIcon]}} bento-tree-icon second-tree-icon\"\n" +
    "             ng-if=\"!!node[secondTreeIcon]\"\n" +
    "          ></i>\n" +
    "          <div ng-click=\"labelSelect(node, $event)\"\n" +
    "               ng-keydown=\"onTreeItemKeydown($event, node)\"\n" +
    "               ng-keyup=\"onTreeItemKeyup($event, node)\"\n" +
    "               class=\"bento-tree-item-cta\"\n" +
    "               ng-class=\"{'bento-tree-node-parent':node[nodeChildren], 'bento-tree-item-static':node.static}\"\n" +
    "               id=\"{{getTreeId(node)}}-label\"\n" +
    "               aria-label=\"{{node[treeLabel] | bentoStripHtml}}{{\n" +
    "            node.items.length > 0 ? ' ' +\n" +
    "              (node.collapsed ?\n" +
    "                ('BENTO_UI_TREE_COLLAPSED'|bentoTranslate) : ('BENTO_UI_TREE_EXPANDED'|bentoTranslate))\n" +
    "              : ''\n" +
    "            }}\"\n" +
    "              ng-attr-tabindex=\"{{node.disabled||treeDisabled||node.static ? '-1' : '0'}}\"\n" +
    "          >\n" +
    "            <div ng-bind-html=\"node[treeLabel]\"></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div bento-tree\n" +
    "             ng-if=\"node[nodeChildren]\"\n" +
    "             ng-hide=\"node.collapsed\"\n" +
    "             tree-icon=\"{{treeIcon}}\"\n" +
    "             tree-model=\"node[nodeChildren]\"\n" +
    "             tree-collapsed=\"treeCollapsed\"\n" +
    "             tree-label=\"{{treeLabel}}\"\n" +
    "             node-children=\"{{nodeChildren}}\"\n" +
    "             collapsing-callback=\"collapsingCallback\"\n" +
    "             expanding-callback=\"expandingCallback\"\n" +
    "             select-callback=\"selectCallback\"\n" +
    "             multi-select=\"multiSelect\"\n" +
    "             use-checkbox=\"useCheckbox\"\n" +
    "             checkbox-model=\"{{checkboxModel}}\"\n" +
    "             select-model=\"{{selectModel}}\"\n" +
    "             selectable-model=\"{{selectableModel}}\"\n" +
    "             second-tree-icon=\"{{secondTreeIcon}}\"\n" +
    "             on-checkbox-change=\"onCheckboxChange\"\n" +
    "             select-as-check=\"selectAsCheck\"\n" +
    "             tree-selection-helper=\"treeSelectionHelper\"\n" +
    "             expand-only-model=\"{{expandOnlyModel}}\"\n" +
    "             tree-disabled=\"node.disabled || treeDisabled\"\n" +
    "             tree-level=\"currentLevel\"\n" +
    "             independent-checkbox=\"independentCheckbox()\"\n" +
    "             nav-mode=\"navMode()\"\n" +
    "        >\n" +
    "        </div>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-class=\"{open: isOpen}\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><i ng-class=\"isOpen === true ? 'bento-icon-minus-plain' : 'bento-icon-plus-plain'\" ></i><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>");
}]);

angular.module("../templates/universe_filter/bento-universe-filter-dropdown.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/universe_filter/bento-universe-filter-dropdown.html",
    "<div class=\"bento-uni-filter row\" ng-class=\"[{'has-back-btn':bentoUniverseFilterCtrl.hasBackBtn,'first-open':bentoUniverseFilterCtrl.isOpen[0],'align-right':bentoUniverseFilterCtrl.alignPosition==='right','full-width':bentoUniverseFilterCtrl.alignPosition==='full'},bentoUniverseFilterCtrl.isLastOpen()]\">\n" +
    "	<div class=\"bento-uni-filter_back-btn\" \n" +
    "		ng-if=\"bentoUniverseFilterCtrl.hasBackBtn\" \n" +
    "		ng-disabled=\"bentoUniverseFilterCtrl.backButtonDisabled\" \n" +
    "		ng-click=\"bentoUniverseFilterCtrl.onBackButtonClick()\"\n" +
    "		ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.onBackButtonClick():0\"\n" +
    "		tabindex=\"0\">\n" +
    "		<i class=\"bento-icon-arrow-left\"></i>\n" +
    "	</div>\n" +
    "	<div class=\"bento-uni-filter_item\" \n" +
    "		ng-repeat=\"item in bentoUniverseFilterCtrl.filterItems | limitTo: 4\" \n" +
    "		ng-class=\"{'col-xs-12':bentoUniverseFilterCtrl.filterItems.length===1,'col-xs-6':bentoUniverseFilterCtrl.filterItems.length===2,'col-xs-4':bentoUniverseFilterCtrl.filterItems.length===3,'col-xs-3':bentoUniverseFilterCtrl.filterItems.length>=4,'selected':bentoUniverseFilterCtrl.selectedName===item.name, 'open':bentoUniverseFilterCtrl.isOpen[$index]}\"\n" +
    "		tabindex=\"0\" ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.isOpen[$index]=!bentoUniverseFilterCtrl.isOpen[$index]:0\" uib-dropdown dropdown-append-to=\"bentoUniverseFilterCtrl.appendToElement\" auto-close=\"outsideClick\" is-open=\"bentoUniverseFilterCtrl.isOpen[$index]\">\n" +
    "		<div class=\"bento-uni-filter_dropdown-toggle\" href uib-dropdown-toggle>\n" +
    "			<div class=\"bento-uni-filter_item-header\">{{item.name}}</div>\n" +
    "			<div class=\"bento-uni-filter_item-text\" bento-universe-filter-ellipsis bento-ellipsis-text=\"item.selectedName || bentoUniverseFilterCtrl.selectText\" data-uib-tooltip=\"{{item.selectedName || bentoUniverseFilterCtrl.selectText}}\" tooltip-placement=\"bottom\"></div>\n" +
    "			<i class=\"bento-uni-filter_carat bento-icon-caret-down\"></i>\n" +
    "		</div>\n" +
    "		<div class=\"bento-uni-filter_dropdown-menu\" ng-class=\"{'dropdown-menu-right': bentoUniverseFilterCtrl.isRTL === true}\" uib-dropdown-menu>\n" +
    "			<div bento-universe-filter-dropdown-menu filter-item=\"item\" is-open=\"bentoUniverseFilterCtrl.isOpen[$index]\" ng-include src=\"item.modalTemplateUrl || item.templateUrl || 'bentoUniFilterDropdownMenu.html'\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"bento-uni-filter_back-drop\"></div>\n" +
    "\n" +
    "<script type=\"text/ng-template\" id=\"bentoUniFilterDropdownMenu.html\">\n" +
    "  <ul class=\"bento-uni-filter_dropdown-list\">\n" +
    "  	<li ng-repeat=\"item in bentoUniFilterItemCtrl.filterItem.items\" ng-click=\"bentoUniFilterItemCtrl.selectItem(item, bentoUniFilterItemCtrl.filterItem)\" ng-keypress=\"($event.which === 13)?bentoUniFilterItemCtrl.selectItem(item, bentoUniFilterItemCtrl.filterItem):0\" ng-class=\"{'selected':item.name === bentoUniFilterItemCtrl.filterItem.selectedName}\" tabindex=\"0\">{{item.name}}</li>\n" +
    "  </ul>\n" +
    "</script>");
}]);

angular.module("../templates/universe_filter/bento-universe-filter.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../templates/universe_filter/bento-universe-filter.html",
    "<div class=\"bento-uni-filter row\" ng-class=\"{'has-back-btn':bentoUniverseFilterCtrl.hasBackBtn}\">\n" +
    "	<div class=\"bento-uni-filter_back-btn\" \n" +
    "		ng-if=\"bentoUniverseFilterCtrl.hasBackBtn\" \n" +
    "		ng-disabled=\"bentoUniverseFilterCtrl.backButtonDisabled\" \n" +
    "		ng-click=\"bentoUniverseFilterCtrl.onBackButtonClick()\"\n" +
    "		ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.onBackButtonClick():0\"\n" +
    "		tabindex=\"0\">\n" +
    "		<i class=\"bento-icon-arrow-left\"></i>\n" +
    "	</div>\n" +
    "	<div class=\"bento-uni-filter_item\" \n" +
    "		ng-repeat=\"item in bentoUniverseFilterCtrl.filterItems | limitTo: 4\" \n" +
    "		ng-class=\"{'col-xs-12':bentoUniverseFilterCtrl.filterItems.length===1,'col-xs-6':bentoUniverseFilterCtrl.filterItems.length===2,'col-xs-4':bentoUniverseFilterCtrl.filterItems.length===3,'col-xs-3':bentoUniverseFilterCtrl.filterItems.length>=4,'selected':bentoUniverseFilterCtrl.selectedName===item.name}\"\n" +
    "		ng-click=\"bentoUniverseFilterCtrl.openModal(item)\"\n" +
    "		ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.openModal(item):0\"\n" +
    "		tabindex=\"0\">\n" +
    "		<div class=\"bento-uni-filter_item-header\">{{item.name}}</div>\n" +
    "		<div class=\"bento-uni-filter_item-text\" bento-universe-filter-ellipsis bento-ellipsis-text=\"item.selectedName || bentoUniverseFilterCtrl.selectText\" data-uib-tooltip=\"{{item.selectedName || bentoUniverseFilterCtrl.selectText}}\" tooltip-placement=\"bottom\"></div>\n" +
    "		<i class=\"bento-uni-filter_carat bento-icon-caret-down\"></i>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<script type=\"text/ng-template\" id=\"bentoUniFilterModal.html\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"closeModal()\" ng-keypress=\"($event.which === 13)?closeModal():0\" tabindex=\"0\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\">\n" +
    "    Select {{filterItem.name}}\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <ul class=\"bento-uni-filter_modal-list\">\n" +
    "    	<li ng-repeat=\"item in filterItem.items\" ng-click=\"selectItem(item, filterItem)\" ng-keypress=\"($event.which === 13)?selectItem(item, filterItem):0\" tabindex=\"0\">{{item.name}}</li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</script>");
}]);

(function(angular){

  'use strict';

  angular.module('bento.cookie',[])
    .provider('$bentoCookie', function(){

      this.getCookie = _getCookie;

      this.$get = [function(){
        return {
          getCookie : _getCookie
        };
      }];

      function _getCookie(cookieName, defaultValue){
        var cookie = (document.cookie.match('(^|; )' + cookieName + '=([^;]*)') || 0)[2];

        if((cookie === null || cookie === '' || typeof cookie === 'undefined') && !!defaultValue){
          cookie = defaultValue;
        }

        return cookie;
      }
    });

})(window.angular);

/* jshint -W044 */
(function (angular) {

  'use strict';

  // This greatly helps finding out the current JS file / Bento Frameworks location
  // and a possible solution to bundling issues with the i18n files
  var jsScripts = document.getElementsByTagName("script");
  var currentJSFileSrc = jsScripts[jsScripts.length - 1].src;

  /**
   * Bento Service Module
   */
  angular.module('bento.services', ['ui.bootstrap.tooltip'])
    /**
     * Config the whole framework
     */
    .config([
      '$animateProvider',
      '$uibTooltipProvider',
      function ($animateProvider, $uibTooltipProvider) {
        // Register `ng-animate-disabled` as a class to turn off ng-animate
        $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

        // Add UIB Tooltip trigger
        $uibTooltipProvider.setTriggers({
          'touchstart': 'touchstart'
        });

        // This is redundant but we'll use it for the time been
        var msTouchEnabled = window.navigator.msMaxTouchPoints;
        var generalTouchEnabled = "ontouchstart" in document.createElement("div");

        if (msTouchEnabled || generalTouchEnabled) {
          angular.element(document.getElementsByTagName('body')).addClass('touch');
        }

        var os = getOS();

        angular.element(document.getElementsByTagName('body')).addClass(os);

        var browser = getBrowser();

        angular.element(document.getElementsByTagName('body')).addClass(browser.browser);
        angular.element(document.getElementsByTagName('body')).addClass(browser.browserVersion);
      }
    ])
    /**
     * FILTER: Highlight a substring that matches the value and return it with <strong></strong>
     */
    .filter('highlight', function () {

      /**
       * @param str - input string
       * @param value - search string
       * @param bypass - bypass highlighting
       */
      return function (_str, value, bypass) {

        if (value === '' || typeof value === 'undefined' || bypass) {
          return _str;
        }

        var str = _str || '';
        var newStr;
        var re = new RegExp('(' + value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ')', 'gi');
        newStr = str.replace(re, '<span class="matching-text-highlight">$&</span>');

        return newStr;
      };
    })
    /**
     * Find and replace a subString within a string
     */
    .filter('bentoStringReplace', function () {
      return function (str, find, replace) {
        if (str) {
          return str.replace(find, replace);
        }
        return;
      }
    })
    /**
     * Strip HTML from a string
     */
    .filter('bentoStripHtml', function () {
      return function (str) {
        return str ? String(str).replace(/<[^>]+>/gm, '') : '';
      };
    })
    /**
     * Provide keycodes
     */
    .factory('$bentoKeyboard', function () {
      return {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAUSE: 19,
        CAPS_LOCK: 20,
        ESC: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        INSERT: 45,
        DELETE: 46,
        COMMAND: 91,
        COMMA: 188,
      };
    })
    /**
     * BentoService Factory to provide various services and utilities
     */
    .factory('$bentoServices', [
      '$window',
      '$timeout',
      function ($window, $timeout) {
        return {
          // Returns current IE version
          getIEVersion: getIEVersion,
          // rAF for animation
          rAF: RAFProvider,
          // Detect retina displays
          retina: $window.devicePixelRatio > 1,
          // Check if the device is touch supported
          isTouchSupported: isTouchSupported,
          // Generate a numeric uniqueID
          generateUID: generateUID,
          // Fire scope.$apply safely
          safeApply: safeApply,
          // Check if a keyCode is printable
          isPrintableKeyCode: isPrintableKeyCode,
          // Check if desktop
          isDesktop: isDesktop,
          // Remove all browser selections
          removeBrowserSelection: removeBrowserSelection,
          // Find focussable elements in element
          findFocussable: findFocussable,
          // Find tabbable elements in element
          findTabbable: findTabbable,
          // Find if the element is visible on the stage
          isVisible: isVisible,
          // Loop tabble elements in an element
          loopTabbables: loopTabbables,
          // Find if RTL
          isRTL: isRTL,
          // Get the closest scrollable parent
          getScrollableParent: getScrollableParent,
          // get browser version
          getBrowser: getBrowser,
          // Get scrollbar width
          getScrollbarWidth: getScrollbarWidth
        };

        /**
         * Calculates scrollbar width
         */
        function getScrollbarWidth() {
          var outter = document.createElement('div');
          var inner = document.createElement('div');
          var width;
          outter.style.width = '100px';
          outter.style.height = '100px';
          outter.style.overflow = 'auto';
          outter.style.position = 'fixed';
          outter.style.top = '-200px';
          inner.style.height = '110px';
          outter.appendChild(inner);
          document.body.appendChild(outter);
          width = 100 - inner.offsetWidth;
          document.body.removeChild(outter);

          return width;
        }

        /**
         * Loop tabbable elements in a given element
         * Caution: USE THIS WISELY
         * @param  {jqLite Element} element - The container element
         */
        function loopTabbables($element) {
          $element[0].addEventListener('keydown', function (event) {
            if (event.keyCode === 9) {
              var tabbables = findTabbable($element[0]);
              if (event.shiftKey) {
                if (tabbables.indexOf(event.target) === 0) {
                  tabbables[tabbables.length - 1].focus();
                  event.preventDefault();
                  event.stopPropagation();
                }
              } else {
                if (tabbables.indexOf(event.target) === tabbables.length - 1 && tabbables[0]) {
                  tabbables[0].focus();
                  event.preventDefault();
                  event.stopPropagation();
                }
              }
            }
          });
        }

        /**
         * Find focussable elements in an element
         * @param  {htmlElement} element - container htmlElement
         * @return {array}         array of elements that are focussable
         */
        function findFocussable(element) {
          var els = element.querySelectorAll('a,input,select,textarea,button,[tabindex]'),
            elArray = [],
            el;

          for (var i = 0, len = els.length; i < len; i++) {
            el = els[i];
            if (isVisible(el) && (!el.hasAttribute('disabled') || el.nodeName === 'A')) {
              elArray.push(el);
            }
          }

          return elArray;
        }

        /**
         * Find tabbable element in an element
         * @param  {htmlElement} element - container htmlElement
         * @return {array}          array of elements that are tabbable
         */
        function findTabbable(element) {
          var elArray = findFocussable(element);

          return elArray.filter(function (item, index) {
            var a = item.getAttribute('tabindex');
            if (!a || a != -1) {
              return true;
            }
          });
        }

        function isVisible(element) {
          return !(element.offsetWidth === 0 && element.offsetHeight === 0);
        }

        /**
         * Remove all browser selections
         */
        function removeBrowserSelection() {
          // Remove all text selections from the document
          if (window.getSelection) {
            // Chrome & Safari
            if (window.getSelection().empty) {
              window.getSelection().empty();
            } else
              // Firefox
              if (window.getSelection().removeAllRanges) {
                window.getSelection().removeAllRanges();
              }
          } else
            // IE
            if (document.selection) {
              document.selection.empty();
            }
        }

        /**
         * isDesktop
         * @returns {boolean}
         *
         * Check if current device is desktop
         *
         */
        function isDesktop() {
          var os = getOS();
          return os != 'android' && os != 'ios';
        }

        /**
         * isTouchSupported
         * @returns {boolean}
         *
         * Check of the current device is touch friendly
         *
         */
        function isTouchSupported() {
          var msTouchEnabled = window.navigator.msMaxTouchPoints;
          var generalTouchEnabled = "ontouchstart" in document.createElement("div");

          return msTouchEnabled || generalTouchEnabled;
        }

        /**
         * safeApply a function on a scope
         * @param scope
         * @param fn
         *
         */
        function safeApply(scope, fn) {
          var phase;
          if (scope && scope.$root) {
            phase = scope.$root.$$phase;
          }
          if (phase === '$apply' || phase === '$digest' || typeof phase === 'undefined') {
            if (fn && (typeof (fn) === 'function')) {
              fn();
            }
          } else {
            scope.$apply(fn);
          }
        }

        /**
         * getIEVersion
         * @returns {number}
         *
         * Returns the version of Internet Explorer or a -1
         * (indicating the use of another browser).
         */
        function getIEVersion() {
          var rv = -1; // Return value assumes failure.
          var ua;
          var re;
          if (navigator.appName === 'Microsoft Internet Explorer') {

            ua = navigator.userAgent;
            re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
            }
          } else if (navigator.appName === 'Netscape') {
            ua = navigator.userAgent;
            re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
            }
          }

          return rv;
        }

        /**
         * Generate an unique numeric ID
         */
        function generateUID() {
          return Math.round(Math.random() * 10000000).toString() + Math.round(Math.random() * 10000000).toString();
        }

        /**
         * This is a port to angularJS v1.2.11 and up $$rAF for temporary use
         * @param callBackFunc
         * @returns {Function}
         * @constructor
         */
        function RAFProvider(callBackFunc) {

          var requestAnimationFrame = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            $window.mozRequestAnimationFrame;

          var cancelAnimationFrame = $window.cancelAnimationFrame ||
            $window.webkitCancelAnimationFrame ||
            $window.mozCancelAnimationFrame ||
            $window.webkitCancelRequestAnimationFrame;

          var rafSupported = !!requestAnimationFrame;
          if (rafSupported) {
            var id = requestAnimationFrame(callBackFunc);
            return function () {
              cancelAnimationFrame(id);
            };
          } else {
            var timer = $timeout(callBackFunc, 16.66, false); // 1000 / 60 = 16.666
            return function () {
              $timeout.cancel(timer);
            };
          }
        }

        /**
         * Check if a keyCode is printable
         * @param keyCode
         * @returns {boolean}
         */
        function isPrintableKeyCode(keyCode) {
          return (keyCode > 47 && keyCode < 58) || // number keys
            keyCode === 32 || keyCode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
            (keyCode > 64 && keyCode < 91) || // letter keys
            (keyCode > 95 && keyCode < 112) || // numpad keys
            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
            (keyCode > 218 && keyCode < 223); // [\]' (in order)
        }

        /**
         * Determine if dir is set to RTL
         * @return {boolean}
         */
        function isRTL(element) {
          var value = false;
          if (window.getComputedStyle(element || document.body, null).getPropertyValue('direction') === 'rtl') {
            value = true;
          }
          return value;
        }

        /**
         * Get the closest scrollable parent
         * @param el - HTMLElement
         * @returns {any}
         */
        function getScrollableParent(el) {
          if (el === null) {
            return;
          }
          var cStyle = window.getComputedStyle(el);

          var overflowY = cStyle.getPropertyValue('overflow-y');
          var overflow = cStyle.getPropertyValue('overflow');

          if (
            overflowY === 'auto' ||
            overflowY === 'scroll' ||
            overflow === 'auto' ||
            overflow === 'scroll' ||
            overflow === 'hidden' ||
            overflowY === 'hidden'
          ) {
            return el;
          } else if (el.nodeName === 'BODY') {
            return el;
          } else {
            return getScrollableParent(el.parentElement);
          }
        }
      }
    ])
    /**
     * Help directive recursions without running into stack overflow on string replace
     */
    .factory('$recursionHelper', ['$compile', function ($compile) {
      return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function (element, link) {
          // Normalize the link parameter
          if (angular.isFunction(link)) {
            link = {
              post: link
            };
          }

          // Break the recursion loop by removing the contents
          var contents = element.contents().remove();
          var compiledContents;
          return {
            pre: (link && link.pre) ? link.pre : null,
            /**
             * Compiles and re-adds the contents
             */
            post: function (scope, element) {
              // Compile the contents
              if (!compiledContents) {
                compiledContents = $compile(contents);
              }
              // Re-add the compiled contents to the element
              compiledContents(scope, function (clone) {
                element.append(clone);
              });

              // Call the post-linking function, if any
              if (link && link.post) {
                link.post.apply(null, arguments);
              }
            }
          };
        }
      };
    }])

    .factory('$bentoObservables', [
      function () {
        return {
          createObservable: createObservable
        };

        function BentoObservable (data) {
          this.observers = [];
          this.data = data;

          BentoObservable.prototype.subscribe = function(f) {
            this.observers.push(f);
          };
         
          BentoObservable.prototype.unsubscribe = function(f) {
            this.observers = this.observers.filter(function(subscriber) {
              subscriber !== f;
            });
          };
        
          BentoObservable.prototype.getData = function(f) {
            return this.data;
          };
  
          BentoObservable.prototype.notify = function(data) {
            this.observers.forEach(function(observer) {
              observer(data);
            });
          }
        }
      
        function createObservable(data) {
          return new BentoObservable(data);
        }
      }
    ])

    /**
     * Provider: Provide Bento JS Root
     */
    .provider('$bentoJSRoot', function () {
      var bentoJSRootLink;
      var _this = this;

      /**
       * configAngularTranslateProvider
       * @param componentName
       * @param $translateProvider
       * @param $bentoTranslateLoaderProvider
       * @param defaultLanguage
       *
       * Configures $translateProvider for multilingual support
       */
      this.configAngularTranslateProvider = function (componentName, $translateProvider, $bentoTranslateLoaderProvider, defaultLanguage) {
        //Setup Bento Translate Loader
        //
        // Concert Example:
        //
        // $bentoTranslateLoaderProvider.addURLPattern('components/languages/lang-{lang}.js');
        //
        $bentoTranslateLoaderProvider.addURLPattern(_this.getBentoJSRoot(componentName) + 'i18n/' + componentName + '-{lang}.json');

        // Use Bento Translate Loader
        $translateProvider.useLoader('$bentoTranslateLoader');

        // Default all languages to en_us for the time been
        if (!!defaultLanguage) {
          $translateProvider.preferredLanguage(defaultLanguage.replace('-', '_').toLowerCase());
        } else {
          $translateProvider.preferredLanguage('en');
        }

        $translateProvider.translationNotFoundIndicatorLeft('!');
        $translateProvider.translationNotFoundIndicatorRight('!');

        $translateProvider.fallbackLanguage(defaultLanguage);
      };

      /**
       * getBentoJSRoot
       * @param elementName
       * @returns {string}
       */
      this.getBentoJSRoot = getBentoJSRoot;

      function getBentoJSRoot(elementName) {
        var bentoLinks = document.querySelectorAll('script[src]'); //document.querySelector('script[src~="/bento-"');
        var index = -1;
        for (var i = 0; i < bentoLinks.length; i++) {

          if (bentoLinks[i].attributes['src'].value.search('/' + elementName) != -1) {
            index = i;
            break;
          } else if (bentoLinks[i].attributes['src'].value.search('components/bento-modern.') != -1) {
            index = i;
            break;
          }
        }

        // currentJSFileSrc is a Global variable to this JS file
        // Check if bento.ui is loaded individually
        var bentoLinkTemp = (index === -1) ?
          // Death start approach
          currentJSFileSrc.split('/') :
          // Found it!
          bentoLinks[index].src.split('/');
        bentoLinkTemp.pop();
        bentoJSRootLink = bentoLinkTemp.join('/') + '/';

        return bentoJSRootLink;
      }

      /**
       * Turn on or of Full Console Error reporting where Chrome omits most of the outputs
       * @param bool
       */
      this.turnOnFullErrorReporting = function (bool) {
        if (bool) {
          //Chrome passes the error object (5th param) which we must use since it now truncates the Msg (1st param).
          window.onerror = function (errorMsg, url, lineNumber, columnNumber, errorObject) {
            var errMsg;
            //check the errorObject as IE and FF don't pass it through (yet)
            if (errorObject && errorObject !== undefined) {
              errMsg = errorObject.message;
            } else {
              errMsg = errorMsg;
            }
            window.console.log('Full Error: ' + errMsg);
          };
        } else {
          window.onerror = null;
        }
      };

      this.$get = [function () {
        if (typeof bentoJSRootLink === 'undefined') {
          getBentoJSRoot(currentJSFileSrc);
        }
        return bentoJSRootLink;
      }];
    });

  function getOS() {
    // Adding os name to body
    var OSName = navigator.appVersion;
    var os = 'unknown-os';
    if (OSName.indexOf("Win") !== -1) {
      os = 'win';
    } else if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
      os = 'ios';
    } else if (OSName.indexOf("Mac") !== -1) {
      os = 'mac';
    } else if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      os = 'android';
    } else if (OSName.indexOf("X11") !== -1) {
      os = 'unix';
    } else if (OSName.indexOf("Linux") !== -1) {
      os = 'linux';
    } else if (OSName.indexOf("SunOS") !== -1) {
      os = 'solaris';
    }
    return os;
  }

  function getBrowser() {
    // Adding brower name and version to body
    var isOpera = !!window.opera || (navigator && navigator.userAgent.indexOf(' OPR/') >= 0),
      isFirefox = typeof InstallTrigger !== 'undefined',
      isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
      isMobileSafari = (navigator.userAgent && (navigator.userAgent.search("Mobile") > -1) && (navigator.userAgent.search("Safari") > -1)),
      isiOSChrome = navigator.userAgent.match('CriOS'),
      isChrome = !!window.chrome && !isOpera,
      isIE = detectIE(),
      browser = 'unknown-browser',
      browserVersion = 'unknown-browser-version',
      version;

    var os = getOS();

    try {
      if (isIE) {
        browser = 'ie';
        browserVersion = browser + isIE;
      } else if (isiOSChrome) {
        browser = 'ios_chrome';
        browserVersion = browser + navigator.userAgent.match(/CriOS\/(\d+)/i)[1];
      } else if (isMobileSafari && os !== 'android') {
        browser = 'mobile_safari';
        browserVersion = browser + navigator.userAgent.match(/version\/(\d+)/i)[1];
      } else if (isOpera) {
        browser = 'opera';
        browserVersion = browser + (window.opera ? window.opera.version() : navigator.userAgent.match(/opr\/(\d+)/i)[1]);
      } else if (isFirefox && navigator.userAgent) {
        browser = 'firefox';
        browserVersion = browser + navigator.userAgent.match(/firefox\/(\d+)/i)[1];
      } else if (isSafari && navigator.userAgent.search(/version/i) !== -1) {
        browser = 'safari';
        browserVersion = browser + navigator.userAgent.match(/version\/(\d+)/i)[1];
      } else if (isChrome && navigator.userAgent) {
        browser = 'chrome';
        version = navigator.userAgent.match(/chrome\/(\d+)/i);
        // Android Jellybean and below don't have Chrome/[version] parameter so we skip them
        if (version) {
          browserVersion = browser + navigator.userAgent.match(/chrome\/(\d+)/i)[1];
        }
      } else if (isOpera) {
        browser = 'opera';
        if (window.opera) {
          browserVersion = browser + window.opera.version();
        } else {
          browserVersion = browser + navigator.userAgent.match(/ OPR\/(\d+)/i)[1];
        }
      } //else if(os !== 'android' &&)
    } catch (e) {
      // This browser is unknown;
    }

    return {
      browser: browser,
      browserVersion: browserVersion
    }
  }

  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   * https://codepen.io/gapcode/pen/vEJNZN
   */
  function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

})(window.angular);
(function() {
    'use strict';

         angular.module('bento.services')
        .service('flexGridSetUpService', flexGridSetUpService);

    flexGridSetUpService.$inject = ['$rootScope', '$timeout'];

    function flexGridSetUpService($rootScope, $timeout) {
        var self = this;
        var ON_MULTI_SELECT = 'onMultiSelect';
        this.multiSelectPanelObj = {}

        this.setupCulture = function(){
            wijmo.culture.FlexGridFilter = {
                // filter
                ascending: '\u2191 Ascending',
                descending: '\u2193 Descending',
                apply: 'Apply',
                clear: 'Clear',
                conditions: 'Filter by Condition',
                values: 'Filter by Value',
                // value filter
                search: 'Search',
                selectAll: 'Select All',
                null: '(nothing)',
                // condition filter
                header: 'Show items where the value',
                and: 'And',
                or: 'Or',
                stringOperators: [
                    { name: '(not set)', op: null },
                    { name: 'Equals', op: 0 /* EQ */ },
                    { name: 'Does not equal', op: 1 /* NE */ },
                    { name: 'Begins with', op: 6 /* BW */ },
                    { name: 'Ends with', op: 7 /* EW */ },
                    { name: 'Contains', op: 8 /* CT */ },
                    { name: 'Does not contain', op: 9 /* NC */ }
                ],
                numberOperators: [
                    { name: '(not set)', op: null },
                    { name: 'Equals', op: 0 /* EQ */ },
                    { name: 'Does not equal', op: 1 /* NE */ },
                    { name: 'Is Greater than', op: 2 /* GT */ },
                    { name: 'Is Greater than or equal to', op: 3 /* GE */ },
                    { name: 'Is Less than', op: 4 /* LT */ },
                    { name: 'Is Less than or equal to', op: 5 /* LE */ }
                ],
                dateOperators: [
                    { name: '(not set)', op: null },
                    { name: 'Equals', op: 0 /* EQ */ },
                    { name: 'Is Before', op: 4 /* LT */ },
                    { name: 'Is After', op: 2 /* GT */ }
                ],
                booleanOperators: [
                    { name: '(not set)', op: null },
                    { name: 'Equals', op: 0 /* EQ */ },
                    { name: 'Does not equal', op: 1 /* NE */ }
                ]
            };
        }

        this.updateFlexGridRowHeight = function(grid, height, headHeight) {
            height = height || 48;
            grid.rows.defaultSize = height;
            var headerHeight = 48;
            for (var i = 0, total = grid.columnHeaders.rows.length; i < total; i++) {
                grid.columnHeaders.rows[i].height = headHeight && headHeight[i] ? headHeight[i] : headerHeight;
            }
        };

        this.setupRowHeader = function(panel, r, c, cell) {
            if (panel.cellType == wijmo.grid.CellType.RowHeader) {
                cell.style.textAlign = 'right';
                cell.textContent = (r + 1).toString();
            }
        };

        this.initFilters = function(grid, gridFilter, filteredCols) {
            if (!gridFilter) {
                gridFilter = new wijmo.grid.filter.FlexGridFilter(grid);
                // gridFilter.filterColumns = filteredCols;
                // grid.autoSizeColumns();
                self.toggleFilter(false, gridFilter, filteredCols);
            }
            return gridFilter;
        };

        this.setupActions = function(panel, r, c, cell, header) {
            var col = panel.columns[c];
            if (col.header === header) {
                cell.className += " cell-actions";
            }
        };

        this.addClassToColumnByHeader = function(panel, r, c, cell, header, className) {
            var col = panel.columns[c];
            if (col.header === header) {
                cell.className += " " + className;
            }
        };

        this.addClassToColumnByBinding = function(panel, r, c, cell, binding, className) {
            var col = panel.columns[c];
            if (col.binding === binding) {
                cell.className += " " + className;
            }
        };

      /**
       * Setup Column visibility
       * @param flex
       * @param colBindings
       * @param numRows
       * @returns {{columnBindingsToggle: Array, columnVis: {}}}
       */
      this.setUpColumnVisibility = function (flex, colBindings, numRows) {
        if (flex && colBindings.length > 0) {
          var columnBindingsToggle = [];
          var columnVis = {};
          var ttl = colBindings.length;
          var rows = numRows || 10;
          var colArray;
          for (var i = 0; i < ttl; i++) {
            if(i % rows === 0){
              colArray = [];
              columnBindingsToggle.push(colArray);
            }
            colArray.push(colBindings[i]);
            columnVis[colBindings[i].binding] = true;
          }
          return {
            columnBindingsToggle: columnBindingsToggle,
            columnVis           : columnVis
          }
        }
      };

        this.toggleFilter = function(filtersHidden, gridFilter, filteredCols) {
            //if flexgrid available
            if (gridFilter) {
                //get FlexGridFilter, defined in initGrid
                var f = gridFilter;
                if (f) {
                    //if filters are hidden, clear the grid filter
                    if(filtersHidden){
                        f.clear();
                    }
                    //iterate through columns to filtered
                    for (var i = 0, il = filteredCols.length; i < il; i++) {
                        //get column and column filter
                        var col = f.grid.columns.getColumn(filteredCols[i].binding),
                            cf = col ? f.getColumnFilter(col, true) : {};
                        //switch filterType to 0 if filters hidden, otherwise to filterType defined in model
                        cf.filterType = filtersHidden ? 0 : filteredCols[i].filterType;
                    }

                }
                //refresh grid
                f.grid.refresh();
            }

        }


    }
})();
(function (angular, window) {
  'use strict';

  /**
   * This Service Object is backported from Bento NG
   * @type {{}}
   */
  var BentoPositioning = {};

  window.BentoPositioning = BentoPositioning;

  angular.module('bento.positioning', [])
    .constant('$bentoPositioning', BentoPositioning);

  // Back-ported from the Original TS file
 
  /**
   * Main method to position a target element against the host element included in a container
   * @param host The HTMLElement that is to be aligned to
   * @param target The HTMLElement that is to be placed to align with the `host`
   * @param container Container HTMLElement to host the `target` element
   * @param placement Only work for 'top' and 'bottom' at this point
   * @param alignment Horizontal alignment 'left' and 'right' TODO: 'center' to come later
   * @param offset Offset in pixels to fine tune the placement location
   * @param autoRealign Auto relaign to the container with the `target` is out of boundary
   */
  BentoPositioning.positionElement = function (
    host,
    target,
    container,
    placement,
    alignment,
    offset,
    autoRealign // Only works for TOP & BOTTOM
  ) {
    var containerClientWidth = container.clientWidth;
    placement = placement || 'bottom';
    alignment = alignment || 'left';
    offset = offset == null ? 0 : offset;
    target.style.visibility = 'hidden';

    if (placement === 'bottom') {
      target.style.top = '0';
      target.style.bottom = 'auto';
    } else {
      target.style.bottom = '0';
      target.style.top = 'auto';
    }

    if (alignment === 'left') {
      target.style.left = '0';
      target.style.right = 'auto';
    } else {
      target.style.right = '0';
      target.style.left = 'auto';
    }

    if (autoRealign) {
      // Set max width to the target el if there is an auto-relaignment
      target.style.maxWidth = containerClientWidth + 'px';
    }

    container.appendChild(target);
    var hostRect = host.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var dTop = hostRect.bottom - targetRect.top;
    var dBottom = hostRect.top - targetRect.bottom;
    var dLeft = hostRect.left - targetRect.left;
    var dRight = hostRect.right - targetRect.right;

    if (autoRealign) {
      // We still need a temporary element to measure the content location against
      // the viewport so that we can conpensate gaps with all borders and scrollbars(in RTL)
      // without having gaps
      var tempEl = document.createElement('div');
      var tempRect;
      tempEl.style.visibility = 'hidden';
      tempEl.style.height = '0';
      container.appendChild(tempEl);
      tempRect = tempEl.getBoundingClientRect();

      // Remove and clean temporary element
      container.removeChild(tempEl);
      tempEl = null;

      if (alignment === 'left' && hostRect.left + targetRect.width > tempRect.right) {
        // `target` is out of boundary on the right need to move it back
        dLeft = tempRect.right - targetRect.width - targetRect.left;
      } else if (alignment === 'right' && hostRect.right - targetRect.width < tempRect.left) {
        // `target` is out of boundary on the left and need to align left
        dRight = tempRect.left + targetRect.width - targetRect.right;
      }
    }

    // There are only two case for now 'top' and 'bottom'
    // Will exrtend to 'left' and 'right' when required
    switch (placement) {
      case 'top':
        if (alignment === 'left') {
          BentoPositioning.updatePositionStyles(target, 'auto', 'auto', -dBottom + offset + 'px', dLeft + 'px');
        } else {
          BentoPositioning.updatePositionStyles(target, 'auto', -dRight + 'px', -dBottom + offset + 'px', 'auto');
        }
        break;
      default:
        if (alignment === 'left') {
          BentoPositioning.updatePositionStyles(target, dTop + offset + 'px', 'auto', 'auto', dLeft + 'px');
        } else {
          BentoPositioning.updatePositionStyles(target, dTop + offset + 'px', -dRight + 'px', 'auto', 'auto');
        }
    }

    // Show element
    target.style.visibility = 'visible';
  };


  /**
   * Reset element styles
   * @param {HTMLElement} el 
   */
  BentoPositioning.resetStyles = function(el){
    var style = el.style;
    style.top = null;
    style.right = null;
    style.bottom = null;
    style.left = null;
    style.width = null;
  };


  /**
   * Update positioning CSS styles
   * @param target
   * @param top
   * @param right
   * @param bottom
   * @param left
   */
  BentoPositioning.updatePositionStyles = function (target, top, right, bottom, left, width) {
    var style = target.style;
    style.top = top;
    style.right = right;
    style.bottom = bottom;
    style.left = left;

    if (width) {
      style.width = width;
    }
  };
  // End of back-port

})(window.angular, window);
(function(angular, window, performance, undefined) {
'use strict';

var EASE_FUNCTIONS = {
  // no easing, no acceleration
  linear: function(t) {
    return t;
  },
  // accelerating from zero velocity
  easeInQuad: function(t) {
    return t * t;
  },
  // decelerating to zero velocity
  easeOutQuad: function(t) {
    return t * (2 - t);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  // accelerating from zero velocity
  easeInCubic: function(t) {
    return t * t * t;
  },
  // decelerating to zero velocity
  easeOutCubic: function(t) {
    return (--t) * t * t + 1;
  },
  // acceleration until halfway, then deceleration
  easeInOutCubic: function(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  // accelerating from zero velocity
  easeInQuart: function(t) {
    return t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuart: function(t) {
    return 1 - (--t) * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
  },
  // accelerating from zero velocity
  easeInQuint: function(t) {
    return t * t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuint: function(t) {
    return 1 + (--t) * t * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuint: function(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
  }
};


angular.module('bento.transition', []).factory('$bentoTransition', function() {
  // Ease functions

  function go(from, to, duration, tick, complete, ease) {
    var easeFunc = ease || EASE_FUNCTIONS.easeOutCubic;
    var startTime = performance.now();
    var d = to - from;
    var frameDuration = 18;  // ~60FPS
    var timeoutID;
    var stop = false;

    animate();

    function animate() {
      var dTime = performance.now() - startTime;
      var dX = easeFunc(dTime / duration) * d;

      if (dTime >= duration) {
        tick && tick(to);
        complete && complete();
      } else {
        tick && tick(from + dX);
        window.requestAnimationFrame(animate);
      }
    }

    return function() {
      stop = true;
    };
  }
  return {go: go, ease: EASE_FUNCTIONS};
});
})(angular, window, window.performance);

(function (angular, window, undefined) {

  'use strict';

  angular.module('bento.inputblur', [])
    // Supporting directive for input fields
    .directive('input',directiveFunction)
    // Supporting directive for textarea fields
    .directive('textarea',directiveFunction);

  directiveFunction.$inject = ['$bentoServices'];

  /**
   * Input Blur and Textarea blur directive definition
   * @param $bentoServices
   * @returns {{restrict: string, require: string, link: Function}}
   */
  function directiveFunction($bentoServices) {
    return {
      restrict: 'E',
      require : '?ngModel',
      link    : function (scope, element, attr, control) {
        if (!control) {
          return;
        }

        element.on('focus', function () {
          // Using safe apply to comply bug [CXUI-289]
          $bentoServices.safeApply(scope,function () {
            element.addClass('has-focus');
            control.hasFocus = true;
          });
        });

        element.on('blur', function () {
          // Using safe apply to comply bug [CXUI-289]
          $bentoServices.safeApply(scope,function () {
            element.removeClass('has-focus');
            element.addClass('has-visited');
            control.hasFocus = false;
            control.hasVisited = true;
          });
        });

        // extend $setPristine()
        if (!!control.$setPristine) {
          control.$setPristineUsedByBentoInputBlur = control.$setPristine;

          control.$setPristine = function () {
            // called Super function
            control.$setPristineUsedByBentoInputBlur();
            // Resetting hasVisited flag

            $bentoServices.safeApply(scope,function () {
              element.removeClass('has-visited');
              control.hasVisited = false;
            });
          };
        }
      }
    };
  }
})(window.angular, window);
/* jshint -W016 */
(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.busyloader', ['bento.services', 'bento.translate'])
    /**
     * Config to add $http interceptions
     */
    .config([
      '$provide',
      '$httpProvider',
      function ($provide, $httpProvider) {

        /**
         * Register a new interceptor for Busy Loader for auto show and hide
         */
        $provide.factory('bentoBusyLoaderHttpInterceptor', [
          '$q',
          '$log',
          function ($q, $log) {

            /**
             * Get a BentoBusyLoader from the config file, undefined otherwise
             * @param config
             * @returns {*}
             */
            var getBusyLoader = function (config) {
              // There is nothing assigned to config
              if (typeof config === 'undefined') {
                return undefined;
              }

              // Make sure busyLoader is assigned as part of the config object
              // And the object is a `BentoBusyLoader` instance
              if (!!config.busyLoader) {
                return config.busyLoader;
              } else {
                return undefined;
              }
            };

            /**
             * Show the Busy Loader referenced from the config object
             * @param config
             */
            var showBusyLoader = function (config) {
              var busyLoader = getBusyLoader(config);

              if (!!busyLoader) {
                busyLoader.show(config.showDelay || 0);
              }
            };

            /**
             * Hides the Busy Loader referenced from the config object
             * @param config
             */
            var hideBusyLoader = function (config) {
              var busyLoader = getBusyLoader(config);

              if (!!busyLoader) {
                busyLoader.hide(config.hideDelay || 0);
              }
            };

            /**
             * Return all $http interception results
             */
            return {
              // optional method
              'request': function (config) {
                // do something on success
                showBusyLoader(config);
                return config;
              },

              // optional method
              'requestError': function (rejection) {
                // do something on error
                //hideBusyLoader(rejection.config);

                return $q.reject(rejection);
              },

              // optional method
              'response': function (response) {
                // do something on success
                hideBusyLoader(response.config);
                return response;
              },

              // optional method
              'responseError': function (rejection) {
                // do something on error
                // hideBusyLoader(rejection.config);

                return $q.reject(rejection);
              }
            };

          }]);

        // Push the interceptor to $httpProvider.interceptor stack
        $httpProvider.interceptors.push('bentoBusyLoaderHttpInterceptor');

      }
    ])
    /**
     * Provides Busy Loader services
     */
    .factory('$bentoBusyLoader', [
      '$timeout',
      '$log',
      '$q',
      '$bentoServices',
      '$bentoTranslate',
      function ($timeout, $log, $q, $bentoServices, $bentoTranslate) {

        // Busy Loader Object
        function BentoBusyLoader(_dom, _size, nonBlocking) {
          // Normalize DOM type
          var dom                = typeof _dom === 'string' ? document.querySelector(_dom) : _dom,
              bgSize             = '',
              canvasSize,
              isPositionedStatic = false,
              showTimeoutID,
              hideTimeoutID,
              self               = this
            ;

          _size = _size? _size:'default';

          // Now we can set the size of the spinner animation
          switch (_size) {
            case 'small' :
              canvasSize = 24;
              break;
            default:
              canvasSize = 75;
          }


          // Create loader dom elements
          var loader  = angular.element('<div '+
                (nonBlocking? '' : 'tabindex="0" ') +
                'class="bento-busyloader-blocker'+ bgSize + '">' +
                '<div class="bento-busyloader-wrapper"><div class="bento-busyloader-inner">' +
                '<svg ' +
                'class="bento-busyloader-svg bento-busyloader-svg-'+_size+'" preserveAspectRatio="none"' +
            'viewBox="0 0 '+canvasSize+' '+canvasSize+'"' +
            '></svg>' +
                '</div>'+
                '</div>' +
                '</div>'),

              // Insert loader HTML code into the DOM
              mainDom = angular.element(dom),
              mainDomPosition,
              blocker = nonBlocking? null : angular.element('<div tabindex="0" class="bento-busyloader-front-blocker"></div>')
            ;

          this.$el = loader;

          // SR Support
          applySR();
          function applySR() {
            $bentoTranslate.translate('BENTO_UI_BUSY_LOADER_LOADING')
              .then(function (value) {
                loader.attr('aria-label', value);
                !nonBlocking && blocker.attr('aria-label', value);
              });
          }

          $bentoTranslate.onChange(applySR);
          loader.on('$destroy', function () {
            $bentoTranslate.removeOnChange(applySR);
          });

          if(!nonBlocking){
            loader[0].addEventListener('keydown', function (event) {
              // Bypass the content from tabbing
              if (event.shiftKey && event.keyCode === 9) {
                blocker[0].focus();
              }
            });
  
            blocker[0].addEventListener('keydown', function (event) {
              // Bypass the content from tabbing
              if (!event.shiftKey && event.keyCode === 9) {
                loader[0].focus();
              }
            });
          }

          this.show = function (delay) {
            var deferred = $q.defer();
            var _delay = (typeof delay === 'undefined') ? 0 : parseInt(delay, 10);

            // Clear any previous $timeout IDs
            $timeout.cancel(hideTimeoutID);

            showTimeoutID = $timeout(function () {
              // Adding loader
              mainDom.append(loader);
              !nonBlocking && mainDom.prepend(blocker);
              
              // Clear any previous $timeout IDs
              $timeout.cancel(showTimeoutID);

              // Make parent container 'relative' when it is static
              mainDomPosition = window.getComputedStyle(mainDom[0]).position.trim();

              // Check and assign `relative` position where it is at default, `static`
              if (mainDomPosition.length === 0 || mainDomPosition === 'static') {
                mainDom[0].style.position = 'relative';
                isPositionedStatic = true;
              }

              // svg render disabled
              startAnimate();

              deferred.resolve('Busy Loader is now bocking content');

              /*
               Gain focus if necessary and
               ONLY gains focus when this loader is an overlay
               */
              self.activeElement = document.activeElement;

              if (mainDom[0].contains(self.activeElement)) {
                loader[0].focus();
              } else {
                self.activeElement = undefined;
              }

            }, _delay);

            return deferred.promise;
          };

          this.hide = function (delay) {
            var _delay = (typeof delay === 'undefined') ? 0 : parseInt(delay, 10);
            var deferred = $q.defer();

            // Clear any previous $timeout IDs
            $timeout.cancel(hideTimeoutID);

            hideTimeoutID = $timeout(function () {
              // Clear any previous $timeout IDs
              $timeout.cancel(showTimeoutID);

              // Put static positioning back
              if (isPositionedStatic) {
                mainDom[0].style.position = null;
              }

              stopAnimate();

              deferred.resolve('Busy Loader is now hidden');

              /*
               Return focus if necessary
               */
              if (self.activeElement && blocker &&
                (document.activeElement === loader[0] || document.activeElement === blocker[0])// focus hasn't
                                                                                                  // changed during
                                                                                                  // loading phase
              ) {
                self.activeElement.focus();
              }

              loader.remove();
              !nonBlocking && blocker.remove();
            }, _delay);

            return deferred.promise;

          };

          // svg spinner animation code
          // rFA is used for animation part to minimize CPU load
          var svg,
              intervalDelay   = 150,
              currentArcIndex = 0,
              arcs            = [],
              setIntID,
              radius          = canvasSize / 2,
              segments        = 8,
              stroke          = radius * 0.40,
              gap             = 7;

          /**
           * Start animation
           */
          function startAnimate() {
            clearInterval(setIntID);
            setIntID = setInterval(tick, intervalDelay);
          }

          /**
           * Stop animation
           */
          function stopAnimate() {
            clearInterval(setIntID);
          }

          /**
           *
           */
          function tick() {
            var arc = arcs[currentArcIndex];
            currentArcIndex = (currentArcIndex - 1 + arcs.length) % arcs.length;

            arc.setAttribute('class', 'bento-busyloader-arc bento-busyloader-arc-alt');

            setTimeout(function () {
              arc.setAttribute('class', 'bento-busyloader-arc');
            }, 200);
          }

          // Spinner init
          function initSpinner() {
            var arcSize = 360 / segments,
                arc
              ;
            svg = angular.element(loader[0].getElementsByTagName('svg')[0]);
            //svg is not ready when render is called by apps
            if (!svg) {
              return;
            }
            for (var i = 0; i < segments; i++) {
              arc = getSegment(i, arcSize, gap, stroke, radius);
              arcs.push(arc);
              svg.append(arc);
            }
          }

          function getSegment(segNum, arcSize, gap, stroke, radius) {
            var nRadius = radius - stroke * 0.5,
                startD  = getRadianFromDegree((segNum * arcSize + gap * 0.5)),
                endD    = getRadianFromDegree(segNum * arcSize + arcSize - gap * 0.5),
                d       = (radius + Math.sin(startD) * (radius - stroke * 0.5)) + ' ' +  // X1
                  (radius + Math.cos(startD) * (radius - stroke * 0.5)) + ' ' + // Y1
                  'A ' + nRadius + ' ' + nRadius + ' 0 0 0 ' + // min point
                  (radius + Math.sin(endD) * nRadius) + ' ' + // X2
                  (radius + Math.cos(endD) * nRadius), // Y1
                path    = document.createElementNS('http://www.w3.org/2000/svg', 'path')
              ;
            path.setAttribute('d', 'M' + d);
            path.setAttribute('stroke-width', stroke);
            path.setAttribute('fill', 'none');
            path.setAttribute('class', 'bento-busyloader-arc');

            return path;
          }

          function getRadianFromDegree(degrees) {
            return degrees * (Math.PI / 180);
          }

          initSpinner();
        }

        var getNewLoader = function (dom, size, nonBlocking) {
          return new BentoBusyLoader(dom, size, nonBlocking);
        };

        // Finally return the actual loader
        return {
          getNewLoader: getNewLoader
        };
      }])
    .directive('bentoBusyLoader', [
      '$bentoBusyLoader',
      '$log',
      function ($bentoBusyLoader, $log) {
        return {
          scope: {
            bentoBusyLoader    : '=',  //get Busy Loader state
            bentoBusyLoaderSize: '@', //define the size of BL
            nonBlocking: '&', // flag to set busyloader non blocking
          },
          link : function (scope, element, attr) {

            var busyLoader = $bentoBusyLoader.getNewLoader(element, scope.bentoBusyLoaderSize, scope.nonBlocking());

            // Watch loader variable
            scope.$watch('bentoBusyLoader', function (newVal) {
              if (newVal) {
                busyLoader.show();
              } else {
                busyLoader.hide();
              }
            });
          } // end of link
        };
      }
    ])
    .directive('busyLoader', [
      '$bentoBusyLoader',
      '$log',
      function ($bentoBusyLoader, $log) {
        return {
          scope: {
            busyLoader    : '=',  //get Busy Loader state
            busyLoaderSize: '@', //define the size of BL
            nonBlocking: '&', // flag to set busyloader non blocking
          },
          link : function (scope, element, attr) {

            $log.warn('`busy-loader` directive is deprecated, use `bento-busy-loader`.');

            var busyLoader = $bentoBusyLoader.getNewLoader(element, scope.busyLoaderSize, scope.nonBlocking());

            // Watch loader variable
            scope.$watch('busyLoader', function (newVal) {
              if (newVal) {
                busyLoader.show();
              } else {
                busyLoader.hide();
              }
            });
          } // end of link
        };
      }
    ])
  ;
})(window, window.angular);

(function () {
  'use strict';

  var $sanitize;

  angular.module('bento.carousel', ['bento.services'])
  /**
   * Main Bento Carousel Directive
   */
    .directive('bentoCarousel', [
      '$sanitize',
      function ($s) {
        $sanitize = $s;
        return {
          scope     : false,
          restrict  : 'EA',
          controller: 'bentoCarouselController',
          link      : bentoCarouselLink
        }
      }
    ])
    .controller('bentoCarouselController', bentoCarouselMainController)
  /**
   * Bento Carousel Card Directive
   * Defines card class and as a parent of card templates
   */
    .directive('bentoCarouselCard',
    function () {
      return {
        //require: '^bentoCarousel',
        restrict: 'EA',
        scope   : false,
        link    : bentoCarouselCardLink
      }
    }
  );

  /**
   * Bento Carousel Card Directive Main Link
   * @param scope
   * @param element
   * @param attrs
   * @param ctrl
   */
  function bentoCarouselCardLink(scope, element, attrs, ctrl) {
    attrs.$addClass('bento-carousel-card');
    //attrs.$set('tabindex', '0');
    attrs.$set('role', 'card');
  }

  /**
   * bentoCarouselMainController for main directive
   */
  bentoCarouselMainController.$inject = [
    '$scope',
    '$element',
    '$timeout',
    '$rootScope',
    '$compile',
    '$attrs',
    '$sanitize',
    '$bentoServices'];
  function bentoCarouselMainController($scope, $element, $timeout, $rootScope, $compile, $attrs, $sanitize,$bentoServices) {
    // init variables
    var ctrl = this;
    var slideshowTimeout = 5000;
    var slideshowTimeoutPromise;
    var cardHeightStyle = document.createElement('style');
    ctrl.localScope = $rootScope.$new();
    ctrl.localScope.dots = ['active'];
    ctrl.isRTL = $bentoServices.isRTL();

    if($attrs.slideshow){
      $timeout(autoChangeSlides);
    }

    var scrollXTimeout;
    var cardMargin = 20;
    var currentPage = 0;
    ctrl.dom = {};
    ctrl.dom.mainContainer = angular.element($element[0].querySelector('ul'));

    // Dom change after all scopes are linked
    $timeout(function () {
      ctrl.dom.mainContainer.wrap('<div class="bento-carousel-container"></div>');
    });

    ctrl.dom.leftArrow = angular.element(
      '<div class="bento-carousel-left-arrow bento-carousel-arrow" ' +
      'ng-show="showLeftArrow && !hideArrows" ' +
      'ng-click="onLeftArrowClick()">' +
      '<i class="bento-icon-chevron-left"></i>' +
      '</div>');
    ctrl.dom.rightArrow = angular.element(
      '<div class="bento-carousel-right-arrow bento-carousel-arrow" ' +
      'ng-show="showRightArrow  && !hideArrows" ' +
      'ng-click="onRightArrowClick();">' +
      '<i class="bento-icon-chevron-right"></i>' +
      '</div>');
    ctrl.dom.dots = angular.element(
      '<div class="bento-carousel-dots">' +
      '<button class="bento-carousel-dot {{dot}}" ' +
      'ng-click="onDotClick($index)" ' +
      'ng-repeat="dot in dots track by $index">' +
      '</button></div>');

    ctrl.localScope.onLeftArrowClick = function () {
      var dX = ctrl.dom.mainContainer.children()[0].offsetWidth;
      scrollToAnimate(ctrl.dom.mainContainer[0].scrollLeft - dX, 500, ctrl.dom.mainContainer[0]);

      if($attrs.slideshow){
        $timeout.cancel(slideshowTimeoutPromise);
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout + 1000);
      }
    };

    ctrl.localScope.onRightArrowClick = function (isAuto) {
      var dX = ctrl.dom.mainContainer.children()[0].offsetWidth;
      scrollToAnimate(ctrl.dom.mainContainer[0].scrollLeft + dX, 500, ctrl.dom.mainContainer[0]);

      if($attrs.slideshow && !isAuto){
        $timeout.cancel(slideshowTimeoutPromise);
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout + 1000);
      }
    };

    ctrl.localScope.onDotClick = function (page) {
      //reset all dots
      for (var i = 0; i < ctrl.localScope.dots.length; i++) {
        ctrl.localScope.dots[i] = '';
      }
      // activate the current page dot
      ctrl.localScope.dots[page] = 'active';

      // scroll to the new page
      scrollTo(ctrl.dom.mainContainer[0].offsetWidth * page);
    };

    $compile(ctrl.dom.leftArrow)(ctrl.localScope);
    $compile(ctrl.dom.rightArrow)(ctrl.localScope);
    $element.append(ctrl.dom.leftArrow);
    $element.append(ctrl.dom.rightArrow);

    $compile(ctrl.dom.dots)(ctrl.localScope);
    $element.append(ctrl.dom.dots);

    // inject card height with variable binding
    $element[0].parentNode.insertBefore(cardHeightStyle, $element[0]);

    // Watch children size to refresh rendering for dots
    $scope.$watch(function () {
      return ctrl.dom.mainContainer.children().length
    }, function (numChildren) {
      // Always make sure that AngularJS has finished rendering the children
      $timeout(function () {
        updateDotsAndArrows();
      });
    });

    // Watch children heights
    $scope.$watch(function(){
      var children = ctrl.dom.mainContainer.children();
      var maxHeight = 0;
      var h;
      for(var i=0; i<children.length; i++){
        h = children[i].firstElementChild.offsetHeight;
        if(h > maxHeight){
          maxHeight = h;
        }
      }
      return maxHeight;
    }, function(newHeight){
      cardHeightStyle.innerHTML = '.bento-carousel .bento-carousel-card{height:'+$sanitize(newHeight)+'px}';
    })

    $scope.$watch(function () {
        return $bentoServices.isRTL();
    }, function (nv, ov) {
      if(nv !== null || nv !== undefined) {
        ctrl.isRTL = nv;
        updateDotsAndArrows();
      }
    });

    // Watch windows resize
    var timeoutID = 0;
    angular.element(window).on('resize', onWindowResize);

    // Function to fire on window resize
    function onWindowResize(){
      $timeout.cancel(timeoutID);
      timeoutID = $timeout(function () {
        updateDotsAndArrows();
        $bentoServices.safeApply(ctrl.localScope);
      }, 500);
    }

    ctrl.dom.mainContainer.on('scroll', function () {
      $timeout.cancel(timeoutID);
      timeoutID = $timeout(function () {
        updateDotsAndArrows();
        $bentoServices.safeApply(ctrl.localScope);
      }, 100);
    });

    // Listen to mouseenter and mouseleave to enable and disable slideshow
    ctrl.dom.mainContainer.on('mouseenter', function(event){
      if($attrs.slideshow){
        $timeout.cancel(slideshowTimeoutPromise);
      }
    });

    ctrl.dom.mainContainer.on('mouseleave', function(event){
      if($attrs.slideshow){
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout);
      }
    });

    // Function for slideshow
    function autoChangeSlides(){
      var container = ctrl.dom.mainContainer[0];
      var safeNumX = container.scrollWidth - container.offsetWidth;
      $timeout.cancel(slideshowTimeoutPromise);

      if(container.scrollLeft  === safeNumX){
        scrollTo(0);
      }else{
        ctrl.localScope.onRightArrowClick(true);
      }


      slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout);
    }

    // Animate scrolling
    function scrollTo(numX) {
      $timeout.cancel(scrollXTimeout);
      if (numX < 0) {
        numX = 0;
      }
      var container = ctrl.dom.mainContainer[0];
      // Prevent from over scroll effect
      var safeNumX = container.scrollWidth - container.offsetWidth;
      // last page
      if (safeNumX < numX) {
        numX = safeNumX;
      }
      // snap to a cell
      else if (numX !== 0) {
        // find and align with card
        var cardIndexToShow = 0;
        var cards = ctrl.dom.mainContainer.children();
        for (var i = 0; i < cards.length; i++) {
          if (Math.abs(cards[i].offsetLeft) > numX) {
            cardIndexToShow = i - 1;
            break;
          }
        }
        numX = Math.abs(cards[cardIndexToShow].offsetLeft) - cardMargin * 0.5;
      }
      // animate scrolling
      scrollToAnimate(numX, 500, container);
    }

    // using RAF with (x-1)^3+1 curve easing
    function scrollToAnimate(scrollX, duration, container, originalTime, originalX, dX) {
      if(typeof originalTime === 'undefined'){
        originalTime = new Date();
        originalX = container.scrollLeft;
        dX = scrollX-originalX;
      }

      var currentTime = new Date();
      var dTimeRatio = Math.pow((currentTime.getTime() - originalTime.getTime()) / duration -1, 3) + 1; // (x-1)^3 + 1
      var distanceByRatio = dTimeRatio * dX;

      if (Math.abs(dX - distanceByRatio) < 1) {
        container.scrollLeft = scrollX;
      } else {
        container.scrollLeft = originalX + distanceByRatio;
        $bentoServices.rAF(function(){
          scrollToAnimate(scrollX, duration, container, originalTime, originalX, dX);
        });
      }
    }

    function updateDotsAndArrows() {
      var container = ctrl.dom.mainContainer[0];

      if (container.scrollWidth === container.offsetWidth) {
        ctrl.localScope.dots = ['active'];
        currentPage = 0;
      } else {
        var newDots = [];
        var numPages = Math.ceil(container.scrollWidth / container.offsetWidth);
        currentPage = Math.ceil(container.scrollLeft / container.offsetWidth);
        for (var i = 0; i < numPages; i++) {
          newDots.push('');
        }
        newDots[currentPage] = 'active';
        ctrl.localScope.dots = newDots;
      }

      // Show hide arrows
      ctrl.localScope.showLeftArrow = (container.scrollLeft > 0);
      ctrl.localScope.showRightArrow = (container.scrollLeft + container.offsetWidth < container.scrollWidth);
    }

    // on $destroy cleanup
    $element.on('$destroy',function(){
      // remove window resize listener and its timeout
      $timeout.cancel(timeoutID);
      angular.element(window).off('resize', onWindowResize);
    });
  }

  /**
   * Bento Carousel driective link function
   * @param scope
   * @param element
   * @param attrs
   * @param ctrl
   */
  function bentoCarouselLink(scope, element, attrs, ctrl) {
    attrs.$addClass('bento-carousel');
    // Determine if need to hide arrows
    ctrl.localScope.hideArrows = !!attrs.hideArrows && attrs.hideArrows.toLowerCase() === 'true';
    ctrl.localScope.arrowOffset = !!attrs.arrowOffset ? attrs.arrowOffset : '0';

    // Update arrow offset
    ctrl.dom.leftArrow[0].style.left = '-'+ctrl.localScope.arrowOffset;
    ctrl.dom.rightArrow[0].style.right = '-'+ctrl.localScope.arrowOffset;

    // Adding gutter size override
    var customStyling;

    // Adjust gutter size
    if (!!attrs.gutterSize) {
      customStyling = '.bento-carousel-container>ul>li{' +
      'margin-right:' + attrs.gutterSize +
      '}';
    }
    // Change indicator color
    if (!!attrs.indicatorColor) {
      customStyling += '.bento-carousel-dots .bento-carousel-dot{' +
      'border:1px solid ' + attrs.indicatorColor +
      '}';
      customStyling += '.bento-carousel-dots .bento-carousel-dot.active{' +
      'background:' + attrs.indicatorColor +
      '}';
    }

    var styleNode = document.createElement('style');
    styleNode.innerHTML = $sanitize(customStyling);

    element[0].parentNode.insertBefore(styleNode,element[0]);
  }

})();
(function () {
  'use strict';
  angular.module('bento.carousel')
    .directive('bentoCarouselCardTemplate', [
      '$timeout',
      function ($timeout) {
        return {
          scope   : {
            cardData          : '=',  // Card Data
            cardName          : '=',  // This Card's Main Name
            cardSecondaryName : '=?', // This Card's Secondary Name
            cardTimestamp     : '=',  // Time stamp in [Date] object
            cardTemplateUrl   : '=',  // URL to the card inner template
            hideNewTabIcon    : '=',  // Show/Hide new tab icon
            onNewTabClick     : '&',  // Tab click callback
            enablePopover     : '='   // Enable/Disable Popover
          },
          templateUrl: '../templates/carousel/bento-carousel-card-default.html'
          ,
          link    : function (scope) {
            /**
             * Fire tab click callback function
             * @param $event
             */
            scope.newTabClick = function ($event) {
              scope.onNewTabClick({cardData: scope.cardData});
              $event.stopPropagation();
              $event.preventDefault();
            };

            /**
             * Set the main name from car templates
             * @param name
             */
            scope.setName = function(name){
              scope.cardName = name;
            };

            /**
             * Set secondary name from car templates
             * @param name
             */
            scope.setSecondaryName = function(name){
              scope.cardSecondaryName = name;
            };

            /**
             * PRIVATE DO NOT CHANGE
             */

            /**
             * Bottom Day feedback calculation and updates
             */
            var today, tempToday, oldDay, updateTimeout;

            // Initiate
            calcDays();

            // Clean timeout queue
            scope.$on('$destroy', function () {
              $timeout.cancel(updateTimeout);
            });

            /**
             * Calculate the time difference and update the `date` label for hourly date
             */
            function calcDays() {



              if(scope.cardTimestamp && scope.cardTimestamp.getDate) {
                tempToday = new Date();
                today = new Date(
                  tempToday.getUTCFullYear(),
                  tempToday.getUTCMonth(),
                  tempToday.getUTCDate());
                oldDay = new Date(
                  scope.cardTimestamp.getUTCFullYear(),
                  scope.cardTimestamp.getUTCMonth(),
                  scope.cardTimestamp.getUTCDate());

                scope.dDay = Math.floor((today.getTime() - oldDay.getTime())/ (86400000));

                // `scope.date` is assigned with Bento Translate label
                if (scope.dDay === 0) {
                  scope.date = 'BENTO_UI_TODAY';
                }
                else if (scope.dDay === 1) {
                  scope.date = 'BENTO_UI_YESTERDAY';
                } else {
                  scope.date = 'BENTO_UI_N_DAY_AGO';
                }
              }else{
                scope.date = null;
              }

              // Calculate for the next update
              // Every update should be at the first second of each hour
              var secondsUntilNextUpdate = (60 - today.getMinutes()) * 60 - today.getSeconds() + 1;
              updateTimeout = $timeout(calcDays, secondsUntilNextUpdate * 1000);

            }

            scope.onHeaderClick = function (event) {
              event.stopPropagation();
              event.preventDefault();
            }
          }
        }
      }])
})();

(function(angular) {
  'use strict';

  var CLASS_CHECKED = 'bento-icon-checkbox-filled';
  var CLASS_EMPTY = 'bento-icon-checkbox';
  var CLASS_INDETERMINATE = 'bento-icon-collapse';

  angular
    .module('bento.checkbox', [])
    .controller('bentoCheckboxController', function() {
      this.$onDestroy = function() {
        if (this.wrapperEl && this.wrapperEl.parentElement) {
          // Make sure to remove the wrapper element
          this.wrapperEl.parentElement.removeChild(this.wrapperEl);
        }
      };
    })
    .directive('bentoCheckbox', function() {
      return {
        restrict: 'C',
        controller: 'bentoCheckboxController',
        link: function(scope, element, attrs, ctrl) {
          var el = element[0];
          var val, indeterminate;
          var parent = el.parentElement;
          var fakeIcon = document.createElement('i');
          var classList = fakeIcon.classList;
          ctrl.wrapperEl = document.createElement('DIV');
          ctrl.wrapperEl.className = el.className;
          el.className = '';

          // Wrap the checkbox with Bento UI
          parent.insertBefore(ctrl.wrapperEl, el);
          ctrl.wrapperEl.appendChild(el);
          ctrl.wrapperEl.appendChild(fakeIcon);

          // Init UI
          val = el.checked;
          indeterminate = el.indeterminate;

          scope.$watch(
            function() {
              return el.indeterminate;
            },
            function(newVal) {
              indeterminate = newVal;
              if (newVal) {
                // Indeterminate is a priority class.
                // Therefore, it overrides other CSS classes when it's set to
                // `true`
                classList.remove(CLASS_CHECKED);
                classList.remove(CLASS_EMPTY);
                classList.add(CLASS_INDETERMINATE);
              } else {
                classList.remove(CLASS_INDETERMINATE);
                setClass();
              }
            }
          );

          scope.$watch(
            function() {
              return el.checked;
            },
            function(newVal) {
              val = newVal;
              setClass();
            }
          );

          /**
           * Set checkbox UI CSS Class
           */
          function setClass() {
            attrs.$set('aria-checked', val);

            if (indeterminate) {
              // Do not add classes when indeterminate is in place
              return;
            }

            if (val) {
              classList.add(CLASS_CHECKED);
              classList.remove(CLASS_EMPTY);
            } else {
              classList.remove(CLASS_CHECKED);
              classList.add(CLASS_EMPTY);
            }
          }

          // Initialize class
          setClass();
        }
      };
    })
    .directive('ngIndeterminate', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attributes) {
          scope.$watch(attributes['ngIndeterminate'], function(value) {
            element.prop('indeterminate', !!value);
          });
        }
      };
    });
})(window.angular);

(function(angular, undefined) {

'use strict';

var comboboxApp = angular.module(
    'bento.combobox',
    ['ngSanitize', 'bento.services', 'bento.busyloader', 'bento.translate']);

comboboxApp
    /**
     * CONSTANTS
     */
    .constant('COMBOBOX_PAGE_UP', -1)   // Page up direction
    .constant('COMBOBOX_PAGE_DOWN', 1)  // page down direction
    /**
     * DIRECTIVE: bentoCombobox
     */
    .directive(
        'bentoCombobox',
        [
          '$document', '$timeout', '$parse', '$bentoServices',
          function($document, $timeout, $parse, $bentoServices) {
            return {
              require: ['ngModel', 'bentoCombobox', '?bentoAppendToParent'],
              scope: {
                getData: '&',
                columnsWidth: '&',  // Option to determine each column-width
                editable:
                    '&',  // Flag to determine if this component is editable
                headers: '=',  // headers
                headerIndex:
                    '=?',  // header index to be displayed in the input field
                headerTemplate: '=',  // Template support for headers
                ignoreInputClick:
                    '&',  // To ignore click even for the input field
                inputLabel: '=?inputText',
                labelName: '@',
                deferLoad:
                    '&',  // defer getData until the input field is onFocus
                minSearchCharacterCount:
                    '=?',  // Determines minimum character count to trigger
                // server search
                ngDisabled: '&',
                ngHide: '&',  // Track ng-hide
                ngModel: '=',
                ngShow: '&',  // Track ng-show
                onChange: '&',
                placeholder: '@',
                resetListOnSelect:
                    '&',  // Flag to determine whether to reset the list
                // when a selection is made
                revertOnInvalidInput:
                    '&',           // Revert selection on invalid inputs
                rowTemplate: '&',  // Custom row template for this Combobox
                searchable: '&',   // Check if this is searchable
                searchKeydownTimeout:
                    '&',  // Expose local `searchKeydownTimeout` to let dev
                // to control the delay
                type: '&',  // Table or normal
                useServer: '&',
                controller:
                    '=?',  // controller to trigger internal instructions
                searchFunction: '&',  // before the search starts
                // Footer Attributes to be forwarded
                footerOptions: '&',  // Footer Object
                containerVisibilityChanged:
                    '&',  // Function to be executed when container visibility
                          // changes.
                // Args: {visibility: scope.isContainerVisible}
                valueUpdatedWithoutMatch: '&'  // Callback function for when the
                                               // ngModel is about to update
                // on an EMPTY result set.
              },
              templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ?
                    attrs.templateUrl :
                    '../templates/combobox/bento-combobox.html';
              },
              controller: [
                function() {}
              ],  // for references to be improved in the future
              link:
                  /**
                   * Main Link function for Bento Combobox
                   * @param scope
                   * @param element
                   * @param attrs
                   * @param controllers
                   */
                  function comboboxMainLink(
                      scope, element, attrs, controllers) {
                    var ngModelController = controllers[0],
                        comboboxController = controllers[1],
                        appentToParentController = controllers[2];

                    // Initialize scope variables
                    scope.data = [];
                    scope.selectedIndex = -1;
                    scope.uid =
                        'bento-combobox-' + $bentoServices.generateUID();
                    scope.minSearchCharacterCount =
                        scope.minSearchCharacterCount || 1;

                    scope.attrs = attrs;  // link attrs for template to use

                    // Initialize header index when header exists
                    if (scope.headers) {
                      // No header Index
                      if (typeof scope.headerIndex === 'undefined') {
                        if (typeof scope.labelName === 'undefined') {
                          scope.headerIndex = scope.headers[0];
                        } else {
                          scope.headerIndex = 0;
                        }
                      }
                    }

                    // Set ng-form element state flags
                    ngModelController.$setUntouched();
                    ngModelController.$setPristine();

                    // local variabled
                    var $input =
                            angular.element(element[0].querySelector('input')),
                        getLabel = $parse(scope.labelName), baseData,
                        // `useServer` variabled
                        focused = false, isFullData = false, page = 0,
                        initLoad = true, searchFunc, initialDataLoaded = false;

                    // Check if there is a custom search function assigned
                    if (attrs.searchFunction) {
                      searchFunc = scope.searchFunction;
                    }
                    // Use default case insensitive global search
                    else {
                      searchFunc = function(obj) {
                        return obj.string.toLowerCase().indexOf(
                                   obj.search.toLowerCase()) > -1;
                      }
                    }

                    // Kick off initial data retrieval
                    if (!scope.deferLoad()) {
                      getData();
                      initialDataLoaded = true;
                    }

                    // Add element event listener
                    element.on('focusin', onInputFocus);
                    element.on('focusout', onInputBlur);
                    $input.on('click touchend', onInputClick);

                    // Add destroy listener to Scope to make sure that the
                    // listeners are cleaned properly
                    scope.$on('$destroy', function() {
                      element.off('focusin', onInputFocus);
                      element.off('focusout', onInputBlur);
                      $input.off('click touchend', onInputClick);
                      $input = undefined;
                      document.removeEventListener(
                          'mousedown', onAppendToParentDocClick);
                      document.removeEventListener(
                          'touchstart', onAppendToParentDocClick);
                      window.removeEventListener('resize', onWindowResize);
                    });

                    window.addEventListener('resize', onWindowResize);

                    function onWindowResize() {
                      // Align header if there is any
                      if (scope.containerCtrl) {
                        scope.containerCtrl.align();
                      }
                    }

                    // Watch ngModel to update the inputLabel accordingly
                    var ignoreNgModelWatchOnce = false;
                    scope.$watch('ngModel', function(object, previousObject) {
                      // Nothing needs to be updated even when `ngModel` changes
                      // from `undefined` to `null` or vice versa. Use loose
                      // comparison here to match `undefined` with `null`
                      if (!object && object == previousObject) return;

                      // update Label
                      if (!ignoreNgModelWatchOnce) {
                        scope.inputLabel = getLabelText(object);
                      }
                      ignoreNgModelWatchOnce = false;

                      inputLabelWatchIgnoreOnce = true;
                    });

                    // initialize controller object
                    scope.controller = {
                      reload: function() {
                        // Reset all internal references
                        isFullData = false;
                        baseData = undefined;
                        autoSelectCatchUp = false;
                        page = 0;
                        scope.selectedIndex = -1;
                        scope.data = [];
                        scope.loadingData = false;
                        ngModelController.$setUntouched();
                        ngModelController.$setPristine();
                        getData();
                      },
                      setTextField: function(str) {
                        scope.inputLabel = str;
                      }
                    };

                    function onAppendToParentDocClick(event) {
                      var dropdownContainer =
                          document.getElementById(scope.uid);
                      if (dropdownContainer.contains(event.target) ||
                          event.target === dropdownContainer) {
                        if (event.type === 'mousedown') {
                          // Only prevent default from clicking for mouse
                          // Otherwise, the dropdown does not scroll on touch
                          // devices
                          event.stopPropagation();
                          event.preventDefault();
                        }
                      }
                    }

                    /**
                     * When the Dropdown button is clicked
                     */
                    scope.onButtonClick = function() {
                      // Toggle container visibility
                      showContainer(!scope.isContainerVisible);

                      if (scope.isContainerVisible) {
                        $input[0].select();
                        if (scope.inputLabel) {
                          $input[0].setSelectionRange(
                              scope.inputLabel.length, scope.inputLabel.length);
                        }
                      }

                      // Safe apply the change to the scope
                      $bentoServices.safeApply(scope);
                    };

                    /**
                     * Callback function when an item is clicked
                     * @param index
                     */
                    scope.onItemClick = function(index, ignoreFocus) {
                      var isSameSelection = false;

                      if (!ignoreFocus && index > -1) {
                        $input[0].focus();
                      }

                      // Combobox ngModel will be changed, there for the
                      // directive is now "dirty"
                      ngModelController.$setDirty();

                      // Hide container
                      showContainer(false);

                      // Skip watch & search
                      inputLabelWatchIgnoreOnce = true;

                      // Make no changes and fire no callbacks
                      if (index > -1 &&
                          angular.equals(scope.ngModel, scope.data[index])) {
                        isSameSelection = true;
                      }

                      if (scope.editable() && index === -1) {
                        // We are going to fire a callback with the current
                        // input
                        var newItem = {};
                        newItem[scope.labelName] = scope.inputLabel;
                        scope.ngModel = newItem;
                      } else {
                        // Update input label immediately
                        scope.inputLabel = getLabelText(scope.data[index]);

                        // update model
                        scope.ngModel = scope.data[index];
                      }

                      // Fire onChange event
                      if (!isSameSelection) {
                        setTimeout(function() {
                          // onChange callback need to be fired after ngModel is
                          // updated
                          scope.onChange({item: scope.ngModel});
                        });
                      }

                      // Clear the keyboard dirty flag from the same data gets
                      // updated multiple time
                      scope.isDirty = false;
                      ignoreNgModelWatchOnce = true;
                      // Reset server searche flags for next refresh
                      if (scope.useServer()) {
                        isFullData = false;
                        page = 0;
                        scope.selectedIndex = -1;

                        getData();
                      } else if (!scope.useServer()) {
                        if (baseData) {
                          scope.data = baseData;
                          baseData = undefined;
                        }
                        scope.selectedIndex = scope.data.indexOf(scope.ngModel);
                      }
                    };

                    /**
                     * Get Label Text
                     * @param  {object} row Row object in an array
                     * @return {string}     Label to be displayed in textinput
                     */
                    function getLabelText(row) {
                      var label = getLabel(row);
                      if (typeof label === 'undefined' && !!row) {
                        label = row;
                      }

                      if (typeof label === 'object') {
                        label = label[scope.headerIndex];
                      }

                      return label;
                    }

                    /**
                     * When the expand Carat is clicked
                     */
                    function onInputClick(event) {
                      if (event.type === 'touchend') {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                      }
                      // Clear timeouts
                      $input[0].select();

                      // ignore input click
                      if (scope.ignoreInputClick()) {
                        return;
                      }

                      // Toggle container visibility
                      showContainer(!scope.isContainerVisible);

                      // Safe apply the change to the scope
                      $bentoServices.safeApply(scope);
                    }

                    var inputLabelWatchIgnoreOnce = false;
                    var isKeyboardInteraction = false;
                    scope.$watch('inputLabel', inputLabelWatch);

                    function inputLabelWatch(str) {
                      if (!str || str.length === 0) {
                        scope.selectedIndex = -1;
                        str = '';
                      }

                      if (attrs.required && str.length === 0) {
                        ngModelController.$setValidity('required', false);
                      } else {
                        ngModelController.$setValidity('required', true);
                      }

                      if (!initLoad && !inputLabelWatchIgnoreOnce &&
                          isKeyboardInteraction) {
                        scope.isDirty = true;
                        comboboxController.search(str);
                      } else {
                        initLoad = false;
                        inputLabelWatchIgnoreOnce = false;
                      }

                      isKeyboardInteraction = false;
                    }

                    /**
                     * Callback when the content is changed in inputlabel
                     * @param $event
                     */
                    scope.onInputChange = function($event) {
                      ngModelController.$setDirty();
                    };

                    /**
                     * When a key is pressed on the Input Field
                     * @param $event
                     */
                    scope.onInputKeypress = function($event) {
                      // FF fires Keypress on all keys including un-printable
                      // characters... 9 : Tab 13: Enter
                      if ($event.keyCode !== 9 && $event.keyCode !== 13) {
                        scope.isDirty = true;
                      }
                    };

                    /**
                     * When a key is down on the Input Field
                     * @param $event
                     */
                    scope.onInputKeyDown = function($event) {
                      // An user interaction is recorded
                      isKeyboardInteraction = true;

                      inputLabelWatchIgnoreOnce =
                          false;  // don't ignore keyboard interaction

                      // bypass all instructions
                      if (attrs.readonly) {
                        return;
                      }

                      var keyCode = $event.keyCode;

                      switch (keyCode) {
                        // Enter Key
                        case 13:
                          if (scope.isDirty) {
                            if (scope.selectedIndex > -1 ||
                                !scope.revertOnInvalidInput()) {
                              scope.onItemClick(scope.selectedIndex);
                            } else {
                              resetSelection();
                            }
                          }
                          $event.preventDefault();
                          break;
                          // Arrow Key  down
                        case 40:
                          $event.stopPropagation();
                          $event.preventDefault();
                          // Alt + Arrow Key behavior
                          // Recrouce:
                          // https://www.w3.org/TR/2009/WD-wai-aria-practices-20090224/#combobox
                          if ($event.ALT || !scope.isContainerVisible) {
                            showContainer(!scope.isContainerVisible);
                            break;
                          }

                          if (scope.data.length > 0 &&
                              (!scope.useServer() ||
                               (scope.useServer() && isFullData) ||
                               (scope.useServer() &&
                                scope.selectedIndex < scope.data.length - 1))) {
                            scope.selectedIndex =
                                (scope.selectedIndex + 1) % scope.data.length;
                          }
                          showContainer(true);
                          scope.isDirty = true;

                          break;
                          // Arrow Key Up
                        case 38:
                          $event.stopPropagation();
                          $event.preventDefault();

                          // Alt + Arrow Key behavior
                          // Recrouce:
                          // https://www.w3.org/TR/2009/WD-wai-aria-practices-20090224/#combobox
                          if ($event.ALT || !scope.isContainerVisible) {
                            showContainer(!scope.isContainerVisible);
                            break;
                          }
                          if (scope.data.length > 0) {
                            scope.selectedIndex = scope.selectedIndex < 0 ?
                                0 :
                                scope.selectedIndex;
                            scope.selectedIndex =
                                (scope.selectedIndex - 1 + scope.data.length) %
                                scope.data.length;
                          }
                          showContainer(true);
                          scope.isDirty = true;
                          break;
                          // Home
                        case 36:
                          if (scope.data.length > 0) {
                            scope.selectedIndex = 0;
                          }
                          scope.isDirty = true;
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                          // End
                        case 35:
                          if (scope.data.length > 0) {
                            scope.selectedIndex = scope.data.length - 1;
                          }
                          scope.isDirty = true;
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                          // Page up
                        case 33:
                          if (scope.data.length > 0) {
                            scope.selectedIndex -= 8;
                            scope.selectedIndex = scope.selectedIndex < 0 ?
                                0 :
                                scope.selectedIndex;
                          }
                          scope.isDirty = true;
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                          // Page Down
                        case 34:
                          if (scope.data.length > 0) {
                            scope.selectedIndex += 8;
                            scope.selectedIndex =
                                scope.selectedIndex >= scope.data.length ?
                                scope.data.length - 1 :
                                scope.selectedIndex;
                          }
                          scope.isDirty = true;
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                          // ESC Key
                        case 27:
                          resetSelection();
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                        default:
                          break;
                      }
                    };

                    /**
                     * When a key is released from the keyboard
                     * @param $event
                     */
                    scope.onInputKeyup = function($event) {
                      // bypass all instructions
                      if (attrs.readonly) {
                        return;
                      }

                      var keyCode = $event.keyCode;
                      switch (keyCode) {
                        // Enter Key
                        case 13:
                          // Stop a FORM from submitting
                          $event.stopPropagation();
                          $event.preventDefault();
                          break;
                          // Tab Key
                        case 9:
                          break;
                      }

                      isKeyboardInteraction = false;
                    };

                    /**
                     * When focused out from this Combobox
                     * @param $event
                     */
                    var autoSelectCatchUp;

                    function onInputBlur($event) {
                      focused = false;
                      // bypass all instructions
                      if (attrs.readonly) {
                        return;
                      }

                      // Ignore all key entry delays
                      $timeout.cancel(keyEntryDelayTimeoutId);
                      if (element[0].contains($event.relatedTarget) ||
                          comboboxController.containerScope.containerEl
                              .contains($event.relatedTarget)) {
                        // Ignore blur when the related target is also part of
                        // combobox
                        return;
                      }

                      // Emit blur event for this component
                      element.triggerHandler('blur');
                      if (scope.isDirty) {
                        if (scope.selectedIndex > -1) {
                          if (scope.loadingData) {
                            // If were searching for the wrong thing (i.e. the
                            // user typed more characters), do a search with the
                            // most recent string
                            if (currentSearchTerm !== scope.inputLabel) {
                              page = 0;
                              isFullData = false;
                              getData(scope.inputLabel);
                            }
                            autoSelectCatchUp = true;
                          } else {
                            scope.onItemClick(scope.selectedIndex, true);
                          }
                          // If the user typed quickly enough such that the
                          // search never started, start now
                        } else if (
                            scope.useServer() && scope.inputLabel.length > 0 &&
                            currentSearchTerm !== scope.inputLabel) {
                          page = 0;
                          isFullData = false;
                          getData(scope.inputLabel);
                          autoSelectCatchUp = true;
                        } else {
                          if (scope.valueUpdatedWithoutMatch) {
                            scope.valueUpdatedWithoutMatch(
                                {value: scope.inputLabel});
                          }

                          if (scope.revertOnInvalidInput()) {
                            resetSelection();
                          } else {
                            scope.onItemClick(-1);
                          }
                        }

                        // Update ngModel dirty flag
                        ngModelController.$setDirty();

                        // Reset data here to refresh the dropdown
                        // If were waiting to autoselect, the onItemClick method
                        // will handle the data refresh
                        if (scope.useServer() && scope.isDirty &&
                            !autoSelectCatchUp) {
                          // Reset page number so that a fresh set of data will
                          // be requested
                          page = 0;
                          getData();
                        }

                        // Reset the internal dirty flag until next user
                        // keypress
                        scope.isDirty = false;
                      }

                      // Reset index
                      scope.selectedIndex = -1;
                      showContainer(false);

                      ngModelController.$setTouched();

                      if ($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                      }
                    }

                    /**
                     * When focused in to this Combobox
                     */
                    function onInputFocus() {
                      if (scope.deferLoad() && !initialDataLoaded) {
                        getData();
                        initialDataLoaded = true;
                      }
                      focused = true;
                    }

                    /**
                     * Callback function when the list is at the end of scroll
                     */
                    scope.onEndOfScroll = function() {
                      // Only applies to server enabled environement
                      // This instance must be idle
                      if (scope.useServer() && !scope.loadingData) {
                        getData(currentSearchTerm);
                      }
                    };

                    /**
                     * Reset selection to the previous one
                     */
                    function resetSelection() {
                      // Do not watch the reset change for once
                      scope.inputLabel = getLabelText(scope.ngModel);
                      cleanSelectionData();
                    }

                    /**
                     * Clean selection data without touch the inputlabel &
                     * ngModel
                     */
                    function cleanSelectionData() {
                      scope.selectedIndex = -1;
                      scope.isDirty = false;
                      comboboxController.search('');
                      inputLabelWatchIgnoreOnce = true;
                      // Hide container
                      showContainer(false);
                    }

                    /**
                     * Get data from callback
                     * @param page
                     * @param search
                     */
                    var missedSearchTerm;  // use a stack
                    var currentSearchTerm = '';
                    var currentGetDataID;

                    function getData(search) {
                      currentSearchTerm = search || '';

                      // Need to ignore getData until the preivous getData
                      // request is finished
                      if (scope.loadingData) {
                        missedSearchTerm = currentSearchTerm;
                      } else if (isFullData) {
                        return;
                      }

                      // Generate UID for this get data
                      var getDataID = $bentoServices.generateUID();
                      // For promise validation
                      currentGetDataID = getDataID;

                      missedSearchTerm = undefined;

                      var dataObj = scope.getData(
                          {page: page || 0, search: search || ''});

                      scope.loadingData = true;

                      // Check if the returned data is an array or not
                      if (Array.isArray(dataObj)) {
                        if (page === 0) {
                          scope.data = dataObj;
                        } else {
                          // Directly assign
                          scope.data = scope.data.concat(dataObj);
                        }
                        scope.loadingData = false;

                        if (autoSelectCatchUp) {
                          if (scope.inputLabel.length > 0) {
                            if (scope.data.length > 0) {
                              scope.selectedIndex = 0;
                              scope.onItemClick(0, true);
                              autoSelectCatchUp = false;
                            } else {
                              if (scope.revertOnInvalidInput()) {
                                resetSelection();
                              } else {
                                scope.onItemClick(-1);
                              }
                            }
                          } else {
                            scope.ngModel = undefined;
                          }

                          autoSelectCatchUp = false;
                        }

                        // In case it's a lazyload
                        if (dataObj.length > 0) {
                          page++;
                        } else {
                          isFullData = true;
                        }
                      }
                      // This is promise
                      else if (dataObj && dataObj.then) {
                        dataObj.then(
                            function(data) {
                              // This dataset is no longer valid
                              if (getDataID !== currentGetDataID) {
                                return;
                              }

                              scope.loadingData = false;
                              if (page === 0) {
                                scope.data = [];

                                // There is no need to scroll to top even the
                                // container dropdown isn't ready New container
                                // will have scrollToTop => 0 anyways...
                                if (scope.containerCtrl) {
                                  scope.containerCtrl.scrollToTop();
                                }
                              }
                              scope.data = scope.data.concat(data);

                              // There is a pending getData (mostly a new
                              // search)
                              if (missedSearchTerm !== undefined) {
                                page = 0;
                                isFullData = false;
                                getData(missedSearchTerm);
                                return;
                              } else
                                  // There is data
                                  if (data.length > 0) {
                                // prepare for the next request
                                page++;

                                if (autoSelectCatchUp) {
                                  if (scope.inputLabel.length > 0) {
                                    scope.selectedIndex = 0;
                                    scope.onItemClick(0, true);
                                  } else {
                                    scope.ngModel = undefined;
                                  }
                                  autoSelectCatchUp = false;
                                }
                              } else
                              // Empty result and there is no need to load more
                              // data and select
                              {
                                if (autoSelectCatchUp &&
                                    scope.inputLabel.length > 0) {
                                  if (scope.revertOnInvalidInput()) {
                                    resetSelection();
                                  } else {
                                    scope.onItemClick(-1);
                                  }
                                }
                                scope.selectedIndex = -1;
                                isFullData = true;
                                autoSelectCatchUp = false;
                              }

                              // Align after the data is populated and rendered
                              if (scope.containerCtrl) {
                                $timeout(scope.containerCtrl.align, 10);
                              }
                            },
                            function(message) {
                              scope.loadingData = false;
                              isFullData = true;

                              // Reset data array if there is no result on page
                              // 0
                              if (page === 0) {
                                scope.data = [];
                              }
                            });
                      } else {
                        // None qualitfied data is returned.
                        // We stop loading here
                        isFullData = true;
                        scope.loadingData = false;

                        // Reset data array if there is no result on page 0
                        if (page === 0) {
                          scope.data = [];
                        }
                      }
                      $bentoServices.safeApply(scope);
                    }

                    /**
                     * Show/Hide the container
                     * @param bool
                     */
                    var isUserDefinedDropdown;

                    function showContainer(bool) {
                      // Ignore if bool is not changed
                      if (scope.isContainerVisible === bool ||
                          scope.ngDisabled() || attrs.readonly) {
                        return;
                      }

                      // Align header if there is any
                      if (scope.containerCtrl) {
                        scope.containerCtrl.align();
                      }

                      if (attrs.bentoAppendToParent) {
                        // Only applies doc event listeners when
                        // `bento-append-to-parent` is enabled Also need to
                        // calculate its button absolute alignement when it's
                        // calculated as a dropup

                        if (bool) {
                          document.addEventListener(
                              'mousedown', onAppendToParentDocClick);
                          document.addEventListener(
                              'touchstart', onAppendToParentDocClick);
                        } else {
                          document.removeEventListener(
                              'mousedown', onAppendToParentDocClick);
                          document.removeEventListener(
                              'touchstart', onAppendToParentDocClick);
                        }
                        // calculate view port position then update
                        if (typeof isUserDefinedDropdown === 'undefined') {
                          isUserDefinedDropdown = !element.hasClass('up');
                        }

                        if (!bool) {
                          // reset dropdown / dropup class to its original state
                          if (isUserDefinedDropdown) {
                            element[0].classList.remove('up');
                          } else {
                            element[0].classList.add('up');
                          }
                        } else {
                          // calculate and update dropdown / dropup properties
                          var elRect = element[0].getBoundingClientRect(),
                              containerHeight =
                                  scope.containerCtrl.el.offsetHeight,
                              scrollableParent =
                                  $bentoServices.getScrollableParent(
                                      element[0]);

                          if (scrollableParent) {
                            var scrollableParentRect =
                                    scrollableParent.getBoundingClientRect(),
                                top = elRect.top - scrollableParentRect.top,
                                isUp = !isUserDefinedDropdown;

                            if (isUp) {
                              // check if up is possible or not
                              if (top + scrollableParent.scrollTop -
                                      containerHeight <
                                  0) {
                                // There is not enough space on the top
                                isUp = false;
                              }
                            } else {
                              // check if bottom is possible or not
                              if ((top + elRect.height + containerHeight) >
                                  (scrollableParent.scrollHeight +
                                   scrollableParent.scrollTop)) {
                                // There is not enough space at the bottom
                                isUp = true;
                              }
                            }

                            if (isUp) {
                              element[0].classList.add('up');
                            } else {
                              element[0].classList.remove('up');
                            }
                          }
                        }
                      }

                      // Set show/hide flag variable

                      scope.isContainerVisible = bool;

                      emitAppendToParent(bool);
                      if (scope.containerVisibilityChanged) {
                        scope.containerVisibilityChanged(
                            {visibility: scope.isContainerVisible});
                      }

                      // Safe apply the change to the scope
                      $bentoServices.safeApply(scope);
                    }

                    /**
                     * Emit append to parent change
                     * @param show
                     */
                    function emitAppendToParent(show) {
                      if (appentToParentController) {
                        // Only emit when there is appendToParent Directive that
                        // is assigned to this Combobox component
                        if (show) {
                          window.addEventListener(
                              'scroll', onAppendToParentWindowScroll, true);
                        } else {
                          window.removeEventListener(
                              'scroll', onAppendToParentWindowScroll, true);
                        }

                        scope.$emit(
                            'append_to_parent_show_list', show, scope.uid);
                      }
                    }

                    /**
                     * Window Scroll Listener for Append to Parent
                     * @param e
                     */
                    function onAppendToParentWindowScroll(e) {
                      var target = e.target;
                      if (target.contains(element[0]) &&
                          !target.contains(scope.containerCtrl.el)) {
                        showContainer(false);
                      }
                    }

                    /**
                     * Search through data labels and list result
                     */
                    var keyEntryDelayTimeoutId = 0;

                    /**
                     * Search and update data
                     * @param str
                     * @param silentSearch : search without showing the
                     *     container
                     */
                    comboboxController.search = function(str, silentSearch) {
                      // Normalize undefined value to an empty string
                      if (typeof str === 'undefined') {
                        str = '';
                      }

                      if (scope.searchable() &&
                          (scope.minSearchCharacterCount <= str.length ||
                           str.length === 0)) {
                        if (!silentSearch) {
                          showContainer(true);
                        }

                        if (!scope.useServer()) {
                          if (!baseData) {
                            baseData = scope.data;
                          }

                          var newArray = [], i, iLen, row, rowLabel;

                          // No entry
                          // IGNORE THE RESET
                          if (!str || str.trim().length === 0) {
                            scope.selectedIndex = -1;
                            scope.data = baseData;
                            return;
                          }

                          for (i = 0, iLen = baseData.length; i < iLen; i++) {
                            row = baseData[i];
                            rowLabel =
                                scope.labelName ? row[scope.labelName] : row;

                            // Search column if there are some
                            if (typeof rowLabel === 'object') {
                              var isNumKey = Array.isArray(rowLabel);

                              for (var key in rowLabel) {
                                if (searchFunc({
                                      string: rowLabel[key],
                                      search: str,
                                      column: isNumKey ? Number(key) : key,
                                      row: row
                                    })) {
                                  newArray.push(row);
                                  break;
                                }
                              }
                            } else if (searchFunc({
                                         string: rowLabel,
                                         search: str,
                                         column: 0,
                                         row: row
                                       })) {
                              newArray.push(row);
                            }
                          }

                          // Reset `selectedIndex` to auto select only if the
                          // input field is not empty
                          if (newArray.length > 0) {
                            scope.selectedIndex = 0;
                          } else {
                            // nothing to select
                            scope.selectedIndex = -1;
                          }

                          // Feed new Array
                          scope.data = newArray;

                          // Need to align the columns during search to avoid
                          // jumping when there is a scrollbar
                          $timeout(scope.containerCtrl.align);
                        }
                        // Server search
                        else {
                          $timeout.cancel(keyEntryDelayTimeoutId);
                          keyEntryDelayTimeoutId = $timeout(function() {
                            page = 0;
                            isFullData = false;
                            // Auto select when there is a string in the input
                            // field
                            if (scope.inputLabel &&
                                scope.inputLabel.length > 0) {
                              scope.selectedIndex = 0;
                            }
                            // Empty string gets no selection
                            else {
                              scope.selectedIndex = -1;
                            }

                            // Because of the 200 mil delay we need to find out
                            // if the search is done after blur
                            if (str.length > 0 && !focused) {
                              autoSelectCatchUp = true;
                            }
                            getData(str || '');
                          }, scope.searchKeydownTimeout() || 200);
                        }
                      }
                    }
                  }
            };
          }
        ])

    /**
     * Bento Combobox Container Directive
     * For Combobox 1.x
     */
    .directive(
        'bentoComboboxContainer',
        [
          '$timeout',
          function($timeout) {
            return {
              replace: true, require: '^bentoCombobox', scope: {
                selectedIndex: '=',
                columnsWidth: '&',
                headers: '=',
                headerTemplate: '=',
                data: '=',
                isTable: '=',
                labelName: '=',
                onItemClick: '&',
                controller: '=',
                onEndOfScroll: '&',
                rowTemplate: '&',
                footerTemplateUrl: '&?',
              },
                  templateUrl:
                      function(element, attrs) {
                        return angular.isDefined(attrs.templateUrl) ?
                            attrs.templateUrl :
                            '../templates/combobox/bento-combobox-container.html';
                      },
                  link: function bentoComboboxContainerListLink(
                      scope, element, attrs, comboboxCtrl) {
                    scope.selectedIndex =
                        typeof scope.selectedIndex === 'undefined' ?
                        -1 :
                        scope.selectedIndex;
                    var container = element[0].querySelector(
                        '.bento-combobox-container-body');
                    scope.containerEl = container;

                    comboboxCtrl.containerScope = scope;

                    // Listen to scrolling for lazy loading
                    container.addEventListener('scroll', function() {
                      // fire end of scroll event, offset by 200px to make
                      // infinite scroll a little smoother
                      if (container.scrollTop + container.offsetHeight + 200 >=
                          container.scrollHeight) {
                        scope.onEndOfScroll();
                      }
                    });

                    scope.selectItem = function(index) {
                      scope.selectedIndex = index;
                      scope.onItemClick({index: index});
                    };

                    scope.$watch('selectedIndex', function(value) {
                      if (value > -1 && container && scope.data &&
                          scope.data.length > 0) {
                        // Wait until rendering is finished.
                        $timeout(function() {
                          var item = element[0].querySelector(
                              '[rel="row-' + value + '"]');
                          if (item) {
                            // Make sure the selected item/row is in view
                            if (item.offsetTop < container.scrollTop) {
                              container.scrollTop = item.offsetTop;
                            } else if (
                                item.offsetTop + item.offsetHeight >
                                container.scrollTop + container.offsetHeight) {
                              container.scrollTop = item.offsetTop +
                                  item.offsetHeight - container.offsetHeight;
                              if (value === scope.data.length - 1) {
                                scope.onEndOfScroll();
                              }
                            }
                          }
                        });
                      }
                    });

                    // Create a controller for the parent directive to access
                    scope.controller = {
                      scrollToTop: scrollToTop,
                      align: alignColumns,  // Align the header and columns
                      el: element[0],
                    };

                    // Dropdown load helpers
                    function scrollToTop() {
                      container.scrollTop = 0;
                    }

                    function alignColumns() {
                      if (scope.data && scope.data.length > 0) {
                        var cWidth = scope.columnsWidth() ?
                            scope.columnsWidth().slice() :
                            [];
                        var rowObj = element[0].querySelector(
                            '.bento-combobox-container-item bento-combobox-row-template');
                        var header = element[0].querySelector(
                            '.bento-combobox-container-header');
                        if (!rowObj || !header) {
                          return;
                        }
                        var row = rowObj.children, headers = header.children, i,
                            len, tempVar;

                        // Normalize Column Width
                        for (i = 0, len = headers.length; i < len; i++) {
                          tempVar = parseInt(cWidth[i]);
                          cWidth[i] = isNaN(tempVar) ? 'auto' : (tempVar + 'px')
                        }

                        // reset header widths
                        for (i = 0, len = headers.length; i < len; i++) {
                          headers[i].style.width = cWidth[i];
                          headers[i].style.opacity = '0';
                        }

                        // delayed render
                        $timeout(function() {
                          var targetWidth;
                          for (i = 0, len = headers.length; i < len; i++) {
                            if (i < len - 1 && row[i]) {
                              tempVar = cWidth[i];
                              targetWidth = (tempVar === 'auto') ?
                                  (Math.max(
                                       row[i].offsetWidth,
                                       headers[i].offsetWidth) +
                                   'px') :
                                  tempVar;
                              // Make sure the min width inline with the header
                              // columns
                              row[i].style.minWidth = targetWidth;
                              row[i].style.width = targetWidth;
                              // Align header widths
                              headers[i].style.width =
                                  row[i].offsetWidth + 'px';
                            }
                            headers[i].style.opacity = '1';
                          }
                        });
                      }
                    }
                  }
            }
          }
        ])

    /**
     * Bento Combobox Header Template Directive
     * For Combobox 1.x
     */
    .directive('bentoComboboxHeaderTemplate', [
      '$compile',
      function($compile) {
        return {
          replace: true,
          templateUrl:
              '../templates/combobox/bento-combobox-header-template.html',
          scope: {
            bentoComboboxHeaderTemplate:
                '&',       // Custom header template string/array
            $header: '&',  // item object
            $index: '@'    // an index of this column to refer the template
            // array
          },
          link: function(scope, element) {
            var defaultRowTemplate = '<span>{{$header()}}</span>',
                template = defaultRowTemplate;

            if (typeof scope.bentoComboboxHeaderTemplate() === 'string') {
              template =
                  '<span>' + scope.bentoComboboxHeaderTemplate() + '</span>';
            } else if (Array.isArray(scope.bentoComboboxHeaderTemplate())) {
              template = '<span>' +
                  scope.bentoComboboxHeaderTemplate()[scope.$index] + '</span>';
            }

            if (!template) {
              template = defaultRowTemplate;
            }

            template = angular.element(template);

            $compile(template)(scope);
            element.append(template);
          }
        };
      }
    ]);

/**
 * Bento Combobox Footer Directive
 * For Combobox 1.x
 */
var comboboxFooterDefaultTemplate = '<div class="bento-combobox-footer-row">' +
    '<div class="bento-combobox-footer-item" ng-repeat="button in footerOptions.buttons track by $index">' +
    '<div class="bento-combobox-footer-item-inner">' +
    '<a ng-click="onButtonAction(button)"' +
    ' ng-attr-aria-label="{{button.ariaLabel}}"' +
    ' ng-attr-title="{{button.ariaLabel}}"' +
    ' ng-keydown="onFooterItemKeydown($event, button)">' +
    '<i ng-if="button.icon" ng-class="button.icon"></i> ' +
    '{{button.label | bentoStringReplace:\'_ITEM_\': getComboboxInputLabel() || button.defaultItemLabel}}</a>' +
    '</div>' +
    '</div>' +
    '</div>';

comboboxApp
    .directive(
        'bentoComboboxFooter',
        [
          '$compile', '$templateCache', '$http', '$log',
          function($compile, $templateCache, $http, $log) {
            return {
              restrict: 'EA',
              require: '^bentoCombobox',
              template: '',
              link: function(scope, element, attrs, comboboxCtrl) {
                var template,
                    $templateEl =
                        angular.element(document.createElement('div')),
                    comboboxScope = scope.$parent.$parent,
                    // Create Keycode ref
                    KeyCodes = {
                      TAB: 9,
                      RETURN: 13,
                      SPACE: 32,
                      ALT: 18,
                      UP: 38,
                      DOWN: 40,
                      ESCAPE: 27
                    };

                comboboxCtrl.footerScope = scope;

                if (attrs.templateUrl && attrs.templateUrl.length) {
                  template = $templateCache.get(attrs.templateUrl);
                  if (template) {
                    // Template exists in the template
                    init();
                  } else {
                    // Use $http to lazy load template file
                    $http.get(attrs.templateUrl, {cache: true})
                        .then(
                            function(res) {
                              template = res.data;
                              init();
                            },
                            function(res) {
                              $log.error(
                                  'Combobox Footer Tempalte: [Error] Faild to load "' +
                                  attrs.templateUrl + '"');
                            });
                  }
                } else {
                  template = comboboxFooterDefaultTemplate;
                  init();
                }

                // Initialize
                function init() {
                  $templateEl.addClass('bento-combobox-footer-inner');
                  $templateEl.html(template);
                  $compile($templateEl)(scope);
                  element.append($templateEl);
                }

                // Get options
                scope.footerOptions = comboboxScope.footerOptions();
                // Init object
                scope.values = {};

                scope.onButtonAction = function(button) {
                  var value = scope.values.input || '';

                  // Make that the default item label is not forwarded to the
                  // callback
                  if (button.defaultItemLabel &&
                      value.toLowerCase() ===
                          button.defaultItemLabel.toLowerCase()) {
                    value = '';
                  }

                  // Call button action
                  button.action(value);

                  // Clear input label and set the Combobox to dirty
                  if (button.clearInputOnAction) {
                    comboboxScope.inputLabel = '';
                    comboboxScope.isDirty = false;
                  }

                  // Collapse the list container by default
                  if (button.collapseOnAction ||
                      typeof button.collapseOnAction == 'undefined') {
                    comboboxScope.onButtonClick();
                    comboboxCtrl.search('', true);
                  }
                };

                scope.onTabList = function() {
                  return comboboxScope.isContainerVisible;
                };

                scope.onFooterItemKeydown = function($event, button) {
                  switch ($event.keyCode) {
                    case KeyCodes.SPACE:
                    case KeyCodes.RETURN:
                      scope.onButtonAction(button);
                      $event.preventDefault();
                      $event.stopPropagation();
                      break;
                  }
                };

                // TODO: assign to scope to make unit testing easier
                scope.bentoOnInputKeyDown = comboboxScope.onInputKeyDown;
                comboboxScope.onInputKeyDown = function($event) {
                  if (scope.footerOptions) {
                    switch ($event.keyCode) {
                      case KeyCodes.RETURN:
                        // deprecated: this will be deprecated on the next
                        // update of bento
                      case KeyCodes.UP:
                      case KeyCodes.DOWN:
                        if ($event.ALT) {
                          comboboxScope.onButtonClick();
                          $event.preventDefault();
                          $event.stopPropagation();
                          return;
                        }
                        break;
                        // end here
                    }
                  }
                  scope.bentoOnInputKeyDown.call(
                      scope.bentoOnInputKeyDown, $event);
                };

                // Determine if the CTAs are tabbable
                scope.onTabList = function() {
                  if (comboboxScope.isContainerVisible) {
                    if (comboboxScope.data.length < 1 ||
                        !comboboxScope.inputLabel) {
                      return true;
                    }
                  }
                  return false;
                };

                // Get Text from the input label of the Combobox
                scope.getComboboxInputLabel = function() {
                  // If the dropdown is open a item may be selected
                  var selectedItem =
                      comboboxScope.data[comboboxScope.selectedIndex];
                  var itemLabel;
                  var inputString;
                  var labelName =
                      comboboxScope.labelName || comboboxScope.headerIndex;
                  // If an item is selected get the displayed property,
                  // otherwise the selected item is the ngModel
                  //
                  // (the user is not interacting with the combobox when
                  // selectedItem is the model)
                  if (comboboxScope.selectedIndex > -1 &&
                      angular.isObject(selectedItem)) {
                    itemLabel = selectedItem[labelName];

                    if (Array.isArray(itemLabel)) {
                      // This is a grid layout we need to find the right label
                      // string
                      itemLabel =
                          getLabelFrom(itemLabel[comboboxScope.headerIndex])
                              .toLowerCase();
                    } else {
                      // Label is a normal string
                      itemLabel = getLabelFrom(itemLabel).toLowerCase();
                    }

                  } else if (
                      comboboxScope.selectedIndex > -1 &&
                      angular.isObject(comboboxScope.ngModel) &&
                      comboboxScope.ngModel.hasOwnProperty(labelName)) {
                    itemLabel = getLabelFrom(comboboxScope.ngModel[labelName])
                                    .toLowerCase();
                  } else if (
                      angular.isObject(comboboxScope.ngModel) &&
                      comboboxScope.ngModel.hasOwnProperty(labelName)) {
                    if (angular.isObject(comboboxScope.ngModel[labelName])) {
                      itemLabel =
                          getLabelFrom(
                              comboboxScope.ngModel[labelName]
                                                   [comboboxScope.headerIndex])
                              .toLowerCase();
                    } else {
                      itemLabel = getLabelFrom(comboboxScope.ngModel[labelName])
                                      .toLowerCase();
                    }
                    selectedItem = comboboxScope.ngModel;
                  }
                  // If the user typed something in the combobox input
                  if (angular.isString(comboboxScope.inputLabel)) {
                    inputString = comboboxScope.inputLabel.toLowerCase();
                  }
                  // Use the text in the combobox input if there is not a
                  // selected item with the same text, otherwise use the default
                  // text
                  if (comboboxScope.inputLabel &&
                      (!angular.isObject(selectedItem) ||
                       itemLabel !== inputString)) {
                    scope.values.input = comboboxScope.inputLabel;
                  } else {
                    scope.values.input = scope.defaultAddText;
                  }

                  return scope.values.input;
                };

                // There are chances where the variable str is undefined, so
                // return and empty string to avoid errors
                function getLabelFrom(str) {
                  return typeof str === 'string' ? str : '';
                }
              }
            };
          }
        ])

    /**
     * Bento Combobox Row Template Directive
     * For Combobox 1.x
     */
    .component('bentoComboboxRowTemplate', {
      bindings: {
        rowTemplate: '<',  // Custom row template
        $item: '<',        // item object
        $labelName: '<',   // variable name used to display row
        $index: '<',       // an index of this item
        headers: '<'
      },
      // template    : '',
      controllerAs: '$row',
      controller: [
        '$scope', '$compile', '$element', '$attrs',
        function($scope, $compile, $element, $attrs) {
          var $row = this;

          $row.$onInit = function() {
            var defaultRowTemplate =
                    '<span class="combobox-default-row">{{$row.$labelName? $row.$item[$row.$labelName]:$row.$item}}</span>',
                defaultGridTemplate =
                    '<span class="combobox-grid-column" ng-repeat="cell in $row.$item[$row.$labelName] track by $index">{{cell}}</span>',
                defaultGridTemplateWithoutLabelName =
                    '<span class="combobox-grid-column-no-ln" ng-repeat="header in $row.headers track by $index">{{$row.$item[header]}}</span>',
                template = defaultRowTemplate;

            if ($row.rowTemplate) {
              template = $row.rowTemplate;
            } else
                // Grid
                if (Array.isArray($row.headers)) {
              if ($row.$labelName) {
                template = defaultGridTemplate;
              } else {
                template = defaultGridTemplateWithoutLabelName;
              }
            }
            var templateEl = angular.element(template);

            $compile(templateEl)($scope);
            $element.append(templateEl);
          };
        }
      ]
    });
})(window.angular);
(function (angular) {
  'use strict';

  angular
    .module('bento.contextualheader', [])
    .directive('bentoContextualHeader', bentoContextualHeader);

  bentoContextualHeader.$inject = [];

  function bentoContextualHeader() {
    var isImgRegex = /[^\s]+(\.(jpg|png|gif|bmp|svg)$)/;

    return {
      restrict   : 'EA',
      scope      : {
        contextualHeaderData: '&',
        onBackBtnClick      : '&',
        backBtnDisabled     : '&',
        hideBackBtn         : '&'
      },
      templateUrl: function (element, attrs) {
        return angular.isDefined(attrs.templateUrl) ?
          attrs.templateUrl : '../templates/contextual_header/bento-contextual-header.html';
      },
      link       : function (scope, element) {
        element.addClass('bento-contextual-header');

        // Right button click CTA
        scope.onRightButtonClick = function(){
          var button = scope.contextualHeaderData().button;
          if(button && button.action){
            button.action();
          }
        };

        // Return the condition whether the subtitle needs a tooltip
        scope.isTooltipEnabled = function(index){
          var selector = 'div[data-subtitle-id="'+index+'"]';
          var el = element[0].querySelector(selector);
          return (el && el.offsetWidth < el.scrollWidth);
        };

        // Check if the str is an image url
        scope.isImage = function(str){
          return isImgRegex.test(str);
        };
      }
    };
  }
})(window.angular);

(function(angular, window, undefined) {

'use strict';

angular
    .module(
        'bento.fileselector',
        ['bento.busyloader', 'bento.services', 'bento.translate'])
    .directive(
        'bentoFileSelector', [function() {
          return {
            controller: 'fileSelectorController',
            controllerAs: 'bentoFileSelectorCtrl',
            replace: true,
            scope: {
              ngModel: '=?',  // List of selected files
              accept: '@',    // Accept file types
              fileType:
                  '@',  // Limit the type of file that needs to be selected
              onFileSelect: '&',  // Callback when a file is selected
              onFileRemove: '&',  // Callback when the selected file's reference
                                  // is removed from this directive
              onDuplicateSelect: '&',  // Callback when the file(s) that have
                                       // already been selected
              multiple: '=',           // (Boolean) for multiple file selections
              appendOnSelection:
                  '=',  // (Boolean) append new files onto the existing list
              showSelected: '=',            // Show selected files in the view
              showFileSize: '=',            // Show file size info
              uploadProgress: '=',          // Upload progress variable
              showProgressPercentage: '=',  // Show upload progress percentage
              disableFilesDuringUpload: '=?',  // Disable file buttons from
                                               // being removed during upload
              dropFieldLabel: '@',     // Override to the drop field text
              browseButtonLabel: '@',  // Override to the upload button
              ngDisabled: '&'          // If this component is disabled or not
            },
            templateUrl: function(element, attrs) {
              return angular.isDefined(attrs.templateUrl) ?
                  attrs.templateUrl :
                  '../templates/file_selector/bento-file-selector.html';
            },
          };
        }])
    .filter(
        'bentoFileSizeFilter',
        function() {
          return function(value) {
            var output = '0 Byte';
            if (value < 1000) {
              output = value + 'B';
            } else if (value < 100000) {
              output = Math.round(value / 100) / 10 + 'KB';
            } else if (value < 1000000) {
              output = Math.round(value / 1000) + 'KB';
            } else if (value < 100000000) {
              output = Math.round(value / 100000) / 10 + 'MB';
            } else if (value < 1000000000) {
              output = Math.round(value / 1000000) + 'MB';
            } else if (value < 100000000000) {
              output = Math.round(value / 100000000) / 10 + 'GB';
            } else if (value < 1000000000000) {
              output = Math.round(value / 1000000000) + 'GB';
            } else if (value < 100000000000000) {
              output = Math.round(value / 100000000000) / 10 + 'TB';
            } else if (value < 1000000000000000) {
              output = Math.round(value / 1000000000000) + 'TB';
            }

            return output;
          }
        })
    .factory(
        '$fileSelectorServices',
        [
          '$bentoServices', '$sanitize',
          function($bentoServices, $sanitize) {
            /**
             * Parse a File out from the file list and forward it back to the
             * callback function
             * @param scope
             * @param files
             * @param selectedCallback
             * @param duplicateCallback
             * @param fileType
             */
            var parseFiles = function(
                scope, files, selectedCallback, duplicateCallback, fileType,
                element, accepted) {
              // Ignore non-file selection
              if (typeof files === 'undefined') {
                return;
              }

              var newFiles = (scope.multiple) ?
                  files :
                  [files[0]];  // 1 element when `mutiple` is NOT
                               // `true`
              var originalFiles = scope.ngModel;

              var selectedFiles = [];
              var duplicatedFiles = [];
              var dupIndex;
              scope.errorFiles = [];
              for (var i = 0; i < newFiles.length; i++) {
                var file = newFiles[i];
                if (originalFiles &&
                    (dupIndex = hasFileAtIndex(originalFiles, file)) > -1) {
                  // This is file has already been selected
                  duplicatedFiles.push(originalFiles[dupIndex]);
                  if (duplicateCallback && duplicatedFiles.length > 0) {
                    // Fire callback only when there are duplicates
                    duplicateCallback({files: duplicatedFiles});
                  }

                  $bentoServices.safeApply(scope);
                } else {
                  isFileAccepted(
                      file, accepted, element, scope, function(accepted) {
                        if (accepted) {
                          if (isValidFileType(file, fileType)) {
                            // A new file
                            var displayFilename =
                                truncateFilename(file, element);

                            // add new property to file object `displayFilename`
                            // only for display purpose, to avoid showing very
                            // long file name
                            file.displayFilename = displayFilename;
                            selectedFiles.push(file);

                            if (selectedFiles.length > 0) {
                              // Append or renew only if there is at least a
                              // selected file
                              if (scope.appendOnSelection &&
                                  Array.isArray(scope.ngModel) &&
                                  scope.multiple) {
                                // Determine if it needs to append to the
                                // existing file array or not
                                scope.ngModel =
                                    scope.ngModel.concat(selectedFiles);
                              } else if (selectedFiles.length > 0) {
                                // Add a file reference to scope
                                scope.ngModel = selectedFiles;
                                scope.disabledFiles = [];
                                scope.fileProgresses = [];
                              }

                              if (selectedCallback) {
                                selectedCallback({files: selectedFiles});
                              }
                            }
                          }
                        }
                        $bentoServices.safeApply(scope);
                      });
                }
              }
            };


            /**
             * Determine if the first element in files has the right file type
             * @param file
             * @param fileTypes
             * @returns {boolean}
             */
            var isValidFileType = function(file, fileTypes) {
              var _ft = (!!fileTypes) ? fileTypes.trim() : '';
              var fileNameBreakDown = file.name.split('.');
              var fileExtension =
                  fileNameBreakDown[fileNameBreakDown.length - 1];

              // This is no filetype specified
              if (typeof _ft === 'undefined' || _ft.length === 0) {
                return true;
              }

              // Check if this file extension exists in fileTypes string
              if (fileTypes.toLowerCase().search(
                      fileExtension.toLowerCase()) !== -1) {
                return true;
              }

              // File extension does not exist in the fileTypes
              return false;
            };

            /**
             * Callback will be set to true if it's a file.
             * If it's a folder the callback will be set to false.
             *
             * https://stackoverflow.com/questions/47362320/how-to-identify-the-difference-between-file-and-folder-ondropping-in-javascript
             *
             * @param {*} file - File that is uploaded
             * @param {*} callback true: if file, false: if it's a folder
             */
            function isFile(file, callback) {
              var start = 0;  // start byte
              var stop = 4;   // end byte - to avoid read all the content

              try {
                var reader = new FileReader();
                reader.onloadend = function(evt) {
                  if (evt.target.readyState == FileReader.DONE) {
                    var binary = '';
                    var bytes = new Uint8Array(evt.target.result);
                    var length = bytes.byteLength;
                    if (length == 0) {
                      callback(false);
                    } else {
                      callback(true);
                    }
                  } else {
                    callback(false);
                  }
                };

                var blob = file.slice(start, stop + 1);
                reader.readAsArrayBuffer(blob);
              } catch (e) {
                callback(false);
              }
            }

            /**
             * Find out if the file extensions belong to the `accepted` array
             * list
             * @param {File} file
             * @param {Array} accepted
             * @param {HTMLElement} element
             * @param {Object} scope
             * @param {Function} callback
             */
            var isFileAccepted =
                function(file, accepted, element, scope, callback) {
              isFile(file, function(isFile) {
                file.displayType = isFile ? 'file' : 'folder';
                var fileAccepted = isFile;
                if (fileAccepted) {
                  // this file type is not accepted
                  var indexOfExt = file.name.lastIndexOf('.');
                  var selectedFileExtension = indexOfExt < 0 ?
                      '' :
                      file.name.slice(indexOfExt).toLowerCase();

                  // list only the files that are accepted
                  if (accepted && accepted.length &&
                      accepted.indexOf(selectedFileExtension) < 0) {
                    fileAccepted = false;
                  }
                }

                updateFileNotAcceptedUI(file, fileAccepted, element, scope);

                callback(fileAccepted);
              });
            }

            /**
             * This function updates the UI if there are any errors. The UI is
             * manipulated inside the service is for a reason - to show errors
             * individually for all files when executing `parseFiles`.
             * @param {File} file File Object
             * @param {boolean} fileAccepted Defines whether the file is
             *     accecepted or not
             * @param {HTMLElement} element File Selector Element Container
             * @param {Object} scope Controller scope object
             */
            var updateFileNotAcceptedUI =
                function(file, fileAccepted, element, scope) {
              var fsContainer = element.querySelector('.bento-file-selector');
              var fsErrorEl = element.querySelector('.file-selection-error');
              if (fileAccepted) {
                // do not reset any old errors, if present
                if (scope.errorFiles.length === 0) {
                  if (fsContainer) {
                    fsContainer.classList.remove('accept-error');
                  }
                  if (fsErrorEl) {
                    fsErrorEl.classList.remove('show');
                  }
                }
              } else {
                if (fsContainer) {
                  fsContainer.classList.add('accept-error');
                }

                if (fsErrorEl) {
                  fsErrorEl.classList.add('show');
                }

                // push the new file
                scope.errorFiles.push(file);
              }
            }

            /**
             * Truncate given displayFilename based on the max length
             * @param file
             * @returns updated file object with `displayFilename` added
             */
            var truncateFilename = function(file, element) {
              // consider the file size information (ex: (100.2KB) ) + 'x'
              // (close button)
              var FILESIZE_INFO_LENGTH = 10;

              // 3 dots that needs to be shown
              var START_LENGTH_TO_REDUCE = 3;

              // last 5 chars
              var LAST_CHARS_TO_SHOW = 5;

              var fileNameBreakDown = file.name.split('.');
              var fileExtension =
                  fileNameBreakDown[fileNameBreakDown.length - 1];
              var displayFilename = file.name;
              var filename = fileNameBreakDown[0];

              if (!element) {
                return displayFilename;
              }

              var lengthCalcEl =
                  element.querySelector('span#truncated-filename-placeholder');
              if (lengthCalcEl) {
                var pixelsPerCharacter = 0;
                var charsLengthThatFit = 0;

                lengthCalcEl.innerHTML = $sanitize(displayFilename);
                lengthCalcEl.classList.remove('hidden');

                var style = window.getComputedStyle(element, null)
                                .getPropertyValue('font-size');
                var fontSize = parseFloat(style);
                lengthCalcEl.style.fontSize = fontSize;

                pixelsPerCharacter =
                    (lengthCalcEl.clientWidth / displayFilename.length);

                // remove spaces, number & spl characters to compute proper
                // pixels per char value
                pixelsPerCharacter +=
                    (displayFilename.length -
                     (displayFilename.replace(/[^A-Z]/gi, '').length - 1)) /
                    2;

                // add additional characters (size info)
                var sizeInfoLength = pixelsPerCharacter * FILESIZE_INFO_LENGTH;
                if (lengthCalcEl.clientWidth + sizeInfoLength >
                    element.clientWidth) {
                  charsLengthThatFit =
                      Math.round(element.clientWidth / pixelsPerCharacter);

                  var removeFromStart = START_LENGTH_TO_REDUCE +
                      FILESIZE_INFO_LENGTH + LAST_CHARS_TO_SHOW;
                  var showAtEnd = LAST_CHARS_TO_SHOW;

                  if (charsLengthThatFit <= removeFromStart) {
                    removeFromStart -= (LAST_CHARS_TO_SHOW);
                    if (charsLengthThatFit - removeFromStart < 1) {
                      removeFromStart = charsLengthThatFit - 1;
                    }
                    showAtEnd = 1;
                  }

                  displayFilename =
                      filename.substr(0, charsLengthThatFit - removeFromStart) +
                      '...' +
                      filename.substr(
                          filename.length - showAtEnd, filename.length);
                }

                lengthCalcEl.classList.add('hidden');
              }

              return displayFilename;
            };


            /**
             * Resets variables for the selector
             * @param scope
             */
            var resetFileSelector = function(scope) {
              scope.ngModel = undefined;
            };

            /**
             * Construct a new file input
             * @param scope
             * @returns {*}
             */
            var getFileInput = function(scope) {
              var accept = (scope.accept && scope.accept.length > 1) ?
                  ' accept="' + scope.accept + '"' :
                  '',
                  fileInput = angular.element(
                      '<input type="file" name="fileselect[]"' +
                      ' class="sr-only" tabindex="-1"' + accept +
                      (!!scope.multiple ? ' multiple' : '') +
                      ' bento-test="input-file"' +
                      ' />');

              return fileInput;
            };

            // private functions
            /**
             * Determine if the two files are identical
             * @param f1
             * @param f2
             * @returns {boolean}
             */
            function fileEqual(f1, f2) {
              return f1.lastModified === f2.lastModified &&
                  f1.name === f2.name && f1.size === f2.size;
            }

            /**
             * Determine if a file exist in a file array
             * @param fileArray
             * @param file
             * @returns {boolean}
             */
            function hasFileAtIndex(fileArray, file) {
              for (var i = 0, len = fileArray.length; i < len; i++) {
                if (fileEqual(fileArray[i], file)) {
                  return i;
                }
              }
              return -1;
            }

            return {
              resetFileSelector: resetFileSelector,
              isValidFileType: isValidFileType,
              parseFiles: parseFiles,
              getFileInput: getFileInput,
              truncateFilename: truncateFilename,
              isFileAccepted: isFileAccepted
            };
          }
        ])
    .controller('fileSelectorController', [
      '$scope', '$element', '$timeout', '$compile', '$bentoServices',
      '$fileSelectorServices', '$log',
      function(
          $scope, $element, $timeout, $compile, $bentoServices,
          $fileSelectorServices, $log) {
        // to debounce resize event
        var resizeTimer;

        // files types accepted
        // var accepted = ($scope.accept && $scope.accept.length) ?
        // $scope.accept.replace(/ /g,'').toLowerCase().split(',') : undefined;
        var accepted = parseAcceptFileList($scope.accept);

        // Initialize fileInput
        var fileInput = $fileSelectorServices.getFileInput($scope);
        // post removal message SR element
        var postRemovalMessage = $element[0].querySelector(
            '.bento-file-selector-post-removal-message');
        // File input field file change callback
        fileInput.on('change', onFileInputChange);
        $element.append(fileInput);

        if (typeof $scope.disableFilesDuringUpload === 'undefined') {
          $scope.disableFilesDuringUpload = true
        }

        // Need to compile when everything else is ready
        $timeout(function() {
          $compile(fileInput)($scope);
        });

        // Init variable
        $scope.disabledFiles = [];
        $scope.errorFiles = [];

        // Browse button click and trigger file input
        $scope.onBrowseClick = function($event) {
          if ($scope.ngDisabled()) {
            // This component is disabled therefore do nothing
            return;
          }

          // Use native dispatch for IEs
          if ($bentoServices.getIEVersion() !== -1) {
            // Using the native dispatcher on click for the file selector
            var clickEvent = document.createEvent('Event');
            clickEvent.initEvent('click', true, true);
            fileInput[0].dispatchEvent(clickEvent);
          } else {
            // Otherwise simple
            fileInput[0].click();
          }

          if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
          }
        };

        // Watch Selected files count when removing
        $scope.$watch('ngModel', function() {
          // Create a new  input field for the next file selection
          var newFileInput = $fileSelectorServices.getFileInput($scope);

          // Need to compile when everything else is ready
          $timeout(function() {
            $compile(fileInput)($scope);
          });

          newFileInput.on('change', onFileInputChange);

          // Replace the old fileInput with the new one
          fileInput.off('change', onFileInputChange);
          fileInput.replaceWith(newFileInput);
          fileInput = newFileInput;
        });

        // User clicks on the file name remove icon
        // Removes the file name pill and notify the
        // parent controller if there is a callback function `onFileRemove()`
        $scope.onRemoveClick = function($index) {
          var fileToBeRemoved = $scope.ngModel[$index];

          $scope.ngModel.splice($index, 1);
          $scope.fileRemoved = fileToBeRemoved.name;

          postRemovalMessage.focus();

          if (!!$scope.onFileRemove) {
            $scope.onFileRemove({file: fileToBeRemoved});
          }
        };

        // Add drag and drop event listeners
        $element[0].addEventListener('dragover', function(event) {
          if ($scope.ngDisabled()) {
            // prevent browsers to open the file
            event.stopPropagation();
            event.preventDefault();

            // Disabled do nothing
            return;
          }

          $element.addClass('dragged-over');

          // prevent browsers to open the file
          event.stopPropagation();
          event.preventDefault();
        });

        // When user drags the file away from the dropping area
        $element[0].addEventListener('dragleave', function(event) {
          if ($scope.ngDisabled()) {
            // prevent browsers to open the file
            event.stopPropagation();
            event.preventDefault();

            // Disabled do nothing
            return;
          }

          $element.removeClass('dragged-over');
        });

        // When user drops a files into the dropping area
        $element[0].addEventListener('drop', function(event) {
          if ($scope.ngDisabled()) {
            // prevent browsers to open the file
            event.stopPropagation();
            event.preventDefault();

            // Disabled do nothing
            return;
          }

          $element.removeClass('dragged-over');

          /**
           * IE 11
           * Drag and Drop for Folders behaves little different in IE. Every
           * drop method callback will be supplied with event . This event
           * argument is little different for IE when a folder is dropped.
           * Basically the file list (inside event) comes empty, where as in
           * Chrome or FF, the file list shows up with the folder name and a
           * default size of 4096.
           */
          if (event && event.dataTransfer && event.dataTransfer.files &&
              !event.dataTransfer.files.length) {
            var file = {type: 'unknown'};
            $scope.errorFiles = [];
            $fileSelectorServices.isFileAccepted(
                file, '', $element[0], $scope, function() {
                  $bentoServices.safeApply($scope);
                });
          } else {
            $fileSelectorServices.parseFiles(
                $scope, event.dataTransfer.files, $scope.onFileSelect,
                $scope.onDuplicateSelect, $scope.fileType, $element[0],
                accepted);
          }

          // prevent browsers to open the file
          event.stopPropagation();
          event.preventDefault();
        });

        window.addEventListener('resize', updateDisplayFilenameDuringResize);

        function updateDisplayFilenameDuringResize(event) {
          if (!$scope.ngModel) {
            return;
          }
          // simple debounce
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            var selectedFile;
            var updatedDisplayName;
            var applyChanges = false;
            for (var i = 0; i < $scope.ngModel.length; i++) {
              selectedFile = $scope.ngModel[i];
              updatedDisplayName = $fileSelectorServices.truncateFilename(
                  selectedFile, $element[0]);
              if (selectedFile.displayFilename !== updatedDisplayName) {
                selectedFile.displayFilename = updatedDisplayName;
                applyChanges = true;
              }
            }
            // apply only when display name is updated
            if (applyChanges) {
              $scope.$apply()
            }
          }, 250);
        }

        // Upload progress
        var uploadProgressTickPromise;
        $scope.uploadProgressPercentage = 0;
        $scope.$watchCollection('uploadProgress', function(progress) {
          uploadProgressTick();
        });

        function uploadProgressTick() {
          $timeout.cancel(uploadProgressTickPromise);
          uploadProgressTickPromise = $timeout(function() {
            var progress = $scope.uploadProgress;
            if (progress && progress.length > 0) {
              if (!Array.isArray(progress)) {
                $element.removeClass('bento-file-selector-in-progress');
                $log.error(
                    'Bento File Selector: incorrect "upload-progross" data structure.\nUse [{file:<type File>, position:<type Number - bytes uploaded>},...]')
              } else if (progress.length > 0) {
                var totalFileSize = 0, totalPosition = 0, fileObj, fileIndex;

                if (!$scope.appendOnSelection) {
                  $scope.disableBrowseButton = true;
                }

                // calculate the percentage and file disabled states
                for (var i in progress) {
                  fileObj = progress[i];
                  fileIndex = $scope.ngModel.indexOf(fileObj.file);

                  // No need to
                  if (fileIndex === -1) {
                    continue;
                  } else {
                    totalFileSize += fileObj.file.size;
                    totalPosition += fileObj.position;

                    if (fileObj.file.size > fileObj.position) {
                      $scope.disabledFiles[fileIndex] = true;
                    } else {
                      $scope.disabledFiles[fileIndex] = false;
                    }

                    $scope.fileProgresses[fileIndex] =
                        Math.floor(fileObj.position / fileObj.file.size * 100);
                  }
                }

                $scope.uploadProgressPercentage =
                    Math.floor(totalPosition / totalFileSize * 100);

                // update the progress bar view based on the current progress
                // percentage
                if (
                    $scope.uploadProgressPercentage >= 100 ||
                    totalFileSize === 0  // No more files
                ) {
                  $element.removeClass('bento-file-selector-in-progress');
                  $scope.disableBrowseButton = false;
                  // remove all progress references
                  $scope.uploadProgress = [];

                  // reset progress bar after hiding
                  $timeout(function() {
                    $scope.uploadProgressPercentage = 0;
                  }, 1000);
                } else if ($scope.uploadProgressPercentage >= 0) {
                  if (!$element.hasClass('bento-file-selector-in-progress')) {
                    $element.addClass('bento-file-selector-in-progress');
                  }
                  uploadProgressTick();
                }
              }
            } else {
              $element.removeClass('bento-file-selector-in-progress');
              $scope.disableBrowseButton = false;
              $scope.disabledFiles = [];
            }
          }, 500);  // $timeout
        }

        // Callback
        function onFileInputChange(event) {
          $fileSelectorServices.parseFiles(
              $scope, event.target.files, $scope.onFileSelect,
              $scope.onDuplicateSelect, $scope.fileType, $element[0], accepted);

          $timeout(function() {
            // focus to the first file label
            if ($scope.showSelected) {
              var filenameLabel = $element[0].querySelector(
                  '.bento-file-selector-filename-label');
              if (filenameLabel) {
                filenameLabel.focus();
              }
            }
          }, 100);
        }

        function parseAcceptFileList(sAcceptTypes) {
          var consolidatedAcceptFileTypeList;
          var acceptedTypeLists = (sAcceptTypes && sAcceptTypes.length) ?
              sAcceptTypes.replace(/ /g, '').toLowerCase().split(',') :
              undefined;
          if (!acceptedTypeLists) {
            return undefined;
          }

          var acceptedType;
          for (var i = 0; i < acceptedTypeLists.length; i++) {
            acceptedType = acceptedTypeLists[i];
            // if the accept string is a MIME type, then prepare the list, else
            // convert string to array
            var mime = getMime(acceptedType);
            if (mime && mime.type) {
              var acceptedFileList;
              switch (mime && mime.type) {
                case 'audio':
                  acceptedFileList = mime.extension === '*' ?
                      [
                        '.aac', '.mid', '.midi', '.oga', '.wav', '.weba',
                        '.3gp', '.3g2'
                      ] :
                      [mime.extension];
                  break;

                case 'video':
                  acceptedFileList = mime.extension === '*' ?
                      ['.avi', '.mpeg', '.ogv', '.webm', '.3gp', '.3g2'] :
                      [mime.extension];
                  break;

                case 'image':
                  acceptedFileList = mime.extension === '*' ?
                      [
                        '.bmp', '.gif', '.ico', '.jpeg', '.jpg', '.png', '.svg',
                        '.tif', '.tiff', '.webp'
                      ] :
                      [mime.extension];
                  break;

                case 'text':
                  acceptedFileList = mime.extension === '*' ?
                      ['.css', '.csv', '.html', '.calendar', '.plain'] :
                      [mime.extension];
                  break;

                default:
                  break;
              }

              if (acceptedFileList) {
                !consolidatedAcceptFileTypeList &&
                    (consolidatedAcceptFileTypeList = []);
                for (var j = 0; j < acceptedFileList.length; j++) {
                  consolidatedAcceptFileTypeList.push(acceptedFileList[j]);
                }
              }
            } else {
              !consolidatedAcceptFileTypeList &&
                  (consolidatedAcceptFileTypeList = []);
              consolidatedAcceptFileTypeList.push(acceptedType);
            }
          }

          return consolidatedAcceptFileTypeList;
        }

        function getMime(sAccept) {
          var mime;
          if (sAccept && sAccept.length) {
            var index = sAccept.indexOf('/');
            if (index !== -1) {
              var extension = sAccept.slice(index + 1, sAccept.length);
              mime = {
                type: sAccept.slice(0, index),
                extension: extension === '*' ? extension : '.' + extension
              };
            }
          }

          return mime;

          // return (sAccept && sAccept.length && sAccept.indexOf('/') !== -1) ?
          // true : false;
        }

        $scope.$on('$destroy', function() {
          window.removeEventListener(
              'resize', updateDisplayFilenameDuringResize);
        });
      }
    ]);
})(window.angular, window);

(function (window, angular) {
  var timeout;
  /* Directive */
  angular.module('bento.megamenu', [])
    .directive('megamenu', [
      '$timeout',
      function ($timeout) {
        timeout = $timeout;
        return {
          restrict: 'AC',
          scope   : false,
          link    : megamenuLinkFunc
        }
      }]);

  /**
   * Megamenu Main link function
   * @param scope
   * @param element
   * @param attrs
   * @param controller
   */
  function megamenuLinkFunc(scope, element, attrs, controller) {

    var isMemberOfToolbar = false,
        toolbar,
        currentItem,
        submenu,
        toggleButton = element[0].parentElement.querySelector('[uib-dropdown-toggle]')
    ;

    // make sure this directive has the right class name for CSS to kick in
    element.addClass('megamenu');

    /**
     * Takeover Megamenu
     */
    // Check if this is an `takeover` element
    if (attrs.takeover && attrs.takeover.trim() === 'true') {
      /*
      Instead of restructure the current DOM element AKA "dropdown-menu",
      We will create a new element after this and move everything over.
      At the same time, $watch the original element and see if its content gets repopulated or not
       */
      // check if this megamenu is part of a toolbar
      var tmpEl        = element[0],
          takeoverMenu,
          isClicked;

      // Walk up the DOM tree to find out if this `takeover` is part of a navbar
      do {
        if (tmpEl.className.search('global-subnav') > -1) {
          // Bingo
          // This `takeover` is a Nav (Tool)Bar member
          isMemberOfToolbar = true;
          toolbar = tmpEl;
        }
        tmpEl = tmpEl.parentNode;
      } while (tmpEl.tagName !== 'BODY' && !isMemberOfToolbar);

      // Only a Nav (Tool)Bar member can become the actual `takeover` directive.
      // Otherwise, nothing is executed below.
      if (isMemberOfToolbar) {

        // Hide the origina megamenu
        element.removeClass('dropdown-menu');
        element.addClass('ng-hide');

        // Create and add the new menu
        takeoverMenu = angular.element('<ul class="dropdown-menu megamenu megamenu-takeover"></ul>')
        element.after(takeoverMenu);

        // Declare the entire menu item is a `megamenu-takeover-dropdown`
        angular.element(element[0].parentElement).addClass('megamenu-takeover-dropdown');

        // Check if this dropdown is expanded or not
        scope.$watch(function () {
          return toggleButton.getAttribute('aria-expanded') === 'true';
        }, function (isOpen) {
          // clean columns when closed
          if (!isOpen) {
            cleanColumns();
            isClicked = false;

            // Clean global var `submenu`
            if (submenu) {
              submenu.removeAttr('style');
            }

            // Remove active state to the current `submenu` item
            if (currentItem) {
              angular.element(currentItem).removeClass('active');
            }
          }
        });

        // Restructure the menu as a `takeover` element
        scope.$watch(function () {
          return element[0].textContent;
        }, function () {
          // Wait for all the variables bindings are rendered
          timeout(function () {
            restructureMenu(element, takeoverMenu);
          }, 0);
        });
      }

      /**
       * Cleans all the columns except for the submenu header column
       * 'megamenu-takeover-header'
       */
      function cleanColumns() {
        var columnsToRemove = takeoverMenu[0].querySelectorAll('.column.submenu');

        for (i = 0, len = columnsToRemove.length; i < len; i++) {
          column = columnsToRemove[i];
          column.parentNode.removeChild(column);
        }
      }

      /**
       * Event Handler when a submenu header is click or hovered
       * @param currentTarget
       * @param element
       */
      function onHeaderHover(currentTarget, element) {
        // clean the previous columns if there is any
        var columns = [],
            links   = currentTarget.links,
            i, len, column;

        // Clean before preceeding
        cleanColumns();

        // Clean `megamenu-takeover-header`
        submenu.removeAttr('style');

        // create new column(s)
        var currentColumn;
        for (i = 0, len = links.length; i < len; i++) {
          if (!currentColumn) {
            currentColumn = angular.element('<li class="column submenu"></li>');
            element.append(currentColumn);
            columns.push(currentColumn);
          }

          currentColumn.append(links[i]);

          // Make new column if content overflows
          if (currentColumn[0].offsetHeight > submenu[0].offsetHeight) {
            currentColumn = angular.element('<li class="column submenu"></li>');
            element.append(currentColumn);

            columns.push(currentColumn);
            currentColumn.append(links[i]);
          }

          // This column is overflowing to the next row.
          // It needs to be removed and to be rendered differently
          if (currentColumn[0].offsetTop > submenu[0].offsetTop) {
            columns.pop();
            currentColumn[0].parentElement.removeChild(currentColumn[0]);
            // New render
            renderOnlyIntoGivenColumns(columns, links);
            break;
          }
        }
      }

      /**
       * Re-render the submenu items into give columns
       * @param columns
       * @param links
       * @param submenu
       */
      function renderOnlyIntoGivenColumns(columns, links) {
        var columnItemCount = Math.ceil(links.length / columns.length);
        var currentColumnIndex = 0;

        // Start to put links into the current column that is indexed
        for (var i = 0, len = links.length; i < len; i++) {
          if (i >= columnItemCount * (currentColumnIndex + 1)) {
            currentColumnIndex++;
          }
          if (columns[currentColumnIndex]) {
            columns[currentColumnIndex].append(links[i]);
            // Need to redo the rearranging with less columns
            if (columns[currentColumnIndex][0].offsetTop > submenu[0].offsetTop) {
              columns.pop();
              renderOnlyIntoGivenColumns(columns, links);
              break;
            }
          }
        }

        if (columns[0]) {
          submenu.css('height', columns[0][0].offsetHeight + 'px');
        }
      }

      /**
       * Restructuring the current Menu
       * @param element
       */
      function restructureMenu(element, takeoverMenu) {
        var linkCollection = [], link;
        var liEls = element[0].querySelectorAll('li.column');
        var $liEl;
        var lastActive;

        // we do not restructure when there is nothing in the original dropdown-menu
        if (liEls.length === 0) {
          return;
        }

        // Reset takeoverMenu
        takeoverMenu[0].innerHTML = '';

        // Generate a new DOM structure for this `Takeover` megamenu
        submenu = angular.element('<li class="column"><ul></ul></li>');
        takeoverMenu.append(submenu);
        submenu.find('ul').append(liEls);

        // Remove all categorized links into memory/`links` variable
        for (var i = 0, len = liEls.length; i < len; i++) {
          var links = [];
          var children = liEls[i].children,
              child
          ;

          for(var c=0, lenC = children.length; c < lenC; c++){
            child = children[c];
            if(child.tagName === 'A'){
              links.push(child);
            }
          }

          linkCollection.push(links);

          // Create a reference for its submenu links
          liEls[i].links = links;

          // Remove all the links and to use later
          for (var j = 0, lenJ = links.length; j < lenJ; j++) {
            link = links[j];
            link.parentElement.removeChild(link);
          }

          // Add style to headers
          $liEl = angular.element(liEls[i]);
          $liEl.removeClass('column');
          $liEl.addClass('megamenu-takeover-header');


          if(links.length > 0) {
            // Only add navigation when there are children in this column
            $liEl.attr('tabindex', 0);
            $liEl.append('<i class="bento-icon-chevron-right"></i>');
          }
          // Support `hover` `click` and `touch` so that there is no delay
          $liEl.on('click mouseenter touchstart focus', function (e) {
            // Update global var
            currentItem = e.currentTarget;

            if(currentItem.links.length > 0){
              // Just execute this even listener once without
              // any additional clicking interference
              // Only when there is child in the link
              e.stopPropagation();
              e.preventDefault();
            }

            if (e.type === 'click') {
              isClicked = true;
              return;
            }

            if (e.type === 'mouseover' && isClicked) {
              // mouseover is no longer available after a mouse click
              return;
            }

            // Reset the previous `active` category menu header
            if (lastActive) {
              lastActive.removeClass('active');
            }

            lastActive = angular.element(e.currentTarget);
            lastActive.addClass('active');

            // Fire the actual code for submenu header hover event handler
            onHeaderHover(currentItem, takeoverMenu);
          });

        }
      }
    }
    /**
     * Normal Megamenu
     */
    else {
      // no need to proceed as megamenu leaves on CSS natively
      // Need to add resize code

      var windowResizeTimer, vw, toggleRect;

      window.addEventListener('resize', onWindowResize);

      function onWindowResize(e) {

        timeout.cancel(windowResizeTimer);
        timeout(timedResize, 100);
      }

      function timedResize() {
        vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vw < 600) {
          toggleRect = toggleButton.getBoundingClientRect();
          element.addClass('megamenu-mobile');
          element.css('width', vw + 'px');

          if (toggleRect.left < 20) {
            element.css('max-width', (vw - toggleRect.left - 20) + 'px');
            element.css('left', 0);
          } else {
            element.css('max-width', (vw - 40) + 'px');
            element.css('left', (20 - toggleRect.left) + 'px');
          }

        } else {
          element.removeClass('megamenu-mobile');
          element.attr('style', '');
        }
      }

      // Clear
      element.on('$destroy', function () {
        window.removeEventListener('resize', onWindowResize);
      });

      timedResize();
    }

  }
})(window, angular);
(function(angular, window) {
'use strict';
// GLOBAL CONSTANTS
var CHECKED_STAT = '__buimsoChecked';

angular
    .module('bento.multiselectoverlay', ['bento.services', 'bento.translate'])
    .directive(
        'bentoMultiselectOverlay',
        [
          '$timeout',
          function($timeout) {
            return {
              require: ['ngModel', '?bentoAppendToParent'],
              scope: {
                ngModel: '=',   // in Array
                listData: '&',  // List data array in `{name:string,
                                // data:object}` format
                side: '@',  // Side where the overlay shows ['left : 'right']
                sort: '=',  // (boolean) turn on / off sorting
                sortReverse: '=',     // (boolean) sort in reverse order or not
                doneButtonText: '@',  // Text for Done button
                selectAllText: '@',   // Text for Select All checkbox
                showAllText: '@',     // Text for Show All tab
                showSelectedText: '@',  // Text for Show Selected tab
                selectButtonText: '@',  // Text for select
                editButtonText: '@',    // Text for Edit
                selectedInfoText:
                    '@',  // Text for Info text next to the Edit button
                allSelectedInfoText: '@',  // Text Pattern for Info text when
                                           // all items are selected
                revertSelectionsOnDismissal:
                    '=',  // Flag to revert to the previous selections when
                          // clicked outside of the component
                hideSelectedInfo: '&',     // Flag to hide selected info text,
                bentoAppendToParent: '@',  // CSS selector to set scrollable
                                           // parent, pass to side overlay
                isOpen: '=?',  // To dynamically change its open/close state
                tooltip: '@'   // Show tooltip when enabled
              },
              templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ?
                    attrs.templateUrl :
                    '../templates/multiselect_overlay/bento-multiselect-overlay.html';
              },
              link: function(scope, element, attrs, controllers) {
                var lastArray = Array.isArray(scope.ngModel) ?
                    scope.ngModel.slice() :
                    [],
                    mainLabel = element[0].querySelector(
                        '.bento-multiselect-overlay-label'),
                    sideOverlayEl =
                        element[0].querySelector('.bento-side-overlay'),
                    cancelNgModelWatch, ngModelController = controllers[0];

                // initialize ngModel properties
                ngModelController.$setPristine();
                ngModelController.$setUntouched();

                // Override the isEmpty definition
                ngModelController.$isEmpty = function(val) {
                  if (scope.ngModel && scope.ngModel.length === 0) {
                    return true;
                  } else if (!scope.ngModel) {
                    return true;
                  }
                  return false;
                };

                // Initiate internal variables
                scope.selectedItemCount = 0;
                scope.selectedItems = [];
                scope.firstItemName =
                    (scope.selectedItemCount > 0) ? scope.ngModel[0].name : '';

                scope.onDoneClick = function(isDismissal) {
                  var revertAndDismissal =
                      scope.revertSelectionsOnDismissal && isDismissal;

                  if (revertAndDismissal) {
                    // revert selection in the list
                    scope.selectedItems = ngModelController.$modelValue.slice();
                    mainLabel.focus();
                  } else if (!arrayEqual(
                                 scope.selectedItems,
                                 ngModelController.$modelValue)) {
                    // update ngModel
                    scope.ngModel =
                        scope.selectedItems && scope.selectedItems.length ?
                        scope.selectedItems.slice() :
                        [];
                    ngModelController.$setViewValue(scope.ngModel);
                    ngModelController.$commitViewValue();

                    // Make this component dirty
                    ngModelController.$setDirty();
                  }

                  // Set the component to be touched
                  ngModelController.$setTouched();
                };

                attrs.$observe('disabled', function(bool) {
                  scope.isDisabled = bool;
                });

                scope.onListChange = function() {
                  ngModelController.$setTouched();
                };

                // Start watching `ngModel`
                watchNgModel();

                /**
                 * Initiate `ngModel` watch
                 */
                function watchNgModel() {
                  if (cancelNgModelWatch) {
                    cancelNgModelWatch();
                  }

                  cancelNgModelWatch =
                      scope.$watchCollection('ngModel', function(newModel) {
                        if (!arrayEqual(newModel, scope.selectedItems)) {
                          // after ngModel is updated internally
                          scope.selectedItems =
                              newModel ? newModel.slice() : [];
                        }

                        var length = newModel ? newModel.length : 0;
                        scope.selectedItemCount = length;
                        scope.firstItemName =
                            (length > 0) ? scope.ngModel[0].name : '';
                      });
                }
              }
            };
          }
        ])

    /**
     * Sub Directive
     * Bento Side Overlay and elements
     */
    .directive(
        'bentoSideOverlay',
        [
          '$timeout', '$parse', '$bentoServices',
          function($timeout, $parse, $bentoServices) {
            return {
              scope: false,
              restrict: 'A',
              link: function(scope, element, attrs, controller) {
                // properties and pointer to do the geo calculations
                var $body = angular.element(document.body), overlayMargin = 20,
                    side = attrs.side ? attrs.side.trim() : 'right',
                    $toggleButton = angular.element(
                        element[0].querySelector('.bento-side-overlay-toggle')),
                    $overlayContainer =
                        angular.element(element[0].querySelector(
                            '[bento-side-overlay-content]')),
                    $overlayContainerWrapper =
                        angular.element(element[0].querySelector(
                            '.bento-side-overlay-container-wrapper')),
                    $overlayFooter = angular.element(element[0].querySelector(
                        '.bento-side-overlay-container-footer')),
                    overlayHeight = 0,
                    $doneButton = angular.element(element[0].querySelector(
                        '.bento-side-overlay-container-footer-done')),
                    $cancelButton = angular.element(element[0].querySelector(
                        '.bento-side-overlay-container-footer-cancel')),
                    scrollableParent =
                        getScrollableParent(element[0].parentElement),
                    scrollableParentScrollTop, isDismissal = false;

                // Init directive CSS classes
                element.addClass('bento-side-overlay');
                element.addClass(
                    (side === 'right') ? 'bento-side-overlay-right' :
                                         'bento-side-overlay-left');

                // Toggle button listener
                $toggleButton.on('click', function(event) {
                  toggle();
                  preventEvent(event);
                });

                // Done button listener and function
                $doneButton.on('click touchend', function(event) {
                  isDismissal = false;
                  scope.isOpen = false;
                  preventEvent(event);
                  $bentoServices.safeApply(scope);
                });

                // Cancel Button listener and function
                $cancelButton.on('click touchend', function(event) {
                  isDismissal = true;
                  scope.isOpen = false;
                  preventEvent(event);
                  $bentoServices.safeApply(scope);
                });

                // Keyboar event listener for keyboard supports
                element[0].addEventListener('keydown', function(event) {
                  switch (event.keyCode) {
                    // 'ESC'
                    case 27:
                      if (element.hasClass('open')) {
                        isDismissal = true;
                        scope.isOpen = false;
                        preventEvent(event);
                        $bentoServices.safeApply(scope);
                      }
                      break;
                  }
                });

                var scrollPane;

                $timeout(function() {
                  // Get El reference of the scrollpane when ready
                  scrollPane = element[0].querySelector(
                      '.bento-multiselect-list-scroll-pane');
                }, 100);

                function toggle() {
                  scope.isOpen = !scope.isOpen;
                  $bentoServices.safeApply(scope);
                }

                function open() {
                  if (!element.hasClass('open')) {
                    element.addClass('open');

                    $timeout(function() {
                      // `click` should not be used since the items clicked in
                      // the overlay could disappear before the window recieves
                      // its event
                      window.addEventListener('mousedown', onWindowClick);

                      // Render after the overlay is not hidden on stage
                      renderOverlay();

                      // Focus on the overlay's input
                      $overlayContainer[0].querySelector('input').focus();
                    });

                    // disable the parent scroll from double scrolling
                    scrollableParentScrollTop = scrollableParent.scrollTop;
                    window.addEventListener('wheel', preventWheelScroll);
                    window.addEventListener('keydown', preventKeyScroll);
                  }
                }

                function close() {
                  if (element.hasClass('open')) {
                    isDismissal = false;
                    onDoneClick();
                  }
                }

                function preventWheelScroll(event) {
                  if (!scrollPane) {
                    scrollPane = element[0].querySelector(
                        '.bento-multiselect-list-scroll-pane');
                  }

                  var scrollTop = scrollPane.scrollTop, deltaY = event.deltaY;

                  if ((!scrollPane.contains(event.target) &&
                       event.target !== scrollPane) ||
                      (deltaY < 0 && scrollTop === 0) ||
                      (deltaY > 0 &&
                       (scrollTop + scrollPane.offsetHeight >=
                        scrollPane.scrollHeight))) {
                    event.stopPropagation();
                    event.preventDefault();
                  }

                  scrollableParent.scrollTop = scrollableParentScrollTop;
                }

                // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
                // left: 37, up: 38, right: 39, down: 40,
                var keysToPrevent =
                    {32: 0, 33: 1, 34: 1, 35: 1, 36: 1, 37: 1, 38: 1, 40: 1};

                function preventKeyScroll(event) {
                  if (keysToPrevent[event.keyCode]) {
                    event.preventDefault();
                    event.stopPropagation();
                  }
                }

                function preventEvent(e) {
                  e.stopPropagation();
                  e.preventDefault();
                }

                // jQuery event Listener
                function onDoneClick() {
                  element.removeClass('open');
                  $overlayContainerWrapper.removeClass('show-overlay');

                  // Remove fixed position classes
                  $overlayContainerWrapper.removeClass(
                      'bento-side-overlay-container-wrapper-fixed');
                  $overlayContainerWrapper.removeClass('open');


                  window.removeEventListener('wheel', preventWheelScroll);
                  window.removeEventListener('keydown', preventKeyScroll);

                  // remove window listener
                  window.removeEventListener('mousedown', onWindowClick);

                  // focus back to the toggle button
                  $toggleButton[0].focus();

                  if (!!attrs.onDone) {
                    var funcName = attrs.onDone.replace('()', '').trim();
                    // fire callback function
                    if (!!scope[funcName]) {
                      scope[funcName](isDismissal);
                      // notify NG digest
                      $bentoServices.safeApply(scope);
                    }
                  }

                  $toggleButton.after($overlayContainerWrapper);
                }

                // Window (aka Done) click listener function
                function onWindowClick(event) {
                  if (!element[0].contains(event.target) &&
                      !$overlayContainerWrapper[0].contains(event.target)) {
                    isDismissal = true;
                    scope.isOpen = false;
                    preventEvent(event);
                    $bentoServices.safeApply(scope);
                  }
                }

                // Watch and assign overlay height
                if (!!attrs.overlayHeight) {
                  scope.$watch(
                      function() {
                        return scope[attrs.overlayHeight.trim()];
                      },
                      function(newHeight) {
                        overlayHeight = newHeight;
                      });
                }

                scope.$watch('isOpen', function(v) {
                  if (v && !element.hasClass('open')) {
                    open();
                  } else if (!v) {
                    close();
                  }
                });

                // Watch and adjust footer height when switching `force-desktop`
                // class
                scope.$watch(
                    function() {
                      return $overlayFooter[0].offsetHeight;
                    },
                    function(newHeight) {
                      $overlayContainer.css('padding-bottom', newHeight + 'px');
                    });

                // Get the parent where there is scrolling or <body>
                function getScrollableParent(el) {
                  if (el === null) {
                    return;
                  }

                  if (attrs.bentoAppendToParent &&
                      attrs.bentoAppendToParent != '') {
                    var cssSelector = attrs.bentoAppendToParent;
                    var parentEl = el.closest(cssSelector);
                    if (parentEl) {
                      return parentEl;
                    }
                  }

                  var overflowY = window.getComputedStyle(el).getPropertyValue(
                      'overflow-y');
                  var overflow =
                      window.getComputedStyle(el).getPropertyValue('overflow');

                  if (overflowY === 'auto' || overflowY === 'scroll' ||
                      overflow === 'auto' || overflow === 'scroll') {
                    return el;
                  } else if (el.nodeName === 'BODY') {
                    return el;
                  } else {
                    return getScrollableParent(el.parentElement);
                  }
                }

                // Find out how far the toggle is away from it's scrolling
                // parent
                function getElementOffsetFrom(element, parentElement) {
                  var parentRect = parentElement.getBoundingClientRect();
                  var toggleRect = element.getBoundingClientRect();

                  // Return the relative RECT of the toggle button to the given
                  // parent
                  return {
                    left: toggleRect.left - parentRect.left,
                    right: parentRect.right - toggleRect.right,
                    top: toggleRect.top - parentRect.top,
                    bottom: parentRect.bottom - toggleRect.bottom,
                    width: toggleRect.width,
                    height: toggleRect.height
                  };
                }

                // Render and position overlay
                var getOverlayHeightWith = $parse(attrs.overlayHeight),
                    windowResizeTimeout = 0;

                /**
                 * Event Listener when the window is resizing
                 * @param e
                 */
                function onWindowResize(e) {
                  if (element.hasClass('open')) {
                    $timeout.cancel(windowResizeTimeout);
                    windowResizeTimeout = $timeout(renderOverlay, 100);
                  }
                }

                // Attach windows resize code
                window.addEventListener('resize', onWindowResize);
                // Make sure to remove the listener when this component is
                // destroyed
                scope.$on('$destroy', function() {
                  window.removeEventListener('resize', onWindowResize);
                  $overlayContainerWrapper.remove();
                });

                function renderOverlay() {
                  var parentElement = $overlayContainerWrapper, viewport = {
                    width: Math.max(
                        document.documentElement.clientWidth,
                        window.innerWidth || 0),
                    height: Math.max(
                        document.documentElement.clientHeight,
                        window.innerHeight || 0)
                  };

                  if (viewport.width < 601 || viewport.height < 421) {
                    parentElement.addClass(
                        'bento-side-overlay-container-wrapper-fixed open');
                    $body.append($overlayContainerWrapper);
                    $doneButton.addClass('btn-primary');
                    $doneButton.removeClass('btn-default');
                  } else {
                    parentElement.removeClass(
                        'bento-side-overlay-container-wrapper-fixed open');
                    $toggleButton.after($overlayContainerWrapper);
                    $doneButton.addClass('btn-default');
                    $doneButton.removeClass('btn-primary');

                    var maxOverlayHeight =
                            scrollableParent.offsetHeight - overlayMargin * 2,
                        overlayInnerHeight = !!attrs.overlayHeight ?
                        getOverlayHeightWith(scope) :
                        -1,
                        toggleOffset = getElementOffsetFrom(
                            $toggleButton[0], scrollableParent),
                        toggleOffsetTop = toggleOffset.top -
                        (document.documentElement.scrollTop ||
                         document.body.scrollTop),
                        toggleCenterOffsetTop = toggleOffsetTop +
                        $toggleButton[0].offsetHeight * 0.5,

                        // check toggle button location and realign if needed
                        // for better layout spacing
                        allowedTopSpacing = overlayMargin + 25, overlayHeight,
                        targetOverlayTop;

                    // adjust overlay height based on the scrollable container
                    // or body
                    if (overlayInnerHeight > 0) {
                      // overlayHeight is bigger than max-height
                      if (overlayInnerHeight >
                          maxOverlayHeight - $overlayFooter[0].offsetHeight) {
                        $overlayContainer.css(
                            'max-height', maxOverlayHeight + 'px');
                      } else {
                        $overlayContainer.css(
                            'max-height',
                            (overlayInnerHeight +
                             $overlayFooter[0].offsetHeight) +
                                'px');
                      }
                    } else {
                      $overlayContainer.css(
                          'max-height', maxOverlayHeight + 'px');
                    }

                    // Get the overlay height of max is updated
                    overlayHeight = $overlayContainer[0].offsetHeight;

                    // when the scrollable is <BODY>
                    if (scrollableParent.tagName === 'BODY') {
                      // We need to scroll up a little bit
                      if (toggleCenterOffsetTop < allowedTopSpacing) {
                        // IE
                        if (document.documentMode) {
                          document.documentElement.scrollTop =
                              toggleOffset.top - allowedTopSpacing;
                        }
                        // Other browsers
                        else {
                          scrollableParent.scrollTop =
                              toggleOffset.top - allowedTopSpacing;
                        }
                        toggleCenterOffsetTop = allowedTopSpacing +
                            $toggleButton[0].offsetHeight * 0.5;
                      } else
                          // We need to scroll down a little
                          if (toggleCenterOffsetTop >
                              scrollableParent.offsetHeight -
                                  allowedTopSpacing) {
                        // IE
                        if (document.documentMode) {
                          document.documentElement.scrollTop =
                              (toggleOffset.top +
                               $toggleButton[0].offsetHeight) -
                              scrollableParent.offsetHeight + allowedTopSpacing;
                        }
                        // Other Broswers
                        else {
                          scrollableParent.scrollTop =
                              (toggleOffset.top +
                               $toggleButton[0].offsetHeight) -
                              scrollableParent.offsetHeight + allowedTopSpacing;
                        }
                        toggleCenterOffsetTop = scrollableParent.offsetHeight -
                            allowedTopSpacing -
                            $toggleButton[0].offsetHeight * 0.5;
                      }

                      // Set default
                      targetOverlayTop = -overlayHeight * 0.5;

                      // Make sure the overlay is not overflowing the top
                      if (-targetOverlayTop >
                          toggleCenterOffsetTop - overlayMargin) {
                        targetOverlayTop =
                            -(toggleCenterOffsetTop - overlayMargin +
                              $toggleButton[0].offsetHeight * 0.25);
                      } else
                          // Make sure the overlay is not overflowing the bottom
                          if (overlayHeight + targetOverlayTop >
                              scrollableParent.offsetHeight -
                                  toggleCenterOffsetTop - overlayMargin) {
                        targetOverlayTop = scrollableParent.offsetHeight -
                            toggleCenterOffsetTop - overlayMargin -
                            overlayHeight -
                            $toggleButton[0].offsetHeight * 0.25;
                      }
                    }
                    // Scrollable is other
                    else {
                      // We need to scroll up a little bit
                      if (toggleOffset.bottom < allowedTopSpacing) {
                        scrollableParent.scrollTop +=
                            allowedTopSpacing - toggleOffset.bottom;
                      }
                      // We need to scroll down a little
                      else if (toggleOffset.top < allowedTopSpacing) {
                        scrollableParent.scrollTop -=
                            allowedTopSpacing - toggleOffset.top;
                      }

                      var overlayLocalRect = getElementOffsetFrom(
                          $overlayContainer[0], scrollableParent);

                      // set default
                      targetOverlayTop =
                          -$overlayContainer[0].offsetHeight * 0.5;

                      // Make sure the overlay is not overflowing the top
                      if (targetOverlayTop < overlayMargin) {
                        targetOverlayTop = $overlayContainer[0].offsetTop -
                            overlayLocalRect.top + overlayMargin;
                      } else
                          // Make sure the overlay is not overflowing the bottom
                          if (overlayLocalRect.bottom + targetOverlayTop <
                              overlayMargin) {
                        targetOverlayTop = $overlayContainer[0].offsetTop +
                            overlayLocalRect.bottom - overlayMargin;
                      }

                      if (targetOverlayTop >
                          -$doneButton[0].offsetHeight * 0.5 - overlayMargin) {
                        targetOverlayTop =
                            -$doneButton[0].offsetHeight * 0.5 - overlayMargin;
                      } else if (
                          targetOverlayTop + overlayLocalRect.height <
                          $doneButton[0].offsetHeight * 0.5 + overlayMargin) {
                        targetOverlayTop = -overlayLocalRect.height +
                            $doneButton[0].offsetHeight * 0.5 + overlayMargin;
                      }
                    }

                    $overlayContainer.css('top', targetOverlayTop + 'px');
                  }

                  // animate in
                  if (!$overlayContainerWrapper.hasClass('show-overlay')) {
                    $timeout(function() {
                      $overlayContainerWrapper.addClass('show-overlay');
                    });
                  }
                }

                function getOffsetFromParent(child, parent) {
                  if (!parent.contains(child) || parent === child) {
                    return {left: 0, top: 0};
                  } else {
                    var offset =
                        getOffsetFromParent(child.offsetParent, parent);
                    return {
                      left: child.offsetLeft + offset.left,
                          top: child.offsetTop + offset.top
                    }
                  }
                }
              }
            };
          }
        ])
    // THe actual toggle button
    .directive('bentoSideOverlayToggle', [function() {
                 return {
                   restrict: 'A',
                   scope: false,
                   link: function(scope, element, attrs) {
                     // only add class
                     element.addClass('bento-side-overlay-toggle noselect');
                   }
                 };
               }])
    // Redering to the actual toggle
    // Might need templateUrl later
    .directive(
        'bentoSideOverlayContent',
        [
          '$compile', '$timeout', '$bentoServices',
          function($compile, $timeout, $bentoServices) {
            return {
              restrict: 'A',
              scope: false,
              link: function(scope, element) {
                element.addClass('bento-side-overlay-container');
                element.wrap(
                    '<div class="bento-side-overlay-container-wrapper"></div>');

                // Add arrows
                var leftArrow = '<div class="bento-side-overlay-left-arrow">' +
                    '<svg height="35" width="20">' +
                    '<polygon points="21,0 0.5,17.5 21,35" class="bento-side-overlay-triangle" />' +
                    '</svg>' +
                    '</div>',
                    rightArrow =
                        '<div class="bento-side-overlay-right-arrow">' +
                    '<svg height="35" width="20">' +
                    '<polygon points="-1,0 19.5,17.5 -1,35" class="bento-side-overlay-triangle" />' +
                    '</svg>' +
                    '</div>';
                element.after(leftArrow);
                element.after(rightArrow);

                // Add footer
                var footer = angular.element(
                    '<div class="bento-side-overlay-container-footer">\
              <button class="btn btn-primary bento-side-overlay-container-footer-done" \
              aria-label="{{\'BENTO_UI_MULTISELECT_OVERLAY_DONE_DESCRIPTION\' | bentoTranslate}}"\
              type="button">' +
                    '{{ "BENTO_UI_MULTISELECT_OVERLAY_DONE" | bentoTranslate:doneButtonText }}</button>\
              <button class="btn btn-default bento-side-overlay-container-footer-cancel" \
              aria-label="{{\'BENTO_UI_MULTISELECT_OVERLAY_CANCEL_DESCRIPTION\' | bentoTranslate}}"\
              type="button">' +
                    '{{ "BENTO_UI_MULTISELECT_OVERLAY_CANCEL" | bentoTranslate }}</button>\
              </div>');

                $compile(footer)(scope);
                element.append(footer);
                // Loops tabs within
                $bentoServices.loopTabbables(element);
              }
            };
          }
        ])

    /**
     * Sub Directive
     * Bento MultiSelect List
     */

    /*
     * Show only the selected item base on the flag
     */
    .filter(
        'multiselectShowSelected',
        function() {
          return function(itemArray, flag, uid) {
            if (flag) {
              var arr = [];
              for (var i = 0; i < itemArray.length; i++) {
                var item = itemArray[i];

                if (getItemChecked(item, uid)) {
                  arr.push(item);
                }
              }
              return arr;
            }

            return itemArray;
          };
        })
    .directive('bentoMultiselectList', [
      '$timeout', '$bentoServices', '$filter',
      function($timeout, $bentoServices, $filter) {
        return {
          templateUrl: function(element, attrs) {
            return angular.isDefined(attrs.templateUrl) ?
                attrs.templateUrl :
                '../templates/multiselect_list/bento-multiselect-list.html';
          },
          scope: {
            listData: '&',
            onChange: '&',
            selectedItems: '=',
            side: '@',
            selectAllText: '@',
            showAllText: '@',
            showSelectedText: '@',
            sort: '=',         // (boolean) sort
            sortReverse: '=',  // (boolean) sort reverse
            maxAllowedHeight:
                '=?'  // Get the total height of the scrolling for external use
          },
          link: function(scope, element, attrs) {
            var firstLoad = true, input = element[0].querySelector('input');

            scope.filteredItems = [];
            scope.checkedUid = CHECKED_STAT + $bentoServices.generateUID();

            if (typeof scope.selectedItems === 'undefined') {
              scope.selectedItems = [];
            }
            scope.searchTerm = '';

            // showSelectedCallback
            scope.setShowSelected = function(bool) {
              // change focus
              element[0]
                  .querySelector('.bento-multiselect-search input')
                  .focus();
              scope.showSelected = bool;
            };

            // Helper
            function redefineAllChecked() {
              // Check whether to show the check to "Select All" checkbox
              if (hasAllChecked(scope.filteredItems, scope.checkedUid)) {
                scope.selectAll = true;
              } else {
                scope.selectAll = false;
              }
            }

            function refreshList() {
              // Dataset is not ready
              if (typeof scope.listData() === 'undefined') {
                return;
              }

              var value = scope.searchTerm;
              if (!value || typeof value.length === 'undefined' ||
                  value.length === 0) {
                scope.filteredItems = scope.sort ?
                    $filter('orderBy')(
                        scope.listData(), 'name', scope.sortReverse) :
                    scope.listData().slice();
              } else {
                scope.filteredItems = scope.sort ?
                    $filter('orderBy')(
                        searchArray(value, scope.listData(), 'name'), 'name',
                        scope.sortReverse) :
                    searchArray(value, scope.listData(), 'name');
              }

              redefineAllChecked();
            }

            scope.onSearchChange = function() {
              refreshList();
            };

            scope.$watchCollection(
                function() {
                  return scope.listData();
                },
                function(value) {
                  refreshList();
                });

            // Helper

            scope.$watchCollection(
                'selectedItems', function(newArray, oldArray) {
                  var i, len;

                  for (i = 0, len = oldArray.length;
                       Array.isArray(oldArray) && i < len; i++) {
                    setItemChecked(oldArray[i], false, scope.checkedUid);
                  }

                  if (newArray) {
                    for (i = 0, len = newArray.length; i < len; i++) {
                      setItemChecked(newArray[i], true, scope.checkedUid);
                    }
                  }

                  redefineAllChecked();

                  // Fire a callback
                  if (!firstLoad) {
                    scope.onChange();
                  } else {
                    firstLoad = false;
                  }
                });

            var searchBar =
                    element[0].querySelector('.bento-multiselect-search'),
                scrollPane = element[0].querySelector(
                    '.bento-multiselect-list-scroll-pane');

            element.addClass('bento-multiselect-list-wrapper');

            // Watch the top offset of `.bento-multiselect-list-scroll-pane`
            scope.$watch(
                function() {
                  return searchBar.offsetHeight;
                },
                function(newHeight) {
                  scrollPane.style.top = newHeight + 'px';

                  // Update maxAllowedHeight
                  scope.maxAllowedHeight =
                      searchBar.offsetHeight + scrollPane.scrollHeight;
                });

            /**
             * Triggers select and deselect all items
             */
            scope.onSelectAllClick = function(e) {
              if (e.screenX !== 0 || e.screenY !== 0) {
                // Focus back onto the input field when it's a mouse click
                input.focus();
                input.setSelectionRange(0, input.value.length);
              }

              scope.selectAll = !scope.selectAll;

              if (scope.selectAll) {
                scope.selectedItems = [];
                for (var i = 0; i < scope.filteredItems.length; i++) {
                  var item = scope.filteredItems[i];
                  scope.selectedItems.push(item);
                }
              } else {
                scope.selectedItems = [];
              }
            };

            /**
             * Update checked status when an item is clicked
             * @param item
             */
            scope.onItemClick = function(item, e) {
              if (e.screenX !== 0 || e.screenY !== 0) {
                // Focus back onto the input field when it's a mouse click
                input.focus();
                input.setSelectionRange(0, input.value.length);
              }

              var selectItemIndex = scope.selectedItems.indexOf(item);

              if (selectItemIndex === -1) {
                scope.selectedItems.push(item);
              } else {
                scope.selectedItems.splice(selectItemIndex, 1);
              }
            };

            /**
             * Like htmlentities in PHP, it change special characters such as
             * (>) into their encoded values (&lt;)
             */
            scope.htmlEntities = function(str) {
              return String(str)
                  .replace(/&/g, '&amp;')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')
                  .replace(/"/g, '&quot;');
            };

            // Get Max height
            $timeout(function() {
              scope.maxAllowedHeight =
                  searchBar.offsetHeight + scrollPane.scrollHeight;
            });
          }
        };
      }
    ]);

// helper classes
/**
 * See if the array has all items checked
 * @param  {Array}  a Array to check
 * @return {Boolean}
 */
function hasAllChecked(a, uid) {
  var len = a.length;

  // Empty array
  if (len === 0) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (!getItemChecked(a[i], uid)) {
      return false;
    }
  }
  return true;
}

/**
 * check if the two arrays have the same child in order
 **/
function arrayEqual(a1, a2) {
  if ((!a1 && !a2) || (a1 && a1.length === 0 && !a2) ||
      (!a1 && a2 && a2.length === 0) || (a1 === a2)) {
    // Both arrays are undefined or
    // one of the arrays is undefined and the other has length that is 0
    return true;
  }

  if ((a1 && a1.length > 0 && !a2) || (!a1 && a2 && a2.length > 0)) {
    // one of the arrays is undefined and the other has length > 0
    return false
  }

  if (a1.length != a2.length) {
    // Two arrays have difference lengths
    return false;
  }

  // Need to sort the two arrays
  var a1S = a1.slice().sort(function(a, b) {
    return a.name > b.name;
  }),
      a2S = a2.slice().sort(function(a, b) {
        return a.name > b.name;
      });

  for (var i = 0, len = a1S.length; i < len; i++) {
    // Do the
    if (a1S[i] != a2S[i]) {
      return false;
    }
  }
  return true;
}

/**
 * Search and return an array of found items
 * @param  {String} search - Search term
 * @param  {Array}  array  - Array to search from
 * @param  {String} label  - Label of the variable to search from each object
 * @return {Array}         - Found objects in an array
 */
function searchArray(search, array, label) {
  var found = [], item, searchLow = search.toLowerCase();

  // Linear search
  for (var i = 0, len = array.length; i < len; i++) {
    item = array[i];
    if (item[label].toLowerCase().indexOf(searchLow) > -1) {
      found.push(item);
    }
  }

  return found;
}

/**
 * Set a item checked/unchecked
 * @param {object}  obj  the item object
 * @param {boolean} flag
 */
function setItemChecked(obj, flag, checkedUid) {
  obj[checkedUid] = flag;
}

/**
 * Get an item check state
 * @param  {object}      obj Item object
 * @param  {uid}         uid Unique ID
 * @return {boolean}     checked/unchecked
 */
function getItemChecked(obj, checkedUid) {
  return obj[checkedUid];
}
})(window.angular, window);
(function (window, angular, undefined) {
  'use strict';

  //Define bentoUI App object
  angular.module('bento.numberinput', ['bento.services'])
    .factory('$bentoNumberInputHelper', [

      function () {

        function alignButtons($element) {
          var parentElement = $element[0].parentNode;
          parentElement.style.width = $element[0].offsetWidth + 'px';
          parentElement.style.height = $element[0].offsetHeight + 'px';
        }

        function updateModelWithStep(model, step, max, min, decimalSep) {
          var value  = Number(String(model).replace(decimalSep, '.')),
              maxNum = Number(max),
              minNum = Number(min);

          if (typeof model === 'undefined') {
            value = 0;
          }

          value = Math.round((Number(value) + step) * 1000000000000) / 1000000000000;

          if (typeof max !== 'undefined' && value > maxNum) {
            value = maxNum;
          } else if (typeof min !== 'undefined' && value < minNum) {
            value = minNum;
          }

          return String(value).replace('.', decimalSep);
        }

        return {
          alignButtons       : alignButtons,
          updateModelWithStep: updateModelWithStep
        };

      }
    ])
    .directive('bentoNumberInput', [
      '$bentoNumberInputHelper',
      '$bentoServices',
      '$locale',
      '$bentoTranslate',
      '$timeout',
      '$log',
      function ($bentoNumberInputHelper, $bentoServices, $locale, $bentoTranslate, $timeout, $log) {
        return {
          restrict  : 'A',
          require   : 'ngModel',
          replace   : false,
          transclude: true,
          link      : function ($scope, $element, $attrs, ngModelCtrl) {

            // Due to type="number" has limitations retrieving invalid input,
            // we need to change it back to "text"
            if ($attrs.type.toLowerCase() === 'number') {
              $log.warn('Bento.UI: `bento-number-input` must ' +
                'be implemented as `<... type="text" ... />` in order to work properly');
            }

            // Error notification
            if (typeof $attrs.min !== 'undefined'
              && typeof $attrs.max !== 'undefined'
              && Number($attrs.min) > Number($attrs.max)) {
              $log.error('Bento.UI: `bento-number-input` "max" value must be larger than "min" value');
            }

            // Locale Related
            var decimalSeparatorTranslateLabel = 'BENTO_NUMBER_INPUT_DECIMAL_SEPARATOR';
            var decimalSep = '.';  // default

            // Decide which decimal separator to use
            if ($attrs.decimalSeparator) {
              // Directive has its specified
              decimalSep = $attrs.decimalSeparator;
            } else {
              // Lookup Bento Translate dictionary first
              // NOTE: the translation needs to be pre-defined before this directive is loaded
              $bentoTranslate.translate(decimalSeparatorTranslateLabel)
                .then(bentoTranslateReady);
            }

            // Listen to Bento Translate Onchange when a new translation is ready
            $bentoTranslate.onChange(bentoTranslateOnChange);

            /**
             * Callback to bentoTranslate onchange
             */
            function bentoTranslateOnChange() {
              $bentoTranslate.translate(decimalSeparatorTranslateLabel)
                .then(bentoTranslateReady);
            }

            /**
             * Get the translated decimal separator and update the model
             * @param value
             */
            function bentoTranslateReady(value) {
              if (value !== decimalSeparatorTranslateLabel) {
                // Bento Translate defined
                decimalSep = value;
              } else {
                // Use Angular $locale service
                decimalSep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
              }

              // Update ngModelView with the new decimal separator if there is a predefined number
              if (!isNaN(ngModelCtrl.$modelValue)) {
                ngModelCtrl.$setViewValue(String(ngModelCtrl.$modelValue).replace('.', decimalSep));
                ngModelCtrl.$commitViewValue();
                ngModelCtrl.$render();
              }
            }

            var uid = $bentoServices.generateUID();
            var step = Number($attrs.step) || 1;
            var previousValue = '';
            var _upButton = angular.element('<div ' +
              'id="bento-number-input-button-up-' + uid + '" ' +
              'class="bento-number-input-button bento-number-input-button-up">' +
              '<i class="bento-icon-chevron-up"></i>' +
              '</div>'
            );
            var _downButton = angular.element('<div ' +
              'id="bento-number-input-button-down-' + uid + '" ' +
              'class="bento-number-input-button bento-number-input-button-down">' +
              '<i class="bento-icon-chevron-down"></i>' +
              '</div>'
            );

            // Adding parser to handle decimal separator on commit
            ngModelCtrl.$parsers.push(function (value) {
              return typeof value === 'undefined' || value.length === 0 ? undefined : Number(value.replace(decimalSep, '.'));
            });

            // Adding formatter to handle decimal separator on ng-model update
            ngModelCtrl.$formatters.push(function (value) {
              return typeof value === 'undefined' || value === null ? '' : String(value).replace('.', decimalSep);
            });

            // Add validator for min and max validation
            ngModelCtrl.$validators.min = function (modelValue) {
              if (typeof $attrs.min === 'undefined') {
                // There is no minimum
                return true;
              }else if(typeof modelValue === 'undefined' || modelValue === null){
                // The number isn't even ready. This validation cannot be done
                return true;
              }

              return modelValue >= Number($attrs.min);
            };

            ngModelCtrl.$validators.max = function (modelValue) {
              if (typeof $attrs.max === 'undefined') {
                // There is no maximum
                return true;
              }else if(typeof modelValue === 'undefined' || modelValue === null){
                // The number isn't even ready. This validation cannot be done
                return true;
              }

              return modelValue <= Number($attrs.max);
            };

            // Check max and min to block from additional input
            $element.on('input', function (event) {
              setModelValue(event.currentTarget.value);
            });

            /**
             * Prevent non number input related keypress
             */
            $element[0].addEventListener('keypress', function (event) {
              var char = String.fromCharCode(event.charCode);
              var modelVale = event.currentTarget.value;

              if ((isNaN(char)
                && event.charCode > 0
                && char !== '-'
                && char !== decimalSep
                && event.charCode !== 13)// Enter key on chrome
                || (char === '-' && modelVale.indexOf(char) > -1) //IE 9
                || (char === decimalSep && modelVale.indexOf(char) > -1) //IE 9
                || (char === '-' && event.currentTarget.selectionStart > 0)
              ) {
                event.preventDefault();
                event.stopPropagation();
              }
            });

            /**
             * Watch element height for responsiveness
             */
            $scope.$watch(function () {
              return $element[0].offsetTop;
            }, function (top) {
              _upButton.css('top', top + 'px');
              _downButton.css('top', top + 'px');
            });

            $element[0].addEventListener('paste', function () {
              isPasted = true;
            });

            $element[0].addEventListener('keydown', function (event) {
              var target = event.currentTarget,
                  val;

              // 38 up
              // 40 down
              if (event.keyCode === 38) {
                val = $bentoNumberInputHelper
                  .updateModelWithStep(ngModelCtrl.$viewValue, step, $attrs.max, $attrs.min, decimalSep);
                setModelValue(val);
              } else if (event.keyCode === 40) {
                val = $bentoNumberInputHelper
                  .updateModelWithStep(ngModelCtrl.$viewValue, -step, $attrs.max, $attrs.min, decimalSep);
                setModelValue(val);
              } else if (event.keyCode !== 37 && event.keyCode !== 39) {
                setModelValue(target.value);
              }
            });

            //Parse step into a number
            step = Number(step);

            var pointerDown              = 'mousedown touchstart',
                pointerUp                = 'mouseup touchend',
                defaultRepeatDelayAmount = 125,
                initRepeatDelay          = 1000,
                isPasted                 = false,
                repeatDelayAmount,
                delay,
                timeoutProcess,
                direction;

            /**
             * Repeater for Up/Down arrow keys or buttons
             * @param isInitDelay
             */
            function onUpDownTimer(isInitDelay) {
              inputButtonRepeat();

              if (isInitDelay) {
                repeatDelayAmount = defaultRepeatDelayAmount;
                delay = initRepeatDelay;
              } else {
                delay = (delay <= 20) ? 20 : repeatDelayAmount -= 2;
              }

              timeoutProcess = $timeout(onUpDownTimer, delay);
            }

            //On up arrow click
            _upButton.on(pointerDown, function (e) {
              // kill event for right click
              if (e.which === 3) {
                return false;
              }

              // Repeat direction
              direction = step;

              var cElement = $element.context || $element[0];
              if (cElement && !cElement.disabled) {
                onUpDownTimer(true);

                angular.element(window).one(pointerUp, function (e) {
                  $timeout.cancel(timeoutProcess);
                  e.preventDefault();
                  e.stopPropagation();
                });
              }

              e.preventDefault();
              e.stopPropagation();
            });

            //On down arrow click
            _downButton.on(pointerDown, function (e) {
              // kill event for right click
              if (e.which === 3) {
                return false;
              }

              // Repeat direction
              direction = -step;

              var cElement = $element.context || $element[0];
              if (cElement && !cElement.disabled) {
                onUpDownTimer(true);

                angular.element(window).one(pointerUp, function () {
                  $timeout.cancel(timeoutProcess);
                });
              }

              e.preventDefault();
              e.stopPropagation();
            });

            function inputButtonRepeat() {
              var val = $bentoNumberInputHelper
                .updateModelWithStep(ngModelCtrl.$modelValue, direction, $attrs.max, $attrs.min, decimalSep);
              setModelValue(val);
            }

            // Check how many digits that this input field will have
            var maxDigits = typeof $attrs.max !== 'undefined' ? $attrs.max.length : 6;
            var digitClass = ' six-digit';

            if (!!$attrs.min && $attrs.min.length > maxDigits) {
              maxDigits = $attrs.min.length;
            }

            if (maxDigits <= 3) {
              digitClass = ' two-digit';
            }

            // Determine if this directive follows bootstrap's `form-control` CSS
            $element.wrap('<span class="bento-number-input-wrapper' +
              ($element.hasClass('form-control') ? ' full-width' : '') +
              digitClass +
              '"></span>');

            // We still need form-control styling
            $element.addClass('form-control');
            $element.after(_downButton);
            $element.after(_upButton);

            // When the DOM element is removed from the page cancel
            // any possible pending triggers
            $scope.$on(
              "$destroy",
              function () {
                // Stop arrow press repeater
                $timeout.cancel(timeoutProcess);
                // Remove bentoTranslate callback
                $bentoTranslate.removeOnChange(bentoTranslateOnChange);
              }
            );

            /**
             * Validate the current string and correct its input
             * @param value
             * @returns {object}
             */
            function validateValue(value) {
              var hasMax      = typeof $attrs.max !== 'undefined',
                  hasMin      = typeof $attrs.min !== 'undefined',
                  vNum        = Number(value),
                  max         = Number(hasMax ? $attrs.max : Number.POSITIVE_INFINITY),
                  min         = Number(hasMin ? $attrs.min : Number.NEGATIVE_INFINITY),
                  maxDigits   = hasMax ? String($attrs.max).length : 20,
                  minDigits   = hasMin ? String($attrs.min).length : 21,
                  valueLength = value.length,
                  isRollback  = false,
                  newNum      = vNum;

              if (typeof value === 'undefined' || value === null
                || valueLength === 0) {
                newNum = '';
              } else if ((isNaN(vNum) && value !== '-')
                ||
                (vNum > max || vNum < min)
              ) {

                if(isNaN(vNum)){
                  newNum = vNum = 0;
                }

                if (isPasted) {
                  // we need to do concat the value
                  newNum = (vNum > max) ?
                    value.slice(0, maxDigits) :
                    value.slice(0, minDigits)
                } else if (
                  (vNum > max && ((valueLength >= maxDigits && max >= 0) || valueLength >= minDigits))
                  || (vNum < min && ((valueLength >= minDigits && min < 0) || valueLength >= maxDigits))
                  || (min < 0 && max < 0 && vNum >= 0)
                ) {
                  // Rollback when out of bound
                  newNum = previousValue;
                  isRollback = true;
                }
              } else if (value.indexOf('-') === 0 || value.indexOf('.') > -1) {

                if (min >= 0 && max >= 0 && value.indexOf('-') > -1) {
                  // Minus sign is used when max and min are all positive
                  newNum = previousValue;
                  isRollback = true;
                } else {
                  // OK to add both minus sign and default decimal separator
                  newNum = value.trim();
                }
              }

              return {
                number    : newNum,
                isRollback: isRollback
              };
            }

            /**
             * Set value to ngModel
             * @param value
             */
            function setModelValue(value) {
              // Normalize localization
              value = String(value).replace(decimalSep, '.').trim();  // Convert decimal separator back to period

              // No need to update the ngModel since there is no change in string
              if (value === previousValue) {
                return;
              }

              // Proceed with number validation
              var newVal = validateValue(value);
              var newValStr     = String(newVal.number).replace('.', decimalSep),
                  input         = $element[0],
                  caratPosStart = newVal.isRollback ? input.selectionStart - 1 : input.selectionStart,
                  caratPosEnd   = input.selectionEnd;

              previousValue = newVal.number;
              isPasted = false;



              ngModelCtrl.$setViewValue(newValStr, 'inputvalidate');
              ngModelCtrl.$commitViewValue();
              ngModelCtrl.$render();

              // make sure to bring the selection back after setting the value after rendering
              input.setSelectionRange(caratPosStart, caratPosEnd);
            }
          }
        };
      }
    ]);

})(window, window.angular);
(function (window, angular, undefined) {
  'use strict';

//Define bentoUI App object
  angular.module('bento.off.canvas.menu', [])
  /**
   * Bento Off Canvas Menu Main Controller
   */
    .controller('bentoOffCanvasMenuController', [
      '$scope',
      '$element',
      function ($scope, $element) {

      }
    ])
  /**
   * Bento Off Canvas Menu Main Directive
   */
    .directive('bentoOffCanvasMenu', [
      '$parse',
      '$bentoServices',
      '$timeout',
      function ($parse, $bentoServices, $timeout) {
        /**
         * Main Off Canvas Menu Directive
         */
        return {
          restrict  : 'AE',
          scope     : false,
          controller: 'bentoOffCanvasMenuController',
          link      : function (scope, element, attrs, controller) {
            // Getters
            var expandedLeftGetter, expandedRightGetter;
            var expandedLeftLocal, expandedRightLocal;
            element.addClass('bento-off-canvas-menu');

            if (!!attrs.type && attrs.type === 'push') {
              element.addClass('push-over');
            } else {
              element.addClass('default');
            }

            //Get menu object from DOM
            var $menu = angular.element(element[0].querySelector('.bento-off-canvas-menu-aside'));
            var $menuRight = angular.element(element[0].querySelector('.bento-off-canvas-menu-aside-right'));
            var $menuHeader, $menuHeaderRight;
            var $menuBackgroundRight;
            var $menuCloseButton, $menuRightCloseButton, $hambugerButton;

            //Get navbar object from DOM
            var $navbar = angular.element(element[0].querySelector('.bento-off-canvas-menu-topbar'));

            //Get content object from DOM
            var $content = angular.element(querySelector(element[0], '.bento-off-canvas-menu-content'));

            // Trnasition listeners
            $menu.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(event){
              if(!element.hasClass('expanded')){
                $menu.addClass('ng-hide');
                $hambugerButton[0].focus();
              }
            });

            $menuRight.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(event){
              if(!element.hasClass('expanded-right')){
                $menuRight.addClass('ng-hide');
                if (typeof $menuBackgroundRight !== 'undefined') {
                  $menuBackgroundRight.addClass('ng-hide');
                }
              }
            });

            // Left menu ESC key listener
            $menu.on('keyup', function(event){
              if(event.keyCode === 27){
                setLeftExpand(false);
              }
            });

            if ($navbar.length === 0) {
              $content.css('top', '0');
            } else {
              $hambugerButton = angular.element('<button class="bento-off-canvas-menu-button" role="button" aria-label="Open side menu"><i class="bento-icon-hamburger-menu"></i></button>')
              $navbar.prepend($hambugerButton);
              $hambugerButton.on('click', onMenuClick);
            }

            //Add hamburger icon to navbar

            //Add Overlay
            var $overlay = angular.element('<div class="bento-off-canvas-menu-content-overlay"></div>');
            //Adding click actions to menuButton and .bento-off-canvas-menu-content
            $overlay.on('click', onContentClick);

            //Inject a fake background to the menu so it fully extends to the bottom of the page
            // Construct Memu DOM

            // LEFT
            element.append($overlay);


            if ($menu.length > 0) {
              $menu.after('<div class="bento-off-canvas-menu-aside-bg"></div>');
              $menuCloseButton = angular.element('<button class="bento-off-canvas-menu-close-button" role="button" aria-label="Close Side Menu">&times;</button>');
              $menuHeader = angular.element('<div class="bento-off-canvas-menu-header"></div>');
              $menuHeader.append($menuCloseButton);
              $menuHeader.append(['<div class="bento-off-canvas-menu-header-title">', (!!attrs.menuTitle ? attrs.menuTitle : 'Menu'), '</div>'].join(''));
              $menu.prepend($menuHeader);
              $menu.on('click', function (event) {

                if ((event.target.nodeName === 'A' || event.target.nodeName === 'BUTTON' || isParentClickable(event.target))
                  && !event.target.parentNode.hasAttribute('disabled')
                  && !event.target.hasAttribute('bento-off-canvas-menu-aside')
                ) {
                  //auto collapse left aside menu
                  setLeftExpand(false);
                }
              });

              if (attrs.menuTitle) {
                attrs.$observe('menuTitle', function (newValue) {
                  $menuHeader[0].querySelector('.bento-off-canvas-menu-header-title').innerHTML = $sanitize(newValue);
                });
              }
            }

            //Helper function
            // Check if
            function isParentClickable(node){
              var n = node;
              while(n.className.search('bento-off-canvas-menu-aside') === -1 && typeof n !== 'undefined'){
                if(n.nodeName === 'A' || n.nodeName === 'BODY'){
                  return true;
                }
                n = n.parentNode;
              }
              return false;
            }

            // RIGHT
            if ($menuRight.length > 0) {
              $menuRightCloseButton = angular.element('<button class="bento-off-canvas-menu-close-button">&times;</button>');
              $menuHeaderRight = angular.element('<div class="bento-off-canvas-menu-header"></div>');
              $menuHeaderRight.append($menuRightCloseButton);
              $menuRight.prepend($menuHeaderRight);
              $menuRight.after('<div class="bento-off-canvas-menu-aside-bg-right"></div>');
              $menuBackgroundRight = angular.element($menuRight[0].nextElementSibling);
              $menuRightCloseButton.on('click', function (event) {
                setRightExpand(false);
              })
            }

            // Add watchers for expand and collapse
            if (attrs.isExpanded) {
              expandedLeftGetter = $parse(attrs.isExpanded);
            }
            scope.$watch(function () {
                return expandedLeftGetter ? expandedLeftGetter(scope) : expandedLeftLocal;
              },
              function (exp) {
                toggleLeftMenu(exp);
              });

            if (attrs.isExpandedRight) {
              expandedRightGetter = $parse(attrs.isExpandedRight);
            }
            scope.$watch(function () {
                return expandedRightGetter ? expandedRightGetter(scope) : expandedRightLocal;
              },
              function (exp) {
                toggleRightMenu(exp);
              });

            /**
             * Toggle Left Menu
             * @param expanded
             */
            function toggleLeftMenu(expanded) {
              if (expanded) {
                setRightExpand(false);
                $menu.removeClass('ng-hide');
                $timeout(function(){
                  // Animation only works when ng-hide is completely removed
                  element.addClass('expanded');
                  $timeout(function(){
                    $menu[0].focus();
                  },200);
                  element[0].scrollTop = 0;
                  if ($menu.length > 0) {
                    $menu[0].scrollTop = 0;
                  }
                });

              } else if(!element.hasClass('expanded')){
                $menu.addClass('ng-hide');
              } else{
                element.removeClass('expanded');
              }
            }

            /**
             * Toggle Right Menu
             * @param expanded
             */
            function toggleRightMenu(expanded) {

              if (expanded) {
                setLeftExpand(false);
                $menuRight.removeClass('ng-hide');
                $menuBackgroundRight.removeClass('ng-hide');
                $timeout(function(){
                  element.addClass('expanded-right');
                  $timeout(function(){
                    $menuRight[0].focus();
                  },200);
                });

                if ($menuRight.length > 0) {
                  $menuRight[0].scrollTop = 0;
                }
              } else if(!element.hasClass('expanded-right')){
                $menuRight.addClass('ng-hide');
                if (typeof $menuBackgroundRight !== 'undefined') {
                  $menuBackgroundRight.addClass('ng-hide');
                }
              } else {
                element.removeClass('expanded-right');
              }

            }

            //When the hamburger menu is clicked
            function onMenuClick() {
              setLeftExpand(!expandedLeftLocal);
            }

            //Fires when the content is clicked
            //Check and retract the Off Canvas Menu
            function onContentClick() {
              setLeftExpand(false);
              setRightExpand(false);
            }

            /**
             * Set left menu expand state
             * @param b (bool)
             */
            function setLeftExpand(b) {
              if (expandedLeftGetter) {
                expandedLeftGetter.assign(scope, b);
              }
              expandedLeftLocal = b;

              $bentoServices.safeApply(scope);
            }

            /**
             * Set right menu expand state
             * @param b
             */
            function setRightExpand(b) {
              if (expandedRightGetter) {
                expandedRightGetter.assign(scope, b);
              }
              expandedRightLocal = b;

              $bentoServices.safeApply(scope);
            }
          }
        };
      }])
  /**
   * Bento Off Canvas Menu Aside Directive
   */
    .directive('bentoOffCanvasMenuAside',['$bentoServices', function ($bentoServices) {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        template: '<div class="bento-off-canvas-menu-aside" ng-transclude tabindex="-1"></div>',
        transclude: true,
        replace: true,
        link   : function (scope, element, attrs) {
          $bentoServices.loopTabbables(element);
        }
      };
    }])
  /**
   * Bento Off Canvas Menu Aside Right Directive
   */
    .directive('bentoOffCanvasMenuAsideRight',['$bentoServices', function ($bentoServices) {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        template: '<div class="bento-off-canvas-menu-aside-right" ng-transclude tabindex="-1"></div>',
        transclude: true,
        replace: true,
        link   : function (scope, element, attrs) {
        }
      };
    }])
  /**
   * Bento Off Canvas Menu Top Navbar
   */
    .directive('bentoOffCanvasMenuTopbar', function () {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        link   : function (scope, element, attrs, controller) {
          element.addClass('bento-off-canvas-menu-topbar');
        }
      };
    })
  /**
   * Bento Off Canvas Menu Main Content
   */
    .directive('bentoOffCanvasMenuContent', function () {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        link   : function (scope, element, attrs, controller) {
          element.addClass('bento-off-canvas-menu-content');
        }
      };
    });

  // Helper functions
  function querySelector(element, queryString) {
    var obj = element.querySelector(queryString);

    // Return if obj is not null
    if (typeof obj !== 'undefined' && obj) {
      return obj;
    } else {
      obj = element.querySelector(queryString.replace('div[', 'div[data-'));
      return obj;
    }

  }
})(window, window.angular);
(function(angular, window) {
    'use strict';
    //Define bentoUI App object
    var bentoPaginageApp = angular.module('bento.pagination', ['bento.services', 'bento.select', 'bento.cookie', 'bento.translate']);
    //Directive
    bentoPaginageApp
        .controller('bentoPaginationController',bentoPaginationController)
        .directive('bentoPagination', bentoPagination);

    function bentoPaginationController(){
        return this;
    }
    bentoPagination.$inject = ['$parse', '$q', '$window', '$timeout'];

    function bentoPagination($parse, $q, $window, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                currentPage: '=page',
                totalItems: '=',
                itemsPerPage: '=?',
                infoText: '@', // String
                infoPageText: '@', // String
                goToText: '@', // String
                directionLinks: '&',
                boundaryLinks: '&',
                itemsArray: '=?',
                onChange: '&',
                onChangeSize: '&',
                eventTracking: '&',
                onSelectPage: '&'
            },
            templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/pagination/bento-pagination.html'
            },
            controller: 'bentoPaginationController',
            controllerAs: 'bentoPaginationCtrl',
            replace: true,
            link: function(scope, el, attrs, paginationCtrl) {
                // Link Math lib to template
                scope.Math = Math;


                var trackedEvent = {
                    eventName: 'default',
                    value: '-1'
                };
                var onChangeEvent = {
                    page: 1
                };
                var sizeChangeEvent = {
                    size: -1
                };

                paginationCtrl = scope.VM = {
                    currentPage: 1,
                    tgtPage: 1,
                    maxPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageHistory: 10,
                    itemsArray: [{
                        value: 10,
                        label: 10
                    }, {
                        value: 25,
                        label: 25
                    }, {
                        value: 50,
                        label: 50
                    }, {
                        value: 100,
                        label: 100
                    }],
                    goBtnVisible: true,
                    goIconVisible: false,
                    boundaryLinks: true,
                    directionLinks: true,
                    lastButtonSmallMargin: false
                };

                Object.keys(scope.VM).forEach(function(el, i) { //ignores interpolated attributes
                    attrs[el] = (typeof(attrs[el]) == 'undefined') ? scope.VM[el] : attrs[el];
                    // scope[el] = (typeof(scope[el]) == "undefined") ? scope.VM[el] : scope[el];
                });
                scope.VM.boundaryLinks = typeof attrs.boundaryLinks == 'string' ? JSON.parse(attrs.boundaryLinks.toLowerCase()) : true;
                scope.VM.itemsPerPageHistory = scope.itemsPerPage;
                scope.VM.maxPage = Math.ceil(scope.totalItems / scope.itemsPerPage);

                //set default itemsArray if needed
                scope.itemsArray = scope.itemsArray ? scope.itemsArray : scope.VM.itemsArray;

                var renderComponent = function() {
                    scope.VM.tgtPage = scope.currentPage;
                    scope.VM.maxPage = Math.ceil(scope.totalItems / scope.itemsPerPage);
                    scope.eventTracking(trackedEvent);
                    if (scope.currentPage != onChangeEvent.page) {
                        onChangeEvent.page = scope.currentPage;
                        scope.onChange(onChangeEvent);
                    }
                };
                scope.renderComponent = renderComponent; //used only to test this function.
                angular.element($window).on('resize', onWindowResize);
                scope.$watch(function() {
                    return el[0].offsetWidth;
                }, onElementResize);
                scope.$on('$destroy', onDestroy);

                scope.$watch('itemsPerPage', function(newValue, oldValue) {
                    // Yes, this happens on $watch()...
                    if (newValue === oldValue) {
                        return;
                    }
                    trackedEvent.eventName = "items per page changed";
                    trackedEvent.value = scope.itemsPerPage;
                    sizeChangeEvent.size = scope.itemsPerPage;
                    scope.onChangeSize(sizeChangeEvent);

                    // No change when the current page is 1
                    if (scope.currentPage === 1 || (angular.isDefined(attrs.pageOverride)&&attrs.pageOverride == "true")) {
                        renderComponent();
                    } else {
                        scope.currentPage = 1;
                    }
                });

                scope.$watch('currentPage', function(newVal,oldVal) {
                    if(newVal !== oldVal){
                         renderComponent();
                    }
                });

                scope.$watch('totalItems', function() {
                    trackedEvent.eventName = "total items changed";
                    trackedEvent.value = scope.totalItems;
                    renderComponent();
                });

                attrs.$observe('infoPageText', function(value) {
                    if (value) {
                        renderComponent();
                    }
                });
                attrs.$observe('infoText', function(value) {
                    if (value) {
                        renderComponent();
                    }
                });
                attrs.$observe('goToText', function(value) {
                    if (value) {
                        renderComponent();
                    }
                });


                scope.keySelectPage = function(ev, page) {
                    ev = (ev) ? ev : window.event;
                    if (ev.which === 13) {
                        scope.goToPage(page);
                    }
                };

                scope.goToPage = function(n) {
                    //if there are no items, disable pagination
                    if(scope.totalItems<=0){
                        return;
                    }
                    if (n === "max") {
                        scope.currentPage = scope.VM.maxPage;
                    } else {
                        scope.currentPage = (!isNaN(parseInt(n)) && n > 0 && n <= scope.VM.maxPage) ? parseInt(n) : scope.currentPage;
                    }
                    trackedEvent.eventName = "current page value modification";
                    trackedEvent.value = "input value => " + n + " value@ " + scope.currentPage;
                };

                function onWindowResize() {
                    $timeout(function(){
                        onElementResize(el[0].offsetWidth)
                    });
                }

                function onElementResize(width) {
                    if (!width) return;
                    if (width < 550) {
                        scope.VM.lastButtonSmallMargin = true;
                        if (width < 420) {
                            scope.VM.boundaryLinks = false;
                            if (width < 290) {
                                scope.VM.goBtnVisible = false;
                            } else {
                                scope.VM.goIconVisible = true;
                                scope.VM.goBtnVisible = true;
                            }
                        } else {
                            scope.VM.goIconVisible = false;
                            scope.VM.goBtnVisible = true;
                            checkBoundaryLinks();
                        }
                    } else {
                        scope.VM.goIconVisible = false;
                        scope.VM.goBtnVisible = true;
                        checkBoundaryLinks();
                        scope.VM.lastButtonSmallMargin = false;
                    }
                }

                function checkBoundaryLinks() {
                    scope.VM.boundaryLinks = typeof attrs.boundaryLinks == 'string' ? JSON.parse(attrs.boundaryLinks.toLowerCase()) : true;
                }

                function onDestroy() {
                    angular.element($window).off('resize', onWindowResize);
                }

            }
        };
    }
})(window.angular, window);
(function (window, angular, undefined) {
  'use strict';

  // Define bentoUI App object
  angular.module('bento.reset', ['bento.services'])

    /**
     * Main Bento Reset factory
     */
    .factory('$bentoResetFactory', [
      '$bentoServices',
      function ($bentoServices) {
        var isRTL = $bentoServices.isRTL();
        var browser = $bentoServices.getBrowser();

        /**
         * Align the clear button to the input field
         * @param inputElement
         * @param clearButton
         */
        var alignClearButton = function (inputElement, clearButton) {

          var position = 'left';
          var inputEl = inputElement[0];
          var clearButtonEl = clearButton[0];
          var scrollableParentEl = findScrollableParent(inputEl.parentElement);
          var offsetParent = inputEl.offsetParent;
          var offsetLeft;

          if (offsetParent && offsetParent.contains(scrollableParentEl)) {
            offsetLeft = browser === 'firefox'? inputEl.offsetLeft : inputEl.offsetLeft - scrollableParentEl.scrollLeft;
          } else {
            offsetLeft = inputEl.offsetLeft;
          }

          if (isRTL) {
            position = 'right';
          }

          // set left
          clearButton.css(position,
            (inputEl.offsetWidth - clearButtonEl.offsetWidth + offsetLeft) + 'px'
          );

          // set top
          clearButton.css('top',
            (inputEl.offsetTop + (inputEl.offsetHeight - clearButtonEl.offsetHeight) * 0.5) + 'px'
          );

        };

        /**
         * Show and hide clear button and adjust input fields right padding
         * @param inputElement
         * @param clearButton
         * @param value
         */
        var showAndHideButton = function (inputElement, clearButton, value) {
          // Hide clearButton where is the input field is empty
          // or it is not focused
          if (typeof value === 'undefined' || value === null || value.length === 0) {
            clearButton.addClass('hide');
            inputElement.removeClass('bento-reset-dirty');
            window.removeEventListener('resize', windowResizeEventHandler);
          } else if (clearButton.hasClass('hide')) {
            clearButton.removeClass('hide');
            inputElement.addClass('bento-reset-dirty');
            // Realign clear button is there is any change
            alignClearButton(inputElement, clearButton);
            window.addEventListener('resize', windowResizeEventHandler);
          } else{
            // Realign clear button is there is any change while typing
            // ex. browser input scroll... 
            alignClearButton(inputElement, clearButton);
          }

          // Private event handler
          // Check clear button location when window is resizing
          function windowResizeEventHandler(event) {
            alignClearButton(inputElement, clearButton);
          }
        };
        /**
         * Find the the parent that scrolls
         * @param {HTMLElement} el 
         */
        function findScrollableParent(el) {
          if(el == null){
            return document.body;
          }else if (el.nodeName === 'HTML') {
            return el;
          } else if (el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight) {
            return el;
          } else {
            return findScrollableParent(el.parentElement);
          }
        }

        // Return all services
        return {
          alignClearButton: alignClearButton,
          showAndHideButton: showAndHideButton
        };

      }
    ])
    /**
     * Directive: Bento Reset
     */
    .directive('bentoReset', [
      '$window', '$timeout', '$bentoResetFactory', '$parse', '$bentoServices',
      function ($window, $timeout, $bentoResetFactory, $parse, $bentoServices) {

        return {
          restrict: 'A',
          require: 'ngModel',
          replace: false,
          scope: false,
          link: function (scope, element, attrs, ngModelController) {
            var override = (attrs.closeButtonIconClass) ? attrs.closeButtonIconClass : 'bento-icon-close-x',
              clearButton = angular.element('<div class="bento-reset-close-button hide '+
              override+
              '" tabindex="-1"></div>');

            var getter = $parse(attrs.ngModel);

            // Add class
            element.addClass('bento-reset');

            scope.$watch(function () {
              return getter(scope);
            }, function (newVal) {
              if (document.activeElement === element[0]) {
                // Only change status when input is in focus
                $bentoResetFactory.showAndHideButton(element, clearButton, newVal);
              }
            }, true);

            if (typeof attrs.bentoResetAlwaysOn === 'undefined') {

              // Listen to input field `change` and `focus` and show / hide clear button
              element.on('focus', function () {
                $bentoResetFactory.showAndHideButton(element, clearButton, getter(scope));
              });

              // Listen to input field blur
              // update: `event.relatedTarget` is not available on `blur` use `focusout` instead with IE9
              element.on('focusout', function (event) {
                if (event.relatedTarget !== clearButton[0]) {
                  // We need to use timeout to make sure clearBottom is clicked
                  // even `event.relatedTarget` is NULL <-- FF security
                  $timeout(function () {
                    clearButton.addClass('hide');
                  }, 10);
                }
              });
            }

            window.addEventListener('scroll',onWindowScroll, true);

            function onWindowScroll(e){
              if(document.activeElement === element[0]){
                $bentoResetFactory.alignClearButton(element, clearButton);
              }
            }

            // On clear button click
            // Clear input field
            clearButton.on('mousedown touchstart', function (event) {
              ngModelController.$setViewValue('', 'reset');
              ngModelController.$render();
              clearButton.addClass('hide');
              $bentoServices.safeApply(scope);

              // bring the focus back to the input field after one digest cycle
              $timeout(function () {
                element[0].focus();
              });

            });

            scope.$on('$destroy', function(){
              window.removeEventListener('scroll',onWindowScroll, true);
            })

            // Initialize the location of the clear button
            $timeout(function () {
              $bentoResetFactory.alignClearButton(element, clearButton);
            });

            // Add clearButton after the input field
            element.after(clearButton);
          }
        };
      }
    ]);
})(window, window.angular);
(function (window, angular, undefined) {
  'use strict';

  var TRANSITON_DURATION = 750;

  angular.module('bento.scrollablebar', [])
    .component('bentoScrollableBar', {
      bindings: {
        controller: '=?',
      },
      templateUrl: '../templates/scrollable-bar/bento-scrollable-bar.html',
      transclude: true,
      controller: [
        '$element',
        '$bentoTransition',
        '$timeout',
        BentoScrollbarController
      ]
    });

  function BentoScrollbarController($element, $bentoTransition, $timeout) {
    var ctrl = this;
    var stopTransition = function () {};

    ctrl.$onInit = function () {
      // Bind `this` to listeners
      ctrl.onInnerScroll = ctrl.onInnerScroll.bind(ctrl);
      ctrl.renderUI = ctrl.renderUI.bind(ctrl);
      ctrl.onMouseScroll = ctrl.onMouseScroll.bind(ctrl);

      ctrl._isLeftArrowDisabled = false;
      ctrl._isRightArrowDisabled = false;
      ctrl.el = $element[0];

      window.addEventListener('resize', ctrl.renderUI);
    };

    ctrl.$postLink = function () {
      ctrl.innerEl = ctrl.el.querySelector('.bento-scrollable-bar-inner');
      ctrl.innerEl.addEventListener('scroll', ctrl.onInnerScroll);
      ctrl.innerEl.addEventListener('wheel', ctrl.onMouseScroll);

      if (!ctrl.controller) {
        ctrl.controller = {};
      }

      ctrl.controller.refresh = ctrl.refresh;

      setTimeout(function () {
        ctrl.renderUI();
      });
    };

    ctrl.$onDestroy = function () {
      window.removeEventListener('resize', ctrl.renderUI);
    };

    /**
     * Scroll forward to the next half of screen
     */
    ctrl.scrollForward = function () {
      stopTransition();

      var maxScroll = ctrl.innerEl.scrollWidth - ctrl.innerEl.offsetWidth;
      var from = ctrl.innerEl.scrollLeft;
      var to = Math.min(ctrl.innerEl.scrollLeft + ctrl.innerEl.offsetWidth * .5, maxScroll);

      stopTransition = $bentoTransition.go(
        from,
        to,
        TRANSITON_DURATION,
        ctrl.onScrollTransitionTick.bind(this),
        null,
        $bentoTransition.ease.easeOutQuint
      );
    };

    /**
     * Scroll back to the previous screen
     */
    ctrl.scrollBack = function () {
      stopTransition();

      var from = ctrl.innerEl.scrollLeft;
      var to = Math.max(ctrl.innerEl.scrollLeft - ctrl.innerEl.offsetWidth * .5, 0);

      stopTransition = $bentoTransition.go(
        from,
        to,
        TRANSITON_DURATION,
        ctrl.onScrollTransitionTick.bind(this),
        null,
        $bentoTransition.ease.easeOutQuint
      );
    };

    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    ctrl.refresh = function () {
      ctrl.innerEl.scrollLeft = 0;
      ctrl.renderUI();
    };

    /**
     * Scroll content on mouse vertical scroll
     */
    ctrl.onMouseScroll = function (e) {
      var delta;

      if (e.deltaX === 0) {
        delta = e.deltaY;
      }else{
        delta = e.deltaX;
      }

      ctrl.innerEl.scrollLeft += delta;
      e.stopPropagation();
      e.preventDefault();
    };

    /**
     * Display scroll
     * @param val the value from the current transtion tick
     */
    ctrl.onScrollTransitionTick = function (val) {
      ctrl.innerEl.scrollLeft = val;
    };



    /**
     * Callback when the inner container is scrolled
     * We will need to check the arrow states
     * @param e
     */
    ctrl.onInnerScroll = function (e) {
      $timeout(function(){
        // Need the detection to be aligned with template with appropriate $digest
        var scrollLeft = ctrl.innerEl.scrollLeft;
      
        if (scrollLeft === 0) {
          ctrl._isLeftArrowDisabled = true;
          ctrl._isRightArrowDisabled = false;
        } else if (scrollLeft + ctrl.innerEl.offsetWidth === ctrl.innerEl.scrollWidth) {
          ctrl._isLeftArrowDisabled = false;
          ctrl._isRightArrowDisabled = true;
        } else {
          ctrl._isLeftArrowDisabled = false;
          ctrl._isRightArrowDisabled = false;
        }
      });
    };

    /**
     * Render arrows and gradients based on the width of this bar
     */
    ctrl.renderUI = function () {

      if (ctrl.innerEl) {
        clearTimeout(ctrl.renderUITimeout);

        ctrl.renderUITimeout = setTimeout(function () {
            // Render only when DOM is ready
            ctrl.hasScroll = ctrl.innerEl.scrollWidth > ctrl.el.offsetWidth;

            if (ctrl.hasScroll) {
              $element.addClass('bento-scroll-bar-has-scroll');
              ctrl.onInnerScroll();
            }else{
              $element.removeClass('bento-scroll-bar-has-scroll');
            }
          },
          100 // window resize debounce
        );
      }
    };
  }
})(window, angular);
(function (window, angular, undefined) {
  'use strict';

  angular.module('bento.scrollabletoolbar', [])
    .component('bentoScrollableToolbarItem', {
      bindings: {
        item: '<', // Menu item
      },
      require: {
        scrollableToolbar: '^^bentoScrollableToolbar'
      },
      templateUrl: '../templates/scrollable-toolbar/bento-scrollable-toolbar-item.html',
      controller: [
        '$element',
        '$bentoKeyboard',
        '$timeout',
        BentoScrollToolbarItemController
      ]
    });

  function BentoScrollToolbarItemController($element, Keyboard, $timeout) {
    var ctrl = this;
    ctrl.placement = 'left';
    ctrl.el = $element[0];

    ctrl.$onInit = function(){
    };

    ctrl.$postLink = function () {
      ctrl.onToggleKeydown = ctrl.onToggleKeydown.bind(ctrl);
      ctrl.onDropdownKeydown = ctrl.onDropdownKeydown.bind(ctrl);
      ctrl.onToggleFocus = ctrl.onToggleFocus.bind(ctrl);
      ctrl.onWindowKeydown = ctrl.onWindowKeydown.bind(ctrl);
      ctrl.calculatePlacementSide = ctrl.calculatePlacementSide.bind(ctrl);

      $timeout(function(){
        ctrl.dropdownMenuEl = ctrl.el.querySelector('.dropdown-menu');
        ctrl.dropdownEl = ctrl.el.querySelector('.dropdown');
      
        if (ctrl.dropdownMenuEl) {
          // There is a dropdown
          // Need to wire tabs for better accessibility
          ctrl.parentEl = ctrl.el.parentElement;
          ctrl.toggleEl = ctrl.el.querySelector('button');
          ctrl
          ctrl.dropdownMenuEl = ctrl.el.querySelector('.dropdown-menu');
  
          ctrl.toggleEl.addEventListener('keydown', ctrl.onToggleKeydown);
          ctrl.dropdownMenuEl.addEventListener('keydown', ctrl.onDropdownKeydown);
          ctrl.toggleEl.addEventListener('focus',ctrl.onToggleFocus);
          window.addEventListener('keydown', ctrl.onWindowKeydown);
          ctrl.parentEl.addEventListener('scroll', ctrl.calculatePlacementSide);
          ctrl.calculatePlacementSide();
        }
      });
    };

    ctrl.$onDestroy = function () {
      if (ctrl.dropdownMenuEl) {
        if(ctrl.dropdownMenuEl.parentElement){
          // remove dropdown HTMLElement in case it is not in placed within this component
          ctrl.dropdownMenuEl.parentElement.removeChild(ctrl.dropdownMenuEl);
        }
        window.removeEventListener('keydown', ctrl.onWindowKeydown);
        ctrl.parentEl.removeEventListener('scroll', ctrl.calculatePlacementSide);
      }
    };

    ctrl.$doCheck = function() {
      ctrl.calculatePlacementSide();
    };

    /**
     * To be called to calculate the current placement
     */
    ctrl.calculatePlacementSide = function () {
      if(ctrl.parentEl){
        //ca
        clearTimeout(ctrl.timeoutID);
        ctrl.timeoutID = setTimeout(function () {
            var centerPoint = ctrl.el.offsetWidth * .5 + ctrl.el.offsetLeft;
            var viewLeft = centerPoint - ctrl.parentEl.scrollLeft;
            if (viewLeft > ctrl.parentEl.offsetWidth * .5) {
              ctrl.placement = 'right';
            } else {
              ctrl.placement = 'left';
            }
          }, 100 // debounce the calling of calculation
        );
      }
    };

    /**
     * When the toggle gains focus
     * @param e
     */
    ctrl.onToggleFocus = function (e) {
      if (ctrl.dropdownEl.classList.contains('open') && !ctrl.isInternalFocusChange && ctrl.shiftKey) {
        // Need to move the focus to the last dropdown item
        var menuButtons = ctrl.dropdownMenuEl.querySelectorAll('a');
        var lastButton = menuButtons[menuButtons.length - 1];
        lastButton.focus();
      }
      ctrl.isInternalFocusChange = false;
    };

    /**
     * Check if the current keydown has shiftkey
     * @param e
     */
    ctrl.onWindowKeydown = function (e) {
      ctrl.shiftKey = e.shiftKey;
    };


    /**
     * Listener for the toggle when a TAB is pressed
     */
    ctrl.onToggleKeydown = function (e) {
      if (e.keyCode === Keyboard.TAB && !e.shiftKey && ctrl.dropdownEl.classList.contains('open')) {
        var dropdownItem = ctrl.dropdownMenuEl.querySelector('a');
        dropdownItem.focus();
        e.preventDefault();
      }
    };

    /**
     * Listener for the ngbDropdown when TAB is pressed
     * @param e
     */
    ctrl.onDropdownKeydown = function (e) {
      var buttons = ctrl.dropdownMenuEl.querySelectorAll('a');
      var currentButton = e.target;
      if (buttons[0] === currentButton && e.shiftKey) {
        ctrl.isInternalFocusChange = true;
        ctrl.toggleEl.focus();
        e.preventDefault();
      } else if (currentButton === buttons[buttons.length - 1] && !e.shiftKey) {
        ctrl.isInternalFocusChange = true;
        ctrl.toggleEl.focus();
      }
    };
  }
})(window, angular);
(function (window, angular, undefined) {
  'use strict';

  angular.module('bento.scrollabletoolbar')
    .component('bentoScrollableToolbar', {
      bindings: {
        toolbarData: '<', // Menu item
        controller: '=?',
      },
      transclude: {
        navbarLeft: '?navbarLeft',
        navbarRight: '?navbarRight'
      },
      templateUrl: '../templates/scrollable-toolbar/bento-scrollable-toolbar.html',
      controller: [
        '$scope',
        '$element',
        '$bentoServices',
        BentoScrollToolbarController
      ]
    });

  function BentoScrollToolbarController($scope, $element, $bentoServices) {
    var ctrl = this;
    ctrl.appendToEl = $element[0];
    ctrl.scrollableBarController = {};
    ctrl.id = 'bento-scrollable-toolbar-' + $bentoServices.generateUID();

    $element[0].setAttribute('id', ctrl.id);

    $scope.$on('bentoToolbarRefresh', onRefresh);

    ctrl.$postLink = function () {
      ctrl.controller = ctrl.scrollableBarController;
    };

    function onRefresh(){
      if(ctrl.scrollableBarController){
        ctrl.scrollableBarController.refresh();
      }
    }
  }

})(window, angular);
(function (window, angular, undefined) {
  'use strict';

//Define bentoUI App object
  angular.module('bento.select', ['ui.bootstrap'])
    .directive('bentoSelect', function () {
      return {
        restrict  : 'A',
        scope     : false,
        link      : function(scope, element, attrs, controller){
          var select = element[0].querySelector('select');
          var tabindex = '0';
          element.addClass('bento-select');

          scope.$watch(function(){
            if(select){
              return select.getAttribute('readonly');
            }
          }, function(v){
            if(select){
              if(v){
                tabindex = select.getAttribute('tabindex') || 0;
                select.setAttribute('tabindex', '-1');
              }else{
                select.setAttribute('tabindex', tabindex);
              }
            }
          });


          // Add IE and Firefox version for better UI look and feel
          if (window.navigator.userAgent.search(/MSIE 9/gi) !== -1) {
            element.addClass('ie9');
          } else if (window.navigator.userAgent.search(/MSIE 10/gi) !== -1) {
            element.addClass('ie10');
          } else if (window.navigator.userAgent.search(/Firefox/gi) !== -1) {
            element.addClass('firefox');
            element.append('<div class="bento-select-border"></div>');
          }

          // Add button decoration
          element.append('<div class="btn"><span class="bento-icon-caret-down"></span></div>');
          element.append('<div class="bento-select-overlay"></div>');
        }
      };
    });

})(window, window.angular);





(function(window, angular, undefined) {

'use strict';

var directiveName = 'bentoSplitterGroup';
var bentSplitterGroupApp = angular.module(
    'bento.splittergroup', ['bento.services', 'bento.translate']);

var HANDLE_DEFAULT = '<svg version="1.1" ' +
    'class="bento-splitter-handle-default" ' +
    'id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
    'viewBox="0 0 13 73" enable-background="new 0 0 13 73" xml:space="preserve">' +
    '<g>' +
    '<g>' +
    '<path class="splitter-group-handle-border" d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 ' +
    'C0,61.9,0,58.6,5.4,57.3z"/>' +
    '<path class="splitter-group-handle-bg" d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 ' +
    'C0,58.9,0,56.9,4.8,55.8z"/>' +
    '</g>' +
    '<polygon class="splitter-group-handle-triangle" points="3,32.4 8.3,36.5 3,40.6 	"/>' +
    '</g>' +
    '</svg>';
var HANDLE_MOVE = '<svg class="bento-splitter-handle-move" ' +
    'version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
    'viewBox="0 0 13 73" enable-background="new 0 0 13 73" xml:space="preserve">' +
    '<g>' +
    '<g>' +
    '<rect y="15" class="splitter-group-handle-border" width="13" height="43"/>' +
    '<rect y="16" class="splitter-group-handle-bg" width="13" height="41"/>' +
    '</g>' +
    '<g>' +
    '<polygon class="splitter-group-handle-triangle" points="6,39.6 3,36.5 6,33.4"/>' +
    '<polygon class="splitter-group-handle-triangle" points="7.1,33.4 10.1,36.5 7.1,39.6"/>' +
    '</g>' +
    '</g>' +
    '</svg>';

var LEFT = 'left', RIGHT = 'right', TOP = 'top', BOTTOM = 'bottom',
    C_LEFT = 'Left', C_RIGHT = 'Right', C_TOP = 'Top', C_BOTTOM = 'Bottom',
    DIRECTIVE_NAME_SPACE = 'bento-splitter-group-';

// Convert side variable to "C_" prfixed side variable (eg. LEFT -> C_LEFT)
function C_(side) {
  return side.charAt(0).toUpperCase() + side.slice(1);
}

bentSplitterGroupApp
    /**
     * A notification factory to let the controllers in the left, middle and
     * right panels to communicate with each other
     *
     * This also helps with Left and Right panel collapses and expansions
     */
    .factory(
        'splitterGroupNotification',
        function() {
          var notificationStack = [];
          /**
           * Add a splitter group notification
           * @param nName - Notification name
           * @param func - Notification function
           * @param uid - (Optional) unique ID
           */
          var addNotification = function(nName, func, uid) {
            // Check if notification with `nName` exists or create a new `nName`
            // stack
            if (typeof notificationStack[nName] === 'undefined') {
              notificationStack[nName] = [];
            }

            // To partially prevent notification redundancy
            var stack = notificationStack[nName];
            var notificationObj;
            for (var i = 0, len = stack.length; i < len; i++) {
              notificationObj = stack[i];
              if (notificationObj.func === func &&
                  notificationObj.uid === uid) {
                console.warn(
                    '`splitterGroupNotification.addNotification()`:', nName,
                    ' notification has already been added width uid =', uid);
                // This notification already exists
                return;
              }
            }

            notificationStack[nName].push({func: func, uid: uid});
          };

          /**
           * Remove a splitter group notification
           * @param nName - Notification name
           * @param func - Notification function
           * @param uid - (Optional) unique ID
           */
          var removeNotification = function(nName, func, uid) {
            // If `nName` notification does not exist
            // Do nothing.
            if (typeof notificationStack[nName] === 'undefined') {
              return;
            }

            var nNameStack = notificationStack[nName];

            var index = 0;
            var notification;
            // Remove the matching notification
            while (index < nNameStack.length) {
              notification = nNameStack[index];
              if (notification.func === func && notification.uid === uid) {
                nNameStack.splice(index, 1);
              } else {
                index++;
              }
            }
          };

          /**
           * Notify through the notification center
           * @param nName - Notification name
           * @param uid - (Optional)
           * @param data - (Optional)
           */
          var notify = function(nName, uid, data) {
            // If `nName` notification does not exist
            // Do nothing.
            if (typeof notificationStack[nName] === 'undefined') {
              return;
            }

            var nNameStack = notificationStack[nName];

            for (var i = 0; i < nNameStack.length; i++) {
              var notification = nNameStack[i];
              if (typeof uid === 'undefined' || uid === null ||
                  notification.uid === uid) {
                notification.func(data);
              }
            }
          };

          // Regiter notification functions to factory
          return {
            addNotification: addNotification,
            removeNotification: removeNotification,
            notify: notify
          };
        })
    .factory(
        'splitterGroupMainHelper',
        [
          '$window', '$timeout',
          function($window, $timeout) {
            /**
             * parse side pane width from a string
             * @param element
             * @param width
             * @returns number
             */
            var parseWidth = function(element, width) {
              return parseLength(element, width, 'w');
            };

            /**
             * parse top/bottom pane height from a string
             * @param element
             * @param width
             * @returns number
             */
            var parseHeight = function(element, height) {
              return parseLength(element, height, 'h');
            };

            function parseLength(element, length, scaleDirection) {
              if (typeof length === 'number') {
                return length;
              } else if (typeof length === 'undefined') {
                return -1;
              }

              var lengthType = length.search('%') > -1 ? '%' : 'px';
              var lengthInt = parseInt(length);

              if (lengthType === '%') {
                if (scaleDirection === 'w') {
                  return element[0].offsetWidth * lengthInt / 100;
                } else {
                  return element[0].offsetHeight * lengthInt / 100;
                }
              }

              return lengthInt;
            }

            return {parseWidth: parseWidth, parseHeight: parseHeight};
          }
        ])
    /**
     * Main Controller to Splitter Group directive
     */
    .controller(
        'bentoSplitterGroupMainController',
        [
          '$scope', '$element', '$window', 'splitterGroupMainHelper',
          '$bentoServices', '$timeout',
          function(
              $scope, $element, $window, splitterGroupMainHelper,
              $bentoServices, $timeout) {
            var ctrl = this;

            ctrl.isRTL = $scope.isRTL = $bentoServices.isRTL();

            // Check if the browser is IE 9
            if ($bentoServices.getIEVersion() === 9) {
              $element.addClass('ie9');
            }

            $element.addClass('bento-splitter-group');

            // Add `no-collapse` class when this directive is not collapsable
            if (!!$scope.noCollapse()) {
              $element.addClass('no-collapse');
            }

            // Determine if user is clicking on the left handle or not

            /* Global Helper */
            ctrl.hasHandle = function(side) {
              return $scope['splitter' + side] &&
                  $scope['splitter' + side].length;
            };

            // Align left & right panes and handles based on the side
            ctrl.alignLeftRightPanes = function(C_SIDE, pos) {
              var SIDE = C_SIDE.toLowerCase(), openedSide = 'opened-' + SIDE,
                  posPx;

              alignSide(C_LEFT);
              alignSide(C_RIGHT);

              function alignSide(C_SIDE) {
                if (ctrl.hasHandle(C_SIDE)) {
                  posPx = $element.hasClass(openedSide) ?
                      ($scope['splitHandle' + C_SIDE][0].offsetWidth + pos) +
                          'px' :
                      $scope['splitHandle' + C_SIDE][0].offsetWidth + 'px';
                  $scope['splitHandle' + C_SIDE][0].style[SIDE] =
                      $scope['splitter' + C_SIDE][0].style[SIDE] = posPx;
                }
              }
            };

            ctrl.toggleSide = function(SIDE) {
              SIDE = !!SIDE ? SIDE : $scope.actionOn;
              var C_SIDE = C_(SIDE);

              // Bypass click when this directive is not collapsable
              if (!!$scope.noCollapse()) {
                return;
              }

              // Do the actual action to its open-close
              if ($element.hasClass('opened-' + SIDE)) {
                ctrl.closePanel(C_SIDE);
                $scope['is' + C_SIDE + 'Collapsed'] = true;
              } else {
                ctrl.openPanel(C_SIDE);
                $scope['is' + C_SIDE + 'Collapsed'] = false;
              }

              $bentoServices.safeApply($scope);
            };

            // Helper
            // get event target side
            function getEventSide(event) {
              return $scope.actionOn;
            }

            /**
             * Execute mouse click
             * @param event
             */
            ctrl.onHandleClick = function(event) {
              ctrl.toggleSide(getEventSide(event));
            };

            /**
             * Execute keyboard event
             * @param  {event} event
             */
            ctrl.onHandleKeyup = function(event) {
              // Enter or Space
              if (event.keyCode === 32 || event.keyCode === 13) {
                ctrl.toggleSide(getEventSide(event));
              }
            };

            // Helper functions used with the above logic for
            // `ctrl.onHandleClick`
            ctrl.openPanel = function(C_SIDE) {
              var SIDE = C_SIDE.toLowerCase();
              var length = SIDE +
                  ((C_SIDE === C_TOP || C_SIDE === C_BOTTOM) ? 'Height' :
                                                               'Width');

              $scope['splitter' + C_SIDE].css('display', 'block');

              $timeout(function() {
                $element.addClass('opened-' + SIDE);

                $scope['splitter' + C_SIDE].css(SIDE, '0');
                $scope.splitterMain.css(SIDE, $scope[length]);
                $scope['splitHandle' + C_SIDE].css(SIDE, $scope[length]);

                if (SIDE === TOP || SIDE === BOTTOM) {
                  ctrl.alignLeftRightPanes(
                      C_SIDE, parseInt($scope[length].replace('px', '')));
                }
              });
            };

            // Helper functions used with the above logic for
            // `ctrl.onHandleClick`
            ctrl.closePanel = function(C_SIDE) {
              var SIDE = C_SIDE.toLowerCase();
              var length = SIDE +
                  ((C_SIDE === C_TOP || C_SIDE === C_BOTTOM) ? 'Height' :
                                                               'Width');

              $element.removeClass('opened-' + SIDE);

              $scope['splitter' + C_SIDE].css(SIDE, '-' + $scope[length]);
              $scope.splitterMain.css(SIDE, '0');
              $scope['splitHandle' + C_SIDE].css(SIDE, '0');

              if (SIDE === TOP || SIDE === BOTTOM) {
                ctrl.alignLeftRightPanes(C_SIDE, 0);
              }

              $timeout(function() {
                $scope['splitter' + C_SIDE].css('display', 'none');
              }, 200)
            };

            // Initialize window resize elements
            $scope.leftMaxWidthPx = splitterGroupMainHelper.parseWidth(
                $element, $scope.leftMaxWidth);
            $scope.rightMaxWidthPx = splitterGroupMainHelper.parseWidth(
                $element, $scope.rightMaxWidth);
            $scope.topMaxHeightPx = splitterGroupMainHelper.parseHeight(
                $element, $scope.topMaxHeight);
            $scope.bottomMaxHeightPx = splitterGroupMainHelper.parseHeight(
                $element, $scope.bottomMaxHeight);

            var $w = angular.element($window);

            // Adding resize listener if there is a maxDraggable variable
            // assigned
            if ($scope.leftMaxWidthPx > -1 || $scope.rightMaxWidthPx > -1) {
              $w.on('resize', onWindowsResize);
              $element.on('$destroy', function() {
                $w.off('resize', onWindowsResize);
              });
            }

            /**
             * check the width of left and right panels to make sure they are
             * not oversized based on the max draggable settings
             * @param $event
             */
            function onWindowsResize($event) {
              $scope.leftMaxWidthPx = splitterGroupMainHelper.parseWidth(
                  $element, $scope.leftMaxWidth);
              $scope.rightMaxWidthPx = splitterGroupMainHelper.parseWidth(
                  $element, $scope.rightMaxWidth);
              $scope.topMaxHeightPx = splitterGroupMainHelper.parseHeight(
                  $element, $scope.topMaxHeight);
              $scope.bottomMaxHeightPx = splitterGroupMainHelper.parseHeight(
                  $element, $scope.bottomMaxHeight);

              // LEFT
              if ($scope.leftMaxWidthPx > -1 && ctrl.hasHandle(C_LEFT)) {
                if (parseInt($scope.leftWidth) > $scope.leftMaxWidthPx) {
                  $scope.leftWidth = $scope.leftMaxWidthPx + 'px';
                  $scope.splitterLeft[0].style.width = $scope.leftWidth;
                }

                if ($scope.splitHandleLeft[0].offsetLeft >
                    $scope.leftMaxWidthPx) {
                  $scope.splitterMain[0].style.left =
                      $scope.splitHandleLeft[0].style.left = $scope.leftWidth;
                }
              }

              // RIGHT
              if ($scope.rightMaxWidthPx > -1 && ctrl.hasHandle(C_RIGHT)) {
                if (parseInt($scope.rightWidth) > $scope.rightMaxWidthPx) {
                  $scope.rightWidth = $scope.rightMaxWidthPx + 'px';
                  $scope.splitterRight[0].style.width = $scope.rightWidth;
                }

                if ($element[0].offsetWidth -
                        $scope.splitHandleRight[0].offsetLeft -
                        $scope.splitHandleRight[0].offsetWidth >
                    $scope.leftMaxWidthPx) {
                  $scope.splitterMain[0].style.right =
                      $scope.splitHandleRight[0].style.right =
                          $scope.rightWidth;
                }
              }

              // TOP
              if ($scope.topMaxHeightPx > -1 && ctrl.hasHandle(C_TOP)) {
                if (parseInt($scope.topHeight) > $scope.topMaxHeightPx) {
                  $scope.topHeight = $scope.topMaxHeightPx + 'px';
                  $scope.splitterTop[0].style.height = $scope.topHeight;
                }

                if ($scope.splitHandleTop[0].offsetTop >
                    $scope.topMaxHeightPx) {
                  $scope.splitterMain[0].style.top =
                      $scope.splitHandleTop[0].style.top = $scope.topHeight;
                }

                ctrl.alignLeftRightPanes(
                    C_TOP, parseInt($scope.topHeight.replace('px', '')));
              }

              // BOTTOM
              if ($scope.bottomMaxHeightPx > -1 && ctrl.hasHandle(C_BOTTOM)) {
                if (parseInt($scope.bottomHeight) > $scope.bottomMaxHeightPx) {
                  $scope.bottomHeight = $scope.bottomMaxHeightPx + 'px';
                  $scope.splitterBottom[0].style.height = $scope.bottomHeight;
                }

                if ($element[0].offsetHeight -
                        $scope.splitHandleBottom[0].offsetTop -
                        $scope.splitHandleBottom[0].offsetHeight >
                    $scope.bottomMaxHeightPx) {
                  $scope.splitterMain[0].style.bottom =
                      $scope.splitHandleRight[0].style.bottom =
                          $scope.bottomHeight;
                }

                ctrl.alignLeftRightPanes(
                    C_BOTTOM, parseInt($scope.bottomHeight.replace('px', '')));
              }
            }

            // Initialize dragging variables
            var draggingClassTimeout;
            var isDragging = false;
            var lastMousePos;  // is used to track mose X movement
            var initialHandlePos;
            var elementSize;
            var handleSize;
            var screenDirection;

            /**
             * When the mouse is pressed down on the handle
             * @param event
             */
            $scope.onHandleDown = function(event) {
              var offsetProp;

              // Prevent the other event
              event.stopPropagation();
              event.preventDefault();

              if (event.currentTarget.className.search('handle-' + LEFT) > -1) {
                $scope.actionOn = LEFT;
                offsetProp = 'offsetWidth';
                screenDirection = 'screenX';
              } else if (
                  event.currentTarget.className.search('handle-' + RIGHT) >
                  -1) {
                $scope.actionOn = RIGHT;
                offsetProp = 'offsetWidth';
                screenDirection = 'screenX';
              } else if (
                  event.currentTarget.className.search('handle-' + TOP) > -1) {
                $scope.actionOn = TOP;
                offsetProp = 'offsetHeight';
                screenDirection = 'screenY';
              } else {
                $scope.actionOn = BOTTOM;
                offsetProp = 'offsetHeight';
                screenDirection = 'screenY';
              }

              var C_SIDE = C_($scope.actionOn);

              elementSize = $element[0][offsetProp];
              handleSize = $scope['splitHandle' + C_SIDE][0][offsetProp];

              // Show pane on drag
              $scope['splitter' + C_SIDE].css('display', 'block');

              // Calculate lastMousePosition
              lastMousePos = (event.touches && event.touches.length > 0) ?
                  event.touches[0][screenDirection] :
                  event[screenDirection];

              switch ($scope.actionOn) {
                case LEFT:
                  initialHandlePos = $scope.splitHandleLeft[0].offsetLeft;
                  break;
                case RIGHT:
                  initialHandlePos = $scope.splitHandleRight[0].offsetLeft +
                      $scope.splitHandleRight[0].offsetWidth;
                  break;
                case TOP:
                  initialHandlePos = $scope.splitHandleTop[0].offsetTop;
                  break;
                case BOTTOM:
                  initialHandlePos = $scope.splitHandleBottom[0].offsetTop +
                      $scope.splitHandleBottom[0].offsetHeight;
                  break;
              }

              $element.addClass('unselectable');

              // start to track mouse move
              // touch devices are disabled for now.
              if (!!$scope.resizable() &&
                  (event.type === 'mousedown' || event.type === 'touchstart')) {
                $w.on('touchmove mousemove', $scope.onHandleMove);

                // on Destroy just in case the splitter group is destroyed while
                // moving
                $element.on('$destroy', function() {
                  $w.off('touchmove mousemove', $scope.onHandleMove);
                });

                $element.addClass(DIRECTIVE_NAME_SPACE + 'handle-pointer-down');

                draggingClassTimeout = $timeout(function() {
                  $element.addClass('dragging-' + $scope.actionOn);
                }, 300);
              }
              // track mouse up
              $w.one('touchend mouseup', $scope.onHandleUp);
            };

            /**
             * When mouse is released within the window
             * @param event
             */
            $scope.onHandleUp = function(event) {
              // angular.element(event.target).on('click',ctrl.onHandleClick);
              event.preventDefault();
              event.stopPropagation();

              $timeout.cancel(draggingClassTimeout);
              var dragging = 'dragging-';
              $element.removeClass(dragging + TOP);
              $element.removeClass(dragging + BOTTOM);
              $element.removeClass(dragging + LEFT);
              $element.removeClass(dragging + RIGHT);
              $element.removeClass(
                  DIRECTIVE_NAME_SPACE + 'handle-pointer-down');

              $bentoServices.removeBrowserSelection();

              // If the user didn't drag mouse pointer and released it inside of
              // the splitter It would be treated as a click
              if (!isDragging && event.target.className &&
                  !$scope.noCollapse()) {
                ctrl.onHandleClick(event);
                // Dispatch click tracking event
                $scope.eventTracking({eventName: 'splitter_group_click'});
              }
              // Normalize width and heights
              else {
                // helper class
                var normalize = function(C_SIDE, offset) {
                  var SIDE = C_SIDE.toLowerCase(),
                      orientation = (C_SIDE === C_LEFT || C_SIDE === C_RIGHT) ?
                      'Width' :
                      'Height',
                      length = SIDE + orientation,
                      $splitter = $scope['splitter' + C_SIDE];

                  offset = (offset < 50) ? 0 : offset;
                  // update offset width or height
                  $scope[length] =
                      (offset < 50) ? $scope[length] : offset + 'px';

                  // Close
                  if (offset === 0) {
                    handleTargetPos = 0;
                    // Restore previous pane width/height
                    $splitter.css(orientation.toLowerCase(), $scope[length]);
                    ctrl.closePanel(C_SIDE);
                    $scope['is' + C_SIDE + 'Collapsed'] = true;
                  } else {
                    $element.addClass('opened-' + SIDE);
                    $scope['is' + C_SIDE + 'Collapsed'] = false;
                  }

                  $bentoServices.safeApply($scope);
                };

                // Normalize leftWidth
                switch ($scope.actionOn) {
                  case LEFT:
                    normalize(C_LEFT, $scope.splitHandleLeft[0].offsetLeft);
                    break;
                  case RIGHT:
                    normalize(
                        C_RIGHT,
                        elementSize - $scope.splitHandleRight[0].offsetLeft -
                            $scope.splitHandleRight[0].offsetWidth);
                    break;
                  case TOP:
                    normalize(C_TOP, $scope.splitHandleTop[0].offsetTop);
                    break;
                  case BOTTOM:
                    normalize(
                        C_BOTTOM,
                        elementSize - $scope.splitHandleBottom[0].offsetTop -
                            $scope.splitHandleBottom[0].offsetHeight);
                    break;
                }
                // Dispatch drag tracking event
                $scope.eventTracking({eventName: 'splitter_group_drag'});

                normalize = null;
              }

              $element.removeClass('unselectable');
              // stop move
              $w.off('touchmove mousemove', $scope.onHandleMove);

              // turn on down
              $scope['splitHandle' + C_($scope.actionOn)].one(
                  'touchstart mousedown', $scope.onHandleDown);

              // reset dragging flag
              isDragging = false;

              // Fire onResize Callback
              if (!!$scope.onResize) {
                $scope.onResize({side: $scope.actionOn});
              }
            };

            var handleTargetPos;
            var dPos;

            // Animate dragging using window.requestAnimationFrame for optimal
            // performance
            var animateDragging = function() {
              var C_SIDE = C_($scope.actionOn);
              var targetPosPx = handleTargetPos + 'px';
              var orientation;

              if (handleTargetPos > 0 && dPos !== 0) {
                orientation = (C_SIDE === C_LEFT || C_SIDE === C_RIGHT) ?
                    'width' :
                    'height';

                $scope.splitterMain[0].style[$scope.actionOn] =
                    $scope['splitHandle' + C_SIDE][0].style[$scope.actionOn] =
                        $scope['splitter' + C_SIDE][0].style[orientation] =
                            targetPosPx;

                if (orientation === 'height') {
                  ctrl.alignLeftRightPanes(C_SIDE, handleTargetPos);
                }

                // Fire onResize Callback
                if (!!$scope.onResize) {
                  $scope.onResize({side: $scope.actionOn});
                }
              }

              if (isDragging) {
                $bentoServices.rAF(animateDragging);
              }
            };

            /**
             * Track on window mousemove
             * @param event
             */
            $scope.onHandleMove = function(event) {
              var touchObject = (event.touches && event.touches.length > 0) ?
                  event.touches[0] :
                  event;
              var currentMousePos = touchObject[screenDirection];
              var SIDE = $scope.actionOn;
              var C_SIDE = C_(SIDE);
              var C_orientation =
                  (SIDE === LEFT || SIDE === RIGHT) ? 'Width' : 'Height';
              var maxLength = $scope[SIDE + 'Max' + C_orientation + 'Px'];

              // Prevent the screen from scrolling on touch devices
              event.preventDefault();
              event.stopPropagation();

              $bentoServices.removeBrowserSelection();

              if (lastMousePos !== currentMousePos) {
                // Calculate dPos for rendering
                dPos = currentMousePos - lastMousePos;
                handleTargetPos = (initialHandlePos + dPos);
                handleTargetPos = (SIDE === LEFT || SIDE === TOP) ?
                    handleTargetPos :
                    elementSize - handleTargetPos;
                handleTargetPos = (handleTargetPos < 0) ? 0 : handleTargetPos;
                handleTargetPos = (handleTargetPos > elementSize - handleSize) ?
                    elementSize - handleSize :
                    handleTargetPos;

                // Check draggable area so the oppsited handles don't overlap
                if (SIDE === LEFT && ctrl.hasHandle(C_RIGHT) &&
                    handleTargetPos >
                        $scope.splitHandleRight[0].offsetLeft - handleSize) {
                  handleTargetPos =
                      $scope.splitHandleRight[0].offsetLeft - handleSize;
                } else if (
                    SIDE === RIGHT && ctrl.hasHandle(C_LEFT) &&
                    handleTargetPos > elementSize -
                            $scope.splitHandleLeft[0].offsetLeft -
                            handleSize * 2) {
                  handleTargetPos = elementSize -
                      $scope.splitHandleLeft[0].offsetLeft - handleSize * 2;
                } else if (
                    SIDE === TOP && ctrl.hasHandle(C_BOTTOM) &&
                    handleTargetPos >
                        $scope.splitHandleBottom[0].offsetTop - handleSize) {
                  handleTargetPos =
                      $scope.splitHandleBottom[0].offsetTop - handleSize;
                } else if (
                    SIDE === BOTTOM && ctrl.hasHandle(C_TOP) &&
                    handleTargetPos > elementSize -
                            $scope.splitHandleTop[0].offsetTop -
                            handleSize * 2) {
                  handleTargetPos = elementSize -
                      $scope.splitHandleTop[0].offsetTop - handleSize * 2;
                }

                if (!isDragging) {
                  $bentoServices.rAF(animateDragging);
                }

                // Need to 'open' the splitter group when the handle is moved
                // out
                if (handleTargetPos > 0 &&
                    !$element.hasClass('opened-' + SIDE)) {
                  $element.addClass('opened-' + SIDE);
                  $scope['splitter' + C_SIDE][0].style[SIDE] = '0';
                }

                // Lock handleTargetPos if there is a dragging limit here
                if (maxLength > -1 && handleTargetPos > maxLength) {
                  handleTargetPos = maxLength;
                }

                // flag isDragging
                isDragging = true;
              }
            };
          }
        ])
    /**
     * Splitter Group directive declaration
     */
    .directive(
        directiveName,
        [
          '$timeout', '$log', 'splitterGroupNotification',
          'splitterGroupMainHelper', '$compile', '$bentoServices',
          function(
              $timeout, $log, splitterGroupNotification,
              splitterGroupMainHelper, $compile, $bentoServices) {
            var isRTL = $bentoServices.isRTL();

            return {
              restrict: 'A',
              replace: false,
              scope: {
                _bottomHeight: '@bottomHeight',  // Set the default width to the
                                                 // bottom pane
                _leftWidth:
                    '@leftWidth',  // Set the default width to the left pane
                _rightWidth:
                    '@rightWidth',  // Set the default width to the right pane
                _topHeight:
                    '@topHeight',  // Set the default width to the top pane
                autoResize: '=',   // Option to auto-resize the parent container
                                   // with the content of this SG
                bottomMaxHeight:
                    '@',  // Set max draggable height of the bottom panel
                eventTracking: '&',  // Dispatch external event handlers
                isLeftCollapsed: isRTL ? '=?isRightCollapsed' :
                                         '=?',  // Default to false if doesn't
                                                // exist
                isRightCollapsed: isRTL ? '=?isLeftCollapsed' :
                                          '=?',  // Default to false if doesn't
                                                 // exist
                isTopCollapsed: '=?',     // Default to false if doesn't exist
                isBottomCollapsed: '=?',  // Default to false if doesn't exist
                leftMaxWidth: '@',  // Set max draggable width of the left panel
                noCollapse: '&',    // Making the splitter group to be only
                                    // resizable but not
                                    // collapsable on Left
                onResize: '&',      // Callback for resize
                resizable: '&',     // This enables the dragging function to the
                                    // handle bar
                rightMaxWidth:
                    '@',           // Set max draggable width of the right panel
                topMaxHeight: '@'  // Set max draggable height of the top panel
              },
              controller: 'bentoSplitterGroupMainController',
              link: function($scope, $element, $attrs, ctrl) {
                // Set default width to both left, right, top & bottom
                if (typeof $scope._leftWidth === 'undefined' ||
                    $scope._leftWidth === null) {
                  $scope.leftWidth = '300px';
                } else {
                  $scope.leftWidth = $scope._leftWidth;
                }

                if (typeof $scope._rightWidth === 'undefined' ||
                    $scope._rightWidth === null) {
                  $scope.rightWidth = '300px';
                } else {
                  $scope.rightWidth = $scope._rightWidth;
                }

                if (typeof $scope._topHeight === 'undefined' ||
                    $scope._topHeight === null) {
                  $scope.topHeight = '300px';
                } else {
                  $scope.topHeight = $scope._topHeight;
                }

                if (typeof $scope._bottomHeight === 'undefined' ||
                    $scope._bottomHeight === null) {
                  $scope.bottomHeight = '300px';
                } else {
                  $scope.bottomHeight = $scope._bottomHeight;
                }

                // Make sure the intial leftWidth doesn't exceed the
                // leftMaxWidth
                if ($scope.leftMaxWidthPx > -1 &&
                    splitterGroupMainHelper.parseWidth(
                        $element, $scope.leftWidth) > $scope.leftMaxWidthPx) {
                  $scope.leftWidth = $scope.leftMaxWidthPx + 'px';
                }

                // Make sure the intial rightWidth doesn't exceed the
                // rightMaxWidth
                if ($scope.rightMaxWidthPx > -1 &&
                    splitterGroupMainHelper.parseWidth(
                        $element, $scope.rightWidth) > $scope.rightMaxWidthPx) {
                  $scope.rightWidth = $scope.rightMaxWidthPx + 'px';
                }

                if ($scope.topMaxHeightPx > -1 &&
                    splitterGroupMainHelper.parseHeight(
                        $element, $scope.topHeight) > $scope.topMaxHeightPx) {
                  $scope.topHeight = $scope.topMaxHeightPx + 'px';
                }

                // Make sure the intial rightWidth doesn't exceed the
                // rightMaxWidth
                if ($scope.bottomMaxHeightPx > -1 &&
                    splitterGroupMainHelper.parseHeight(
                        $element, $scope.bottomHeight) >
                        $scope.bottomMaxHeightPx) {
                  $scope.bottomHeight = $scope.bottomMaxHeightPx + 'px';
                }

                var mainPaneInner = $element[0].querySelector(
                    '.' + DIRECTIVE_NAME_SPACE + 'main-inner');

                // Main SR object
                var srObj = angular.element(
                    '<info class="sr-only" tabindex="0">{{ "BENTO_UI_SPLITTER_GROUP" | bentoTranslate}}</info>');
                $compile(srObj)($scope);
                $element.prepend(srObj);

                // Get the children elements from the splitter group DOM
                // structure
                var getDomEl = function(side) {
                  var children = $element.children(), $sideEl, $foundSideEl;

                  angular.forEach(children, function(sideEl) {
                    $sideEl = angular.element(sideEl);
                    if ($sideEl.hasClass(DIRECTIVE_NAME_SPACE + side)) {
                      $foundSideEl = $sideEl;
                    }
                  });

                  return $foundSideEl;
                };

                $scope.splitterLeft = getDomEl(LEFT);
                $scope.splitterRight = getDomEl(RIGHT);
                $scope.splitterTop = getDomEl(TOP);
                $scope.splitterBottom = getDomEl(BOTTOM);
                $scope.splitterMain = getDomEl('main');

                getDomEl = null;

                /* Inject splitter buttons */
                // helper function
                var handleInject = function(C_SIDE) {
                  // Handle doesn't exist
                  if (!ctrl.hasHandle(C_SIDE)) {
                    return;
                  }

                  var SIDE = C_SIDE.toLowerCase(),
                      splitHandleSide = 'splitHandle' + C_SIDE,
                      splitterSide = 'splitter' + C_SIDE,
                      length = (C_SIDE === C_TOP || C_SIDE === C_BOTTOM) ?
                      SIDE + 'Height' :
                      SIDE + 'Width',
                      lengthOrientation =
                          (length.search('Height') > -1) ? 'height' : 'width',
                      eventOpen = 'open' + C_SIDE,
                      eventClose = 'close' + C_SIDE,
                      openedSide = 'opened-' + SIDE;

                  $scope[splitHandleSide] = angular.element(
                      '<button class="bento-splitter-handle bento-splitter-handle-' +
                      SIDE + '" ' +
                      'tabindex="0" type="button" aria-label="{{ \'BENTO_UI_SPLITTER_GROUP_' +
                      SIDE.toUpperCase() + '_BAR\' | bentoTranslate}}">' +
                      HANDLE_DEFAULT + HANDLE_MOVE + '</button>');

                  $scope[splitHandleSide].on('focusin', function() {
                    $scope.actionOn = SIDE;
                  });

                  // Append the handle after each pane
                  $scope[splitterSide][0].parentNode.insertBefore(
                      $scope[splitHandleSide][0], $scope[splitterSide][0]);

                  $compile($scope[splitHandleSide])($scope);
                  // Initialize pane initial position
                  $scope[splitterSide].css(lengthOrientation, $scope[length]);
                  $scope[splitterSide].css(SIDE, '-' + $scope[length]);
                  // Initialize splitHandle listener
                  $scope[splitHandleSide].one(
                      'touchstart mousedown', $scope.onHandleDown);
                  $scope[splitHandleSide][0].addEventListener(
                      'keyup', ctrl.onHandleKeyup);
                  mainPaneInner.className += ' has-' + SIDE + '-pane';

                  // Assign Notifications
                  splitterGroupNotification.addNotification(
                      eventOpen, eventCallbackOnOpen, $attrs.id);
                  splitterGroupNotification.addNotification(
                      eventClose, eventCallbackOnClose, $attrs.id);

                  $scope.$on('$destroy', function() {
                    splitterGroupNotification.removeNotification(
                        eventClose, eventCallbackOnClose, $attrs.id);
                    splitterGroupNotification.removeNotification(
                        eventOpen, eventCallbackOnOpen, $attrs.id);
                  });

                  function eventCallbackOnOpen() {
                    if (!$element.hasClass(openedSide)) {
                      $scope.actionOn = SIDE;
                      ctrl.onHandleClick(null);
                    }
                  }

                  function eventCallbackOnClose() {
                    if ($element.hasClass(openedSide)) {
                      $scope.actionOn = SIDE;
                      ctrl.onHandleClick(null);
                    }
                  }
                };

                handleInject(C_TOP);
                handleInject(C_LEFT);
                handleInject(C_RIGHT);
                handleInject(C_BOTTOM);
                handleInject = null;  // clear memory

                function isSideCollapsed(SIDE, collapsed) {
                  var C_SIDE = C_(SIDE);
                  var isOpened = $element.hasClass('opened-' + SIDE);

                  if (!ctrl.hasHandle(C_SIDE) || !!collapsed !== isOpened) {
                    return;
                  }
                  // Default to open
                  if (collapsed && $element.hasClass('opened-' + SIDE)) {
                    ctrl.closePanel(C_SIDE);
                  } else {
                    ctrl.openPanel(C_SIDE);
                  }
                }

                $scope.$watch('isLeftCollapsed', function(collapsed) {
                  isSideCollapsed(LEFT, collapsed);
                });

                $scope.$watch('isRightCollapsed', function(collapsed) {
                  isSideCollapsed(RIGHT, collapsed);
                });

                $scope.$watch('isTopCollapsed', function(collapsed) {
                  isSideCollapsed(TOP, collapsed);
                });

                $scope.$watch('isBottomCollapsed', function(collapsed) {
                  isSideCollapsed(BOTTOM, collapsed);
                });

                function getSideContainer(side) {
                  var children = $element.children(), $el;
                  for (var i = 0, len = children.length; i < len; i++) {
                    $el = angular.element(children[i]);
                    if ($el.hasClass(DIRECTIVE_NAME_SPACE + side)) {
                      return $el
                    }
                  }
                }

                // Auto-resize the parent container
                if (!!$scope.autoResize) {
                  // Get DOM Reference
                  var parentContainer = $element[0].parentNode;
                  var leftContainer = getSideContainer(LEFT);
                  var mainContainer = $element[0].querySelector(
                      '.' + DIRECTIVE_NAME_SPACE + 'main-inner');
                  var rightContainer = getSideContainer(RIGHT);
                  // Preserve the parent original height when this
                  // directive shrinks too small
                  parentContainer.style.minHeight =
                      parentContainer.offsetHeight + 'px';

                  // Adding padding to left, main and right containers
                  // and set overflow-y to hidden width one parent class
                  $element.addClass('auto-resize');

                  // Adding three marker objects to determine where the last
                  // line is
                  var markerLeft;
                  var markerRight;
                  var markerMain;

                  if (!!leftContainer) {
                    markerLeft = document.createElement('div');
                    markerLeft.classNames = 'clearfix';
                    leftContainer.appendChild(markerLeft);
                  }

                  markerMain = document.createElement('div');
                  markerMain.classNames = 'clearfix';
                  mainContainer.appendChild(markerMain);

                  if (!!rightContainer) {
                    markerRight = document.createElement('div');
                    markerRight.classNames = 'clearfix';
                    rightContainer.appendChild(markerRight);
                  }

                  // Watch the three containers and return the most height
                  // and adjust their parent container
                  $scope.$watch(
                      function() {
                        var newHeight = Math.max(
                            !!markerLeft ? markerLeft.offsetTop : 0,
                            !!markerRight ? markerRight.offsetTop : 0,
                            !!markerMain ? markerMain.offsetTop : 0);
                        return newHeight;
                      },
                      function(newValue) {
                        parentContainer.style.height = (newValue + 24) + 'px';
                      });
                }

                // Add the transition class to the left and main pane
                // 0.5second after the page is rendered
                // because IE renders the animation on the main pane when
                // the left pane is opened
                $timeout(function() {
                  if (ctrl.hasHandle(C_LEFT)) {
                    $scope.splitterLeft.addClass('animate');
                  }
                  if (ctrl.hasHandle(C_RIGHT)) {
                    $scope.splitterRight.addClass('animate');
                  }
                  if (ctrl.hasHandle(C_TOP)) {
                    $scope.splitterTop.addClass('animate');
                  }
                  if (ctrl.hasHandle(C_BOTTOM)) {
                    $scope.splitterBottom.addClass('animate');
                  }

                  $element.addClass(DIRECTIVE_NAME_SPACE + 'ready');

                  $scope.splitterMain.addClass('animate');
                }, 500);
              }
            };
          }
        ])
    .directive(
        directiveName + C_LEFT,
        [
          '$bentoTranslate',
          function($bentoTranslate) {
            return {
              require: '^' + directiveName,
              restrict: 'A',
              scope: false,
              link: function(scope, element, attr, controller) {
                element.addClass(
                    DIRECTIVE_NAME_SPACE + (controller.isRTL ? RIGHT : LEFT));
                element[0].setAttribute('tabindex', '0');
                // Aria and translation
                updateAria();

                function updateAria() {
                  $bentoTranslate
                      .translate('BENTO_UI_SPLITTER_GROUP_LEFT_PANEL')
                      .then(function(value) {
                        element[0].setAttribute('aria-label', value);
                      });
                }

                $bentoTranslate.onChange(updateAria);
                scope.$on('$destroy', function() {
                  $bentoTranslate.removeOnChange(updateAria);
                });
              }
            };
          }
        ])
    .directive(
        directiveName + C_RIGHT,
        [
          '$bentoTranslate',
          function($bentoTranslate) {
            return {
              require: '^' + directiveName,
              restrict: 'A',
              scope: false,
              link: function(scope, element, attr, controller) {
                element.addClass(
                    DIRECTIVE_NAME_SPACE + (controller.isRTL ? LEFT : RIGHT));
                element[0].setAttribute('tabindex', '0');
                // Aria and translation
                updateAria();

                function updateAria() {
                  $bentoTranslate
                      .translate('BENTO_UI_SPLITTER_GROUP_RIGHT_PANEL')
                      .then(function(value) {
                        element[0].setAttribute('aria-label', value);
                      });
                }

                $bentoTranslate.onChange(updateAria);
                scope.$on('$destroy', function() {
                  $bentoTranslate.removeOnChange(updateAria);
                });
              }
            };
          }
        ])
    .directive(
        directiveName + C_TOP,
        [
          '$bentoTranslate',
          function($bentoTranslate) {
            return {
              require: '^' + directiveName,
              restrict: 'A',
              scope: false,
              link: function(scope, element, attr) {
                element.addClass(DIRECTIVE_NAME_SPACE + TOP);
                element[0].setAttribute('tabindex', '0');
                // Aria and translation
                updateAria();

                function updateAria() {
                  $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_TOP_PANEL')
                      .then(function(value) {
                        element[0].setAttribute('aria-label', value);
                      });
                }

                $bentoTranslate.onChange(updateAria);
                scope.$on('$destroy', function() {
                  $bentoTranslate.removeOnChange(updateAria);
                });
              }
            };
          }
        ])
    .directive(
        directiveName + C_BOTTOM,
        [
          '$bentoTranslate',
          function($bentoTranslate) {
            return {
              require: '^' + directiveName,
              restrict: 'A',
              scope: false,
              link: function(scope, element, attr) {
                element.addClass(DIRECTIVE_NAME_SPACE + BOTTOM);
                element[0].setAttribute('tabindex', '0');
                // Aria and translation
                updateAria();

                function updateAria() {
                  $bentoTranslate
                      .translate('BENTO_UI_SPLITTER_GROUP_BOTTOM_PANEL')
                      .then(function(value) {
                        element[0].setAttribute('aria-label', value);
                      });
                }

                $bentoTranslate.onChange(updateAria);
                scope.$on('$destroy', function() {
                  $bentoTranslate.removeOnChange(updateAria);
                });
              }
            };
          }
        ])
    .directive(directiveName + 'Main', [
      '$bentoTranslate',
      function($bentoTranslate) {
        return {
          require: '^' + directiveName,
          restrict: 'A',
          replace: true,
          transclude: true,
          template: '<section class="' + DIRECTIVE_NAME_SPACE +
              'main" tabindex="0" roe="main">' +
              '<div class="' + DIRECTIVE_NAME_SPACE +
              'main-inner" ng-transclude></div>' +
              '</section>',
          scope: false,
          link: function(scope, element, attr) {
            element[0].setAttribute('tabindex', '0');
            // Aria and translation
            updateAria()

            function updateAria() {
              $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_MAIN_PANEL')
                  .then(function(value) {
                    element[0].setAttribute('aria-label', value);
                  });
            }

            $bentoTranslate.onChange(updateAria);
            scope.$on('$destroy', function() {
              $bentoTranslate.removeOnChange(updateAria);
            });
          }
        };
      }
    ]);
})(window, window.angular);
(function (window, angular, undefined) {

  'use strict';

  // Template override
  angular.module("template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/tabs/tab.html",
      '<li ng-class="{active: active, disabled: disabled}" role="tab">\n' +
      '  <a href bento-test="anchor" ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n' +
      '</li>\n' +
      '');
  }]);

  angular.module('bento.tabs', ['bento.services'])
    .directive('uibTabset', tabsetDirective)
    .directive('uibTab', tabDirective);

  tabsetDirective.$inject = ['$compile', '$bentoServices', '$timeout'];
  /**
   * Tabset directive extension
   */
  function tabsetDirective($compile, $bentoServices, $timeout) {
    return {
      require : 'uibTabset',
      priority: 1,
      link    : function (scope, element, attrs, controller) {

        // local variables used within the directive
        var startTime;
        var scrollFrom;
        var scrollTo;
        var scrollDelta;
        var _scrollLeft;
        var _tempDate;
        var lastActiveIndex;
        var scrollAnimateCounter = 0;
        var MAX_SCROLL_COUNTER = 1000;
        var containerScrollWidth = -1;
        var totalScrollLength = 0;

        var localScope = scope.$new();
        element.addClass('bento-tabset');

        // Vertical tabs will be ignored from this directive extension
        if (!element.hasClass('tabs-top') && !element.hasClass('tabs-bottom')) {
          return;
        }

        // Variable declaration
        var tabs         = element[0].querySelector('ul.nav'),
            isRTL        = $bentoServices.isRTL(),
            btnLeftMost  = angular.element(
              '<button ng-disabled="disableLeftArrows" ng-click="onLeftMostClick()" class="btn btn-default bento-tabset-nav-button left-most">' +
              '<i class="bento-icon-chevron-first-left"></i></button>'),
            btnLeft      = angular.element(
              '<button ng-disabled="disableLeftArrows" ng-click="onLeftClick()" class="btn btn-default bento-tabset-nav-button left">' +
              '<i class="bento-icon-chevron-left"></i></button>'),
            btnRight     = angular.element(
              '<button ng-disabled="disableRightArrows" ng-click="onRightClick()" class="btn btn-default bento-tabset-nav-button right">' +
              '<i class="bento-icon-chevron-right"></i></button>'),
            btnRightMost = angular.element(
              '<button ng-disabled="disableRightArrows" ng-click="onRightMostClick()" class="btn btn-default bento-tabset-nav-button right-most">' +
              '<i class="bento-icon-chevron-last-right"></i></button>'),

            btnContainer = angular.element('<div class="bento-tabset-nav-button-container"></div>'),
            isAnimating,
            firstTab,  // This reference is used for setting margins
            marginSide = isRTL? 'marginRight' : 'marginLeft',
            currentTab;

        tabs.setAttribute('role', 'tablist');

        localScope.disableLeftArrows = false;
        localScope.disableRightArrows = false;

        // Button listeners
        localScope.onLeftMostClick = function (reversed) {
          if(isRTL && !reversed) {
            localScope.onRightMostClick(true);
          } else {
            if(!currentTab) {
              currentTab = getCurrentTab();
            }
            startTime = performance.now();

            // Skip starting a new animation thread
            if (isAnimating) {
              return;
            }

            // Update flag
            isAnimating = true;
            _scrollAnimate(200, tabs.offsetWidth + currentTab.offsetWidth, 0, -(tabs.offsetWidth + currentTab.offsetWidth));
          }
        };

        localScope.onLeftClick = function (reversed) {
          if(isRTL && !reversed){
            localScope.onRightClick(true);
          } else{
            currentTab = getCurrentTab();
            if(!currentTab) {
              localScope.disableLeftArrows = true;
            } else {
              totalScrollLength -= currentTab.offsetWidth;
              var delta = totalScrollLength - tabs.scrollLeft;

              startTime = performance.now();

              // Skip starting a new animation thread
              if (isAnimating) {
                return;
              }

              // Update flag
              isAnimating = true;
              _scrollAnimate(200, tabs.scrollLeft, totalScrollLength, delta);
            }
          }
          
        };

        localScope.onRightClick = function (reversed) {
          if(isRTL && !reversed){
            localScope.onLeftClick(true);
          } else{
            currentTab = getCurrentTab();
            if(!currentTab) {
              localScope.disableRightArrows = true;
            } else {
              totalScrollLength += currentTab.offsetWidth;
              var delta = totalScrollLength - tabs.scrollLeft;

              startTime = performance.now();

              // Skip starting a new animation thread
              if (isAnimating) {
                return;
              }

              // Update flag
              isAnimating = true;
              _scrollAnimate(200, tabs.scrollLeft, totalScrollLength, delta);
            }
          }
        };

        localScope.onRightMostClick = function (reversed) {
          if(isRTL && !reversed) {
            localScope.onLeftMostClick(true);
          } else {
            currentTab = getCurrentTab();
            if(!currentTab) {
              localScope.disableRightArrows = true;
            } else {
              startTime = performance.now();

              // Skip starting a new animation thread
              if (isAnimating) {
                return;
              }

              // Update flag
              isAnimating = true;
              _scrollAnimate(200, 0, tabs.scrollWidth, tabs.scrollWidth);
            }
          }
        };

        scope.$on('bentoTabsetRefresh', refreshTabset);

        scope.$watch(function () {
            return $bentoServices.isRTL();
        }, function (nv, ov) {
          if(nv !== null || nv !== undefined) {
            // Tabs are not redered yet...
            if (tabs.children.length < 1 || nv === ov) {
              return;
            }
            resetLocals();
            isRTL = nv;

            $timeout(function() {
              inspectWidth();
              validateButtons();
            }, 500);
          }
        });

        // Watch tab active states and autoscroll if neccessary
        scope.$watch(function () {
          var activeIndex = 0;
          var count = 0;
          controller.tabs.forEach(function (item, index) {
            if (item.active) {
              count++;
              activeIndex = index;
            }
          });

          if (count === 1) {
            lastActiveIndex = activeIndex;
          }

          return lastActiveIndex;
        }, function (activeIndex) {

          // Bypass if the tabs are not ready
          // This happens when the tabs are dynamically rendered when Tab is initiated but the data is not
          // BENTO-152
          if (typeof activeIndex === 'undefined') {
            return;
          }

          // Scroll needs to come in after components rendering
          $timeout(function () {
            var tabChildren = tabs.children,
                activeTab   = tabChildren[activeIndex],
                tabLeft     = activeTab.offsetLeft,
                tabRight    = tabLeft + activeTab.offsetWidth,
                tabsWidth   = tabs.offsetWidth -
                  parseInt(getComputedStyle(tabChildren[tabChildren.length - 1]).marginRight.replace('px', ''))
              ;

            if (tabLeft < tabs.scrollLeft) {
              scrollToTab(activeTab, false);
            } else if (tabRight > tabs.scrollLeft + tabsWidth) {
              scroll(tabRight - tabsWidth);
            }
          })

        });

        btnContainer.append(btnLeftMost);
        btnContainer.append(btnLeft);
        btnContainer.append(btnRight);
        btnContainer.append(btnRightMost);

        $compile(btnContainer)(localScope);

        element.prepend(btnContainer);

        angular.element(window).on('resize', onResize);

        function refreshTabset() {
          localScope.onLeftMostClick(true);
        }

        function onResize(event) {
          inspectWidth();
          validateButtons();
        }

        // delay the event loop: calculate width and validate button
        $timeout(function() {
          inspectWidth();
          validateButtons();
        });

        /**
         * Inspect the tab container width and scrollWidth and see if it's scrollable
         */
        function inspectWidth() {
          // Tabs are not redered yet...
          if (tabs.children.length < 1) {
            return;
          }

          var sWidth      = -getTabVirtualLeft(tabs.children[0]) + tabs.scrollWidth,
              width       = tabs.offsetWidth,
              children    = tabs.children,
              hasScroll   = element.hasClass('bento-tabset-h-scrollable'),
              rightMargin = parseInt(getComputedStyle(children[children.length-1]).marginRight.replace('px', ''));

          if (hasScroll && sWidth <= width + rightMargin) {
            element.removeClass('bento-tabset-h-scrollable');
          } else if (!hasScroll && sWidth > width + rightMargin && rightMargin < 100) {
            element.addClass('bento-tabset-h-scrollable');
          }
        }

        /**
         * $destroy listener for cleanup
         */
        scope.$on('$destroy', function () {
          angular.element(window).off('resize', onResize);
          localScope.$destroy();
        });

        /**
         * when toggling between RTL and LTR, reset the variable's state
         */
        function resetLocals() {
          startTime = 0;
          scrollFrom = 0;
          scrollTo = 0;
          scrollDelta = 0;
          _scrollLeft = 0;
          _tempDate = 0;
          firstTab = undefined;
          currentTab = undefined;
          isAnimating = false;
          marginSide = isRTL? 'marginRight' : 'marginLeft';
          containerScrollWidth = -1;
        }

        /**
         * Get the current tab that is in the first position
         * @returns {*}
         */
        function getCurrentTab() {
          var leftPadding = getLeftPadding(),
              i, len, center, tab,
              children    = tabs.children,
              scrollLeft  = tabs.scrollLeft + leftPadding,
              found
            ;
          if(containerScrollWidth === -1) {
            containerScrollWidth = Math.ceil(tabs.scrollWidth - tabs.offsetWidth);
          }
          for (i = 0, len = children.length; i < len; i++) {
            tab = children[i];
            if(tab.offsetLeft >= Math.ceil(tabs.scrollLeft)) {
              found = tab;
              break;
            }
          }

          return found;
        }

        /**
         * 
         * @param tab:  active tab
         * @param isLeft: true when left button is clicked 
         */
        function scrollToTab(tab, isLeft) {
          var scrollLeft;

          if(isRTL){
            if(isLeft) {
              scrollLeft = (containerScrollWidth - Math.ceil(tabs.scrollLeft)) - tab.offsetWidth;
            } else {
              scrollLeft = (containerScrollWidth - Math.ceil(tabs.scrollLeft)) + tab.offsetWidth;
            }
          }else{
            scrollLeft = isLeft ? tab.offsetLeft - tab.offsetWidth:tab.offsetLeft + tab.offsetWidth;
          }

          // reset it to 0
          if(scrollLeft < 0) {
            scrollLeft = 0;
          } else if(scrollLeft > containerScrollWidth) {
            scrollLeft = containerScrollWidth;
          }

          scroll(scrollLeft);
        }

        /**
         * 
         * @param scrollLeftTo: pixes to move
         */
        function scroll(scrollLeftTo) {
          var time = 200;

          // // Initialize animation
          startTime = performance.now();

          if(isRTL) {
            firstTab = tabs.children[0]; // The first tab can dynamically change
            scrollFrom = Math.abs(getTabVirtualLeft(firstTab));
            scrollTo = scrollLeftTo;
          } else {
            scrollFrom = (currentTab) ? currentTab.offsetLeft : 0;
            scrollTo = scrollLeftTo;
          }

          scrollDelta = scrollTo - scrollFrom;

          // Skip starting a new animation thread
          if (isAnimating) {
            return;
          }

          // Update flag
          isAnimating = true;
          // Start animate
          _scrollAnimate(time, tabs.offsetWidth);

        }

        /**
         * 
         * @param time: starting time
         */
        function _scrollAnimate(time, from, to, delta) {
          // restrict the number of times getting called. Sometimes, it gets
          // called un reasonably
          if(++scrollAnimateCounter > MAX_SCROLL_COUNTER) { 
            tabs.scrollLeft = to;
            inspectWidth();
            validateButtons(to);

            isAnimating = false;
            scrollAnimateCounter = 0;
            return;
          }

          _scrollLeft = from + (delta * _ease((performance.now() - startTime) / time));
          tabs.scrollLeft = _scrollLeft;

          if (Math.abs(_scrollLeft - to) <= 1) {
            tabs.scrollLeft = to;

            inspectWidth();
            validateButtons();

            isAnimating = false;
            scrollAnimateCounter = 0;

            totalScrollLength = tabs.scrollLeft;
          } else {
            // Use rAF to generate the next frame
            $bentoServices.rAF(function () {
              _scrollAnimate(time, from, to, delta);
            });
          }
        }

        /**
         * 
         * @param to: scroll to position in pixels
         */
        function validateButtons() {
          // Tabs are not redered yet...
          if (tabs.children.length < 1) {
            return;
          }

          localScope.disableRightArrows = !isRTL ? (Math.ceil(tabs.offsetWidth + tabs.scrollLeft) >= tabs.scrollWidth) : (tabs.scrollLeft <= 0);
          localScope.disableLeftArrows = !isRTL ? (tabs.scrollLeft <= 0) : (Math.ceil(tabs.offsetWidth + tabs.scrollLeft) >= tabs.scrollWidth);

          $bentoServices.safeApply(localScope);
        }

        /**
         * Get ease ration based on time ratio wi
         * @param timeRatio - 0.0 to 1.0
         * @param ease - easing factor
         * @returns {number}
         * @private
         */
        function _ease(timeRatio) {
          return -(Math.pow(timeRatio - 1, 4)) + 1;
        }

        function getLeftPadding() {
          return parseInt(getComputedStyle(tabs).paddingLeft.replace('px', ''));
        }

        function getTabVirtualLeft(tab){
          if(!tab) {
            return 0;
          }
          return Math.round(parseFloat(window.getComputedStyle(tab)[marginSide]));
        }

      }
    }
  }

  tabDirective.$inject = ['$compile', '$log'];
  /**
   * Tabset tab directive extension
   * @returns {{require: string, priority: number, link: link}}
   */
  function tabDirective($compile, $log) {
    return {
      require : 'uibTab',
      priority: -1,
      link    : function (scope, element, attrs) {

        attrs.$set('role', 'tab');

        if (typeof attrs.count !== 'undefined') {
          // Deprecation warning message
          $log.warn('uib-tab: "count" is deprecated. See "tabset" documentation for the use of <uib-tab-heading></uib-tab-heading>');

          var $count = angular.element('<span class="badge" aria-hidden="false">{{count}}</span>');
          var isoScope = scope.$new();
          $compile($count)(isoScope);

          element.find('a').append($count);

          attrs.$observe('count', function (newValue) {
            isoScope.count = newValue;
          });

          scope.$on('$destroy', function () {
            isoScope.$destroy();
          });
        }
      }
    }
  }

})(window, angular);
(function (angular, window) {
  'use strict';

  var BTI_TYPE_STRING   = 'string',
      BTI_TYPE_OPERATOR = 'operator',
      BTI_TYPE_NUMBER   = 'number',
      defaults          = {
        minTagLength    : 2,
        propertyName    : 'name',
        allowedOperators: '-+=/*%[]()!~&|<>'
      };

  angular.module('bento.tagsinput', [])
  /**
   * Bento Tags Input Directive
   */
    .directive('bentoTagsInput', [
      '$timeout',
      function ($timeout) {
        return {
          priority: 2, // 1 higher than ngModel
          scope       : {
            addOnComma                  : '=?',  // Add a tag on comma key
            addOnEnter                  : '=?',  // Add on enter key
            addOnSpace                  : '=?',  // Add on space bar
            editable                    : '=?',  // Flag to editable pills
            minTagLength                : '=?', // Minimum Tag length
            ngModel                     : '=',  // Tags in array
            onTagAdded                  : '&',  // Event handler - when a tag is added
            onTagAddStart               : '&',  // Event handler - when a tag is being added
            onTagEditEnd                : '&',  // Event handler - when a tag edit is ending
            onTagEdited                 : '&',  // Event handler - when a tag is edited
            onTagInvalidInput           : '&',  // Event handler - when a tag input is invalid
            onTagRemoved                : '&',  // Event handler - when a tag is removed
            onTagRemoveStart            : '&',  // Event handler - when a tag is being removed
            placeholder                 : '@',  // Placeholder for the input field
            useOperators                : '=?', // Use Math Operators
            allowedOperators            : '=?', // String of the operators to use
            replaceSpacesWithDashes     : '=',  // If the spaces are replaced with spaces
            replaceSpacesWithUnderscores: '=?',  // If the spaces are replaced with underscores
            tagPropertyName             : '@?', // Property name of each pill
            ngDisabled                  : '=?', // ngDisabled
            ngReadonly                  : '=?', // ngReadonly
            disableKeyInput             : '=?'  // disable keyboard interaction
          },
          require     : ['ngModel', 'bentoTagsInput'],
          replace     : true,
          templateUrl : function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tags_input/bento-tags-input.html';
          },
          controller  : ['$scope', '$element',
            function ($scope, $element) {
              // Set default
              $scope.propertyName = typeof $scope.tagPropertyName === 'undefined' ?
                defaults.propertyName : $scope.tagPropertyName;
              $scope.minTagLength = typeof $scope.minTagLength === 'undefined' ?
                defaults.minTagLength : $scope.minTagLength;
              $scope.allowedOperators = typeof $scope.allowedOperators === 'undefined' ?
                defaults.allowedOperators : $scope.allowedOperators;
              var self = this;

              self.setEditingMode = function (bool) {
                $scope.isPillEditing = bool;
                angular.element($element[0].querySelector('.bento-tags-input-text')).css('width', 60 + 'px');
              };

              self.setActivePill = function (index) {
                $scope.activePill = index;
              };

              self.hasRedundancy = function (tag, ignoreTagIndex) {
                return $scope.ngModel.some(function (value, index, array) {
                  if (index === ignoreTagIndex) {
                    return false;
                  }

                  return value[$scope.propertyName] === tag.trim();
                });
              };

              self.validate = function (tag) {
                var v = {
                  isValidLength: false,
                  type         : BTI_TYPE_STRING
                };
                tag = tag.trim();
                v.name = tag;

                // operator related inspection
                if ($scope.useOperators) {
                  var allowedOperators = $scope.allowedOperators;
                  v.type = BTI_TYPE_OPERATOR;
                  v.isValidLength = true;

                  if (!isNaN(Number(tag))) {
                    v.type = BTI_TYPE_NUMBER;
                  } else {
                    for (var i = 0, len = tag.length; i < len; i++) {
                      if (allowedOperators.indexOf(tag.charAt(i)) < 0) {
                        v.type = BTI_TYPE_STRING;
                        if (tag.length >= $scope.minTagLength) {
                          v.isValidLength = true;
                        } else {
                          v.isValidLength = false;
                        }
                      }
                    }
                  }
                } else
                // length based inspection
                if (tag.length >= $scope.minTagLength) {
                  v.isValidLength = true;
                }

                return v;
              };

              $element.on('focusout', function(e){
                // This event listener needs to be declared from ngModel does it's own
                // ignore ngModel from assignment touched

                var target = e.relatedTarget || document.activeElement;

                if($element[0].contains(target)){
                  e.stopImmediatePropagation();
                }
              })
            }
          ],
          controllerAs: 'bentoTagsInputCtrl',
          link        : /**
           * Link funcion of bento-tags-input directive
           * @param scope
           * @param element
           * @param attrs
           * @param controllers
           */
          function (scope, element, attrs, controllers) {
            var ngModelController = controllers[0];
            var controller = controllers[1];
            var $input = angular.element(element[0].querySelector('.bento-tags-input-text'));
            var $hiddenInput = angular.element(element[0].querySelector('.bento-tags-input-text-hidden'));
            var goBlur = true;
            var t;
            var textBeforeKeypress;

            // init ngModel form element conditions
            ngModelController.$setPristine();
            ngModelController.$setUntouched();
            attrs.$set('tabindex','-1');


            // Set Defaults
            scope.activePill = -1;
            scope.addOnComma = typeof scope.addOnComma === 'undefined' ? true : scope.addOnComma;
            scope.addOnEnter = typeof scope.addOnEnter === 'undefined' ? true : scope.addOnEnter;

            scope.ngModel = scope.ngModel ? scope.ngModel : [];

            scope.$watch(function () {
              return scope.ngModel ? scope.ngModel.length : 0;
            }, function (modelSize) {
              if (attrs.required) {
                if (modelSize === 0) {
                  ngModelController.$setValidity('required', false);
                } else {
                  ngModelController.$setValidity('required', true);
                }
              }
            });

            scope.$watch('editable', function () {
              if ($input) {
                $input.css('width', 60 + 'px');
              }
            });

            /**
             * When a user focus out from this input
             *
             * To be declared in controller
             **/
            element.on('focusout', function (event) {

              var target = event.relatedTarget || document.activeElement;

              if (goBlur && !element[0].contains(target)) {
                // Only goBlur is set to true
                // Workaround in order to work with various browsers

                if(ngModelController.$untouched){
                  $timeout(function(){
                    ngModelController.$setTouched();
                  });
                }

                element.removeClass('bento-tags-input-focused');
                t = scope.inputText ? scope.inputText : '';
                if (t.length === 0) {
                  return;
                }
                addTagToModel(t);
              }else{
                event.preventDefault();
                event.stopImmediatePropagation();
              }
            });

            /**
             * On a pillfocus
             * @param index
             */
            scope.onPillFocus = function (index) {
              if (scope.ngReadonly) {
                return;
              }
              scope.activePill = index;
              element.addClass('bento-tags-input-focused');
            };

            /**
             * Callback when entering pill edit mode
             * @param index
             */
            scope.onPillEdit = function (index) {
              element.addClass('bento-tags-input-focused');
            };

            /**
             * On a pillblur
             * @param index
             */
            scope.onPillBlur = function (index) {
              scope.activePill = -1;
              element.removeClass('bento-tags-input-focused');
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             */
            scope.onPillMoveLeft = function (index) {
              $hiddenInput.focus();
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             */
            scope.onPillMoveRight = function (index) {
              $hiddenInput.focus();
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             * TODO: doesn't play well with ng-repeat
             */
            scope.onPillDeleteLeft = function (index) {
//              if (index > 0) {
//                scope.ngModel.splice(index - 1, 1);
//              }
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             * TODO: doesn't play well with ng-repeat
             */
            scope.onPillDeleteRight = function (index) {
//              if (index === scope.ngModel.length - 1 && scope.inputText) {
//                scope.inputText = scope.inputText.substring(1);
//              } else {
//                scope.ngModel.splice(index+1,1);
//              }
            };

            /**
             * Return form element based default classes for NG
             * @returns {string}
             */
            scope.getClass = function () {
              return ''
            };

            /**
             * Get focus event
             */
            element.on('focus', function (event) {
              goBlur = false;
              $input[0].focus();
              goBlur = true;
            });

            /**
             * Callback function to when a pill's content is changed
             * @param label
             * @param index
             */
            scope.onPillChange = function (index, label, oldLabel) {
              // This label is completely removed
              if (!label || label.length === 0) {
                var toBeRemovedTag = scope.ngModel[index];

                decideTagRemoval(
                  toBeRemovedTag,
                  function () {
                    // remove tag from ngModel array
                    scope.ngModel.splice(scope.ngModel.indexOf(toBeRemovedTag), 1);

                    // Fire callback
                    scope.onTagRemoved({tag: toBeRemovedTag});
                  }
                ); // decideTagRemoval

              } else {
                var res = scope.onTagEditEnd({tagString: label});
                
                if(res === true || res == null){
                  // Result is either true or undefined
                  // This is a valid edit
                  // Fire callback
                  scope.onTagEdited({tag: scope.ngModel[index]});
                }else if (typeof res === 'object' && res.then){
                  // Result is a promise
                  res.then(function(){
                    // This is also a valid edit with deferred response
                    // Fire callback
                    scope.onTagEdited({tag: scope.ngModel[index]});
                  },
                  function(){
                    // Rejection
                    // Invalid edit
                    // Revert edit
                    scope.ngModel[index][scope.propertyName] = oldLabel;
                  }
                );
                }else{
                  // Invalid edit
                  // Revert edit
                  scope.ngModel[index][scope.propertyName] = oldLabel;

                }
              }

              // resize the main input field
              if (scope.ngModel && scope.ngModel.length > 0) {
                var pills = element[0].querySelectorAll('.bento-tags-input-pill:not(.ng-leave)');
                var rect = pills[pills.length - 1].getBoundingClientRect();
                calculateInputField(rect);
              } else {
                calculateInputField(0);
              }
            };

            /**
             * Callback from pills redundancy report
             * @param index
             * @param isRedundant
             */
            scope.onPillRedundant = function (index, isRedundant) {
              if (isRedundant) {
                ngModelController.$setValidity('tags-input-redundant', false);
              } else {
                ngModelController.$setValidity('tags-input-redundant', true);
              }
            };

            /**
             * Callback from pills' length report
             * @param index
             * @param invalidLength
             */
            scope.onPillTagLength = function (index, isValidLength) {
              if (!isValidLength) {
                ngModelController.$setValidity('tags-input-invalid-length', false);
              } else {
                ngModelController.$setValidity('tags-input-invalid-length', true);
              }
            };

            /**
             * When a key is entered into the input field
             * Auto resize input field as user types
             * @param event
             */
            scope.onKeypress = function (event) {
              if (scope.isPillEditing) {
                return;
              }
              var width = (scope.inputText) ? (scope.inputText.length) * 9 : 60;
              $input.css('width', width + 'px');
            };

            /**
             * Callback when a key is up in the input field
             * @param event
             */
            scope.onKeyup = function (event) {
              if (scope.ngReadonly) {
                return;
              }

              if (textBeforeKeypress !== scope.inputText) {
                ngModelController.$setDirty();

                ngModelController.$setValidity('tags-input-length', true);
                ngModelController.$setValidity('tags-input-redundant', true);
                $input.removeClass('tags-input-invalid');
              }
            };

            /**
             * On keydown in the directive
             * @param event
             */
            scope.onKeydown = function (event) {
              if (scope.ngReadonly) {
                return;
              }

              textBeforeKeypress = scope.inputText;
              if (scope.isPillEditing) {
                return;
              }
              // Enter: 13
              // Left: 37
              // Right: 39
              // Delete: 46
              // Backspace: 8
              // Tab: 9
              // Comma: 188
              // Space: 32
              if (
                // Enter
              (scope.addOnEnter && event.keyCode === 13) ||
              // Space
              (scope.addOnSpace && event.keyCode === 32) ||
              // Comma
              (scope.addOnComma && event.keyCode === 188)) {
                if (scope.inputText) {
                  t = scope.inputText;
                  if (t.length === 0) {
                    return;
                  }

                  // unrelate to NG
                  $timeout(function () {
                    goBlur = false;
                    $input[0].focus();
                    goBlur = true;
                  }, 10);

                  addTagToModel(t);

                  event.stopPropagation();
                  event.preventDefault();
                }
              } else if (event.keyCode === 37) {
                if ($input[0].selectionStart === 0) {
                  goBlur = false;
                  $hiddenInput[0].focus();
                  goBlur = true;

                  if (scope.activePill === -1) {
                    scope.activePill = scope.ngModel.length - 1;
                  } else if (scope.activePill > 0) {
                    scope.activePill--;
                  }
                  event.stopPropagation();
                  event.preventDefault();
                }

              } else if (event.keyCode === 39) {
                if (scope.activePill === scope.ngModel.length - 1) {
                  $timeout(function () {
                    goBlur = false;
                    $input[0].focus();
                    goBlur = true;
                  }, 10);
                } else if (scope.activePill != -1) {
                  scope.activePill++
                }

                if (document.activeElement !== $input[0]) {
                  event.stopPropagation();
                  event.preventDefault();
                }

              } else if (event.keyCode == 46 || event.keyCode == 8) {
                if (scope.activePill != -1) {
                  scope.onPillClose(scope.activePill);

                  if (scope.activePill === scope.ngModel.length) {
                    scope.activePill = scope.ngModel.length - 1;
                  }

                  if (scope.activePill === -1) {
                    $timeout(function () {
                      $input[0].focus()
                    }, 10);
                  }
                  event.preventDefault();
                  event.stopPropagation();
                } else if (event.keyCode === 8 && $input[0].selectionStart === 0 && $input[0].selectionEnd === 0) {
                  scope.onPillClose(scope.ngModel.length - 1);
                } else {
                  $input.css('width', ((scope.inputText) ? scope.inputText.length * 9 : 0 ) + 'px')
                }
              } else if (
                // Tab
              event.keyCode === 9
              ) {
                if (scope.inputText) {
                  t = scope.inputText;
                  if (t.length === 0) {
                    return;
                  }
                  addTagToModel(t);
                  event.preventDefault();
                  event.stopPropagation();
                }
                scope.activePill = -1;
              }
            };

            /**
             * Decide to whether add the item or not
             * @param tag
             * @param callback
             */
            function decideTagAddition(tag, callback) {
              var okToAdd = scope.onTagAddStart({tag: tag});

              // `okToAdd` is a promise
              if (typeof okToAdd === 'object' && okToAdd.then) {
                // Resolve or reject
                okToAdd.then(
                  function () {
                    callback(tag);
                  },
                  function () {
                    // rejected, no addition
                  }
                );
              } else
              // Boolean
              if (typeof okToAdd === 'undefined' || okToAdd) {
                callback(tag);
              }
            }

            /**
             * Decide whether we should remove the tag based on `onTagRemoveStart` callback function
             * @param tag
             * @param callback
             */
            function decideTagRemoval(tag, callback) {
              var okToRemove = scope.onTagRemoveStart({tag: tag});

              // `okToRemove` is a promise
              if (typeof okToRemove === 'object' && okToRemove.then) {
                // Resolve or reject
                okToRemove.then(
                  function () {
                    callback(tag);
                  },
                  function () {
                    // Removal rejected
                  }
                );
              } else
              // Boolean
              // Only add when there is no onTagRemoveStart callback or returned `true`
              if (typeof okToRemove === 'undefined' || okToRemove) {
                callback(tag);
              }
            }

            /**
             * Add a new Tag to the array
             * @param tag
             */
            function addTagToModel(tag) {
              var isValidTag = true;
              var validation = controller.validate(tag)

              if (scope.replaceSpacesWithDashes) {
                tag = tag.replace(/ /g, "-");
              } else if (scope.replaceSpacesWithUnderscores) {
                tag = tag.replace(/ /g, "_");
              }

              // Check if the tag is too short
              // Or there is a repeated one
              if (!validation.isValidLength) {
                $input.addClass('tags-input-invalid');
                ngModelController.$setValidity('tags-input-length', false);
                isValidTag = false;
              }

              if (!scope.useOperators && controller.hasRedundancy(tag)) {
                // error notification
                $input.addClass('tags-input-invalid');
                ngModelController.$setValidity('tags-input-redundant', false);
                validation.isRedundant = true;
                isValidTag = false;
              }

              if (isValidTag) {
                var newTag = {};
                newTag[scope.propertyName] = tag;
                newTag.type = validation.type;

                // findout if we can add this new tag
                decideTagAddition(
                  newTag,
                  function () {
                    scope.ngModel.push(newTag);
                    scope.inputText = '';
                    $input.css('width', '0');

                    // Fire tagAdded event handler
                    scope.onTagAdded({tag: newTag});
                  }
                ); //decideTagAddition
              } else {
                // fire invalidicity callback
                scope.onTagInvalidInput({
                  tag: validation
                });
              }
            }

            scope.onInputFocus = function () {
              scope.activePill = -1;
              element.addClass('bento-tags-input-focused');
            };

            scope.onHiddenInputFocus = function () {
              element.addClass('bento-tags-input-focused');
            };

            scope.onPillClose = function (index) {
              var tagToBeRemoved = scope.ngModel[index];

              // Need to confirm removal
              decideTagRemoval(
                tagToBeRemoved,
                function () {
                  $timeout(function () {
                    scope.ngModel.splice(scope.ngModel.indexOf(tagToBeRemoved), 1);

                    if (scope.ngModel.length > 0) {
                      var pills = element[0].querySelectorAll('.bento-tags-input-pill:not(.ng-leave)');
                      var rect = pills[pills.length - 1].getBoundingClientRect();
                      calculateInputField(rect);
                    } else {
                      calculateInputField(0);
                    }

                    // focus back to the text-field for additional user input
                    $input[0].focus();

                    // Fire callback
                    scope.onTagRemoved({tag: tagToBeRemoved});
                  }, 100);

                  // Set dirty
                  ngModelController.$setDirty();
                }
              );
            }; // decideTagRemoval

            scope.resizeInput = function (rect) {
              if (rect) {
                calculateInputField(rect);
              } else {
                var pill = element[0].querySelector('.bento-tags-input-pill:last-of-type');
                calculateInputField(pill.getBoundingClientRect());
              }
            };

            function calculateInputField(rect) {
              var elRect = element[0].getBoundingClientRect();
              var targetWidth = elRect.width - ( rect.left - elRect.left) - rect.width - 30;
              targetWidth = targetWidth < 60 || rect === 0 ? '60px' : targetWidth + 'px';
              $input.css('width', targetWidth);
            }
          }
        }
      }
    ])
    /**
     * To accommodate multiple spaces in pills
     */
    .filter('bentoTagsInputPillFilter', function () {
      return function (input) {

        if (input) {
          // \u00A0 is the unicode for &nbsp;
          return input.replace(/ /g, '\u00A0');
        } else {
          return input;
        }
      }
    })
    /**
     * Bento Tags Input Pill Sub-Directive
     */
    .directive('bentoTagsInputPill', [
      '$timeout',
      function ($timeout) {
        return {
          scope      : {
            label         : '=',
            editable      : '=',
            index         : '=',
            isActive      : '=',
            length        : '=',
            onEdit        : '&',
            onClose       : '&',
            resizeCallback: '&',
            onPillChange  : '&',
            onMoveLeft    : '&',
            onMoveRight   : '&',
            onDeleteLeft  : '&',
            onDeleteRight : '&',
            onRedundantTag: '&',
            onTagLength   : '&',
            tag           : '=',
            ngReadonly    : '=',
            addOnComma    : '&',
            addOnSpace    : '&',
          },
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tags_input/bento-tags-input-pill.html';
          },
          require    : '^bentoTagsInput',
          replace    : true,
          link       : /**
           * Link function of bento-tags-input-pill directive
           * @param scope
           * @param element
           * @param attr
           * @param controller
           */
          function (scope, element, attr, controller) {
            var $input,
                sizeRef = element[0].querySelector('.bento-tags-input-pill-size-ref'),
                isRedundant, isValidLength, validation, pillchangetimeout;

            scope.isEditing = false;
            validation = controller.validate(scope.label);
            scope.tag.type = validation.type;

            /**
             * Watch the change of the label and make size adjustments
             */
            scope.$watch('editLabel', function (newLabel) {
              // Only adjust when it's in editing mode
              if (scope.isEditing && sizeRef && $input) {
                $input.css('width', (sizeRef.offsetWidth + 2) + 'px');
                scope.resizeCallback();
                isRedundant = controller.hasRedundancy(newLabel, scope.index);
                validation = controller.validate(newLabel);
                isValidLength = validation.isValidLength;
                scope.tag.type = validation.type;
                scope.onRedundantTag({index: scope.index, isRedundant: isRedundant});
                scope.onTagLength({index: scope.index, isValidLength: isValidLength});

                if (isRedundant || !isValidLength) {
                  element.addClass('bento-tags-input-pill-invalid');
                } else {
                  element.removeClass('bento-tags-input-pill-invalid');
                }
              }
            });

            /**
             * On pill edit keypress
             * @param event
             */
            scope.onKeypress = function (event) {

            };

            /**
             * On pill edit keydown
             * @param event
             */
            scope.onKeydown = function (event) {
              // Left key 37
              // Right key 39
              switch (event.keyCode) {
                case 37:
                  if ($input[0].selectionStart === 0 && $input[0].selectionEnd === 0) {
                    scope.onMoveLeft({index: scope.index, label: scope.label});
                  }
                  break;
                case 39:
                  if ($input[0].selectionStart === scope.label.length) {
                    scope.onMoveRight({index: scope.index, label: scope.label});
                  }
                  break;
                // Enter
                case 13:
                  // Firing blur to make the change permanent
                  scope.onInputBlur();
                  event.stopPropagation();
                  event.preventDefault();
                  break;
                // Backspace
                case 8:
                  if ($input[0].selectionStart === 0 && scope.index > 0) {
                    scope.onDeleteLeft({index: scope.index});
                  }
                  break;
                // Delete key
                case 46:
                  if ($input[0].selectionStart === scope.label.length) {
                    scope.onDeleteRight({index: scope.index});
                  }
                  break;
                case 32:
                  // Space bar
                  if(scope.addOnSpace()){
                    // Do not add space in pill
                    event.stopPropagation();
                    event.preventDefault();
                  }
                  break;
                case 188:
                  // Comma key
                  if(scope.addOnComma()){
                    // Do not add commas in pill
                    event.stopPropagation();
                    event.preventDefault();
                  }
                  break;
              }
            };

            /**
             * Returns a class for this component
             * @returns {*}
             */
            scope.getClass = function () {
              var c = 'ready ';

              if (scope.isActive) {
                c += 'active ';
              }

              if (!scope.isEditing) {
                c += 'btn btn-default ';
              }

              c += 'bti-pill-type-' + scope.tag.type;

              return c;
            };

            /**
             * Callback when the pill input is on focus
             * @param event
             */
            scope.onInputFocus = function (event) {

            };

            /**
             * When user forcuses out from the edit input field
             * @param event
             */
            scope.onInputBlur = function (event) {
              // Turn off editing mode
              scope.isEditing = false;
              controller.setEditingMode(false);

              // To avoid jump in some browsers
              $input.addClass('ng-hide');

              // Reset error & label to previous state on blur
              if (isRedundant || !isValidLength) {
                isRedundant = false;
                isValidLength = true;
                scope.onRedundantTag({index: scope.index, isRedundant: isRedundant});
                scope.onTagLength({index: scope.index, isValidLength: isValidLength});
                element.removeClass('bento-tags-input-pill-invalid');
              } else {
                var oldLabel = scope.label;
                scope.label = scope.editLabel.trim();

                // Fire callback function
                if(pillchangetimeout){
                  $timeout.cancel(pillchangetimeout);
                }
                pillchangetimeout = $timeout(function () {
                  scope.onPillChange({
                    oldLabel: oldLabel,
                    label: scope.label,
                    index: scope.index
                  });
                });

              }

            };

            /**
             * On edit icon click
             * @param event
             */
            scope.onEditClick = function (event) {

              // ignore if this is not editable
              if (!scope.editable) {
                return;
              }

              scope.isEditing = true;
              scope.editLabel = scope.label;

              $timeout(function () {
                $input = angular.element(element[0].querySelector('input'));
                $input.css('width', sizeRef.offsetWidth + 'px');

                // Wait a bit more for focus
                $timeout(function () {
                  $input[0].select();
                  controller.setEditingMode(true);
                  controller.setActivePill(scope.index);
                  scope.onEdit({index: scope.index});
                }, 100);

              });

              event.stopPropagation();
              event.preventDefault();
            };

            /**
             * On close button click
             * @param event
             */
            scope.onCloseClick = function (event) {
              event.preventDefault();
              event.stopPropagation();
              scope.onClose({index: scope.index});
            };
          }
        }
      }
    ])
  ;

})(angular, window);
(function (undefined) {
  'use strict';

  angular.module('bento.test', [])
    .directive('bentoTest', bentoTestDirFunc)
    .provider('bentoTest', bentoTestProvider)
    .controller('bentoTestDirController', bentoTestDirController)
  ;

  bentoTestDirFunc.$inject = ['bentoTest', '$timeout'];
  /**
   * QE Test directive definition and link
   * @returns {{link: link}}
   */
  function bentoTestDirFunc(bentoTest, $timeout) {
    return {
      controller: 'bentoTestDirController', // API used for children links
      restrict  : 'A', // Attribute ONLY
      require   : ['bentoTest', '^^?bentoTest'],
      link      : function (scope, element, attrs, controllers) {
        var ctrl       = controllers[0],
            parentCtrl = controllers[1],
            isIsolated,
            localWatchCancel,
            idWatchCancel
          ;

        $timeout(function(){
          element[0].removeAttribute('bento-test');
          element[0].removeAttribute('bento-test-attribute-name');
          element[0].removeAttribute('bento-test-isolate');
        });

        if (!bentoTest.isEnabled) {
          // In case Bento Test is enabled again
          bentoTest._onUnmuteOnce(init);
        }else{
          // First time
          init();
        }

        /**
         * Init Link logics
         */
        function init() {
          bentoTest._onMuteOnce(mute);
          ctrl.setParentController(parentCtrl);

          // $watch local elementName & assign
          localWatchCancel = scope.$watch(
            function () {
              return ctrl.elementName;
            },
            function (elName) {
              // Only update it when `bento-test` has a value
              if ((typeof attrs.bentoTest === 'string') && attrs.bentoTest.length > 0) {
                attrs.$set(ctrl.getInheritedAttributeName(), elName);
              }
            }
          );

          // Define isolation value
          isIsolated = (typeof attrs.bentoTestIsolate !== 'undefined') ?
            scope.$eval(attrs.bentoTestIsolate) : bentoTest.isolateByDefault;

          // Test ID needs to be pulled ONLY after all rendering is done
          $timeout(function () {
            if (parentCtrl && !isIsolated) {
              // Watch & update test id if its parent's id changes
              idWatchCancel = scope.$watch(function () {
                  return parentCtrl.elementName;
                },
                function (newElName) {
                  if(newElName){
                    ctrl.addParentElementName(newElName);
                  }
                });
            }
          });
        }

        function mute() {
          localWatchCancel();
          idWatchCancel && idWatchCancel();

          isIsolated =
            localWatchCancel =
              idWatchCancel =
                null;

          bentoTest._onUnmuteOnce(init);
        }

        // Destroy
        scope.$on('$destroy', function () {
          bentoTest._removeCallback(init, mute);
        });
      }
    }
  }

  bentoTestDirController.$inject = ['$scope', '$attrs', '$element', '$timeout', 'bentoTest'];
  /**
   * Bento Test directive controller
   * @param $scope
   * @param $attrs
   */
  function bentoTestDirController($scope, $attrs, $element, $timeout, bentoTest) {
    var ctrl             = this,
        attributeName, inheritedAttributeName,
        childControllers = [],
        parentController,
        cancelDirObserve,
        cancelAttrObserve
      ;

    if (!bentoTest.isEnabled) {
      bentoTest._onUnmuteOnce(init);
    }else{
      init();
    }

    ctrl.addParentElementName = function (parentElName) {

      if (parentElName.length > 0 && ctrl.elementID.length > 0) {
        parentElName += '-';
      }

      ctrl.elementName = parentElName + ctrl.elementID;
    };

    // Add child controller
    ctrl.addChildController = function (childController) {
      if (childControllers.indexOf(childController) === -1) {
        childController.setInheritedAttributeName(ctrl.getInheritedAttributeName());
        childControllers.push(childController);
      }
    };

    // Remove a child controller
    ctrl.removeChildController = function (childController) {
      var index;
      if (index = childControllers.indexOf(childController) > -1) {
        childControllers.splice(index, 1);
      }
    };

    // Set parent controller
    ctrl.setParentController = function (controller) {
      // No need to set parent when this element has its own test attribute name
      if ($attrs.bentoTestAttributeName) {
        return;
      }

      removeFromParentController();
      if (controller) {
        parentController = controller;
        parentController.addChildController(ctrl);
      }
    };

    // Set attribute name
    ctrl.setAttributeName = function (aName) {
      attributeName = aName;
      removeFromParentController();
      ctrl.setInheritedAttributeName(aName);
    };

    // Set Inherited Attribute Name
    ctrl.setInheritedAttributeName = function (aName) {
      // No need to update
      if(aName == inheritedAttributeName) return;

      // Only update when `bento-test` has a value
      if ((typeof $attrs.bentoTest === 'string') && $attrs.bentoTest.length > 0) {
        // get the current El test name
        var elTestName = $attrs[ctrl.getInheritedAttributeName()];
        // Remove old attribute name
        $attrs.$set(ctrl.getInheritedAttributeName(), null);

        // The test value to the new attribute name
        $attrs.$set(aName, elTestName);
      }

      inheritedAttributeName = aName;

      updateChildControllers();
    };

    // Get Inherited Attribute Name
    ctrl.getInheritedAttributeName = function () {
      return inheritedAttributeName || bentoTest.attributeName;
    };

    // Get attribute name
    ctrl.getAttributeName = function () {
      return attributeName || bentoTest.attributeName;
    };

    // Destroy
    $scope.$on('$destroy', function () {
      removeFromParentController();
      bentoTest._removeCallback(init, mute);
    });


    /**
     * Mute Bento Test
     */
    function mute() {
      cancelDirObserve && cancelDirObserve();
      cancelAttrObserve && cancelAttrObserve();

      var attributeToRemove = inheritedAttributeName || bentoTest.attributeName;

      attributeName =
        inheritedAttributeName =
          parentController =
            cancelDirObserve =
              cancelAttrObserve = undefined;
      childControllers = [];

      attributeToRemove = attributeToRemove.replace(/([A-Z])/g, function($1){return "-"+$1.toLowerCase();});

      $element[0].removeAttribute(attributeToRemove);
      bentoTest._onUnmuteOnce(init);
    }


    /**
     * Init controller
     */
    function init() {
      // Add mute listener
      bentoTest._onMuteOnce(mute);
      // Initialize variables
      ctrl.elementID = $attrs.bentoTest;
      ctrl.elementName = $attrs.bentoTest;

      cancelDirObserve = $attrs.$observe('bentoTest', function () {
        ctrl.elementID = $attrs.bentoTest;
        ctrl.elementName = $attrs.bentoTest;
        ctrl.componentName = undefined;

        $timeout(function () {
          $element[0].removeAttribute('bento-test');
        });
      });

      cancelAttrObserve = $attrs.$observe('bentoTestAttributeName', function (newAttributeName) {
        if (newAttributeName) {
          ctrl.setAttributeName(newAttributeName);
        }
      });
    }

    // Remove `ctrl` controller from its parent controller
    function removeFromParentController() {
      if (parentController) {
        parentController.removeChildController(ctrl);
      }
    }

    // Update child controllers
    function updateChildControllers() {
      var child;
      for (var i = 0, len = childControllers.length; i < len; i++) {
        child = childControllers[i];
        child.setInheritedAttributeName(inheritedAttributeName);
      }
    }
  }


  // Main API
  var bentoTestAPI = {
    attributeName: 'bentoTestId',
    isEnabled: false,
    isolateByDefault: false,
    enable: function(){
      bentoTestAPI.unmute();
    },
    disable: function(){
      bentoTestAPI.mute()
    },
    /**
     * Mute all Bento Test directives
     */
    mute: function(){
      bentoTestAPI.isEnabled = false;

      // Call mute callbacks
      // NOTE all callbacks get removed onces called
      if (Array.isArray(bentoTestMuteStack) && bentoTestMuteStack.length) {
        do {
          // pop and call
          bentoTestMuteStack.shift()();
        } while (bentoTestMuteStack[0]);
      }
    },
    /**
     * Unmute all tests
     */
    unmute: function(){
      bentoTestAPI.isEnabled = true;

      // Call onmute callbacks
      // NOTE all callbacks get removed onces called
      if (Array.isArray(bentoTestUnmuteStack) && bentoTestUnmuteStack.length) {
        do {
          // pop and call
          bentoTestUnmuteStack.shift()();
        } while (bentoTestUnmuteStack[0]);
      }
    },
    // Private functions
    // Mute callback
    _onMuteOnce  : function(func){
      if (!bentoTestMuteStack) {
        bentoTestMuteStack = [];
      }

      if (bentoTestMuteStack.indexOf(func) == -1) {
        bentoTestMuteStack.push(func);
      }
    },
    // Unmute callback
    _onUnmuteOnce: function(func){
      if (!bentoTestUnmuteStack) {
        bentoTestUnmuteStack = [];
      }

      if (bentoTestUnmuteStack.indexOf(func) == -1) {
        bentoTestUnmuteStack.push(func);
      }
    },
    // Remove callback
    _removeCallback: function(init,mute){
      var index;
      if(bentoTestMuteStack && ((index = bentoTestMuteStack.indexOf(mute)) > -1)){
        bentoTestMuteStack.splice(index,1);
      }
      if(bentoTestUnmuteStack && ((index = bentoTestUnmuteStack.indexOf(init)) > -1)){
        bentoTestUnmuteStack.splice(index,1);
      }
    }
  };

  var bentoTestMuteStack = [], bentoTestUnmuteStack = [];

  // Implement bentoTestProvider Getter and setters

  /**
   * Implement bentoTestProvider Getter and setters
   */
  // `attributeName`
  Object.defineProperty(bentoTestProvider.prototype,'attributeName',{
    set: function(name){
      bentoTestAPI.attributeName = name;
    },
    get: function(){
      return bentoTestAPI.attributeName;
    }
  });
  // `isEnabled`
  Object.defineProperty(bentoTestProvider.prototype,'isEnabled',{
    set: function(bool){
      bentoTestAPI.isEnabled = bool;
    },
    get: function(){
      return bentoTestAPI.isEnabled;
    }
  });
  // `isolateByDefault`
  Object.defineProperty(bentoTestProvider.prototype,'isolateByDefault',{
    set: function(bool){
      bentoTestAPI.isolateByDefault = bool;
    },
    get: function(){
      return bentoTestAPI.isolateByDefault;
    }
  });

  /**
   * QE Test Provider & its service
   */
  function bentoTestProvider() {

    // Detect and automatically turn on forge
    // Forge support infomation
    // `window.theforge.bentoTest` [boolean]
    this.isEnabled = !!window.theforge && window.theforge.bentoTest;


    // Register global API to turn the test on or off
    window.bento = window.bento || {};
    window.bento.enableBentoTest = bentoTestAPI.unmute;
    window.bento.disableBentoTest = bentoTestAPI.mute;

    // Expose API
    this.$get = [function () {
      return bentoTestAPI;
    }];
  }
})();
(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.toggle', ['bento.services'])
  /**
   * Directive declaration
   */
    .directive('bentoToggle', ['$bentoServices', function ($bentoServices) {

      return {
        restrict   : 'A',
        replace    : true,
        require    : 'ngModel',
        scope      : {
          ngModel    : '=',
          onChange   : '&',
          lockToState: '=',
          isLocked   : '&'
        },
        templateUrl: '../templates/toggle/bento-toggle.html',
        link       : function (scope, element, attrs, ngModelController) {

          if (typeof scope.ngModel === 'undefined') {
            scope.ngModel = false;
          }

          /**
           * Swipe gestures
           */
          var startDragging = false;
          var startX = 0;
          var triggeringDX = element[0].offsetWidth * 0.3; //trigering distance when mouse or touch
                                                           // is moved
          var pointerDown;
          var pointerMove;
          var pointerUp;
          var hasPointerDownListener = false;
          scope.isTouch = $bentoServices.isTouchSupported();

          pointerDown = 'touchstart mousedown';
          pointerMove = 'touchmove mousemove';
          pointerUp = 'touchend mouseup';

          element.on(pointerDown, touchdown);
          hasPointerDownListener = true;
          scope.onKeydown = function (event) {
            if (event.keyCode === 32 || event.keyCode === 13) // Space
            {
              toggle(event);
            }
          };

          /**
           * Touchdown / Mousedown
           * @param event
           */

          function touchdown(event) {

            // ignore toggle event when this is locked
            if (scope.isLocked()) {
              return;
            }

            // ignore user event if there is a one-way lock
            if (typeof scope.lockToState !== 'undefined') {
              if ((scope.lockToState && scope.ngModel) ||
                (!scope.lockToState && !scope.ngModel)) {

                return;
              }
            }

            startDragging = true;
            startX = !!event.originalEvent && event.originalEvent.touches ?
              event.originalEvent.touches[0].pageX : event.pageX;

            element.on(pointerMove, touchmove);
            element.on(pointerUp, toggle);
            element.off(pointerDown, touchdown);
            hasPointerDownListener = false;

            event.stopPropagation(); //disable mousedown on touch devices
          }

          /**
           * Turn ON or OFF based on mouse/touch `x` swipes
           * @param event
           */
          function touchmove(event) {
            var dX = !!event.originalEvent && event.originalEvent.touches ?
              event.originalEvent.touches[0].pageX - startX : event.pageX - startX;
            var absDX = Math.abs(dX);

            // Check deltaX to define ON or OFF
            if (absDX > triggeringDX) {
              if (dX > 0) {
                scope.ngModel = true;
              } else {
                scope.ngModel = false;
              }

              element.off(pointerMove, touchmove);
              element.off(pointerUp, toggle);

              if (!hasPointerDownListener) {
                element.on(pointerDown, touchdown);
                hasPointerDownListener = true;
              }

              // Fire external onChange callback function
              if (!!scope.onChange) {
                scope.onChange({value: scope.ngModel});
              }

              scope.$apply();
              event.stopPropagation(); //disable mousedown on touch devices

            }
            // <FALLBACK> Toggle on touch devices
            // incase draggable area is way too small for fat fingers
            else if (scope.isTouch) {
              toggle(event);
            }
          }

          /**
           * Toggle this main directive
           */
          function toggle(event) {

            // ignore toggle event when this is locked
            if (scope.isLocked()) {
              return;
            }

            // ignore user event if there is a one-way lock
            // double assurance
            if (typeof scope.lockToState !== 'undefined') {
              if ((scope.lockToState && scope.ngModel) ||
                (!scope.lockToState && !scope.ngModel)
              ) {

                return;
              }
            }


            scope.ngModel = !scope.ngModel;

            ngModelController.$setDirty();
            ngModelController.$setTouched();

            // Fire external onChange callback function
            if (!!scope.onChange) {
              scope.onChange({value: scope.ngModel});
            }

            // update listeners
            element.off(pointerMove, touchmove);
            element.off(pointerUp, toggle);

            if (!hasPointerDownListener) {
              element.on(pointerDown, touchdown);
              hasPointerDownListener = true;
            }

            $bentoServices.safeApply(scope);

            event.stopPropagation(); //disable mousedown on touch devices
            event.preventDefault();
          }

        }
      };
    }]);

})(window, window.angular);

(function(angular, undefined) {
    'use strict';
    angular
        .module('bento.toolbar', ['bento.translate', 'bento.services', 'bento.reset', 'bento.cookie'])
        .controller('BentoToolbarController', BentoToolbarController)
        .directive('bentoToolbar', bentoToolbar)
        .directive('bentoToolbarButton', bentoToolbarButton)
        .directive('bentoToolbarDropdown', bentoToolbarDropdown)
        .directive('bentoToolbarNgRepeatComplete', bentoToolbarNgRepeatComplete);

    BentoToolbarController.$inject = ['$scope', '$element', '$timeout'];

    function BentoToolbarController($scope, $element, $timeout) {
        var vm = this;
        vm.initialized = false;
        vm.moreVisible = true;
        vm.moreWidth = 100;
        var oldTData = [];
        vm.oldMoreOpacity = 0;
        var repeatTimeout;
        vm.init = function() {
            if(vm.tData){
                vm.tData.map(function(item,index) {
                    item.isVisible = true;
                    if(oldTData[index]){
                        item.isTransparent = oldTData[index].isTransparent;
                    }
                    return item;
                });
                oldTData = vm.tData;
            }
            vm.initialized = false;
            vm.moreVisible = true; 
            vm.oldMoreOpacity = 0;
            vm.moreWidth = 100;
            var moreButton = $element[0].querySelector('li.more-button');
            if (moreButton) {
                moreButton.style.opacity = vm.oldMoreOpacity;
            }
            
        }
        vm.onRepeatComplete = function() {
            $timeout.cancel(repeatTimeout);
            repeatTimeout = $timeout(function(){
                vm.moreVisible = true;
                //when ng repeat is completed, all list elements are rendered in DOM
                //get list element's widths and set in button data
                var children = $element[0].querySelector('ul.nav.navbar-nav').children;
                if(vm.tData){
                    var index = 0;
                    vm.tData.map(function(item) {
                        if (!item.hidden && children[index]) {
                            item.width = children[index].getAttribute('data-button-width');
                            index++;
                        }

                        return item;
                    });
                }
                var moreButton = $element[0].querySelector('li.more-button');
                if (moreButton) {
                    vm.moreWidth = +moreButton.getAttribute('data-button-width');
                }

                //adjust button in toolbar
                //initialized flag is to prevent window resize 
                //from calling adjustButtons first
                vm.initialized = true;
                vm.adjustButtons();
            },10);
        };

        //Watch toolbar data, and set privately used
        //tData, add custom properties isVisible, isTransparent
        $scope.$watch(function() {
                return (vm.toolbarData);
            },
            function onToolbarData(newValue, oldValue) {
                if ((newValue && !vm.initialized) || !angular.equals(newValue,oldValue)) {
                    vm.tData = angular.copy(newValue);
                    vm.init();
                }
            }, true);
    }
    bentoToolbar.$inject = ['$timeout', '$window'];

    function bentoToolbar($timeout, $window) {
        return {
            restrict: 'A',
            scope: {},
            transclude: {
                'navbarLeft': '?navbarLeft',
                'navbarRight': '?navbarRight'
            },
            controller: 'BentoToolbarController',
            controllerAs: 'bentoToolbarCtrl',
            bindToController: {
                'toolbarData': '=',
                'moreButtonLabel': '='
            },
            templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/toolbar/bento-toolbar.html';
            },
            link: function(scope, element, attrs, toolbarCtrl) {
                var resizeTimer,initTimeout;

                toolbarCtrl.adjustButtons = adjustButtons;

                angular.element($window).bind('resize', onElementResize);
                //scope.$watch(getElementWidth, onElementResize);
                scope.$on('$destroy', onDestroy);
                element.on('$destroy', onDestroy);

                function getElementWidth() {
                    return element[0].offsetWidth;
                }

                function onWindowResize() {
                    scope.$apply();
                }

                function onElementResize(width) {
                    if (resizeTimer) {
                        $timeout.cancel(resizeTimer);
                    }
                    resizeTimer = $timeout(function() {
                        adjustButtons();
                    });
                }
                scope.$on('bentoToolbarRefresh', onRefresh);
                scope.$on('bentoToolbarResize', onElementResize);

                function onRefresh() {
                    initTimeout = $timeout(function() {
                        toolbarCtrl.init();
                        toolbarCtrl.onRepeatComplete();
                    });
                }

                function onDestroy() {
                    angular.element($window).unbind('resize', onElementResize);
                    $timeout.cancel(initTimeout);
                }

                function adjustButtons() {
                    if (!toolbarCtrl.initialized) {
                        return;
                    }
                    if(!toolbarCtrl.tData || toolbarCtrl.tData.length===0){
                        return;
                    }
                    var tData = toolbarCtrl.tData; //toolbar button data
                    var totalWidth = 0; //reset total width of cumulative button widths
                    var elWidth = getElementWidth(); //get width of toolbar container
                    var navbarRight = element[0]
                        .querySelector('div.toolbar-navbar-right');
                    var navBarRightWidth = navbarRight ? +navbarRight.offsetWidth : 0; //get width of right nav
                    var navbarLeft = element[0]
                        .querySelector('div.toolbar-navbar-left');
                    var navBarLeftWidth =  navbarLeft ? +navbarLeft.offsetWidth : 0; //get width of left nav
                    var moreWidth = toolbarCtrl.moreWidth; //get width of more button
                    var pad = navBarRightWidth > 0 ? 5 : 40; //extra pad
                    var staticWidth = 0;
                    if (tData) {
                        //Iterate through buttons, 
                        //and display if cumulative width is 
                        //less than container width
                        for (var i = 0, il = tData.length; i < il; i++) {
                            var td = tData[i];
                            if(!td.width){
                                continue;
                            }
                            if(td.hidden){
                                continue;
                            }
                            if(td.static){
                                staticWidth += +td.width;
                            }
                            totalWidth += +td.width;
                            var accumulatedWidth = (totalWidth + moreWidth + pad + navBarRightWidth + navBarLeftWidth);
                            var targetWidth = (elWidth - staticWidth);


                            if (accumulatedWidth < targetWidth) {
                                td.isVisible = true;
                                td.isTransparent = false;
                            } else {
                                td.isVisible = false;
                                td.isTransparent = true;
                            }
                            if(td.static){
                                td.isVisible = true;
                                td.isTransparent = false;
                            }
                        }

                        toolbarCtrl.moreVisible = true;

                        // to adjust opacity of more button, need to wrap in timeout for window resize
                        $timeout(function(){
                            var moreButton = element[0].querySelector('li.more-button');
                            if (moreButton) {
                                moreButton.style.opacity = 1;
                                toolbarCtrl.oldMoreOpacity = moreButton.style.opacity;
                            }
                        })

                        if (tData[il - 1].isVisible === true) {
                            if (totalWidth + pad + navBarRightWidth + navBarLeftWidth < elWidth) {
                                toolbarCtrl.moreVisible = false;
                            }
                        }
                    }
                }
            }
        }
    }
    bentoToolbarButton.$inject = ['$timeout'];

    function bentoToolbarButton($timeout) {
        return {
            restrict: 'A',
            require: '^bentoToolbar',
            link: function(scope, element, attr, ctrl) {
                var el = element[0];
                // var width = getTotalWidth(el);
                scope.$watch(function() {
                    return el.offsetWidth;
                }, function(newValue, oldValue) {
                    var width = getTotalWidth(el);
                    el.setAttribute('data-button-width', width);
                    if(oldValue === 0 || oldValue === undefined){
                        ctrl.onRepeatComplete();
                    }
                });

                function getTotalWidth(el) {
                    var style = el.currentStyle || window.getComputedStyle(el);
                    var width = Math.ceil(el.offsetWidth) +
                        parseFloat(style.paddingLeft) +
                        parseFloat(style.paddingRight) +
                        parseFloat(style.marginLeft != "auto" ? style.marginLeft : 0) +
                        parseFloat(style.marginRight != "auto" ? style.marginRight : 0);
                    return width;
                }
            }
        }
    }
    bentoToolbarNgRepeatComplete.$inject = ['$timeout'];

    function bentoToolbarNgRepeatComplete($timeout) {
        return {
            restrict: 'A',
            require: '^bentoToolbar',
            link: function(scope, element, attr, ctrl) {
                if (scope.$last === true) {
                    $timeout(function() {
                        ctrl.onRepeatComplete(element);
                    });
                }
            }
        }
    }

    bentoToolbarDropdown.$inject = ['$parse', '$window', '$timeout', '$compile'];

    function bentoToolbarDropdown($parse, $window, $timeout, $compile) {
        return {
            restrict: 'A',
            controller: function() {
                var vm = this;
                vm.isOpen = false;
                vm.toggle = function(button) {
                    if (!button.disabled) {
                        vm.isOpen = !vm.isOpen;
                    }
                }
            },
            controllerAs: 'bentoToolbarDropdownCtrl',
            bindToController: {},
            link: function(scope, element, attrs, ctrl) {

            }
        };
    }

})(window.angular);
(function(angular){

  'use strict';

  var translateApp = angular.module('bento.services');

  translateApp
    .provider('$bentoTranslateLoader',function(){
      var urlPatterns = [];

      // Pushing a new pattern onto the pattern stack for loading later
      this.addURLPattern = function(pattern){
        urlPatterns.push(pattern);
      };

      /**
       * Loader Factory
       * @type {*[]}
       */
      this.$get = ['$http', '$q', function($http, $q){
        // return loaderFn
        return function (options) {

          var deferred = $q.defer();
          var filePatternArray = urlPatterns.slice(0);
          var languageData = {};
          var counter = 0;

          loadLanguageFile();

          function loadLanguageFile(){
            // pop and get the top time from the stack
            var url = filePatternArray.pop().replace('{lang}',options.key);
            $http({method: 'GET', url: url}).
              then(function(res) {
                // this callback will be called asynchronously
                // when the response is available
                addAndCheckFile(res.data);
              }).
              catch(function(res) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                addAndCheckFile();
              });
          }

          function addAndCheckFile(data){

            if(!!data) {
              for (var key in data) {
                if(!!data[key]) {
                  languageData[key] = data[key];
                  counter += 1;
                }
              }
            }

            if(filePatternArray.length > 0){
              loadLanguageFile();
            }else{
              if(counter > 0){
                deferred.resolve(languageData);
              }else{
                deferred.reject(options.key);
              }
            }
          }
          return deferred.promise;
        };
      }];
    });

})(window.angular);

(function () {

  /*
   DO NOT CHANGE!!
   This is Bento.UI's default translation variable.
   All new translations must be updated or overwritten with its API.

   See: http://bento.ui.int.thomsonreuters.com/#/components/translate
   Default Locale: `en-us`
   */
  var BENTO_TRANSLATE_DEFAULT = {
    // Component Translations
    "BENTO_UI_ALERT_DESCRIPTION"                      : "You have alerts, press tab key to continue.",
    "BENTO_UI_ALERT_CLOSE_BUTTON"                     : "Close alert.",
    "BENTO_UI_BUSY_LOADER_LOADING"                    : "Loading content. ",
    "BENTO_UI_FILE_SELECTOR_DESCRIPTION"              : "This is file selector, press Tab key to proceed to the browse button",
    "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON"            : "Press enter key to Browse file",
    "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL"      : "Browse for File",
    "BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL"         : "Drag a File Here or",
    "BENTO_UI_FILE_SELECTOR_FILE_NAME"                : "File _FILE_NUMBER_ of _NUM_FILES_, file name: _FILE_NAME_",
    "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS"     : " loading",
    "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE"     : " loading complete",
    "BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON"            : "Remove _FILE_NAME_",
    "BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE"          : "_FILE_NAME_ is removed",
    "BENTO_UI_MULTISELECT_OVERLAY_DESCRIPTION"        : "Multiselect menu, press Enter key to start selecting.",
    "BENTO_UI_MULTISELECT_OVERLAY_CONTENT_DESCRIPTION": "Tab to navigate through the content. Enter key to select or toggle.  Escape key to dismiss the selection.",
    "BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO"  : "All (NUMBER) selected",
    "BENTO_UI_MULTISELECT_OVERLAY_CANCEL"             : "Cancel",
    "BENTO_UI_MULTISELECT_OVERLAY_CANCEL_DESCRIPTION" : "Enter key or space bar to confirm and cancel the selections.",
    "BENTO_UI_MULTISELECT_OVERLAY_DONE"               : "Done",
    "BENTO_UI_MULTISELECT_OVERLAY_DONE_DESCRIPTION"   : "Enter key or space bar to confirm and apply the selections.",
    "BENTO_UI_MULTISELECT_OVERLAY_EDIT"               : "Edit",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECT"             : "Select",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL"         : "Select All",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO"      : "NUMBER selected",
    "BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL"           : "Show All",
    "BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED"      : "Show Selected",
    "BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL"       : "Search Item Text Field",
    "BENTO_UI_PAGINATION_GO_BUTTON"                   : "Go",
    "BENTO_UI_PAGINATION_INFO_PAGE_TEXT"              : "Page _PAGE_ of _PAGES_",
    "BENTO_UI_PAGINATION_INFO_TEXT"                   : "_START_ to _END_ of _MAX_",
    "BENTO_UI_SPLITTER_GROUP"                         : "This is a splitter group, press Tab key to proceed to its contents.",
    "BENTO_UI_SPLITTER_GROUP_TOP_BAR"                 : "Splitter Group top group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR"              : "Splitter Group bottom group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_LEFT_BAR"                : "Splitter Group left group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_RIGHT_BAR"               : "Splitter Group right group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_TOP_PANEL"               : "Splitter Group top panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_BOTTOM_PANEL"            : "Splitter Group bottom panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_LEFT_PANEL"              : "Splitter Group left panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_RIGHT_PANEL"             : "Splitter Group right panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_MAIN_PANEL"              : "Splitter Group main panel, press Tab key to proceed.",
    "BENTO_UI_TILE_RIBBON_TOGGLE_SHOW"                : 'Show',
    "BENTO_UI_TILE_RIBBON_TOGGLE_HIDE"                : 'Hide',
    "BENTO_UI_TOGGLE_ON"                              : "Toggle is on. Space bar to turn it off",
    "BENTO_UI_TOGGLE_OFF"                             : "Toggle is off. Space bar to turn it on",
    "BENTO_UI_TOOLBAR_MORE"                           : "More",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE"              : "Add",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO"              : "Remove",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT"                  : "Transfer",
    "BENTO_UI_TRANSFER_BOX_INFO_TEXT"                 : "_SELECTED_ of _TOTAL_ Checked",
    "BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD"        : 'Add',
    "BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE"     : 'Remove',
    "BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT"         : 'Search',
    "BENTO_UI_TREE_EXPANDED"                          : "expanded",
    "BENTO_UI_TREE_COLLAPSED"                         : "collapsed",
    "BENTO_UI_TREE_EXPAND_ALL"                        : 'Expand All',
    "BENTO_UI_TREE_COLLAPSE_ALL"                      : 'Collapse All',
    "BENTO_UI_WIZARD_DESCRIPTION"                     : "Wizard to complete a process. Tab key to proceed to wizard steps.  Enter key to select each wizard step and its content.",
    "BENTO_UI_WIZARD_STEP_NAME"                       : "Wizard Step Title.",
    "BENTO_UI_WIZARD_BUTTON_CANCEL"                   : "Cancel",
    "BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION"       : "Cancel",
    "BENTO_UI_WIZARD_BUTTON_DONE"                     : "Done",
    "BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION"         : "Done with the last step.",
    "BENTO_UI_WIZARD_BUTTON_NEXT"                     : "Next",
    "BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION"         : "Proceed to next step.",
    "BENTO_UI_WIZARD_BUTTON_PREVIOUS"                 : "Previous",
    "BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION"     : "Back to previous step.",
    // Static translations
    "BENTO_UI_TODAY"                                  : "Today",
    "BENTO_UI_TOMORROW"                               : "Tomorrow",
    "BENTO_UI_YESTERDAY"                              : "Yesterday",
    "BENTO_UI_N_DAY_AGO"                              : "_NUMBER_ Days Ago",

    // A11Y translations
    // Transferbox
    "BENTO_UI_A11Y_TBOX_BOX1_LABEL"                   : "Source Box",
    "BENTO_UI_A11Y_TBOX_BOX2_LABEL"                   : "Destination Box",
    "BENTO_UI_A11Y_TBOX_ADD_LABEL"                    : "Add items from ",
    "BENTO_UI_A11Y_TBOX_REMOVE_LABEL"                 : "Remove items from ",
    "BENTO_UI_TBOX_TOGGLE_FILTERS"                    : "Toggle Filters",

    // Pagination
    "BENTO_UI_TBOX_PAGINATION_FIRST"                  : "Goto First Page",
    "BENTO_UI_TBOX_PAGINATION_NEXT"                   : "Goto Next Page",
    "BENTO_UI_TBOX_PAGINATION_PREVIOUS"               : "Goto Previous Page",
    "BENTO_UI_TBOX_PAGINATION_LAST"                   : "Goto Last Page",
    "BENTO_UI_TBOX_PAGINATION_PAGE_NUM"               : "Enter Page number to Goto",
    "BENTO_UI_TBOX_PAGINATION_GOTO_PAGE"              : "Goto Page",
    "BENTO_UI_TBOX_PAGINATION_ITEMS_PER_PAGE"         : "Items Per Page",

    // scrollable bar
    "BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT"             : "Scroll Left",
    "BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT"            : "Scroll Right",

  };

  angular.module('bento.translate', ['bento.services'])
    /**
     * Setting up the translate
     */
    .run([
      '$bentoTranslate',
      function ($bentoTranslate) {

        $bentoTranslate.setTranslation(
          BENTO_TRANSLATE_DEFAULT,
          true // To avoid $apply in init cycle since the first cycle will be automatically applied.
        );

      }])
    /**
     * Bento Translate Main Filter
     */
    .filter('bentoTranslate', [
      '$bentoTranslate',
      function ($bentoTranslate) {

        function bentoTranslateFilter(label, override) {

          // Use override
          if (!!override && override.trim().length > 0) {
            return override;
          }

          return $bentoTranslate._translate(label);
        }

        bentoTranslateFilter.$stateful = true;

        return bentoTranslateFilter;
      }])
    /**
     * Factory to support various useful functions
     */
    .factory('$bentoTranslate', [
      '$http',
      '$bentoServices',
      '$rootScope',
      '$q',
      '$log',
      function ($http, $bentoServices, $rootScope, $q, $log) {
        var _data         = {},
            isLoading     = true,
            promiseStack  = [],
            callbackStack = [];

        // Add a callback to stack
        function onChange(fn) {
          callbackStack.push(fn);
        }

        // Remove a callback from stack
        function removeOnChange(fn) {
          var i = callbackStack.indexOf(fn);
          if (i > -1) {
            callbackStack.splice(i, 1);
          }
        }

        // Set custom data
        function set(data, bypassApply) {
          for (var key in data) {
            _data[key] = data[key];
          }
          isLoading = false;

          _fireCallbacks();

          // To avoid apply conflicts in init cycle
          if (!bypassApply) {
            $bentoServices.safeApply($rootScope);
          }
        }

        // Add translation key
        function add(key, translation) {
          if (hasData()) {
            _data[key] = translation;
            _fireCallbacks();
          }
        }

        // Get custom data
        function get() {
          return _data;
        }

        // Load a new set of translation
        function load(url) {
          isLoading = true;
          $http.get(url)
            .then(function (res) {
              isLoading = false;
              set(res.data);
              resolvePromises(true);
              $bentoServices.safeApply($rootScope);
            })
            .catch(function () {
              $log.error('Bento Translate: Unable to load ' + url);
              resolvePromises(false);
              isLoading = false;
            })
        }

        // Has translation in this factory/service
        function hasData() {
          return !!_data;
        }

        // Resolve all promises
        function resolvePromises() {
          var p;
          while (promiseStack.length > 0) {
            p = promiseStack.pop();
            p.deferred.resolve(_translate(p.label));
          }
        }

        // Public API for translate
        function translate(label) {
          var deferred = $q.defer();

          // Still loading translation need to wait
          if (isLoading) {
            promiseStack.push({label: label, deferred: deferred});
          } else {
            deferred.resolve(_translate(label));
          }

          return deferred.promise;
        }

        // Private API for translate
        // Offers instant possible translation
        // Not suiTable for server loadings
        function _translate(label) {
          if (hasData()) {
            if (_data[label]) {
              return _data[label];
            } else {
              return label;
            }
          } else {
            return label;
          }
        }

        // fire all callbacks
        function _fireCallbacks() {
          for (var i in callbackStack) {
            callbackStack[i]();
          }
        }

        return {
          add           : add,
          getTranslation: get,
          hasTranslation: hasData,
          load          : load,
          onChange      : onChange,
          removeOnChange: removeOnChange,
          setTranslation: set,
          translate     : translate,
          //Private API
          _translate    : _translate
        };
      }
    ])
  ;

})();

(function() {
    'use strict';

    angular.module('bento.transferbox', [
        'bento.cookie',
        'bento.translate'
    ])
        .controller('bentoFlexgridTransferBoxController', transferboxController)
        .directive('bentoFlexgridTransferbox', transferbox)

    transferboxController.$inject = ['$timeout', '$scope', '$window', 'flexGridSetUpService'];

    function transferboxController($timeout, $scope, $window, flexGridSetUpService) {
        var vm = this;
        // to debounce resize event
        var resizeTimer;
        /**** CONFIG ***/
        vm.config = {
            boxOneTitle: "Available Users",
            boxTwoTitle: "Available Users",
            infoText: undefined,
            transferBtnText: undefined,
            transferBtnTextOne: "Add",
            transferBtnTextTwo: "Remove",
            paginationInfoText: undefined,
            paginationGoText: undefined,
            paginationInfoPageText: undefined,
            boxOneInfoShown: true,
            boxTwoInfoShown: true,
            disableTransfer: false
        };
        vm.transferItems = transferItems;
        vm.style = {
            height: vm.config.height + 'px'
        }
        $scope.$watch('columnDefinitions', function(columnDefinitions) {
            vm.columnDefinitions = columnDefinitions;
        });
        $scope.$watch('height', function(height) {
            vm.config.height = height;
            vm.style.height = height + 'px';
        });
        $scope.$watchCollection('boxOneItemSource', function(data) {
            vm.gridDataOne = data
        });
        $scope.$watchCollection('boxTwoItemSource', function(data) {
            vm.gridDataTwo = data
        });

        var gridOneWatch = $scope.$watch(function() {
            return vm.box1;
        }, function(box1) {
            if (box1) {
                if (typeof $scope.control === "object") {
                    $scope.control.gridOne = box1;
                }
                gridOneWatch();
            }
        });
        var gridTwoWatch = $scope.$watch(function() {
            return vm.box2;
        }, function(box2) {
            if (box2) {
                if (typeof $scope.control === "object") {
                    $scope.control.gridTwo = box2;
                }
                gridTwoWatch();
            }
        });

        vm.onSplitterResize = function onSplitterResize() {
          // simple debounce
          clearTimeout(resizeTimer);

          resizeTimer = $timeout(function() {
            $scope.$broadcast('bentoTransferBoxResize')
          }, 100);
        }

        vm.checkItemsOne = function (items, gridData){
            if (!!$scope.onBeforeTransfer) {
                $scope.onBeforeTransfer({
                    fromData: items,
                    toData: gridData,
                    transferItemsFn: vm.transferItemsOne
                });
            } else {
                vm.transferItemsOne(items,gridData);
            }
        }
        vm.checkItemsTwo = function (items, gridData){
            if (!!$scope.onBeforeTransfer) {
                // $scope.onBeforeTransfer(items, gridData, vm.transferItemsTwo);
                $scope.onBeforeTransfer({
                    fromData: items,
                    toData: gridData,
                    transferItemsFn: vm.transferItemsTwo
                });
            } else {
                vm.transferItemsTwo(items,gridData);
            }
        }
        vm.transferItemsOne = function (items, gridData) {
                vm.gridDataTwo = items.concat(vm.gridDataTwo);
                vm.gridDataOne = gridData;
                vm.transferItems();
        }
        vm.transferItemsTwo = function (items, gridData) {
                vm.gridDataOne = items.concat(vm.gridDataOne);
                vm.gridDataTwo = gridData;
                vm.transferItems();
        }

        function transferItems() {
            // //strip out select property
            // vm.gridDataOne.forEach(function(obj) {
            //     delete obj.bentoTboxSelect;
            // });
            // vm.gridDataTwo.forEach(function(obj) {
            //     delete obj.bentoTboxSelect;
            //     console.log('strip',obj)
            // });

            $scope.boxOneItemSource = vm.gridDataOne;
            $scope.boxTwoItemSource = vm.gridDataTwo;

            $scope.onTransfer({
                gridDataOne: vm.gridDataOne,
                gridDataTwo: vm.gridDataTwo
            });
        }
    }

    transferbox.$inject = ['$timeout'];

    function transferbox($timeout) {
        return {
            restrict: 'AE',
            scope: {
                boxOneItemSource: '=',
                boxTwoItemSource: '=',
                columnDefinitions: '=',
                control: '=?',
                desktopMode: '=?',
                boxOneTitle: '@',
                boxTwoTitle: '@',
                infoText: '@',
                transferBtnText: '@',
                transferBtnTextOne: '@',
                transferBtnTextTwo: '@',
                height: '=',
                childItemsPath: '=?',
                hidePagination: '=?',
                onBeforeTransfer: '&?',
                onTransfer: '&',
                uniqueKey: '@',
                paginationInfoText: '@',
                paginationGoText: '@',
                paginationInfoPageText: '@',
                showFilters: '=?',
                gridTemplateUrl: '=?',
                disableTransfer: '=?',
                leftWidth: '=?'
            },
            controller: 'bentoFlexgridTransferBoxController',
            controllerAs: 'bentoTransferBoxCtrl',
            templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/transfer_box/bento-flexgrid-transferbox-base.html';
            },
            replace: true,
            link: function(scope, element, attrs, tBoxCtrl) {
                for (var key in tBoxCtrl.config) {
                    if (key in attrs.$attr) {
                        tBoxCtrl.config[key] = attrs[key];
                    }
                }
                attrs.$observe('boxOneTitle', function(title) {
                    tBoxCtrl.config.boxOneTitle = title;
                });
                attrs.$observe('boxTwoTitle', function(title) {
                    tBoxCtrl.config.boxTwoTitle = title;
                });
                scope.$watch('disableTransfer', function(disableTransfer){
                    tBoxCtrl.config.disableTransfer = disableTransfer;
                });
                scope.control = {
                    toggleAll: toggleAll
                };
                function toggleAll(box) {
                    if (box === 1) {
                        if (tBoxCtrl.box1) {
                            tBoxCtrl.box1.toggleAll();
                        }
                    } else {
                        if (tBoxCtrl.box2) {
                            tBoxCtrl.box2.toggleAll();
                        }
                    }
                }
            }
        }
    }
}());
(function(undefined) {
  'use strict';

  angular.module('bento.transferbox')
      .controller('bentoFlexgridTBoxController', tboxController)
      .directive('bentoFlexgridTbox', tbox)

  tboxController.$inject = ['$timeout', '$scope', '$element', 'flexGridSetUpService', '$bentoServices', '$bentoTranslate'];

  function tboxController($timeout, $scope, $element, flexGridSetUpService, $bentoServices, $bentoTranslate) {
      if (typeof wijmo === 'undefined') {
          return;
      }
      var vm = this;
      var hasInitialized = false;
      var hasPaginized = false;
      var multiSelectPanelObj;
      var columnHeaderCheckBox = undefined;
      var originalWijmoFilter;
      /**** CONFIG ***/
      vm.defaults = {
          page: 1,
          pageSize: 25,
          collectionView: undefined,
          offsetHeight: 162,
          paginationOffsetHeight: 96
      };
      vm.selectedItems = [];
      vm.searchBoxFilter;
      vm.scrollableBarControllerLeft = {};
      vm.scrollableBarControllerRight = {};
      vm.tBoxAriaLabel = {
        tboxSelectedAriaLabel: '',
        boxOneAriaLabel: '',
        boxTwoAriaLabel: ''
      }
      $scope.filter;

      $scope.ctx = {
        filterButtonHidden: false,
        groupButtonHidden: true,
        columnButtonHidden: false,
        filtersHidden: false
      };

      vm.$onInit = function() {
        var translations = $bentoTranslate.getTranslation();

        var setAriaTags = function() {
          $element[0].setAttribute('aria-labelledby', $bentoServices.generateUID());
          $element[0].setAttribute('aria-describedby', $bentoServices.generateUID());
          var el;
          el = $element[0].querySelector('.container-title');
          el.setAttribute('id', $element[0].getAttribute('aria-labelledby'));

          el = $element[0].querySelector('.container-info');
          el ? el.setAttribute('id', $element[0].getAttribute('aria-describedby')) : '';
        }
        $element[0].setAttribute('role', 'Grid');
        $timeout(function() {
          if(vm.boxOne) {
            vm.tBoxAriaLabel.tboxSelectedAriaLabel = translations.BENTO_UI_A11Y_TBOX_BOX1_LABEL;
            vm.tBoxAriaLabel.boxOneAriaLabel = translations.BENTO_UI_A11Y_TBOX_BOX1_LABEL;
            setAriaTags();
          } else {
            vm.tBoxAriaLabel.tboxSelectedAriaLabel = translations.BENTO_UI_A11Y_TBOX_BOX2_LABEL;
            vm.tBoxAriaLabel.boxTwoAriaLabel = translations.BENTO_UI_A11Y_TBOX_BOX2_LABEL;
            setAriaTags();
          }

          // make searchbox accessible - a11y
          var inputEl = $element[0].querySelector('.bento-search input');
          if(inputEl) {
            var uid = $bentoServices.generateUID();
            var label = translations.BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT;
            inputEl.setAttribute('id', uid);
            vm.updateLabel(inputEl, vm.tBoxAriaLabel.tboxSelectedAriaLabel + ' ' + label);
          }

          // toggle filter aria-label change
          var el = $element[0].querySelector('.toggle-button-order button');
          if(el) {
            vm.updateLabel(el, vm.tBoxAriaLabel.tboxSelectedAriaLabel + ' ' + translations.BENTO_UI_TBOX_TOGGLE_FILTERS);
          }

          // add and remove button aria-label
          el = $element[0].querySelector('.transfer-button-order button');
          if(el) {
            var label = (vm.boxOne ? 
                        translations.BENTO_UI_A11Y_TBOX_ADD_LABEL :
                        translations.BENTO_UI_A11Y_TBOX_REMOVE_LABEL) +
                        vm.tBoxAriaLabel.tboxSelectedAriaLabel;
            vm.updateLabel(el, label);
          }
        });
      }

      vm.updateLabel = function(el, overrideText) {
        if(overrideText) {
          el.setAttribute('aria-label', overrideText);
        } else {
          var label = el.getAttribute('aria-label');
          el.setAttribute('aria-label', vm.tBoxAriaLabel.tboxSelectedAriaLabel + ' ' + label);
        }
      }

      vm.globalFilterTextChange = function () {
        if ($scope.filter) {
          $scope.filter.apply();
        }
      }
      vm.toggleFilter = function () {
        $scope.filter.showFilterIcons = !$scope.filter.showFilterIcons;
      }

      vm.filterApplied = function (filter) {
        initCustomFilterFun(filter);
      }

      vm.initFilter = function initFilter(filter) {
        $scope.filter = filter;
        initCustomFilterFun(filter);
      }

      vm.$postLink = function () {
        vm.controllerLeft = vm.scrollableBarControllerLeft;
        vm.controllerRight = vm.scrollableBarControllerRight;
      };
  
      function onRefresh(){
        if(vm.scrollableBarControllerLeft){
          vm.scrollableBarControllerLeft.refresh();
        }
        if(vm.scrollableBarControllerRight){
          vm.scrollableBarControllerRight.refresh();
        }
      }

      function initCustomFilterFun(filter) {
        var filterFun = function (item) {
          //check if item satisfies default filters
          var filCols = filter.filterColumns;
          if (!filCols) {
            filCols = filter.grid.columns.map(function (col) { return col.binding; });
          }
          for (var i = 0; i < filCols.length; i++) {
            var colBinding = filCols[i];
            var colFil = filter.getColumnFilter(colBinding);
            if (!colFil.apply(item)) {
              return false;
            }
          }
          //passes default filters now check for custom filter/filters
          //if globalFilterText does not exists then it passes filter, return true
          if (!vm.globalFilterText) {
            return true;
          }

          var searchString = vm.globalFilterText.toLowerCase();
          //ceck lif global filter text is present in any of the entries
          for (var key in item) {
            var curValue = item[key].toString().toLowerCase();
            if (curValue.indexOf(searchString) >= 0) {
              //passses global filter, return true
              return true;
            }
          }
          //failed global filter
          return false;
        };
        if (filter.grid.collectionView) {
          filter.grid.collectionView.filter = filterFun;
        }
      }
    
      //Watch config file from base
      $scope.$watch('config', function(config) {
          vm.config = angular.extend(angular.copy(vm.defaults), config);
      });
      //watch titles
      $scope.$watch('config.boxOneTitle', function(title) {
          vm.config.boxOneTitle = title
      });
      $scope.$watch('config.boxTwoTitle', function(title) {
          vm.config.boxTwoTitle = title
      });
      //flag for first transfer box grid, 
      //used in template for display left or right aligned titles and buttons
      $scope.$watch('boxOne', function(boxOne) {
          vm.boxOne = boxOne;
      });
      $scope.$on('$destroy', vm.onDestroy);
        vm.flexGrid = undefined;
        vm.togglePagination = togglePagination;
        vm.initialized = function(s, e) {
      }

      vm.itemFormatter = function(panel, r, c, cell) {
      }
      vm.transferItems = function() {
          //Seperate the row items to selected and non selected arrays

          var sourceCollection = vm.config.collectionView.sourceCollection;
          vm.selectedItems = [];
          var gridItems = [];
          var sCount = 0,
              gCount = 0;
          for (var i = 0, ttl = sourceCollection.length; i < ttl; i++) {
              var item = sourceCollection[i];
              if (item.bentoTboxSelect === true) {
                  vm.selectedItems[sCount] = item;
                  sCount++;
              } else {
                  gridItems[gCount] = item;
                  gCount++;
              }
          }
          $scope.transferItems({
              items: vm.selectedItems,
              gridData: gridItems
          });

      };
      vm.onDestroy = function() {
          if ($scope.showFilters != false &&
              vm.config &&
              vm.config.collectionView
          ) {
              vm.config.collectionView.collectionChanged.removeHandler(onCollectionChanged);
          }
      }
      //MULTI-SELECT Checkbox
      vm.CHECKBOX_INDETERMINATE = 0;
      vm.CHECKBOX_UNSELECTED = 1;
      vm.CHECKBOX_SELECTED = 2;
      vm.headerCheckBoxMode = vm.CHECKBOX_UNSELECTED;

      vm.onCheckBoxChange = function($item) {
          //if $item parameter passed, that means it's from click event in template
          if($item){
              $item.bentoTboxSelect = !$item.bentoTboxSelect;
              var childItems;
              //if $item has children
              if(vm.childItemsPath && $item[vm.childItemsPath]){
                  childItems = $item[vm.childItemsPath];
              }
              //if $item has parent
              if($item.parentItem){
                  $item.parentItem.bentoTboxSelect = $item.bentoTboxSelect;
                  childItems = $item.parentItem[vm.childItemsPath];
              }
              //if childrent items available
              if(childItems){
                  childItems.forEach(function(childItem){
                      childItem.bentoTboxSelect = $item.bentoTboxSelect;
                  });                    
              }
          }
          vm.selectedItems = vm.config.collectionView.sourceCollection.filter(function(item) {
              return (item.bentoTboxSelect === true);
          });
          
        vm.updateHeaderCheckBox();
      };

      vm.onHeaderCheckBoxChange = function() {
        var selected = false;
        if (vm.headerCheckBoxMode !== vm.CHECKBOX_SELECTED) {
          vm.headerCheckBoxMode = vm.CHECKBOX_SELECTED;
          selected = true;
        } else {
          vm.headerCheckBoxMode = vm.CHECKBOX_UNSELECTED;
          selected = false;
        }
        for (var i = 0, ttl = vm.flexGrid.rows.length; i < ttl; i++) {
          //logic for disabled checkbox
          if(!vm.flexGrid.rows[i].dataItem.disabled){
            vm.flexGrid.rows[i].dataItem.bentoTboxSelect = selected;
          }

          vm.flexGrid.rows[i].cssClass = vm.flexGrid.rows[i].dataItem.bentoTboxSelect ? 'tbox-row-selection-bg' : '';
        }

        vm.selectedItems = vm.config.collectionView.sourceCollection.filter(function(item) {
            return (item.bentoTboxSelect === true);
        });
      };

      vm.updateHeaderCheckBox = function() {
        vm.headerCheckBoxMode = vm.CHECKBOX_UNSELECTED;
        var count = 0;
        if(!vm.flexGrid){
          return;
        }
        for (var i = 0, ttl = vm.flexGrid.rows.length; i < ttl; i++) {
          if (vm.flexGrid.rows[i].dataItem.bentoTboxSelect === true) {
            count++;
          }
          vm.flexGrid.rows[i].cssClass = vm.flexGrid.rows[i].dataItem.bentoTboxSelect ? 'tbox-row-selection-bg' : '';
        }

        if (count === vm.flexGrid.rows.length && vm.flexGrid.rows.length > 0) {
          vm.headerCheckBoxMode = vm.CHECKBOX_SELECTED;
        } else if (count > 0) {
          vm.headerCheckBoxMode = vm.CHECKBOX_INDETERMINATE;
        }
      };

      vm.toggleAll = function() {
          vm.onHeaderCheckBoxChange();
      };

      vm.onFilterInput = function(boxId) {
        if(vm.columnFilter) {
          vm.columnFilter.clear();
        }

        if(vm.searchBoxFilter && vm.searchBoxFilter.length) {
          if(vm.config.collectionView.filter !== allColumnFilter) {
            originalWijmoFilter = vm.config.collectionView.filter;
            vm.config.collectionView.filter = allColumnFilter;
          }
        } else {
          vm.config.collectionView.filter = originalWijmoFilter;
        }
        vm.config.collectionView.refresh();
      };

      //listens to event to refresh grid 
      $scope.$on('bentoTransferBoxResize', function onTransferBoxResize() {
        if (vm.flexGrid) {
          vm.flexGrid.invalidate();
          (vm.scrollableBarControllerLeft && vm.scrollableBarControllerLeft.refresh) ? vm.scrollableBarControllerLeft.refresh() : '';
          (vm.scrollableBarControllerRight && vm.scrollableBarControllerRight.refresh) ? vm.scrollableBarControllerRight.refresh() : '';
        }
      });

      $scope.$watch('hidePagination', togglePagination);

      //watch for initialization of grid
      var removeFlexGridWatch = $scope.$watch(
          function() {
              return vm.flexGrid
          },
          function(grid) {
              if (!grid || hasInitialized) return;
              if (!$scope.hidePagination) {
                  setupPagination(grid);
              } else {
                  vm.config.paginationOffsetHeight = vm.defaults.paginationOffsetHeight;
              }

              // if ($scope.showFilters != false) {
              //     $scope.setupFilters(grid);
              // }
              if (typeof $scope.control === "object") {
                  $scope.control.flexGrid = grid;
              }

              if ($scope.hidePagination) {
                  grid.deferResizing = true;
              }
              updateRowHeight();
              grid.rowHeaders.columns[0].width = 40;
              hasInitialized = true;
              removeFlexGridWatch();
          }
      );

      // Init render
      // Force the grid to render when it is initialized when hidden with CSS
      var removeInitRenderWatch = $scope.$watch(
          function() {
              return $element[0].offsetWidth;
          },
          function(width) {
              if (width > 0 && vm.flexGrid) {
                  vm.flexGrid.invalidate();
                  removeInitRenderWatch();
              }
          }
      );

      $scope.$watch('desktopMode', function(desktopMode) {
          vm.desktopMode = desktopMode;
          updateRowHeight();
      });

      function updateRowHeight() {
          if (!vm.flexGrid) {
              return;
          }
          if (!!$scope.desktopMode) {
              flexGridSetUpService.updateFlexGridRowHeight(vm.flexGrid, 30, [36, 38]);
              vm.config.offsetHeight = 130;
              if ($scope.hidePagination) {
                  vm.config.offsetHeight = 150;
              }
          } else {
              flexGridSetUpService.updateFlexGridRowHeight(vm.flexGrid, 48, [48, 56]);
              vm.config.offsetHeight = 162;
          }
      }
      $scope.$watch('columnDefinitions', function(columnDefinitions) {
          vm.config.columnDefinitions = angular.copy(columnDefinitions);
          var selectColumnDefinition = {
              binding: 'bentoTboxSelect',
              header: ' ',
              visible: true,
              minWidth: 40,
              width: 40
          }
          vm.config.columnDefinitions.unshift(selectColumnDefinition);
      }, true);
      $scope.$watchCollection('gridData', function(data) {
          if (Array.isArray(data)) {
              data.forEach(function(obj) {
                  obj.bentoTboxSelect = false;
                  if(obj[$scope.childItemsPath]){
                      var childItems = obj[$scope.childItemsPath];
                      //circular reference
                      childItems.forEach(function(childItem){
                          childItem.parentItem = obj;
                          childItem.bentoTboxSelect = false;
                      });
                  }
              });
              if (vm.config.collectionView) {
                  delete vm.config.collectionView;
              }

              vm.config.collectionView = new wijmo.collections.CollectionView(data);
              vm.config.collectionView.moveCurrentToPosition(-1);

              //Set up handling for collection changed
              vm.config.collectionView.collectionChanged.addHandler(onCollectionChanged);

              //refresh to get filtered items totalItemCount
              vm.config.collectionView.refresh();
              vm.onCheckBoxChange();

              $timeout(function() {
                  if (vm.config.collectionView) {
                      vm.config.totalItems = vm.config.collectionView.totalItemCount;
                      if (!$scope.hidePagination) {
                          vm.config.collectionView.pageSize = vm.config.pageSize;
                      } else {
                          vm.config.pageSize = vm.config.collectionView.sourceCollection.length;
                          vm.config.collectionView.pageSize = vm.config.pageSize;
                      }
                      //on Transfer, keep grid page from resetting to first page, keep it the same page
                      if (vm.config.page <= 0) {
                          vm.config.page = 1;
                      }

                      var newPageCount = vm.config.collectionView.pageCount;
                      if (newPageCount < vm.config.page) {
                          vm.config.page = newPageCount;
                      }

                      vm.config.collectionView.moveToPage(vm.config.page - 1);
                  }
              });
          }
      });

      function setupPagination(flexGrid) {
          if (flexGrid && !hasPaginized) {
              $scope.$watch(function() {
                  return vm.config.page;
              }, function(page) {
                  if (flexGrid.collectionView) {
                      flexGrid.collectionView.moveToPage(page - 1);
                  }
              });

              $scope.$watch(function() {
                  return vm.config.pageSize;
              }, function(pageSize) {
                  if (flexGrid && flexGrid.collectionView) {
                      flexGrid.collectionView.pageSize = pageSize;
                  }
              });
              hasPaginized = true;
          }
      }

      function togglePagination(pagination) {
          var hidePagination = pagination || $scope.hidePagination;
          if (!hidePagination) {
              setupPagination(vm.flexGrid);
              vm.config.pageSize = vm.defaults.pageSize;
              if (vm.flexGrid && vm.flexGrid.collectionView) {
                  vm.flexGrid.collectionView.pageSize = vm.config.pageSize;
              }
              vm.config.paginationOffsetHeight = 0;
              if ($scope.desktopMode) {
                  vm.config.offsetHeight = 130;
              }
          } else {
              if (vm.config.collectionView) {
                  vm.config.pageSize = vm.config.collectionView.sourceCollection.length;
                  vm.config.collectionView.pageSize = vm.config.pageSize;
              }
              if (vm.flexGrid) {
                  vm.flexGrid.deferResizing = true;
              }
              vm.config.page = 1;
              vm.config.paginationOffsetHeight = vm.defaults.paginationOffsetHeight;
              if ($scope.desktopMode) {
                  vm.config.offsetHeight = 150;
              }
          }
      }

      //FILTER
      vm.updateFilter = function(id) {
          $scope.updateFilter(id);
      }

      function customCollectionViewFilter(item) {
        var val = null;
        var itemkey = null;

        for (var i = 0, il = vm.config.columnDefinitions.length; i < il; i++) {
            var col = vm.config.columnDefinitions[i];
            if ('dateObj' in col && col.dateObj) {
                val = formatDate(col.dateObj);
                itemkey = formatDate(item[col.binding]);
            } else if ('filterText' in col && col.filterText) {
                val = col.filterText;
                itemkey = item[col.binding];
            } else if ('selectText' in col && col.selectText) {
                val = col.selectText;
                if (val === 'All') {
                    val = undefined;
                }
                itemkey = item[col.binding];
            } else if ('comboboxObj' in col && col.comboboxObj) {
                val = col.comboboxObj.name;
                if (val === 'All') {
                    val = undefined;
                }
                itemkey = item[col.binding];
            }
            if (!val) {
                continue;
            }
            val = String(val);

            if (String(itemkey).toLowerCase().indexOf(val.toLowerCase()) < 0) {
                return false;
            }
        }

        // all passed
        return true;
    };

    function allColumnFilter(item) {
    //   var filter = (vm.searchBoxFilter) ? vm.searchBoxFilter.toLowerCase() : undefined;
    //   if (!filter) {
    //     return true;
    //   }
    //   var value;
    //   for (var key in item) {
    //     if (item.hasOwnProperty(key)) {
    //       //convert it to string
    //       value = item[key] + '';
    //       if (value.length && value.toLowerCase().indexOf(filter) > -1) {
    //         return true;
    //       }
    //     }
    //   }
    };

    //On Collection Changed, update total items to sync pagination
    function onCollectionChanged(cv) {
        //get grid's collection view total item count
        vm.config.totalItems = cv.totalItemCount;
    }
  }

  tbox.$inject = ['$timeout', '$templateCache', '$compile', '$parse'];

  function tbox($timeout, $templateCache, $compile, $parse) {
      return {
          restrict: 'AE',
          scope: {
              gridData: '=',
              config: '=',
              columnDefinitions: '=',
              desktopMode: '=?',
              boxOne: '=?',
              showFilters: '=?',
              hidePagination: '=?',
              transferItems: '&',
              control: '=',
              gridTemplateUrl: '=?',
              disableTransfer: '=?',
              childItemsPath: '=?'
          },
          controller: 'bentoFlexgridTBoxController',
          controllerAs: 'bentoFlexgridTboxCtrl',
          templateUrl: function(element, attrs) {
              return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/transfer_box/bento-flexgrid-transferbox-grid.html';
          },
          replace: true,
          link: function(scope, element, attrs, tBoxCtrl) {
              if (typeof wijmo === 'undefined') {
                  console.warn('Bento TransferBox relies on Wijmo FlexGrid, please make sure Wijmo files are included')
                  return;
              }

              //If 
              scope.$watch('gridTemplateUrl', function(tUrl) {
                  if (tUrl) {
                      var templateCache = $templateCache.get(tUrl);
                      $timeout(function() {
                          element.html(templateCache);
                          $compile(element.contents())(scope);
                      })
                  }
              });
              var filterTimeout;

              scope.control = {
                  toggleAll: tBoxCtrl.toggleAll
              };

              tBoxCtrl.onInputFocus = onInputFocus;

              scope.setupFilters = function setupFilters(grid) {
                  //Add new column header row for filters
                  var row = new wijmo.grid.Row();
                  grid.columnHeaders.rows.insert(1, row);
              }

              scope.$watch('childItemsPath',function(childItemsPath){
                  if(childItemsPath){
                      tBoxCtrl.childItemsPath = childItemsPath;
                  }
              });

              scope.updateFilter = function updateFilter(id) {

                  if (filterTimeout) {
                      $timeout.cancel(filterTimeout);
                  }
                  filterTimeout = $timeout(function() {
                      if (tBoxCtrl.config.collectionView) {
                          tBoxCtrl.config.collectionView.refresh();
                      }
                      tBoxCtrl.config.page = 1;
                      $timeout(function() {
                          var focusedID = '.transferbox-' + id;
                          setFocus(focusedID);
                      }, 100);
                  }, 300);
              }

              function onInputFocus(col, evt) {
                  var focusedID = '.transferbox-' + col.binding;
                  setFocus(focusedID);
              }

              function setFocus(focusedID) {
                  var focused = element[0].querySelector(focusedID);
                  if (focused) {
                      focused.focus();
                      var strLength = focused.value.length;
                      focused.setSelectionRange(strLength, strLength);
                  }
              }
          }
      }
  }
}());
angular.module('bento.transferbox')
	.controller('bentoFlexgridTBoxInputFilterController', tboxInputFilterController)
	.directive('bentoFlexgridTboxInputFilter', tboxInputFilter);


tboxInputFilterController.$inject = ['$timeout', '$scope', '$element', '$bentoServices']
/**
 * [tboxInputFilterController Input Filter Directive's Controller]
 * @param  {[type]} $timeout [description]
 * @param  {[type]} $scope   [description]
 * @param  {[type]} $element [description]
 * @return {[type]}          [description]
 */
function tboxInputFilterController($timeout, $scope, $element, $bentoServices) {
	var vm = this;
	var inputTimeout;

	$scope.$on('$destroy',vm.onDestroy);

	$timeout(function() {
		if (vm.bentoFlexgridTboxInputFilter && vm.bentoFlexgridTboxInputFilter.type === 'input') {
			vm.initFilter();
		}
	});
	/**
	 * [initFilter create input text field and add relevant event handling]
	 * @return {[type]} [description]
	 */
	vm.initFilter = function() {
		//DOM maninpulation in controller, but it's ok, it's a directive's controller
		//create input element
		vm.inputTextElement = document.createElement('input');
		vm.inputTextElement.type = "text";
		vm.inputTextElement.className = "form-control";
		//create input container element
		vm.inputElement = document.createElement('div');
		vm.inputElement.className = "input-filter";
		vm.inputElement.appendChild(vm.inputTextElement); //append input element into container
		vm.el = $element[0]; //get column element
		vm.eGrid = vm.el.parentElement; //get grid element
		vm.containerElement = vm.eGrid.parentElement; //get transfer box element
		vm.att = vm.el.attributes['binding']; //get binding attribute
		vm.filterContainer = vm.containerElement.querySelector('.input-filter-container');
		vm.filterContainer.appendChild(vm.inputElement); //append input container into transferbox element
		vm.inputTextElement.addEventListener('input', vm.onTextInput) //add event listener to input
		vm.inputTextElement.addEventListener('keyup', vm.onTextInput)
		vm.grid = wijmo.Control.getControl(vm.eGrid); //get grid control
		wijmo.assert(vm.grid instanceof wijmo.grid.FlexGrid);
		vm.col = vm.grid.columns.getColumn(vm.att.value); //get grid column
		wijmo.assert(vm.col instanceof wijmo.grid.Column);
		vm.grid.updatedView.addHandler(vm.resizeFilter); //add grid event handling when grid view is updated
	}


	/**
	 * [resizeFilter - Resize and position input text field to it's column header]
	 * @return {[type]} [description]
	 */
	vm.resizeFilter = function() {
		var pad = 40;
		var rc = vm.grid.columnHeaders.getCellBoundingRect(1, vm.col.index);
		var containerRect = vm.containerElement.getBoundingClientRect();
		//set input field position
		wijmo.setCss(vm.inputElement, {
			position: 'absolute',
			left: $bentoServices.isRTL() ? 'auto' : rc.left - containerRect.left - pad,
			right: $bentoServices.isRTL() ? containerRect.right - rc.right - pad : 'auto',
			top: 0,
			width: rc.width,
			height: vm.grid.columnHeaders.rows[1].renderHeight,
			borderRadius: '0px'
		});
		//set container's position
		wijmo.setCss(vm.filterContainer, {
			position: 'absolute',
			overflow: 'hidden',
			zIndex:1,
			top: rc.top - containerRect.top,
			left: $bentoServices.isRTL() ? 'auto' : pad,
			right: $bentoServices.isRTL() ? pad : 'auto',
			width: vm.grid.clientSize.width,
			height: vm.grid.columnHeaders.rows[1].renderHeight
		})
	}

	/**
	 * [onTextInput - handler for input event]
	 * @param  {[type]} e [event]
	 * @return {[type]}   [description]
	 */
	vm.onTextInput = function(e) {
		//throttle events 
		 if (inputTimeout) {
		 	$timeout.cancel(inputTimeout)
		 }
		//update two-way bound col.filterText
		$timeout(function(){
			vm.bentoFlexgridTboxInputFilterText = e.target.value;
		});
		inputTimeout = $timeout(function() {
			//let the filter in the bento-flexgrid-transferbox-grid-ng.js take it's filtering effect
			// console.log('text',vm.bentoFlexgridTboxInputFilterText)
			vm.grid.collectionView.refresh();
		 }, 200);
	}

	vm.onDestroy = function (){
		if(vm.grid){
			vm.grid.updatedView.removeHandler(vm.resizeFilter);
		}
		vm.inputTextElement.removeEventListener('input', vm.onTextInput);
		vm.inputTextElement.removeEventListener('keyup', vm.onTextInput);
	}
}

/**
 * [tboxInputFilter Directive, all functions in controller]
 * @return {[type]} [description]
 */
function tboxInputFilter() {
	return {
		restrict: 'A',
		priority: 110,
		controller: tboxInputFilterController,
		controllerAs: 'flexGridInputFilterCtrl',
		bindToController: {
			bentoFlexgridTboxInputFilter: '=',
			bentoFlexgridTboxInputFilterText: '='
		},
		link: function(scope, element, attrs, ctrl) {

		}
	}
}
(function(){
    'use strict';
    angular.module('bento.transferbox.basic',['bento.translate'])
    .component('bentoTransferbox',{
        templateUrl: '../templates/transfer_box_basic/bento-transferbox-base.html',
        bindings: {
            boxOneItemSource: '=',
            boxTwoItemSource: '=',
            columnDefinitions: '<',
            control: '=?',
            boxOneTitle: '<?',
            boxTwoTitle: '<?',
            infoShown: '<?',
            infoText: '<?',
            transferBtnTextOne: '<',
            transferBtnTextTwo: '<',
            height: '<',
            onBeforeTransfer: '&?',
            onTransfer: '&',
            uniqueKey: '<?',
            paginationInfoText: '<?',
            paginationGoText: '<?',
            paginationInfoPageText: '<?',
            searchText: '<?',
            gridTemplateUrl: '<?',
            disableTransfer: '<?',
            leftWidth: '<?'
        },
        controller: transferboxController
    });

    transferboxController.$inject = ['$timeout'];
    function transferboxController($timeout){
        var vm = this;
        var box1, box2;

        this.$doCheck = function () {
            if ( !angular.equals(vm.box1, box1)) {
                box1 = vm.box1;
                updateControl();
            }
            if ( !angular.equals(vm.box2, box2)) {
                box2 = vm.box2;
                updateControl();
            }
        }
        this.transferItemsOne = function transferItemsOne(selectedItems, remainingItems){
            var gridTwoItems = selectedItems.concat(vm.boxTwoItemSource);
            transferItems(remainingItems,gridTwoItems);
        }

        this.transferItemsTwo = function transferItemsTwo(selectedItems, remainingItems){
            var gridOneItems = selectedItems.concat(vm.boxOneItemSource);
            transferItems(gridOneItems,remainingItems);
        }

        function updateControl(){
            $timeout(function(){
                vm.control = {
                    gridOne: vm.box1,
                    gridTwo: vm.box2
                };
            });
        }

        function transferItems(gridOneItems,gridTwoItems){
            vm.boxOneItemSource = gridOneItems;
            vm.boxTwoItemSource = gridTwoItems;
            vm.onTransfer({
                gridDataOne: gridOneItems,
                gridDataTwo: gridTwoItems
            })
        }
    }
}());
(function(){
    'use strict'
    angular.module('bento.transferbox.basic')
    .component('bentoBasicTbox',{
        templateUrl: '../templates/transfer_box_basic/bento-transferbox-grid.html',
        bindings: {
            gridData: '=',
            config: '<',
            columnDefinitions: '<',
            boxOne: '<?',
            transferItems: '&',
            infoShown: '<?',
            control: '=',
            boxTitle: '<?',
            subTitle: '<?',
            gridTemplateUrl: '<?',
            disableTransfer: '<?',
            searchText: '<?',
            transferBtnText: '<?',
            uniqueKey: '<?',
            height: '<?',
            paginationInfoText: '<',
            paginationGoText: '<',
            paginationInfoPageText: '<'
        },
        controller: tboxController
    });

    tboxController.$inject = ['$element','$timeout'];
    function tboxController($element,$timeout){
            var vm = this;
            vm.control = this;
            var itemSource = undefined;
            var headerChecked = undefined;
            var headerCheckbox = $element[0].querySelector('#header-checkbox');
            var filteredData = [];
            var sortDirections = ['','asc','desc'];
            var headerPaginationHeight = 172;
            var tboxHeight = vm.height;
            vm.gridHeight =  tboxHeight - headerPaginationHeight;
            vm.tableStyle = {
                height: vm.gridHeight + 'px'
            }
            vm.colHeaderSort = {};
            vm.renderData = undefined;
            vm.uniqueKey = vm.uniqueKey || 'id';
            vm.selection = [];
            vm.hasSelection = false;
            vm.totalSelected = 0;
            vm.pagination = {
                currentPage: 1,
                pageSize: 10
            }
            vm.activeCol = undefined;
            vm.activeColDirection = '';

            this.$onInit = function(){
                this.checkbox = $element[0].querySelector('#myCheckbox');
                this.control = {
                    toggleAll: vm.toggleAll,
                    gridData: vm.gridData
                };
            }
            this.$doCheck = function () {
                if ( !angular.equals(vm.gridData, itemSource)) {
                    itemSource = vm.gridData.slice();
                    resetAll();
                    showRenderedData();
                }
                if( !angular.equals(vm.headerCheckboxModel, headerChecked)){
                    checkAll();
                    headerChecked = vm.headerCheckboxModel;
                }
                if( !angular.equals(vm.height, tboxHeight)){
                    tboxHeight = vm.height;
                    vm.gridHeight = tboxHeight - headerPaginationHeight;
                    vm.tableStyle = {
                        height: vm.gridHeight+'px'
                    }
                }
            }
            this.onPageChanged = function onPageChanged(page){
                showRenderedData();
            }
            this.onSizeChanged = function onSizeChanged(size){
                vm.pagination.currentPage = 1;
                showRenderedData();
            }
            this.onCheckboxChange = function onCheckboxChange(){
                vm.totalSelected = getSelectedCount();
                if(vm.totalSelected > 0 && vm.totalSelected !==vm.gridData.length){
                    headerCheckbox.indeterminate = true;
                    // vm.headerCheckboxModel = false;
                } else if(vm.totalSelected > 0 && vm.totalSelected === vm.gridData.length) {
                    headerCheckbox.indeterminate = false;
                    vm.headerCheckboxModel = true;
                } else {
                    headerCheckbox.indeterminate = false;
                    vm.headerCheckboxModel = false;
                }
            }
            this.transferItemsClick = function onTransferItemsClick(){
                var splitItems = getSplitItems();
                if(splitItems){
                    vm.transferItems(splitItems);
                }
            }
            this.onFilterInput = function onFilterInput(){
                $timeout(function(){
                    showRenderedData();
                },100)
            }
            this.onRowClick = function onRowClick(item){
                vm.selection[item[vm.uniqueKey]] = !vm.selection[item[vm.uniqueKey]];
                vm.onCheckboxChange()
            }
            this.onHeaderClick = function onHeaderClick(col){
                vm.activeCol = col.binding;
                // reset other sort
                for (var property in vm.colHeaderSort) {
                    if (vm.colHeaderSort.hasOwnProperty(property)) {
                        if(property !== vm.activeCol){
                            vm.colHeaderSort[property] = undefined;
                        }
                    }
                }
                if(vm.colHeaderSort[col.binding] === undefined){
                    vm.colHeaderSort[col.binding] = {
                        count: 0,
                        sortDirection: ''
                    };
                } 
                vm.colHeaderSort[col.binding].count ++;
                vm.colHeaderSort[col.binding].count = vm.colHeaderSort[col.binding].count % 3;
                vm.colHeaderSort[col.binding].sortDirection = sortDirections[vm.colHeaderSort[col.binding].count];
                showRenderedData();
            }

            function resetAll(){
                vm.selection = [];
                vm.headerCheckboxModel = false;
                headerCheckbox.indeterminate = false;
                vm.hasSelection = false;
                vm.filterValue = '';
                vm.activeCol = undefined;
                filteredData = [];
                vm.totalSelected = 0;
                vm.colHeaderSort = {};
            }

            function getSplitItems(){
                if (!vm.gridData) { return; }
                if (vm.selection.length === 0) { return; }
                var selectedItems = [];
                var remainingItems = [];
                for(var i = 0, ttl=vm.gridData.length; i < ttl; i++){
                    if(vm.selection[vm.gridData[i][vm.uniqueKey]] === true){
                        selectedItems.push(vm.gridData[i]);
                    } else {
                        remainingItems.push(vm.gridData[i]);
                    }
                }

                return {
                    selectedItems: selectedItems,
                    remainingItems: remainingItems
                }
            }
            function showRenderedData(){
                // var sortedData = ;
                var renderData = vm.gridData;
                if(vm.activeCol){
                    renderData = sortData(renderData, vm.activeCol, vm.colHeaderSort[vm.activeCol].sortDirection);
                }
                // if filtered
                if(vm.filterValue && vm.filterValue.length){
                    renderData = renderData.slice().filter(function(item){
                        var searchStr = '';
                        if(vm.columnDefinitions) {
                            vm.columnDefinitions.forEach(function(colDef){
                                if(item[colDef.binding]){
                                    searchStr += String(item[colDef.binding]).toLowerCase();
                                }
                            });
                        }
                        return searchStr.indexOf(vm.filterValue.toLowerCase()) !== -1;
                    });
                    filteredData = renderData.slice();
                } else {
                    filteredData = [];
                }
                vm.pagination.totalItems = renderData.length;
                var startIndex = (vm.pagination.currentPage - 1) * vm.pagination.pageSize;
                vm.renderData = renderData.slice().splice(startIndex, vm.pagination.pageSize);
            }
            // Multi-select - check if all items are selected
            function getSelectedCount(){
                if (!vm.gridData) { return false; }
                if (vm.selection.length === 0) { return false; }

                var count = 0;
                for(var i = 0, ttl=vm.selection.length; i < ttl; i++){
                    if(vm.selection[i] === true){
                        count ++;
                    }
                }
                if(count > 0){
                    vm.hasSelection = true;
                } else {
                    vm.hasSelection = false;
                }
                return count;
            }

            vm.toggleAll = function(){
                vm.headerCheckboxModel = !vm.headerCheckboxModel;
                headerCheckbox.indeterminate = false;
                checkAll();
            }
            function checkAll() {
                if (!vm.gridData) {return;}
                if (!vm.headerCheckboxModel) {
                    vm.selection = [];
                    vm.hasSelection = false;
                    // vm.totalSelected = 0;
                } else if (vm.filterValue && vm.filterValue.length) {
                    vm.selection = [];
                    vm.hasSelection = false;
                    if(filteredData.length){
                        vm.hasSelection = true;
                    }
                    filteredData.forEach(function(item){
                        vm.selection[item[vm.uniqueKey]] = true;
                    });
                } else {
                    if(vm.gridData.length){
                        vm.hasSelection = true;
                    }
                    vm.gridData.forEach(function(item){
                        vm.selection[item[vm.uniqueKey]] = true;
                    });
                }
                vm.totalSelected = getSelectedCount();
            }

            /** Returns a sorted copy of the data. */
            function sortData(data, colID, sortDirection){
                // return original data if sort reset
                if (!colID || !sortDirection || sortDirection === '') { return data; }
                // return a copy of the data sorted
                return heapSort(data.slice(), colID, sortDirection);
            }

            function heapSort(array, colID, sortDirection) {
                function heapify(array, index, heapSize) {
                    var left = 2 * index + 1,
                        right = 2 * index + 2,
                        largest = index;
                 
                    if (left < heapSize && (sortDirection === 'asc' ? array[left][colID] > array[index][colID] : array[left][colID] < array[index][colID])) {
                        largest = left;
                    }

                    if (right < heapSize && (sortDirection === 'asc' ? array[right][colID] > array[largest][colID] : array[right][colID] < array[largest][colID])) {
                        largest = right;
                    }
                 
                    if (largest !== index) {
                        var temp = array[index];
                        array[index] = array[largest];
                        array[largest] = temp;
                        heapify(array, largest, heapSize, colID);
                    }
                }

                function buildMaxHeap(array) {
                    for (var i = Math.floor(array.length / 2); i >= 0; i -= 1) {
                        heapify(array, i, array.length);
                    }
                    return array;
                }
                
                var size = array.length,
                    temp;

                buildMaxHeap(array);

                for (var i = array.length - 1; i > 0; i -= 1) {
                    temp = array[0];
                    array[0] = array[i];
                    array[i] = temp;
                    size -= 1;
                    heapify(array, 0, size);
                }

                return array;
                
            };
        }
}());
(function (angular, undefined) {
  "use strict";

  var CHECKBOX = '-checkbox';
  var NODE_HIDDEN_PROP = '$$bentoNodeHidden';

  // Provides lazy loading to enhance initial load time
  angular.module('bento.tree', ['bento.services'])
    // Bento Tree Directive
    .directive('bentoTree', [
      '$compile',
      '$timeout',
      'treeSelection',
      'treeHelper',
      '$recursionHelper',
      function ($compile, $timeout, treeSelection, treeHelper, $recursionHelper) {

        return {
          restrict: 'A',
          scope: {
            checkboxModel: '@',
            collapsingCallback: '=', // Two way binding is needed for direct function
            // reference
            expandingCallback: '=', // Two way binding is needed for direct function
            // reference
            expandOnlyModel: '@', // Model to determine if the current node can only
            // expand and collapse
            multiSelect: '=',
            nodeChildren: '@',
            onCheckboxChange: '=', // Two way binding is needed for direct function
            // reference
            secondTreeIcon: '@',
            selectableModel: '@', // Model to determine if the node is selectable or
            // not
            selectAsCheck: '=',
            selectCallback: '=', // Two way binding is needed for direct function
            // reference
            selectModel: '@', // Selection Model
            treeCollapsed: '=',
            treeDisabled: '=', // Private API
            treeIcon: '@',
            treeId: '@',
            treeLabel: '@',
            treeModel: '=',
            treeSelectionHelper: '=?', // **Internal Use** forwarded TreeSelectionHelper
            independentCheckbox: '&', // Make checkboxes to be independent from hierachical relationships
            useCheckbox: '=',
            searchable: '&', // Flag when the tree is searchable
            navMode: '&', // Turn tree into nav mode
            showExpandCollapseAllButtons: '&', // Show "Expand/Collapse All" buttons
            treeLevel: '&' // Current node level (depth from the root)
          },
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tree/bento-tree.html'
          },
          replace: true,
          compile: function (element) {
            // Use the compile function from the RecursionHelper,
            // And return the linking function(s) which it returns
            return $recursionHelper.compile(element);
          },
          controller: 'mainTreeController',
          controllerAs: '$ctrl',
        };
      }
    ])
    // Tree selection factory
    .factory('treeSelection', function () {

      var TreeSelectionHelper = function () {
        var self = this;

        this.node = [];

        this.setRootElement = function (treeRootElement) {
          self.rootElement = treeRootElement;
        };

        this.getRootElement = function () {
          return self.rootElement;
        };

        this.getClickableNodes = function () {
          if (self.rootElement) {
            var nodes        = self.rootElement[0].querySelectorAll('.bento-tree-item-cta:not(.bento-tree-item-static)'),
                disabledNodes= Array.from(self.rootElement[0].querySelectorAll('.bento-tree-disabled .bento-tree-item-cta')),
                visibleNodes = [],
                node;


            // find out if the nodes are clickable aka visible
            for (var i = 0, len = nodes.length; i < len; i++) {
              node = nodes[i];
              if (node.offsetWidth > 0 && node.offsetHeight > 0 && disabledNodes.indexOf(node) < 0) {
                visibleNodes.push(node);
              }
            }

            return visibleNodes;
          }
        };

        this.findElement = function (array, child, label, id) {
          var flag = false;
          for (var i = array.length - 1; i >= 0; i--) {
            if ((array[i])[label] === id) {
              this.clearNodes();
              flag = true;
              if (typeof array[i].collapsed === 'undefined') {
                array[i].collapsed = false;
              }
              array[i].selected = 'selected';
              this.addToSelection(array[i]);
              break;
            } else {
              if (angular.isArray((array[i])[child])) {
                flag = this.findElement((array[i])[child], child, label, id);
                if (flag) {
                  if (typeof array[i].collapsed === 'undefined') {
                    array[i].collapsed = false;
                  }
                  break;
                }
              }
            }
          }
          return flag;
        };

        /**
         * Add a node into selection
         * @param _node
         * @returns {boolean} - Tells if the node is already in selection or not
         */
        this.addToSelection = function (_node) {
          if (!this.contains(_node)) {
            this.node.push(_node);
            return true;
          }

          return false;
        };

        this.contains = function (_node) {
          return this.node.indexOf(_node) > -1;
        };

        this.getSelection = function () {
          return this.node;
        };

        this.removeFromSelection = function (_node) {
          var index = this.node.indexOf(_node);
          this.node.splice(index, 1);
        };

        this.clearNodes = function (node, itemsProp) {

          // Clear all
          // We need to clear everything
          if (typeof node == 'undefined') {
            this.node = [];
            return;
          }

          // Clearing only the selected node and its childnNodes
          var items = node[itemsProp],
            index = this.node.indexOf(node);

          // We remove nodes
          if (index > -1) {
            this.node.splice(index, 1);
          }

          if (Array.isArray(items)) {
            for (var i = 0, len = items.length; i < len; i++) {
              self.clearNodes(items[i], itemsProp);
            }
          }
        };

        this.findSelectElement = function (node, child, label, id) {
          return this.getSelection();
        };

      };

      var getHelper = function () {
        return new TreeSelectionHelper();
      };

      return {
        getHelper: getHelper
      };
    })

    // Tree Helper factory
    .factory('treeHelper', function () {

      /**
       * Get the Boolean from a node selection
       * @param scope
       * @param node
       */
      function getSelectModelValue(scope, node) {
        if (typeof scope.selectModel === 'undefined' ||
          (typeof scope.selectModel === 'string' && scope.selectModel === '')) {
          return node._selected;
        }
        return node[scope.selectModel];
      }

      /**
       * Set the Selection Boolean to a node
       * @param scope
       * @param node
       */
      function setSelectModelValue(scope, node, value) {
        if (typeof scope.selectModel === 'undefined' ||
          (typeof scope.selectModel === 'string' && scope.selectModel === '')) {
          node._selected = value;
        } else {
          node[scope.selectModel] = value;
        }
      }

      /**
       * Search and hide nodes based on search string
       * @param {Array} nodes 
       * @param {*} labelProp 
       * @param {*} itemsProp 
       */
      function searchAndMark(search, nodes, labelProp, itemsProp) {
        var node;
        var hasSelection;
        for (var i = 0; i < nodes.length; i++) {
          node = nodes[i];
          var childrenSelected = false;
          var items = node[itemsProp];
          
          if (items && items.length) {
            childrenSelected = searchAndMark(search, items, labelProp, itemsProp);
          }

          if (!childrenSelected) {
            // None of its children is selected
            if (search && search.length > 0) {
              if (node[labelProp].toLowerCase().indexOf(search) > -1 ) {
                // Has match for this node
                node[NODE_HIDDEN_PROP] = false;
                hasSelection = true;
              } else {
                node[NODE_HIDDEN_PROP] = true;
              }
            } else {
              // Search is empty => reset
              node[NODE_HIDDEN_PROP] = false;
              hasSelection = true;
            }
          } else {
            node[NODE_HIDDEN_PROP] = false;
            hasSelection = true;
          }
        }

        return hasSelection;
      }

      /**
       * Expand Collapse node and its offspring
       * @param expand
       */
      function expandNodeAndOffspring(node, nodeChildren, expand) {
        var children;

        if (Array.isArray(node)) {
          children = node;
        } else {
          children = node[nodeChildren];
          node.collapsed = !expand;
        }

        if (Array.isArray(children)) {
          for (var i = 0, len = children.length; i < len; i++) {
            expandNodeAndOffspring(children[i], nodeChildren, expand);
          }
        }
      }

      /**
       * Check / Uncheck offspring of a node based on its status
       * @param node
       * @param nodeChildrenName
       * @param checkboxModelName
       * @param checked
       */
      function checkOffspring(node, nodeChildrenName, checkboxModelName, checked) {
        // Node is disabled don't check it's offspring
        if (node.disabled) {
          return;
        }

        //console.log('what');
        if (typeof checked !== 'undefined') {
          if (!node.hideCheckbox) {
            node[checkboxModelName] = checked;
            node._indeterminate = false;
            document.getElementById(node.$$bentoTreeId + CHECKBOX).indeterminate = false;
          }
        }

        // recursively check/uncheck the offspring of node
        if (!!node[nodeChildrenName] && node[nodeChildrenName].length > 0) {
          var hasCheckedChildren = false;
          for (var i = 0; i < node[nodeChildrenName].length; i++) {
            hasCheckedChildren = checkOffspring(
              node[nodeChildrenName][i],
              nodeChildrenName,
              checkboxModelName,
              node[checkboxModelName]) || hasCheckedChildren;
          }

          //indeterminate the current checkbox
          if (hasCheckedChildren && !node[checkboxModelName]) {
            node._indeterminate = true;
            var treeEl = document.getElementById(node.$$bentoTreeId + CHECKBOX);
            if (treeEl) {
              treeEl.indeterminate = true;
            }
          }
        }

        return node[checkboxModelName] || node._indeterminate;
      }

      /**
       * Help to check / uncheck / indeterminate check boxes on one root branch
       * @param node
       * @param nodeChildrenName
       * @param checkboxModelName
       */
      function indeterminateRoot(scope, nodeChildrenName, checkboxModelName) {
        var nodeScope = scope,
          parentScope = // walk up the scope hierarchy
          (nodeScope &&
            nodeScope.$parent &&
            nodeScope.$parent.$parent) ?
          nodeScope.$parent.$parent.$parent : undefined,
          parentNode = (parentScope && parentScope.node) ? parentScope.node : undefined;

        if (!!parentNode) {
          //check siblings and see if checked
          var siblings = parentNode[nodeChildrenName];
          var hasChecked = false;
          var hasUnchecked = false;
          var hasIndeterminate = false;
          for (var i = 0; i < siblings.length; i++) {
            var _node = siblings[i];

            // Ignore .hideCheckbox nodes
            if (_node.hideCheckbox) {
              continue;
            }

            if (_node._indeterminate) {
              hasIndeterminate = true;
            } else if (!_node[checkboxModelName]) {
              hasUnchecked = true;
            } else {
              hasChecked = true;
            }
          }

          // There are three conditions
          // 1. All siblings are checked without indeterminate
          // 2. None of the siblings are checked without indeterminate
          // 3. Some siblings are checked with indeterminate
          var checkbox = document.getElementById(parentNode.$$bentoTreeId + CHECKBOX) || {};

          // Case 1:
          if (!hasUnchecked && hasChecked && !hasIndeterminate) {
            parentNode[checkboxModelName] = true;
            checkbox.indeterminate = false;
            parentNode._indeterminate = false;
          } else
            // Case 2:
            if (hasUnchecked && !hasChecked && !hasIndeterminate) {
              parentNode[checkboxModelName] = false;
              checkbox.indeterminate = false;
              parentNode._indeterminate = false;
            } else
              // Case 3:
              if ((hasUnchecked && hasChecked) || hasIndeterminate) {
                parentNode[checkboxModelName] = false;
                parentNode._indeterminate = true;
                checkbox.indeterminate = true;
              }

          // recursive
          indeterminateRoot(parentScope, nodeChildrenName, checkboxModelName);
        }
      }

      /**
       * Get tree root element
       * @param  {element} element - current element that is part of the tree
       * @return {element} root element
       */
      function getTreeRootElement(element) {
        return el;
      }

      return {
        indeterminateRoot: indeterminateRoot,
        checkOffspring: checkOffspring,
        getSelectModelValue: getSelectModelValue,
        setSelectModelValue: setSelectModelValue,
        getTreeRootElement: getTreeRootElement,
        expandNodeAndOffspring: expandNodeAndOffspring,
        searchAndMark: searchAndMark
      };
    })
    // Main Tree Controller
    .controller('mainTreeController', [
      '$scope',
      '$element',
      'treeSelection',
      'treeHelper',
      '$timeout',
      '$bentoServices',
      function ($scope, $element, treeSelection, treeHelper, $timeout, $bentoServices) {
        var ctrl = this;

        ctrl.branchReady = false;

        $timeout(function(){
          ctrl.branchReady = true;
        }, 
          10 // give 10ms delay for each level
        );
        // treeId defines the root of this tree
        if (typeof $scope.treeSelectionHelper === 'undefined') {
          $scope.treeSelectionHelper = treeSelection.getHelper();
          $scope.treeSelectionHelper.setRootElement($element);
          $scope.treeSelectionHelper.rootCtrl = ctrl;
          // Add a root class
          $element.addClass('bento-tree-root');

          ctrl.isRoot = true;

          // Watch main data object to re-adjust the width
          $scope.$watchCollection('treeModel', function (newTreeModel) {
            // Tree model is not ready
            if (typeof newTreeModel === 'undefined') {
              return;
            }

            if(!$scope.independentCheckbox()){
              $timeout(function () {
                // Update checks
                for (var j = 0; j < $scope.treeModel.length; j++) {
                  treeHelper.checkOffspring($scope.treeModel[j], $scope.nodeChildren, $scope.checkboxModel);
                }
              });
            }
            

            processTree(newTreeModel);

            // Reset search
            ctrl.search = '';
          });
        }

        function initCollapse(treeModel) {
          var i, len, child;
          //check to see if we need to collapse by default
          if (treeModel.length > 0) {
            var children = treeModel;
            if (typeof $scope.treeCollapsed === 'undefined') {
              for (i = 0, len = children.length; i < len; i++) {
                child = children[i];
                if (typeof child.collapsed === 'undefined') {
                  child.collapsed = false;
                }
              }
            } else {
              for (i = 0, len = children.length; i < len; i++) {
                child = children[i];
                if (typeof child.collapsed === 'undefined') {
                  child.collapsed = $scope.treeCollapsed;
                  if (Array.isArray(child.items)) {
                    initCollapse(child.items);
                  }
                }
              }
            }
          }
        }

        function processTree(treeModel) {

          initCollapse(treeModel);

          /*
           performs the necessary action if the data model contains the value for selected
           */
          $timeout(function () {
            $scope.treeSelectionHelper.clearNodes();
            updateSelectionInfo(treeModel);
          });

          /**
           * Update node selection info in helper
           * @param treeNodeCollection
           */
          function updateSelectionInfo(treeNodeCollection) {
            for (var i = 0; i < treeNodeCollection.length; i++) {
              var nodeModel = treeNodeCollection[i];
              if (treeHelper.getSelectModelValue($scope, nodeModel)) {
                $scope.labelSelect(nodeModel);
                $scope.treeSelectionHelper.addToSelection(nodeModel);
              }

              if (nodeModel[$scope.nodeChildren] && Array.isArray(nodeModel[$scope.nodeChildren])) {
                updateSelectionInfo(nodeModel[$scope.nodeChildren]);
              }
            }
          }
        }

        $scope.currentLevel = typeof $scope.treeLevel() === 'undefined' ? 1 : $scope.treeLevel() + 1;

        ctrl.$postLink = function () {
          // Add level CSS class
          var treeBaseEl = $element[0].querySelector('.bento-tree-branch-base');
          var levelClassName = 'bento-tree-node-level-' + $scope.currentLevel;
          treeBaseEl.classList.add(levelClassName);

          // Add no-expand-collapse class
          if (ctrl.isRoot && $scope.navMode()) {
            $element.addClass('bento-tree-nav-mode');
          }
        };

        /**
         * Method to expand all nodes
         */
        $scope.expandAll = function () {
          treeHelper.expandNodeAndOffspring($scope.treeModel, $scope.nodeChildren, true);
        };

        /**
         * Method to collapse all nodes
         */
        $scope.collapseAll = function () {
          treeHelper.expandNodeAndOffspring($scope.treeModel, $scope.nodeChildren, false);
        };

        /**
         * Generate Tree ID on the fly and preserve previously created node ID
         * @param node
         * @returns {string|*}
         */
        $scope.getTreeId = function (node) {
          if (typeof node.$$bentoTreeId === 'undefined') {
            node.$$bentoTreeId = 'bento-tree-node-' + Math.round(Math.random() * 1000000000000);
          }
          return node.$$bentoTreeId;
        };

        /**
         * On check box change
         *
         * We need to use `ng-click` instead of `ng-chage` due to odd behaviors on IE browsers
         * where `indeterminate` state click does not count as a "change state"
         *
         * Because `ng-click` fires before the model changes it's variable, we need to update the
         * tree models when rendering is done
         *
         */
        $scope.checkboxClick = function (_node) {
          // Bypass if this node and branch is disabled
          if ($scope.treeModel.disabled || $scope.treeDisabled) {
            return;
          }

          var parentScope = this.$parent,
            node = _node || parentScope.node,
            checkbox = document.getElementById(node.$$bentoTreeId + CHECKBOX);

          // remove indeterminate
          node._indeterminate = false;
          if (checkbox) {
            checkbox.indeterminate = false;
          }

          // setting timeout here to make sure that all models are updated
          $timeout(function () {
            if(!$scope.independentCheckbox()){
              // Only check descendants and validate ancesters when it's not independent
              // check all children
              treeHelper.checkOffspring(node, $scope.nodeChildren, $scope.checkboxModel);

              // indeterminate the whole branch to check / uncheck / indeterminate checkboxes
              treeHelper.indeterminateRoot(parentScope, $scope.nodeChildren, $scope.checkboxModel);
            }

            // Fire callback
            if (!!$scope.onCheckboxChange) {
              $scope.onCheckboxChange(node);
            }
          });
        };

        /**
         * Select and de-select a node based on `multiSelect` flag
         */
        $scope.labelSelect = function (node, event) {
          // Bypass if this node and branch is disabled
          if ($scope.treeModel.disabled || $scope.treeDisabled) {
            return;
          }

          var elementNode = typeof (node) === 'undefined' ? this.node : node;

          if (typeof $scope.selectableModel !== 'undefined' &&
            typeof node[$scope.selectableModel] === 'boolean' && !node[$scope.selectableModel]
          ) {
            return;
          }

          if (!$scope.navMode()) {
            // Forward click action to the checkbox when doing select as check
            if ($scope.selectAsCheck) {
              elementNode[$scope.checkboxModel] = !elementNode[$scope.checkboxModel];
              $scope.checkboxClick(elementNode);
              return;
            } else
              // Forward a label select as tree toggle
              if ($scope.expandOnlyModel && elementNode[$scope.expandOnlyModel]) {
                $scope.toggleCollapse(elementNode);
                return;
              }
          } else if ($scope.treeSelectionHelper.contains(node)) {
            // In Nav Mode, there is deselecting so we skip
            return;
          }

          if ($scope.selectCallback && event) {
            // Fire select callback and bypass if it returns a `false`
            // This only generate callback when `labelSelect` is triggered by user
            var reply = $scope.selectCallback(elementNode, !elementNode[$scope.selectModel], event);
            // replay is `false`
            if (typeof reply === 'boolean' && !reply) {
              return;
            }
          }

          //here where we would set multi select
          var currentNode = $scope.treeSelectionHelper.getSelection();
          if($scope.multiSelect && !$scope.navMode()){
            var nodeArray = currentNode.filter(function (node) {
              if (node === elementNode) {
                treeHelper.setSelectModelValue($scope, node, false);
                return true;
              }
              return false;
            });
            if (nodeArray.length > 0) {
              treeHelper.setSelectModelValue($scope, nodeArray[0], false);
              $scope.treeSelectionHelper.removeFromSelection(elementNode);
            } else {
              treeHelper.setSelectModelValue($scope, elementNode, true);
              $scope.treeSelectionHelper.addToSelection(elementNode);
            }
          }else {
            // This is not a multiselect Tree

            angular.forEach(currentNode, function (node) {
              // Flip all selected node(s) to not selected
              treeHelper.setSelectModelValue($scope, node, false);
            });

            if ($scope.treeSelectionHelper.contains(elementNode)) {
              // Remove everything from selection
              $scope.treeSelectionHelper.clearNodes();
            } else {
              // Set the elementNode to selected then add it to selection
              treeHelper.setSelectModelValue($scope, elementNode, true);
              $scope.treeSelectionHelper.clearNodes();
              $scope.treeSelectionHelper.addToSelection(elementNode);
            }

            if($scope.navMode()){
              $scope.treeSelectionHelper.rootCtrl.search = '';
              $scope.treeSelectionHelper.rootCtrl.onSearchChange();
            }
          } 

        };

        /**
         * On tree item keyboard key press
         * @param  {event} event Keyboard event
         * @return {}
         */
        $scope.onTreeItemKeydown = function (event, node) {
          /*
           37: left
           38: top
           39: right
           40: down
           */
          switch (event.keyCode) {
            case 13:
            case 32:
              event.preventDefault();
              event.stopPropagation();
              break;
            case 37: // left
              // collapse node
              if (!node.collapsed && node.items) {
                node.collapsed = true;
                fireCollapseCallback(node);
              }
              // move up one level and focus the parent node
              else if ($scope.$parent.node) {
                $scope
                  .treeSelectionHelper
                  .getRootElement()[0]
                  .querySelector('#' + $scope.$parent.node.$$bentoTreeId + ' > .bento-tree-item-cta')
                  .focus();
              }

              event.preventDefault();
              event.stopPropagation();
              break;
            case 38: // top
              fucusToAvailableNodeWith(event.currentTarget, -1);
              event.preventDefault();
              event.stopPropagation();
              break;
            case 39: // right
              if (node.items) {
                if (node.collapsed) {
                  node.collapsed = false;
                  fireCollapseCallback(node);

                  // Auto focus the first child node
                  // Similar to Windows File Explorer
                  if (node.items.length > 0) {
                    $timeout(function () {
                      fucusToAvailableNodeWith(event.target, 1);
                    });
                  }
                } else if (node.items.length > 0) {
                  fucusToAvailableNodeWith(event.currentTarget, 1);
                }
              }
              event.preventDefault();
              event.stopPropagation();
              break;
            case 40: // down
              fucusToAvailableNodeWith(event.currentTarget, 1);
              event.preventDefault();
              event.stopPropagation();
              break;
          }
        };

        function fucusToAvailableNodeWith(currentNode, step) {
          var currentIndex, ctaArray;
          ctaArray = $scope.treeSelectionHelper.getClickableNodes();
          currentIndex = ctaArray.indexOf(currentNode);
          ctaArray[(currentIndex + ctaArray.length + step) % ctaArray.length].focus();
        }

        /**
         * Node keyboard event listener on keyup
         * @param event
         * @param node
         */
        $scope.onTreeItemKeyup = function (event, node) {
          if (event.keyCode === 13 || event.keyCode === 32) {
            $scope.labelSelect(node, event);
          }
        };

        /**
         * This method is used by the Template to get node CSS class
         * @param node
         */
        $scope.getNodeSelectionClass = function (node) {
          var css = '';

          // See if this node is selected
          if (treeHelper.getSelectModelValue($scope, node)) {
            css = 'selected';
          } else {
            css = '';
          }

          // If this node is selectable
          if (typeof $scope.selectableModel === 'undefined' ||
            typeof node[$scope.selectableModel] === 'undefined' ||
            (typeof node[$scope.selectableModel] === 'boolean' && node[$scope.selectableModel])) {
            css += ' bento-selectable';
          }

          // If this node is disabled
          if (node.disabled) {
            css += ' bento-tree-disabled';
          }

          return css;
        };

        /**
         * Expand or Collapse a branch
         */
        $scope.toggleCollapse = function (node) {
          node.collapsed = !node.collapsed;
          fireCollapseCallback(node);
        };

        ctrl.onSearchChange = function () {
          treeHelper.searchAndMark(ctrl.search.toLowerCase(), $scope.treeModel, $scope.treeLabel, $scope.nodeChildren);
        };

        function fireCollapseCallback(node) {
          if (!node.collapsed) {
            // Make sure if the callback exists
            if (typeof $scope.expandingCallback !== 'undefined' && $scope.expandingCallback) {
              $scope.expandingCallback(node);
            }
          } else {
            // Make sure if the callback exists
            if (typeof $scope.collapsingCallback !== 'undefined' && $scope.collapsingCallback) {
              $scope.collapsingCallback(node);
            }
          }
        }

        /**
         * not used at the moment
         */
        $scope.loadMore = function () {
          $scope.limitAmount += 20;
        };

        /**
         * Clean memory
         */
        $scope.$on('$destroy', function (event) {
          if (ctrl.isRoot) {
            $scope.treeSelectionHelper.clearNodes($scope.node, $scope.nodeChildren);
          }
        });
      }
    ])

    /**
     * Directive for lazy loading
     */
    .directive('lastWatch', [
      '$timeout',
      function ($timeout) {
        return {
          restrict: 'A',
          link: function (scope) {
            scope.$watch('$last', function (value) {
              if (value) {
                $timeout(function () {
                  scope.$parent.loadMore();
                });
              }
            });
          }
        };
      }
    ]);
}(window.angular));

(function(angular, undefined) {
  'use strict';

  var CHECKBOX = '-checkbox';
  var NODE_HIDDEN_PROP = '$$bentoNodeHidden';
  var LEVEL_PROP = '$$buiItemLevel';
  var INDENTATION_PADDING = '$$buiItemIndentation';
  var treeViewID = 0;
  var INDENTATION = '16';

  BentoTreeViewController.$inject = [
    '$q',
    '$scope',
    '$element',
    '$bentoKeyboard',
    '$bentoServices',
    '$sanitize'
  ];

  function BentoTreeViewController(
    $q,
    $scope,
    $element,
    $keyboard,
    $bentoServices,
    $sanitize
  ) {
    var ctrl = this;
    var parentMap;
    var btDeferred;
    var btDom;
    ctrl.$parent = $scope.$parent;
    ctrl.checkedItems = [];
    ctrl.selectedItems = [];
    ctrl.isRTL = false;
    ctrl.indentationPx = INDENTATION;
    ctrl.uid = 'buiTreeView' + treeViewID++;
    ctrl.indeterminateProp = '$' + ctrl.uid + 'Indeterminate';
    ctrl.btControl = {};
    ctrl.btColumnDefinitions = [
      {
        type: 'template',
        template: 'tree-view-default-cell-template'
      }
    ];

    ctrl.rowTemplate = 'tree-view-default-row-template';

    // Flattened tree data for UI rendering
    ctrl._itemsFlatData = [];

    ctrl.toggleCollapse = function(item) {
      item.collapsed = !item.collapsed;

      if (item.collapsed) {
        ctrl.removeDescendants(item);
        ctrl.onCollapsing({item:item});
      } else {
        ctrl.insertDescendants(item);
        ctrl.onExpanding({item: item});
      }
      return ctrl.btControl.reloadTable(true);
    };

    /**
     * Draw indentation
     */
    ctrl.getIndentation = function(row) {
      if (ctrl.isRTL) {
        return { 'padding-right': row[INDENTATION_PADDING] };
      }
      return { 'padding-left': row[INDENTATION_PADDING] };
    };

    /**
     * On init lifecycle hook
     */
    ctrl.$onInit = function() {
      // Check if this component is in RTL environment
      // Component needs to refresh
      ctrl.isRTL = $bentoServices.isRTL($element[0]);

      // Expose this main controller
      ctrl.treeViewController = this;

      // Give this comnponent a unique Class ID
      $element[0].classList.add(ctrl.uid);

      if (
        typeof ctrl.rowTemplateUrl === 'string' &&
        ctrl.rowTemplateUrl.length
      ) {
        ctrl.rowTemplate = ctrl.rowTemplateUrl;
      }

      ctrl.btOptions = {
        rowHeight: $sanitize(ctrl.rowHeight) || 30,
        colWidth: 100, // dummy and will overridden by CSS
        doNotAssignDimensions: true
      };

      btDom = $element[0].querySelector('[bento-table]');

      // Add keyboard listeners for navigations
      btDom.addEventListener('keydown', onTableKeydown);

      setRowStyles();

      setTimeout(function(){
        ctrl.onTreeViewReady();
      });
    };

    function setRowStyles() {
      // Update encapsulated Custom CSS
      var styleEl = $element[0].querySelector('style');
      var styles = [
        '.',
        ctrl.uid,
        ' .bui-tree-view-item-content {padding: ',
        (ctrl.btOptions.rowHeight - 18) * 0.5,
        'px 0;} ',
        '.',
        ctrl.uid,
        ' .bui-tree-view-expand-btn{margin-top:',
        (ctrl.btOptions.rowHeight - 30) * 0.5,
        'px;}',
        '.',
        ctrl.uid,
        ' .bento-table-row{height:',
        ctrl.btOptions.rowHeight,
        'px;}'
      ].join('');

      styleEl.innerHTML = styles;
    }

    // On keyboard keydown listner
    function onTableKeydown(e) {
      var currentRowIndex;
      var activeEl = document.activeElement;
      var nextRowIndex;
      var tabbables;
      var rowTabbableIndex;
      switch (e.keyCode) {
        case $keyboard.DOWN:
          currentRowIndex = getCurrentFocuesedRowID();
          tabbables = getRowTabbables(currentRowIndex);
          rowTabbableIndex = tabbables.indexOf(activeEl);
          nextRowIndex = currentRowIndex + 1;
          if (
            nextRowIndex < ctrl._itemsFlatData.length &&
            !isNaN(nextRowIndex)
          ) {
            focusToRowWithIndex(nextRowIndex, rowTabbableIndex);
            e.preventDefault();
          }
          break;
        case $keyboard.UP:
          currentRowIndex = getCurrentFocuesedRowID();
          tabbables = getRowTabbables(currentRowIndex);
          rowTabbableIndex = tabbables.indexOf(activeEl);
          nextRowIndex = currentRowIndex - 1;
          if (nextRowIndex >= 0 && !isNaN(nextRowIndex)) {
            focusToRowWithIndex(nextRowIndex, rowTabbableIndex);
            e.preventDefault();
          }
          break;
        case $keyboard.LEFT:
          if (ctrl.isRTL) {
            moveFocusToRight();
          } else {
            moveFocusToLeft();
          }
          e.preventDefault();
          break;
        case $keyboard.RIGHT:
          if (ctrl.isRTL) {
            moveFocusToLeft();
          } else {
            moveFocusToRight();
          }
          e.preventDefault();
          break;
        case $keyboard.HOME:
          currentRowIndex = getCurrentFocuesedRowID();
          tabbables = getRowTabbables(currentRowIndex);
          rowTabbableIndex = tabbables.indexOf(activeEl);
          focusToRowWithIndex(0, rowTabbableIndex);
          e.preventDefault();
          break;
        case $keyboard.END:
          currentRowIndex = getCurrentFocuesedRowID();
          tabbables = getRowTabbables(currentRowIndex);
          rowTabbableIndex = tabbables.indexOf(activeEl);
          focusToRowWithIndex(ctrl._itemsFlatData.length - 1, rowTabbableIndex);
          e.preventDefault();
          break;
        default:
          break;
      }
    }

    function moveFocusToLeft() {
      var currentRowIndex;
      var activeEl = document.activeElement;
      var tabbables;
      var rowTabbableIndex;
      var row;

      currentRowIndex = getCurrentFocuesedRowID();
      tabbables = getRowTabbables(currentRowIndex);
      rowTabbableIndex = tabbables.indexOf(activeEl);
      row = ctrl._itemsFlatData[currentRowIndex];
      var parent = parentMap.get(row);

      if (rowTabbableIndex === 0) {
        if (row[ctrl.nodeChildren] && !row.collapsed) {
          ctrl.toggleCollapse(row);
        }
        if (parent) {
          focusToRowWithIndex(
            ctrl._itemsFlatData.indexOf(parent),
            rowTabbableIndex
          );
        }
      } else if (rowTabbableIndex > 0) {
        tabbables[rowTabbableIndex - 1].focus();
      }
    }

    function moveFocusToRight() {
      var currentRowIndex;
      var activeEl = document.activeElement;
      var tabbables;
      var rowTabbableIndex;

      currentRowIndex = getCurrentFocuesedRowID();
      tabbables = getRowTabbables(currentRowIndex);
      rowTabbableIndex = tabbables.indexOf(activeEl);
      var currentNode = ctrl._itemsFlatData[currentRowIndex];

      if (
        rowTabbableIndex === tabbables.length - 1 &&
        currentNode[ctrl.nodeChildren]
      ) {
        if (currentNode.collapsed) {
          ctrl.toggleCollapse(currentNode).then(function() {
            focusToRowWithIndex(
              ctrl._itemsFlatData.indexOf(currentNode[ctrl.nodeChildren][0]),
              rowTabbableIndex
            );
          });
        } else {
          focusToRowWithIndex(
            ctrl._itemsFlatData.indexOf(currentNode[ctrl.nodeChildren][0]),
            rowTabbableIndex
          );
        }
      } else if (rowTabbableIndex < tabbables.length - 1) {
        tabbables[rowTabbableIndex + 1].focus();
      }
    }

    function focusToRowWithIndex(rowIndex, tabbableIndex) {
      ctrl.btControl.showRow(rowIndex, $q).then(function() {
        window.requestAnimationFrame(function() {
          setTimeout(function() {
            var tabbables = getRowTabbables(rowIndex);
            tabbables[Math.min(tabbableIndex, tabbables.length - 1)].focus();
          });
        });
      });
    }

    function getRowTabbables(rowIndex) {
      var rowEl = $element[0].querySelector(
        '.bui-tree-view-item[rel="' +
          rowIndex +
          '"] .bui-tree-view-item-content'
      );
      return $bentoServices.findTabbable(rowEl);
    }

    function getCurrentFocuesedRowID() {
      var el = document.activeElement;
      if (btDom.contains(el)) {
        while (
          !el.classList.contains('bui-tree-view-item') &&
          el.nodeName !== 'BODY'
        ) {
          el = el.parentElement;
        }
        return parseInt(el.getAttribute('rel'));
      } else {
        return Number.NaN;
      }
    }

    /**
     * Collapse all tree items
     */
    ctrl.collapseAll = function() {
      setCollapseAllState(true);
    };

    /**
     * Expand all tree items
     */
    ctrl.expandAll = function() {
      setCollapseAllState(false);
    };

    // Utilized by
    // `ctrl.collapseAll()` and `ctrl.expandAll()`
    function setCollapseAllState(doIt) {
      ctrl.treeCollapsed = doIt;
      ctrl.setTreeCollapseState(ctrl.treeModel, doIt, false);
      ctrl.refresh();
    }

    /**
     * On change lifecycle hook
     */
    ctrl.$onChanges = function(changes) {
      if (changes.treeCollapsed && ctrl.treeModel) {
        var takeItemSetting =
          typeof changes.treeCollapsed.previousValue !== 'boolean';
        ctrl.setTreeCollapseState(
          ctrl.treeModel,
          changes.treeCollapsed.currentValue,
          takeItemSetting
        );
        ctrl.refresh();
      } else if (changes.treeModel) {
        if (
          typeof ctrl.treeCollapsed === 'boolean' &&
          Array.isArray(ctrl.treeModel)
        ) {
          ctrl.setTreeCollapseState(
            ctrl.treeModel,
            ctrl.treeCollapsed,
            takeItemSetting
          );
        }
        ctrl.refresh(typeof changes.treeModel.previousValue === 'boolean');
      }
    };

    /**
     * Set the collapse states for the entire tree
     */
    ctrl.setTreeCollapseState = function(items, collapsed, takeItemSetting) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var children = item[ctrl.nodeChildren];
        if (Array.isArray(children)) {
          if (!takeItemSetting) {
            item.collapsed = collapsed;
          }
          if (children.length) {
            ctrl.setTreeCollapseState(children, collapsed, takeItemSetting);
          }
        }
      }
    };

    /**
     * Refresh Tree View
     */
    ctrl.refresh = function(reloadBentoTable) {
      var model = ctrl.treeModel;
      reloadBentoTable = reloadBentoTable == null ? true : false;

      ctrl.btOptions = {
        rowHeight: $sanitize(ctrl.rowHeight) || 30,
        colWidth: 100, // dummy and will overridden by CSS
        doNotAssignDimensions: true
      };

      setRowStyles();

      if (model) {
        // Only refresh when there is a model presense
        ctrl.createParentMapping();
        ctrl.assignLevel();
        ctrl._itemsFlatData = [];
        for (var i = 0; i < model.length; i++) {
          var item = model[i];
          if (!item.hidden) {
            ctrl._itemsFlatData.push(item);
            ctrl.insertDescendants(item);
            ctrl.updateCheckedState(item);
          }
        }
        if (ctrl.btControl.reloadTable && reloadBentoTable) {
          // Reload table when assigned
          ctrl.btControl.reloadTable(true);
        }
        if (btDeferred) {
          // Resolve the current data when there is still a promise pending
          btDeferred.resolve(this._itemsFlatData);
          btDeferred = null;
        }
      }
    };

    /**
     * On check change
     */
    ctrl.onCheckChange = function(item) {
      if (!ctrl.independentCheckbox) {
        var parent = parentMap.get(item);
        this.updateParentCheckState(parent);

        ctrl.updateCheckedItemsArray(item);

        // Disable indeterminate
        item[ctrl.indeterminateProp] = false;

        ctrl.checkChildren(item, item[ctrl.checkboxModel]);

        // TODO: Fire callback here
        ctrl.onCheckboxChange({item:item});
      }
    };

    ctrl.updateCheckedItemsArray = function(item) {
      var itemIndex = ctrl.checkedItems.indexOf(item);
      var isChecked = item[ctrl.checkboxModel];

      if (isChecked && itemIndex === -1) {
        // If item is checked and is not in `checkedItem` array
        ctrl.checkedItems.push(item);
      } else if (!isChecked && itemIndex > -1) {
        // If item is NOT checked and is in `checkedItem` array
        ctrl.checkedItems.splice(itemIndex, 1);
      }
    };

    /**
     * Update checkbox status based on their relationships
     * This method is only used when model is updated or refreshed
     */
    ctrl.updateCheckedState = function(item) {
      if (ctrl.independentCheckbox) {
        // No need to do anything
        return;
      }

      var isChecked = item[ctrl.checkboxModel];

      if (isChecked) {
        ctrl.checkChildren(item, true);
      } else {
        var children = item[ctrl.nodeChildren];

        if (children) {
          var allChecked = true;
          var allUnChecked = true;
          var hasIndeterminate = false;

          for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (child.hidden) {
              // We skip the check state of hidden items
              continue;
            }
            var indetermiate = ctrl.updateCheckedState(child);
            var childIsChecked = child[ctrl.checkboxModel];

            if (indetermiate) {
              hasIndeterminate = true;
            } else if (childIsChecked) {
              allUnChecked = false;
            } else if (!childIsChecked) {
              allChecked = false;
            }
          }

          if (hasIndeterminate || !(allChecked || allUnChecked)) {
            // Indeterminate state is present
            item[ctrl.indeterminateProp] = true;
            item[ctrl.checkboxModel] = false;
          } else {
            item[ctrl.indeterminateProp] = false;
            item[ctrl.checkboxModel] = allChecked;
          }

          ctrl.updateCheckedItemsArray(item);

          return false;
        } else {
          // Not indetermindate
          return false;
        }
      }
    };

    /**
     * Update parent change state
     */
    ctrl.updateParentCheckState = function(item) {
      if (!item) {
        // There is nothing to check
        return;
      }

      var allChecked = true;
      var allUnChecked = true;
      var hasIndeterminate = false;
      var children = item[ctrl.nodeChildren];

      for (var i = 0; i < children.length; i++) {
        var child = children[i];

        if (!child.hideCheckbox) {
          var isChecked = child[ctrl.checkboxModel];
          var isIndeterminate = child[ctrl.indeterminateProp];

          if (isIndeterminate || !(allChecked || allUnChecked)) {
            hasIndeterminate = true;
            break;
          } else if (allUnChecked && allChecked) {
            allChecked = isChecked;
            allUnChecked = !isChecked;
          } else if (
            (allChecked && !isChecked) ||
            (allUnChecked && isChecked)
          ) {
            hasIndeterminate = true;
            break;
          }
        }
      }

      if (hasIndeterminate) {
        // Indeterminate state is present
        item[ctrl.indeterminateProp] = true;
        item[ctrl.checkboxModel] = false;
      } else {
        item[ctrl.indeterminateProp] = false;
        item[ctrl.checkboxModel] = allChecked;
      }

      ctrl.updateCheckedItemsArray(item);

      // Now check this item's parent
      ctrl.updateParentCheckState(parentMap.get(item));
    };

    /**
     * Check children based on the current item status
     */
    ctrl.checkChildren = function(item, state) {
      var children = item[ctrl.nodeChildren];
      if (Array.isArray(children)) {
        for (var i in children) {
          var child = children[i];
          child[ctrl.checkboxModel] = state; // Do not bubble
          ctrl.updateCheckedItemsArray(child);
          ctrl.checkChildren(child, state);
        }
      }
    };

    /**
     * Callback when Bento Table data is ready
     */
    ctrl.onBTReady = function() {
      // To add when Bento Table is ready
    };

    /**
     * Callback when user selects an item
     */
    ctrl.onItemSelect = function(item, event) {
      if (ctrl.expandOnlyModel && item[ctrl.expandOnlyModel]) {
        ctrl.toggleCollapse(item);
      } else if (ctrl.selectAsCheck) {
        item[ctrl.checkboxModel] = !item[ctrl.checkboxModel];
        ctrl.onCheckChange(item);
      } else if (item[ctrl.selectableModel] !== false) {
        var isSelected = !item[ctrl.selectModel];
        var result;
          // need to get result from user input incase they want to
          // cancel this selection
          result = ctrl.onSelect({item:item, isSelected: isSelected, event:event});

        if (result !== false) {
          // Only execute when result is undefined or `true`
          var index = ctrl.selectedItems.indexOf(item);
          item[ctrl.selectModel] = isSelected;

          if (!ctrl.multiSelect && isSelected) {
            while (ctrl.selectedItems.length) {
              ctrl.selectedItems.pop()[ctrl.selectModel] = false;
            }
          }

          if (isSelected && index < 0) {
            ctrl.selectedItems.push(item);
          } else if (!isSelected && index > -1) {
            ctrl.selectedItems.splice(index, 1);
          }
        }
      }
    };

    /**
     * Callback for Bento Table to feed tree data
     */
    ctrl.feedTreeData = function() {
      btDeferred = $q.defer();

      setTimeout(function() {
        // Create data object
        if (btDeferred && ctrl._itemsFlatData && ctrl._itemsFlatData.length) {
          btDeferred.resolve(ctrl._itemsFlatData);
          btDeferred = null;
        }
      }, 0);

      return btDeferred.promise;
    };

    /**
     * Create parent child mapping to avoid circular reference
     */
    ctrl.createParentMapping = function(parent) {
      var children;
      if (parent == null) {
        parentMap = new Map();
        children = ctrl.treeModel;
      } else if (parent[ctrl.nodeChildren]) {
        children = parent[ctrl.nodeChildren];
      }

      if (children && children.length) {
        for (var index in children) {
          var child = children[index];
          if (parent) {
            parentMap.set(child, parent);
          }
          ctrl.createParentMapping(child);
        }
      }
    };

    /**
     * Insert all descendants into an item for render
     */
    ctrl.insertDescendants = function(parent) {
      if (parent.collapsed) {
        // This node is collapsed so there is no need to insert its children
        return;
      }

      var children = parent[ctrl.nodeChildren];

      if (Array.isArray(children)) {
        // Get the index where the current parent is located in the flatArray
        // Insert its children after the index
        var index = ctrl._itemsFlatData.indexOf(parent) + 1;

        ctrl._itemsFlatData.splice.apply(
          ctrl._itemsFlatData,
          [index, 0].concat(children)
        );

        for (var childIndex in children) {
          // Do the same to each child
          ctrl.insertDescendants(children[childIndex]);
        }
      }
    };

    /**
     * Remove all descendants of the parent from the flattened array
     */
    ctrl.removeDescendants = function(item) {
      var startIndex = ctrl._itemsFlatData.indexOf(item) + 1;
      var endIndex = -1;
      var me = item;
      var parent;
      var index;
      var siblings;

      while (endIndex < 0) {
        parent = parentMap.get(me);
        siblings = parent ? parent[ctrl.nodeChildren] : ctrl.treeModel;
        index = siblings.indexOf(me) + 1;

        if (index < siblings.length) {
          // Found! There is a younger sibling
          // 1 based indexing
          endIndex = ctrl._itemsFlatData.indexOf(siblings[index]);
        } else if (parent) {
          // Nope! Need to find itemMarkers parent's younger sibling
          me = parent;
        } else {
          // This `parent` is the last parent here
          // remove the reset
          endIndex = ctrl._itemsFlatData.length;
        }
      }

      // Now we remove
      ctrl._itemsFlatData.splice(startIndex, endIndex - startIndex);
    };

    /**
     * Assign tree item level from the root (ZERO)
     * @param {treeItem} item Each tree item node
     * @param {number} level depth of this node's depth from root (ZERO)
     */
    ctrl.assignLevel = function(item, level) {
      var children = ctrl.treeModel; // default to the root array
      level = level == null ? -1 : level; // default to 0

      if (item) {
        // Get the next level of children and assign the current level to
        // the current item
        item[LEVEL_PROP] = level;
        item[INDENTATION_PADDING] = level * INDENTATION + 'px';
        children = item[ctrl.nodeChildren];
      }

      if (children && children.length) {
        // Move to the next level reccursively
        level++;
        for (var i = 0; i < children.length; i++) {
          ctrl.assignLevel(children[i], level);
        }
      }
    };
  }

  // Provides lazy loading to enhance initial load time
  angular
    .module('bento.tree.view', ['ngSanitize', 'bento.table'])
    .component('bentoTreeView', {
      bindings: {
        checkboxModel: '@',
        expandOnlyModel: '@',
        independentCheckbox: '<',
        multiSelect: '<',
        nodeChildren: '@',
        onCollapsing: '&',
        onCheckboxChange: '&',
        onExpanding: '&',
        onSelect: '&',
        onTreeViewReady: '&',
        rowHeight: '<',
        rowTemplateUrl: '@',
        secondTreeIcon: '@',
        selectModel: '@',
        selectableModel: '@',
        selectAsCheck: '<',
        showExpandCollapseAllButtons: '<',
        treeLabel: '@',
        treeModel: '<',
        treeIcon: '@',
        treeCollapsed: '=?',
        treeController: '=',
        treeViewController: '=?'
      },
      controller: BentoTreeViewController,
      controllerAs: '$treeViewCtrl',
      templateUrl: '../templates/tree-view/bento-tree-view.html'
    });
})(window.angular);

(function (window, angular, undefined) {
  'use strict';

  /**
   * @ngdoc directive
   * @name bentoWizrd
   * @description
   *
   * # bentoWizrd
   *
   * The `bentoWizrd` directive provides directive objects to mimic off canvas menue behavior.
   *
   *   */

    // Global setting variables

  var GAP = 37;  // in pixels
  var WINDOW_RESIZE_DELAY = 300; // in milliseconds
  var MAX_STEP_BOX_WIDTH = 350; // in pixels
  var STEP_PADDING = 0;  // in pixels
  var TRANSITION_DURATION = 200; // in ms

// Define bentoUI App object
  angular.module('bento.wizard', ['ui.bootstrap', 'bento.services', 'bento.cookie', 'bento.translate'])
    .controller('wizardMainController', ['$scope', '$rootScope', '$element', '$bentoServices',
      function ($scope, $rootScope, $element, $bentoServices) {
        // initialize variables
        $scope.isRTL = $bentoServices.isRTL($element[0]);
        $scope.isLeftArrowDisabled = true;
        $scope.isRightArrowDisabled = true;

        $element.addClass('bento-wizard');

        // Add SR content HTML
        $scope.wizardDesciption = angular.element('<span tabindex="0" class="sr-only">{{\'BENTO_UI_WIZARD_DESCRIPTION\' | bentoTranslate}}</span>');

        // For a controller to control to assign the current step
        // to this wizard directive
        if (typeof $scope.currentStep === 'undefined') {
          // Default current step to 0
          $scope.currentStep = 0;
        }
        $scope.previousStep = 0;

        // Set side-arrows true by default
        $scope._useSideArrows = !!(typeof $scope.useSideArrows === 'undefined' || $scope.useSideArrows === 'true');

        // Left and Right Arrow clicks
        $scope.onLeftArrowClick = function () {
          var scrollPane = $scope.$ul[0].parentElement;
          // Can scroll the whole pane
          if ($scope.leftIndex >= $scope.displayCount) {
            $scope.leftIndex = $scope.leftIndex - $scope.displayCount;
          }
          // Scroll to 0
          else {
            $scope.leftIndex = 0;
          }

          $scope.scrollLeftTo(scrollPane, $scope.leftIndex);
          $scope.updateLeftRightArrows();
        };

        $scope.onRightArrowClick = function () {
          var scrollPane = $scope.$ul[0].parentElement;
          // Can scroll the whole pane
          if (($scope.numSteps - $scope.leftIndex - $scope.displayCount) >= $scope.displayCount) {
            $scope.leftIndex = $scope.leftIndex + $scope.displayCount;
          }
          // Scroll all the way to the right
          else {
            $scope.leftIndex = $scope.numSteps - $scope.displayCount;
          }

          $scope.scrollLeftTo(scrollPane, $scope.leftIndex);
          $scope.updateLeftRightArrows();
        };

        // Watch step disabled states
        $scope.$watchCollection(
          function () {
            var states = [],
                children;

            if ($scope.$ul) {
              children = $scope.$ul.children();
              for (var i = 0, len = children.length; i < len; i++) {
                states.push(children[i].getAttribute('disabled'));
              }
            }

            return states;
          },
          function (states) {
            var children;

            if ($scope.$ul) {
              children = $scope.$ul.children();
            }

            for (var i = 0, len = states.length; i < len; i++) {
              if (states[i]) {
                children[i].removeAttribute('tabindex');
              } else {
                children[i].setAttribute('tabindex', 0);
              }
            }
          }
        );

        // Watch step states
        $scope.$watch(function () {
          var steps      = $element[0].querySelectorAll('.bento-wizard-step'),
              step,
              // true: enabled
              // false: disabled
              // .p: previous button
              // .n: next button
              stepStates = {p: true, n: true};

          //Check previous
          if ($scope.currentStep > 0 && steps[$scope.currentStep - 1]) {
            stepStates.p = steps[$scope.currentStep - 1].getAttribute('disabled') == undefined;
          } else {
            stepStates.p = true;
          }

          //Check next
          if ($scope.currentStep < steps.length - 1 && steps[$scope.currentStep + 1]) {
            stepStates.n = steps[$scope.currentStep + 1].getAttribute('disabled') == undefined;
          } else {
            stepStates.n = true;
          }

          return stepStates;

        }, function (stepStates) {
          // Set button disabled states

          $scope.buttonNextDisabled = !stepStates.n;
          $scope.buttonPreviousDisabled = !stepStates.p;
        }, true);

        // Previous and Next button clicks
        $scope.onPreviousClick = function () {
          if ($scope.currentStep === 0) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = parseInt($scope.currentStep, 10) - 1;
          // focus on the main content
          $scope.content[0].focus();
        };

        $scope.onNextClick = function () {
          if ($scope.currentStep === $scope.stepList.length - 1) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = parseInt($scope.currentStep, 10) + 1;
          // focus on the main content
          $scope.content[0].focus();
        };

        // Done button click
        $scope.onDoneClick = function () {
          $scope.isUserAction = true;
          $scope.onFinish();
        };

        // A step is clicked on the top step nav
        $scope.onStepClick = function (step) {

          // ignore the step that is already selected
          if (step === $scope.currentStep) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = step;
        };

      }])
    .directive('bentoWizard', [
      '$compile',
      '$timeout',
      '$window',
      '$log',
      '$bentoServices',
      function ($compile, $timeout, $window, $log, $bentoServices) {
        return {
          restrict  : 'AEC',
          replace   : false,
          scope     : {
            onChange              : '&',  // Fire onChange() when a wizard step is changed.
            onFinish              : '&',  // Fire onFinish() when the whole wizard is finished
            onCancel              : '&',  // Fire onCancel() when the "Cancel" button is clicked
            useSideArrows         : '@',  // Check if we need to use arrows
            currentStep           : '=?', // Listen to step value change
            totalStep             : '=?', // Expose the total number of steps
            demoMode              : '@',  // A mode to disable focus
            isDoneButtonDisabled  : '&',  // Expose showButtonDone
            hideDefaultButtons    : '&',  // Hide "Previous", "Next" and "Done" buttons
            hidePreviousButton    : '&',  // Hide "Previous" button
            hideNextButton        : '&',  // Hide "Next" button
            hideDoneButton        : '&',  // Hide "Done" button
            showCancelButton      : '&',  // Show "Cancel" button
            isCancelButtonDisabled: '&',  // Disable "Cancel" button
            useStickyFooter       : '@',  // Flag to show if the footer should be sticky
            stickyFooterFullWidth : '&',  // Flag to determine if the footer span to the fullwidth of the scroll. default `true`
          },
          controller: 'wizardMainController',
          link      : function (scope, element) {
            // This flag is used when a use dynamically change the currentStep and return false
            // onChange() So that the updateStep() doesn't fire in the watch
            var isCurrentSetpReset = false;
            // For windows resize
            var resizeTimeout = 0;
            // side of margin
            var marginSide = scope.isRTL? 'marginRight':'marginLeft';
            // This variable is used to make sure Wizard still has the correct width to avoid
            // IE related offsetWidth == 0 issue
            var widthCache;

            scope.el = element[0];
            scope.isUserAction = false;
            element.addClass('ng-hide');

            // Render wizard when all rendering is done
            $timeout(function () {

              // Basic rendering
              // update the step layouts the first time
              $timeout(renderStepWidth, 1);
              // need to re-render the second path in case the scroll bar showed/hided
              $timeout(renderStepWidth, 2);

              // Watch element width and render it's width
              angular.element($window).on('resize', onWindowResize);

              // localization
              var cancelButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL' | bentoTranslate }}";
              var nextButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_NEXT' | bentoTranslate }}";
              var previousButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS' | bentoTranslate }}";
              var doneButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_DONE' | bentoTranslate }}";
              var cancelButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION' | bentoTranslate }}";
              var nextButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION' | bentoTranslate }}";
              var previousButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION' | bentoTranslate }}";
              var doneButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION' | bentoTranslate }}";
              var wizardFooter = angular.element(
                '<div ' + 
                (scope.useStickyFooter === 'true' ? 
                  'bento-sticky-footer show-on-element-visible="el" full-width="stickyFooterFullWidth()"' : '') + 
                'class="bento-wizard-footer"></div>');
              var customFooterElements = [];

              // Content pointers
              scope.content = angular.element(element[0].querySelector('.contents'));
              scope.contents = scope.content.children();

              // Get custom footer elements
              var customSibling = scope.content[0].nextSibling;
              while(customSibling){
                customFooterElements.push(customSibling);
                customSibling = customSibling.nextSibling;
              }

              // Add cancel button
              var buttonCancel = angular.element(
                '<button role="button" class="btn btn-cancel btn-default btn-action pull-right" ' +
                'role="button" aria-label="' + cancelButtonLabelDescription + '" ' +
                'title="' + cancelButtonLabelDescription + '"' +
                'ng-click="onCancel({step:currentStep})" ' +
                'ng-if="!hideDefaultButtons() && showCancelButton()" ' +
                'ng-disabled="isCancelButtonDisabled()"' +
                'bento-test="button-cancel"' +
                '>' +
                cancelButtonLabel +
                '</button>'
              );

              // Add previous and next buttons
              var buttonNext = angular.element(
                '<button role="button" class="btn btn-next btn-primary btn-action pull-left" ' +
                'role="button" aria-label="' + nextButtonLabelDescription + '" ' +
                'title="' + nextButtonLabelDescription + '"' +
                'ng-show="showButtonNext" ng-click="onNextClick()" ' +
                'ng-if="!hideDefaultButtons() && !hideNextButton()" ' +
                'ng-disabled="buttonNextDisabled"' +
                'bento-test="button-next"' +
                '>' +
                nextButtonLabel +
                ' <i class="bento-icon-chevron-right"></i></button>'
              );
              var buttonPrevious = angular.element(
                '<button role="button" class="btn btn-previous btn-default pull-left" ' +
                'role="button" aria-label="' + previousButtonLabelDescription + '" ' +
                'ng-show="showButtonPrevious" ng-click="onPreviousClick()" ' +
                'title="' + previousButtonLabelDescription + '"' +
                'ng-if="!hideDefaultButtons() && !hidePreviousButton()" ' +
                'ng-disabled="buttonPreviousDisabled"' +
                'bento-test="button-previous">' +
                '<i class="bento-icon-chevron-left"></i> ' +
                previousButtonLabel +
                '</button>'
              );
              var buttonDone = angular.element(
                '<button class="btn btn-primary btn-action pull-left" ' +
                'role="button" aria-label="' + doneButtonLabelDescription + '"' +
                'title="' + doneButtonLabelDescription + '"' +
                'ng-disabled="isDoneButtonDisabled()"' +
                'ng-show="showButtonDone" ng-click="onDoneClick()"' +
                'ng-if="!hideDefaultButtons() && !hideDoneButton()" ' +
                'bento-test="button-done"' +
                '>' +
                doneButtonLabel +
                '</button>'
              );
              scope.$buttonNext = buttonNext;
              scope.$buttonPrevious = buttonPrevious;
              scope.$buttonDone = buttonDone;

              // Add top left and right arrows
              var arrowLeft = angular.element(
                '<button class="wizard-arrow arrow-left"' +
                ' role="button" aria-label="Left Arrow"' +
                ' alt="Show previous step headers"' +
                ' ng-disabled="isLeftArrowDisabled"' +
                ' tabindex="-1"' +
                ' ng-click="onLeftArrowClick()">' +
                ' <i class="bento-icon-chevron-large-left"></i>' +
                '</button>'
              );
              var arrowRight = angular.element(
                '<button class="wizard-arrow arrow-right"' +
                ' role="button" aria-label="Right Arrow"' +
                ' alt="Show next step headers"' +
                ' ng-disabled="isRightArrowDisabled"' +
                ' tabindex="-1"' +
                ' ng-click="onRightArrowClick()">' +
                ' <i class="bento-icon-chevron-large-right"></i>' +
                '</button>'
              );

              scope.$arrowLeft = arrowLeft;
              scope.$arrowRight = arrowRight;

              $compile(arrowLeft)(scope);
              $compile(arrowRight)(scope);

              // Compile description
              $compile(scope.wizardDesciption)(scope);
              wizardFooter.append(buttonPrevious);
              wizardFooter.append(buttonNext);
              wizardFooter.append(buttonDone);
              wizardFooter.append(buttonCancel);

              // Compile Wizard footer
              $compile(wizardFooter)(scope);

              // Append custom buttons into footer
              for(var i=0; i<customFooterElements.length; i++){
                wizardFooter.append(customFooterElements[i]);
              }

              // POST DOM injection
              // Update model reference to be used in controller
              scope.$ul = angular.element(element[0].querySelector('.steps'));
              scope.stepList = scope.$ul.children();

              // Add the two buttons and footer to content
              scope.content.after(wizardFooter);
              scope.$ul.after(arrowLeft);
              scope.$ul.after(arrowRight);
              scope.$ul.attr('tabindex', -1);

              // Add description
              scope.$ul[0].parentElement.insertBefore(scope.wizardDesciption[0], scope.$ul[0]);

              // Add CSS class to the main container
              element.addClass('bento-wizard');

              // Assign Step Class Name with bento-wizard name spage
              scope.$ul.wrap('<div class="bento-wizard-steps" role="tablist"/>');

              processSteps();

              // Add scope.$ul keyboard listeners
              scope.$ul[0].addEventListener('keydown', function (event) {
                switch (event.keyCode) {
                  // Space & Enter
                  case 32:
                  case 13:
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                }
              });

              // Add scope.$ul keyboard listeners
              scope.$ul[0].addEventListener('keyup', function (event) {
                switch (event.keyCode) {
                  // Space & Enter
                  case 32:
                  case 13:
                    onStepClick(event, true);
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                  // Tab & shift-tab
                  case 9:
                  case 16:
                    var boxWidth  = scope.$ul.children()[0].offsetWidth,
                        leftCount = Math.round(scope.$ul[0].parentElement.scrollLeft / boxWidth);

                    scope.leftIndex = leftCount;
                    scope.updateLeftRightArrows();
                    break;
                }
              });

              // Add click event listeners to steps

              // init buttons
              scope.showButtonNext = (scope.stepList.length !== 1);
              scope.showButtonPrevious = false;
              scope.showButtonDone = (scope.stepList.length === 1);

              // setup content
              scope.content.attr('tabindex', -1);

              // Start to watch the currentStep variable change and
              // update wizards GUI
              scope.$watch('currentStep', function (newValue, oldValue) {
                scope.previousStep = oldValue;
                if (!isCurrentSetpReset) {
                  updateStep();
                } else {
                  isCurrentSetpReset = false;
                }
              });

              // Watch the count to the steps to see if there is anything changed
              var ulChildren = scope.$ul.children();
              scope.totalStep = ulChildren.length;

              scope.$watch(
                function () {
                  setTimeout(function () {
                    // Custom watch - gets fired for watch digest cycle but needs to be after
                    // rendering

                    // As reported on HUB issue #1
                    // https://thehub.thomsonreuters.com/thread/127898?sr=stream&ru=1145180
                    // New algorithm is implemented to reslove this issue when dynamic array had the
                    // same size when changing
                    var newUlChildren     = scope.$ul.children(),
                        i, len, hasChange = false;

                    if (ulChildren.length !== newUlChildren.length) {
                      ulChildren = newUlChildren;
                      hasChange = true;
                    } else {
                      for (i = 0, len = ulChildren.length; i < len; i++) {
                        if (ulChildren[i] !== newUlChildren[i]) {
                          ulChildren = newUlChildren;
                          hasChange = true;
                          break;
                        }
                      }
                    }

                    if (hasChange) {

                      $timeout(function () {
                        // Update step length
                        scope.totalStep = ulChildren.length;
                      });
                      

                      // Update Step List
                      updateStep();

                      // Add event listeners and classes to newly restored steps
                      processSteps();

                      // Need to re-render the width of the steps when adding or removing a step
                      renderStepWidth();
                    }

                  });

                  // return dummy
                  return 0;
                },
                function () {
                });

              // Skin steps
              function processSteps() {
                var stepHeaderHTML = '<div class="sr-only">{{\'BENTO_UI_WIZARD_STEP_NAME\' | bentoTranslate}}' +
                  '</div><div class="bento-wizard-step-count"></div>';
                // insert prefix number to a step <li> where it's not initialized
                for (var i = 0; i < scope.stepList.length; i++) {
                  var $li = angular.element(scope.stepList[i]);
                  if (!$li.hasClass('bento-wizard-step')) {
                    $li.addClass('bento-wizard-step');
                    $li.attr('role', 'tab');
                    // add counter and screen reader
                    $li.prepend($compile(angular.element(stepHeaderHTML))(scope));
                    // Add click event handler
                    $li.on('click', onStepClick);
                  }
                }
              }

              // Click function
              function onStepClick(event, target) {
                var currentTarget = target ? event.target : event.currentTarget;
                // ignore the click even if this step is disabled
                if (currentTarget.getAttribute('disabled')) {
                  return;
                }

                var index = 0;
                for (var i = 0; i < scope.stepList.length; i++) {
                  if (scope.stepList[i] === currentTarget) {
                    index = i;
                    break;
                  }
                }

                scope.onStepClick(index);
                scope.$apply();

                // Focus on the content after selection
                scope.content[0].focus();
              }

              // Show the whole module
              element.removeClass('ng-hide');
            }); // End of $timeout

            // Private function
            function updateStep() {
              var step = parseInt(scope.currentStep, 10);

              // Make sure the new step is a number
              step = isNaN(step) ? 0 : step;

              // Update the step and content references
              scope.stepList = scope.$ul.children();
              scope.contents = scope.content.children();

              // Reset currentStep if it is out of range
              if (scope.currentStep >= scope.stepList.length) {
                scope.currentStep = scope.stepList.length - 1;
              }

              // Fire event and forward step variable over
              if (typeof scope.onChange !== 'undefined' && scope.isUserAction) {
                if (scope.onChange({step: step}) === false) {
                  // Bypassed wizard update by user
                  step = scope.currentStep = scope.previousStep;
                  isCurrentSetpReset = true;
                }

                scope.isUserAction = false;
              }

              var previous$li;
              for (var i = 0; i < scope.stepList.length; i++) {
                var $li = angular.element(scope.stepList[i]);
                $li.removeClass('previous');
                if (i === step) {
                  $li.addClass('selected');
                  if (typeof previous$li !== 'undefined') {
                    previous$li.addClass('previous');
                  }
                } else {
                  $li.removeClass('selected');
                }

                previous$li = $li;
              }

              previous$li = null;

              // show & hide buttons
              scope.showButtonNext = !!((scope.stepList.length > 1) && (step < scope.stepList.length - 1));
              scope.showButtonPrevious = !!((scope.stepList.length > 1) && (step > 0));
              scope.showButtonDone = !!((scope.stepList.length === 1) || (step === scope.stepList.length - 1));

              // show & hide contents
              for (var j = 0; j < scope.contents.length; j++) {
                var $content = angular.element(scope.contents[j]);
                if (j === step) {
                  $content.removeClass('ng-hide');
                } else {
                  $content.addClass('ng-hide');
                }
              }

              updateStepContainerOffset();
            }

            // Update step location
            function updateStepContainerOffset() {
              scope.currentStep = parseInt(scope.currentStep, 10);

              if (isNaN(scope.currentStep)) {
                $log.warn('Wizard: `current-step` is not an integer ');
                scope.currentStep = 0;
              }

              // Variables to be used for calculation
              var scrollPane        = scope.$ul[0].parentElement,
                  offsetWidth       = scrollPane.offsetWidth,
                  stepArray         = scope.stepList,
                  stepWidth         = stepArray[0].offsetWidth,
                  currentSideMargin = -parseFloat(window.getComputedStyle(scope.$ul[0])[marginSide]),
                  leftOfPrevious    = (scope.currentStep > 0) ?
                    getOffsetLeft(scope.currentStep - 1,stepWidth,currentSideMargin) :
                    0,
                  rightOfNext       = (scope.currentStep < stepArray.length - 1) ?
                    getOffsetLeft(scope.currentStep + 1,stepWidth,currentSideMargin) + stepWidth:
                    0,
                  currentLeft = getOffsetLeft(scope.currentStep,stepWidth,currentSideMargin),
                  currentRight = currentLeft + stepWidth;

              // for For loop
              var stepOffsetLeft;

              // find the left index
              scope.leftIndex = 0;
              for (var i = 0; i < stepArray.length; i++) {
                stepOffsetLeft = getOffsetLeft(i,stepWidth,currentSideMargin);
                if (stepOffsetLeft <= currentSideMargin && stepOffsetLeft + stepWidth > 0) {
                  scope.leftIndex = i;
                  break;
                }
              }

              // Better UX
              // Check if the next or the previous step object is out side of the OL
              // Bring it bring if not
              if (leftOfPrevious < 0) {
                scope.leftIndex = scope.currentStep - 1;
              } else if (rightOfNext > offsetWidth) {
                scope.leftIndex = scope.currentStep + 2 - scope.displayCount;
              }

              // Again double check if the current object is in the container viewport or not
              // If not, bring it in.
              if (currentLeft < 0 && scope.leftIndex > 0) {
                scope.leftIndex = scope.currentStep;

              } else if (currentRight > offsetWidth+5  ) {
                scope.leftIndex = scope.currentStep - scope.displayCount + 1;
              }

              scope.scrollLeftTo(scope.$ul[0].parentElement, scope.leftIndex);

              scope.updateLeftRightArrows();
            }

            // get offsetLeft or a simulated offsetLeft from an element
            function getOffsetLeft(index,stepWidth,margin){
              return index * stepWidth - margin;
            }

            // Render boxes' width
            function renderStepWidth() {
              var offsetWidth = element[0].offsetWidth;
              var width;

              if(offsetWidth === 0 && widthCache){
                // IE Rendering issue
                // When inserting a new step, Wizard briefly gives offsetWidth with a ZERO
                // Setting $timeout of this method yelds a visual glitch so NO GO
                // Therefore we need to use the previous width value
                width = widthCache;
              }else{
                widthCache = width = offsetWidth - 2;
              }

              // Set the total step object to be displayed
              // in wizard viewport based on its width
              var numSteps = scope.stepList.length;
              var displayCount = (numSteps > 4) ? 4 : numSteps; // Default step count

              // Refine displayCount based on the width and numSteps
              if (width < 720 && displayCount > 2) {
                displayCount = 2;
              } else if (width < 960 && displayCount > 3) {
                displayCount = 3;
              } else if (MAX_STEP_BOX_WIDTH * displayCount + (displayCount - 1 ) * STEP_PADDING < width &&
                numSteps > displayCount) {
                displayCount = Math.ceil(width / MAX_STEP_BOX_WIDTH);
              }

              // Update displayCount for controller to use
              scope.displayCount = displayCount;
              // Add numSteps for controller to use
              scope.numSteps = numSteps;

              if (scope._useSideArrows) {
                if (displayCount < numSteps) {
                  element.addClass('side-arrows');
                  width = element[0].offsetWidth - GAP * 2
                    - 2;//side borders
                } else {
                  element.removeClass('side-arrows');
                }
              }

              // Set list container width based on the total step count
              // and their widths
              var boxWidth = (width - (displayCount - 1) * STEP_PADDING) / displayCount;
              scope.stepList = scope.$ul.children();

              //Cap the step box width
              if (numSteps == displayCount &&
                MAX_STEP_BOX_WIDTH * numSteps < width - 100 &&
                boxWidth > MAX_STEP_BOX_WIDTH
              ) {
                boxWidth = MAX_STEP_BOX_WIDTH;
              }

              scope.$ul.css('width', (scope.stepList.length * (boxWidth + STEP_PADDING)) + "px");
              scope.stepList.css('width', boxWidth + 'px');

              //Reset all height classes
              angular.element(scope.stepList).removeClass('narrow');

              //if (boxWidth > 310) {
              angular.element(scope.stepList).addClass('flat');
              scope.$arrowLeft.addClass('flat');
              scope.$arrowRight.addClass('flat');

              updateStepContainerOffset();
            }

            // Enable and Disable left and right arrows based on current
            // step position
            scope.updateLeftRightArrows = function () {

              if (typeof scope.displayCount === 'undefined') {
                return;
              }

              if (scope.leftIndex === 0) {
                scope.$arrowLeft.attr('disabled', 'disabled');
              } else {
                scope.$arrowLeft.removeAttr('disabled');
              }

              if (scope.leftIndex + scope.displayCount >= scope.numSteps) {
                scope.$arrowRight.attr('disabled', 'disabled');
              } else {
                scope.$arrowRight.removeAttr('disabled');
              }

              angular.element(scope.stepList).removeClass('most-right');

              if (element[0].offsetWidth <= scope.displayCount * MAX_STEP_BOX_WIDTH) {
                angular.element(scope.stepList[scope.leftIndex + scope.displayCount - 1]).addClass('most-right');
              }
            };

            // Scroll Animation for the header
            var initScrollLeft,
                dScrollLeft,
                scrollStartTime,
                targetScrollLeft,
                scrollRange
            ;

            scope.scrollLeftTo = function (scrollPane, toLeftIndex) {
              scrollRange = scrollPane.scrollWidth - scrollPane.offsetWidth;
              initScrollLeft = -parseFloat(window.getComputedStyle(scope.$ul[0])[marginSide]);
              targetScrollLeft = scope.$ul.children()[0].offsetWidth * toLeftIndex;
              dScrollLeft = targetScrollLeft - initScrollLeft;
              scrollStartTime = performance.now();

              if(scrollRange < 1 && dScrollLeft === 0) return;

              // RTL translate
              targetScrollLeft = scope.isRTL? scrollRange - targetScrollLeft: targetScrollLeft;

              scrollAnimate(scope.$ul[0]);
            };

            // Quad transition
            function scrollAnimate(scrollPane) {
              var dTimeRatio  = Math.pow((performance.now() - scrollStartTime) / TRANSITION_DURATION - 1, 3) + 1, // (x-1)^3 + 1
                  dScroll     = dScrollLeft * dTimeRatio;

              if (dTimeRatio > 0.999) {
                scrollPane.style[marginSide] = -initScrollLeft - dScrollLeft + 'px';
              } else {
                scrollPane.style[marginSide] = -initScrollLeft - dScroll + 'px';
                $bentoServices.rAF(function () {
                  scrollAnimate(scrollPane);
                })
              }
            }

            // Window resize function
            function onWindowResize() {
              // Set a timeout to minimize performance issue
              $timeout.cancel(resizeTimeout);
              resizeTimeout = $timeout(renderStepWidth, WINDOW_RESIZE_DELAY);
            }

            // Destroy with garbage collection
            scope.$on('$destroy', function () {
              //remove window listener
              angular.element($window).off('resize', onWindowResize);
            });

          }
        };
      }]);
})(window, window.angular);

(function(angular, undefined) {
    'use strict';

    angular
        .module('bento.progressbar', [
            'bento.services',
        ])
        .controller('BentoProgressbarController', ['$scope',
            function($scope) {
                $scope.$watch('value', function(val) {
                    $scope.dynamic = val;
                }, true)
                $scope.$watch('type', function(val) {
                    $scope.barType = val;
                }, true)
            }
        ])
        .directive('bentoProgressbar', [
            function() {
                return {
                    restrict: 'EA',
                    scope: {
                        value: '=',
                        animate: '=',
                        type: '='
                    },
                    templateUrl: '../templates/progressbar/bento-progressbar.html',
                    controller: 'BentoProgressbarController',
                    link: function(scope, element, attrs) {
                        console.warn('bento-progressbar: Warning! This directive has been deprecated. Please use uib-progressbar instead. Please see Bento 1.3.0 changelog for more info.');
                    }
                };
            }
        ])
})(window.angular);
(function (window, angular, undefined) {
  'use strict';

  var Z_INDEX = 102; // To be higher than Global Header

  angular.module('bento.append.to.parent', ['bento.services']).directive('bentoAppendToParent', [
    '$log',
    '$bentoServices',
    '$bentoPositioning',
    function ($log, $bentoServices, $bentoPositioning) {
      return {
        controller: function () {},
        link: function (scope, element, attrs) {
          /*
           * The element where 'append-to-parent' is added
           */
          var thisElement = element[0];

          var appendTo = attrs.bentoAppendToParent;
          if (appendTo.length <= 0) {
            //default it to body
            appendTo = 'body';
          }

          var appendToContainer = document.querySelector(appendTo);
          if (!appendToContainer) {
            //to make it work between site and dev
            appendTo = 'body';
            appendToContainer = document.querySelector(appendTo);
          }

          /*
           * This element holds/contains the list element (ul/ol)
           */
          var listContainerElement = element[0].querySelector('.bento-append-to-parent');
          if (!listContainerElement || listContainerElement === undefined) {
            $log.warn("bento-append-to-parent: Container class does not have 'bento-append-to-parent' class");
            return;
          } else {
            //reset it since it could be a directive with 'replace=true;'
            listContainerElement = null;
          }

          /*
           * Directive along with its used will emit 'append_to_parent_show_list' event when the list needs to be shown or hidden
           */
          scope.$on('append_to_parent_show_list', function (e, flag, id) {
            if (typeof flag !== 'boolean') {
              $log.warn("bento-append-to-parent: 'append_to_parent_show_list' flag needs to be boolean");
              return;
            }

            if (!listContainerElement) {
              listContainerElement = element[0].querySelector('.bento-append-to-parent');
            }

            if (id && listContainerElement.getAttribute('id') != id) {
              // Do nothing when the element ids don't match
              return;
            }

            if (flag) {
              //list is visible
              updateContainerPosition();
            } else {
              //list is hidden
              resetContainerPosition();
            }
          });

          window.addEventListener('resize', onWindowResize); // resize - event listener
          function onWindowResize(event) {
            if (listContainerElement && listContainerElement.style.zIndex === Z_INDEX) {
              updateContainerPosition();
            }
          }

          /*
           * 1. Append list container element to its parent (specified by append-to-parent)
           * 2. Calculate list container element's placement position when it needs to be shown
           */
          function updateContainerPosition() {
            var rect = thisElement.getBoundingClientRect();
            var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            var isRTL = $bentoServices.isRTL();
            var offset = attrs.appendToOffset ? parseFloat(attrs.appendToOffset) : 0;
            var spacingErrorMarging = 14; // give 14px for size error margining

            if (!listContainerElement) {
              listContainerElement = element[0].querySelector('.bento-append-to-parent');
            }

            // See if the list has offset and this overrides the original directive declaration
            var listOffset = listContainerElement.getAttribute('append-to-offset');
            offset = listOffset ? parseFloat(listOffset) : offset;

            // Self Awareness
            if (
              listContainerElement.offsetHeight + rect.top + rect.height + spacingErrorMarging > viewportHeight &&
              listContainerElement.offsetHeight <= rect.top
            ) {
              // There is not enough space at the bottom
              // **AND** there is enough space on the top
              $bentoPositioning.positionElement(
                thisElement,
                listContainerElement,
                appendToContainer,
                'top',
                isRTL ? 'right' : 'left',
                offset,
                attrs.autoRealign === 'true'
              );
            } else {
              // Align to top only when it fits there
              $bentoPositioning.positionElement(
                thisElement,
                listContainerElement,
                appendToContainer,
                'bottom',
                isRTL ? 'right' : 'left',
                offset,
                attrs.autoRealign === 'true'
              );
            }

            listContainerElement.style.minWidth = rect.width + 'px';
            listContainerElement.style.zIndex = Z_INDEX;
          }

          /*
           * reset all style
           */
          function resetContainerPosition() {
            // Skip this function when `listContainerElement` is not ready
            if (typeof listContainerElement === 'undefined' || !listContainerElement) {
              return;
            }

            $bentoPositioning.resetStyles(listContainerElement);

            // Put the list back to its original element
            element.append(listContainerElement);
          }

          /*
           * Remove the child when the directive is destroyed.
           * Otherwise if attached to 'body', duplicate children (zombies) will
           * be seen when the body element is inspected.
           */
          scope.$on('$destroy', function () {
            window.removeEventListener('resize', onWindowResize);
            if (listContainerElement && listContainerElement.parentNode) {
              // Remove listContainerElement if hasn't done so from viewport

              // Depends how directives are initiated, 'listContainerElement' might already
              // be removed by another directive (ex. BentoDropdownAppendToParent)
              // Reported by: @Owen Anderson on 9/25/2017
              listContainerElement.parentNode.removeChild(listContainerElement);
            }
          });
        }, //link
      }; //return
    },
  ]); //bentoAppendToBody directive
})(window, window.angular);

(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.dropdown.append.to.parent', [])


   /**
   * Directive declaration
   */
    .directive('bentoDropdownAppendToParent', [
      '$timeout',
      '$bentoPositioning',
    function ($timeout, $bentoPositioning) {
      return {
        require: '^uibDropdown',
        link: function (scope, element, attrs, dropdownCtrl) {

          var listContainerElement = angular.element(element[0].querySelector('.dropdown-menu'));
          
          if(listContainerElement) {
            listContainerElement.addClass('bento-append-to-parent');
            $timeout(function(){
              if(listContainerElement){
                listContainerElement.css('min-width','');
              }
            })
            
          }

          var unwatch = scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
            if(typeof isOpen === 'boolean') {
              if (isOpen){
                listContainerElement.addClass('show');
                window.addEventListener('scroll', onWindowScroll, true);
                window.addEventListener('resize', onWindowResize);
              }else{
                listContainerElement.removeClass('show');
                $bentoPositioning.resetStyles(listContainerElement[0]);
                window.removeEventListener('scroll', onWindowScroll, true);
                window.removeEventListener('resize', onWindowResize);
              }
              scope.$emit('append_to_parent_show_list', isOpen);
            }
          });

          // Garbage collection
          element.on('$destroy',function(){
            unwatch();
            if(listContainerElement){
              var el = listContainerElement[0];
              if(el.parentNode){
                el.parentNode.removeChild(el);
                listContainerElement = null;
              }
            }
            window.removeEventListener('scroll', onWindowScroll, true);
            window.removeEventListener('resize', onWindowResize);
          });

          // Need to hide dropdown when window resizes to avoid mis-alignment
          function onWindowResize(){
            if(listContainerElement.hasClass('show')){
              $timeout(function(){
                dropdownCtrl.toggle(false);
              });
            }
          }

          // Catch events when window scrolls
          function onWindowScroll(e){
            if(listContainerElement.hasClass('show')){
              if(!e.target.contains(listContainerElement[0])){
                // Auto close when the scrolling panel doesn't contain this list
                $timeout(function(){
                  dropdownCtrl.toggle(false);
                });
              }
            }
          }
        }
    };
  }]);
})(window, window.angular);

(function (window, angular, undefined) {
  'use strict';

  angular.module('bento.alert', ['bento.services', 'bento.translate'])

    .controller('BentoAlertController', [
      '$scope',
      '$element',
      '$timeout',
      '$bentoServices',
      function ($scope, $element, $timeout, $bentoServices) {
        var controller = this;
        var clearAlertObjectTimer;
        // Access through controller
        controller.closeBentoAlert = function (alert) {

          var index = $scope.bentoAlertObject.indexOf(alert),
              a     = $element[0].querySelector('div[rel="bento-alert-' + index + '"]'),
              el
            ;

          /* Update focus */
          // Will be no more alerts
          if ($scope.bentoAlertObject.length === 1) {
            $scope.$container.attr('tabindex', '');
            if ($scope.activeElement) {
              $scope.activeElement.focus();
              $scope.activeElement = undefined;
            }
          }
          // Deleting that last alert
          else if (index === $scope.bentoAlertObject.length - 1) {
            el = $element[0].querySelector('div[rel="bento-alert-' + (index - 1) + '"] .alert > span');
          } else {
            el = $element[0].querySelector('div[rel="bento-alert-' + (index + 1) + '"] .alert > span');
          }

          // fire close callback function [BENTO-478]
          $scope.closeAlertCallback({$index: index});

          // remove the alert object from the array
          $scope.bentoAlertObject.splice(index, 1);

          if(clearAlertObjectTimer) {
            $timeout.cancel(clearAlertObjectTimer);
          }

          // A timeout event has already dismissed this alert
          // We skip everything...
          if (a && a.style) {
            a.style.height = a.offsetHeight + 'px';
            clearAlertObjectTimer = $timeout(function () {
              el ? el.focus() : 0;
            });
          }
        };

        // From Link

        var container = $element[0].querySelector('.alert-container');
        $scope.$container = angular.element(container);

        $bentoServices.loopTabbables($scope.$container);

        getFirstScrollableParent();

        $scope.$on('$destroy', function () {
          document.removeEventListener('keydown', onDocumentKeydown);
        });

        document.addEventListener('keydown', onDocumentKeydown);

        function onDocumentKeydown(event) {
          // Will react to tab only
          if (event.keyCode === 9) {
            var children = $scope.$container.children();
            if (children.length > 0) {
              if (!(container === event.target || container.contains(event.target))) {
                container.setAttribute('tabindex', '-1');
                $scope.activeElement = document.activeElement;
                container.focus();
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }

        // Keyup to listen to delete and backspace
        $element[0].addEventListener('keydown', function (event) {
          var index;
          switch (event.keyCode) {
            // DEL and BackSpace
            case 46:
            case 8:
              var alertDoms = $element[0].querySelectorAll('.bento-alert-container');
              for (var i = 0, len = alertDoms.length; i < len; i++) {
                if (alertDoms[i].contains(document.activeElement)) {
                  controller.closeBentoAlert($scope.bentoAlertObject[i]);
                  event.stopPropagation();
                  event.preventDefault();
                  break;
                }
              }
              break;
            case 38: // Up Arrow Key
              index = getCurrentAlertFocusIndex();
              setFocusToAlert(
                (index === -1) ?
                $scope.bentoAlertObject.length - 1
                  :
                (index + $scope.bentoAlertObject.length - 1) % $scope.bentoAlertObject.length);
              event.preventDefault();
              break;
            case 40: // Down Arrow Key
              index = getCurrentAlertFocusIndex();
              setFocusToAlert(
                (index === -1) ?
                  0
                  :
                (index + 1) % $scope.bentoAlertObject.length);
              event.preventDefault();
              break;
          }
        });

        function getCurrentAlertFocusIndex() {
          var alerts = $element[0].querySelectorAll('.bento-alert');
          for (var i = 0, len = alerts.length; i < len; i++) {
            if (alerts[i].contains(document.activeElement)) {
              return i;
            }
          }

          return -1;
        }

        function setFocusToAlert(index) {
          $element[0].querySelector('div[rel="bento-alert-' + index + '"] .alert > span').focus();
        }

        $scope.$watch('align', function () {
          if (!!$scope.align) {
            if ($scope.align === 'right') {
              container.className = 'alert-container right';
            } else if ($scope.align === 'left') {
              container.className = 'alert-container left';
            } else {
              container.className = 'alert-container';
            }
          }
        });

        // Find the first parent that scrolls
        function getFirstScrollableParent(domEl) {
          var style = window.getComputedStyle(document.querySelector('html'));
        }

        // Update body scrolling position
        function updateScrollingPosition(event) {
          var targetTop = 20;
          var scroll = getScroll();
          if (scroll.top < 90) {
            targetTop = 90 - scroll.top;
          }

          if (targetTop < 20) {
            targetTop = '20';
          }
          container.style.top = targetTop + 'px';
        }

      }
    ])
    .directive('bentoAlert', [
      '$bentoServices',
      function ($bentoServices) {
        return {
          restrict    : 'EA',
          controller  : 'BentoAlertController',
          controllerAs: 'bentoAlertCtrl',
          templateUrl : function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/alerts/bento_alert_container.html';
          },
          scope       : {
            bentoAlertObject: '=',
            closeAlertCallback : '&bentoAlertClose',
            align           : '@'
          } //$scope
        }; //return
      } //function compile, timeout
    ])
    .directive('bentoAlertMessage', [
      '$timeout',
      '$compile',
      function ($timeout, $compile) {
        return {
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/alerts/bento_alert.html';
          },
          require    : '^bentoAlert',
          replace    : true,
          scope      : {
            bentoAlertMessage     : '=',
            bentoAlertMessageIndex: '='
          },
          link       : function (scope, element, attr, controller) {
            // Original parent scope that declares Bento Alert
            var appScope = scope
                  .$parent // ng-repeat
                  .$parent // Bento Alert
                  .$parent,// App Scope
                // We need to compile the message content against the original Application scope
                message  = $compile(
                  '<span class="bento-alert-message-content">' +
                  scope.bentoAlertMessage.msg + '</span>'
                )(appScope)
              ;

            // Prepend the compile message into the alert DOM
            angular.element(element[0].querySelector('.bento-alert')).prepend(message);

            // There is a timeout
            if (typeof scope.bentoAlertMessage.timeout !== 'undefined') {
              var alertTimeout = Number(scope.bentoAlertMessage.timeout);
              // Fire the timeout

              $timeout(function () {
                controller.closeBentoAlert(scope.bentoAlertMessage);
              }, alertTimeout); //timeout
            }

            // Close Bento Alert
            scope.closeBentoAlert = function () {
              controller.closeBentoAlert(scope.bentoAlertMessage);
            };
          }
        }
      }]);

  // helper class to get document scrolling
  function getScroll() {
    var doc = document.documentElement;
    var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    return {top: top, left: left};
  }

})(window, window.angular);

function BentoScrollable(dom) {
  'use strict';
  var s = this;
  // Public
  s.dom = dom;
  s.init = init;
  s.onScroll = onScrollListener;
  s.render = render;
  s.height = height;
  s.callbackStack = [];
  // Private variables
  s._domSize = {};
  s._scrollableSize = {};
  s._bgEl = document.createElement('div');
  s.offsetTop = 0;
  s.init();
  /**
   * Public
   * setScrollable Height
   * @param containerHeight
   */
  function height(containerHeight) {
    if (typeof containerHeight !== 'undefined') {
      s.dom.style.height = [containerHeight, 'px'].join('');
    } else {
      return s.dom.offsetHeight;
    }
  }
  /**
   * Oublic
   * Render scrollable pane and scrollbar when layouts change
   * @param width
   * @param height
   */
  function render(width, height, top) {
    s.offsetTop = (typeof top !== 'undefined') ? top : s.offsetTop;
    s._scrollableSize.width = width || 1;
    s._scrollableSize.height = height;
    s._bgEl.style.height = (height+s.offsetTop) + 'px';
    // Fire scrolling event to notify scrolling change
    s.vScrollRange = height - s._domSize.height;
    var e = {
      scrollLeft: s.dom.scrollLeft,
      scrollTop: s.dom.scrollTop,
      scrollHeightRange: s.vScrollRange,
      scrollWidthRange: s.hScrollRange
    };
    // Callback functions first
    fireCallbacks(e);
  }

  // Public
  function onScrollListener(objectWithOnScroll) {
    s.callbackStack.push(objectWithOnScroll);
  }
  /**
   * Regular scroll
   * @param event
   * @private
   */
  function _onScroll(event) {
    event.scrollLeft = s.dom.scrollLeft;
    event.scrollTop = s.dom.scrollTop;
    event.scrollHeightRange = s.dom.scrollHeight - s.dom.offsetHeight;
    event.scrollWidthRange = s.dom.scrollWidth - s.dom.offsetWidth;
    // Callback functions first
    fireCallbacks(event);
  }
  /**
   * batch fire callback functions
   * @param event
   */
  function fireCallbacks(event) {
    for (var i = 0; i < s.callbackStack.length; i++) {
      s.callbackStack[i](event);
    }
  }
  /**
   * Initialize scrollable
   */
  function init() {
    s.dom.insertBefore(s._bgEl, s.dom.firstElementChild);
    s._bgEl.className = 'bento-scrollable-bg';
    s._domSize.width = s.dom.offsetWidth;
    s._domSize.height = s.dom.offsetHeight;
    s.dom.classList.add('bento-scrollable');
    
    // Add wheel or scroll events
    s.dom.addEventListener('scroll', _onScroll);

    // Window resize
    window.addEventListener('resize', function (event) {
      // No need to resize since the scrollable is not even visible
      // no need to render
      if (s.dom.offsetWidth === 0 || s.dom.offsetHeight === 0) {
        return;
      }
      if (s._domSize.width !== s.dom.offsetWidth || s._domSize.height !==
        s.dom.offsetHeight) {
        s._domSize.width = s.dom.offsetWidth;
        s._domSize.height = s.dom.offsetHeight;
        render(s._scrollableSize.width, s._scrollableSize.height);
      }
    });
  }
}

function BentoTableCell(parent, isHeader) {
  var cell = this;
  cell.dom = document.createElement('DIV');
  cell.dom.className = 'bento-table-cell';
  cell.parent = parent;
  cell.dom.cell = this;
  cell.html = setHtml;
  cell.setTop = setTop;
  cell.setBottom = setBottom;
  cell.setLeft = setLeft;
  cell.setRight = setRight;
  cell.getWidth = getWidth;
  cell.setWidth = setWidth;
  cell.destroy = destroy;
  cell.setIndex = setIndex;
  cell.addClass = addClass;
  cell.removeClass = removeClass;
  cell.hasClass = hasClass;
  cell.setType = setType;
  cell.getType = getType;
  cell.setData = setData;
  cell.getData = getData;

  // Private
  var headerPlate;
  var headerContent;
  var type;
  var data;

  init();

  // Private
  var _classes = [cell.dom.className];

  function setData(d) {
    data = d;
  }

  function getData() {
    return data;
  }

  function setType(t) {
    if (type) {
      cell.removeClass(type);
    }
    type = t;
    cell.addClass(type);
  }

  function getType() {
    return type;
  }

  function addClass(className) {
    if (_classes.indexOf(className) < 0) {
      _classes.push(className);
      cell.dom.className = _classes.join(' ');
    }
  }

  function hasClass(className) {
    return _classes.indexOf(className) > -1
  }

  function removeClass(className) {
    var index = _classes.indexOf(className);
    if (index > -1) {
      _classes.splice(index, 1);
      cell.dom.className = _classes.join(' ');
    }
  }


  function setHtml(html) {
    if (isHeader && html) {
      if (typeof html === 'string' || typeof html === 'number') {
        headerContent.innerHTML = html;
      } else if(html) {
        headerContent.innerHTML = '';
        headerContent.appendChild(html);
      }
    } else if (html) {
      if (typeof html === 'string' || typeof html === 'number') {
        cell.dom.innerHTML = html;
      } else {
        cell.dom.innerHTML = '';
        cell.dom.appendChild(html);
      }
    } else{
      cell.dom.innerHTML = '';
    }
  }

  function setIndex(col, row) {
    cell.col = col;
    cell.row = row;
  }

  function setTop(topCell) {
    cell.top = topCell;
  }

  function setBottom(bottomCell) {
    cell.bottom = bottomCell;
  }

  function setLeft(leftCell) {
    cell.left = leftCell;
  }

  function setRight(rightCell) {
    cell.right = rightCell;
  }

  function getWidth() {
    return cell.dom.offsetWidth;
  }

  function setWidth(width) {
    cell.dom.style.width = width + 'px';
  }

  function destroy() {
    delete cell.dom;
    cell.top = null;
    cell.bottom = null;
    cell.left = null;
    cell.right = null;
    cell.parent = null;

    //AngularJS code
    if(data && data.scope){
      // Destroy NG code to prevent NG related memory leak
      data.scope.$destroy();
    }

    data = null;
  }

  function init() {
    if (isHeader) {
      headerPlate = document.createElement('DIV');
      headerPlate.className = 'bt-header-cell-plate';
      headerContent = document.createElement('DIV');
      cell.dom.appendChild(headerContent);
      cell.dom.appendChild(headerPlate);
    }
  }
}
var BentoTableCore;

(function() {
  var ROW_CACHE_COUNT = 6;
  BentoTableCore = _BentoTableCore;
  _BentoTableCore.prototype.addColumn = addColumn;
  _BentoTableCore.prototype.addFrozenRow = addFrozenRow;
  _BentoTableCore.prototype.addNewColumn = addNewColumn;
  _BentoTableCore.prototype.addRow = addRow;
  _BentoTableCore.prototype.adjustColRowAllocation = adjustColRowAllocation;
  _BentoTableCore.prototype.calcGridColSizeArray = calcGridColSizeArray;
  _BentoTableCore.prototype.calcGridRowSizeArray = calcGridRowSizeArray;
  _BentoTableCore.prototype.deselectRow = deselectRow; // number
  _BentoTableCore.prototype.deselectFrozenRow = deselectFrozenRow; // number
  _BentoTableCore.prototype.fastForwardCol = fastForwardCol;
  _BentoTableCore.prototype.fastForwardRow = fastForwardRow;
  _BentoTableCore.prototype.fireCellRenderRequestCallbackWithArray = fireCellRenderRequestCallbackWithArray;
  _BentoTableCore.prototype.getColSizes = getColSizes;
  _BentoTableCore.prototype.getFirstRow = getFirstRow;
  _BentoTableCore.prototype.getLastRow = getLastRow;
  _BentoTableCore.prototype.getNumRows = getNumRows;
  _BentoTableCore.prototype.getRowSizes = getRowSizes;
  _BentoTableCore.prototype.getTableHeight = getTableHeight;
  _BentoTableCore.prototype.getTableWidth = getTableWidth;
  _BentoTableCore.prototype.init = init;
  _BentoTableCore.prototype.linkRows = linkRows;
  _BentoTableCore.prototype.onHeaderClick = onHeaderClick; // event
  _BentoTableCore.prototype.onRowClick = onRowClick; // event
  _BentoTableCore.prototype.onScrollAtBottom = onScrollAtBottom; // event
  _BentoTableCore.prototype.pushRow = pushRow;
  _BentoTableCore.prototype.refreshScrollBars = refreshScrollBars;
  _BentoTableCore.prototype.removeColumn = removeColumn;
  _BentoTableCore.prototype.removeLastColumn = removeLastColumn;
  _BentoTableCore.prototype.removeLastRow = removeLastRow;
  _BentoTableCore.prototype.removeRow = removeRow;
  _BentoTableCore.prototype.removeFrozenRow = removeFrozenRow;
  _BentoTableCore.prototype.render = render;
  _BentoTableCore.prototype.renderHeaderCell = renderHeaderCell;
  _BentoTableCore.prototype.requestCellContent = requestCellContent;
  _BentoTableCore.prototype.requestHeaderContent = requestHeaderContent;
  _BentoTableCore.prototype.requestFrozenCellContent = requestFrozenCellContent;
  _BentoTableCore.prototype.reset = reset;
  _BentoTableCore.prototype.rewindCol = rewindCol;
  _BentoTableCore.prototype.rewindRow = rewindRow;
  _BentoTableCore.prototype.scrollToRowIndex = scrollToRowIndex; // number
  _BentoTableCore.prototype.selectRow = selectRow; // number
  _BentoTableCore.prototype.selectFrozenRow = selectFrozenRow; // number
  _BentoTableCore.prototype.setColSizes = setColSizes;
  _BentoTableCore.prototype.setColumnWidth = setColumnWidth; // number
  _BentoTableCore.prototype.setGridSize = setGridSize;
  _BentoTableCore.prototype.setRowHeight = setRowHeight; // number
  _BentoTableCore.prototype.setRowSizes = setRowSizes;
  _BentoTableCore.prototype.toggleRow = toggleRow; // number
  _BentoTableCore.prototype.toggleFrozenRow = toggleFrozenRow; // number
  _BentoTableCore.prototype.unshiftRow = unshiftRow;
  _BentoTableCore.prototype.updateRowWithIndex = updateRowWithIndex;

  // Private
  _BentoTableCore.prototype._headerCellClick = _headerCellClick;
  _BentoTableCore.prototype._onHeaderColumnResize = _onHeaderColumnResize;
  _BentoTableCore.prototype._onRowClick = _onRowClick;
  _BentoTableCore.prototype._onScroll = _onScroll;

  /**
   * Constructore
   * @param dom
   * @param options
   * @private
   */
  function _BentoTableCore(dom, options) {
    var self = this;
    // API

    // row and column size reference array
    /* 'this.rowSizes' is an array where each element is an array and represents the following
     * ----------------
     * 0. Row Height
     * 1. Total Height includeing this row
     * 2. (Bool) selected toggle
     *
     */

    this.rowSizes = [];
    this.frozenRowSizes = [];
    this.colSizes = [];
    this.ready = false;

    // Default values
    this.options = {
      rowHeight: options.rowHeight || 30,
      colWidth: options.colWidth || 100,
      border: options.border || 1,
      header: options.header || { resize: false },
      autoHeight: options.autoHeight,
      doNotAssignDimensions: options.doNotAssignDimensions,
      scope: options.scope
    };

    // private variable declaration
    this._currentHIndex = 0;
    this._currentVIndex = 0;
    this._dom = dom;
    this._domWidth = 0.0;
    this._headerClickCallbackStack = [];
    this._headerHeight = 0;
    this._requestCellContentCallback = null;
    this._requestFrozenCellContentCallback = null;
    this._requestHeaderContentCallback = null;
    this._rowClickCallbackStack = [];
    this._rows = [];
    this._scrollLeft = 0.0;
    this._scrollTop = 0.0;
    this._translateTop = 0;
    this._translateLeft = 0;
    this._animatingFrameID = 0;

    // Creating sub components
    this.header = new BentoTableHeader(
      this.options.colWidth,
      this.options.rowHeight,
      this.options.header
    );
    this.scrollable = new BentoScrollable(this._dom);
    this.pane = document.createElement('DIV');
    this.pane.className = 'bento-table-inner';
    this._dom.appendChild(this.pane);
    this._dom.appendChild(this.header.dom);
    this.scrollable.onScroll(function(event) {
      self._onScroll(event);
    });

    this.isRendering = false;
  }

  // Render Header Cell
  function renderHeaderCell(headerCell, colObj, scope, compile) {
    this.header.renderCell(headerCell, colObj, scope, compile);
  }

  /**
   * Reset table content without distroying column definitions
   */
  function reset() {
    this.rowSizes = [];
    this.header.reset();
    for (var i = 0, len = this._rows.length; i < len; i++) {
      this._rows[i].clear();
    }
  }

  /**
   * Add a frozen row object
   */
  function addFrozenRow() {
    if (this.header) {
      this.header.addFrozenRow();
    }
  }

  /**
   * Remove a frozen row object
   */
  function removeFrozenRow(index) {
    if (this.header) {
      this.header.removeFrozenRow(index);
    }
  }

  /**
   * Adding scroll at bottom callback
   * @param callback
   */
  function onScrollAtBottom(callback) {
    if (typeof this._scrollAtBottomCallbacks === 'undefined') {
      this._scrollAtBottomCallbacks = [];
    }

    // To avoid adding the same callback instance
    if (this._scrollAtBottomCallbacks.indexOf(callback) > -1) {
      return;
    }

    this._scrollAtBottomCallbacks.push(callback);
  }

  /**
   * Scroll to a given row
   * @param {any} row
   */
  function scrollToRowIndex(rowIndex, $q) {
    var rowSize = this.rowSizes[rowIndex];
    var rowLocation = rowSize[1];
    var rowBottom = rowSize[0] + rowLocation;
    var scrollTop = this._dom.scrollTop;
    var offsetHeight = this._dom.offsetHeight;
    var table = this;

    this._renderReadyDefer = $q.defer();

    if (rowLocation < scrollTop) {
      this._dom.scrollTop = rowLocation;
    } else if (rowBottom > scrollTop + offsetHeight) {
      this._dom.scrollTop = rowBottom - offsetHeight;
    } else {
      setTimeout(function() {
        table._renderReadyDefer.resolve();
        table._renderReadyDefer = null;
      });
    }

    return this._renderReadyDefer.promise;
  }

  /**
   * Set Column width
   * @param col - Could be either integer to arary
   * @param width - Width to the given colIndex from `col` can be array
   */
  function setColumnWidth(colData, widthData) {
    var col,
      width,
      smallestCol = this.colSizes.length;

    if (!Array.isArray(colData)) {
      colData = [colData];
      widthData = [widthData];
    }

    for (var i = 0, len = colData.length; i < len; i++) {
      col = colData[i];
      width = widthData[i];

      if (col < smallestCol) {
        smallestCol = col;
      }

      if (this.colSizes[col]) {
        var cell = this.getFirstRow().getFirstCell();
        var fCCell = cell,
          fRCell;
        do {
          cell = cell.right;
          if (cell.col == col) {
            fRCell = cell;
            // Set width to all cell in the same column
            do {
              if (!this.options.doNotAssignDimensions) {
                cell.dom.style.width = width + 'px';
              }

              cell = cell.bottom;
            } while (cell !== fRCell);

            // update column width index
            this.colSizes[col][0] = width;
          }
        } while (cell !== fCCell);
      }
    }

    this.calcGridColSizeArray(smallestCol);
    this.render();
  }

  function updateCellCSS(cell) {
    if (cell.col === 0) {
      cell.addClass('bt-row-head');
    } else {
      cell.removeClass('bt-row-head');
    }
  }

  function setRowHeight(rowIndex, height) {
    if (this.rowSizes[rowIndex]) {
      this.rowSizes[rowIndex][0] = height;
      this.calcGridRowSizeArray(rowIndex);
      //Find the row and adjust its height if it's in viewport
      var row;
      for (var i = 0; i < this._rows; i++) {
        row = this._rows[i];
        if (row.row === row) {
          row.dom.style.height = height + 'px';
        }
      }
      this.render();
    }
  }

  function addColumn(col, count, width) {
    for (var i = 0; i < (count || 1); i++) {
      this.colSizes.splice(col, 0, [width || this.options.colWidth, 0]);
    }
    this.calcGridColSizeArray(col);
    this.render();
  }

  function addRow(row, count, height) {
    for (var i = 0; i < (count || 1); i++) {
      this.rowSizes.splice(row, 0, [height || this.options.rowHeight, 0]);
    }
    this.calcGridRowSizeArray(row);
    this.render();
  }

  function removeRow(row, count) {
    this.rowSizes.splice(row, count || 1);
    this.calcGridRowSizeArray(row);
    this.render();
  }

  function removeColumn(col, count) {
    this.colSizes.splice(col, count || 1);
    this.calcGridColSizeArray(col);
    this.render();
  }

  function calcGridRowSizeArray(index, isFrozen) {
    var array = isFrozen ? this.frozenRowSizes : this.rowSizes;
    var height = index === 0 ? 0 : array[index - 1][1];
    var size = array.length;
    for (var i = index; i < size; i++) {
      if (i > 0) {
        height += array[i - 1][0];
      }
      array[i][1] = height;
    }
  }

  function calcGridColSizeArray(index) {
    var width;
    var size = this.colSizes.length;
    for (var i = index; i < size; i++) {
      if (i > 0) {
        var lastCol = this.colSizes[i - 1];
        width = lastCol[1] + lastCol[0];
      } else {
        width = 0;
      }
      this.colSizes[i][1] = width;
    }
  }

  function requestCellContent(callback) {
    this._requestCellContentCallback = callback;
  }

  function requestHeaderContent(callback) {
    this._requestHeaderContentCallback = callback;
  }

  function requestFrozenCellContent(callback) {
    this._requestFrozenCellContentCallback = callback;
  }

  function getColSizes() {
    return this.colSizes;
  }

  function setColSizes(array) {
    this.colSizes = array;
  }

  function getRowSizes() {
    return this.rowSizes;
  }

  function setRowSizes(array) {
    this.rowSizes = array;
  }

  function _onScroll(event) {
    cancelAnimationFrame(this._animatingFrameID);

    this._animatingFrameID = requestAnimationFrame(
      function() {
        if (this.isRendering) {
          // Browser might be busy rendering previous scroll
          // Skip!!
          return;
        }

        this.isRendering = true;

        var index, vIndex, hIndex, fIndex;
        var dHIndex = 0,
          dVIndex = 0,
          cWidth = 0,
          i,
          j,
          len;
        var renderStack = [],
          headerRenderStack = [],
          freezeRenderStack = [];
        var cSize = this.getFirstRow().getNumCells(),
          rSize = this.getNumRows(),
          dataRowSize = this.rowSizes.length,
          scrollTop = event.scrollTop,
          cell,
          hCell;

        // Check if need to fire scroll at bottom or not
        if (
          this._scrollAtBottomCallbacks &&
          event.scrollHeightRange - event.scrollTop < 500
        ) {
          for (
            i = 0, len = this._scrollAtBottomCallbacks.length;
            i < len;
            i++
          ) {
            this._scrollAtBottomCallbacks[i](event);
          }
        }

        // H Scroll
        if (this._scrollLeft !== event.scrollLeft) {
          this._scrollLeft = event.scrollLeft;
          index = bSearchIndexByScroll(this.colSizes, event.scrollLeft);
          if (index + cSize >= this.colSizes.length) {
            index = this.colSizes.length - cSize;
          }
          dHIndex = index - this._currentHIndex;
          this._currentHIndex = index;

          this._translateLeft = this.colSizes[this._currentHIndex][1];
        }

        if (event.scrollHeightRange < scrollTop) {
          // To prevent scrollTop
          scrollTop = event.scrollHeightRange;
        }

        // V Scroll
        if (this._scrollTop !== scrollTop && dataRowSize) {
          this._scrollTop = scrollTop;
          index = Math.max(
            bSearchIndexByScroll(this.rowSizes, scrollTop) - 3,
            0
          );

          if (index + rSize >= dataRowSize) {
            index = dataRowSize - rSize;
          }
          dVIndex = index - this._currentVIndex;
          this._currentVIndex = index;
          this._translateTop = this.rowSizes[this._currentVIndex][1];
        }

        // Use `transform` to improve performance
        if (this._headerHeight > 10) {
          this.header.dom.style.transform = 'translate(0, ' + scrollTop + 'px)';
        }
        if (cSize > 1) {
          this.pane.style.transform =
            'translate(' +
            this._translateLeft +
            'px, ' +
            (this._translateTop + this._headerHeight) +
            'px)';
        } else {
          this.pane.style.transform =
            'translateY(' + (this._translateTop + this._headerHeight) + 'px)';
        }

        //Total this.render
        if (Math.abs(dHIndex) > cSize || Math.abs(dVIndex) > rSize) {
          hCell = this.header.row.getFirstCell();
          cell = this.getFirstRow().getFirstCell();
          for (i = 0; i < rSize; i++) {
            vIndex = this._currentVIndex + i;
            if (vIndex < this.rowSizes.length) {
              this.updateRowWithIndex(cell.parent, vIndex);
              for (j = 0; j < cSize; j++) {
                hIndex = this._currentHIndex + j;
                cWidth = this.colSizes[hIndex]
                  ? [this.colSizes[hIndex][0], 'px'].join('')
                  : '';
                if (hIndex < this.colSizes.length) {
                  cell.setIndex(hIndex, vIndex);
                  if (!this.options.doNotAssignDimensions) {
                    cell.dom.style.width = cWidth;
                  }
                  renderStack.push(cell);
                }

                // Only execute once
                if (i === 0 && hIndex < this.colSizes.length) {
                  hCell.setIndex(hIndex, 0);
                  if (!this.options.doNotAssignDimensions) {
                    hCell.dom.style.width = cWidth;
                  }
                  headerRenderStack.push(hCell);
                  __getFreezeCellRenderStackFromHeader(
                    freezeRenderStack,
                    hCell,
                    cWidth
                  );
                }

                hCell = hCell.right;
                cell = cell.right;
              }
            } else {
              for (j = 0; j < cSize; j++) {
                cell.html('');
                cell = cell.right;
              }
            }
            cell = cell.bottom;
          }
        } else {
          // horizontal Scrolling
          //FF
          if (dHIndex > 0) {
            // Get first cell
            hCell = this.header.row.getFirstCell();
            cell = this.getFirstRow().getFirstCell();
            hIndex = this._currentHIndex + cSize - dHIndex;
            // Column
            for (i = 0; i < dHIndex; i++) {
              index = hIndex + i;
              cWidth = this.colSizes[index]
                ? [this.colSizes[index][0], 'px'].join('')
                : null;
              // Row
              for (j = 0; j < rSize; j++) {
                if (
                  index < this.colSizes.length &&
                  cell.row < this.rowSizes.length
                ) {
                  cell.setIndex(index, cell.row);
                  if (!this.options.doNotAssignDimensions) {
                    cell.dom.style.width = cWidth;
                  }
                  renderStack.push(cell);
                } else {
                  cell.html('');
                }
                cell = cell.bottom;
              }
              if (index < this.colSizes.length) {
                hCell.setIndex(index, 0);
                if (!this.options.doNotAssignDimensions) {
                  hCell.dom.style.width = cWidth;
                }
                headerRenderStack.push(hCell);
                __getFreezeCellRenderStackFromHeader(
                  freezeRenderStack,
                  hCell,
                  cWidth
                );
              }

              cell = cell.right;
              hCell = hCell.right;
              this.fastForwardCol();
            }
          }
          //RW
          else if (dHIndex < 0) {
            //get first row last Cell
            hCell = this.header.row.getLastCell();
            cell = this.getFirstRow().getLastCell();
            hIndex = this._currentHIndex - dHIndex;
            // Column
            for (i = -1; i >= dHIndex; i--) {
              index = hIndex + i;
              cWidth = this.colSizes[index][0] + 'px';
              // Row
              for (j = 0; j < rSize; j++) {
                if (cell.row < this.rowSizes.length) {
                  cell.setIndex(index, cell.row);
                  if (!this.options.doNotAssignDimensions) {
                    cell.dom.style.width = cWidth;
                  }
                  renderStack.push(cell);
                }
                cell = cell.bottom;
              }
              hCell.setIndex(index, 0);
              if (!this.options.doNotAssignDimensions) {
                hCell.dom.style.width = cWidth;
              }
              headerRenderStack.push(hCell);
              __getFreezeCellRenderStackFromHeader(
                freezeRenderStack,
                hCell,
                cWidth
              );

              hCell = hCell.left;
              cell = cell.left;
              this.rewindCol();
            }
          }

          // Vertical Scrolling
          //FF
          if (dVIndex > 0) {
            // Get first cell
            cell = this.getFirstRow().getFirstCell();
            vIndex = this._currentVIndex + rSize - dVIndex;
            // Row
            for (i = 0; i < dVIndex; i++) {
              index = vIndex + i;
              if (
                index < this.rowSizes.length &&
                cell.col < this.colSizes.length
              ) {
                this.updateRowWithIndex(cell.parent, index);
                // Column
                for (j = 0; j < cSize; j++) {
                  if (cell.col < this.colSizes.length) {
                    cell.setIndex(cell.col, index);
                    if (renderStack.indexOf(cell) === -1) {
                      renderStack.push(cell);
                    }
                  }
                  cell = cell.right;
                }
                cell = cell.bottom;
              }
              this.fastForwardRow();
            }
          }
          //RW
          else if (dVIndex < 0) {
            //get first row last Cell
            cell = this.getLastRow().getFirstCell();
            vIndex = this._currentVIndex - dVIndex;
            // Row
            for (i = -1; i >= dVIndex; i--) {
              index = vIndex + i;
              this.updateRowWithIndex(cell.parent, index);
              // Column
              for (j = 0; j < cSize; j++) {
                if (cell.col < this.colSizes.length) {
                  cell.setIndex(cell.col, index);
                  if (renderStack.indexOf(cell) === -1) {
                    renderStack.push(cell);
                  }
                }
                cell = cell.right;
              }
              cell = cell.top;
              this.rewindRow();
            }
          }
        } // End of main if statement

        // callback for cell this.rendering
        this.fireCellRenderRequestCallbackWithArray(
          renderStack,
          headerRenderStack,
          freezeRenderStack
        );
        renderStack = null;
        headerRenderStack = null;
        freezeRenderStack = null;
        this.isRendering = false;

        if (this._renderReadyDefer) {
          var table = this;
          setTimeout(function() {
            table._renderReadyDefer.resolve();
            table._renderReadyDefer = null;
          });
        }
      }.bind(this)
    );
  }

  /**
   * Get a render stack for frozen column using a header cell as a column reference
   * @param hCell
   * @param cWidth
   * @private
   */
  function __getFreezeCellRenderStackFromHeader(
    freezeRenderStack,
    hCell,
    cWidth
  ) {
    if (hCell === hCell.top) {
      return;
    }

    var fIndex = 0,
      fCell;

    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.setIndex(hCell.col, fIndex);
      if (!this.options.doNotAssignDimensions) {
        fCell.dom.style.width = cWidth;
      }
      freezeRenderStack.push(fCell);
      // next frozen cell in this column
      fCell = fCell.bottom;
      fIndex++;
    }
  }

  function updateRowWithIndex(row, index) {
    var newHeight = this.rowSizes[index][0];
    var newHeightPx = this.rowSizes[index][0] + 'px';
    if (this.options.doNotAssignDimensions) {
      if (newHeight === this.options.rowHeight) {
        if (row.dom.style.height.length) {
          // remove row height
          row.dom.style.height = '';
        }
      } else {
        row.dom.style.height = newHeightPx;
      }
    } else if (row.dom.style.height !== newHeightPx) {
      row.dom.style.height = newHeightPx;
    }

    // set row index
    row.setRow(index);
  }

  function fireCellRenderRequestCallbackWithArray(arr, headerArr, frozenArr) {
    var i, len, cell;
    for (i = 0, len = arr.length; i < len; i++) {
      cell = arr[i];
      cell.parent.addClass('dirty');
      updateCellCSS(cell);
      this._requestCellContentCallback(cell);
    }

    for (i = 0, len = headerArr.length; i < len; i++) {
      cell = headerArr[i];
      updateCellCSS(cell);
      this._requestHeaderContentCallback(cell);
    }

    for (i = 0, len = frozenArr.length; i < len; i++) {
      cell = frozenArr[i];
      cell.parent.addClass('dirty');
      updateCellCSS(cell);
      this._requestFrozenCellContentCallback(frozenArr[i]);
    }
    if (!this.options.scope.$root.$$phase) {
      this.options.scope.$digest();
    }
  }

  /**
   * Find the index of an array from its scroll
   * @param arr
   * @param scroll
   * @returns (int)
   */
  function bSearchIndexByScroll(arr, scroll) {
    if (scroll <= 0 || arr.length === 0) {
      return 0;
    }

    // Using three pivot points
    var lP = 0,
      rP = arr.length - 1,
      cR,
      notFound = true;

    while (notFound) {
      cR = Math.floor((lP + rP) * 0.5);
      //Compare cR
      if (arr[cR][1] < scroll) {
        if (arr[cR][1] + arr[cR][0] >= scroll) {
          notFound = false;
        } else if(cR === lP){
          // There seems to be a case where data is updated before the scrollHeight
          // where the last row's bottom is still way smaller than scroll
          // so we take the index of the last row for this and terminate the loop
          // to avoid infinit looping
          cR = rP;
          notFound = false;
        } else  {
          lP = cR;
        }
      } else {
        rP = cR;
      }
    }
    return cR;
  }

  function setGridSize(row, col, data) {
    var height,
      width,
      h = this.options.rowHeight,
      w = this.options.colWidth;

    // Do row size refresh
    this.rowSizes = [];
    if (data) {
      for (var i = 0; i < row; i++) {
        this.rowSizes[i] = [data[i].rowHeight || h];
      }
    } else {
      for (var i = 0; i < row; i++) {
        this.rowSizes[i] = [h];
      }
    }
    this.calcGridRowSizeArray(0);

    // Add new col indexes
    if (col > this.colSizes.length) {
      for (var j = this.colSizes.length; j < col; j++) {
        if (j > 0) {
          var lastColumn = this.colSizes[j - 1];
          width = lastColumn[0] + lastColumn[1];
        } else {
          width = 0;
        }
        this.colSizes.push([w, width]);
      }
    }
    // Slice the current array to match with the new col count
    else if (col < this.colSizes.length) {
      this.colSizes = this.colSizes.slice(0, col);
    }
  }

  function refreshScrollBars() {
    this.scrollable.render(
      this.colSizes.length ? this.colSizes[this.colSizes.length - 1][1] : 0,
      this.rowSizes.length ? this.rowSizes[this.rowSizes.length - 1][1] : 0,
      this.header.dom.offsetHeight
    );
  }

  function render(deepRender, doNotCleanCells) {
    this.adjustColRowAllocation();

    var cSize = this.getFirstRow().getNumCells(),
      rSize = this.getNumRows(),
      cWidth,
      cell,
      hCell,
      hIndex,
      vIndex,
      i,
      j,
      len,
      renderStack = [],
      headerRenderStack = [],
      freezeRenderStack = [];
    if (deepRender) {
      this.calcGridRowSizeArray(0);
    }

    if (this.options.autoHeight) {
      if (rSize < this.rowSizes.length) {
        var newRow;
        for (i = 0, len = this.rowSizes.length - rSize; i < len; i++) {
          newRow = new BentoTableRow(
            cSize,
            this.options.colWidth,
            this.options.rowHeight,
            null,
            null,
            this.options
          );
          this.pushRow(newRow, true);
        }

        rSize = this.rowSizes.length;
      }

      // resize table

      var newHeight =
        (this.rowSizes.length
          ? this.rowSizes[this.rowSizes.length - 1][1]
          : 0) + this.header.dom.offsetHeight;
      this._dom.style.height = newHeight + 'px';
      this.scrollable.height(newHeight);

      //need to set the parent height
      this._dom.parentElement.style.position = 'relative';
      this._dom.parentElement.style.height = newHeight + 'px';
    }

    this._domWidth = this._dom.offsetWidth;

    //Total this.render
    cell = this.getFirstRow().getFirstCell();
    hCell = this.header.row.getFirstCell();

    for (i = 0; i < rSize; i++) {
      vIndex = this._currentVIndex + i;
      // out of boundary check
      if (vIndex < this.rowSizes.length) {
        this.updateRowWithIndex(cell.parent, vIndex);
        for (j = 0; j < cSize; j++) {
          // out of boundary check
          hIndex = this._currentHIndex + j;
          if (hIndex >= this.colSizes.length) {
          } else {
            cWidth = this.colSizes[hIndex][0] + 'px';
            cell.setIndex(hIndex, vIndex);
            if (!this.options.doNotAssignDimensions) {
              cell.dom.style.width = cWidth;
            }
            renderStack.push(cell);
          }
          cell = cell.right;

          // Only execute once
          if (i === 0 && hIndex < this.colSizes.length) {
            hCell.setIndex(hIndex, 0);
            if (!this.options.doNotAssignDimensions) {
              hCell.dom.style.width = cWidth;
            }
            headerRenderStack.push(hCell);
            __getFreezeCellRenderStackFromHeader(
              freezeRenderStack,
              hCell,
              cWidth
            );

            hCell = hCell.right;
          }
        }
      } else if (!doNotCleanCells) {
        // Erase the empty cells
        for (j = 0; j < cSize; j++) {
          if (j === 0) {
            cell.parent.clearClasses();
          }

          cell.html('');
          cell = cell.right;
        }
      }
      cell = cell.bottom;
    }

    this._headerHeight = this.header.dom.offsetHeight;

    this.refreshScrollBars();
    this.fireCellRenderRequestCallbackWithArray(
      renderStack,
      headerRenderStack,
      freezeRenderStack
    );
    renderStack = null;
    headerRenderStack = null;
    freezeRenderStack = null;
  }

  function getTableWidth() {
    return this.colSizes.reduce(function(a, b) {
      return a + b;
    });
  }

  function getTableHeight() {
    return this.rowSizes.reduce(function(a, b) {
      return a + b;
    });
  }

  /**
   * Row and Column rotations
   */
  function fastForwardRow() {
    this.pushRow(this.getFirstRow());
  }

  function rewindRow() {
    this.unshiftRow(this.getLastRow());
  }

  function fastForwardCol() {
    var row, i, len, hCell, fCell;
    for (i = 0, len = this._rows.length; i < len; i++) {
      row = this._rows[i];
      row.push(row.getFirstCell());
    }

    // header
    hCell = this.header.row.getFirstCell();
    this.header.row.push(hCell);

    // Frozen rows
    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.parent.push(fCell);
      fCell = fCell.bottom;
    }
  }

  function rewindCol() {
    var row, i, len, hCell, fCell;
    for (i = 0, len = this._rows.length; i < len; i++) {
      row = this._rows[i];
      row.unshift(row.getLastCell());
    }

    //header
    hCell = this.header.row.getLastCell();
    this.header.row.unshift(hCell);

    // Frozen rows
    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.parent.unshift(fCell);
      fCell = fCell.bottom;
    }
  }

  function getFirstRow() {
    return this.pane.firstElementChild.row;
  }

  function getLastRow() {
    return this.pane.lastElementChild.row;
  }

  /**
   * Column and row operations
   */
  function pushRow(row, isNew) {
    if (isNew) {
      this.linkRows(row);
      var table = this;
      row.dom.addEventListener('click', function(event) {
        event.row = row;
        table._onRowClick(event);
      });
    }
    this.pane.appendChild(row.dom);
  }

  function unshiftRow(row, isNew) {
    if (isNew) {
      this.linkRows(row);
    }
    this.pane.insertBefore(row.dom, this.pane.firstChild);
  }

  function getNumRows() {
    return this._rows.length;
  }

  /**
   * Remove the last row from Pane in DOM order
   */
  function removeLastRow() {
    var row = this.getLastRow();
    this._rows.splice(this._rows.indexOf(row), 1);
    row.destroy();
  }

  function removeLastColumn() {
    for (var i = 0; i < this._rows; i++) {
      this._rows[i].removeLastCell();
    }
  }

  function addNewColumn() {
    var fCell, cell, lCell;
    for (var i = 0; i < this._rows.length; i++) {
      cell = new BentoTableCell(this._rows[i]);
      if (typeof fCell === 'undefined') {
        fCell = cell;
      }

      if (lCell) {
        lCell.setBottom(cell);
        cell.setTop(lCell);
      }
      this._rows[i].push(cell, true);
      lCell = cell;
    }

    fCell.setTop(cell);
    cell.setBottom(fCell);
  }

  function onHeaderClick(callback) {
    this._headerClickCallbackStack.push(callback);
  }

  function _headerCellClick(event) {
    event.cell = event.currentTarget.cell;
    for (var i = 0, len = this._headerClickCallbackStack.length; i < len; i++) {
      this._headerClickCallbackStack[i](event);
    }
  }

  function onRowClick(callback) {
    this.header.onRowClick(callback);
    this._rowClickCallbackStack.push(callback);
  }

  // Fire RowClick callback functions
  function _onRowClick(event) {
    this._rowClickCallbackStack.forEach(function(callback) {
      var row = event.currentTarget.row;
      event.rowIndex = row.row;
      event.row = row;
      callback(event);
    });
  }

  function deselectRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;
    if (rowIndex < rowSizes.length) {
      // update index
      // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          rows[i].removeClass('bt-row-selected');
          break;
        }
      }
    }
  }

  function selectRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;
    if (rowIndex < rowSizes.length)
      // update index

      // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          rows[i].addClass('bt-row-selected');
          break;
        }
      }
  }

  function toggleRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;

    if (rowIndex < rowSizes.length) {
      // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          return rows[i].toggleClass('bt-row-selected');
          break;
        }
      }
    }
  }

  function deselectFrozenRow(rowDom) {
    rowDom.row.removeClass('bt-row-selected');
  }

  function selectFrozenRow(rowDom) {
    rowDom.row.addClass('bt-row-selected');
  }

  function toggleFrozenRow(rowDom) {
    rowDom.row.toggleClass('bt-row-selected');
  }

  // Resize column
  function _onHeaderColumnResize(event) {
    this.setColumnWidth(event.col, event.width);
  }

  /**
   * Link all cells in current row with other cells that are in the same column
   * @param row
   */
  function linkRows(row) {
    this._rows.push(row);
    if (this._rows.length > 1) {
      var fRow = this.getFirstRow();
      var lRow = this.getLastRow();
      var numCol = fRow.getNumCells();
      var cell, fCell, lCell;

      for (var i = 0; i < numCol; i++) {
        cell = row.getNthCell(i);
        fCell = fRow.getNthCell(i);
        lCell = lRow.getNthCell(i);

        fCell.setTop(cell);
        lCell.setBottom(cell);
        cell.setTop(lCell);
        cell.setBottom(fCell);
      }
    }
  }

  function adjustColRowAllocation() {
    var table = this;
    var numRows = this.getNumRows();
    var numCols = numRows === 0 ? 1 : this.getFirstRow().getNumCells();
    var maxNumRows =
      Math.ceil(this._dom.offsetHeight / this.options.rowHeight) +
      ROW_CACHE_COUNT;
    var maxNumCols =
      Math.ceil(this._dom.offsetWidth / this.options.colWidth) + 3;
    var targetNumRows =
      this.rowSizes.length > numRows && this.rowSizes.length > maxNumRows
        ? maxNumRows
        : this.rowSizes.length;
    var targetNumCols =
      this.colSizes.length > numCols && this.colSizes.length > maxNumCols
        ? maxNumCols
        : this.colSizes.length;
    var row;

    if (numRows === 0 && numRows === targetNumRows) {
      // There is still no data, we do nothing
      return;
    }

    // Process rows
    if (targetNumRows > numRows) {
      // Need to add rows
      var dNumRows = targetNumRows - numRows;
      for (var i = 0; i < dNumRows; i++) {
        row = new BentoTableRow(
          numCols,
          this.options.colWidth,
          this.options.rowHeight,
          null,
          null,
          this.options
        );
        //row.setClassName(isOddRow? 'odd' : 'even');
        this.pushRow(row, true);
      }
    } else if (targetNumRows < numRows) {
      // Need to remove rows
      var dNumRows = numRows - targetNumRows;
      for (i = 0; i < dNumRows; i++) {
        this.removeLastRow();
      }
    }

    // Process columns
    if (targetNumCols > numCols) {
      // Need to add Cols
      var dNumCols = targetNumCols - numCols;
      for (var i = 0; i < dNumCols; i++) {
        this.addNewColumn();
      }
    } else if (targetNumCols < numCols) {
      // Need to remove Cols
      var dNumCols = numCols - targetNumCols;
      for (i = 0; i < dNumCols; i++) {
        this.removeLastColumn();
      }
    }

    // Update header columns
    this.header.setNumColumns(targetNumCols, function(e) {
      table._headerCellClick(e);
    });
    this.header.onColumnResize(this._onHeaderColumnResize.bind(this));
  }

  /**
   * Initialize Table
   */
  function init() {
    var table = this;

    this.ready = true;
  }
})();

var BentoTableHelper;

(function() {
  "use strict";

  // Public API
  BentoTableHelper = _BentoTableHelper;
  BentoTableHelper.prototype.applyTableOptions = applyTableOptions;
  BentoTableHelper.prototype.concatData = concatData;
  BentoTableHelper.prototype.getDataForRender = getDataForRender;
  BentoTableHelper.prototype.freezeRow = freezeRow;
  BentoTableHelper.prototype.getCellByIndex = getCellByIndex;
  BentoTableHelper.prototype.getColumnByIndex = getColumnByIndex;
  BentoTableHelper.prototype.getDataColunmIndex = getDataColunmIndex;
  BentoTableHelper.prototype.getNumCols = getNumCols;
  BentoTableHelper.prototype.getNumRows = getNumRows;
  BentoTableHelper.prototype.getRowByIndex = getRowByIndex;
  BentoTableHelper.prototype.init = init;
  BentoTableHelper.prototype.parseColumnDefinitions = parseColumnDefinitions;
  BentoTableHelper.prototype.removeColumnIndex = removeColumnIndex;
  BentoTableHelper.prototype.removeFrozenRecords = removeFrozenRecords;
  BentoTableHelper.prototype.renderCell = renderCell;
  BentoTableHelper.prototype.renderCellDefault = renderCellDefault;
  BentoTableHelper.prototype.renderFrozenCell = renderFrozenCell;
  BentoTableHelper.prototype.reset = reset;
  BentoTableHelper.prototype.sort = sort;
  BentoTableHelper.prototype.onRowClick = onRowClick;
  BentoTableHelper.prototype.unfreezeRow = unfreezeRow;
  BentoTableHelper.prototype.updateObjectsForRender = updateObjectsForRender;
  BentoTableHelper.prototype.fireRowClickCallbacks = fireRowClickCallbacks;

  // Private API
  BentoTableHelper.prototype._prepSort = _prepSort;

  function _BentoTableHelper(data, bentoTable, options, scope, compile, attrs) {
    var helper = this;
    // Class variables
    this._columnIndexRefArray = null;
    this._sorter = new BentoTableSort(bentoTable);

    // local variables
    this._cColumn = null;
    this._scope = scope;
    this._options = options;
    this._compile = compile;
    this._attrs = attrs;
    this._cColumnTemplate = null;
    this._columnTemplateStack = [];
    this._columnTypeObjs = {
      number: new BentoTableNumberColumn(),
      default: new BentoTableDefaultColumn(),
      checkbox: new BentoTableCheckBoxColumn()
    };

    this._table = bentoTable;
    this._cellObj = null;
    this._rowObj = null;
    this._data = data;
    this._frozenRows = [];

    this._colWidthArray = [];
    this._colIndexArray = [];

    this._rowClickCallbacks = [];

    this._table.onRowClick(function(event) {
      helper.fireRowClickCallbacks(event);
    });
  }

  /**
   * Initialization
   */
  function init(colOffset) {
    this._colOffset = colOffset ? colOffset : 0;
    this.parseColumnDefinitions(this._data.columns);
  }

  /**
   * Get ordered data for render
   * @returns {*}
   */
  function getDataForRender() {
    return this._data.data;
  }

  /**
   * Reset helper
   */
  function reset() {
    this._cellObj = null;
    this._frozenRows = [];
    this._rowObj = null;
  }

  /**
   * Public function to add table row clicks
   * @param callback
   */
  function onRowClick(callback) {
    this._rowClickCallbacks.push(callback);
  }

  function fireRowClickCallbacks(event) {
    for (var i = 0, len = this._rowClickCallbacks.length; i < len; i++) {
      this._rowClickCallbacks[i](event);
    }
  }

  /**
   * Concat two data arrays then return the new array
   * @param mainData
   * @param newData
   */
  function concatData(mainData, newData) {
    return (this._data.data = mainData.concat(newData));
  }

  /**
   * Remove frozen records from sourceData
   * IMPORTANT: sourceData needs to be sourced by tableCol
   * @param sourceData (array)
   * @param tableCol (number)
   */
  function removeFrozenRecords(sourceData, tableCol, desc) {
    var col = this._data.columns[this.getDataColunmIndex(tableCol)].name,
      fRow,
      dRow,
      index,
      val;
    // find the approx index for the match
    for (var i = 0, len = this._frozenRows.length; i < len; i++) {
      fRow = this._frozenRows[i];
      val = fRow[col];
      // Find the index to be removed
      index = this._sorter.findIndex(
        sourceData,
        function(l, r) {
          if (desc) {
            return l[col] >= val && val >= r[col];
          } else {
            return l[col] <= val && val <= r[col];
          }
        },
        function(f, l) {
          if (desc) {
            return f[col] < val || val < l[col];
          } else {
            return l[col] < val || val < f[col];
          }
        },
        true
      );

      // search linearly for the exact matching data since there might be multiple rows with the same col value
      while ((dRow = sourceData[index]) && fRow[col] === dRow[col]) {
        //found matching

        if (isEqual(fRow, dRow)) {
          fRow["__btDataIndex"] = index;
          sourceData.splice(index, 1);
          break;
        }
        index++;
      }
    }

    return sourceData;
  }

  // Check if two arrays are equal based on numbered indexes
  function isEqual(a, b) {
    var equal = true;
    for (var i = 0, len = a.length; i < len; i++) {
      if (a[i] !== b[i]) {
        equal = false;
        break;
      }
    }

    return equal;
  }

  /**
   * Freeze a row
   * @param row - row data object
   * @param noRender - do not render
   * @param mainData - (Array optional)
   */
  function freezeRow(row, noRender, mainData) {
    if (this._frozenRows.indexOf(row) > -1) {
      console.warn("Bento Table: This row is already frozen.");
      return;
    }

    // Remove row from base data
    var dataArray = mainData || this._data.data,
      index = dataArray.indexOf(row);
    dataArray.splice(index, 1);

    // Add a bookmark as the position in Data
    row["__btDataIndex"] = index;

    // Add row to the frozen row
    this._frozenRows.push(row);
    this._table.addFrozenRow();

    // Remove and add row size from rowSizes to frozenRowSizes in BentoTable
    this._table.frozenRowSizes.push(this._table.rowSizes.splice(index, 1)[0]);

    // Calculate row size indexes
    this._table.calcGridRowSizeArray(0, true);
    this._table.calcGridRowSizeArray(index);

    // Will render
    if (!noRender) {
      // Sort if necessary before rendering
      if (typeof this._sortedDataColIndex !== "undefined") {
        var col = this._sortedDataColIndex;
        var data;
        if (this._sortedDesc) {
          //frozen rows
          data = this._sorter.sort(
            this._frozenRows,
            this._table.frozenRowSizes,
            function(a, b) {
              return a[col] < b[col];
            }
          );
        } else {
          //frozen rows
          data = this._sorter.sort(
            this._frozenRows,
            this._table.frozenRowSizes,
            function(a, b) {
              return a[col] > b[col];
            }
          );
        }

        this._frozenRows = data.rows;
        this._table.frozenRowSizes = data.rowSizes;
      }

      this._table.render();
      this._table.refreshScrollBars();
    }
  }

  /**
   * Unfreeze a row
   * @param row - row data object
   * @param mainData - (Array optional)
   */
  function unfreezeRow(row, noRender, mainData) {
    // Remove frozen row
    var index,
      rowSize,
      dataArray = mainData || this._data.data;
    index = this._frozenRows.indexOf(row);

    // The row doesn't exit in the frozen area
    if (index < 0) {
      console.warn("Bento Table: This row is already unfrozen.");
      return;
    }

    this._frozenRows.splice(index, 1);
    this._table.removeFrozenRow(index);
    rowSize = this._table.frozenRowSizes.splice(index, 1)[0];

    // Add back to data
    // Condition 1: check if there is a sort -> use b-search to insert
    // Condition 2: No Sort

    //[Condition 1]
    if (typeof this._sortedDataColIndex !== "undefined") {
      var col = this._sortedDataColIndex;
      // Descending
      if (this._sortedDesc) {
        index = this._sorter.findIndex(
          dataArray,
          function(a, b) {
            return a[col] >= row[col] && row[col] >= b[col];
          },
          function(a, b) {
            // too small
            if (row[col] > a[col]) {
              return -1;
            }
            // too big
            else if (row[col] < b[col]) {
              return 1;
            } else {
              return 0;
            }
          }
        );
      }
      // Ascending
      else {
        index = this._sorter.findIndex(
          dataArray,
          function(a, b) {
            return a[col] <= row[col] && row[col] <= b[col];
          },
          function(a, b) {
            // too small
            if (row[col] < a[col]) {
              return -1;
            }
            // too big
            else if (row[col] > b[col]) {
              return 1;
            } else {
              return 0;
            }
          }
        );
      }
    }
    // [Condition 2]
    // insert the row back to its original location in the data array
    // no need to worry about the sorting for now because it'll be resorted
    else if (typeof row["__btDataIndex"] !== "undefined") {
      index = row["__btDataIndex"];
    } else {
      index = 0;
    }

    delete row["__btDataIndex"];
    // Insert the row back and update the rowSize
    dataArray.splice(index, 0, row);
    this._table.rowSizes.splice(index, 0, rowSize);

    // Calculate row size indexes
    this._table.calcGridRowSizeArray(0, true);
    this._table.calcGridRowSizeArray(index);

    if (!noRender) {
      this._table.render();
      this._table.refreshScrollBars();
    }
  }

  /**
   * Renders an object to BentoCell
   * @param cell - (BentoCell) cell to be rendered
   *
   * This will be overridden based on the type of the object
   */
  function renderCell(cell) {
    if (this.updateObjectsForRender(cell, false)) {
      this.renderCellDefault(cell);
      cell.parent.applyClasses();
    }
  }

  /**
   * Render a frozen cell from frozen row array
   * @param cell
   */
  function renderFrozenCell(cell) {
    if (this.updateObjectsForRender(cell, true)) {
      this.renderCellDefault(cell);
      cell.parent.applyClasses();
    }
  }

  /**
   * Most default cell dom rendering based on template and other column types
   * @param cell
   */
  function renderCellDefault(cell) {
    if (this._cColumn.type === "template" && !!this._cColumn.template) {
      this._cColumnTemplate = this._columnTemplateStack[this._cColumn.template];
      // Create custom template the first time
      if (typeof this._cColumnTemplate === "undefined") {
        this._cColumnTemplate = new BentoTableCellTemplateColumn(
          this._scope,
          this._compile,
          this._attrs.bentoTable
        );
        this._cColumnTemplate.setTemplate(
          document.getElementById(this._cColumn.template).textContent
        );
        this._columnTemplateStack[
          this._cColumn.template
        ] = this._cColumnTemplate;
      }
      //use template to render
      this._cColumnTemplate.applyContentToCell(
        this._cellObj,
        cell,
        this._rowObj
      );
    } else if (
      !!this._cColumn.type &&
      this._columnTypeObjs[this._cColumn.type]
    ) {
      this._columnTypeObjs[this._cColumn.type].applyContentToCell(
        this._cellObj,
        cell
      );
    } else {
      this._columnTypeObjs.default.applyContentToCell(this._cellObj, cell);
    }
  }

  /**
   * Prepare objects for cell render
   * @param cell
   * @param isFrozen
   * @returns {boolean} - OK to render
   */
  function updateObjectsForRender(cell, isFrozen) {
    var col = cell.col;
    if ((this._cColumn = this.getColumnByIndex(col))) {
      this._rowObj = this.getRowByIndex(cell.row, isFrozen);
      this._cellObj = this.getCellByIndex(cell.row, this._cColumn, isFrozen);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Sort data based on the colIndex and order
   * @param colIndex (number)
   * @param desc (bool)
   * @param isInfiniteScroll (bool)
   */
  function sort(colName, desc, isInfiniteScroll) {
    var col = colName,
      data,
      frozenData;
    this._prepSort(col, desc);
    // descending sort
    if (desc) {
      if (!isInfiniteScroll) {
        data = this._sorter.sort(
          this._data.data,
          this._table.rowSizes,
          function(a, b) {
            return a[col] < b[col];
          }
        );
      }

      //frozen rows
      frozenData = this._sorter.sort(
        this._frozenRows,
        this._table.frozenRowSizes,
        function(a, b) {
          return a[col] < b[col];
        }
      );
    }
    // ascending sort
    else {
      if (!isInfiniteScroll) {
        data = this._sorter.sort(
          this._data.data,
          this._table.rowSizes,
          function(a, b) {
            return a[col] > b[col];
          }
        );
      }

      //frozen rows
      frozenData = this._sorter.sort(
        this._frozenRows,
        this._table.frozenRowSizes,
        function(a, b) {
          return a[col] > b[col];
        }
      );
    }

    if (!isInfiniteScroll) {
      this._data.data = data.rows;
      this._table.rowSizes = data.rowSizes;
    } else {
      this._data.data = [];
      this._table.rowSizes = [];
    }

    this._frozenRows = frozenData.rows;
    this._table.frozenRowSizes = frozenData.rowSizes;
  }

  /**
   * Prepare for sorting
   * This function will store sorting config for later use this function needs to be called
   * everytime when a sort is fired, even it is an override function
   * Will be used by the follow functions:
   *  - unfreezeRow
   *
   * @param col
   * @param desc
   * @private
   */
  function _prepSort(col, desc) {
    this._sortedDataColIndex = col;
    this._sortedDesc = desc;
  }

  /**
   * Get a row data array by row index
   * @param rowIndex
   * @returns {*} - row data array
   */
  function getRowByIndex(rowIndex, isFrozen) {
    return isFrozen ? this._frozenRows[rowIndex] : this._data.data[rowIndex];
  }

  /**
   * Get Column object based on the table column index
   * @param colIndex
   * @returns {*}
   */
  function getColumnByIndex(colIndex) {
    return this._data.columns[this._columnIndexRefArray[colIndex]];
  }

  /**
   * Get a cell data object from Table row and column indexes
   * @param rowIndex
   * @param colIndex
   * @returns {*}
   */
  function getCellByIndex(rowIndex, columnObj, isFrozen) {
    return columnObj.name
      ? this.getRowByIndex(rowIndex, isFrozen)[columnObj.name]
      : this.getRowByIndex(rowIndex, isFrozen);
  }

  /**
   * Get total rows for table to render
   * @returns {number}
   */
  function getNumRows() {
    return this._data.data.length;
  }

  /**
   * Gets the total number of columns that should be rendered
   * @returns {number}
   */
  function getNumCols() {
    return this._columnIndexRefArray.length;
  }

  /**
   * Remove Column index from reference
   * @param colIndex
   */
  function removeColumnIndex(colIndex) {
    var index = this._columnIndexRefArray.indexOf(colIndex);
    if (index > -1) {
      this._columnIndexRefArray.splice(index, 1);
    }
  }

  /**
   * Return an original column index from the table index
   * @param tableColumnIndex
   * @returns {number}
   */
  function getDataColunmIndex(tableColumnIndex) {
    return this._columnIndexRefArray[tableColumnIndex];
  }

  /**
   * Apply options to table
   */
  function applyTableOptions() {
    // Update initial column width
    this._table.setColumnWidth(this._colIndexArray, this._colWidthArray);

    this._colIndexArray = null;
    this._colWidthArray = null;

    delete this._colIndexArray;
    delete this._colWidthArray;
  }

  /**
   * Parse columns based on the `hide` prameters
   * @param columns
   */
  function parseColumnDefinitions(columns) {
    this._columnIndexRefArray = [];
    var colDef, i, len;
    var offsetColWidth = this._options.rowSelectColumnWidth
      ? this._options.rowSelectColumnWidth
      : 40;

    if (this._colOffset > 0) {
      for (i = 0, len = this._colOffset; i < len; i++) {
        this._colIndexArray.push(0); // spacer
        this._colWidthArray.push(offsetColWidth); // default
        this._columnIndexRefArray.push(0);
      }
    }

    for (i = 0, len = columns.length; i < len; i++) {
      colDef = columns[i];
      if (colDef.hide !== true) {
        if (colDef.width && colDef.width > 0) {
          this._colIndexArray.push(this._columnIndexRefArray.length);
          this._colWidthArray.push(colDef.width);
        }
        this._columnIndexRefArray.push(i);
      }
    }
  }
})();

var bentoTableApp = bentoTableApp;

(function(angular){

  bentoTableApp = bentoTableApp || angular.module('bento.table',[]);

  bentoTableApp
    .factory('tableFacotry', function(){
      return{
        /**
         * Build sort object for the controller to use
         * @param sortAttr
         * @param header
         *
         * sortAttr needs to be either a Boolean or an Object
         *
         * Boolean: decides if all the columns are sortable or not
         *
         * Object:
         *    -
         *
         */
        buildSortOptions : function(sortAttr, header){

          if(typeof header != 'undefined' && header) {

            var sortOptions = [];
            var noSortArray = [];
            var initSort = {
              column : -1,
              direction: 'asc'
            };


            //Get the noSort reference ready
            if(typeof sortAttr.noSort != 'undefined'){
              var noSortData = sortAttr.noSort.splice(',');
              for(var i = 0; i < noSortData.length; i++){
                noSortArray[parseInt(noSortData[i])] = true;
              }
            }

            //See if there is an initial sort value specified
            if(typeof sortAttr.initSort != 'undefined'){
              initSort.column = parseInt(sortAttr.initSort.column);
              initSort.direction = (sortAttr.initSort.direction == 'desc') ? 'desc' : 'asc';
            }

            //Construct the confuguration
            for(var i = 0; i < header.length; i++) {
              var option = {};

              if (typeof sortAttr == 'boolean') {
                option.sortable = sortAttr;
              } else if (typeof sortAttr == 'object') {
                option.sortable = (noSortArray[i] === true) ? false : true;
              } else {
                option.sortable = true;
              }

              sortOptionspush(option);

            }

            return {
              initSort : iniSort,
              options  : sortOptions
            };

          }
        }
      }

    });

})(window.angular);

/**
 * Constructor
 * @param data
 * @param bentoTable
 * @param options
 * @param scope
 * @param $compile
 * @param attrs
 * @private
 */
function BentoTableGroupingHelper(data, bentoTable, options, scope, $compile, attrs) {
  BentoTableHelper.apply(this, arguments);
  var helper = this;

  // Variables
  this._groupingArray = null; // Array to sort groups in group hierarchy
  this._rowRefArray = null; // Main reference to show what is in the table viewport in order
  this._groupColName = null;  // Column index that is actually grouping the whole table
  this._table = bentoTable; // table reference to (BentoTable) object
  this._dataSize = this._data.data.length;
  this._rowPropertyMap = null // Row property map
  this._rowPropertyRefArray = null; // Fallback: Reference to link row and its properties
  this._rowPropertyArray = null; // Fallback: Refernce to row properties defined by `this._rowPropertyRefArray`

  this._table.onRowClick(function (event) {
    helper._onRowClick(event)
  });

  // Private constant label variables
  var uid = [Math.round(Math.random() * 100000), Math.round(Math.random() * 100000)].join('');
  this._labelBTDataIndex = ['__btDataIndex', uid].join('');
  this._labelBTGroupParent = ['_btGroupParent', uid].join('');
  this._labelBTRowRefDataIndex = ['__btRowRefDataIndex', uid].join('');
  this._labelBTGroupMember = ['_btGroupMember', uid].join('');
}

(function (undefined) {
  'use strict';
  // Inherit from BentoTableHelper
  BentoTableGroupingHelper.prototype = Object.create(BentoTableHelper.prototype);
  BentoTableGroupingHelper.prototype.constructor = BentoTableGroupingHelper;

  //Method Overrides
  BentoTableGroupingHelper.prototype.getRowByIndex = getRowByIndex;
  BentoTableGroupingHelper.prototype.getCellByIndex = getCellByIndex;
  BentoTableGroupingHelper.prototype.getDataForRender = getDataForRender;
  BentoTableGroupingHelper.prototype.getNumRows = getNumRows;
  BentoTableGroupingHelper.prototype.renderCell = renderCell;
  BentoTableGroupingHelper.prototype.concatData = concatData;
  BentoTableGroupingHelper.prototype.sort = sort;
  BentoTableGroupingHelper.prototype.freezeRow = freezeRow;
  BentoTableGroupingHelper.prototype.unfreezeRow = unfreezeRow;
  BentoTableGroupingHelper.prototype.fireRowClickCallbacks = fireRowClickCallbacks;
  BentoTableGroupingHelper.prototype.getParentVariableName = getParentVariableName;

  //New Method
  BentoTableGroupingHelper.prototype.setGrouping = setGrouping;
  BentoTableGroupingHelper.prototype.expandRow = expandRow;
  BentoTableGroupingHelper.prototype.collapseRow = collapseRow;
  BentoTableGroupingHelper.prototype.getRowProperty = getRowProperty;
  BentoTableGroupingHelper.prototype.setRowProperty = setRowProperty;
  BentoTableGroupingHelper.prototype.deleteRowProperty = deleteRowProperty;

  //Private Methods
  BentoTableGroupingHelper.prototype._buildRowRefArray = _buildRowRefArray;
  BentoTableGroupingHelper.prototype._onRowClick = _onRowClick;

  /**
   * Expose group parent variable for other helpers to use
   * @returns {string|*|BentoTableGroupingHelper._labelBTGroupParent}
   */
  function getParentVariableName() {
    return this._labelBTGroupParent;
  }

  /**
   * Freeze a row and it needs to be a group-member
   * @param row
   * @param noRender - do not render
   * @param mainData - (Array optional)
   */
  function freezeRow(row, noRender) {
    if (typeof row === 'object') {
      if (this._frozenRows.indexOf(row) > -1) {
        console.warn('Bento Table: This row is already frozen.');
        return;
      }

      this._frozenRows.push(row);

      // Remove row from base data
      var
        index
        ;

      if (this.getRowProperty(row, this._labelBTGroupParent)) {
        this.setRowProperty(
          row, this._labelBTDataIndex,
          this.getRowProperty(row, this._labelBTGroupParent).removeMember(row, this._labelBTGroupParent));
      } else {
        index = this._groupingArray.indexOf(row);
        this._groupingArray.splice(index, 1);
        this.setRowProperty(row, this._labelBTDataIndex, index);
        this.setRowProperty(row, this._labelBTRowRefDataIndex, this._rowRefArray.indexOf(row));
      }

      index = this._rowRefArray.indexOf(row);
      this._table.addFrozenRow();

      this._rowRefArray.splice(index, 1);
      this._table.removeRow(index, 1);

      // TODO: update the sizes

    } else {
      console.warn('Bento Table: Can not freeze a group.');
    }
  }

  /**
   * Unfreeze a row and put it back to the group
   * @param row
   */
  function unfreezeRow(row) {
    if (this._frozenRows.indexOf(row) === -1) {
      console.warn('Bento Table: this row is not frozen.')
      return;
    }

    var index, col, rowCol;
    // This row is part of a group
    if (this.getRowProperty(row, this._labelBTGroupParent)) {

      var group = this.getRowProperty(row, this._labelBTGroupParent);

      if (typeof this._sortedDataColIndex !== 'undefined') {
        col = this._sortedDataColIndex;
        rowCol = this.getRowProperty(row, col);
        if (this._sortedDesc) {
          index = this._sorter.findIndex(
            group.members,
            function (a, b) {
              return this.getRowProperty(a, col) >= rowCol && rowCol >= this.getRowProperty(b, col);
            },
            function (a, b) {
              if (this.getRowProperty(a, col) < rowCol) {
                return -1;
              }
              if (this.getRowProperty(b, col) > rowCol) {
                return 1;
              }
              return 0;
            }
          );
        } else {
          index = this._sorter.findIndex(
            group.members,
            function (a, b) {
              return this.getRowProperty(a, col) <= rowCol && rowCol <= this.getRowProperty(b, col);
            },
            function (a, b) {
              if (this.getRowProperty(a, col) > rowCol) {
                return -1;
              }
              if (this.getRowProperty(b, col) < rowCol) {
                return 1;
              }
              return 0;
            }
          );
        }
        group.addMember(row, index, this._labelBTGroupParent, this);
      } else {
        // not sorted
        group.addMember(
          row,
          this.getRowProperty(row, this._labelBTDataIndex),
          this._labelBTGroupParent,
          this);
      }

      this._buildRowRefArray();

      if (group.isExpanded) {
        index = this._rowRefArray.indexOf(group);
        this._table.addRow(index == 0 ? 0 : index - 1, 1);
      } else {
        this._table.render();
      }
    }
    else {

      // This is an independent row
      if (typeof this._sortedDataColIndex !== 'undefined') {

        col = this._sortedDataColIndex;
        rowCol = this.getRowProperty(row, col);
        if (this._sortedDesc) {
          index = this._sorter.findIndex(
            this._groupingArray,
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col);
              }
              return a >= rowCol && rowCol >= b;
            },
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }

              if (a < rowCol) {
                return -1;
              }
              if (b > rowCol) {
                return 1;
              }
              return 0;
            }
          );
        } else {
          index = this._sorter.findIndex(
            this._groupingArray,
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }
              return a <= rowCol && rowCol <= b;
            },
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }

              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }

              if (a > rowCol) {
                return -1;
              }
              if (b < rowCol) {
                return 1;
              }
              return 0;
            }
          );
        }
        this._groupingArray.splice(index, 0, row);
      } else {
        // not sorted
        var rowProp = this.getRowProperty(row, this._labelBTRowRefDataIndex);
        index = rowProp ? rowProp : 0;
        this._groupingArray.splice(rowProp, 0, row);
      }

      this._buildRowRefArray();
      // insert this row back to refArray
      this._table.addRow(index, 1);
    }

    this.deleteRowProperty(row, this._labelBTDataIndex);
    this.deleteRowProperty(row, this._labelBTRowRefDataIndex);

    this._frozenRows.splice(this._frozenRows.indexOf(row), 1);
    this._table.removeFrozenRow();
    this._table.render();
    this._table.refreshScrollBars();
  }

  /**
   * Concat new data to the main data
   * @param data
   * @param newData
   * @returns {*}
   */
  function concatData(mainData, newData) {
    //We need to update _groupingArray and _rowRefArray with new rows
    // Grouping process
    this._data.data = mainData.concat(newData);
    this.setGrouping(this._data.data, this._options.group.by, this._options.group.expanded, this._options.group.referencingTo);
    return this._data.data;
  }

  /**
   * Fires row click
   * @param event
   * @private
   */
  function fireRowClickCallbacks(event) {
    // Find current col of clicked row

    // We do not fire row click even on group header rows
    var colIndex = __findColFromRowClick(event);
    if (colIndex === false || (event.row.hasClass('bt-group') && colIndex >= this._colOffset)) {
      return;
    }

    BentoTableHelper.prototype.fireRowClickCallbacks.call(this, event);
  }

  /**
   * Helper function to find the col index that is clicked on a row
   * @param event
   */
  function __findColFromRowClick(event) {
    var obj = event.target;
    while (obj && typeof obj.cell === 'undefined') {
      obj = obj.parentElement;
    }

    return obj ? obj.cell.col : false;
  }

  /**
   * Returns a data array for render (override)
   * @returns {*}
   */
  function getDataForRender() {
    return this._rowRefArray;
  }

  /**
   * Handles events when a row is clicked
   * @param event
   */
  function _onRowClick(event) {
    // we do not expand or collapse row if clicked col is in the column offset indexes
    var colIndex = __findColFromRowClick(event);
    if (colIndex === false || (__findColFromRowClick(event) < this._colOffset)) {
      return
    }

    var row = event.row;

    // This row needs to be a group header
    // AND the first column is clicked
    if (row.hasClass('bt-group')) {
      // Expand and Collapse Row for row grouping
      row.toggleClass('bt-group-expanded');
      if (row.hasClass('bt-group-expanded')) {
        this.expandRow(event.rowIndex);
      } else {
        this.collapseRow(event.rowIndex);
      }
    }

    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Renders an object to BentoCell
   * @param cell - (BentoCell) cell to be rendered
   *
   * This will be overridden based on the type of the object
   */
  function renderCell(cell) {
    this.updateObjectsForRender(cell, false);
    if (this._rowObj instanceof BentoTableGroupingRow) {
      // clear
      if (cell.col - this._colOffset === 0) {
        cell.parent.removeClass('bt-group-member', true);
        cell.parent.addClass('bt-group', true);

        cell.addClass('bt-group-row-head', true);
        if (this._rowObj.isExpanded) {
          cell.parent.addClass('bt-group-expanded', true);
        }
        if (this._rowObj.row) {
          cell.parent.addClass('bt-group-leader', true);
          this.renderCellDefault(cell);
        } else {
          cell.html(this._rowObj.name);
        }
      } else {

        cell.removeClass('bt-row-head', true);
        // only render for group leader row
        if (this._rowObj.row) {
          this.renderCellDefault(cell);
        }
      }
    } else {
      cell.parent.removeClass('bt-group', true);
      cell.parent.removeClass('bt-group-expanded', true);
      cell.parent.removeClass('bt-group-leader', true);
      try {
        if (this.getRowProperty(this._rowObj, this._labelBTGroupMember)) {
          cell.parent.addClass('bt-group-member', true);
          if (cell.col - this._colOffset === 0) {
            cell.addClass('bt-group-row-head', true);
          } else {
            cell.removeClass('bt-group-row-head', true);
          }
        } else {
          if (cell.col - this._colOffset === 0) {
            cell.parent.removeClass('bt-group-member', true);
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.renderCellDefault(cell);
    }

    cell.parent.applyClasses();
  }

  /**
   * Sort the current grouped table
   * @param this._sorter - (BentoTableSort) object
   * @param colName - (number) column index that needs to be sorted
   * @param desc - (bool) Descending
   */
  function sort(colName, desc) {
    var cIndex = colName;
    var i, len, group;
    this._prepSort(colName, desc);
    // descending sort
    if (desc) {
      // sort grouping array
      this._groupingArray = this._sorter.sort(this._groupingArray, null, function (a, b) {

        if (a instanceof BentoTableGroupingRow) {
          a = (a.row) ? a.row[cIndex] : a.name;
        } else {
          a = a[cIndex]
        }

        if (b instanceof BentoTableGroupingRow) {
          b = (b.row) ? b.row[cIndex] : b.name;
        } else {
          b = b[cIndex]
        }

        return a < b;
      }).rows;

      // sort the members in each group
      for (i = 0, len = this._groupingArray.length; i < len; i++) {
        group = this._groupingArray[i];
        if (group instanceof BentoTableGroupingRow) {
          group.members = this._sorter.sort(group.members, null, function (a, b) {
            return a[cIndex] < b[cIndex];
          }).rows;
        }
      }

    }
    // ascending sort
    else {
      // sort grouping array
      this._groupingArray = this._sorter.sort(this._groupingArray, null, function (a, b) {

        if (a instanceof BentoTableGroupingRow) {
          a = (a.row) ? a.row[cIndex] : a.name;
        } else {
          a = a[cIndex]
        }

        if (b instanceof BentoTableGroupingRow) {
          b = (b.row) ? b.row[cIndex] : b.name;
        } else {
          b = b[cIndex]
        }

        return a > b;
      }).rows;

      // sort the members in each group
      for (i = 0, len = this._groupingArray.length; i < len; i++) {
        group = this._groupingArray[i];
        if (group instanceof BentoTableGroupingRow) {
          group.members = this._sorter.sort(group.members, null, function (a, b) {
            return a[cIndex] > b[cIndex];
          }).rows;
        }
      }
    }

    // Rebuild `rowRefArray` for redering
    this._buildRowRefArray();
  }

  /**
   * Get cell by given row and column indexes
   * @param col
   * @param rowIndex
   * @returns {BentoTableGroupingRow || cell || null}
   */
  function getCellByIndex(rowIndex, col, isFrozen) {
    var row = isFrozen ? this._frozenRows[rowIndex] : this._rowRefArray[rowIndex];

    if (row instanceof BentoTableGroupingRow) {
      if (row.row) {
        return row.row[col.name];
      } else {
        if (col === 0) {
          return row.name;
        } else {
          return null;
        }
      }
    } else {
      try {
        return row[col.name];
      } catch (e) {
        console.error(e);
      }
    }
  }

  /**
   * Expand a row
   * @param rowIndex
   *
   * rowIndex has to reference to a BentoTableGroupingRow
   */
  function expandRow(rowIndex) {
    var group = this._rowRefArray[rowIndex];
    if (group instanceof BentoTableGroupingRow && !group.isExpanded) {
      var i,
          length = group.members.length;
      group.isExpanded = true;

      for (i = 0; i < length; i++) {
        this._rowRefArray.splice(rowIndex + 1 + i, 0, group.members[i]);
      }

      this._table.addRow(rowIndex, length);
    }
  }

  /**
   * Collapse a row
   * @param rowIndex
   *
   * rowIndex has to reference to a BentoTableGroupingRow
   */
  function collapseRow(rowIndex) {
    var group = this._rowRefArray[rowIndex];
    if (group instanceof BentoTableGroupingRow && group.isExpanded) {
      var i,
          length = group.members.length;
      group.isExpanded = false;
      for (i = 0; i < length; i++) {
        this._rowRefArray.splice(rowIndex + 1, 1);
      }

      this._table.removeRow(rowIndex, length);
    }
  }

  /**
   * Setup grouping references and indexes
   * @param groupBy - (number) Column Index
   * @param isExpanded - (bool) Check if all groups are expanded or not
   * @param groupedByColumnContent - (bool) check if grouping is based on who column content is
   * @param groupFlag
   *
   * We do one group for now
   */
  function setGrouping(sourceData, groupBy, isExpanded, referencingTo) {
    var tempArray = [], groupByObj, type, i, length, row;
    this._groupColName = groupBy;

    // Determine browser support for Map
    if (Map) {;
      this._rowPropertyMap = new Map();
    }
    // IE10 and lower
    else {
      this._rowPropertyRefArray = [];
      this._rowPropertyArray = [];
    }

    this._groupingArray = [];

    // Grouping
    length = sourceData.length;

    // There is parent / child relationship
    if (typeof referencingTo !== 'undefined') {
      /*
       Logic: 3 step approach
       1. Create an array with all children rows categorized by parent referencingTo parameter
       2. Create an array with all isolated rows
       3. Combine the two array with parent-child relationship
       */
      var childrenArray = [];
      var childArray;
      // Separate children and parent-to-bes
      for (i = 0; i < length; i++) {
        row = sourceData[i];
        groupByObj = row[this._groupColName];
        type = typeof groupByObj;

        if ((type === 'number') || (type === 'string' && groupByObj.length > 0)) {
          childArray = childrenArray[groupByObj];
          if (typeof childArray === 'undefined') {
            childArray = [];
            childrenArray[groupByObj] = childArray;
          }
          // Mark this row as a member
          this.setRowProperty(row, this._labelBTGroupMember, true);
          childArray.push(row);
        } else {
          tempArray.push(row);
        }
      }

      // Combine the two arrays
      var childrenGroup;
      for (i = 0, length = tempArray.length; i < length; i++) {
        row = tempArray[i];
        if (childrenArray[row[referencingTo]]) {
          childrenGroup = childrenArray[row[referencingTo]];
          childrenGroup['_tempGroupLeader'] = true;
          childrenGroup['_leader'] = row;
          this.setRowProperty(row, '_btGroup', true);
          tempArray[i] = childrenGroup;
        }
      }
    }
    else {
      for (i = 0; i < length; i++) {
        row = sourceData[i];
        groupByObj = row[this._groupColName];
        if (typeof tempArray[groupByObj] === 'undefined') {
          tempArray[groupByObj] = [];
          tempArray[groupByObj]['_tempGroupLeader'] = true;
        }
        this.setRowProperty(row, this._labelBTGroupMember, true);
        tempArray[groupByObj].push(row);
      }
    }

    // Put Grouping to index
    var group, groupArr;
    for (var key in tempArray) {
      groupArr = tempArray[key];
      if (Array.isArray(groupArr) && groupArr['_tempGroupLeader']) {
        group = new BentoTableGroupingRow(key, isExpanded);
        group.addMembers(tempArray[key], this._labelBTGroupParent, this);
        if (groupArr['_leader']) {
          group.row = groupArr['_leader'];
        }
      } else {
        // There is no children
        group = groupArr;
      }
      // Using array since it's faster than Object referencing
      this._groupingArray.push(group);
    }

    // Build RefArray
    this._buildRowRefArray();

    // Remove column index that's been grouped by
    this.removeColumnIndex(groupBy);
  }

  /**
   * Get number of rows
   * @returns {number}
   */
  function getNumRows() {
    //check if row is changed
    if (this._dataSize !== this._data.data.length) {
      // update reference array

      this._dataSize = this._data.data.length;
    }

    return this._rowRefArray.length;
  }

  /**
   * Return row object from Data by new rowNumber
   * @param rowNum (number)
   */
  function getRowByIndex(rowIndex, isFrozen) {
    return isFrozen ? this._frozenRows[rowIndex] : this._rowRefArray[rowIndex];
  }

  /**
   * Get property of a row
   * @param row
   * @param label
   * @returns {*}
   */
  function getRowProperty(row, label) {
    var prop;
    prop = Map ?
      this._rowPropertyMap.get(row)
      : this._rowPropertyArray[
      this._rowPropertyRefArray.indexOf(row)
      ];

    if (prop) {
      return prop[label];
    }
    return prop;
  }

  /**
   * Set proerty of a row
   * @param row
   * @param label
   * @param value
   */
  function setRowProperty(row, label, value) {

    if (Map) {
      var prop;
      if (!this._rowPropertyMap.has(row)) {
        prop = {};
        this._rowPropertyMap.set(row, prop);
      } else {
        prop = this._rowPropertyMap.get(row);
      }
      prop[label] = value
      return;
    }

    // Fallback for IE10 and lower
    var index = this._rowPropertyRefArray.indexOf(row);
    if (index == -1) {
      index = this._rowPropertyRefArray.length;
      this._rowPropertyRefArray.push(row);
      this._rowPropertyArray[index] = {};
    }
    this._rowPropertyArray[index][label] = value;
  }

  /**
   * Delete a row property
   * @param row
   * @param label
   */
  function deleteRowProperty(row, label) {
    if (Map) {
      delete this._rowPropertyMap.get(row)[label];
    }
    // Fallback: IE10 and lower
    else {
      delete this._rowPropertyArray[
        this._rowPropertyRefArray.indexOf(row)
        ][label];
    }

  }

  // Private functions
  /**
   * Build this._rowRefArray for table rendering
   */
  function _buildRowRefArray() {
    this._rowRefArray = [];

    for (var i = 0, length = this._groupingArray.length, group; i < length; i++) {
      group = this._groupingArray[i];
      this._rowRefArray.push(group);
      if (group.isExpanded) {
        for (var j = 0, lengthJ = group.members.length; j < lengthJ; j++) {
          this._rowRefArray.push(group.members[j]);
        }
      }
    }
  }
})();

var BentoTableGroupingRow;

(function () {
  'use strict';

  BentoTableGroupingRow = b;
  b.prototype.addMember = addMember;
  b.prototype.addMembers = addMembers;
  b.prototype.removeMember = removeMember;

  /**
   * Constructor
   * @param name
   * @param isExpanded
   */
  function b(name, isExpanded) {
    this.name = name;
    this.members = [];
    this.isExpanded = isExpanded;
    this.row = null; // init row
  }

  /**
   * Removing a member from this group
   * @param member
   * @returns {boolean}
   */
  function removeMember(member, parentLabel) {
    var index = this.members.indexOf(member);

    if (index > -1) {
      this.members.splice(index, 1);
      return index;
    } else {
      return false;
    }
  }

  /**
   * Adding a member to this group
   * @param member (*)
   */
  function addMember(member, index, parentLabel, tableGroupHelper) {
    tableGroupHelper.setRowProperty(member, parentLabel, this);
    if (typeof index !== 'undefined') {
      // Put the member back to `index` position in this group
      this.members.splice(index, 0, member);
    } else {
      this.members.push(member);
    }
  }

  /**
   * Adding multiple members to this group
   * @param members (array)
   */
  function addMembers(members, parentLabel, tableGroupHelper) {
    for (var i = 0, len = members.length; i < len; i++) {
      tableGroupHelper.setRowProperty(members[i], parentLabel, this);
    }
    this.members = this.members.concat(members)
  }
})();



function BentoTableHeader(width, height, options) {
  'use strict';

  var h = this;

  // API
  h.setNumColumns = setNumColumns;
  h.reset = reset;
  h.renderCell = renderCell;
  h.onColumnResize = onColumnResize;
  h.removeFrozenRow = removeFrozenRow;
  h.addFrozenRow = addFrozenRow;
  h.onRowClick = onRowClick;
  h.frozenRows = [];
  this.options = options;

  init();

  var resizeBar;
  var _columnResizeCallbackStack = [];
  var _rowClickCallback = [];
  var isResizing = false;

  /**
   * Remove header classes and frozen rows
   */
  function reset(){
    this.frozenRows.forEach(function(row){
      row.remove();
    });
    h.row.removeClass('bt-row-selected');

    var fCell = h.row.getFirstCell();
    var tempCell = fCell;

    do{
      tempCell.top = tempCell.bottom = tempCell;
      tempCell = tempCell.right;
    }
    while(tempCell !== fCell)
  }

  /**
   * Append row click callback to stack
   * @param callback
   */
  function onRowClick(callback) {
    _rowClickCallback.push(callback);
  }

  function _onRowClick(event) {
    var i, len,
        rows = h.dom.querySelectorAll('.bt-frozen-row');
    ;
    event.isFrozen = true;

    for (i = 0, len = rows.length; i < len; i++) {
      if (rows.item(i) === event.currentTarget) {
        event.rowIndex = i;
        break;
      }
    }

    for (i = 0, len = _rowClickCallback.length; i < len; i++) {
      _rowClickCallback[i](event);
    }
  }

  /**
   * Render a header cell
   * @param headerCell
   * @param colOffset
   */
  function renderCell(headerCell, colObj,scope,compile) {

    headerCell.html(colObj.label);

    /* IE issue with the cache */
    /*if(typeof this._headerCellCache === 'undefined'){
      this._headerCellCache = [];
    }

    if(this._headerCellCache[headerCell.col]){
      console.log('doing cache', this._headerCellCache[headerCell.col]);
      headerCell.html(this._headerCellCache[headerCell.col][0]);
    }else{
      var cellDOM = angular.element(['<div>',colObj.label,'</div>'].join(''));
      compile(cellDOM)(scope);
      this._headerCellCache[headerCell.col] = cellDOM;
      headerCell.html(cellDOM[0]);
    }*/
  }

  /**
   * Remove a frozen row
   */
  function removeFrozenRow(index) {
    var index = index ? index : 0;
    // Remove only when there is at least one frozen row
    var rows = h.dom.querySelectorAll('.bt-frozen-row'),
        rowToRemove = rows[index];
    if (rowToRemove) {
      h.frozenRows.splice(index,1);
      rowToRemove.parentElement.removeChild(rowToRemove);
      rowToRemove.removeEventListener('click', _onRowClick);
      // According to BentoTableRow API
      // destroy() will relinke the top and bottom cells
      rowToRemove.row.destroy();

      for(var i=index,len= h.frozenRows.length; i<len; i++){
        h.frozenRows[i].row = i;
      }
    }
  }

  /**
   * Add a frozen row
   */
  function addFrozenRow() {
    var numCol = h.row.dom.childElementCount;
    var newRow = new BentoTableRow(numCol, width, height, null, null, this.options);
    newRow.addClass('bt-frozen-row');
    newRow.dom.addEventListener('click', _onRowClick);

    // Add row DOM
    h.dom.appendChild(newRow.dom);

    newRow.row = h.frozenRows.length;
    h.frozenRows.push(newRow);

    // Link row
    var headerCells = h.row.dom.children;
    var rowCells = newRow.dom.children;
    for (var i = 0, len = headerCells.length, hCell, rCell; i < len; i++) {
      hCell = headerCells[i].cell;
      rCell = rowCells[i].cell;
      hCell.top.bottom = rCell;
      rCell.top = hCell.top;
      hCell.top = rCell;
      rCell.bottom = hCell;
    }
  }

  /**
   * Set number of columns for this header
   * @param num
   * @param clickCallback
   */
  function setNumColumns(num, clickCallback) {
    if (typeof h.row === 'undefined') {
      h.row = new BentoTableRow(num, width, height, clickHijack(clickCallback), true, this.options); // start with one cell
      h.dom.appendChild(h.row.dom);

      // Add touch down events
      var cells = h.row.dom.children,
          cellDom;
      for (var i = 0; i < cells.length; i++) {
        cellDom = cells[i];
        cellDom.addEventListener('touchstart', onCellMouseDown);
        cellDom.addEventListener('mousedown', onCellMouseDown);
        cellDom.cell.top = cellDom.cell;
        cellDom.cell.bottom = cellDom.cell;
      }
    }
    else {
      var dCount = num - h.row.getNumCells();
      var cell;
      if (dCount > 0) {
        for (var i = 0; i < dCount; i++) {
          cell = new BentoTableCell(h.row, true);
          cell.dom.addEventListener('touchstart', onCellMouseDown);
          cell.dom.addEventListener('mousedown', onCellMouseDown);
          cell.top = cell;
          cell.bottom = cell;
          h.row.push(cell, true, clickHijack(clickCallback));
        }
      } else if (dCount < 0){
        // need to remove header cells
        for (var i = dCount; i > 0; i--) {
          h.row.removeLastCell();
        }
      }
    }
  }

  /**
   * Hijack Header callbacks
   * @param callback
   * @returns {Function}
   */
  function clickHijack(callback) {
    if (callback) {
      return function (event) {
        // It was a resizing
        // no need to fire callback
        if (isResizing) {
          isResizing = false;
        } else {
          callback(event)
        }
      }
    }
  }

  function onColumnResize(callback) {
    if(_columnResizeCallbackStack.indexOf(callback) < 0){
      _columnResizeCallbackStack.push(callback);
    }
  }

  // Event Listeners
  var oldX, dX, localX, cellX;
  var cellBoundry, cellRightBound, resizingCol;

  function onCellMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    resizingCol = event.currentTarget; // Type: Cell.dom
    cellBoundry = resizingCol.getBoundingClientRect();
    cellRightBound = cellBoundry.left + cellBoundry.width;

    //Check if user click the most right 8px of this header cell
    if (event.pageX > cellRightBound - 8 && event.pageX <= cellRightBound && h.options.resize) {
      window.addEventListener('touchmove', onHeaderMouseMouse);
      window.addEventListener('mousemove', onHeaderMouseMouse);
      window.addEventListener('touchend', onHeaderMouseUp);
      window.addEventListener('mouseup', onHeaderMouseUp);
      oldX = event.pageX;
      dX = true;
    }
  }

  function onHeaderMouseMouse(event) {
    cellX = event.pageX - cellBoundry.left;
    // not allowing the cell to be 50px or less wide
    if (cellX < 50) {
      return;
    }

    dX = event.pageX - oldX;
    oldX = event.pageX;
    //show bar
    if (resizeBar.style.display === 'none') {
      resizeBar.style.display = 'block';
      h.dom.setAttribute('data-resizing', '1');
    }

    localX = resizingCol.offsetLeft + cellX;
    resizeBar.style.left = localX;

    event.preventDefault();
    event.stopPropagation();
  }

  function onHeaderMouseUp(event) {
    event.preventDefault();
    event.stopPropagation();

    // Fire resize callback
    if (typeof dX === 'number') {
      var width = resizeBar.offsetLeft - resizingCol.offsetLeft;

      resizingCol.style.width = width + 'px';

      _columnResizeCallbackStack.forEach(function (callback) {
        event.col = resizingCol.cell.col;
        event.width = width;
        callback(event);
      });
      isResizing = true;

      // Reset resizing flag in a moment
      setTimeout(function () {
        isResizing = false
      }, 100);
    }

    resizeBar.style.display = 'none';
    h.dom.removeAttribute('data-resizing');
    // Remove all listeners excpet mousedown & touchstart
    window.removeEventListener('touchmove', onHeaderMouseMouse);
    window.removeEventListener('mousemove', onHeaderMouseMouse);
    window.removeEventListener('touchend', onHeaderMouseUp);
    window.removeEventListener('mouseup', onHeaderMouseUp);
  }

  // initilization
  function init() {
    h.dom = document.createElement('DIV');
    h.dom.className = 'bento-table-header';

    if (h.options.resize) {
      resizeBar = document.createElement('DIV');
      resizeBar.className = 'bt-header-resize-bar';
      resizeBar.style.display = 'none';
      h.dom.appendChild(resizeBar);
      h.dom.className += ' bt-header-is-resizable';
    }
  }

}
(function() {
  var bentoTableApp = angular.module("bento.table", []);

  bentoTableApp
    .controller("bentoTableController", [
      "$scope",
      "$element",
      "$log",
      function($scope, $element, $log) {
      }
    ])
    .directive("bentoTable", [
      "$compile",
      "$log",
      "$timeout",
      '$q',
      function($compile, $log, $timeout, $q) {
        return {
          restrict: "A",
          scope: false,
          replace: true, //
          template: [
            '<div class="bento-table">',
            ' <div class="bento-table-body">',
            " </div>",
            "</div>"
          ].join("\n"),
          controller: "bentoTableController",
          link: function(scope, element, attrs, ctrl) {
            // Init
            var data = { data: [] },
              body,
              table,
              tableHelper,
              tableRowSelectHelper,
              getSourceData,
              options,
              initialLoad = true,
              state = {},
              colOffset = 0,
              loadingDefer,
              isReload = false,
              windowResizeTimeout = 0
              ;

            var localScope = scope.$new(false); // inherit from parent
            var control;

            localScope.freezeRow = freezeRow;
            localScope.unfreezeRow = unfreezeRow;

            if (typeof attrs.columnDefinitions === "undefined") {
              $log.error(
                'Bento Table: Parameter "column-definitions" is missing.'
              );
              return;
            }

            data.columns = scope.$eval(attrs.columnDefinitions);

            // Pulic controls
            if (typeof attrs.bentoTableControl !== "undefined") {
              control = scope.$eval(attrs.bentoTableControl);
              control.freezeRow = freezeRow;
              control.unfreezeRow = unfreezeRow;
              control.reloadTable = reloadTable;
              control.showRow = showRow;
            }

            // Check basic parameters
            if (typeof attrs.sourceDataCallback === "undefined") {
              $log.error(
                'Bento Table: Parameter of "source-data-callback" is missing.'
              );
              return;
            }

            getSourceData = scope.$eval(attrs.sourceDataCallback);

            if (typeof getSourceData !== "function") {
              $log.error(
                "Bento Table: Type of parameter variable `" +
                  attrs.sourceDataCallback +
                  "` is incorrect. It needs to be `function(){return promise}`"
              );
              return;
            }

            init();

            ctrl.$onDestroy = function(){
              // Remove Window resize listener
              window.removeEventListener('resize', onWindowResize);
            }

            window.addEventListener('resize', onWindowResize);

            function onWindowResize(event){
              clearTimeout(windowResizeTimeout);

              windowResizeTimeout = setTimeout(function(){
                // Debounce 
                requestAnimationFrame(function(){
                  table.render(false, true);
                });
              },100);
            }

            // Get first set of data
            getSourceData(
              state.currentPage,
              state.recordsPerPage,
              state.sortKey,
              state.sortDirection
            ).then(getDataSuccess, getDataFail);

            // Reload table
            function reloadTable(softReload) {
              data.data = [];
              isReload = !softReload;
              loadingDefer = $q.defer();
              getSourceData(
                state.currentPage,
                state.recordsPerPage,
                state.sortKey,
                state.sortDirection
              ).then(getDataSuccess, getDataFail);

              return loadingDefer.promise;
            }

            // Freeze a row
            function freezeRow(row) {
              tableHelper.freezeRow(row);
            }

            // Unfreeze a row
            function unfreezeRow(row) {
              tableHelper.unfreezeRow(row);
            }

            // Show a row
            function showRow(rowIndex, $q){
              return table.scrollToRowIndex(rowIndex, $q);
            }

            function getDataSuccess(newData) {
              // Data is not ready
              //              if (typeof newData === 'undefined' || newData.length === 0) {
              //                $log.error('Bento Table: Provided source data is either undefined or empty.');
              //                return;
              //              }

              if (isReload) {
                tableHelper.reset();
                table.reset();
                if (tableRowSelectHelper) {
                  tableRowSelectHelper.clear();
                }
              }

              data.data = tableHelper.concatData(data.data, newData);

              if (table.ready) {
                prepareData();
              }

              // fire dataready callback
              if (!!attrs.sourceDataReadyCallback) {
                var cb = scope.$eval(attrs.sourceDataReadyCallback);
                if (cb) {
                  cb();
                }
              }

              isReload = false;
            }

            function prepareData() {
              var numCols;

              numCols = tableHelper.getNumCols();

              table.setGridSize(tableHelper.getNumRows(), numCols, data.data);

              // Fire selected row getter
              if (tableRowSelectHelper) {
                if (attrs.getSelectedRows) {
                  var getSelectedRows = scope.$eval(attrs.getSelectedRows);
                  getSelectedRows().then(function(selectedRowsObj) {
                    tableRowSelectHelper.preSelectRows(
                      table,
                      tableHelper.getDataForRender(),
                      selectedRowsObj.data,
                      selectedRowsObj.key
                    );

                    table.render(!isReload);
                    // fire selection callback
                    fireRowSelectCallback();
                  });
                }
              }

              if (
                !options.infiniteScroll &&
                state.sortKey &&
                state.sortDirection
              ) {
                tableHelper.sort(
                  state.sortKey,
                  state.sortDirection === "desc",
                  options.infiniteScroll
                );
                table.calcGridRowSizeArray(0);
              }

              table.render(!isReload, true);

              if (initialLoad) {
                // This includes table.render();
                tableHelper.applyTableOptions();
                initialLoad = null;
              }

              if(loadingDefer){
                loadingDefer.resolve();
                loadingDefer = null;
              }
            }

            function getDataFail(message) {
              $log.warn(message);
            }

            /*Header*/

            var _col = 0;
            var colSort = [];
            var colObj;
            table.requestHeaderContent(function(headerCell) {
              if (tableRowSelectHelper && headerCell.col === 0) {
                tableRowSelectHelper.renderCell(headerCell);
              } else {
                renderHeader(headerCell);
              }
            });

            function renderHeader(headerCell) {
              _col = headerCell.col;
              colObj = tableHelper.getColumnByIndex(_col);

              if (colObj) {
                table.renderHeaderCell(
                  headerCell,
                  colObj,
                  localScope,
                  $compile
                );
                if (colSort[_col] === 1) {
                  headerCell.dom.setAttribute("data-sort", "bt-sort-asc");
                } else if (colSort[_col] === 2) {
                  headerCell.dom.setAttribute("data-sort", "bt-sort-desc");
                } else {
                  headerCell.dom.removeAttribute("data-sort");
                }
              } else {
                headerCell.dom.removeAttribute("data-sort");
                headerCell.dom.innerHTML = "";
              }
            }

            //header click and sorting
            table.onHeaderClick(function(event) {
              var cell = event.cell, // type: BentoCell in Header
                col = cell.col,
                column,
                desc = false;
              // Bypass
              if (tableRowSelectHelper && col === 0) {
                var row = cell.parent,
                  selectedClass = "bt-row-selected";
                row.toggleClass(selectedClass);

                if (row.hasClass(selectedClass)) {
                  tableRowSelectHelper.addRows(tableHelper.getDataForRender());
                } else {
                  tableRowSelectHelper.deselectAllRows(
                    tableHelper.getDataForRender()
                  );
                }

                table.render();

                fireRowSelectCallback();

                return;
              }

              column = tableHelper.getColumnByIndex(col);

              // Check and sort the current clicked column
              if (column.sort || typeof column.sort === "undefined") {
                // Other normal sorting
                if (cell.dom.getAttribute("data-sort") === "bt-sort-asc") {
                  removeSortingClass(cell);
                  cell.dom.setAttribute("data-sort", "bt-sort-desc");
                  tableHelper.sort(column.name, true, options.infiniteScroll);
                  colSort = [];
                  colSort[col] = 2; //Desc
                  state.sortKey = column.name;
                  state.sortDirection = "desc";
                  desc = true;
                } else {
                  removeSortingClass(cell);
                  cell.dom.setAttribute("data-sort", "bt-sort-asc");
                  tableHelper.sort(column.name, false, options.infiniteScroll);
                  colSort = [];
                  colSort[col] = 1; //Asc
                  state.sortKey = column.name;
                  state.sortDirection = "asc";
                }

                if (options.infiniteScroll) {
                  // Need to request a new set of data
                  data.data = [];
                  state.currentPage = 0;
                  getSourceData(
                    state.currentPage,
                    state.recordsPerPage,
                    state.sortKey,
                    state.sortDirection
                  ).then(function(data) {
                    //Find and remove record(s) that is(are) frozen
                    data = tableHelper.removeFrozenRecords(data, col, desc);
                    getDataSuccess(data);
                  }, getDataFail);
                } else {
                  // Render table (Deep Render Mode)
                  table.render(true);
                  scope.$apply();
                }
              }
            });

            // clean sorting class names
            function removeSortingClass(cell) {
              var fCell = cell;
              do {
                cell.dom.setAttribute("data-sort", "");
                cell = cell.right;
              } while (cell !== fCell);
            }

            /*
             Frozen Cell
             */
            table.requestFrozenCellContent(function(cell) {
              if (tableRowSelectHelper && cell.col === 0) {
                var row = tableHelper.getRowByIndex(cell.row, true);
                tableRowSelectHelper.renderCell(cell);
                if (row && row[tableRowSelectHelper._selectedLabel]) {
                  cell.parent.addClass("bt-row-selected", true);
                } else {
                  cell.parent.removeClass("bt-row-selected", true);
                }
              } else {
                tableHelper.renderFrozenCell(cell);
              }
            });

            /*
             Cell
             */

            table.requestCellContent(function(cell) {
              if (tableRowSelectHelper && cell.col === 0) {
                var row = tableHelper.getRowByIndex(cell.row);
                tableRowSelectHelper.renderCell(cell);

                if (row[tableRowSelectHelper._selectedLabel]) {
                  cell.parent.addClass("bt-row-selected", true);
                  cell.parent.removeClass("bt-row-indeterminate", true);
                } else if (row[tableRowSelectHelper._indeterminateLabel]) {
                  cell.parent.removeClass("bt-row-selected", true);
                  cell.parent.addClass("bt-row-indeterminate", true);
                } else {
                  cell.parent.removeClass("bt-row-selected", true);
                  cell.parent.removeClass("bt-row-indeterminate", true);
                }
              } else {
                tableHelper.renderCell(cell);
              }
            });

            var onRowClickCallback = scope.$eval(attrs.rowClick);

            // On row click
            function onRowClick(event) {
              var row = tableHelper.getRowByIndex(
                  event.rowIndex,
                  event.isFrozen
                ),
                isSelected;

              if (
                tableRowSelectHelper &&
                event.target.className === "bt-check-box"
              ) {
                if (!tableRowSelectHelper.isRowSelected(row)) {
                  tableRowSelectHelper.add(row, true);
                } else {
                  tableRowSelectHelper.remove(row, true);
                  table.header.dom
                    .querySelector(".bento-table-row")
                    .row.removeClass("bt-row-selected");
                }

                $timeout(function() {
                  table.render();
                });

                fireRowSelectCallback();
              }

              /**
               * Fire callback and return the original row object or BentoTableRow object
               */
              if (onRowClickCallback) {
                onRowClickCallback(row);
              }
            }

            // Fire select row callback
            function fireRowSelectCallback() {
              if (attrs.sourceDataSelectCallback) {
                scope.$eval(attrs.sourceDataSelectCallback)(
                  tableRowSelectHelper.getSelection()
                );
              }
            }

            function init() {
              body = element[0].querySelector(".bento-table-body");
              options = !!attrs.options
                ? scope.$eval(attrs.options)
                : { rowHeight: 30, colWidth: 150 };
              state.currentPage = 0;
              state.recordsPerPage = options.recordsPerPage || 50;

              options.scope = scope;

              table = new BentoTable(body, options);

              // initialize row selection
              if (options.rowSelect) {
                tableRowSelectHelper = new BentoTableRowSelectHelper(table);
                colOffset += tableRowSelectHelper.colOffset;
              }

              // Getting helper
              if (typeof tableHelper === "undefined") {
                if (options.group) {
                  // Grouping table helper
                  tableHelper = new BentoTableGroupingHelper(
                    data,
                    table,
                    options,
                    localScope,
                    $compile,
                    attrs
                  );
                } else {
                  // Default table helper
                  tableHelper = new BentoTableHelper(
                    data,
                    table,
                    options,
                    localScope,
                    $compile,
                    attrs
                  );
                }
                tableHelper.init(colOffset);
                tableHelper.onRowClick(onRowClick);
              }

              if (options.rowSelect) {
                tableRowSelectHelper.addHelper(tableHelper);
              }

              // infinite scroll initialization
              if (options.infiniteScroll) {
                var promise;
                table.onScrollAtBottom(function(event) {
                  if (!promise) {
                    var newPage = state.currentPage + 1;
                    promise = getSourceData(
                      newPage,
                      state.recordsPerPage,
                      state.sortKey,
                      state.sortDirection
                    );
                    promise.then(function(data) {
                      state.currentPage = newPage;
                      getDataSuccess(data);
                      promise = null;
                    }, getDataFail);
                  }
                });
              }

              // Make sure when the table is ready
              var tableInitWatch = scope.$watch(
                function() {
                  return { height: body.offsetHeight, width: body.offsetWidth };
                },
                function(size) {
                  if (size.height > 0 && size.width > 0) {
                    table.init();

                    if (data.data.length > 0) {
                      prepareData();
                    }
                    // release one time watch
                    tableInitWatch();
                  }
                },
                true // need to deepwatch this object
              );
            }
          }
        };
      }
    ]);
})();

function BentoTableRowSelectHelper(table, tableHelper) {
  var uid = Math.round(Math.random() * 100000000);
  this.colOffset = 1;
  this._selection = [];
  this._table = table;
  this._selectedLabel = '_btSelectedRow' + uid;
  this._indeterminateLabel = '_btSelectIndeterminate' + uid;
  this._tableHelper = tableHelper;
}

(function () {
  BentoTableRowSelectHelper.prototype.renderCell = renderCell;
  BentoTableRowSelectHelper.prototype.add = add;
  BentoTableRowSelectHelper.prototype.addHelper = addHelper;
  BentoTableRowSelectHelper.prototype.remove = remove;
  BentoTableRowSelectHelper.prototype.clear = clear;
  BentoTableRowSelectHelper.prototype.addRows = addRows;
  BentoTableRowSelectHelper.prototype.getSelection = getSelection;
  BentoTableRowSelectHelper.prototype.isRowSelected = isRowSelected;
  BentoTableRowSelectHelper.prototype.deselectAllRows = deselectAllRows;
  BentoTableRowSelectHelper.prototype.preSelectRows = preSelectRows;

  /**
   * Help to check if a row is selected or not
   * @param row
   * @returns {*}
   */
  function isRowSelected(row) {
    return row[this._selectedLabel];
  }

  /**
   * Add a table helper to reference it's functions
   * @param tableHelper
   */
  function addHelper(tableHelper) {
    this._tableHelper = tableHelper;
  }

  /**
   *
   * @param table (BentoTable) - BentoTable instance for rendering
   * @param dataArray (array) - Original Data array
   * @param selectedDataArray (array) - Selected rows in array
   * @param keyToCompare (object) - Unique key to compare the arrays
   */
  function preSelectRows(table, dataArray, selectedDataArray, keyToCompare) {

    if (
      typeof selectedDataArray === 'undefined' ||
      typeof keyToCompare === 'undefined' || !Array.isArray(selectedDataArray)
    ) {
      console.warn(
        'BentoTable: Getter `getSelectedRows` mis-formed.',
        '{key: (string)|(number), data: (array)}');
      return;
    }

    // Find and add selected row(s)
    var key, i, j, iLen, jLen, row;
    for (i = 0, iLen = selectedDataArray.length; i < iLen; i++) {
      key = selectedDataArray[i][keyToCompare];

      for (j = 0, jLen = dataArray.length; j < jLen; j++) {
        row = dataArray[j];
        if (row[keyToCompare] == key) {
          this.add(dataArray[j]);

          // Update table rendering flag for row selections
          table.rowSizes[j][2] = true;
          break;
        }
      }
    }
  }

  /**
   * Get a copy of the current selection
   * @returns {Array}
   */
  function getSelection() {
    var newArr = [];
    for (var i = 0, len = this._selection.length; i < len; i++) {
      newArr.push(this._selection[i]);
    }
    return newArr;
  }

  /**
   * Select all rows in the table
   */
  function addRows(rows) {
    var i, len;

    var row;
    for (i = 0, len = rows.length; i < len; i++) {
      row = rows[i];
      this.add(row);
    }
  }

  /**
   * Deselect all row
   */
  function deselectAllRows(rows) {
    var i, len;
    for (i = 0, len = rows.length; i < len; i++) {
      this.remove(rows[i]);
    }

    this._selection = [];
  }

  /**
   * Add row to selection
   * @param row
   */
  function add(row, checkParent) {
    row[this._selectedLabel] = true;
    if (row instanceof BentoTableGroupingRow) {
      for (var i = 0, len = row.members.length; i < len; i++) {
        this.add(row.members[i]);
      }
      __checkGroupSelectionStates(row, this);
    } else {
      if (this._selection.indexOf(row) === -1) {
        this._selection.push(row);
      }

      if (checkParent && this._tableHelper instanceof BentoTableGroupingHelper) {
        __checkGroupSelectionStates(
          this._tableHelper.getRowProperty(row, this._tableHelper.getParentVariableName())
          ,
          this);
      }
    }
  }

  /**
   * Check if a group is fully checked or not
   * @param btGroup
   * @private
   */
  function __checkGroupSelectionStates(btGroup, self) {

    var allSelected = true;
    var noneSelected = true;
    btGroup.members.forEach(function (item, i) {
      if (item[self._selectedLabel]) {
        noneSelected = false;
      } else {
        allSelected = false;
      }
    });

    if (allSelected) {
      btGroup[self._selectedLabel] = true;
      delete btGroup[self._indeterminateLabel];
    } else if (noneSelected) {

      delete btGroup[self._indeterminateLabel];
      delete btGroup[self._selectedLabel];
    } else {
      delete btGroup[self._selectedLabel];
      btGroup[self._indeterminateLabel] = true;
    }
  }

  /**
   * Remove a row from selection
   * @param row
   */
  function remove(row, checkParent) {
    var index = this._selection.indexOf(row);

    delete row[this._selectedLabel];

    if (row instanceof BentoTableGroupingRow) {
      for (var i = 0, len = row.members.length; i < len; i++) {
        this.remove(row.members[i]);
      }
      __checkGroupSelectionStates(row, this);
    } else {
      if (index > -1) {
        this._selection.splice(this._selection.indexOf(row), 1);
      }

      // Check group selection states
      if (checkParent && this._tableHelper instanceof BentoTableGroupingHelper) {
        __checkGroupSelectionStates(
          this._tableHelper.getRowProperty(row, this._tableHelper.getParentVariableName())
          , this);
      }
    }

  }

  /**
   * Remove all selection
   * @returns {Array}
   */
  function clear() {
    for (i = 0, len = this._selection.length; i < len; i++) {
      delete this._selection[i][this._selectedLabel];
    }
    return this._selection = [];
  }

  /**
   * Render selection cell
   * @param cell
   */
  function renderCell(cell) {
    cell.html('<div class="bt-check-box"></div>');
  }

})();
var BentoTableRow;

(function() {
  BentoTableRow = Row;
  Row.prototype.push = push;
  Row.prototype.unshift = unshift;
  Row.prototype.getFirstCell = getFirstCell;
  Row.prototype.getLastCell = getLastCell;
  Row.prototype.getNthCell = getNthCell;
  Row.prototype.getNumCells = getNumCells;
  Row.prototype.destroy = destroy;
  Row.prototype.setRow = setRowIndex;
  Row.prototype.remove = remove;
  Row.prototype.removeLastCell = removeLastCell;
  Row.prototype.addClass = addClass;
  Row.prototype.hasClass = hasClass;
  Row.prototype.removeClass = removeClass;
  Row.prototype.applyClasses = applyClasses;
  Row.prototype.clearClasses = clearClasses;
  Row.prototype.toggleClass = toggleClass;
  Row.prototype.setLinkages = setLinkages;
  Row.prototype.clear = clear;

  Object.defineProperty(Row.prototype, "isFrozen", { get: isFrozen });

  // Private
  Row.prototype._init = init;

  /**
   * Constructer
   * @param initNumColumns
   * @param width
   * @param height
   * @param cellClickCallback
   * @param isHeader
   * @constructor
   */
  function Row(initNumColumns, width, height, cellClickCallback, isHeader, tableOptions) {
    var row = this;
    this._dom = document.createElement("DIV");
    this._dom.row = this;
    // Private
    this._classes = [""];
    this._changed = false;
    this.initNumColumns = initNumColumns;
    this.width = width;
    this.height = height;
    this.cellClickCallback = cellClickCallback;
    this.isHeader = isHeader;
    this.tableOptions = tableOptions;

    Object.defineProperty(this,'dom',{
      set: function(v){
        console.log('trying to set', v);
      },
      get: function(){
        return row._dom;
      }
    });

    this._init();
  }

  function clear() {
    this._classes = [];
    this.addClass("bento-table-row");
    var children = this._dom.children;
    for (var i = 0, len = children.length; i < len; i++) {
      children[i].innerHTML = "";
    }
  }

  /**
   * Remove row from the parent element
   */
  function remove() {
    if (this._dom.parentElement) {
      this._dom.parentElement.removeChild(this._dom);
    }
  }

  /**
   * Check if this row is frozen or not
   * @returns {*}
   */
  function isFrozen() {
    return this.hasClass("bt-frozen-row");
  }

  /**
   * Toggles a class name on and off
   * @param className
   * @returns {boolean} to tell either the class is applied or not
   */
  function toggleClass(className) {
    if (this.hasClass(className)) {
      this.removeClass(className);
      return false;
    } else {
      this.addClass(className);
      return true;
    }
  }

  /**
   * Add a CSS Class to this row
   * @param className
   * @param doNotApply - do not apply the new class to the actual element
   */
  function addClass(className, doNotApply) {
    if (this._classes.indexOf(className) < 0) {
      this._classes.push(className);
      if (doNotApply) {
        this._changed = true;
        return;
      }
      this._dom.className = this._classes.join(" ");
    }
  }

  /**
   * Check if this row has a given class
   * @param className
   * @returns {boolean}
   */
  function hasClass(className) {
    return this._classes.indexOf(className) > -1;
  }

  /**
   * Remove a CSS class from this row
   * @param className
   * @param doNotApply - do not apply the new class to the actual element
   */
  function removeClass(className, doNotApply) {
    var index = this._classes.indexOf(className);
    if (index > -1) {
      this._classes.splice(index, 1);
      if (doNotApply) {
        this._changed = true;
        return;
      }
      this._dom.className = this._classes.join(" ");
    }
  }

  /**
   * Clear all CSS classes
   * @param doNotApply - do not apply the new class to the actual element
   */
  function clearClasses(doNotApply) {
    this._classes = [this._classes[0]];

    if (doNotApply) {
      this._changed = true;
      return;
    }
    this._dom.className = this._classes[0];
  }

  /**
   * Apply all CSS classes to the element at once
   */
  function applyClasses() {
    if (this._changed) {
      this._changed = false;
      this._dom.className = this._classes.join(" ");
    }
  }

  /**
   * Push a cell to this row and link it
   * @param cell
   * @param isNew
   * @param callback
   */
  function push(cell, isNew, callback) {
    this.setLinkages(cell, isNew);
    this._dom.appendChild(cell.dom);

    if (callback) {
      cell.dom.addEventListener("click", callback);
    }
  }

  /**
   * Set row index
   * @param index
   */
  function setRowIndex(index) {
    this.row = index;
  }

  /**
   * Unshift a cell to this row
   * @param cell
   * @param isNew
   */
  function unshift(cell, isNew) {
    this.setLinkages(cell, isNew);
    this._dom.insertBefore(cell.dom, this._dom.firstChild);
  }

  /**
   * Gets the first DOM cell from the current row
   * @returns {BentoTableCell}
   */
  function getFirstCell() {
    return this._dom.firstElementChild.cell;
  }

  /**
   * Gets the last DOM cell from the current row
   * @returns (BentoTableCell)
   */
  function getLastCell() {
    return this._dom.lastElementChild.cell;
  }

  /**
   * Get's the (n)th cell from the current row
   * @param index
   * @returns {BentoTableCell}
   */
  function getNthCell(index) {
    return this._dom.children[index].cell;
  }

  /**
   * Get the total number of cells in this row
   * @returns {Number}
   */
  function getNumCells() {
    return this._dom.childElementCount;
  }

  /**
   * Destroy this row
   */
  function destroy() {
    var child;
    // delete children
    while (this._dom.childElementCount > 0) {
      child = this._dom.firstElementChild.cell;

      if (child.top) {
        child.top.setBottom(child.bottom);
      }

      if (child.bottom) {
        child.bottom.setTop(child.top);
      }
      this._dom.removeChild(child.dom);
      child.destroy();
    }
    child = null;
    this.remove();
    delete this._dom;
  }

  function removeLastCell() {
    var cell = this.getLastCell();
    cell.removeEventListener(this.cellClickCallback);
    if (cell.left) {
      cell.left.setRight(cell.right);
    }

    if (cell.right) {
      cell.right.setLeft(cell.left);
    }

    this._dom.removeChild(cell.dom);
    cell.destroy();
  }

  function init() {
    var cell, i, len;

    for (i = 0; i < this.initNumColumns; i++) {
      cell = new BentoTableCell(this, this.isHeader);
      if (!this.tableOptions.doNotAssignDimensions && this.width) {
        cell.dom.style.width = this.width + "px";
      }
      this.push(cell, true, this.cellClickCallback);
    }

    var children = this._dom.children;
    for (i = 0, len = children.length; i < len; i++) {
      cell = children[i].cell;
    }

    if (this.height && (!this.tableOptions || (!this.tableOptions.doNotAssignDimensions))) {
      this._dom.style.height = this.height + "px";
    }

    this._classes.pop();
    this.addClass("bento-table-row");
  }

  /**
   * Set linkages to all cells with a new cell
   * @param cell - Cell object
   * @param isNew - Tell is cell is a new object
   */
  function setLinkages(cell, isNew) {
    if (isNew) {
      if (this._dom.childElementCount > 0 && isNew) {
        var fCell = this.getFirstCell();
        var lCell = this.getLastCell();

        fCell.setLeft(cell);
        lCell.setRight(cell);
        cell.setLeft(lCell);
        cell.setRight(fCell);
      } else {
        // This is the only cell in a row
        // linking to itself
        cell.setLeft(cell);
        cell.setRight(cell);
      }
    }
  }
})();

function BentoTableSort(table) {
  var bh = this;
  var btRowArray;
  bh.sort = heapSort;
  bh.findIndex = findIndex;

  /**
   * Find the index of an object within a sorted array
   * @param arr
   * @param isBetween - (bool)
   * @param outOfBound - number of index when found otherwise false
   * @returns {*}
   */
  function findIndex(arr, isBetween, outOfBound, outOfBoundAsNotFound) {
    var left = 0,
        right = arr.length - 1,
        middle = Math.floor((left + right) * 0.5),
        bound = outOfBound(arr[left], arr[right]);
      ;

    if (outOfBoundAsNotFound && bound) {
      return -1;
    } else if (bound === -1 || bound === 1) {
      return bound > 0 ? arr.length : 0;
    }

    while (left !== middle) {
      if (isBetween(arr[left], arr[middle])) {
        right = middle;
      } else {
        left = middle;
      }
      middle = Math.floor((left + right) * 0.5);
    }
    return left + 1;
  }

  /**
   * Sort an array based a column (index : col)
   * @param arr
   * @param col
   *
   * Using BlockSort
   * http://en.wikipedia.org/wiki/Block_sort
   */

  /**
   * Finds the correct place of given element in given max heap.
   *
   * @private
   * @param {Array} array Array.
   * @param {Number} index Index of the element which palce in
   * the max heap should be found.
   * @param {Number} heapSize Size of the heap.
   * @param {function} cmp Comparison function.
   */
  function heapify(array, btRowArray, index, heapSize, cmp) {
    var left = 2 * index + 1;
    var right = 2 * index + 2;
    var largest = index;
    if (left < heapSize && cmp(array[left], array[index]) > 0) {
      largest = left;
    }
    if (right < heapSize && cmp(array[right], array[largest]) > 0) {
      largest = right;
    }
    if (largest !== index) {
      var temp = array[index];
      var temp2 = btRowArray[index];
      array[index] = array[largest];
      btRowArray[index] = btRowArray[largest];
      array[largest] = temp;
      btRowArray[largest] = temp2;
      heapify(array, btRowArray, largest, heapSize, cmp);
    }
  }

  /**
   * Builds max heap from given array.
   *
   * @private
   * @param {Array} array Array which should be turned into max heap.
   * @param {function} cmp Comparison function.
   * @return {Array} array Array turned into max heap.
   */
  function buildMaxHeap(array, btRowArray, cmp) {
    for (var i = Math.floor(array.length / 2); i >= 0; i -= 1) {
      heapify(array, btRowArray, i, array.length, cmp);
    }
    return array;
  }

  /**
   * Heapsort. Turns the input array into max
   * heap and after that sorts it.<br><br>
   * Time complexity: O(N log N).
   *
   * @example
   *
   * var sort = require('path-to-algorithms/src' +
   * '/sorting/heapsort').heapSort;
   * console.log(sort([2, 5, 1, 0, 4])); // [ 0, 1, 2, 4, 5 ]
   *
   * @public
   * @module sorting/heapsort
   * @param {Array} array Input array.
   * @param {Function} cmp Optional. A function that defines an
   * alternative sort order. The function should return a negative,
   * zero, or positive value, depending on the arguments.
   * @return {Object} Sorted array.
   */
  function heapSort(array, rowArray, cmp) {
    cmp = cmp || comparator;
    var size = array.length;
    var temp, temp2;
    btRowArray = rowArray? rowArray:[];

    buildMaxHeap(array, btRowArray, cmp);
    for (var i = array.length - 1; i > 0; i -= 1) {
      temp = array[0];
      temp2 = btRowArray[0];
      array[0] = array[i];
      btRowArray[0] = btRowArray[i];
      array[i] = temp;
      btRowArray[i] = temp2;
      size -= 1;
      heapify(array, btRowArray, 0, size, cmp);
    }

    return {rows: array, rowSizes: btRowArray};
  }

  function comparator(a, b) {
    return a - b;
  }

}
var BentoTable;

(function(){

  BentoTable = _BentoTable;
  _BentoTable.prototype = Object.create(BentoTableCore.prototype);
  _BentoTable.prototype.constructor = _BentoTable;

  function _BentoTable(dom, options){
    BentoTableCore.apply(this,arguments);
  }
})();



var BentoTableDefaultColumn;

(function(){

  'user strict';
  BentoTableDefaultColumn = _BentoTableDefaultColumn;
  BentoTableDefaultColumn.prototype.applyContentToCell = applyContentToCell;
  BentoTableDefaultColumn.prototype.applyContentToCellWithType = applyContentToCellWithType;

  // Constructor
  function _BentoTableDefaultColumn(){
  }

  /**
   * Apply HTML content to a BentoCell object
   * @param content
   * @param cell
   */
  function applyContentToCell(content, cell){
    applyContentToCellWithType(content, cell, 'bt-cell-default');
  }

  /**
   * Apply HTML content to a BentoCell object with a unique type
   * @param content
   * @param cell
   * @param type
   */
  function applyContentToCellWithType(content, cell, type){
    if(type){
      cell.setType(type);
    }
    cell.html(content);
  }
})();

var BentoTableCellTemplateColumn;

(function() {
  BentoTableCellTemplateColumn = btCellTemplate;
  btCellTemplate.prototype = Object.create(BentoTableDefaultColumn.prototype);
  btCellTemplate.prototype.constructor = btCellTemplate;

  // Override
  btCellTemplate.prototype.applyContentToCell = applyContentToCell;
  btCellTemplate.prototype.setTemplate = setTemplate;

  /**
   * Constructor
   * @param scope
   * @param compile
   * @param dataName
   */
  function btCellTemplate(scope, compile, dataName) {
    BentoTableDefaultColumn.apply(this, arguments);
    this._scope = scope;
    this._compile = compile;
    this._dataName = dataName;
    this._template = null;
  }

  /**
   * Set Template of this column
   * @param tpl
   */
  function setTemplate(tpl) {
    if (typeof tpl === 'string') {
      this._template = tpl;
    } else {
      var tmp = document.createElement('div');
      tmp.appendChild(tpl);
      this._template = tmp.innerHTML;
      tmp = null;
    }
  }

  /**
   * Override on Apply content to Cell
   * @param content
   * @param cell
   * @param item
   */
  function applyContentToCell(content, cell, row) {
    if (cell.rowData === row) {
      // We are trying to re-render this cell
      // therefore skip
      return;
    }

    var cellData = cell.getData();
    var data = cellData || {
      // Inherit from the parent scope
      scope: this._scope.$new()
    };

    data.scope.$row = row;
    data.scope.$item = content;
    data.scope.$index = cell.row;

    if (!cellData) {
      // First time cell render
      data.element = this._compile(this._template)(data.scope);
      // Keep reference
      cell.setData(data);

      // Content has to be true or false
      this.applyContentToCellWithType(
        data.element[0],
        cell,
        'bt-cell-template'
      );
    }
    cell.rowData = row;
  }
})();

var BentoTableCheckBoxColumn;

(function(){
  BentoTableCheckBoxColumn = _BTCheckBoxColumn;
  BentoTableCheckBoxColumn.prototype = Object.create(BentoTableDefaultColumn.prototype);
  BentoTableCheckBoxColumn.prototype.constructor = BentoTableCheckBoxColumn;
  // Methods
  BentoTableCheckBoxColumn.prototype.applyContentToCell = applyContentToCell;

  function _BTCheckBoxColumn(){
    BentoTableDefaultColumn.apply(this, arguments);

    var col = this;
    // Override
    col.applyContentToCell = applyContentToCell;
  }

  function applyContentToCell(content, cell){
    // Content has to be true or false
    this.applyContentToCellWithType(content,cell,'bt-checkbox-cell');
  }

})();
function BentoTableNumberColumn(){
  BentoTableNumberColumn.prototype = new BentoTableDefaultColumn();
  BentoTableDefaultColumn.apply(this, arguments);

  var col = this;
  // Override
  col.applyContentToCell = applyContentToCell;

  function applyContentToCell(content, cell){
    col.applyContentToCellWithType(content,cell,'bt-number-cell');
  }

}
(function (angular, window, undefined) {
  "use strict";

  angular.module('bento.uib.datepicker.addon', [])
    /**
     * uib-datepicker-popup-wrap Addon
     */
    .directive('uibDatepickerPopupWrap',
      [
        '$timeout',
        function ($timeout) {
          return {
            scope: false,
            priority: -1,
            link: function(scope,element){
              var timeoutPromise,
                  $previousSibling = angular.element(element[0].previousSibling),
                  $body = angular.element(document.body);

              // Detection and placement
              detectViewport();

              // Add/Remove window listener
              window.addEventListener('resize',onWindowResize);
              scope.$on('$destroy',function(){
                $timeout.cancel(timeoutPromise);
                window.removeEventListener('resize',onWindowResize);
              });

              function onWindowResize(){
                $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(detectViewport,100);
              }

              function detectViewport(){
                var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                if(vw < 601){
                  $body.prepend(element);
                  element.addClass('uib-datepicker-fixed');
                }else{
                  $previousSibling.after(element);
                  element.removeClass('uib-datepicker-fixed');
                }
              }
            }
          }
        }
      ]);

})(angular, window);
(function(angular, undefined) {
    'use strict';

    angular
        .module('bento.universeFilter', [
            'bento.services',
            'ngSanitize'
        ])
        .directive('bentoUniverseFilterDropdown', bentoUniverseFilterDropdown)
        .directive('bentoUniverseFilterEllipsis', bentoUniverseFilterEllipsis)
        .controller('bentoUniverseFilterDropdownController', bentoUniverseFilterDropdownController);

    bentoUniverseFilterDropdown.$inject = ['$timeout', '$compile', '$window'];

    function bentoUniverseFilterDropdown($timeout, $compile, $window) {
        return {
            restrict: 'EA',
            require: ['ngModel', 'bentoUniverseFilterDropdown'],
            scope: {
                onBackBtnClick: '&?',
                backBtnDisabled: '=?',
                onFilterItemChanged: '&?',
                selectText: '=?'
            },
            controller: 'bentoUniverseFilterDropdownController',
            controllerAs: 'bentoUniverseFilterCtrl',
            templateUrl: function(element, attrs) {
                return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/universe_filter/bento-universe-filter-dropdown.html';
            },
            compile: function(tElem, tAttrs) {
                return {
                    post: postLink,
                }

                function postLink(scope, element, attrs, ctrl) {
                    // Get Model Controller
                    var ngModelCtrl = ctrl[0];
                    // Get Filter Controller
                    var filterCtrl = ctrl[1];
                    // Keep track of selected items
                    var selectedItems = [];

                    //watch ngModelCtrl
                    scope.$watch(function() {
                        return ngModelCtrl.$modelValue;
                    }, onModelChange, true);

                    // watch back button disabled toggle
                    scope.$watch('backBtnDisabled', onBackBtnDisabled);
                    // back button click handler
                    filterCtrl.onBackButtonClick = function($event) {
                        scope.onBackBtnClick();
                    }
                    // keep track in template if there is back button
                    if (attrs.onBackBtnClick) {
                        filterCtrl.hasBackBtn = true;
                    }
                    // back button is disabled handler
                    function onBackBtnDisabled(newValue) {
                        filterCtrl.backButtonDisabled = newValue;
                    }

                    //model changed
                    function onModelChange(newValue, oldValue) {
                        if (newValue) {
                            if(newValue !== oldValue){
                                var selectedItem = checkForSelectedItems(newValue);
                                if(selectedItem){
                                    scope.onFilterItemChanged({filterItems:newValue,selectedItem:selectedItem});
                                }
                            }
                            filterCtrl.filterItems = newValue;
                        }
                    }
                    /**
                     * Check to see which item is currently selected
                     */
                    function checkForSelectedItems(items){
                        var selectedItem;
                        for(var i=0,ttl=items.length;i<ttl;i++){
                            if(selectedItems[i]){
                                if(String(selectedItems[i]) !== String(items[i].selectedName)){
                                    selectedItem = items[i];
                                    selectedItems[i] = items[i].selectedName;
                                    break;
                                }
                                selectedItems[i] = items[i].selectedName;
                            } else if(items[i].selectedName){
                                selectedItem = items[i];
                                selectedItems[i] = items[i].selectedName;
                                break;
                            } else {
                                selectedItems[i] = items[i].selectedName;
                            }
                        }
                        return selectedItem;
                    }
                    //Window resize
                    angular.element($window).bind('resize', onWindowResize);
                    scope.$watch(getElementWidth, onWindowResize);

                    function getElementWidth() {
                        return element[0].offsetWidth;
                    }

                    function onWindowResize() {
                        $timeout(function() {
                            // Close any dropdown on resize
                            if(filterCtrl.isOpen && filterCtrl.isOpen.length){
                                for(var i = 0,ttl = filterCtrl.isOpen.length;i<ttl;i++){
                                    filterCtrl.isOpen[i] = false;
                                }
                            }
                            // check for ellipsis
                            filterCtrl.checkTextOverflow();
                        });
                    }

                    //Destroy
                    scope.$on('$destroy', onDestroy);
                    element.on('$destroy', onDestroy);

                    function onDestroy() {
                        angular.element($window).unbind('resize', onWindowResize);
                    }
                }
            }
        };
    }

    bentoUniverseFilterDropdownController.$inject = ['$scope', '$element', '$attrs','$uibModal', '$timeout', '$bentoServices'];

    function bentoUniverseFilterDropdownController($scope, $element, $attrs, $uibModal, $timeout, $bentoServices) {
        var vm = this;
        vm.alignPosition = '';
        vm.isOpen = [];
        var adjustTimer;
        var openIndex = -1;

        vm.selectText = $scope.selectText || 'Select';
        // get dropdown append to element
        vm.appendToElement = angular.element($element[0].querySelector('.bento-uni-filter'));
        // add class to template if last dropdown is open
        vm.isLastOpen = function(entry) {
            var classAlign = vm.isRTL ? 'align-left' : 'align-right';
            if(vm.isOpen && vm.isOpen.length){
                var lastIndex = vm.isOpen.length - 1;
                return vm.isOpen[lastIndex] ? classAlign:'';
            }
        }
        vm.checkTextOverflow = checkTextOverflow;
        function checkTextOverflow() {
            $scope.$broadcast('bentoUniverFilterCheckEllipsis');
        }

        // $scope.$on('$includeContentLoaded', function() {
        //     // if(adjustTimer){
        //     //     $timeout.cancel(adjustTimer);
        //     // }
        //     // adjustTimer = $timeout(function(){
        //     //     adjustDropdownMenu();
        //     // });
        // });

        $scope.$watchCollection('bentoUniverseFilterCtrl.isOpen',isDropdownOpen);
        $scope.$on('bentoUniverseFilterRefresh', function(){
            adjustDropdownMenu();
        });
        $scope.$watch(function () {
            return $bentoServices.isRTL();
        }, function (nv) {
          if(nv !== null || nv !== undefined) {
            vm.isRTL = nv;
          }
        });
        
        function isDropdownOpen(isOpen){

            openIndex = -1;
            isOpen.forEach(function(item,$index){
                if(item === true){
                    if(adjustTimer){
                        $timeout.cancel(adjustTimer);
                    }
                    openIndex = $index;
                    adjustTimer = $timeout(function(){
                        adjustDropdownMenu();
                    });
                }
            })
        }
        // adjust position of dropdown menu
        function adjustDropdownMenu(){
            vm.alignPosition = '';
            // grab all dropdown elements that are open, usually the previous one closing and the new
            // one opening
            var dropdownElementArr = $element[0].querySelectorAll('.bento-uni-filter_dropdown-menu');
            // get the last item in the array, as that will be the one about to open
            var dropdownElement = dropdownElementArr[dropdownElementArr.length - 1];
            // display it first to be able to get dimensions
            var buttonElement = $element[0].querySelectorAll('.bento-uni-filter_item')[openIndex];
            if(!dropdownElement || !buttonElement){
                return;
            }
            dropdownElement.style.display = 'block';
            // get dimensions of dropdown
            var ddRect = dropdownElement.getBoundingClientRect();
            // get dimensions of filter
            var filtRect = $element[0].getBoundingClientRect();
            // get dimensions of button
            var buttonRect = buttonElement.getBoundingClientRect();
            // set min-width of dropdown element to width of button
            dropdownElement.style.minWidth = (Math.floor(buttonRect.width)+2)+'px';
            if(vm.isRTL) {
              dropdownElement.style.textAlign = 'right';
              // find the total client width and subtract element's width
              var widthToExclude = document.body.clientWidth - filtRect.width;

              var ddElementRight = parseInt(dropdownElement.style.right);

              // if dropdownElement.style.right is invalid, set it ddElementRight
              var computedRightVal = isNaN(ddElementRight) ? widthToExclude: ddElementRight;

              dropdownElement.style.right = ((computedRightVal - widthToExclude) - 2) + 'px';
            } else {
                dropdownElement.style.textAlign = 'left';
                dropdownElement.style.right = 'auto';
            }
            // check if dropdown width is wider than filter width,
            // if so then make full-width            
            if(ddRect.width > (filtRect.width-30)){
                vm.alignPosition = 'full';
            } 
            // check if right border of dropdown menu hits right border of filter
            // if right border overflows, then shift dropdown menu to the left
            else if((ddRect.width + buttonRect.left) - (filtRect.width + filtRect.left) >=0){
                // check if too wide
                vm.alignPosition = vm.isRTL ? 'left' : 'right';
            } 
        }

    }

    // directive to show tooltip only when there is ellipsis
    bentoUniverseFilterEllipsis.$inject = ['$sanitize'];

    function bentoUniverseFilterEllipsis($sanitize) {
        return {
            restrict: 'EA',
            scope: {
                bentoEllipsisText: '='
            },
            compile: function(tElem, tAttrs) {
                return {
                    post: postLink,
                }

                function postLink(scope, element) {
                    scope.$watch('bentoEllipsisText', checkEllipsis);
                    scope.$on('bentoUniverFilterCheckEllipsis', checkEllipsis);

                    function checkEllipsis() {
                        var txtElem = element[0];
                        var str = scope.bentoEllipsisText;
                        txtElem.innerHTML = $sanitize(str);
                        txtElem.style.pointerEvents = "";
                        if ((txtElem.offsetWidth) > txtElem.scrollWidth){
                            //disable tooltip if full display of label
                            txtElem.style.pointerEvents = "none";
                        }
                    }
                }
            }
        }
    }    
})(window.angular);
(function(angular, undefined) {
  'use strict';

  angular
    .module('bento.universeFilter')
    .directive('bentoUniverseFilterDropdownMenu', bentoUniverseFilterDropdownMenu)
    .controller('bentoUniverseFilterDropdownMenuController', bentoUniverseFilterDropdownMenuController);

  bentoUniverseFilterDropdownMenu.$inject = ['$timeout', '$compile', '$window', '$controller', '$parse'];

  function bentoUniverseFilterDropdownMenu($timeout, $compile, $window, $controller, $parse) {
    return {
      restrict: 'EA',
      scope: true,
      bindToController: {
        filterItem: '=',
        isOpen: '=?'
      },
      controller: 'bentoUniverseFilterDropdownMenuController',
      controllerAs: 'bentoUniFilterItemCtrl',
      link: linkFunc
    }
    function linkFunc(scope, element, attrs, ctrl) {
      var lastActiveElement;
      scope.$watch('bentoUniFilterItemCtrl.isOpen',function(isOpen){
        if(isOpen === true){
          lastActiveElement = document.activeElement;
          element[0].focus();
        }
      });
    }
  }
  bentoUniverseFilterDropdownMenuController.$inject = ['$scope', '$element', '$attrs', '$timeout'];
  function bentoUniverseFilterDropdownMenuController($scope, $element, $attrs, $timeout) {
    var vm = this;

    vm.selectItem = function(item){
      vm.filterItem.selectedName= item.name;
      vm.close();
    }
    vm.close = function(){
      vm.isOpen = false;
    }
  }
})(window.angular);
(function (angular, window, undefined) {
  'use strict';

  angular.module('bento.uib.timepicker.addon', [])
    .directive('uibTimepicker',['$bentoServices', function ($bentoServices) {
      return {
        require: 'uibTimepicker',
        link   : function (scope, element, attrs, ctrl) {
          var isRTL = $bentoServices.isRTL();
          var hourInput = element[0].querySelector('.hours input');
          var minuteInput = element[0].querySelector('.minutes input');
          var hasFocus = false;
          var KEYBOARD_LEFT = 37;
          var KEYBOARD_RIGHT = 39;
          var SELECTION_START_INDEX = 0;
          var SELECTION_END_INDEX = 2;
          var amPmButton;

          element[0].setAttribute('tabindex', '-1');
          element[0].classList.add('bento-timepicker');


          setTimeout(function () {
            // Second input and amPmInput are sometimes redered after two digest cycles
            var secondInput = element[0].querySelector('.seconds input');
            amPmButton = element[0].querySelector('.am-pm button');

            // Check if this component is RTL
            if(isRTL){
              // Swap hour, minute and seconds
              var trElArray = element[0].querySelectorAll('tr');
              for(var i=0, len=trElArray.length; i<len; i++){
                reorderColumnsForRtl(trElArray[i]);
              }

              // Flip selection indexes
              SELECTION_START_INDEX = 2;
              SELECTION_END_INDEX = 0;
            }




            // Add keyboard listeners to input fields and button
            hourInput.addEventListener('keydown', function (e) {
              var input = e.currentTarget;

              if(isRTL && e.keyCode === KEYBOARD_LEFT
                && input.selectionStart === SELECTION_START_INDEX
                && input.selectionEnd === SELECTION_START_INDEX){
                // Focus on meridian button in RTL mode
                amPmButton.focus();
              }else if (e.keyCode === KEYBOARD_RIGHT
                && input.selectionStart === SELECTION_END_INDEX
                && input.selectionEnd === SELECTION_END_INDEX) {
                focusAndSelect(minuteInput);
                e.preventDefault();
              }
            });

            minuteInput.addEventListener('keydown', function (e) {
              var input = e.currentTarget;

              if (e.keyCode === KEYBOARD_RIGHT
                && input.selectionStart === SELECTION_END_INDEX
                && input.selectionEnd === SELECTION_END_INDEX) {
                if (secondInput.offsetParent) {
                  focusAndSelect(secondInput);
                  e.preventDefault();
                }

              }

              if (e.keyCode === KEYBOARD_LEFT
                && input.selectionStart === SELECTION_START_INDEX
                && input.selectionEnd === SELECTION_START_INDEX) {
                focusAndSelect(hourInput);
                e.preventDefault();
              }
            });

            if (secondInput.offsetParent) {
              secondInput.addEventListener('keydown', function (e) {
                var input = e.currentTarget;
                if (e.keyCode === KEYBOARD_LEFT
                  && input.selectionStart === SELECTION_START_INDEX
                  && input.selectionEnd === SELECTION_START_INDEX) {
                  focusAndSelect(minuteInput);
                  e.preventDefault();
                } else if ( !isRTL && e.keyCode === KEYBOARD_RIGHT
                  && input.selectionStart === SELECTION_END_INDEX
                  && input.selectionEnd === SELECTION_END_INDEX
                  && amPmButton.offsetParent) {
                  amPmButton.focus();
                }
              });
            }
            if (amPmButton.offsetParent) {
              amPmButton.addEventListener('keydown', function (e) {
                if(isRTL && e.keyCode === KEYBOARD_RIGHT){
                  // Focus on hour in RTL
                  focusAndSelect(hourInput);
                }else if (!isRTL && e.keyCode === KEYBOARD_LEFT) {
                  if (secondInput.offsetParent) {
                    focusAndSelect(secondInput);
                  } else {
                    focusAndSelect(minuteInput);
                  }
                  e.preventDefault();
                } else if (e.keyCode === 38 || e.keyCode === 40) {
                  amPmButton.click();
                  e.preventDefault();
                }
              })
            }
          });

          // Add focus events
          element[0].addEventListener('focusin', function (e) {

            if (!attrs.disabled && !attrs.readonly) {
              if (!hasFocus) {
                hasFocus = true;
                element[0].classList.add('has-focus');
              }

              if (document.activeElement === element[0]) {
                if(isRTL && amPmButton){
                  amPmButton.focus()
                }else{
                  focusAndSelect(hourInput);
                }
              }
            }
          });

          element[0].addEventListener('focusout', function (e) {
            if (!element[0].contains(document.activeElement)) {
              hasFocus = false;
              element[0].classList.remove('has-focus');
            }
          });

        }
      }
    }]);

  /**
   * Reorder <TR> elements to work with RTL
   * From: 1 2 3 4 5 6
   * To:   5 4 3 2 1 6
   *
   * Where:
   * 1 - Hour
   * 2 - Minute Spacer
   * 3 - Minute
   * 4 - Second Spacer
   * 5 - Second
   * 6 - Meridian Toggle Button
   *
   * @param trEl
   */
  function reorderColumnsForRtl(trEl){
    var lastChild = trEl.lastElementChild;
    var firstChild = trEl.firstElementChild;
    for(var i=0; i<4; i++){
      trEl.insertBefore(firstChild,lastChild);
      lastChild = firstChild;
      firstChild = trEl.firstElementChild;
    }
  }

  function focusAndSelect(inputEl) {
    inputEl.focus();
    inputEl.setSelectionRange(0, 2);
  }

})(angular, window);

(function (angular, undefined) {
  'use strict';
  var bentoServices;
  var timeout;
  var parse;
  angular.module('bento.sticky.footer', []).directive('bentoStickyFooter', [
    '$bentoServices',
    '$timeout',
    '$parse',
    function ($bentoServices, $timeout, $parse) {
      bentoServices = $bentoServices;
      timeout = $timeout;
      parse = $parse;
      return {
        restrict: 'A',
        link: BentoStickyFooterLink,
      };
    },
  ]);

  function BentoStickyFooterLink(scope, element, attrs) {
    var el = element[0];
    var scrollParentEl;
    var scrollbarWidth = bentoServices.getScrollbarWidth();
    var lastScrolled = performance.now();
    var stickyEl = document.createElement('div');
    var viewSize;
    var placeholder;
    var isRTL = bentoServices.isRTL();
    var showOnRefVisibleEl = attrs.showOnElementVisible ? parse(attrs.showOnElementVisible)(scope) : null;
    var timeoutPromise;
    if (typeof showOnRefVisibleEl === 'string') {
      // If showOnRefVisibleEl is a specified CSS selector, we go find the Element
      showOnRefVisibleEl = document.querySelector(showOnRefVisibleEl);
    }
    // Initialize sticky footer DOM
    stickyEl.className = el.className; // copy class names over
    stickyEl.classList.add('bento-sticky-footer');
    stickyEl.addEventListener('keydown', onStickyFooterKeydown);
    document.addEventListener('scroll', onWindowScroll, true);
    window.addEventListener('resize', onWindowResize);
    // Do a check first
    timeoutPromise = timeout(
      function () {
        checkAllocation();
      },
      300 // wait for view to finish rendering
    );
    scope.$on('$destroy', function () {
      // Remove all window listeners to prevent memory leak
      document.removeEventListener('scroll', onWindowScroll, true);
      window.removeEventListener('resize', onWindowResize);
      // Cancel timeout ifsticky footer is destroyed within the first 300 ms
      timeout.cancel(timeoutPromise);

      if (stickyEl.parentElement) {
        // Remove sticky element from any HTMLElement if there is one
        stickyEl.parentElement.removeChild(stickyEl);
      }
      // May not need this
      stickyEl = null;
    });

    function onWindowResize() {
      bentoServices.rAF(function () {
        checkAllocation();
      });
    }

    function onWindowScroll(e) {
      bentoServices.rAF(function () {
        checkAllocation(e);
      });
    }

    function alignFooter() {
      if (stickyEl.parentElement) {
        // Make sure everything is aligned since the sticky footer is in the view
        var parentRect =
          scrollParentEl === document
            ? {
                left: 0,
                right: viewSize.width,
                top: 0,
                bottom: viewSize.height,
              }
            : scrollParentEl.getBoundingClientRect();
        var left, width;

        if (attrs.hasOwnProperty('fullWidth') && parse(attrs.fullWidth)(scope) === false) {
          // This sticky footer should match the orginal footer width
          // and we need to align it with the original localtion
          var placeholderRect = placeholder.getBoundingClientRect();
          left = placeholderRect.left - parentRect.left;
          width = placeholder.offsetWidth;
        } else {
          // Fullwidth of the scrollable parent and align with scrollbable parent
          left = (isRTL ? scrollbarWidth : 0) + scrollParentEl.offsetLeft;
          width = scrollParentEl.offsetWidth - scrollbarWidth;
        }

        stickyEl.style.width = width + 'px';
        stickyEl.style.left = left + 'px';

        if (stickyEl.classList.contains('fixed')) {
          // Not need to align vertically since this footer is fixed
          return;
        }
        var style = getComputedStyle(scrollParentEl);
        if (
          scrollParentEl.offsetWidth < scrollParentEl.scrollWidth &&
          (style.overflow === 'auto' ||
            style.overflow === 'scroll' ||
            style.overflowX === 'auto' ||
            style.overflowX === 'scroll')
        ) {
          // There is a horizontal scroll bar
          stickyEl.style.top =
            scrollParentEl.offsetTop - scrollbarWidth + parentRect.height - stickyEl.offsetHeight + 'px';
        } else {
          // There is only a vertical scroll bar
          stickyEl.style.top = scrollParentEl.offsetTop + parentRect.height - stickyEl.offsetHeight + 'px';
        }

        if (placeholder) {
          placeholder.style.height = stickyEl.offsetHeight + 'px';
        }
      }
    }
    /**
     * A method/callback to check whether sticky footer should be displayed
     * @param {ScrollEvent} e
     */
    function checkAllocation(e) {
      var timeScrolled = performance.now();
      var dTime = timeScrolled - lastScrolled;
      var refEl = placeholder || el;
      var elRect = refEl.getBoundingClientRect();
      var parentRect;
      var showOnRefElementRect = showOnRefVisibleEl ? showOnRefVisibleEl.getBoundingClientRect() : null;
      var refElementInView = true;
      lastScrolled = timeScrolled;

      if (!stickyEl) {
        // This could happen when sticky footer is detroyed prior this this function call
        // so we don't need to check allocations
        return;
      }

      if (dTime > 500 || !e) {
        scrollParentEl = getScrollParent(refEl);
        viewSize = getViewSize();
      }
      if (scrollParentEl === document) {
        if (
          showOnRefElementRect &&
          (showOnRefElementRect.top + elRect.height > viewSize.height || showOnRefElementRect.bottom < 0)
        ) {
          // refElement is not visible in viewport
          refElementInView = false;
        }
        if (Math.floor(elRect.bottom) > viewSize.height && refElementInView) {
          if (!stickyEl.parentElement) {
            offsetParent = document.body;
            stickyEl.classList.add('fixed');
            offsetParent.appendChild(stickyEl);
            // Need directive to be able to receive focus
            placeholder = moveFooterToStikcy(el, stickyEl);
            placeholder.addEventListener('focus', onElFocus);
            // Align footer
            alignFooter();
          }
        } else if (stickyEl.parentElement) {
          stickyEl.parentElement.removeChild(stickyEl);
          restoreFooterFromSticky(el, stickyEl, placeholder);
          placeholder.removeEventListener('focus', onElFocus);
          placeholder = null;
        }
      } else if (!e || e.target === scrollParentEl) {
        parentRect = scrollParentEl.getBoundingClientRect();
        if (
          showOnRefElementRect &&
          (showOnRefElementRect.top + refEl.height > parentRect.bottom || showOnRefElementRect.bottom < parentRect.top)
        ) {
          // refElement is not visible in viewport
          refElementInView = false;
        }

        if (Math.floor(elRect.bottom) > parentRect.bottom && refElementInView) {
          if (!stickyEl.offsetParent) {
            // Append sticky
            var offsetParent = scrollParentEl.offsetParent;
            placeholder = moveFooterToStikcy(el, stickyEl);
            offsetParent.appendChild(stickyEl);
            // Need directive to be able to receive focus
            placeholder.addEventListener('focus', onElFocus);
          }
          // adjust the top
          alignFooter();
        } else {
          if (stickyEl.offsetParent) {
            stickyEl.parentElement.removeChild(stickyEl);
            stickyEl.style.top = '-1000px'; // just in case
            restoreFooterFromSticky(el, stickyEl, placeholder);
            placeholder.removeEventListener('focus', onElFocus);
            placeholder = null;
          }
        }
      }
    }
    /**
     * Tasks to perform when el is focused
     * @param {FocusEvent} e
     */
    function onElFocus(e) {
      var tabbables = bentoServices.findTabbable(stickyEl);
      if (tabbables.length) {
        timeout(function () {
          tabbables[0].focus();
        });
      }
    }
    /**
     * Used to catch Tab keys
     * @param {KeyboardEvent} e
     */
    function onStickyFooterKeydown(e) {
      // Tab: 9
      if (e.keyCode === 9) {
        var tabbables = bentoServices.findTabbable(stickyEl);
        if (e.target === tabbables[0] && e.shiftKey) {
          // focus back
          if (placeholder) {
            placeholder.marker.focus();
          }
        } else if (e.target === tabbables[tabbables.length - 1] && !e.shiftKey) {
          // focus forward
          if (placeholder) {
            placeholder.firstChild.focus();
          }
        }
      }
    }
  }
  /**
   * Move directive to the sticky footer
   * @param {HTMLElement} footer
   * @param {HTMLElement} sticky
   */
  function moveFooterToStikcy(footer, sticky) {
    var placeholder = document.createElement('div');
    var previousMarker = document.createElement('div');
    var attr = footer.attributes;
    var parent = footer.parentElement;
    placeholder.marker = previousMarker;
    previousMarker.className = 'bento-sticky-footer-previous-marker';
    previousMarker.setAttribute('tabindex', '-1');
    placeholder.className = 'bento-sticky-footer-placeholder';
    placeholder.setAttribute('tabindex', '0');
    placeholder.innerHTML = '<div tabindex="-1"></div>';
    // copy inner HTML
    parent.insertBefore(placeholder, footer);
    parent.insertBefore(previousMarker, placeholder);
    placeholder.style.height = footer.offsetHeight + 'px';
    sticky.innerHTML = '';
    sticky.appendChild(footer);
    return placeholder;
  }
  /**
   * Restore contents from sticky to footer
   * @param {HTMLElement} footer
   * @param {HTMLElement} sticky
   * @param {object} placeholder
   */
  function restoreFooterFromSticky(footer, sticky, placeholder) {
    var parent = placeholder.parentElement;
    placeholder.style.visibility = 'hidden';
    parent.insertBefore(footer, placeholder);
    parent.removeChild(placeholder);
    parent.removeChild(placeholder.marker);
  }
  /**
   * Get a parent that scrolls
   * This is we
   * @param {HTMLElement} el
   */
  function getScrollParent(el) {
    var parent = el.parentElement;
    while (parent) {
      if (parent.scrollHeight > parent.offsetHeight) {
        var style = getComputedStyle(parent);
        if (
          style.overflow === 'auto' ||
          style.overflowY === 'auto' ||
          style.overflow === 'scroll' ||
          style.overflowY === 'scroll'
        ) {
          return parent;
        }
      }
      parent = parent.parentElement;
    }
    return document;
  }
  /**
   * Get viewport size (aka window size)
   */
  function getViewSize() {
    return {
      width: window.innerWidth || document.body.clientWidth,
      height: window.innerHeight || document.body.clientHeight,
    };
  }
})(angular);

(function (window, undefined) {
  'use strict';
  /**
   * 
   * @param {string} value Display value of the tile
   * @param {string} header Header text
   * @param {string} description Description text
   * @param {function} onTileSelect Expression when  this tile is selected with `BentoRibbonTile` as its first parameter
   * @param {string} linkTitle Text to the eyebrow link
   * @param {function} onLinkClick Expression when `linkTitle` is clicked
   * @param {string} indicator Define the type of the indicator from BentoRibbonTile['SUCCESS'|'INFO'|'DANGER'|'WARNING] (default: undefined)
   * @param {boolean} selected Determine if  this tile is preselected
   */
  function BentoRibbonTile(value, header, description, onTileSelect,
    linkTitle, onLinkClick, indicator, selected) {

    var tile = this;

    // Array<(tile: BentoRibbonTile) => void>
    tile._selectionCallbacks = [];
    //  Array<(tile: BentoRibbonTile) => void>
    tile._deselectionCallbacks = [];

    tile.value = value || '';
    tile.header = header || '';
    tile.description = description;
    tile._selectionCallbacks.push(onTileSelect || function () {});
    tile.linkTitle = linkTitle;
    tile.onLinkClick = onLinkClick || function () {};
    tile.indicator = indicator;
    tile._selected = selected;
    Object.defineProperty(tile, 'selected', {
      get: function () {
        return tile._selected;
      }
    });
  }

  /* Static definitions */
  BentoRibbonTile.SUCCESS = 'success';
  BentoRibbonTile.INFO = 'info';
  BentoRibbonTile.DANGER = 'danger';
  BentoRibbonTile.WARNING = 'warning';

  /**
   * Select the current tile
   */
  BentoRibbonTile.prototype.select = function () {
    this._selected = true;
    this._dispatchSelectionCallbacks();
  };

  /**
   * Deselect the current tile
   */
  BentoRibbonTile.prototype.deselect = function () {
    this._selected = false;
    this._dispatchDeselectionCallbacks();
  };

  /**
   * Add a selection callback.  The returned function is used to remove the current callback
   */
  BentoRibbonTile.prototype.addSelectionCallback = function (callback) {
    var tile = this;
    tile._selectionCallbacks.push(callback);
    return function () {
      // Callback to remove the assigned one
      var i = tile._selectionCallbacks.indexOf(callback);
      tile._selectionCallbacks.splice(i, 1);
    };
  };

  /**
   * Add a deselection callback.  The returned function is used to remove the current callback
   */
  BentoRibbonTile.prototype.addDeselectionCallback = function (callback) {
    var tile = this;
    tile._deselectionCallbacks.push(callback);
    return function () {
      // Callback to remove the assigned one
      var i = tile._deselectionCallbacks.indexOf(callback);
      tile._deselectionCallbacks.splice(i, 1);
    };
  };

  /**
   * Dispatch selection callbacks
   */
  BentoRibbonTile.prototype._dispatchSelectionCallbacks = function () {
    for (var i in this._selectionCallbacks) {
      if (typeof this._selectionCallbacks[i] === 'function') {
        this._selectionCallbacks[i](this);
      }
    }
  };

  /**
   * Dispatch deselection callbacks
   */
  BentoRibbonTile.prototype._dispatchDeselectionCallbacks = function () {
    for (var i in this._deselectionCallbacks) {
      if (typeof this._deselectionCallbacks[i] === 'function') {
        this._deselectionCallbacks[i](this);
      }
    }
  };

  // Make class global
  window.BentoRibbonTile = BentoRibbonTile;
})(window);

(function (angular, window, undefined) {
  'use strict';
  /**
   * Each tiles minimum width for calculation
   */
  var TILE_MIN_WIDTH = 260;
  /**
   * Arrow paddings together on both sides in default layout
   */
  var ARROW_PADDING = 40;

  BentoTileRibbonController.$inject = ['$scope', '$element',
    '$bentoTransition', '$bentoServices', 'splitterGroupNotification',
    '$timeout'
  ];

  function BentoTileRibbonController($scope, $element, $bentoTransition,
    $bentoServices, splitterGroupNotification, $timeout) {
    /**
     * Main component HTMLElement variable
     */
    var el = $element[0];
    var ctrl = this;
    var innerEl;
    var panelEl;
    var selectedTile;
    var isRTL = $bentoServices.isRTL();
    /**
     * Variable to keep previous check arrow timeout
     */
    var checkArrowTimeout;

    /**
     * Flag to determine if there is a transition in progress
     */
    var inTransition = false;
    /**
     * Keep track on the current item count
     */
    var itemCount = 0;

    /**
     * Flag to determine if the tile ribbon is hidden or not
     */
    ctrl.ribbonHidden = false;

    /**
     * Current item width
     */
    ctrl.itemWidth = ctrl.tileMinWidth || TILE_MIN_WIDTH;

    /**
     * Flag to determine if the left arrow is disabled
     */
    ctrl.disableLeftArrow = false;

    /**
     * Flag to determine if the right arrow is disabled
     */
    ctrl.disableRightArrow = false;

    ctrl.$onInit = function () {
      if (ctrl.showCollapseToggle == null) {
        ctrl.showCollapseToggle = true;
      }
    };

    ctrl.$postLink = function () {
      innerEl = el.querySelector('.bento-tile-ribbon-inner');
      panelEl = el.querySelector('.bento-tile-ribbon-panel');
      innerEl.style.marginBottom = -$bentoServices.getScrollbarWidth() +
        'px';

      innerEl.addEventListener('scroll', onInnerScroll);
      innerEl.addEventListener('wheel', function (e) {
        if (e.deltaX === 0) {
          // Only apply to vertical scroll events
          innerEl.scrollLeft = innerEl.scrollLeft + (isRTL ? -e.deltaY :
            e.deltaY);
          e.preventDefault();
        }
      });

      window.addEventListener('resize', alignItems);

      innerEl.style.opacity = 0;

      // Align at once
      alignItems(true);

      if (isRTL) {
        // Scroll to the right initially
        $timeout(function () {
          innerEl.scrollLeft = innerEl.scrollWidth - innerEl.offsetWidth;
        },200);
      }

    };

    ctrl.$doCheck = function () {
      if (innerEl && panelEl && ctrl.items && ctrl.items.length > 0 && ctrl
        .items.length !== itemCount) {
        // Item counts are not aligned
        itemCount = ctrl.items.length;
        alignItems();
      }
    };

    ctrl.$onDestroy = function () {
      window.removeEventListener('resize', alignItems);
    };

    /**
     * Toggle ribbon's visiblity.  Property `ribbonHidden` is used to determine ribbon's visiblity
     */
    ctrl.toggleVisibility = function () {
      ctrl.ribbonHidden = !ctrl.ribbonHidden;
      if (ctrl.ribbonHidden) {
        el.classList.add('bento-tile-ribbon-hidden');
      } else {
        el.classList.remove('bento-tile-ribbon-hidden');
      }
    };

    /**
     * Callback when an arrow is clicked
     */
    ctrl.onArrowClick = function (isRight) {
      //var children = panelEl.children;
      var scrollLeft = innerEl.scrollLeft;
      //var scrollRange = innerEl.scrollWidth - innerEl.offsetWidth;
      var itemWidth = ctrl.itemWidth;
      var scrollLeftIndex = isRight ? Math.round(scrollLeft / itemWidth) +
        1 : Math.round(scrollLeft / ctrl.itemWidth) - 1;

      scrollTo(Math.round(scrollLeftIndex * itemWidth));
    };

    /**
     * Callback when a tile is selected
     */
    ctrl.onTileSelect = function (tile) {
      if (selectedTile) {
        selectedTile.deselect();
      }
      selectedTile = tile;
    };

    function onInnerScroll(e) {
      clearTimeout(checkArrowTimeout);
      checkArrowTimeout = $timeout(function () {
          checkArrowStates();
        },
        500);
    }

    function scrollTo(scrollLeft) {
      if (scrollLeft >= 0) {
        // Cancel previous transition
        ctrl.previousTransition && ctrl.previousTransition();

        ctrl.previousTransition = $bentoTransition.go(
          innerEl.scrollLeft,
          scrollLeft,
          100,
          function (val) {
            innerEl.scrollLeft = val;
          },
          function () {
            inTransition = false;
          }
        );
      }
    }

    $scope.$watch(function () {
        return el.offsetWidth;
      },
      function (val) {
        if (val > (ctrl.tileMinWidth || TILE_MIN_WIDTH)) {
          innerEl.style.opacity = 1;
          alignItems();
        }
      });

    /**
     * Align tile items
     */
    function alignItems(noArrowClick) {
      var elWidth = el.offsetWidth;
      var tileMinWidth = ctrl.tileMinWidth || TILE_MIN_WIDTH;
      var hasScroll = tileMinWidth * itemCount > elWidth;
      var innerWidth = hasScroll ? (elWidth - (el.classList.contains('alt') ?
        ARROW_PADDING * 2 : ARROW_PADDING)) : elWidth;
      var numColumnsToFitInner = hasScroll ? Math.floor(innerWidth /
        tileMinWidth) : itemCount;
      var adjustedItemWidth = innerWidth / numColumnsToFitInner;
      var panelWidth = adjustedItemWidth * itemCount;
      panelEl.style.width = panelWidth + 'px';
      if (hasScroll) {
        el.classList.add('scroll');
      } else {
        el.classList.remove('scroll');
      }

      ctrl.itemWidth = adjustedItemWidth;
      checkArrowStates();

      // align the the left and right for RTL item
      if(!noArrowClick){
        ctrl.onArrowClick(isRTL);
      }
    }

    /**
     * Check current state to decide whether to enable or disable arrows
     */
    function checkArrowStates() {
      $timeout(function () {
        /* left arrow */
        ctrl.disableLeftArrow = innerEl.scrollLeft === 0;
        /* right arrow */
        ctrl.disableRightArrow = innerEl.scrollLeft === innerEl.scrollWidth -
          innerEl.offsetWidth;
      });
    }
  }

  angular.module('bento.tileribbon', [])
    /**
     * Bento Tile Ribbon Directive
     */
    .component('bentoTileRibbon', {
      templateUrl: '../templates/tile-ribbon/bento_tile_ribbon.html',
      bindings: {
        items: '<', // tile item array
        title: '<', // Title of ctrl component
        tileTemplate: '@', // used for custom tile templates
        showCollapseToggle: '<', // Show/Hide the collapse toggle 
        tileMinWidth: '<' // tileMinimum width
      },
      controller: BentoTileRibbonController
    });
})(angular, window);

(function (angular, window, undefined) {
  'use strict';
  BentoTileRibbonTileController.$inject = ['$compile', '$element', '$log',
    '$timeout', '$templateCache', '$scope'
  ];

  function BentoTileRibbonTileController($compile, $element, $log, $timeout,
    $templateCache, $scope) {
    var el = $element[0];
    var ctrl = this;
    ctrl.$postLink = function () {
      el.querySelector('.bento-ribbon-tile-inner').setAttribute('tabindex',
        '0');
      ctrl.onItemSelect = ctrl.onItemSelect.bind(ctrl);
      ctrl.removeSelectionCallback = ctrl.item.addSelectionCallback(ctrl.onItemSelect);
      ctrl.onItemDeselect = ctrl.onItemDeselect.bind(ctrl);
      ctrl.removeDeselectionCallback = ctrl.item.addDeselectionCallback(
        ctrl.onItemDeselect);

      if (ctrl.item.selected) {
        // Highlight if the item is pre-selected
        $timeout(function () {
          ctrl.onItemSelect(ctrl.item);
        });
      }

      // check custom template
      if (ctrl.template) {
        // Check template
        var template = $templateCache.get(ctrl.template);
        if (template) {
          // Will compile template with current local scope
          var $templateEl = angular.element(document.createElement('div'));
          $templateEl.html(template);
          $compile($templateEl)($scope);
          $element[0].querySelector('.bento-ribbon-tile-inner').appendChild($templateEl[0]);
        } else {
          $log.error('Bento Tile Ribbon: Template "' + ctrl.template +
            '" is undefined');
        }
      }
    };

    ctrl.$onInit = function () {};

    ctrl.$onChanges = function (changeObj) {
      if (changeObj.width) {
        el.style.width = changeObj.width.currentValue + 'px';
      }
    };

    ctrl.$onDestroy = function () {
      ctrl.removeSelectionCallback();
      ctrl.removeDeselectionCallback();
    };

    ctrl.onLinkClick = function (e) {
      if (ctrl.item.onLinkClick) {
        ctrl.item.onLinkClick(ctrl.item);
      }
      e.stopPropagation();
      e.preventDefault();
    };

    $element.on('click', function (e) {
      ctrl.item.select();
    });

    /**
     * Callback when an element is selected
     */
    ctrl.onItemSelect = function (item) {
      ctrl.selected = true;
      el.classList.add('selected');
      this.onSelect({
        tile: item
      });
    };

    /**
     * Callback when an element is selected
     */
    ctrl.onItemDeselect = function (item) {
      ctrl.selected = false;
      el.classList.remove('selected');
    };
  }
  angular.module('bento.tileribbon')
    /**
     * Bento Tile Ribbon Tile Directive
     */
    .component('bentoTileRibbonTile', {
      templateUrl: '../templates/tile-ribbon/bento_tile_ribbon_tile.html',
      bindings: {
        item: '<', // tile item
        width: '<', // tile width
        template: '<', // used for custom templates
        onSelect: '&', // callbacks when the tile is selected
      },
      controller: BentoTileRibbonTileController
    });
})(angular, window);

(function(window, angular, undefined) {
'use strict';

// Define bentoUI App object
angular.module('bento.smartbadge', ['bento.services'])
    .directive('bentoSmartBadge', BentoSmartBadge)
    .controller('bentoSmartBadgeController', BentoSmartBadgeController);

BentoSmartBadge.$inject = ['$compile', '$timeout'];
function BentoSmartBadge($compile, $timeout) {
  return {
    restrict: 'A',
    priority: 1200,
    scope: {},
    bindToController: {details: '<'},
    controller: 'bentoSmartBadgeController',
    controllerAs: 'vm'
  };
}

BentoSmartBadgeController.$inject =
    ['$scope', '$element', '$compile', '$timeout', '$bentoObservables'];
function BentoSmartBadgeController(
    $scope, $element, $compile, $timeout, $bentoObservables) {
  // to debounce resize event
  var resizeTimer;
  var badgeEl;
  var self = this;
  var hostElement = $element[0];

  this.badgeContent;
  this.badgeDynamicClass = 'hide';

  this.setBadge = function(badgeDetails) {
    if (!badgeDetails) {
      return;
    }

    self.badgeDynamicClass = 'bento-smart-badge';
    self.customStyle = '';

    if (badgeDetails.content && badgeDetails.type === 'icon') {
      self.badgeDynamicClass += ' ' +
          'bento-smart-badge-dot-with-icon';
      // make some icon specific tweaks
      switch (badgeDetails.content.value) {
        case 'bento-smart-icon-success':
          self.badgeDynamicClass += ' bento-smart-badge-success-icon';
          break;

        case 'bento-smart-icon-info':
          self.badgeDynamicClass += ' bento-smart-badge-info-icon';
          break;

        case 'bento-smart-icon-warning':
          self.badgeDynamicClass += ' bento-smart-badge-warning-icon';
          break;

        case 'bento-smart-icon-failure':
          self.badgeDynamicClass += ' bento-smart-badge-failure-icon';
          break;
      }
      self.badgeContent = '';
    } else if (badgeDetails.content && badgeDetails.type === 'digit') {
      self.badgeContent = badgeDetails.content.value + '';
      if (badgeDetails.content.value > 99) {
        self.badgeContent = 99 + '+';
      } else if (
          badgeDetails.content.value <= 0 || !badgeDetails.content.value) {
        self.badgeContent = '';
        self.badgeDynamicClass += ' ' +
            'hide';
      }

      if (badgeDetails.color && badgeDetails.color.length &&
          self.badgeContent.length) {
        self.badgeDynamicClass += ' ' + badgeDetails.color;
      }

      switch (self.badgeContent.length) {
        case 1:
          self.badgeDynamicClass += ' ' +
              'bento-smart-digit sm';
          break;

        case 2:
          self.badgeDynamicClass += ' ' +
              'bento-smart-digit md';
          break;

        case 3:
          self.badgeDynamicClass += ' ' +
              'bento-smart-digit lg';
          break;

        default:
          self.badgeDynamicClass += ' ' +
              'bento-smart-digit sm';
          break;
      }
    } else if (badgeDetails.type === 'dot') {
      self.badgeContent = '';
      self.badgeDynamicClass += ' ' +
          'bento-smart-badge-dot';

      if (badgeDetails.color && badgeDetails.color.length) {
        self.badgeDynamicClass += ' ' + badgeDetails.color;
      }
    }

    // customize as per the need
    if (badgeDetails.customParams) {
      if (badgeDetails.customParams.relativeElementSelector) {
        hostElement = document.querySelector(
            badgeDetails.customParams.relativeElementSelector);
      }
      if (badgeDetails.customParams.style) {
        self.customStyle = badgeDetails.customParams.style;
      }
      if (badgeDetails.customParams.width) {
        self.customStyle += 'width: ' + badgeDetails.customParams.width +
            'px; ' +
            'max-width: ' + badgeDetails.customParams.width + 'px;';
      }
      if (badgeDetails.customParams.height) {
        self.customStyle += 'height: ' + badgeDetails.customParams.height +
            'px; ' +
            'max-height: ' + badgeDetails.customParams.height + 'px;';
      }
    }
  };


  this.$onInit = function() {};

  this.$postLink = function() {
    if (this.badgeContent !== undefined) {
      // notice the use of {{vm.badgeDynamicClass}} - when observer class
      // calls `setBadge`, `this` context gets changed.
      badgeEl = angular.element(
          '<span class="{{vm.badgeDynamicClass}}" style="' + this.customStyle +
          '">{{vm.badgeContent}}</span>');
      $element.append($compile(badgeEl)($scope));
    } else {
      // remove the container for smart-badge
      var parentEl = $element.parent();
      if (parentEl && parentEl[0]) {
        parentEl[0].removeChild($element[0]);
      }
    }
  };

  this.$onChanges =
      function(changes) {
    // check if the function is defined or not, checking by
    // constructor.name doesn't work on minified code
    if (changes.details.currentValue &&
        typeof changes.details.currentValue.subscribe === 'function') {
      changes.details.currentValue.unsubscribe(this.setBadge);
      changes.details.currentValue.subscribe(this.setBadge);

      this.setBadge(changes.details.currentValue.data);
    } else {
      this.setBadge(changes.details.currentValue);
    }

    if ($element[0].hasAttribute('bento-smart-badge')) {
      var bsb = $element[0].querySelector('span.bento-smart-badge');
      if (bsb) {
        var newClassList;

        // removing the list this way keeps unit test case warning away
        // if you use bsb.classList = '';
        // unit test cases throw error saying
        // `TypeError: Attempted to assign to readonly property.`
        for (var i = bsb.classList.length; i > 0; i--) {
          bsb.classList.remove(bsb.classList[0]);
        }

        newClassList = this.badgeDynamicClass.split(' ');
        for (var i = 0; i < newClassList.length; i++) {
          bsb.classList.add(newClassList[i]);
        }
      }
    }
  }

      $scope.$on('$destroy', function() {
        if (self.details && self.details.unsubscribe === 'function') {
          self.details.unsubscribe(self.setBadge);
        }
      });
}
})(window, window.angular);
(function (window, angular, undefined) {

  "use strict";

  angular.module('bento.prevent.overflow.scroll', ['bento.services'])
    .directive('bentoPreventOverflowScroll', ['$bentoServices', '$timeout', function ($bentoServices, $timeout) {
      var mouseEnterFn;
      var mouseLeaveFn;
      var originalOverflow;
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          /**
           * Issue:
           * ------
           * When a tooltip/popover is appended to the body, it causes brower to 
           * flash/shake.
           * Every time the tooltip is shown, its appended to the body; causing body
           * to recalculate its position, which eventually shows up the scrollbars
           * and then hides it.
           * 
           * Fix:
           * ----
           * This directive hides body's scrollX during `mouseenter` and resets the
           * scrollX back to its original during `mouseleave`. This way the scrollbars
           * are hidden during recalculation process.
           */
  
          // do it only in RTL mode
          if ($bentoServices.isRTL()) {
            mouseEnterFn = element.on('mouseenter', function () {
              var body = document.getElementsByTagName('body')[0];
              originalOverflow = body.style.overflowX;
              body.style.overflowX = 'hidden';
            });
  
            mouseLeaveFn = element.on('mouseleave', function () {
              // timeout and give a delay - to avoid scroll flashing if hovered & left quickly
              $timeout(function() {
                var body = document.getElementsByTagName('body')[0];
                body.style.overflowX = originalOverflow;
              });
            });
    
            scope.$on('$destroy', function () {
              // clear all listeners
              if (mouseEnterFn) {
                element.off('mouseenter', mouseEnterFn);
              } else {
                element.off('mouseenter', mouseLeaveFn);
              }
            });
          }
        } //link
      }; //return
    }]); //preventOverflowScroll directive
})(window, window.angular);
(function(angular) {

'use strict';

var FOCUSED_CLASS = 'bui-focused';

BentoSkipLinksController.$inject = ['$bentoSkipLinks', '$element', '$location'];

/**
 * Controller designated to the Skip Link Component
 * It's Link object should be formatted as the following
 *
 * {
 *   anchor: string,        // ID of the element where the link skips to
 *   text: string,          // Text of the link that is used
 *   isHashAnchor: boolean  // (default: `false`) - Flag to decide whether using
 * an location hash `#` or directly focus
 * }
 */
function BentoSkipLinksController($bentoSkipLinks, $el, $location) {
  var ctrl = this;

  /**
   * Init
   */
  this.$onInit = function() {
    $bentoSkipLinks.register(ctrl);
    $el.on('focusin', function(e) {
      $el.addClass(FOCUSED_CLASS);
    });

    $el.on('focusout', function(e) {
      if (!$el[0].contains(document.activeElement)) {
        $el.removeClass(FOCUSED_CLASS);
      }
    });
  };

  /**
   * Destroy
   */
  this.$onDestroy = function() {
    $bentoSkipLinks.deregister(ctrl);
  };

  /**
   * Update links in this component
   */
  this.updateLinks = function(links) {
    ctrl.links = links;
  };

  /**
   * Callback to when a link is clicked
   */
  this.onLinkClick = function(e, link) {
    e.preventDefault();

    if (link.isHashAnchor) {
      // This is going to be a hash anchor using HTML5 anchorings using `id`
      // attribute
      var pathHash = $location.hash();
      var hashString = '#' + link.anchor;
      if (pathHash.substr(
              pathHash.length - hashString.length, hashString.length) !==
          hashString) {
        // Need make sure that if this hash has already been called
        // If so this is not going to fire again
        $location.hash(hashString);
      }
    } else {
      // Brinng focus to a HTMLElemenet defined by its CSS selector
      var anchorEl = document.getElementById(link.anchor);
      if (anchorEl) {
        anchorEl.focus();
      } else {
        /* istanbul ignore next */
        throw new Error(
            'Bento Skip Links: Cannot find element id="' + link.anchor +
            '" in viewport');
      }
    }
  };
}

angular.module('bento.skiplinks', [])
    .component('bentoSkipLinks', {
      templateUrl: '../templates/skip_links/bento-skip-links.html',
      controller: BentoSkipLinksController,
    })
    .factory('$bentoSkipLinks', function() {
      var skipLinksController;
      var skipLinks;

      var updateLinks = function(links) {
        skipLinks = links;
        if (skipLinksController) {
          skipLinksController.updateLinks(links);
        }
      };

      /**
       * Register Skip Links controller so we can use it to render links
       * @param {BentoSkipLinksController} comp
       */
      var register = function(comp) {
        if (!(comp instanceof BentoSkipLinksController)) {
          console.warn(
              'Bento Skip Links Service: Not registering. Only instance of `BentoSkipLinksController` can be registered.');
        } else if (skipLinksController) {
          console.warn(
              'Bento Skip Links Service: Component is already in your view.  Remove it before placing a new one in application\'s template.');
        } else {
          skipLinksController = comp;
          updateLinks(skipLinks || []);
        }
      };

      var deregister = function(comp) {
        if (comp === skipLinksController) {
          skipLinksController = null;
        } else {
          console.warn(
              'Bento Skip Links Service: Cannot deregister.  This controller has not been registered.');
        }
      };

      return {
        register: register,
        deregister: deregister,
        updateLinks: updateLinks,
      };
    });
})(window.angular);

/*!
    *
    * Wijmo Library 5.20211.781
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */

var wijmo,__extends=this&&this.__extends||function(){var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)};return function(e,t){extendStatics(e,t);function __(){this.constructor=e}e.prototype=null===t?Object.create(t):(__.prototype=t.prototype,new __)}}();!function(e){"use strict";var t="undefined"!=typeof navigator?navigator.userAgent:"",n=null!=t.match(/iPad|iPhone|iPod|Android|webOS|BlackBerry|Windows Phone/i);e.isMobile=function isMobile(){return n};var i=null!=t.match(/iPad|iPhone|iPod/i);e.isiOS=function isiOS(){return i};var r=null!=t.match(/Firefox\//);function isFirefox(){return r}e.isFirefox=isFirefox;var o=null!=t.match(/^((?!Chrome|Android).)*safari/i);e.isSafari=function isSafari(){return o};var s=null!=t.match(/Edge\//);e.isEdge=function isEdge(){return s};var a=null!=t.match(/MSIE |Trident\/|Edge\//);e.isIE=function isIE(){return a};var l=!1;e.isIE9=function isIE9(){return l};var u=!1;e.isIE10=function isIE10(){return u};var c=!1;"undefined"!=typeof document&&document.addEventListener("test",(function(e){}),{get passive(){c=!0;return!0}});e.getEventOptions=function getEventOptions(e,t){return c?{capture:e,passive:t}:e};var h=!1;"undefined"!=typeof document&&document.createElement("div").focus({get preventScroll(){h=!0;return!0}});e.supportsFocusOptions=function supportsFocusOptions(){return h};e._startDrag=function _startDrag(e,t){e.effectAllowed=t;isFirefox()&&e.setData("text","")};if("undefined"!=typeof document&&document.doctype){navigator.appVersion.indexOf("MSIE 10")>-1&&(u=!0);if(navigator.appVersion.indexOf("MSIE 9")>-1){l=!0;document.addEventListener("mousemove",(function(t){if(1==t.which){var n=e.closest(t.target,".wj-control");if(n&&!n.style.cursor)for(var i=t.target;i;i=i.parentElement)if(i.attributes&&i.attributes.draggable){i.dragDrop();return!1}}}))}}if("undefined"!=typeof window){var f="requestAnimationFrame";if(!window[f]){var p=0;window[f]=function(e){var t=Date.now(),n=16-(t-p),i=n>0?n:0;p=t+i;return setTimeout((function(){e(p)}),i)};window.cancelAnimationFrame=clearTimeout}if(!window.atob){var d="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",g=new RegExp("[^"+d+"]");window.atob=function(e){var t,n,i,r,o=[],s=0,a=e.length;if(g.test(e)||/=/.test(e)&&(/=[^=]/.test(e)||/={3}/.test(e)))throw new Error("Invalid base64 data");a%4>0&&(a=(e+=Array(4-a%4+1).join("=")).length);for(;s<a;){for(n=[],r=s;s<r+4;)n.push(d.indexOf(e.charAt(s++)));i=[((t=(n[0]<<18)+(n[1]<<12)+((63&n[2])<<6)+(63&n[3]))&255<<16)>>16,64===n[2]?-1:(65280&t)>>8,64===n[3]?-1:255&t];for(r=0;r<3;++r)(i[r]>=0||0===r)&&o.push(String.fromCharCode(i[r]))}return o.join("")};window.btoa=function(e){for(var t,n,i=[],r=0,o=e.length;r<o;){t=((n=[e.charCodeAt(r++),e.charCodeAt(r++),e.charCodeAt(r++)])[0]<<16)+((n[1]||0)<<8)+(n[2]||0);i.push(d.charAt((t&63<<18)>>18),d.charAt((258048&t)>>12),d.charAt(isNaN(n[1])?64:(4032&t)>>6),d.charAt(isNaN(n[2])?64:63&t))}return i.join("")}}}}(wijmo||(wijmo={}));!function(e){var t="undefined"!=typeof window&&window.Symbol?Symbol("_getProxyTarget"):"\t_get\tProxy\tTarget\t";e._getCalculatedArray=function _getCalculatedArray(n,i,r){var o=new WeakMap;if(!r){var s={};if(n.length){var a=n[0];for(var l in a){var u=typeof a[l];s[l]="string"==u?"":"number"==u?0:null}r=s}}return new Proxy(n,{get:function(n,s){if(s===t)return n;if("string"==typeof s||"number"==typeof s){if("indexOf"==s)return function(e,i){var r=n.indexOf(e,i);r<0&&e&&(e=e[t])&&(r=n.indexOf(e,i));return r};var a=parseInt(s);if(!isNaN(a)){var l=n[a];if(l&&!l[t]){var u=o.get(l);if(!u){u=function _createItemProxy(n,i,r){if(!n[t]){if(e.isIE())for(var o in i)n[o]=null;var s={};s.get=function(e,n,o){if(n===t)return e;if("constructor"===n)return function(){return Object.assign({},r||{})};var s=i[n];if(s)switch(typeof s){case"function":return s(o);case"string":return function _eval(e,t){var n=[t];return(new(Function.bind.apply(Function,[void 0].concat(["$"],["return "+e])))).apply(void 0,n)}(s,o)}return e[n]};if(!e.isIE()){s.ownKeys=function(e){return Object.keys(e).concat(Object.keys(i))};s.getOwnPropertyDescriptor=function(e,t){return t in i?{enumerable:!0,configurable:!0,writable:!1}:Reflect.getOwnPropertyDescriptor(e,t)}}n=new Proxy(n,s)}return n}(l,i,r);o.set(l,u)}l=u}return l}}return Reflect.get(n,s)}})};e._getTargetObject=function _getTargetObject(e){return(e?e[t]:null)||e}}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function Binding(e){this.path=e}Object.defineProperty(Binding.prototype,"path",{get:function(){return this._path},set:function(e){this._path=e;this._parts=e?e.split("."):[];for(var t=0;t<this._parts.length;t++){var n=this._parts[t],i=n.indexOf("[");if(i>-1){this._parts[t]=n.substr(0,i);this._parts.splice(++t,0,parseInt(n.substr(i+1)))}}this._key=1==this._parts.length?this._parts[0]:null},enumerable:!0,configurable:!0});Binding.prototype.getValue=function(e){if(e){if(this._key)return e[this._key];if(this._path&&this._path in e)return e[this._path];for(var t=0;t<this._parts.length&&e;t++)e=e[this._parts[t]]}return e};Binding.prototype.setValue=function(e,t){if(e)try{var n=this._path;if(n in e){e[n]=t;return e[n]==t}for(var i=0;i<this._parts.length-1;i++)if(null==(e=e[this._parts[i]]))return!1;e[n=this._parts[this._parts.length-1]]=t;return e[n]==t}catch(e){return!1}return!1};return Binding}();e.Binding=t}(wijmo||(wijmo={}));!function(e){"use strict";var t=function t(e,n){this.handler=e;this.self=n},n=function(){function Event(e){this._handlers=[];this._handlersChanged=e}Event.prototype.addHandler=function(n,i){n=e.asFunction(n);this._handlers.push(new t(n,i));e.isFunction(this._handlersChanged)&&this._handlersChanged()};Event.prototype.removeHandler=function(t,n){var i=!1;t=e.asFunction(t);for(var r=0;r<this._handlers.length;r++){var o=this._handlers[r];if(!(o.handler!=t&&null!=t||o.self!=n&&null!=n)){this._handlers.splice(r,1);i=!0;if(t&&n)break}}i&&e.isFunction(this._handlersChanged)&&this._handlersChanged()};Event.prototype.removeAllHandlers=function(){var t=this._handlers.length>0;this._handlers.length=0;t&&e.isFunction(this._handlersChanged)&&this._handlersChanged()};Event.prototype.raise=function(e,t){void 0===t&&(t=i.empty);for(var n=this._handlers,r=0;r<n.length;r++){var o=n[r];o.handler.call(o.self,e,t);n[r]!==o&&r--}};Object.defineProperty(Event.prototype,"hasHandlers",{get:function(){return this._handlers.length>0},enumerable:!0,configurable:!0});Object.defineProperty(Event.prototype,"handlerCount",{get:function(){return this._handlers.length},enumerable:!0,configurable:!0});return Event}();e.Event=n;var i=function(){function EventArgs(){}EventArgs.empty=new EventArgs;return EventArgs}();e.EventArgs=i;var r=function(e){__extends(CancelEventArgs,e);function CancelEventArgs(){var t=null!==e&&e.apply(this,arguments)||this;t.cancel=!1;return t}return CancelEventArgs}(i);e.CancelEventArgs=r;var o=function(e){__extends(PropertyChangedEventArgs,e);function PropertyChangedEventArgs(t,n,i){var r=e.call(this)||this;r._name=t;r._oldVal=n;r._newVal=i;return r}Object.defineProperty(PropertyChangedEventArgs.prototype,"propertyName",{get:function(){return this._name},enumerable:!0,configurable:!0});Object.defineProperty(PropertyChangedEventArgs.prototype,"oldValue",{get:function(){return this._oldVal},enumerable:!0,configurable:!0});Object.defineProperty(PropertyChangedEventArgs.prototype,"newValue",{get:function(){return this._newVal},enumerable:!0,configurable:!0});return PropertyChangedEventArgs}(i);e.PropertyChangedEventArgs=o;var s=function(e){__extends(RequestErrorEventArgs,e);function RequestErrorEventArgs(t,n){var i=e.call(this)||this;i._xhr=t;i._msg=n;return i}Object.defineProperty(RequestErrorEventArgs.prototype,"request",{get:function(){return this._xhr},enumerable:!0,configurable:!0});Object.defineProperty(RequestErrorEventArgs.prototype,"message",{get:function(){return this._msg},set:function(e){this._msg=e},enumerable:!0,configurable:!0});return RequestErrorEventArgs}(r);e.RequestErrorEventArgs=s}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var n;!function(e){e[e.Add=0]="Add";e[e.Remove=1]="Remove";e[e.Change=2]="Change";e[e.Reset=3]="Reset"}(n=t.NotifyCollectionChangedAction||(t.NotifyCollectionChangedAction={}));var i=function(e){__extends(NotifyCollectionChangedEventArgs,e);function NotifyCollectionChangedEventArgs(t,i,r){void 0===t&&(t=n.Reset);void 0===i&&(i=null);void 0===r&&(r=-1);var o=e.call(this)||this;o.action=t;o.item=i;o.index=r;return o}NotifyCollectionChangedEventArgs.reset=new NotifyCollectionChangedEventArgs(n.Reset);return NotifyCollectionChangedEventArgs}(e.EventArgs);t.NotifyCollectionChangedEventArgs=i;var r=function(){function SortDescription(t,n){this._bnd=new e.Binding(t);this._asc=n}Object.defineProperty(SortDescription.prototype,"property",{get:function(){return this._bnd.path},enumerable:!0,configurable:!0});Object.defineProperty(SortDescription.prototype,"ascending",{get:function(){return this._asc},enumerable:!0,configurable:!0});return SortDescription}();t.SortDescription=r;var o=function(e){__extends(PageChangingEventArgs,e);function PageChangingEventArgs(t){var n=e.call(this)||this;n.newPageIndex=t;return n}return PageChangingEventArgs}(e.CancelEventArgs);t.PageChangingEventArgs=o;var s=function(){function GroupDescription(){}GroupDescription.prototype.groupNameFromItem=function(e,t){return""};GroupDescription.prototype.namesMatch=function(e,t){return e===t};return GroupDescription}();t.GroupDescription=s;var a=function(t){__extends(PropertyGroupDescription,t);function PropertyGroupDescription(n,i){var r=t.call(this)||this;r._bnd=new e.Binding(n);r._converter=i;return r}Object.defineProperty(PropertyGroupDescription.prototype,"propertyName",{get:function(){return this._bnd.path},enumerable:!0,configurable:!0});PropertyGroupDescription.prototype.groupNameFromItem=function(e,t){return this._converter?this._converter(e,this.propertyName):this._bnd.getValue(e)};PropertyGroupDescription.prototype.namesMatch=function(e,t){return e===t};return PropertyGroupDescription}(s);t.PropertyGroupDescription=a}(e.collections||(e.collections={}))}(wijmo||(wijmo={}));!function(e){"use strict";var t,n="5.20211.781";e.getVersion=function getVersion(){return n};e.setLicenseKey=function setLicenseKey(t){e.Control._licKey=t};!function(e){e[e.Back=8]="Back";e[e.Tab=9]="Tab";e[e.Enter=13]="Enter";e[e.Escape=27]="Escape";e[e.Space=32]="Space";e[e.PageUp=33]="PageUp";e[e.PageDown=34]="PageDown";e[e.End=35]="End";e[e.Home=36]="Home";e[e.Left=37]="Left";e[e.Up=38]="Up";e[e.Right=39]="Right";e[e.Down=40]="Down";e[e.Delete=46]="Delete";e[e.F1=112]="F1";e[e.F2=113]="F2";e[e.F3=114]="F3";e[e.F4=115]="F4";e[e.F5=116]="F5";e[e.F6=117]="F6";e[e.F7=118]="F7";e[e.F8=119]="F8";e[e.F9=120]="F9";e[e.F10=121]="F10";e[e.F11=122]="F11";e[e.F12=123]="F12"}(e.Key||(e.Key={}));!function(e){e[e.Object=0]="Object";e[e.String=1]="String";e[e.Number=2]="Number";e[e.Boolean=3]="Boolean";e[e.Date=4]="Date";e[e.Array=5]="Array"}(t=e.DataType||(e.DataType={}));function tryCast(e,t){return null==e?null:isString(t)?isFunction(e.implementsInterface)&&e.implementsInterface(t)?e:null:e instanceof t?e:null}e.tryCast=tryCast;function isPrimitive(e){return isString(e)||isNumber(e)||isBoolean(e)||isDate(e)}e.isPrimitive=isPrimitive;function isString(e){return"string"==typeof e}e.isString=isString;e.isNullOrWhiteSpace=function isNullOrWhiteSpace(e){return!e||!/\S/.test(e)};function isNumber(e){return"number"==typeof e}e.isNumber=isNumber;function isInt(e){return isNumber(e)&&e==Math.round(e)}e.isInt=isInt;function isBoolean(e){return"boolean"==typeof e}e.isBoolean=isBoolean;function isFunction(e){return"function"==typeof e}e.isFunction=isFunction;function isUndefined(e){return void 0===e}e.isUndefined=isUndefined;function isDate(e){return(e instanceof Date||"[object Date]"===Object.prototype.toString.call(e))&&!isNaN(e.getTime())}e.isDate=isDate;function isArray(e){return e instanceof Array||Array.isArray(e)||"[object Array]"===Object.prototype.toString.call(e)}e.isArray=isArray;function isObject(e){return null!=e&&"object"==typeof e&&!isDate(e)&&!isArray(e)}e.isObject=isObject;e.isEmpty=function isEmpty(e){for(var t in e)return!1;return!0};e.getUniqueId=function getUniqueId(e){for(var t=e,n=0;null!=document.getElementById(t);n++)t=e+n;return t};e.mouseToPage=function mouseToPage(e){if(e instanceof o)return e;e&&e.touches&&e.touches.length>0&&(e=e.touches[0]);if(isNumber(e.clientX)&&isNumber(e.clientY))return new o(e.clientX+pageXOffset,e.clientY+pageYOffset);throw"Mouse or touch event expected."};function getType(e){return isNumber(e)?t.Number:isBoolean(e)?t.Boolean:isDate(e)?t.Date:isString(e)?t.String:isArray(e)?t.Array:t.Object}e.getType=getType;e.getTypes=function getTypes(e){var t=[];if(e&&e.length>0){var n=e[0];for(var i in n)for(var r=null,o=0;o<e.length&&o<1e3&&null==r;o++)if(isPrimitive(r=e[o][i])){var s=Object.getOwnPropertyDescriptor(e[o],i);t.push({binding:i,dataType:getType(r),isReadOnly:s&&!s.writable&&!s.set})}}return t};function changeType(n,i,r,o){if(null!=n){var s=t;if(isString(n))switch(i){case s.Number:var a=e.Globalize.parseFloat(n,r);return isNaN(a)?n:a;case s.Date:var l=e.Globalize.parseDate(n,r,isDate(o)?o:null);l||r||!n||(l=new Date(n));return l&&isFinite(l.getTime())?l:n;case s.Boolean:switch(n.toLowerCase()){case"true":return!0;case"false":return!1}return n;case s.Array:try{var u=n.split(",").map((function(e){return(e=e.trim()).match(/^(\+|\-)?\d+\.?\d*$/)?e:'"'+e+'"'}));return JSON.parse("["+u.join(",")+"]")}catch(e){}}if(i==t.String)return e.Globalize.format(n,r)}return n}e.changeType=changeType;e.toFixed=function toFixed(e,t,n){if(n){var i=(r=e.toString()).indexOf(".");if(r.indexOf("e")<0&&i>-1){r=r.substr(0,i+1+t);e=parseFloat(r)}}else{var r=e.toFixed(t);e=parseFloat(r)}return e};e.format=function format(t,n,i){if((t=asString(t)).match(/\{.*"count".*:.*"when".*:.*\}/))try{var r=JSON.parse(t);if(isString(r.count)){var o=n[r.count],s=r.when;if(isNumber(o)&&isObject(s)){var a=s[o]||s.other;isString(a)&&(t=a)}}}catch(e){}return t.replace(/\{(.*?)(:(.*?))?\}/g,(function(t,r,o,s){var a=t;if(r&&"{"!=r[0]&&n){a=new e.Binding(r).getValue(n);s&&(a=e.Globalize.format(a,s));i&&(a=i(n,r,s,a))}return null==a?"":a}))};function glbz(){for(var t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];var i=[],r=-1;t[0].forEach((function(n,o){if(o>0&&o!=r){var s=t[o],a=n.match(/^:([a-z][0-9]*\b)/i)||n.match(/^:'(.+?)'/)||n.match(/^:"(.+?)"/);if(a){s=e.Globalize.format(s,a[1]);n=n.substr(a[0].length)}else if(":"==n&&o<t.length-1&&(isNumber(s)||isDate(s))){s=e.Globalize.format(s,t[o+1]);n="";r=o+1}i.push(s)}n&&i.push(n)}));return i.join("")}e.glbz=glbz;e.evalTemplate=function evalTemplate(t,n){if(e.isIE()){return(t=t.replace(/:\${([^}]*)}/g,(function(e,t){return":"+_evalExpression(t,n)}))).replace(/\${([^}]*)}(:(([A-Za-z]\d*)|"([^"]+)"|'([^']+)'))?/g,(function(t,i,r,o,s,a,l){var u=_evalExpression(i,n);return o?e.Globalize.format(u,s||a||l):u}))}return _evalExpression(t,n)};function _evalExpression(t,n){(n=n||{}).glbz=glbz;var i=Object.keys(n),r=i.map((function(e){return n[e]}));return(e.isIE()?new(Function.bind.apply(Function,[void 0].concat(i,["return "+t]))):new(Function.bind.apply(Function,[void 0].concat(i,["return glbz`"+t+"`"])))).apply(void 0,r)}e.clamp=function clamp(e,t,n){if(null!=e){null!=n&&e>n&&(e=n);null!=t&&e<t&&(e=t)}return e};e.copy=function copy(t,n){if(n)for(var i in n)if("_"!=i[0]){assert(i in t,'Unknown property "'+i+'".');var r=n[i];t._copy&&t._copy(i,r)||(t[i]instanceof e.Event?isFunction(r)&&t[i].addHandler(r):!isObject(r)||"undefined"!=typeof Element&&r instanceof Element||!t[i]||"itemsSource"==i?t[i]=r:copy(t[i],r))}return t};function assert(e,t){if(!e){t="** Assertion failed in Wijmo: "+t;var n=new Error;isString(n.stack)&&(t+=" "+n.stack);throw t}}e.assert=assert;e._deprecated=function _deprecated(e,t){console.error('** WARNING: "'+e+'" has been deprecated; please use "'+t+'" instead.')};function asString(e,t){void 0===t&&(t=!0);isUndefined(e)&&(e=null);assert(t&&null==e||isString(e),"String expected.");return e}e.asString=asString;function asNumber(e,t,n){void 0===t&&(t=!1);void 0===n&&(n=!1);assert(t&&null==e||isNumber(e),"Number expected.");if(n&&e&&e<0)throw"Positive number expected.";return e}e.asNumber=asNumber;e.asInt=function asInt(e,t,n){void 0===t&&(t=!1);void 0===n&&(n=!1);assert(t&&null==e||isInt(e),"Integer expected.");if(n&&e&&e<0)throw"Positive integer expected.";return e};function asBoolean(e,t){void 0===t&&(t=!1);assert(t&&null==e||isBoolean(e),"Boolean expected.");return e}e.asBoolean=asBoolean;e.asDate=function asDate(e,n){void 0===n&&(n=!1);if(isString(e)){var i=changeType(e,t.Date,"r");isDate(i)&&(e=i)}assert(n&&null==e||isDate(e),"Date expected.");return e};function asFunction(e,t){void 0===t&&(t=!0);assert(t&&null==e||isFunction(e),"Function expected.");return e}e.asFunction=asFunction;e.asArray=function asArray(e,t){void 0===t&&(t=!0);assert(t&&null==e||isArray(e),"Array expected.");return e};e.asType=function asType(e,t,n){void 0===n&&(n=!1);e=tryCast(e,t);assert(n||null!=e,t+" expected.");return e};e.asEnum=function asEnum(e,t,n){void 0===n&&(n=!1);if(null==e&&n)return null;var i=isString(e)?t[e]:e;assert(null!=i,'Invalid enum value: "'+e+'"');return isNumber(i)?i:e};e.asCollectionView=function asCollectionView(t,n){void 0===n&&(n=!0);if(null==t&&n)return null;var i=tryCast(t,"ICollectionView");if(null!=i)return i;isArray(t)||assert(!1,"Array or ICollectionView expected.");return new e.collections.CollectionView(t)};e.hasItems=function hasItems(e){return null!=e&&null!=e.items&&e.items.length>0};e.toHeaderCase=function toHeaderCase(e){return e&&e.length?e[0].toUpperCase()+e.substr(1).replace(/([a-z])([A-Z])/g,"$1 $2"):""};e.escapeHtml=function escapeHtml(e){e&&isString(e)&&(e=e.replace(/[&<>"'\/]/g,(function(e){return r[e]})));return null!=e?e.toString():""};var i,r={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;"};e.escapeRegExp=function escapeRegExp(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")};e.toPlainText=function toPlainText(e){var t=asString(e);if(isString(t)&&t.indexOf("<")>-1){i||(i=document.createElement("div"));i.innerHTML=t;t=i.textContent}return t};function hasClass(t,n){if(t&&n){if(t instanceof HTMLElement&&t.classList&&!e.isIE9())return t.classList.contains(n);if(t.getAttribute){var i=new RegExp("(\\s|^)"+n+"(\\s|$)");return t&&i.test(t.getAttribute("class"))}}return!1}e.hasClass=hasClass;function addClass(t,n){if(t&&n){if(t instanceof HTMLElement&&t.classList&&!e.isIE9()){n.indexOf(" ")<0?t.classList.add(n):n.split(" ").forEach((function(e){t.classList.add(e)}));return}t.setAttribute&&n.split(" ").forEach((function(e){if(!hasClass(t,e)){var n=t.getAttribute("class");t.setAttribute("class",n?n+" "+e:e)}}))}}e.addClass=addClass;function removeClass(t,n){if(t&&n){if(t instanceof HTMLElement&&t.classList&&!e.isIE9()){n.indexOf(" ")<0?t.classList.remove(n):n.split(" ").forEach((function(e){t.classList.remove(e)}));return}t.setAttribute&&n.split(" ").forEach((function(e){if(hasClass(t,e)){var n=new RegExp("((\\s|^)"+e+"(\\s|$))","g"),i=t.getAttribute("class");(i=i.replace(n," ").replace(/ +/g," ").trim())?t.setAttribute("class",i):t.removeAttribute("class")}}))}}e.removeClass=removeClass;function toggleClass(e,t,n){null==n&&(n=!hasClass(e,t));n?addClass(e,t):removeClass(e,t)}e.toggleClass=toggleClass;function setAttribute(e,t,n,i){e&&(null!=n?i&&e.getAttribute(t)||e.setAttribute(t,n.toString()):e.removeAttribute(t))}e.setAttribute=setAttribute;e.setChecked=function setChecked(t,n){var i=null==n;t.checked=e.isIE()?n||i:n;t.indeterminate=i};e.setAriaLabel=function setAriaLabel(e,t){setAttribute(e,"aria-label",t)};e.setSelectionRange=function setSelectionRange(e,t,n){void 0===n&&(n=t);assert(e instanceof HTMLInputElement||e instanceof HTMLTextAreaElement,"INPUT or TEXTAREA element expected");if(contains(document.body,e)&&!e.disabled&&e.offsetHeight){try{e.setSelectionRange(t,n,"backward")}catch(e){}try{e.focus();return!0}catch(e){}}return!1};e.disableAutoComplete=function disableAutoComplete(e){var t="autocomplete",n=e.getAttribute(t);n&&"on"!=n||e.setAttribute(t,"off");"autocorrect,autocapitalize,spellcheck".split(",").forEach((function(t){e.setAttribute(t,"spellcheck"==t?"false":"off")}))};e.removeChild=function removeChild(e){return e&&e.parentNode?e.parentNode.removeChild(e):null};function getActiveElement(){var e=document.activeElement;if(e){var t=e.shadowRoot;t&&t.activeElement&&(e=t.activeElement)}return e}e.getActiveElement=getActiveElement;e.moveFocus=function moveFocus(t,n){var i=function _getFocusableElements(t){var n=[],i=Array.prototype.slice.call(t.querySelectorAll("input,select,textarea,button,a,div"));i.sort((function(e,t){return e.tabIndex-t.tabIndex}));for(var r=0;r<i.length;r++){var o=i[r];if(o.offsetHeight>0&&o.tabIndex>-1&&!o.disabled&&!closest(o,"[disabled],.wj-state-disabled")){if(o instanceof HTMLAnchorElement&&!o.hasAttribute("href"))continue;if(e.isIE()&&!o.hasAttribute("tabindex")){if(o instanceof HTMLDivElement)continue;var s=e.Control.getControl(closest(o,".wj-flexgrid"));if(s&&0==s.keyActionTab)continue}!e.Control.getControl(o)&&_getFocusableElements(o).length||n.push(o)}}return n}(t),r=0;if(n){var o=i.indexOf(getActiveElement());o>-1&&(r=(o+n+i.length)%i.length)}if(r<i.length){var s=i[r];s.focus();s instanceof HTMLInputElement&&s.select();return!0}return!1};e.saveFile=function saveFile(e,t,n){void 0===n&&(n="text/plain");(n.match(/\bcsv\b/i)||t.match(/\.csv$/i))&&(e="\ufeff"+e);var i=new Blob([e],{type:n});if(isFunction(navigator.msSaveBlob))navigator.msSaveBlob(i,t);else{var r=URL.createObjectURL(i),o=createElement('<a href="'+r+'" download="'+t+'"></a>',document.body,{display:"none"});o.click();o.remove();URL.revokeObjectURL(r)}};function getElement(e){if(e instanceof Element)return e;if(isString(e))try{return document.querySelector(e)}catch(e){}return e&&e.jquery?e[0]:null}e.getElement=getElement;function createElement(e,t,n){e=e.replace(/\bstyle\s*=\s*"/g,'_wj-style="');var i=document.createElement("div");i.innerHTML=e;if(e.indexOf("_wj-style")>-1)for(var r=i.querySelectorAll("[_wj-style]"),_loop_1=function(e){var t=r[e];t.getAttribute("_wj-style").split(";").forEach((function(e){var n=e.split(":");2==n.length&&(t.style[n[0].trim()]=n[1].trim())}));t.removeAttribute("_wj-style")},o=0;o<r.length;o++)_loop_1(o);1==i.children.length&&(i=i.children[0]);n&&setCss(i,n);t&&(t=getElement(t)).appendChild(i);return i}e.createElement=createElement;e.setText=function setText(e,t){e.textContent=t||""};function contains(t,n,i){for(var r=n;r&&t;){if(r===t)return!0;r=(i?r[e.Control._OWNR_KEY]:null)||r.parentNode||r.host}return!1}e.contains=contains;function closest(e,t){if(e){if(isFunction(e.closest))return e.closest(t);var n=e.matches||e.webkitMatchesSelector||e.msMatchesSelector||e.mozMatchesSelector;if(n)for(;e&&1===e.nodeType;e=e.parentElement||e.parentNode)if(n.call(e,t))return e}return null}e.closest=closest;e.closestClass=function closestClass(e,t){return closest(e,"."+t)};e.enable=function enable(e,t){var n=!t,i="disabled";toggleClass(e,"wj-state-disabled",n);setAttribute(e,i,n?i:null);for(var r=e.querySelectorAll("input,button"),o=0;o<r.length;o++)setAttribute(r[o],i,n?i:null)};e.getElementRect=function getElementRect(e){var t=e.getBoundingClientRect();return new a(t.left+pageXOffset,t.top+pageYOffset,t.width,t.height)};function setCss(e,t){assert(isObject(t),"css parameter should be an object");if(e instanceof Array)for(var n=0;n<e.length;n++)setCss(e[n],t);else if(e&&e.style){var i=e.style;for(var r in t){var o=t[r];"number"==typeof o&&r.match(/width|height|left|top|right|bottom|size|padding|margin'/i)&&(o+="px");i[r]!==o&&(i[r]=o)}}}e.setCss=setCss;e.animate=function animate(t,n,i){null==n&&(n=e.Control._ANIM_DEF_DURATION);null==i&&(i=e.Control._ANIM_DEF_STEP);t=asFunction(t);n=asNumber(n,!1,!0);i=asNumber(i,!1,!0);var r,o=Date.now(),s=setInterval((function(){var e=Math.min(1,(Date.now()-o)/n);e=Math.sin(e*Math.PI/2);e*=e;r&&cancelAnimationFrame(r);r=requestAnimationFrame((function(){r=null;t(e)}));e>=1&&clearInterval(s)}),i);return s};var o=function(){function Point(e,t){void 0===e&&(e=0);void 0===t&&(t=0);this.x=asNumber(e);this.y=asNumber(t)}Point.prototype.equals=function(e){return e instanceof Point&&this.x==e.x&&this.y==e.y};Point.prototype.clone=function(){return new Point(this.x,this.y)};return Point}();e.Point=o;var s=function(){function Size(e,t){void 0===e&&(e=0);void 0===t&&(t=0);this.width=asNumber(e);this.height=asNumber(t)}Size.prototype.equals=function(e){return e instanceof Size&&this.width==e.width&&this.height==e.height};Size.prototype.clone=function(){return new Size(this.width,this.height)};return Size}();e.Size=s;var a=function(){function Rect(e,t,n,i){this.left=asNumber(e);this.top=asNumber(t);this.width=asNumber(n);this.height=asNumber(i)}Object.defineProperty(Rect.prototype,"right",{get:function(){return this.left+this.width},enumerable:!0,configurable:!0});Object.defineProperty(Rect.prototype,"bottom",{get:function(){return this.top+this.height},enumerable:!0,configurable:!0});Rect.prototype.equals=function(e){return e instanceof Rect&&this.left==e.left&&this.top==e.top&&this.width==e.width&&this.height==e.height};Rect.prototype.clone=function(){return new Rect(this.left,this.top,this.width,this.height)};Rect.fromBoundingRect=function(e){if(null!=e.left)return new Rect(e.left,e.top,e.width,e.height);if(null!=e.x)return new Rect(e.x,e.y,e.width,e.height);assert(!1,"Invalid source rectangle.")};Rect.union=function(e,t){var n=Math.min(e.left,t.left),i=Math.min(e.top,t.top);return new Rect(n,i,Math.max(e.right,t.right)-n,Math.max(e.bottom,t.bottom)-i)};Rect.intersection=function(e,t){var n=Math.max(e.left,t.left),i=Math.max(e.top,t.top);return new Rect(n,i,Math.min(e.right,t.right)-n,Math.min(e.bottom,t.bottom)-i)};Rect.prototype.contains=function(e){if(e instanceof o)return e.x>=this.left&&e.x<=this.right&&e.y>=this.top&&e.y<=this.bottom;if(e instanceof Rect){var t=e;return t.left>=this.left&&t.right<=this.right&&t.top>=this.top&&t.bottom<=this.bottom}assert(!1,"Point or Rect expected.")};Rect.prototype.inflate=function(e,t){return new Rect(this.left-e,this.top-t,this.width+2*e,this.height+2*t)};return Rect}();e.Rect=a;var l=function(){function DateTime(){}DateTime.addDays=function(e,t){(e=new Date(e.getTime())).setDate(e.getDate()+t);return e};DateTime.addMonths=function(e,t){var n=(e=new Date(e.getTime())).getDate();e.setMonth(e.getMonth()+t);e.getDate()!=n&&e.setDate(0);return e};DateTime.addYears=function(e,t){(e=new Date(e.getTime())).setFullYear(e.getFullYear()+t);return e};DateTime.addHours=function(e,t){(e=new Date(e.getTime())).setHours(e.getHours()+t);return e};DateTime.addMinutes=function(e,t){(e=new Date(e.getTime())).setMinutes(e.getMinutes()+t);return e};DateTime.addSeconds=function(e,t){(e=new Date(e.getTime())).setSeconds(e.getSeconds()+t);return e};DateTime.weekFirst=function(t,n){void 0===n&&(n=e.Globalize.getFirstDayOfWeek());return DateTime.addDays(t,-(t.getDay()-n))};DateTime.weekLast=function(t,n){void 0===n&&(n=e.Globalize.getFirstDayOfWeek());t=DateTime.weekFirst(t,n);return DateTime.addDays(t,6)};DateTime.monthFirst=function(e){return DateTime.addDays(e,1-e.getDate())};DateTime.monthLast=function(e){e=DateTime.monthFirst(e);e=DateTime.addMonths(e,1);return DateTime.addDays(e,-1)};DateTime.yearFirst=function(e){return new Date(e.getFullYear(),0,1)};DateTime.yearLast=function(e){return new Date(e.getFullYear(),11,31)};DateTime.sameDate=function(e,t){return isDate(e)&&isDate(t)&&e.getFullYear()==t.getFullYear()&&e.getMonth()==t.getMonth()&&e.getDate()==t.getDate()};DateTime.sameTime=function(e,t){return isDate(e)&&isDate(t)&&e.getHours()==t.getHours()&&e.getMinutes()==t.getMinutes()&&e.getSeconds()==t.getSeconds()&&e.getMilliseconds()==t.getMilliseconds()};DateTime.equals=function(e,t){return e==t||isDate(e)&&isDate(t)&&e.getTime()==t.getTime()};DateTime.fromDateTime=function(e,t){if(!e&&!t)return null;e||(e=t);t||(t=e);return DateTime.newDate(e.getFullYear(),e.getMonth(),e.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds())};DateTime.toFiscal=function(t,n){var i=e.culture.Globalize.calendar;return isArray(i.fiscalYearOffsets)?DateTime.addMonths(t,-i.fiscalYearOffsets[n?0:1]):t};DateTime.fromFiscal=function(t,n){var i=e.culture.Globalize.calendar;return isArray(i.fiscalYearOffsets)?DateTime.addMonths(t,+i.fiscalYearOffsets[n?0:1]):t};DateTime.newDate=function(e,t,n,i,r,o,s){if(null==e||null==t||null==n){var a=new Date;null==e&&(e=a.getFullYear());null==t&&(t=a.getMonth());null==n&&(n=a.getDate())}null==i&&(i=0);null==r&&(r=0);null==o&&(o=0);null==s&&(s=0);var l=new Date(e,t,n,i,r,o,s),u=l.getFullYear();e<100&&u>=1900&&l.setFullYear(l.getFullYear()-1900);return l};DateTime.clone=function(e){return DateTime.fromDateTime(e,e)};return DateTime}();e.DateTime=l;e.httpRequest=function httpRequest(e,t){var n=t||{},i=n.method?asString(n.method).toUpperCase():"GET",r=null==n.async||asBoolean(n.async),o=n.data;if(null!=o&&"GET"==i){var s=[];for(var a in o){var l=o[a];isDate(l)&&(l=l.toJSON());s.push(a+"="+encodeURIComponent(l))}if(s.length){var u=e.indexOf("?")<0?"?":"&";e+=u+s.join("&")}o=null}var c=new XMLHttpRequest;c.URL_DEBUG=e;var h=!1;if(null!=o&&!isString(o)){h=isObject(o);o=JSON.stringify(o)}c.onload=function(){if(4==c.readyState){c.status<300?n.success&&asFunction(n.success)(c):n.error&&asFunction(n.error)(c);n.complete&&asFunction(n.complete)(c)}};c.onerror=function(){if(!isFunction(n.error))throw"HttpRequest Error: "+c.status+" "+c.statusText;n.error(c)};c.open(i,e,r,n.user,n.password);n.user&&n.password&&c.setRequestHeader("Authorization","Basic "+btoa(n.user+":"+n.password));h&&c.setRequestHeader("Content-Type","application/json");if(n.requestHeaders)for(var f in n.requestHeaders)c.setRequestHeader(f,n.requestHeaders[f]);isNumber(n.timeout)&&(c.timeout=n.timeout);isFunction(n.beforeSend)&&n.beforeSend(c);c.send(o);return c};var u={};e._registerModule=function _registerModule(e,t){u[e]=t;if("wijmo"===e){var n="undefined"!=typeof window?window:"undefined"!=typeof self?self:null;n&&(n.wijmo=t)}};e._getModule=function _getModule(e){return u[e]}}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function Color(e){this._r=0;this._g=0;this._b=0;this._a=1;e&&this._parse(e)}Object.defineProperty(Color.prototype,"r",{get:function(){return this._r},set:function(t){this._r=e.clamp(e.asNumber(t),0,255)},enumerable:!0,configurable:!0});Object.defineProperty(Color.prototype,"g",{get:function(){return this._g},set:function(t){this._g=e.clamp(e.asNumber(t),0,255)},enumerable:!0,configurable:!0});Object.defineProperty(Color.prototype,"b",{get:function(){return this._b},set:function(t){this._b=e.clamp(e.asNumber(t),0,255)},enumerable:!0,configurable:!0});Object.defineProperty(Color.prototype,"a",{get:function(){return this._a},set:function(t){this._a=e.clamp(e.asNumber(t),0,1)},enumerable:!0,configurable:!0});Color.prototype.equals=function(e){return e instanceof Color&&this.r==e.r&&this.g==e.g&&this.b==e.b&&this.a==e.a};Color.prototype.toString=function(){var e=Math.round(100*this.a);return e>99?"#"+((1<<24)+(this.r<<16)+(this.g<<8)+this.b).toString(16).slice(1):"rgba("+this.r+","+this.g+","+this.b+","+e/100+")"};Color.fromRgba=function(t,n,i,r){void 0===r&&(r=1);var o=new Color(null);o.r=Math.round(e.clamp(e.asNumber(t),0,255));o.g=Math.round(e.clamp(e.asNumber(n),0,255));o.b=Math.round(e.clamp(e.asNumber(i),0,255));o.a=e.clamp(e.asNumber(r),0,1);return o};Color.fromHsb=function(t,n,i,r){void 0===r&&(r=1);var o=Color._hsbToRgb(e.clamp(e.asNumber(t),0,1),e.clamp(e.asNumber(n),0,1),e.clamp(e.asNumber(i),0,1));return Color.fromRgba(o[0],o[1],o[2],r)};Color.fromHsl=function(t,n,i,r){void 0===r&&(r=1);var o=Color._hslToRgb(e.clamp(e.asNumber(t),0,1),e.clamp(e.asNumber(n),0,1),e.clamp(e.asNumber(i),0,1));return Color.fromRgba(o[0],o[1],o[2],r)};Color.fromString=function(t){var n=new Color(null);return n._parse(e.asString(t))?n:null};Color.prototype.getHsb=function(){return Color._rgbToHsb(this.r,this.g,this.b)};Color.prototype.getHsl=function(){return Color._rgbToHsl(this.r,this.g,this.b)};Color.interpolate=function(t,n,i){i=e.clamp(e.asNumber(i),0,1);var r=Color._rgbToHsl(t.r,t.g,t.b),o=Color._rgbToHsl(n.r,n.g,n.b),s=1-i,a=t.a*s+n.a*i,l=[r[0]*s+o[0]*i,r[1]*s+o[1]*i,r[2]*s+o[2]*i],u=Color._hslToRgb(l[0],l[1],l[2]);return Color.fromRgba(u[0],u[1],u[2],a)};Color.toOpaque=function(t,n){if(1==(t=e.isString(t)?Color.fromString(t):e.asType(t,Color)).a)return t;n=null==n?Color.fromRgba(255,255,255,1):e.isString(n)?Color.fromString(n):e.asType(n,Color);var i=t.a,r=1-i;return Color.fromRgba(t.r*i+n.r*r,t.g*i+n.g*r,t.b*i+n.b*r)};Color.prototype._parse=function(t){if("transparent"==(t=t.toLowerCase())){this._r=this._g=this._b=this._a=0;return!0}if(t&&0!=t.indexOf("#")&&0!=t.indexOf("rgb")&&0!=t.indexOf("hsl")){var n=document.createElement("div");n.style.color=t;var i=n.style.color;if(i==t&&!(i=window.getComputedStyle(n).color)){document.body.appendChild(n);i=window.getComputedStyle(n).color;e.removeChild(n)}t=i.toLowerCase()}if(0==t.indexOf("#")){if(4==t.length){this.r=parseInt(t[1]+t[1],16);this.g=parseInt(t[2]+t[2],16);this.b=parseInt(t[3]+t[3],16);this.a=1;return!0}if(7==t.length){this.r=parseInt(t.substr(1,2),16);this.g=parseInt(t.substr(3,2),16);this.b=parseInt(t.substr(5,2),16);this.a=1;return!0}return!1}if(0==t.indexOf("rgb")){var r=t.indexOf("("),o=t.indexOf(")");if(r>-1&&o>-1){if((s=t.substr(r+1,o-(r+1)).split(",")).length>2){this.r=parseInt(s[0]);this.g=parseInt(s[1]);this.b=parseInt(s[2]);this.a=s.length>3?parseFloat(s[3]):1;return!0}}}if(0==t.indexOf("hsl")){r=t.indexOf("("),o=t.indexOf(")");if(r>-1&&o>-1){var s;if((s=t.substr(r+1,o-(r+1)).split(",")).length>2){var a=parseInt(s[0])/360,l=parseInt(s[1]),u=parseInt(s[2]);s[1].indexOf("%")>-1&&(l/=100);s[2].indexOf("%")>-1&&(u/=100);var c=Color._hslToRgb(a,l,u);this.r=c[0];this.g=c[1];this.b=c[2];this.a=s.length>3?parseFloat(s[3]):1;return!0}}}return!1};Color._hslToRgb=function(t,n,i){e.assert(t>=0&&t<=1&&n>=0&&n<=1&&i>=0&&i<=1,"bad HSL values");var r,o,s;if(0==n)r=o=s=i;else{var a=i<.5?i*(1+n):i+n-i*n,l=2*i-a;r=Color._hue2rgb(l,a,t+1/3);o=Color._hue2rgb(l,a,t);s=Color._hue2rgb(l,a,t-1/3)}return[Math.round(255*r),Math.round(255*o),Math.round(255*s)]};Color._hue2rgb=function(e,t,n){n<0&&(n+=1);n>1&&(n-=1);return n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e};Color._rgbToHsl=function(t,n,i){e.assert(t>=0&&t<=255&&n>=0&&n<=255&&i>=0&&i<=255,"bad RGB values");t/=255,n/=255,i/=255;var r,o,s=Math.max(t,n,i),a=Math.min(t,n,i),l=(s+a)/2;if(s==a)r=o=0;else{var u=s-a;o=l>.5?u/(2-s-a):u/(s+a);switch(s){case t:r=(n-i)/u+(n<i?6:0);break;case n:r=(i-t)/u+2;break;case i:r=(t-n)/u+4}r/=6}return[r,o,l]};Color._rgbToHsb=function(t,n,i){e.assert(t>=0&&t<=255&&n>=0&&n<=255&&i>=0&&i<=255,"bad RGB values");var r=Color._rgbToHsl(t,n,i);return Color._hslToHsb(r[0],r[1],r[2])};Color._hsbToRgb=function(e,t,n){var i=Color._hsbToHsl(e,t,n);return Color._hslToRgb(i[0],i[1],i[2])};Color._hsbToHsl=function(t,n,i){e.assert(t>=0&&t<=1&&n>=0&&n<=1&&i>=0&&i<=1,"bad HSB values");var r=e.clamp(i*(2-n)/2,0,1),o=1-Math.abs(2*r-1),s=e.clamp(o>0?i*n/o:n,0,1);e.assert(!isNaN(r)&&!isNaN(s),"bad conversion to HSL");return[t,s,r]};Color._hslToHsb=function(t,n,i){e.assert(t>=0&&t<=1&&n>=0&&n<=1&&i>=0&&i<=1,"bad HSL values");var r=e.clamp(1==i?1:(2*i+n*(1-Math.abs(2*i-1)))/2,0,1),o=e.clamp(r>0?2*(r-i)/r:n,0,1);e.assert(!isNaN(r)&&!isNaN(o),"bad conversion to HSB");return[t,o,r]};return Color}();e.Color=t}(wijmo||(wijmo={}));!function(e){"use strict";e.culture="undefined"!=typeof window&&window.wijmo&&window.wijmo.culture||{Globalize:{numberFormat:{".":".",",":",","-":"-","+":"+","%":"%",percent:{pattern:["-n%","n%"]},currency:{decimals:2,symbol:"$",pattern:["($n)","$n"]}},calendar:{"/":"/",":":":",firstDay:0,days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysAbbr:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],am:["AM","A"],pm:["PM","P"],eras:["A.D.","B.C."],patterns:{d:"M/d/yyyy",D:"dddd, MMMM dd, yyyy",f:"dddd, MMMM dd, yyyy h:mm tt",F:"dddd, MMMM dd, yyyy h:mm:ss tt",t:"h:mm tt",T:"h:mm:ss tt",M:"MMMM d",m:"MMMM d",Y:"MMMM, yyyy",y:"MMMM, yyyy",g:"M/d/yyyy h:mm tt",G:"M/d/yyyy h:mm:ss tt",s:'yyyy"-"MM"-"dd"T"HH":"mm":"ss',o:'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',O:'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',U:"dddd, MMMM dd, yyyy h:mm:ss tt"},fiscalYearOffsets:[-3,-3]}}};var t=function(){function Globalize(){}Globalize.format=function(t,n,i,r,o){if(e.isString(t))return t;if(e.isNumber(t)){n=n||(t==Math.round(t)?"n0":"n2");return Globalize.formatNumber(t,n,i,r,o)}if(e.isDate(t)){n=n||"d";return Globalize.formatDate(t,n)}return null!=t?t.toString():""};Globalize.formatNumber=function(t,n,i,r,o){t=e.asNumber(t);n=e.asString(n);var s,a=e.culture.Globalize.numberFormat,l=Globalize._parseNumericFormat(n),u=l.spec,c=l.prec,h=a["."]||".",f=a[","]||",",p=a["-"]||"-";null==c&&(c=null!=o?o:"c"==u?a.currency.decimals:"e"==u?6:"r"==u?15:t==Math.round(t)?0:2);l.scale&&(t/=Math.pow(10,l.scale));if("d"==u||"x"==u){s=Math.round(Math.abs(t)).toString("d"==u?10:16);for(;s.length<c;)s="0"+s;t<0&&(s=p+s);return"X"==l.specRaw?s.toUpperCase():s}if("p"==u){t=Globalize._shiftDecimal(t,2);t=e.toFixed(t,c,r)}r&&"p"!=u&&"e"!=u&&(t=e.toFixed(t,c,!0));switch(u){case"e":s=t.toExponential(c);"E"==l.specRaw&&(s=s.replace("e","E"));break;case"c":case"p":s=Globalize._toFixedStr(Math.abs(t),c);break;default:"-"!=(s=Globalize._toFixedStr(t,c))[0]||s.match(/[1-9]/)||(s=s.substr(1))}(i||"g"==u||"r"==u)&&s.indexOf(".")>-1&&(s=s.replace(/(\.\d*?)0+$/g,"$1").replace(/\.$/,""));"."!=h&&(s=s.replace(".",h));"-"!=p&&(s=s.replace("-",p));if(f&&("n"==u||"c"==u||"p"==l.specRaw||"F"==l.specRaw||"G"==l.specRaw)){var d=s.indexOf(h),g=/\B(?=(\d\d\d)+(?!\d))/g;s=d>-1?s.substr(0,d).replace(g,f)+s.substr(d):s.replace(g,f)}if("c"==u){var m=t<0&&s.match(/[1-9]/)?0:1,_=a.currency.pattern[m],v=l.curr||a.currency.symbol;"​"==v&&(v="");s=_.replace("n",s).replace("$",v)}if("p"==u){m=t<0&&s.match(/[1-9]/)?0:1,_=a.percent.pattern[m];var b=a["%"]||"%";s=_.replace("n",s);"%"!=b&&(s=s.replace("%",b));"-"!=p&&0==m&&(s=s.replace("-",p))}return l.prefix||l.suffix?l.prefix+s+l.suffix:s};Globalize.formatDate=function(t,n){t=e.asDate(t);switch(n){case"r":case"R":return t.toUTCString();case"u":return t.toISOString().replace(/\.\d{3}/,"")}n=Globalize._expandFormat(n);return Globalize._parseDateFormat(n).map((function(e){return Globalize._formatDatePart(t,n,e)})).join("")};Globalize.parseInt=function(e,t){return Math.round(Globalize.parseFloat(e,t))};Globalize.parseFloat=function(t,n){var i=Globalize._parseNumericFormat(n),r=i.prefix;r&&0==t.indexOf(r)&&(t=t.substring(r.length));var o=i.suffix;o&&t.lastIndexOf(o)==t.length-o.length&&(t=t.substring(0,t.length-o.length));var s=e.culture.Globalize.numberFormat,a=s["."]||".",l=s[","]||",",u=s["-"]||"-",c=s["%"]||"%",h=i.curr||s.currency.symbol||"$",f=t.indexOf(c)>-1,p=t.indexOf("(")>-1&&t.indexOf(")")>-1,d=0;if("x"==i.spec)d=parseInt(t,16);else{[h,c,"(",")"].forEach((function(e){t=t.replace(e,"")}));/\s/.test(l)&&(t=t.replace(/\s+/g,""));var g=(t=t.replace(new RegExp("\\"+l,"g"),"").replace(new RegExp("\\"+u,"g"),"-").replace(/(\+|\-)\s+/g,"$1").replace(a,".").trim()).length;if(!p&&g&&"-"==t[g-1]){p=!0;t=t.substring(0,g-1)}d=/^\s*(\+|\-)?\d*(\.\d*)?(\s*E(\+|\-)?\d+)?\s*$/i.test(t)?parseFloat(t):Number.NaN}if(!isNaN(d)){p=p||d<0;d=Math.abs(d);f&&(d=Globalize._shiftDecimal(d,-2));p&&(d=-d);i.scale&&(d*=Math.pow(10,i.scale))}return d};Globalize.parseDate=function(t,n,i){if(!(t=e.asString(t)))return null;if("u"==n)return new Date(t);var r;if("R"==n||"r"==n){var o=t.match(/((\d+)\-(\d+)\-(\d+))?\s?((\d+):(\d+)(:(\d+))?)?/);if(o[1]||o[5]){r=o[1]?new Date(parseInt(o[2]),parseInt(o[3])-1,parseInt(o[4])):new Date;if(o[5]){r.setHours(parseInt(o[6]));r.setMinutes(parseInt(o[7]));r.setSeconds(o[8]?parseInt(o[9]):0)}}else r=new Date(t);return isNaN(r.getTime())?null:r}n=Globalize._expandFormat(n||"d");var s=e.culture.Globalize.calendar,a=Globalize._CJK,l=new RegExp("(\\"+s["/"]+")|(\\"+s[":"]+")|(\\d+)|(["+a+"\\.]{2,})|(["+a+"]+)","gi"),u=t.match(l),c=Globalize._parseDateFormat(n),h=0;if(!(u&&u.length&&c&&c.length))return null;var f,p,d,g,m,_=-1,v=0,b=1,y=0,C=0,w=0,E=0,A=-1,T=null;if(i=e.asDate(i,!0)){v=i.getMonth();b=i.getDate();y=i.getHours();C=i.getMinutes();w=i.getSeconds();E=i.getMilliseconds()}for(var P=0;P<c.length&&u;P++){var x=P-h,D=x>-1&&x<u.length?u[x]:"",O=c[P].length;switch(c[P]){case"EEEE":case"EEE":case"EE":case"E":case"eeee":case"eee":case"ee":case"e":m=c[P];case"yyyy":case"yyy":case"yy":case"y":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}_=parseInt(D);g=4==D.length;break;case"MMMM":case"MMM":d=!0;var S=D.toLowerCase();v=-1;for(var F=0;F<12;F++)if(0==s.months[F].toLowerCase().indexOf(S)){v=F;break}if(v>-1)break;case"MM":case"M":d=!0;if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}v=parseInt(D)-1;break;case"dddd":case"ddd":f=!0;break;case"dd":case"d":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}b=parseInt(D);p=!0;break;case"hh":case"h":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}y=12==(y=parseInt(D))?0:y;break;case"HH":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}y=parseInt(D);break;case"H":y=parseInt(D);break;case"mm":case"m":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}C=parseInt(D);break;case"ss":case"s":if(O>1&&D.length>O){u[x]=D.substr(O);D=D.substr(0,O);h++}w=parseInt(D);break;case"fffffff":case"FFFFFFF":case"ffffff":case"FFFFFF":case"fffff":case"FFFFF":case"ffff":case"FFFF":case"fff":case"FFF":case"ff":case"FF":case"f":case"F":E=parseInt(D)/Math.pow(10,O-3);break;case"tt":case"t":D=D.toUpperCase();y<12&&s.pm.indexOf(D)>-1&&(y+=12);break;case"q":case"Q":case"u":case"U":A=parseInt(D);break;case"ggg":case"gg":case"g":T=s.eras.length>1?Globalize._getEra(D,s):null;if(s.eras.length>0&&!T)return null;break;case"/":case":":if(D&&D!=s[c[P]])return null;break;case s["/"]:case s[":"]:if(D&&D!=c[P])return null;break;case"K":break;default:Globalize._unquote(c[P]).trim()!=D.trim()&&h++}}if(d&&p){isNaN(y)&&(y=0);isNaN(C)&&(C=0);isNaN(w)&&(w=0)}if(v<0||v>11||isNaN(v)||b<1||b>31||isNaN(b)||y<0||y>=24||isNaN(y)||C<0||C>=60||isNaN(C)||w<0||w>=60||isNaN(w))return null;if(u.length+h>c.length)return null;if(m){if(!d)return null;var I=e.culture.Globalize.calendar;if(e.isArray(I.fiscalYearOffsets)){var M="E"==m[0],R=v-I.fiscalYearOffsets[M?0:1];_+=R>11?-1:R<0?1:0}}if(f&&!p)return null;!d&&A>=1&&A<=4&&(v=3*(A-1));if(isNaN(_)||_<0)_=i?i.getFullYear():(new Date).getFullYear();else if(T&&T.start)_=_+T.start.getFullYear()-1;else if(_<100&&!g){var k=e.isNumber(s.twoDigitYearMax)?s.twoDigitYearMax:2029;k>99&&(_+=_+2e3<=k?2e3:1900)}return(r=e.DateTime.newDate(_,v,b,y,C+0,w,E)).getMonth()!=v||r.getDate()!=b?null:isNaN(r.getTime())?null:r};Globalize.getFirstDayOfWeek=function(){var t=e.culture.Globalize.calendar.firstDay;return t||0};Globalize.getNumberDecimalSeparator=function(){var t=e.culture.Globalize.numberFormat["."];return t||"."};Globalize._toFixedStr=function(e,t){var n=e.toString(),i=n.indexOf("."),r=t-(n.length-i)+1,o=n.indexOf("e")>-1;if(!o&&i>-1&&r>=0)return n+Array(r+1).join("0");if(i>-1&&!o&&"5"==n[n.length-1]){e=+(Math.round(+(Math.abs(e)+"e"+t))+"e"+-t)*(e<0?-1:1)}return e.toFixed(t)};Globalize._unquote=function(e){return e.length>1&&e[0]==e[e.length-1]&&("'"==e[0]||'"'==e[0])?e.substr(1,e.length-2):e};Globalize._parseNumericFormat=function(e){var t=Globalize._numFormatInfo[e];if(!t){var n=e&&e.match(/(\"(.*?)\"\s*)?([a-z]+)\s*(\d*)\s*(,*)(\s*\"(.*?)\"\s*)?(.*)/i)||[],i=n[3]?n[3]:"n";if(i.length>1){n=[];i="n"}t={prefix:n[2]||"",spec:i.toLowerCase(),specRaw:i,prec:n[4]?parseInt(n[4]):null,scale:n[5]?3*n[5].length:0,suffix:n[7]||"",curr:n[8]||null};Globalize._numFormatInfo[e]=t}return t};Globalize._parseDateFormat=function(e){var t=Globalize._dateFormatParts[e];if(!t){t=[];if(e){var n=void 0,i=void 0;for(n=0;n>-1&&n<e.length;n++){var r=e[n];if(("'"==r||'"'==r)&&(i=e.indexOf(r,n+1))>-1){t.push(e.substring(n,i+1));n=i}else if("\\"==r&&n<e.length-1){n++;t.push('"'+e[n]+'"')}else{i=n+1;for(;i<e.length&&e[i]==r;i++);t.push(e.substring(n,i));n=i-1}}}Globalize._dateFormatParts[e]=t}return t};Globalize._formatDatePart=function(t,n,i){var r,o=e.culture.Globalize.calendar,s=null,a=0,l=0,u=i.length;switch(i){case"yyyy":case"yyy":case"yy":case"y":case"EEEE":case"EEE":case"EE":case"E":case"eeee":case"eee":case"ee":case"e":a=(r="E"==i[0]?e.DateTime.toFiscal(t,!0):"e"==i[0]?e.DateTime.toFiscal(t,!1):t).getFullYear();o.eras.length>1&&n.indexOf("g")>-1&&(s=Globalize._getEra(t,o))&&(a=e.isDate(s.start)?a-s.start.getFullYear()+1:Math.abs(a));var c=i.length<3?a%100:3==i.length?a%1e3:a;return Globalize._zeroPad(c,i.length);case"MMMMM":return o.monthsAbbr[t.getMonth()][0];case"MMMM":return o.months[t.getMonth()];case"MMM":return o.monthsAbbr[t.getMonth()];case"MM":case"M":return Globalize._zeroPad(t.getMonth()+1,u);case"dddd":return o.days[t.getDay()];case"ddd":return o.daysAbbr[t.getDay()];case"dd":return Globalize._zeroPad(t.getDate(),2);case"d":return t.getDate().toString();case"hh":case"h":return Globalize._zeroPad(Globalize._h12(t),u);case"HH":case"H":return Globalize._zeroPad(t.getHours(),u);case"mm":case"m":return Globalize._zeroPad(t.getMinutes(),u);case"ss":case"s":return Globalize._zeroPad(t.getSeconds(),u);case"fffffff":case"FFFFFFF":case"ffffff":case"FFFFFF":case"fffff":case"FFFFF":case"ffff":case"FFFF":case"fff":case"FFF":case"ff":case"FF":case"f":case"F":l=t.getMilliseconds()*Math.pow(10,u-3);return"f"==i[0]?Globalize._zeroPad(l,u):l.toFixed(0);case"tt":return t.getHours()<12?o.am[0]:o.pm[0];case"t":return t.getHours()<12?o.am[1]:o.pm[1];case"q":case"Q":return(Math.floor(t.getMonth()/3)+1).toString();case"u":case"U":r=e.DateTime.toFiscal(t,"U"==i);return(Math.floor(r.getMonth()/3)+1).toString();case"ggg":case"gg":case"g":if(o.eras.length>1&&(s=Globalize._getEra(t,o))){if(e.isString(s))return s;switch(i){case"gg":return s.name[0];case"g":return s.symbol;default:return s.name}}return o.eras[0];case":":case"/":return o[i];case"K":var h=t.toString().match(/(\+|\-)(\d{2})(\d{2})/);return h?h[1]+h[2]+h[3]:"";case"zzz":case"zz":case"z":var f=-t.getTimezoneOffset(),p=void 0;switch(i){case"zzz":p=Globalize.format(f/60,"d2",!1,!0)+o[":"]+Globalize.format(f%60,"d2",!1,!0);break;case"zz":p=Globalize.format(f/60,"d2",!1,!0);break;case"z":p=Globalize.format(f/60,"d1",!1,!0)}return f>=0?"+"+p:p}return u>1&&i[0]==i[u-1]&&('"'==i[0]||"'"==i[0])?i.substr(1,u-2):i};Globalize._getEra=function(t,n){if(n.eras){var i=n.eras,r=n.eras.length;if(e.isDate(t)){if(e.isString(i[0]))return i[t.getFullYear()>=0?0:1];if(e.isDate(i[0].start)){for(var o=0;o<r;o++)if(t>=i[o].start)return i[o];return i[r-1]}}else if(e.isString(t)&&t.length>0){t=t.toLowerCase();for(o=0;o<r;o++){var s=i[o];if(e.isString(s)){if(0==s.toLowerCase().indexOf(t))return s}else if(s.name&&0==s.name.toLowerCase().indexOf(t)||s.symbol&&0==s.symbol.toLowerCase().indexOf(t))return s}}}return null};Globalize._expandFormat=function(t){var n=e.culture.Globalize.calendar.patterns[t];return n||t};Globalize._zeroPad=function(e,t){var n=e.toFixed(0),i=t-n.length+1;return i>0?Array(i).join("0")+n:n};Globalize._h12=function(t){var n=e.culture.Globalize.calendar,i=t.getHours();n.am&&n.am[0]&&0==(i%=12)&&(i=12);return i};Globalize._shiftDecimal=function(e,t){if(0==t||isNaN(e))return e;var n=e.toString();if(n.indexOf("e")>-1)return e*Math.pow(10,t);var i=Array(Math.abs(t)+1).join("0");t<0&&(n=i+n);var r=n.indexOf(".");r<0&&(r=(n+=".").indexOf("."));t>0&&(n+=i);r+=t;n=(n=n.replace(".","")).substr(0,r)+"."+n.substr(r);return parseFloat(n)};Globalize._CJK="a-z"+"u00c0-u017fu3000-u30ffu4e00-u9faf".replace(/u/g,"\\u")+"u1100-u11ffu3130-u318fua960-ua97fuac00-ud7afud7b0-ud7ff".replace(/u/g,"\\u");Globalize._numFormatInfo={};Globalize._dateFormatParts={};return Globalize}();e.Globalize=t;e._updateCulture=function _updateCulture(t){e.culture=t};e._addCultureInfo=function _addCultureInfo(t,n){var i="undefined"!=typeof window?window.wijmo:null,r=i?i.culture:null,o=r?r[t]:null;e.culture[t]=o||n}}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function _MaskProvider(t,n,i){void 0===n&&(n="");void 0===i&&(i="_");this._promptChar="_";this._mskArr=[];this._overWrite=!1;this._full=!0;this._inputBnd=this._input.bind(this);this._keydownBnd=this._keydown.bind(this);this._keypressBnd=this._keypress.bind(this);this._cmpstartBnd=this._cmpstart.bind(this);this._cmpendBnd=this._cmpend.bind(this);this.mask=e.asString(n);this.input=t;this.promptChar=e.asString(i,!1);this._connect(!0);(this._evtInput=document.createEvent("HTMLEvents")).initEvent("input",!0,!1)}Object.defineProperty(_MaskProvider.prototype,"input",{get:function(){return this._tbx},set:function(e){this._connect(!1);this._tbx=e;this._connect(!0)},enumerable:!0,configurable:!0});Object.defineProperty(_MaskProvider.prototype,"mask",{get:function(){return this._msk},set:function(t){if(t!=this._msk){this._msk=e.asString(t,!0);this._parseMask();this._valueChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(_MaskProvider.prototype,"promptChar",{get:function(){return this._promptChar},set:function(t){if(t!=this._promptChar){this._promptChar=e.asString(t,!1);e.assert(1==this._promptChar.length,"promptChar must be a string with length 1.");this._valueChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(_MaskProvider.prototype,"overwriteMode",{get:function(){return this._overWrite},set:function(t){this._overWrite=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(_MaskProvider.prototype,"maskFull",{get:function(){return this._full},enumerable:!0,configurable:!0});_MaskProvider.prototype.getMaskRange=function(){return this._mskArr.length?[this._firstPos,this._lastPos]:[0,this._tbx.value.length-1]};_MaskProvider.prototype.getRawValue=function(){var e=this._tbx?this._tbx.value:"";if(!this.mask)return e;for(var t="",n=0;n<this._mskArr.length&&n<e.length;n++)this._mskArr[n].literal||e[n]==this._promptChar||(t+=e[n]);return t};_MaskProvider.prototype.refresh=function(){this._parseMask();this._valueChanged()};_MaskProvider.prototype._input=function(e){var t=this;if(this._msk&&!this._composing&&e!=this._evtInput){e.preventDefault();e.stopImmediatePropagation();setTimeout((function(){t._valueChanged();t._tbx&&t._tbx.dispatchEvent(t._evtInput)}))}};_MaskProvider.prototype._keydown=function(t){if(t.keyCode==e.Key.Back){var n=this._tbx.selectionStart,i=this._tbx.selectionEnd;if(n<=this._firstPos&&i==n){t.preventDefault();this._backSpace=!1;return}}this._backSpace=t.keyCode==e.Key.Back};_MaskProvider.prototype._keypress=function(e){e.ctrlKey||e.metaKey||e.altKey||this._composing||!this._preventKey(e.charCode)||e.preventDefault()};_MaskProvider.prototype._cmpstart=function(e){this._composing=!0};_MaskProvider.prototype._cmpend=function(e){var t=this;if(this._composing){this._composing=!1;setTimeout((function(){var e=t._tbx;e&&t._valueChanged()&&e.dispatchEvent(t._evtInput)}))}};_MaskProvider.prototype._preventKey=function(t){if(t&&this._mskArr.length){var n=this._tbx,i=n.selectionStart,r=String.fromCharCode(t);if(i<this._firstPos){i=this._firstPos;e.setSelectionRange(n,i)}if(i>=this._mskArr.length)return!0;var o=this._mskArr[i];if(o.literal)this._validatePosition(i);else if(o.wildCard!=r&&!this._isCharValid(o.wildCard,r))return!0}return!1};_MaskProvider.prototype._connect=function(t){var n=this._tbx;if(n){e.assert(n instanceof HTMLInputElement||n instanceof HTMLTextAreaElement,"INPUT or TEXTAREA element expected.");if(t){this._autoComplete=n.autocomplete;this._spellCheck=n.spellcheck;n.autocomplete="off";n.spellcheck=!1;n.addEventListener("input",this._inputBnd,!0);n.addEventListener("keydown",this._keydownBnd,!0);n.addEventListener("keypress",this._keypressBnd,!0);n.addEventListener("compositionstart",this._cmpstartBnd,!0);n.addEventListener("compositionend",this._cmpendBnd,!0);n.addEventListener("blur",this._cmpendBnd,!0);this._valueChanged()}else{n.autocomplete=this._autoComplete;n.spellcheck=this._spellCheck;n.removeEventListener("input",this._inputBnd,!0);n.removeEventListener("keydown",this._keydownBnd,!0);n.removeEventListener("keypress",this._keypressBnd,!0);n.removeEventListener("compositionstart",this._cmpstartBnd,!0);n.removeEventListener("compositionend",this._cmpendBnd,!0);n.removeEventListener("blur",this._cmpendBnd,!0)}}};_MaskProvider.prototype._valueChanged=function(){if(!this._tbx||!this._msk)return!1;var e=this._tbx,t=e.selectionStart,n=t>0?e.value[t-1]:"",i=e.value;e.value=this._applyMask();""==i&&(t=this._firstPos+1);var r=t>0?e.value[t-1]:"";t>0&&r==this._promptChar&&n!=this.promptChar&&t--;t==i.length&&(t=this._matchEnd);this._validatePosition(t);return i!=e.value};_MaskProvider.prototype._applyMask=function(){var e=this._tbx,t=e.value;this._full=!0;this._matchEnd=0;if(!this._msk)return t;if(!t&&!e.required)return t;if(this._overWrite&&t.length==this.mask.length+1){var n=e.selectionStart;e==document.activeElement&&e.selectionEnd==n&&(t=t.substr(0,n)+t.substr(n+1))}t=this._handleVagueLiterals(t);for(var i="",r=0,o=this._promptChar,s=0;s<this._mskArr.length;s++){var a=this._mskArr[s],l=a.literal;l&&l==t[r]&&r++;if(a.wildCard){l=o;if(t){for(var u=r;u<t.length;u++)if(this._isCharValid(a.wildCard,t[u])){l=t[u];switch(a.charCase){case">":l=l.toUpperCase();break;case"<":l=l.toLowerCase()}l!=o&&(this._matchEnd=i.length+1);break}r=u+1}l==o&&(this._full=!1)}i+=l}return i};_MaskProvider.prototype._handleVagueLiterals=function(t){if(t.length>this._mskArr.length+1)return t;var n=t.length-this._mskArr.length;if(0!=n&&t.length>1){for(var i=-1,r=this._tbx,o=r==e.getActiveElement()?r.selectionStart:r.value.length,s=Math.max(0,o-n);s<this._mskArr.length;s++)if(this._mskArr[s].vague){i=s;break}if(i>-1)if(n<0){var a=Array(1-n).join(this._promptChar),l=i+n;l>-1&&(t=t.substr(0,l)+a+t.substr(l))}else{for(;i>0&&this._mskArr[i-1].literal;)i--;t=t.substr(0,i)+t.substr(i+n)}}return t};_MaskProvider.prototype._isCharValid=function(e,t){if(t==this._promptChar)return!0;switch(e){case"0":return this._isDigit(t);case"9":return this._isDigit(t)||" "==t;case"#":return this._isDigit(t)||" "==t||"+"==t||"-"==t;case"L":return this._isLetter(t);case"l":return this._isLetter(t)||" "==t;case"A":return this._isDigit(t)||this._isLetter(t);case"a":return this._isDigit(t)||this._isLetter(t)||" "==t;case"９":return t>="０"&&t<="９";case"Ｊ":case"Ｇ":return!("Ｇ"==e&&_MaskProvider._X_DBCS_BIG_HIRA.indexOf(t)>-1)&&(t>="ぁ"&&t<="ゟ");case"Ｋ":case"Ｎ":return!("Ｎ"==e&&_MaskProvider._X_DBCS_BIG_KATA.indexOf(t)>-1)&&(t>="゠"&&t<="ヿ");case"Ｚ":return!(t>="ｦ"&&t<="ﾟ")&&(t<="!"||t>="ÿ");case"H":return t>="!"&&t<="ÿ"||t>="ｦ"&&t<="ﾟ";case"K":case"N":return!("N"==e&&_MaskProvider._X_SBCS_BIG_KATA.indexOf(t)>-1)&&(t>="ｦ"&&t<="ﾟ")}return!1};_MaskProvider.prototype._isDigit=function(e){return e>="0"&&e<="9"};_MaskProvider.prototype._isLetter=function(e){return e>="a"&&e<="z"||e>="A"&&e<="Z"};_MaskProvider.prototype._validatePosition=function(t){var n=this._mskArr;if(this._backSpace)for(;t>0&&t<n.length&&n[t-1].literal;)t--;if(0==t||!this._backSpace)for(;t<n.length&&n[t].literal;)t++;e.getActiveElement()==this._tbx&&e.setSelectionRange(this._tbx,t);this._backSpace=!1};_MaskProvider.prototype._parseMask=function(){this._mskArr=[];this._firstPos=-1;this._lastPos=-1;for(var t,i=this._msk,r="|",o=0;i&&o<i.length;o++)switch(i[o]){case"0":case"9":case"#":case"A":case"a":case"L":case"l":case"９":case"Ｊ":case"Ｇ":case"Ｋ":case"Ｎ":case"Ｚ":case"K":case"N":case"H":this._firstPos<0&&(this._firstPos=this._mskArr.length);this._lastPos=this._mskArr.length;this._mskArr.push(new n(i[o],r));break;case".":case",":case":":case"/":case"$":switch(i[o]){case".":case",":t=e.culture.Globalize.numberFormat[i[o]];break;case":":case"/":t=e.culture.Globalize.calendar[i[o]];break;case"$":t=e.culture.Globalize.numberFormat.currency.symbol}for(var s=0;s<t.length;s++)this._mskArr.push(new n(t[s]));break;case"<":case">":case"|":r=i[o];break;case"\\":o<i.length-1&&o++;this._mskArr.push(new n(i[o]));break;default:this._mskArr.push(new n(i[o]))}for(o=0;o<this._mskArr.length;o++){var a=this._mskArr[o];if(a.literal)for(s=0;s<o;s++){var l=this._mskArr[s];if(l.wildCard&&this._isCharValid(l.wildCard,a.literal)){a.vague=!0;break}}}};_MaskProvider._X_DBCS_BIG_HIRA="ぁぃぅぇぉっゃゅょゎゕゖ";_MaskProvider._X_DBCS_BIG_KATA="ァィゥェォッャュョヮヵヶ";_MaskProvider._X_SBCS_BIG_KATA="ｧｨｩｪｫｬｭｮｯ";return _MaskProvider}();e._MaskProvider=t;var n=function n(e,t){if(t){this.wildCard=e;this.charCase=t}else this.literal=e};e._MaskElement=n}(wijmo||(wijmo={}));!function(e){"use strict";var t;!function(e){e[e.None=0]="None";e[e.Sum=1]="Sum";e[e.Cnt=2]="Cnt";e[e.Avg=3]="Avg";e[e.Max=4]="Max";e[e.Min=5]="Min";e[e.Rng=6]="Rng";e[e.Std=7]="Std";e[e.Var=8]="Var";e[e.StdPop=9]="StdPop";e[e.VarPop=10]="VarPop";e[e.CntAll=11]="CntAll";e[e.First=12]="First";e[e.Last=13]="Last"}(t=e.Aggregate||(e.Aggregate={}));e.getAggregate=function getAggregate(n,i,r){var o=0,s=0,a=0,l=0,u=null,c=null,h=null,f=r?new e.Binding(r):null;if((n=e.asEnum(n,t))==t.CntAll)return i.length;for(var p=0;p<i.length;p++){var d=i[p];f&&(d=f.getValue(d));if(null!=d){if(n==t.First)return d;o++;(null==u||d<u)&&(u=d);(null==c||d>c)&&(c=d);h=d;if(e.isNumber(d)&&!isNaN(d)){s++;a+=d;l+=d*d}else if(e.isBoolean(d)){s++;if(1==d){a++;l++}}}}var g=0==s?0:a/s;switch(n){case t.Avg:return g;case t.Cnt:return o;case t.Max:return c;case t.Min:return u;case t.Rng:return c-u;case t.Sum:return a;case t.VarPop:return s<=1?0:l/s-g*g;case t.StdPop:return s<=1?0:Math.sqrt(l/s-g*g);case t.Var:return s<=1?0:(l/s-g*g)*s/(s-1);case t.Std:return s<=1?0:Math.sqrt((l/s-g*g)*s/(s-1));case t.Last:return h}throw"Invalid aggregate type."}}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var n=function(e){__extends(ArrayBase,e);function ArrayBase(){var t=this;i?t.length=0:t=e.call(this)||this;return t}return ArrayBase}(Array);t.ArrayBase=n;var i=!0;try{n.prototype=Array.prototype;i=n.prototype===Array.prototype}catch(e){i=!1}var r="undefined"!=typeof window?window.Symbol:null;!i&&r&&r.species&&Object.defineProperty(n,r.species,{get:function(){return Array},enumerable:!1,configurable:!1});var o=function(n){__extends(ObservableArray,n);function ObservableArray(t){var i=n.call(this)||this;i._updating=0;i.collectionChanged=new e.Event;if(t){t=e.asArray(t);i._updating++;for(var r=0;r<t.length;r++)i.push(t[r]);i._updating--}return i}ObservableArray.prototype.push=function(){for(var e=this,i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];i.forEach((function(i){n.prototype.push.call(e,i);e._raiseCollectionChanged(t.NotifyCollectionChangedAction.Add,i,e.length-1)}));return this.length};ObservableArray.prototype.shift=function(){var e=n.prototype.shift.call(this);this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Remove,e,0);return e};ObservableArray.prototype.unshift=function(){for(var e=[],i=0;i<arguments.length;i++)e[i]=arguments[i];var r=n.prototype.unshift.apply(this,e);1==e.length?this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Add,e[0],0):this._raiseCollectionChanged();return r};ObservableArray.prototype.pop=function(){var e=n.prototype.pop.call(this);this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Remove,e,this.length);return e};ObservableArray.prototype.splice=function(e,i){for(var r=[],o=2;o<arguments.length;o++)r[o-2]=arguments[o];var s,a=t.NotifyCollectionChangedAction,l=this._raiseCollectionChanged.bind(this);if(i&&r.length){s=n.prototype.splice.apply(this,[e,i].concat(r));1==i&&1==r.length?l(a.Change,r[0],e):l()}else if(r.length){s=n.prototype.splice.apply(this,[e,0].concat(r));1==r.length?l(a.Add,r[0],e):l()}else{s=n.prototype.splice.call(this,e,i);1==i?l(a.Remove,s[0],e):l()}return s};ObservableArray.prototype.slice=function(e,t){return n.prototype.slice.call(this,e,t)};ObservableArray.prototype.indexOf=function(e,t){return n.prototype.indexOf.call(this,e,t)};ObservableArray.prototype.sort=function(e){var t=n.prototype.sort.call(this,e);this._raiseCollectionChanged();return t};ObservableArray.prototype.insert=function(e,t){this.splice(e,0,t)};ObservableArray.prototype.remove=function(e){var t=this.indexOf(e);t>-1&&this.removeAt(t);return t>-1};ObservableArray.prototype.removeAt=function(e){this.splice(e,1)};ObservableArray.prototype.setAt=function(e,t){e>=this.length&&(this.length=e+1);this.splice(e,1,t)};ObservableArray.prototype.clear=function(){this.length&&this.splice(0,this.length)};ObservableArray.prototype.beginUpdate=function(){this._updating++};ObservableArray.prototype.endUpdate=function(){this._updating--;this._updating<=0&&this._raiseCollectionChanged()};Object.defineProperty(ObservableArray.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0});ObservableArray.prototype.deferUpdate=function(e){try{this.beginUpdate();e()}finally{this.endUpdate()}};ObservableArray.prototype.implementsInterface=function(e){return"INotifyCollectionChanged"==e};ObservableArray.prototype.onCollectionChanged=function(e){void 0===e&&(e=t.NotifyCollectionChangedEventArgs.reset);this.isUpdating||this.collectionChanged.raise(this,e)};ObservableArray.prototype._raiseCollectionChanged=function(e,n,i){void 0===e&&(e=t.NotifyCollectionChangedAction.Reset);if(!this.isUpdating){var r=new t.NotifyCollectionChangedEventArgs(e,n,i);this.onCollectionChanged(r)}};return ObservableArray}(n);t.ObservableArray=o}(e.collections||(e.collections={}))}(wijmo||(wijmo={}));!function(e){!function(t){var n;!function(e){e[e.Natural=0]="Natural";e[e.First=1]="First";e[e.Last=2]="Last"}(n=t.SortNulls||(t.SortNulls={}));var i=function(){function CollectionView(i,r){var o=this;this._srcRaw=null;this._src=null;this._ncc=null;this._view=null;this._pgView=null;this._groups=null;this._fullGroups=null;this._digest="";this._idx=-1;this._filter=null;this._filters=new t.ObservableArray;this._srtDsc=new t.ObservableArray;this._grpDesc=new t.ObservableArray;this._newItem=null;this._edtItem=null;this._edtClone=null;this._committing=!1;this._canceling=!1;this._pendingRefresh=!1;this._pendingRemove=!1;this._pgSz=0;this._pgIdx=0;this._updating=0;this._stableSort=!1;this._srtNulls=n.Last;this._canFilter=!0;this._canGroup=!0;this._canSort=!0;this._canAddNew=!0;this._canCancelEdit=!0;this._canRemove=!0;this._canChangePage=!0;this._refreshOnEdit=!0;this._trackChanges=!1;this._chgAdded=new t.ObservableArray;this._chgRemoved=new t.ObservableArray;this._chgEdited=new t.ObservableArray;this._orgVals=window.Map?new Map:null;this._srtCvt=null;this._srtCmp=null;this._getError=null;this._keepCurrentItem=null;this._initializing=!1;this.collectionChanged=new e.Event;this.sourceCollectionChanging=new e.Event;this.sourceCollectionChanged=new e.Event;this.currentChanged=new e.Event;this.currentChanging=new e.Event;this.pageChanged=new e.Event;this.pageChanging=new e.Event;this._srtDsc.collectionChanged.addHandler((function(){o._srtDsc.forEach((function(n){e.assert(n instanceof t.SortDescription,"sortDescriptions array must contain SortDescription objects.")}));o.canSort&&o._commitAndRefresh()}));this._grpDesc.collectionChanged.addHandler((function(){o._grpDesc.forEach((function(n){e.assert(n instanceof t.GroupDescription,"groupDescriptions array must contain GroupDescription objects.")}));o.canGroup&&o._commitAndRefresh()}));this._filters.collectionChanged.addHandler((function(){o._filters.forEach((function(t){e.assert(e.isFunction(t),"filters array must contain IPredicate functions.")}));o.canFilter&&o._commitAndRefresh()}));this.sourceCollection=i||new t.ObservableArray;if(r){this._initializing=!0;this.deferUpdate((function(){e.copy(o,r)}));this._initializing=!1}null==this._keepCurrentItem&&(this._keepCurrentItem=!0)}CollectionView.prototype._copy=function(n,i){switch(n){case"sortDescriptions":var r=this.sortDescriptions;r.deferUpdate((function(){r.clear();e.asArray(i).forEach((function(n){e.isString(n)?n=new t.SortDescription(n,!0):n instanceof t.SortDescription||!n.property||(n=new t.SortDescription(n.property,n.ascending));r.push(n)}))}));return!0;case"groupDescriptions":var o=this.groupDescriptions;o.deferUpdate((function(){o.clear();i.forEach((function(n){e.isString(n)&&(n=new t.PropertyGroupDescription(n));o.push(n)}))}));return!0;case"currentItem":this.currentItem=i;return!0}return!1};Object.defineProperty(CollectionView.prototype,"calculatedFields",{get:function(){return this._calcFields},set:function(e){if(e&&!window.Proxy){console.warn("** Calculated fields require Proxy (see https://www.npmjs.com/package/proxy-polyfill).");e=null}if(e!=this._calcFields){this._calcFields=e;var t=this._srcRaw;this._srcRaw=null;this.sourceCollection=t}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"newItemCreator",{get:function(){return this._itemCreator},set:function(t){this._itemCreator=e.asFunction(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sortConverter",{get:function(){return this._srtCvt},set:function(t){t!=this._srtCvt&&(this._srtCvt=e.asFunction(t,!0))},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sortComparer",{get:function(){return this._srtCmp},set:function(t){t!=this._srtCmp&&(this._srtCmp=e.asFunction(t,!0))},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"useStableSort",{get:function(){return this._stableSort},set:function(t){if(t!=this._stableSort){this._stableSort=e.asBoolean(t);this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sortNulls",{get:function(){return this._srtNulls},set:function(t){if((t=e.asEnum(t,n))!=this._srtNulls){this._srtNulls=t;this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sortNullsFirst",{get:function(){return this.sortNulls!=n.Last},set:function(t){e._deprecated("sortNullsFirst","sortNulls");this.sortNulls=e.asBoolean(t)?n.First:n.Last},enumerable:!0,configurable:!0});CollectionView.prototype.getAggregate=function(t,n,i){var r=i?this._pgView:this._view;return e.getAggregate(t,r,n)};Object.defineProperty(CollectionView.prototype,"trackChanges",{get:function(){return this._trackChanges},set:function(t){this._trackChanges=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"refreshOnEdit",{get:function(){return this._refreshOnEdit},set:function(t){this._refreshOnEdit=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"itemsAdded",{get:function(){return this._chgAdded},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"itemsRemoved",{get:function(){return this._chgRemoved},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"itemsEdited",{get:function(){return this._chgEdited},enumerable:!0,configurable:!0});CollectionView.prototype.clearChanges=function(){this._chgAdded.clear();this._chgRemoved.clear();this._chgEdited.clear();this._orgVals&&this._orgVals.clear()};CollectionView.prototype.implementsInterface=function(e){switch(e){case"ICollectionView":case"IEditableCollectionView":case"IPagedCollectionView":case"INotifyCollectionChanged":return!0}return!1};Object.defineProperty(CollectionView.prototype,"getError",{get:function(){return this._getError},set:function(t){if(this._getError!=t){this._getError=e.asFunction(t);this._raiseCollectionChanged()}},enumerable:!0,configurable:!0});CollectionView.prototype.onCollectionChanged=function(e){void 0===e&&(e=t.NotifyCollectionChangedEventArgs.reset);e.action!=t.NotifyCollectionChangedAction.Change||this._committing||this._canceling||e.item==this.currentEditItem||e.item==this.currentAddItem||this._trackItemChanged(e.item);this._updating||this.collectionChanged.raise(this,e)};CollectionView.prototype._raiseCollectionChanged=function(e,n,i){void 0===e&&(e=t.NotifyCollectionChangedAction.Reset);var r=new t.NotifyCollectionChangedEventArgs(e,n,i);this.onCollectionChanged(r)};CollectionView.prototype.onSourceCollectionChanging=function(e){this.sourceCollectionChanging.raise(this,e);return!e.cancel};CollectionView.prototype.onSourceCollectionChanged=function(e){this.sourceCollectionChanged.raise(this,e)};Object.defineProperty(CollectionView.prototype,"canFilter",{get:function(){return this._canFilter},set:function(t){this._canFilter=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"canGroup",{get:function(){return this._canGroup},set:function(t){this._canGroup=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"canSort",{get:function(){return this._canSort},set:function(t){this._canSort=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"currentItem",{get:function(){return this._pgView&&this._idx>-1&&this._idx<this._pgView.length?this._pgView[this._idx]:null},set:function(e){this.moveCurrentTo(e)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"currentPosition",{get:function(){return this._idx},set:function(t){this.moveCurrentToPosition(e.asNumber(t))},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"filter",{get:function(){return this._filter},set:function(t){if(this._filter!=t){this._filter=e.asFunction(t);this.canFilter&&this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"filters",{get:function(){return this._filters},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"groupDescriptions",{get:function(){return this._grpDesc},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"groups",{get:function(){return this._groups},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"isEmpty",{get:function(){return!this._pgView||!this._pgView.length},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sortDescriptions",{get:function(){return this._srtDsc},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"sourceCollection",{get:function(){return this._src},set:function(t){if(t!=this._srcRaw){if(!this.onSourceCollectionChanging(new e.CancelEventArgs))return;var n=this.currentPosition;this.commitEdit();null!=this._ncc&&this._ncc.collectionChanged.removeHandler(this._sourceChanged);this._srcRaw=t;this._src=e.asArray(t,!1);this._calcFields&&(this._src=e._getCalculatedArray(this._src,this._calcFields));this._ncc=e.tryCast(this._src,"INotifyCollectionChanged");this._ncc&&this._ncc.collectionChanged.addHandler(this._sourceChanged,this);this.clearChanges();this.refresh();this.moveCurrentToFirst();this.onSourceCollectionChanged();this.currentPosition<0&&n>-1&&this.onCurrentChanged()}},enumerable:!0,configurable:!0});CollectionView.prototype._sourceChanged=function(e,t){this._updating<=0&&this.refresh()};CollectionView.prototype.contains=function(e){return this._pgView.indexOf(e)>-1};CollectionView.prototype.moveCurrentTo=function(e){return this.moveCurrentToPosition(this._pgView.indexOf(e))};CollectionView.prototype.moveCurrentToFirst=function(){return this.moveCurrentToPosition(0)};CollectionView.prototype.moveCurrentToLast=function(){return this.moveCurrentToPosition(this._pgView.length-1)};CollectionView.prototype.moveCurrentToPrevious=function(){return this._idx>0&&this.moveCurrentToPosition(this._idx-1)};CollectionView.prototype.moveCurrentToNext=function(){return this.moveCurrentToPosition(this._idx+1)};CollectionView.prototype.moveCurrentToPosition=function(t){if(t>=-1&&t<this._pgView.length&&t!=this._idx){var n=new e.CancelEventArgs;if(this.onCurrentChanging(n)){var i=this._pgView[t],r=e._getTargetObject(i),o=this._edtItem,s=this._newItem;o&&o!=i&&o!=r?this.commitEdit():s&&s!=i&&s!=r&&this.commitNew();this._idx=t;this.onCurrentChanged()}}return this._idx==t};CollectionView.prototype.refresh=function(){if(this._newItem||this._edtItem||this._updating>0)this._pendingRefresh=!0;else{var e=this.currentItem;this._performRefresh();this.onCollectionChanged();e==this.currentItem||this._initializing||this.onCurrentChanged()}};CollectionView.prototype._commitAndRefresh=function(){if(this.currentEditItem||this.currentAddItem){this._pendingRefresh=!0;this.commitEdit()}else this.refresh()};CollectionView.prototype._performRefresh=function(){if(this._updating>0)this._pendingRefresh=!0;else{this._pendingRefresh=!1;this._pendingRemove=!1;var t=this.currentItem;this._view=this._src?this._performFilter(this._src):[];if(this.canSort&&this._srtDsc.length>0){this._view==this._src&&(this._view=this._src.slice());this._performSort(this._view)}this._groups=this.canGroup?this._createGroups(this._view):null;this._fullGroups=this._groups;this._groups&&(this._view=this._mergeGroupItems(this._groups));this._pgIdx=e.clamp(this._pgIdx,0,this.pageCount-1);this._pgView=this._getPageView();if(this._groups&&this.pageCount>1){this._groups=this._createGroups(this._pgView);this._mergeGroupItems(this._groups)}var n=this._keepCurrentItem&&null!=t?this._pgView.indexOf(t):-1;n<0&&(n=Math.min(this._idx,this._pgView.length-1));this._idx=n;this._digest=this._getGroupsDigest(this.groups)}};CollectionView.prototype._performSort=function(e){if(this._stableSort){var t=e.map((function(e,t){return{item:e,index:t}})),n=this._compareItems();t.sort((function(e,t){var i=n(e.item,t.item);return 0==i?e.index-t.index:i}));for(var i=0;i<e.length;i++)e[i]=t[i].item}else e.sort(this._compareItems())};CollectionView.prototype._compareItems=function(){var e=this,t=this._srtDsc,i=this._srtCvt,r=this._srtCmp,o=CollectionView._collator,s=!0,a=0;return function(l,u){for(var c=0;c<t.length;c++){var h=t[c],f=h._bnd.getValue(l),p=h._bnd.getValue(u);if(i){f=i(h,l,f,s);p=i(h,u,p,!1);s=!1}if(r&&null!=(a=r(f,p))){if(0!=a)return h.ascending?+a:-a}else{f!=f&&(f=null);p!=p&&(p=null);if(f!==p&&(null==f||null==p))switch(e._srtNulls){case n.First:return null==f?-1:1;case n.Last:return null==f?1:-1;default:a=null==f?-1:1;return h.ascending?+a:-a}if("string"==typeof f&&"string"==typeof p){if(o){if(0!=(a=o.compare(f,p)))return h.ascending?+a:-a;continue}var d=f.toLowerCase(),g=p.toLowerCase();if(d!=g){f=d;p=g}}if(0!=(a=f<p?-1:f>p?1:0))return h.ascending?+a:-a}}return 0}};CollectionView.prototype._performFilter=function(e){return this.canFilter&&this._filter||this._filters.length?e.filter(this._filterItem,this):e};CollectionView.prototype._filterItem=function(e){for(var t=!this.canFilter||!this._filter||this._filter(e),n=0;n<this._filters.length&&t;n++)t=this._filters[n](e);return t};CollectionView.prototype.onCurrentChanged=function(e){this.currentChanged.raise(this,e)};CollectionView.prototype.onCurrentChanging=function(e){this.currentChanging.raise(this,e);return!e.cancel};Object.defineProperty(CollectionView.prototype,"items",{get:function(){return this._pgView},enumerable:!0,configurable:!0});CollectionView.prototype.beginUpdate=function(){this._updating++};CollectionView.prototype.endUpdate=function(e){void 0===e&&(e=!0);this._updating--;e&&(this._pendingRefresh=!0);if(this._updating<=0){this._pendingRefresh&&this.refresh();if(this._pendingRemove){this._pendingRemove=!1;this._raiseCollectionChanged()}}};Object.defineProperty(CollectionView.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0});CollectionView.prototype.deferUpdate=function(e,t){void 0===t&&(t=!0);try{this.beginUpdate();e()}finally{this.endUpdate(t)}};Object.defineProperty(CollectionView.prototype,"canAddNew",{get:function(){return this._canAddNew},set:function(t){if(t!=this._canAddNew){this._canAddNew=e.asBoolean(t);this._raiseCollectionChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"canCancelEdit",{get:function(){return this._canCancelEdit},set:function(t){this._canCancelEdit=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"canRemove",{get:function(){return this._canRemove},set:function(t){this._canRemove=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"currentAddItem",{get:function(){return this._newItem},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"currentEditItem",{get:function(){return this._edtItem},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"isAddingNew",{get:function(){return null!=this._newItem},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"isEditingItem",{get:function(){return null!=this._edtItem},enumerable:!0,configurable:!0});CollectionView.prototype.editItem=function(e){if(e!=this._edtItem&&this.moveCurrentTo(e)){this.commitEdit();this._edtItem=e;this._edtClone={};this._extend(this._edtClone,this._edtItem)}};CollectionView.prototype.commitEdit=function(){var e=this._edtItem,n=this._edtClone;if(null!=e){this._committing=!0;var i=this._getChangedFields(e,n),r=this._pendingRefresh;this._edtItem=null;this._edtClone=null;var o=this._pgView.indexOf(e),s=this._digest;this._needRefresh(i)&&this._refreshOnEdit&&this._performRefresh();i&&this._trackItemChanged(e,n);this._pgView.indexOf(e)!=o||s!=this._digest||r?this._raiseCollectionChanged():this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Change,e,o);this.commitNew();this._committing=!1;if(this.sourceCollection instanceof t.ObservableArray){this._updating++;var a=new t.NotifyCollectionChangedEventArgs(t.NotifyCollectionChangedAction.Change,e);this.sourceCollection.onCollectionChanged(a);this._updating--}}};CollectionView.prototype.cancelEdit=function(){var e=this._edtItem;if(null!=e){this._edtItem=null;if(!this.canCancelEdit)return;var n=this._src.indexOf(e);if(n>=0&&this._edtClone){this._extend(this._src[n],this._edtClone);this._edtClone=null;this._canceling=!0;this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Change,e,n);this._canceling=!1;if(this._pendingRefresh&&this._refreshOnEdit){this._performRefresh();this._raiseCollectionChanged()}}}};CollectionView.prototype.addNew=function(e,n){void 0===n&&(n=!1);this.commitEdit();if(!this.canAddNew)return null;var i=this.sourceCollection;null==e&&(e=this.newItemCreator?this.newItemCreator():i&&i.length?new i[0].constructor:{});if(null!=e){this._updating++;i.push(e);this._updating--;e=i[i.length-1];this._newItem=e;this._pgView!=this._src&&this._pgView.push(e);if(this.groups&&this.groups.length){var r=this.groups[this.groups.length-1];r.items.push(e);for(;r.groups&&r.groups.length;)(r=r.groups[r.groups.length-1]).items.push(e)}this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Add,e,this._pgView.length-1);this.moveCurrentTo(e);n&&this.commitNew()}return this._newItem};CollectionView.prototype.commitNew=function(){var e=this._newItem;if(null!=e){this._newItem=null;var n=this._pgView.indexOf(e),i=this._digest;this._refreshOnEdit&&this._performRefresh();if(this._trackChanges){var r=this._chgEdited.indexOf(e);r>-1&&this._chgEdited.removeAt(r);this._chgAdded.indexOf(e)<0&&this._chgAdded.push(e)}this._pgView.indexOf(e)!=n||i!=this._digest||this.calculatedFields?this._raiseCollectionChanged():this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Change,e,n)}};CollectionView.prototype.cancelNew=function(){var e=this._newItem;null!=e&&this.remove(e)};CollectionView.prototype.remove=function(e){var n=e==this._newItem;n&&(this._newItem=null);e==this._edtItem&&this.cancelEdit();if(this.canRemove){var i=this._src.indexOf(e);if(i>-1){var r=this.currentItem;this._updating++;this._src.splice(i,1);this._updating--;var o=this._digest;if(this._refreshOnEdit)this._performRefresh();else{this._updating>0&&(this._pendingRemove=!0);var s=this._pgView.indexOf(e);s>=0&&this._pgView.splice(s,1)}if(this._trackChanges){var a=this._chgAdded.indexOf(e);a>-1&&this._chgAdded.removeAt(a);var l=this._chgEdited.indexOf(e);l>-1&&this._chgEdited.removeAt(l);this._chgRemoved.indexOf(e)<0&&!n&&a<0&&this._chgRemoved.push(e)}var u=this.sortDescriptions.length>0,c=this.pageSize>0&&this._pgIdx>-1;u||c||o!=this._getGroupsDigest(this.groups)?this._raiseCollectionChanged():this._raiseCollectionChanged(t.NotifyCollectionChangedAction.Remove,e,i);this.currentItem!==r&&this.onCurrentChanged()}}};CollectionView.prototype.removeAt=function(t){t=e.asInt(t);this.remove(this._pgView[t])};CollectionView.prototype._trackItemChanged=function(e,n){if(this._trackChanges){var i=this.sourceCollection;if(i&&i.indexOf(e)>-1){var r=this._orgVals,o=r?r.get(e):null;if(n&&!o&&r){r.set(e,n);o=n}var s=this._chgEdited.indexOf(e),a=t.NotifyCollectionChangedAction.Change;if(o&&this._sameContent(e,o)&&s>-1){this._chgEdited.removeAt(s);r.delete(e);return}if(s<0&&this._chgAdded.indexOf(e)<0)this._chgEdited.push(e);else if(s>-1){var l=new t.NotifyCollectionChangedEventArgs(a,e,s);this._chgEdited.onCollectionChanged(l)}else if((s=this._chgAdded.indexOf(e))>-1){l=new t.NotifyCollectionChangedEventArgs(a,e,s);this._chgAdded.onCollectionChanged(l)}}}};CollectionView.prototype._extend=function(t,n,i){void 0===i&&(i=2);for(var r in n)try{var o=n[r];if(i>0&&e.isObject(o)){t[r]={};this._extend(t[r],o,i-1)}else t[r]=o}catch(e){}};CollectionView.prototype._getChangedFields=function(t,n,i){void 0===i&&(i=2);e.assert(null!=n&&null!=t,"Two objects expected.");var r={};for(var o in n)try{this._sameValue(t[o],n[o],i)||(r[o]=!0)}catch(e){}for(var o in t)try{r[o]||this._sameValue(t[o],n[o],i)||(r[o]=!0)}catch(e){}var s=Object.keys(r);return s.length?s:null};CollectionView.prototype._sameValue=function(t,n,i){void 0===i&&(i=2);return!(t!==n&&!e.DateTime.equals(t,n))||!(!e.isObject(t)||!e.isObject(n))&&(!(i>0)||null==this._getChangedFields(t,n,i-1))};CollectionView.prototype._sameContent=function(e,t){return null==this._getChangedFields(e,t)};CollectionView.prototype._needRefresh=function(e){if(this._pendingRefresh)return!0;if(!e)return!1;if(this._filter)return!0;for(var n=0;n<this._srtDsc.length;n++){var i=this._getBindingRoot(this._srtDsc[n].property);if(e.indexOf(i)>-1)return!0}for(n=0;n<this._grpDesc.length;n++){var r=this._grpDesc[n];if(!(r instanceof t.PropertyGroupDescription))return!0;i=this._getBindingRoot(r.propertyName);if(e.indexOf(i)>-1)return!0}return!1};CollectionView.prototype._getBindingRoot=function(e){var t=e.indexOf(".");return t>-1?e.substr(0,t):e};Object.defineProperty(CollectionView.prototype,"canChangePage",{get:function(){return this._canChangePage},set:function(t){this._canChangePage=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"isPageChanging",{get:function(){return!1},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"itemCount",{get:function(){return this._pgView.length},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"pageIndex",{get:function(){return this._pgIdx},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"pageSize",{get:function(){return this._pgSz},set:function(t){if(t!=this._pgSz){this._pgSz=e.asInt(t);this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"totalItemCount",{get:function(){return this._view.length},enumerable:!0,configurable:!0});Object.defineProperty(CollectionView.prototype,"pageCount",{get:function(){return this.pageSize?Math.ceil(this.totalItemCount/this.pageSize):1},enumerable:!0,configurable:!0});CollectionView.prototype.moveToFirstPage=function(){return this.moveToPage(0)};CollectionView.prototype.moveToLastPage=function(){return this.moveToPage(this.pageCount-1)};CollectionView.prototype.moveToPreviousPage=function(){return this.moveToPage(this.pageIndex-1)};CollectionView.prototype.moveToNextPage=function(){return this.moveToPage(this.pageIndex+1)};CollectionView.prototype.moveToPage=function(n){var i=e.clamp(n,0,this.pageCount-1);if(i!=this._pgIdx){if(!this.canChangePage)return!1;var r=new t.PageChangingEventArgs(i);if(this.onPageChanging(r)&&this.onCurrentChanging(r)){this.commitEdit();this.commitNew();var o=this.currentItem;this._pgIdx=i;this._pgView=this._getPageView();this._idx=0;if(this.groupDescriptions&&0!=this.groupDescriptions.length)this.refresh();else{this.onCollectionChanged();o!=this.currentItem&&this.onCurrentChanged()}this.onPageChanged()}}return this._pgIdx==n};CollectionView.prototype.onPageChanged=function(e){this.pageChanged.raise(this,e)};CollectionView.prototype.onPageChanging=function(e){this.pageChanging.raise(this,e);return!e.cancel};CollectionView.prototype._getFullGroup=function(e){var t=this._getGroupByPath(this._fullGroups,e.level,e._path);null!=t&&(e=t);return e};CollectionView.prototype._getGroupByPath=function(e,t,n){if(e)for(var i=0;i<e.length;i++){var r=e[i];if(r.level==t&&r._path==n)return r;if(r.level<t&&0==n.indexOf(r._path)&&null!=(r=this._getGroupByPath(r.groups,t,n)))return r}return null};CollectionView.prototype._getPageView=function(){if(this.pageSize<=0||this._pgIdx<0)return this._view;var e=this._pgSz*this._pgIdx,t=Math.min(e+this._pgSz,this._view.length);return this._view.slice(e,t)};CollectionView.prototype._createGroups=function(t){var n=this;if(!this._grpDesc||!this._grpDesc.length)return null;var i=[],r={},o=null;t.forEach((function(t){for(var s=i,a=n._grpDesc.length,l="",u=0;u<a;u++){var c=n._grpDesc[u],h=c.groupNameFromItem(t,u),f=u==a-1;if(!(o=r[l])&&e.isPrimitive(h)){o={};r[l]=o}var p=n._getGroup(c,s,o,h,u,f);l+="/"+h;p._path=l;f&&p.items.push(t);s=p.groups}}));return i};CollectionView.prototype._getGroupsDigest=function(e){for(var t="",n=0;null!=e&&n<e.length;n++){var i=e[n];t+="{"+i.name+":"+(i.items?i.items.length:"*");if(i.groups.length>0){t+=",";t+=this._getGroupsDigest(i.groups)}t+="}"}return t};CollectionView.prototype._mergeGroupItems=function(e){for(var t=[],n=0;n<e.length;n++){var i=e[n];if(!i._isBottomLevel)for(var r=this._mergeGroupItems(i.groups),o=0,s=r.length;o<s;o++)i._items.push(r[o]);for(o=0,s=i._items.length;o<s;o++)t.push(i._items[o])}return t};CollectionView.prototype._getGroup=function(t,n,i,o,s,a){var l;if(i&&e.isPrimitive(o)){if(l=i[o])return l}else for(var u=0;u<n.length;u++)if(t.namesMatch(n[u].name,o))return n[u];var c=new r(t,o,s,a);n.push(c);i&&(i[o]=c);return c};CollectionView._collator="undefined"!=typeof window&&window.Intl&&Intl.Collator?new Intl.Collator:null;return CollectionView}();t.CollectionView=i;var r=function(){function CollectionViewGroup(e,t,n,i){this._gd=e;this._name=t;this._level=n;this._isBottomLevel=i;this._groups=[];this._items=[]}Object.defineProperty(CollectionViewGroup.prototype,"name",{get:function(){return this._name},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewGroup.prototype,"level",{get:function(){return this._level},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewGroup.prototype,"isBottomLevel",{get:function(){return this._isBottomLevel},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewGroup.prototype,"items",{get:function(){return this._items},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewGroup.prototype,"groups",{get:function(){return this._groups},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewGroup.prototype,"groupDescription",{get:function(){return this._gd},enumerable:!0,configurable:!0});CollectionViewGroup.prototype.getAggregate=function(t,n,r){var o=e.tryCast(r,i),s=o?o._getFullGroup(this):this;return e.getAggregate(t,s.items,n)};return CollectionViewGroup}();t.CollectionViewGroup=r}(e.collections||(e.collections={}))}(wijmo||(wijmo={}));!function(e){"use strict";e.controlBaseClass="undefined"!=typeof window&&window["wj-control-is-element"]?HTMLElement:Object;var t=!1;try{var n=function __c(){};n.prototype=Array.prototype;t=n.prototype!==Array.prototype}catch(e){t=!0}var i=t||e.controlBaseClass!==Object,r=function(e){__extends(ControlBase,e);function ControlBase(){var t=this;i&&(t=e.call(this)||this);return t}return ControlBase}(e.controlBaseClass);e.ControlBase=r;var o=function(t){__extends(Control,t);function Control(n,i,r){void 0===i&&(i=null);void 0===r&&(r=!1);var o=t.call(this)||this;o._listeners=[];o._pristine=!0;o._focus=!1;o._updating=0;o._fullUpdate=!1;o.gotFocus=new e.Event;o.lostFocus=new e.Event;o.invalidInput=new e.Event;o.refreshing=new e.Event;o.refreshed=new e.Event;o._updateWme();e.assert(null==Control.getControl(n),"Element is already hosting a control.");var s=e.getElement(n);e.assert(null!=s,"Cannot find the host element.");o._orgTabIndex=s.hasAttribute("tabindex")?s.tabIndex:0;o._orgOuter=s.outerHTML;o._orgTag=s.tagName;o._orgAtts=s.attributes;"INPUT"!=s.tagName&&"SELECT"!=s.tagName||(s=o._replaceWithDiv(s));o._e=s;s[Control._CTRL_KEY]=o;var a=o.addEventListener.bind(o);if(1==r){o._szCtl=new e.Size(s.offsetWidth,s.offsetHeight);var l=window.ResizeObserver,u=null;l&&(u=o._szObserver=new l((function(e){e.forEach((function(e){var t=Control.getControl(e.target);t&&t._handleResize()}))})));u?u.observe(s):a(window,"resize",o._handleResize.bind(o))}var c=o._handleFocusBlur.bind(o);a(s,"focus",c,!0);a(s,"blur",c,!0);var h=o._handleDisabled.bind(o);a(s,"mousedown",h,!0);a(s,"mouseup",h,!0);a(s,"click",h,!0);a(s,"dblclick",h,!0);a(s,"wheel",h,e.getEventOptions(!0,!0));a(s,"keydown",(function(t){o.isDisabled&&t.keyCode!=e.Key.Tab&&t.preventDefault()}));0==Control._ctlCnt&&_detectTouch(!0);Control._ctlCnt++;return o}Control.prototype.getTemplate=function(){for(var e=Object.getPrototypeOf(this);e;e=Object.getPrototypeOf(e)){var t=e.constructor.controlTemplate;if(t)return t}return null};Control.prototype.applyTemplate=function(t,n,i,r){var o=this,s=this._e;t&&e.addClass(s,t);var a=null;n&&(a=e.createElement(n,s));for(var l=s.querySelectorAll("a.wj-btn"),u=0;u<l.length;u++){var c=l[u];e.setAttribute(c,"role","button",!0);e.setAttribute(c,"href","",!0);e.setAttribute(c,"draggable",!1,!0)}var h=s.querySelectorAll("button");for(u=0;u<h.length;u++)e.setAttribute(h[u],"type","button",!0);var f=s.querySelectorAll("input"),p=1==f.length?f[0]:null;if(p){var d=Control._rxInputAtts;this._copyAttributes(p,s.attributes,d);this._copyAttributes(p,this._orgAtts,d)}if(p&&s.id){for(var g=s;g.parentElement;)g=g.parentElement;var m=g.querySelector('label[for="'+s.id+'"]');if(m instanceof HTMLLabelElement){var _=e.getUniqueId(s.id+"_input");p.id=_;m.htmlFor=_}}if(p){var v=p.value,b=document.createEvent("HTMLEvents");b.initEvent("change",!0,!1);this.gotFocus.addHandler((function(){return v=p.value}));this.addEventListener(p,"focus",(function(){return v=p.value}));this.addEventListener(p,"input",(function(){o._pristine=!1;setTimeout((function(){return v=p.value}))}));this.addEventListener(s,"blur",(function(){if(!o.containsFocus()){if(o._pristine){o._pristine=!1;o._updateState()}if(v!=p.value){v=p.value;p.dispatchEvent(b)}}}),!0)}p?s.tabIndex=-1:s.getAttribute("tabindex")||(s.tabIndex=0);this._updateState();if(i)for(var y in i){var C=i[y];this[y]=a.querySelector('[wj-part="'+C+'"]');null==this[y]&&a.getAttribute("wj-part")==C&&(this[y]=a);if(null==this[y])throw'Missing template part: "'+C+'"';if(C==r){var w="name",E=s.attributes[w];E&&E.value&&this[y].setAttribute(w,E.value);w="accesskey";if((E=s.attributes[w])&&E.value){this[y].setAttribute(w,E.value);s.removeAttribute(w)}}}return a};Control.prototype.dispose=function(){if(this._e){for(var t=this._e.querySelectorAll(".wj-control"),n=0;n<t.length;n++){var i=Control.getControl(t[n]);i&&i.dispose()}if(this._toInv){clearTimeout(this._toInv);this._toInv=null}if(this._toFocus){clearTimeout(this._toFocus);this._toFocus=null}var r=this._szObserver;r&&r.disconnect();this.removeEventListener();for(var o in this)if(o.length>2&&0==o.indexOf("on")){(a=this[o[2].toLowerCase()+o.substr(3)])instanceof e.Event&&a.removeAllHandlers()}var s=this.collectionView;if(s instanceof e.collections.CollectionView)for(var o in s){var a;(a=s[o])instanceof e.Event&&a.removeHandler(null,this)}this._e.parentNode&&(this._e.outerHTML=this._orgOuter);this._e[Control._CTRL_KEY]=null;this._e=this._orgOuter=this._orgTag=this._szObserver=null;Control._ctlCnt--;0==Control._ctlCnt&&_detectTouch(!1)}};Control.getControl=function(t){var n=e.getElement(t);return n?e.asType(n[Control._CTRL_KEY],Control,!0):null};Object.defineProperty(Control.prototype,"hostElement",{get:function(){return this._e},enumerable:!0,configurable:!0});Object.defineProperty(Control.prototype,"rightToLeft",{get:function(){null==this._rtlDir&&(this._rtlDir=!!this._e&&"rtl"==getComputedStyle(this._e).direction);return this._rtlDir},enumerable:!0,configurable:!0});Control.prototype.focus=function(){var t=this._e;t&&t.offsetHeight&&(t.tabIndex>=0||!e.moveFocus(t,0))&&t.focus()};Control.prototype.containsFocus=function(){return e.contains(this._e,e.getActiveElement(),!0)};Control.prototype.invalidate=function(e){var t=this;void 0===e&&(e=!0);this._rtlDir=null;this._fullUpdate=this._fullUpdate||e;if(this._toInv){clearTimeout(this._toInv);this._toInv=null}this.isUpdating||(this._toInv=setTimeout((function(){t.refresh(t._fullUpdate);t._toInv=null}),Control._REFRESH_INTERVAL))};Control.prototype.refresh=function(e){var t=this;void 0===e&&(e=!0);if(!this.isUpdating){this.onRefreshing();this.refreshed.hasHandlers&&setTimeout((function(){t.onRefreshed()}))}if(!this.isUpdating&&this._toInv){clearTimeout(this._toInv);this._toInv=null;this._fullUpdate=!1}this._updateState();this._updateWme()};Control.invalidateAll=function(e){e||(e=document.body);var t=e.children;if(t)for(var n=0;n<t.length;n++)Control.invalidateAll(t[n]);var i=Control.getControl(e);i&&i.invalidate()};Control.refreshAll=function(e){e||(e=document.body);if(e.children)for(var t=0;t<e.children.length;t++)Control.refreshAll(e.children[t]);var n=Control.getControl(e);n&&n.refresh()};Control.disposeAll=function(e){var t=Control.getControl(e);if(t)t.dispose();else if(e.children)for(var n=0;n<e.children.length;n++)Control.disposeAll(e.children[n])};Control.prototype.beginUpdate=function(){this._updating++};Control.prototype.endUpdate=function(){this._updating--;this._updating<=0&&this.invalidate()};Object.defineProperty(Control.prototype,"isUpdating",{get:function(){return this._updating>0},enumerable:!0,configurable:!0});Control.prototype.deferUpdate=function(e){try{this.beginUpdate();e()}finally{this.endUpdate()}};Object.defineProperty(Control.prototype,"isTouching",{get:function(){return Control._touching},enumerable:!0,configurable:!0});Object.defineProperty(Control.prototype,"isDisabled",{get:function(){return this._e&&null!=this._e.getAttribute("disabled")},set:function(t){if((t=e.asBoolean(t,!0))!=this.isDisabled){var n=this._e;if(n){e.toggleClass(n,"wj-state-disabled",t);e.setAttribute(n,"disabled",t?"disabled":null);n.tabIndex=this.isDisabled||n.querySelector("input")?-1:this._orgTabIndex;for(var i=n.querySelectorAll("input,textarea,button,command,fieldset,keygen,optgroup,option,select"),r=Control._DSBL_KEY,o=0;o<i.length;o++){var s=i[o];if(t){s[r]=s.disabled;s.disabled=!0}else{if(!!e.closest(s,".wj-control.wj-state-disabled")){s[r]=s.disabled;s.disabled=!0}else{var a=s[r];e.isBoolean(a)||(a=!1);s.disabled=a;delete s[r]}}}}}},enumerable:!0,configurable:!0});Control.prototype.initialize=function(t){e.copy(this,t)};Control.prototype.addEventListener=function(t,n,i,r,o){if(t){null==r&&(r=!1);e.isBoolean(r)&&null==o&&(n.indexOf("touch")>-1||n.indexOf("wheel")>-1)&&(o=!1);var s=e.isBoolean(r)&&e.isBoolean(o)?e.getEventOptions(r,o):r;t.addEventListener(n,i,s);this._listeners.push({target:t,type:n,fn:i,capture:r})}};Control.prototype.removeEventListener=function(e,t,n,i){for(var r=0,o=0;o<this._listeners.length;o++){var s=this._listeners[o];if(!(null!=e&&e!=s.target||null!=t&&t!=s.type||null!=n&&n!=s.fn||null!=i&&i!=s.capture)){s.target.removeEventListener(s.type,s.fn,s.capture);this._listeners.splice(o,1);o--;r++}}return r};Control.prototype.onGotFocus=function(e){this.gotFocus.raise(this,e)};Control.prototype.onLostFocus=function(e){this.lostFocus.raise(this,e)};Control.prototype.onInvalidInput=function(e){var t=this;this.invalidInput.raise(this,e);if(e.cancel){var n=Control._FOCUS_INTERVAL+50;if(Date.now()-Control._tsInvalidInput>n+50){Control._toInvalidInput&&clearTimeout(Control._toInvalidInput);Control._toInvalidInput=setTimeout((function(){Control._toInvalidInput=null;Control._tsInvalidInput=Date.now();t.focus()}),n)}}this._updateState();return!e.cancel};Control.prototype.onRefreshing=function(e){this.refreshing.raise(this,e)};Control.prototype.onRefreshed=function(e){this.refreshed.raise(this,e)};Control.prototype._getProductInfo=function(){return"B0C3,Control"};Control.prototype._updateWme=function(){var t=this._getProductInfo(),n=Control._toWme,i=e._updateWme;if(e.isFunction(i)&&!n[t]){n[t]=!0;i(this,Control._licKey)}};Control.prototype._hasPendingUpdates=function(){return null!=this._toInv};Control.prototype._handleResize=function(){if(this._e.parentElement){var t=new e.Size(this._e.offsetWidth,this._e.offsetHeight);if(!t.equals(this._szCtl)){this._szCtl=t;(t.width||t.height)&&this.invalidate()}}};Control.prototype._handleFocusBlur=function(){var e=this;this._toFocus||(this._toFocus=setTimeout((function(){e._toFocus=null;e._updateFocusState()}),Control._FOCUS_INTERVAL))};Control.prototype._updateFocusState=function(){setTimeout((function(){for(var t=e.EventArgs.empty,n=document.body.querySelectorAll(".wj-state-focused"),i=0;i<n.length;i++){if((a=Control.getControl(n[i]))&&a._focus&&!a.containsFocus()){e.removeClass(a._e,"wj-state-focus");a._focus=!1;a._updateState();a.onLostFocus(t)}}var r=e.getActiveElement();if(r)for(var o=!0,s=r;s;){var a;if((a=Control.getControl(s))&&!a._focus&&a.containsFocus()){if(o){e.addClass(s,"wj-state-focus");o=!1}a._focus=!0;a._updateState();a.onGotFocus(t)}s=s[Control._OWNR_KEY]||s.parentNode}}))};Control.prototype._updateState=function(){var t=this.hostElement;if(t){e.toggleClass(t,"wj-state-focused",this._focus);this._rtlDir="rtl"==getComputedStyle(t).direction;e.toggleClass(t,"wj-rtl",this._rtlDir);var n=t.querySelector("input");if(n instanceof HTMLInputElement){e.toggleClass(t,"wj-state-empty",0==n.value.length);e.toggleClass(t,"wj-state-readonly",n.readOnly);var i=n.validationMessage;e.toggleClass(t,"wj-state-invalid",!this._pristine&&null!=i&&i.length>0)}}};Control.prototype._handleDisabled=function(t){if(this.isDisabled||e.closest(t.target,".wj-state-disabled")){t.preventDefault();t.stopPropagation();t.stopImmediatePropagation()}};Control.prototype._replaceWithDiv=function(e){var t=document.createElement("div");e.parentElement.replaceChild(t,e);t.innerHTML=e.innerHTML;this._copyAttributes(t,e.attributes,/id|style|class/i);return t};Control.prototype._copyAttributes=function(e,t,n){if(e)for(var i=0;i<t.length;i++){var r=t[i].name;r.match(n)&&e.setAttribute(r,t[i].value)}};Control.prototype._getKeyCode=function(t){var n=t.keyCode;if(this.rightToLeft)switch(n){case e.Key.Right:n=e.Key.Left;break;case e.Key.Left:n=e.Key.Right}return n};Control._toWme={};Control._ctlCnt=0;Control._touching=!1;Control._tsInvalidInput=0;Control._REFRESH_INTERVAL=10;Control._FOCUS_INTERVAL=5;Control._ANIM_DEF_DURATION=400;Control._ANIM_DEF_STEP=35;Control._CLICK_DELAY=800;Control._CLICK_REPEAT=75;Control._CLIPBOARD_DELAY=100;Control._POPUP_ZINDEX=1500;Control._SEARCH_DELAY=500;Control._HOVER_DELAY=400;Control._LEAVE_DELAY=600;Control._DRAG_SCROLL_EDGE=15;Control._DRAG_SCROLL_STEP=20;Control._CTRL_KEY="$WJ-CTRL";Control._OWNR_KEY="$WJ-OWNR";Control._SCRL_KEY="$WJ-SCRL";Control._TTIP_KEY="$WJ-TTIP";Control._DSBL_KEY="$WJ-DSBL";Control._rxInputAtts=/name|tabindex|placeholder|autofocus|autocomplete|autocorrect|autocapitalize|spellcheck|readonly|minlength|maxlength|pattern|type|aria-.+/i;return Control}(r);e.Control=o;function _detectTouch(t){if("ontouchstart"in window||"onpointerdown"in window){var n=document,i=e.getEventOptions(!0,!0),r=_handleTouchStart,o=_handleTouchEnd,s=t?n.addEventListener.bind(n):n.removeEventListener.bind(n);if("ontouchstart"in window){s("touchstart",r,i);s("touchend",o,i);s("touchcancel",o,i)}else if("onpointerdown"in window){s("pointerdown",r,i);s("pointerup",o,i);s("pointercancel",o,i)}}}function _handleTouchStart(t){if(null==t.pointerType||"touch"==t.pointerType){if(o._toTouch){clearTimeout(o._toTouch);o._toTouch=null}o._touching=!0;var n=t.target,i=e.getActiveElement();if(i&&!e.contains(i,n)){o.getControl(e.closest(i,".wj-control"))&&n.focus()}}}function _handleTouchEnd(t){if(null==t.pointerType||"touch"==t.pointerType){o._toTouch=setTimeout((function(){o._toTouch=null;o._touching=!1}),900);if(document.querySelector("ion-app")){var n=t.target;if(e.closest(n,".wj-dropdown-panel,.wj-dropdown")){n.focus();t.stopPropagation();t.stopImmediatePropagation()}}}}}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function PrintDocument(t){this._title=null;this._copyCss=!0;null!=t&&e.copy(this,t)}Object.defineProperty(PrintDocument.prototype,"title",{get:function(){return this._title},set:function(t){this._title=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(PrintDocument.prototype,"copyCss",{get:function(){return this._copyCss},set:function(t){this._copyCss=e.asBoolean(t)},enumerable:!0,configurable:!0});PrintDocument.prototype.addCSS=function(e){this._css||(this._css=[]);this._css.push(e)};PrintDocument.prototype.append=function(t){var n=this._getDocument();if(e.isString(t))n.write(t);else if(t instanceof Element){t instanceof HTMLElement&&e.Control.refreshAll(t);for(var i=t.cloneNode(!0),r=i.querySelectorAll("input"),o=0;o<r.length;o++){var s=r[o];switch(s.type){case"checkbox":e.setAttribute(s,"checked",!!s.checked||null);e.setAttribute(s,"indeterminate",!!s.indeterminate||null);break;case"radio":e.setAttribute(s,"checked",!!s.checked||null);break;default:e.setAttribute(s,"value",s.value||null)}}n.write(i.outerHTML)}else e.assert(!1,"content should be an HTML string or an Element.")};PrintDocument.prototype.print=function(t){var n=this;if(this._iframe){this._close();setTimeout((function(){var i=n._iframe.contentWindow,r="onafterprint"in i&&!e.isFirefox();r&&(i.onafterprint=function(){n._afterPrint(t)});if(!(e.isIE()&&null==i.document.body)&&document.queryCommandSupported("print"))i.document.execCommand("print",!0,null);else{i.focus();i.print()}r||n._afterPrint(t)}),100)}};PrintDocument.prototype._afterPrint=function(t){document.body.removeChild(this._iframe);this._iframe=null;e.isFunction(t)&&t()};PrintDocument.prototype._getDocument=function(){if(!this._iframe){var t=this._iframe=document.createElement("iframe");e.addClass(t,"wj-printdocument");e.setCss(t,{position:"fixed",left:32e3,top:32e3});document.body.appendChild(t)}return this._iframe.contentDocument};PrintDocument.prototype._close=function(){var t=this._getDocument();t.close();t.title=null!=this.title?this.title:document.title;t.title&&t.title.trim()||(t.title=" ");if(this._copyCss){for(var n=document.head.querySelectorAll("LINK"),i=0;i<n.length;i++){var r=n[i];if(r.href.match(/\.css$/i)&&r.rel.match(/stylesheet/i)){var o=e.httpRequest(r.href,{async:!1});this._addStyle(o.responseText)}}var s=document.head.querySelectorAll("STYLE");for(i=0;i<s.length;i++)this._addStyle(s[i].textContent)}if(this._css)for(i=0;i<this._css.length;i++){var a=t.createElement("style");o=e.httpRequest(this._css[i],{async:!1});a.textContent=o.responseText;t.head.appendChild(a)}};PrintDocument.prototype._addStyle=function(e){var t=this._getDocument(),n=t.createElement("style");n.textContent=e;t.head.appendChild(n)};return PrintDocument}();e.PrintDocument=t}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function Clipboard(){}Clipboard.copy=function(t){Clipboard._copyPaste(e.asString(t),null)};Clipboard.paste=function(t){t=e.asFunction(t);Clipboard._copyPaste(null,t)};Clipboard._copyPaste=function(t,n){for(var i=e.getActiveElement(),r=e.closest(i,".wj-control");r&&e.Control.getControl(r);)r=r.parentElement;if(r=r||document.body){var o=!1,s=e.createElement('<textarea class="wj-clipboard">',r,{position:"fixed",opacity:"0"});s.onkeydown=function(e){return e.preventDefault()};s.onchange=function(e){return e.stopImmediatePropagation()};if(e.isString(t)){s.value=t;s.select();document.execCommand("copy")&&(o=!0)}else{s.select();if(e.isFunction(n)&&document.execCommand("paste")){n(s.value);o=!0}}setTimeout((function(){i.focus({preventScroll:!0});e.removeChild(s);!o&&e.isFunction(n)&&n(s.value)}),e.Control._CLIPBOARD_DELAY)}};return Clipboard}();e.Clipboard=t}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function _ClickRepeater(e){this._isDown=!1;this._mousedownBnd=this._mousedown.bind(this);this._mouseupBnd=this._mouseup.bind(this);this._clickBnd=this._click.bind(this);this.element=e;this._connect(!0)}Object.defineProperty(_ClickRepeater.prototype,"element",{get:function(){return this._e},set:function(t){this._connect(!1);this._e=e.asType(t,HTMLElement,!0);this._connect(!0)},enumerable:!0,configurable:!0});Object.defineProperty(_ClickRepeater.prototype,"disabled",{get:function(){return this._disabled},set:function(t){this._disabled=e.asBoolean(t)},enumerable:!0,configurable:!0});_ClickRepeater.prototype._connect=function(e){var t=this;this._e&&_ClickRepeater._startEvents.forEach((function(n){e?t._e.addEventListener(n,t._mousedownBnd):t._e.removeEventListener(n,t._mousedownBnd)}))};_ClickRepeater.prototype._clearTimeouts=function(){if(this._toRepeat){clearTimeout(this._toRepeat);this._toRepeat=null}if(this._toDelay){clearTimeout(this._toDelay);this._toDelay=null}};_ClickRepeater.prototype._mousedown=function(t){var n=this;this._isDown&&this._mouseup(null);if(!this._disabled){this._isDown=!0;_ClickRepeater._stopEvents.forEach((function(e){document.addEventListener(e,n._mouseupBnd)}));this._clearTimeouts();this._toDelay=setTimeout((function(){if(n._isDown){n._click();n._toRepeat=setTimeout(n._clickBnd,e.Control._CLICK_REPEAT)}}),e.Control._CLICK_DELAY)}};_ClickRepeater.prototype._mouseup=function(e){var t=this;this._isDown&&e&&"keydown"!=e.type&&this._clicked&&e.preventDefault();_ClickRepeater._stopEvents.forEach((function(e){document.removeEventListener(e,t._mouseupBnd)}));this._clearTimeouts();this._isDown=!1;this._clicked=!1};_ClickRepeater.prototype._click=function(){this._clicked=!0;this._clearTimeouts();if(this._e){this._e.click();this._isDown&&(this._toRepeat=setTimeout(this._clickBnd,e.Control._CLICK_REPEAT))}};_ClickRepeater._startEvents=["mousedown","touchstart"];_ClickRepeater._stopEvents=["mouseup","mouseout","keydown","touchend","touchcancel"];return _ClickRepeater}();e._ClickRepeater=t}(wijmo||(wijmo={}));!function(e){"use strict";var t;!function(e){e[e.Above=0]="Above";e[e.AboveRight=1]="AboveRight";e[e.RightTop=2]="RightTop";e[e.Right=3]="Right";e[e.RightBottom=4]="RightBottom";e[e.BelowRight=5]="BelowRight";e[e.Below=6]="Below";e[e.BelowLeft=7]="BelowLeft";e[e.LeftBottom=8]="LeftBottom";e[e.Left=9]="Left";e[e.LeftTop=10]="LeftTop";e[e.AboveLeft=11]="AboveLeft"}(t=e.PopupPosition||(e.PopupPosition={}));e.showPopup=function showPopup(n,i,r,o,s,a){void 0===s&&(s=!0);var l=n.offsetHeight||n.offsetWidth,u=r;(e.isBoolean(r)||null==r)&&(u=r?t.AboveLeft:t.BelowLeft);var c=function _getPopupParent(t){var n=document.body;if(t instanceof HTMLElement){if(!e.contains(document.body,t))return n;for(var i=t;i;i=i.parentElement){if("DIALOG"==i.tagName||"ION-CONTENT"==i.tagName||"fixed"==getComputedStyle(i).position){n=i;break}if(_isjQueryDialog(i)){n=i.querySelector(".ui-dialog-content")||i;break}}}return n}(i);!function _addPopupToDOM(t,n){if(!t.offsetHeight||!t.offsetWidth||t.parentElement!=n){e.setCss(t,{opacity:"0",position:"fixed",left:0,top:0,transform:"",display:""});n.appendChild(t)}}(n,c);!function _copyPopupStyles(t,n,i){if(n instanceof HTMLElement&&i){var r=i instanceof HTMLElement?i:n,o=getComputedStyle(r);1==new e.Color(o.backgroundColor).a&&e.setCss(t,{color:o.color,backgroundColor:o.backgroundColor,fontFamily:o.fontFamily,fontSize:o.fontSize,fontWeight:o.fontWeight,fontStyle:o.fontStyle})}}(n,i,s);e.Control.refreshAll(n);e.isFirefox()?requestAnimationFrame((function(){_updatePopupPosition(n,i,u)})):_updatePopupPosition(n,i,u);i instanceof HTMLElement&&(n[e.Control._OWNR_KEY]=i);if(!l){!function _hidePopupOnscroll(t,n,i){var r=n instanceof MouseEvent?n.target:n;if(r instanceof HTMLElement&&r.parentElement!=document.body){var o=Date.now(),s=r.getBoundingClientRect(),a=new e.Control(document.createElement("div"));t[e.Control._SCRL_KEY]=a;a.addEventListener(document,"scroll",(function(l){if(l.target!=t.parentElement&&Date.now()-o>100&&e.contains(document,r)&&!e.contains(t,l.target)&&(l.target!=document||null!=n&&"fixed"==t.style.position)){var u=r.getBoundingClientRect(),c=Math.abs(u.left-s.left),h=Math.abs(u.top-s.top);if(c>1||h>1){e.isFunction(i)&&i();_hidePopup(t,!0);a.dispose()}}}),!0)}}(n,i,a);if(o)return e.animate((function(e){return n.style.opacity=e<1?e.toString():""}));n.style.opacity=""}return null};e.hidePopup=function hidePopup(t,n,i){void 0===n&&(n=!0);void 0===i&&(i=!1);var r=null;i?r=e.animate((function(e){t.style.opacity=(1-e).toString();if(1==e){_hidePopup(t,n);t.style.opacity=""}})):_hidePopup(t,n);return r};function _updatePopupPosition(n,i,r){var o=function _getReferenceRect(t,n){if(n instanceof MouseEvent)return n.clientX<=0&&n.clientY<=0&&n.target instanceof HTMLElement?e.Rect.fromBoundingRect(n.target.getBoundingClientRect()):new e.Rect(n.pageX-pageXOffset,n.pageY-pageYOffset,0,0);if(n instanceof e.Point)return new e.Rect(n.x,n.y,0,0);if(n instanceof HTMLElement)return e.Rect.fromBoundingRect(n.getBoundingClientRect());if(n&&null!=n.top&&null!=n.left)return n;return null}(0,i),s=function _getPopupOffset(t){var n=document.body,i=document.documentElement,r=t.parentElement,o=new e.Point(n.scrollLeft||pageXOffset,n.scrollTop||pageYOffset);if(r!=n){var s=r==n?i:t.offsetParent||r;s==n&&(s=r);if(s){var a=s.getBoundingClientRect();o=new e.Point(s.scrollLeft-a.left,s.scrollTop-a.top)}}if(r instanceof HTMLElement){var l=getComputedStyle(r);o.x-=parseFloat(l.borderLeftWidth);o.y-=parseFloat(l.borderTopWidth)}return o}(n),a=function _getPopupPosition(n,i,r,o){var s=document.documentElement,a=s.clientWidth,l=s.clientHeight,u=t;switch(r){case u.AboveLeft:case u.AboveRight:case u.BelowLeft:case u.BelowRight:if(i){var c=i.width;if(c){e.isIE()&&(c-=n.offsetWidth-n.clientWidth);n.style.minWidth=c+"px"}}}var h=getComputedStyle(n),f=parseFloat(h.marginTop)+parseFloat(h.marginBottom),p=parseFloat(h.marginLeft)+parseFloat(h.marginRight),d=new e.Size(n.offsetWidth+p,n.offsetHeight+f),g=new e.Point((a-d.width)/2,Math.round((l-d.height)/2*.7));if(i){"rtl"==h.direction&&(r=function _getRtlPosition(e){var n=t;switch(e){case n.AboveLeft:return n.AboveRight;case n.AboveRight:return n.AboveLeft;case n.BelowLeft:return n.BelowRight;case n.BelowRight:return n.BelowLeft;case n.Left:return n.Right;case n.LeftTop:return n.RightTop;case n.LeftBottom:return n.RightBottom;case n.Right:return n.Left;case n.RightTop:return n.LeftTop;case n.RightBottom:return n.LeftBottom}return e}(r));var m=i.left,_=a-i.right;g.x=i.left;switch(r){case u.Above:case u.Below:g.x=i.left+(i.width-d.width)/2;break;case u.AboveLeft:case u.BelowLeft:g.x=i.left;break;case u.AboveRight:case u.BelowRight:g.x=i.right-d.width;break;case u.Left:case u.LeftTop:case u.LeftBottom:g.x=m>=d.width||m>=_?i.left-d.width:i.right;break;case u.RightTop:case u.RightBottom:case u.Right:g.x=_>=d.width||_>=m?i.right:i.left-d.width}var v=i.top,b=l-i.bottom;switch(r){case u.Above:case u.AboveLeft:case u.AboveRight:g.y=v>d.height||v>b?i.top-d.height:i.bottom;break;case u.Below:case u.BelowLeft:case u.BelowRight:g.y=b>d.height||b>v?i.bottom:i.top-d.height;break;case u.LeftTop:case u.RightTop:g.y=i.top;break;case u.LeftBottom:case u.RightBottom:g.y=i.bottom-d.height;break;case u.Left:case u.Right:g.y=i.bottom-d.height+(d.height-i.height)/2}}g.x=Math.min(g.x,a-d.width);g.y=Math.min(g.y,l-d.height);g.x=Math.max(0,g.x)+o.x;g.y=Math.max(0,g.y)+o.y;return g}(n,o,r,s),l={position:"absolute",zIndex:e.Control._POPUP_ZINDEX};if(0==s.x){l.left=a.x;l.top=a.y}else l.transform="translate("+a.x+"px, "+a.y+"px)";e.setCss(n,l)}function _hidePopup(t,n){t.style.display="none";n&&t.parentElement&&setTimeout((function(){if("none"==t.style.display){e.removeChild(t);e.isFunction(n)&&n()}}),e.Control._FOCUS_INTERVAL+50);var i=t[e.Control._SCRL_KEY];i instanceof e.Control&&i.dispose();delete t[e.Control._SCRL_KEY];delete t[e.Control._OWNR_KEY]}function _isjQueryDialog(t){var n=window.jQuery,i=e.isFunction(n)?n(t):null;return i&&e.isFunction(i.dialog)&&e.hasClass(t,"ui-dialog")}}(wijmo||(wijmo={}));!function(e){"use strict";var t=function(){function Tooltip(t){this._showAutoTipBnd=this._showAutoTip.bind(this);this._hideAutoTipBnd=this._hideAutoTip.bind(this);this._mousemoveBnd=this._mousemove.bind(this);this._html=!0;this._cssClass="";this._gap=6;this._isAnimated=!1;this._position=e.PopupPosition.Above;this._showAtMouse=!1;this._showDelay=500;this._hideDelay=0;this._tips=[];this.popup=new e.Event;e.copy(this,t)}Object.defineProperty(Tooltip.prototype,"position",{get:function(){return this._position},set:function(t){this._position=e.asEnum(t,e.PopupPosition)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"isAnimated",{get:function(){return this._isAnimated},set:function(t){this._isAnimated=e.asBoolean(t)},enumerable:!0,configurable:!0});Tooltip.prototype.setTooltip=function(t,n,i){t=e.getElement(t);n=this._getContent(n);var r=this._indexOf(t);if(r>-1){this._detach(t);this._tips.splice(r,1)}if(n){this._attach(t);this._tips.push({element:t,content:n,position:i})}var o=Tooltip._eTip;o&&o[e.Control._TTIP_KEY]==t&&(n?this._setContent(n):this._hideAutoTip())};Tooltip.prototype.getTooltip=function(t){t=e.getElement(t);for(var n=this._tips,i=0;i<n.length;i++)if(n[i].element==t)return n[i].content;return null};Tooltip.prototype.show=function(t,i,r,o){t=e.getElement(t);i=this._getContent(i);if(t){null==o&&(o=this.position);var s=Tooltip._eTip;if(!s){s=Tooltip._eTip=document.createElement("div");e.addClass(s,"wj-tooltip");s.style.visibility="none"}e.addClass(s,this.cssClass);this._setContent(i);s[e.Control._TTIP_KEY]=t;var a=new n(i,t);this.onPopup(a);if(a.content&&!a.cancel){this._setContent(a.content);r||(r=e.Rect.fromBoundingRect(t.getBoundingClientRect()));var l=this.gap,u=e.PopupPosition;if(l)switch(o){case u.Above:case u.AboveLeft:case u.AboveRight:case u.Below:case u.BelowLeft:case u.BelowRight:r=r.inflate(0,l);break;default:r=r.inflate(l,0)}e.showPopup(s,r,o,this.isAnimated);document.addEventListener("mousedown",this._hideAutoTipBnd)}}};Tooltip.prototype.hide=function(){var t=Tooltip._eTip;if(t){e.removeChild(t);e.removeClass(t,this.cssClass);t.innerHTML=""}document.removeEventListener("mousedown",this._hideAutoTipBnd)};Tooltip.prototype.dispose=function(){var e=this;this.isVisible&&this.hide();var t=this._tips;if(t.length){t.forEach((function(t){e._detach(t.element)}));t.splice(0,t.length)}this._clearTimeouts()};Object.defineProperty(Tooltip.prototype,"isVisible",{get:function(){var e=Tooltip._eTip;return null!=e&&null!=e.parentElement&&e.offsetWidth>0},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"isContentHtml",{get:function(){return this._html},set:function(t){this._html=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"cssClass",{get:function(){return this._cssClass},set:function(t){this._cssClass=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"gap",{get:function(){return this._gap},set:function(t){this._gap=e.asNumber(t)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"showAtMouse",{get:function(){return this._showAtMouse},set:function(t){this._showAtMouse=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"showDelay",{get:function(){return this._showDelay},set:function(t){this._showDelay=e.asInt(t)},enumerable:!0,configurable:!0});Object.defineProperty(Tooltip.prototype,"hideDelay",{get:function(){return this._hideDelay},set:function(t){this._hideDelay=e.asInt(t)},enumerable:!0,configurable:!0});Tooltip.prototype.onPopup=function(e){this.popup&&this.popup.raise(this,e);return!e.cancel};Tooltip.prototype._indexOf=function(e){for(var t=0;t<this._tips.length;t++)if(this._tips[t].element==e)return t;return-1};Tooltip.prototype._attach=function(e){e.addEventListener("mouseenter",this._showAutoTipBnd);e.addEventListener("mouseleave",this._hideAutoTipBnd);e.addEventListener("click",this._showAutoTipBnd);this.showAtMouse&&e.addEventListener("mousemove",this._mousemoveBnd)};Tooltip.prototype._detach=function(e){e.removeEventListener("mouseenter",this._showAutoTipBnd);e.removeEventListener("mouseleave",this._hideAutoTipBnd);e.removeEventListener("click",this._showAutoTipBnd);e.removeEventListener("mousemove",this._mousemoveBnd)};Tooltip.prototype._showAutoTip=function(t){var n=this;if(!t.defaultPrevented)if("click"!=t.type||e.Control._touching){var i="mouseenter"==t.type?this._showDelay:0,r=this._hideDelay;this._clearTimeouts();this._eMouse=t;this._toShow=setTimeout((function(){var i=n._indexOf(t.target);if(i>-1){var o=n._tips[i],s=n._eMouse,a=n._showAtMouse?new e.Rect(s.clientX,s.clientY,0,0):null;if(o&&o.element&&o.element.offsetHeight){var l=e.Control.getControl(o.element);if(null==l||0!=l.isVisible){n.show(o.element,o.content,a,o.position);r>0&&(n._toHide=setTimeout((function(){n.hide()}),r))}}}}),i)}else this._hideAutoTip()};Tooltip.prototype._mousemove=function(e){this._eMouse=e};Tooltip.prototype._hideAutoTip=function(){this._clearTimeouts();this.hide()};Tooltip.prototype._clearTimeouts=function(){if(this._toShow){clearTimeout(this._toShow);this._toShow=null}if(this._toHide){clearTimeout(this._toHide);this._toHide=null}};Tooltip.prototype._getContent=function(t){if((t=e.asString(t))&&"#"==t[0]){var n=e.getElement(t);n&&(t=n.innerHTML)}return t};Tooltip.prototype._setContent=function(e){var t=Tooltip._eTip;t&&(this._html?t.innerHTML=e:t.textContent=e)};return Tooltip}();e.Tooltip=t;var n=function(n){__extends(TooltipEventArgs,n);function TooltipEventArgs(t,i){var r=n.call(this)||this;r._content=e.asString(t);r._e=i;return r}Object.defineProperty(TooltipEventArgs.prototype,"tip",{get:function(){return t._eTip},enumerable:!0,configurable:!0});Object.defineProperty(TooltipEventArgs.prototype,"element",{get:function(){return this._e},enumerable:!0,configurable:!0});Object.defineProperty(TooltipEventArgs.prototype,"content",{get:function(){return this._content},set:function(t){this._content=e.asString(t)},enumerable:!0,configurable:!0});return TooltipEventArgs}(e.CancelEventArgs);e.TooltipEventArgs=n}(wijmo||(wijmo={}));!function(e){e._registerModule("wijmo",e)}(wijmo||(wijmo={}));!function(e){"use strict";var t="The Wijmo license in this application ",n={evl:"Wijmo Evaluation Version ({version})",prd:t+"is not valid for the <b>{control}</b> control.",ver:t+"is not valid for the version in use. The license version is <b>{licVer}</b>; the product version is <b>{version}</b>.",dmn:t+"is not valid for the current domain. The license domain is <b>{licDomain}</b>; the current domain is <b>{domain}</b>.",exp:t+"has expired. The license expiration date is <b>{expDate:d}</b>.",lic:t+"is invalid.",mss:t+"is not set.",ctc:'If you are a customer, you can <a target="_blank" rel="noopener" href="https://www.grapecity.com/licensing/wijmo?utm_source=Wijmo-In-App&utm_medium=Click-to-Site&utm_campaign=Wijmo-User-Analysis">create a license</a> online. Otherwise, you can <a target="_blank" rel="noopener" href="https://www.grapecity.com/wijmo/request-trial-key?utm_source=Wijmo-In-App&utm_medium=Click-to-Site&utm_campaign=Wijmo-User-Analysis">generate a 30-day license</a> for free. For further assistance, contact GrapeCity: <a href="mailto:us.sales@grapecity.com">us.sales@grapecity.com</a>.',hdr:"Wijmo License",cls:"CLOSE"},i={};e._updateWme=function _updateWme(t,n){var o=e.Control._wme;if(!(o&&e.contains(document.body,o)&&o.offsetWidth&&o.offsetHeight))if(n){var s=_getControlCode(t);if(!i[s]){i[s]=!0;!function _attorn(e,t,n,i){var o=function parseKeyData(e,t){try{t="#"+t;var n=e.indexOf(t);if(n>-1)return{prefix:e.substring(0,n),lic:JSON.parse(decode(e.substr(n+t.length)))}}catch(e){}return null}(e,t.algorithmCode);if(!o)return i();var s=o.lic,a=o.prefix+"#"+t.algorithmCode;if(function tripleHash(e){for(var t=0,n=5381,i=0,r=e.length-1;r>=0;r--){var o=e.charCodeAt(r);t=o+(t<<6)+(t<<16)-t;n=o+((n<<5)+n);i=o+((i<<5)-i)}var s=t^n^i;s<0&&(s=~s);return s.toString(16).toUpperCase()}(a+JSON.stringify(s.D))!=s.H)return i();var l=window.msCrypto||window.crypto,u=l?l.subtle:null;if(!u||!location.protocol.match(/^https/i))return n(s.D);var c={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}},h={alg:"RS256",e:"AQAB",kty:"RSA",n:(f=t.publicKey,f.replace(/\+/g,"-").replace(/\//g,"_").replace(/\=+$/,""))};var f;h=window.msCrypto?str2ArrayBuffer(JSON.stringify(h)):h;try{asPromise(u.importKey("jwk",h,c,!1,["verify"])).then((function(e){var t=function arrayBuffer2Str(e){return String.fromCharCode.apply(null,new r(e))}(str64ToArrayBuffer(function str64EncodeUnicode(e){return btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,(function(e,t){return String.fromCharCode(parseInt(t,16))})))}(a+JSON.stringify(s.D))));asPromise(u.verify(c,e,str64ToArrayBuffer(s.S),str2ArrayBuffer(t))).then((function(e){return e?n(s.D):i()}))}),(function(){return n(s.D)}))}catch(e){return n(s.D)}}(n,{algorithmCode:"B0",publicKey:"l6/zrbWoSbcLFwEetFh38rH3ErBZE9H+Cqix3R+wTlfA1wD5B+lUcCQn+EJ60I4RGrm0x1sFjkiLWwB0jAn6BWZv0W4WbqAKriOdeoivxDp1Wmjs3qkEDhvbsjPtfvwx2BHil6o+/tDrdMJQSGs18WZm2PoQLQuL+9VhZ4FNRHUQU3Jtioke/OZEGHJOdYVwvCGalzBad6QFOiVbDBQPePpS3++GJzOxN8SN/7lyS5/IdKiy3WJRaVGkB370+HbN6hKraDfUgReLX26yxRaKC/5aWnGAJ2NnWLoGyAGRcwT9dVjo4bcAZNrrA0U9JVKQxaSskhdv2p49XzJkltXx5w=="},(function(e){_checkLicense(t,n,e);delete i[s]}),(function(){_checkLicense(t,n,null);delete i[s]}))}}else _checkLicense(t,null,null)};function _getControlCode(e){return e._getProductInfo().split(",")[0]}function _getControlName(e){return e._getProductInfo().split(",")[1]}function _checkLicense(t,r,o){var s=e.culture.Licensing||n,a=null;o?!function _checkExpiration(e,t){if(t.Exp){var n=t.Exp,i=new Date(parseInt(n.substr(0,4))||0,parseInt(n.substr(4,2))-1||0,parseInt(n.substr(6,2))||0);if(Math.ceil((i.valueOf()-Date.now())/864e5)<=0)return!1}return!0}(0,o)?a=s.exp:!function _checkVersion(t,n){var i=n.Anl?n.Anl.ver:null,r=e.getVersion();if(i&&r){var o=parseInt(i.replace("v",""))+10,s=parseInt(r.split(".")[1]);return o>=s}return!0}(0,o)?a=s.ver:!function _checkDomain(e,t){if(_isLocalHost()||!t.Dms)return!0;for(var n=location.hostname,i=t.Dms.split(","),r=0;r<i.length;r++)if(_checkHost(n,i[r]))return!0;return!1}(0,o)?a=s.dmn:!function _checkProductCode(e,t){var n=_getControlCode(e);if(n&&n.length>=4)for(var i=0;i<t.Prd.length;i++)if(t.Prd[i].C.indexOf(n)>-1)return!0;return!1}(t,o)?a=s.prd:_checkEval(t,o)&&(a=s.evl):a=r?s.lic:s.mss;a&&function _addWme(t,r,o){r=_getMessage(t,r,o);if(!i[" "]&&!_isLocalHost()&&!_checkEval(t,o)){i[" "]=!0;var s=e.culture.Licensing||n,a='<div style="position:fixed;background:rgba(0,0,0,0.3);left:0;top:0;width:100%;height:100%;font-family: sans-serif;z-index:10000;"><div style="position:relative;overflow:auto;background:white;width:450px;padding:36pt;left:50%;top:50%;transform:translate(-50%,-50%)"><div><p style="font-size:150%;font-weight:bold">'+s.hdr+"</p><p>"+r+'</p></div><div style="text-align:right;margin-top:24pt"><button style="border:none;background:rgba(158,158,158,.2);padding:8px 16px">'+s.cls+"</button></div></div></div>",l=e.createElement(a,document.body);l.addEventListener("click",(function(t){t.target instanceof HTMLButtonElement&&e.removeChild(l)}))}if(!e.Control._wme){a='<div><a href="'+function _getWmeHref(){return"ja"==e.culture.Globalize.name?"https://www.grapecity.co.jp/developer/support/wijmo-license":"https://www.grapecity.com/licensing/wijmo?utm_source=Wijmo-In-App&utm_medium=Click-to-Site&utm_campaign=Wijmo-User-Analysis"}()+'" target="_blank" rel="noopener">'+_getMessage(t)+"</a></div>";var u=e.createElement(a),c={position:"fixed",display:"block",visibility:"visible",background:"rgba(240,240,240,.9)",padding:"8px 12px",margin:"6px",fontFamily:"sans-serif",fontSize:"14pt",fontWeight:"bold",zIndex:1e4,opacity:.8,height:"auto",width:"auto",transform:"none"};switch(Math.round(100*Math.random())%3){case 0:c.right=c.bottom=0;break;case 1:c.left=c.bottom=0;break;case 2:c.right=c.top=0}e.setCss(u,c);document.body.appendChild(u);e.Control._wme=u;!function _addClickableTooltip(t,n){var i,r=e.createElement(n);r.className="wj-tooltip";e.setCss(r,{pointerEvents:"auto",padding:"10px",margin:"6px"});[t,r].forEach((function(e){e.addEventListener("mouseenter",(function(){return trackMouse(!0)}));e.addEventListener("mouseleave",(function(){return trackMouse(!1)}))}));var o=0;function trackMouse(n){o+=n?1:-1;i&&clearTimeout(i);i=setTimeout((function(){i=null;1==o?e.showPopup(r,t.getBoundingClientRect()):o<1&&e.hidePopup(r)}),500)}}(u,r)}}(t,a+="<br/><br/>"+s.ctc,o)}function _checkHost(e,t){var n="^"+t.replace(/\./g,"\\.").replace(/\*/g,"(.*)")+"$",i=new RegExp(n,"i").test(e);return i||"*."!=t.substr(0,2)?i:_checkHost(e,t.substr(2))}function _checkEval(e,t){return!!t&&t.Evl}function _isLocalHost(){var e=location,t=atob("Xih8bG9jYWxob3N0fGZpZGRsZS5qc2hlbGwubmV0fHJ1bi5wbG5rci5jb3xzLmNvZGVwZW4uaW98bnVsbC5qc2Jpbi5jb218Lio/LnN0YWNrYmxpdHouaW98MTI3LjAuMC4xfFt3LV0rLmxvY2FsfFt3LV0rfDo6MSkk");return"file:"==e.protocol||new RegExp(t,"i").test(e.hostname)}function _getMessage(t,i,r){if(!i||i.trim().length<15){i=(e.culture.Licensing||n).evl}(!i||i.trim().length<15)&&(i=atob("V2lqbW8gRXZhbHVhdGlvbiBWZXJzaW9uICh7dmVyc2lvbn0p"));var o=null;if(r&&r.Exp){var s=r.Exp;o=new Date(parseInt(s.substr(0,4))||0,parseInt(s.substr(4,2))-1||0,parseInt(s.substr(6,2))||0)}return i=e.format(i,{version:e.getVersion(),domain:location.hostname,control:_getControlName(t),licVer:r&&r.Anl?"5."+r.Anl.ver.replace("v","")+".*":null,licDomain:r?r.Dms:null,expDate:o})}var r="undefined"==typeof window?null:window.Uint8Array||window.TypedArray;function decode(e){if(!e)return"";var t=function unshiftString(e){for(var t=e.split(""),n=t.length-5;n>=0;n--){swapArrayElements(t,n+1,n+3,unshiftChar);swapArrayElements(t,n,n+2,unshiftChar)}return t.join("")}(e);t=function reverseString(e){return e.split("").reverse().join("")}(t);var n=Math.ceil(t.length/2);return function str64DecodeUnicode(e){for(var t=atob(e),n="",i=0;i<t.length;i++)n+="%"+("00"+t.charCodeAt(i).toString(16)).slice(-2);return decodeURIComponent(n)}(t=(t=(t=t.substr(n)+t.substr(0,n)).replace("#","=")).replace("&","=="))}function swapArrayElements(e,t,n,i){e.length>1&&e.splice(n,1,i(e.splice(t,1,i(e[n]))[0]))}function unshiftChar(e){return function shiftChar(e,t){var n=e.charCodeAt(0);return n>=65&&n<=90?e.toLowerCase():n>=97&&n<=122?e.toUpperCase():n>=48&&n<=57?String.fromCharCode(48+(n-48+10+t)%10):e}(e,-1)}function str64ToArrayBuffer(e){for(var t=atob(e),n=t.length,i=new r(n),o=0;o<n;o++)i[o]=t.charCodeAt(o);return i.buffer}function str2ArrayBuffer(e){for(var t=new ArrayBuffer(e.length),n=new r(t),i=0,o=e.length;i<o;i++)n[i]=e.charCodeAt(i);return t}function asPromise(e){if("oncomplete"in e){e.then=function(t,n){e.resolve=t;e.reject=n};e.oncomplete=function(t){e.resolve(e.result)};e.onerror=function(t){e.reject()}}return e}}(wijmo||(wijmo={}));
/*!
    *
    * Wijmo Library 5.20211.781
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */

var wijmo,__extends=this&&this.__extends||function(){var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(e,t)};return function(e,t){extendStatics(e,t);function __(){this.constructor=e}e.prototype=null===t?Object.create(t):(__.prototype=t.prototype,new __)}}();!function(e){!function(t){"use strict";!function(e){e[e.AutoComplete=0]="AutoComplete";e[e.DropDownList=1]="DropDownList";e[e.RadioButtons=2]="RadioButtons"}(t.DataMapEditor||(t.DataMapEditor={}));var i=function(){function DataMap(t,i,o){this._keyPath="";this._displayPath="";this._sortByVal=!0;this._editable=!1;this.mapChanged=new e.Event;if(e.isArray(t)&&!i&&!o){t=t.map((function(e){return{value:e}}));i=o="value"}this._cv=e.asCollectionView(t);this._keyPath=e.asString(i,!1);this._displayPath=e.asString(o,!1);this._cv.collectionChanged.addHandler(this.onMapChanged,this)}Object.defineProperty(DataMap.prototype,"sortByDisplayValues",{get:function(){return this._sortByVal},set:function(t){this._sortByVal=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(DataMap.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0});Object.defineProperty(DataMap.prototype,"selectedValuePath",{get:function(){return this._keyPath},enumerable:!0,configurable:!0});Object.defineProperty(DataMap.prototype,"displayMemberPath",{get:function(){return this._displayPath},enumerable:!0,configurable:!0});DataMap.prototype.getDataItem=function(t){var i=this;if(!this._hash){var o=this._cv.sourceCollection,n={};e.isArray(o)&&this._keyPath&&o.forEach((function(e){var t=e[i._keyPath];null==n[t]&&(n[t]=e)}));this._hash=n}return this._hash[t]};DataMap.prototype.getDisplayValue=function(e){var t=this._displayPath,i=this.getDataItem(e);return t&&i?i[t]:e};DataMap.prototype.getKeyValue=function(e,t){var i=this._displayPath,o=this._indexOf(e,i,t,!0);o<0&&(o=this._indexOf(e,i,t,!1));return o>-1?this._cv.sourceCollection[o][this._keyPath]:null};DataMap.prototype.getDisplayValues=function(e){var t=this;return this._cv&&this._displayPath?this._cv.items.map((function(e){return e[t._displayPath]})):[]};DataMap.prototype.getKeyValues=function(){var e=this;return this._cv&&this._keyPath?this._cv.items.map((function(t){return t[e._keyPath]})):[]};Object.defineProperty(DataMap.prototype,"isEditable",{get:function(){return this._editable},set:function(t){this._editable=e.asBoolean(t)},enumerable:!0,configurable:!0});DataMap.prototype.onMapChanged=function(e){this._hash=null;this.mapChanged.raise(this,e)};DataMap.prototype._indexOf=function(t,i,o,n){var r=-1,l=-1;if(this._cv&&i){var s=null!=t?t.toString():"";s&&o&&(t=e.toPlainText(s));for(var a=n?s:s.toLowerCase(),d=this._cv.sourceCollection,c=0;c<d.length;c++){var u=d[c],h=u[i];o&&e.isString(h)&&(h=e.toPlainText(h));h==t?r=c:n||h.length!=a.length||h.toLowerCase()!=a?null!=h&&h.toString()==s&&(r=c):r=c;if(r==c){if(!this._cv.filter||this._cv.filter(u))return r;l<0&&(l=r)}}}return l};return DataMap}();t.DataMap=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function CellRange(e,t,i,o){void 0===e&&(e=-1);void 0===t&&(t=-1);void 0===i&&(i=e);void 0===o&&(o=t);this.setRange(e,t,i,o)}CellRange.prototype.setRange=function(t,i,o,n){void 0===t&&(t=-1);void 0===i&&(i=-1);void 0===o&&(o=t);void 0===n&&(n=i);this._row=e.asInt(t);this._col=e.asInt(i);this._row2=e.asInt(o);this._col2=e.asInt(n)};Object.defineProperty(CellRange.prototype,"row",{get:function(){return this._row},set:function(t){this._row=e.asInt(t)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"col",{get:function(){return this._col},set:function(t){this._col=e.asInt(t)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"row2",{get:function(){return this._row2},set:function(t){this._row2=e.asInt(t)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"col2",{get:function(){return this._col2},set:function(t){this._col2=e.asInt(t)},enumerable:!0,configurable:!0});CellRange.prototype.clone=function(){return new CellRange(this._row,this._col,this._row2,this._col2)};CellRange.prototype.copy=function(e){this.setRange(e._row,e._col,e._row2,e._col2)};Object.defineProperty(CellRange.prototype,"rowSpan",{get:function(){return Math.abs(this._row2-this._row)+1},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"columnSpan",{get:function(){return Math.abs(this._col2-this._col)+1},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"topRow",{get:function(){return Math.min(this._row,this._row2)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"bottomRow",{get:function(){return Math.max(this._row,this._row2)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"leftCol",{get:function(){return Math.min(this._col,this._col2)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"rightCol",{get:function(){return Math.max(this._col,this._col2)},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"isValid",{get:function(){return this._row>-1&&this._col>-1&&this._row2>-1&&this._col2>-1},enumerable:!0,configurable:!0});Object.defineProperty(CellRange.prototype,"isSingleCell",{get:function(){return this._row==this._row2&&this._col==this._col2},enumerable:!0,configurable:!0});CellRange.prototype.contains=function(t,i){var o=e.tryCast(t,CellRange);if(o)return o.topRow>=this.topRow&&o.bottomRow<=this.bottomRow&&o.leftCol>=this.leftCol&&o.rightCol<=this.rightCol;if(e.isInt(t)&&e.isInt(i))return t>=this.topRow&&t<=this.bottomRow&&i>=this.leftCol&&i<=this.rightCol;throw"contains expects a CellRange or row/column indices."};CellRange.prototype.containsRow=function(t){return e.asInt(t)>=this.topRow&&t<=this.bottomRow};CellRange.prototype.containsColumn=function(t){return e.asInt(t)>=this.leftCol&&t<=this.rightCol};CellRange.prototype.intersects=function(e){return this.intersectsRow(e)&&this.intersectsColumn(e)};CellRange.prototype.intersectsRow=function(e){return e&&!(this.bottomRow<e.topRow||this.topRow>e.bottomRow)};CellRange.prototype.intersectsColumn=function(e){return e&&!(this.rightCol<e.leftCol||this.leftCol>e.rightCol)};CellRange.prototype.getRenderSize=function(t){var i=new e.Size(0,0);if(this.isValid){for(var o=this.topRow;o<=this.bottomRow;o++)i.height+=t.rows[o].renderSize;for(var n=this.leftCol;n<=this.rightCol;n++)i.width+=t.columns[n].renderSize}return i};CellRange.prototype.equals=function(e){return e instanceof CellRange&&this._row==e._row&&this._col==e._col&&this._row2==e._row2&&this._col2==e._col2};CellRange.prototype.combine=function(e){return e?new CellRange(Math.min(this.topRow,e.topRow),Math.min(this.leftCol,e.leftCol),Math.max(this.bottomRow,e.bottomRow),Math.max(this.rightCol,e.rightCol)):this};CellRange.prototype.toString=function(){return e.format("({row}, {col})-({row2}, {col2})",this)};return CellRange}();t.CellRange=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None";e[e.Cell=1]="Cell";e[e.ColumnHeader=2]="ColumnHeader";e[e.RowHeader=3]="RowHeader";e[e.TopLeft=4]="TopLeft";e[e.ColumnFooter=5]="ColumnFooter";e[e.BottomLeft=6]="BottomLeft"}(i=t.CellType||(t.CellType={}));var o=function(){function GridPanel(i,o,n,r,l){this._offsetY=0;this._rng=new t.CellRange;this._g=e.asType(i,t.FlexGrid);this._ct=e.asInt(o);this._rows=e.asType(n,t.RowCollection);this._cols=e.asType(r,t.ColumnCollection);this._e=e.asType(l,HTMLElement);this._vrb=new t.CellRange}Object.defineProperty(GridPanel.prototype,"grid",{get:function(){return this._g},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"cellType",{get:function(){return this._ct},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"viewRange",{get:function(){return this._getViewRange()},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"width",{get:function(){return this._cols.getTotalSize()},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"height",{get:function(){return this._rows.getTotalSize()},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"rows",{get:function(){return this._rows},enumerable:!0,configurable:!0});Object.defineProperty(GridPanel.prototype,"columns",{get:function(){return this._cols},enumerable:!0,configurable:!0});GridPanel.prototype.getCellData=function(o,n,r){var l,s=this._g,a=this._rows[e.asNumber(o,!1,!0)],d=null;if(!a)return null;n=this._toIndex(n);l=this._cols[e.asNumber(n,!1,!0)];var c=s?s._getBindingColumn(this,o,l):l,u=null;a instanceof t.GroupRow&&a.dataItem instanceof e.collections.CollectionViewGroup&&!s.childItemsPath&&(u=a.dataItem);c.binding&&a.dataItem&&!u?d=c._binding.getValue(a.dataItem):a._ubv&&(d=a._ubv[l._hash]);if(null==d){var h=i;switch(this._ct){case h.TopLeft:case h.ColumnHeader:o!=this._rows.length-1&&c==l||(d=c.header);break;case h.ColumnFooter:if(c.aggregate!=e.Aggregate.None&&a instanceof t.GroupRow){var f=this._g.collectionView;if(f){var g=e.tryCast(f,e.collections.CollectionView);d=g?g.getAggregate(c.aggregate,c.binding):e.getAggregate(c.aggregate,f.items,c.binding)}}break;case h.Cell:c.aggregate!=e.Aggregate.None&&a instanceof t.GroupRow&&u&&(d=u.getAggregate(c.aggregate,c.binding,this._g.collectionView))}}if(r){var p=c.dataMap||a.dataMap;this.cellType==i.Cell&&p&&(d=p.getDisplayValue(d));d=null!=d?e.Globalize.format(d,c.format||a.format):""}return d};GridPanel.prototype.setCellData=function(t,o,n,r,l){void 0===r&&(r=!0);void 0===l&&(l=!0);var s=this._g,a=this._rows[e.asNumber(t,!1,!0)],d=this._cols[e.asNumber(this._toIndex(o),!1,!0)],c=e.DataType;if(!a)return!1;var u=s?s._getBindingColumn(this,t,d):d;if(this._ct==i.Cell){var h=u.dataMap||a.dataMap,f=u.getIsRequired(a),g=u.isContentHtml||a.isContentHtml;if(h&&null!=n){var p=h.getKeyValue(n,g);if(null==p&&null==h.getDisplayValue(null)){if(h.getDisplayValue(n)!=n);else if(!h.isEditable||h.displayMemberPath!=h.selectedValuePath){if(""!=n||f)return!1;n=null}}else n=p}var _=c.Object,m=u.dataType||a.dataType,w=this.getCellData(t,o,!1);_=m||e.getType(w);var C=null==n||""===n&&!h;if(!f&&C){_!=c.String&&(n=null);r=!1}else if(f&&C&&r)return!1;if(r){var v=u.format||a.format;v||_!=c.Date||(v="d");u.mask&&e.isString(n)&&_!=c.String&&(n=n.replace(/_/g,""));n=e.changeType(n,_,v,w);if(_!=c.Object&&e.getType(n)!=_)return!1}}if(a.dataItem&&u.binding){var y=u._binding,b=a.dataItem,R=y.getValue(b);if(n!==R&&!e.DateTime.equals(n,R)){y.setValue(b,n);var E=s.collectionView;if(E instanceof e.collections.CollectionView&&b!=E.currentEditItem){var x=new e.collections.NotifyCollectionChangedEventArgs(e.collections.NotifyCollectionChangedAction.Change,b,E.items.indexOf(b));E.onCollectionChanged(x)}}}else{a._ubv||(a._ubv={});a._ubv[d._hash]=n}l&&s&&s.invalidate();return!0};GridPanel.prototype.getCellBoundingRect=function(t,i,o){var n=this._g,r=this.rows[t],l=this.columns[this._toIndex(i)],s=new e.Rect(l.pos,r.pos,l.renderSize,r.renderSize);if(n.rightToLeft){s.left=this.hostElement.clientWidth-s.right;e.isIE()||(s.left-=n._root.offsetWidth-n._root.clientWidth)}if(!o){var a=this.hostElement.getBoundingClientRect();s.left+=a.left;s.top+=a.top-this._offsetY}t<this.rows.frozen&&(s.top-=n.scrollPosition.y);i<this.columns.frozen&&(s.left-=n.scrollPosition.x*(n.rightToLeft?-1:1));return s};GridPanel.prototype.getCellElement=function(e,t){var i=this.hostElement.children,o=Math.min(e+2,i.length);t=this._toIndex(t);for(var n=0;n<o;n++)for(var r=i[n].children,l=Math.min(t+2,r.length),s=0;s<l;s++){var a=r[s],d=a[GridPanel._INDEX_KEY];if(d&&(d.row==e&&d.col==t||d.rng&&d.rng.contains(e,t)))return a}return null};GridPanel.prototype.getSelectedState=function(e,o,n){var r=this._g,l=r.selectionMode,s=r._selHdl.selection,a=t.SelectionMode,d=t.SelectedState;if(l==a.None)return d.None;o=this._toIndex(o);switch(this._ct){case i.Cell:n||(n=r.getMergedRange(this,e,o));if(n){if(n.contains(s.row,s.col))return r.showMarquee?d.Active:d.Cursor;if(n.intersects(s)&&l!=a.ListBox)return d.Selected;for(var c=n.leftCol;c<=n.rightCol;c++)if(r.columns[c].isSelected)return d.Selected;for(var u=n.topRow;u<=n.bottomRow;u++)if(r.rows[u].isSelected)return d.Selected}if(s.row==e&&s.col==o)return r.showMarquee?d.Active:d.Cursor;if(r.rows[e].isSelected||r.columns[o].isSelected)return d.Selected;if(l==a.MultiRange)for(var h=r._selHdl.extendedSelection,f=0;f<h.length;f++)if(h[f].contains(e,o)||n&&n.intersects(h[f]))return d.Selected;if(n)switch(l){case a.Row:case a.RowRange:if(n.containsRow(s.row))return d.Selected}return l==a.ListBox?d.None:(s=this._getAdjustedSelection(s)).containsRow(e)&&s.containsColumn(o)?d.Selected:d.None;case i.ColumnHeader:if(r.showSelectedHeaders&t.HeadersVisibility.Column&&(r.columns[o].isSelected||s.containsColumn(o)||s.intersectsColumn(n))){n&&(e=n.bottomRow);if(e==this.rows.length-1)return d.Selected}break;case i.RowHeader:if(r.showSelectedHeaders&t.HeadersVisibility.Row&&(r.rows[e].isSelected||s.containsRow(e)||s.intersectsRow(n))){n&&(o=n.rightCol);if(o==this.columns.length-1)return d.Selected}}return d.None};Object.defineProperty(GridPanel.prototype,"hostElement",{get:function(){return this._e},enumerable:!0,configurable:!0});GridPanel.prototype._toIndex=function(t){if(e.isString(t)&&(t=this._cols.indexOf(t))<0)throw"Invalid column name or binding.";return t};GridPanel.prototype._getAdjustedSelection=function(e){var i=this._g,o=this._rng,n=t.SelectionMode;switch(i.selectionMode){case n.Cell:o.setRange(e.row,e.col,e.row,e.col);break;case n.Row:o.setRange(e.row,0,e.row,i.columns.length-1);break;case n.RowRange:case n.ListBox:o.setRange(e.row,0,e.row2,i.columns.length-1);break;default:o.copy(e)}return o};GridPanel.prototype._getOffsetY=function(){return this._offsetY};GridPanel.prototype._updateContent=function(o,n,r){var l=this._g,s=this._e,a=this._rows,d=this._cols,c=this._ct;if(c==i.ColumnHeader||c==i.ColumnFooter||c==i.RowHeader){var u=l._ptScrl,h=s.style;c==i.RowHeader?h.top=u.y+"px":l.rightToLeft?h.right=u.x+"px":h.left=u.x+"px"}if(this._offsetY!=r){o=!1;this._offsetY=r}var f=this._getViewRange(),g=f;if(g.isValid){var p=a.length<=l._vtRows?a.length:0,_=d.length<=l._vtCols?d.length:0;g=new t.CellRange(Math.max(f.row-p,a.frozen),Math.max(f.col-_,d.frozen),Math.min(f.row2+p,a.length-1),Math.min(f.col2+_,d.length-1))}if(o&&!n&&this._vrb.contains(f)&&!a.frozen&&!d.frozen)return this._activeCell;o&&g.equals(this._vrb)||(n=!1);o&&!n&&this._ct!=i.TopLeft&&this._reorderCells(g,this._vrb);this._activeCell=null;this._vru=f;this._vrb=g;this._recycle=o;var m=0;this._ct==i.Cell&&(m=this._renderColHdrRow(g,n));for(var w=0;w<a.frozen&&w<a.length;w++)m=this._renderRow(w,g,n,m);for(w=g.topRow;w<=g.bottomRow&&w>-1;w++)m=this._renderRow(w,g,n,m);for(;s.childElementCount>m;){var C=s.lastElementChild;e.removeChild(C);this._removeExtraCells(C,0)}return this._activeCell};GridPanel.prototype._clearCells=function(){for(var t=this.hostElement,i=this._g.cellFactory,o=t.childElementCount-1;o>=0;o--){var n=t.children[o];e.removeChild(n);for(var r=n.childElementCount-1;r>=0;r--)i.disposeCell(n.children[r])}};GridPanel.prototype._reorderCells=function(t,o){if(this._g._reorderCells&&o.isValid&&t.isValid&&t.intersects(o)){if(t.row!=o.row){var n=this._e;if(0!=(a=t.row-o.row)){var r=this._ct==i.Cell?1:0;r+=this.rows.frozen;if(a>0)for(var l=0;l<a;l++)e.removeChild(n.children[r]);else if(a<0){var s=n.children[r];for(l=0;l<-a;l++){(d=document.createElement("div")).className="wj-row";n.insertBefore(d,s)}}}}if(t.col!=o.col){var a;n=this._e;if(0!=(a=t.col-o.col)){r=this._ct==i.Cell&&this._g.rowHeaderPath?1:0;r+=this.columns.frozen;for(l=0;l<n.children.length;l++){var d=n.children[l];if(e.hasClass(d,"wj-row"))if(a>0)for(var c=0;c<a;c++)e.removeChild(d.children[r]);else if(a<0){s=d.children[r];for(var u=0;u<-a;u++){var h=document.createElement("div");h.className="wj-cell";d.insertBefore(h,s)}}}}}}};GridPanel.prototype._renderColHdrRow=function(t,i){if(i)return 1;var o=this._e.children[0];o||(o=e.createElement('<div class="wj-row" role="row"></div>',this._e));var n=this._g,r=n?n.columnHeaders.rows.ariaLabel:null;e.setAttribute(o,"aria-label",r);e.setAttribute(o,"aria-selected",null);var l=0,s=this._g._getRowHeaderPath();s&&(l=this._renderRowHdrCell(o,-1,s.path));for(var a=0;a<this.columns.frozen&&a<this.columns.length;a++)l=this._renderColHdrCell(o,a,t,i,l);for(a=t.leftCol;a<=t.rightCol&&a>-1;a++)l=this._renderColHdrCell(o,a,t,i,l);this._removeExtraCells(o,l);return 1};GridPanel.prototype._renderColHdrCell=function(t,i,o,n,r){var l=this.grid,s=this.columns[i];if(s.renderSize<=0)return r;if(n)return r+1;var a=t.children[r];a||(a=e.createElement(GridPanel._HTML_CELL,t));e.setAttribute(a,"role","columnheader");if(a&&this._recycle&&l._lazyRender){var d=a[GridPanel._INDEX_KEY];if(d&&-1==d.row&&d.col==i&&i>=this.columns.frozen)return r+1}a.textContent=this.columns[i].header;e.setCss(a,{position:"fixed",left:s.pos,top:-32e3,width:s.renderSize,height:.1,overflow:"hidden",opacity:"0",pointerEvents:"none"});if(s.describedById||this.columns.describedById){var c=[s.describedById,this.columns.describedById].join(" ").trim();e.setAttribute(a,"aria-describedby",c||null)}if(l.allowSorting){var u="none";switch(l._getBindingColumn(this,0,s).currentSort){case"+":u="ascending";break;case"-":u="descending"}e.setAttribute(a,"aria-sort",u)}if(!l.isReadOnly){e.setAttribute(a,"aria-readonly",s.isReadOnly);e.setAttribute(a,"aria-required",s.getIsRequired())}a[GridPanel._INDEX_KEY]={row:-1,col:i,panel:this};return r+1};GridPanel.prototype._renderRowHdrCell=function(t,i,o){var n=t.children[0];n||(n=e.createElement(GridPanel._HTML_CELL,t));n.setAttribute("role",i<0?"columnheader":"rowheader");n.textContent=o?o.toString():"";e.setCss(n,{position:"fixed",left:-32e3,top:-32e3,width:.1,height:.1,overflow:"hidden",opacity:"0"});n[GridPanel._INDEX_KEY]={row:i,col:-1,panel:this};return 1};GridPanel.prototype._renderRow=function(o,n,r,l){var s=this._g,a=this.rows[o];if(a.renderSize<=0)return l;var d=this._e.children[l];d||(d=e.createElement('<div class="wj-row"></div>',this._e));if(this._ct==i.Cell){d.setAttribute("role","row");var c=t.SelectionMode,u=a.isSelected;switch(s.selectionMode){case c.Row:case c.RowRange:u=u||this._g._selHdl.selection.containsRow(o)}e.setAttribute(d,"aria-selected",!!u||null);e.setAttribute(d,"aria-level",a instanceof t.GroupRow?a.level+1:null);e.setAttribute(d,"aria-expanded",a instanceof t.GroupRow?!a.isCollapsed:null);this.rows.ariaLabel&&e.setAttribute(d,"aria-label",this.rows.ariaLabel)}var h=0;if(this._ct==i.Cell){var f=this._g._getRowHeaderPath();f&&(h=this._renderRowHdrCell(d,o,f.getValue(a.dataItem)))}for(var g=0;g<this.columns.frozen&&g<this.columns.length;g++)h=this._renderCell(d,o,g,n,r,h);for(g=n.leftCol;g<=n.rightCol&&g>-1;g++)h=this._renderCell(d,o,g,n,r,h);this._removeExtraCells(d,h);return l+1};GridPanel.prototype._renderCell=function(o,n,r,l,s,a){var d=this._g,c=d.getMergedRange(this,n,r);if(c){for(var u=Math.max(l.row,c.row);u<n;u++)if(this.rows[u].renderSize)return a;for(u=Math.max(l.col,c.col);u<r;u++)if(this.columns[u].renderSize)return a;var h=this.columns.frozen;if(h&&c.col<h&&c.col2>=h&&r>c.col)return a}var f=this.columns[r];if(f.renderSize<=0&&(!c||c.getRenderSize(this).width<=0))return a;var g=o.children[a];if(g&&!s&&this._recycle&&d._lazyRender&&!d.activeEditor){var p=g[GridPanel._INDEX_KEY];p&&p.row==n&&p.col==r&&p.rng==c&&n>=this.rows.frozen&&r>=this.columns.frozen&&(s=!0)}var _=t.SelectedState,m=this.getSelectedState(n,r,c),w=m==_.Cursor||m==_.Active;if(g&&s){e.toggleClass(g,"wj-state-active",w);e.toggleClass(g,"wj-state-selected",m==_.Cursor);e.toggleClass(g,"wj-state-multi-selected",m==_.Selected);e.setAttribute(g,"aria-selected",!(!w&&m==_.None)||null);w&&(this._activeCell=g);return a+1}g||(g=e.createElement(GridPanel._HTML_CELL,o));w&&(this._activeCell=g);if(this._ct==i.Cell){e.setAttribute(g,"role","gridcell");e.setAttribute(g,"aria-selected",!(m==_.None&&!w)||null);e.setAttribute(g,"aria-readonly",!d.canEditCell(n,r)||null);e.setAttribute(g,"aria-required",f.getIsRequired())}d.cellFactory.updateCell(this,n,r,g,c);g[GridPanel._INDEX_KEY]={row:n,col:r,rng:c,panel:this};return a+1};GridPanel.prototype._removeExtraCells=function(t,i){for(var o=this._g.cellFactory;t.childElementCount>i;){var n=t.lastElementChild;e.removeChild(n);o.disposeCell(n)}};GridPanel.prototype._getViewRange=function(){var e=this._g,o=e._ptScrl,n=e._szClientSB,r=this._rows,l=this._cols,s=new t.CellRange(0,0,r.length-1,l.length-1);if(this._ct==i.Cell||this._ct==i.RowHeader){var a=-o.y+this._offsetY,d=n.height;if((f=Math.min(r.frozen,r.length-1))>0){a+=_=r[f-1].pos;d-=_}if(f>0&&r[f].pos>n.height)s.row=s.row2=-1;else{s.row=Math.min(r.length-1,Math.max(f,r.getItemAt(a)));s.row2=Math.max(s.row,r.getItemAt(a+d))}var c=e.hostElement;if(e._clipToScreen&&c){var u=c.getBoundingClientRect(),h=-u.top-e.cells._e.offsetTop;u.top<0&&(s.row=Math.max(s.row,r.getItemAt(h)-1));u.bottom>innerHeight&&(s.row2=Math.min(s.row2,r.getItemAt(h+innerHeight)+1))}}if(this._ct==i.Cell||this._ct==i.ColumnHeader){var f,g=-o.x,p=n.width;if((f=Math.min(l.frozen,l.length-1))>0){var _;g+=_=l[f-1].pos;p-=_}if(f>0&&l[f].pos>n.width)s.col=s.col2=-1;else{s.col=Math.min(l.length-1,Math.max(f,l.getItemAt(g)));s.col2=Math.max(s.col,l.getItemAt(g+p))}}r.length<=r.frozen&&(s.row=s.row2=-1);l.length<=l.frozen&&(s.col=s.col2=-1);return s};GridPanel.prototype._getFrozenPos=function(){var t=this._rows.frozen,i=this._cols.frozen,o=t>0?this._rows[t-1]:null,n=i>0?this._cols[i-1]:null,r=o?o.pos+o.renderSize:0,l=n?n.pos+n.renderSize:0;return new e.Point(l,r)};GridPanel._INDEX_KEY="wj-cell-index";GridPanel._HTML_CELL='<div class="wj-cell" tabindex="-1"></div>';return GridPanel}();t.GridPanel=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(i){__extends(CellRangeEventArgs,i);function CellRangeEventArgs(o,n,r){var l=i.call(this)||this;l._p=e.asType(o,t.GridPanel,!0);l._rng=e.asType(n,t.CellRange,!0);l._data=r;return l}Object.defineProperty(CellRangeEventArgs.prototype,"panel",{get:function(){return this._p},enumerable:!0,configurable:!0});Object.defineProperty(CellRangeEventArgs.prototype,"range",{get:function(){return this._rng.clone()},enumerable:!0,configurable:!0});Object.defineProperty(CellRangeEventArgs.prototype,"row",{get:function(){return this._rng.row},enumerable:!0,configurable:!0});Object.defineProperty(CellRangeEventArgs.prototype,"col",{get:function(){return this._rng.col},enumerable:!0,configurable:!0});Object.defineProperty(CellRangeEventArgs.prototype,"data",{get:function(){return this._data},set:function(e){this._data=e},enumerable:!0,configurable:!0});CellRangeEventArgs.prototype.getRow=function(){return this._p&&this.row>-1?this._p.rows[this.row]:null};CellRangeEventArgs.prototype.getColumn=function(e){var t=this._p,i=t&&this.col>-1?t.columns[this.col]:null;i&&e&&(i=t.grid._getBindingColumn(t,this.row,i));return i};return CellRangeEventArgs}(e.CancelEventArgs);t.CellRangeEventArgs=i;var o=function(t){__extends(FormatItemEventArgs,t);function FormatItemEventArgs(i,o,n,r){void 0===r&&(r=!0);var l=t.call(this,i,o)||this;l._updateContent=!0;l._cell=e.asType(n,HTMLElement);return l}Object.defineProperty(FormatItemEventArgs.prototype,"cell",{get:function(){return this._cell},enumerable:!0,configurable:!0});Object.defineProperty(FormatItemEventArgs.prototype,"updateContent",{get:function(){return this._updateContent},enumerable:!0,configurable:!0});return FormatItemEventArgs}(i);t.FormatItemEventArgs=o;var n=function(t){__extends(CellEditEndingEventArgs,t);function CellEditEndingEventArgs(){var e=null!==t&&t.apply(this,arguments)||this;e._stayInEditMode=!1;e._refresh=!0;return e}Object.defineProperty(CellEditEndingEventArgs.prototype,"stayInEditMode",{get:function(){return this._stayInEditMode},set:function(t){this._stayInEditMode=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(CellEditEndingEventArgs.prototype,"refresh",{get:function(){return this._refresh},set:function(t){this._refresh=e.asBoolean(t)},enumerable:!0,configurable:!0});return CellEditEndingEventArgs}(i);t.CellEditEndingEventArgs=n}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i,o;!function(e){e[e.None=0]="None";e[e.Cell=1]="Cell";e[e.CellRange=2]="CellRange";e[e.Row=3]="Row";e[e.RowRange=4]="RowRange";e[e.ListBox=5]="ListBox";e[e.MultiRange=6]="MultiRange"}(i=t.SelectionMode||(t.SelectionMode={}));!function(e){e[e.None=0]="None";e[e.Selected=1]="Selected";e[e.Cursor=2]="Cursor";e[e.Active=3]="Active"}(t.SelectedState||(t.SelectedState={}));!function(e){e[e.None=0]="None";e[e.Next=1]="Next";e[e.Prev=2]="Prev";e[e.NextPage=3]="NextPage";e[e.PrevPage=4]="PrevPage";e[e.Home=5]="Home";e[e.End=6]="End";e[e.NextCell=7]="NextCell";e[e.PrevCell=8]="PrevCell";e[e.NextEditableCell=9]="NextEditableCell";e[e.PrevEditableCell=10]="PrevEditableCell"}(o=t.SelMove||(t.SelMove={}));var n=function(){function _SelectionHandler(o){this._sel=new t.CellRange(0,0);this._xSel=new e.collections.ObservableArray;this._mode=i.CellRange;this._g=o;this._e=new t.CellRangeEventArgs(o.cells,new t.CellRange(0,0));this._xSel.collectionChanged.addHandler((function(){o.invalidate()}))}Object.defineProperty(_SelectionHandler.prototype,"selectionMode",{get:function(){return this._mode},set:function(e){e!=this._mode&&this._setSelectionMode(e)},enumerable:!0,configurable:!0});Object.defineProperty(_SelectionHandler.prototype,"selection",{get:function(){return this._sel},set:function(e){this.select(e)},enumerable:!0,configurable:!0});Object.defineProperty(_SelectionHandler.prototype,"extendedSelection",{get:function(){return this._xSel},enumerable:!0,configurable:!0});_SelectionHandler.prototype.select=function(o,n,r){void 0===n&&(n=!0);void 0===r&&(r=!1);var l=this._g,s=this._e.range,a=this._sel,d=s,c=!1,u=i;if(e.isNumber(o)&&e.isString(n)){var h=l.columns.indexOf(n);if(h<0)throw"Invalid column name or binding.";s.setRange(o,h);n=!0}else if(e.isNumber(o)&&e.isNumber(n)){s.setRange(o,n);n=!0}else o instanceof t.CellRange?s.copy(o):e.assert(!1,"CellRange expected");switch(l.selectionMode){case u.Cell:d.row2=d.row;d.col2=d.col;break;case u.Row:d.row2=d.row;break;case u.ListBox:c=!0}var f=d.equals(a);c&&d.row>-1&&d.row<l.rows.length&&(l.rows[d.row].isSelected||(f=!1));if(f&&l.isRangeValid(d)){n&&this._showSelection();return!0}var g=e.Control.getControl(e.closest(e.getActiveElement(),".wj-flexgrid"));if(g&&g.activeEditor&&!g.finishEditing())return!1;var p=this._e;p._rng=d;p.cancel=!1;if(!l.onSelectionChanging(p)&&!r)return!1;c&&l.rows.forEach((function(e,i){e._setFlag(t.RowColFlags.Selected,d.containsRow(i),!0)}));d.row=Math.min(d.row,l.rows.length-1);d.row2=Math.min(d.row2,l.rows.length-1);this._sel.copy(d);l.refreshCells(!1,!0,!0);n&&this._showSelection();var _=l.collectionView;if(_){var m=l._getCvIndex(d.row);_.moveCurrentToPosition(m)}l.onSelectionChanged(p);return!0};_SelectionHandler.prototype.moveSelection=function(e,i,n){var r=this._g,l=this._sel,s=n&&r.anchorCursor?new t.CellRange(l.row2,l.col2):new t.CellRange(l.row,l.col);this._adjustReferenceCell(s,e,i);var a=s.row,d=s.col,c=r.rows,u=r.columns,h=Math.max(0,r._szClient.height-r.columnHeaders.height),f=o;switch(i){case f.NextCell:case f.NextEditableCell:if((d=u.getNextCell(d,i))==s.col&&(a=c.getNextCell(a,i))>s.row){d=u.getNextCell(0,i);d=u.getNextCell(d,i==f.NextCell?f.PrevCell:f.PrevEditableCell)}r.select(a,d);break;case f.PrevCell:case f.PrevEditableCell:if((d=u.getNextCell(s.col,i))==s.col&&(a=c.getNextCell(a,i))<s.row){d=u.getNextCell(u.length-1,i);d=u.getNextCell(d,i==f.PrevCell?f.NextCell:f.NextEditableCell)}r.select(a,d);break;default:a=c.getNextCell(a,e,h);d=u.getNextCell(d,i,h);n?r.selection=r.anchorCursor?new t.CellRange(l.row,l.col,a,d):new t.CellRange(a,d,l.row2,l.col2):r.select(a,d)}};_SelectionHandler.prototype._setSelectionMode=function(e){var o=this._g,n=o.rows,r=i;if(e==r.ListBox||this._mode==r.ListBox)for(var l=0;l<n.length;l++){var s=e==r.ListBox&&this._sel.containsRow(l);n[l]._setFlag(t.RowColFlags.Selected,s,!0)}this._mode=e;this._xSel.clear();if(n.length){s=this._sel;s=e!=r.None?new t.CellRange(s.row,s.col):new t.CellRange;this.select(s,!1,!0);o.invalidate()}};_SelectionHandler.prototype._expandSelection=function(){var e=this._g;if(e.expandSelectionOnCopyPaste&&e.selectionMode){var i=this.selection,o=e.cells,n=e.getMergedRange(o,i.topRow,i.leftCol,!1),r=e.getMergedRange(o,i.bottomRow,i.leftCol,!1),l=e.getMergedRange(o,i.topRow,i.rightCol,!1),s=e.getMergedRange(o,i.bottomRow,i.rightCol,!1);if(n||r||l||s){n=n||new t.CellRange(i.topRow,i.leftCol);r=r||new t.CellRange(i.bottomRow,i.leftCol);l=l||new t.CellRange(i.topRow,i.rightCol);s=s||new t.CellRange(i.bottomRow,i.rightCol);var a=new t.CellRange(Math.min(n.topRow,r.topRow,l.topRow,s.topRow),Math.min(n.leftCol,r.leftCol,l.leftCol,s.leftCol),Math.max(n.bottomRow,r.bottomRow,l.bottomRow,s.bottomRow),Math.max(n.rightCol,r.rightCol,l.rightCol,s.rightCol));this.select(a,!1)}}};_SelectionHandler.prototype._deselectRange=function(e){var i=this.selection,o=this.extendedSelection;if(i.contains(e)){var n=o.length;this._sel=n?o[n-1]:new t.CellRange;n&&o.removeAt(n-1);return!0}for(var r=0;r<o.length;r++)if(o[r].contains(e)){o.removeAt(r);return!0}return!1};_SelectionHandler.prototype._showSelection=function(){var e=this._g,t=this._sel;e.anchorCursor?e.scrollIntoView(t.row2,t.col2):e.scrollIntoView(t.row,t.col)};_SelectionHandler.prototype._adjustReferenceCell=function(e,t,i){var n=this._g,r=n.getMergedRange(n.cells,e.row,e.col);if(r&&!r.isSingleCell){var l=o;switch(t){case l.Next:case l.NextCell:case l.NextEditableCell:e.row=r.bottomRow;break;case l.Prev:case l.PrevCell:case l.PrevEditableCell:e.row=r.topRow}switch(i){case l.Next:case l.NextCell:case l.NextEditableCell:e.col=r.rightCol;break;case l.Prev:case l.PrevCell:case l.PrevEditableCell:e.col=r.leftCol}}};return _SelectionHandler}();t._SelectionHandler=n}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i;!function(e){e[e.Visible=1]="Visible";e[e.AllowResizing=2]="AllowResizing";e[e.AllowDragging=4]="AllowDragging";e[e.AllowMerging=8]="AllowMerging";e[e.AllowSorting=16]="AllowSorting";e[e.AutoGenerated=32]="AutoGenerated";e[e.Collapsed=64]="Collapsed";e[e.ParentCollapsed=128]="ParentCollapsed";e[e.Selected=256]="Selected";e[e.ReadOnly=512]="ReadOnly";e[e.HtmlContent=1024]="HtmlContent";e[e.WordWrap=2048]="WordWrap";e[e.MultiLine=4096]="MultiLine";e[e.HasTemplate=8192]="HasTemplate";e[e.RowDefault=3]="RowDefault";e[e.ColumnDefault=23]="ColumnDefault"}(i=t.RowColFlags||(t.RowColFlags={}));var o=function(){function RowCol(){this._type=null;this._align=null;this._inpType=null;this._mask=null;this._maxLen=null;this._required=null;this._fmt=null;this._map=null;this._ddCssClass=null;this._cssClass=null;this._cssClassAll=null;this._szMin=null;this._szMax=null;this._sz=null;this._pos=0;this._idx=-1;this._idxVis=-1;this._idxData=-1;this.gridChanged=new e.Event}Object.defineProperty(RowCol.prototype,"binding",{get:function(){return this._binding?this._binding.path:null},set:function(t){if(t!=this.binding){var i=e.asString(t);this._binding=i?new e.Binding(i):null;if(!this._type&&this.grid&&this._binding){var o=this.grid.collectionView;if(o&&o.sourceCollection&&o.sourceCollection.length){var n=o.sourceCollection[0];this._type=e.getType(this._binding.getValue(n))}}this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"sortMemberPath",{get:function(){return this._bindingSort?this._bindingSort.path:null},set:function(t){if(t!=this.sortMemberPath){var i=e.asString(t);this._bindingSort=i?new e.Binding(i):null;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"dataType",{get:function(){return this._type},set:function(t){t=e.asEnum(t,e.DataType,!0);if(this._type!=t){this._type=t;this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"inputType",{get:function(){return this._inpType},set:function(t){this._inpType=e.asString(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"mask",{get:function(){return this._mask},set:function(t){this._mask=e.asString(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"maxLength",{get:function(){return this._maxLen},set:function(t){this._maxLen=e.asNumber(t,!0,!0)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"align",{get:function(){return this._align},set:function(e){if(this._align!=e){this._align=e;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"format",{get:function(){return this._fmt},set:function(e){if(this._fmt!=e){this._fmt=e;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"dataMap",{get:function(){return this._map},set:function(i){if(this._map!=i){this._map&&this._map.mapChanged.removeHandler(this.onPropertyChanged,this);e.isArray(i)&&(i=new t.DataMap(i,null,null));this._map=e.asType(i,t.DataMap,!0);this._map&&this._map.mapChanged.addHandler(this.onPropertyChanged,this);this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"dataMapEditor",{get:function(){return null!=this._mapEditor?this._mapEditor:t.DataMapEditor.DropDownList},set:function(i){if(i!=this._mapEditor){this._mapEditor=e.asEnum(i,t.DataMapEditor);this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"showDropDown",{get:function(){return this.dataMapEditor==t.DataMapEditor.DropDownList},set:function(i){e._deprecated("showDropDown","dataMapEditor");this.dataMapEditor=i?t.DataMapEditor.DropDownList:t.DataMapEditor.AutoComplete},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"dropDownCssClass",{get:function(){return this._ddCssClass},set:function(t){this._ddCssClass=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"visible",{get:function(){return this._getFlag(i.Visible)},set:function(e){this._setFlag(i.Visible,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"isVisible",{get:function(){return!!this._getFlag(i.Visible)&&(!this._getFlag(i.ParentCollapsed)||this instanceof t._NewRowTemplate)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"pos",{get:function(){this._list&&this._list._dirty&&this._list._update();return this._pos},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"index",{get:function(){this._list&&this._list._dirty&&this._list._update();return this._idx},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"visibleIndex",{get:function(){this._list&&this._list._dirty&&this._list._update();return this.isVisible?this._idxVis:-1},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"size",{get:function(){return this._sz},set:function(t){if(t!=this._sz){this._sz=e.asNumber(t,!0);this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"renderSize",{get:function(){var e=0,t=this._list;if(this.isVisible){(null==(e=this._sz)||e<0)&&(e=t?t.defaultSize:0);t&&null!=t.minSize&&e<t.minSize&&(e=t.minSize);t&&null!=t.maxSize&&e>t.maxSize&&(e=t.maxSize);null!=this._szMin&&e<this._szMin&&(e=this._szMin);null!=this._szMax&&e>this._szMax&&(e=this._szMax)}return e},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"allowResizing",{get:function(){return this._getFlag(i.AllowResizing)},set:function(e){this._setFlag(i.AllowResizing,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"allowDragging",{get:function(){return this._getFlag(i.AllowDragging)},set:function(e){this._setFlag(i.AllowDragging,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"allowMerging",{get:function(){return this._getFlag(i.AllowMerging)},set:function(e){this._setFlag(i.AllowMerging,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"isSelected",{get:function(){return this._getFlag(i.Selected)},set:function(e){if(!!e!=this.isSelected){var o=this.grid;if(o){var n=this instanceof r?new t.CellRange(this.index,-1):new t.CellRange(-1,this.index),l=new t.CellRangeEventArgs(o?o.cells:null,n);if(o.onSelectionChanging(l)&&this._setFlag(i.Selected,e,!0)){o.refreshCells(!1,!0,!0);o.onSelectionChanged(l)}}else this._setFlag(i.Selected,e)}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"isReadOnly",{get:function(){return this._getFlag(i.ReadOnly)},set:function(e){this._setFlag(i.ReadOnly,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"isRequired",{get:function(){return this._required},set:function(t){this._required=e.asBoolean(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"isContentHtml",{get:function(){return this._getFlag(i.HtmlContent)},set:function(e){if(this.isContentHtml!=e){this._setFlag(i.HtmlContent,e);this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"wordWrap",{get:function(){return this._getFlag(i.WordWrap)},set:function(e){this._setFlag(i.WordWrap,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"multiLine",{get:function(){return this._getFlag(i.MultiLine)},set:function(e){this._setFlag(i.MultiLine,e)},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"cssClass",{get:function(){return this._cssClass},set:function(t){if(t!=this._cssClass){this._cssClass=e.asString(t);this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"cssClassAll",{get:function(){return this._cssClassAll},set:function(t){if(t!=this._cssClassAll){this._cssClassAll=e.asString(t);this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"grid",{get:function(){return this._list?this._list._g:null},enumerable:!0,configurable:!0});Object.defineProperty(RowCol.prototype,"collectionView",{get:function(){return this.grid?this.grid.collectionView:null},enumerable:!0,configurable:!0});RowCol.prototype.onPropertyChanged=function(){if(this._list){this._list._dirty=!0;this.grid.invalidate()}};RowCol.prototype.onGridChanged=function(e){this.gridChanged.raise(this,e)};RowCol.prototype._setList=function(e){if(e!=this._list){this._list=e;this.onGridChanged()}};RowCol.prototype._getFlag=function(e){return 0!=(this._f&e)};RowCol.prototype._setFlag=function(e,t,i){if(!!t!=this._getFlag(e)){this._f=t?this._f|e:this._f&~e;i||this.onPropertyChanged();return!0}return!1};return RowCol}();t.RowCol=o;var n=function(o){__extends(Column,o);function Column(t){var n=o.call(this)||this;n._hdr=null;n._name=null;n._agg=null;n._quickSize=null;n._descById=null;n._tpl=null;n._f=i.ColumnDefault;n._hash=Column._ctr.toString(36);Column._ctr++;e.copy(n,t);return n}Object.defineProperty(Column.prototype,"name",{get:function(){return this._name},set:function(e){this._name=e},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"width",{get:function(){return null!=this._szStar?this._szStar:this.size},set:function(t){if(null!=Column._parseStarSize(t)){this._szStar=t;this.onPropertyChanged()}else{this._szStar=null;this.size=e.asNumber(t,!0)}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"minWidth",{get:function(){return this._szMin},set:function(t){if(t!=this._szMin){this._szMin=e.asNumber(t,!0,!0);this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"maxWidth",{get:function(){return this._szMax},set:function(t){if(t!=this._szMax){this._szMax=e.asNumber(t,!0,!0);this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"quickAutoSize",{get:function(){return this._quickSize},set:function(t){this._quickSize=e.asBoolean(t,!0)},enumerable:!0,configurable:!0});Column.prototype._getQuickAutoSize=function(){return!!this.grid._getQuickAutoSize()&&(e.isBoolean(this._quickSize)?this._quickSize:!(this.isContentHtml||this.wordWrap||this.multiLine||this._getFlag(i.HasTemplate)))};Object.defineProperty(Column.prototype,"renderWidth",{get:function(){return this.renderSize},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"header",{get:function(){return this._hdr?this._hdr:this.binding},set:function(e){if(this._hdr!=e){this._hdr=e;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"cellTemplate",{get:function(){return this._tpl},set:function(t){if(t!=this._tpl){e.assert(null==t||e.isString(t)||e.isFunction(t),"cellTemplate should be a string or an ICellTemplateFunction.");this._tpl=t;this._setFlag(i.HasTemplate,null!=t&&""!=t);this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"editor",{get:function(){var e=this._edt;return e?e.control:null},set:function(i){if(i!=this.editor){if(this._edt){this._edt.dispose();this._edt=null}if(null!=i){i=e.asType(i,e.Control);this._edt=new t._CustomEditor(this,i)}}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"allowSorting",{get:function(){return this._getFlag(i.AllowSorting)},set:function(e){this._setFlag(i.AllowSorting,e)},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"currentSort",{get:function(){var e=this.currentSortIndex;if(e>-1){return this.grid.collectionView.sortDescriptions[e].ascending?"+":"-"}return null},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"currentSortIndex",{get:function(){var e=this.grid?this.grid.collectionView:null,t=e?e.sortDescriptions:null,i=t&&t.length?this._getBindingSort():null;if(i)for(var o=0;o<t.length;o++)if(t[o].property==i)return o;return-1},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"aggregate",{get:function(){return null!=this._agg?this._agg:e.Aggregate.None},set:function(t){if((t=e.asEnum(t,e.Aggregate))!=this._agg){this._agg=t;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Column.prototype,"describedById",{get:function(){return this._descById},set:function(t){if(t!=this._descById){this._descById=e.asString(t);this.grid&&this.grid.invalidate()}},enumerable:!0,configurable:!0});Column.prototype.getIsRequired=function(t){return null!=this._required?this._required:t&&null!=t.isRequired?t.isRequired:this.dataType==e.DataType.String?null!=this.dataMap||null!=this._mask&&this._mask.length>0:!t||t.dataType!=e.DataType.String||(null!=t.dataMap||null!=t.mask&&t.mask.length>0)};Column.prototype.getAlignment=function(t){if(null!=this._align)return this._align;if(t&&null!=t.align)return t.align;if(!this._map)switch(this.dataType){case e.DataType.Boolean:return"center";case e.DataType.Number:return"right"}if(t&&!t.dataMap)switch(t.dataType){case e.DataType.Boolean:return"center";case e.DataType.Number:return"right"}return""};Column.prototype._getBindingSort=function(){return this.sortMemberPath?this.sortMemberPath:this.binding?this.binding:null};Column._parseStarSize=function(t){if(e.isString(t)){var i=t.length;if(i>0&&"*"==t[i-1]){var o=1==i?1:parseFloat(t);if(o>0&&!isNaN(o))return o}}return null};Column._ctr=0;return Column}(o);t.Column=n;var r=function(e){__extends(Row,e);function Row(t){var o=e.call(this)||this;o._f=i.ColumnDefault;o._data=t||null;return o}Object.defineProperty(Row.prototype,"dataItem",{get:function(){return this._data},set:function(e){this._data=e},enumerable:!0,configurable:!0});Object.defineProperty(Row.prototype,"dataIndex",{get:function(){this._list&&this._list._dirty&&this._list._update();return this._idxData},enumerable:!0,configurable:!0});Object.defineProperty(Row.prototype,"height",{get:function(){return this.size},set:function(e){this.size=e},enumerable:!0,configurable:!0});Object.defineProperty(Row.prototype,"renderHeight",{get:function(){return this.renderSize},enumerable:!0,configurable:!0});return Row}(o);t.Row=r;var l=function(o){__extends(GroupRow,o);function GroupRow(t){var i=o.call(this,t)||this;i._level=-1;i.level=t instanceof e.collections.CollectionViewGroup?t.level:-1;i.isReadOnly=!0;return i}Object.defineProperty(GroupRow.prototype,"level",{get:function(){return this._level},set:function(t){e.asInt(t);if(t!=this._level){this._level=t;this.onPropertyChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(GroupRow.prototype,"hasChildren",{get:function(){if(null!=this.grid&&null!=this._list){this._list._update();var i=this.index<this._list.length-1?this._list[this.index+1]:null,o=e.tryCast(i,GroupRow),n=e.tryCast(i,t._NewRowTemplate);return null!=i&&null==n&&(null==o||o.level>this.level)}return!0},enumerable:!0,configurable:!0});Object.defineProperty(GroupRow.prototype,"isCollapsed",{get:function(){return this._getFlag(i.Collapsed)},set:function(t){!!t!=this.isCollapsed&&null!=this._list&&this._setCollapsed(e.asBoolean(t))},enumerable:!0,configurable:!0});GroupRow.prototype.getGroupHeader=function(){var t=this.grid,i=t.groupHeaderFormat||e.culture.FlexGrid.groupHeaderFormat,o=this.dataItem;if(o instanceof e.collections.CollectionViewGroup&&i&&t.showGroups&&!t.childItemsPath){var n=o.groupDescription.propertyName,r=o.name,l=t.getColumn(n),s=this.isContentHtml;if(l){s=s||l.isContentHtml;l.header&&(n=l.header);var a=l.dataMap;a&&(r=a.getDisplayValue(r));l.dataType==e.getType(r)&&(r=e.Globalize.format(r,l.format))}else n=e.toHeaderCase(n);var d=o.getAggregate(e.Aggregate.CntAll,null,t.collectionView);return e.format(i,{name:e.escapeHtml(n),value:s?r:e.escapeHtml(r),level:o.level,count:d})}return""};GroupRow.prototype._setCollapsed=function(e){var o=this,n=this.grid,r=n.rows,l=this.getCellRange(),s=new t.CellRangeEventArgs(n.cells,new t.CellRange(this.index,-1));if(n.onGroupCollapsedChanging(s)){n.deferUpdate((function(){r.deferUpdate((function(){o._setFlag(i.Collapsed,e,!0);for(var t=l.topRow+1;t<=l.bottomRow&&t>-1&&t<r.length;t++){r[t]._setFlag(i.ParentCollapsed,e,!0);var n=r[t];n instanceof GroupRow&&n.isCollapsed&&(t=n.getCellRange().bottomRow)}}))}));n.onGroupCollapsedChanged(s)}};GroupRow.prototype.getCellRange=function(){for(var e=this._list,i=this.index,o=e.length-1,n=i+1;n<=o;n++){var r=e[n];if(r instanceof GroupRow&&r.level<=this.level){o=n-1;break}}return new t.CellRange(i,0,o,this.grid.columns.length-1)};return GroupRow}(r);t.GroupRow=l;var s=function(i){__extends(RowColCollection,i);function RowColCollection(o,n){var r=i.call(this)||this;r._frozen=0;r._lastFrozen=-1;r._firstVisible=-1;r._vlen=0;r._szDef=28;r._szTot=0;r._szCustom=!1;r._dirty=!1;r._g=e.asType(o,t.FlexGrid);r._szDef=e.asNumber(n,!1,!0);return r}Object.defineProperty(RowColCollection.prototype,"grid",{get:function(){return this._g},enumerable:!0,configurable:!0});Object.defineProperty(RowColCollection.prototype,"defaultSize",{get:function(){return this._szDef},set:function(t){this._szCustom=!0;if(this._szDef!=t){this._szDef=e.asNumber(t,!1,!0);this._dirty=!0;this._g.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowColCollection.prototype,"frozen",{get:function(){return this._frozen},set:function(t){if(t!=this._frozen){this._frozen=e.asNumber(t,!1,!0);this._dirty=!0;this._g.invalidate()}},enumerable:!0,configurable:!0});RowColCollection.prototype.isFrozen=function(e){return e<this.frozen};Object.defineProperty(RowColCollection.prototype,"minSize",{get:function(){return this._szMin},set:function(t){if(t!=this._szMin){this._szMin=e.asNumber(t,!0,!0);this._dirty=!0;this._g.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(RowColCollection.prototype,"maxSize",{get:function(){return this._szMax},set:function(t){if(t!=this._szMax){this._szMax=e.asNumber(t,!0,!0);this._dirty=!0;this._g.invalidate()}},enumerable:!0,configurable:!0});RowColCollection.prototype.getTotalSize=function(){this._dirty&&this._update();return this._szTot};Object.defineProperty(RowColCollection.prototype,"visibleLength",{get:function(){this._dirty&&this._update();return this._vlen},enumerable:!0,configurable:!0});RowColCollection.prototype.getItemAt=function(e){this._dirty&&this._update();if(e<=0&&this.length>0&&this[0].renderSize)return 0;for(var t,i,o=this.length,n=0,r=o-1;n<=r;)if((i=this[t=n+r>>>1])._pos>=e&&t>0)r=t-1;else{if(!(i._pos+i.renderSize<=e&&t<o-1)){for(;t>0&&!this[t].renderSize;)t--;for(;t<o-1&&!this[t].renderSize;)t++;return t}n=t+1}return r};RowColCollection.prototype.getNextCell=function(e,i,o){void 0===o&&(o=0);var n,r=t.SelMove;switch(i){case r.Next:case r.NextCell:for(n=e+1;n<this.length;n++)if(this[n].renderSize>0)return n;break;case r.NextEditableCell:for(n=e+1;n<this.length;n++)if(this[n].renderSize>0&&!this[n].isReadOnly)return n;break;case r.Prev:case r.PrevCell:for(n=e-1;n>=0;n--)if(this[n].renderSize>0)return n;break;case r.PrevEditableCell:for(n=e-1;n>=0;n--)if(this[n].renderSize>0&&!this[n].isReadOnly)return n;break;case r.End:for(n=this.length-1;n>=0;n--)if(this[n].renderSize>0)return n;break;case r.Home:for(n=0;n<this.length;n++)if(this[n].renderSize>0)return n;break;case r.NextPage:return(n=this.getItemAt(this[e].pos+this[e].renderSize+o))<0?this.getNextCell(e,t.SelMove.End,o):n==e&&n<this.length-1&&this[n+1].renderSize?n+1:n;case r.PrevPage:return(n=this.getItemAt(this[e].pos-o))<0?this.getNextCell(e,t.SelMove.Home,o):n==e&&n>0&&this[n-1].renderSize?n-1:n}return e};RowColCollection.prototype.canMoveElement=function(e,i,o){void 0===o&&(o=!0);if(i==e)return!1;if(e<0||e>=this.length||i>=this.length)return!1;if(o){i<0&&(i=this.length-1);for(var n=Math.min(e,i),r=Math.max(e,i),l=n;l<=r;l++)if(!this[l].allowDragging)return!1}return!(this[i]instanceof t._NewRowTemplate)};RowColCollection.prototype.moveElement=function(e,t,i){void 0===i&&(i=!0);if(this.canMoveElement(e,t,i)){var o=this[e];this.removeAt(e);t<0&&(t=this.length);this.insert(t,o);if(i){var n=this.frozen;e<n&&t>=n?this.frozen--:e>=n&&t<n&&this.frozen++}return!0}return!1};RowColCollection.prototype.onCollectionChanged=function(t){void 0===t&&(t=e.collections.NotifyCollectionChangedEventArgs.reset);this._dirty=!0;this._g.invalidate();i.prototype.onCollectionChanged.call(this,t)};RowColCollection.prototype.push=function(e){e._setList(this);return i.prototype.push.call(this,e)};RowColCollection.prototype.splice=function(e,t){for(var n=this,r=[],l=2;l<arguments.length;l++)r[l-2]=arguments[l];for(var s=e;s<e+t&&s<this.length;s++){var a=this[s];a instanceof o&&a._setList(null)}r.forEach((function(e){return e._setList(n)}));return i.prototype.splice.apply(this,[e,t].concat(r))};RowColCollection.prototype.beginUpdate=function(){this._update();i.prototype.beginUpdate.call(this)};RowColCollection.prototype._setDefaultSize=function(e){if(!this._szCustom){this.defaultSize=e;this._szCustom=!1}};RowColCollection.prototype._update=function(){if(this._dirty&&!this.isUpdating){this._dirty=!1;this._lastFrozen=-1;this._firstVisible=-1;for(var e=0,t=0,i=void 0,o=void 0,n=0;n<this.length;n++){(o=this[n])._idx=n;o._idxVis=e;o._pos=t;o._setList(this);if((i=o.renderSize)>0){t+=i;e++;n<this._frozen&&(this._lastFrozen=n)}this._firstVisible<0&&o.visible&&(this._firstVisible=n)}this._vlen=e;this._szTot=t;return!0}return!1};return RowColCollection}(e.collections.ObservableArray);t.RowColCollection=s;var a=function(t){__extends(ColumnCollection,t);function ColumnCollection(){return null!==t&&t.apply(this,arguments)||this}ColumnCollection.prototype.getColumn=function(t){var i=e.isNumber(t)?t:this.indexOf(t);return i>-1?this[i]:null};ColumnCollection.prototype.indexOf=function(e){if(e instanceof n)return t.prototype.indexOf.call(this,e);for(var i=0;i<this.length;i++)if(this[i].name==e)return i;for(i=0;i<this.length;i++)if(this[i].binding==e)return i;return-1};Object.defineProperty(ColumnCollection.prototype,"describedById",{get:function(){return this._descById},set:function(t){if(t!=this._descById){this._descById=e.asString(t);this._g&&this._g.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(ColumnCollection.prototype,"firstVisibleIndex",{get:function(){this._dirty&&this._update();return this._firstVisible},enumerable:!0,configurable:!0});ColumnCollection.prototype._updateStarSizes=function(e){for(var t,i=!1,o=0,r=0;r<this.length;r++){if((s=this[r]).isVisible)if(s._szStar){o+=n._parseStarSize(s._szStar);t=s}else e-=s.renderWidth}if(t){var l=e;for(r=0;r<this.length;r++){var s;if((s=this[r]).isVisible&&s._szStar){var a=s._sz;s==t&&l>0?a=l:l-=a=Math.max(0,Math.round(n._parseStarSize(s._szStar)/o*e));if(a!=s._sz){s._sz=a;i=!0}}}if(i){this._dirty=!0;this._update()}return i}return!1};return ColumnCollection}(s);t.ColumnCollection=a;var d=function(t){__extends(RowCollection,t);function RowCollection(){var e=null!==t&&t.apply(this,arguments)||this;e._maxLevel=-1;return e}Object.defineProperty(RowCollection.prototype,"ariaLabel",{get:function(){return this._ariaLabel},set:function(t){if(t!=this.ariaLabel){this._ariaLabel=e.asString(t);this._g&&this._g.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(RowCollection.prototype,"maxGroupLevel",{get:function(){this._dirty&&this._update();return this._maxLevel},enumerable:!0,configurable:!0});RowCollection.prototype._update=function(){var e=this;if(t.prototype._update.call(this)){var i=this.grid?this.grid.collectionView:null,o=i?i.items:null,n=0;this._maxLevel=-1;this.forEach((function(t){t instanceof l&&t.level>e._maxLevel&&(e._maxLevel=t.level);t._idxData=-1;var i=t.dataItem;i&&o&&(t._idxData=i===o[n]?n:i===o[n+1]?++n:-1)}));return!0}return!1};return RowCollection}(s);t.RowCollection=d}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){var i=function(){function _ColumnGroupHandler(e){this._grid=e}_ColumnGroupHandler.prototype.createColumnGroups=function(i){var n=this,r=this._grid;this._groupDefs=e.asArray(i);r.autoGenerateColumns=!1;r.columns.clear();this._colGroups=[];i.forEach((function(e){n._colGroups.push(e instanceof o?e:new o(e,null))}));var l=0;this._colGroups.forEach((function(e){n._addColumnGroup(e);l=Math.max(l,e._getMaxLevel())}));this._colGroups.forEach((function(e){e._expandRange(l)}));var s=r.columnHeaders.rows;s.clear();for(var a=0;a<=l;a++){var d=new t.Row;s.splice(a,0,d);a<l&&(d.cssClassAll="wj-colgroup")}for(a=0;a<s.length;a++)for(var c=0;c<r.columns.length;c++){var u=this.getColumnGroup(a,c);if(u){var h=u.header||e.toHeaderCase(u.binding);r.columnHeaders.setCellData(a,c,h)}}};_ColumnGroupHandler.prototype._addColumnGroup=function(e){var t=this,i=this._grid;e._grid=i;e._rng.col=i.columns.length;0==e.columns.length?i.columns.push(e):e.columns.forEach((function(e){t._addColumnGroup(e)}));e._rng.col2=i.columns.length-1};_ColumnGroupHandler.prototype.hasColumnGroups=function(){return null!=this._colGroups&&this._colGroups.length>0};_ColumnGroupHandler.prototype.getGroupDefinitions=function(){return this._groupDefs};_ColumnGroupHandler.prototype.getColumnGroup=function(e,t){var i=this._grid;if(e<i.columnHeaders.rows.length&&t<i.columns.length)for(var o=this._colGroups;o;){for(var n=o,r=0;r<o.length;r++){var l=o[r],s=l._rng;if(s.containsColumn(t)){if(s.containsRow(e)||0==l.columns.length)return l;o=l.columns;break}}if(o==n)break}return null};return _ColumnGroupHandler}();t._ColumnGroupHandler=i;var o=function(i){__extends(ColumnGroup,i);function ColumnGroup(o,n){void 0===n&&(n=null);var r=i.call(this)||this;r._rng=new t.CellRange(0,-1);r._cols=[];r._lvl=0;r._collapsed=!1;r._pGrp=n;for(var l=n;l;l=l._pGrp)r._lvl++;n&&n.columns.indexOf(r)<0&&n.columns.push(r);r._rng.row=r._rng.row2=r._lvl;r.allowDragging=!1;e.copy(r,o);return r}Object.defineProperty(ColumnGroup.prototype,"columns",{get:function(){return this._cols},set:function(e){var t=this,i=this._cols=[];e.forEach((function(e){var o=e instanceof ColumnGroup?e:new ColumnGroup(e,t);i.indexOf(o)<0&&i.push(o)}))},enumerable:!0,configurable:!0});Object.defineProperty(ColumnGroup.prototype,"parentGroup",{get:function(){return this._pGrp},enumerable:!0,configurable:!0});Object.defineProperty(ColumnGroup.prototype,"level",{get:function(){for(var e=this,t=0;e.parentGroup;){e=e.parentGroup;t++}return t},enumerable:!0,configurable:!0});Object.defineProperty(ColumnGroup.prototype,"collapseTo",{get:function(){return this._collTo},set:function(t){this._collTo=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(ColumnGroup.prototype,"isCollapsed",{get:function(){return this._collapsed},set:function(i){var o=this;if(i!=this._collapsed){var n=this._grid;if(n){var r=new t.CellRangeEventArgs(n.rowHeaders,this._rng,this);if(n.onColumnGroupCollapsedChanging(r)){this._collapsed=e.asBoolean(i);n.onColumnGroupCollapsedChanged(r)}}else this._collapsed=e.asBoolean(i)}setTimeout((function(){o._updateCollapsedState()}))},enumerable:!0,configurable:!0});Object.defineProperty(ColumnGroup.prototype,"grid",{get:function(){return this._grid},enumerable:!0,configurable:!0});ColumnGroup.prototype._updateCollapsedState=function(){var e=this._grid?this._grid.columns:null,t=this._rng,i=this._collapsed;if(e){this._cols.forEach((function(e){if(e instanceof ColumnGroup){e._collapsed=i;e._updateCollapsedState()}}));var o=t.rightCol;if(this.collapseTo)switch(this.collapseTo){case"$first":o=t.leftCol;break;case"$last":o=t.rightCol;break;default:var n=e.getColumn(this.collapseTo);n&&t.containsColumn(n.index)&&(o=n.index)}for(var r=t.leftCol;r<=t.rightCol;r++)e[r].visible=!i||r==o}};ColumnGroup.prototype._getMaxLevel=function(){var e=this._lvl;this.columns.forEach((function(t){e=Math.max(e,t._getMaxLevel())}));return e};ColumnGroup.prototype._expandRange=function(e){var t=e-this._getMaxLevel();if(t>0){this._rng.row2+=t;this._cols.forEach((function(e){e._shiftRange(t)}))}for(var i=this._grid.columns,o=this._rng,n=o.col;n<=o.col2;n++){i[n]._rng.row2=e}};ColumnGroup.prototype._shiftRange=function(e){this._rng.row+=e;this._rng.row2+=e;this._cols.forEach((function(t){t._shiftRange(e)}))};return ColumnGroup}(t.Column);t.ColumnGroup=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i,o,n,r,l;e._addCultureInfo("FlexGrid",{groupHeaderFormat:"{name}: <b>{value}</b> ({count:n0} items)",ariaLabels:{toggleDropDown:"Toggle Dropdown",toggleGroup:"Toggle Group"}});!function(e){e[e.None=0]="None";e[e.SingleColumn=1]="SingleColumn";e[e.MultiColumn=2]="MultiColumn"}(o=t.AllowSorting||(t.AllowSorting={}));!function(e){e[e.None=0]="None";e[e.SingleColumn=1]="SingleColumn";e[e.ColumnRange=2]="ColumnRange";e[e.Both=3]="Both"}(n=t.AllowPinning||(t.AllowPinning={}));!function(e){e[e.None=0]="None";e[e.Column=1]="Column";e[e.Row=2]="Row";e[e.All=3]="All"}(r=t.HeadersVisibility||(t.HeadersVisibility={}));!function(e){e[e.Default=0]="Default";e[e.CSV=1]="CSV";e[e.QuoteAll=2]="QuoteAll";e[e.SkipMerged=4]="SkipMerged";e[e.Unformatted=8]="Unformatted";e[e.InvisibleRows=16]="InvisibleRows";e[e.InvisibleColumns=32]="InvisibleColumns";e[e.InvisibleCells=48]="InvisibleCells"}(l=t.ClipStringOptions||(t.ClipStringOptions={}));var s=function(s){__extends(FlexGrid,s);function FlexGrid(i,l){var a=s.call(this,i,null,!0)||this;a._activeCell=null;a._szClient=new e.Size(0,0);a._szClientSB=new e.Size(0,0);a._offsetY=0;a._cssPage=0;a._ptScrl=new e.Point(0,0);a._cellPadLeft=3;a._cellPadHorz=3;a._cellPadVert=0;a._clipToScreen=!1;a._autoGenCols=!0;a._autoClipboard=!0;a._xOnCopyPaste=!0;a._autoScroll=!0;a._autoSearch=!1;a._caseSensitive=!1;a._readOnly=!1;a._indent=14;a._autoSizeMode=t.AutoSizeMode.Both;a._autoHeights=!1;a._quickSize=null;a._hdrVis=r.All;a._alSorting=o.SingleColumn;a._alPinning=n.None;a._alAddNew=!1;a._alDelete=!1;a._alResizing=t.AllowResizing.Columns;a._alDragging=t.AllowDragging.Columns;a._alMerging=t.AllowMerging.None;a._ssHdr=r.None;a._shSort=!0;a._shGroups=!0;a._shMarquee=!1;a._shPlcHld=!1;a._altStep=1;a._shErr=!0;a._shDropDown=!0;a._valEdt=!0;a._gHdrFmt=null;a._childItemsPath=null;a._sortRowIndex=null;a._editColIndex=null;a._deferResizing=!1;a._pSel=!0;a._pOutline=!0;a._stickyHdr=!1;a._anchorCursor=!1;a._copyHeaders=r.None;a._bigChecks=!1;a._fzClone=null;a._vt=0;a._vtRows=0;a._vtCols=0;a._lazyRender=!0;a._refreshOnEdit=!0;a._reorderCells=!0;a._touchEdit=!1;a.itemsSourceChanging=new e.Event;a.itemsSourceChanged=new e.Event;a.scrollPositionChanged=new e.Event;a.selectionChanging=new e.Event;a.selectionChanged=new e.Event;a.loadingRows=new e.Event;a.loadedRows=new e.Event;a.updatingLayout=new e.Event;a.updatedLayout=new e.Event;a.resizingColumn=new e.Event;a.resizedColumn=new e.Event;a.autoSizingColumn=new e.Event;a.autoSizedColumn=new e.Event;a.starSizedColumns=new e.Event;a.draggingColumn=new e.Event;a.draggingColumnOver=new e.Event;a.draggedColumn=new e.Event;a.pinningColumn=new e.Event;a.pinnedColumn=new e.Event;a.resizingRow=new e.Event;a.resizedRow=new e.Event;a.autoSizingRow=new e.Event;a.autoSizedRow=new e.Event;a.draggingRow=new e.Event;a.draggingRowOver=new e.Event;a.draggedRow=new e.Event;a.groupCollapsedChanging=new e.Event;a.groupCollapsedChanged=new e.Event;a.columnGroupCollapsedChanging=new e.Event;a.columnGroupCollapsedChanged=new e.Event;a.sortingColumn=new e.Event;a.sortedColumn=new e.Event;a.beginningEdit=new e.Event;a.prepareCellForEdit=new e.Event;a.cellEditEnding=new e.Event;a.cellEditEnded=new e.Event;a.rowEditStarting=new e.Event;a.rowEditStarted=new e.Event;a.rowEditEnding=new e.Event;a.rowEditEnded=new e.Event;a.rowAdded=new e.Event;a.deletingRow=new e.Event;a.deletedRow=new e.Event;a.copying=new e.Event;a.copied=new e.Event;a.pasting=new e.Event;a.pasted=new e.Event;a.pastingCell=new e.Event;a.pastedCell=new e.Event;a.formatItem=new e.Event((function(){a._clearCells()}));a.updatingView=new e.Event;a.updatedView=new e.Event;a._mappedColumns=null;var d=a.hostElement;e.isIE()&&(d.style.borderRadius="0");var c=a.getTemplate();a.applyTemplate("wj-control wj-content wj-flexgrid",c,{_root:"root",_eSz:"sz",_eCt:"cells",_fCt:"fcells",_eTL:"tl",_eBL:"bl",_eCHdr:"ch",_eRHdr:"rh",_eCFtr:"cf",_eTLCt:"tlcells",_eBLCt:"blcells",_eCHdrCt:"chcells",_eCFtrCt:"cfcells",_eRHdrCt:"rhcells",_eMarquee:"marquee",_eFocus:"focus"});e.setCss(a._root.parentElement,{position:"relative",left:"0",top:"0",width:"100%",height:"100%",overflow:"hidden",minWidth:"inherit",minHeight:"inherit",maxWidth:"inherit",maxHeight:"inherit"});e.setCss(a._root,{position:"absolute",left:"0",top:"0",width:"100%",height:"100%",minWidth:"inherit",minHeight:"inherit",maxWidth:"inherit",maxHeight:"inherit",overflow:"auto",webkitOverflowScrolling:"touch"});e.setCss(a._eCt,{position:"absolute"});e.setCss(a._eMarquee,{display:"none"});e.setCss(a._eMarquee.firstChild,{width:"100%",height:"100%"});e.setCss(a._fCt,{position:"absolute",left:"0",top:"0",overflow:"hidden",pointerEvents:"none"});e.setCss(a._eFocus,{position:"fixed",left:"-32000px"});e.setCss(a._eSz,{position:"relative",visibility:"hidden"});[a._eRHdr,a._eCFtr,a._eCHdr,a._eBL,a._eTL].forEach((function(t){e.setAttribute(t,"aria-hidden",!0);e.setCss(t,{position:"absolute",overflow:"hidden",outline:"none"});e.setCss(t.firstElementChild,{position:"relative"})}));[a._eFocus,a._eMarquee,a._fCt,a._eSz].forEach((function(t){e.setAttribute(t,"aria-hidden",!0)}));if(e.isIE9()||e.isIE10()){var u=a._eMarquee;["click","dblclick","mousedown","mouseup"].forEach((function(e){a.addEventListener(u,e,(function(t){var i=u.style.display;u.style.display="none";var o=document.elementFromPoint(t.clientX,t.clientY);u.style.display=i;var n=document.createEvent("Event");n.initEvent(e,!0,!0);for(var r in t)try{n[r]=t[r]}catch(e){}o.dispatchEvent(n)}))}))}d.tabIndex=-1;a.deferUpdate((function(){var i=a._getDefaultRowHeight();a._rows=new t.RowCollection(a,i);a._cols=new t.ColumnCollection(a,4*i);a._hdrRows=new t.RowCollection(a,i);a._hdrCols=new t.ColumnCollection(a,Math.round(1.25*i));a._ftrRows=new t.RowCollection(a,i);var o=t.CellType;a._gpTL=new t.GridPanel(a,o.TopLeft,a._hdrRows,a._hdrCols,a._eTLCt);a._gpCHdr=new t.GridPanel(a,o.ColumnHeader,a._hdrRows,a._cols,a._eCHdrCt);a._gpRHdr=new t.GridPanel(a,o.RowHeader,a._rows,a._hdrCols,a._eRHdrCt);a._gpCells=new t.GridPanel(a,o.Cell,a._rows,a._cols,a._eCt);a._gpBL=new t.GridPanel(a,o.BottomLeft,a._ftrRows,a._hdrCols,a._eBLCt);a._gpCFtr=new t.GridPanel(a,o.ColumnFooter,a._ftrRows,a._cols,a._eCFtrCt);a._hdrRows.push(new t.Row);a._hdrCols.push(new t.Column({align:"center"}));a._cf=new t.CellFactory;a._keyHdl=new t._KeyboardHandler(a);a._mouseHdl=new t._MouseHandler(a);a._edtHdl=new t._EditHandler(a);a._selHdl=new t._SelectionHandler(a);a._addHdl=new t._AddNewHandler(a);a._grpHdl=new t._ColumnGroupHandler(a);a._mrgMgr=new t.MergeManager;a._bndSortConverter=a._sortConverter.bind(a);a._errorTip=new e.Tooltip({isContentHtml:!1,showDelay:0,cssClass:"wj-error-tip"});e.setAttribute(a.cells.hostElement,"role","grid");a.selectionMode=t.SelectionMode.CellRange;a._root.tabIndex=-1;a.initialize(l)}));a.addEventListener(a._root,"scroll",(function(e){if(a._updateScrollPosition()||a._forceScrollUpdate){var t=a.activeEditor,i=a.activeCell,o=i?i.className:null;a._forceScrollUpdate||a.finishEditing();a._forceScrollUpdate=!1;a._updateContent(!0);var n=a.activeEditor,r=a.activeCell;if(n&&r&&t&&o){n.value=t.value;r.className=o;a._setFocusNoScroll(n)}else n&&!r&&a.finishEditing(!0);a.frozenColumns&&setTimeout((function(){var e=a.columnHeaders.hostElement.style,t=parseInt(e.left),i=a._ptScrl.x;Math.abs(t-i)>1&&a.invalidate()}))}}));a.addEventListener(d,"focus",(function(e){if(d.tabIndex>-1){var t=e.target;t instanceof HTMLElement&&t.tabIndex<0&&a._setFocus(!0)}}),!0);return a}FlexGrid.prototype._handleResize=function(){var e=this;this._rcBounds=null;this.activeEditor&&this.isTouching||this._touchEdit?setTimeout((function(){if(!e.activeEditor){e._touchEdit=!0;e.startEditing(!0)}}),50):s.prototype._handleResize.call(this);this._touchEdit=!1};Object.defineProperty(FlexGrid.prototype,"headersVisibility",{get:function(){return this._hdrVis},set:function(t){if((t=e.asEnum(t,r))!=this._hdrVis){this._hdrVis=t;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"stickyHeaders",{get:function(){return this._stickyHdr},set:function(t){if(t!=this._stickyHdr){this._stickyHdr=e.asBoolean(t);this._updateStickyHeaders();this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"preserveSelectedState",{get:function(){return this._pSel},set:function(t){this._pSel=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"preserveOutlineState",{get:function(){return this._pOutline},set:function(t){this._pOutline=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"anchorCursor",{get:function(){return this._anchorCursor},set:function(t){this._anchorCursor=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"copyHeaders",{get:function(){return this._copyHeaders},set:function(t){this._copyHeaders=e.asEnum(t,r)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"lazyRender",{get:function(){return this._lazyRender},set:function(t){this._lazyRender=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"refreshOnEdit",{get:function(){return this._refreshOnEdit},set:function(t){this._refreshOnEdit=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"virtualizationThreshold",{get:function(){return this._vt},set:function(t){this._vt=t;if(e.isNumber(t))this._vtRows=this._vtCols=e.asNumber(t);else if(t)if(e.isArray(t)&&2==t.length){this._vtRows=e.asNumber(t[0]);this._vtCols=e.asNumber(t[1])}else e.assert(!1,"virtualizationThreshold should be a number or an array with two numbers.");else this._vtRows=this._vtCols=0},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoGenerateColumns",{get:function(){return this._autoGenCols},set:function(t){this._autoGenCols=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoClipboard",{get:function(){return this._autoClipboard},set:function(t){this._autoClipboard=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"expandSelectionOnCopyPaste",{get:function(){return this._xOnCopyPaste},set:function(t){this._xOnCopyPaste=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoScroll",{get:function(){return this._autoScroll},set:function(t){this._autoScroll=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoSearch",{get:function(){return this._autoSearch},set:function(t){this._autoSearch=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"caseSensitiveSearch",{get:function(){return this._caseSensitive},set:function(t){this._caseSensitive=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"columnLayout",{get:function(){var i=FlexGrid._getSerializableProperties(t.Column),o=new t.Column,n=[];this.columns.forEach((function(t){var r={};i.forEach((function(i){var n=t[i];n!=o[i]&&e.isPrimitive(n)&&"size"!=i&&(r[i]=n)}));n.push(r)}));return JSON.stringify({columns:n})},set:function(t){var i=this,o=JSON.parse(e.asString(t));e.assert(o,"Invalid columnLayout data.");this.columns.deferUpdate((function(){i.columns.clear();i.initialize(o)}))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"columnGroups",{get:function(){return this._grpHdl.getGroupDefinitions()},set:function(t){this.columns.clear();this._grpHdl.createColumnGroups(e.asArray(t))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(t){if(t!=this._readOnly){this._readOnly=e.asBoolean(t);this.finishEditing();this.invalidate(!0);this._addHdl.updateNewRowTemplate();e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly);this._setAria("readonly",this.isReadOnly?"true":null)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"bigCheckboxes",{get:function(){return this._bigChecks},set:function(t){this._bigChecks=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"isDisabled",{get:function(){return this._e&&null!=this._e.getAttribute("disabled")},set:function(t){if((t=e.asBoolean(t,!0))!=this.isDisabled){var i=this._e;if(i){e.enable(i,!t);this.invalidate()}}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"imeEnabled",{get:function(){return null!=this._imeHdl},set:function(i){if(e.asBoolean(i)!=this.imeEnabled&&this.finishEditing()){var o=this.containsFocus();if(this._imeHdl){this._imeHdl.dispose();this._imeHdl=null}i&&(this._imeHdl=new t._ImeHandler(this));o&&this.focus()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowResizing",{get:function(){return this._alResizing},set:function(i){this._alResizing=e.asEnum(i,t.AllowResizing)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"deferResizing",{get:function(){return this._deferResizing},set:function(t){this._deferResizing=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoSizeMode",{get:function(){return this._autoSizeMode},set:function(i){this._autoSizeMode=e.asEnum(i,t.AutoSizeMode)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"autoRowHeights",{get:function(){return this._autoHeights},set:function(t){this._autoHeights=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"quickAutoSize",{get:function(){return this._quickSize},set:function(t){this._quickSize=e.asBoolean(t,!0)},enumerable:!0,configurable:!0});FlexGrid.prototype._getQuickAutoSize=function(){return e.isBoolean(this._quickSize)?this._quickSize:!this.formatItem.hasHandlers&&null==this.itemFormatter};Object.defineProperty(FlexGrid.prototype,"allowSorting",{get:function(){return this._alSorting},set:function(t){e.isBoolean(t)&&(t=t?o.SingleColumn:o.None);this._alSorting=e.asEnum(t,o)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowPinning",{get:function(){return this._alPinning},set:function(t){if(t!=this._alPinning){e.isBoolean(t)&&(t=t?n.SingleColumn:n.None);this._alPinning=e.asEnum(t,n);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowAddNew",{get:function(){return this._alAddNew},set:function(t){if(t!=this._alAddNew){this._alAddNew=e.asBoolean(t);this._addHdl.updateNewRowTemplate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"newRowAtTop",{get:function(){return this._addHdl.newRowAtTop},set:function(t){this._addHdl.newRowAtTop=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowDelete",{get:function(){return this._alDelete},set:function(t){t!=this._alDelete&&(this._alDelete=e.asBoolean(t))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowMerging",{get:function(){return this._alMerging},set:function(i){if((i=e.asEnum(i,t.AllowMerging))!=this._alMerging){this._alMerging=i;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showSelectedHeaders",{get:function(){return this._ssHdr},set:function(t){if((t=e.asEnum(t,r))!=this._ssHdr){this._ssHdr=t;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showMarquee",{get:function(){return this._shMarquee},set:function(t){if(t!=this._shMarquee){this._shMarquee=e.asBoolean(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showPlaceholders",{get:function(){return this._shPlcHld},set:function(t){this._shPlcHld=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showSort",{get:function(){return this._shSort},set:function(t){if(t!=this._shSort){this._shSort=e.asBoolean(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showGroups",{get:function(){return this._shGroups},set:function(t){if(t!=this._shGroups){this._shGroups=e.asBoolean(t);this._bindGrid(!1)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"alternatingRowStep",{get:function(){return this._altStep},set:function(t){if(t!=this._altStep){this._altStep=e.asInt(t,!1,!0);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showAlternatingRows",{get:function(){return this._altStep>0},set:function(t){e._deprecated("showAlternatingRows","alternatingRowStep");this.alternatingRowStep=t?1:0},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showErrors",{get:function(){return this._shErr},set:function(t){if(t!=this._shErr){this._clearCells();this._shErr=e.asBoolean(t)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"errorTip",{get:function(){return this._errorTip},set:function(t){if(t!=this._errorTip){this._clearCells();this._errorTip=e.asType(t,e.Tooltip,!0)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"itemValidator",{get:function(){return this._itemValidator},set:function(t){if(t!=this.itemValidator){this._itemValidator=e.asFunction(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"validateEdits",{get:function(){return this._valEdt},set:function(t){this._valEdt=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"groupHeaderFormat",{get:function(){return this._gHdrFmt},set:function(t){if(t!=this._gHdrFmt){this._gHdrFmt=e.asString(t);this._bindGrid(!1)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"allowDragging",{get:function(){return this._alDragging},set:function(i){if((i=e.asEnum(i,t.AllowDragging))!=this._alDragging){this._alDragging=i;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"itemsSource",{get:function(){return this._items},set:function(t){var i=this;if(t!=this._items){var o=new e.CancelEventArgs;if(this.onItemsSourceChanging(o)){if(this._cv){(n=this._cv).currentChanged.removeHandler(null,this);n.collectionChanged.removeHandler(null,this);n instanceof e.collections.CollectionView&&n.sortConverter==this._bndSortConverter&&(n.sortConverter=null);this._cv=null}this._items=t;this._cv=this._getCollectionView(t);this._lastCount=0;if(this._cv){var n;(n=this._cv).currentChanged.addHandler((function(e,t){return i._cvCurrentChanged(e,t)}),this);n.collectionChanged.addHandler((function(e,t){return i._cvCollectionChanged(e,t)}),this);n instanceof e.collections.CollectionView&&!n.sortConverter&&(n.sortConverter=this._bndSortConverter)}this._bindGrid(!0);this._selHdl._setSelectionMode(this.selectionMode);this.onItemsSourceChanged(o)}}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"editableCollectionView",{get:function(){return e.tryCast(this._cv,"IEditableCollectionView")},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"childItemsPath",{get:function(){return this._childItemsPath},set:function(t){if(t!=this._childItemsPath){e.assert(null==t||e.isArray(t)||e.isString(t),"childItemsPath should be an array or a string.");this._childItemsPath=t;this._bindGrid(!0)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"rowHeaderPath",{get:function(){return this._rowHdrPath?this._rowHdrPath.path:null},set:function(t){if(t!=this.rowHeaderPath){t=e.asString(t);this._rowHdrPath=t?new e.Binding(t):null;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"cells",{get:function(){return this._gpCells},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"columnHeaders",{get:function(){return this._gpCHdr},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"columnFooters",{get:function(){return this._gpCFtr},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"rowHeaders",{get:function(){return this._gpRHdr},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"topLeftCells",{get:function(){return this._gpTL},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"bottomLeftCells",{get:function(){return this._gpBL},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"rows",{get:function(){return this._rows},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"columns",{get:function(){return this._cols},enumerable:!0,configurable:!0});FlexGrid.prototype.getColumn=function(e){return this.columns.getColumn(e)};Object.defineProperty(FlexGrid.prototype,"frozenRows",{get:function(){return this.rows.frozen},set:function(e){this.rows.frozen=e},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"frozenColumns",{get:function(){return this.columns.frozen},set:function(e){this.columns.frozen=e},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"cloneFrozenCells",{get:function(){return this._fzClone},set:function(t){if(t!=this._fzClone){e.setText(this._fCt,null);this._fzClone=e.asBoolean(t,!0);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"sortRowIndex",{get:function(){return this._sortRowIndex},set:function(t){if(t!=this._sortRowIndex){this._sortRowIndex=e.asNumber(t,!0);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"editColumnIndex",{get:function(){return this._editColIndex},set:function(t){if(t!=this._editColIndex){this._editColIndex=e.asNumber(t,!0);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"scrollPosition",{get:function(){return this._ptScrl.clone()},set:function(e){var t=this._root,i=-e.x;if(this.rightToLeft)switch(FlexGrid._getRtlMode()){case"rev":i=t.scrollWidth-t.clientWidth+e.x;break;case"neg":i=e.x;break;default:i=-e.x}t.scrollLeft=i;t.scrollTop=-e.y;this._updateScrollPosition()&&(this._forceScrollUpdate=!0)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"clientSize",{get:function(){return this._szClient},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"controlRect",{get:function(){this._rcBounds||(this._rcBounds=e.getElementRect(this._root));return this._rcBounds},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"scrollSize",{get:function(){return new e.Size(this._gpCells.width,this._heightBrowser)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"viewRange",{get:function(){return this._gpCells.viewRange},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"cellFactory",{get:function(){return this._cf},set:function(i){if(i!=this._cf){this._clearCells();this._cf=e.asType(i,t.CellFactory,!1)}},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(t){if(t!=this._itemFormatter){this._clearCells();this._itemFormatter=e.asFunction(t)}},enumerable:!0,configurable:!0});FlexGrid.prototype.canEditCell=function(e,t){return this._edtHdl._allowEdit(e,t)};FlexGrid.prototype.getCellData=function(e,t,i){return this.cells.getCellData(e,t,i)};FlexGrid.prototype.getCellBoundingRect=function(e,t,i){return this.cells.getCellBoundingRect(e,t,i)};FlexGrid.prototype.setCellData=function(e,t,i,o,n){void 0===o&&(o=!0);void 0===n&&(n=!0);return this.cells.setCellData(e,t,i,o,n)};FlexGrid.prototype.hitTest=function(i,o){e.isNumber(i)&&e.isNumber(o)&&(i=new e.Point(i,o));e.isBoolean(o)&&o&&(this._rcBounds=null);return new t.HitTestInfo(this,i)};FlexGrid.prototype.getClipString=function(t,i,o,n){var r;r=null==i||e.isBoolean(i)?i?l.CSV:l.Default:i;e.assert(e.isNumber(r),"Unexpected value for ClipStringOptions parameter.");return this._edtHdl.getClipString(t,r,o,n)};FlexGrid.prototype.setClipString=function(e,t){this._edtHdl.setClipString(e,t)};FlexGrid.prototype.focus=function(e){this._setFocus(e)};FlexGrid.prototype.dispose=function(){this.finishEditing(!0);this.itemsSource=null;s.prototype.dispose.call(this)};FlexGrid.prototype.refresh=function(t){void 0===t&&(t=!0);s.prototype.refresh.call(this,t);this.finishEditing();if(t){this._updateColumnTypes();this.scrollPosition=this._ptScrl;var i=this._getDefaultRowHeight();this._rows._setDefaultSize(i);this._cols._setDefaultSize(4*i);this._hdrRows._setDefaultSize(i);this._hdrCols._setDefaultSize(Math.round(1.25*i));this._ftrRows._setDefaultSize(i);clearTimeout(this._toInv);this._toInv=null}this.refreshCells(t);var o=this._e;o&&(this._szCtl=new e.Size(o.offsetWidth,o.offsetHeight))};FlexGrid.prototype.refreshCells=function(e,t,i){this.isUpdating||(e?this._updateLayout():this._updateContent(t,i))};FlexGrid.prototype.refreshRange=function(e){for(var i=e.topRow;i<=e.bottomRow;i++)for(var o=e.leftCol;o<=e.rightCol;o++){var n=this.cells.getCellElement(i,o);if(n){var r=n[t.GridPanel._INDEX_KEY];this.cellFactory.updateCell(this.cells,i,o,n,r.rng)}}};FlexGrid.prototype.autoSizeColumn=function(e,t,i){void 0===t&&(t=!1);void 0===i&&(i=4);this.autoSizeColumns(e,e,t,i)};FlexGrid.prototype.autoSizeColumns=function(i,o,n,r){var l=this;void 0===n&&(n=!1);void 0===r&&(r=4);var s=0,a=n?this.topLeftCells:this.columnHeaders,d=n?this.bottomLeftCells:this.columnFooters,c=n?this.rowHeaders:this.cells,u=this.viewRange;i=null==i?0:e.asInt(i);o=null==o?c.columns.length-1:e.asInt(o);u.row=Math.max(0,u.row-1e3);u.row2=Math.min(u.row2+1e3,this.rows.length-1);this.finishEditing()&&this.columns.deferUpdate((function(){e.setCss(l._eCt,{width:l._gpCells.width});for(var n=e.createElement("<div "+FlexGrid._WJS_MEASURE+'="true"/>',c.hostElement,{visibility:"hidden"}),h=l._getCanvasContext(),f=i;f<=o&&f>-1&&f<c.columns.length;f++){var g=c.columns[f];if(g.isVisible){s=0;if(l.autoSizeMode&t.AutoSizeMode.Headers){for(var p=0;p<a.rows.length;p++)a.rows[p].isVisible&&(s=Math.max(l._getDesiredWidth(a,p,f,n),s));for(p=0;p<d.rows.length;p++)d.rows[p].isVisible&&(s=Math.max(l._getDesiredWidth(d,p,f,n),s))}if(l.autoSizeMode&t.AutoSizeMode.Cells&&u.row>-1&&u.row2>-1)if(g._getQuickAutoSize()){p=l._getWidestRow(c,u,f,h);s=Math.max(l._getDesiredWidth(c,p,f,n),s)}else for(p=u.row;p<=u.row2&&p<c.rows.length;p++)c.rows[p].isVisible&&(s=Math.max(l._getDesiredWidth(c,p,f,n),s));s>0&&(g.width=s+r+2)}}l.cellFactory.disposeCell(n);e.removeChild(n)}))};FlexGrid.prototype.autoSizeRow=function(e,t,i){void 0===t&&(t=!1);void 0===i&&(i=0);this.autoSizeRows(e,e,t,i)};FlexGrid.prototype.autoSizeRows=function(i,o,n,r){var l=this;void 0===n&&(n=!1);void 0===r&&(r=0);var s=0,a=1==n?this.topLeftCells:null==n?this.bottomLeftCells:this.rowHeaders,d=1==n?this.columnHeaders:null==n?this.columnFooters:this.cells;r=e.asNumber(r);i=null==i?0:e.asInt(i);if((o=null==o?d.rows.length-1:e.asInt(o))>=i&&this.finishEditing()){e.setCss(this._eCt,{width:this._gpCells.width});var c=e.createElement("<div "+FlexGrid._WJS_MEASURE+'="true"/>',d.hostElement,{visibility:"hidden"});this.rows.deferUpdate((function(){for(var e={},n=l._autoSizeMode,u=t.AutoSizeMode,h=i;h<=o&&h>-1&&h<d.rows.length;h++){if(d.rows[h].isVisible){s=0;n&u.Headers&&(s=l._getDesiredRowHeight(a,h,c,e));n&u.Cells&&(s=Math.max(l._getDesiredRowHeight(d,h,c,e),s));s>0&&(d.rows[h].height=s+r)}}}));this.cellFactory.disposeCell(c);e.removeChild(c)}};Object.defineProperty(FlexGrid.prototype,"treeIndent",{get:function(){return this._indent},set:function(t){if(t!=this._indent){this._indent=e.asNumber(t,!1,!0);this.columns.onCollectionChanged()}},enumerable:!0,configurable:!0});FlexGrid.prototype.collapseGroupsToLevel=function(e){var i=this;this.finishEditing()&&this.deferUpdate((function(){var o=i.rows;o.deferUpdate((function(){for(var i=0;i<o.length;i++){var n=o[i];n instanceof t.GroupRow&&(n.isCollapsed=n.level>=e)}}))}))};Object.defineProperty(FlexGrid.prototype,"selectionMode",{get:function(){return this._selHdl.selectionMode},set:function(i){(i=e.asEnum(i,t.SelectionMode))!=this.selectionMode&&(this._selHdl.selectionMode=i)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"selection",{get:function(){return this._selHdl.selection.clone()},set:function(e){this._selHdl.selection=e},enumerable:!0,configurable:!0});FlexGrid.prototype.select=function(e,t){void 0===t&&(t=!0);return this._selHdl.select(e,t)};FlexGrid.prototype.selectAll=function(){var e=this.rows.length,i=this.columns.length;return!(!e||!i)&&this.select(new t.CellRange(0,0,e-1,i-1),!1)};FlexGrid.prototype.getSelectedState=function(e,t){return this.cells.getSelectedState(e,t)};Object.defineProperty(FlexGrid.prototype,"selectedRows",{get:function(){var e=this,i=this.selectionMode,o=this.rows.filter((function(e){return e.isSelected}));if(0==o.length&&i!=t.SelectionMode.None){var n=[];this.selectedRanges.forEach((function(t){for(var i=t.topRow;i<=t.bottomRow&&i>-1&&i<e.rows.length;i++)n.indexOf(i)<0&&n.push(i)}));n.sort();o=n.map((function(t){return e.rows[t]}))}return o},set:function(i){var o=this;e.assert(this.selectionMode==t.SelectionMode.ListBox,"This property can be set only in ListBox mode.");i=e.asArray(i);this.deferUpdate((function(){for(var e=0,t=!0;e<o.rows.length;e++){var n=o.rows[e],r=i&&i.indexOf(n)>-1;if(r&&t){t=!1;o.select(e,o.selection.col)}n.isSelected=r}}))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"selectedItems",{get:function(){var e=[];this.selectedRows.forEach((function(t){var i=t?t.dataItem:null;i&&e.indexOf(i)<0&&e.push(i)}));return e},set:function(i){var o=this;e.assert(this.selectionMode==t.SelectionMode.ListBox,"This property can be set only in ListBox mode.");i=e.asArray(i);this.deferUpdate((function(){for(var e=0,t=!0;e<o.rows.length;e++){var n=o.rows[e],r=i&&i.indexOf(n.dataItem)>-1;if(r&&t){t=!1;o.select(e,o.selection.col)}n.isSelected=r}}))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"selectedRanges",{get:function(){var e=[this.selection];this._selHdl.extendedSelection.forEach((function(t){e.push(t)}));return e},set:function(i){if((i=e.asArray(i))&&i.length>0){this.select(i[0]);if(this.selectionMode==t.SelectionMode.MultiRange){var o=this._selHdl.extendedSelection;o.deferUpdate((function(){o.clear();for(var e=1;e<i.length;e++)o.push(i[e])}))}}},enumerable:!0,configurable:!0});FlexGrid.prototype.scrollIntoView=function(t,i,o){(null==this._maxOffsetY||this._rows._dirty||this._cols._dirty)&&this._updateLayout();var n=this.scrollPosition,r=this._szClient,l=r.width,s=r.height-this._gpCFtr.rows.getTotalSize(),a=this.cells._getFrozenPos();if((t=e.asInt(t))>-1&&t<this._rows.length&&t>=this._rows.frozen){var d=this._rows[t],c=this._getCssPage(d.pos);if(c!=this._cssPage){for(var u=this._maxOffsetY,h=Math.round(u*c);h>d.pos;c-=.1)h=Math.round(u*c);this._offsetY=h}var f=d.pos-this._offsetY,g=f+d.renderSize;g>s-n.y&&(n.y=Math.max(-f,s-g));f-a.y<-n.y&&(n.y=-(f-a.y));c!=this._cssPage&&(this._cssPage=this._getCssPage(-n.y))}e.isString(i)&&(i=this.columns.indexOf(i));if((i=e.asInt(i))>-1&&i<this._cols.length&&i>=this._cols.frozen){var p=this._cols[i],_=p.pos+p.renderSize;_>-n.x+l&&(n.x=Math.max(-p.pos,l-_));p.pos-a.x<-n.x&&(n.x=-(p.pos-a.x))}if(!n.equals(this._ptScrl)){this.scrollPosition=n;if(o){this._updateScrollPosition();this._forceScrollUpdate=!1;this.refresh()}return!0}if(this._activeCell&&t>-1&&i>-1){var m=this._root,w=m.scrollWidth==m.clientWidth,C=m.scrollHeight==m.clientHeight;if(w||C){var v=this._activeCell.getBoundingClientRect(),y=innerWidth,b=innerHeight,R=v.right<0||v.left>y,E=v.bottom<0||v.top>b;n.x=pageXOffset+(v.left<0?v.left:v.right>y?v.right-y:0);n.y=pageYOffset+(v.top<0?v.top:v.bottom>b?v.bottom-b:0);R&&w&&E&&C?scrollTo(n.x,n.y):R&&w?scrollTo(n.x,document.documentElement.scrollLeft):E&&C&&scrollTo(document.documentElement.scrollTop,n.y)}}return!1};FlexGrid.prototype.isRangeValid=function(e){return e&&e.isValid&&e.bottomRow<this.rows.length&&e.rightCol<this.columns.length};FlexGrid.prototype.startEditing=function(e,t,i,o,n){void 0===e&&(e=!0);return this._edtHdl.startEditing(e,t,i,o,n)};FlexGrid.prototype.finishEditing=function(e){return this._edtHdl.finishEditing(e)};Object.defineProperty(FlexGrid.prototype,"activeCell",{get:function(){return this._activeCell},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"activeEditor",{get:function(){var e=this._edtHdl;return e?e.activeEditor:null},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"editRange",{get:function(){var e=this._edtHdl.editRange;return e?e.clone():null},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"mergeManager",{get:function(){return this._mrgMgr},set:function(i){if(i!=this._mrgMgr){this._mrgMgr=e.asType(i,t.MergeManager,!0);this.invalidate()}},enumerable:!0,configurable:!0});FlexGrid.prototype.getMergedRange=function(e,t,i,o){void 0===o&&(o=!0);return this._mrgMgr?this._mrgMgr.getMergedRange(e,t,i,o):null};Object.defineProperty(FlexGrid.prototype,"keyActionTab",{get:function(){return this._keyHdl._kaTab},set:function(i){this._keyHdl._kaTab=e.asEnum(i,t.KeyAction)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"keyActionEnter",{get:function(){return this._keyHdl._kaEnter},set:function(i){this._keyHdl._kaEnter=e.asEnum(i,t.KeyAction)},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"preserveWhiteSpace",{get:function(){return e.hasClass(this.hostElement,FlexGrid._WJS_WSPRE)},set:function(t){e.toggleClass(this.hostElement,FlexGrid._WJS_WSPRE,e.asBoolean(t))},enumerable:!0,configurable:!0});Object.defineProperty(FlexGrid.prototype,"showDropDown",{get:function(){return this._shDropDown},set:function(t){if(t!=this._shDropDown){this._shDropDown=e.asBoolean(t,!0);this.invalidate()}},enumerable:!0,configurable:!0});FlexGrid.prototype.toggleDropDownList=function(){if(!this._tglDropDown){this._tglDropDown=!0;this._edtHdl._toggleListBox(null);this._tglDropDown=!1}return null!=this._edtHdl._lbx};Object.defineProperty(FlexGrid,"defaultTypeWidth",{get:function(){return FlexGrid._defTypeWidth},enumerable:!0,configurable:!0});FlexGrid.prototype.onItemsSourceChanging=function(e){this.itemsSourceChanging.raise(this,e);return!e.cancel};FlexGrid.prototype.onItemsSourceChanged=function(e){this.itemsSourceChanged.raise(this,e)};FlexGrid.prototype.onScrollPositionChanged=function(e){this.scrollPositionChanged.raise(this,e)};FlexGrid.prototype.onSelectionChanging=function(e){this.selectionChanging.raise(this,e);return!e.cancel};FlexGrid.prototype.onSelectionChanged=function(e){this.selectionChanged.raise(this,e)};FlexGrid.prototype.onLoadingRows=function(e){this.loadingRows.raise(this,e);return!e.cancel};FlexGrid.prototype.onLoadedRows=function(e){this.loadedRows.raise(this,e);this._autoRowHeights()};FlexGrid.prototype.onUpdatingLayout=function(e){this.updatingLayout.raise(this,e);return!e.cancel};FlexGrid.prototype.onUpdatedLayout=function(e){this.updatedLayout.raise(this,e)};FlexGrid.prototype.onResizingColumn=function(e){this.resizingColumn.raise(this,e);return!e.cancel};FlexGrid.prototype.onResizedColumn=function(e){this.resizedColumn.raise(this,e);this._autoRowHeights()};FlexGrid.prototype.onAutoSizingColumn=function(e){this.autoSizingColumn.raise(this,e);return!e.cancel};FlexGrid.prototype.onAutoSizedColumn=function(e){this.autoSizedColumn.raise(this,e)};FlexGrid.prototype.onStarSizedColumns=function(e){this.starSizedColumns.raise(this,e);this._autoRowHeights()};FlexGrid.prototype.onDraggingColumn=function(e){this.draggingColumn.raise(this,e);return!e.cancel};FlexGrid.prototype.onDraggingColumnOver=function(e){this.draggingColumnOver.raise(this,e);return!e.cancel};FlexGrid.prototype.onDraggedColumn=function(e){this.draggedColumn.raise(this,e)};FlexGrid.prototype.onPinningColumn=function(e){this.pinningColumn.raise(this,e);return!e.cancel};FlexGrid.prototype.onPinnedColumn=function(e){this.pinnedColumn.raise(this,e)};FlexGrid.prototype.onResizingRow=function(e){this.resizingRow.raise(this,e);return!e.cancel};FlexGrid.prototype.onResizedRow=function(e){this.resizedRow.raise(this,e)};FlexGrid.prototype.onAutoSizingRow=function(e){this.autoSizingRow.raise(this,e);return!e.cancel};FlexGrid.prototype.onAutoSizedRow=function(e){this.autoSizedRow.raise(this,e)};FlexGrid.prototype.onDraggingRow=function(e){this.draggingRow.raise(this,e);return!e.cancel};FlexGrid.prototype.onDraggingRowOver=function(e){this.draggingRowOver.raise(this,e);return!e.cancel};FlexGrid.prototype.onDraggedRow=function(e){this.draggedRow.raise(this,e)};FlexGrid.prototype.onGroupCollapsedChanging=function(e){this.groupCollapsedChanging.raise(this,e);return!e.cancel};FlexGrid.prototype.onGroupCollapsedChanged=function(e){this.groupCollapsedChanged.raise(this,e)};FlexGrid.prototype.onColumnGroupCollapsedChanging=function(e){this.columnGroupCollapsedChanging.raise(this,e);return!e.cancel};FlexGrid.prototype.onColumnGroupCollapsedChanged=function(e){this.columnGroupCollapsedChanged.raise(this,e)};FlexGrid.prototype.onSortingColumn=function(e){this.sortingColumn.raise(this,e);return!e.cancel};FlexGrid.prototype.onSortedColumn=function(e){this.sortedColumn.raise(this,e)};FlexGrid.prototype.onBeginningEdit=function(e){this.beginningEdit.raise(this,e);return!e.cancel};FlexGrid.prototype.onPrepareCellForEdit=function(e){this.prepareCellForEdit.raise(this,e)};FlexGrid.prototype.onCellEditEnding=function(e){this.cellEditEnding.raise(this,e);return!e.cancel&&!e.stayInEditMode};FlexGrid.prototype.onCellEditEnded=function(e){this.cellEditEnded.raise(this,e);this._autoRowHeights()};FlexGrid.prototype.onRowEditStarting=function(e){this.rowEditStarting.raise(this,e);return!e.cancel};FlexGrid.prototype.onRowEditStarted=function(e){this.rowEditStarted.raise(this,e)};FlexGrid.prototype.onRowEditEnding=function(e){this.rowEditEnding.raise(this,e)};FlexGrid.prototype.onRowEditEnded=function(e){this.rowEditEnded.raise(this,e);this._autoRowHeights()};FlexGrid.prototype.onRowAdded=function(e){this.rowAdded.raise(this,e);return!e.cancel};FlexGrid.prototype.onDeletingRow=function(e){this.deletingRow.raise(this,e);return!e.cancel};FlexGrid.prototype.onDeletedRow=function(e){this.deletedRow.raise(this,e)};FlexGrid.prototype.onCopying=function(e){this.copying.raise(this,e);return!e.cancel};FlexGrid.prototype.onCopied=function(e){this.copied.raise(this,e)};FlexGrid.prototype.onPasting=function(e){this.pasting.raise(this,e);return!e.cancel};FlexGrid.prototype.onPasted=function(e){this.pasted.raise(this,e)};FlexGrid.prototype.onPastingCell=function(e){this.pastingCell.raise(this,e);return!e.cancel};FlexGrid.prototype.onPastedCell=function(e){this.pastedCell.raise(this,e)};FlexGrid.prototype.onFormatItem=function(e){this.formatItem.raise(this,e)};FlexGrid.prototype.onUpdatingView=function(e){this.updatingView.raise(this,e);return!e.cancel};FlexGrid.prototype.onUpdatedView=function(e){this.updatedView.raise(this,e)};FlexGrid.prototype._getTabIndex=function(){return this._orgTabIndex};FlexGrid.prototype._autoRowHeights=function(){var i=this;if(this._autoHeights){this.rows.length>100&&[this.columnHeaders,this.rowHeaders].forEach((function(e){e._updateContent(!0,!1,e._getOffsetY())}));clearTimeout(this._toAutoHeights);this._toAutoHeights=setTimeout((function(){i._toAutoHeights=null;if(!i.editRange){var e=i.autoSizeMode,o=t.AutoSizeMode;if(e&o.Headers){i._autoSizeMode=o.Both;i.autoSizeRows(0,i.columnHeaders.rows.length-1,!0);i._autoSizeMode=e}e&o.Cells&&i.autoSizeRows()}}),e.Control._REFRESH_INTERVAL)}};FlexGrid.prototype._getShowErrors=function(){return this.showErrors&&this._hasValidation};FlexGrid.prototype._getHasValidation=function(){return this._hasValidation};FlexGrid.prototype._getError=function(t,i,o,n){if(e.isFunction(this.itemValidator)){if(t==this.cells)return this.itemValidator(i,o,n);if(t==this.rowHeaders)for(o=0;o<this.columns.length;o++){if(c=this.itemValidator(i,o,n))return c}}var r=this._cv,l=r?r.getError:null;if(e.isFunction(l)){var s=t.rows,a=this.columns,d=s[i].dataItem;if(d&&!(d instanceof e.collections.CollectionViewGroup))if(t==this.cells)for(;i<s.length&&s[i].dataItem==d;i++){return l(d,this._getBindingColumn(this.cells,i,a[o]).binding,n)}else if(t==this.rowHeaders){var c;if(!(c=l(d,null))){for(var u=[];i<s.length&&s[i].dataItem==d;i++)for(o=0;o<a.length;o++){(c=l(d,this._getBindingColumn(this.cells,i,a[o]).binding))&&u.indexOf(c)<0&&u.push(c)}if(u.length){var h=this.errorTip,f=!!h&&h.isContentHtml;c=u.join(f?"<br/>":"\n")}}return c}}return null};FlexGrid.prototype._setAria=function(t,i){e.setAttribute(this.cells.hostElement,"aria-"+t,i)};FlexGrid.prototype._setFocus=function(i){if(this.hostElement&&(i||!this.containsFocus())){var o=e.getActiveElement(),n=this.activeEditor,r=this._activeCell,l=this._eFocus,s=this._root,a=this._getTabIndex();if(n){if(!e.contains(n,o)){n.focus();l.tabIndex=-1}}else if(r){if(!e.contains(r,o)&&o!=this._root){e.isIE()&&e.hasClass(r,"wj-group")&&(r=r.querySelector("."+t.CellFactory._WJC_COLLAPSE)||r);r.tabIndex=a;this._setFocusNoScroll(r);l.tabIndex=-1}}else if(!e.contains(l,o)&&o!=s){l.tabIndex=a;this._setFocusNoScroll(l)}if(!this.containsFocus()){l.tabIndex=a;this._setFocusNoScroll(l)}}};FlexGrid.prototype._setFocusNoScroll=function(t){if(e.getActiveElement()!=t){if(e.supportsFocusOptions())t.focus({preventScroll:!0});else{var i=this.scrollPosition,o=t.style,n=o.position;o.position="fixed";t.focus();o.position=n;this.scrollPosition=i}this._fixScroll()}};FlexGrid.prototype._getDefaultRowHeight=function(){var t=this.hostElement,i=this._eFocus,o=null;if(!i.offsetHeight){o=e.createElement('<div><div class="wj-cell">0</div></div>',document.body);t&&o.setAttribute("class",t.getAttribute("class"));i=o.children[0]}var n=i.offsetHeight;(isNaN(n)||n<=6)&&(n=28);e.removeChild(o);return n};FlexGrid.prototype._getCollectionView=function(t){return e.asCollectionView(t)};FlexGrid.prototype._getCanvasContext=function(){var e=document.createElement("canvas").getContext("2d"),t=getComputedStyle(this.hostElement);e.font=t.fontSize+" "+t.fontFamily.split(",")[0];return e};FlexGrid.prototype._getWidestRow=function(t,i,o,n){for(var r=0,l=0,s=t.columns[o].dataType==e.DataType.Boolean,a=i.row;a<=i.row2;a++)if(t.rows[a].isVisible){var d=t.getCellData(a,o,!0),c=n.measureText(d).width,u=this.getMergedRange(t,a,o,!1);u&&u.columnSpan>1&&(c/=u.columnSpan);if(c>l){l=c;r=a}if(s)break}return r};FlexGrid.prototype._getDesiredWidth=function(e,t,i,o){var n=this.getMergedRange(e,t,i,!1),r=o.style;this.cellFactory.updateCell(e,t,i,o,n);r.width=r.top=r.left="";return o.offsetWidth/(n&&n.columnSpan>1?n.columnSpan:1)};FlexGrid.prototype._getDesiredHeight=function(e,t,i,o){var n=o.style,r=this.getMergedRange(e,t,i,!1),l=r?r.rowSpan:1;this.cellFactory.updateCell(e,t,i,o,r);o.innerHTML.trim()||(o.innerHTML="&nbsp;");n.height=n.top=n.left="";return o.offsetHeight/l};FlexGrid.prototype._getDesiredRowHeight=function(t,i,o,n){for(var r=0,l=this._getQuickAutoSize(),s=0;s<t.columns.length;s++){var a=t.columns[s];if(a.isVisible){var d=this.getMergedRange(t,i,s,!1),c=void 0;if(l){var u={ct:t.cellType,col:s,rng:d&&d.rowSpan>1?d.rowSpan:1,data:a.dataType!=e.DataType.Number||a.dataMap?t.getCellData(i,s,!0):"1"},h=JSON.stringify(u);if(null==(c=n[h])){c=this._getDesiredHeight(t,i,s,o);n[h]=c}}else c=this._getDesiredHeight(t,i,s,o);r=Math.max(c,r)}}return r};FlexGrid.prototype._getSortRowIndex=function(){return null!=this._sortRowIndex?this._sortRowIndex:this.columnHeaders.rows.length-1};FlexGrid.prototype._getDeleteColumnIndex=function(){return 0};FlexGrid.prototype._getEditColumnIndex=function(){return null!=this._editColIndex?this._editColIndex:this.rowHeaders.columns.length-1};FlexGrid.prototype._sortConverter=function(e,t,i,o){var n,r=this;if(o){this._mappedColumns=null;this._cv&&this._cv.sortDescriptions.forEach((function(e){if((n=r.getColumn(e.property))&&n.dataMap){r._mappedColumns||(r._mappedColumns={});r._mappedColumns[n.binding]=n.dataMap}}));if(this._mouseHdl._htDown&&this._mouseHdl._htDown.col>-1){n=this.columns[this._mouseHdl._htDown.col];this._mappedColumns&&n.dataMap&&(this._mappedColumns[n.binding]=n.dataMap)}}if(this._mappedColumns){var l=this._mappedColumns[e.property];l&&l.sortByDisplayValues&&(i=l.getDisplayValue(i))}return i};FlexGrid.prototype._bindGrid=function(i){var o=this;this.finishEditing();this.deferUpdate((function(){o.autoGenerateColumns&&0==o._lastCount&&e.hasItems(o._cv)&&(i=!0);var n,r;o.preserveSelectedState&&(n=o._getMap())&&o.rows.forEach((function(e){e.isSelected&&e.dataItem&&n.set(e.dataItem,!0)}));if(o.preserveOutlineState&&o.rows.maxGroupLevel>-1&&(r=o._getMap()))for(var l=0;l<o.rows.length;l++){var s=o.rows[l];if(s instanceof t.GroupRow&&s.isCollapsed&&s.dataItem){var a=s.dataItem;a instanceof e.collections.CollectionViewGroup&&(a=a._path);r.set(a,!0)}}i&&o.columns.deferUpdate((function(){o._bindColumns()}));var d=new e.CancelEventArgs;if(o.onLoadingRows(d)){o.rows.deferUpdate((function(){o._bindRows()}));o.onLoadedRows(d)}o._selHdl.extendedSelection.clear();var c=0;n&&n.size&&o.rows.forEach((function(e){var t=e.dataItem;if(t&&n.has(t)){e.isSelected=!0;c++}}));if(0==c&&o._lastCount>0&&o.selectionMode==t.SelectionMode.ListBox){var u=o.selection;for(l=u.topRow;l<=u.bottomRow&&l>-1&&l<o.rows.length;l++)o.rows[l].isSelected=!0}r&&r.size&&o.rows.deferUpdate((function(){o.rows.forEach((function(i){if(i instanceof t.GroupRow){var o=i.dataItem;o instanceof e.collections.CollectionViewGroup&&(o=o._path);r.has(o)&&(i.isCollapsed=!0)}}))}));if(!o._lastCount){var h=o._cv;h&&h.items&&(o._lastCount=h.items.length)}}));if(this._cv){var n=i&&!this._toInv;this._syncSelection(n)}};FlexGrid.prototype._getMap=function(){return window.Map?new Map:null};FlexGrid.prototype._cvCollectionChanged=function(i,o){if(this.autoGenerateColumns&&0==this.columns.length)this._bindGrid(!0);else{var n=e.collections.NotifyCollectionChangedAction;if(this.childItemsPath&&o.action!=n.Change)this._bindGrid(!1);else{switch(o.action){case n.Change:this.invalidate();return;case n.Add:if(o.index==this._cv.items.length-1){var r=this.rows.length;this.rows[r-1]instanceof t._NewRowTemplate&&r--;this.rows.insert(r,new t.Row(o.item));return}e.assert(!1,"added item should be the last one.");break;case n.Remove:var l=this._findRow(o.item);if(l>-1){this.rows.removeAt(l);this._syncSelection();return}e.assert(!1,"removed item not found on grid.")}this._bindGrid(!1)}}};FlexGrid.prototype._cvCurrentChanged=function(e,t){this._syncSelection()};FlexGrid.prototype._syncSelection=function(i){if(this._cv&&this.selectionMode!=t.SelectionMode.None){var o=this._selHdl.selection,n=o.row>-1&&o.row<this.rows.length?this.rows[o.row]:null,r=n?n.dataItem:null,l=this._cv;if(l instanceof e.collections.CollectionView&&l.isUpdating)return;if(this.newRowAtTop&&n instanceof t._NewRowTemplate)return;r instanceof e.collections.CollectionViewGroup&&(r=null);if(i||r!=l.currentItem||o.row>=this.rows.length){var s=this.editableCollectionView;if(!this.childItemsPath||!s||!s.currentAddItem){var a=this._getRowIndex(l.currentPosition);if(a!=o.row||!this.childItemsPath){o=new t.CellRange(a,o.col,a,o.col2);this.select(o,!1);this.selectionMode&&!this._updating&&this.scrollIntoView(o.row,-1)}}}}};FlexGrid.prototype._getRowIndex=function(e){if(this._cv){var i=this.rows;if(e>-1){for(var o=this._cv.items[e];e<i.length;e++)if(i[e].dataItem===o)return e;return-1}if(1==i.length&&i[0]instanceof t._NewRowTemplate)return 0;var n=this.selection.row,r=n>-1?i[n]:null;return r&&(r instanceof t.GroupRow||null==r.dataItem)?n:-1}return this.selection.row};FlexGrid.prototype._getCvIndex=function(e){return e>-1&&e<this.rows.length?this.rows[e].dataIndex:-1};FlexGrid.prototype._findRow=function(e){for(var t=0;t<this.rows.length;t++)if(this.rows[t].dataItem==e)return t;return-1};FlexGrid.prototype._updateLayout=function(){var t=new e.CancelEventArgs;if(this.onUpdatingLayout(t)){var i=this._hdrVis&r.Row?this._hdrCols.getTotalSize():0,o=this._hdrVis&r.Column?this._hdrRows.getTotalSize():0,n=this._ftrRows.getTotalSize(),l=this._rows.getTotalSize()+n;l<1&&(l=1);this._heightReal=l;this._heightBrowser=Math.min(l,FlexGrid._getMaxSupportedCssHeight());this._maxOffsetY=Math.max(0,l-this._heightBrowser);var s=getComputedStyle(this._eFocus);this._cellPadVert=parseInt(s.paddingTop)+parseInt(s.paddingBottom);this._cellPadHorz=parseInt(s.paddingLeft)+parseInt(s.paddingRight);this._cellPadLeft=parseInt(this.rightToLeft?s.paddingRight:s.paddingLeft);var a=this._heightBrowser+o-n,d=this._gpCells.width,c=this._heightBrowser;!d&&this.rows.length&&(d=.1);!c&&this.columns.length&&(c=.1);if(this.rightToLeft){e.setCss(this._eTL,{right:0,top:0,width:i,height:o});e.setCss(this._eCHdr,{right:i,top:0,height:o});e.setCss(this._eRHdr,{right:0,top:o,width:i});e.setCss(this._eCt,{right:i,top:o,width:d,height:c});e.setCss(this._fCt,{right:i,top:o});e.setCss(this._eBL,{right:0,top:a,width:i,height:n});e.setCss(this._eCFtr,{right:i,top:a,height:n})}else{e.setCss(this._eTL,{left:0,top:0,width:i,height:o});e.setCss(this._eCHdr,{left:i,top:0,height:o});e.setCss(this._eRHdr,{left:0,top:o,width:i});e.setCss(this._eCt,{left:i,top:o,width:d,height:c});e.setCss(this._fCt,{left:i,top:o});e.setCss(this._eBL,{left:0,top:a,width:i,height:n});e.setCss(this._eCFtr,{left:i,top:a,height:n})}this._stickyHdr&&this._updateStickyHeaders();var u=this.frozenRows||this.frozenColumns?"3":"";e.setCss([this._eTL,this._eBL,this._eCHdr,this._eCFtr,this._eRHdr,this._eMarquee],{zIndex:u});e.isIE()&&(this._fCt.style.zIndex=u?"2":"");var h=this._root,f=h.offsetWidth-h.clientWidth,g=h.offsetHeight-h.clientHeight;e.setCss(this._eSz,{width:i+f+this._gpCells.width,height:o+g+this._heightBrowser});var p=null;if(this.columns._updateStarSizes(h.clientWidth-i)){p=h.clientWidth;e.setCss(this._eCt,{width:this._gpCells.width});this.onStarSizedColumns()}this._szClient=new e.Size(h.clientWidth-i,h.clientHeight-o);this._szClientSB=new e.Size(h.offsetWidth-i,h.offsetHeight-o);this._rcBounds=null;this._updateScrollHandler();this._updateContent(!1);f=h.offsetWidth-h.clientWidth;g=h.offsetHeight-h.clientHeight;e.setCss(this._eSz,{width:i+f+this._gpCells.width,height:o+g+this._heightBrowser});this._szClient=new e.Size(h.clientWidth-i,h.clientHeight-o);if(p&&p!=h.clientWidth&&this.columns._updateStarSizes(h.clientWidth-i)){e.setCss(this._eCt,{width:this._gpCells.width});this._updateContent(!1)}e.setCss([this._eCHdr,this._eCFtr,this._fCt],{width:this._szClient.width});e.setCss([this._eRHdr,this._fCt],{height:this._szClient.height});if(n){a=Math.min(a,this._szClient.height+o-n);e.setCss([this._eBL,this._eCFtr],{top:a})}this.onUpdatedLayout(t)}};FlexGrid.prototype._updateStickyHeaders=function(){var t=!1,i=0;if(this._stickyHdr){for(var o=0,n=null,r=this.hostElement;r;r=r.parentElement)if("inline"!=getComputedStyle(r).display){var l=r.getBoundingClientRect();null==n&&(n=l.top);o=Math.max(o,l.top)}i=-(n=Math.max(0,o-n-1));t=n>0;this._rcBounds=null}this._eTL.style.top=this._eCHdr.style.top=t?-i+"px":"";e.toggleClass(this._eTL,FlexGrid._WJS_STICKY,t);e.toggleClass(this._eCHdr,FlexGrid._WJS_STICKY,t)};FlexGrid.prototype._updateScrollHandler=function(){this._clipToScreen=this._getClipToScreen();var e=this._stickyHdr||this._clipToScreen;if(e!=this._scrollHandlerAttached){this._scrollHandlerAttached=e;e?this.addEventListener(window,"scroll",this._scroll.bind(this),!0):this.removeEventListener(window,"scroll")}};FlexGrid.prototype._getClipToScreen=function(){if(this.rows.length<=FlexGrid._MIN_VIRT_ROWS)return!1;if(this._root.scrollHeight>this._root.clientHeight)return!1;for(var e=this.hostElement;e&&e!=document.documentElement;e=e.parentElement){if("auto"==getComputedStyle(e).overflow)return!1}return!0};FlexGrid.prototype._scroll=function(t){var i=this;if(e.contains(t.target,this.hostElement)){if(this._clipToScreen){this._afClip&&cancelAnimationFrame(this._afClip);this._afClip=requestAnimationFrame((function(){i._afClip=null;i.finishEditing();i._updateContent(!0)}))}if(this._stickyHdr){this._afSticky&&cancelAnimationFrame(this._afSticky);this._afSticky=requestAnimationFrame((function(){i._afSticky=null;var t=new e.CancelEventArgs;if(i.onUpdatingLayout(t)){i._updateStickyHeaders();i.onUpdatedLayout(t)}}))}}};FlexGrid.prototype._getCssPage=function(t){if(this._heightReal>this._heightBrowser){var i=this._szClient.height-this._gpCFtr.rows.getTotalSize();if(this._heightBrowser>i)return e.clamp(Math.round(t/(this._heightBrowser-i)*10)/10,0,1)}return 0};FlexGrid.prototype._updateScrollPosition=function(){var t=this._root,i=t.scrollTop,o=t.scrollLeft;this.rightToLeft&&"rev"==FlexGrid._getRtlMode()&&(o=t.scrollWidth-t.clientWidth-o);var n=new e.Point(-Math.abs(o),-i);if(!this._ptScrl.equals(n)){this._ptScrl=n;this.onScrollPositionChanged();return!0}return!1};FlexGrid.prototype._updateContent=function(t,i){var o=this,n=this._root,l=this.hostElement,s=this.cells.hostElement,a=this._activeCell,d=e.getActiveElement(),c=e.contains(l,d),u=e.closest(d,".wj-flexgrid")==l?d:null,h=new e.CancelEventArgs;if(this.onUpdatingView(h)){e.setAttribute(s,"role",this.rows.maxGroupLevel<0?"grid":"treegrid");this._hasValidation=e.isFunction(this._itemValidator)||this._cv&&e.isFunction(this._cv.getError);var f=!i&&this._errorTip&&this._errorTip._tips.length,g=this._getCssPage(-this._ptScrl.y);if(g!=this._cssPage){this._cssPage=g;this._offsetY=Math.round(this._maxOffsetY*g)}this._updateScrollPosition();this._updateMarquee();var p=this._gpCells._updateContent(t,i,this._offsetY),_=this._hdrVis;if(_&r.Column&&(!i||this._ssHdr&_)){this._gpCHdr._updateContent(t,i,0);this.rightToLeft||(this._eCHdr.scrollLeft=0)}if(_&r.Row&&(!i||this._ssHdr&_)){this._gpRHdr._updateContent(t,i,this._offsetY);this._eRHdr.scrollTop=0}_&&!i&&this._gpTL._updateContent(t,i,0);if(this._gpCFtr.rows.length){this._gpBL._updateContent(t,i,0);this._gpCFtr._updateContent(t,i,0)}if(f&&this._errorTip&&this._errorTip._tips.length){clearTimeout(this._toErrorTips);this._toErrorTips=setTimeout((function(){o._errorTip.hide();for(var t=o._errorTip._tips,i=0;i<t.length;i++){var n=t[i].element;if(!n.offsetHeight||!e.hasClass(n,"wj-state-invalid")){o._errorTip.setTooltip(n,null);i--}}}),250)}if(this._useFrozenDiv()){this._updateFrozenCells(i);p&&e.hasClass(p,"wj-frozen")&&(p=null)}this._fCt.style.display=this._fCt.childElementCount?"":"none";this._activeCell=p;if(u)if(u!=n&&u!=this._eFocus&&e.contains(l,u)&&!e.contains(s,u)){e.getActiveElement()!==u&&u.focus();if(e.isIE()&&u instanceof HTMLInputElement&&!u.type.match(/checkbox|radio|range/i)){var m=u.selectionStart,w=u.selectionEnd;u.setSelectionRange(m,w)}}else{var C=p!==a;this._setFocus(C)}!u&&p&&(p.tabIndex=this.isDisabled?-1:this._orgTabIndex);a&&a!=p&&(a.tabIndex=-1);this._eFocus.tabIndex=null!=p||this.isDisabled?-1:this._orgTabIndex;c&&this.focus();this._fixScroll();this._rcBounds=null;this.onUpdatedView(h)}};FlexGrid.prototype._fixScroll=function(){if(!this._updating){var e=this.hostElement,t=this._root?this._root.parentElement:null,i=this.rightToLeft;if(e){e.scrollTop&&(e.scrollTop=0);e.scrollLeft&&!i&&(e.scrollLeft=0)}if(t){t.scrollTop&&(t.scrollTop=0);t.scrollLeft&&!i&&(t.scrollLeft=0)}}};FlexGrid.prototype._clearCells=function(){for(var e in this)if("_"==e[0]){var i=this[e];i instanceof t.GridPanel&&i._clearCells()}this.invalidate()};FlexGrid.prototype._useFrozenDiv=function(){return e.isBoolean(this._fzClone)?this._fzClone:e.isIE()||e.isFirefox()||e.isSafari()||e.isMobile()};FlexGrid.prototype._updateFrozenCells=function(i){var o=this._fCt;if(this.frozenRows||this.frozenColumns){var n=this._eCt.querySelectorAll(".wj-frozen");if(i&&o.children.length==n.length){for(var r=0;r<n.length;r++)o.children[r].className=n[r].className;return}e.setText(o,null);if(!this.activeEditor){var l=this._errorTip,s=navigator.userAgent.indexOf("MSIE")>=0;for(r=0;r<n.length;r++){var a=n[r];if(e.closest(a,".wj-flexgrid")==this.hostElement){var d=a[t.GridPanel._INDEX_KEY];if(s){var c="input[type=checkbox]",u=a.querySelector(c);a=a.cloneNode(!0);if(u){a.querySelector(c).checked=u.checked}}else a=a.cloneNode(!0);a[t.GridPanel._INDEX_KEY]=d;if(l){var h=l.getTooltip(n[r]);h&&l.setTooltip(a,h)}o.appendChild(a)}}}}else e.setText(o,null)};FlexGrid.prototype._updateMarquee=function(){var t=this._eMarquee,i=this._getMarqueeRect();if(i&&i.width&&i.height){var o=t.firstChild,n=t.offsetWidth-o.offsetWidth,r=t.offsetHeight-o.offsetHeight,l=this.cells.hostElement;e.setCss(t,{left:i.left+l.offsetLeft-n/2,top:i.top+l.offsetTop-r/2,width:i.width+n,height:i.height+r,display:""})}else t.style.display="none"};FlexGrid.prototype._getMarqueeRect=function(){if(!this._shMarquee||!this.selectionMode)return null;var t=this._selHdl.selection;if(!this.isRangeValid(t))return null;t=(t=(t=this.cells._getAdjustedSelection(t)).combine(this.getMergedRange(this.cells,t.topRow,t.leftCol,!1))).combine(this.getMergedRange(this.cells,t.bottomRow,t.rightCol,!1));var i=this.cells.getCellBoundingRect(t.topRow,t.leftCol,!0),o=this.cells.getCellBoundingRect(t.bottomRow,t.rightCol,!0);if(this.rows.frozen){var n=Math.min(this.rows.length,this.rows.frozen),r=this.cells.getCellBoundingRect(n-1,0,!0);t.topRow>=n&&i.top<r.bottom&&(i.top=r.bottom);t.bottomRow>=n&&o.bottom<r.bottom&&(o.height=r.bottom-o.top)}if(this.columns.frozen){var l=Math.min(this.columns.length,this.columns.frozen);r=this.cells.getCellBoundingRect(0,l-1,!0);if(this.rightToLeft){t.leftCol>=l&&i.right>r.left&&(i.left=r.left-i.width);t.rightCol>=l&&o.left>r.left&&(o.left=r.left)}else{t.leftCol>=l&&i.left<r.right&&(i.left=r.right);t.rightCol>=l&&o.right<r.right&&(o.width=r.right-o.left)}}return this.rightToLeft?new e.Rect(o.left,i.top,i.right-o.left,o.bottom-i.top):new e.Rect(i.left,i.top,o.right-i.left,o.bottom-i.top)};FlexGrid.prototype._bindColumns=function(){for(var i=this.columns,o=0;o<i.length;o++){if(i[o]._getFlag(t.RowColFlags.AutoGenerated)){i.removeAt(o);o--}}var n=this._cv,r=n?n.items:null;r&&r.length&&this.autoGenerateColumns&&this._getColumnTypes(r).forEach((function(o){var n=new t.Column(o);n._setFlag(t.RowColFlags.AutoGenerated,!0);n.name=n.binding;n.header=e.toHeaderCase(n.binding);var r=FlexGrid._defTypeWidth[n.dataType];if(null!=r){if(e.isString(r)){var l=Math.round(parseFloat(r));r=r.indexOf("*")>-1?l*i.defaultSize:l}e.isNumber(r)&&r>0&&(n.width=r)}i.push(n)}));this._updateColumnTypes()};FlexGrid.prototype._getColumnTypes=function(t){return e.getTypes(t)};FlexGrid.prototype._updateColumnTypes=function(){var t=this._cv;if(e.hasItems(t)){var i=t.items[0];this.columns.forEach((function(t){null==t.dataType&&t._binding&&(t.dataType=e.getType(t._binding.getValue(i)))}))}};FlexGrid.prototype._getMapEditor=function(e,i){return i.editor?null!=i.editor.isDroppedDown?i.dataMapEditor:null:!e.dataMap||e instanceof t.GroupRow?i.dataMap?i.dataMapEditor:null:e.dataMapEditor};FlexGrid.prototype._getBindingColumn=function(e,t,i){return i};FlexGrid.prototype._getBindingColumns=function(){return this.columns};FlexGrid.prototype._getRowHeaderPath=function(){return this._rowHdrPath};FlexGrid.prototype._bindRows=function(){this.rows.clear();var e=this._cv;if(e&&e.items){var t=e.items,i=e.groups;if(this.childItemsPath)for(var o=0;o<t.length;o++)this._addNode(t,o,0);else if(null!=i&&i.length>0&&this.showGroups)for(o=0;o<i.length;o++)this._addGroup(i[o]);else for(o=0;o<t.length;o++)this._addBoundRow(t,o)}};FlexGrid.prototype._addBoundRow=function(e,i){var o=new t.Row(e[i]),n=this.rows;o._list=n;n[n.length++]=o};FlexGrid.prototype._addGroupRow=function(e){this.rows.push(new t.GroupRow(e))};FlexGrid.prototype._addNode=function(i,o,n){var r=i[o],l=this.childItemsPath,s=r[e.isArray(l)?l[n]:l],a=new t.GroupRow(r);a.level=n;this.rows.push(a);if(e.isArray(s))for(var d=0;d<s.length;d++)this._addNode(s,d,n+1)};FlexGrid.prototype._addGroup=function(e){this._addGroupRow(e);if(e.isBottomLevel)for(var t=e.items,i=0;i<t.length;i++)this._addBoundRow(t,i);else for(i=0;i<e.groups.length;i++)this._addGroup(e.groups[i])};FlexGrid._getSerializableProperties=function(e){var t=[];for(e=e.prototype;e!=Object.prototype;e=Object.getPrototypeOf(e))for(var i=Object.getOwnPropertyNames(e),o=0;o<i.length;o++){var n=i[o],r=Object.getOwnPropertyDescriptor(e,n);r&&r.set&&r.get&&"_"!=n[0]&&!n.match(/^(disabled|required|showDropDown)$/)&&t.push(n)}return t};FlexGrid.prototype._hasColumnGroups=function(){return this._grpHdl.hasColumnGroups()};FlexGrid.prototype._getColumnGroup=function(e,t){return this._grpHdl.getColumnGroup(e,t)};FlexGrid.prototype._copy=function(i,o){var n=this;if("columns"==i){var r=e.asArray(o);if(r.some((function(e){return null!=e.columns})))this.columnGroups=r;else{this.columns.clear();r.forEach((function(e){var i=new t.Column(e);n.columns.push(i)}))}return!0}return!1};FlexGrid.prototype._isInputElement=function(t){return t instanceof HTMLElement&&!e.hasClass(t,"wj-btn-glyph")&&("true"==t.contentEditable||null!=t.tagName.match(/^(INPUT|TEXTAREA|BUTTON|A|SELECT|OPTION)$/i))};FlexGrid.prototype._isNativeCheckbox=function(i){return i instanceof HTMLInputElement&&"checkbox"==i.type&&!i.disabled&&!i.readOnly&&e.hasClass(i,t.CellFactory._WJC_CHECKBOX)&&e.closest(i,".wj-flexgrid")==this.hostElement};FlexGrid.prototype._wantsInput=function(t){return this._isInputElement(t)&&!this.activeEditor&&!this._isNativeCheckbox(t)&&!e.hasClass(t,"wj-grid-ime")&&e.contains(document.body,t)};FlexGrid._getMaxSupportedCssHeight=function(){if(!FlexGrid._maxCssHeight){var t=265e5;e.isIE()?t=15e5:e.isFirefox()&&(t=175e5);FlexGrid._maxCssHeight=t}return FlexGrid._maxCssHeight};FlexGrid._getRtlMode=function(){if(!FlexGrid._rtlMode){var t=e.createElement('<div dir="rtl"><div></div></div>');e.setCss(t,{visibility:"hidden",width:100,height:100,overflow:"auto"});e.setCss(t.firstChild,{width:2e3,height:2e3});document.body.appendChild(t);var i=t.scrollLeft;t.scrollLeft=-1e3;var o=t.scrollLeft;e.removeChild(t);FlexGrid._rtlMode=o<0?"neg":i>0?"rev":"std"}return FlexGrid._rtlMode};FlexGrid._WJS_STICKY="wj-state-sticky";FlexGrid._WJS_MEASURE="wj-state-measuring";FlexGrid._WJS_UPDATING="wj-state-updating";FlexGrid._WJS_WSPRE="wj-whitespace-pre";FlexGrid._MIN_VIRT_ROWS=200;FlexGrid._defTypeWidth=((i={})[e.DataType.Number]="0.714285714*",i);FlexGrid.controlTemplate='<div><div wj-part="root"><div wj-part="cells" class="wj-cells"></div><div wj-part="marquee" class="wj-marquee"><div></div></div></div><div wj-part="fcells" aria-hidden="true" class="wj-cells wj-frozen-clone"></div><div wj-part="rh"><div wj-part="rhcells" class="wj-rowheaders"></div></div><div wj-part="cf"><div wj-part="cfcells" class="wj-colfooters"></div></div><div wj-part="ch"><div wj-part="chcells" class="wj-colheaders"></div></div><div wj-part="bl"><div wj-part="blcells" class="wj-bottomleft"></div></div><div wj-part="tl"><div wj-part="tlcells" class="wj-topleft"></div></div><div wj-part="focus" class="wj-cell">0</div><div wj-part="sz"></div></div>';return FlexGrid}(e.Control);t.FlexGrid=s}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function _ImeHandler(t){this._updateImeFocusAsyncBnd=this._updateImeFocusAsync.bind(this);this._cmpstartBnd=this._compositionstart.bind(this);this._keypressBnd=this._keypress.bind(this);this._g=t;var i=e.createElement('<textarea class="wj-grid-editor wj-form-control wj-grid-ime" aria-hidden="true"/>');e.setCss(i,_ImeHandler._cssHidden);e.disableAutoComplete(i);i.tabIndex=-1;this._tbx=i;this._maskProvider=new e._MaskProvider(i);t._root.appendChild(i);this._updateImeFocus();var o=t.hostElement,n=t.addEventListener.bind(t),r=this._updateImeFocusAsyncBnd;n(o,"blur",r,!0);n(o,"focus",r);n(i,"compositionstart",this._cmpstartBnd);e.isiOS()&&n(o,"keypress",this._keypressBnd);t.selectionChanged.addHandler(r,this);t.cellEditEnded.addHandler(this._cellEditEnded,this);t.cellEditEnding.addHandler(this._cellEditEnding,this)}_ImeHandler.prototype.dispose=function(){var t=this._g,i=t.hostElement,o=this._tbx,n=t.removeEventListener.bind(t),r=this._updateImeFocusAsyncBnd;n(i,"blur",r);n(i,"focus",r);n(i,"keypress",this._keypressBnd);n(o,"compositionstart",this._cmpstartBnd);t.selectionChanged.removeHandler(r);t.cellEditEnded.removeHandler(this._cellEditEnded);t.cellEditEnding.removeHandler(this._cellEditEnding);e.removeChild(o)};_ImeHandler.prototype._compositionstart=function(t){var i=this._g;if(!i.activeEditor){var o=i._selHdl.selection;if(i.startEditing(!1,o.row,o.col,!1,t)&&i.activeEditor&&"checkbox"!=i.activeEditor.type){o=i.editRange;var n=i.activeEditor,r=this._tbx,l=i.cells.hostElement,s=i.columns[o.col].pos+l.offsetLeft,a=i.rows[o.row].pos+l.offsetTop,d=i.getCellBoundingRect(o.row,o.col),c=e.closest(n,".wj-cell");d.width=c.offsetWidth;d.height=c.offsetHeight;o.row<i.frozenRows&&(a+=i._root.scrollTop);o.col<i.frozenColumns&&(s+=i._root.scrollLeft);var u=c.querySelector(".wj-btn.wj-right");u&&(d.width-=u.offsetWidth);"minLength,maxLength,pattern".split(",").forEach((function(t){e.setAttribute(r,t,n.getAttribute(t))}));var h=n instanceof HTMLTextAreaElement;e.setAttribute(r,"wrap",h?"soft":"off");var f=getComputedStyle(c),g=f.paddingTop;if(o.rowSpan>1&&!h){var p=parseFloat(f.lineHeight);isNaN(p)&&(p=1.2*parseFloat(f.fontSize));g=Math.max(0,(d.height-p)/2)+"px"}var _={position:"absolute",left:s,top:a,width:d.width-1,height:d.height-1,paddingTop:g,paddingLeft:f.paddingLeft,paddingRight:f.paddingRight,textAlign:f.textAlign,zIndex:c.style.zIndex};if(i.rightToLeft){_.right=parseInt(c.style.right)+parseInt(i.cells.hostElement.style.right);_.left=""}e.setCss(r,_);i._edtHdl._edt=r;r.select();var m=n.value;setTimeout((function(){"　"!=r.value&&" "!=r.value||(r.value=m);e.setSelectionRange(r,r.value.length)}),20);r.placeholder=n.placeholder;n.placeholder="";n.value=""}}};_ImeHandler.prototype._cellEditEnding=function(){var e=this._maskProvider;e&&e.mask&&e._valueChanged()};_ImeHandler.prototype._cellEditEnded=function(){var t=this._tbx;t.value="";e.setCss(t,_ImeHandler._cssHidden);this._updateImeFocus()};_ImeHandler.prototype._keypress=function(e){if(!e.defaultPrevented&&e.target==this._tbx&&!(e.ctrlKey||e.altKey||e.metaKey||27==e.keyCode||this._g.activeEditor)){this._tbx.value="";this._compositionstart(e);e.stopPropagation()}};_ImeHandler.prototype._updateImeFocus=function(){var t=this._g,i=this._tbx,o=e.getActiveElement(),n=t._getTabIndex();if(!t.activeEditor&&e.closest(o,".wj-flexgrid")==t.hostElement)if(this._enableIme()){if(o!=i){t.activeCell&&(t.activeCell.tabIndex=-1);i.tabIndex=n;i.disabled=!1;i.value="";i.select();i.focus()}var r=t._selHdl.selection,l=r.isValid?t._getBindingColumn(t.cells,r.row,t.columns[r.col]):null;this._maskProvider.mask=l?l.mask:null}else{i.tabIndex=-1;i.disabled=!0;i.value="";i.blur();var s=t.activeCell;if(s){s.tabIndex=n;s.focus()}else t.focus()}};_ImeHandler.prototype._updateImeFocusAsync=function(){var e=this;this._toFocus&&clearTimeout(this._toFocus);this._toFocus=setTimeout((function(){e._toFocus=null;e._updateImeFocus()}),100)};_ImeHandler.prototype._enableIme=function(){var i=this._g,o=i._selHdl.selection;if(!i.canEditCell(o.row,o.col))return!1;var n=o.isValid?i._getBindingColumn(i.cells,o.row,i.columns[o.col]):null;return!(!n||n.editor||n.dataType==e.DataType.Boolean)&&(!n||!n.dataMap||n.dataMapEditor!=t.DataMapEditor.RadioButtons)};_ImeHandler._cssHidden={position:"fixed",width:"1px",left:-32e3,top:-32e3,overflow:"hidden"};return _ImeHandler}();t._ImeHandler=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function _AddNewHandler(e){this._nrt=new o;this._top=!1;this._keydownBnd=this._keydown.bind(this);this._committing=!1;this._g=e;this._attach()}Object.defineProperty(_AddNewHandler.prototype,"newRowAtTop",{get:function(){return this._top},set:function(i){if(i!=this.newRowAtTop){this._top=e.asBoolean(i);this.updateNewRowTemplate();var o=this._g;if(this._top&&o.selectionMode==t.SelectionMode.ListBox){o.rows.forEach((function(e,i){e._setFlag(t.RowColFlags.Selected,0==i,!0)}));o.select(0,o.selection.col)}}},enumerable:!0,configurable:!0});_AddNewHandler.prototype.updateNewRowTemplate=function(){var e=this._g,i=e.editableCollectionView,o=e.rows,n=this._nrt,r=i&&i.canAddNew&&e.allowAddNew&&!e.isReadOnly,l=o.indexOf(n),s=this._top?0:o.length-1,a=!1;if(!r&&l>-1){var d=e.selection;d.row==l&&e.select(d.row-1,d.col);o.removeAt(l)}else if(r){if(l<0)a=!0;else if(l!=s){o.removeAt(l);a=!0}a&&(this._top?o.insert(0,n):o.push(n));if(n){n._ubv=null;n._setFlag(t.RowColFlags.ParentCollapsed,!1);this._top&&e.selectionMode==t.SelectionMode.ListBox||n._setFlag(t.RowColFlags.Selected,!1)}}};_AddNewHandler.prototype._attach=function(){var e=this._g;if(e){e.beginningEdit.addHandler(this._beginningEdit,this);e.pastingCell.addHandler(this._beginningEdit,this);e.rowEditEnded.addHandler(this._rowEditEnded,this);e.loadedRows.addHandler(this.updateNewRowTemplate,this);e.hostElement.addEventListener("keydown",this._keydownBnd,!0)}};_AddNewHandler.prototype._detach=function(){var e=this._g;if(e){e.beginningEdit.removeHandler(this._beginningEdit);e.pastingCell.removeHandler(this._beginningEdit);e.rowEditEnded.removeHandler(this._rowEditEnded);e.loadedRows.removeHandler(this.updateNewRowTemplate);e.hostElement.removeEventListener("keydown",this._keydownBnd,!0)}};_AddNewHandler.prototype._keydown=function(t){if(!t.defaultPrevented&&t.keyCode==e.Key.Escape&&null==this._g.activeEditor&&this._top&&this._nrt.dataItem){this._nrt.dataItem=null;this._g.invalidate()}};_AddNewHandler.prototype._beginningEdit=function(t,i){if(!i.cancel){var n=t.rows[i.row];if(n instanceof o){var r=t.editableCollectionView;if(r&&r.canAddNew)if(this._top){if(null==this._nrt.dataItem){var l=null,s=r.sourceCollection,a=r.newItemCreator;l=e.isFunction(a)?a():s&&s.length?new s[0].constructor:{};this._nrt.dataItem=l}}else{l=r.currentAddItem&&r.currentAddItem==n.dataItem?r.currentAddItem:r.addNew();r.moveCurrentTo(l);var d=this._nrt.isSelected;this.updateNewRowTemplate();d&&i.row>-1&&(t.rows[i.row].isSelected=!0);t.isUpdating||t.refresh(!0);t.onRowAdded(i)||r.cancelNew()}}}};_AddNewHandler.prototype._rowEditEnded=function(e,t){var i=this,o=e.editableCollectionView,n=this._nrt.dataItem;if(o&&!this._committing)if(o.isAddingNew)o.commitNew();else if(n&&!t.cancel){this._committing=!0;this._nrt.dataItem=null;var r=o.addNew();for(var l in n)r[l]=n[l];e.onRowAdded(t)?o.commitNew():o.cancelNew();setTimeout((function(){e.select(0,e.columns.firstVisibleIndex);i.updateNewRowTemplate()}),20);this._committing=!1}};return _AddNewHandler}();t._AddNewHandler=i;var o=function(e){__extends(_NewRowTemplate,e);function _NewRowTemplate(){return null!==e&&e.apply(this,arguments)||this}return _NewRowTemplate}(t.Row);t._NewRowTemplate=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None";e[e.Cells=1]="Cells";e[e.ColumnHeaders=2]="ColumnHeaders";e[e.RowHeaders=4]="RowHeaders";e[e.AllHeaders=6]="AllHeaders";e[e.All=7]="All"}(i=t.AllowMerging||(t.AllowMerging={}));var o=function(){function MergeManager(e){null!=e&&console.error('** WARNING: the "grid" parameter has been deprecated. Please remove it.')}MergeManager.prototype.getMergedRange=function(o,n,r,l){void 0===l&&(l=!0);var s=o.grid,a=o.cellType,d=o.columns,c=o.rows,u=c[n],h=d[r];if(u instanceof t._NewRowTemplate)return null;if(!(u instanceof t.Row&&h instanceof t.Column))return null;if(o==s.columnHeaders){var f=s._getColumnGroup(n,r);if(f){var g=f._rng,p=o.columns;if(p.isFrozen(g.col)!=p.isFrozen(g.col2)){g=g.clone();p.isFrozen(r)?g.col2=p.frozen-1:g.col=p.frozen}return g}}if(s.showGroups&&!s.childItemsPath&&u instanceof t.GroupRow&&u.dataItem instanceof e.collections.CollectionViewGroup&&a==t.CellType.Cell){g=new t.CellRange(n,r);if(h.aggregate==e.Aggregate.None){for(;g.col>0&&d[g.col-1].aggregate==e.Aggregate.None&&g.col!=d.frozen;)g.col--;for(;g.col2<d.length-1&&d[g.col2+1].aggregate==e.Aggregate.None&&g.col2+1!=d.frozen;)g.col2++}for(;g.col<r&&!d[g.col].visible;)g.col++;return g.isSingleCell?null:g}var _=!1,m=i,w=t.CellType;switch(s.allowMerging){case m.None:_=!0;break;case m.Cells:_=a!=w.Cell;break;case m.ColumnHeaders:_=a!=w.ColumnHeader&&a!=w.TopLeft;break;case m.RowHeaders:_=a!=w.RowHeader&&a!=w.TopLeft;break;case m.AllHeaders:_=a==w.Cell}if(_)return null;if(a==w.Cell){var C=s.editableCollectionView,v=C?C.currentAddItem:null;if(v&&u.dataItem==v)return null}if(d[r].allowMerging){g=new t.CellRange(n,r);var y=o._vrb,b=0,R=c.length-1;if(n>=c.frozen){if(l&&(a==t.CellType.Cell||a==t.CellType.RowHeader)&&s._vtRows<c.length&&y){b=y.topRow;R=y.bottomRow}}else c.length>c.frozen&&(R=c.frozen-1);for(var E=n-1;E>=b&&this._mergeCell(o,E,r,n,r);E--)g.row=E;for(var x=n+1;x<=R&&this._mergeCell(o,n,r,x,r);x++)g.row2=x;for(;g.row<n&&!c[g.row].visible;)g.row++;if(!g.isSingleCell)return g}if(c[n].allowMerging){g=new t.CellRange(n,r),y=o._vrb;var S=0,H=d.length-1;if(r>=d.frozen){if(l&&(a==t.CellType.Cell||a==t.CellType.ColumnHeader)&&s._vtCols<d.length&&y){S=y.leftCol;H=y.rightCol}}else H=d.frozen-1;for(var P=r-1;P>=S&&this._mergeCell(o,n,P,n,r);P--)g.col=P;for(var M=r+1;M<=H&&this._mergeCell(o,n,r,n,M);M++)g.col2=M;for(;g.col<r&&!d[g.col].visible;)g.col++;if(!g.isSingleCell)return g}return null};MergeManager.prototype._mergeCell=function(e,i,o,n,r){var l=e.rows[i],s=e.rows[n];if(!l||!s)return!1;if(l instanceof t.GroupRow||l instanceof t._NewRowTemplate||s instanceof t.GroupRow||s instanceof t._NewRowTemplate)return!1;var a=e.grid.editableCollectionView,d=a?a.currentAddItem:null;if(d&&(l.dataItem==d||s.dataItem==d))return!1;if(i!=n&&e.rows.isFrozen(i)!=e.rows.isFrozen(n))return!1;if(o!=r&&e.columns.isFrozen(o)!=e.columns.isFrozen(r))return!1;if(i!=n){if(o>0&&(l.allowMerging&&this._mergeCell(e,i,o-1,i,o)||s.allowMerging&&this._mergeCell(e,n,o-1,n,o)))return!1;if(r<e.columns.length-1&&(l.allowMerging&&this._mergeCell(e,i,r,i,r+1)||s.allowMerging&&this._mergeCell(e,n,r,n,r+1)))return!1}return e.getCellData(i,o,!0)==e.getCellData(n,r,!0)};return MergeManager}();t.MergeManager=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function HitTestInfo(i,o){this._row=-1;this._col=-1;this._edge=0;var n;if(o instanceof Element){if(e.closest(o,".wj-flexgrid")!=i.hostElement)return;i=o;this._target=o}if(!(i instanceof Element)||i instanceof t.FlexGrid){if(i instanceof t.FlexGrid){this._target=i.hostElement;n=this._g=i}else{if(!(i instanceof t.GridPanel))throw"First parameter should be a FlexGrid or GridPanel.";this._target=i.hostElement;this._p=i;n=this._g=this._p.grid}if(o instanceof MouseEvent){this._target=o.target;"mousedown"==o.type&&(n._rcBounds=null)}o=e.mouseToPage(o);this._pt=o.clone();var r=n.controlRect,l=n._szClient,s=n.topLeftCells,a=n._eTL,d=n.headersVisibility,c=t.HeadersVisibility,u=d&c.Row?s.columns.getTotalSize():0,h=d&c.Column?s.rows.getTotalSize():0,f=d&c.Column?h+a.offsetTop:0,g=n._eBL,p=g.offsetHeight;o.x-=r.left;o.y-=r.top;n.rightToLeft&&(o.x=r.width-o.x);this._p||o.x>=0&&o.y>=a.offsetTop&&l&&o.x<=l.width+u&&o.y<=l.height+h&&(o.y<f?this._p=o.x<u?n.topLeftCells:n.columnHeaders:o.y<g.offsetTop?this._p=o.x<u?n.rowHeaders:n.cells:this._p=o.x<u?n.bottomLeftCells:n.columnFooters);if(null!=this._p){var _=this._p.rows,m=this._p.columns,w=this._p.cellType,C=t.CellType,v=this._p._getFrozenPos(),y=w==C.TopLeft||w==C.ColumnHeader?h:w==C.BottomLeft||w==C.ColumnFooter?p:_.getTotalSize(),b=w==C.TopLeft||w==C.BottomLeft||w==C.RowHeader?u:m.getTotalSize();if(w==C.RowHeader||w==C.Cell){o.y-=h;if(o.y>v.y||v.y<=0){o.y-=n._ptScrl.y;o.y+=this._p._getOffsetY()}}else w!=C.BottomLeft&&w!=C.ColumnFooter||(o.y-=g.offsetTop);if(w==C.ColumnHeader||w==C.Cell||w==C.ColumnFooter){o.x-=u;(o.x>v.x||v.x<=0)&&(o.x-=n._ptScrl.x)}w!=C.ColumnHeader&&w!=C.TopLeft||(o.y-=f-h);this._edge=0;var R=HitTestInfo._SZEDGE[this._g.isTouching?1:0];if(this._g.isTouching){R=HitTestInfo._SZEDGE[1];o.x-=R/2}this._row=o.y>y?-1:_.getItemAt(o.y);this._col=o.x>b?-1:m.getItemAt(o.x);if(this._row<0||this._col<0){this._p=null;return}if(this._col>-1){var E=m[this._col];o.x-E.pos<=R&&(this._edge|=1);var x=E.pos+E.renderSize-o.x;if(x<=R){this._edge|=4;x<=R/2&&(this._edge|=16)}}if(this._row>-1){var S=_[this._row];o.y-S.pos<=R&&(this._edge|=2);var H=S.pos+S.renderSize-o.y;if(H<=R){this._edge|=8;H<=R/2&&(this._edge|=32)}}}}else{var P=e.closest(i,".wj-cell"),M=P?P[t.GridPanel._INDEX_KEY]:null;if(M){this._target=i;this._row=M.row;this._col=M.col;this._rng=M.rng;this._p=M.panel;this._g=M.panel.grid}}}Object.defineProperty(HitTestInfo.prototype,"point",{get:function(){return this._pt},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"cellType",{get:function(){return this._p?this._p.cellType:t.CellType.None},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"panel",{get:function(){return this._p},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"grid",{get:function(){return this._p?this._p.grid:null},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"row",{get:function(){return this._row},enumerable:!0,configurable:!0});HitTestInfo.prototype.getRow=function(){return this._p&&this._row>-1?this._p.rows[this._row]:null};Object.defineProperty(HitTestInfo.prototype,"col",{get:function(){return this._col},enumerable:!0,configurable:!0});HitTestInfo.prototype.getColumn=function(e){var t=this._p,i=t&&this._col>-1?t.columns[this._col]:null;i&&e&&(i=this._g._getBindingColumn(t,this._row,i));return i};Object.defineProperty(HitTestInfo.prototype,"range",{get:function(){this._rng||(this._rng=new t.CellRange(this._row,this._col));return this._rng},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeLeft",{get:function(){return 0!=(1&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeTop",{get:function(){return 0!=(2&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeRight",{get:function(){return 0!=(4&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeFarRight",{get:function(){return 0!=(16&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeBottom",{get:function(){return 0!=(8&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"edgeFarBottom",{get:function(){return 0!=(32&this._edge)},enumerable:!0,configurable:!0});Object.defineProperty(HitTestInfo.prototype,"target",{get:function(){return this._target},enumerable:!0,configurable:!0});HitTestInfo._SZEDGE=[6,30];return HitTestInfo}();t.HitTestInfo=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){t.softInput=function softInput(){return e._getModule("wijmo.input")}}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function CellFactory(){}CellFactory.prototype.updateCell=function(i,o,n,r,l,s){var a=i.grid,d=a.rightToLeft,c=i.rows,u=i.columns,h=c[o],f=u[n],g=o,p=n,_=h instanceof t.GroupRow?h:null,m=h instanceof t._NewRowTemplate?h:null,w=f.renderWidth,C=h.renderHeight,v=i.cellType,y="wj-cell",b="",R={display:""},E=t.CellType;0!=s&&r.firstElementChild&&(1==r.childNodes.length&&"checkbox"==r.firstElementChild.type||(r.textContent=""));if(l&&!l.isSingleCell){o=l.row;n=l.col;g=l.row2;p=l.col2;h=c[o];f=u[n];_=h instanceof t.GroupRow?h:null;C=(D=l.getRenderSize(i)).height;w=D.width}var x=a._getBindingColumn(i,o,f),S=x.dataType||h.dataType,H=x.dataMap||h.dataMap,P=v==E.Cell?a._getMapEditor(h,x):null,M=v==E.RowHeader||v==E.Cell&&(!_||a.childItemsPath),F=M&&P==t.DataMapEditor.RadioButtons,z=S==e.DataType.Boolean&&!H,G=x.isContentHtml||h.isContentHtml,T=f.pos,I=h.pos,A=a._ptScrl;if(a._useFrozenDiv()&&v==E.Cell&&!a.editRange)n<u.frozen&&g>=c.frozen?I+=A.y:o<c.frozen&&p>=u.frozen&&(T+=A.x);else{var D=a._szClient;if(g<c.frozen){I=Math.min(I,D.height);C=Math.min(C,Math.max(0,D.height-I));I-=A.y}if(p<u.frozen){T=Math.min(T,D.width);w=Math.min(w,Math.max(0,D.width-T));T-=A.x}}d?R.right=T+"px":R.left=T+"px";g>=c.frozen&&(I-=i._getOffsetY());R.top=I+"px";R.width=w+"px";R.height=C+"px";R.zIndex="";(o<c.frozen||n<u.frozen)&&(R.zIndex=o<c.frozen&&n<u.frozen?2:1);var j=!1,O=a.alternatingRowStep;if(O&&(!l||l.row==l.row2)){j=h.visibleIndex%(O+1)==0;1==O&&(j=!j)}if(v==E.Cell){_&&(y+=" wj-group");j&&(y+=" wj-alt");(o<c.frozen||n<u.frozen)&&(y+=" wj-frozen");m&&(y+=" wj-new");h.cssClass&&(y+=" "+h.cssClass);x.cssClass&&(y+=" "+x.cssClass)}else{y+=" wj-header";j&&(y+=" wj-header-alt");h.cssClass&&v==E.ColumnHeader&&(y+=" "+h.cssClass);x.cssClass&&v==E.RowHeader&&(y+=" "+x.cssClass);var L=!1;v!=E.ColumnHeader&&v!=E.TopLeft||a.allowResizing&t.AllowResizing.Columns&&(L=null!=a._mouseHdl._getResizeCol(i,p));L||v!=E.RowHeader||a.allowResizing&t.AllowResizing.Rows&&(L=null!=a._mouseHdl._getResizeRow(i,g));L&&(y+=" wj-big-header")}h.cssClassAll&&(y+=" "+h.cssClassAll);x.cssClassAll&&(y+=" "+x.cssClassAll);var k=t.SelectedState,N=i.getSelectedState(o,n,l);N!=k.None&&v==E.Cell&&!z&&a.editRange&&a.editRange.contains(o,n)&&(N=k.None);switch(N){case k.Active:y+=" wj-state-active";break;case k.Cursor:y+=" wj-state-selected wj-state-active";break;case k.Selected:y+=" wj-state-multi-selected"}g==c._lastFrozen&&(y+=" wj-frozen-row");p==u._lastFrozen&&(y+=" wj-frozen-col");(x.wordWrap||h.wordWrap)&&(y+=" wj-wrap");(x.multiLine||h.multiLine)&&(y+=" wj-multiline");var B=x.getAlignment(h);B&&(b=" wj-align-"+B);var V=v!=E.ColumnHeader&&v!=E.RowHeader||!a._hasColumnGroups()?null:a._getColumnGroup(o,n);V&&V.align&&(b=" wj-align-"+V.align);R.paddingLeft=R.paddingRight=R.paddingTop=R.paddingBottom="";if(v==E.Cell&&a.rows.maxGroupLevel>-1&&n==u.firstVisibleIndex&&a.treeIndent){var K=_?Math.max(0,_.level):c.maxGroupLevel+1,W=Math.min(a.treeIndent*K+a._cellPadLeft,w-a._cellPadHorz)+"px";d?R.paddingRight=W:R.paddingLeft=W}w<=a._cellPadHorz&&null==r.getAttribute(t.FlexGrid._WJS_MEASURE)&&(R.paddingLeft=R.paddingRight=0);var q=v==E.Cell&&n==u.firstVisibleIndex&&_&&_.hasChildren&&!_isEditingCell(a,o,n);q&&(b="");if(0!=s){var U=i.getCellData(o,n,!1),Y=i.getCellData(o,n,!0);if(q){var J=_getTreeBtn(_);Y=_.getGroupHeader()||e.escapeHtml(Y);r.innerHTML=J.outerHTML+" "+Y}else if(v!=E.ColumnHeader||g!=a._getSortRowIndex()&&x==f)if(v!=E.RowHeader||Y)if(v!=E.Cell||S!=e.DataType.Boolean||H||_&&!e.isBoolean(U))if(v==E.Cell&&!F&&_isEditingCell(a,o,n)){var X=x.inputType||h.inputType;X||(X=S!=e.DataType.Number||H?"text":"tel");if(!H&&!x.mask&&!h.mask){var $=i.getCellData(o,n,!1);e.isNumber($)&&(Y=function _getEditString(t,i){i=i||"n";var o=e.Globalize._parseNumericFormat(i);switch(o.spec){case"d":case"x":break;case"e":i=i.replace(/[0-9]/g,"");break;default:i="p"==o.spec?"P15":"r";o.scale&&(i+=Array(o.scale/3+1).join(","))}return e.Globalize.formatNumber(t,i,!0)}($,x.format||h.format))}r.innerHTML=(x.multiLine||h.multiLine)&&"checkbox"!=X?'<textarea wrap="soft"></textarea>':'<input type="'+X+'"/>';var Q=r.children[0];e.addClass(Q,"wj-grid-editor wj-form-control");e.disableAutoComplete(Q);G&&H&&!H.isEditable&&(Y=e.toPlainText(Y));Q.value=Y;Q.tabIndex=-1;Q.required=x.getIsRequired(h);e.setAttribute(Q,"aria-required",Q.required);var Z=x.maxLength||h.maxLength;Z&&(Q.maxLength=Z);Q.style.textAlign=x.getAlignment(h);var ee=x.mask||h.mask;ee&&new e._MaskProvider(Q,ee);a.showPlaceholders&&(Q.placeholder=x.header);a._edtHdl._edt=Q}else{if(F){var te=[],ie=i.getCellData(o,n,!1);H.getDisplayValues(h.dataItem).forEach((function(t){var i=H.getKeyValue(t)==ie?" checked":"",o=a.isReadOnly||h.isReadOnly||f.isReadOnly?" disabled":"";te.push('<label><input type="radio" tabindex="-1"'+i+o+"><span>"+e.escapeHtml(t)+"</span></label>")}));r.innerHTML=te.join(" ");y+=" "+CellFactory._WJC_RADIOMAP}(ae=M?x._tpl:null)?_renderTemplate(ae,r,U,Y,h,x):F||(v==E.Cell&&G?r.innerHTML=Y:r.textContent=Y||"");if(V&&V.collapseTo){var oe=V._rng;if(oe&&(v==E.ColumnHeader&&oe.columnSpan>1||v==E.RowHeader&&oe.rowSpan>1)){var ne=V.isCollapsed;r.innerHTML='<div role="button" class="'+CellFactory._WJC_COLLAPSE+'">'+_getGlyph(ne?"plus":"minus")+"</div>&nbsp;"+r.innerHTML;ne&&e.addClass(r,"wj-state-collapsed")}}}else{var re=r.firstChild;if(!a._isNativeCheckbox(re)){r.innerHTML='<label><input type="checkbox" class="'+CellFactory._WJC_CHECKBOX+'" tabindex="-1"/><span></span></label>';re=r.querySelector("input")}e.setChecked(re,U);re.disabled=!a.canEditCell(o,n);re.disabled&&(re.style.cursor="default");a.editRange&&a.editRange.contains(o,n)&&(a._edtHdl._edt=re)}else{if(n==a._getEditColumnIndex()){var le=a.editableCollectionView,se=le?le.currentEditItem:null;Y=r.innerHTML=se&&h.dataItem==se?_getGlyph("pencil"):h instanceof t._NewRowTemplate?_getGlyph("asterisk"):""}var ae;(ae=x._tpl)&&_renderTemplate(ae,r,U,Y,h,x)}else{r.innerHTML=e.escapeHtml(Y);var de=x.currentSort;if(de&&a.showSort){y+=" wj-sort-"+("+"==de?"asc":"desc");r.innerHTML+="&nbsp;"+function _getSortGlyph(e){var t=_getGlyph("+"==e.currentSort?"up":"down"),i=e.grid.collectionView;if(i&&i.sortDescriptions.length>1){var o=e.currentSortIndex;o>-1&&(t+='<span class="wj-sort-index">'+(o+1)+"</span>")}return t}(x)}a.allowPinning&&e.contains(a.hostElement,r)&&_addPinButton(r,n<a.frozenColumns)}if(P==t.DataMapEditor.DropDownList&&a.showDropDown&&a.canEditCell(o,n)&&t.softInput()){var ce=_getDropDownBtn();r.insertBefore(ce,r.firstChild);_isEditingCell(a,o,n)&&(y+=" wj-hasdropdown")}}if(v==E.RowHeader||v==E.ColumnHeader){var ue=v==E.RowHeader?!_&&!m&&h.allowDragging&&0!=(a.allowDragging&t.AllowDragging.Rows):f.allowDragging&&0!=(a.allowDragging&t.AllowDragging.Columns);e.setAttribute(r,"draggable",ue?"true":null)}y+=b;r.className!=y&&(r.className=y);var he=r.style;for(var fe in R)he[fe]!==R[fe]&&(he[fe]=R[fe]);if(a._edtHdl._edt&&a._edtHdl._edt.parentElement==r){var ge=a._root,pe=ge.getBoundingClientRect(),_e=r.getBoundingClientRect(),me=pe.top+ge.clientHeight-_e.top,we=pe.left+ge.clientWidth-_e.left;_e.height>me&&(r.style.height=me+"px");_e.width>we&&(r.style.width=we+"px")}if((v==E.Cell||v==E.RowHeader)&&a._getShowErrors()){var Ce=a._getError(i,o,n);a._edtHdl._setCellError(r,Ce)}a.itemFormatter&&a.itemFormatter(i,o,n,r);if(a.formatItem.hasHandlers){var ve=CellFactory._fmtItemArgs;if(ve){ve._p=i;ve._rng.setRange(o,n,g,p);ve._cell=r}else ve=CellFactory._fmtItemArgs=new t.FormatItemEventArgs(i,new t.CellRange(o,n,g,p),r);ve._updateContent=!1!==s;a.onFormatItem(ve)}};CellFactory.prototype.disposeCell=function(e){};CellFactory.prototype.getEditorValue=function(t){var i=t._edtHdl,o=(i._rng,i._edt);if(o instanceof HTMLInputElement&&"checkbox"==o.type)return o.checked;if(o instanceof HTMLInputElement||o instanceof HTMLTextAreaElement){var n=o.value,r=o.maxLength;if(e.isNumber(r)&&r>-1&&n.length>r){var l=e.culture.Globalize.numberFormat["%"]||"%",s=n.length&&n[n.length-1]==l;n=n.substr(0,r);s&&n.indexOf(l)<0&&(n+=l)}return n}return null};CellFactory._WJC_RADIOMAP="wj-radio-map";CellFactory._WJC_CHECKBOX="wj-cell-check";CellFactory._WJC_COLLAPSE="wj-elem-collapse";CellFactory._WJC_DROPDOWN="wj-elem-dropdown";CellFactory._WJC_PIN="wj-elem-pin";CellFactory._tplDdBtn=_getButton(CellFactory._WJC_DROPDOWN,"down");CellFactory._tplCtx={row:null,col:null,value:null,text:null,item:null};return CellFactory}();t.CellFactory=i;function _renderTemplate(t,o,n,r,l,s){var a=i._tplCtx;a.value=n;a.text=r;a.item=l.dataItem;a.row=l;a.col=s;var d=e.isString(t)?e.evalTemplate(t,a):t(a,o);null!=d&&(o.innerHTML=d)}function _isEditingCell(e,t,i){return e.editRange&&e.editRange.contains(t,i)}function _getDropDownBtn(){var t=i._ddBtn;if(!t){t=i._ddBtn=e.createElement(i._tplDdBtn);e.setAriaLabel(t,e.culture.FlexGrid.ariaLabels.toggleDropDown);e.setAttribute(t,"aria-expanded",!1)}return t.cloneNode(!0)}function _addPinButton(t,o){var n=_getButton(i._WJC_PIN,"pin"),r=e.createElement(n);e.toggleClass(r,"wj-state-pinned",o);e.setAttribute(r,"aria-pressed",o);t.insertBefore(r,t.firstChild)}function _getTreeBtn(t){var o=i._WJC_COLLAPSE,n=(t.isCollapsed?"":"down-")+(t.grid.rightToLeft?"left":"right"),r=e.createElement('<button class="wj-btn wj-btn-glyph '+o+'" type="button" tabindex="-1">'+_getGlyph(n)+"</button>");e.setAriaLabel(r,e.culture.FlexGrid.ariaLabels.toggleGroup);e.setAttribute(r,"aria-expanded",!t.isCollapsed);return r}function _getGlyph(e){return'<span class="wj-glyph-'+e+'"></span>'}function _getButton(e,t){return'<button class="wj-btn wj-btn-glyph wj-right {cls}" type="button" tabindex="-1">{glyph}</button>'.replace("{cls}",e).replace("{glyph}",_getGlyph(t))}}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(){function _EditHandler(i){var o=this;this._rng=null;this._edt=null;this._edItem=null;this._fullEdit=!1;this._list=null;this._evtInput=null;this._evtChange=null;this._cstEdtValue=null;this._g=i;this._evtInput=document.createEvent("HTMLEvents");this._evtInput.initEvent("input",!0,!1);this._evtChange=document.createEvent("HTMLEvents");this._evtChange.initEvent("change",!0,!1);i.selectionChanging.addHandler((function(e,t){if(o.finishEditing()){var n=i._selHdl.selection.row;if(n!=t.row){var r=i.rows.length;(n>-1&&n<r?i.rows[n].dataItem:null)!=(t.row>-1&&t.row<r?i.rows[t.row].dataItem:null)&&o._commitRowEdits()}}else t.cancel=!0}));i.lostFocus.addHandler((function(){var t=e.getActiveElement();t&&"fixed"==getComputedStyle(t).position?o.finishEditing():o._commitRowEdits()}));var n=i.hostElement;i.addEventListener(n,"mousedown",(function(e){if(!e.defaultPrevented&&0==e.button&&!i._mouseHdl._szRowCol){var n=i.hitTest(e);n.cellType!=t.CellType.Cell&&n.cellType!=t.CellType.None&&(o.finishEditing()||o.finishEditing(!0))}}),!0);i.addEventListener(n,"compositionend",this._keypress.bind(this))}_EditHandler.prototype.startEditing=function(i,o,n,r,l){void 0===i&&(i=!0);var s=this._g,a=s._selHdl.selection;o=e.asNumber(o,!0,!0);n=e.isString(n)?s.columns.indexOf(n):e.asNumber(n,!0,!0);null==o&&(o=a.row);null==n&&(n=a.col);null==r&&(r=!0);if(!this._allowEdit(o,n))return!1;var d=s.getMergedRange(s.cells,o,n,!1);d||(d=new t.CellRange(o,n));var c=s.rows[o].dataItem;s.scrollIntoView(d.row,d.col,!0);if(!s.select(d,!0))return!1;if(!s.rows[o]||c!=s.rows[o].dataItem)return!1;if(this.activeEditor){if(d.equals(this._rng))return!0;if(!this.finishEditing())return!1}var u=new t.CellRangeEventArgs(s.cells,d,l);if(!s.onBeginningEdit(u))return!1;var h=s.editableCollectionView,f=!1;if(h){(f=(c=s.rows[o].dataItem)!=h.currentEditItem)&&s.onRowEditStarting(u);h.editItem(c);if(f){s.onRowEditStarted(u);this._edItem=c}}var g=s.rows[o],p=s._getBindingColumn(s.cells,o,s.columns[n]),_=p.dataMap||g.dataMap,m=t.DataMapEditor.RadioButtons,w=g.dataMap&&g.dataMapEditor==m||p.dataMap&&p.dataMapEditor==m;this._fullEdit=e.asBoolean(i);this._rng=d;this._list=null;if(_&&!w&&!p.editor){var C=_.getDisplayValues(c);(p.isContentHtml||g.isContentHtml)&&(C=C.map((function(t){return e.toPlainText(t)})));this._list=C}if(w){var v=s._activeCell||s.hostElement.querySelector(".wj-cell.wj-state-active");if(v){this._edt=v.querySelector("input");this._updateRowHeaderCell(o)}}else d.isSingleCell?this._updateEditorCell(o,n,f):s.refresh(!1);var y=this._edt;if(y){if("checkbox"==y.type||"radio"==y.type)this._fullEdit=!1;else if(r){var b=0,R=y.value.length,E=!1,x=e.culture.Globalize.numberFormat["%"]||"%",S=s.getCellData(o,n,!1);e.isNumber(S)?E=y.value.indexOf(x)>-1:null==S&&(E=/^p/i.test(p.format))&&y.value.indexOf(x)<0&&(y.value+=x);if(E){var H=y.value;b=0;R=H.length;for(;R>0&&(H[R-1]==x||" "==H[R-1]);)R--;for(;b<R&&H[b]==x;)b++}l&&"keydown"==l.type&&l.keyCode==e.Key.Space&&(b=R);e.setSelectionRange(y,b,R);e.isIE()&&"right"==y.style.textAlign&&(y.style.paddingRight="1px")}s.onPrepareCellForEdit(u)}r&&!s.containsFocus()&&s.focus();return null!=y&&!y.disabled&&!y.readOnly};_EditHandler.prototype.finishEditing=function(i){var o=this._edt;if(!o){this._removeListBox();return!0}var n=this._g,r=this._rng,l=new t.CellEditEndingEventArgs(n.cells,r),s=n.containsFocus(),a=n.hostElement.querySelector(".wj-control.wj-state-focused");if(a){var d=e.Control.getControl(a);d&&d.onLostFocus(l)}l.cancel=i;if(!i&&n.validateEdits){if(p=this._getValidationError()){l.cancel=!0;var c=n.cells.getCellElement(r.row,r.col);if(c){this._setCellError(c,p);l.stayInEditMode=!0}}}this._cstEdtValue=null;if(!n.onCellEditEnding(l)&&l.stayInEditMode){s?setTimeout((function(){o.select()})):o.select();this._fullEdit=!0;return!1}if(!l.cancel){l.data=n.cells.getCellData(r.topRow,r.leftCol,!1);for(var u=this._cstEdtValue,h=u&&!e.isUndefined(u.value)?u.value:n.cellFactory.getEditorValue(n),f=r.topRow;f<=r.bottomRow&&f<n.rows.length;f++)for(var g=r.leftCol;g<=r.rightCol&&g<n.columns.length;g++){if(!n.cells.setCellData(f,g,h,!0,!1)&&n.validateEdits){var p;if(p=this._getValidationError(!0)){l.cancel=!0;var _=n.cells.getCellElement(r.row,r.col);if(_){this._setCellError(_,p);l.stayInEditMode=!0}return!1}}}o.value==this._edtValue&&o.dispatchEvent(this._evtChange)}this._edt=null;this._rng=null;this._list=null;this._edtValue=null;this._removeListBox();var m=e.closest(o,".wj-cell");e.contains(m,e.getActiveElement())&&n._setFocusNoScroll(m);!l.cancel&&l.refresh&&n._refreshOnEdit?n.refresh(!1):this._updateEditorCell(r.row,r.col,!1);s&&n.focus();n.onCellEditEnded(l);return!0};_EditHandler.prototype._setCustomEditorValue=function(e){this._cstEdtValue={value:e}};_EditHandler.prototype._setCellError=function(t,i){var o=this._g;""==i&&(i=null);e.toggleClass(t,"wj-state-invalid",null!=i);var n=o.errorTip,r=o.activeEditor;if(n){n.setTooltip(t,i);r&&e.contains(t,r)&&e.setAttribute(r,"title","")}else e.setAttribute(t,"title",i);r&&t==o.activeCell&&!e.contains(t,r)&&n&&n.setTooltip(r,i)};Object.defineProperty(_EditHandler.prototype,"activeEditor",{get:function(){return this._edt},enumerable:!0,configurable:!0});Object.defineProperty(_EditHandler.prototype,"editRange",{get:function(){return this._rng},enumerable:!0,configurable:!0});_EditHandler.prototype.getClipString=function(e,i,o,n){var r,l=this,s=this._g,a=s.selectionMode,d=[],c=0!=(i&t.ClipStringOptions.CSV),u=c?"\r\n":"\n",h=c?",":"\t",f=0!=(i&t.ClipStringOptions.InvisibleRows),g=t.SelectionMode,p=null!=e;if(!e&&a!=g.ListBox)for(var _=s.rows,m=0;m<_.length;m++)if(_[m].isSelected){a=g.ListBox;break}if(!e){s._selHdl._expandSelection();e=s.selection;switch(a){case g.Row:case g.RowRange:case g.ListBox:e.col=0;e.col2=s.columns.length-1;break;case g.MultiRange:var w=s.selectedRanges;if(w.length>1){var C=this._sameCols(w),v=this._sameRows(w);if(C||v){(w=w.slice()).sort((function(e,t){var i=e.topRow-t.topRow;return i||e.leftCol-t.leftCol}));for(var y=0;y<w.length;y++)for(var b=w[y],R=y+1;R<w.length;R++)if(b.contains(w[R])){w.splice(R,1);R--}if(C){var E=[];w.forEach((function(e){E.push(l.getClipString(e,i,o,n));o=!1}));return E.join(u)}if(v){var x;w.forEach((function(e){var t=l.getClipString(e,i,o,n).split(u);if(null==x){x=t;n=!1}else t.forEach((function(e,t){x[t]+=h+e}))}));return x.join(u)}}}}}o&&(r=s.columnHeaders).rows.forEach((function(t,o){if(f||t.isVisible){var s=l._getRowClipString(r,o,e,i,n);d.push(s)}}));r=s.cells;if(a!=g.ListBox||p){for(y=e.topRow;y<=e.bottomRow;y++)if(f||r.rows[y].isVisible){var S=this._getRowClipString(r,y,e,i,n);d.push(S)}}else r.rows.forEach((function(t,o){if(t.isSelected&&(f||t.isVisible)){var s=l._getRowClipString(r,o,e,i,n);d.push(s)}}));return d.join(u)};_EditHandler.prototype._getRowClipString=function(i,o,n,r,l){var s=[],a=i.rows[o],d=t.ClipStringOptions,c=0!=(r&d.CSV),u=0!=(r&d.InvisibleColumns),h=0==(r&d.Unformatted),f=0!=(r&d.SkipMerged);if(a.isVisible){if(l)for(var g=i.cellType==t.CellType.ColumnHeader?i.grid.topLeftCells:i.grid.rowHeaders,p=0;p<g.columns.length;p++)if(u||g.columns[p].isVisible){var _=g.getCellData(o,p,!0);f&&this._skipMergedCell(i,null,o,p)&&(_="");s.push(this._getCellClipString(_,r))}for(p=n.leftCol;p<=n.rightCol;p++)if(u||i.columns[p].isVisible){!(_=i.getCellData(o,p,h))&&a instanceof t.GroupRow&&p==i.columns.firstVisibleIndex&&(_=e.toPlainText(a.getGroupHeader()));f&&this._skipMergedCell(i,null,o,p)&&(_="");s.push(this._getCellClipString(_,r))}}return s.join(c?",":"\t")};_EditHandler.prototype._skipMergedCell=function(e,t,i,o){var n=e.grid.getMergedRange(e,i,o,!1);if(n){if(t){n.row=Math.max(t.topRow,n.row);n.col=Math.max(t.leftCol,n.col)}if(n.row!=i||n.col!=o)return!0}return!1};_EditHandler.prototype._getCellClipString=function(i,o){e.isString(i)||(i=e.isDate(i)?i.toJSON():null!=i?i.toString():"");i=i.replace(/\t/g," ");var n=0!=(o&t.ClipStringOptions.QuoteAll);(n=n||/\n|^"|"$/.test(i))||0==(o&t.ClipStringOptions.CSV)||(n=i.indexOf(",")>-1);n&&(i='"'+(i=i.replace(/"/g,'""'))+'"');return i};_EditHandler.prototype._sameRows=function(e){for(var t=e[0],i=1;i<e.length;i++)if(e[i].topRow!=t.topRow||e[i].bottomRow!=t.bottomRow)return!1;return!0};_EditHandler.prototype._sameCols=function(e){for(var t=e[0],i=1;i<e.length;i++)if(e[i].leftCol!=t.leftCol||e[i].rightCol!=t.rightCol)return!1;return!0};_EditHandler.prototype.setClipString=function(i,o){var n=this,r=this._g,l=r.editableCollectionView,s=null==o,a=t.SelectionMode;if(s){r._selHdl._expandSelection();o=r.selection;switch(r.selectionMode){case a.Row:case a.RowRange:case a.ListBox:o.col=0;o.col2=r.columns.length-1;break;case a.MultiRange:var d=r.selectedRanges;if(d.length>1){l&&l.beginUpdate();d.forEach((function(e){r.setClipString(i,e)}));l&&l.endUpdate();r.selectedRanges=d;return}}}o=e.asType(o,t.CellRange);var c=this._parseClipString(e.asString(i));!s&&c.length>o.rowSpan&&(c=c.slice(0,o.rowSpan));this._expandClipRows(c,o);var u=s?new t.CellRange(o.topRow,o.leftCol,o.topRow+c.length-1,o.leftCol+c[0].length-1):o,h=new t.CellRangeEventArgs(r.cells,u,i);if(!r.onPasting(h))return!1;u=new t.CellRange(o.topRow,o.leftCol);var f=new t.CellRangeEventArgs(r.cells,new t.CellRange(o.topRow,-1)),g=!1,p=0,_=o.topRow,m=r.rows,w=r.columns,C=this._deferPaste(o,c.length);r.deferUpdate((function(){var i=-1;if(l&&C){i=l.currentPosition;l.beginUpdate()}for(var s=0;s<c.length&&_<m.length;s++,_++){var a=m[_];if(a.isVisible){var d=a.dataItem,h=l?l.currentEditItem:null;if(h&&d!=h){r.onRowEditEnding(f);r.onRowEditEnded(f)}if(d!=h){f._rng.setRange(_,-1,_,-1);r.onRowEditStarting(f);r.onRowEditStarted(f)}a instanceof t._NewRowTemplate&&l&&C&&(a.dataItem=l.addNew());for(var v=c[s],y=o.leftCol,b=0;b<v.length&&y<w.length;b++,y++){var R=w[y];if(R.isVisible){if(n._allowEdit(_,y)){var E=v[b],x=E.length;x>1&&'"'==E[0]&&'"'==E[x-1]&&E.indexOf("\n")>-1&&(E=E.substr(1,x-2));var S=R.maxLength||a.maxLength;S&&(E=E.substr(0,S));var H=new t.CellRangeEventArgs(r.cells,new t.CellRange(_,y),E);if(r.onPastingCell(H)){if(l){l.editItem(d);n._edItem=l.currentEditItem}var P=r.getCellData(_,y,!1);if(r.setCellData(_,y,H.data)){H.data=P;r.onPastedCell(H);g=!0}}u.row2=Math.max(u.row2,_+p);u.col2=Math.max(u.col2,y)}}else b--}if(n._edItem&&l instanceof e.collections.CollectionView){var M=new e.collections.NotifyCollectionChangedEventArgs(e.collections.NotifyCollectionChangedAction.Change,n._edItem,_);l.onCollectionChanged(M)}if(a instanceof t._NewRowTemplate&&l&&C){a.dataItem=null;if(g){_--;p++;l.commitNew()}else l.cancelNew()}}else s--}if(l)if(C){if(l.currentEditItem){l.commitEdit();r.onRowEditEnding(f);r.onRowEditEnded(f)}l.moveCurrentToPosition(i);l.endUpdate(!0)}else{var F=l.currentAddItem;!F&&0==o.row&&r.newRowAtTop&&m[0]instanceof t._NewRowTemplate&&(F=m[0].dataItem);if(F){l.editItem(F);n._edItem=F}}u.rowSpan>1&&0==u.topRow&&m[0]instanceof t._NewRowTemplate&&(u.row=u.row2=0);r.select(u)}));r.onPasted(h);if(g&&e.closest(r.hostElement,"form")){var v=document.createEvent("HTMLEvents"),y=e.createElement("<input>",r.hostElement);v.initEvent("change",!0,!1);y.dispatchEvent(v);e.removeChild(y)}};_EditHandler.prototype._deferPaste=function(e,i){var o=this._g.rows,n=o.length;if(i>1){if(n>1&&o[0].dataItem!=o[1].dataItem)return!0;if(1==n&&o[0]instanceof t._NewRowTemplate)return!0}return!1};_EditHandler.prototype._parseClipString=function(e){e=(e=e.replace(/\r\n/g,"\n").replace(/\r/g,"\n")).replace(/\n$/,"");var t=0,i=0,o=[];for(t=0;t<e.length;t++){var n='"'==e[t],r=!1,l=!1;for(i=t;i<e.length&&!l;i++){var s=e[i];switch(s){case'"':n&&(r=!r);break;case"\t":case"\n":if(!r){this._parseClipCell(o,e,t,i,"\n"==s);t=i;i==e.length-1&&(t=i+1);l=!0}}}if(i==e.length){this._parseClipCell(o,e,t,i,!1);break}}0==o.length&&o.push([""]);return o};_EditHandler.prototype._parseClipCell=function(e,t,i,o,n){e.length||e.push([]);var r=t.substr(i,o-i),l=r.length;l>2&&'"'==r[0]&&'"'==r[l-1]&&r.indexOf('""')>-1?r=(r=r.substr(1,l-2)).replace(/""/g,'"'):"\t"==r&&(r="");e[e.length-1].push(r);n&&e.push([])};_EditHandler.prototype._expandClipRows=function(e,t){for(var i=e.length,o=0,n=0;n<i;n++)o=Math.max(o,e[n].length);for(var r=this._g,l=0,s=0,a=t.topRow;a<=t.bottomRow;a++)r.rows[a].isVisible&&l++;for(var d=t.leftCol;d<=t.rightCol;d++)r.columns[d].isVisible&&s++;if(l>1||s>1){1==l&&(l=i);1==s&&(s=o);if(s%o==0&&l%i==0){for(d=o;d<s;d++)for(a=0;a<i;a++)e[a].push(e[a%i][d%o]);for(a=i;a<l;a++)e.push(e[a%i])}}};_EditHandler.prototype._updateEditorCell=function(t,i,o){var n=this._g,r=n.cells.getCellElement(t,i),l=n._useFrozenDiv()&&(t<n.frozenRows||i<n.frozenColumns);if(!r||l||n._hasPendingUpdates())n.refresh(!1);else if(n.onUpdatingView(new e.CancelEventArgs)){this._updateCell(r);(o||n._getHasValidation())&&this._updateRowHeaderCell(t);n.onUpdatedView()}};_EditHandler.prototype._updateRowHeaderCell=function(e){var i=this._g;if(i.headersVisibility&t.HeadersVisibility.Row){var o=i.rowHeaders,n=i._getEditColumnIndex(),r=o.getCellElement(e,n);r&&this._updateCell(r)}};_EditHandler.prototype._updateCell=function(i){var o=new t.HitTestInfo(i,null),n=t.FlexGrid._WJS_UPDATING;if(o.panel){e.addClass(i,n);o.grid.cellFactory.updateCell(o.panel,o.row,o.col,i,o.range);e.removeClass(i,n)}};_EditHandler.prototype._getValidationError=function(e){var t=this._g,i="";if(t._getHasValidation()){var o=this._rng.row,n=this._rng.col,r=t.cellFactory.getEditorValue(t),l=t.getCellData(o,n,!1);if(e)i=t._getError(t.cells,o,n,!0);else{var s=t.activeEditor;s&&(i=s.validationMessage);if(!i){!t._getBindingColumn(t.cells,o,t.columns[n]).isRequired||null!=r&&""!=r||(i=this._getRequiredMsg())}if(!i&&t.setCellData(o,n,r,!0,!1)){i=t._getError(t.cells,o,n);t.setCellData(o,n,l,!1,!1)}}}return i};_EditHandler.prototype._getRequiredMsg=function(){if(!_EditHandler._msgRequired){var e=document.createElement("input");e.required=!0;_EditHandler._msgRequired=e.validationMessage}return _EditHandler._msgRequired};_EditHandler.prototype._allowEdit=function(e,i){var o=this._g;if(o.isReadOnly||o.selectionMode==t.SelectionMode.None)return!1;if(o.collectionView&&!o.editableCollectionView)return!1;if(null!=e){if(e<0||e>=o.rows.length)return!1;var n=o.rows[e];if(!n||n.isReadOnly||!n.isVisible)return!1}if(null!=i){if(i<0||i>=o.columns.length)return!1;var r=o._getBindingColumn(o.cells,e,o.columns[i]);if(!r||r.isReadOnly||!r.isVisible)return!1}return!0};_EditHandler.prototype._commitRowEdits=function(){var e=this._g;if(this.finishEditing()&&this._edItem){var i=e.editableCollectionView;if(i&&(i.currentEditItem||i.currentAddItem)){var o=new t.CellRangeEventArgs(e.cells,e.selection);e.onRowEditEnding(o);i.commitEdit();e.onRowEditEnded(o)}this._edItem=null}};_EditHandler.prototype._keydown=function(t){var i=this._edt;switch(t.keyCode){case e.Key.F2:this._fullEdit=!this._fullEdit;t.preventDefault();return!0;case e.Key.F4:this._toggleListBox(t);t.preventDefault();return!0;case e.Key.Space:if(i&&"checkbox"==i.type&&!i.disabled&&!i.readOnly){e.setChecked(i,i.indeterminate||!i.checked);this.finishEditing();t.preventDefault()}return!0;case e.Key.Enter:t.preventDefault();if(i&&t.altKey){var o=t.target;if(o instanceof HTMLTextAreaElement&&"soft"==o.wrap){o.style.setProperty("ime-mode","auto","important");var n=o.value,r=o.selectionStart,l=o.selectionEnd;o.value=n.substr(0,r)+"\n"+n.substr(l);e.setSelectionRange(o,r+1);o.style.imeMode=""}return!0}if(i&&this._lbx){this._toggleListBox(t);return!0}return!this.finishEditing();case e.Key.Tab:t.preventDefault();return!this.finishEditing();case e.Key.Escape:t.preventDefault();this.finishEditing(!0);return!0;case e.Key.Up:case e.Key.Down:case e.Key.Left:case e.Key.Right:case e.Key.PageUp:case e.Key.PageDown:case e.Key.Home:case e.Key.End:if(this._lbx)return this._keydownListBox(t);if(t.altKey)switch(t.keyCode){case e.Key.Up:case e.Key.Down:this._toggleListBox(t);t.preventDefault();return!0}if(this._fullEdit)switch(t.keyCode){case e.Key.PageUp:case e.Key.PageDown:t.preventDefault()}else if(this.finishEditing())return!1}return!0};_EditHandler.prototype._keydownListBox=function(t){var i=!0;if(this._lbx)switch(t.keyCode){case e.Key.Up:t.altKey?this._toggleListBox(t):this._lbx.selectedIndex>0&&this._lbx.selectedIndex--;break;case e.Key.Down:t.altKey?this._toggleListBox(t):this._lbx.selectedIndex++;break;case e.Key.Home:case e.Key.PageUp:this._lbx.selectedIndex=0;break;case e.Key.End:case e.Key.PageDown:this._lbx.selectedIndex=this._lbx.collectionView.items.length-1;break;default:i=!1}if(i){t.preventDefault();return!0}return!1};_EditHandler.prototype._keypress=function(t){if("AltLeft"!=t.code&&"AltRight"!=t.code){var i=this._edt,o=t.charCode||32,n=this._list;if(i&&"checkbox"!=i.type&&e.getActiveElement()==i&&n&&n.length>0&&o>=32){var r=i.selectionStart,l=i.value.substr(0,r);if(t.target==i&&t.charCode){l+=String.fromCharCode(t.charCode);r++}var s=this._findString(n,l,!0);s<0&&!this._g.caseSensitiveSearch&&(s=this._findString(n,l,!1));if(s>-1){var a=this._lbx;a&&(a.selectedIndex=s);i.value=n[s];e.setSelectionRange(i,r,i.value.length);i.dispatchEvent(this._evtInput);t.preventDefault&&t.preventDefault()}}}else t.preventDefault()};_EditHandler.prototype._findString=function(e,t,i){i||(t=t.toLowerCase());for(var o=0;o<e.length;o++){var n=e[o];if(null!=n){n=n.toString();i||(n=n.toLowerCase());if(0==n.indexOf(t))return o}}return-1};_EditHandler.prototype._toggleListBox=function(e,i){var o=this._g,n=o._selHdl.selection,r=o.isTouching;i||(i=n);if(this._lbx){this._removeListBox();if(n.intersects(i)){o.activeEditor?o.activeEditor.focus():o.containsFocus()||o.focus();return!0}}if(!i.isValid)return!1;var l=o.rows[i.row],s=o._getBindingColumn(o.cells,i.row,o.columns[i.col]),a=l.dataMap||s.dataMap,d=o._getMapEditor(l,s);if(!a||d!=t.DataMapEditor.DropDownList||!t.softInput())return!1;if(null!=s.editor)return!1;if(!i.intersects(o.editRange)&&!this.startEditing(!0,i.row,i.col,!r,e))return!1;var c=this._lbx=this._createListBox();requestAnimationFrame((function(){return c.showSelection()}));r&&c.focus();return!0};_EditHandler.prototype._createListBox=function(){var i=this,o=this._g,n=o.activeEditor,r=this._rng,l=o.rows[r.row],s=o._getBindingColumn(o.cells,r.row,o.columns[r.col]),a=s.isContentHtml||l.isContentHtml,d=s.dataMap||l.dataMap,c=s.dropDownCssClass||l.dropDownCssClass,u=document.createElement("div");this._removeListBox();e.addClass(u,"wj-dropdown-panel wj-grid-listbox");e.addClass(u,c);var h=n?n.value:o.getCellData(r.row,r.col,!0),f=new e.input.ListBox(u,{maxHeight:4*l.renderHeight,isContentHtml:a,itemsSource:d.getDisplayValues(l.dataItem),selectedValue:h});f.addEventListener(u,"keydown",(function(t){switch(t.keyCode){case e.Key.Enter:case e.Key.Escape:i._removeListBox();o.focus()}}));f.addEventListener(u,"click",(function(){i._removeListBox();o.focus();i.finishEditing()}));f.gotFocus.addHandler((function(){f.containsFocus()&&n&&n.focus()}));f.selectedIndexChanged.addHandler((function(){var t=o.activeEditor;if(t){t.value=i._list[f.selectedIndex];t.dispatchEvent(i._evtInput);e.setSelectionRange(t,0,t.value.length)}}));var g=o.cells.getCellElement(r.row,r.col);if(g){e.showPopup(u,g,!1,!1,!1);var p=g.querySelector("."+t.CellFactory._WJC_DROPDOWN);e.setAttribute(p,"aria-expanded",!0)}else{e.showPopup(u,o.getCellBoundingRect(r.row,r.col));u[e.Control._OWNR_KEY]=o.hostElement}return f};_EditHandler.prototype._removeListBox=function(){var t=this._lbx;if(t){this._lbx=null;e.hidePopup(t.hostElement,(function(){t.dispose()}))}};_EditHandler._msgRequired="";return _EditHandler}();t._EditHandler=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){var i=function(){function _CustomEditor(i,o){this._col=e.asType(i,t.Column);this._ctl=o;this._tbx=o.hostElement.querySelector("input");e.assert(this._col instanceof t.Column,"Invalid Column");e.assert(this._ctl instanceof e.Control,"Invalid edit control");e.assert(this._tbx instanceof HTMLInputElement,"Input element not found in editor");var n=this._ctl;this._prop=e.isUndefined(n.value)?e.isUndefined(n.checkedItems)?e.isUndefined(n.text)?null:"text":"checkedItems":"value";e.assert(null!=this._prop,"value, text properties not found in editor");var r=t.softInput();if(r){this._isDropDown=n instanceof r.DropDown;this._isComboBox=n instanceof r.ComboBox;this._isAutoComplete=n instanceof r.AutoComplete;this._isInputDateTime=n instanceof r.InputDateTime;this._isInputMask=n instanceof r.InputMask}this._updateFocusBnd=this._updateFocus.bind(this);this._keypressBnd=this._keypress.bind(this);this._keydownBnd=this._keydown.bind(this);this._cmpstartBnd=this._cmpstart.bind(this);this._mousedownBnd=this._mousedown.bind(this);this._connect();this._col.gridChanged.addHandler(this._connect,this);this._hideEditor();this._updateFocus()}Object.defineProperty(_CustomEditor.prototype,"grid",{get:function(){return this._g},enumerable:!0,configurable:!0});Object.defineProperty(_CustomEditor.prototype,"column",{get:function(){return this._col},enumerable:!0,configurable:!0});Object.defineProperty(_CustomEditor.prototype,"control",{get:function(){return this._ctl},enumerable:!0,configurable:!0});_CustomEditor.prototype.dispose=function(){this._disconnect();this._isDropDown&&(this._isDropDown=!1);this._g=this._col=this._ctl=this._tbx=null};_CustomEditor.prototype._connect=function(){var e=this._col?this._col.grid:null;if(e!=this._g){this._disconnect();if(e){var t=e.hostElement,i=e.addEventListener.bind(e),o=this._updateFocusBnd;this._g=e;i(t,"keydown",this._keydownBnd,!0);i(t,"keypress",this._keypressBnd,!0);i(t,"mousedown",this._mousedownBnd,!0);i(t,"mouseup",o,!0);i(t,"blur",o,!0);i(t,"focus",o);i(this._tbx,"compositionstart",this._cmpstartBnd);e.selectionChanged.addHandler(o,this);e.prepareCellForEdit.addHandler(this._prepareCellForEdit,this);e.cellEditEnding.addHandler(this._cellEditEnding,this);e.cellEditEnded.addHandler(this._cellEditEnded,this)}}};_CustomEditor.prototype._disconnect=function(){var e=this._g;if(e){var t=e.hostElement,i=e.removeEventListener.bind(e),o=this._updateFocusBnd;i(t,"keydown",this._keydownBnd);i(t,"keypress",this._keypressBnd);i(t,"mousedown",this._mousedownBnd);i(t,"mouseup",o);i(t,"blur",o);i(t,"focus",o);i(this._tbx,"compositionstart",this._cmpstartBnd);e.selectionChanged.removeHandler(o,this);e.prepareCellForEdit.removeHandler(this._prepareCellForEdit,this);e.cellEditEnding.removeHandler(this._cellEditEnding,this);e.cellEditEnded.removeHandler(this._cellEditEnded,this);this._g=null}};_CustomEditor.prototype._prepareCellForEdit=function(t,i){if(!i.cancel&&i.getColumn(!0)==this._col){var o=this.grid,n=this._ctl,r=this._tbx,l=this._prop,s=i.range,a=i.data,d=a?a.type:"",c=o.getCellData(s.row,s.col,"text"==l||this._isInputMask),u=!1;if(this._isComboBox){n._oldText="";if(!n.isRequired){n.selectedIndex=-1;r.value=""}this._isInputDateTime&&n._setDropdown(n._ddDate)}if("checkedItems"==l){if(n.showFilterInput){n.showFilterInput=!1;n.showFilterInput=!0}if(null==c||0==c.length){n[l]=[];n.selectedIndex=0}}if(null!=c||!n.isRequired){n[l]=c;if(this._isAutoComplete){clearTimeout(n._toSearch);c&&(n.selectedIndex=n._findNext(c,1,-1))}}switch(d){case"keydown":case"mousedown":if(e.isUndefined(a.keyCode)||a.keyCode==e.Key.F4||a.altKey){u=this._isDropDown;if(this._isAutoComplete&&(null==c||e.isString(c))){var h=n.collectionView;if(h){if(h.filter||n._rxHighlight){n._rxHighlight=null;h.filter=null}n.selectedIndex=c?n._findNext(c,1,-1):-1}}}}o.showPlaceholders&&!n.placeholder&&(r.placeholder=this._col.header);this._showEditor();o._edtHdl._fullEdit=!0;if(0==d.indexOf("key")&&32==a.keyCode){e.setSelectionRange(r,r.value.length);a.preventDefault()}if(e.isIE())if("keypress"==d&&a.key){setTimeout((function(){r.value=a.key;e.setSelectionRange(r,1);var t=document.createEvent("HTMLEvents");t.initEvent("input",!0,!1);r.dispatchEvent(t)}));a.preventDefault()}else if("compositionstart"==d){var f=r.value.length;e.setSelectionRange(r,f)}this._isDropDown&&(n.isDroppedDown=u)}};_CustomEditor.prototype._cellEditEnding=function(t,i){if(!i.cancel&&i.getColumn(!0)==this._col){var o=this.grid,n=this._ctl,r=this._prop;if(this._isAutoComplete){var l=n.selectedIndex;if(e.isNumber(l)&&l<0){var s=n.collectionView;s&&1==s.items.length?n.selectedIndex=0:this._col.isRequired&&(i.cancel=!0)}}!i.cancel&&r&&o._edtHdl._setCustomEditorValue(n[r])}};_CustomEditor.prototype._cellEditEnded=function(e,t){this._hideEditor();this._updateFocus()};_CustomEditor.prototype._cmpstart=function(t){var i=this;e.isIE()?setTimeout((function(){i._activateEditor(t)})):this._activateEditor(t)};_CustomEditor.prototype._keypress=function(e){e.defaultPrevented||this.grid.activeEditor||!this._checkColumn(e.target)||e.ctrlKey||e.altKey||e.metaKey||27==e.keyCode||this._activateEditor(e)};_CustomEditor.prototype._keydown=function(t){if(!t.defaultPrevented&&this._checkColumn(t.target))if(this.grid.activeEditor){if(t.keyCode==e.Key.Enter&&this._isDropDown){var i=this._ctl;if(i.isDroppedDown){i.isDroppedDown=!1;t.preventDefault();t.stopImmediatePropagation()}}}else if(this._isDropDown){var o=t.keyCode;switch(o){case e.Key.F4:case e.Key.Up:case e.Key.Down:if(o==e.Key.F4||t.altKey){this._activateEditor(t);t.preventDefault()}}}};_CustomEditor.prototype._checkColumn=function(t){if(e.contains(t,this._tbx)){var i=this._g,o=i._selHdl.selection;return i._getBindingColumn(i.cells,o.row,i.columns[o.col])==this._col}return!1};_CustomEditor.prototype._mousedown=function(i){if(!i.defaultPrevented&&0==i.button&&!i.shiftKey&&!i.ctrlKey&&!i.metaKey&&this._isDropDown&&e.closestClass(i.target,t.CellFactory._WJC_DROPDOWN)){var o=this.grid,n=o.hitTest(i);if(n.getColumn(!0)==this._col){o.select(n.range);this._activateEditor(i);i.preventDefault()}}};_CustomEditor.prototype._activateEditor=function(e){var t=this.grid;if(!t.activeEditor){var i=t._selHdl.selection;if(i.isValid)return t.startEditing(!0,i.row,i.col,!0,e)}return!1};_CustomEditor.prototype._showEditor=function(){var t=this.grid,i=t.activeEditor,o=e.closest(i,".wj-cell");if(o){var n=this._tbx,r=this._ctl.hostElement;e.setCss(r,_CustomEditor._cssVisible);e.toggleClass(n,"wj-grid-ime",!1);o.innerHTML="";o.appendChild(r);t._edtHdl._edt=n;n.select();n.focus();i.value=""}};_CustomEditor.prototype._hideEditor=function(){var t=this.grid,i=this._ctl.hostElement,o=this._tbx;this._isDropDown&&(this._ctl.isDroppedDown=!1);o.setCustomValidity("");var n=o.value;o.value=n+" ";o.value=n;e.setCss(i,_CustomEditor._cssHidden);e.toggleClass(o,"wj-grid-ime",!0);t&&i.parentElement!=t._root&&t._root.appendChild(i)};_CustomEditor.prototype._updateFocus=function(){var t=this.grid;if(t&&!t.activeEditor){var i=t.hostElement,o=".wj-flexgrid",n=this._tbx,r=e.getActiveElement(),l=t._getTabIndex();if(e.closest(r,o)==i)if(e.closest(n,o)!=i)this._hideEditor();else{var s=t._selHdl.selection,a=t._getBindingColumn(t.cells,s.row,t.columns[s.col]);if(a&&a==this._col&&t.canEditCell(s.row,s.col)){n.tabIndex=l;n.select();n.focus()}else if(n.tabIndex>-1){n.tabIndex=-1;r==n&&t.focus(!0)}}}};_CustomEditor._cssHidden={position:"fixed",left:-32e3,top:-32e3,width:"1px",height:"1px",overflow:"hidden",border:"none"};_CustomEditor._cssVisible={position:"absolute",left:0,top:0,width:"100%",height:"100%"};return _CustomEditor}();t._CustomEditor=i}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i;!function(e){e[e.None=0]="None";e[e.MoveDown=1]="MoveDown";e[e.MoveAcross=2]="MoveAcross";e[e.Cycle=3]="Cycle";e[e.CycleOut=4]="CycleOut";e[e.CycleEditable=5]="CycleEditable"}(i=t.KeyAction||(t.KeyAction={}));var o=function(){function _KeyboardHandler(e){this._kaTab=i.None;this._kaEnter=i.MoveDown;this._g=e;var t=e.hostElement;e.addEventListener(t,"keypress",this._keypress.bind(this));e.addEventListener(t,"keydown",this._keydown.bind(this))}_KeyboardHandler.prototype._keydown=function(i){var o=this._g,n=o._edtHdl,r=o.selection,l=i.ctrlKey||i.metaKey,s=i.shiftKey,a=i.altKey,d=i.target,c=i.char||i.key,u=!0;if(!l&&!a&&c&&1==c.length&&e.closest(d,".wj-cell")&&d.firstElementChild&&(" "!=c||!s)){var h=d.querySelectorAll("."+t.CellFactory._WJC_RADIOMAP+" label input");if(h&&h.length){for(var f=-1,g=0;g<h.length;g++)if(h[g].checked){f=g;break}c=c.toLowerCase();for(g=0;g<h.length;g++){var p=h[(f+g+1)%h.length],_=p.parentElement;if(" "==c||_.textContent[0].toLowerCase()==c){p.click();i.preventDefault();return}}}}if(!o._wantsInput(d)){var m=e.tryCast(o.rows[r.row],t.GroupRow),w=o.editableCollectionView,C=o._getKeyCode(i),v=t.SelMove,y=t.SelectionMode,b=i.defaultPrevented&&!(d instanceof HTMLInputElement);if((o.isRangeValid(r)&&!b||l&&65==C)&&(!o.activeEditor||!n._keydown(i)||o._isNativeCheckbox(o.activeEditor))){if(o.autoClipboard){if(l&&(67==C||45==C)){var R=new t.CellRangeEventArgs(o.cells,r);if(o.onCopying(R)){var E=t.HeadersVisibility,x=0!=(o.copyHeaders&E.Column),S=0!=(o.copyHeaders&E.Row),H=o.getClipString(null,!1,x,S)+"\r\n";o._eFocus.focus();e.Clipboard.copy(H);o.onCopied(R)}i.stopPropagation();return}if(l&&86==C||s&&45==C){o.isReadOnly||e.Clipboard.paste((function(e){o.setClipString(e)}));i.stopPropagation();return}}(s||l)&&"Space"==i.code&&(C=e.Key.Space);switch(C){case e.Key.Space:if(s&&r.isValid)switch(o.selectionMode){case y.CellRange:case y.MultiRange:case y.Row:case y.RowRange:case y.ListBox:o.select(new t.CellRange(r.row,0,r.row,o.columns.length-1),!1)}else if(l&&r.isValid)switch(o.selectionMode){case y.CellRange:case y.MultiRange:o.select(new t.CellRange(0,r.col,o.rows.length-1,r.col),!1)}else{(u=this._startEditing(!0,i))&&setTimeout((function(){var t=o.activeEditor;if(t)if(t.disabled||t.readOnly&&!e.closest(t,".wj-control"))o.finishEditing();else if("checkbox"==t.type){e.setChecked(t,t.indeterminate||!t.checked);o.finishEditing()}}));u=!0}break;case 65:if(l)switch(o.selectionMode){case y.None:case y.Cell:break;default:o.selectAll()}else u=!1;break;case e.Key.Left:l||a?u=!1:r.isValid&&0==r.leftCol&&m&&!m.isCollapsed&&m.hasChildren?m.isCollapsed=!0:this._moveSel(v.None,l?v.Home:v.Prev,s);break;case e.Key.Right:l||i.altKey?u=!1:r.isValid&&0==r.leftCol&&m&&m.isCollapsed?m.isCollapsed=!1:this._moveSel(v.None,l?v.End:v.Next,s);break;case e.Key.Up:l?u=!1:i.altKey&&n._toggleListBox(i)?u=!0:this._moveSel(v.Prev,v.None,s);break;case e.Key.Down:l?u=!1:i.altKey&&n._toggleListBox(i)?u=!0:this._moveSel(v.Next,v.None,s);break;case e.Key.PageUp:this._moveSel(i.altKey?v.Home:v.PrevPage,v.None,s);if(o.rows.frozen&&o.selection.row<o.rows.frozen){var P=o.scrollPosition;P.y&&(o.scrollPosition=new e.Point(P.x,0))}break;case e.Key.PageDown:this._moveSel(i.altKey?v.End:v.NextPage,v.None,s);break;case e.Key.Home:this._moveSel(l?v.Home:v.None,v.Home,s);break;case e.Key.End:this._moveSel(l?v.End:v.None,v.End,s);break;case e.Key.Tab:u=this._performKeyAction(o.keyActionTab,s);break;case e.Key.Enter:u=this._performKeyAction(o.keyActionEnter,s);!s&&w&&null!=w.currentEditItem&&n._commitRowEdits();break;case e.Key.Escape:u=!1;if(w&&(w.currentAddItem||w.currentEditItem)){var M=new t.CellRangeEventArgs(o.cells,o.selection);M.cancel=!0;o.onRowEditEnding(M);w.currentAddItem&&w.cancelNew();w.currentEditItem&&w.cancelEdit();o.onRowEditEnded(M);u=!0}o._mouseHdl.resetMouseState();break;case e.Key.Delete:case e.Key.Back:u=this._deleteSel(i);break;case e.Key.F2:u=this._startEditing(!0,i);break;case e.Key.F4:u=n._toggleListBox(i);break;default:u=!1}if(u){o.containsFocus()||o.focus();i.preventDefault();i.stopPropagation()}}}};_KeyboardHandler.prototype._performKeyAction=function(e,o){var n=i,r=t.SelMove;switch(e){case n.MoveDown:this._moveSel(o?r.Prev:r.Next,r.None,!1);return!0;case n.MoveAcross:this._moveSel(r.None,o?r.Prev:r.Next,!1);return!0;case n.Cycle:this._moveSel(r.None,o?r.PrevCell:r.NextCell,!1);return!0;case n.CycleEditable:this._moveSel(r.None,o?r.PrevEditableCell:r.NextEditableCell,!1);return!0;case n.CycleOut:var l=this._g.selection;this._moveSel(r.None,o?r.PrevCell:r.NextCell,!1);return!l.equals(this._g.selection)}return!1};_KeyboardHandler.prototype._keypress=function(t){var i=this,o=this._g;if(!o._wantsInput(t.target)&&!t.defaultPrevented){var n=o._edtHdl;if(o.activeEditor)n._keypress(t);else if(t.charCode>e.Key.Space&&"AltLeft"!=t.code&&"AltRight"!=t.code)if(this._startEditing(!1,t)&&o.activeEditor){var r=e.getActiveElement();if(r instanceof HTMLInputElement&&"checkbox"!=r.type||r instanceof HTMLTextAreaElement){var l=o._selHdl.selection,s=o.getCellData(l.row,l.col,!0),a=o.getCellData(l.row,l.col,!1),d=e.culture.Globalize.numberFormat["%"]||"%",c=String.fromCharCode(t.charCode),u=e.isNumber(a)&&s.indexOf(d)>-1||""==s&&r.value==d;r.value=u?c+d:c;e.setSelectionRange(r,1);r.dispatchEvent(n._evtInput);n._keypress(t);n._edtValue=r.value!=s?r.value:null;t.preventDefault()}}else if(o.autoSearch){var h=!1;l=o._selHdl.selection;if(t.charCode>32||32==t.charCode&&this._search){t.preventDefault();this._search+=String.fromCharCode(t.charCode);this._toSearch&&clearTimeout(this._toSearch);this._toSearch=setTimeout((function(){i._toSearch=null;i._search=""}),e.Control._SEARCH_DELAY);var f=this._findNext(l.row,l.col);if(f<0&&this._search.length>1){this._search=this._search[this._search.length-1];f=this._findNext(l.row,l.col)}if(f>-1){h=!0;o.select(f,l.col)}}h||(this._search="")}}};_KeyboardHandler.prototype._findNext=function(t,i){var o=this._g,n=o.rows.length;(t<0||1==this._search.length)&&t++;var r=this._search,l=o.caseSensitiveSearch;l||(r=r.toLowerCase());for(var s=o.columns[i].isContentHtml,a=0;a<n;a++){var d=(t+a)%n,c=o.getCellData(d,i,!0).trim();s&&(c=e.toPlainText(c));l||(c=c.toLowerCase());if(0==c.indexOf(r))return d}return-1};_KeyboardHandler.prototype._moveSel=function(e,i,o){var n=this._g;n.selectionMode!=t.SelectionMode.None&&n._selHdl.moveSelection(e,i,o)};_KeyboardHandler.prototype._deleteSel=function(e){var i=this,o=this._g,n=o.rows,r=o.editableCollectionView,l=o.selection,s=[],a=new t.CellRange,d=new t.CellEditEndingEventArgs(o.cells,a,e),c=t.SelectionMode;if(!o._edtHdl._allowEdit())return!1;if(o.allowDelete&&(null==r||r.canRemove&&!r.isAddingNew&&!r.isEditingItem)&&0==(s=n.filter((function(e){return e.isSelected}))).length)switch(o.selectionMode){case c.CellRange:case c.MultiRange:var u=o._getDeleteColumnIndex();o.selectedRanges.forEach((function(e){if(e.leftCol==u&&e.rightCol==o.columns.length-1)for(var t=e.topRow;t>-1&&t<=e.bottomRow;t++){var i=n[t];s.indexOf(i)<0&&s.push(i)}}));break;case c.Row:l.topRow>-1&&s.push(n[l.topRow]);break;case c.RowRange:for(var h=l.topRow;h>-1&&h<=l.bottomRow;h++)s.push(n[h])}if(s.length>0){o.deferUpdate((function(){r&&r.beginUpdate();for(var e=s.length-1;e>=0;e--){var i=s[e];if(!(i instanceof t._NewRowTemplate)){a.setRange(i.index,-1);if(o.onDeletingRow(d)){r&&i.dataItem?r.remove(i.dataItem):o.rows.removeAt(i.index);o.onDeletedRow(d)}}}r&&r.endUpdate(!1)}));var f=l.topRow;f=Math.min(f,o.rows.length-1);for(;f>0&&o.rows[f]instanceof t._NewRowTemplate;)f--;l.row=l.row2=f;o.select(l,!1);o.childItemsPath&&r&&r.refresh();return!0}if(0==s.length){o.deferUpdate((function(){var a=o.scrollPosition,d=-1;s=n.filter((function(e){return e.isSelected}));var u=o.selectedRanges.length>1||s.length>1||l.isValid&&n[l.row].dataItem!=n[l.row2].dataItem;r&&r.beginUpdate();if(s.length){var h=new t.CellRange(0,0,0,o.columns.length-1);s.forEach((function(t){h.row=h.row2=t.index;i._deleteRange(e,h);d=h.bottomRow}))}else{i._deleteRange(e,l);d=l.bottomRow;o.selectionMode==c.MultiRange&&o._selHdl.extendedSelection.forEach((function(t){i._deleteRange(e,t);d=t.bottomRow}))}o.select(l,!1);o.scrollPosition=a;if(r){if(u&&r.currentEditItem){r.commitEdit();var f=new t.CellRangeEventArgs(o.cells,new t.CellRange(d,-1));o.onRowEditEnding(f);o.onRowEditEnded(f)}r.endUpdate(!1)}}));return!0}return!1};_KeyboardHandler.prototype._deleteRange=function(e,i){for(var o=this._g,n=o.editableCollectionView,r=new t.CellRange,l=new t.CellEditEndingEventArgs(o.cells,r,e),s=new t.CellRangeEventArgs(o.cells,new t.CellRange(i.topRow,-1)),a=i.topRow;a<=i.bottomRow;a++){var d=o.rows[a];if(!d.isReadOnly)for(var c=i.leftCol;c<=i.rightCol;c++){var u=o._getBindingColumn(o.cells,a,o.columns[c]);if(!u.getIsRequired(d)&&!u.isReadOnly&&o.getCellData(a,c,!0)){r.setRange(a,c);l.cancel=!1;if(o.onBeginningEdit(l)){var h=d.dataItem,f=n?n.currentEditItem:null;if(f&&h!=f){o.onRowEditEnding(s);o.onRowEditEnded(s)}if(h!=f){s._rng.setRange(a,-1);o.onRowEditStarting(s);o.onRowEditStarted(s)}if(n){n.editItem(h);o._edtHdl._edItem=h}o.setCellData(a,c,"",!0,!1);o.onCellEditEnding(l);o.onCellEditEnded(l)}}}}};_KeyboardHandler.prototype._startEditing=function(e,t,i,o){return this._g._edtHdl.startEditing(e,i,o,!0,t)};return _KeyboardHandler}();t._KeyboardHandler=o}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i,o,n="wj-flexgrid";!function(e){e[e.None=0]="None";e[e.Columns=1]="Columns";e[e.Rows=2]="Rows";e[e.Both=3]="Both";e[e.ColumnsAllCells=4|e.Columns]="ColumnsAllCells";e[e.RowsAllCells=4|e.Rows]="RowsAllCells";e[e.BothAllCells=4|e.Both]="BothAllCells"}(i=t.AllowResizing||(t.AllowResizing={}));!function(e){e[e.None=0]="None";e[e.Headers=1]="Headers";e[e.Cells=2]="Cells";e[e.Both=3]="Both"}(t.AutoSizeMode||(t.AutoSizeMode={}));!function(e){e[e.None=0]="None";e[e.Columns=1]="Columns";e[e.Rows=2]="Rows";e[e.Both=3]="Both"}(o=t.AllowDragging||(t.AllowDragging={}));var r=function(){function _MouseHandler(i){var o=this,r=i.hostElement,l=i.addEventListener.bind(i),s=i.removeEventListener.bind(i);this._g=i;this._dvMarker=e.createElement('<div class="wj-marker">&nbsp;</div>');l(r,"mousedown",(function(r){i._rcBounds=null;if(!r.defaultPrevented&&0==r.button){var a=r.target;if(!i.containsFocus()){var d=a instanceof HTMLElement&&a.tabIndex>-1?a:i._eFocus;i._setFocusNoScroll(d)}setTimeout((function(){r.defaultPrevented||i.focus()}));var c=e.closestClass(a,n);if(c&&c!=i.hostElement||!i.activeEditor&&i._isInputElement(a)&&!o._hasRadioMap(r)&&!i._isNativeCheckbox(a)){var u=i.hitTest(r),h=t.CellType;switch(u.cellType){case h.Cell:i.select(u.range,!1);a instanceof HTMLElement&&"root"!=a.getAttribute("wj-part")&&a.focus();break;case h.ColumnHeader:case h.ColumnFooter:i.scrollIntoView(-1,u.col);break;case h.RowHeader:i.scrollIntoView(u.row,-1)}e.isIE()&&u.cellType!=h.Cell&&i._isInputElement(a)&&a.focus();return}var f=document;s(f,"mousemove");s(f,"mouseup");l(f,"mousemove",mouseMove);l(f,"mouseup",mouseUp);o._isDown=!0;o._mousedown(r)}}));var mouseMove=function(e){o._mousemove(e)},mouseUp=function(e){o._isDown=!1;s(document,"mousemove");s(document,"mouseup");o._mouseup(e)};l(r,"mouseenter",(function(e){i._rcBounds=null}));l(r,"mousemove",this._hover.bind(this));l(r,"dblclick",this._dblclick.bind(this));l(r,"click",this._click.bind(this));l(r,"selectstart",(function(e){i._isInputElement(e.target)||e.preventDefault()}));l(r,"wheel",(function(t){if(!t.defaultPrevented&&t.deltaY&&!t.ctrlKey&&!t.metaKey){var o=i._root,r=t.deltaY;if((t.shiftKey?o.scrollWidth>o.clientWidth:o.scrollHeight>o.clientHeight)&&e.closestClass(t.target,n)==i.hostElement){switch(t.deltaMode){case 1:r=i.rows.defaultSize*(r<0?-1:1);break;case 2:r=(t.shiftKey?o.clientWidth:o.clientHeight)*(r<0?-1:1);break;case 0:default:e.isSafari()&&(r=e.clamp(r,-150,150))}i.containsFocus()||i._eFocus.focus();i.finishEditing(!1)&&(t.shiftKey?o.scrollLeft+=r:o.scrollTop+=r);t.preventDefault();t.stopImmediatePropagation()}}}));l(r,"dragstart",this._dragstart.bind(this));l(r,"dragover",this._dragover.bind(this));l(r,"dragleave",this._dragover.bind(this));l(r,"drop",this._drop.bind(this));l(r,"dragend",this._dragend.bind(this))}_MouseHandler.prototype.resetMouseState=function(){var t=this._g,i=t.hostElement;if(this._updating){this._updating=!1;t.endUpdate()}this._dragSrc&&e.removeClass(this._dragSrc,"wj-state-dragsrc");this._showDragMarker(null);i&&(i.style.cursor="");e.isSafari()&&this._szRowCol&&t.invalidate();t.removeEventListener(document,"mousemove");t.removeEventListener(document,"mouseup");this._eMouse=null;this._isDown=null;this._htDown=null;this._lbSelState=null;this._szRowCol=null;this._szArgs=null;t._rcBounds=null};_MouseHandler.prototype._mousedown=function(n){var r=this._g,l=n.target,s=r.hitTest(n),a=s.cellType,d=t.CellType,c=n.ctrlKey||n.metaKey;this._selDown=r.selection;this._ignoreClick=!1;if(s.panel==r.cells){if(e.closestClass(l,t.CellFactory._WJC_DROPDOWN)){var u=r.hitTest(l);r._edtHdl._toggleListBox(n,u.range);n.preventDefault();this._ignoreClick=!0;return}var h=r.editRange;if(h&&h.contains(s.range))return}var f=e.getActiveElement();if(l!=f||!r._isInputElement(l))if(a!=d.None){this._htDown=s;this._eMouse=n;if(null==this._szRowCol){var g=r.allowResizing,p=i;if((a==d.RowHeader||a==d.TopLeft)&&s.edgeBottom&&g&p.Rows&&this._getResizeRowHt(s))this._ignoreClick=!0;else if((a==d.ColumnHeader||a==d.TopLeft)&&s.edgeRight&&g&p.Columns&&this._getResizeColHt(s))this._ignoreClick=!0;else{var _=r.allowDragging,m=o;switch(a){case d.Cell:case d.RowHeader:if(c&&r.selectionMode==t.SelectionMode.ListBox){this._lbSelState=r.rows[s.row].isSelected;e.closest(l,".wj-elem-collapse")&&(this._lbSelState=!1)}this._mouseSelect(n,n.shiftKey);if(a==d.RowHeader&&!(_&m.Rows)){n.preventDefault();r.focus()}break;case d.ColumnHeader:r.allowSorting||_&m.Columns||e.closest(l,"button")||this._mouseSelect(n,n.shiftKey)}}}else{var w=r._eFocus;if(f!=w){w.tabIndex=0;w.focus()}this._ignoreClick=!0;this._handleResizing(n)}}else{r.finishEditing();l!=r._root&&l!=r._fCt&&r._edtHdl._commitRowEdits()}};_MouseHandler.prototype._mousemove=function(e){if(this._htDown&&!e.defaultPrevented){if(0==e.buttons&&this._eMouse&&e.timeStamp-this._eMouse.timeStamp>600){this.resetMouseState();return}this._eMouse=e;if(this._szRowCol)this._handleResizing(e);else{var i=this._g,n=i.allowDragging,r=o,l=t.CellType;switch(this._htDown.cellType){case l.Cell:this._mouseSelect(e,!0);break;case l.RowHeader:n&r.Rows||this._mouseSelect(e,!0);break;case l.ColumnHeader:n&r.Columns||i.allowSorting||this._mouseSelect(e,!0)}}}};_MouseHandler.prototype._mouseup=function(e){var i=this._g;if(!i.isTouching||!(this._dragSrc||e.target instanceof HTMLHtmlElement)){var o=i.hitTest(e),n=this._htDown;if(n&&!e.defaultPrevented){this._szArgs&&this._finishResizing(e);if(!this._szArgs&&o.panel==n.panel&&o.row==n.row&&o.col==n.col){var r=o.getColumn();if(r){if(!(r._getFlag(t.RowColFlags.HasTemplate)&&!r.cellTemplate)){var l=o.target;if(l!=n.target&&l instanceof HTMLElement){if(n.target instanceof HTMLInputElement){var s=o.point,a=n.point;Math.abs(s.x-a.x)+Math.abs(s.y-a.y)<10&&(l=l.querySelector("input")||l)}var d=document.createEvent("Event");d.initEvent("click",!0,!0);for(var c in e)/Key$|X$|Y$|^button|^(x|y|which)$/.test(c)&&(d[c]=e[c]);l.dispatchEvent(d)}}}}}this.resetMouseState()}};_MouseHandler.prototype._click=function(i){if(this._ignoreClick){this._ignoreClick=!1;i.preventDefault()}if(!i.defaultPrevented){var o=this._g,n=i.target,r=o.hitTest(n),l=e.tryCast(n,HTMLInputElement),s="input."+t.CellFactory._WJC_CHECKBOX;if(!l){var a=e.closest(n,"label");a&&(l=a.querySelector(s))}!l&&o.bigCheckboxes&&(l=n.querySelector(s));if(l!=o.activeEditor&&o._isNativeCheckbox(l)){if(r.panel==o.cells){var d=o.getCellData(r.row,r.col,!1);if(o.startEditing(!1,r.row,r.col,!1,i)){o.activeEditor.checked=!d;o.finishEditing();o.focus()}else l.checked=d}return}if(this._hasRadioMap(i)){this._handleClick(i);return}if(o.rows.maxGroupLevel>-1&&e.closestClass(n,t.CellFactory._WJC_COLLAPSE)){var c=o.rows[r.row];if(r.panel==o.cells&&c instanceof t.GroupRow){i.ctrlKey||i.metaKey?o.collapseGroupsToLevel(c.isCollapsed?c.level+1:c.level):c.isCollapsed=!c.isCollapsed;return}}if(!(i.ctrlKey||i.metaKey||i.shiftKey||o.activeEditor)&&r.panel==o.cells){var u=o._selHdl.selection;if(u.equals(this._selDown)&&r.range.contains(u)){o.startEditing(!0,null,null,!0,i);return}}this._handleClick(i)}};_MouseHandler.prototype._handleClick=function(i){var o=this._g,n=i.target,r=o.hitTest(n),l=r.panel;if(!i.defaultPrevented&&r.grid==o){if(l==o.cells&&this._hasRadioMap(i)){var s=e.closest(n,"label"),a=s&&s.querySelector("input");if(a&&!a.disabled&&o.startEditing(!1,r.row,r.col,!1)){o.setCellData(r.row,r.col,s.textContent,!0,o.refreshOnEdit);o.finishEditing()}return}if(!o._isInputElement(n)){if(l==o.topLeftCells){var d=t.SelectionMode;switch(o.selectionMode){case d.None:case d.Cell:break;default:o.selectAll()}return}if(l==o.columnHeaders){if(o.allowPinning&&e.closestClass(n,t.CellFactory._WJC_PIN))this._clickPin(i,r);else if(e.closestClass(i.target,t.CellFactory._WJC_COLLAPSE)){if(g=o._getColumnGroup(r.row,r.col))if(i.ctrlKey||i.metaKey){for(var c=g.isCollapsed,u=g.level,h=[],f=0;f<o.columns.length;f++)if((g=o._getColumnGroup(r.row,f))&&g.collapseTo&&g.level==u&&h.indexOf(g)<0){h.push(g);g.isCollapsed=!c}}else g.isCollapsed=!g.isCollapsed}else{n instanceof HTMLSpanElement&&n.parentElement instanceof HTMLLabelElement&&(n=n.parentElement.querySelector("input"));n instanceof HTMLInputElement||this._clickSort(i,r);o.focus()}return}if(l==o.rowHeaders){if(e.closestClass(i.target,t.CellFactory._WJC_COLLAPSE)){var g;if(g=o._getColumnGroup(r.row,r.col))if(i.ctrlKey||i.metaKey){c=g.isCollapsed,u=g.level,h=[];for(var p=0;p<o.rows.length;p++)if((g=o._getColumnGroup(p,r.col))&&g.collapseTo&&g.level==u&&h.indexOf(g)<0){h.push(g);g.isCollapsed=!c}}else g.isCollapsed=!g.isCollapsed}return}if(l==o.cells){if(r.row<0){this._clickSort(i,r);return}if(e.closestClass(n,t.CellFactory._WJC_COLLAPSE)){var _=o.rows[r.row];_ instanceof t.GroupRow&&(i.ctrlKey?o.collapseGroupsToLevel(_.isCollapsed?_.level+1:_.level):_.isCollapsed=!_.isCollapsed);return}e.closestClass(n,t.CellFactory._WJC_DROPDOWN)&&o._edtHdl._toggleListBox(i,r.range)}}}};_MouseHandler.prototype._hasRadioMap=function(i){var o=i.target;if(e.closest(o,"label")){var r=e.closestClass(o,t.CellFactory._WJC_RADIOMAP);return e.closestClass(r,n)==this._g.hostElement}return!1};_MouseHandler.prototype._clickSort=function(i,o){var n=this._g,r=n.allowSorting,l=n.collectionView,s=l?l.sortDescriptions:null,a=i.ctrlKey||i.metaKey,d=i.shiftKey;if(l&&l.canSort&&r!=t.AllowSorting.None){var c=o.panel.columns[o.col],u=n._getBindingColumn(o.panel,o.row,c),h=u?u._getBindingSort():null;if(u.allowSorting&&h){if(c==u){var f=n.getMergedRange(o.panel,o.row,o.col,!1);if(f&&f.columnSpan>1)return}var g=new t.CellRangeEventArgs(o.panel,o.range,i);if(n.onSortingColumn(g)){n._edtHdl._commitRowEdits();for(var p=-1,_=null,m=0;m<s.length;m++)if(s[m].property==h){p=m;_=s[m];break}s.deferUpdate((function(){if(a&&d)s.clear();else if(_){var i=a;!i&&n.isTouching&&(i=0==_.ascending);i?s.removeAt(p):s[p]=new e.collections.SortDescription(h,!_.ascending)}else{r!=t.AllowSorting.MultiColumn&&s.clear();var o=new e.collections.SortDescription(h,!0);s.push(o)}}));n.onSortedColumn(g)}}}};_MouseHandler.prototype._clickPin=function(e,i){var o=this._g,n=o.columns,r=n.frozen,l=o.allowPinning;l==t.AllowPinning.Both&&(l=e.shiftKey?t.AllowPinning.ColumnRange:t.AllowPinning.SingleColumn);var s=new t.CellRangeEventArgs(o.cells,i.range);if(o.onPinningColumn(s)){if(l==t.AllowPinning.SingleColumn)if(i.col>=r){n.moveElement(i.col,r,!1);n.frozen++}else{n.moveElement(i.col,r-1,!1);n.frozen--}l==t.AllowPinning.ColumnRange&&(i.col+1!=r?n.frozen=i.col+1:n.frozen=0);o.onPinnedColumn(s)}};_MouseHandler.prototype._dblclick=function(e){if(!e.defaultPrevented){var o,n=this._g,r=n.hitTest(e),l=r.range,s=r.cellType,a=t.CellType,d=n.selection,c=n.allowResizing,u=i;if(r.edgeRight&&c&u.Columns){if(s==a.TopLeft){if(r.panel.columns[r.col].allowResizing){o=new t.CellRangeEventArgs(r.panel,new t.CellRange(-1,r.col));if(n.onAutoSizingColumn(o)&&n.onResizingColumn(o)){this._ignoreClick=!0;n.autoSizeColumn(r.col,!0);n.onAutoSizedColumn(o);n.onResizedColumn(o);e.preventDefault()}}}else if(s==a.ColumnHeader||4&c){s==a.ColumnHeader&&e.ctrlKey&&d.containsColumn(r.col)&&(l=d);for(var h=s==a.RowHeader||s==a.BottomLeft,f=l.leftCol;f<=l.rightCol;f++)if(r.panel.columns[f].allowResizing){o=new t.CellRangeEventArgs(r.panel,new t.CellRange(-1,f));if(n.onAutoSizingColumn(o)&&n.onResizingColumn(o)){this._ignoreClick=!0;n.autoSizeColumn(f,h);n.onResizedColumn(o);n.onAutoSizedColumn(o);e.preventDefault()}}}this.resetMouseState()}else if(r.edgeBottom&&c&u.Rows){if(s==a.TopLeft||s==a.BottomLeft){if(r.getRow().allowResizing){h=s==a.TopLeft||null;o=new t.CellRangeEventArgs(r.panel,new t.CellRange(r.row,-1));if(n.onAutoSizingRow(o)&&n.onResizingRow(o)){this._ignoreClick=!0;n.autoSizeRow(r.row,h);n.onResizedRow(o);n.onAutoSizedRow(o);e.preventDefault()}}}else if(s==a.RowHeader||4&c){var g=r.panel;h=g==n.columnHeaders||g==n.columnFooters&&null;e.ctrlKey&&d.containsRow(r.row)&&g==n.cells&&(l=d);for(var p=l.topRow;p<=l.bottomRow;p++)if(g.rows[p].allowResizing){o=new t.CellRangeEventArgs(g,new t.CellRange(p,-1));if(n.onAutoSizingRow(o)&&n.onResizingRow(o)){this._ignoreClick=!0;n.autoSizeRow(p,h);n.onResizedRow(o);n.onAutoSizedRow(o);e.preventDefault()}}}this.resetMouseState()}else;}};_MouseHandler.prototype._hover=function(e){if(!this._isDown){var i=this._g,o=i.hitTest(e),n="";this._szRowCol=this._getResizeColHt(o)||this._getResizeRowHt(o);this._szRowCol instanceof t.Column?n="col-resize":this._szRowCol instanceof t.Row&&(n="row-resize");this._szStart=this._szRowCol?this._szRowCol.renderSize:0;i.hostElement.style.cursor=n;return o}return null};_MouseHandler.prototype._getResizeColHt=function(e){var o,n=this._g.allowResizing,r=e.cellType,l=t.CellType;if(n&i.Columns&&(r==l.ColumnHeader||r==l.TopLeft||4&n)){e.edgeRight&&(o=e.getColumn());e.edgeFarRight&&(o=this._getResizeCol(e.panel,e.col)||e.getColumn());e.edgeLeft&&(o=this._getResizeCol(e.panel,e.col,!0))}return o&&o.allowResizing?o:null};_MouseHandler.prototype._getResizeRowHt=function(e){var o,n=this._g.allowResizing,r=e.cellType,l=t.CellType;if(n&i.Rows&&(r==l.RowHeader||r==l.TopLeft||4&n)){e.edgeBottom&&(o=e.getRow());e.edgeFarBottom&&(o=this._getResizeRow(e.panel,e.row)||e.getRow());e.edgeTop&&(o=this._getResizeRow(e.panel,e.row,!0))}return o&&o.allowResizing?o:null};_MouseHandler.prototype._getResizeCol=function(e,i,o){void 0===o&&(o=!1);var n=this._g,r=e.columns;if(o){for(var l=i-1;l>=0;l--){if((s=r[l]).isVisible)return this._asResizable(s)}if(r==n.columns&&0!=(n.headersVisibility&t.HeadersVisibility.Row))for(l=(r=n.rowHeaders.columns).length-1;l>=0;l--){if((s=r[l]).isVisible)return this._asResizable(s)}return null}for(l=i+1;l<r.length;l++){if((s=r[l]).isVisible)return this._asResizable(s)}if(i==r.length-1&&r==n.rowHeaders.columns){r=n.columns;for(l=0;l<r.length;l++){var s;if((s=r[l]).isVisible)return this._asResizable(s)}}return null};_MouseHandler.prototype._getResizeRow=function(e,i,o){void 0===o&&(o=!1);var n=this._g,r=e.rows;if(o){for(var l=i-1;l>=0;l--){if((s=r[l]).isVisible)return this._asResizable(s)}if(r==n.rows&&0!=(n.headersVisibility&t.HeadersVisibility.Column))for(l=(r=n.columnHeaders.rows).length-1;l>=0;l--){if((s=r[l]).isVisible)return this._asResizable(s)}return null}for(l=i+1;l<r.length;l++){if((s=r[l]).isVisible)return this._asResizable(s)}if(i==r.length-1&&r==n.columnHeaders.rows){r=n.rows;for(l=0;l<r.length;l++){var s;if((s=r[l]).isVisible)return this._asResizable(s)}}return null};_MouseHandler.prototype._asResizable=function(e){return 0==e.renderSize&&e.allowResizing?e:null};_MouseHandler.prototype._mouseSelect=function(i,o){var n=this,r=this._g;if(i&&this._htDown&&this._htDown.panel&&r.selectionMode!=t.SelectionMode.None){var l=new t.HitTestInfo(this._htDown.panel,i);this._handleSelection(l,o);!e.isIE9()&&i.button>=0&&i.target!=r._root&&((l=new t.HitTestInfo(r,i)).panel||setTimeout((function(){n._isDown&&n._eMouse&&n._mouseSelect(n._eMouse,o)}),100))}};_MouseHandler.prototype._handleResizing=function(i){"mousedown"==i.type&&(e.isSafari()?e.setAttribute(i.target,"draggable",null):i.preventDefault());var o=this._szRowCol;if(o instanceof t.Column){var n=this._g,r=e.mouseToPage(i).x,l=Math.round(Math.max(_MouseHandler._SZ_MIN,this._szStart+(r-this._htDown.point.x)*(n.rightToLeft?-1:1)));if(o.renderSize!=l){if(null==this._szArgs){var s=n.rowHeaders.columns.indexOf(o)>-1?n.rowHeaders:n.cells;this._szArgs=new t.CellRangeEventArgs(s,new t.CellRange(-1,o.index))}this._szArgs.cancel=!1;n.onResizingColumn(this._szArgs)&&(n.deferResizing?this._showResizeMarker(l):o.width=l)}}var a=this._szRowCol;if(a instanceof t.Row){n=this._g;var d=e.mouseToPage(i).y;l=Math.round(Math.max(_MouseHandler._SZ_MIN,this._szStart+(d-this._htDown.point.y)));if(a.renderSize!=l){if(null==this._szArgs){s=n.columnHeaders.rows.indexOf(a)>-1?n.columnHeaders:n.columnFooters.rows.indexOf(a)>-1?n.columnFooters:n.cells;this._szArgs=new t.CellRangeEventArgs(s,new t.CellRange(a.index,-1))}this._szArgs.cancel=!1;n.onResizingRow(this._szArgs)&&(n.deferResizing?this._showResizeMarker(l):a.height=l)}}this._szArgs&&i.preventDefault()};_MouseHandler.prototype._dragstart=function(i){var n=this._g,r=this._htDown,l=o,s=t.CellType;if(r){this._dragSrc=null;this._htDrag=null;if(!this._szRowCol){var a=new t.CellRangeEventArgs(r.panel,r.range),d=n.allowDragging,c=r.cellType,u=r.panel.rows,h=r.panel.columns;r.col>-1&&h[r.col].allowDragging&&(c==s.ColumnHeader||c==s.TopLeft)&&d&l.Columns&&(n.onDraggingColumn(a)?this._dragSrc=i.target:i.preventDefault());if(!this._dragSrc&&r.row>-1&&u[r.row].allowDragging){var f=u[r.row];f instanceof t.GroupRow||f instanceof t._NewRowTemplate||c==s.RowHeader&&d&l.Rows&&(n.onDraggingRow(a)?this._dragSrc=i.target:i.preventDefault())}}if(this._dragSrc&&i.dataTransfer&&!i.defaultPrevented){this._htDrag=r;e._startDrag(i.dataTransfer,"move");i.stopPropagation();e.addClass(this._dragSrc,"wj-state-dragsrc");n.beginUpdate();this._updating=!0}}};_MouseHandler.prototype._dragend=function(e){this._dragSrc=null;this._htDrag=null;this.resetMouseState()};_MouseHandler.prototype._dragover=function(i){var o=this._g,n=this._hitTest(i),r=this._dragSrc?this._htDrag:null,l=t.CellType,s=!1;if(r&&n.cellType==r.cellType){var a=new t.CellRangeEventArgs(n.panel,n.range,r);if(n.cellType==l.ColumnHeader){a.cancel=!o.columns.canMoveElement(r.col,n.col);s=o.onDraggingColumnOver(a)}else if(n.cellType==l.RowHeader){a.cancel=!o.rows.canMoveElement(r.row,n.row);s=o.onDraggingRowOver(a)}else if(n.cellType==l.TopLeft){a.cancel=!o.topLeftCells.columns.canMoveElement(r.col,n.col);s=o.onDraggingColumnOver(a)}}if(s){i.dataTransfer.dropEffect="move";i.preventDefault();i.stopPropagation();this._showDragMarker(n)}else this._showDragMarker(null);if(r&&o.autoScroll){var d=o.controlRect,c=o.scrollPosition,u=e.Control._DRAG_SCROLL_EDGE,h=e.Control._DRAG_SCROLL_STEP;if(r.panel==o.columnHeaders){i.pageX-d.left<u&&(c.x+=h);d.right-i.pageX<u&&(c.x-=h)}else if(r.panel==o.rowHeaders){i.pageY-d.top<u&&(c.y+=h);d.bottom-i.pageY<u&&(c.y-=h)}if(!c.equals(o._ptScrl)){o.scrollPosition=c;o._rcBounds=null}}};_MouseHandler.prototype._drop=function(e){var i=this._g,o=this._hitTest(e),n=this._dragSrc?this._htDrag:null,r=t.CellType;if(n&&o.cellType==n.cellType){var l=i.selection,s=new t.CellRangeEventArgs(o.panel,o.range,n);if(o.cellType==r.ColumnHeader){i.columns.moveElement(n.col,o.col);i.select(l.row,o.col);i.onDraggedColumn(s)}else if(o.cellType==r.RowHeader){i.rows.moveElement(n.row,o.row);i.select(o.row,l.col);i.onDraggedRow(s)}else if(o.cellType==r.TopLeft){i.topLeftCells.columns.moveElement(n.col,o.col);i.onDraggedColumn(s)}}this.resetMouseState()};_MouseHandler.prototype._hitTest=function(e){var t=this._g;t._rcBounds=null;return t.hitTest(e)};_MouseHandler.prototype._showResizeMarker=function(i){var o,n=this._g,r=n._ptScrl,l=this._szArgs.panel.cellType,s=t.CellType,a=this._dvMarker,d=n.cells.hostElement;a.parentElement!=d&&d.appendChild(a);if(this._szRowCol instanceof t.Column){o={left:this._szRowCol.pos+i-1,top:-1e3,right:"",bottom:0,width:3,height:""};l!=s.TopLeft&&l!=s.RowHeader||(o.left-=n._eTL.offsetWidth+r.x);l==s.Cell&&this._szRowCol.index<n.frozenColumns&&(o.left-=r.x);n.rightToLeft&&(o.left=d.clientWidth-o.left-o.width)}else{o={left:-1e3,top:this._szRowCol.pos+i-1,right:0,bottom:"",width:"",height:3};l!=s.TopLeft&&l!=s.ColumnHeader||(o.top-=n._eTL.offsetHeight+r.y);l==s.Cell&&this._szRowCol.index<n.frozenRows&&(o.top-=r.y)}e.setCss(a,o)};_MouseHandler.prototype._showDragMarker=function(i){var o=this._dvMarker;if(i&&i.panel){if(!i.range.equals(this._rngTarget)){this._rngTarget=i.range;var n=i.panel.hostElement;o.parentElement!=n&&n.appendChild(o);var r=this._g,l=r._ptScrl,s=t.CellType,a={left:0,top:0,width:6,height:6,right:"",bottom:""};switch(i.cellType){case s.TopLeft:case s.ColumnHeader:var d=i.panel.columns[i.col];a.left=d.pos-a.width/2;a.height=i.panel.height;this._htDown&&i.col>this._htDown.col&&(a.left+=d.renderWidth);i.cellType==s.ColumnHeader&&i.col<r.frozenColumns&&(a.left-=l.x);r.rightToLeft&&(a.left=o.parentElement.clientWidth-a.left-a.width);break;case s.RowHeader:var c=i.getRow();a.top=c.pos-a.height/2;a.width=i.panel.width;i.row>this._htDown.row&&(a.top+=c.renderHeight);i.row<r.frozenRows&&(a.top-=l.y)}e.setCss(o,a)}}else{e.removeChild(o);this._rngTarget=null}};_MouseHandler.prototype._finishResizing=function(i){var o=this._g,n=o.selection,r=this._szArgs,l=this._eMouse&&this._eMouse.ctrlKey,s=t.CellType;if(r&&!r.cancel){if(r.col>-1){var a=r.col,d=e.mouseToPage(i).x,c=Math.round(Math.max(_MouseHandler._SZ_MIN,this._szStart+(d-this._htDown.point.x)*(this._g.rightToLeft?-1:1)));r.panel.columns[a].width=Math.round(c);o.onResizedColumn(r);if(l&&this._htDown.cellType==s.ColumnHeader&&n.containsColumn(a))for(var u=n.leftCol;u<=n.rightCol;u++)if(o.columns[u].allowResizing&&u!=a){r=new t.CellRangeEventArgs(o.cells,new t.CellRange(-1,u));if(o.onResizingColumn(r)){o.columns[u].size=o.columns[a].size;o.onResizedColumn(r)}}i.preventDefault()}if(r.row>-1){var h=r.row,f=e.mouseToPage(i).y;c=Math.round(Math.max(_MouseHandler._SZ_MIN,this._szStart+(f-this._htDown.point.y)));r.getRow().height=Math.round(c);o.onResizedRow(r);if(l&&this._htDown.cellType==s.RowHeader&&n.containsRow(h))for(var g=n.topRow;g<=n.bottomRow;g++)if(o.rows[g].allowResizing&&g!=h){r=new t.CellRangeEventArgs(o.cells,new t.CellRange(g,-1));if(o.onResizingRow(r)){o.rows[g].size=o.rows[h].size;o.onResizedRow(r)}}i.preventDefault()}}};_MouseHandler.prototype._handleSelection=function(i,o){var n=this._g,r=n._selHdl.selection,l=new t.CellRange(i.row,i.col),s=t.CellType,a=t.SelectionMode;if(l.isValid)if(null==this._lbSelState){switch(i.cellType){case s.RowHeader:l.col=0;l.col2=n.columns.length-1;break;case s.ColumnHeader:switch(n.selectionMode){case a.Row:case a.Cell:l.row=l.row2=r.row;o=!1;break;default:l.row=0;l.row2=n.rows.length-1}}if(o){if(n.anchorCursor){l.row=r.row;l.col=r.col}else{l.row2=r.row2;l.col2=r.col2}if(!l.isValid){var d=this._htDown;d&&(l=new t.CellRange(d.row,d.col))}}if(n.selectionMode==t.SelectionMode.MultiRange){var c=n._mouseHdl._eMouse,u=c&&(c.ctrlKey||c.metaKey),h=n._selHdl,f=h.selection,g=h.extendedSelection,p=i.panel!=n.cells;e.closest(c.target,".wj-elem-collapse")&&(u=!1);if(u){if(!o&&h._deselectRange(l))h.selection.isValid&&(l=null);else if(f.isValid&&(p||!f.intersects(l))){(p?this._splitRange(f):[f.clone()]).forEach((function(e){for(var t=!1,i=0;i<g.length&&!t;i++)g[i].equals(e)&&(t=!0);t||g.push(e)}))}}else g.clear()}if(l){n.select(l,!1);switch(i.cellType){case s.RowHeader:n.scrollIntoView(i.row,-1);break;case s.ColumnHeader:n.scrollIntoView(-1,i.col);break;default:n.scrollIntoView(i.row,i.col)}}else{var _=new t.CellRangeEventArgs(n.cells,new t.CellRange(i.row,i.col));n.onSelectionChanging(_);n.onSelectionChanged(_);n.invalidate()}}else{n.rows[i.row].isSelected=!this._lbSelState;n.scrollIntoView(i.row,i.col)}};_MouseHandler.prototype._splitRange=function(e){var i=this._g,o=i.columns.length,n=i.rows.length,r=[];if(e.columnSpan==o)for(var l=e.topRow;l<=e.bottomRow;l++)r.push(new t.CellRange(l,0,l,o-1));else if(e.rowSpan==n)for(var s=e.leftCol;s<=e.rightCol;s++)r.push(new t.CellRange(0,s,n-1,s));else r.push(e.clone());return r};_MouseHandler._SZ_MIN=0;return _MouseHandler}();t._MouseHandler=r}(e.grid||(e.grid={}))}(wijmo||(wijmo={}));!function(e){e.grid||(e.grid={}),e._registerModule("wijmo.grid",e.grid)}(wijmo||(wijmo={}));
/*!
    *
    * Wijmo Library 5.20211.781
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */

var wijmo,__extends=this&&this.__extends||function(){var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(e,t)};return function(e,t){extendStatics(e,t);function __(){this.constructor=e}e.prototype=null===t?Object.create(t):(__.prototype=t.prototype,new __)}}();!function(e){!function(t){"use strict";e._addCultureInfo("InputNumber",{ariaLabels:{incVal:"Increase Value",decVal:"Decrease Value"}});var i=function(t){__extends(InputNumber,t);function InputNumber(i,n){var o=t.call(this,i)||this;o._value=null;o._min=null;o._max=null;o._format="";o._step=null;o._showBtn=!0;o._readOnly=!1;o._handleWheel=!0;o._oldText="";o.textChanged=new e.Event;o.valueChanged=new e.Event;var s=o.hostElement;e.setAttribute(s,"role","spinbutton",!0);var r=o.getTemplate();o.applyTemplate("wj-control wj-content wj-inputnumber",r,{_tbx:"input",_btnUp:"btn-inc",_btnDn:"btn-dec"},"input");var a=e.culture.InputNumber.ariaLabels;e.setAriaLabel(o._btnUp.querySelector("button"),a.incVal);e.setAriaLabel(o._btnDn.querySelector("button"),a.decVal);o._tbx.type.match(/number/i)&&(o.inputType="");var l=o._tbx;l.autocomplete="off";l.spellcheck=!1;o._updateSymbols();var h=o.addEventListener.bind(o);h(l,"keypress",o._keypress.bind(o));h(l,"keydown",o._keydown.bind(o));h(l,"input",o._input.bind(o));h(l,"blur",(function(){o.text!=o._oldText&&o._setText(o.text)}));h(l,"compositionstart",(function(){o._composing=!0}));h(l,"compositionend",(function(){o._composing=!1;setTimeout((function(){var e=o.text,t=o._oldText,i=o._chrPct;t&&t.indexOf(i)>-1&&e.indexOf(i)<0&&(e+=i);o._setText(e)}))}));var u=o._clickSpinner.bind(o);h(o._btnUp,"click",u);h(o._btnDn,"click",u);o._rptUp=new e._ClickRepeater(o._btnUp.querySelector("button"));o._rptDn=new e._ClickRepeater(o._btnDn.querySelector("button"));h(l,"wheel",(function(t){if(o.handleWheel&&!t.defaultPrevented&&!t.ctrlKey&&o._isEditable()&&o.containsFocus()){var i=e.clamp(-t.deltaY,-1,1);o._increment((o.step||1)*i);setTimeout((function(){return o.selectAll()}));t.preventDefault()}}));o.value=0;o.isRequired=!0;o.initialize(n);return o}Object.defineProperty(InputNumber.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"inputType",{get:function(){return this._tbx.type},set:function(t){this._tbx.type=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"value",{get:function(){return this._value},set:function(t){if(t!=this._value)if(null==(t=e.asNumber(t,!this.isRequired||null==t&&null==this._value)))this._setText("");else if(!isNaN(t)){var i=e.Globalize.format(t,this.format);this._setText(i)}},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(t){this._tbx.required=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(t){this._readOnly=e.asBoolean(t);this.inputElement.readOnly=this._readOnly;e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"handleWheel",{get:function(){return this._handleWheel},set:function(t){this._handleWheel=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"min",{get:function(){return this._min},set:function(t){if(t!=this._min){this._min=e.asNumber(t,!0);this._updateAria()}},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"max",{get:function(){return this._max},set:function(t){if(t!=this._max){this._max=e.asNumber(t,!0);this._updateAria()}},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"step",{get:function(){return this._step},set:function(t){this._step=e.asNumber(t,!0);this._updateBtn()},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"format",{get:function(){return this._format},set:function(t){if(t!=this.format){this._format=e.asString(t);this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"text",{get:function(){return this._tbx.value},set:function(e){if(e!=this.text){this._oldText=null;this._setText(e)}},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(e){this._tbx.placeholder=e},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"showSpinner",{get:function(){return this._showBtn},set:function(t){this._showBtn=e.asBoolean(t);this._updateBtn()},enumerable:!0,configurable:!0});Object.defineProperty(InputNumber.prototype,"repeatButtons",{get:function(){return!this._rptUp.disabled},set:function(t){this._rptUp.disabled=this._rptDn.disabled=!e.asBoolean(t)},enumerable:!0,configurable:!0});InputNumber.prototype.selectAll=function(){var t=this._tbx;e.setSelectionRange(t,0,t.value.length)};InputNumber.prototype.clamp=function(t){return e.clamp(t,this.min,this.max)};InputNumber.prototype.onTextChanged=function(e){this.textChanged.raise(this,e);this._updateState()};InputNumber.prototype.onValueChanged=function(e){this._updateAria();this.valueChanged.raise(this,e)};InputNumber.prototype.dispose=function(){this._rptUp.element=null;this._rptDn.element=null;t.prototype.dispose.call(this)};InputNumber.prototype.onGotFocus=function(e){this._oldValue=this.value;if(!this.isTouching){this._tbx.focus();this.selectAll()}t.prototype.onGotFocus.call(this,e)};InputNumber.prototype.onLostFocus=function(i){if(this._composing){this._composing=!1;this._setText(this.text)}if(this._isEditable()){var n=this.clamp(this.value);if(n==this.value||this.onInvalidInput(new e.CancelEventArgs)){var o=e.Globalize.format(n,this.format);this._setText(o)}}t.prototype.onLostFocus.call(this,i)};InputNumber.prototype.refresh=function(i){void 0===i&&(i=!0);t.prototype.refresh.call(this,i);if(this.hostElement){this._updateSymbols();var n=e.Globalize.format(this.value,this.format);this._setText(n)}};InputNumber.prototype._isEditable=function(){return!this.isReadOnly&&!this.isDisabled};InputNumber.prototype._updateSymbols=function(){var t=e.culture.Globalize.numberFormat,i=e.Globalize._parseNumericFormat(this.format);this._chrDec=t["."]||".";this._chrTho=t[","]||",";this._chrNeg=t["-"]||"-";this._chrPls=t["+"]||"+";this._chrPct=t["%"]||"%";this._chrCur=i.curr||t.currency.symbol||"$";this._fmtSpc=i.spec;this._fmtPrc=i.prec;this._rxSym=new RegExp("^[%+\\-() \\"+this._chrDec+"\\"+this._chrCur+"\\"+this._chrNeg+"\\"+this._chrPls+"\\"+this._chrPct+"]*$");this._rxNeg=new RegExp("(\\-|\\(|\\"+this._chrNeg+")")};InputNumber.prototype._isNumeric=function(e,t){var i=e==this._chrDec||e>="0"&&e<="9",n="x"==this._fmtSpc;!i&&n&&(i=e>="a"&&e<="f"||e>="A"&&e<="F");i||t||n||(i=e==this._chrPls||e==this._chrNeg||"("==e||")"==e);return i};InputNumber.prototype._getInputRange=function(e){for(var t=[0,0],i=this.text,n=!1,o=0;o<i.length;o++)if(this._isNumeric(i[o],e)){if(!n){t[0]=o;n=!0}t[1]=o+1}return t};InputNumber.prototype._flipSign=function(){var e=this._getSelStartDigits();this.value*=-1;this._setSelStartDigits(e)};InputNumber.prototype._getSelStartDigits=function(){for(var e=0,t=this._tbx.selectionStart,i=this._tbx.value,n=0;n<i.length&&n<t;n++)this._isNumeric(i[n],!0)&&e++;return e};InputNumber.prototype._setSelStartDigits=function(t){for(var i=this._tbx.value,n=0;n<i.length&&t>=0;n++)if(this._isNumeric(i[n],!0)){if(!t){e.setSelectionRange(this._tbx,n);break}t--}else if(!t){e.setSelectionRange(this._tbx,n);break}};InputNumber.prototype._increment=function(t){if(t){var i=this.clamp(e.isNumber(this.value)?this.value+t:0),n=e.Globalize.format(i,this.format,!1,!1);this._setText(n)}};InputNumber.prototype._updateBtn=function(){var t=this.showSpinner&&!!this.step,i=t;e.setCss([this._btnUp,this._btnDn],{display:t?"":"none"});e.toggleClass(this.hostElement,"wj-input-show-spinner",t);e.enable(this._btnUp,i);e.enable(this._btnDn,i);this._updateAria()};InputNumber.prototype._setText=function(t){if(!this._composing){var i=this._tbx,n=this._chrDec,o=this._rxNeg.test(t),s=this._delKey,r=this.containsFocus();t&&this._rxSym.test(t)&&r&&(t=this.isRequired||!s?(o?"-0":"0")+(t.indexOf(n)>-1?n:""):"");this._delKey=!1;s&&0==this.value&&!this.isRequired&&(t="");if(!t){if(!this.isRequired){i.value="";if(null!=this._value){this._value=null;this.onValueChanged()}if(this._oldText){this._oldText=t;this.onTextChanged()}this._updateBtn();return}t="0"}var a=t.indexOf(n),l=this._format||(a>-1?"n2":"n0"),h=e.Globalize.parseFloat(t,l);isFinite(h)||(h=this.clamp(h));if(isNaN(h))this.onInvalidInput(new e.CancelEventArgs)?i.value=this._oldText:this.focus();else{var u=r&&a>-1?2:null,c=e.Globalize.format(h,l,!1,!1,u);o&&h>=0&&!s&&(c=this._chrNeg+c);r&&a>-1&&"g"==this._fmtSpc&&0!=this._fmtPrc&&(c=t).indexOf(n)<0&&(c+=n);if(i.value!=c){i.value=c;h=e.Globalize.parseFloat(c,l)}if(h!=this._value){this._value=h;this.onValueChanged()}if(this.text!=this._oldText){this._oldText=this.text;this.onTextChanged()}this._updateBtn();this._updateState()}}};InputNumber.prototype._keypress=function(t){if(!t.defaultPrevented&&!this._composing&&this._isEditable()&&t.charCode&&!t.ctrlKey&&!t.metaKey){var i=this._tbx,n=String.fromCharCode(t.charCode);if(this._isNumeric(n,!1)){var o=i.maxLength;if(o>-1&&i.value.length>=o&&i.selectionEnd==i.selectionStart){t.preventDefault();return}var s=this._getInputRange(!0),r=i.selectionStart,a=i.selectionEnd;if(r<s[0]&&a<i.value.length){a=Math.max(a,s[0]);e.setSelectionRange(i,s[0],a)}if(r>=s[1]){var l=null!=this._fmtPrc?this._fmtPrc:2,h=i.value.indexOf(this._chrDec);h>-1&&r-h>l&&t.preventDefault()}}else t.preventDefault();switch(n){case"-":case this._chrNeg:if(this.clamp(-1)>=0)this.value<0&&this._flipSign();else if(this.value&&i.selectionStart==i.selectionEnd)this._flipSign();else if(this.clamp(-1)<0){i.value=this._chrNeg;e.setSelectionRange(i,1)}t.preventDefault();break;case"+":case this._chrPls:this.value<0&&this._flipSign();t.preventDefault();break;case".":case this._chrDec:if(0==this._fmtPrc)t.preventDefault();else{var u=i.value.indexOf(this._chrDec);if(u>-1){i.selectionStart<=u&&u++;e.setSelectionRange(i,u);t.preventDefault()}}}if(!t.defaultPrevented&&e.isIE()){var c=i.value;if((r=i.selectionStart)==(a=i.selectionEnd)){i.value=c.substr(0,r)+n+c.substr(a);e.setSelectionRange(i,r+1);t.preventDefault();this._input()}}}};InputNumber.prototype._keydown=function(t){var i=this;this._delKey=!1;if(!t.defaultPrevented&&!this._composing&&!e.hasClass(this._tbx,"wj-grid-ime")){var n=this._tbx,o=n.value,s=n.selectionStart,r=n.selectionEnd;switch(t.keyCode){case 65:if(t.ctrlKey){setTimeout((function(){i.selectAll()}));t.preventDefault()}break;case e.Key.Up:case e.Key.Down:if(this.step&&this._isEditable()){this._increment(this.step*(t.keyCode==e.Key.Up?1:-1));setTimeout((function(){i.selectAll()}));t.preventDefault()}break;case e.Key.Back:this._delKey=!0;if(r-s<2&&this._isEditable()){var a=o[r-1];if(a==this._chrDec||a==this._chrPct||a==this._chrTho||")"==a){setTimeout((function(){r=a==i._chrPct?i._getInputRange(!0)[1]:r-1;e.setSelectionRange(n,r)}));t.preventDefault()}}break;case e.Key.Delete:this._delKey=!0;if(r-s<2&&this._isEditable())if("0"==o&&1==s)e.setSelectionRange(n,0);else{var l=o[s];if(l==this._chrDec||l==this._chrPct){setTimeout((function(){e.setSelectionRange(n,s+1)}));t.preventDefault()}}break;case e.Key.Escape:this.value=this._oldValue;this.selectAll()}}};InputNumber.prototype._input=function(){var t=this;this._composing||setTimeout((function(){var i=t._tbx,n=i.value,o=n.indexOf(t._chrDec),s=i.selectionStart,r=t._getSelStartDigits();"p"==t._fmtSpc&&n.length&&n.indexOf(t._chrPct)<0&&(n+=t._chrPct);t._setText(n);if(t.containsFocus()){var a=i.value,l=a.indexOf(t._chrDec),h=t._getInputRange(!0);if(n==t._chrNeg+t._chrDec&&l>-1){e.setSelectionRange(i,l+1);return}if(n[0]==t._chrNeg&&a[0]!=t._chrNeg){1==a.length?e.setSelectionRange(i,1):t._setSelStartDigits(r);return}n?n==t._chrDec&&l>-1?s=l+1:s<=o&&l>-1||o<0&&l<0?s+=a.length-n.length:o<0&&l>-1&&(s=l):s=l>-1?l:h[1];s=e.clamp(s,h[0],h[1]);e.setSelectionRange(i,s)}}))};InputNumber.prototype._clickSpinner=function(t){var i=this;if(!t.defaultPrevented&&this._isEditable()&&this.step){this._increment(this.step*(e.contains(this._btnUp,t.target)?1:-1));this.isTouching||setTimeout((function(){return i.selectAll()}))}};InputNumber.prototype._updateAria=function(){var t=this.hostElement;if(t){e.setAttribute(t,"aria-valuemin",this.min);e.setAttribute(t,"aria-valuemax",this.max);e.setAttribute(t,"aria-valuenow",this.value);e.enable(this._btnDn,null==this.min||this.value>this.min);e.enable(this._btnUp,null==this.max||this.value<this.max)}};InputNumber.controlTemplate='<div class="wj-template"><div class="wj-input"><div class="wj-input-group"><span wj-part="btn-dec" class="wj-input-group-btn" tabindex="-1"><button class="wj-btn wj-btn-default" tabindex="-1">-</button></span><input type="tel" wj-part="input" class="wj-form-control wj-numeric"/><span wj-part="btn-inc" class="wj-input-group-btn" tabindex="-1"><button class="wj-btn wj-btn-default" tabindex="-1">+</button></span></div></div></div>';return InputNumber}(e.Control);t.InputNumber=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(InputMask,t);function InputMask(i,n){var o=t.call(this,i)||this;o.valueChanged=new e.Event;var s=o.getTemplate();o.applyTemplate("wj-control wj-content wj-inputmask",s,{_tbx:"input"},"input");if("INPUT"==o._orgTag){var r=o._tbx.getAttribute("value");r&&(o.value=r)}o._msk=new e._MaskProvider(o._tbx);o.isRequired=!0;o.initialize(n);o.addEventListener(o._tbx,"input",(function(){o.onValueChanged()}));o.addEventListener(o._tbx,"blur",o._commitText.bind(o));o.addEventListener(o._tbx,"keydown",(function(t){t.keyCode==e.Key.Enter&&o._commitText()}));return o}Object.defineProperty(InputMask.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"inputType",{get:function(){return this._tbx.type},set:function(t){this._tbx.type=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"value",{get:function(){return this._tbx.value},set:function(t){if(t!=this.value){this._tbx.value=e.asString(t);t=this._msk._applyMask();this._tbx.value=t;this.onValueChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"rawValue",{get:function(){return this._msk.getRawValue()},set:function(t){t!=this.rawValue&&(this.value=e.asString(t))},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"mask",{get:function(){return this._msk.mask||""},set:function(t){var i=this.value;this._msk.mask=e.asString(t);this.value!=i&&this.onValueChanged()},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"promptChar",{get:function(){return this._msk.promptChar},set:function(e){var t=this.value;this._msk.promptChar=e;this.value!=t&&this.onValueChanged()},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"overwriteMode",{get:function(){return this._msk.overwriteMode},set:function(t){this._msk.overwriteMode=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(e){this._tbx.placeholder=e},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"maskFull",{get:function(){return this._msk.maskFull},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(t){this._tbx.required=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputMask.prototype,"isReadOnly",{get:function(){return this._tbx.readOnly},set:function(t){this._tbx.readOnly=e.asBoolean(t);e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0});InputMask.prototype.selectAll=function(){var t=this._msk.getMaskRange();e.setSelectionRange(this._tbx,t[0],t[1]+1)};InputMask.prototype.onValueChanged=function(e){if(this.value!=this._oldValue){this._oldValue=this.value;this.valueChanged.raise(this,e)}this._updateState()};InputMask.prototype._commitText=function(){if((this.value||this.isRequired)&&!this.maskFull&&!this.onInvalidInput(new e.CancelEventArgs)){var t=this._tbx,i=t.value,n=i.indexOf(this.promptChar);n>-1&&e.setSelectionRange(t,n,i.length)}this._updateState()};InputMask.prototype.dispose=function(){this._msk.input=null;t.prototype.dispose.call(this)};InputMask.prototype.refresh=function(e){void 0===e&&(e=!0);t.prototype.refresh.call(this,e);this.hostElement&&this._msk.refresh()};InputMask.prototype.onGotFocus=function(e){t.prototype.onGotFocus.call(this,e);this.selectAll()};InputMask.controlTemplate='<div class="wj-input"><div class="wj-input-group"><input wj-part="input" class="wj-form-control"/></div></div>';return InputMask}(e.Control);t.InputMask=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(ColorPicker,t);function ColorPicker(i,n){var o=t.call(this,i)||this;o._hsb=[.5,1,1];o._alpha=1;o.valueChanged=new e.Event;var s=o.getTemplate();o.applyTemplate("wj-control wj-content wj-colorpicker",s,{_eSB:"div-sb",_eHue:"div-hue",_eAlpha:"div-alpha",_ePreview:"div-pv",_ePal:"div-pal",_eText:"div-text"});o._palette="#FFF,#000,#F00,#FFC000,#FFFF00,#92D050,#00B050,#00B0F0,#0070C0,#7030A0".split(",");o._updatePalette();o._eHue.style.backgroundImage="url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAD4CAIAAACi6hsPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuM4zml1AAAAGvSURBVDhPXdBPaM9xHMfxz4pWaxcmtoOhpdXSVpiyHWxqmVpDjaU5rK34XfypjTJ/p+ZPay6jhsOsRrKwaJElf9IQq03WIkv4FeMwMq221tfje1ByeFzfvd7PEKWGEKWTQRZLySWfVRRTQjmVbKWGOhLsZT+HaeY0bbTTQSfdXOcWffTzmAFeMcwoYyT5ygS/mA5hNgphip98J8kHRnnNSwZ4yH1uc4OrdHGR87RximYO0cgedlLLdqqoYAPrWMtKVrCcJSxiPmnMJUQp/Bsyk2xyyKOAQooopYwKtlDNDur5G7SBJo7RQiv/B+2hl3s84CkvGGKEOOYnxolj/mYmhBmDJ5ngCx95xxsGecYj4pB3iENeoZMO2mmlhaMcpIE4ZII6aqhmM3HMMkooopB88sghm0wySCeVlCjMCVFIYx4LWUwOeRSwhmLWU84mqqihll3sppEmjnOSs5zjEl1c4yZ99POE5wwxwns+840fTDFLFKaZZIJxkozxlmEGGSC+GF++Sy89dHOZC8Rr4lVnOMERDrCPBPXEX22jko2UEn+/mnxyWUYWC0gnNUQh/AEc0HJs6cex0gAAAABJRU5ErkJggg==)";o._eHue.style.backgroundSize="contain";if(navigator.appVersion.indexOf("MSIE 9")>-1){o._eSB.children[0].style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffffff,endColorstr=#00ffffff,GradientType=1)";o._eSB.children[1].style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#00000000,endColorstr=#ff000000,GradientType=0)"}s=ColorPicker._tplCursor;o._cSB=e.createElement(s);o._cHue=e.createElement(s);o._cHue.style.width="100%";o._cAlpha=e.createElement(s);o._cAlpha.style.height="100%";o._eSB.appendChild(o._cSB);o._eHue.appendChild(o._cHue);o._eAlpha.appendChild(o._cAlpha);var r=o.addEventListener.bind(o),a=o.removeEventListener.bind(o),l=document;r(o.hostElement,"mousedown",(function(e){r(l,"mousemove",mouseMove);r(l,"mouseup",mouseUp);o._mouseDown(e)}));r(o.hostElement,"touchstart",(function(e){r(l,"touchmove",mouseMove);r(l,"touchend",mouseUp);o._mouseDown(e)}));var mouseMove=function(e){o._mouseMove(e)},mouseUp=function(e){a(l,"mousemove",mouseMove);a(l,"mouseup",mouseUp);a(l,"touchmove",mouseMove);a(l,"touchend",mouseUp);o._mouseUp(e)};r(o.hostElement,"click",(function(t){var i=t.target;if(i&&"DIV"==i.tagName&&e.contains(o._ePal,i)){var n=i.style.backgroundColor;n&&(o.value=new e.Color(n).toString())}}));o.value="#ffffff";o.initialize(n);o._updatePanels();return o}Object.defineProperty(ColorPicker.prototype,"showAlphaChannel",{get:function(){return"none"!=this._eAlpha.parentElement.style.display},set:function(t){this._eAlpha.parentElement.style.display=e.asBoolean(t)?"":"none"},enumerable:!0,configurable:!0});Object.defineProperty(ColorPicker.prototype,"showColorString",{get:function(){return"none"!=this._eText.style.display},set:function(t){this._eText.style.display=e.asBoolean(t)?"":"none"},enumerable:!0,configurable:!0});Object.defineProperty(ColorPicker.prototype,"value",{get:function(){return this._value},set:function(t){if(t!=this.value){t=e.asString(t);var i=e.Color.fromString(t);if(i){this._value=t;this._eText.innerText=t;var n=i.getHsb();if(this._hsb[0]!=n[0]||this._hsb[1]!=n[1]||this._hsb[2]!=n[2]||this._alpha!=i.a){if(0==n[2]){n[0]=this._hsb[0];n[1]=this._hsb[1]}else 0==n[1]&&(n[0]=this._hsb[0]);this._hsb=n;this._alpha=i.a;this._updatePanels();this.onValueChanged()}}}},enumerable:!0,configurable:!0});Object.defineProperty(ColorPicker.prototype,"palette",{get:function(){return this._palette},set:function(t){if((t=(t=e.asArray(t)).slice(0,10)).every((function(t){return null!=e.Color.fromString(t)}))){this._palette=t;this._updatePalette()}},enumerable:!0,configurable:!0});ColorPicker.prototype.onValueChanged=function(e){this._updatePanels();this.valueChanged.raise(this,e)};ColorPicker.prototype._mouseDown=function(e){this._htDown=this._getTargetPanel(e);if(this._htDown){e.preventDefault();this.focus();this._mouseMove(e)}};ColorPicker.prototype._mouseMove=function(t){var i=t.touches?t.touches[0]:t,n=this._htDown;if(n){var o=n.getBoundingClientRect(),s=this._hsb;if(n==this._eHue)s[0]=e.clamp((i.clientY-o.top)/o.height,0,.99);else if(n==this._eSB){s[1]=e.clamp((i.clientX-o.left)/o.width,0,1);s[2]=e.clamp(1-(i.clientY-o.top)/o.height,0,1)}else n==this._eAlpha&&(this._alpha=e.clamp((i.clientX-o.left)/o.width,0,1));this._updateColor()}};ColorPicker.prototype._mouseUp=function(e){this._htDown=null};ColorPicker.prototype._updateColor=function(){var t=e.Color.fromHsb(this._hsb[0],this._hsb[1],this._hsb[2],this._alpha);this.value=t.toString();this._updatePanels()};ColorPicker.prototype._updatePalette=function(){var t=new e.Color("#fff"),i=new e.Color("#000");this._ePal.innerHTML="";for(var n=0;n<this._palette.length;n++){var o=e.createElement('<div style="float:left;width:10%;box-sizing:border-box;padding:1px">'),s=new e.Color(this._palette[n]),r=s.getHsb();o.appendChild(this._makePalEntry(s,4));for(var a=0;a<5;a++){if(0==r[1]){var l=.1*a+(r[2]>.5?.05:.55);s=e.Color.interpolate(t,i,l)}else s=e.Color.fromHsb(r[0],.1+.2*a,1-.1*a);o.appendChild(this._makePalEntry(s,0))}this._ePal.appendChild(o)}};ColorPicker.prototype._makePalEntry=function(t,i){var n=document.createElement("div");e.setCss(n,{cursor:"pointer",backgroundColor:t.toString(),marginBottom:i||""});n.innerHTML="&nbsp";return n};ColorPicker.prototype._updatePanels=function(){var t=e.Color.fromHsb(this._hsb[0],1,1,1),i=e.Color.fromHsb(this._hsb[0],this._hsb[1],this._hsb[2],1);this._eSB.style.backgroundColor=t.toString();this._eAlpha.style.background="linear-gradient(to right, transparent 0%, "+i.toString()+" 100%)";navigator.appVersion.indexOf("MSIE 9")>-1&&(this._eAlpha.style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr=#00000000,endColorstr="+i.toString()+", GradientType = 1)");this._ePreview.style.backgroundColor=this.value;this._cHue.style.top=(100*this._hsb[0]).toFixed(0)+"%";this._cSB.style.left=(100*this._hsb[1]).toFixed(0)+"%";this._cSB.style.top=(100-100*this._hsb[2]).toFixed(0)+"%";this._cAlpha.style.left=(100*this._alpha).toFixed(0)+"%"};ColorPicker.prototype._getTargetPanel=function(t){var i=t.target;return e.contains(this._eSB,i)?this._eSB:e.contains(this._eHue,i)?this._eHue:e.contains(this._eAlpha,i)?this._eAlpha:null};ColorPicker.controlTemplate='<div style="position:relative;width:100%;height:100%"><div style="float:left;width:50%;height:100%;box-sizing:border-box;padding:2px"><div wj-part="div-pal"><div style="float:left;width:10%;box-sizing:border-box;padding:2px"><div style="background-color:black;width:100%">&nbsp;</div><div style="height:6px"></div></div></div><div wj-part="div-text" style="position:absolute;bottom:0px;display:none"></div></div><div style="float:left;width:50%;height:100%;box-sizing:border-box;padding:2px"><div wj-part="div-sb" class="wj-colorbox" style="float:left;width:89%;height:89%"><div style="position:absolute;width:100%;height:100%;background:linear-gradient(to right, white 0%,transparent 100%)"></div><div style="position:absolute;width:100%;height:100%;background:linear-gradient(to top, black 0%,transparent 100%)"></div></div><div style="float:left;width:1%;height:89%"></div><div style="float:left;width:10%;height:89%"><div wj-part="div-hue" class="wj-colorbox"></div></div><div style="float:left;width:89%;height:1%"></div><div style="float:left;width:89%;height:10%"><div style="width:100%;height:100%;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuM4zml1AAAAAcSURBVBhXY/iPBBYgAWpKQGkwgMqDAdUk/v8HAM7Mm6GatDUYAAAAAElFTkSuQmCC)"><div wj-part="div-alpha" class="wj-colorbox"></div></div></div><div style="float:left;width:1%;height:10%"></div><div style="float:left;width:10%;height:10%"><div wj-part="div-pv" class="wj-colorbox" style="position:static"></div></div></div></div>';ColorPicker._tplCursor='<div style="position:absolute;left:50%;top:50%;width:7px;height:7px;transform:translate(-50%,-50%);border:2px solid #f0f0f0;border-radius:50px;box-shadow:0px 0px 4px 2px #0f0f0f"></div>';return ColorPicker}(e.Control);t.ColorPicker=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(CollectionViewNavigator,t);function CollectionViewNavigator(i,n){var o=t.call(this,i)||this;o._view=null;o._byPage=!1;o._fmt="{current:n0} / {count:n0}";var s=o.getTemplate();o.applyTemplate("wj-control wj-content wj-pager wj-collectionview-navigator",s,{_btnFirst:"btn-first",_btnPrev:"btn-prev",_txtCurr:"txt-curr",_btnNext:"btn-next",_btnLast:"btn-last"},"input");o._rptNext=new e._ClickRepeater(o._btnNext.querySelector("button"));o._rptPrev=new e._ClickRepeater(o._btnPrev.querySelector("button"));o.addEventListener(o.hostElement,"click",o._click.bind(o));o.initialize(n);o._update();return o}Object.defineProperty(CollectionViewNavigator.prototype,"cv",{get:function(){return this._view},set:function(t){if(t!=this._view){var i=this._view;if(i){i.collectionChanged.removeHandler(this._collectionChanged);i.currentChanged.removeHandler(this._currentChanged)}i=this._view=e.asType(t,"ICollectionView",!0);this._update();if(i){i.collectionChanged.addHandler(this._collectionChanged,this);i.currentChanged.addHandler(this._currentChanged,this)}}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewNavigator.prototype,"byPage",{get:function(){return this._byPage},set:function(t){if(t!=this._byPage){this._byPage=e.asBoolean(t);this._update()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewNavigator.prototype,"headerFormat",{get:function(){return this._fmt},set:function(t){if(t!=this._fmt){this._fmt=e.asString(t);this._update()}},enumerable:!0,configurable:!0});Object.defineProperty(CollectionViewNavigator.prototype,"repeatButtons",{get:function(){return!this._rptNext.disabled},set:function(t){this._rptNext.disabled=this._rptPrev.disabled=!e.asBoolean(t)},enumerable:!0,configurable:!0});CollectionViewNavigator.prototype._update=function(){var t=this._view,i=this._byPage,n=t?i?t.pageIndex:t.currentPosition:0,o=t?i?t.pageCount:t.itemCount:0;e.enable(this._btnFirst,t&&n>0);e.enable(this._btnPrev,t&&n>0);e.enable(this._txtCurr,null!=t);e.enable(this._btnNext,t&&n<o-1);e.enable(this._btnLast,t&&n<o-1);this._txtCurr.value=e.format(this._fmt,{current:t?n+1:0,count:t?o:0,currentItem:t?t.currentPosition+1:0,itemCount:t?t.itemCount:0,currentPage:t?t.pageIndex+1:0,pageCount:t?t.pageCount:0})};CollectionViewNavigator.prototype._currentChanged=function(){this._update()};CollectionViewNavigator.prototype._collectionChanged=function(){this._update()};CollectionViewNavigator.prototype._click=function(t){var i=t.target,n=this._view,o=this._byPage;if(n){e.contains(this._btnFirst,i)?o?n.moveToFirstPage():n.moveCurrentToFirst():e.contains(this._btnPrev,i)?o?n.moveToPreviousPage():n.moveCurrentToPrevious():e.contains(this._btnNext,i)?o?n.moveToNextPage():n.moveCurrentToNext():e.contains(this._btnLast,i)&&(o?n.moveToLastPage():n.moveCurrentToLast());t.preventDefault()}};CollectionViewNavigator.controlTemplate='<div class="wj-input-group"><span wj-part="btn-first" class="wj-input-group-btn"><button class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-step-backward"></span></button></span><span wj-part="btn-prev" class="wj-input-group-btn"> <button class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-left"></span> </button></span><input wj-part="txt-curr" class="wj-form-control" readonly><span wj-part="btn-next" class="wj-input-group-btn"><button class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-right"></span></button></span><span wj-part="btn-last" class="wj-input-group-btn"><button class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-step-forward"></span></button></span></div>';return CollectionViewNavigator}(e.Control);t.CollectionViewNavigator=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(ListBox,t);function ListBox(i,n){var o=t.call(this,i)||this;o._pathDisplay=new e.Binding("");o._pathValue=new e.Binding("");o._pathChecked=new e.Binding("");o._html=!1;o._shGroups=!1;o._itemRole="option";o._checking=!1;o._search="";o._caseSensitive=!1;o._fmtItemHandlers=0;o._itemCount=0;o.selectedIndexChanged=new e.Event;o.itemsChanged=new e.Event;o.loadingItems=new e.Event;o.loadedItems=new e.Event;o.itemChecked=new e.Event;o.checkedItemsChanged=new e.Event;o.formatItem=new e.Event((function(){o.invalidate()}));o.applyTemplate("wj-control wj-content wj-listbox",null,null);var s=o.hostElement;e.setAttribute(s,"role","listbox",!0);"SELECT"==o._orgTag&&o._initFromSelect(o.hostElement);o.addEventListener(s,"click",o._click.bind(o));o.addEventListener(s,"keydown",o._keydown.bind(o));o.addEventListener(s,"keypress",o._keypress.bind(o));o.addEventListener(s,"wheel",(function(e){if(s.scrollHeight>s.offsetHeight&&(e.deltaY<0&&0==s.scrollTop||e.deltaY>0&&s.scrollTop+s.offsetHeight>=s.scrollHeight)){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation()}}));o.initialize(n);return o}Object.defineProperty(ListBox.prototype,"itemsSource",{get:function(){return this._items},set:function(t){if(this._items!=t){if(this._cv){this._cv.currentChanged.removeHandler(this._cvCurrentChanged,this);this._cv.collectionChanged.removeHandler(this._cvCollectionChanged,this);this._cv=null}this._items=t;this._checkedItems=null;this._cv=e.asCollectionView(t);if(null!=this._cv){this._cv.currentChanged.addHandler(this._cvCurrentChanged,this);this._cv.collectionChanged.addHandler(this._cvCollectionChanged,this)}this._populateList();this.onItemsChanged();this.onSelectedIndexChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"collectionView",{get:function(){return this._cv},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"showGroups",{get:function(){return this._shGroups},set:function(t){if(t!=this._shGroups){this._shGroups=e.asBoolean(t);this._populateList()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"isContentHtml",{get:function(){return this._html},set:function(t){if(t!=this._html){this._html=e.asBoolean(t);this._populateList()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(t){if(t!=this._itemFormatter){this._itemFormatter=e.asFunction(t);this._populateList()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"displayMemberPath",{get:function(){return this._pathDisplay.path},set:function(t){if(t!=this.displayMemberPath){this._pathDisplay.path=e.asString(t);this._populateList()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"selectedValuePath",{get:function(){return this._pathValue.path},set:function(t){this._pathValue.path=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"checkedMemberPath",{get:function(){return this._pathChecked.path},set:function(t){if(t!=this.checkedMemberPath){this._pathChecked.path=e.asString(t);this._populateList()}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"caseSensitiveSearch",{get:function(){return this._caseSensitive},set:function(t){this._caseSensitive=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"itemRole",{get:function(){return this._itemRole},set:function(t){if(t!=this.itemRole){this._itemRole=e.asString(t);this._populateList()}},enumerable:!0,configurable:!0});ListBox.prototype.getDisplayValue=function(t){var i=null;if(t>-1&&e.hasItems(this._cv)){i=this._cv.items[t];this.displayMemberPath&&(i=this._pathDisplay.getValue(i))}var n=null!=i?i.toString():"";this._itemFormatter&&(n=this._itemFormatter(t,n));return n};ListBox.prototype.getDisplayText=function(e){var t=this._getChild(e);return null!=t?t.textContent:""};ListBox.prototype.isItemEnabled=function(t){var i=this._getChild(t);return null!=i&&!i.hasAttribute("disabled")&&!e.hasClass(i,"wj-state-disabled")&&!e.hasClass(i,"wj-separator")};Object.defineProperty(ListBox.prototype,"selectedIndex",{get:function(){return this._cv?this._cv.currentPosition:-1},set:function(t){this._cv&&this._cv.moveCurrentToPosition(e.asNumber(t))},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"selectedItem",{get:function(){return this._cv?this._cv.currentItem:null},set:function(e){this._cv&&this._cv.moveCurrentTo(e)},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"selectedValue",{get:function(){var e=this.selectedItem;e&&this.selectedValuePath&&(e=this._pathValue.getValue(e));return e},set:function(t){var i=this._cv,n=i?i.items:null,o=this.selectedValuePath,s=-1;if(n){for(var r=0;r<n.length;r++){var a=n[r],l=o?this._pathValue.getValue(a):a;if(l===t||e.DateTime.equals(l,t)){s=r;break}if(this.isContentHtml&&e.isString(l)&&l.indexOf("<")>-1&&e.toPlainText(l)===t){s=r;break}}this.selectedIndex=s}},enumerable:!0,configurable:!0});Object.defineProperty(ListBox.prototype,"maxHeight",{get:function(){var e=this.hostElement,t=e?parseFloat(e.style.maxHeight):null;return isNaN(t)?null:t},set:function(t){var i=this.hostElement;if(i){t=e.asNumber(t,!0);i.style.maxHeight=null==t?"":t+"px"}},enumerable:!0,configurable:!0});ListBox.prototype.showSelection=function(t){var i=this.selectedIndex,n=this.hostElement,o=n.children;i=this._getElementIndex(i);for(var s=0;s<o.length;s++){var r=o[s],a=s==i,l=this.checkedMemberPath?this._getCheckbox(s):null,h=l?l.checked:null;e.toggleClass(r,"wj-state-selected",a);e.setAttribute(r,"aria-selected",this._getAriaSelected(a,h));r.tabIndex=a?this._orgTabIndex:-1}if(i>-1&&i<o.length){var u=(r=o[i]).getBoundingClientRect(),c=n.getBoundingClientRect(),p=0;if(this._shGroups){var d=o[0];e.hasClass(d,"wj-header")&&(p=d.offsetHeight)}u.bottom>c.bottom?n.scrollTop+=u.bottom-c.bottom:u.top<c.top+p&&(n.scrollTop-=c.top+p-u.top)}if(i>-1){null==t&&(t=this.containsFocus());if(t){(r=o[i])instanceof HTMLElement&&!e.contains(r,e.getActiveElement())&&r.focus()}}n.tabIndex=i<0?this._orgTabIndex:-1};ListBox.prototype.loadList=function(){this._populateList()};ListBox.prototype.getItemChecked=function(t){var i=this._cv.items[t],n=this._pathChecked;if(e.isObject(i)&&n.path)return n.getValue(i);var o=this._getCheckbox(t);return!!o&&o.checked};ListBox.prototype.setItemChecked=function(e,t){this._setItemChecked(e,t,!0)};ListBox.prototype.toggleItemChecked=function(e){this.setItemChecked(e,!this.getItemChecked(e))};Object.defineProperty(ListBox.prototype,"checkedItems",{get:function(){null==this._checkedItems&&(this._checkedItems=this._getCheckedItems());return this._checkedItems},set:function(t){var i=this,n=e.asArray(t,!1);if(!this._arrayEquals(n,this.checkedItems)){var o=this._cv,s=this._pathChecked,r=new Map;if(s&&o){var a=o.sourceCollection;if(a&&a.length){e.isObject(a[0])||(s=null);n.forEach((function(e){return r.set(e,!0)}));this._checking=!0;var l=[];a.forEach((function(e){var t=r.has(e);t&&l.push(e);s&&s.setValue(e,t)}));this._checking=!1;n=l}o.items.forEach((function(e,t){i._setItemChecked(t,r.has(e),!1)}))}if(!this._arrayEquals(n,this._checkedItems)){this._checkedItems=n;this.onCheckedItemsChanged()}}},enumerable:!0,configurable:!0});ListBox.prototype.indexOf=function(t){if(this._shGroups&&e.hasClass(t,"wj-header"))return-1;for(var i=this.hostElement.children,n=0,o=0;n<i.length;n++){var s=i[n];if(e.contains(i[n],t))return o;this._shGroups&&e.hasClass(s,"wj-header")||o++}return-1};ListBox.prototype.onSelectedIndexChanged=function(e){this.selectedIndexChanged.raise(this,e)};ListBox.prototype.onItemsChanged=function(e){this.itemsChanged.raise(this,e)};ListBox.prototype.onLoadingItems=function(e){this.loadingItems.raise(this,e)};ListBox.prototype.onLoadedItems=function(e){this.loadedItems.raise(this,e)};ListBox.prototype.onItemChecked=function(e){this.itemChecked.raise(this,e)};ListBox.prototype.onCheckedItemsChanged=function(e){this.checkedItemsChanged.raise(this,e)};ListBox.prototype.onFormatItem=function(e){this.formatItem.raise(this,e)};ListBox.prototype.refresh=function(e){void 0===e&&(e=!0);t.prototype.refresh.call(this,e);if(this.hostElement){var i=this._cv?this._cv.items.length:0,n=this.formatItem.handlerCount;if(i!=this._itemCount||n!=this._fmtItemHandlers){this._fmtItemHandlers=n;this._populateList()}}};ListBox.prototype._getCheckedItems=function(){var t=this,i=this._cv,n=this._pathChecked,o=[];i&&n&&n.path&&(o=i.sourceCollection.filter((function(o,s){if(i.filter&&!i.filter(o))return!1;if(e.isObject(o))return n.getValue(o);var r=i.items[s]==o?s:i.items.indexOf(o);return t.getItemChecked(r)})));return o};ListBox.prototype._arrayEquals=function(e,t){if(e==t)return!0;if(!e||!t||e.length!=t.length)return!1;for(var i=0;i<e.length;i++)if(e[i]!=t[i])return!1;return!0};ListBox.prototype._getChild=function(e){e=this._getElementIndex(e);return this.hostElement.children[e]};ListBox.prototype._getElementIndex=function(t){if(this._shGroups)for(var i=this.hostElement.children,n=0;n<=t&&n<i.length;n++){var o=i[n];e.hasClass(o,"wj-header")&&t++}return t};ListBox.prototype._setItemChecked=function(t,i,n){void 0===n&&(n=!0);var o=this._cv.items[t],s=this._pathChecked,r=!1,a=this.selectedIndex,l=this._checking;if(e.isObject(o)&&s.path){if(s.getValue(o)!=i){var h=e.tryCast(this._cv,"IEditableCollectionView");r=!0;this._checking=!0;if(h){h.editItem(o);s.setValue(o,i);h.commitEdit()}else{s.setValue(o,i);h.refresh()}this._checking=l}}else r=!0;var u=this._getCheckbox(t);if(u){u.checked=i;var c=e.closest(u,".wj-listbox-item");if(c){e.toggleClass(c,"wj-state-checked",i);e.setAttribute(c,"aria-selected",!!i||null)}}if(n){if(r){this._checkedItems=null;this.onItemChecked();this.onCheckedItemsChanged()}a!=this.selectedIndex&&this.onSelectedIndexChanged()}return r};ListBox.prototype._cvCollectionChanged=function(){if(!this._checking){this._populateList();this.onItemsChanged()}};ListBox.prototype._cvCurrentChanged=function(){if(!this._checking){this.showSelection();this.onSelectedIndexChanged()}};ListBox.prototype._populateList=function(){var t=this.hostElement,i=this._cv;this._itemCount=i?i.items.length:0;if(t){var o=this.containsFocus(),s=-1,r=void 0;this.onLoadingItems();t.textContent="";if(i){var a=[],l=0,h=void 0;s=i.currentPosition;if(this._shGroups&&i.groups&&i.groups.length){r={};for(var u=0;u<i.groups.length;u++){var c=i.groups[u];r[l]=c;h=this._createHeaderItem(c);a.push(h);for(var p=0;p<c.items.length;p++,l++){h=this._createItem(l);a.push(h)}}}else for(p=0;p<i.items.length;p++,l++){h=this._createItem(l);a.push(h)}t.innerHTML=a.join("")}if(this.formatItem.hasHandlers&&i){var d=t.children,f=i.items,m=(l=0,new n(0,null,null));for(p=0;p<d.length;p++){m._item=d[p];if(this._shGroups&&e.hasClass(m._item,"wj-header")){m._index=-1;m._data=r[l]}else{m._index=l;m._data=f[l];l++}this.onFormatItem(m)}}0==t.children.length&&t.appendChild(document.createElement("div"));t.tabIndex=s<0?this._orgTabIndex:-1;if(o){(s>=0?t.children[this._getElementIndex(s)]:t).focus()}else s>0&&this.showSelection();this.checkedItems=this._getCheckedItems();this.onLoadedItems()}};ListBox.prototype._createItem=function(t){var i=this._cv.items[t],n=t==this._cv.currentPosition,o=this.getDisplayValue(t);1!=this._html&&(o=e.escapeHtml(o));var s=null;if(this.checkedMemberPath){s=!1;e.isObject(i)?s=!!this._pathChecked.getValue(i):this._checkedItems&&(s=this._checkedItems.indexOf(i)>-1);o='<label><input type="checkbox" tabindex="-1"'+(s?" checked":"")+"><span></span> "+o+"</label>"}var r="wj-listbox-item";n&&(r+=" wj-state-selected");s&&(r+=" wj-state-checked");if(this._html){var a=["wj-separator","wj-state-disabled"];if(o.indexOf(a[0])>-1||o.indexOf(a[1])>-1){var l=e.createElement(o);a.forEach((function(t){e.hasClass(l,t)&&(r+=" "+t)}))}}return'<div class="'+r+'" role="'+this.itemRole+'" '+(this._getAriaSelected(n,s)?'aria-selected="true" ':"")+'tabindex="'+(n?this._orgTabIndex:-1)+'">'+o+"</div>"};ListBox.prototype._getAriaSelected=function(e,t){return!!(null!=t?t:e)||null};ListBox.prototype._createHeaderItem=function(t){return'<div class="wj-listbox-item wj-header wj-state-disabled" role="presentation" tabindex="-1">'+e.escapeHtml(t.name)+"</div>"};ListBox.prototype._click=function(e){if(0==e.button&&!e.defaultPrevented){var t=this.indexOf(e.target);if(t>-1){this.selectedIndex=t;if(this.checkedMemberPath){var i=this._getCheckbox(t),n=this.hostElement.children[t];if(i==e.target||e.target==n){n.focus({preventScroll:!0});this.setItemChecked(t,i.checked)}}}}};ListBox.prototype._keydown=function(t){var i=this.selectedIndex;if(!t.defaultPrevented){if(65==t.keyCode&&(t.ctrlKey||t.metaKey)){var n=this.collectionView;if(this.checkedMemberPath&&e.hasItems(n)){this.checkedItems=this.checkedItems.length!=n.items.length?n.items:[];t.preventDefault();return}}if(!(t.ctrlKey||t.shiftKey||t.altKey||t.metaKey))switch(t.keyCode){case e.Key.Down:t.preventDefault();this._selectNext();break;case e.Key.Up:t.preventDefault();this._selectPrev();break;case e.Key.Home:t.preventDefault();this._selectFirst();break;case e.Key.End:t.preventDefault();this._selectLast();break;case e.Key.PageDown:t.preventDefault();this._selectNextPage();break;case e.Key.PageUp:t.preventDefault();this._selectPrevPage();break;case e.Key.Space:if(this.checkedMemberPath&&i>-1){var o=this._getCheckbox(i);if(o&&this.isItemEnabled(i)){this.setItemChecked(i,!o.checked);t.preventDefault()}}}}};ListBox.prototype._keypress=function(t){var i=this;if(!t.defaultPrevented&&!(t.target instanceof HTMLInputElement)&&(t.charCode>32||32==t.charCode&&this._search)){t.preventDefault();this._search+=String.fromCharCode(t.charCode);this._toSearch&&clearTimeout(this._toSearch);this._toSearch=setTimeout((function(){i._toSearch=null;i._search=""}),e.Control._SEARCH_DELAY);var n=this._findNext();if(n<0&&this._search.length>1){this._search=this._search[this._search.length-1];n=this._findNext()}n>-1&&(this.selectedIndex=n)}};ListBox.prototype._selectNext=function(){for(var e=this.hostElement.children.length,t=this.selectedIndex+1;t<e;t++)if(this.isItemEnabled(t)){this.selectedIndex=t;return!0}return!1};ListBox.prototype._selectPrev=function(){for(var e=this.selectedIndex-1;e>=0;e--)if(this.isItemEnabled(e)){this.selectedIndex=e;return!0}return!1};ListBox.prototype._selectFirst=function(){for(var e=this.hostElement.children.length,t=0;t<e;t++)if(this.isItemEnabled(t)){this.selectedIndex=t;return!0}return!1};ListBox.prototype._selectLast=function(){for(var e=this.hostElement.children.length-1;e>=0;e--)if(this.isItemEnabled(e)){this.selectedIndex=e;return!0}return!1};ListBox.prototype._selectNextPage=function(){for(var e=this.hostElement,t=e.offsetHeight,i=e.children,n=0,o=this.selectedIndex+1;o<this._cv.items.length;o++){var s=i[o].scrollHeight;if(n+s>t&&this.isItemEnabled(o)){this.selectedIndex=o;return!0}n+=s}return this._selectLast()};ListBox.prototype._selectPrevPage=function(){for(var e=this.hostElement,t=e.offsetHeight,i=e.children,n=0,o=this.selectedIndex-1;o>0;o--){var s=i[o].scrollHeight;if(n+s>t&&this.isItemEnabled(o)){this.selectedIndex=o;return!0}n+=s}return this._selectFirst()};ListBox.prototype._findNext=function(){if(this.hostElement){var e=this.hostElement.childElementCount,t=this.selectedIndex;(t<0||1==this._search.length)&&t++;var i=this._search,n=this.caseSensitiveSearch;n||(i=i.toLowerCase());for(var o=0;o<e;o++){var s=(t+o)%e;if(this.isItemEnabled(s)){var r=this.getDisplayText(s).trim();n||(r=r.toLowerCase());if(0==r.indexOf(i))return s}}}return-1};ListBox.prototype._getCheckbox=function(e){var t=this.hostElement,i=t?t.children:null;e=this._getElementIndex(e);return t&&e>-1&&e<i.length?i[e].querySelector("input[type=checkbox]"):null};ListBox.prototype._initFromSelect=function(e){for(var t=e.children,i=[],n=-1,o=0;o<t.length;o++){var s=t[o];if("OPTION"==s.tagName){s.hasAttribute("selected")&&(n=i.length);s.innerHTML?i.push({hdr:s.innerHTML,val:s.getAttribute("value"),cmdParam:s.getAttribute("cmd-param")}):i.push({hdr:'<div class="wj-separator"></div>'});e.removeChild(s);o--}}if(i){this.displayMemberPath="hdr";this.selectedValuePath="val";this.itemsSource=i;this.selectedIndex=n}};return ListBox}(e.Control);t.ListBox=i;var n=function(t){__extends(FormatItemEventArgs,t);function FormatItemEventArgs(i,n,o){var s=t.call(this)||this;s._index=e.asNumber(i);s._data=n;s._item=e.asType(o,HTMLElement,!0);return s}Object.defineProperty(FormatItemEventArgs.prototype,"index",{get:function(){return this._index},enumerable:!0,configurable:!0});Object.defineProperty(FormatItemEventArgs.prototype,"data",{get:function(){return this._data},enumerable:!0,configurable:!0});Object.defineProperty(FormatItemEventArgs.prototype,"item",{get:function(){return this._item},enumerable:!0,configurable:!0});return FormatItemEventArgs}(e.EventArgs);t.FormatItemEventArgs=n}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";e._addCultureInfo("MultiSelectListBox",{filterPlaceholder:"Filter",selectAll:"Select All"});var i=function(i){__extends(MultiSelectListBox,i);function MultiSelectListBox(n,o){var s=i.call(this,n)||this;s._selectAllLabel=null;s._filterPlaceholder=null;s._filterText="";s._checkOnFilter=!0;s._delay=e.Control._SEARCH_DELAY;s.checkedItemsChanged=new e.Event;s.selectedIndexChanged=new e.Event;var r=s.getTemplate();s.applyTemplate("wj-control wj-content wj-multiselectlistbox",r,{_selectAll:"select-all",_filter:"filter",_lbHost:"list-box"});s._selectAll.style.display="none";s._filter.style.display="none";s._lbx=new t.ListBox(s._lbHost,{checkedMemberPath:MultiSelectListBox._DEF_CHECKED_PATH,loadedItems:function(){return s._updateCheckAllCheckbox()},checkedItemsChanged:function(){return s.onCheckedItemsChanged()},selectedIndexChanged:function(){return s.onSelectedIndexChanged()}});s._cbSelectAll=s._selectAll.querySelector("input[type=checkbox]");s._spSelectAll=s._selectAll.querySelector("label>span");var a=e.culture.MultiSelectListBox;e.setText(s._spSelectAll,a.selectAll);s._filter.placeholder=a.filterPlaceholder;s.initialize(o);s.addEventListener(s._filter,"input",(function(){if(s._filter.value!=s._filterText){s._filterText=s._filter.value;s._toSearch&&clearTimeout(s._toSearch);s._toSearch=setTimeout((function(){s._toSearch=null;s._applyFilter()}),s.delay)}}));s.addEventListener(s._cbSelectAll,"click",(function(t){var i=s._lbx.collectionView;e.hasItems(i)&&(s.checkedItems=t.target.checked?i.items:[])}));s.addEventListener(s.hostElement,"keydown",(function(t){var i=s.showFilterInput?s._filter:null,n=s._lbx;if(i&&t.keyCode==e.Key.F3){e.setSelectionRange(i,0,i.value.length);t.preventDefault()}if(e.getActiveElement()==i){var o=!t.altKey;switch(t.keyCode){case e.Key.Escape:case e.Key.F4:o=!1}o&&t.stopPropagation()}if(!n.containsFocus())switch(t.keyCode){case e.Key.Up:case e.Key.Down:s._lbx.focus();var r=n.selectedIndex+(t.keyCode==e.Key.Up?-1:1);n.selectedIndex=Math.max(0,r);t.preventDefault()}}),!0);return s}Object.defineProperty(MultiSelectListBox.prototype,"itemsSource",{get:function(){return this._lbx.itemsSource},set:function(e){this._lbx.itemsSource=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"collectionView",{get:function(){return this._lbx.collectionView},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"displayMemberPath",{get:function(){return this._lbx.displayMemberPath},set:function(e){this._lbx.displayMemberPath=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"isContentHtml",{get:function(){return this._lbx.isContentHtml},set:function(e){this._lbx.isContentHtml=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"caseSensitiveSearch",{get:function(){return this._lbx.caseSensitiveSearch},set:function(e){this._lbx.caseSensitiveSearch=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"delay",{get:function(){return this._delay},set:function(t){this._delay=e.asNumber(t,!1,!0)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"showGroups",{get:function(){return this._lbx.showGroups},set:function(e){this._lbx.showGroups=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"checkOnFilter",{get:function(){return this._checkOnFilter},set:function(t){if(t!=this.checkOnFilter){this._checkOnFilter=e.asBoolean(t);this.checkedItems=[]}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"selectedIndex",{get:function(){return this._lbx.selectedIndex},set:function(e){this._lbx.selectedIndex=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"listBox",{get:function(){return this._lbx},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"showFilterInput",{get:function(){return""==this._filter.style.display},set:function(t){if(t!=this.showFilterInput){this._filter.style.display=e.asBoolean(t)?"":"none";if(!this.showFilterInput){this._filter.value="";this._applyFilter()}}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"filterInputPlaceholder",{get:function(){return this._filterPlaceholder},set:function(t){if(t!=this._filterPlaceholder){this._filterPlaceholder=e.asString(t);this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"showSelectAllCheckbox",{get:function(){return""==this._selectAll.style.display},set:function(t){this._selectAll.style.display=e.asBoolean(t)?"":"none"},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"selectAllLabel",{get:function(){return this._selectAllLabel},set:function(t){if(t!=this._selectAllLabel){this._selectAllLabel=e.asString(t);this.refresh()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"checkedMemberPath",{get:function(){var e=this.listBox.checkedMemberPath;return e!=MultiSelectListBox._DEF_CHECKED_PATH?e:null},set:function(t){t=e.asString(t);this.listBox.checkedMemberPath=t||MultiSelectListBox._DEF_CHECKED_PATH},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelectListBox.prototype,"checkedItems",{get:function(){return this.listBox.checkedItems},set:function(t){this.listBox.checkedItems=e.asArray(t)},enumerable:!0,configurable:!0});MultiSelectListBox.prototype.onCheckedItemsChanged=function(e){this._updateCheckAllCheckbox();this.checkedItemsChanged.raise(this,e)};MultiSelectListBox.prototype.onSelectedIndexChanged=function(e){this.selectedIndexChanged.raise(this,e)};MultiSelectListBox.prototype.refresh=function(t){void 0===t&&(t=!0);i.prototype.refresh.call(this,t);if(this.hostElement){var n=e.culture.MultiSelectListBox;this._filter.placeholder=null!=this._filterPlaceholder?this._filterPlaceholder:n.filterPlaceholder;this._spSelectAll&&e.setText(this._spSelectAll,null!=this._selectAllLabel?this._selectAllLabel:n.selectAll);this._updateCheckAllCheckbox()}};MultiSelectListBox.prototype.dispose=function(){this.listBox.dispose();i.prototype.dispose.call(this)};MultiSelectListBox.prototype._applyFilter=function(){var t=this,i=this._lbx,n=i.collectionView,o=this._filter.value,s=o?new RegExp(e.escapeRegExp(o),i.caseSensitiveSearch?"":"i"):null,r=this.displayMemberPath,a=r?new e.Binding(r):null,l=this.checkOnFilter?null:this.checkedItems;n.filter=function(i){if(null!=s){if(l&&l.indexOf(i)>-1)return!0;a&&(i=a.getValue(i));t.isContentHtml&&(i=e.toPlainText(i));return null!=i&&s.test(i.toString())}return!0};i.selectedIndex=Math.max(0,i.selectedIndex);this._checkOnFilter&&(this.checkedItems=s?n.items:[])};MultiSelectListBox.prototype._updateCheckAllCheckbox=function(){var t=this._lbx.collectionView,i=this._cbSelectAll;if(e.hasItems(t)){var n=t.items.length,o=this.checkedItems.length;e.setChecked(i,o==n||0!=o&&null);i.disabled=!1}else{e.setChecked(i,!1);i.checked=!1;i.disabled=!0}};MultiSelectListBox._DEF_CHECKED_PATH="$checked";MultiSelectListBox.controlTemplate='<div class="wj-template wj-listbox"><input wj-part="filter" class="wj-form-control"><div wj-part="select-all" class="wj-header wj-select-all wj-listbox-item"><label><input type="checkbox" tabindex="-1"> <span></span></label></div><div wj-part="list-box"/></div>';return MultiSelectListBox}(e.Control);t.MultiSelectListBox=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";e._addCultureInfo("Calendar",{ariaLabels:{calendar:"Calendar",monthView:"Month View",yearView:"Year View",prvMo:"Previous Month",today:"Today",nxtMo:"Next Month",prvYr:"Previous Year",currMo:"Current Month",nxtYr:"Next Year"}});var i,n;!function(e){e[e.None=0]="None";e[e.Day=1]="Day";e[e.Month=2]="Month";e[e.Range=3]="Range"}(i=t.DateSelectionMode||(t.DateSelectionMode={}));!function(e){e[e.None=0]="None";e[e.FirstMonth=1]="FirstMonth";e[e.LastMonth=2]="LastMonth";e[e.FirstAndLastMonths=3]="FirstAndLastMonths";e[e.AllMonths=4]="AllMonths";e[e.Outside=5]="Outside"}(n=t.ShowMonthPicker||(t.ShowMonthPicker={}));var o=function(o){__extends(Calendar,o);function Calendar(t,s){var r=o.call(this,t)||this;r._yrPicker=!0;r._mtPicker=n.FirstMonth;r._wksBefore=0;r._wksAfter=0;r._rngMin=0;r._rngMax=0;r._min=null;r._max=null;r._readOnly=!1;r._handleWheel=!0;r._fdw=null;r._selMode=i.Day;r._tmYrHidden=0;r._fmtYrMo="y";r._fmtYr="yyyy";r._fmtDayHdr="ddd";r._fmtDay="d ";r._fmtMonths="MMM";r.valueChanged=new e.Event;r.rangeEndChanged=new e.Event;r.rangeChanged=new e.Event;r.displayMonthChanged=new e.Event;r.formatItem=new e.Event((function(){r.invalidate()}));r._value=r._rngEnd=e.DateTime.newDate();r._month=r._getMonth(r._value);r._cals=[r];r._createChildren();r._createYearPicker();var a=r.hostElement,l=r.addEventListener.bind(r);l(a,"keydown",r._keydown.bind(r));l(a,"click",r._click.bind(r));r._rptUp=new e._ClickRepeater(r._btnPrv);r._rptDn=new e._ClickRepeater(r._btnNxt);r.addEventListener(a,"wheel",(function(e){if(r.handleWheel&&!e.defaultPrevented&&!r.isReadOnly&&r.containsFocus()){e.deltaY<0?r._btnPrv.click():r._btnNxt.click();e.preventDefault()}}));r.initialize(s);r.refresh(!0);return r}Object.defineProperty(Calendar.prototype,"value",{get:function(){return this._value},set:function(t){if(t!==this._value){this._clearingRangeEnd=!e.DateTime.equals(this._value,t);this.rangeEnd=null;this._clearingRangeEnd=!1;t=e.asDate(t,!0);t=this._clamp(t);if(this._valid(t)||null==t){this.ensureVisible(t);if(!e.DateTime.equals(this._value,t)){this._value=t;this.invalidate(!1);this.onValueChanged()}}if(!this.value){var i=this.min,n=this.max,o=this.displayMonth;n&&n<o?this.ensureVisible(n):i&&i>o&&this.ensureVisible(i)}}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"rangeEnd",{get:function(){return this._rngEnd},set:function(t){t=e.asDate(t,!0);if((t=this._clamp(t))&&this._value&&this._rngMode()){t<this._value&&(t=this._value);var i=this._rngMin,n=this._rngMax;if(i&&i>0||n&&n>0){var o=this._value,s=Math.ceil((t.getTime()-o.getTime())/864e5)+1;i&&i>0&&s<i&&(t=e.DateTime.addDays(o,i-1));n&&n>0&&s>n&&(t=e.DateTime.addDays(o,n-1))}}if((this._valid(t)||null==t)&&!e.DateTime.equals(this._rngEnd,t)){this._rngEnd=t;this.ensureVisible(t);this.invalidate(!1);this.onRangeEndChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"rangeMin",{get:function(){return this._rngMin},set:function(t){if((t=e.asNumber(t,!0,!0))!=this._rngMin){this._rngMin=t;this._syncProp(this,"rangeMin");this._rngMode()&&this._rngEnd&&(this.rangeEnd=this._rngEnd)}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"rangeMax",{get:function(){return this._rngMax},set:function(t){if((t=e.asNumber(t,!0,!0))!=this._rngMax){this._rngMax=t;this._syncProp(this,"rangeMax");this._rngMode()&&this._rngEnd&&(this.rangeEnd=this._rngEnd)}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"min",{get:function(){return this._min},set:function(t){if((t=e.asDate(t,!0))!=this.min){this._min=t;this._syncProp(this,"min");this.refresh();!this.value&&t&&t>this.displayMonth&&this.ensureVisible(t)}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"max",{get:function(){return this._max},set:function(t){if((t=e.asDate(t,!0))!=this.max){this._max=t;this._syncProp(this,"max");this.refresh();!this.value&&t&&t<this.displayMonth&&this.ensureVisible(t)}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"selectionMode",{get:function(){return this._selMode},set:function(t){var n=i;if((t=e.asEnum(t,n))!=this._selMode){this._selMode=t;this._mthMode()&&(this.monthView=!1);this._rngEnd=t==n.Range?this._value:null;this.refresh();this._syncProp(this,"selectionMode")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(t){this._readOnly=e.asBoolean(t);e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly);this._syncProp(this,"isReadOnly")},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"handleWheel",{get:function(){return this._handleWheel},set:function(t){this._handleWheel=e.asBoolean(t);this._syncProp(this,"handleWheel")},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"repeatButtons",{get:function(){return!this._rptUp.disabled},set:function(t){this._rptUp.disabled=this._rptDn.disabled=!e.asBoolean(t);this._syncProp(this,"repeatButtons")},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"showYearPicker",{get:function(){return this._yrPicker},set:function(t){if(t!=this._yrPicker){this._yrPicker=e.asBoolean(t);this._syncProp(this,"showYearPicker")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"showMonthPicker",{get:function(){return this._mtPicker},set:function(t){if(t!=this._mtPicker){var i=n;e.isBoolean(t)&&(t=t?i.FirstMonth:i.None);this._mtPicker=e.asEnum(t,i);e.toggleClass(this.hostElement,"wj-btns-outside",this._getShowMonthPicker()==i.Outside);this.refresh();this._syncProp(this,"showMonthPicker")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"firstDayOfWeek",{get:function(){return this._fdw},set:function(t){if(t!=this._fdw){if((t=e.asNumber(t,!0))&&(t>6||t<0))throw"firstDayOfWeek must be between 0 and 6 (Sunday to Saturday).";this._fdw=t;this.refresh();this._syncProp(this,"firstDayOfWeek")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"displayMonth",{get:function(){return this._month},set:function(t){t=e.asDate(t);t=this._getMonth(t);var i=this._getDisplayMonthRange();i.to&&t>i.to&&(t=i.to);i.from&&t<i.from&&(t=i.from);if(!e.DateTime.equals(this.displayMonth,t)){this._month=t;this.invalidate(!0);this.onDisplayMonthChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"monthCount",{get:function(){var e=this.hostElement;return e?e.querySelectorAll(".wj-calendar").length+1:0},set:function(t){var i=this,n=this.hostElement;if(t!=this.monthCount&&n){var o=n.querySelectorAll(".wj-calendar");t=e.asInt(t,!1);e.assert(t>0,"monthCount must be >= 1.");e.assert(1==t||!e.closest(n.parentElement,".wj-calendar"),"Only top-level calendars can set monthCount.");for(var s=0;s<o.length;s++){var r=o[s];e.removeChild(r);this._getCalendar(r).dispose()}this._cals=[this];for(s=1;s<t;s++){(r=new Calendar(document.createElement("div"),{itemFormatter:this.itemFormatter,itemValidator:this.itemValidator,formatItem:function(e,t){return i.onFormatItem(t)}}))._selMode=this._selMode;r._value=this._value;r._rngEnd=this._rngEnd;for(var a in this)if(!/^(_.*|constructor|displayMonth|monthCount|hostElement|rightToLeft|isUpdating|isTouching)$/.test(a)){var l=this[a];e.isFunction(l)||l instanceof e.Event||(r[a]=l)}this._cals.push(r);n.appendChild(r.hostElement)}e.toggleClass(n,"wj-calendar-multimonth",t>1);this._syncProp(this,"displayMonth")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"formatYearMonth",{get:function(){return this._fmtYrMo},set:function(t){if(t!=this._fmtYrMo){this._fmtYrMo=e.asString(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"formatDayHeaders",{get:function(){return this._fmtDayHdr},set:function(t){if(t!=this._fmtDayHdr){this._fmtDayHdr=e.asString(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"formatDays",{get:function(){return this._fmtDay},set:function(t){if(t!=this._fmtDay){this._fmtDay=e.asString(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"formatYear",{get:function(){return this._fmtYr},set:function(t){if(t!=this._fmtYr){this._fmtYr=e.asString(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"formatMonths",{get:function(){return this._fmtMonths},set:function(t){if(t!=this._fmtMonths){this._fmtMonths=e.asString(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"showHeader",{get:function(){return"none"!=this._tbHdr.style.display},set:function(t){if(t!=this.showHeader){this._tbHdr.style.display=e.asBoolean(t)?"":"none";this._syncProp(this,"showHeader")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"monthView",{get:function(){return"none"!=this._tbMth.style.display},set:function(t){if(t!=this.monthView){this._tbMth.style.display=t?"":"none";this._tbYr.style.display=t?"none":"";this.refresh();var i=e.culture.Calendar.ariaLabels;e.setAriaLabel(this._btnPrv,t?i.prvMo:i.prvYr);e.setAriaLabel(this._btnTdy,t?i.today:i.currMo);e.setAriaLabel(this._btnNxt,t?i.nxtMo:i.nxtYr);e.setAriaLabel(this._btnMth,t?i.monthView:i.yearView);this._syncProp(this,"monthView")}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"weeksBefore",{get:function(){return this._wksBefore},set:function(t){if(t!=this._wksBefore){this._wksBefore=Math.floor(e.asNumber(t,!1,!0));this._syncProp(this,"weeksBefore");this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"weeksAfter",{get:function(){return this._wksAfter},set:function(t){if(t!=this._wksAfter){this._wksAfter=Math.floor(e.asNumber(t,!1,!0));this._syncProp(this,"weeksAfter");this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"itemFormatter",{get:function(){return this._itemFormatter},set:function(t){if(t!=this._itemFormatter){this._itemFormatter=e.asFunction(t);this._syncProp(this,"itemFormatter");this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(Calendar.prototype,"itemValidator",{get:function(){return this._itemValidator},set:function(t){if(t!=this._itemValidator){this._itemValidator=e.asFunction(t);this._syncProp(this,"itemValidator");this.invalidate()}},enumerable:!0,configurable:!0});Calendar.prototype.hitTest=function(t){var i=t instanceof MouseEvent?t.target:t instanceof Element?t:null;e.assert(null!=i,"MouseEvent or Element expected");return i?i[Calendar._DATE_KEY]:null};Calendar.prototype.ensureVisible=function(t){if(null!=t){var i=this._getCalendars(),n=i.indexOf(this),o=i[0],s=i[i.length-1];t<o.displayMonth?this.displayMonth=e.DateTime.addMonths(this._getMonth(t),n):t>s.displayMonth&&(this.displayMonth=e.DateTime.addMonths(this._getMonth(t),n-i.length+1))}};Calendar.prototype.onValueChanged=function(e){this.valueChanged.raise(this,e);this._syncProp(this,"value")};Calendar.prototype.onRangeEndChanged=function(e){this.rangeEndChanged.raise(this,e);this._syncProp(this,"rangeEnd");this._value&&this._rngEnd&&this.onRangeChanged(e)};Calendar.prototype.onRangeChanged=function(e){this.rangeChanged.raise(this,e)};Calendar.prototype.onDisplayMonthChanged=function(e){this.displayMonthChanged.raise(this,e);this._syncProp(this,"displayMonth")};Calendar.prototype.onFormatItem=function(e){this.formatItem.raise(this,e)};Calendar.prototype.containsFocus=function(){return o.prototype.containsFocus.call(this)||this._lbYears.containsFocus()};Calendar.prototype.dispose=function(){this._rptUp.element=null;this._rptDn.element=null;this._lbYears.dispose();o.prototype.dispose.call(this)};Calendar.prototype.refresh=function(t){void 0===t&&(t=!0);var i=this.hostElement,n=this.containsFocus();if(i){o.prototype.refresh.call(this,t);t&&this._updateContent();this._updateSelection();var s=this._getDisplayMonthRange(),r=this.displayMonth;e.enable(this._btnPrv,null==s.from||r>s.from);e.enable(this._btnNxt,null==s.to||r<s.to);if(n){var a=(this.monthView?this._tbMth:this._tbYr).querySelector("td.wj-state-selected")||i;a&&a.focus()}var l=this._getCalendars();l.length>1&&this==l[0]&&l.forEach((function(e,i){i>0&&e.refresh(t)}))}};Calendar.prototype._getShowMonthPicker=function(){var e=n,t=this._getCalendars(),i=t.indexOf(this),o=this.showMonthPicker;switch(o){case e.FirstMonth:case e.Outside:return 0==i?o:0;case e.LastMonth:return i==t.length-1?o:0;case e.FirstAndLastMonths:return 0==i||i==t.length-1?o:0;case e.AllMonths:return o}return 0};Calendar.prototype._getDisplayMonthRange=function(){var t={from:null,to:null};if(this.min||this.max){var i=this._getCalendars(),n=i.indexOf(this),o=this._mthMode()?e.DateTime.addYears:e.DateTime.addMonths;this.min&&(t.from=o(this._getMonth(this.min),n));this.max&&(t.to=o(this._getMonth(this.max),n-i.length+1))}return t};Calendar.prototype._getCalendar=function(t){return e.Control.getControl(t)};Calendar.prototype._getCalendars=function(){var t=e.closest(this.hostElement,".wj-calendar-multimonth");return(t?this._getCalendar(t):this)._cals};Calendar.prototype._syncProp=function(t,i){var n=this;if(!this._syncing){var o=this._getCalendars();if(o&&o.length>1){var s=t[i],r=this._mthMode()?e.DateTime.addYears:e.DateTime.addMonths;"displayMonth"==i&&(s=r(s,-o.indexOf(t)));o[0].deferUpdate((function(){n._syncing=!0;o.forEach((function(e,o){if(e!=t){var a=e.displayMonth;e[i]="displayMonth"==i?r(s,o):s;if("value"==i){e.displayMonth=a;n._rngMode()&&(e.rangeEnd=null)}}}));n._syncing=!1}))}}};Calendar.prototype._updateContent=function(){var t=this.displayMonth,i=e.Globalize.format,n=e.DateTime,o=this._getShowMonthPicker();e.setText(this._spMth,i(t,this._fmtYrMo));var s=this._btnMth.querySelector(".wj-glyph-down");s&&(s.style.display=this._mthMode()||!o?"none":"");var r=e.closest(this._btnTdy,".wj-btn-group");r&&(r.style.display=o?"":"none");for(var a=null!=this._fdw?this._fdw:e.Globalize.getFirstDayOfWeek(),l=n.addDays(t,-(t.getDay()-a+7)%7),h=n.monthLast(t),u=this._tbMth.querySelectorAll("td"),c=0;c<7&&c<u.length;c++){var p=n.addDays(l,c);e.setText(u[c],i(p,this._fmtDayHdr))}var d=this._tbMth.querySelectorAll("tr");for(c=1;c<d.length;c++)e.removeChild(d[c]);var f=n.addDays(l,-7*this._wksBefore);for(c=0;c<this._wksBefore;c++)f=this._addWeek(f,"wj-week-before");for(;f<=h;)f=this._addWeek(f);for(c=0;c<this._wksAfter;c++)f=this._addWeek(f,"wj-week-after");(u=this._tbYr.querySelectorAll("td")).length&&e.setText(u[0],i(t,this._fmtYr));for(c=1;c<u.length;c++){f=n.newDate(t.getFullYear(),c-1,1);var m=u[c],_=!this._monthInValidRange(f);m[Calendar._DATE_KEY]=f;e.setText(m,i(f,this._fmtMonths));e.toggleClass(m,"wj-state-disabled",_);e.setAriaLabel(m,e.Globalize.format(f,"MMMM yyyy"))}};Calendar.prototype._updateSelection=function(){for(var t=Calendar._DATE_KEY,i=e.DateTime,n=this._tbMth.querySelectorAll("td"),o=7;o<n.length;o++){var s=(c=n[o])[t],r=this.value,a=this.rangeEnd,l=this._selMode&&null!=r&&i.sameDate(s,r),h=this._selMode&&null!=r&&i.sameDate(s,a),u=this._selMode&&null!=r&&s>r&&null!=a&&s<=a;e.toggleClass(c,"wj-state-selected",l);e.toggleClass(c,"wj-state-multi-selected",u);e.toggleClass(c,"wj-state-last-selected",h);e.setAttribute(c,"aria-selected",!!l||null);this._customizeCell(o,s,c)}n=this._tbYr.querySelectorAll("td");for(o=0;o<n.length;o++){var c;s=(c=n[o])[t],l=this._sameMonth(s,this.value);e.toggleClass(c,"wj-state-selected",l);e.setAttribute(c,"aria-selected",!!l||null)}};Calendar.prototype._addWeek=function(t,i){for(var n=this._createElement("tr",this._tbMth,i),o=e.DateTime,s=0;s<7;s++){var r=this._createElement("td",n),a=o.addDays(t,s);r[Calendar._DATE_KEY]=a;e.setText(r,e.Globalize.format(a,this._fmtDay));e.setAriaLabel(r,e.Globalize.format(a,"D"));var l=!this._valid(a),h=a.getDay(),u=a.getMonth()!=this.displayMonth.getMonth();e.toggleClass(r,"wj-day-today",o.sameDate(a,o.newDate()));e.toggleClass(r,"wj-day-weekend",0==h||6==h);e.toggleClass(r,"wj-day-othermonth",u||!this._inValidRange(a)||l);e.toggleClass(r,"wj-state-invalid",l)}return o.addDays(t,7)};Calendar.prototype._customizeCell=function(i,n,o){e.isFunction(this.itemFormatter)&&this.itemFormatter(n,o);if(this.formatItem.hasHandlers){var s=new t.FormatItemEventArgs(i,n,o);this.onFormatItem(s)}};Calendar.prototype._canChangeValue=function(){return!this._readOnly&&this._selMode!=i.None};Calendar.prototype._valid=function(t){return!(!e.isDate(t)||!e.DateTime.sameDate(t,this._clamp(t)))&&(!e.isFunction(this.itemValidator)||this.itemValidator(t))};Calendar.prototype._inValidRange=function(t){var i=e.DateTime.fromDateTime;return!(this.min&&t<i(this.min,t))&&!(this.max&&t>i(this.max,t))};Calendar.prototype._monthInValidRange=function(t){if(this.min||this.max){var i=t.getFullYear(),n=t.getMonth(),o=e.DateTime,s=o.newDate(i,n,1),r=o.newDate(i,n+1,0);if(this.min&&this.min>r)return!1;if(this.max&&this.max<s)return!1}return!0};Calendar.prototype._sameMonth=function(t,i){return e.isDate(t)&&e.isDate(i)&&t.getMonth()==i.getMonth()&&t.getFullYear()==i.getFullYear()};Calendar.prototype._getValidDate=function(t,i){if(e.isDate(t))for(var n=t.getFullYear(),o=t.getMonth()+(i?0:1),s=i?1:0,r=e.DateTime,a=r.newDate(n,o,s),l=i?1:-1,h=0;h<31;h++){if(this._valid(a))return a;a=r.addDays(a,l)}return null};Calendar.prototype._clamp=function(t){if(t){var i=e.DateTime.fromDateTime;if(this.min){var n=i(this.min,t);t<n&&(t=n)}if(this.max){var o=i(this.max,t);t>o&&(t=o)}}return t};Calendar.prototype._createChildren=function(){var t=this.getTemplate();this.applyTemplate("wj-control wj-calendar",t,{_tbHdr:"tbl-header",_btnMth:"btn-month",_spMth:"span-month",_btnPrv:"btn-prev",_btnTdy:"btn-today",_btnNxt:"btn-next",_tbMth:"tbl-month",_tbYr:"tbl-year"});this._tbYr.style.display="none";var i=e.culture.Calendar.ariaLabels;e.setAriaLabel(this._tbMth,i.calendar);e.setAriaLabel(this._tbYr,i.calendar);e.setAriaLabel(this._btnPrv,i.calendar);e.setAriaLabel(this._btnMth,i.monthView);e.setAriaLabel(this._btnPrv,i.prvMo);e.setAriaLabel(this._btnTdy,i.today);e.setAriaLabel(this._btnNxt,i.nxtMo);for(var n=this._createElement("tr",this._tbMth,"wj-header"),o=0;o<7;o++)this._createElement("td",n);n=this._createElement("tr",this._tbYr,"wj-header");this._createElement("td",n).setAttribute("colspan","4");for(var s=0;s<3;s++){n=this._createElement("tr",this._tbYr);for(var r=0;r<4;r++)this._createElement("td",n)}};Calendar.prototype._createYearPicker=function(){var i=this,n=this.hostElement,o=this._createElement("div",null,"wj-dropdown-panel wj-yearpicker");o.tabIndex=this._orgTabIndex;this._lbYears=new t.ListBox(o,{lostFocus:function(t){e.hidePopup(o);i._tmYrHidden=Date.now();i.removeEventListener(window,"touchstart");if(t.selectedIndex>-1){var n=e.DateTime.clone(i.displayMonth);n.setFullYear(t.selectedIndex+t.itemsSource[0]);i.displayMonth=n}}});this.addEventListener(o,"keydown",(function(t){switch(t.keyCode){case e.Key.Enter:n.focus();break;case e.Key.Escape:i._lbYears.selectedIndex=-1;n.focus()}t.defaultPrevented&&t.stopPropagation()}));this.addEventListener(o,"click",(function(e){n.focus()}))};Calendar.prototype._createElement=function(t,i,n){var o=document.createElement(t);n&&e.addClass(o,n);i&&i.appendChild(o);return o};Calendar.prototype._click=function(t){var i=this;if(!t.defaultPrevented&&0==t.button){var n=!1,o=t.target;if(e.contains(this._btnMth,o)&&!this._mthMode()&&this._getShowMonthPicker()){this.monthView=!this.monthView;n=!0}else if(e.contains(this._btnPrv,o)){this._navigate(-1);n=!0}else if(e.contains(this._btnNxt,o)){this._navigate(1);n=!0}else if(e.contains(this._btnTdy,o)){this._navigate(0);n=!0}if(o&&!n&&this._yrPicker&&e.contains(this._tbYr,o)&&e.closest(o,".wj-header")){if(Date.now()-this._tmYrHidden<600){t.preventDefault();return}for(var s=this.displayMonth.getFullYear(),r=this.min?this.min.getFullYear():s-100,a=this.max?this.max.getFullYear():s+100,l=[],h=r;h<=a;h++)l.push(h);var u=this._lbYears,c=u.hostElement,p=e.closest(o,".wj-header"),d=this.hostElement,f=e.closest(d,".wj-inputdate-dropdown")||d;u.itemsSource=l;u.selectedIndex=s-l[0];e.setAttribute(c,"dir",this.rightToLeft?"rtl":null);e.setCss(c,{minWidth:"",width:p.offsetWidth});e.showPopup(c,p,!1,!1,f);requestAnimationFrame((function(){u.showSelection(!0)}));this.addEventListener(window,"touchstart",(function(t){if(!e.contains(c,t.target)){e.hidePopup(c);i._tmYrHidden=Date.now();i.removeEventListener(window,"touchstart")}}));t.preventDefault();return}if(o&&!n){var m=e.closest(o,"td");if(m){var _=this.hitTest(m),g=e.DateTime.fromDateTime;if(this.monthView){if(_&&this._canChangeValue()){var b=g(_,this._value);this._inValidRange(b)&&this._valid(b)&&(this._rngMode()&&this.value&&!this.rangeEnd&&b>=this.value?this.rangeEnd=b:this.value=b);n=!0}}else if(_){this.displayMonth=_;if(this._mthMode()){if(this._canChangeValue()){b=g(this.displayMonth,this.value);this._inValidRange(b)&&(this.value=b)}}else this.monthView=!0;n=!0}}}if(n){t.preventDefault();this.focus()}}};Calendar.prototype._keydown=function(t){if(!t.defaultPrevented){if(t.altKey)switch(t.keyCode){case e.Key.Up:case e.Key.Down:return;case e.Key.End:this._navigate(0);t.preventDefault();return}if(!(t.ctrlKey||t.metaKey||t.shiftKey&&!this._rngMode())){var i=this._getKeyCode(t),n=0,o=0,s=!0;if(this.monthView)switch(i){case e.Key.Left:n=-1;break;case e.Key.Right:n=1;break;case e.Key.Up:n=-7;break;case e.Key.Down:n=7;break;case e.Key.PageDown:o=t.altKey?12:1;break;case e.Key.PageUp:o=t.altKey?-12:-1;break;case e.Key.Home:case e.Key.End:if(this._canChangeValue()&&!t.shiftKey){var r=this.value||this.displayMonth;if(l=this._getValidDate(r,i==e.Key.Home)){this.value=e.DateTime.fromDateTime(l,this.value);this._rngEnd=null}}break;default:s=!1}else switch(i){case e.Key.Left:o=-1;break;case e.Key.Right:o=1;break;case e.Key.Up:o=-4;break;case e.Key.Down:o=4;break;case e.Key.PageDown:o=t.altKey?120:12;break;case e.Key.PageUp:o=t.altKey?-120:-12;break;case e.Key.Home:o=this.value?-this.value.getMonth():0;break;case e.Key.End:o=this.value?11-this.value.getMonth():0;break;case e.Key.Enter:this._mthMode()?s=!1:this.monthView=!0;break;default:s=!1}if(this._canChangeValue()&&(n||o)){var a=t.shiftKey&&null!=this.rangeEnd?this.rangeEnd:this.value,l=e.DateTime;if(a){a=l.addDays(a,n);a=l.addMonths(a,o)}else a=this._getValidDate(new Date,!0);if(o&&!this._valid(a)){r=a.getMonth();for(var h=1;h<31&&!this._valid(a);h++){var u=l.addDays(a,+h),c=l.addDays(a,-h);this._valid(u)&&u.getMonth()==r?a=u:this._valid(c)&&c.getMonth()==r&&(a=c)}}for(h=0;h<31&&!this._valid(a);h++)a=l.addDays(a,n>0||o>0?1:-1);t.shiftKey&&a>this.value?this.rangeEnd=a:this.value=a}s&&t.preventDefault()}}};Calendar.prototype._getMonth=function(t){var i=e.DateTime;t=t||i.newDate();return i.newDate(t.getFullYear(),t.getMonth(),1)};Calendar.prototype._mthMode=function(){return this.selectionMode==i.Month};Calendar.prototype._rngMode=function(){return this.selectionMode==i.Range};Calendar.prototype._navigate=function(t){var i=this.monthView,n=this.displayMonth,o=e.DateTime;switch(t){case 0:var s=o.newDate();this._canChangeValue()&&(this.value=i?o.fromDateTime(s,this.value):this._getMonth(s));n=this._getMonth(s);break;case 1:n=o.addMonths(n,i?1:12);break;case-1:n=o.addMonths(n,i?-1:-12)}this.displayMonth=n};Calendar._DATE_KEY="$WJ-DATE";Calendar.controlTemplate='<div class="wj-content wj-calendar-outer"><div wj-part="tbl-header" class="wj-calendar-header"><div wj-part="btn-month" class="wj-month-select" role="button"><span wj-part="span-month"></span> <span class="wj-glyph-down"></span></div><div class="wj-btn-group"><button wj-part="btn-prev" class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-left"></span></button><button wj-part="btn-today" class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-circle"></span></button><button wj-part="btn-next" class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-right"></span></button></div></div><table wj-part="tbl-month" class="wj-calendar-month" role="grid"></table><table wj-part="tbl-year" class="wj-calendar-year" role="grid"></table></div>';return Calendar}(e.Control);t.Calendar=o}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";e._addCultureInfo("DropDown",{ariaLabels:{tgl:"Toggle Dropdown"}});var i;!function(e){e[e.Select=0]="Select";e[e.Open=1]="Open";e[e.Toggle=2]="Toggle"}(i=t.ClickAction||(t.ClickAction={}));var n=function(t){__extends(DropDown,t);function DropDown(n,o){var s=t.call(this,n)||this;s._clickAction=i.Select;s._showBtn=!0;s._autoExpand=!0;s._animate=!1;s._oldText="";s.textChanged=new e.Event;s.isDroppedDownChanging=new e.Event;s.isDroppedDownChanged=new e.Event;var r=s.getTemplate();s.applyTemplate("wj-control wj-content wj-dropdown",r,{_tbx:"input",_btn:"btn",_dropDown:"dropdown"},"input");s._dropDown.style.display="none";var a=e.culture.DropDown.ariaLabels;e.setAriaLabel(s._btn.querySelector("button"),a.tgl);var l=s._elRef=s._tbx;e.disableAutoComplete(l);s._createDropDown();s._updateBtn();var h=s.hostElement;e.addClass(h,"wj-state-collapsed");s.addEventListener(window,"resize",(function(){s.isDroppedDown&&s.invalidate()}));var u=s.dropDown,c=s.addEventListener.bind(s),p=s._updateFocusState.bind(s);c(u,"blur",p,!0);c(u,"focus",p);var d=s._keydown.bind(s);c(h,"keydown",d);c(u,"keydown",d);var f=s._keypress.bind(s);c(h,"keypress",f,!0);c(u,"keypress",f,!0);c(l,"input",(function(){s._setText(s.text,!1)}));c(l,"blur",(function(){s._commitText()}),!0);c(l,"click",(function(){s._autoExpand&&s._expandSelection()}));c(l,"mousedown",(function(e){switch(s._clickAction){case i.Open:if(!s.isDroppedDown){e.preventDefault();s.focus();s.isDroppedDown=!0}break;case i.Toggle:e.preventDefault();s.focus();s.isDroppedDown=!s.isDroppedDown}}));c(s._btn,"mousedown",(function(e){s._btnclick(e)}));e.removeChild(u);e.isIE()&&s._elRef==s._tbx&&c(h,"mouseup",(function(t){if(!t.defaultPrevented&&0==t.button&&e.hasClass(t.target,"wj-btn")){var i=e.getActiveElement();i&&i!=t.target&&setTimeout((function(){i.focus()}))}}));e.isIE9()&&c(l,"keyup",(function(){s._setText(s.text,!1)}));c(u,"click",s._dropDownClick.bind(s));return s}Object.defineProperty(DropDown.prototype,"text",{get:function(){return this._tbx.value},set:function(e){if(e!=this.text){this._setText(e,!0);this._commitText()}},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"inputType",{get:function(){return this._tbx.type},set:function(t){this._tbx.type=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"isReadOnly",{get:function(){return this._tbx.readOnly},set:function(t){this._tbx.readOnly=e.asBoolean(t);e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"isRequired",{get:function(){return this._tbx.required},set:function(t){this._tbx.required=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"placeholder",{get:function(){return this._tbx.placeholder},set:function(e){this._tbx.placeholder=e},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"clickAction",{get:function(){return this._clickAction},set:function(t){this._clickAction=e.asEnum(t,i)},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"isDroppedDown",{get:function(){var e=this._dropDown;return e&&"none"!=e.style.display},set:function(t){var i=this,n=this.hostElement,o=this._dropDown,s=this.containsFocus();if(n&&o&&(t=e.asBoolean(t)&&!this.isDisabled&&!this.isReadOnly&&n.offsetWidth>0)!=this.isDroppedDown&&this.onIsDroppedDownChanging(new e.CancelEventArgs)){if(t){this._minWidthDropdown=o.style.minWidth;o.style.display="";this._updateDropDown();this.addEventListener(window,"touchstart",(function(t){for(var o=t.target;o;){if(o==n)return;o=o[e.Control._OWNR_KEY]||o.parentNode}e.Control._touching=!0;i.isDroppedDown=!1;e.Control._touching=!1}))}else{this.removeEventListener(window,"touchstart");e.hidePopup(o);o.style.minWidth=this._minWidthDropdown}s&&(this.isTouching&&this.showDropDownButton?n.focus():this.selectAll());this._updateFocusState();e.toggleClass(n,"wj-state-collapsed",!this.isDroppedDown);this.onIsDroppedDownChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"dropDown",{get:function(){return this._dropDown},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"dropDownCssClass",{get:function(){return this._cssClass},set:function(t){if(t!=this._cssClass){e.removeClass(this._dropDown,this._cssClass);this._cssClass=e.asString(t);e.addClass(this._dropDown,this._cssClass)}},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"showDropDownButton",{get:function(){return this._showBtn},set:function(t){this._showBtn=e.asBoolean(t);this._updateBtn()},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"autoExpandSelection",{get:function(){return this._autoExpand},set:function(t){this._autoExpand=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(DropDown.prototype,"isAnimated",{get:function(){return this._animate},set:function(t){this._animate=e.asBoolean(t)},enumerable:!0,configurable:!0});DropDown.prototype.selectAll=function(){var t=this._tbx;this._elRef==t&&e.setSelectionRange(t,0,this.text.length);this.containsFocus()||this.focus()};DropDown.prototype.onTextChanged=function(e){this.textChanged.raise(this,e);this._updateState()};DropDown.prototype.onIsDroppedDownChanging=function(e){this.isDroppedDownChanging.raise(this,e);return!e.cancel};DropDown.prototype.onIsDroppedDownChanged=function(e){this.isDroppedDownChanged.raise(this,e)};DropDown.prototype.onGotFocus=function(i){this.isTouching||e.contains(this._dropDown,e.getActiveElement())||this.selectAll();t.prototype.onGotFocus.call(this,i)};DropDown.prototype.onLostFocus=function(e){this._commitText();this.isDroppedDown=!1;t.prototype.onLostFocus.call(this,e)};DropDown.prototype.containsFocus=function(){return t.prototype.containsFocus.call(this)||this.isDroppedDown&&e.contains(this._dropDown,e.getActiveElement())};DropDown.prototype.dispose=function(){this.isDroppedDown=!1;var i=this._dropDown;if(i){this._dropDown=null;e.removeChild(i);var n=e.Control.getControl(i);n&&n.dispose()}t.prototype.dispose.call(this)};DropDown.prototype.refresh=function(i){void 0===i&&(i=!0);t.prototype.refresh.call(this,i);var n=this.hostElement;if(n&&n.offsetHeight&&this.isDroppedDown){var o=e.getActiveElement();this.isAnimated&&""!=this._dropDown.style.opacity||e.showPopup(this._dropDown,n,!1,!1,null==this.dropDownCssClass);o instanceof HTMLElement&&o!=e.getActiveElement()&&o.focus()}};DropDown.prototype._handleResize=function(){this.isDroppedDown&&this.refresh()};DropDown.prototype._dropDownClick=function(e){e.stopPropagation()};DropDown.prototype._expandSelection=function(){var t=this._tbx,i=t.value,n=t.selectionStart,o=t.selectionEnd;if(i&&n==o){var s=this._getCharType(i,n);if(s>-1){for(;o<i.length&&this._getCharType(i,o)==s;o++);for(;n>0&&this._getCharType(i,n-1)==s;n--);n!=o&&e.setSelectionRange(t,n,o)}}};DropDown.prototype._getCharType=function(e,t){var i=e[t];return i>="0"&&i<="9"?0:i>="a"&&i<="z"||i>="A"&&i<="Z"?1:-1};DropDown.prototype._keydown=function(t){if(!t.defaultPrevented&&!this._isHiddenEditor()){switch(t.keyCode){case e.Key.Tab:case e.Key.Escape:case e.Key.Enter:if(this.isDroppedDown){this.isDroppedDown=!1;t.keyCode==e.Key.Tab||this.containsFocus()||this.focus();t.preventDefault()}break;case e.Key.F4:case e.Key.Up:case e.Key.Down:if(t.keyCode==e.Key.F4||t.altKey){var i=this.hostElement;if(i&&i.offsetHeight){this.isDroppedDown=!this.isDroppedDown;t.preventDefault()}}}if(!t.defaultPrevented&&t.keyCode==e.Key.Escape&&e.isIE()){var n=this._tbx;if(t.target==n){var o=n.value;n.value=o+" ";n.value=o}}}};DropDown.prototype._isHiddenEditor=function(){return e.hasClass(this._tbx,"wj-grid-ime")};DropDown.prototype._keypress=function(e){"AltLeft"!=e.code&&"AltRight"!=e.code||e.preventDefault()};DropDown.prototype._btnclick=function(e){if(!e.defaultPrevented&&0==e.button){e.preventDefault();this.focus();this.isDroppedDown=!this.isDroppedDown}};DropDown.prototype._setText=function(e,t){(e=(e||"").toString())!=this._tbx.value&&(this._tbx.value=e);if(e!=this._oldText){this._oldText=e;this.onTextChanged()}this._updateState()};DropDown.prototype._updateBtn=function(){this._btn.style.display=this._showBtn?"":"none"};DropDown.prototype._createDropDown=function(){};DropDown.prototype._commitText=function(){};DropDown.prototype._updateDropDown=function(){if(this.isDroppedDown){this._commitText();var t=this.dropDown;e.setAttribute(t,"dir",this.rightToLeft?"rtl":null);e.showPopup(t,this.hostElement,!1,this._animate,null==this.dropDownCssClass)}};DropDown.controlTemplate='<div class="wj-template"><div class="wj-input"><div class="wj-input-group wj-input-btn-visible"><input wj-part="input" type="text" class="wj-form-control"><span wj-part="btn" class="wj-input-group-btn"><button class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-down"></span></button></span></div></div><div wj-part="dropdown" class="wj-content wj-dropdown-panel"></div></div>';return DropDown}(e.Control);t.DropDown=n}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i,n;!function(e){e[e.None=0]="None";e[e.ClickOwner=1]="ClickOwner";e[e.ClickPopup=2]="ClickPopup";e[e.Click=3]="Click";e[e.BlurOwner=4]="BlurOwner";e[e.BlurPopup=8]="BlurPopup";e[e.Blur=12]="Blur";e[e.ClickOrBlur=15]="ClickOrBlur";e[e.DownOwner=16]="DownOwner";e[e.DownPopup=32]="DownPopup";e[e.Down=48]="Down";e[e.EnterOwner=64]="EnterOwner";e[e.EnterPopup=128]="EnterPopup";e[e.Enter=192]="Enter";e[e.LeaveOwner=256]="LeaveOwner";e[e.LeavePopup=512]="LeavePopup";e[e.Leave=768]="Leave"}(i=t.PopupTrigger||(t.PopupTrigger={}));!function(e){e[e.None=0]="None";e[e.Left=1]="Left";e[e.Top=2]="Top";e[e.Right=4]="Right";e[e.Bottom=8]="Bottom";e[e.LeftTop=3]="LeftTop";e[e.RightTop=6]="RightTop";e[e.RightBottom=12]="RightBottom";e[e.LeftBottom=9]="LeftBottom"}(n||(n={}));var o=function(o){__extends(Popup,o);function Popup(t,n){var s=o.call(this,t)||this;s._owner=null;s._modal=!1;s._position=e.PopupPosition.BelowLeft;s._showTrigger=i.ClickOwner;s._hideTrigger=i.Blur;s._hideAnim=[];s._fadeIn=!0;s._fadeOut=!0;s._removeOnHide=!0;s._draggable=!1;s._resizable=!1;s._result=null;s._resultEnter=null;s._resultSubmit=null;s._callback=null;s._visible=!1;s._ownerClickBnd=s._ownerClick.bind(s);s._ownerDownBnd=s._ownerDown.bind(s);s._ownerBlurBnd=s._ownerBlur.bind(s);s._ownerEnterBnd=s._ownerEnter.bind(s);s._ownerLeaveBnd=s._ownerLeave.bind(s);s._mousedownBnd=s._mousedown.bind(s);s._mousemoveBnd=s._mousemove.bind(s);s._mousedragBnd=s._mousedrag.bind(s);s._mouseupBnd=s._mouseup.bind(s);s._hideBnd=s.hide.bind(s);s._lastShow=0;s.showing=new e.Event;s.shown=new e.Event;s.hiding=new e.Event;s.hidden=new e.Event;s.resizing=new e.Event;s.resized=new e.Event;s.dragging=new e.Event;s.dragged=new e.Event;s.sizeChanging=new e.Event;s.sizeChanged=new e.Event;s.positionChanging=new e.Event;s.positionChanged=new e.Event;var r=s.hostElement;e.addClass(r,"wj-control wj-content wj-popup");r.getAttribute("tabindex")||(r.tabIndex=0);e.hidePopup(r,!1);var a=s.addEventListener.bind(s);a(r,"compositionstart",(function(){s._composing=!0}));a(r,"compositionend",(function(){s._composing=!1}));a(window,"resize",(function(){!s.isVisible||s._dragged||s.isTouching||s.invalidate()}));a(r,"keydown",(function(t){if(!t.defaultPrevented){if(t.keyCode==e.Key.Escape&&!s._composing){t.preventDefault();s.hide()}if(t.keyCode==e.Key.Enter&&!s._composing){var i=s.dialogResultEnter;if(i){t.preventDefault();s._validateAndHide(i)}}if(t.keyCode==e.Key.Tab&&s.modal){t.preventDefault();e.moveFocus(r,t.shiftKey?-1:1)}}}));a(r,"click",(function(e){var t=e.target;if(t instanceof HTMLElement){if(t instanceof HTMLButtonElement&&"submit"==t.type){var i=s.hostElement,n=s.dialogResultSubmit;if(i instanceof HTMLFormElement&&n&&i.reportValidity()){e.preventDefault();s.hide(n)}}var o=t.className.match(/\bwj-hide[\S]*\b/);if(o&&o.length>0){e.preventDefault();e.stopPropagation();s.hide(o[0])}}}));var l=s._toggle.bind(s),h=i;s.addEventListener(r,"click",(function(e){s._ignoreClick||l(e,h.ClickPopup)}),!0);s.addEventListener(r,"mousedown",(function(e){s._ignoreClick=!1;l(e,h.DownPopup)}),!0);s.addEventListener(r,"mouseenter",(function(e){e.target==r&&l(e,h.EnterPopup)}),!0);s.addEventListener(r,"mouseleave",(function(e){e.target==r&&l(e,h.LeavePopup)}),!0);s.addEventListener(r,"blur",(function(e){s.containsFocus()||l(e,h.BlurPopup)}),!0);a(document,"wheel",(function(e){if(s.isVisible&&s._modal){for(var t=e.target;t&&t!=document.body;t=t.parentElement)if(t.scrollHeight>t.clientHeight)return;e.preventDefault()}}));s.initialize(n);return s}Object.defineProperty(Popup.prototype,"owner",{get:function(){return this._owner},set:function(t){var i=this._owner;if(i){this.removeEventListener(i,"click");this.removeEventListener(i,"mousedown");this.removeEventListener(i,"mouseenter");this.removeEventListener(i,"mouseleave");this.removeEventListener(i,"blur")}if(i=this._owner=null!=t?e.getElement(t):null){this.addEventListener(i,"click",this._ownerClickBnd,!0);this.addEventListener(i,"mousedown",this._ownerDownBnd,!0);this.addEventListener(i,"mouseenter",this._ownerEnterBnd,!0);this.addEventListener(i,"mouseleave",this._ownerLeaveBnd,!0);this.addEventListener(i,"blur",this._ownerBlurBnd,!0)}},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"position",{get:function(){return this._position},set:function(t){this._position=e.asEnum(t,e.PopupPosition)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"content",{get:function(){return this.hostElement.firstElementChild},set:function(e){if(e!=this.content){this.hostElement.innerHTML="";e instanceof HTMLElement&&this.hostElement.appendChild(e)}},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"showTrigger",{get:function(){return this._showTrigger},set:function(t){this._showTrigger=e.asEnum(t,i)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"hideTrigger",{get:function(){return this._hideTrigger},set:function(t){this._hideTrigger=e.asEnum(t,i)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"fadeIn",{get:function(){return this._fadeIn},set:function(t){this._fadeIn=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"fadeOut",{get:function(){return this._fadeOut},set:function(t){this._fadeOut=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"removeOnHide",{get:function(){return this._removeOnHide},set:function(t){if((t=e.asBoolean(t))!=this.removeOnHide){this._removeOnHide=t;if(!this.isVisible){var i=this.hostElement;if(t)e.removeChild(i);else if(i&&document.body){i.style.display="none";document.body.appendChild(i)}}}},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"modal",{get:function(){return this._modal},set:function(t){this._modal=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"isDraggable",{get:function(){return this._draggable},set:function(t){this._draggable=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"isResizable",{get:function(){return this._resizable},set:function(t){this._resizable=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"dialogResult",{get:function(){return this._result},set:function(e){this._result=e},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"dialogResultEnter",{get:function(){return this._resultEnter},set:function(e){this._resultEnter=e},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"dialogResultSubmit",{get:function(){return this._resultSubmit},set:function(t){this._resultSubmit=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(Popup.prototype,"isVisible",{get:function(){var e=this.hostElement;return this._visible&&null!=e&&e.offsetHeight>0},enumerable:!0,configurable:!0});Popup.prototype.show=function(t,n){var o=this;this._lastShow=Date.now();if(!this.isVisible){var s=this.hostElement;this.dialogResult=null;this._callback=null;this._oldFocus=null;this._myFocus=null;this._hideAnim.forEach((function(e){clearInterval(e)}));this._hideAnim.length=0;var r=new e.CancelEventArgs;if(this.onShowing(r)){null!=t&&(this.modal=e.asBoolean(t));null!=n&&(this._callback=e.asFunction(n));this._oldFocus=e.getActiveElement();e.showPopup(s,this._owner,this._position,this._fadeIn,!1,this._hideBnd);this._modal&&this._showBackdrop();this._composing=!1;this._visible=!0;this.onShown(r);this._clearTimeouts();if(this.modal){this.addEventListener(window,"focus",(function(){if(!o.containsFocus()){var t=o._myFocus;t&&t.offsetHeight?t.focus():e.moveFocus(s,0)}}));this.addEventListener(s,"focusin",(function(){var t=e.getActiveElement();t&&e.contains(s,t)&&(t.tabIndex>-1||!o._myFocus)&&(o._myFocus=t)}))}this._resized=this._dragged=this._ignoreClick=!1;this._handleDragResize(!0);this.addEventListener(window,"touchstart",(function(t){o._hideTrigger&i.Blur&&!e.contains(s,t.target,!0)&&o.hide()}));setTimeout((function(){if(!o.containsFocus()&&!o.isTouching){var t=s.querySelector("[autofocus]");if(t&&t.clientHeight>0&&!t.disabled&&t.tabIndex>-1&&!e.closest(t,"[disabled],.wj-state-disabled")){t.focus();e.isFunction(t.select)&&t.select()}else e.moveFocus(s,0)}if(!o.containsFocus()){s.tabIndex=0;s.focus()}}),100)}}};Popup.prototype.hide=function(n){var o=this;this._handleDragResize(!1);this.removeEventListener(window,"touchstart");if(this.isVisible){e.isUndefined(n)||(this.dialogResult=n);var s=new e.CancelEventArgs,r=this.hostElement;if(this.onHiding(s)){for(var a=this.containsFocus()?this._oldFocus:null,l=r.querySelectorAll(".wj-control.wj-dropdown"),h=0;h<l.length;h++){var u=e.Control.getControl(l[h]);u instanceof t.DropDown&&(u.isDroppedDown=!1)}var c=this.removeOnHide,p=this.fadeOut;this._bkDrop&&this._hideAnim.push(e.hidePopup(this._bkDrop,c,p));this._hideAnim.push(e.hidePopup(r,c,p));this._visible=!1;this._oldFocus=null;this._myFocus=null;this.removeEventListener(window,"focus");this.removeEventListener(r,"focusin");this.containsFocus()&&e.getActiveElement().blur();setTimeout((function(){o._updateState();o.onHidden(s);o._callback&&o._callback(o);if(o.hideTrigger&i.LeavePopup){var t=e.Control.getControl(e.closest(o.owner,".wj-popup"));if(t instanceof Popup&&0!=(t.hideTrigger&i.Leave)){var n=Popup._evtHover,r=n?document.elementFromPoint(n.clientX,n.clientY):null,a=e.Control.getControl(e.closest(r,".wj-popup"));a instanceof Popup&&!a.isVisible&&(r=null);r&&e.contains(t.hostElement,r,!0)||t.hide()}}}));this._clearTimeouts();!this.isVisible&&a&&a.offsetHeight&&a.focus()}}};Popup.prototype.onShowing=function(e){this.showing.raise(this,e);return!e.cancel};Popup.prototype.onShown=function(e){this.shown.raise(this,e)};Popup.prototype.onHiding=function(e){this.hiding.raise(this,e);return!e.cancel};Popup.prototype.onHidden=function(e){this._wasVisible=!1;this.hidden.raise(this,e)};Popup.prototype.onResizing=function(e){this.resizing.raise(this,e);return!e.cancel};Popup.prototype.onResized=function(e){this.resized.raise(this,e)};Popup.prototype.onDragging=function(e){this.dragging.raise(this,e);return!e.cancel};Popup.prototype.onDragged=function(e){this.dragged.raise(this,e)};Popup.prototype.onSizeChanging=function(e){this.sizeChanging.raise(this,e);return!e.cancel};Popup.prototype.onSizeChanged=function(e){this.sizeChanged.raise(this,e)};Popup.prototype.onPositionChanging=function(e){this.positionChanging.raise(this,e);return!e.cancel};Popup.prototype.onPositionChanged=function(e){this.positionChanged.raise(this,e)};Popup.prototype.onLostFocus=function(e){o.prototype.onLostFocus.call(this,e);if(this._hideTrigger&i.BlurPopup&&!this.containsFocus()){var t=document.createEvent("Event");t.initEvent("blur",!0,!0);this._toggle(t,i.BlurPopup)}};Popup.prototype.dispose=function(){this.owner=null;o.prototype.dispose.call(this)};Popup.prototype.refresh=function(i){void 0===i&&(i=!0);var n=this.hostElement;o.prototype.refresh.call(this,i);if(this.isVisible&&!this._refreshing&&n){this._refreshing=!0;for(var s=e.getActiveElement(),r=this._owner?this._owner.getBoundingClientRect():null,a=[],l=n.querySelectorAll(".wj-dropdown"),h=0;h<l.length;h++){var u=e.Control.getControl(l[h]);if(u instanceof t.DropDown&&u.isDroppedDown){a.push(u);u.dropDown.style.display="none"}}e.showPopup(n,r,this._position);a.forEach((function(e){e.dropDown.style.display="";e._updateDropDown()}));this._modal&&s instanceof HTMLElement&&s!=e.getActiveElement()&&s.focus();this._refreshing=!1}};Popup.prototype._clearTimeouts=function(){if(this._toShow){clearTimeout(this._toShow);this._toShow=null}if(this._toHideLeave){clearTimeout(this._toHideLeave);this._toHideLeave=null}if(this._toHideBlur){clearTimeout(this._toHideBlur);this._toHideBlur=null}};Popup.prototype._handleDragResize=function(e){var t=this.hostElement,i=this._draggable?this._getHeaderElement():null,n=this.addEventListener.bind(this),o=this.removeEventListener.bind(this),s=this._mousemoveBnd,r=this._mousedownBnd;if(e){n(t,"mousemove",s);n(t,"mousedown",r);n(t,"touchstart",r);i&&(i.style.touchAction="none")}else{this._mousedownEvt=null;this._rcBounds=null;o(t,"mousemove",s);o(t,"mousedown",r);o(t,"touchstart",r);o(document,"mousemove",this._mousedragBnd);o(document,"mouseup",this._mouseupBnd);i&&(i.style.touchAction="")}};Popup.prototype._mousemove=function(e){if(!this._mousedownEvt){var t=this.hostElement,i=this._getEdges(t,e),o="",s=n;this._edges=i;this._resizable&&(i==s.LeftTop||i==s.RightBottom?o="nwse-resize":i==s.LeftBottom||i==s.RightTop?o="nesw-resize":i==s.Left||i==s.Right?o="ew-resize":i!=s.Top&&i!=s.Bottom||(o="ns-resize"));this._draggable&&!o&&this._getClosestHeader(e.target)&&(o="move");t.style.cursor=o}};Popup.prototype._mousedown=function(t){if(!t.defaultPrevented){var i=t.touches&&t.touches.length>0?t.touches[0]:t;this._edges=this._getEdges(this.hostElement,i);if(this._edges||this._draggable&&this._getClosestHeader(t.target)){var n=new e.CancelEventArgs;if(this._edges?this.onResizing(n):this.onDragging(n)){this._mousedownEvt=i;this._rcBounds=this.hostElement.getBoundingClientRect();var o=this.addEventListener.bind(this),s=document,r=this._mousedragBnd,a=this._mouseupBnd;o(s,"mousemove",r);o(s,"touchmove",r);o(s,"mouseup",a);o(s,"touchend",a)}}this._ignoreClick=!1}};Popup.prototype._mouseup=function(){this._mousedownEvt=null;this._rcBounds=null;var e=this.removeEventListener.bind(this),t=document,i=this._mousedragBnd,n=this._mouseupBnd;e(t,"mousemove",i);e(t,"touchmove",i);e(t,"mouseup",n);e(t,"touchend",n);this._resized?this.onResized():this._dragged&&this.onDragged();this._resized=this._dragged=this._ignoreClick=!1};Popup.prototype._mousedrag=function(t){if(!t.defaultPrevented){var i=this.hostElement,o=this._mousedownEvt,r=t.touches&&t.touches.length>0?t.touches[0]:t,a=r.clientX-o.clientX,l=r.clientY-o.clientY,h=this._rcBounds,u=this._edges,c=Popup._SZ_MIN,p=e.Rect.fromBoundingRect(h);if(u){if(u&n.Left){p.left=h.left+a+(r.pageX-r.clientX);p.width=Math.max(h.width-a,c)}else if(u&n.Right){p.left=h.left;p.width=Math.max(h.width+a,c)}if(u&n.Top){p.top=h.top+l+(r.pageY-r.clientY);p.height=Math.max(h.height-l,c)}else if(u&n.Bottom){p.top=h.top;p.height=Math.max(h.height+l,c)}if(this.onSizeChanging(new s(p))){e.setCss(i,{left:p.left,top:p.top,width:p.width,height:p.height});this._resized=this._dragged=this._ignoreClick=!0;this.onSizeChanged()}if(!window.ResizeObserver)for(var d=this.hostElement.children,f=0;f<d.length;f++)e.Control.invalidateAll(d[f])}else if(this._draggable&&(this._dragged||Math.abs(a)+Math.abs(l)>Popup._DRAG_THRESHOLD)){p.left=Math.max(h.left+a+(r.pageX-r.clientX),50-h.width);p.top=Math.max(h.top+l+(r.pageY-r.clientY),0);if(this.onPositionChanging(new s(p))){e.setCss(i,{left:p.left,top:p.top});this._dragged=this._ignoreClick=!0;this.onPositionChanged()}}}};Popup.prototype._getEdges=function(e,t){var i=0;if(this._resizable){var o=e.getBoundingClientRect(),s=Popup._SZ_EDGE;t.clientX-o.left<s&&(i|=n.Left);t.clientY-o.top<s&&(i|=n.Top);o.right-t.clientX<s&&(i|=n.Right);o.bottom-t.clientY<s&&(i|=n.Bottom)}return i};Popup.prototype._ownerClick=function(e){this._toggle(e,i.ClickOwner)};Popup.prototype._ownerDown=function(e){this._wasVisible=this.isVisible;this._toggle(e,i.DownOwner)};Popup.prototype._ownerBlur=function(t){e.contains(this._owner,e.getActiveElement())||this._toggle(t,i.BlurOwner)};Popup.prototype._ownerEnter=function(e){e.target==this._owner&&this._toggle(e,i.EnterOwner)};Popup.prototype._ownerLeave=function(e){e.target==this._owner&&this._toggle(e,i.LeaveOwner)};Popup.prototype._toggle=function(t,n){var o=this;t instanceof MouseEvent&&(Popup._evtHover=t);if(!("mouseenter"==t.type&&Date.now()-this._lastShow<300||t.defaultPrevented)){var s=0!=(this._hideTrigger&n),r=0!=(this._showTrigger&n),a=i;(s||r)&&this._clearTimeouts();s&&this.isVisible&&(n&a.Leave?this._toHideLeave=setTimeout((function(){var t=Popup._evtHover,i=t?document.elementFromPoint(t.clientX,t.clientY):null;i&&e.contains(o.hostElement,i,!0)||o.hide()}),e.Control._LEAVE_DELAY):n&a.Blur?this._toHideBlur=setTimeout((function(){o.containsFocus()||e.contains(o._owner,e.getActiveElement())||o.hide()}),e.Control._FOCUS_INTERVAL+50):this.hide());r&&n!=a.ClickPopup&&(this._wasVisible||(n&a.Enter?this._toShow=setTimeout((function(){o.show()}),e.Control._HOVER_DELAY):this.show()))}};Popup.prototype._getHeaderElement=function(){var e=this.hostElement;return e.querySelector(".wj-dialog-header")||e.querySelector(".modal-header")};Popup.prototype._getClosestHeader=function(t){return e.closest(t,".wj-dialog-header")||e.closest(t,".modal-header")};Popup.prototype._showBackdrop=function(){var t=this;if(!this._bkDrop){this._bkDrop=document.createElement("div");this._bkDrop.tabIndex=-1;e.addClass(this._bkDrop,"wj-popup-backdrop");this.addEventListener(this._bkDrop,"mousedown",(function(e){e.preventDefault();e.stopPropagation();t.hostElement.focus();t.hideTrigger&i.Blur&&t.hide()}))}e.setCss(this._bkDrop,{zIndex:e.Control._POPUP_ZINDEX,display:""});var n=this.hostElement;n.parentElement.insertBefore(this._bkDrop,n)};Popup.prototype._validateAndHide=function(e){var t=this.hostElement;if(t instanceof HTMLFormElement)t.reportValidity()&&this.hide(e);else{var i=this.hostElement.querySelector(":invalid");i?i.focus():this.hide(e)}};Popup._DRAG_THRESHOLD=6;Popup._SZ_EDGE=10;Popup._SZ_MIN=40;return Popup}(e.Control);t.Popup=o;var s=function(e){__extends(PopupBoundsChangingEventArgs,e);function PopupBoundsChangingEventArgs(t){var i=e.call(this)||this;i._rc=t;return i}Object.defineProperty(PopupBoundsChangingEventArgs.prototype,"bounds",{get:function(){return this._rc},enumerable:!0,configurable:!0});return PopupBoundsChangingEventArgs}(e.CancelEventArgs);t.PopupBoundsChangingEventArgs=s}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(i){__extends(InputDate,i);function InputDate(n,o){var s=i.call(this,n)||this;s._fmt="d";s._sep=" - ";s._rngs=null;s._showCal=!1;s._clsOnSel=!0;s._handleWheel=!0;s._clicked=!1;s._rangeChanged=!1;s.valueChanged=new e.Event;s.rangeEndChanged=new e.Event;s.rangeChanged=new e.Event;e.addClass(s.hostElement,"wj-inputdate");s._msk=new e._MaskProvider(s._tbx);e.isIE9()||(s.inputType="tel");s._tbx.type.match(/^(tel|text|)$/i)||(s.inputType="text");s.addEventListener(s.hostElement,"wheel",(function(i){if(s.handleWheel&&!i.defaultPrevented&&!s.isDroppedDown&&s.containsFocus()&&null!=s.value&&s._canChangeValue()){var n=e.clamp(-i.deltaY,-1,1),o=s.value;s.value=s.selectionMode==t.DateSelectionMode.Month?e.DateTime.addMonths(o,n):e.DateTime.addDays(o,n);s.selectAll();i.preventDefault()}}));var r=s._lbx=new t.ListBox(document.createElement("div"),{displayMemberPath:"name",selectedIndexChanged:function(t){var i=t.selectedItem,n=e.DateTime.fromDateTime;if(i&&i.from&&i.to){var o=s.value;s.value=n(i.from,o);s.rangeEnd=n(i.to,o);s._selectAll()}else s._cal.hostElement.style.display=""}}),a=s._cal=new t.Calendar(document.createElement("div")),l=s._dropDown;e.addClass(l,"wj-inputdate-dropdown");l.appendChild(r.hostElement);l.appendChild(a.hostElement);s.addEventListener(l,"click",(function(){s._clicked=!0;setTimeout((function(){s._clicked=!1}),50)}),!0);if("INPUT"==s._orgTag){var h=s._tbx.getAttribute("value");h&&(a.value=a.rangeEnd=e.Globalize.parseDate(h,"yyyy-MM-dd"))}s.isRequired=!0;s.initialize(o);s._tbx.value=s._oldText=s._getText();s._updateState();a.valueChanged.addHandler((function(e,t){s.onValueChanged(t);s._closeOnChange();s._refreshText()}));a.rangeEndChanged.addHandler((function(e,t){if(a._rngMode()){s.onRangeEndChanged(t);s._closeOnChange();a._clearingRangeEnd||s._refreshText()}}));a.hostElement.addEventListener("click",(function(t){if(a.selectionMode&&!a._rngMode()){var i=t.target,n=a.hitTest(i);(e.DateTime.sameDate(s.value,n)||e.closest(i,"[wj-part=btn-today]"))&&s._closeOnChange()}}));return s}Object.defineProperty(InputDate.prototype,"value",{get:function(){return this._cal.value},set:function(e){this._cal.value=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"rangeEnd",{get:function(){return this._cal.rangeEnd},set:function(e){this._cal.rangeEnd=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"rangeMin",{get:function(){return this._cal.rangeMin},set:function(e){this._cal.rangeMin=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"rangeMax",{get:function(){return this._cal.rangeMax},set:function(e){this._cal.rangeMax=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"text",{get:function(){return this._tbx.value},set:function(e){if(e!=this.text){this._setText(e,!0);this._commitText()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"format",{get:function(){return this._fmt},set:function(t){if(t!=this.format){this._fmt=e.asString(t);this._refreshText()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"separator",{get:function(){return this._sep},set:function(t){if(t!=this._sep){this._sep=e.asString(t,!1);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"mask",{get:function(){return this._msk.mask},set:function(t){this._msk.mask=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"closeOnSelection",{get:function(){return this._clsOnSel},set:function(t){this._clsOnSel=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"handleWheel",{get:function(){return this._handleWheel},set:function(t){t=e.asBoolean(t);this._handleWheel=t;t||(this.calendar.handleWheel=t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"predefinedRanges",{get:function(){return this._rngs},set:function(t){if(this._rngs!=t){e.assert(null==t||e.isObject(t),"Object expected");this._rngs=t;this._lbx.itemsSource=this._getRanges(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"alwaysShowCalendar",{get:function(){return this._showCal},set:function(t){this._showCal=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"min",{get:function(){return this._cal.min},set:function(t){this._cal.min=e.asDate(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"max",{get:function(){return this._cal.max},set:function(t){this._cal.max=e.asDate(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"repeatButtons",{get:function(){return this._cal.repeatButtons},set:function(t){this._cal.repeatButtons=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"showYearPicker",{get:function(){return this._cal.showYearPicker},set:function(t){this._cal.showYearPicker=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"showMonthPicker",{get:function(){return this._cal.showMonthPicker},set:function(e){this._cal.showMonthPicker=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"showHeader",{get:function(){return this._cal.showHeader},set:function(e){this._cal.showHeader=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"weeksBefore",{get:function(){return this._cal.weeksBefore},set:function(e){this._cal.weeksBefore=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"weeksAfter",{get:function(){return this._cal.weeksAfter},set:function(e){this._cal.weeksAfter=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"selectionMode",{get:function(){return this._cal.selectionMode},set:function(e){if(e!=this.selectionMode){this._cal.selectionMode=e;this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"monthCount",{get:function(){return this._cal.monthCount},set:function(e){this._cal.monthCount=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"calendar",{get:function(){return this._cal},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"inputType",{get:function(){return this._tbx.type},set:function(t){this._tbx.type=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"itemValidator",{get:function(){return this._cal.itemValidator},set:function(t){if(t!=this.itemValidator){this._cal.itemValidator=e.asFunction(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(InputDate.prototype,"itemFormatter",{get:function(){return this._cal.itemFormatter},set:function(t){this._cal.itemFormatter=e.asFunction(t)},enumerable:!0,configurable:!0});InputDate.prototype.onValueChanged=function(e){this.valueChanged.raise(this,e)};InputDate.prototype.onRangeEndChanged=function(e){this.rangeEndChanged.raise(this,e);this.rangeEnd&&(this.isDroppedDown?this._rangeChanged=!0:this.onRangeChanged(e))};InputDate.prototype.onRangeChanged=function(e){this._rangeChanged=!1;this.rangeChanged.raise(this,e)};InputDate.prototype.refresh=function(e){void 0===e&&(e=!0);i.prototype.refresh.call(this,e);if(this.hostElement){this._msk&&this._msk.refresh();this._cal&&this._cal.refresh();this._refreshText()}};InputDate.prototype.onIsDroppedDownChanging=function(t){if(this.isDroppedDown){(o=this._cal)._rngMode()&&o.value&&!o.rangeEnd&&(o.rangeEnd=o.value)}else{var n=this._lbx,o=this._cal,s=n.collectionView,r=n.hostElement.style,a=o.hostElement.style;if(o._rngMode()&&e.hasItems(s)){var l=this._updateRangeSelection();r.display="";a.display=!this._showCal&&l&&l.from&&s.items.some((function(e){return!e.to}))?"none":""}else{r.display="none";a.display=""}o._mthMode()||(o.monthView=!0)}return i.prototype.onIsDroppedDownChanging.call(this,t)};InputDate.prototype.onIsDroppedDownChanged=function(e){i.prototype.onIsDroppedDownChanged.call(this,e);var t=this.containsFocus();if(this.isDroppedDown){t&&(this._tryFocus(this._cal)||this._tryFocus(this._lbx)||this.dropDown.focus());this._lbx.showSelection();this._cal.refresh()}else{this._commitText();this._rangeChanged&&this.onRangeChanged()}};InputDate.prototype._updateDropDown=function(){this._commitText();var e=getComputedStyle(this.hostElement);this._dropDown.style.minWidth=18*parseFloat(e.fontSize)+"px";this._cal.refresh();i.prototype._updateDropDown.call(this)};InputDate.prototype._keydown=function(n){if(!(n.defaultPrevented||n.altKey||n.ctrlKey||n.metaKey)){if(this._isHiddenEditor())return;switch(n.keyCode){case e.Key.Enter:this._commitText();break;case e.Key.Escape:this.text=this._getText();this.selectAll();break;case e.Key.Tab:if(this._cal._rngMode()){var o=this._tbx,s=this._sep,r=o.value,a=r.indexOf(s);if(a>-1){var l=r.length,h=o.selectionStart,u=o.selectionEnd,c=null;o.selectionEnd<=a&&!n.shiftKey?c=0==h&&0==u:n.shiftKey&&o.selectionStart>=a+s.length&&(c=h<l||u<l);if(null!=c){c?e.setSelectionRange(o,0,a):e.setSelectionRange(o,a+s.length,l);n.preventDefault()}}}break;case e.Key.Up:case e.Key.Down:if(!this.isDroppedDown&&this.value&&this._canChangeValue()){var p=n.keyCode==e.Key.Up?1:-1,d=this.selectionMode==t.DateSelectionMode.Month?e.DateTime.addMonths(this.value,p):e.DateTime.addDays(this.value,p);this.value=this._fromDateTime(d);this.selectAll();n.preventDefault()}}}i.prototype._keydown.call(this,n)};InputDate.prototype._expandSelection=function(){if(this._cal._rngMode()){var t=this._tbx,n=t.value,o=t.selectionStart,s=t.selectionEnd,r=this._sep,a=n.indexOf(r);a>-1&&o==s&&(s<=a?e.setSelectionRange(t,0,a):o>=a+r.length&&e.setSelectionRange(t,a+r.length,t.value.length))}else i.prototype._expandSelection.call(this)};InputDate.prototype._refreshText=function(){var e=this._getText();if(e!=this.text){this._tbx.value=this._oldText=e;this.onTextChanged()}};InputDate.prototype._selectAll=function(){this.isDroppedDown||!this.containsFocus()||this.isTouching||this.selectAll()};InputDate.prototype._closeOnChange=function(){var e=this;if(this._clsOnSel&&this._clicked){var t=this._cal;(!t._rngMode()||t.value&&t.rangeEnd)&&setTimeout((function(){e.isDroppedDown=!1}))}};InputDate.prototype._tryFocus=function(e){var t=e.hostElement;if(t&&t.offsetHeight){t.focus();return!0}return!1};InputDate.prototype._clamp=function(e){return this._cal._clamp(e)};InputDate.prototype._getText=function(){var t=e.Globalize.format,i=this._fmt,n=t(this.value,i);this._cal._rngMode()&&n&&(n+=this._sep+t(this.rangeEnd,i));return n};InputDate.prototype._commitText=function(){var t=this._tbx.value;if(t!=this._getText()){var i=!1,n=this._fmt,o=this._cal,s=e.Globalize.parseDate;if(t||this.isRequired)if(o._rngMode()){var r=t.split(this._sep);if(2==r.length&&r[0]){if(l=s(r[0],n,this.value)){var a=s(r[1],n,this.value);o.value=this._fromDateTime(l);o.rangeEnd=a&&a>=l?this._fromDateTime(a):l;i=!0}}}else{var l;if(l=s(t,n,this.value)){this.value=this._fromDateTime(l);i=!0}}else this.value=this.rangeEnd=null;(i||this.onInvalidInput(new e.CancelEventArgs))&&(this.text=this._getText())}this._selectAll()};InputDate.prototype._fromDateTime=function(t){return e.DateTime.fromDateTime(t,this.value)};InputDate.prototype._canChangeValue=function(){return!this.isReadOnly&&!this.isDisabled&&this.selectionMode!=t.DateSelectionMode.None};InputDate.prototype._isValidDate=function(e){if(e){if(this._clamp(e)!=e)return!1;if(this.itemValidator&&!this.itemValidator(e))return!1}return!0};InputDate.prototype._getRanges=function(t){var i=[];if(e.isObject(t))for(var n in t){var o=t[n];i.push({name:n,from:o?o[0]:null,to:o?o[1]:null})}return new e.collections.CollectionView(i,{currentItem:null})};InputDate.prototype._updateRangeSelection=function(){var t=this._lbx,i=-1;if(e.hasItems(t.collectionView))for(var n=this._lbx.collectionView.items,o=e.DateTime.sameDate,s=0;s<n.length;s++){var r=n[s];if(r.from){if(o(r.from,this.value)&&o(r.to,this.rangeEnd)){i=s;break}}else i=s}t.selectedIndex=i;return t.selectedItem};return InputDate}(t.DropDown);t.InputDate=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(i){__extends(InputDateRange,i);function InputDateRange(n,o){var s=i.call(this,n,{selectionMode:t.DateSelectionMode.Range,showMonthPicker:"Outside",monthCount:2})||this;e.addClass(s.hostElement,"wj-inputdaterange");s.initialize(o);return s}Object.defineProperty(InputDateRange.prototype,"selectionMode",{get:function(){return this.calendar.selectionMode},set:function(i){i=e.asEnum(i,t.DateSelectionMode);e.assert(i==t.DateSelectionMode.Range,'InputDateRange.selectionMode must be "Range"');this.calendar.selectionMode=i},enumerable:!0,configurable:!0});return InputDateRange}(t.InputDate);t.InputDateRange=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(i){__extends(InputColor,i);function InputColor(t,n){var o=i.call(this,t)||this;o.valueChanged=new e.Event;e.addClass(o.hostElement,"wj-inputcolor");o._ePreview=e.createElement('<div class="wj-inputcolorbox"></div>',o.hostElement.firstElementChild);if("INPUT"==o._orgTag){o._tbx.type="";o._commitText()}o.value="#ffffff";o.isRequired=!0;o.initialize(n);o.addEventListener(o._colorPicker.hostElement,"click",(function(t){var i=t.target;if(i&&"DIV"==i.tagName&&(e.closest(i,'[wj-part="div-pal"]')||e.closest(i,'[wj-part="div-pv"]'))){i.style.backgroundColor&&(o.isDroppedDown=!1)}}));return o}Object.defineProperty(InputColor.prototype,"value",{get:function(){return this._value},set:function(e){this.text=e},enumerable:!0,configurable:!0});Object.defineProperty(InputColor.prototype,"text",{get:function(){return this._tbx.value},set:function(t){if((t=e.asString(t))!=this.text&&(t||!this.isRequired)&&(!t||e.Color.fromString(t))){this._setText(t,!0);this._commitText()}},enumerable:!0,configurable:!0});Object.defineProperty(InputColor.prototype,"showAlphaChannel",{get:function(){return this._colorPicker.showAlphaChannel},set:function(e){this._colorPicker.showAlphaChannel=e},enumerable:!0,configurable:!0});Object.defineProperty(InputColor.prototype,"showColorString",{get:function(){return this._colorPicker.showColorString},set:function(e){this._colorPicker.showColorString=e},enumerable:!0,configurable:!0});Object.defineProperty(InputColor.prototype,"palette",{get:function(){return this._colorPicker.palette},set:function(e){this._colorPicker.palette=e},enumerable:!0,configurable:!0});Object.defineProperty(InputColor.prototype,"colorPicker",{get:function(){return this._colorPicker},enumerable:!0,configurable:!0});InputColor.prototype.onValueChanged=function(e){this.valueChanged.raise(this,e)};InputColor.prototype.onIsDroppedDownChanged=function(e){i.prototype.onIsDroppedDownChanged.call(this,e);this.isDroppedDown&&!this.isTouching&&this.selectAll()};InputColor.prototype._createDropDown=function(){var i=this;this._colorPicker=new t.ColorPicker(this._dropDown);e.setCss(this._dropDown,{minWidth:420,minHeight:200});this._colorPicker.valueChanged.addHandler((function(){i.value=i._colorPicker.value}))};InputColor.prototype._keydown=function(t){if(!t.defaultPrevented)switch(t.keyCode){case e.Key.Enter:this._commitText();this.selectAll();break;case e.Key.Escape:this.text=this.value;this.selectAll()}i.prototype._keydown.call(this,t)};InputColor.prototype._commitText=function(){if(this._value!=this.text){if(!this.isRequired&&!this.text){this._value=this.text;this._ePreview.style.backgroundColor="";this.onValueChanged();return}if(e.Color.fromString(this.text)){var t=this._colorPicker;t.value=this.text;this._value=t.value;this._ePreview.style.backgroundColor=this.value;this.onValueChanged()}else this.onInvalidInput(new e.CancelEventArgs)&&(this.text=this._value?this._value:"")}};return InputColor}(t.DropDown);t.InputColor=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(i){__extends(ComboBox,i);function ComboBox(t,n){var o=i.call(this,t)||this;o._editable=!1;o._trimText=!0;o._handleWheel=!0;o._delKey=0;o._pathHdr=new e.Binding(null);o._bsCollapse=!0;o._fmtItemHandlers=0;o.itemsSourceChanged=new e.Event;o.selectedIndexChanged=new e.Event;var s=o.hostElement;e.addClass(s,"wj-combobox");o.dropDown.id=e.getUniqueId(s.id+"_dropdown");o.autoExpandSelection=!1;var r=o._tbx;o.addEventListener(r,"compositionstart",(function(){o._composing=!0;var e=r.selectionStart,t=r.selectionEnd;if(t>e){var i=r.value;r.value=i.substring(0,e)+i.substring(t,i.length)}}));o.addEventListener(r,"compositionend",(function(){o._composing=!1;o._setText(o.text,!0)}));o.addEventListener(s,"wheel",o._wheel.bind(o));"SELECT"==o._orgTag&&o._lbx._initFromSelect(s);var a=o._lbx;a.loadedItems.addHandler((function(e){o.selectedIndex>-1&&(o.selectedIndex=a.selectedIndex)}));o.isRequired=!0;o.initialize(n);return o}Object.defineProperty(ComboBox.prototype,"itemsSource",{get:function(){return this._lbx.itemsSource},set:function(e){if(this._lbx.itemsSource!=e){this._lbx.itemsSource=e;this.onItemsSourceChanged()}this._updateBtn()},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"collectionView",{get:function(){return this._lbx.collectionView},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"showGroups",{get:function(){return this._lbx.showGroups},set:function(e){this._lbx.showGroups=e},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"displayMemberPath",{get:function(){return this._lbx.displayMemberPath},set:function(e){this._lbx.displayMemberPath=e;var t=this.getDisplayText();this.text!=t&&this._setText(t,!0)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"headerPath",{get:function(){return this._pathHdr.path},set:function(t){this._pathHdr.path=e.asString(t);var i=this.getDisplayText();this.text!=i&&this._setText(i,!0)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"selectedValuePath",{get:function(){return this._lbx.selectedValuePath},set:function(e){this._lbx.selectedValuePath=e},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"isContentHtml",{get:function(){return this._lbx.isContentHtml},set:function(t){if(t!=this.isContentHtml){this._lbx.isContentHtml=e.asBoolean(t);var i=this.getDisplayText();this.text!=i&&this._setText(i,!0)}},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"caseSensitiveSearch",{get:function(){return this._lbx.caseSensitiveSearch},set:function(t){this._lbx.caseSensitiveSearch=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"trimText",{get:function(){return this._trimText},set:function(t){if(t!=this._trimText){this._trimText=e.asBoolean(t);this.invalidate()}},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"itemFormatter",{get:function(){return this._lbx.itemFormatter},set:function(t){this._lbx.itemFormatter=e.asFunction(t);this.selectedIndex=this._lbx.selectedIndex},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"formatItem",{get:function(){return this._lbx.formatItem},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"selectedIndex",{get:function(){return this._lbx.selectedIndex},set:function(t){t!=this.selectedIndex&&e.isNumber(t)&&(this._lbx.selectedIndex=t);t=this.selectedIndex;var i=this.getDisplayText(t);this.text!=i&&this._setText(i,!0)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"selectedItem",{get:function(){return this._lbx.selectedItem},set:function(e){this._lbx.selectedItem=e},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"selectedValue",{get:function(){return this.collectionView?this._lbx.selectedValue:this.text},set:function(e){this.collectionView?this._lbx.selectedValue=e:null!=e&&(this.text=e.toString())},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"isEditable",{get:function(){return this._editable},set:function(t){this._editable=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"handleWheel",{get:function(){return this._handleWheel},set:function(t){this._handleWheel=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"maxDropDownHeight",{get:function(){return this._lbx.maxHeight},set:function(e){this._lbx.maxHeight=e},enumerable:!0,configurable:!0});Object.defineProperty(ComboBox.prototype,"maxDropDownWidth",{get:function(){var e=this._dropDown,t=e?parseInt(e.style.maxWidth):null;return isNaN(t)?null:t},set:function(t){var i=this._dropDown.style;t=e.asNumber(t,!0);i.maxWidth=null==t?"":t+"px";i.minWidth=""},enumerable:!0,configurable:!0});ComboBox.prototype.getDisplayText=function(t,i){void 0===t&&(t=this.selectedIndex);void 0===i&&(i=this._trimText);var n,o=this.collectionView;if(this.headerPath&&t>-1&&e.hasItems(o)){var s=o.items[t];n=null!=(n=s?this._pathHdr.getValue(s):null)?n.toString():"";this.isContentHtml&&(n=e.toPlainText(n))}else n=this._lbx.getDisplayText(t);return i?n.trim():n};ComboBox.prototype.indexOf=function(t,i){var n=this.collectionView,o=this.caseSensitiveSearch;if(e.hasItems(n)&&null!=t){t=t.toString();o||(t=t.toLowerCase());var s=this.selectedIndex,r=this.getDisplayText(s);if(i){o||(r=r.toLowerCase());if(t==r)return s}for(var a=0;a<n.items.length;a++)if(this._lbx.isItemEnabled(a)){r=this.getDisplayText(a);o||(r=r.toLowerCase());if(i){if(r==t)return a}else if(t&&0==r.indexOf(t))return a}}return-1};Object.defineProperty(ComboBox.prototype,"listBox",{get:function(){return this._lbx},enumerable:!0,configurable:!0});ComboBox.prototype.onItemsSourceChanged=function(e){this.itemsSourceChanged.raise(this,e)};ComboBox.prototype.onSelectedIndexChanged=function(e){this._updateBtn();this.selectedIndexChanged.raise(this,e)};ComboBox.prototype.refresh=function(t){void 0===t&&(t=!0);i.prototype.refresh.call(this,t);if(this.hostElement&&e.hasItems(this.collectionView)){this._lbx.refresh();this.selectedIndex>-1&&(this.selectedIndex=this._lbx.selectedIndex)}};ComboBox.prototype.onLostFocus=function(t){if(this._composing){this._composing=!1;this._setText(this.text,!0)}this.isEditable&&this.isRequired&&!this.text&&e.hasItems(this.collectionView)&&(this.selectedIndex=0);i.prototype.onLostFocus.call(this,t)};ComboBox.prototype.onIsDroppedDownChanging=function(e){if(!this.isDroppedDown&&!this._hasItems()){e.cancel=!0;return!1}return i.prototype.onIsDroppedDownChanging.call(this,e)};ComboBox.prototype.onIsDroppedDownChanged=function(e){i.prototype.onIsDroppedDownChanged.call(this,e);if(this.isDroppedDown){this._fmtItemHandlers=this.formatItem.handlerCount;this._lbx.showSelection()}this._updateAria()};ComboBox.prototype._updateBtn=function(){var t=this.collectionView,n=this._tbx,o=this._hasItems();i.prototype._updateBtn.call(this);this._btn.style.display=this._showBtn&&null!=t?"":"none";e.enable(this._btn,o);e.setAttribute(n,"role",o?"combobox":null);e.setAttribute(n,"aria-autocomplete",o?"both":null);this._updateAria()};ComboBox.prototype._hasItems=function(){return e.hasItems(this.collectionView)};ComboBox.prototype._updateAria=function(){var t=this._tbx,i=this.isDroppedDown,n=this.dropDown?this.dropDown.id:null,o=n&&e.hasItems(this.collectionView);e.setAttribute(t,"aria-owns",o&&i?n:null);e.setAttribute(t,"aria-expanded",o?i:null)};ComboBox.prototype._createDropDown=function(){var i=this;this._lbx||(this._lbx=new t.ListBox(this._dropDown));this._lbx.maxHeight=200;this._lbx.selectedIndexChanged.addHandler((function(){i._updateBtn();var t=i._lbx.selectedIndex,n=i._lbx.hostElement.children,o=t>-1&&t<n.length?n[t].id:null;e.setAttribute(i._tbx,"aria-activedescendant",o&&o.length?o:null);i.selectedIndex=t;i.onSelectedIndexChanged()}));this._lbx.itemsChanged.addHandler((function(){i._updateBtn()}))};ComboBox.prototype._wheel=function(e){if(this.handleWheel&&!e.defaultPrevented&&!this.isDroppedDown&&!this.isReadOnly&&this.containsFocus()&&this.selectedIndex>-1){var t=this._findNext("",e.deltaY>0?1:-1);t>-1&&(this.selectedIndex=t);e.preventDefault()}};ComboBox.prototype._dropDownClick=function(e){e.defaultPrevented||e.target!=this._dropDown&&(this.isDroppedDown=!1);i.prototype._dropDownClick.call(this,e)};ComboBox.prototype._setText=function(t,n){if(!this._composing&&!this._settingText){this._settingText=!0;if(this.containsFocus()){var o=this.formatItem.handlerCount;if(this._fmtItemHandlers!=o){this._fmtItemHandlers=o;this._lbx.loadList()}}null==t&&(t="");t=t.toString();var s=this.selectedIndex,r=this.collectionView,a=this._getSelStart(),l=-1,h=!0;if(this.isEditable&&(this._delKey||this._getSelEnd()<t.length||!this.containsFocus())){n=!0;h=!1}s=this.indexOf(t,n);if(h){s<0&&n&&(s=this.indexOf(t,!1));s<0&&a>0&&(s=this.indexOf(t.substr(0,a),!1))}if(s<0&&!this.isEditable&&e.hasItems(r)&&(this.isRequired||t)){var u=this._oldText||"";s=Math.max(0,this.indexOf(u,!1));for(var c=0;c<t.length&&c<u.length;c++)if(t[c]!=u[c]){a=c;break}}if(s>-1){l=a;t=this.getDisplayText(s)}var p=this._tbx;t!=p.value&&(p.value=t);l>-1&&this.containsFocus()&&!this.isTouching&&this._updateInputSelection(l);r&&r.moveCurrentToPosition(s);this._delKey=0;this._settingText=!1;i.prototype._setText.call(this,t,n)}};ComboBox.prototype._findNext=function(e,t,i){void 0===i&&(i=this.selectedIndex);var n=this.collectionView,o=n?n.items.length:0,s=this._lbx,r=this.caseSensitiveSearch;if(n&&o&&t){r||(e=e.toLowerCase());for(var a=i+t;a>-1&&a<o;a+=t){var l=this.getDisplayText(a);r||(l=l.toLowerCase());if(0==l.indexOf(e)){if(!this.dropDown.children[a]||s.isItemEnabled(a))return a}}}return i};ComboBox.prototype._keydown=function(t){i.prototype._keydown.call(this,t);if(!t.defaultPrevented&&!this.isReadOnly&&!t.altKey&&e.hasItems(this.collectionView)&&this._elRef==this._tbx&&!this._isHiddenEditor()){this._delKey=0;var n=this._getSelStart();switch(t.keyCode){case e.Key.Back:if(this._bsCollapse&&!this.isEditable){var o=this._getSelEnd();n>0&&o==this._tbx.value.length&&e.hasItems(this.collectionView)&&this._setSelRange(n-1,o)}this._delKey=t.keyCode;break;case e.Key.Delete:this._delKey=t.keyCode;break;case e.Key.Up:case e.Key.Down:n==this.text.length&&(n=0);this.selectedIndex=this._findNext(this.text.substr(0,n),t.keyCode==e.Key.Up?-1:1);this._setSelRange(n,this.text.length);t.preventDefault();break;case e.Key.PageUp:this._lbx._selectPrevPage();this.selectAll();t.preventDefault();break;case e.Key.PageDown:this._lbx._selectNextPage();this.selectAll();t.preventDefault()}}};ComboBox.prototype._updateInputSelection=function(e){var t=this._tbx;this._elRef==t&&this._setSelRange(e,t.value.length)};ComboBox.prototype._getSelStart=function(){var e=this._tbx;return e&&e.value?e.selectionStart:0};ComboBox.prototype._getSelEnd=function(){var e=this._tbx;return e&&e.value?e.selectionEnd:0};ComboBox.prototype._setSelRange=function(t,i){var n=this._tbx;this._elRef!=n||n.readOnly||e.setSelectionRange(n,t,i)};return ComboBox}(t.DropDown);t.ComboBox=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";e._addCultureInfo("MultiSelect",{itemsSelected:"{count:n0} items selected",selectAll:"Select All"});var i=function(i){__extends(MultiSelect,i);function MultiSelect(n,o){var s=i.call(this,n)||this;s._maxHdrItems=2;s._readOnly=!1;s._hdrFmt=null;s.checkedItemsChanged=new e.Event;e.addClass(s.hostElement,"wj-multiselect");s._tbx.readOnly=!0;s.checkedMemberPath=null;s.removeEventListener(s.dropDown,"click");s._lbx.itemsChanged.addHandler((function(){s._updateHeader()}));s._lbx.checkedItemsChanged.addHandler((function(){s._updateHeader();s.onCheckedItemsChanged()}));s.clickAction=t.ClickAction.Toggle;s.initialize(o);return s}Object.defineProperty(MultiSelect.prototype,"showSelectAllCheckbox",{get:function(){return this._msLbx.showSelectAllCheckbox},set:function(t){this._msLbx.showSelectAllCheckbox=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"showFilterInput",{get:function(){return this._msLbx.showFilterInput},set:function(t){this._msLbx.showFilterInput=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"delay",{get:function(){return this._msLbx.delay},set:function(e){this._msLbx.delay=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"caseSensitiveSearch",{get:function(){return this._msLbx.caseSensitiveSearch},set:function(e){this._msLbx.caseSensitiveSearch=e},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"filterInputPlaceholder",{get:function(){return this._msLbx.filterInputPlaceholder},set:function(t){this._msLbx.filterInputPlaceholder=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"checkOnFilter",{get:function(){return this._msLbx.checkOnFilter},set:function(t){if(t!=this.checkOnFilter){this._msLbx.checkOnFilter=e.asBoolean(t);this.checkedItems=[]}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"selectAllLabel",{get:function(){return this._msLbx.selectAllLabel},set:function(t){this._msLbx.selectAllLabel=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"checkedMemberPath",{get:function(){return this._msLbx.checkedMemberPath},set:function(t){this._msLbx.checkedMemberPath=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"maxHeaderItems",{get:function(){return this._maxHdrItems},set:function(t){if(this._maxHdrItems!=t){this._maxHdrItems=e.asNumber(t);this._updateHeader()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"headerFormat",{get:function(){return this._hdrFmt},set:function(t){if(t!=this._hdrFmt){this._hdrFmt=e.asString(t);this._updateHeader()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"headerFormatter",{get:function(){return this._hdrFormatter},set:function(t){if(t!=this._hdrFormatter){this._hdrFormatter=e.asFunction(t);this._updateHeader()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiSelect.prototype,"checkedItems",{get:function(){return this._msLbx.checkedItems},set:function(t){this._msLbx.checkedItems=null==t?[]:e.asArray(t);this._updateHeader()},enumerable:!0,configurable:!0});MultiSelect.prototype.onCheckedItemsChanged=function(e){this.checkedItemsChanged.raise(this,e)};MultiSelect.prototype.dispose=function(){this._lbx.dispose();i.prototype.dispose.call(this)};MultiSelect.prototype.onIsDroppedDownChanged=function(e){var t=this;i.prototype.onIsDroppedDownChanged.call(this,e);setTimeout((function(){if(t.isDroppedDown&&t.containsFocus())if(t.showFilterInput&&!t.isTouching)t._msLbx._filter.focus();else{var e=t.listBox;if(e.selectedIndex<0){var i=0,n=e.checkedItems;n.length&&(i=e.collectionView.items.indexOf(n[0]));e.selectedIndex=Math.max(0,i)}e.showSelection(!0);e.focus()}}))};MultiSelect.prototype._createDropDown=function(){var n=e.createElement("<div></div>",this._dropDown);this._msLbx=new t.MultiSelectListBox(n);this._lbx=this._msLbx.listBox;i.prototype._createDropDown.call(this)};Object.defineProperty(MultiSelect.prototype,"isReadOnly",{get:function(){return this._readOnly},set:function(t){this._readOnly=e.asBoolean(t);e.toggleClass(this.hostElement,"wj-state-readonly",this.isReadOnly)},enumerable:!0,configurable:!0});MultiSelect.prototype.refresh=function(e){void 0===e&&(e=!0);i.prototype.refresh.call(this,e);this.hostElement&&this._updateHeader()};MultiSelect.prototype._setText=function(e,t){};MultiSelect.prototype._keydown=function(t){i.prototype._keydown.call(this,t);e.hasClass(this._tbx,"wj-grid-ime")||!t.defaultPrevented&&e.hasItems(this.collectionView)&&t.keyCode>32&&(this.isDroppedDown=!0)};MultiSelect.prototype._hasItems=function(){var t=this.collectionView,i=t?t.sourceCollection:null;return e.hasItems(t)||i&&i.length&&this.showFilterInput};MultiSelect.prototype._updateHeader=function(){var t="";if(e.isFunction(this._hdrFormatter))t=this._hdrFormatter(this);else{var i=this.checkedItems;if(i.length>0)if(i.length<=this._maxHdrItems){if(this.headerPath){var n=new e.Binding(this.headerPath);i=i.map((function(e){return n.getValue(e)}))}else if(this.displayMemberPath){var o=new e.Binding(this.displayMemberPath);i=i.map((function(e){return o.getValue(e)}))}this.isContentHtml&&(i=i.map((function(t){return e.toPlainText(t)})));this.trimText&&(i=i.map((function(e){return e?e.toString().trim():""})));t=i.join(", ")}else t=e.format(this.headerFormat||e.culture.MultiSelect.itemsSelected,{count:i.length})}var s=this.inputElement;if(t!=s.value){s.value=t;this.onTextChanged()}this._updateState()};MultiSelect._DEF_CHECKED_PATH="$checked";return MultiSelect}(t.ComboBox);t.MultiSelect=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(Menu,t);function Menu(i,n){var o=t.call(this,i)||this;o._closing=!1;o._cmd=null;o._cmdPath=null;o._cmdParamPath=null;o._subPath=null;o._owner=null;o._isButton=!1;o._openOnHover=!1;o._closeOnLeave=!0;o._subMenu=null;o._hoverEnterBnd=o._hoverEnter.bind(o);o._hoverLeaveBnd=o._hoverLeave.bind(o);o._hoverOverBnd=o._hoverOver.bind(o);o.itemClicked=new e.Event;var s=o.hostElement,r=o._tbx,a=o._lbx,l=o.dropDown;e.addClass(s,"wj-menu");r.style.display="none";o._hdr=o._elRef=e.createElement('<div wj-part="header" class="wj-form-control"/>');r.parentElement.insertBefore(o._hdr,o._tbx);var h=o._orgOuter.match(/tabindex="?(-?\d+)"?/i);s.tabIndex=h?parseInt(h[1]):0;o.isRequired=!1;e.setAttribute(s,"role","menubar",!0);e.setAttribute(r,"role",null);e.setAttribute(r,"aria-autocomplete",null);e.setAttribute(r,"aria-owns",null);e.setAttribute(l,"role","menu");a.itemRole="menuitem";if("SELECT"==o._orgTag){o.header=s.getAttribute("header");o._lbx.itemsSource&&(o.commandParameterPath="cmdParam")}o.isContentHtml=!0;o.maxDropDownHeight=500;o.addEventListener(o._hdr,"click",(function(e){if(!e.defaultPrevented){o._clearHover(e);if(o._isButton){o.isDroppedDown=!1;o._raiseCommand()}else o.isDroppedDown=!o.isDroppedDown}}));a.lostFocus.addHandler((function(){o.containsFocus()||(o.isDroppedDown=!1)}));e.addClass(l,"wj-menu-items");a.formatItem.addHandler(o._formatMenuItem.bind(o));o.initialize(n);return o}Object.defineProperty(Menu.prototype,"header",{get:function(){return this._hdr.innerHTML},set:function(t){this._hdr.innerHTML=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"command",{get:function(){return this._cmd},set:function(e){this._cmd=e},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"commandPath",{get:function(){return this._cmdPath},set:function(t){this._cmdPath=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"commandParameterPath",{get:function(){return this._cmdParamPath},set:function(t){this._cmdParamPath=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"subItemsPath",{get:function(){return this._subPath},set:function(e){if(e!=this._subPath){this._subPath=e;this.refresh(!0)}},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"openOnHover",{get:function(){return this._openOnHover},set:function(t){this._openOnHover=e.asBoolean(t);this._updateHoverEvents()},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"closeOnLeave",{get:function(){return this._closeOnLeave},set:function(t){this._closeOnLeave=e.asBoolean(t);this._updateHoverEvents()},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"isButton",{get:function(){return this._isButton},set:function(t){this._isButton=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(Menu.prototype,"owner",{get:function(){return this._owner},set:function(t){this._owner=e.asType(t,HTMLElement,!0);this._enableDisableItems()},enumerable:!0,configurable:!0});Menu.prototype.show=function(t){if(!this.isDroppedDown){this.selectedIndex=-1;if(this.onIsDroppedDownChanging(new e.CancelEventArgs)){var i=this.dropDown,n=this.owner;!n&&t instanceof MouseEvent&&(n=t.target);n instanceof HTMLElement&&(i[e.Control._OWNR_KEY]=n);if(t instanceof MouseEvent&&this.openOnHover&&this.closeOnLeave){t=new e.Point(t.pageX-pageXOffset-2,t.pageY-pageYOffset-2)}e.showPopup(i,t,!1,this.isAnimated);this.onIsDroppedDownChanged();i.focus()}}};Menu.prototype.hide=function(){if(this.isDroppedDown&&this.onIsDroppedDownChanging(new e.CancelEventArgs)){e.hidePopup(this.dropDown);this.onIsDroppedDownChanged()}};Menu.prototype.onItemClicked=function(e){this.itemClicked.raise(this,e)};Menu.prototype.refresh=function(e){void 0===e&&(e=!0);t.prototype.refresh.call(this,e);this.hostElement&&this._enableDisableItems()};Menu.prototype.onIsDroppedDownChanged=function(e){t.prototype.onIsDroppedDownChanged.call(this,e);if(this.isDroppedDown){this._closing=!0;this._defaultItem=this.selectedItem;this.isRequired=!1;this.selectedIndex=-1;this._enableDisableItems();this._closing=!1;this.dropDown.focus()}else{this.selectedItem||(this.selectedItem=this._defaultItem);var i=this._subMenu;i&&(i.isDroppedDown=!1)}};Menu.prototype._updateHoverEvents=function(){var e=this.hostElement,t=this.dropDown,i=this.addEventListener.bind(this),n=this.removeEventListener.bind(this),o="mouseleave";n(e,"mouseenter",this._hoverEnterBnd);n(e,o,this._hoverLeaveBnd);n(t,"mouseover",this._hoverOverBnd);n(t,o,this._hoverLeaveBnd);if(this._openOnHover){i(e,"mouseenter",this._hoverEnterBnd);i(t,"mouseover",this._hoverOverBnd);if(this._closeOnLeave){i(e,o,this._hoverLeaveBnd);i(t,o,this._hoverLeaveBnd)}}};Menu.prototype._getSubItems=function(t){var i=this.subItemsPath,n=t&&i?t[i]:null;return e.isArray(n)&&n.length?n:null};Menu.prototype._formatMenuItem=function(t,i){var n=i.item;if(this._getSubItems(i.data))e.addClass(n,"wj-subitems");else if("-"==n.innerHTML){n.innerHTML="";e.addClass(n,"wj-separator")}};Menu.prototype._keydown=function(i){if(!i.defaultPrevented){var n=this._getKeyCode(i);if(this.isDroppedDown)switch(n){case e.Key.Enter:case e.Key.Right:if(this._showSubMenu()){i.preventDefault();return}break;case e.Key.Left:var o=e.Control.getControl(this.owner);if(o instanceof Menu){var s=o.dropDown,r=o.selectedIndex;(r>-1?s.children[r]:s).focus();i.preventDefault();return}}if(n==e.Key.Enter)if(this.isDroppedDown)this.selectedIndex>-1&&this._raiseCommand();else{this.isDroppedDown=!0;i.preventDefault()}}t.prototype._keydown.call(this,i)};Menu.prototype._dropDownClick=function(e){if(!e.defaultPrevented&&e.target!=this.dropDown){this._clearHover(e);if(this._showSubMenu()){e.preventDefault();return}this.selectedIndex>-1&&this._raiseCommand()}t.prototype._dropDownClick.call(this,e)};Menu.prototype._showSubMenu=function(){var t=this,i=this._getSubItems(this.selectedItem);if(!i)return null;var n=this.dropDown.children[this.selectedIndex].getBoundingClientRect(),o=new e.Point(n.right,n.top);if(0==n.height)return null;var s=this.rightToLeft||"rtl"==this.dropDown.getAttribute("dir");s&&(o.x=n.left);var r=this._subMenu;r&&(r.isDroppedDown=!1);r=new Menu(document.createElement("div"),{owner:this.hostElement,itemsSource:i,itemClicked:function(e,i){t.itemClicked.raise(e,i)},formatItem:function(e,i){t.formatItem.raise(e,i)}});var a=this.collectionView,l=r.collectionView;a&&a.filter&&l&&!l.filter&&(l.filter=a.filter);"displayMemberPath,selectedValuePath,isContentHtml,command,commandPath,commandParameterPath,maxDropDownWidth,maxDropDownHeight,dropDownCssClass,isAnimated,subItemsPath,openOnHover,closeOnLeave".split(",").forEach((function(e){r[e]=t[e]}));var h=r.dropDown;e.setAttribute(h,"dir",s?"rtl":null);r.show(o);h[e.Control._OWNR_KEY]=this.dropDown;h.focus();return r};Menu.prototype._raiseCommand=function(t){var i=this.selectedItem,n=this._getSubItems(i),o=this._getCommand(i);if(o&&!n){var s=this._getCommandParm(i);if(!this._canExecuteCommand(o,s))return;this._executeCommand(o,s)}var r=this.headerPath;if(r){var a=new e.Binding(r).getValue(i);a=null==a?"":a.toString();this.header=this.isContentHtml?a:e.escapeHtml(a)}this.onItemClicked(t);if(this.containsFocus()){for(var l=this;l&&l.owner;){var h=e.Control.getControl(l.owner);if(!(h instanceof Menu))break;l=h}var u=l.owner;!u&&l.dropDown&&(u=l.dropDown[e.Control._OWNR_KEY]);l.isDroppedDown=!1;l.focus();if(!l.containsFocus()&&u instanceof HTMLElement&&u.offsetHeight)if(e.isIE){var c=document.documentElement,p=c.scrollLeft,d=c.scrollTop;u.focus();c.scrollLeft=p,c.scrollTop=d}else u.focus()}};Menu.prototype._getCommand=function(e){var t=e&&this._cmdPath?e[this._cmdPath]:null;return t||this._cmd};Menu.prototype._getCommandParm=function(e){var t=this._cmdParamPath;return e&&t?e[t]:e};Menu.prototype._executeCommand=function(t,i){t&&!e.isFunction(t)&&(t=t.executeCommand);e.isFunction(t)&&t(i)};Menu.prototype._canExecuteCommand=function(t,i){if(t){var n=t.canExecuteCommand;if(e.isFunction(n))return n(i)}return!0};Menu.prototype._enableDisableItems=function(){if(this.collectionView&&(this._cmd||this._cmdPath))for(var t=this.collectionView.items,i=0;i<t.length;i++){var n=t[i],o=this._getCommand(n);if(o){var s=this._lbx.hostElement.children[i],r=this._getCommandParm(n);e.toggleClass(s,"wj-state-disabled",!this._canExecuteCommand(o,r))}}};Menu.prototype._clearHover=function(e){this._toHover&&clearTimeout(this._toHover);this._toHover=null;Menu._evtHover=e};Menu.prototype._isTargetDisabled=function(t){return e.hasClass(t.target,"wj-state-disabled")};Menu.prototype._hoverEnter=function(t){var i=this;this._clearHover(t);this._toHover=setTimeout((function(){i._toHover=null;i.isDroppedDown=!0}),e.Control._HOVER_DELAY)};Menu.prototype._hoverOver=function(t){var i=this;this._clearHover(t);this._toHover=setTimeout((function(){i._toHover=null;var n=i.listBox.indexOf(t.target);if(n>-1&&!e.hasClass(t.target,"wj-state-disabled")){i.selectedIndex=n;i._subMenu=i._showSubMenu()}}),e.Control._HOVER_DELAY)};Menu.prototype._hoverLeave=function(t){var i=this;this._clearHover(t);this.isDroppedDown&&(this._toHover=setTimeout((function(){var n=(t=Menu._evtHover)?document.elementFromPoint(t.clientX,t.clientY):null,o=e.closest(n,".wj-listbox.wj-menu-items"),s=i._subMenu;if(!o&&!e.contains(i.hostElement,n,!0)){i.isDroppedDown=!1;s&&(s.isDroppedDown=!1)}}),e.Control._LEAVE_DELAY))};return Menu}(t.ComboBox);t.Menu=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(InputTime,t);function InputTime(i,n){var o=t.call(this,i)||this;o._format="t";o.valueChanged=new e.Event;e.addClass(o.hostElement,"wj-inputtime");o.isEditable=!0;o._value=e.DateTime.newDate();o._min=o._max=null;o._msk=new e._MaskProvider(o._tbx);e.isIE9()||(o._tbx.type="tel");if("INPUT"==o._orgTag){var s=o._tbx.getAttribute("value");s&&(o.value=e.Globalize.parseDate(s,"HH:mm:ss"))}o.step=15;o.autoExpandSelection=!0;o.initialize(n);return o}Object.defineProperty(InputTime.prototype,"inputElement",{get:function(){return this._tbx},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"inputType",{get:function(){return this._tbx.type},set:function(t){this._tbx.type=e.asString(t)},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"value",{get:function(){return this._value},set:function(t){(t=e.asDate(t,!this.isRequired))&&(t=this._clamp(t));this._setText(t?e.Globalize.format(t,this.format):"",!0);this.selectedItem&&this.selectedItem.value&&(t=e.DateTime.fromDateTime(t,this.selectedItem.value));if(t!=this._value&&!e.DateTime.equals(t,this._value)){this._value=t;this.onValueChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"text",{get:function(){return this._tbx.value},set:function(e){if(e!=this.text){this._setText(e,!0);this._commitText()}},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"min",{get:function(){return this._min},set:function(t){this._min=e.asDate(t,!0);this.isDroppedDown=!1;this._updateItems()},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"max",{get:function(){return this._max},set:function(t){this._max=e.asDate(t,!0);this.isDroppedDown=!1;this._updateItems()},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"step",{get:function(){return this._step},set:function(t){if(t!=this.step){this._step=e.asNumber(t,!0);this.isDroppedDown=!1;this._updateItems()}},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"format",{get:function(){return this._format},set:function(t){if(t!=this.format){this._format=e.asString(t);this._tbx.value=e.Globalize.format(this.value,this.format);e.hasItems(this.collectionView)&&this._updateItems()}},enumerable:!0,configurable:!0});Object.defineProperty(InputTime.prototype,"mask",{get:function(){return this._msk.mask},set:function(t){this._msk.mask=e.asString(t)},enumerable:!0,configurable:!0});InputTime.prototype.onValueChanged=function(e){this.valueChanged.raise(this,e)};InputTime.prototype.onItemsSourceChanged=function(e){t.prototype.onItemsSourceChanged.call(this,e);this._hasCustomItems=null!=this.itemsSource};InputTime.prototype.refresh=function(i){void 0===i&&(i=!0);t.prototype.refresh.call(this,i);if(this.hostElement){this._msk.refresh();this._tbx.value=e.Globalize.format(this.value,this.format);this._updateItems()}};InputTime.prototype.onSelectedIndexChanged=function(i){if(this.selectedIndex>-1&&!this._settingText){var n=this.value?this.value:e.DateTime.newDate(),o=null!=this.selectedItem.value?this.selectedItem.value:e.Globalize.parseDate(this.text,this.format,this.value);this.value=e.DateTime.fromDateTime(n,o)}t.prototype.onSelectedIndexChanged.call(this,i)};InputTime.prototype._clamp=function(t){null!=this._min&&this._getTime(t)<this._getTime(this._min)&&(t=e.DateTime.fromDateTime(t,this._min));null!=this._max&&this._getTime(t)>this._getTime(this._max)&&(t=e.DateTime.fromDateTime(t,this._max));return t};InputTime.prototype._wheel=function(i){if(!i.defaultPrevented&&!this.isDroppedDown&&!this.isReadOnly&&this.containsFocus()&&this.selectedIndex<0&&this.value&&e.isNumber(this.step)&&this.step>0){var n=e.DateTime.addMinutes(this.value,this.step*e.clamp(i.deltaY,-1,1));this.value=this._clamp(n);this.selectAll();i.preventDefault()}t.prototype._wheel.call(this,i)};InputTime.prototype._updateInputSelection=function(i){if(this._delKey)t.prototype._updateInputSelection.call(this,i);else{for(var n=this._tbx.value;i<n.length&&!n[i].match(/[a-z0-9]/i);)i++;e.setSelectionRange(this._tbx,i,this._tbx.value.length)}};InputTime.prototype._updateItems=function(){if(!this._hasCustomItems){var t=[],i=e.DateTime.newDate(0,0,0,0,0),n=e.DateTime.newDate(0,0,0,23,59,59),o=this.step;this.min&&i.setHours(this.min.getHours(),this.min.getMinutes(),this.min.getSeconds());this.max&&n.setHours(this.max.getHours(),this.max.getMinutes(),this.max.getSeconds());if(e.isNumber(o)&&o>=1)for(var s=i;s<=n;s=e.DateTime.addMinutes(s,o))t.push({value:s,text:e.Globalize.format(s,this.format)});var r=this.value;this._settingText=!0;this.displayMemberPath="text";this.selectedValuePath="text";this.itemsSource=t;this._hasCustomItems=!1;this._settingText=!1;!r&&this.isRequired||(this.value=r)}};InputTime.prototype._getTime=function(e){return 3600*e.getHours()+60*e.getMinutes()+e.getSeconds()};InputTime.prototype._keydown=function(i){t.prototype._keydown.call(this,i);if(!i.defaultPrevented)switch(i.keyCode){case e.Key.Enter:if(!this.isDroppedDown){this._commitText();this.selectAll()}break;case e.Key.Escape:this.text=e.Globalize.format(this.value,this.format);this.selectAll()}};InputTime.prototype._commitText=function(){if(this.text||this.isRequired){var t=this.value?e.Globalize.format(this.value,this.format):"";if(this.text!=t){var i=this.selectedItem&&this.selectedItem.value?this.selectedItem.value:e.Globalize.parseDate(this.text,this.format,this.value);i?(e.DateTime.sameTime(i,this._clamp(i))||this.onInvalidInput(new e.CancelEventArgs))&&(this.value=e.DateTime.fromDateTime(this.value,i)):this.onInvalidInput(new e.CancelEventArgs)&&(this.text=t)}}else this.value=null};return InputTime}(t.ComboBox);t.InputTime=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";e._addCultureInfo("InputDateTime",{ariaLabels:{tglDate:"Toggle Calendar",tglTime:"Toggle Time List"}});var i=function(i){__extends(InputDateTime,i);function InputDateTime(n,o){var s=i.call(this,n)||this;e.addClass(s.hostElement,"wj-inputdatetime");var r=e.culture.InputDateTime.ariaLabels;e.setAriaLabel(s._btn,r.tglDate);e.setAriaLabel(s._btnTm,r.tglTime);s.value=new Date;s.format="g";s._inputTime=new t.InputTime(document.createElement("div"),{valueChanged:function(t){var i=s.rangeEnd;s.value=e.DateTime.fromDateTime(s.value,t.value);s.calendar._rngMode()&&i&&(s.rangeEnd=e.DateTime.fromDateTime(i,t.value))},isDroppedDownChanged:function(e){e.listBox.containsFocus()&&s.inputElement.focus();s._selectAll()}});var a=s.addEventListener.bind(s);s._btnTm=s.hostElement.querySelector('[wj-part="btn-tm"]');a(s._btnTm,"mousedown",(function(e){s._btnclick(e)}));s._ddDate=s._dropDown;var l=s._ddTime=s._inputTime.dropDown;a(l,"keydown",s._keydown.bind(s),!0);a(l,"blur",(function(){s._updateFocusState()}),!0);a(l,"click",(function(e){e.defaultPrevented||e.target!=l&&s.hostElement.focus()}),!0);s.initialize(o);s.text=s._getText();return s}Object.defineProperty(InputDateTime.prototype,"timeMin",{get:function(){return this._inputTime.min},set:function(e){this._inputTime.min=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDateTime.prototype,"timeMax",{get:function(){return this._inputTime.max},set:function(e){this._inputTime.max=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDateTime.prototype,"timeFormat",{get:function(){return this._inputTime.format},set:function(e){this._inputTime.format=e},enumerable:!0,configurable:!0});Object.defineProperty(InputDateTime.prototype,"timeStep",{get:function(){return this._inputTime.step},set:function(t){this._inputTime.step=t;this._btnTm.style.display=e.isNumber(t)&&t>0?"":"none"},enumerable:!0,configurable:!0});Object.defineProperty(InputDateTime.prototype,"inputTime",{get:function(){return this._inputTime},enumerable:!0,configurable:!0});InputDateTime.prototype._fromDateTime=function(e){return e};InputDateTime.prototype._btnclick=function(t){var n=e.closest(t.target,"button")==this._btn?this._ddDate:this._ddTime;this._setDropdown(n);i.prototype._btnclick.call(this,t)};InputDateTime.prototype.dispose=function(){this._setDropdown(this._ddDate);i.prototype.dispose.call(this);this._inputTime.dispose()};InputDateTime.prototype.refresh=function(e){void 0===e&&(e=!0);this._inputTime.refresh();i.prototype.refresh.call(this,e)};InputDateTime.prototype._updateBtn=function(){i.prototype._updateBtn.call(this);if(this._btnTm){this._btnTm.tabIndex=this._btn.tabIndex;this._btnTm.parentElement.style.display=this._btn.style.display}};InputDateTime.prototype._setDropdown=function(e){if(this._dropDown==e)return!1;this.isDroppedDown&&(this.isDroppedDown=!1);var t=this.dropDownCssClass;this.dropDownCssClass="";this._dropDown=e;this.dropDownCssClass=t;return!0};InputDateTime.prototype._updateDropDown=function(){var e=this._inputTime;if(this._dropDown==e.dropDown){this._commitText();i.prototype._updateDropDown.call(this);e.isRequired=this.isRequired&&null!=this.value;e.value=this.value;this.isDroppedDown&&e.listBox.showSelection()}else i.prototype._updateDropDown.call(this)};InputDateTime.controlTemplate='<div class="wj-template"><div class="wj-input"><div class="wj-input-group wj-input-btn-visible"><input wj-part="input" type="text" class="wj-form-control"/><span class="wj-input-group-btn"><button wj-part="btn" class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-calendar"></span></button><button wj-part="btn-tm" class="wj-btn wj-btn-default" tabindex="-1"><span class="wj-glyph-clock"></span></button></span></div></div><div wj-part="dropdown" class="wj-content wj-dropdown-panel"></div></div>';return InputDateTime}(t.InputDate);t.InputDateTime=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(AutoComplete,t);function AutoComplete(i,n){var o=t.call(this,i)||this;o._cssMatch="wj-state-match";o._minLength=2;o._maxItems=6;o._itemCount=0;o._beginsWith=!1;o._delay=e.Control._SEARCH_DELAY;o._query="";o._inCallback=!1;o._srchProps=[];e.addClass(o.hostElement,"wj-autocomplete");o._bsCollapse=!1;o.isEditable=!0;o.isRequired=!1;o.listBox.formatItem.addHandler(o._formatListItem,o);o._itemsSourceFnCallbackBnd=o._itemSourceFunctionCallback.bind(o);o.initialize(n);return o}Object.defineProperty(AutoComplete.prototype,"minLength",{get:function(){return this._minLength},set:function(t){this._minLength=e.asNumber(t,!1,!0)},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"beginsWithSearch",{get:function(){return this._beginsWith},set:function(t){this._beginsWith=e.asBoolean(t)},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"maxItems",{get:function(){return this._maxItems},set:function(t){this._maxItems=e.asNumber(t,!1,!0)},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"delay",{get:function(){return this._delay},set:function(t){this._delay=e.asNumber(t,!1,!0)},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"searchMemberPath",{get:function(){return this._srchProp},set:function(t){this._srchProp=e.asString(t);this._srchProps=t?t.trim().split(/\s*,\s*/):[]},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"itemsSourceFunction",{get:function(){return this._itemsSourceFn},set:function(t){this._itemsSourceFn=e.asFunction(t);e.isFunction(this._itemsSourceFn)&&this.itemsSourceFunction(this.text,this.maxItems,this._itemsSourceFnCallbackBnd)},enumerable:!0,configurable:!0});Object.defineProperty(AutoComplete.prototype,"cssMatch",{get:function(){return this._cssMatch},set:function(t){this._cssMatch=e.asString(t)},enumerable:!0,configurable:!0});AutoComplete.prototype._keydown=function(i){if(!i.defaultPrevented&&this.isDroppedDown)switch(i.keyCode){case e.Key.Up:case e.Key.Down:this.selectAll()}t.prototype._keydown.call(this,i)};AutoComplete.prototype._setText=function(t){var i=this;if(!(this._inCallback||this._composing||this._settingText)){if(this.selectedIndex>-1&&this.getDisplayText()!=t){this._settingText=!0;this.selectedIndex=-1;this._settingText=!1}if(t!=this._oldText){var n=this._tbx;n.value!=t&&(n.value=t);this._oldText=t;this.onTextChanged();var o=this.collectionView;if(!t&&o){(this._query||this.selectedIndex<0)&&(this.isDroppedDown=!1);this._query=this._rxHighlight=null;o.filter=null;var s=this.itemsSourceFunction;if(e.isFunction(s)){this.isDroppedDown=!1;s(this._query,this.maxItems,this._itemsSourceFnCallbackBnd)}return}}this._toSearch&&clearTimeout(this._toSearch);t!=this.getDisplayText()&&(this._toSearch=setTimeout((function(){i._toSearch=null;var t=i.text.trim();if(t.length>=i._minLength&&t!=i._query){i._query=t;t=e.escapeRegExp(t);var n=e.escapeHtml(t),o=i.caseSensitiveSearch?"":"i";i._beginsWith||(o+="g");i._rxSrch=i._beginsWith?new RegExp("^"+t+".*",o):new RegExp("(?=.*"+t.replace(/ /g,")(?=.*")+")",o);i._rxHighlight=new RegExp("("+n.replace(/\s+/g,"|")+")",o);var s=i.itemsSourceFunction;e.isFunction(s)?s(i._query,i.maxItems,i._itemsSourceFnCallbackBnd):i._updateItems()}}),this._delay))}};AutoComplete.prototype._itemSourceFunctionCallback=function(t){this._inCallback=!0;var i=e.asCollectionView(t||[]);i.moveCurrentToPosition(-1);this.itemsSource=i;this._inCallback=!1;if(this.containsFocus()){var n=this._tbx,o=n.selectionStart,s=n.selectionEnd,r=this.collectionView;this.isDroppedDown=null!=r&&r.items.length>0;e.setSelectionRange(n,o,s);this.refresh()}};AutoComplete.prototype.onIsDroppedDownChanged=function(i){t.prototype.onIsDroppedDownChanged.call(this,i);if(this.containsFocus()&&!this.isTouching){var n=this.collectionView;if(this.selectedIndex<0&&n){var o=n.items,s=this.text;1==o.length&&o[0]==s?this.selectedIndex=0:e.setSelectionRange(this._tbx,s.length)}}this._query=""};AutoComplete.prototype._updateItems=function(){var t=this.collectionView;if(t){this._inCallback=!0;t.beginUpdate();this._itemCount=0;t.filter=this._filter.bind(this);t.moveCurrentToPosition(-1);t.endUpdate();this._inCallback=!1;var i=t.items.length,n=this._tbx,o=n.selectionStart,s=n.selectionEnd;this.isDroppedDown=i>0&&this.containsFocus();i||this.isEditable||(this.selectedIndex=-1);if(1==i&&this.selectedIndex<0){var r=this._getItemText(t.items[0],!1),a=n.value;if(!this.caseSensitiveSearch){r=r.toLowerCase();a=a.toLowerCase()}r==a&&(this.selectedIndex=0)}this.isDroppedDown&&e.setSelectionRange(n,o,s);this.refresh()}};AutoComplete.prototype._filter=function(e){if(this._itemCount>=this._maxItems)return!1;var t=this._getItemText(e,!1);this._srchProps&&this._srchProps.forEach((function(i){var n=e[i];null!=n&&(t+="\0"+n)}));this.isContentHtml&&(t=t.replace(/(<[^>]*>|&[^;]*;)/g,""));if(this._rxSrch.test(t)){this._itemCount++;return!0}return!1};AutoComplete.prototype._getItemText=function(e,t){var i=e?e.toString():"",n=t&&this.headerPath?this._pathHdr:this._lbx._pathDisplay;n&&(i=null!=(i=n.getValue(e))?i.toString():"");return i};AutoComplete.prototype._formatListItem=function(e,t){var i=this;this._cssMatch&&this._rxHighlight&&(t.item.innerHTML=t.item.innerHTML.replace(this._rxHighlight,(function(e,t,n,o){return i._enclosed(o,n,"<",">")||i._enclosed(o,n,"&",";")?e:'<span class="'+i._cssMatch+'">'+e+"</span>"})))};AutoComplete.prototype._enclosed=function(e,t,i,n){for(var o=t;o>=0&&e[o]!=n;o--)if(e[o]==i)for(var s=t;s<e.length&&e[s]!=i;s++)if(e[s]==n)return!0;return!1};return AutoComplete}(t.ComboBox);t.AutoComplete=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";var i=function(t){__extends(MultiAutoComplete,t);function MultiAutoComplete(i,n){var o=t.call(this,i)||this;o._selItems=[];o._maxSelItems=null;o._lastInputValue="";o._selPath=new e.Binding(null);o._notAddItm=!1;o.selectedItemsChanged=new e.Event;e.addClass(o.hostElement,"wj-multi-autocomplete");o._wjTpl=o.hostElement.querySelector(".wj-template");o._wjInput=o.hostElement.querySelector(".wj-input");o.showDropDownButton=!1;o.initialize(n);o.addEventListener(o.hostElement,"keyup",o._keyup.bind(o),!0);o.addEventListener(window,"resize",o._adjustInputWidth.bind(o));o.addEventListener(o._tbx,"focus",(function(){o._itemOff()}));o._addHelperInput();o._initSeltems();o.listBox.itemsChanged.addHandler((function(){return o.selectedIndex=-1}));o._refreshHeader();return o}Object.defineProperty(MultiAutoComplete.prototype,"showDropDownButton",{set:function(e){this._showBtn=!1},enumerable:!0,configurable:!0});Object.defineProperty(MultiAutoComplete.prototype,"maxSelectedItems",{get:function(){return this._maxSelItems},set:function(t){if(this._maxSelItems!=t){this._maxSelItems=e.asNumber(t,!0);this._updateMaxItems();this._refreshHeader();this._clearSelIndex()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiAutoComplete.prototype,"selectedMemberPath",{get:function(){return this._selPath.path},set:function(t){if((t=e.asString(t))!==this.selectedMemberPath){this._selPath.path=t;this._initSeltems();this._refreshHeader();this.onSelectedItemsChanged()}},enumerable:!0,configurable:!0});Object.defineProperty(MultiAutoComplete.prototype,"selectedItems",{get:function(){return this._selItems},set:function(t){this._selItems=e.asArray(t);if(this.selectedMemberPath&&""!==this.selectedMemberPath&&this._selItems)for(var i=0;i<this._selItems.length;i++){var n=this._selItems[i];this._setSelItem(n,!1)}this._updateMaxItems();this.onSelectedItemsChanged();this._refreshHeader();this._clearSelIndex()},enumerable:!0,configurable:!0});MultiAutoComplete.prototype.onSelectedItemsChanged=function(e){this.selectedItemsChanged.raise(this,e)};MultiAutoComplete.prototype.onIsDroppedDownChanged=function(e){!this.isDroppedDown&&this.selectedIndex>-1&&!this._notAddItm&&this._addItem(!0);this._notAddItm=!1;t.prototype.onIsDroppedDownChanged.call(this,e)};MultiAutoComplete.prototype.refresh=function(e){void 0===e&&(e=!0);t.prototype.refresh.call(this,e);if(this.hostElement){this._initSeltems();this.isDroppedDown||this._refreshHeader()}};MultiAutoComplete.prototype._keydown=function(i){if(!this.isReadOnly){if(!i.defaultPrevented)switch(i.keyCode){case e.Key.Back:this._lastInputValue=this._tbx.value;break;case e.Key.Enter:this._itemOff();this._addItem(!0);e.isIE&&e.setSelectionRange(this._tbx,0,0);break;case e.Key.Tab:if(this.isDroppedDown){this._addItem(!1);this._tbx.value="";this._lbx.selectedIndex=-1;i.preventDefault()}else this._updateFocus();break;case e.Key.Space:if(""!==this._tbx.value)return;if(!this.isDroppedDown&&!this._tbx.disabled){this.isDroppedDown=!0;this._clearSelIndex()}break;case e.Key.Escape:this.isDroppedDown&&(this._notAddItm=!0);break;case e.Key.Left:this._itemOn(!this.rightToLeft);break;case e.Key.Right:this._itemOn(!!this.rightToLeft);break;case e.Key.Up:case e.Key.Down:var n=e.getActiveElement();if(i.altKey){if(this._tbx==n){this.isDroppedDown=!this.isDroppedDown;this.isDroppedDown||this._tbx.focus();i.preventDefault();return}}else if(this._tbx!==n)return;default:if(i.keyCode===e.Key.Back||i.keyCode===e.Key.Delete)return;this._itemOff();null!=this._maxSelItems&&this._selItems.length>=this._maxSelItems&&i.preventDefault()}this._tbx.disabled||t.prototype._keydown.call(this,i)}};MultiAutoComplete.prototype._updateState=function(){t.prototype._updateState.call(this);this._wjTpl&&(e.hasClass(this.hostElement,"wj-state-focused")||this._itemOff())};MultiAutoComplete.prototype._keyup=function(t){if(!this.isReadOnly&&!t.defaultPrevented)switch(t.keyCode){case e.Key.Back:0===this._tbx.value.length&&0===this._lastInputValue.length&&this._delItem(!1);break;case e.Key.Delete:this._delItem(!0)}};MultiAutoComplete.prototype._addHelperInput=function(){var e=document.createElement("input");e.type="text";e.tabIndex=-1;e.className="wj-token-helper";e.readOnly=!0;this._wjTpl.insertBefore(e,this._wjInput);this._helperInput=e};MultiAutoComplete.prototype._refreshHeader=function(){for(var e=this.hostElement.querySelectorAll(".wj-token"),t=0;t<e.length;t++)this._wjTpl.removeChild(e[t]);var i=this.selectedItems;if(i&&0!==i.length){for(t=0;t<i.length;t++)this._insertToken(i[t]);this._wjInput.style.cssFloat=this.rightToLeft?"right":"left";this._adjustInputWidth()}else{this._wjInput.style.cssFloat=this.rightToLeft?"right":"left";this._adjustInputWidth()}};MultiAutoComplete.prototype._insertToken=function(t){var i=this._getItemText(t,!0);this.isContentHtml||(i=e.escapeHtml(i));this._wjTpl.insertBefore(this._createItem(i),this._wjInput)};MultiAutoComplete.prototype._updateMaxItems=function(){null!=this._maxSelItems&&this._selItems&&this._selItems.length>this._maxSelItems&&(this._selItems=this._selItems.slice(0,this._maxSelItems))};MultiAutoComplete.prototype._updateFocus=function(){var t=this,i=this._wjTpl.querySelector("."+MultiAutoComplete._clsActive);if(i){e.removeClass(i,MultiAutoComplete._clsActive);setTimeout((function(){t._tbx.focus()}))}else this._clearSelIndex()};MultiAutoComplete.prototype._addItem=function(e){if(this.selectedItems.indexOf(this.selectedItem)>-1)this._clearSelIndex();else if(this.selectedIndex>-1){this._updateSelItems(this.selectedItem,!0);this._refreshHeader();e&&this._clearSelIndex();this._disableInput(!0)}};MultiAutoComplete.prototype._delItem=function(e){var t,i,n=this._wjTpl.querySelector("."+MultiAutoComplete._clsActive),o=!1;if(!e||n){if(n){if((i=this._getItemIndex(n))>-1){t=this._selItems[i];o=!0}}else if(this._selItems.length>0){t=this._selItems[this._selItems.length-1];o=!0}if(o){this._updateSelItems(t,!1);this._refreshHeader();this._clearSelIndex();this._disableInput(!1)}this._tbx.focus()}};MultiAutoComplete.prototype._updateSelItems=function(e,t){if(t){this._selItems&&0!==this._selItems.length||(this._selItems=[]);if(null!=this._maxSelItems&&this._selItems.length>=this._maxSelItems)return;this._selItems.push(e)}else{var i=this._selItems.indexOf(e);this._selItems.splice(i,1)}this._hasSelectedMemeberPath()&&this._setSelItem(e,t);this.onSelectedItemsChanged()};MultiAutoComplete.prototype._createItem=function(t){var i=this,n=document.createElement("div"),o=document.createElement("span"),s=document.createElement("a");n.appendChild(o);n.appendChild(s);n.className="wj-token";o.className="wj-token-label";o.innerHTML=t;s.className="wj-token-close";s.href="#";s.tabIndex=-1;s.text="×";n.style.cssFloat=this.rightToLeft?"right":"left";this.addEventListener(n,"click",(function(t){i._helperInput.focus();var o=i._wjTpl.querySelector("."+MultiAutoComplete._clsActive);o&&e.removeClass(o,MultiAutoComplete._clsActive);e.addClass(n,MultiAutoComplete._clsActive);t.stopPropagation();t.preventDefault()}));this.addEventListener(s,"click",(function(e){if(!i.isReadOnly){var t=i._getItemIndex(n);if(t>-1){var o=i._selItems[t];i._updateSelItems(o,!1)}i._wjTpl.removeChild(n);i._adjustInputWidth();i._disableInput(!1);i._tbx.focus();e.stopPropagation();e.preventDefault()}}));return n};MultiAutoComplete.prototype._itemOn=function(t){var i,n,o,s=e.getActiveElement();if((this._tbx!=s||0===this._tbx.value.length)&&0!==(i=this._wjTpl.querySelectorAll(".wj-token")).length){n=this._wjTpl.querySelector("."+MultiAutoComplete._clsActive);o=this._getItemIndex(n);if(t){if(0===o)return;if(-1===o){e.addClass(i[i.length-1],MultiAutoComplete._clsActive);this._helperInput.focus()}else{e.removeClass(n,MultiAutoComplete._clsActive);e.addClass(i[o-1],MultiAutoComplete._clsActive);this._helperInput.focus()}}else if(!t){if(-1===o)return;if(o!==i.length-1){e.removeClass(n,MultiAutoComplete._clsActive);e.addClass(i[o+1],MultiAutoComplete._clsActive);this._helperInput.focus()}else{e.removeClass(n,MultiAutoComplete._clsActive);this._tbx.focus()}}}};MultiAutoComplete.prototype._itemOff=function(){var t=this._wjTpl.querySelector("."+MultiAutoComplete._clsActive);t&&e.removeClass(t,MultiAutoComplete._clsActive)};MultiAutoComplete.prototype._initSeltems=function(){if(this.selectedMemberPath){this._selItems.splice(0,this._selItems.length);var e=this.collectionView;if(e)for(var t=0;t<e.sourceCollection.length;t++)this._getSelItem(t)&&this._selItems.push(e.sourceCollection[t])}};MultiAutoComplete.prototype._getSelItem=function(t){var i=this.collectionView,n=i?i.sourceCollection[t]:null;return!(!e.isObject(n)||!this.selectedMemberPath)&&this._selPath.getValue(n)};MultiAutoComplete.prototype._setSelItem=function(t,i){this.itemsSource;e.isObject(t)&&this._selPath.getValue(t)!=i&&this._selPath.setValue(t,i)};MultiAutoComplete.prototype._clearSelIndex=function(){this.selectedIndex=-1};MultiAutoComplete.prototype._hasSelectedMemeberPath=function(){return this.selectedMemberPath&&""!==this.selectedMemberPath};MultiAutoComplete.prototype._disableInput=function(e){if(null!=this._maxSelItems)if(this._selItems.length<this._maxSelItems){this._tbx.disabled=!1;this._tbx.focus()}else{this._tbx.disabled=!0;this.hostElement.focus()}};MultiAutoComplete.prototype._adjustInputWidth=function(){this._tbx.style.width="60px";var t,i=e.getElementRect(this.hostElement),n=e.getElementRect(this._tbx),o=getComputedStyle(this._tbx),s=parseInt(o.paddingLeft,10),r=parseInt(o.paddingRight,10);t=this.rightToLeft?n.left+n.width-i.left-s-r-8:i.left+i.width-n.left-s-r-8;this._tbx.style.width=t+"px"};MultiAutoComplete.prototype._getItemIndex=function(e){for(var t=this.hostElement.querySelectorAll(".wj-token"),i=0;i<t.length;i++)if(e===t[i])return i;return-1};MultiAutoComplete._clsActive="wj-token-active";return MultiAutoComplete}(t.AutoComplete);t.MultiAutoComplete=i}(e.input||(e.input={}))}(wijmo||(wijmo={}));!function(e){e.input||(e.input={}),e._registerModule("wijmo.input",e.input)}(wijmo||(wijmo={}));
/*!
    *
    * Wijmo Library 5.20211.781
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */

var wijmo,__extends=this&&this.__extends||function(){var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){extendStatics(e,t);function __(){this.constructor=e}e.prototype=null===t?Object.create(t):(__.prototype=t.prototype,new __)}}();!function(e){!function(t){"use strict";t.softChart=function softChart(){return e._getModule("wijmo.chart")};t.softChartAnalytics=function softChartAnalytics(){return e._getModule("wijmo.chart.analytics")};t.softChartAnimation=function softChartAnimation(){return e._getModule("wijmo.chart.animation")};t.softChartAnnotation=function softChartAnnotation(){return e._getModule("wijmo.chart.annotation")};t.softChartFinance=function softChartFinance(){return e._getModule("wijmo.chart.finance")};t.softChartFinanceAnalytics=function softChartFinanceAnalytics(){return e._getModule("wijmo.chart.finance.analytics")};t.softChartHierarchical=function softChartHierarchical(){return e._getModule("wijmo.chart.hierarchical")};t.softChartInteraction=function softChartInteraction(){return e._getModule("wijmo.chart.interaction")};t.softChartRadar=function softChartRadar(){return e._getModule("wijmo.chart.radar")};t.softChartMap=function softChartMap(){return e._getModule("wijmo.chart.map")};t.softGauge=function softGauge(){return e._getModule("wijmo.gauge")};t.softGrid=function softGrid(){return e._getModule("wijmo.grid")};t.softGridDetail=function softGridDetail(){return e._getModule("wijmo.grid.detail")};t.softGridFilter=function softGridFilter(){return e._getModule("wijmo.grid.filter")};t.softGridGrouppanel=function softGridGrouppanel(){return e._getModule("wijmo.grid.grouppanel")};t.softGridSearch=function softGridSearch(){return e._getModule("wijmo.grid.search")};t.softGridMultirow=function softGridMultirow(){return e._getModule("wijmo.grid.multirow")};t.softGridSheet=function softGridSheet(){return e._getModule("wijmo.grid.sheet")};t.softGridTransposed=function softGridTransposed(){return e._getModule("wijmo.grid.transposed")};t.softGridTransposedMultiRow=function softGridTransposedMultiRow(){return e._getModule("wijmo.grid.transposedmultirow")};t.softGridImmutable=function softGridImmutable(){return e._getModule("wijmo.grid.immutable")};t.softNav=function softNav(){return e._getModule("wijmo.nav")};t.softOlap=function softOlap(){return e._getModule("wijmo.olap")};t.softViewer=function softViewer(){return e._getModule("wijmo.viewer")};t.softInput=function softInput(){return e._getModule("wijmo.input")};t.softBarcode=function softBarcode(){return e._getModule("wijmo.barcode")};t.softBarcodeCommon=function softBarcodeCommon(){return e._getModule("wijmo.barcode.common")};t.softBarcodeComposite=function softBarcodeComposite(){return e._getModule("wijmo.barcode.composite")};t.softBarcodeSpecialized=function softBarcodeSpecialized(){return e._getModule("wijmo.barcode.specialized")}}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){var r=function(){function ControlMetaFactory(){}ControlMetaFactory.CreateProp=function(e,t,r,n,i,a){return new o(e,t,r,n,i,a)};ControlMetaFactory.CreateEvent=function(e,t){return new a(e,t)};ControlMetaFactory.CreateComplexProp=function(e,t,r){return new s(e,t,r)};ControlMetaFactory.findProp=function(e,t){return this.findInArr(t,"propertyName",e)};ControlMetaFactory.findEvent=function(e,t){return this.findInArr(t,"eventName",e)};ControlMetaFactory.findComplexProp=function(e,t){return this.findInArr(t,"propertyName",e)};ControlMetaFactory.getMetaData=function(r){switch(r){case e.Control:return new l([this.CreateProp("isDisabled",n.Boolean)],[this.CreateEvent("gotFocus"),this.CreateEvent("lostFocus"),this.CreateEvent("refreshing"),this.CreateEvent("refreshed"),this.CreateEvent("invalidInput")]);case t.softInput()&&t.softInput().DropDown:return this.getMetaData(e.Control).add([this.CreateProp("isDroppedDown",n.Boolean,"isDroppedDownChanged"),this.CreateProp("showDropDownButton",n.Boolean),this.CreateProp("autoExpandSelection",n.Boolean),this.CreateProp("placeholder",n.String),this.CreateProp("dropDownCssClass",n.String),this.CreateProp("isAnimated",n.Boolean),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("isRequired",n.Boolean),this.CreateProp("inputType",n.String),this.CreateProp("clickAction",n.Enum,"",t.softInput().ClickAction),this.CreateProp("text",n.String,"textChanged",null,!0,1e3)],[this.CreateEvent("isDroppedDownChanging"),this.CreateEvent("isDroppedDownChanged",!0),this.CreateEvent("textChanged",!0)]);case t.softInput()&&t.softInput().ComboBox:return this.getMetaData(t.softInput().DropDown).add([this.CreateProp("displayMemberPath",n.String),this.CreateProp("selectedValuePath",n.String),this.CreateProp("headerPath",n.String),this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("isEditable",n.Boolean),this.CreateProp("handleWheel",n.Boolean),this.CreateProp("maxDropDownHeight",n.Number),this.CreateProp("maxDropDownWidth",n.Number),this.CreateProp("itemFormatter",n.Function),this.CreateProp("showGroups",n.Boolean),this.CreateProp("trimText",n.Boolean),this.CreateProp("caseSensitiveSearch",n.Boolean),this.CreateProp("itemsSource",n.Any,"",null,!0,900),this.CreateProp("selectedIndex",n.Number,"selectedIndexChanged",null,!0,1e3),this.CreateProp("selectedItem",n.Any,"selectedIndexChanged",null,!0,1e3),this.CreateProp("selectedValue",n.Any,"selectedIndexChanged",null,!0,1e3)],[this.CreateEvent("itemsSourceChanged"),this.CreateEvent("formatItem"),this.CreateEvent("selectedIndexChanged",!0)]).addOptions({ngModelProperty:"selectedValue"});case t.softInput()&&t.softInput().AutoComplete:return this.getMetaData(t.softInput().ComboBox).add([this.CreateProp("delay",n.Number),this.CreateProp("maxItems",n.Number),this.CreateProp("minLength",n.Number),this.CreateProp("cssMatch",n.String),this.CreateProp("itemsSourceFunction",n.Function),this.CreateProp("searchMemberPath",n.String),this.CreateProp("beginsWithSearch",n.Boolean)]);case t.softInput()&&t.softInput().Calendar:return this.getMetaData(e.Control).add([this.CreateProp("monthView",n.Boolean),this.CreateProp("showHeader",n.Boolean),this.CreateProp("itemFormatter",n.Function),this.CreateProp("itemValidator",n.Function),this.CreateProp("firstDayOfWeek",n.Number),this.CreateProp("max",n.Date),this.CreateProp("min",n.Date),this.CreateProp("formatYearMonth",n.String),this.CreateProp("formatDayHeaders",n.String),this.CreateProp("formatDays",n.String),this.CreateProp("formatYear",n.String),this.CreateProp("formatMonths",n.String),this.CreateProp("selectionMode",n.Enum,"",t.softInput().DateSelectionMode),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("handleWheel",n.Boolean),this.CreateProp("repeatButtons",n.Boolean),this.CreateProp("showYearPicker",n.Boolean),this.CreateProp("value",n.Date,"valueChanged"),this.CreateProp("displayMonth",n.Date,"displayMonthChanged"),this.CreateProp("monthCount",n.Number),this.CreateProp("showMonthPicker",n.Enum,"",t.softInput().ShowMonthPicker),this.CreateProp("weeksBefore",n.Number),this.CreateProp("weeksAfter",n.Number),this.CreateProp("rangeEnd",n.Date,"rangeEndChanged"),this.CreateProp("rangeMin",n.Number),this.CreateProp("rangeMax",n.Number)],[this.CreateEvent("valueChanged",!0),this.CreateEvent("rangeEndChanged",!0),this.CreateEvent("rangeChanged",!1),this.CreateEvent("displayMonthChanged",!0),this.CreateEvent("formatItem",!1)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().ColorPicker:return this.getMetaData(e.Control).add([this.CreateProp("showAlphaChannel",n.Boolean),this.CreateProp("showColorString",n.Boolean),this.CreateProp("palette",n.Any),this.CreateProp("value",n.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().ListBox:return this.getMetaData(e.Control).add([this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("maxHeight",n.Number),this.CreateProp("selectedValuePath",n.String),this.CreateProp("itemFormatter",n.Function),this.CreateProp("displayMemberPath",n.String),this.CreateProp("checkedMemberPath",n.String),this.CreateProp("caseSensitiveSearch",n.Boolean),this.CreateProp("itemsSource",n.Any),this.CreateProp("showGroups",n.Boolean),this.CreateProp("selectedIndex",n.Number,"selectedIndexChanged"),this.CreateProp("selectedItem",n.Any,"selectedIndexChanged"),this.CreateProp("selectedValue",n.Any,"selectedIndexChanged"),this.CreateProp("checkedItems",n.Any,"checkedItemsChanged")],[this.CreateEvent("formatItem",!1),this.CreateEvent("itemsChanged",!0),this.CreateEvent("itemChecked",!0),this.CreateEvent("selectedIndexChanged",!0),this.CreateEvent("checkedItemsChanged",!0)]).addOptions({ngModelProperty:"selectedValue"});case t.softInput()&&t.softInput().MultiSelectListBox:return this.getMetaData(e.Control).add([this.CreateProp("itemsSource",n.Any),this.CreateProp("displayMemberPath",n.String),this.CreateProp("selectedIndex",n.Number,"selectedIndexChanged"),this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("showGroups",n.Boolean),this.CreateProp("checkOnFilter",n.Boolean),this.CreateProp("showFilterInput",n.Boolean),this.CreateProp("filterInputPlaceholder",n.String),this.CreateProp("showSelectAllCheckbox",n.Boolean),this.CreateProp("selectAllLabel",n.String),this.CreateProp("delay",n.Number),this.CreateProp("caseSensitiveSearch",n.Boolean),this.CreateProp("checkedMemberPath",n.String),this.CreateProp("checkedItems",n.Any,"checkedItemsChanged")],[this.CreateEvent("checkedItemsChanged",!0),this.CreateEvent("selectedIndexChanged",!0)]).addOptions({ngModelProperty:"checkedItems"});case"ItemTemplate":return new l([],[],[],void 0,void 0,void 0,"owner");case t.softInput()&&t.softInput().Menu:return this.getMetaData(t.softInput().ComboBox).add([this.CreateProp("header",n.String),this.CreateProp("commandParameterPath",n.String),this.CreateProp("commandPath",n.String),this.CreateProp("subItemsPath",n.String),this.CreateProp("openOnHover",n.Boolean),this.CreateProp("closeOnLeave",n.Boolean),this.CreateProp("isButton",n.Boolean),this.CreateProp("value",n.Any,"itemClicked",null,!1,1e3)],[this.CreateEvent("itemClicked")]);case"MenuItem":return new l([this.CreateProp("value",n.Any,""),this.CreateProp("cmd",n.Any,""),this.CreateProp("cmdParam",n.Any,"")],[],[],"itemsSource",!0);case"MenuSeparator":return new l([],[],[],"itemsSource",!0);case t.softInput()&&t.softInput().InputDate:return this.getMetaData(t.softInput().DropDown).add([this.CreateProp("selectionMode",n.Enum,"",t.softInput().DateSelectionMode),this.CreateProp("format",n.String),this.CreateProp("mask",n.String),this.CreateProp("max",n.Date),this.CreateProp("min",n.Date),this.CreateProp("inputType",n.String),this.CreateProp("value",n.Date,"valueChanged",null,!0,1e3),this.CreateProp("repeatButtons",n.Boolean),this.CreateProp("showYearPicker",n.Boolean),this.CreateProp("itemValidator",n.Function),this.CreateProp("itemFormatter",n.Function),this.CreateProp("monthCount",n.Number),this.CreateProp("handleWheel",n.Boolean),this.CreateProp("showMonthPicker",n.Enum,"",t.softInput().ShowMonthPicker),this.CreateProp("showHeader",n.Boolean),this.CreateProp("weeksBefore",n.Number),this.CreateProp("weeksAfter",n.Number),this.CreateProp("rangeEnd",n.Date,"rangeEndChanged",null,!0,1001),this.CreateProp("rangeMin",n.Number),this.CreateProp("rangeMax",n.Number),this.CreateProp("separator",n.String),this.CreateProp("alwaysShowCalendar",n.Boolean),this.CreateProp("predefinedRanges",n.Any),this.CreateProp("closeOnSelection",n.Boolean)],[this.CreateEvent("valueChanged",!0),this.CreateEvent("rangeEndChanged",!0),this.CreateEvent("rangeChanged",!1)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().InputDateTime:return this.getMetaData(t.softInput().InputDate).add([this.CreateProp("timeMax",n.Date),this.CreateProp("timeMin",n.Date),this.CreateProp("timeStep",n.Number),this.CreateProp("timeFormat",n.String)]);case t.softInput()&&t.softInput().InputDateRange:return this.getMetaData(t.softInput().InputDate);case t.softInput()&&t.softInput().InputNumber:return this.getMetaData(e.Control).add([this.CreateProp("showSpinner",n.Boolean),this.CreateProp("repeatButtons",n.Boolean),this.CreateProp("max",n.Number),this.CreateProp("min",n.Number),this.CreateProp("step",n.Number),this.CreateProp("isRequired",n.Boolean),this.CreateProp("placeholder",n.String),this.CreateProp("inputType",n.String),this.CreateProp("format",n.String),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("handleWheel",n.Boolean),this.CreateProp("value",n.Number,"valueChanged"),this.CreateProp("text",n.String,"textChanged")],[this.CreateEvent("valueChanged",!0),this.CreateEvent("textChanged",!0)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().InputMask:return this.getMetaData(e.Control).add([this.CreateProp("mask",n.String),this.CreateProp("overwriteMode",n.Boolean),this.CreateProp("isRequired",n.Boolean),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("promptChar",n.String),this.CreateProp("placeholder",n.String),this.CreateProp("inputType",n.String),this.CreateProp("rawValue",n.String,"valueChanged"),this.CreateProp("value",n.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().InputTime:return this.getMetaData(t.softInput().ComboBox).add([this.CreateProp("max",n.Date),this.CreateProp("min",n.Date),this.CreateProp("step",n.Number),this.CreateProp("format",n.String),this.CreateProp("mask",n.String),this.CreateProp("inputType",n.String),this.CreateProp("value",n.Date,"valueChanged",null,!0,1e3)],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().InputColor:return this.getMetaData(t.softInput().DropDown).add([this.CreateProp("showAlphaChannel",n.Boolean),this.CreateProp("showColorString",n.Boolean),this.CreateProp("value",n.String,"valueChanged")],[this.CreateEvent("valueChanged",!0)]).addOptions({ngModelProperty:"value"});case t.softInput()&&t.softInput().Popup:return this.getMetaData(e.Control).add([this.CreateProp("owner",n.String),this.CreateProp("showTrigger",n.Enum,"",t.softInput().PopupTrigger),this.CreateProp("hideTrigger",n.Enum,"",t.softInput().PopupTrigger),this.CreateProp("fadeIn",n.Boolean),this.CreateProp("fadeOut",n.Boolean),this.CreateProp("isDraggable",n.Boolean),this.CreateProp("isResizable",n.Boolean),this.CreateProp("dialogResultEnter",n.String),this.CreateProp("dialogResultSubmit",n.String),this.CreateProp("modal",n.Boolean),this.CreateProp("removeOnHide",n.Boolean)],[this.CreateEvent("showing"),this.CreateEvent("shown"),this.CreateEvent("hiding"),this.CreateEvent("hidden"),this.CreateEvent("resizing"),this.CreateEvent("sizeChanging"),this.CreateEvent("sizeChanged"),this.CreateEvent("resized"),this.CreateEvent("dragging"),this.CreateEvent("positionChanging"),this.CreateEvent("positionChanged"),this.CreateEvent("dragged")]);case t.softInput()&&t.softInput().MultiSelect:return this.getMetaData(t.softInput().ComboBox).add([this.CreateProp("checkedMemberPath",n.String),this.CreateProp("maxHeaderItems",n.Number),this.CreateProp("headerFormat",n.String),this.CreateProp("headerFormatter",n.Function),this.CreateProp("showSelectAllCheckbox",n.Boolean),this.CreateProp("selectAllLabel",n.String),this.CreateProp("showFilterInput",n.Boolean),this.CreateProp("filterInputPlaceholder",n.String),this.CreateProp("checkOnFilter",n.Boolean),this.CreateProp("delay",n.Number),this.CreateProp("caseSensitiveSearch",n.Boolean),this.CreateProp("checkedItems",n.Any,"checkedItemsChanged",i.TwoWay,!0,950)],[this.CreateEvent("checkedItemsChanged",!0)]).addOptions({ngModelProperty:"checkedItems"});case"CollectionViewNavigator":return new l([this.CreateProp("cv",n.Any)]);case t.softInput()&&t.softInput().CollectionViewNavigator:return this.getMetaData(e.Control).add([this.CreateProp("cv",n.Any),this.CreateProp("byPage",n.Boolean),this.CreateProp("headerFormat",n.String),this.CreateProp("repeatButtons",n.Boolean)]);case"CollectionViewPager":return new l([this.CreateProp("cv",n.Any)]);case t.softInput()&&t.softInput().MultiAutoComplete:return this.getMetaData(t.softInput().AutoComplete).add([this.CreateProp("maxSelectedItems",n.Number),this.CreateProp("selectedMemberPath",n.String,"",null,!0,950),this.CreateProp("selectedItems",n.Any,"selectedItemsChanged")],[this.CreateEvent("selectedItemsChanged",!0)]).addOptions({ngModelProperty:"selectedItems"});case t.softGrid()&&t.softGrid().FlexGrid:return this.getMetaData(e.Control).add([this.CreateProp("newRowAtTop",n.Boolean),this.CreateProp("allowAddNew",n.Boolean),this.CreateProp("allowDelete",n.Boolean),this.CreateProp("allowDragging",n.Enum,"",t.softGrid().AllowDragging),this.CreateProp("allowMerging",n.Enum,"",t.softGrid().AllowMerging),this.CreateProp("allowResizing",n.Enum,"",t.softGrid().AllowResizing),this.CreateProp("allowSorting",n.Enum,"",t.softGrid().AllowSorting),this.CreateProp("allowPinning",n.Enum,"",t.softGrid().AllowPinning),this.CreateProp("autoScroll",n.Boolean),this.CreateProp("autoRowHeights",n.Boolean),this.CreateProp("autoSizeMode",n.Enum,"",t.softGrid().AutoSizeMode),this.CreateProp("autoGenerateColumns",n.Boolean),this.CreateProp("autoSearch",n.Boolean),this.CreateProp("caseSensitiveSearch",n.Boolean),this.CreateProp("quickAutoSize",n.Boolean),this.CreateProp("bigCheckboxes",n.Boolean),this.CreateProp("childItemsPath",n.Any),this.CreateProp("groupHeaderFormat",n.String),this.CreateProp("headersVisibility",n.Enum,"",t.softGrid().HeadersVisibility),this.CreateProp("showSelectedHeaders",n.Enum,"",t.softGrid().HeadersVisibility),this.CreateProp("showMarquee",n.Boolean),this.CreateProp("showPlaceholders",n.Boolean),this.CreateProp("itemFormatter",n.Function),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("imeEnabled",n.Boolean),this.CreateProp("mergeManager",n.Any),this.CreateProp("selectionMode",n.Enum,"",t.softGrid().SelectionMode),this.CreateProp("showGroups",n.Boolean),this.CreateProp("showSort",n.Boolean),this.CreateProp("showDropDown",n.Boolean),this.CreateProp("showAlternatingRows",n.Boolean),this.CreateProp("showErrors",n.Boolean),this.CreateProp("alternatingRowStep",n.Number),this.CreateProp("itemValidator",n.Function),this.CreateProp("validateEdits",n.Boolean),this.CreateProp("treeIndent",n.Number),this.CreateProp("itemsSource",n.Any),this.CreateProp("autoClipboard",n.Boolean),this.CreateProp("expandSelectionOnCopyPaste",n.Boolean),this.CreateProp("frozenRows",n.Number),this.CreateProp("frozenColumns",n.Number),this.CreateProp("cloneFrozenCells",n.Boolean),this.CreateProp("deferResizing",n.Boolean),this.CreateProp("sortRowIndex",n.Number),this.CreateProp("editColumnIndex",n.Number),this.CreateProp("stickyHeaders",n.Boolean),this.CreateProp("preserveSelectedState",n.Boolean),this.CreateProp("preserveOutlineState",n.Boolean),this.CreateProp("preserveWhiteSpace",n.Boolean),this.CreateProp("keyActionTab",n.Enum,"",t.softGrid().KeyAction),this.CreateProp("keyActionEnter",n.Enum,"",t.softGrid().KeyAction),this.CreateProp("rowHeaderPath",n.String),this.CreateProp("virtualizationThreshold",n.Any),this.CreateProp("anchorCursor",n.Boolean),this.CreateProp("lazyRender",n.Boolean),this.CreateProp("refreshOnEdit",n.Boolean),this.CreateProp("copyHeaders",n.Enum,"",t.softGrid().HeadersVisibility),this.CreateProp("columnGroups",n.Any)],[this.CreateEvent("beginningEdit"),this.CreateEvent("cellEditEnded"),this.CreateEvent("cellEditEnding"),this.CreateEvent("prepareCellForEdit"),this.CreateEvent("formatItem"),this.CreateEvent("resizingColumn"),this.CreateEvent("resizedColumn"),this.CreateEvent("autoSizingColumn"),this.CreateEvent("autoSizedColumn"),this.CreateEvent("draggingColumn"),this.CreateEvent("draggingColumnOver"),this.CreateEvent("draggedColumn"),this.CreateEvent("sortingColumn"),this.CreateEvent("sortedColumn"),this.CreateEvent("pinningColumn"),this.CreateEvent("pinnedColumn"),this.CreateEvent("resizingRow"),this.CreateEvent("resizedRow"),this.CreateEvent("autoSizingRow"),this.CreateEvent("autoSizedRow"),this.CreateEvent("draggingRow"),this.CreateEvent("draggingRowOver"),this.CreateEvent("draggedRow"),this.CreateEvent("deletingRow"),this.CreateEvent("deletedRow",!0),this.CreateEvent("loadingRows"),this.CreateEvent("loadedRows",!0),this.CreateEvent("rowEditStarting"),this.CreateEvent("rowEditStarted"),this.CreateEvent("rowEditEnding"),this.CreateEvent("rowEditEnded"),this.CreateEvent("rowAdded",!0),this.CreateEvent("groupCollapsedChanging"),this.CreateEvent("groupCollapsedChanged"),this.CreateEvent("itemsSourceChanging"),this.CreateEvent("itemsSourceChanged",!0),this.CreateEvent("selectionChanging"),this.CreateEvent("selectionChanged",!0),this.CreateEvent("scrollPositionChanged",!1),this.CreateEvent("updatingView"),this.CreateEvent("updatedView"),this.CreateEvent("updatingLayout"),this.CreateEvent("updatedLayout"),this.CreateEvent("pasting"),this.CreateEvent("pasted"),this.CreateEvent("pastingCell"),this.CreateEvent("pastedCell"),this.CreateEvent("copying"),this.CreateEvent("copied")]);case t.softGrid()&&t.softGrid().Column:return new l([this.CreateProp("name",n.String),this.CreateProp("dataMap",n.Any),this.CreateProp("dataType",n.Enum,"",e.DataType),this.CreateProp("binding",n.String),this.CreateProp("sortMemberPath",n.String),this.CreateProp("format",n.String),this.CreateProp("cellTemplate",n.Any),this.CreateProp("header",n.String),this.CreateProp("width",n.Number),this.CreateProp("maxLength",n.Number),this.CreateProp("minWidth",n.Number),this.CreateProp("maxWidth",n.Number),this.CreateProp("align",n.String),this.CreateProp("allowDragging",n.Boolean),this.CreateProp("allowSorting",n.Boolean),this.CreateProp("allowResizing",n.Boolean),this.CreateProp("allowMerging",n.Boolean),this.CreateProp("aggregate",n.Enum,"",e.Aggregate),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("cssClass",n.String),this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("isSelected",n.Boolean,"grid.selectionChanged"),this.CreateProp("visible",n.Boolean),this.CreateProp("wordWrap",n.Boolean),this.CreateProp("multiLine",n.Boolean),this.CreateProp("mask",n.String),this.CreateProp("inputType",n.String),this.CreateProp("isRequired",n.Boolean),this.CreateProp("showDropDown",n.Boolean),this.CreateProp("dataMapEditor",n.Enum,"",t.softGrid().DataMapEditor),this.CreateProp("dropDownCssClass",n.String),this.CreateProp("quickAutoSize",n.Boolean),this.CreateProp("editor",n.Any)],[],[],"columns",!0);case"FlexGridCellTemplate":return new l([this.CreateProp("cellType",n.String,"",null,!1),this.CreateProp("cellOverflow",n.String,""),this.CreateProp("forceFullEdit",n.Boolean)],[],[],void 0,void 0,void 0,"owner");case"MultiRowCellTemplate":return this.getMetaData("FlexGridCellTemplate").add([]);case t.softGrid()&&t.softGridFilter()&&t.softGridFilter().FlexGridFilter:return new l([this.CreateProp("showFilterIcons",n.Boolean),this.CreateProp("showSortButtons",n.Boolean),this.CreateProp("defaultFilterType",n.Enum,"",t.softGridFilter().FilterType),this.CreateProp("filterColumns",n.Any)],[this.CreateEvent("editingFilter"),this.CreateEvent("filterChanging"),this.CreateEvent("filterChanged"),this.CreateEvent("filterApplied")],[],void 0,void 0,void 0,"");case t.softGrid()&&t.softGridGrouppanel()&&t.softGridGrouppanel().GroupPanel:return this.getMetaData(e.Control).add([this.CreateProp("hideGroupedColumns",n.Boolean),this.CreateProp("showDragGlyphs",n.Boolean),this.CreateProp("maxGroups",n.Number),this.CreateProp("placeholder",n.String),this.CreateProp("filter",n.Any),this.CreateProp("grid",n.Any)]);case t.softGrid()&&t.softGridDetail()&&t.softGridDetail().FlexGridDetailProvider:return new l([this.CreateProp("maxHeight",n.Number),this.CreateProp("keyActionEnter",n.Enum,"",t.softGridDetail().KeyAction),this.CreateProp("detailVisibilityMode",n.Enum,"",t.softGridDetail().DetailVisibilityMode),this.CreateProp("rowHasDetail",n.Function),this.CreateProp("isAnimated",n.Boolean)],[],[],void 0,void 0,void 0,"");case t.softGrid()&&t.softGridSearch()&&t.softGridSearch().FlexGridSearch:return this.getMetaData(e.Control).add([this.CreateProp("text",n.String),this.CreateProp("delay",n.Number),this.CreateProp("searchAllColumns",n.Boolean),this.CreateProp("placeholder",n.String),this.CreateProp("cssMatch",n.String),this.CreateProp("grid",n.Any)]);case t.softGrid()&&t.softGridImmutable()&&t.softGridImmutable().ImmutabilityProvider:return new l([this.CreateProp("itemsSource",n.Any)],[this.CreateEvent("dataChanged"),this.CreateEvent("cloningItem")],[],void 0,void 0,void 0,"");case t.softGrid()&&t.softGridSheet()&&t.softGridSheet().FlexSheet:return this.getMetaData(t.softGrid().FlexGrid).add([this.CreateProp("allowAutoFill",n.Boolean),this.CreateProp("isTabHolderVisible",n.Boolean),this.CreateProp("showFilterIcons",n.Boolean),this.CreateProp("enableDragDrop",n.Boolean),this.CreateProp("enableFormulas",n.Boolean),this.CreateProp("selectedSheetIndex",n.Number,"selectedSheetChanged")],[this.CreateEvent("selectedSheetChanged",!0),this.CreateEvent("draggingRowColumn"),this.CreateEvent("droppingRowColumn"),this.CreateEvent("beginDroppingRowColumn"),this.CreateEvent("endDroppingRowColumn"),this.CreateEvent("loaded"),this.CreateEvent("unknownFunction"),this.CreateEvent("sheetCleared"),this.CreateEvent("prepareChangingRow"),this.CreateEvent("prepareChangingColumn"),this.CreateEvent("rowChanged"),this.CreateEvent("columnChanged"),this.CreateEvent("autoFilling"),this.CreateEvent("autoFilled")]);case t.softGrid()&&t.softGridSheet()&&t.softGridSheet().Sheet:return new l([this.CreateProp("name",n.String),this.CreateProp("itemsSource",n.Any),this.CreateProp("visible",n.Boolean),this.CreateProp("rowCount",n.Number,"",null),this.CreateProp("columnCount",n.Number,"",null)],[this.CreateEvent("nameChanged")],[],"sheets",!0,void 0,"");case t.softGrid()&&t.softGridMultirow()&&t.softGridMultirow().MultiRow:return this.getMetaData(t.softGrid().FlexGrid).add([this.CreateProp("layoutDefinition",n.Any),this.CreateProp("headerLayoutDefinition",n.Any),this.CreateProp("centerHeadersVertically",n.Boolean),this.CreateProp("collapsedHeaders",n.Boolean,"collapsedHeadersChanged"),this.CreateProp("showHeaderCollapseButton",n.Boolean),this.CreateProp("multiRowGroupHeaders",n.Boolean)],[this.CreateEvent("collapsedHeadersChanging"),this.CreateEvent("collapsedHeadersChanged",!0)]);case t.softGrid()&&t.softGridMultirow()&&t.softGridMultirow().MultiRowCell:return this.getMetaData(t.softGrid().Column).add([this.CreateProp("colspan",n.Number),this.CreateProp("rowspan",n.Number)],[],[],"cells",!0);case t.softGridMultirow()&&t.softGridMultirow().MultiRowCellGroup:return this.getMetaData(t.softGridMultirow().MultiRowCell).add([],[],[],"layoutDefinition",!0);case t.softGrid()&&t.softGridTransposed()&&t.softGridTransposed().TransposedGrid:return this.getMetaData(t.softGrid().FlexGrid).add([this.CreateProp("autoGenerateRows",n.Boolean,"",null,!0,-100),this.CreateProp("rowGroups",n.Any)]);case t.softGrid()&&t.softGridTransposed()&&t.softGridTransposed().TransposedGridRow:return this.getMetaData(t.softGrid().Column).addOptions({parentProperty:"_rowInfo"});case t.softGrid()&&t.softGridTransposedMultiRow()&&t.softGridTransposedMultiRow().TransposedMultiRow:return this.getMetaData(t.softGrid().FlexGrid).add([this.CreateProp("layoutDefinition",n.Any)]);case t.softChart()&&t.softChart().FlexChartBase:return this.getMetaData(e.Control).add([this.CreateProp("binding",n.String),this.CreateProp("footer",n.String),this.CreateProp("header",n.String),this.CreateProp("selectionMode",n.Enum,"",t.softChart().SelectionMode),this.CreateProp("palette",n.Any),this.CreateProp("plotMargin",n.Any),this.CreateProp("footerStyle",n.Any),this.CreateProp("headerStyle",n.Any),this.CreateProp("tooltipContent",n.String,"",null,!1),this.CreateProp("itemsSource",n.Any)],[this.CreateEvent("rendering"),this.CreateEvent("rendered"),this.CreateEvent("selectionChanged",!0),this.CreateEvent("itemsSourceChanging"),this.CreateEvent("itemsSourceChanged",!0)]);case t.softChart()&&t.softChart().FlexChartCore:return this.getMetaData(t.softChart().FlexChartBase).add([this.CreateProp("bindingX",n.String),this.CreateProp("interpolateNulls",n.Boolean),this.CreateProp("legendToggle",n.Boolean),this.CreateProp("symbolSize",n.Number),this.CreateProp("options",n.Any),this.CreateProp("selection",n.Any,"selectionChanged"),this.CreateProp("itemFormatter",n.Function),this.CreateProp("labelContent",n.String,"",null,!1),this.CreateProp("renderEngine",n.Any,"",null,!0,-1e3)],[this.CreateEvent("seriesVisibilityChanged")],[this.CreateComplexProp("axisX",!1,!1),this.CreateComplexProp("axisY",!1,!1),this.CreateComplexProp("axes",!0),this.CreateComplexProp("plotAreas",!0)]);case t.softChart()&&t.softChart().FlexChart:return this.getMetaData(t.softChart().FlexChartCore).add([this.CreateProp("chartType",n.Enum,"",t.softChart().ChartType),this.CreateProp("rotated",n.Boolean),this.CreateProp("stacking",n.Enum,"",t.softChart().Stacking)]);case t.softChart()&&t.softChart().FlexPie:return this.getMetaData(t.softChart().FlexChartBase).add([this.CreateProp("bindingName",n.String),this.CreateProp("innerRadius",n.Number),this.CreateProp("isAnimated",n.Boolean),this.CreateProp("offset",n.Number),this.CreateProp("reversed",n.Boolean),this.CreateProp("startAngle",n.Number),this.CreateProp("selectedIndex",n.Number),this.CreateProp("selectedItemPosition",n.Enum,"",t.softChart().Position),this.CreateProp("selectedItemOffset",n.Number),this.CreateProp("itemFormatter",n.Function),this.CreateProp("labelContent",n.String,"",null,!1),this.CreateProp("titles",n.Any),this.CreateProp("chartsPerLine",n.Number)]);case t.softChart()&&t.softChart().FlexPie&&t.softChartHierarchical()&&t.softChartHierarchical().Sunburst:return this.getMetaData(t.softChart().FlexChartBase).add([this.CreateProp("bindingName",n.Any),this.CreateProp("innerRadius",n.Number),this.CreateProp("isAnimated",n.Boolean),this.CreateProp("offset",n.Number),this.CreateProp("reversed",n.Boolean),this.CreateProp("startAngle",n.Number),this.CreateProp("selectedIndex",n.Number),this.CreateProp("selectedItemPosition",n.Enum,"",t.softChart().Position),this.CreateProp("selectedItemOffset",n.Number),this.CreateProp("itemFormatter",n.Function),this.CreateProp("labelContent",n.String,"",null,!1),this.CreateProp("childItemsPath",n.Any)]);case t.softChart()&&t.softChartHierarchical()&&t.softChartHierarchical().TreeMap:return this.getMetaData(t.softChart().FlexChartBase).add([this.CreateProp("bindingName",n.Any),this.CreateProp("maxDepth",n.Number),this.CreateProp("type",n.Enum,"",t.softChartHierarchical().TreeMapType),this.CreateProp("labelContent",n.String,"",null,!1),this.CreateProp("childItemsPath",n.Any)]);case t.softChart()&&t.softChart().Axis:return new l([this.CreateProp("axisLine",n.Boolean),this.CreateProp("format",n.String),this.CreateProp("labels",n.Boolean),this.CreateProp("majorGrid",n.Boolean),this.CreateProp("majorTickMarks",n.Enum,"",t.softChart().TickMark),this.CreateProp("majorUnit",n.Number),this.CreateProp("max",n.Number),this.CreateProp("min",n.Number),this.CreateProp("position",n.Enum,"",t.softChart().Position),this.CreateProp("reversed",n.Boolean),this.CreateProp("title",n.String),this.CreateProp("labelAngle",n.Number),this.CreateProp("minorGrid",n.Boolean),this.CreateProp("minorTickMarks",n.Enum,"",t.softChart().TickMark),this.CreateProp("minorUnit",n.Number),this.CreateProp("origin",n.Number),this.CreateProp("logBase",n.Number),this.CreateProp("plotArea",n.Any),this.CreateProp("labelAlign",n.String),this.CreateProp("name",n.String),this.CreateProp("overlappingLabels",n.Enum,"",t.softChart().OverlappingLabels),this.CreateProp("labelPadding",n.Number),this.CreateProp("itemFormatter",n.Function),this.CreateProp("itemsSource",n.Any),this.CreateProp("binding",n.String)],[this.CreateEvent("rangeChanged")],[],"axes",!0);case t.softChart()&&t.softChart().Legend:return new l([this.CreateProp("orientation",n.Enum,"",t.softChart().Orientation),this.CreateProp("position",n.Enum,"",t.softChart().Position),this.CreateProp("title",n.String),this.CreateProp("titleAlign",n.String),this.CreateProp("maxSize",n.String)],[],[],"legend",!1,!1,"");case t.softChart()&&t.softChart().DataLabelBase:return new l([this.CreateProp("content",n.Any,""),this.CreateProp("border",n.Boolean),this.CreateProp("offset",n.Number),this.CreateProp("connectingLine",n.Boolean)],[this.CreateEvent("rendering")],[],"dataLabel",!1,!1);case t.softChart()&&t.softChart().DataLabel:return this.getMetaData(t.softChart().DataLabelBase).add([this.CreateProp("position",n.Enum,"",t.softChart().LabelPosition)]);case t.softChart()&&t.softChart().PieDataLabel:return this.getMetaData(t.softChart().DataLabelBase).add([this.CreateProp("position",n.Enum,"",t.softChart().PieLabelPosition)]);case t.softChart()&&t.softChart().SeriesBase:return new l([this.CreateProp("axisX",n.Any),this.CreateProp("axisY",n.Any),this.CreateProp("binding",n.String),this.CreateProp("bindingX",n.String),this.CreateProp("cssClass",n.String),this.CreateProp("name",n.String),this.CreateProp("style",n.Any),this.CreateProp("altStyle",n.Any),this.CreateProp("symbolMarker",n.Enum,"",t.softChart().Marker),this.CreateProp("symbolSize",n.Number),this.CreateProp("symbolStyle",n.Any),this.CreateProp("visibility",n.Enum,"chart.seriesVisibilityChanged",t.softChart().SeriesVisibility),this.CreateProp("itemsSource",n.Any),this.CreateProp("interpolateNulls",n.Boolean),this.CreateProp("tooltipContent",n.Any),this.CreateProp("itemFormatter",n.Function)],[this.CreateEvent("rendering"),this.CreateEvent("rendered")],[this.CreateComplexProp("axisX",!1,!0),this.CreateComplexProp("axisY",!1,!0)],"series",!0);case t.softChart()&&t.softChart().Series:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("chartType",n.Enum,"",t.softChart().ChartType)]);case t.softChart()&&t.softChart().LineMarker:return new l([this.CreateProp("isVisible",n.Boolean),this.CreateProp("seriesIndex",n.Number),this.CreateProp("horizontalPosition",n.Number),this.CreateProp("content",n.Function),this.CreateProp("verticalPosition",n.Number),this.CreateProp("alignment",n.Enum,"",t.softChart().LineMarkerAlignment),this.CreateProp("lines",n.Enum,"",t.softChart().LineMarkerLines),this.CreateProp("interaction",n.Enum,"",t.softChart().LineMarkerInteraction),this.CreateProp("dragLines",n.Boolean),this.CreateProp("dragThreshold",n.Number),this.CreateProp("dragContent",n.Boolean)],[this.CreateEvent("positionChanged")],[],void 0,void 0,void 0,"");case t.softChart()&&t.softChart().DataPoint:return new l([this.CreateProp("x",n.AnyPrimitive),this.CreateProp("y",n.AnyPrimitive)],[],[],"");case t.softChart()&&t.softChartAnnotation()&&t.softChartAnnotation().AnnotationLayer:return new l([],[],[],void 0,void 0,void 0,"");case"FlexChartAnnotation":return new l([this.CreateProp("type",n.String,"",null,!1),this.CreateProp("attachment",n.Enum,"",t.softChartAnnotation().AnnotationAttachment),this.CreateProp("position",n.Enum,"",t.softChartAnnotation().AnnotationPosition),this.CreateProp("point",n.Any),this.CreateProp("seriesIndex",n.Number),this.CreateProp("pointIndex",n.Number),this.CreateProp("offset",n.Any),this.CreateProp("style",n.Any),this.CreateProp("isVisible",n.Boolean),this.CreateProp("tooltip",n.String),this.CreateProp("text",n.String),this.CreateProp("content",n.String),this.CreateProp("name",n.String),this.CreateProp("width",n.Number),this.CreateProp("height",n.Number),this.CreateProp("start",n.Any),this.CreateProp("end",n.Any),this.CreateProp("radius",n.Number),this.CreateProp("length",n.Number),this.CreateProp("href",n.String)],[],[this.CreateComplexProp("point",!1,!0),this.CreateComplexProp("start",!1,!0),this.CreateComplexProp("end",!1,!0),this.CreateComplexProp("points",!0)],"items",!0);case t.softChart()&&t.softChartInteraction()&&t.softChartInteraction().RangeSelector:return new l([this.CreateProp("isVisible",n.Boolean),this.CreateProp("min",n.Number),this.CreateProp("max",n.Number),this.CreateProp("orientation",n.Enum,"",t.softChartInteraction().Orientation),this.CreateProp("seamless",n.Boolean),this.CreateProp("minScale",n.Number),this.CreateProp("maxScale",n.Number)],[this.CreateEvent("rangeChanged")],[],void 0,void 0,void 0,"");case t.softChart()&&t.softChartInteraction()&&t.softChartInteraction().ChartGestures:return new l([this.CreateProp("mouseAction",n.Enum,"",t.softChartInteraction().MouseAction),this.CreateProp("interactiveAxes",n.Enum,"",t.softChartInteraction().InteractiveAxes),this.CreateProp("enable",n.Boolean),this.CreateProp("scaleX",n.Number),this.CreateProp("scaleY",n.Number),this.CreateProp("posX",n.Number),this.CreateProp("posY",n.Number)],[],[],void 0,void 0,void 0,"");case t.softChart()&&t.softChartAnimation()&&t.softChartAnimation().ChartAnimation:return new l([this.CreateProp("animationMode",n.Enum,"",t.softChartAnimation().AnimationMode),this.CreateProp("easing",n.Enum,"",t.softChartAnimation().Easing),this.CreateProp("duration",n.Number),this.CreateProp("axisAnimation",n.Boolean)],[],[],void 0,void 0,void 0,"");case t.softChart()&&t.softChartFinance()&&t.softChartFinance().FinancialChart:return this.getMetaData(t.softChart().FlexChartCore).add([this.CreateProp("chartType",n.Enum,"",t.softChartFinance().FinancialChartType)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinance().FinancialSeries:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("chartType",n.Enum,"",t.softChartFinance().FinancialChartType)]);case t.softChart()&&t.softChartRadar()&&t.softChartRadar().FlexRadar:return this.getMetaData(t.softChart().FlexChartCore).add([this.CreateProp("chartType",n.Enum,"",t.softChartRadar().RadarChartType),this.CreateProp("startAngle",n.Number),this.CreateProp("totalAngle",n.Number),this.CreateProp("reversed",n.Boolean),this.CreateProp("stacking",n.Enum,"",t.softChart().Stacking)]);case t.softChart()&&t.softChartRadar()&&t.softChartRadar().FlexRadarSeries:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("chartType",n.Enum,"",t.softChartRadar().RadarChartType)]);case t.softChart()&&t.softChartRadar()&&t.softChartRadar().FlexRadarAxis:return this.getMetaData(t.softChart().Axis);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().TrendLineBase:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("sampleCount",n.Number)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().TrendLine:return this.getMetaData(t.softChartAnalytics().TrendLineBase).add([this.CreateProp("order",n.Number),this.CreateProp("fitType",n.Enum,"",t.softChartAnalytics().TrendLineFitType)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().MovingAverage:return this.getMetaData(t.softChartAnalytics().TrendLineBase).add([this.CreateProp("period",n.Number),this.CreateProp("type",n.Enum,"",t.softChartAnalytics().MovingAverageType)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().FunctionSeries:return this.getMetaData(t.softChartAnalytics().TrendLineBase).add([this.CreateProp("min",n.Number),this.CreateProp("max",n.Number)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().YFunctionSeries:return this.getMetaData(t.softChartAnalytics().FunctionSeries).add([this.CreateProp("func",n.Function)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().ParametricFunctionSeries:return this.getMetaData(t.softChartAnalytics().FunctionSeries).add([this.CreateProp("func",n.Function),this.CreateProp("xFunc",n.Function),this.CreateProp("yFunc",n.Function)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().Waterfall:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("relativeData",n.Boolean),this.CreateProp("start",n.Number),this.CreateProp("startLabel",n.String),this.CreateProp("showTotal",n.Boolean),this.CreateProp("totalLabel",n.String),this.CreateProp("showIntermediateTotal",n.Boolean),this.CreateProp("intermediateTotalPositions",n.Any),this.CreateProp("intermediateTotalLabels",n.Any),this.CreateProp("connectorLines",n.Boolean),this.CreateProp("styles",n.Any)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().BoxWhisker:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("quartileCalculation",n.Enum,"",t.softChartAnalytics().QuartileCalculation),this.CreateProp("groupWidth",n.Number),this.CreateProp("gapWidth",n.Number),this.CreateProp("showMeanLine",n.Boolean),this.CreateProp("meanLineStyle",n.Any),this.CreateProp("showMeanMarker",n.Boolean),this.CreateProp("meanMarkerStyle",n.Any),this.CreateProp("showInnerPoints",n.Boolean),this.CreateProp("showOutliers",n.Boolean)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().ErrorBar:return this.getMetaData(t.softChart().Series).add([this.CreateProp("errorBarStyle",n.Any),this.CreateProp("value",n.Any),this.CreateProp("errorAmount",n.Enum,"",t.softChartAnalytics().ErrorAmount),this.CreateProp("endStyle",n.Enum,"",t.softChartAnalytics().ErrorBarEndStyle),this.CreateProp("direction",n.Enum,"",t.softChartAnalytics().ErrorBarDirection)]);case t.softChart()&&t.softChartAnalytics()&&t.softChartAnalytics().BreakEven:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("fixedCost",n.Number),this.CreateProp("variableCost",n.Number),this.CreateProp("salesPrice",n.Number),this.CreateProp("styles",n.Any)]);case t.softChart()&&t.softChart().PlotArea:return new l([this.CreateProp("column",n.Number),this.CreateProp("height",n.String),this.CreateProp("name",n.String),this.CreateProp("row",n.Number),this.CreateProp("style",n.Any),this.CreateProp("width",n.String)],[],[],"plotAreas",!0);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().Fibonacci:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("high",n.Number),this.CreateProp("low",n.Number),this.CreateProp("labelPosition",n.Enum,"",t.softChart().LabelPosition),this.CreateProp("levels",n.Any),this.CreateProp("minX",n.AnyPrimitive),this.CreateProp("maxX",n.AnyPrimitive),this.CreateProp("uptrend",n.Boolean)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().FibonacciTimeZones:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("startX",n.Any),this.CreateProp("endX",n.Any),this.CreateProp("labelPosition",n.Enum,"",t.softChart().LabelPosition),this.CreateProp("levels",n.Any)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().FibonacciArcs:case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().FibonacciFans:return this.getMetaData(t.softChart().SeriesBase).add([this.CreateProp("start",n.Any),this.CreateProp("end",n.Any),this.CreateProp("labelPosition",n.Enum,"",t.softChart().LabelPosition),this.CreateProp("levels",n.Any)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().OverlayIndicatorBase:return this.getMetaData(t.softChart().SeriesBase);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().SingleOverlayIndicatorBase:return this.getMetaData(t.softChartFinanceAnalytics().OverlayIndicatorBase).add([this.CreateProp("period",n.Number)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().MacdBase:return this.getMetaData(t.softChartFinanceAnalytics().OverlayIndicatorBase).add([this.CreateProp("fastPeriod",n.Number),this.CreateProp("slowPeriod",n.Number),this.CreateProp("smoothingPeriod",n.Number)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().Macd:return this.getMetaData(t.softChartFinanceAnalytics().MacdBase).add([this.CreateProp("styles",n.Any)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().MacdHistogram:return this.getMetaData(t.softChartFinanceAnalytics().MacdBase);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().ATR:case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().RSI:case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().WilliamsR:return this.getMetaData(t.softChartFinanceAnalytics().SingleOverlayIndicatorBase);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().CCI:return this.getMetaData(t.softChartFinanceAnalytics().SingleOverlayIndicatorBase).add([this.CreateProp("constant",n.Number)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().Stochastic:return this.getMetaData(t.softChartFinanceAnalytics().OverlayIndicatorBase).add([this.CreateProp("dPeriod",n.Number),this.CreateProp("kPeriod",n.Number),this.CreateProp("smoothingPeriod",n.Number),this.CreateProp("styles",n.Any)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().Envelopes:return this.getMetaData(t.softChartFinanceAnalytics().OverlayIndicatorBase).add([this.CreateProp("period",n.Number),this.CreateProp("size",n.Number),this.CreateProp("type",n.Enum,"",t.softChartFinanceAnalytics().MovingAverageType)]);case t.softChart()&&t.softChartFinance()&&t.softChartFinanceAnalytics()&&t.softChartFinanceAnalytics().BollingerBands:return this.getMetaData(t.softChartFinanceAnalytics().OverlayIndicatorBase).add([this.CreateProp("period",n.Number),this.CreateProp("multiplier",n.Number)]);case t.softChart()&&t.softChartMap()&&t.softChartMap().FlexMap:return this.getMetaData(t.softChart().FlexChartBase).add([this.CreateProp("center",n.Any),this.CreateProp("zoom",n.Number)],[],[]);case t.softChart()&&t.softChartMap()&&t.softChartMap().MapLayerBase:return new l([this.CreateProp("style",n.Any),this.CreateProp("itemsSource",n.Any,"itemsSourceChanged"),this.CreateProp("url",n.String)],[this.CreateEvent("itemsSourceChanged",!0)],[],"layers",!0);case t.softChart()&&t.softChartMap()&&t.softChartMap().ScatterMapLayer:return this.getMetaData(t.softChartMap().MapLayerBase).add([this.CreateProp("symbolSize",n.Number),this.CreateProp("symbolMinSize",n.Number),this.CreateProp("symbolMaxSize",n.Number),this.CreateProp("binding",n.String)]);case t.softChart()&&t.softChartMap()&&t.softChartMap().GeoMapLayer:return this.getMetaData(t.softChartMap().MapLayerBase).add([this.CreateProp("itemFormatter",n.Any)]);case t.softChart()&&t.softChartMap()&&t.softChartMap().GeoGridLayer:return this.getMetaData(t.softChartMap().MapLayerBase);case t.softChart()&&t.softChartMap()&&t.softChartMap().ColorScale:return new l([this.CreateProp("scale",n.Number),this.CreateProp("binding",n.String),this.CreateProp("colorUnknown",n.String),this.CreateProp("colors",n.Any),this.CreateProp("format",n.String)],[],[],"colorScale",!1);case t.softGauge()&&t.softGauge().Gauge:return this.getMetaData(e.Control).add([this.CreateProp("value",n.Number,"valueChanged"),this.CreateProp("min",n.Number),this.CreateProp("max",n.Number),this.CreateProp("origin",n.Number),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("handleWheel",n.Boolean),this.CreateProp("step",n.Number),this.CreateProp("format",n.String),this.CreateProp("thickness",n.Number),this.CreateProp("hasShadow",n.Boolean),this.CreateProp("isAnimated",n.Boolean),this.CreateProp("showText",n.Enum,"",t.softGauge().ShowText),this.CreateProp("showTicks",n.Boolean),this.CreateProp("showTickText",n.Boolean),this.CreateProp("showRanges",n.Boolean),this.CreateProp("stackRanges",n.Boolean),this.CreateProp("thumbSize",n.Number),this.CreateProp("tickSpacing",n.Number),this.CreateProp("getText",n.Function)],[this.CreateEvent("valueChanged",!0)],[this.CreateComplexProp("ranges",!0),this.CreateComplexProp("pointer",!1,!1),this.CreateComplexProp("face",!1,!1)]).addOptions({ngModelProperty:"value"});case t.softGauge()&&t.softGauge().LinearGauge:return this.getMetaData(t.softGauge().Gauge).add([this.CreateProp("direction",n.Enum,"",t.softGauge().GaugeDirection)]);case t.softGauge()&&t.softGauge().BulletGraph:return this.getMetaData(t.softGauge().LinearGauge).add([this.CreateProp("target",n.Number),this.CreateProp("good",n.Number),this.CreateProp("bad",n.Number)]);case t.softGauge()&&t.softGauge().RadialGauge:return this.getMetaData(t.softGauge().Gauge).add([this.CreateProp("autoScale",n.Boolean),this.CreateProp("startAngle",n.Number),this.CreateProp("sweepAngle",n.Number),this.CreateProp("needleShape",n.Enum,"",t.softGauge().NeedleShape),this.CreateProp("needleLength",n.Enum,"",t.softGauge().NeedleLength),this.CreateProp("needleElement",n.Any)]);case t.softGauge()&&t.softGauge().Range:return new l([this.CreateProp("color",n.String),this.CreateProp("min",n.Number),this.CreateProp("max",n.Number),this.CreateProp("name",n.String),this.CreateProp("thickness",n.Number)],[],[],"ranges",!0);case t.softOlap()&&t.softOlap().PivotGrid:return this.getMetaData(t.softGrid().FlexGrid).add([this.CreateProp("showDetailOnDoubleClick",n.Boolean),this.CreateProp("customContextMenu",n.Boolean),this.CreateProp("collapsibleSubtotals",n.Boolean),this.CreateProp("centerHeadersVertically",n.Boolean),this.CreateProp("showColumnFieldHeaders",n.Boolean),this.CreateProp("showRowFieldHeaders",n.Boolean),this.CreateProp("showValueFieldHeaders",n.Boolean),this.CreateProp("outlineMode",n.Boolean)]);case t.softOlap()&&t.softOlap().PivotChart:return this.getMetaData(e.Control).add([this.CreateProp("chartType",n.Enum,"",t.softOlap().PivotChartType),this.CreateProp("showHierarchicalAxes",n.Boolean),this.CreateProp("showTotals",n.Boolean),this.CreateProp("showTitle",n.Boolean),this.CreateProp("showLegend",n.Enum,"",t.softOlap().LegendVisibility),this.CreateProp("legendPosition",n.Enum,"",t.softChart().Position),this.CreateProp("stacking",n.Enum,"",t.softChart().Stacking),this.CreateProp("maxSeries",n.Number),this.CreateProp("maxPoints",n.Number),this.CreateProp("itemsSource",n.Any),this.CreateProp("header",n.String),this.CreateProp("footer",n.String),this.CreateProp("headerStyle",n.Any),this.CreateProp("footerStyle",n.Any)]);case t.softOlap()&&t.softOlap().PivotPanel:return this.getMetaData(e.Control).add([this.CreateProp("autoGenerateFields",n.Boolean),this.CreateProp("viewDefinition",n.String),this.CreateProp("engine",n.Any),this.CreateProp("itemsSource",n.Any),this.CreateProp("showFieldIcons",n.Boolean),this.CreateProp("restrictDragging",n.Boolean)],[this.CreateEvent("itemsSourceChanged"),this.CreateEvent("viewDefinitionChanged"),this.CreateEvent("updatingView"),this.CreateEvent("updatedView")]);case t.softOlap()&&t.softOlap().Slicer:return this.getMetaData(e.Control).add([this.CreateProp("field",n.Any),this.CreateProp("showHeader",n.Boolean),this.CreateProp("header",n.String),this.CreateProp("showCheckboxes",n.Boolean),this.CreateProp("multiSelect",n.Boolean)]);case t.softOlap()&&t.softOlap().PivotField:return new l([this.CreateProp("binding",n.String),this.CreateProp("header",n.String),this.CreateProp("aggregate",n.Enum,"",e.Aggregate),this.CreateProp("showAs",n.Enum,"",t.softOlap().ShowAs),this.CreateProp("format",n.String),this.CreateProp("width",n.Number),this.CreateProp("wordWrap",n.Boolean),this.CreateProp("descending",n.Boolean),this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("visible",n.Boolean),this.CreateProp("dataType",n.Enum,"",e.DataType),this.CreateProp("getValue",n.Function),this.CreateProp("getAggregateValue",n.Function)],[],[],"",!0,!0,"");case t.softViewer()&&t.softViewer().ViewerBase:return this.getMetaData(e.Control).add([this.CreateProp("serviceUrl",n.String),this.CreateProp("filePath",n.String),this.CreateProp("fullScreen",n.Boolean,"fullScreenChanged"),this.CreateProp("zoomFactor",n.Number,"zoomFactorChanged"),this.CreateProp("zoomMode",n.Enum,"zoomModeChanged",t.softViewer().ZoomMode),this.CreateProp("mouseMode",n.Enum,"mouseModeChanged",t.softViewer().MouseMode),this.CreateProp("viewMode",n.Enum,"viewModeChanged",t.softViewer().ViewMode),this.CreateProp("requestHeaders",n.Any)],[this.CreateEvent("pageIndexChanged"),this.CreateEvent("viewModeChanged"),this.CreateEvent("mouseModeChanged"),this.CreateEvent("fullScreenChanged"),this.CreateEvent("zoomFactorChanged",!0),this.CreateEvent("zoomModeChanged",!0),this.CreateEvent("queryLoadingData"),this.CreateEvent("beforeSendRequest")]);case t.softViewer()&&t.softViewer().ReportViewer:return this.getMetaData(t.softViewer().ViewerBase).add([this.CreateProp("parameters",n.Any),this.CreateProp("paginated",n.Boolean),this.CreateProp("reportName",n.String)]);case t.softViewer()&&t.softViewer().PdfViewer:return this.getMetaData(t.softViewer().ViewerBase);case t.softNav()&&t.softNav().TreeView:return this.getMetaData(e.Control).add([this.CreateProp("childItemsPath",n.Any),this.CreateProp("displayMemberPath",n.Any),this.CreateProp("imageMemberPath",n.Any),this.CreateProp("checkedMemberPath",n.Any),this.CreateProp("isContentHtml",n.Boolean),this.CreateProp("showCheckboxes",n.Boolean),this.CreateProp("autoCollapse",n.Boolean),this.CreateProp("isAnimated",n.Boolean),this.CreateProp("isReadOnly",n.Boolean),this.CreateProp("allowDragging",n.Boolean),this.CreateProp("checkOnClick",n.Boolean),this.CreateProp("expandOnClick",n.Boolean),this.CreateProp("collapseOnClick",n.Boolean),this.CreateProp("expandOnLoad",n.Boolean),this.CreateProp("lazyLoadFunction",n.Function),this.CreateProp("itemsSource",n.Any),this.CreateProp("selectedItem",n.Any,"selectedItemChanged"),this.CreateProp("selectedNode",n.Any,"selectedItemChanged"),this.CreateProp("checkedItems",n.Any,"checkedItemsChanged")],[this.CreateEvent("itemsSourceChanged",!0),this.CreateEvent("loadingItems"),this.CreateEvent("loadedItems"),this.CreateEvent("itemClicked"),this.CreateEvent("selectedItemChanged"),this.CreateEvent("checkedItemsChanged",!0),this.CreateEvent("isCollapsedChanging"),this.CreateEvent("isCollapsedChanged"),this.CreateEvent("isCheckedChanging"),this.CreateEvent("isCheckedChanged"),this.CreateEvent("formatItem"),this.CreateEvent("dragStart"),this.CreateEvent("dragOver"),this.CreateEvent("drop"),this.CreateEvent("dragEnd"),this.CreateEvent("nodeEditStarting"),this.CreateEvent("nodeEditStarted"),this.CreateEvent("nodeEditEnding"),this.CreateEvent("nodeEditEnded")]);case t.softNav()&&t.softNav().TabPanel:return this.getMetaData(e.Control).add([this.CreateProp("isAnimated",n.Boolean),this.CreateProp("autoSwitch",n.Boolean),this.CreateProp("selectedIndex",n.Number,"selectedIndexChanged"),this.CreateProp("selectedTab",n.Any,"selectedIndexChanged")],[this.CreateEvent("selectedIndexChanged",!0)]);case t.softNav()&&t.softNav().Tab:return new l([this.CreateProp("isDisabled",n.Boolean),this.CreateProp("isVisible",n.Boolean)],[],[],"tabs",!0);case t.softNav()&&t.softNav().Accordion:return this.getMetaData(e.Control).add([this.CreateProp("isAnimated",n.Boolean),this.CreateProp("autoSwitch",n.Boolean),this.CreateProp("selectedIndex",n.Number,"selectedIndexChanged"),this.CreateProp("selectedPane",n.Any),this.CreateProp("showIcons",n.Boolean),this.CreateProp("allowCollapseAll",n.Boolean),this.CreateProp("allowExpandMany",n.Boolean)],[this.CreateEvent("selectedIndexChanged",!0)]);case t.softNav()&&t.softNav().AccordionPane:return new l([this.CreateProp("isDisabled",n.Boolean),this.CreateProp("isVisible",n.Boolean)],[],[],"panes",!0);case t.softBarcode()&&t.softBarcode().BarcodeBase:return this.getMetaData(e.Control).add([this.CreateProp("value",n.AnyPrimitive),this.CreateProp("quietZone",n.Any),this.CreateProp("renderType",n.Enum,null,t.softBarcode().RenderType),this.CreateProp("color",n.String),this.CreateProp("backgroundColor",n.String),this.CreateProp("hideExtraChecksum",n.Boolean),this.CreateProp("font",n.Any)],[this.CreateEvent("isValidChanged")]);case t.softBarcodeCommon()&&t.softBarcodeCommon().Codabar:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("checkDigit",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition),this.CreateProp("nwRatio",n.Enum,null,t.softBarcode().NarrowToWideRatio)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().EanBase:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().Ean8:return this.getMetaData(t.softBarcodeCommon().EanBase);case t.softBarcodeCommon()&&t.softBarcodeCommon().Ean13:return this.getMetaData(t.softBarcodeCommon().EanBase).add([this.CreateProp("addOn",n.AnyPrimitive),this.CreateProp("addOnHeight",n.AnyPrimitive),this.CreateProp("addOnLabelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().Code39:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("checkDigit",n.Boolean),this.CreateProp("fullAscii",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition),this.CreateProp("nwRatio",n.Enum,null,t.softBarcode().NarrowToWideRatio),this.CreateProp("labelWithStartAndStopCharacter",n.Boolean)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().Code128:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("codeSet",n.Enum,null,t.softBarcodeCommon().Code128CodeSet),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().Gs1_128:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().UpcBase:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("addOn",n.AnyPrimitive),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition),this.CreateProp("addOnHeight",n.AnyPrimitive),this.CreateProp("addOnLabelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeCommon()&&t.softBarcodeCommon().UpcA:case t.softBarcodeCommon()&&t.softBarcodeCommon().UpcE0:case t.softBarcodeCommon()&&t.softBarcodeCommon().UpcE1:return this.getMetaData(t.softBarcodeCommon().UpcBase);case t.softBarcodeCommon()&&t.softBarcodeCommon().QrCode:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("charCode",n.Number),this.CreateProp("charset",n.Enum,null,t.softBarcodeCommon().QrCodeCharset),this.CreateProp("model",n.Enum,null,t.softBarcodeCommon().QrCodeModel),this.CreateProp("version",n.AnyPrimitive),this.CreateProp("errorCorrectionLevel",n.Enum,null,t.softBarcodeCommon().QrCodeCorrectionLevel),this.CreateProp("mask",n.Number),this.CreateProp("connection",n.Boolean),this.CreateProp("connectionIndex",n.Number)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarBase:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition),this.CreateProp("linkage",n.String),this.CreateProp("linkageVersion",n.Enum,null,t.softBarcodeComposite().Gs1DataBarLinkageVersion),this.CreateProp("linkageHeight",n.AnyPrimitive),this.CreateProp("hideLinkageText",n.Boolean),this.CreateProp("hideAiText",n.Boolean)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarOmnidirectional:case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarTruncated:return this.getMetaData(t.softBarcodeComposite().Gs1DataBarBase);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarStacked:case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarStackedOmnidirectional:return this.getMetaData(t.softBarcodeComposite().Gs1DataBarBase).add([this.CreateProp("ratio",n.Number)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarLimited:return this.getMetaData(t.softBarcodeComposite().Gs1DataBarBase);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarExpanded:return this.getMetaData(t.softBarcodeComposite().Gs1DataBarBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().Gs1DataBarExpandedStacked:return this.getMetaData(t.softBarcodeComposite().Gs1DataBarBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("rowCount",n.AnyPrimitive)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().Pdf417:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("errorCorrectionLevel",n.AnyPrimitive),this.CreateProp("columns",n.AnyPrimitive),this.CreateProp("rows",n.AnyPrimitive),this.CreateProp("compact",n.Boolean)]);case t.softBarcodeComposite()&&t.softBarcodeComposite().MicroPdf417:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("dimensions",n.Enum,null,t.softBarcodeComposite().MicroPdfDimensions),this.CreateProp("compactionMode",n.Enum,null,t.softBarcodeComposite().MicroPdfCompactionMode),this.CreateProp("structuredAppend",n.Boolean),this.CreateProp("segmentIndex",n.Number),this.CreateProp("fileId",n.Number),this.CreateProp("optionalFields",n.Any)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().DataMatrixBase:return this.getMetaData(t.softBarcode().BarcodeBase);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().DataMatrixEcc000:return this.getMetaData(t.softBarcodeSpecialized().DataMatrixBase).add([this.CreateProp("version",n.Enum,null,t.softBarcodeSpecialized().DataMatrixVersion),this.CreateProp("symbolSize",n.Enum,null,t.softBarcodeSpecialized().Ecc000_140SymbolSize)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().DataMatrixEcc200:return this.getMetaData(t.softBarcodeSpecialized().DataMatrixBase).add([this.CreateProp("symbolSize",n.Enum,null,t.softBarcodeSpecialized().Ecc200SymbolSize),this.CreateProp("encodingMode",n.Enum,null,t.softBarcodeSpecialized().Ecc200EncodingMode),this.CreateProp("structuredAppend",n.Boolean),this.CreateProp("structureNumber",n.Number),this.CreateProp("fileIdentifier",n.Number)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().Code49:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("grouping",n.Boolean),this.CreateProp("groupIndex",n.Number),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().Code93:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("checkDigit",n.Boolean),this.CreateProp("fullAscii",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().Itf14:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("nwRatio",n.Enum,null,t.softBarcode().NarrowToWideRatio),this.CreateProp("bearerBar",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().Interleaved2of5:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("autoWidth",n.Boolean),this.CreateProp("autoWidthZoom",n.Number),this.CreateProp("showLabel",n.Boolean),this.CreateProp("nwRatio",n.Enum,null,t.softBarcode().NarrowToWideRatio),this.CreateProp("bearerBar",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition),this.CreateProp("checkCharacter",n.Boolean)]);case t.softBarcodeSpecialized()&&t.softBarcodeSpecialized().JapanesePostal:return this.getMetaData(t.softBarcode().BarcodeBase).add([this.CreateProp("showLabel",n.Boolean),this.CreateProp("labelPosition",n.Enum,null,t.softBarcode().LabelPosition)])}return new l([])};ControlMetaFactory.getClassName=function(e){return(e.toString().match(/function (.+?)\(/)||[,""])[1]};ControlMetaFactory.toCamelCase=function(e){return e.toLowerCase().replace(/-(.)/g,(function(e,t){return t.toUpperCase()}))};ControlMetaFactory.findInArr=function(e,t,r){for(var n in e)if(e[n][t]===r)return e[n];return null};return ControlMetaFactory}();t.ControlMetaFactory=r;var n,i,o=function(){function PropDescBase(e,t,r,n,i,o){void 0===i&&(i=!0);void 0===o&&(o=0);this._priority=0;this._propertyName=e;this._propertyType=t;this._changeEvent=r;this._enumType=n;this._isNativeControlProperty=i;this._priority=o}Object.defineProperty(PropDescBase.prototype,"propertyName",{get:function(){return this._propertyName},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"propertyType",{get:function(){return this._propertyType},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"changeEvent",{get:function(){return this._changeEvent},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"enumType",{get:function(){return this._enumType},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"bindingMode",{get:function(){return this.changeEvent?i.TwoWay:i.OneWay},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"isNativeControlProperty",{get:function(){return this._isNativeControlProperty},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"priority",{get:function(){return this._priority},enumerable:!0,configurable:!0});Object.defineProperty(PropDescBase.prototype,"shouldUpdateSource",{get:function(){return this.bindingMode===i.TwoWay&&this.propertyType!=n.EventHandler},enumerable:!0,configurable:!0});PropDescBase.prototype.initialize=function(t){e.copy(this,t)};PropDescBase.prototype.castValueToType=function(t){if(null==t)return t;var r=this.propertyType,i=n;if(r===i.AnyPrimitive){if(!e.isString(t))return t;if("true"!==t&&"false"!==t){o=+t;if(!isNaN(o))return o;var o=this._parseDate(t);return e.isString(o)?t:o}r=i.Boolean}switch(r){case i.Number:if("string"==typeof t){if(t.indexOf("*")>=0)return t;if(""===t.trim())return null}return+t;case i.Boolean:return"true"===t||"false"!==t&&!!t;case i.String:return t+"";case i.Date:return this._parseDate(t);case i.Enum:return"number"==typeof t?t:this.enumType[t];default:return t}};PropDescBase.prototype._parseDate=function(t){if(t&&e.isString(t)){t=t.replace(/["']/g,"");var r=e.changeType(t,e.DataType.Date,"r");if(e.isDate(r))return r}return t};return PropDescBase}();t.PropDescBase=o;!function(e){e[e.Boolean=0]="Boolean";e[e.Number=1]="Number";e[e.Date=2]="Date";e[e.String=3]="String";e[e.AnyPrimitive=4]="AnyPrimitive";e[e.Enum=5]="Enum";e[e.Function=6]="Function";e[e.EventHandler=7]="EventHandler";e[e.Any=8]="Any"}(n=t.PropertyType||(t.PropertyType={}));t.isSimpleType=function isSimpleType(e){return e<=n.Enum};!function(e){e[e.OneWay=0]="OneWay";e[e.TwoWay=1]="TwoWay"}(i=t.BindingMode||(t.BindingMode={}));var a=function(){function EventDescBase(e,t){this._eventName=e;this._isPropChanged=t}Object.defineProperty(EventDescBase.prototype,"eventName",{get:function(){return this._eventName},enumerable:!0,configurable:!0});Object.defineProperty(EventDescBase.prototype,"isPropChanged",{get:function(){return!0===this._isPropChanged},enumerable:!0,configurable:!0});return EventDescBase}();t.EventDescBase=a;var s=function(){function ComplexPropDescBase(e,t,r){void 0===r&&(r=!1);this.isArray=!1;this._ownsObject=!1;this.propertyName=e;this.isArray=t;this._ownsObject=r}Object.defineProperty(ComplexPropDescBase.prototype,"ownsObject",{get:function(){return this.isArray||this._ownsObject},enumerable:!0,configurable:!0});return ComplexPropDescBase}();t.ComplexPropDescBase=s;var l=function(){function MetaDataBase(e,t,r,n,i,o,a,s){this._props=[];this._events=[];this._complexProps=[];this.props=e;this.events=t;this.complexProps=r;this.parentProperty=n;this.isParentPropertyArray=i;this.ownsObject=o;this.parentReferenceProperty=a;this.ngModelProperty=s}Object.defineProperty(MetaDataBase.prototype,"props",{get:function(){return this._props},set:function(e){this._props=e||[]},enumerable:!0,configurable:!0});Object.defineProperty(MetaDataBase.prototype,"events",{get:function(){return this._events},set:function(e){this._events=e||[]},enumerable:!0,configurable:!0});Object.defineProperty(MetaDataBase.prototype,"complexProps",{get:function(){return this._complexProps},set:function(e){this._complexProps=e||[]},enumerable:!0,configurable:!0});MetaDataBase.prototype.add=function(e,t,r,n,i,o,a,s){return this.addOptions({props:e,events:t,complexProps:r,parentProperty:n,isParentPropertyArray:i,ownsObject:o,parentReferenceProperty:a,ngModelProperty:s})};MetaDataBase.prototype.addOptions=function(e){for(var t in e){var r=this[t],n=e[t];r instanceof Array?this[t]=r.concat(n||[]):void 0!==n&&(this[t]=n)}return this};MetaDataBase.prototype.prepare=function(){var e=[].concat(this._props);this._props.sort((function(t,r){var n=t.priority-r.priority;n||(n=e.indexOf(t)-e.indexOf(r));return n}))};return MetaDataBase}();t.MetaDataBase=l}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){e.angular||(e.angular={}),e._registerModule("wijmo.meta",e.angular)}(wijmo||(wijmo={}));!function(e){!function(e){var t=function(t){__extends(MetaFactory,t);function MetaFactory(){return null!==t&&t.apply(this,arguments)||this}MetaFactory.CreateProp=function(e,t,n,i,o,a){return new r(e,t,n,i,o,a)};MetaFactory.CreateEvent=function(e,t){return new n(e,t)};MetaFactory.CreateComplexProp=function(e,t,r){return new i(e,t,r)};MetaFactory.findProp=function(t,r){return e.ControlMetaFactory.findProp(t,r)};MetaFactory.findEvent=function(t,r){return e.ControlMetaFactory.findEvent(t,r)};MetaFactory.findComplexProp=function(t,r){return e.ControlMetaFactory.findComplexProp(t,r)};return MetaFactory}(e.ControlMetaFactory);e.MetaFactory=t;var r=function(t){__extends(PropDesc,t);function PropDesc(r,n,i,o,a,s){var l=t.call(this,r,n,i,o,a,s)||this;l._scopeBindingMode=l.propertyType===e.PropertyType.EventHandler?"&":l.bindingMode==e.BindingMode.OneWay&&e.isSimpleType(l.propertyType)?"@":"=";return l}Object.defineProperty(PropDesc.prototype,"scopeBindingMode",{get:function(){return this._scopeBindingMode},set:function(e){this._scopeBindingMode=e},enumerable:!0,configurable:!0});Object.defineProperty(PropDesc.prototype,"customHandler",{get:function(){return this._customHandler},set:function(e){this._customHandler=e},enumerable:!0,configurable:!0});return PropDesc}(e.PropDescBase);e.PropDesc=r;var n=function(e){__extends(EventDesc,e);function EventDesc(){return null!==e&&e.apply(this,arguments)||this}return EventDesc}(e.EventDescBase);e.EventDesc=n;var i=function(e){__extends(ComplexPropDesc,e);function ComplexPropDesc(){return null!==e&&e.apply(this,arguments)||this}return ComplexPropDesc}(e.ComplexPropDescBase);e.ComplexPropDesc=i}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){var r=window.angular,n=[];t._registerNgModule=function _registerNgModule(e){var t=r.module(e,[]);n.push(e);return t};t.getNgModules=function getNgModules(){return n.slice()};var i=function(){function WjDirective(){this.replace=!0;this.restrict="E";this.template="<div />";this.transclude=!1;this._props=[];this._events=[];this._complexProps=[];var e=this;this._dirId=++WjDirective._dirIdCounter+"";this.link=this._postLinkFn();this.controller=["$scope","$parse","$element",function(t,r,n){e._$parse=r;n[0][WjDirective._elemScopeProp]=t;this[WjDirective._cntrlScopeProp]=t;t[WjDirective._scopeChildrenProp]=[];e._controllerImpl(this,t,n)}];this._initDirective()}WjDirective._versionOk=function(e){var t=r.version,n=[t.major,t.minor,t.dot],i=e.split(".");if(i.length!==n.length)throw"Unrecognizable version number.";for(var o=0;o<i.length;o++){if(n[o]<i[o])return!1;if(n[o]>i[o])return!0}return!0};Object.defineProperty(WjDirective.prototype,"_controlConstructor",{get:function(){throw"Abstract method call"},enumerable:!0,configurable:!0});WjDirective.prototype._getMetaDataId=function(){return this._controlConstructor};WjDirective.prototype._getMetaData=function(){return t.MetaFactory.getMetaData(this._getMetaDataId())};WjDirective.prototype._initDirective=function(){this._initSharedMeta();this._prepareProps();this._initEvents();this._initScopeEvents();this._initScopeDescription()};WjDirective.prototype._initSharedMeta=function(){var e=this._getMetaData();this._props=e.props;this._events=e.events;this._complexProps=e.complexProps;this._property=e.parentProperty;this._isPropertyArray=e.isParentPropertyArray;this._ownObject=e.ownsObject;this._parentReferenceProperty=e.parentReferenceProperty;this._ngModelProperty=e.ngModelProperty};WjDirective.prototype._initProps=function(){};WjDirective.prototype._initEvents=function(){};WjDirective.prototype._createLink=function(){return new o};WjDirective.prototype._controllerImpl=function(e,t,r){};WjDirective.prototype._initControl=function(e){try{return new(0,this._controlConstructor)(e)}catch(e){return}};WjDirective.prototype._isChild=function(){return this._isParentInitializer()||this._isParentReferencer()};WjDirective.prototype._isParentInitializer=function(){return null!=this._property};WjDirective.prototype._isParentReferencer=function(){return null!=this._parentReferenceProperty};WjDirective.prototype._scopeToAttrName=function(e){var t=this.scope[e];if(t){var r=1,n=t.length;if(n<2)return e;"?"===t.charAt(1)&&(r=2);return n===r?e:t.substr(r)}return e};WjDirective.prototype._getComplexPropDesc=function(e){return t.MetaFactory.findComplexProp(e,this._complexProps)};WjDirective.prototype._initScopeEvents=function(){for(var e in this._events){var r=this._events[e];this._props.push(new t.PropDesc(r.eventName,t.PropertyType.EventHandler))}};WjDirective.prototype._initScopeDescription=function(){var e=this._props,t={},r=WjDirective._optionalAttr?"=?":"=";if(null!=e)for(var n,i=0;i<e.length;i++){t[(n=e[i]).propertyName]=n.scopeBindingMode;WjDirective._optionalAttr&&"="==n.scopeBindingMode&&(t[n.propertyName]="=?")}t.control=r;t[WjDirective._initPropAttr]=r;t[WjDirective._initEventAttr]="&";t[WjDirective._parPropAttr]="@";t[WjDirective._wjModelPropAttr]="@";this.scope=t};WjDirective.prototype._postLinkFn=function(){var t=this;return function(r,n,i,o){var a=t._createLink();a.directive=t;a.scope=r;a.tElement=n;a.tAttrs=i;if(e.isArray(o)){var s=n.parent()[0][WjDirective._elemScopeProp];for(var l in o){var c=o[l];if(null!=c){c[WjDirective._cntrlScopeProp]===r&&(c=n.parent().controller(t._stripRequire(+l)));if(c&&c[WjDirective._cntrlScopeProp]===s){a.controller=c;break}}}}else a.controller=o;a.ngModel=n.controller("ngModel");a._link()}};WjDirective.prototype._prepareProps=function(){this._initProps();var e=[].concat(this._props);this._props.sort((function(t,r){var n=t.priority-r.priority;n||(n=e.indexOf(t)-e.indexOf(r));return n}))};WjDirective.prototype._stripRequire=function(e){if(!this._stripReq){this._stripReq=[];this._stripReq.length=this.require.length}if(!this._stripReq[e]){var t=/^[^A-Za-z]*(.*)/.exec(this.require[e]);this._stripReq[e]=t?t[1]:""}return this._stripReq[e]};WjDirective.prototype._getId=function(){return this._dirId};WjDirective._removeTransclude=function(e){if(!e)return e;var t=document.createElement("div");t.innerHTML=e;var r=t.querySelectorAll("[ng-transclude]");[].forEach.call(r,(function(e,t){e.removeAttribute("ng-transclude")}));return t.innerHTML};WjDirective._parPropAttr="wjProperty";WjDirective._wjModelPropAttr="wjModelProperty";WjDirective._initPropAttr="isInitialized";WjDirective._initEventAttr="initialized";WjDirective._cntrlScopeProp="_cntrlScope";WjDirective._elemScopeProp="_elemCntrl";WjDirective._cntrlLinkProp="$_thisLink";WjDirective._scopeChildrenProp="$_childLinks";WjDirective._dirIdAttr="wj-directive-id";WjDirective._optionalAttr=WjDirective._versionOk("1.1.4");WjDirective._dynaTemplates=WjDirective._optionalAttr;WjDirective._angStripPrefixes=["data","x"];WjDirective._dirIdCounter=0;return WjDirective}();t.WjDirective=i;var o=function(){function WjLink(){this._nonAssignable={};this._definedProps={};this._definedEvents={};this._oldValues={};this._isInitialized=!1;this._hasTriggeredInitialized=!1;this._isNgModelInitialized=!1;this._scopeSuspend=0;this._suspendedEvents=[];this._areChlildrenReady=!1;this._isDestroyed=!1;this._isAppliedToParent=!1}WjLink.prototype._link=function(){var e=this.directive,n=this;this.tElement[0].setAttribute(i._dirIdAttr,e._getId());this.directiveTemplateElement=e.replace?this.tElement:r.element(this.tElement.children()[0]);this._initNonAssignable();if(this._isChild()){this._parentPropDesc=new t.ComplexPropDesc(e._property,e._isPropertyArray,e._ownObject);this.controller[i._cntrlScopeProp][i._scopeChildrenProp].push(this);var o=this.controller[i._cntrlScopeProp][i._cntrlLinkProp];o&&o._areChlildrenReady&&this._parentReady(o)}else{this._createInstance();this._notifyReady();this._prepareControl()}this._destroyEhUnreg=this.scope.$on("$destroy",(function(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];n._destroy()}))};WjLink.prototype._onChildrenReady=function(){};WjLink.prototype._createInstance=function(){this.control=this._initControl();this._safeApply(this.scope,"control",this.control)};WjLink.prototype._parentReady=function(e){if(this._isChild()){var t=this;if(!this._isAttrDefined(i._parPropAttr)||this.scope[i._parPropAttr]){var r=this._getParentProp(),n=e.directive._getComplexPropDesc(r);n?this._parentPropDesc=n:this._parentPropDesc.propertyName=r;this.parent=e;if(this._useParentObj()){this.control=e.control[r];this._safeApply(this.scope,"control",this.control)}else this._createInstance();this._notifyReady();this._prepareControl();this._initParent();this.directiveTemplateElement[0].style.display="none";this._appliedToParent()}else this.scope.$watch(i._parPropAttr,(function(){t._parentReady(e)}))}};WjLink.prototype._initParent=function(){if(!this._useParentObj()){this.directive;var e=this._getParentProp(),t=this.parent.control,r=this.control;if(this._isParentInitializer())if(this._isParentArray()){var n=t[e],i=this._getIndex();(i<0||i>=n.length)&&(i=n.length);n.splice(i,0,r);this._siblingInsertedEH=this._siblingInserted.bind(this);this.tElement[0].addEventListener("DOMNodeInserted",this._siblingInsertedEH)}else t[e]=r;this._isParentReferencer()&&!this._parentInCtor()&&(r[this._getParentReferenceProperty()]=t)}};WjLink.prototype._destroy=function(){if(!this._isDestroyed){this._isDestroyed=!0;var t=this.control;this._destroyEhUnreg&&(this._destroyEhUnreg=null);this._siblingInsertedEH&&this.tElement[0].removeEventListener("DOMNodeInserted",this._siblingInsertedEH);if(this._isParentArray()&&!this.parent._isDestroyed){var r=this.parent.control,n=this._getParentProp();if(r&&n&&t){var o=r[n];if(o){var a=o.indexOf(t);a>=0&&o.splice(a,1)}}}this.tElement[0][i._elemScopeProp]=null;t instanceof e.Control&&setTimeout((function(){t.hostElement&&t.dispose()}),0)}};WjLink.prototype._siblingInserted=function(e){if(e.target===this.tElement[0]){var t=this._getIndex(),r=this.parent.control[this._getParentProp()],n=this.control,i=r.indexOf(n);if(t>=0&&i>=0&&t!==i){r.splice(i,1);t=Math.min(t,r.length);r.splice(t,0,n)}}};WjLink.prototype._notifyReady=function(){this.scope[i._cntrlLinkProp]=this;for(var e=[].concat(this.scope[i._scopeChildrenProp]),t=0;t<e.length;t++)e[t]._parentReady(this);this._areChlildrenReady=!0;this._onChildrenReady()};WjLink.prototype._initControl=function(){return this.directive._initControl(this._parentInCtor()?this.parent.control:this.directiveTemplateElement[0])};WjLink.prototype._prepareControl=function(){this._addEventHandlers();this._addWatchers()};WjLink.prototype._setupScopeWithControlProperties=function(){for(var e,r,n,i,o=this.control,a=this.scope,s=this.directive._props,l=0;l<s.length;l++)if("="===(e=s[l]).scopeBindingMode&&e.isNativeControlProperty&&e.shouldUpdateSource){n=a[r=e.propertyName];i=o[r];var c=e.propertyType==t.PropertyType.Function,u=e.propertyType==t.PropertyType.EventHandler;!this._canApply(a,e.propertyName)||this._isEqual(i,n)||c||u||(a[e.propertyName]=i)}a.$root.$$phase||a.$apply()};WjLink.prototype._initNonAssignable=function(){var e,t=this.directive._$parse,r=this.directive.scope;for(var n in r)"="===r[n].charAt(0)&&(void 0!==(e=this.tAttrs[this.directive._scopeToAttrName(n)])&&null!=t(e).assign||(this._nonAssignable[n]=!0))};WjLink.prototype._suspendScope=function(){this._scopeSuspend++};WjLink.prototype._resumeScope=function(){this._scopeSuspend>0&&0==--this._scopeSuspend&&this._suspendedEvents.length>0&&this._updateScope()};WjLink.prototype._isScopeSuspended=function(){return this._scopeSuspend>0};WjLink.prototype._isAttrDefined=function(e){return null!=this.tAttrs.$attr[this.directive._scopeToAttrName(e)]};WjLink.prototype._childInitialized=function(e){var t=this.scope[i._scopeChildrenProp],r=t.indexOf(e);if(r>=0){t.splice(r,1);this._checkRaiseInitialized()}};WjLink.prototype._thisInitialized=function(){this._checkRaiseInitialized()};WjLink.prototype._initialized=function(){};WjLink.prototype._appliedToParent=function(){this._isAppliedToParent=!0;this._checkRaiseInitialized()};WjLink.prototype._checkRaiseInitialized=function(){if(!this._hasTriggeredInitialized&&0===this.scope[i._scopeChildrenProp].length&&this._isInitialized&&(!this._isChild()||this._isAppliedToParent)){this._hasTriggeredInitialized=!0;this._initialized();this._safeApply(this.scope,i._initPropAttr,!0);var e=this.scope[i._initEventAttr],t=this;e&&setTimeout((function(){e({s:t.control,e:void 0})}),0);this._isChild()&&this.parent&&this.parent._childInitialized(this)}};WjLink.prototype._addWatchers=function(){var r=this,n=this.directive._props,o=this.scope;if(n){if(this.ngModel){var a=this.ngModel;a.$pristine&&e.addClass(this.tElement[0],"ng-pristine");a.$valid&&e.addClass(this.tElement[0],"ng-valid");a.$untouched&&e.addClass(this.tElement[0],"ng-untouched");a.$render=this._ngModelRender.bind(this);this._updateNgModelPropDesc();this._isAttrDefined(i._wjModelPropAttr)&&o.$watch(i._wjModelPropAttr,(function(){r._updateNgModelPropDesc();r._ngModelRender()}))}var s,l,c;for(s=0;s<n.length;s++){l=(c=n[s]).propertyName;c.propertyType!==t.PropertyType.EventHandler&&this._isAttrDefined(l)&&(this._definedProps[l]=c)}var u=this.control;o.$watch((function(e){if(!r._isDestroyed)try{var t={};for(var n in r._definedProps)e[n]!==r._oldValues[n]&&(t[n]=e[n]);for(var n in t){var i=t[n];if(i!==r._oldValues[n]){r._oldValues[n]=i;if(r._isInitialized||void 0!==i){var o=r._definedProps[n],a=r._nullOrValue(r._castValueToType(i,o)),s=u[n];if(!r._isEqual(s,a)){var l=!1;null!=o.customHandler&&(l=o.customHandler(e,u,a,s,r));o.isNativeControlProperty&&!0!==l&&(u[n]=a)}}}}}finally{if(!r._isInitialized){r._isNgModelInitialized=!0;if(r.ngModel)if(void 0!==r.ngModel.$viewValue)r._ngModelRender();else if(r._ngModelPropDesc){r.ngModel.$setViewValue(u[r._ngModelPropDesc.propertyName]);r.ngModel.$setPristine()}r._isInitialized=!0;r._setupScopeWithControlProperties();r._thisInitialized()}}}))}};WjLink.prototype._addEventHandlers=function(){var e,t,r=this.directive._events;for(e=0;e<r.length;e++){t=r[e];this._addEventHandler(t)}};WjLink.prototype._addEventHandler=function(e){var t=this,r=e.eventName,n=this.control[r];if(null==n)throw'Event "'+r+'" not found in '+t.constructor.name;if(this._isAttrDefined(r))this._definedEvents[r]=e;else if(!e.isPropChanged)return;this.scope,this.directive._props;var i=this.control;n.addHandler((function(r,n){var i={eventDesc:e,s:r,e:n};t._isScopeSuspended()?t._suspendedEvents.push(i):t._updateScope(i)}),i)};WjLink.prototype._updateScope=function(e){void 0===e&&(e=null);if(!this._isDestroyed){var t=e?e.eventDesc.isPropChanged:this._suspendedEvents.some((function(e){return e.eventDesc.isPropChanged})),r=this;if(t)for(var n=this.directive._props,i=0;i<n.length;i++){var o=n[i];if("="==o.scopeBindingMode&&o.isNativeControlProperty&&o.shouldUpdateSource){var a=o.propertyName,s=this.control[a];if(this._shouldApply(this.scope,a,s)){this.scope[a]=s;this.directive._$parse(this.tAttrs[this.directive._scopeToAttrName(a)]).assign(this.scope.$parent,s)}this._ngModelPropDesc&&this._isInitialized&&this._ngModelPropDesc.propertyName==a&&this.ngModel.$viewValue!==s&&this.ngModel.$setViewValue(s)}}var l=function(){for(var t=e?[e]:this._suspendedEvents,n=0;n<t.length;n++){var i=t[n],o=i.eventDesc.eventName,a=this.scope[o];r._definedEvents[o]&&a&&a({s:i.s,e:i.e})}e||(this._suspendedEvents.length=0)}.bind(this);if(t)if(this.scope.$root.$$phase)var c=this.scope.$watch("value",(function(){c()}));else this.scope.$apply();l()}};WjLink.prototype._ngModelRender=function(){if(this._isNgModelInitialized){var e=this.ngModel.$viewValue,t=this._ngModelPropDesc;if(t&&(void 0!==e||this._isInitialized)){this._nullOrValue(this._castValueToType(e,t));this._isEqualEx(e,this.control[t.propertyName])||(this.control[t.propertyName]=e)}}};WjLink.prototype._castValueToType=function(e,t){return t.castValueToType(e)};WjLink.prototype._isChild=function(){return this.directive._isChild()};WjLink.prototype._isParentInitializer=function(){return this.directive._isParentInitializer()};WjLink.prototype._isParentReferencer=function(){return this.directive._isParentReferencer()};WjLink.prototype._getParentProp=function(){return this._isParentInitializer()?this.scope[i._parPropAttr]||this.directive._property:void 0};WjLink.prototype._getParentReferenceProperty=function(){return this.directive._parentReferenceProperty};WjLink.prototype._useParentObj=function(){return!this._isParentReferencer()&&this._isParentInitializer()&&!this._parentPropDesc.isArray&&!this._parentPropDesc.ownsObject};WjLink.prototype._isParentArray=function(){return this._isParentInitializer()&&this._parentPropDesc.isArray};WjLink.prototype._parentInCtor=function(){return this._isParentReferencer()&&""==this._getParentReferenceProperty()};WjLink.prototype._getNgModelProperty=function(){return this.scope[i._wjModelPropAttr]||this.directive._ngModelProperty};WjLink.prototype._updateNgModelPropDesc=function(){var r=this._getNgModelProperty();this._ngModelPropDesc=e.isNullOrWhiteSpace(r)?null:t.MetaFactory.findProp(r,this.directive._props)};WjLink.prototype._safeApply=function(e,t,r){if(this._shouldApply(e,t,r)){e[t]=r;e.$root.$$phase||e.$apply();return!0}return!1};WjLink.prototype._shouldApply=function(e,t,r){return this._canApply(e,t)&&!this._isEqual(r,e[t])};WjLink.prototype._canApply=function(e,t){return!this._nonAssignable[t]};WjLink.prototype._isEqual=function(e,t){return e==t||this._isSpValEq(e,t)};WjLink.prototype._isEqualEx=function(e,t){return e===t||this._isSpValEq(e,t)};WjLink.prototype._isSpValEq=function(t,r){return e.DateTime.equals(t,r)};WjLink.prototype._nullOrValue=function(e){return null!=e?e:null};WjLink.prototype._getIndex=function(){var e=this.tElement[0],t=e.parentElement;if(!t)return-1;for(var r=t.childNodes,n=-1,o=this.directive._getId(),a=0;a<r.length;a++){var s=r[a];if(1==s.nodeType&&s.getAttribute(i._dirIdAttr)==o){++n;if(s===e)return n}}return-1};return WjLink}();t.WjLink=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){"use strict";t.softRefChart=function softRefChart(){return e._getModule("wijmo.chart")};t.softRefChartAnalytics=function softRefChartAnalytics(){return e._getModule("wijmo.chart.analytics")};t.softRefChartAnimation=function softRefChartAnimation(){return e._getModule("wijmo.chart.animation")};t.softRefChartAnnotation=function softRefChartAnnotation(){return e._getModule("wijmo.chart.annotation")};t.softRefChartFinance=function softRefChartFinance(){return e._getModule("wijmo.chart.finance")};t.softRefChartFinanceAnalytics=function softRefChartFinanceAnalytics(){return e._getModule("wijmo.chart.finance.analytics")};t.softRefChartHierarchical=function softRefChartHierarchical(){return e._getModule("wijmo.chart.hierarchical")};t.softRefChartInteraction=function softRefChartInteraction(){return e._getModule("wijmo.chart.interaction")};t.softRefChartRadar=function softRefChartRadar(){return e._getModule("wijmo.chart.radar")};t.softRefGauge=function softRefGauge(){return e._getModule("wijmo.gauge")};t.softRefGrid=function softRefGrid(){return e._getModule("wijmo.grid")};t.softRefGridDetail=function softRefGridDetail(){return e._getModule("wijmo.grid.detail")};t.softRefGridFilter=function softRefGridFilter(){return e._getModule("wijmo.grid.filter")};t.softRefGridGrouppanel=function softRefGridGrouppanel(){return e._getModule("wijmo.grid.grouppanel")};t.softRefGridMultirow=function softRefGridMultirow(){return e._getModule("wijmo.grid.multirow")};t.softRefGridSheet=function softRefGridSheet(){return e._getModule("wijmo.grid.sheet")};t.softRefNav=function softRefNav(){return e._getModule("wijmo.nav")};t.softRefOlap=function softRefOlap(){return e._getModule("wijmo.olap")};t.softRefViewer=function softRefViewer(){return e._getModule("wijmo.viewer")};t.softRefInput=function softRefInput(){return e._getModule("wijmo.input")}}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.input");if(t.softRefInput()){r.directive("wjAutoComplete",["$compile",function(e){return new o(e)}]);r.directive("wjCalendar",[function(){return new a}]);r.directive("wjColorPicker",[function(){return new s}]);r.directive("wjComboBox",["$compile",function(e){return new i(e)}]);r.directive("wjInputDate",[function(){return new g}]);r.directive("wjInputDateTime",[function(){return new P}]);r.directive("wjInputNumber",[function(){return new v}]);r.directive("wjInputMask",[function(){return new j}]);r.directive("wjInputTime",["$compile",function(e){return new y(e)}]);r.directive("wjInputColor",[function(){return new _}]);r.directive("wjListBox",[function(){return new l}]);r.directive("wjItemTemplate",["$compile",function(e){return new c(e)}]);r.directive("wjMenu",["$compile",function(e){return new p(e)}]);r.directive("wjMenuItem",[function(e){return new d}]);r.directive("wjMenuSeparator",[function(){return new f}]);r.directive("wjContextMenu",[function(){return new m}]);r.directive("wjCollectionViewNavigator",[function(){return new x}]);r.directive("wjCollectionViewPager",[function(){return new F}]);r.directive("wjPopup",[function(){return new w}]);r.directive("wjMultiSelect",["$compile",function(e){return new b(e)}]);r.directive("wjMultiAutoComplete",["$compile",function(e){return new W(e)}])}var n=function(t){__extends(WjDropDown,t);function WjDropDown(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjDropDown.prototype,"_controlConstructor",{get:function(){return e.input.DropDown},enumerable:!0,configurable:!0});return WjDropDown}(t.WjDirective);t.WjDropDown=n;var i=function(t){__extends(WjComboBox,t);function WjComboBox(e){var r=t.call(this)||this;r._$compile=e;r.template="<div ng-transclude />";r.transclude=!0;return r}Object.defineProperty(WjComboBox.prototype,"_controlConstructor",{get:function(){return e.input.ComboBox},enumerable:!0,configurable:!0});return WjComboBox}(n);t.WjComboBox=i;var o=function(t){__extends(WjAutoComplete,t);function WjAutoComplete(e){return t.call(this,e)||this}Object.defineProperty(WjAutoComplete.prototype,"_controlConstructor",{get:function(){return e.input.AutoComplete},enumerable:!0,configurable:!0});return WjAutoComplete}(i);t.WjAutoComplete=o;var a=function(t){__extends(WjCalendar,t);function WjCalendar(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjCalendar.prototype,"_controlConstructor",{get:function(){return e.input.Calendar},enumerable:!0,configurable:!0});return WjCalendar}(t.WjDirective);t.WjCalendar=a;var s=function(t){__extends(WjColorPicker,t);function WjColorPicker(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjColorPicker.prototype,"_controlConstructor",{get:function(){return e.input.ColorPicker},enumerable:!0,configurable:!0});return WjColorPicker}(t.WjDirective);t.WjColorPicker=s;var l=function(t){__extends(WjListBox,t);function WjListBox(){var e=t.call(this)||this;e.transclude=!0;e.template="<div ng-transclude />";return e}Object.defineProperty(WjListBox.prototype,"_controlConstructor",{get:function(){return e.input.ListBox},enumerable:!0,configurable:!0});return WjListBox}(t.WjDirective);t.WjListBox=l;var c=function(e){__extends(WjItemTemplate,e);function WjItemTemplate(r){var n=e.call(this)||this;n._$compile=r;n.require=["?^wjListBox","?^wjMenu"];n.terminal=!0;if(t.WjDirective._dynaTemplates){n.transclude=!1;n.priority=100;n.template=function(e,t){t[WjItemTemplate._itemTemplateProp]=e[0].innerHTML;return"<div />"}}else{n.transclude=!0;n.template="<div ng-transclude/>"}return n}WjItemTemplate.prototype._initControl=function(e){return{}};WjItemTemplate.prototype._createLink=function(){return new u};WjItemTemplate.prototype._getMetaDataId=function(){return"ItemTemplate"};WjItemTemplate._itemTemplateProp="$__wjItemTemplate";WjItemTemplate._itemScopeProp="$_itemScope";return WjItemTemplate}(t.WjDirective);t.WjItemTemplate=c;var u=function(r){__extends(WjItemTemplateLink,r);function WjItemTemplateLink(){return null!==r&&r.apply(this,arguments)||this}WjItemTemplateLink.prototype._initParent=function(){r.prototype._initParent.call(this);var e=this.tAttrs[c._itemTemplateProp],n=this.parent.control,i=this._getListBox();this.itemTemplate=null!=e?e:t.WjDirective._removeTransclude(this.tElement[0].innerHTML);i.formatItem.addHandler(this._fmtItem,this);i.loadingItems.addHandler(this._loadingItems,this);this.parent._isInitialized&&n.invalidate()};WjItemTemplateLink.prototype._destroy=function(){var e=this.parent&&this.parent.control,t=this._getListBox();if(t){t.formatItem.removeHandler(this._fmtItem,this);t.loadingItems.removeHandler(this._loadingItems,this)}r.prototype._destroy.call(this);this._tmplLink=null;e&&e.invalidate()};WjItemTemplateLink.prototype._loadingItems=function(e){for(var t=e.hostElement.getElementsByClassName("wj-listbox-item"),r=t.length-1;r>=0;r--){var n=t[r],i=n[c._itemScopeProp];if(i){n[c._itemScopeProp]=null;i.$destroy()}}};WjItemTemplateLink.prototype._fmtItem=function(e,t){this._tmplLink||(this._tmplLink=this.directive._$compile("<div>"+this.itemTemplate+"</div>"));var r=t.item,n=this.scope.$parent.$new();r[c._itemScopeProp]=n;n.$control=e;n.$item=t.data;n.$itemIndex=t.index;var i=this._tmplLink(n,(function(e,t){}))[0];if(1===r.childNodes.length)r.replaceChild(i,r.firstChild);else{r.textContent="";r.appendChild(i)}clearTimeout(this._closingApplyTimeOut);this._closingApplyTimeOut=setTimeout((function(){n.$root.$$phase||n.$apply()}),40)};WjItemTemplateLink._invalidateControl=function(e){e&&e.invalidate()};WjItemTemplateLink.prototype._getListBox=function(){var t=this.parent&&this.parent.control;return t?t instanceof e.input.ListBox?t:t.listBox:null};return WjItemTemplateLink}(t.WjLink),p=function(r){__extends(WjMenu,r);function WjMenu(e){return r.call(this,e)||this}Object.defineProperty(WjMenu.prototype,"_controlConstructor",{get:function(){return e.input.Menu},enumerable:!0,configurable:!0});WjMenu.prototype._createLink=function(){return new h};WjMenu.prototype._initProps=function(){r.prototype._initProps.call(this);var e=this;t.MetaFactory.findProp("value",this._props).customHandler=function(t,r,n,i,o){e.updateControlValue(t,r,o)}};WjMenu.prototype.updateControlValue=function(e,t,r){if(null!=e.value){t.selectedValue=e.value;r.directive.updateHeader(e,t,r)}};WjMenu.prototype.updateHeader=function(e,t,r){t.header=e.header||"";var n=t.selectedItem;if(void 0!==e.value&&n&&t.displayMemberPath){var i=n[d._itemLinkProp],o=i?i.linkedContent.innerHTML:n[t.displayMemberPath];null!=o&&(t.header+=": <b>"+o+"</b>")}};return WjMenu}(i);t.WjMenu=p;var h=function(t){__extends(WjMenuLink,t);function WjMenuLink(){return null!==t&&t.apply(this,arguments)||this}WjMenuLink.prototype._initControl=function(){var t=this,r=new e.input.Menu(this.directiveTemplateElement[0],{itemsSource:new e.collections.ObservableArray,selectedIndex:0,itemClicked:function(){t._safeApply(t.scope,"value",r.selectedValue)||t.scope.$root.$$phase||t.scope.$apply();t.directive.updateHeader(t.scope,r,t)}.bind(t)});r.listBox.formatItem.addHandler(t._fmtItem,this);r.listBox.loadingItems.addHandler(this._loadingItems,this);return r};WjMenuLink.prototype._initialized=function(){this.directive.updateControlValue(this.scope,this.control,this)};WjMenuLink.prototype._fmtItem=function(t,r){var n=r.data[d._itemLinkProp];if(n){n.contentLink||(n.contentLink=this.directive._$compile("<div>"+n.itemTemplate+"</div>"));var i=this,o=r.item,a=n.scope.$parent.$new();o[d._itemScopeProp]=a;a.$control=this.control;a.$item=r.data;a.$itemIndex=r.index;var s=n.linkedContent=n.contentLink(a,(function(e,t){}))[0];n.isSeparator&&e.addClass(o,"wj-state-disabled");if(1===o.childNodes.length)o.replaceChild(s,o.firstChild);else{o.textContent="";o.appendChild(s)}clearTimeout(this._closingApplyTimeOut);this._closingApplyTimeOut=setTimeout((function(){a.$root.$$phase||a.$apply();i.control.selectedItem&&i.directive.updateHeader(i.scope,i.control,i)}),40)}};WjMenuLink.prototype._loadingItems=function(e){for(var t=e.hostElement.getElementsByClassName("wj-listbox-item"),r=t.length-1;r>=0;r--){var n=t[r],i=n[d._itemScopeProp];if(i){n[c._itemScopeProp]=null;i.$destroy()}}};return WjMenuLink}(t.WjLink),d=function(e){__extends(WjMenuItem,e);function WjMenuItem(){var r=e.call(this)||this;r.require="^wjMenu";r.terminal=!0;if(t.WjDirective._dynaTemplates){r.transclude=!1;r.priority=100;r.template=function(e,t){t[c._itemTemplateProp]=e[0].innerHTML;return"<div />"}}else{r.transclude=!0;r.template="<div ng-transclude/>"}return r}WjMenuItem.prototype._createLink=function(){return new C(!1)};WjMenuItem.prototype._getMetaDataId=function(){return"MenuItem"};WjMenuItem.prototype._getId=function(){return WjMenuItem._directiveId};WjMenuItem._itemTemplateProp="$__wjMenuItemTemplate";WjMenuItem._itemScopeProp="$_menuItemScope";WjMenuItem._itemLinkProp="$_menuItemLink";WjMenuItem._directiveId="menuItemDir";return WjMenuItem}(t.WjDirective);t.WjMenuItem=d;var C=function(e){__extends(WjMenuItemLink,e);function WjMenuItemLink(t){var r=e.call(this)||this;r.isSeparator=t;return r}WjMenuItemLink.prototype._initControl=function(){var e=this.tAttrs[c._itemTemplateProp];this.itemTemplate=this.isSeparator?'<div class="wj-state-disabled" style="width:100%;height:1px;background-color:lightgray"></div>':null!=e?e:t.WjDirective._removeTransclude(this.tElement[0].innerHTML);var r={value:null,cmd:null,cmdParam:null,header:this.itemTemplate};r[d._itemLinkProp]=this;return r};WjMenuItemLink.prototype._initParent=function(){e.prototype._initParent.call(this);var t=this.parent.control;1==t.itemsSource.length&&t.selectedIndex<0&&(t.selectedIndex=0);t.displayMemberPath||(t.displayMemberPath="header");t.selectedValuePath||(t.selectedValuePath="value");t.commandPath||(t.commandPath="cmd");t.commandParameterPath||(t.commandParameterPath="cmdParam")};WjMenuItemLink.prototype._destroy=function(){var t=this.parent&&this.parent.control;e.prototype._destroy.call(this);t&&t.invalidate()};return WjMenuItemLink}(t.WjLink),f=function(e){__extends(WjMenuSeparator,e);function WjMenuSeparator(){var t=e.call(this)||this;t.template="<span />";t.require="^wjMenu";return t}WjMenuSeparator.prototype._getMetaDataId=function(){return"MenuSeparator"};WjMenuSeparator.prototype._createLink=function(){return new C(!0)};WjMenuSeparator.prototype._getId=function(){return d._directiveId};return WjMenuSeparator}(t.WjDirective);t.WjMenuSeparator=f;var m=function(t){__extends(WjContextMenu,t);function WjContextMenu(){var e=t.call(this)||this;e.template=void 0;e.restrict="A";e.scope=!1;return e}WjContextMenu.prototype._getMetaDataId=function(){return"WjContextMenu"};WjContextMenu.prototype._postLinkFn=function(){return function(t,r,n){var i=e.getElement(n.wjContextMenu);r[0].addEventListener("contextmenu",(function(t){var n=e.Control.getControl(i),o=n.dropDown;if(n&&o&&!e.closest(t.target,"[disabled]")){t.preventDefault();n.owner=r[0];n.show(t)}}))}};return WjContextMenu}(t.WjDirective);t.WjContextMenu=m;var g=function(t){__extends(WjInputDate,t);function WjInputDate(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjInputDate.prototype,"_controlConstructor",{get:function(){return e.input.InputDate},enumerable:!0,configurable:!0});return WjInputDate}(n);t.WjInputDate=g;var P=function(t){__extends(WjInputDateTime,t);function WjInputDateTime(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjInputDateTime.prototype,"_controlConstructor",{get:function(){return e.input.InputDateTime},enumerable:!0,configurable:!0});return WjInputDateTime}(g);t.WjInputDateTime=P;var v=function(t){__extends(WjInputNumber,t);function WjInputNumber(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjInputNumber.prototype,"_controlConstructor",{get:function(){return e.input.InputNumber},enumerable:!0,configurable:!0});return WjInputNumber}(t.WjDirective);t.WjInputNumber=v;var j=function(t){__extends(WjInputMask,t);function WjInputMask(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjInputMask.prototype,"_controlConstructor",{get:function(){return e.input.InputMask},enumerable:!0,configurable:!0});return WjInputMask}(t.WjDirective);t.WjInputMask=j;var y=function(t){__extends(WjInputTime,t);function WjInputTime(e){return t.call(this,e)||this}Object.defineProperty(WjInputTime.prototype,"_controlConstructor",{get:function(){return e.input.InputTime},enumerable:!0,configurable:!0});return WjInputTime}(i);t.WjInputTime=y;var _=function(t){__extends(WjInputColor,t);function WjInputColor(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjInputColor.prototype,"_controlConstructor",{get:function(){return e.input.InputColor},enumerable:!0,configurable:!0});return WjInputColor}(n);t.WjInputColor=_;var w=function(r){__extends(WjPopup,r);function WjPopup(){var e=r.call(this)||this;e.transclude=!0;e.template="<div ng-transclude/>";return e}Object.defineProperty(WjPopup.prototype,"_controlConstructor",{get:function(){return e.input.Popup},enumerable:!0,configurable:!0});WjPopup.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("owner",this._props).customHandler=function(e,t,r,n,i){null==e.modal&&(t.modal=!r)}};return WjPopup}(t.WjDirective);t.WjPopup=w;var b=function(t){__extends(WjMultiSelect,t);function WjMultiSelect(e){return t.call(this,e)||this}Object.defineProperty(WjMultiSelect.prototype,"_controlConstructor",{get:function(){return e.input.MultiSelect},enumerable:!0,configurable:!0});return WjMultiSelect}(i);t.WjMultiSelect=b;var W=function(t){__extends(WjMultiAutoComplete,t);function WjMultiAutoComplete(e){return t.call(this,e)||this}Object.defineProperty(WjMultiAutoComplete.prototype,"_controlConstructor",{get:function(){return e.input.MultiAutoComplete},enumerable:!0,configurable:!0});return WjMultiAutoComplete}(o);t.WjMultiAutoComplete=W;var x=function(e){__extends(WjCollectionViewNavigator,e);function WjCollectionViewNavigator(){var t=e.call(this)||this;t.template='<div class="wj-control wj-content wj-pager"><div class="wj-input-group"><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToFirst()" ng-disabled="cv.currentPosition <= 0"><span class="wj-glyph-left" style="margin-right:-4px"></span><span class="wj-glyph-left"></span> </button></span><span class="wj-input-group-btn"> <button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToPrevious()" ng-disabled="cv.currentPosition <= 0"><span class="wj-glyph-left"></span> </button></span><input type="text" class="wj-form-control" value=" {{cv.currentPosition + 1 | number}} / {{cv.itemCount | number}} " disabled /><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToNext()" ng-disabled="cv.currentPosition >= cv.itemCount - 1"><span class="wj-glyph-right"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button" ng-click="cv.moveCurrentToLast()" ng-disabled="cv.currentPosition >= cv.itemCount - 1"><span class="wj-glyph-right"></span><span class="wj-glyph-right" style="margin-left:-4px"></span></button></span></div></div>';return t}WjCollectionViewNavigator.prototype._getMetaDataId=function(){return"CollectionViewNavigator"};WjCollectionViewNavigator.prototype._postLinkFn=function(){return function(e,t,r,n){}};return WjCollectionViewNavigator}(t.WjDirective);t.WjCollectionViewNavigator=x;var F=function(e){__extends(WjCollectionViewPager,e);function WjCollectionViewPager(){var t=e.call(this)||this;t.template='<div class="wj-control wj-content wj-pager"><div class="wj-input-group"><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToFirstPage()"ng-disabled="cv.pageIndex <= 0"><span class="wj-glyph-left" style="margin-right:-4px"></span><span class="wj-glyph-left"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToPreviousPage()"ng-disabled="cv.pageIndex <= 0"><span class="wj-glyph-left"></span></button></span><input type="text" class="wj-form-control" value="{{cv.pageIndex + 1 | number}} / {{cv.pageCount | number}}" disabled /><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToNextPage()"ng-disabled="cv.pageIndex >= cv.pageCount - 1"><span class="wj-glyph-right"></span></button></span><span class="wj-input-group-btn"><button class="wj-btn wj-btn-default" type="button"ng-click="cv.moveToLastPage()"ng-disabled="cv.pageIndex >= cv.pageCount - 1"><span class="wj-glyph-right"></span><span class="wj-glyph-right" style="margin-left:-4px"></span></button></span></div></div>';return t}WjCollectionViewPager.prototype._getMetaDataId=function(){return"CollectionViewPager"};WjCollectionViewPager.prototype._postLinkFn=function(){return function(e,t,r,n){}};return WjCollectionViewPager}(t.WjDirective);t.WjCollectionViewPager=F}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.gauge");if(t.softRefGauge()&&t.softRefGauge().LinearGauge){r.directive("wjLinearGauge",[function(){return new i}]);r.directive("wjBulletGraph",[function(){return new o}]);r.directive("wjRadialGauge",[function(){return new a}]);r.directive("wjRange",[function(){return new s}])}var n=function(t){__extends(WjGauge,t);function WjGauge(){var e=t.call(this)||this;e.template="<div ng-transclude />";e.transclude=!0;return e}Object.defineProperty(WjGauge.prototype,"_controlConstructor",{get:function(){return e.gauge.Gauge},enumerable:!0,configurable:!0});return WjGauge}(t.WjDirective);t.WjGauge=n;var i=function(t){__extends(WjLinearGauge,t);function WjLinearGauge(){return t.call(this)||this}Object.defineProperty(WjLinearGauge.prototype,"_controlConstructor",{get:function(){return e.gauge.LinearGauge},enumerable:!0,configurable:!0});return WjLinearGauge}(n);t.WjLinearGauge=i;var o=function(t){__extends(WjBulletGraph,t);function WjBulletGraph(){return t.call(this)||this}Object.defineProperty(WjBulletGraph.prototype,"_controlConstructor",{get:function(){return e.gauge.BulletGraph},enumerable:!0,configurable:!0});return WjBulletGraph}(i);t.WjBulletGraph=o;var a=function(t){__extends(WjRadialGauge,t);function WjRadialGauge(){return t.call(this)||this}Object.defineProperty(WjRadialGauge.prototype,"_controlConstructor",{get:function(){return e.gauge.RadialGauge},enumerable:!0,configurable:!0});return WjRadialGauge}(n);t.WjRadialGauge=a;var s=function(t){__extends(WjRange,t);function WjRange(){var e=t.call(this)||this;e.require=["?^wjLinearGauge","?^wjRadialGauge","?^wjBulletGraph"];e.template="<div ng-transclude />";e.transclude=!0;e._property="ranges";e._isPropertyArray=!0;return e}Object.defineProperty(WjRange.prototype,"_controlConstructor",{get:function(){return e.gauge.Range},enumerable:!0,configurable:!0});WjRange.prototype._initControl=function(t){return new e.gauge.Range};return WjRange}(t.WjDirective);t.WjRange=s}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.nav");if(t.softRefNav()){r.directive("wjTreeView",[function(){return new n}]);r.directive("wjTabPanel",[function(){return new i}]);r.directive("wjTab",[function(){return new a}])}var n=function(t){__extends(WjTreeView,t);function WjTreeView(){var e=t.call(this)||this;e.transclude=!0;e.template="<div ng-transclude />";return e}Object.defineProperty(WjTreeView.prototype,"_controlConstructor",{get:function(){return e.nav.TreeView},enumerable:!0,configurable:!0});return WjTreeView}(t.WjDirective);t.WjTreeView=n;var i=function(t){__extends(WjTabPanel,t);function WjTabPanel(){var e=t.call(this)||this;e.transclude=!0;e.template="<div ng-transclude />";return e}Object.defineProperty(WjTabPanel.prototype,"_controlConstructor",{get:function(){return e.nav.TabPanel},enumerable:!0,configurable:!0});WjTabPanel.prototype._initControl=function(t){var r=new e.nav.TabPanel(t,null,!0);r.tabs.beginUpdate();return r};WjTabPanel.prototype._createLink=function(){return new o};return WjTabPanel}(t.WjDirective);t.WjTabPanel=i;var o=function(e){__extends(WjTabPanelLink,e);function WjTabPanelLink(){return null!==e&&e.apply(this,arguments)||this}WjTabPanelLink.prototype._onChildrenReady=function(){e.prototype._onChildrenReady.call(this);var t=this.control;t.tabs.endUpdate();t.selectedIndex<0&&t.tabs.length&&(t.selectedIndex=0)};return WjTabPanelLink}(t.WjLink),a=function(t){__extends(WjTab,t);function WjTab(){var e=t.call(this)||this;e.transclude=!0;e.template="<div ng-transclude />";e.require="^wjTabPanel";return e}Object.defineProperty(WjTab.prototype,"_controlConstructor",{get:function(){return e.nav.Tab},enumerable:!0,configurable:!0});WjTab.prototype._initControl=function(t){return new e.nav.Tab(t.children[0],t.children[1])};return WjTab}(t.WjDirective);t.WjTab=a}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart");if(t.softRefChart()&&t.softRefChart().FlexChart){r.directive("wjFlexChart",[function(){return new o}]);r.directive("wjFlexChartAxis",[function(){return new a}]);r.directive("wjFlexChartSeries",[function(){return new h}]);r.directive("wjFlexChartLegend",[function(){return new s}]);r.directive("wjFlexChartDataLabel",[function(){return new c}]);r.directive("wjFlexPieDataLabel",[function(){return new u}]);r.directive("wjFlexChartLineMarker",[function(){return new d}]);r.directive("wjFlexChartPlotArea",[function(){return new m}]);r.directive("wjFlexChartDataPoint",[function(){return new C}]);r.directive("wjFlexPie",[function(){return new f}])}var n=function(r){__extends(WjFlexChartBase,r);function WjFlexChartBase(){var e=r.call(this)||this;e.template="<div ng-transclude />";e.transclude=!0;return e}Object.defineProperty(WjFlexChartBase.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChartBase},enumerable:!0,configurable:!0});WjFlexChartBase.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("tooltipContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.tooltip.content=r)}};return WjFlexChartBase}(t.WjDirective);t.WjFlexChartBase=n;var i=function(r){__extends(WjFlexChartCore,r);function WjFlexChartCore(){return null!==r&&r.apply(this,arguments)||this}Object.defineProperty(WjFlexChartCore.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChartCore},enumerable:!0,configurable:!0});WjFlexChartCore.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}};return WjFlexChartCore}(n);t.WjFlexChartCore=i;var o=function(t){__extends(WjFlexChart,t);function WjFlexChart(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjFlexChart.prototype,"_controlConstructor",{get:function(){return e.chart.FlexChart},enumerable:!0,configurable:!0});return WjFlexChart}(i);t.WjFlexChart=o;var a=function(t){__extends(WjFlexChartAxis,t);function WjFlexChartAxis(){var e=t.call(this)||this;e.require=["?^wjFlexChartSeries","?^wjFinancialChartSeries","?^wjFlexChart","?^wjFinancialChart","?^wjFlexRadar"];e.template='<div class="wjFlexChartAxis" />';return e}Object.defineProperty(WjFlexChartAxis.prototype,"_controlConstructor",{get:function(){return e.chart.Axis},enumerable:!0,configurable:!0});WjFlexChartAxis.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartAxis}(t.WjDirective);t.WjFlexChartAxis=a;var s=function(t){__extends(WjFlexChartLegend,t);function WjFlexChartLegend(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjFinancialChart","?^wjFlexRadar"];e.template="<div />";return e}Object.defineProperty(WjFlexChartLegend.prototype,"_controlConstructor",{get:function(){return e.chart.Legend},enumerable:!0,configurable:!0});return WjFlexChartLegend}(t.WjDirective);t.WjFlexChartLegend=s;var l=function(t){__extends(WjFlexChartDataLabelBase,t);function WjFlexChartDataLabelBase(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjTreeMap"];e.template="<div />";return e}Object.defineProperty(WjFlexChartDataLabelBase.prototype,"_controlConstructor",{get:function(){return e.chart.DataLabelBase},enumerable:!0,configurable:!0});return WjFlexChartDataLabelBase}(t.WjDirective);t.WjFlexChartDataLabelBase=l;var c=function(t){__extends(WjFlexChartDataLabel,t);function WjFlexChartDataLabel(){var e=t.call(this)||this;e.require=["^wjFlexChart","?^wjTreeMap"];return e}Object.defineProperty(WjFlexChartDataLabel.prototype,"_controlConstructor",{get:function(){return e.chart.DataLabel},enumerable:!0,configurable:!0});return WjFlexChartDataLabel}(l);t.WjFlexChartDataLabel=c;var u=function(t){__extends(WjFlexPieDataLabel,t);function WjFlexPieDataLabel(){var e=t.call(this)||this;e.require=["^wjFlexPie","?^wjSunburst"];return e}Object.defineProperty(WjFlexPieDataLabel.prototype,"_controlConstructor",{get:function(){return e.chart.PieDataLabel},enumerable:!0,configurable:!0});return WjFlexPieDataLabel}(l);t.WjFlexPieDataLabel=u;var p=function(t){__extends(WjSeriesBase,t);function WjSeriesBase(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart","?^wjFlexRadar"];e.template='<div class="wjSeriesBase" ng-transclude />';e.transclude=!0;return e}Object.defineProperty(WjSeriesBase.prototype,"_controlConstructor",{get:function(){return e.chart.SeriesBase},enumerable:!0,configurable:!0});WjSeriesBase.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};WjSeriesBase.prototype._getId=function(){return"series"};return WjSeriesBase}(t.WjDirective);t.WjSeriesBase=p;var h=function(t){__extends(WjFlexChartSeries,t);function WjFlexChartSeries(){var e=t.call(this)||this;e.require="^wjFlexChart";e.template='<div class="wjFlexChartSeries" ng-transclude />';return e}Object.defineProperty(WjFlexChartSeries.prototype,"_controlConstructor",{get:function(){return e.chart.Series},enumerable:!0,configurable:!0});return WjFlexChartSeries}(p);t.WjFlexChartSeries=h;var d=function(t){__extends(WjFlexChartLineMarker,t);function WjFlexChartLineMarker(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];return e}Object.defineProperty(WjFlexChartLineMarker.prototype,"_controlConstructor",{get:function(){return e.chart.LineMarker},enumerable:!0,configurable:!0});return WjFlexChartLineMarker}(t.WjDirective);t.WjFlexChartLineMarker=d;var C=function(t){__extends(WjFlexChartDataPoint,t);function WjFlexChartDataPoint(){var e=t.call(this)||this;e.require=["?^wjFlexChartAnnotation"];return e}Object.defineProperty(WjFlexChartDataPoint.prototype,"_controlConstructor",{get:function(){return e.chart.DataPoint},enumerable:!0,configurable:!0});return WjFlexChartDataPoint}(t.WjDirective);t.WjFlexChartDataPoint=C;var f=function(r){__extends(WjFlexPie,r);function WjFlexPie(){return null!==r&&r.apply(this,arguments)||this}Object.defineProperty(WjFlexPie.prototype,"_controlConstructor",{get:function(){return e.chart.FlexPie},enumerable:!0,configurable:!0});WjFlexPie.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}};return WjFlexPie}(n);t.WjFlexPie=f;var m=function(t){__extends(WjFlexChartPlotArea,t);function WjFlexChartPlotArea(){var e=t.call(this)||this;e.require=["?^wjFlexChartPlotArea","?^wjFlexChart","?^wjFinancialChart"];e.template='<div class="wjFlexChartPlotArea" />';return e}Object.defineProperty(WjFlexChartPlotArea.prototype,"_controlConstructor",{get:function(){return e.chart.PlotArea},enumerable:!0,configurable:!0});WjFlexChartPlotArea.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartPlotArea}(t.WjDirective);t.WjFlexChartPlotArea=m}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.analytics");if(t.softRefChartAnalytics()){r.directive("wjFlexChartTrendLine",[function(){return new i}]);r.directive("wjFlexChartMovingAverage",[function(){return new o}]);r.directive("wjFlexChartYFunctionSeries",[function(){return new a}]);r.directive("wjFlexChartParametricFunctionSeries",[function(){return new s}]);r.directive("wjFlexChartWaterfall",[function(){return new l}]);r.directive("wjFlexChartBoxWhisker",[function(){return new c}]);r.directive("wjFlexChartErrorBar",[function(){return new u}])}var n=function(t){__extends(WjTrendLineBase,t);function WjTrendLineBase(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];e.template='<div class="wjTrendLineBase" ng-transclude />';return e}Object.defineProperty(WjTrendLineBase.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.TrendLineBase},enumerable:!0,configurable:!0});return WjTrendLineBase}(t.WjSeriesBase);t.WjTrendLineBase=n;var i=function(t){__extends(WjFlexChartTrendLine,t);function WjFlexChartTrendLine(){var e=t.call(this)||this;e.template='<div class="wjTrendLine" ng-transclude />';return e}Object.defineProperty(WjFlexChartTrendLine.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.TrendLine},enumerable:!0,configurable:!0});return WjFlexChartTrendLine}(n);t.WjFlexChartTrendLine=i;var o=function(t){__extends(WjFlexChartMovingAverage,t);function WjFlexChartMovingAverage(){var e=t.call(this)||this;e.template='<div class="wjMovingAverage" ng-transclude />';return e}Object.defineProperty(WjFlexChartMovingAverage.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.MovingAverage},enumerable:!0,configurable:!0});return WjFlexChartMovingAverage}(n);t.WjFlexChartMovingAverage=o;var a=function(t){__extends(WjFlexChartYFunctionSeries,t);function WjFlexChartYFunctionSeries(){var e=t.call(this)||this;e.template='<div class="wjYFunctionSeries" ng-transclude />';return e}Object.defineProperty(WjFlexChartYFunctionSeries.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.YFunctionSeries},enumerable:!0,configurable:!0});return WjFlexChartYFunctionSeries}(n);t.WjFlexChartYFunctionSeries=a;var s=function(r){__extends(WjFlexChartParametricFunctionSeries,r);function WjFlexChartParametricFunctionSeries(){var e=r.call(this)||this;e.template='<div class="wjParametricFunctionSeries" ng-transclude />';return e}Object.defineProperty(WjFlexChartParametricFunctionSeries.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.ParametricFunctionSeries},enumerable:!0,configurable:!0});WjFlexChartParametricFunctionSeries.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("func",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.xFunc=r)}};return WjFlexChartParametricFunctionSeries}(n);t.WjFlexChartParametricFunctionSeries=s;var l=function(t){__extends(WjFlexChartWaterfall,t);function WjFlexChartWaterfall(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];e.template='<div class="wjWaterfall" ng-transclude />';return e}Object.defineProperty(WjFlexChartWaterfall.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.Waterfall},enumerable:!0,configurable:!0});return WjFlexChartWaterfall}(t.WjSeriesBase);t.WjFlexChartWaterfall=l;var c=function(t){__extends(WjFlexChartBoxWhisker,t);function WjFlexChartBoxWhisker(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];e.template='<div class="wjBoxWhisker" ng-transclude />';return e}Object.defineProperty(WjFlexChartBoxWhisker.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.BoxWhisker},enumerable:!0,configurable:!0});return WjFlexChartBoxWhisker}(t.WjSeriesBase);t.WjFlexChartBoxWhisker=c;var u=function(t){__extends(WjFlexChartErrorBar,t);function WjFlexChartErrorBar(){var e=t.call(this)||this;e.require=["?^wjFlexChart"];e.template='<div class="wjErrorBar" ng-transclude />';return e}Object.defineProperty(WjFlexChartErrorBar.prototype,"_controlConstructor",{get:function(){return e.chart.analytics.ErrorBar},enumerable:!0,configurable:!0});return WjFlexChartErrorBar}(t.WjFlexChartSeries);t.WjFlexChartErrorBar=u}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.animation");t.softRefChartAnimation()&&r.directive("wjFlexChartAnimation",[function(){return new n}]);var n=function(t){__extends(WjFlexChartAnimation,t);function WjFlexChartAnimation(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFlexPie","?^wjSunburst","?^wjFinancialChart","?^wjFlexRadar"];return e}Object.defineProperty(WjFlexChartAnimation.prototype,"_controlConstructor",{get:function(){return e.chart.animation.ChartAnimation},enumerable:!0,configurable:!0});return WjFlexChartAnimation}(t.WjDirective);t.WjFlexChartAnimation=n}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.annotation");if(t.softRefChartAnnotation()){r.directive("wjFlexChartAnnotationLayer",[function(){return new n}]);r.directive("wjFlexChartAnnotation",[function(){return new i}])}var n=function(t){__extends(WjFlexChartAnnotationLayer,t);function WjFlexChartAnnotationLayer(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];e.template='<div class="wjFlexChartAnnotationLayer" ng-transclude />';e.transclude=!0;return e}Object.defineProperty(WjFlexChartAnnotationLayer.prototype,"_controlConstructor",{get:function(){return e.chart.annotation.AnnotationLayer},enumerable:!0,configurable:!0});return WjFlexChartAnnotationLayer}(t.WjDirective);t.WjFlexChartAnnotationLayer=n;var i=function(e){__extends(WjFlexChartAnnotation,e);function WjFlexChartAnnotation(){var t=e.call(this)||this;t.require="^wjFlexChartAnnotationLayer";t.template='<div class="wjFlexChartAnnotation" ng-transclude />';t.transclude=!0;return t}WjFlexChartAnnotation.prototype._createLink=function(){return new o};WjFlexChartAnnotation.prototype._getMetaDataId=function(){return"FlexChartAnnotation"};return WjFlexChartAnnotation}(t.WjDirective);t.WjFlexChartAnnotation=i;var o=function(t){__extends(WjFlexChartAnnotationLink,t);function WjFlexChartAnnotationLink(){return null!==t&&t.apply(this,arguments)||this}WjFlexChartAnnotationLink.prototype._initControl=function(){return new e.chart.annotation[this.scope.type]};return WjFlexChartAnnotationLink}(t.WjLink);t.WjFlexChartAnnotationLink=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.finance");if(t.softRefChartFinance()){r.directive("wjFinancialChart",[function(){return new n}]);r.directive("wjFinancialChartSeries",[function(){return new i}])}var n=function(t){__extends(WjFinancialChart,t);function WjFinancialChart(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjFinancialChart.prototype,"_controlConstructor",{get:function(){return e.chart.finance.FinancialChart},enumerable:!0,configurable:!0});return WjFinancialChart}(t.WjFlexChartCore);t.WjFinancialChart=n;var i=function(t){__extends(WjFinancialChartSeries,t);function WjFinancialChartSeries(){var e=t.call(this)||this;e.require="^wjFinancialChart";e.template='<div class="wjFinancialChartSeries" ng-transclude />';return e}Object.defineProperty(WjFinancialChartSeries.prototype,"_controlConstructor",{get:function(){return e.chart.finance.FinancialSeries},enumerable:!0,configurable:!0});return WjFinancialChartSeries}(t.WjSeriesBase);t.WjFinancialChartSeries=i}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.finance.analytics");if(t.softRefChartFinanceAnalytics()){r.directive("wjFlexChartFibonacci",[function(){return new o}]);r.directive("wjFlexChartFibonacciArcs",[function(){return new a}]);r.directive("wjFlexChartFibonacciFans",[function(){return new s}]);r.directive("wjFlexChartFibonacciTimeZones",[function(){return new l}]);r.directive("wjFlexChartAtr",[function(){return new c}]);r.directive("wjFlexChartCci",[function(){return new u}]);r.directive("wjFlexChartRsi",[function(){return new p}]);r.directive("wjFlexChartWilliamsR",[function(){return new h}]);r.directive("wjFlexChartMacd",[function(){return new C}]);r.directive("wjFlexChartMacdHistogram",[function(){return new f}]);r.directive("wjFlexChartStochastic",[function(){return new m}]);r.directive("wjFlexChartBollingerBands",[function(){return new g}]);r.directive("wjFlexChartEnvelopes",[function(){return new P}])}var n=function(t){__extends(WjBaseOverlayIndicator,t);function WjBaseOverlayIndicator(){var e=t.call(this)||this;e.require="^wjFinancialChart";e.template='<div class="wjBaseOverlayIndicator" ng-transclude />';return e}Object.defineProperty(WjBaseOverlayIndicator.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.OverlayIndicatorBase},enumerable:!0,configurable:!0});return WjBaseOverlayIndicator}(t.WjSeriesBase);t.WjBaseOverlayIndicator=n;var i=function(t){__extends(WjBaseSingleOverlayIndicator,t);function WjBaseSingleOverlayIndicator(){var e=t.call(this)||this;e.template='<div class="wjBaseSingleOverlayIndicator" ng-transclude />';return e}Object.defineProperty(WjBaseSingleOverlayIndicator.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.SingleOverlayIndicatorBase},enumerable:!0,configurable:!0});return WjBaseSingleOverlayIndicator}(n);t.WjBaseSingleOverlayIndicator=i;var o=function(t){__extends(WjFlexChartFibonacci,t);function WjFlexChartFibonacci(){var e=t.call(this)||this;e.require=["?^wjFinancialChart"];e.template='<div class="wjFlexChartFibonacci" ng-transclude />';return e}Object.defineProperty(WjFlexChartFibonacci.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Fibonacci},enumerable:!0,configurable:!0});WjFlexChartFibonacci.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartFibonacci}(t.WjSeriesBase);t.WjFlexChartFibonacci=o;var a=function(t){__extends(WjFlexChartFibonacciArcs,t);function WjFlexChartFibonacciArcs(){var e=t.call(this)||this;e.require=["?^wjFinancialChart"];e.template='<div class="wjFlexChartFibonacciArcs" ng-transclude />';return e}Object.defineProperty(WjFlexChartFibonacciArcs.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciArcs},enumerable:!0,configurable:!0});WjFlexChartFibonacciArcs.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartFibonacciArcs}(t.WjSeriesBase);t.WjFlexChartFibonacciArcs=a;var s=function(t){__extends(WjFlexChartFibonacciFans,t);function WjFlexChartFibonacciFans(){var e=t.call(this)||this;e.require=["?^wjFinancialChart"];e.template='<div class="wjFlexChartFibonacciFans" ng-transclude />';return e}Object.defineProperty(WjFlexChartFibonacciFans.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciFans},enumerable:!0,configurable:!0});WjFlexChartFibonacciFans.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartFibonacciFans}(t.WjSeriesBase);t.WjFlexChartFibonacciFans=s;var l=function(t){__extends(WjFlexChartFibonacciTimeZones,t);function WjFlexChartFibonacciTimeZones(){var e=t.call(this)||this;e.require=["?^wjFinancialChart"];e.template='<div class="wjFlexChartFibonacciTimeZones" ng-transclude />';return e}Object.defineProperty(WjFlexChartFibonacciTimeZones.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.FibonacciTimeZones},enumerable:!0,configurable:!0});WjFlexChartFibonacciTimeZones.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexChartFibonacciTimeZones}(t.WjSeriesBase);t.WjFlexChartFibonacciTimeZones=l;var c=function(t){__extends(WjFlexChartAtr,t);function WjFlexChartAtr(){var e=t.call(this)||this;e.template='<div class="wjFlexChartAtr" ng-transclude />';return e}Object.defineProperty(WjFlexChartAtr.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.ATR},enumerable:!0,configurable:!0});return WjFlexChartAtr}(i);t.WjFlexChartAtr=c;var u=function(t){__extends(WjFlexChartCci,t);function WjFlexChartCci(){var e=t.call(this)||this;e.template='<div class="wjFlexChartCci" ng-transclude />';return e}Object.defineProperty(WjFlexChartCci.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.CCI},enumerable:!0,configurable:!0});return WjFlexChartCci}(i);t.WjFlexChartCci=u;var p=function(t){__extends(WjFlexChartRsi,t);function WjFlexChartRsi(){var e=t.call(this)||this;e.template='<div class="wjFlexChartRsi" ng-transclude />';return e}Object.defineProperty(WjFlexChartRsi.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.RSI},enumerable:!0,configurable:!0});return WjFlexChartRsi}(i);t.WjFlexChartRsi=p;var h=function(t){__extends(WjFlexChartWilliamsR,t);function WjFlexChartWilliamsR(){var e=t.call(this)||this;e.template='<div class="wjFlexChartWilliamsR" ng-transclude />';return e}Object.defineProperty(WjFlexChartWilliamsR.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.WilliamsR},enumerable:!0,configurable:!0});return WjFlexChartWilliamsR}(i);t.WjFlexChartWilliamsR=h;var d=function(t){__extends(WjFlexChartMacdBase,t);function WjFlexChartMacdBase(){var e=t.call(this)||this;e.template='<div class="wjFlexChartBaseMacd" ng-transclude />';return e}Object.defineProperty(WjFlexChartMacdBase.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.MacdBase},enumerable:!0,configurable:!0});return WjFlexChartMacdBase}(n);t.WjFlexChartMacdBase=d;var C=function(t){__extends(WjFlexChartMacd,t);function WjFlexChartMacd(){var e=t.call(this)||this;e.template='<div class="wjFlexChartMacd" ng-transclude />';return e}Object.defineProperty(WjFlexChartMacd.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Macd},enumerable:!0,configurable:!0});return WjFlexChartMacd}(d);t.WjFlexChartMacd=C;var f=function(t){__extends(WjFlexChartMacdHistogram,t);function WjFlexChartMacdHistogram(){var e=t.call(this)||this;e.template='<div class="wjFlexChartMacdHistogram" ng-transclude />';return e}Object.defineProperty(WjFlexChartMacdHistogram.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.MacdHistogram},enumerable:!0,configurable:!0});return WjFlexChartMacdHistogram}(d);t.WjFlexChartMacdHistogram=f;var m=function(t){__extends(WjFlexChartStochastic,t);function WjFlexChartStochastic(){var e=t.call(this)||this;e.template='<div class="wjFlexChartStochastic" ng-transclude />';return e}Object.defineProperty(WjFlexChartStochastic.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Stochastic},enumerable:!0,configurable:!0});return WjFlexChartStochastic}(n);t.WjFlexChartStochastic=m;var g=function(t){__extends(WjFlexChartBollingerBands,t);function WjFlexChartBollingerBands(){var e=t.call(this)||this;e.template='<div class="wjFlexChartBollingerBands" ng-transclude />';return e}Object.defineProperty(WjFlexChartBollingerBands.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.BollingerBands},enumerable:!0,configurable:!0});return WjFlexChartBollingerBands}(n);t.WjFlexChartBollingerBands=g;var P=function(t){__extends(WjFlexChartEnvelopes,t);function WjFlexChartEnvelopes(){var e=t.call(this)||this;e.template='<div class="wjFlexChartEnvelopes" ng-transclude />';return e}Object.defineProperty(WjFlexChartEnvelopes.prototype,"_controlConstructor",{get:function(){return e.chart.finance.analytics.Envelopes},enumerable:!0,configurable:!0});return WjFlexChartEnvelopes}(n);t.WjFlexChartEnvelopes=P}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.hierarchical");if(t.softRefChartHierarchical){r.directive("wjSunburst",[function(){return new n}]);r.directive("wjTreeMap",[function(){return new i}])}var n=function(t){__extends(WjSunburst,t);function WjSunburst(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjSunburst.prototype,"_controlConstructor",{get:function(){return e.chart.hierarchical.Sunburst},enumerable:!0,configurable:!0});return WjSunburst}(t.WjFlexPie);t.WjSunburst=n;var i=function(r){__extends(WjTreeMap,r);function WjTreeMap(){return null!==r&&r.apply(this,arguments)||this}Object.defineProperty(WjTreeMap.prototype,"_controlConstructor",{get:function(){return e.chart.hierarchical.TreeMap},enumerable:!0,configurable:!0});WjTreeMap.prototype._initProps=function(){r.prototype._initProps.call(this);t.MetaFactory.findProp("labelContent",this._props).customHandler=function(e,t,r,n,i){null!=r&&(t.dataLabel.content=r)}};return WjTreeMap}(t.WjFlexChartBase);t.WjTreeMap=i}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.interaction");if(t.softRefChartInteraction()){r.directive("wjFlexChartRangeSelector",[function(){return new n}]);r.directive("wjFlexChartGestures",[function(){return new i}]);r.directive("wjFlexChartChartGestures",[function(){return new i}])}var n=function(t){__extends(WjFlexChartRangeSelector,t);function WjFlexChartRangeSelector(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];return e}Object.defineProperty(WjFlexChartRangeSelector.prototype,"_controlConstructor",{get:function(){return e.chart.interaction.RangeSelector},enumerable:!0,configurable:!0});return WjFlexChartRangeSelector}(t.WjDirective);t.WjFlexChartRangeSelector=n;var i=function(t){__extends(WjFlexChartChartGestures,t);function WjFlexChartChartGestures(){var e=t.call(this)||this;e.require=["?^wjFlexChart","?^wjFinancialChart"];return e}Object.defineProperty(WjFlexChartChartGestures.prototype,"_controlConstructor",{get:function(){return e.chart.interaction.ChartGestures},enumerable:!0,configurable:!0});return WjFlexChartChartGestures}(t.WjDirective);t.WjFlexChartChartGestures=i}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.chart.radar");if(t.softRefChartRadar()){r.directive("wjFlexRadar",[function(){return new n}]);r.directive("wjFlexRadarSeries",[function(){return new i}]);r.directive("wjFlexRadarAxis",[function(){return new o}])}var n=function(t){__extends(WjFlexRadar,t);function WjFlexRadar(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjFlexRadar.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadar},enumerable:!0,configurable:!0});return WjFlexRadar}(t.WjFlexChartCore);t.WjFlexRadar=n;var i=function(t){__extends(WjFlexRadarSeries,t);function WjFlexRadarSeries(){var e=t.call(this)||this;e.require="^wjFlexRadar";e.template='<div class="wjFlexRadarSeries" ng-transclude />';return e}Object.defineProperty(WjFlexRadarSeries.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadarSeries},enumerable:!0,configurable:!0});return WjFlexRadarSeries}(t.WjSeriesBase);t.WjFlexRadarSeries=i;var o=function(t){__extends(WjFlexRadarAxis,t);function WjFlexRadarAxis(){var e=t.call(this)||this;e.require=["?^wjFlexRadarSeries","?^wjFlexRadar"];e.template='<div class="wjFlexRadarAxis" />';return e}Object.defineProperty(WjFlexRadarAxis.prototype,"_controlConstructor",{get:function(){return e.chart.radar.FlexRadarAxis},enumerable:!0,configurable:!0});WjFlexRadarAxis.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjFlexRadarAxis}(t.WjDirective);t.WjFlexRadarAxis=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.container");r.directive("wjTooltip",[function(){return new n}]);r.directive("wjValidationError",[function(){return new o}]);var n=function(t){__extends(WjTooltip,t);function WjTooltip(){var e=t.call(this)||this;e.restrict="A";e.template="";return e}Object.defineProperty(WjTooltip.prototype,"_controlConstructor",{get:function(){return e.Tooltip},enumerable:!0,configurable:!0});WjTooltip.prototype._initControl=function(t){return new e.Tooltip};WjTooltip.prototype._createLink=function(){return new i};return WjTooltip}(t.WjDirective);t.WjTooltip=n;var i=function(e){__extends(WjTooltipLink,e);function WjTooltipLink(){return null!==e&&e.apply(this,arguments)||this}WjTooltipLink.prototype._link=function(){e.prototype._link.call(this);var t=this.control,r=this;this.tAttrs.$observe("wjTooltip",(function(e){t.setTooltip(r.tElement[0],e)}))};return WjTooltipLink}(t.WjLink),o=function(e){__extends(WjValidationError,e);function WjValidationError(){var t=e.call(this)||this;t.restrict="A";t.template="";t.require="ngModel";t.scope=!1;return t}WjValidationError.prototype._postLinkFn=function(){return function(e,t,r,n){var i="wjValidationError";e.$watch(r[i],(function(e){var r="INPUT"==t[0].tagName?t[0]:t[0].querySelector("input");"boolean"==typeof e&&(e=e?"error":"");r&&r.setCustomValidity&&r.setCustomValidity(e);n&&n.$setValidity(i,!e)}))}};WjValidationError.prototype._getMetaDataId=function(){return"ValidationError"};return WjValidationError}(t.WjDirective);t.WjValidationError=o}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid");if(t.softRefGrid()&&t.softRefGrid().FlexGrid){r.directive("wjFlexGrid",["$compile","$interpolate",function(e,t){return new n(e,t)}]);r.directive("wjFlexGridColumn",["$compile",function(e){return new l(e)}]);r.directive("wjFlexGridCellTemplate",[function(){return new p}])}var n=function(r){__extends(WjFlexGrid,r);function WjFlexGrid(e,t){var n=r.call(this)||this;n._$compile=e;n._$interpolate=t;n.transclude=!0;n.template="<div ng-transclude />";return n}Object.defineProperty(WjFlexGrid.prototype,"_controlConstructor",{get:function(){return e.grid.FlexGrid},enumerable:!0,configurable:!0});WjFlexGrid.prototype._createLink=function(){return new i};WjFlexGrid.prototype._initProps=function(){var e=t.MetaFactory.findProp("childItemsPath",this._props);e.scopeBindingMode="@";e.customHandler=function(e,t,r,n,i){if(r&&(r=r.trim())&&"["===r[0]){var o=e.$parent.$eval(r);t.childItemsPath=o;return!0}return!1}};return WjFlexGrid}(t.WjDirective);t.WjFlexGrid=n;var i=function(e){__extends(WjFlexGridLink,e);function WjFlexGridLink(){return null!==e&&e.apply(this,arguments)||this}WjFlexGridLink.prototype._initControl=function(){var t=e.prototype._initControl.call(this);new a(t,this);return t};return WjFlexGridLink}(t.WjLink),o=e.grid&&e.grid.CellFactory;if(!o){window.wijmo.grid={};window.wijmo.grid.CellFactory=function(){}}var a=function(r){__extends(DirectiveCellFactory,r);function DirectiveCellFactory(t,n){var i=r.call(this)||this;i._lastApplyTimeStamp=0;i._noApplyLag=!1;i._startingEditing=!1;i._cellStampCounter=0;i._composing=!1;i._grid=t;i._gridLink=n;i._rowHeightUpdates=new s(i);if(!DirectiveCellFactory._templateTypes){DirectiveCellFactory._templateTypes=[];for(var o in c)isNaN(o)&&DirectiveCellFactory._templateTypes.push(o)}var a=i;i._baseCf=t.cellFactory;t.cellFactory=i;i._evtInput=document.createEvent("HTMLEvents");i._evtInput.initEvent("input",!0,!1);i._evtChange=document.createEvent("HTMLEvents");i._evtChange.initEvent("change",!0,!1);i._evtBlur=document.createEvent("HTMLEvents");i._evtBlur.initEvent("blur",!1,!1);t.prepareCellForEdit.addHandler((function(e,t){a._noApplyLag=!0}));t.cellEditEnded.addHandler((function(e,r){(r.range.col<0||!t.columns[r.range.col][p._getTemplContextProp(c.CellEdit)])&&(a._editChar=null);setTimeout((function(){a._noApplyLag=!1}),300)}));t.beginningEdit.addHandler((function(e,t){!t.data||t.data instanceof KeyboardEvent&&!(t.data.charCode<=32)||(a._editChar=null);a._startingEditing=!0}));t.hostElement.addEventListener("keydown",(function(e){a._startingEditing=!1}),!0);t.hostElement.addEventListener("keypress",(function(r){var n=r.charCode>32?String.fromCharCode(r.charCode):null;n&&e.closest(r.target,".wj-flexgrid")===t.hostElement&&(!t.activeEditor||a._startingEditing?a._editChar=n:a._editChar&&(a._editChar+=n))}),!0);t.hostElement.addEventListener("compositionstart",(function(e){a._composing=!0}),!0);t.hostElement.addEventListener("compositionend",(function(e){a._composing=!1}),!0);return i}DirectiveCellFactory.prototype.updateCell=function(r,n,i,o,a){var s=this;this._cellStampCounter=(this._cellStampCounter+1)%1e7;var l=o[DirectiveCellFactory._cellStampProp]=this._cellStampCounter;o.style.overflow&&(o.style.overflow="");var u=n,h=i;if(a&&!a.isSingleCell){n=a.row;i=a.col}var d,C=this,f=r.grid,m=f.editRange,g=r.rows[n],P=g.dataItem,v=!1,j=!1,y=!1,_=!1;switch(r.cellType){case e.grid.CellType.Cell:if(m&&m.row===n&&m.col===i){d=c.CellEdit;j=y=!0}else if(g instanceof e.grid.GroupRow){var w=!((_=P instanceof e.collections.CollectionViewGroup)||g.hasChildren);if(i==r.columns.firstVisibleIndex)d=w?c.Cell:c.GroupHeader;else{d=w?c.Cell:c.Group;j=!0}}else t.softRefGridDetail()&&t.softRefGridDetail().DetailRow&&g instanceof t.softRefGridDetail().DetailRow||(d=c.Cell);break;case e.grid.CellType.ColumnHeader:d=c.ColumnHeader;break;case e.grid.CellType.RowHeader:d=f.collectionView&&f.collectionView.currentEditItem===P?c.RowHeaderEdit:c.RowHeader;v=!0;break;case e.grid.CellType.TopLeft:d=c.TopLeft;v=!0;break;case e.grid.CellType.ColumnFooter:d=c.ColumnFooter;j=!0;break;case e.grid.CellType.BottomLeft:d=c.BottomLeft;v=!0}var b=!1;if(null!=d){var W=_&&d==c.GroupHeader?f.getColumn(P.groupDescription.propertyName):i>=0&&i<r.columns.length?r.columns[i]:null;if(W){var x=p._getTemplContextProp(d),F=(v?f:W)[x];if(!F)if(d===c.RowHeaderEdit){d=c.RowHeader;x=p._getTemplContextProp(d);F=f[x]}else if((d===c.Group||d===c.GroupHeader)&&!_){d=c.Cell;x=p._getTemplContextProp(d);F=W[x]}if(F){var B,M=C._getCellTemplate(F.cellTemplate),S=F.cellStyle,D=F.cellClass,E=!e.isNullOrWhiteSpace(M),A=!e.isNullOrWhiteSpace(S),I=!e.isNullOrWhiteSpace(D);j&&(B=r.getCellData(n,i,!1));if(E){var T=o.getAttribute(e.grid.FlexGrid._WJS_MEASURE),L=T&&"true"===T.toLowerCase();b=!0;y&&this._baseCf.updateCell(r,u,h,o,a,!0);var G=o[x]||{},k=G.column!==W||!G.cellScope||!G.cellScope.$root,R=y&&this._composing&&f.imeEnabled,N=G.cellScope;if(k){this._doDisposeCell(o);G.cellScope=N=F.templLink.scope.$parent.$new();G.column=W;o[x]=G}var O=N.$row!==g||N.$col!==W||N.$item!==P||N.$value!==B;O&&C._initCellScope(N,g,W,P,B);var H=F.cellLink;H||(H=F.cellLink=this._gridLink.directive._$compile('<div style="display:none"'+(A?' ng-style="'+S+'"':"")+(I?' ng-class="'+D+'"':"")+">"+M+"</div>"));var V=G.clonedElement;if(k){var $=N.$watch((function(t){if(V){$();V[0].style.display="";if(r.cellType===e.grid.CellType.ColumnHeader||r.cellType===e.grid.CellType.TopLeft){var n=V[0].style,i=n.outlineColor,o=n.outlineWidth;n.outlineColor="white";n.outlineWidth="0px";setTimeout((function(){n.outlineColor=i;n.outlineWidth=o}),0)}}}));G.clonedElement=V=H(N,(function(e,t){}))}L&&(V[0].style.display="");var z=!1;if(y){var q=o.firstElementChild;if(q){R||o.focus();q.style.display="none"}}else(z=1==o.childNodes.length)||(o.textContent="");z?V[0]!==o.firstChild&&o.replaceChild(V[0],o.firstChild):o.appendChild(V[0]);F.cellOverflow&&(o.style.overflow=F.cellOverflow);this._closingApplyTimeOut&&clearTimeout(this._closingApplyTimeOut);C._rowHeightUpdates.add({panel:r,cell:o,rng:a,cellStamp:l,templateContext:F});if(L||m||this._noApplyLag||O&&Date.now()-this._lastApplyTimeStamp>40){clearTimeout(this._closingApplyTimeOut);N.$root&&!N.$root.$$phase&&N.$apply();m||L||C._rowHeightUpdates.execute();this._lastApplyTimeStamp=Date.now()}else{clearTimeout(this._closingApplyTimeOut);this._closingApplyTimeOut=setTimeout((function(){clearTimeout(this._closingApplyTimeOut);N.$root&&!N.$root.$$phase&&N.$apply();C._rowHeightUpdates.execute()}),10)}R?y&&setTimeout((function(){R?s._initImeEditInput(G,F):s._initEditInput(G,F,null)}),0):setTimeout((function(){if(C._updateRowHeight(r,o,a,l,F)){if(y){C._rowHeightUpdates.clear();var e=C._isFullEdit();f.refresh();f.startEditing(e);return}}else y&&C._initEditInput(G,F,null)}),0);if(y){C._cellEditorScope=N;var editEndingEH=function(a,s){f.cellEditEnding.removeHandler(editEndingEH);if(!s.stayInEditMode){var l=e.getActiveElement();l&&l.dispatchEvent(C._evtBlur);e.contains(o,e.getActiveElement())&&o.focus()}if(!s.cancel&&!s.stayInEditMode){s.cancel=!0;r.grid.setCellData(n,i,N.$value)}var c=o.querySelectorAll(".wj-dropdown");[].forEach.call(c,(function(r){var n=e.Control.getControl(r);n&&t.softRefInput()&&n instanceof t.softRefInput().DropDown&&(n.isDroppedDown=!1)}))};f.cellEditEnding.addHandler(editEndingEH);f.cellEditEnded.addHandler((function(){C._cellEditorScope=null}))}else this._baseCf.updateCell(r,u,h,o,a,!1)}}}}if(!b){this._doDisposeCell(o);this._baseCf.updateCell(r,u,h,o,a)}if(!E&&(A||I)){var U=C._initCellScope({},g,W,P,B),Z=A?this._gridLink.scope.$parent.$eval(S,U):null,Y=I?this._gridLink.scope.$parent.$eval(D,U):null;if(Z||Y){for(var Q=document.createElement("div");o.firstChild;)Q.appendChild(o.firstChild);o.appendChild(Q);if(Z)for(var X in Z)Q.style[X]=Z[X];if(Y){for(var K=e.isArray(Y)?Y:[Y],J="",ee=0;ee<K.length;ee++){var te=K[ee];if(te)if(e.isString(te))J+=" "+te;else for(var re in te)te[re]&&(J+=" "+re)}Q.className=J}}}};DirectiveCellFactory.prototype.getEditorValue=function(e){return this._cellEditorScope?this._cellEditorScope.$value:r.prototype.getEditorValue.call(this,e)};DirectiveCellFactory.prototype.disposeCell=function(e){this._doDisposeCell(e)};DirectiveCellFactory.prototype._doDisposeCell=function(e){for(var t=DirectiveCellFactory._templateTypes,r=0;r<t.length;r++){var n=p._getTemplContextProp(c[t[r]]),i=e[n];if(i&&i.cellScope&&i.cellScope.$root){i.cellScope.$destroy();if(i.clonedElement){i.clonedElement.remove();i.clonedElement=null}e[n]=null}}};DirectiveCellFactory.prototype._updateRowHeight=function(e,t,r,n,i){if(i.autoSizeRows){var o=t.scrollHeight,a=e.rows,s=r&&r.rowSpan||1;if(n===t[DirectiveCellFactory._cellStampProp]&&a.defaultSize*s<o){a.defaultSize=o/s;return!0}}return!1};DirectiveCellFactory.prototype._initCellScope=function(e,t,r,n,i){e.$row=t;e.$col=r;e.$item=n;e.$value=i;return e};DirectiveCellFactory.prototype._getCellTemplate=function(e){e&&(e=(e=(e=e.replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g,"")).replace(/<span>\s*<\/span>/g,"")).trim());return e};DirectiveCellFactory.prototype._isFullEdit=function(){var e=this._grid;return!e.activeEditor||e._edtHdl._fullEdit};DirectiveCellFactory.prototype._setFullEdit=function(e){var t=this._grid;e.forceFullEdit&&t.activeEditor&&(t._edtHdl._fullEdit=!0)};DirectiveCellFactory.prototype._initEditInput=function(t,r,n){var i=this;this._setFullEdit(r);var o=this._findInitialInput(t);if(o){var inpFocusEh_1=function(){o.removeEventListener("focus",inpFocusEh_1);setTimeout((function(){var t=null!=n?n:i._editChar;if(t){o.value=t;i._editChar=null;DirectiveCellFactory._setSelectionRange(o,t.length,t.length);!DirectiveCellFactory.isNgIE||e.hasClass(o,"wj-form-control")||o.getAttribute("wj-part")?o.dispatchEvent(i._evtInput):o.dispatchEvent(i._evtChange)}}),DirectiveCellFactory._FOCUS_INTERVAL)};o.addEventListener("focus",inpFocusEh_1);o.focus()}};DirectiveCellFactory.prototype._initImeEditInput=function(t,r){var n=this,i=e.getActiveElement();if(i&&i instanceof HTMLInputElement&&e.hasClass(i,"wj-grid-ime")){var compEndEh_1=function(o){i.removeEventListener("compositionend",compEndEh_1);e.setCss(i,e.grid._ImeHandler._cssHidden);n._initEditInput(t,r,i.value)};i.addEventListener("compositionend",compEndEh_1);var o=this._findInitialInput(t);if(o){var a=o.getBoundingClientRect(),s=i.getBoundingClientRect(),l=window.getComputedStyle(i),c=parseFloat(l.left),u=parseFloat(l.top);e.setCss(i,{left:c+a.left-s.left+"px",top:u+a.top-s.top+"px",width:a.width+"px",height:a.height+"px"})}}};DirectiveCellFactory.prototype._findInitialInput=function(e){var t=e.clonedElement[0].querySelectorAll("input,textarea");if(t)for(var r=0;r<t.length;r++){var n=t[r],i=window.getComputedStyle(n);if("none"!==i.display&&"visible"===i.visibility)return n}return null};DirectiveCellFactory._setSelectionRange=function(t,r,n){void 0===n&&(n=r);if(e.contains(document.body,t)&&!t.disabled&&"none"!=t.style.display)try{t.setSelectionRange(e.asNumber(r),e.asNumber(n),e.isIE()?null:"backward");t.focus()}catch(e){}};DirectiveCellFactory._cellStampProp="__wjCellStamp";DirectiveCellFactory._FOCUS_INTERVAL=e.Control._FOCUS_INTERVAL+20;DirectiveCellFactory.isNgIE=!!document.documentMode;return DirectiveCellFactory}(e.grid.CellFactory),s=function(){function _RowHeightUpdateQueue(e){this._requests=[];this._timeOuts=[];this._cellFactory=e}_RowHeightUpdateQueue.prototype.add=function(e){this._requests.push(e)};_RowHeightUpdateQueue.prototype.execute=function(){for(var e=this._requests;e.length>0;){var t=this._requests.shift(),r=this,n=function(e){return setTimeout((function(){if(r._cellFactory._updateRowHeight(e.panel,e.cell,e.rng,e.cellStamp,e.templateContext))r.clear();else{var t=r._timeOuts.indexOf(n);t>-1&&r._timeOuts.splice(t,1)}}),0)}(t);this._timeOuts.push(n)}};_RowHeightUpdateQueue.prototype.clear=function(){this._requests.splice(0,this._requests.length);this._clearTimeouts()};_RowHeightUpdateQueue.prototype._clearTimeouts=function(){for(var e=this._timeOuts,t=0;t<e.length;t++)clearTimeout(e[t]);e.splice(0,e.length)};return _RowHeightUpdateQueue}();o||(window.wijmo.grid=null);var l=function(r){__extends(WjFlexGridColumn,r);function WjFlexGridColumn(e){var n=r.call(this)||this;n._$compile=e;n.scope.dataMap+="map";n.scope.dataType+="type";n.require="^wjFlexGrid";n.terminal=!0;if(t.WjDirective._dynaTemplates){n.transclude=!1;n.priority=100;n.template=function(e,t){t[WjFlexGridColumn._colTemplateProp]=e[0].innerHTML;return'<div class="wjGridColumn"/>'}}else{n.transclude=!0;n.template='<div class="wjGridColumn" ng-transclude/>'}return n}Object.defineProperty(WjFlexGridColumn.prototype,"_controlConstructor",{get:function(){return e.grid.Column},enumerable:!0,configurable:!0});WjFlexGridColumn.prototype._initControl=function(t){return new e.grid.Column};WjFlexGridColumn.prototype._createLink=function(){return new u};WjFlexGridColumn._colTemplateProp="$__wjColTemplate";WjFlexGridColumn._colWjLinkProp="$__wjLink";WjFlexGridColumn._cellCtxProp="$_cellCtxProp";return WjFlexGridColumn}(t.WjDirective);t.WjFlexGridColumn=l;var c,u=function(r){__extends(WjFlexGridColumnLink,r);function WjFlexGridColumnLink(){return null!==r&&r.apply(this,arguments)||this}WjFlexGridColumnLink.prototype._initParent=function(){var e=this.parent.control;if(e.autoGenerateColumns){e.autoGenerateColumns=!1;this._safeApply(this.scope,"autoGenerateColumns",!1);e.columns.clear()}r.prototype._initParent.call(this);var t=p._getTemplContextProp(c.Cell),n=this.control[t],i=this[l._cellCtxProp];!n&&i&&(this.control[t]=i);this.control[l._colWjLinkProp]=this};WjFlexGridColumnLink.prototype._link=function(){var n=this.tElement[0],i=this.tAttrs[l._colTemplateProp],o=null!=i?i:t.WjDirective._removeTransclude(n.innerHTML),a={};if(!e.isNullOrWhiteSpace(o)){var s=document.createElement("div");s.innerHTML=o;var c,u=[];[].forEach.call(s.children,(function(e){u.push(e)}));for(var h=0;h<u.length;h++){var d=u[h];if(d.tagName.toLocaleLowerCase()===p._tagName){c||(c=this.scope.$parent.$new());s.removeChild(d);n.appendChild(d);this.directive._$compile(d)(c)}}var C=s.innerHTML;e.isNullOrWhiteSpace(C)||(a.cellTemplate=C)}var f=this.tAttrs.ngStyle,m=this.tAttrs.ngClass;f&&(a.cellStyle=f);m&&(a.cellClass=m);if(a.cellTemplate||a.cellStyle||a.cellClass){a.templLink=this;this[l._cellCtxProp]=a}r.prototype._link.call(this)};return WjFlexGridColumnLink}(t.WjLink);!function(e){e[e.Cell=0]="Cell";e[e.CellEdit=1]="CellEdit";e[e.ColumnHeader=2]="ColumnHeader";e[e.RowHeader=3]="RowHeader";e[e.RowHeaderEdit=4]="RowHeaderEdit";e[e.TopLeft=5]="TopLeft";e[e.GroupHeader=6]="GroupHeader";e[e.Group=7]="Group";e[e.ColumnFooter=8]="ColumnFooter";e[e.BottomLeft=9]="BottomLeft"}(c=t.CellTemplateType||(t.CellTemplateType={}));var p=function(e){__extends(WjFlexGridCellTemplate,e);function WjFlexGridCellTemplate(){var r=e.call(this)||this;r.require=["?^wjFlexGridColumn","?^wjFlexGrid"];r.terminal=!0;if(t.WjDirective._dynaTemplates){r.transclude=!1;r.priority=100;r.template=function(e,t){t[l._colTemplateProp]=e[0].innerHTML;return"<div />"}}else{r.transclude=!0;r.template="<div ng-transclude/>"}return r}WjFlexGridCellTemplate._getTemplContextProp=function(e){return"$__cellTempl"+c[e]};WjFlexGridCellTemplate.prototype._initControl=function(e){return{}};WjFlexGridCellTemplate.prototype._createLink=function(){return new h};WjFlexGridCellTemplate.prototype._getMetaDataId=function(){return"FlexGridCellTemplate"};WjFlexGridCellTemplate._tagName="wj-flex-grid-cell-template";return WjFlexGridCellTemplate}(t.WjDirective);t.WjFlexGridCellTemplate=p;var h=function(r){__extends(WjFlexGridCellTemplateLink,r);function WjFlexGridCellTemplateLink(){return null!==r&&r.apply(this,arguments)||this}WjFlexGridCellTemplateLink.prototype._initParent=function(){r.prototype._initParent.call(this);var n,i=this.scope.cellType;if(i){n=c[i];var o=this.tAttrs[l._colTemplateProp],a=null!=o?o:t.WjDirective._removeTransclude(this.tElement[0].innerHTML),s=this.control;e.isNullOrWhiteSpace(a)||(s.cellTemplate=a);var u=this.tAttrs.ngStyle,h=this.tAttrs.ngClass;u&&(s.cellStyle=u);h&&(s.cellClass=h);this.tAttrs.forceFullEdit||(s.forceFullEdit=!0);var d=this.tAttrs.autoSizeRows;s.autoSizeRows=null==d||"true"===d;if(s.cellTemplate||s.cellStyle||s.cellClass){s.templLink=this;var C=this.parent.control;C[p._getTemplContextProp(n)]=s;C instanceof e.grid.Column&&C._setFlag(e.grid.RowColFlags.HasTemplate,!0)}WjFlexGridCellTemplateLink._invalidateGrid(this.parent.control)}};WjFlexGridCellTemplateLink.prototype._destroy=function(){var e=this.parent&&this.parent.control,t=this.scope.cellType;r.prototype._destroy.call(this);if(t){e[p._getTemplContextProp(c[t])]=void 0;WjFlexGridCellTemplateLink._invalidateGrid(e)}};WjFlexGridCellTemplateLink._invalidateGrid=function(t){var r=t;if(r){r instanceof e.grid.Column&&(r=r.grid);r&&r.invalidate()}};return WjFlexGridCellTemplateLink}(t.WjLink)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid.detail");t.softRefGridDetail()&&r.directive("wjFlexGridDetail",["$compile",function(e){return new n(e)}]);var n=function(r){__extends(WjFlexGridDetail,r);function WjFlexGridDetail(e){var n=r.call(this)||this;n._$compile=e;n.require="^wjFlexGrid";n.terminal=!0;if(t.WjDirective._dynaTemplates){n.transclude=!1;n.priority=100;n.template=function(e,t){t[WjFlexGridDetail._detailTemplateProp]=e[0].innerHTML;return"<div />"}}else{n.transclude=!0;n.template="<div ng-transclude/>"}return n}Object.defineProperty(WjFlexGridDetail.prototype,"_controlConstructor",{get:function(){return e.grid.detail.FlexGridDetailProvider},enumerable:!0,configurable:!0});WjFlexGridDetail.prototype._createLink=function(){return new i};WjFlexGridDetail._detailTemplateProp="$__wjDetailTemplate";WjFlexGridDetail._detailScopeProp="$_detailScope";return WjFlexGridDetail}(t.WjDirective);t.WjFlexGridDetail=n;var i=function(e){__extends(WjFlexGridDetailLink,e);function WjFlexGridDetailLink(){return null!==e&&e.apply(this,arguments)||this}WjFlexGridDetailLink.prototype._initParent=function(){e.prototype._initParent.call(this);var r=this,i=this.tAttrs[n._detailTemplateProp],o=this.control;this.itemTemplate=this._getCellTemplate(null!=i?i:t.WjDirective._removeTransclude(this.tElement[0].innerHTML));var a=this._getCellTemplate(this.itemTemplate);this._tmplLink=this.directive._$compile("<div>"+a+"</div>");o.createDetailCell=function(e,n){var i=r._getCellScope(r.scope.$parent,e,n),a=r._tmplLink(i,(function(e,t){}))[0];a[t.WjDirective._elemScopeProp]=i;o.grid.hostElement.appendChild(a);i.$root&&!i.$root.$$phase&&i.$apply();a.parentElement.removeChild(a);return a};o.disposeDetailCell=function(e){if(e.detail){var r=e.detail[t.WjDirective._elemScopeProp];r&&r.$destroy()}};this.parent._isInitialized&&this.control&&this.control.invalidate()};WjFlexGridDetailLink.prototype._destroy=function(){var t=this.parent&&this.parent.control,r=this.control;r.createDetailCell=null;r.disposeDetailCell=null;e.prototype._destroy.call(this);this._tmplLink=null;t&&t.invalidate()};WjFlexGridDetailLink.prototype._getCellScope=function(e,t,r){var n=e.$new();n.$row=t;n.$col=r;n.$item=t.dataItem;return n};WjFlexGridDetailLink.prototype._getCellTemplate=function(e){e&&(e=(e=(e=e.replace(/ng\-style/g,"style")).replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g,"")).replace(/<span>\s*<\/span>/g,""));return e};return WjFlexGridDetailLink}(t.WjLink)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid.filter");t.softRefGridFilter()&&r.directive("wjFlexGridFilter",[function(){return new n}]);var n=function(t){__extends(WjFlexGridFilter,t);function WjFlexGridFilter(){var e=t.call(this)||this;e.require="^wjFlexGrid";e.template="<div />";return e}Object.defineProperty(WjFlexGridFilter.prototype,"_controlConstructor",{get:function(){return e.grid.filter.FlexGridFilter},enumerable:!0,configurable:!0});return WjFlexGridFilter}(t.WjDirective);t.WjFlexGridFilter=n}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid.grouppanel");t.softRefGridGrouppanel()&&r.directive("wjGroupPanel",[function(){return new n}]);var n=function(t){__extends(WjGroupPanel,t);function WjGroupPanel(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjGroupPanel.prototype,"_controlConstructor",{get:function(){return e.grid.grouppanel.GroupPanel},enumerable:!0,configurable:!0});return WjGroupPanel}(t.WjDirective);t.WjGroupPanel=n}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid.multirow");t.softRefGridMultirow()&&r.directive("wjMultiRow",["$compile","$interpolate",function(e,t){return new n(e,t)}]);var n=function(t){__extends(WjMultiRow,t);function WjMultiRow(e,r){return t.call(this,e,r)||this}Object.defineProperty(WjMultiRow.prototype,"_controlConstructor",{get:function(){return e.grid.multirow.MultiRow},enumerable:!0,configurable:!0});return WjMultiRow}(t.WjFlexGrid);t.WjMultiRow=n}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.grid.sheet");if(t.softRefGridSheet()){r.directive("wjFlexSheet",["$compile","$interpolate",function(e,t){return new n(e,t)}]);r.directive("wjSheet",[function(){return new i}])}var n=function(t){__extends(WjFlexSheet,t);function WjFlexSheet(e,r){return t.call(this,e,r)||this}Object.defineProperty(WjFlexSheet.prototype,"_controlConstructor",{get:function(){return e.grid.sheet.FlexSheet},enumerable:!0,configurable:!0});return WjFlexSheet}(t.WjFlexGrid),i=function(t){__extends(WjSheet,t);function WjSheet(){var e=t.call(this)||this;e.require="^wjFlexSheet";return e}Object.defineProperty(WjSheet.prototype,"_controlConstructor",{get:function(){return e.grid.sheet.Sheet},enumerable:!0,configurable:!0});WjSheet.prototype._initControl=function(e){return t.prototype._initControl.call(this,void 0)};return WjSheet}(t.WjDirective)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular;var r=t._registerNgModule("wj.olap");if(t.softRefOlap()&&t.softRefOlap().PivotGrid){r.directive("wjPivotGrid",["$compile","$interpolate",function(e,t){return new n(e,t)}]);r.directive("wjPivotChart",[function(){return new i}]);r.directive("wjPivotPanel",[function(){return new o}]);r.directive("wjSlicer",[function(){return new a}])}var n=function(t){__extends(WjPivotGrid,t);function WjPivotGrid(e,r){return t.call(this,e,r)||this}Object.defineProperty(WjPivotGrid.prototype,"_controlConstructor",{get:function(){return e.olap.PivotGrid},enumerable:!0,configurable:!0});return WjPivotGrid}(t.WjFlexGrid);t.WjPivotGrid=n;var i=function(t){__extends(WjPivotChart,t);function WjPivotChart(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjPivotChart.prototype,"_controlConstructor",{get:function(){return e.olap.PivotChart},enumerable:!0,configurable:!0});return WjPivotChart}(t.WjDirective);t.WjPivotChart=i;var o=function(t){__extends(WjPivotPanel,t);function WjPivotPanel(){var e=t.call(this)||this;e.transclude=!0;e.template="<div ng-transclude />";return e}Object.defineProperty(WjPivotPanel.prototype,"_controlConstructor",{get:function(){return e.olap.PivotPanel},enumerable:!0,configurable:!0});return WjPivotPanel}(t.WjDirective);t.WjPivotPanel=o;var a=function(t){__extends(WjSlicer,t);function WjSlicer(){return null!==t&&t.apply(this,arguments)||this}Object.defineProperty(WjSlicer.prototype,"_controlConstructor",{get:function(){return e.olap.Slicer},enumerable:!0,configurable:!0});return WjSlicer}(t.WjDirective);t.WjSlicer=a}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));!function(e){!function(t){window.angular,t._registerNgModule("wj.viewer");var r=window.angular.module("wj.viewer",[]);t.softRefViewer()&&t.softRefViewer().ReportViewer&&r.directive("wjReportViewer",[function(){return new i}]);e.viewer&&e.viewer.PdfViewer&&r.directive("wjPdfViewer",[function(){return new o}]);var n=function(t){__extends(WjViewerBase,t);function WjViewerBase(){var e=t.call(this)||this;e.template="<div ng-transclude />";e.transclude=!0;return e}Object.defineProperty(WjViewerBase.prototype,"_controlConstructor",{get:function(){return e.viewer.ViewerBase},enumerable:!0,configurable:!0});return WjViewerBase}(t.WjDirective),i=function(t){__extends(WjReportViewer,t);function WjReportViewer(){return t.call(this)||this}Object.defineProperty(WjReportViewer.prototype,"_controlConstructor",{get:function(){return e.viewer.ReportViewer},enumerable:!0,configurable:!0});return WjReportViewer}(n),o=function(t){__extends(WjPdfViewer,t);function WjPdfViewer(){return t.call(this)||this}Object.defineProperty(WjPdfViewer.prototype,"_controlConstructor",{get:function(){return e.viewer.PdfViewer},enumerable:!0,configurable:!0});return WjPdfViewer}(n)}(e.angular||(e.angular={}))}(wijmo||(wijmo={}));window.angular.module("wj",wijmo.angular.getNgModules());
angular.module('fef', [
]);

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefColspan', FefColspan);
    /**
     * @ngdoc directive
     * @name fefColspan
     *
     * @param {expression} fefColspan The main argument is the value of the colspan you want to bind to.
     *
     * @description
     * Sets the colspan attribute on the attached element to the value of the evaluated main argument.
     * This is useful only in that it does not cause html validation errors, as would setting
     * colspan="{{interpolated expression}}" which would do the same thing.
     */
    function FefColspan() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    element.attr('colspan', scope.$eval(attrs.fefColspan));
                };
                scope.$watch(attrs.fefColspan, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefEnter', FefEnter);
    /**
     * @ngdoc directive
     * @name fefEnter
     *
     * @param {expression} fefEnter the main argument is an expression to evaluate.
     *
     * @description
     * Binds keydown events for key 13 (The enter key) to the evaluation of the
     * main argument as an expression on scope. Used in our directives, for
     * instance, to open/close a dropdown when the user presses enter.
     */
    function FefEnter() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var expression = attrs.fefEnter;
                element.on('keydown', function(event) {
                    if (event.which === 13) {
                        scope.$apply(function() {
                            scope.$eval(expression);
                        });
                        // Cancel any further event propegation
                        return false;
                    }
                    return true;
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFocusOnEvent', FefFocusOnEvent);

    FefFocusOnEvent.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFocusOnEvent
     * @requires fef.Utils
     * @param {expression} fefFocusOnEvent the main argument is an expression to evaluate.
     *
     * @directive
     * Directive to listen for an event on scope (specified as an argument)
     * and focus the element whenever the event fires. Does a $scope.$on on
     * the element's scope, given the main argument as the event name, and
     * gives the element focus when that event occurs. $broadcast that event
     * from the element's scope (or one of its parent scopes), or $emit it from
     * a child scope under the element, to cause the element to gain focus.
     */
    function FefFocusOnEvent(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var eventName = attrs.fefFocusOnEvent;
                var focused = false;
                if (!utils.exists(eventName)) {
                    throw new Error('fefFocusOnEvent requires an event argument');
                }

                scope.$on(eventName, function() {
                    focused = false;
                    element.bind('focus', function(event) {
                        focused = true;
                        element.unbind(event);
                    });

                    element.focus();

                    // If we are in a headless browser, focus() won't do anything. But we still want to fire the events.
                    // So, if the focus event hasn't yet been fired, do that here.
                    if (!focused) {
                        element.triggerHandler('focus');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFormatOnBlur', FefFormatOnBlur);

    FefFormatOnBlur.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFormatOnBlur
     * @requires ng.ngModel
     * @requires fef.Utils
     * @priority 10
     * @param {expression=} fef-format-on-blur-change an expression to evaluate at the time of the blur event
     *  if and only if a model change occurred between the previous focus event and the blur event.
     *
     * @description
     * Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     * a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     * Also, this directive filters ngChange events to just those in which the model value is valid, and upon blur -
     * remembers the initial value or the last valid value and restores that value if the model value is invalid at the
     * time of the blur. This behavior was included in this directive due to event timing difficulties in making them
     * separate directives.
     */
    function FefFormatOnBlur(utils) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            priority: 10,
            link: function postLink(scope, element, attrs, ctrl) {
                // optional onChange expression for ngChange at blur time
                var onChangeAtBlur = attrs.fefFormatOnBlurChange;

                // preserve the value at time of focus
                var originalValue;
                var originalInvalid;

                // this parser reverts the model value to the
                // original value at the time of focus if the current
                // value is invalid. This filters ng-change and model
                // value pushes from ngModel to only valid values (or the original
                // value prior to binding)
                ctrl.$parsers.push(function(input) {
                    if (ctrl.$invalid) {
                        return originalValue;
                    }
                    return input;
                });

                // when we receive focus, capture the current $viewValue
                element.bind('focus', function() {
                    originalValue = ctrl.$modelValue;
                    originalInvalid = ctrl.$invalid;
                });

                // when we lose focus, revert to old value if new value is invalid,
                // then reformat the view.
                element.bind('blur', function() {
                    var i;
                    scope.$digest(); // JEB: do we need this?

                    // re-run the formatter chain on the $modelValue
                    ctrl.$viewValue = ctrl.$modelValue;
                    for (i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                        ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                    }

                    // reset the validity
                    if (angular.isDefined(originalInvalid) && !originalInvalid) {
                        angular.forEach(ctrl.$error, function(p, k) {
                            ctrl.$setValidity(k, true);
                        });
                    }

                    // re-render the view
                    ctrl.$render();

                    // if there is an onChangeAtBlur expression specified
                    // and the original value doesn't equal the current value
                    // then evaluate the expression.
                    if (utils.exists(onChangeAtBlur) &&
                        !angular.equals(originalValue, ctrl.$modelValue)) {
                        scope.$apply(onChangeAtBlur);
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefMaxlength', FefMaxlength);

    FefMaxlength.$inject = ['fef.Utils']
        /**
         * @ngdoc directive
         * @name fefMaxlength
         * @requires fef.Utils
         * @param {expression} fefMaxlength the main argument is an expression which is evaluated to a
         *  number or string (containing an un-formatted number).
         *
         * @description
         * Unlike the angular directive (or argument to the ngInput directive),
         * this directive actually adds the "maxlength" attribute to the element.
         * To remove the attribute, the expression should evaluate to null,
         * undefined, or a blank string.
         */
    function FefMaxlength(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    var value = scope.$eval(attrs.fefMaxlength);
                    if (utils.exists(value)) {
                        value = value.toString();
                    }
                    if (utils.stringIsNonBlank(value)) {
                        element.attr('maxlength', scope.$eval(attrs.fefMaxlength).toString());
                    } else {
                        element.removeAttr('maxlength');
                    }
                };
                scope.$watch(attrs.fefMaxlength, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefTabStop', FefTabStop);

    FefTabStop.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefTabStop
     * @restrict A
     * @requires fef.Utils
     *
     * @param {expression} fefTabStop The main argument is the expression to evaluate,
     * which should evaluate to a truthy or falsy value.
     *
     * @description
     * This directive is a simple on/off switch for tab-stop. If expression evaluates to truthy, then the tabindex
     * attribute is removed from the element. If it evaluates to falsy, then the tabindex attribute is added to the
     * element with a value of -1 (i.e. the element is skipped). This directive assumes you are using the browser
     * to determine tab-order automatically.
     */
    function FefTabStop(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                scope.$watch(attrs.fefTabStop, function(value) {
                    var result = utils.toBoolean(value);

                    if (result) {
                        attrs.$set('tabindex', undefined);
                    } else {
                        attrs.$set('tabindex', '-1');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name <%= _.camelize(appname) %>.filter:<%= _.camelize(name) %>
     * @function
     * @description
     * # <%= _.camelize(name) %>
     * Filter in the <%= _.camelize(appname) %>.
     */
    angular.module('fef')
        .filter('fefMaxchars', FefMaxchars);

    function FefMaxchars() {
        var filter = function(input, numMaxChars) {
            var numMaxCharsInt = parseInt(numMaxChars, 10);
            if (input.length > numMaxCharsInt) {
                return input.substr(0, numMaxCharsInt) + '...';
            } else {
                return input;
            }
        };
        return function(input, numMaxChars) {
            return filter(input, numMaxChars);
        };
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name fefOrElse
     *
     * @param {string} fefOrElse The main argument is a fallback value to use if the input is null or
     * undefined.
     *
     * @description:
     * Will return input, unless input is undefined or null, in which case
     * the argument (the fallback value) is returned.
     *
     * @example
       <example>
         <file name="index.html">
           <input data-ng-model="value" data-ng-init="value = null" /><br />
           <h1>value with filter: {{value | fefOrElse:'default value'}}</h1>
         </file>
       </example>
       <h1>{{data.name | fefOrElse:'Unknown'}}</h1>
     */
    angular.module('fef')
        .filter('fefOrElse', FefOrElse);

    function FefOrElse() {
        var filter = function(input, fallBackValue) {
            if (typeof input === 'undefined' || input === null) {
                return fallBackValue;
            } else {
                return input;
            }
        };
        return function(input, fallBackValue) {
            return filter(input, fallBackValue);
        };
    }
}());
(function () {
    'use strict';

    angular.module('fef')
        .service('fef.dataBindingUtils', DataBindingUtils);
    DataBindingUtils.$inject = ['$parse'];
    function DataBindingUtils ($parse) {
        this.makeOnChangeFuncWithHistory = function (scope, expression, listener) {
            var oldValue;
            var expressionFunc = $parse(expression);
            var updateOldValue = function() {
                oldValue = angular.copy(expressionFunc(scope));
            };

            updateOldValue();

            scope.$watch(expression, function(_oldValue, _newValue) {
                if (!angular.equals(_oldValue, _newValue)) {
                    updateOldValue();
                }
            });

            return function() {
                try {
                    listener(expressionFunc(scope), oldValue);
                } finally {
                    updateOldValue();
                }
            };
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('DeprecatedNoticeService', DeprecatedNoticeService);
    DeprecatedNoticeService.$inject = [];

    function DeprecatedNoticeService() {
        this.notify = function(deprecatedComponent, replacementComponent) {
            return 'The ' + deprecatedComponent +
                ' has been deprecated. Please use the ' +
                replacementComponent +
                ' directive available in the Bento Modern' +
                'Toolset: http://modern.centralux.int.thomsonreuters.com:8888';

        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.EmailService', EmailService);
    EmailService.$inject = [];

    function EmailService() {
        this.validate = function(email) {
            var emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!email) { //test for empty
                return 'Email cannot be empty.';
            } else if (!emailTest.test(email)) //test for valid format
            {
                return 'Email format is not valid.';
            } else {
                return true;
            }

        };
    }

}());

(function () {
	'use strict';
	angular.module('fef')
		.provider('fefLog', FefLogProvider);

	function FefLogProvider() {
		var _$log;

		var levels = ['none', 'error', 'warn', 'info', 'log', 'debug'];
		var baseConfig = {
			rootname : 'fef',
			consoleThreshold: 4,
			consoleTimestamp: false,
			httpThreshold: 1,
			httpPath: null,
			httpAuthorization: null,
			delay: 250
		};
		var rootGuid = trmrguid();
		var namedConfigs = {};
		var $window, $location;

		function setInit(_window, _location, _log) {
			$window = _window;
			$location = _location;
			_$log = _$log || _log
		}

		function thresholdFromString(value) {
			var i;
			for (i = 0; i < levels.length; i++) {
				if (levels[i] == value.toLowerCase()) {
					return i;
				}
			}

			return -1;
		}

		function validateConfig(config) {
			if (typeof config.consoleThreshold == 'string') {
				config.consoleThreshold = thresholdFromString(config.consoleThreshold);
			}
			if (typeof config.consoleThreshold != 'number' || config.consoleThreshold < 0 || config.consoleThreshold > 5) {
				config.consoleThreshold = 4;
			}

			if (typeof config.httpThreshold == 'string') {
				config.httpThreshold = thresholdFromString(config.httpThreshold);
			}
			if (typeof config.httpThreshold != 'number' || config.httpThreshold < 0 || config.httpThreshold > 5) {
				config.httpThreshold = 1;
			}
		}
		// won't allow new properties tp pollute config object
		function extendConfig(base, extended) {
			var keys = Object.keys(base);
			angular.forEach(keys, function (item) {
				// check for undefined explicitly so 0 and false will work
				if (extended[item] !== undefined) {
					base[item] = extended[item];
				}
			});
		}
		function configure(newConfig, name) {
			var cfg, key;

			if (!angular.isUndefined(newConfig)) {
				if (name && name.length) {
					key = ([baseConfig.rootname].concat(name)).join(':');
					cfg = namedConfigs[key];
					if (!cfg) {
						cfg = namedConfigs[key] = {
							consoleThreshold: baseConfig.consoleThreshold,
							httpThreshold: baseConfig.httpThreshold
						};
					}

					if (newConfig === null) {
						delete namedConfigs[key];
						cfg = baseConfig;
					} else {
						// will only override consoleThreshold & httpThreshold
						extendConfig(cfg, newConfig);
						validateConfig(cfg);
					}

					// return clone of configuration object
					return angular.extend({}, baseConfig, cfg);

				} else {
					extendConfig(baseConfig, newConfig);
					validateConfig(baseConfig);
				}
			}

			// return clone of configuration object
			return angular.extend({}, baseConfig);
		}

		/*jshint bitwise: true*/
		function trmrguid() {
			return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}

		function generatePageGuid($http, pagename) {
			rootGuid = trmrguid();
			$http.defaults.headers.common['x-cobalt-pcid'] = rootGuid;

			var data = createLogData(baseConfig.rootname);
			data.level = 'page';
			data.pageName = (typeof pagename == 'string' ? pagename : 'UNKNOWN');
			logHttp(data);
		}

		var logBuffer = [];
		function logHttp(logData) {
			if (baseConfig.httpPath) {
				if (logBuffer.length == 0) {
				//*** DO NOT COPY THE PATTERN BELOW
					// use setTimeout/XMLHttpRequest instead of $timeout/$http to avoid circular exceptions/errors
					setTimeout(function () {
						var logRequest = new XMLHttpRequest();
						logRequest.open('POST', baseConfig.httpPath);
						logRequest.setRequestHeader('x-cobalt-pcid', rootGuid);
						logRequest.setRequestHeader('Content-Type', 'application/json'); // ;charset=UTF-8
						if (baseConfig.httpAuthorization) {
							logRequest.setRequestHeader('Authorization', baseConfig.httpAuthorization);
						}
						logRequest.send(JSON.stringify({version: '0.1', items: logBuffer}));

						logBuffer = [];
					}, baseConfig.delay);
				//***
				}
				logBuffer.push(logData);
			}
		}

		function createLogData (name) {
			var timestamp = (new Date()).toISOString();

			var data = {
				root: rootGuid,
				name: name,
				timestamp: timestamp
			};
			if ($location) {
				data['url'] = $location.absUrl();
			}

			return data;
		}

		// from angular.js source code
		function formatError(arg) {
			if (arg instanceof Error) {
				if (arg.stack) {
					arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
						? 'Error: ' + arg.message + '\n' + arg.stack
						: arg.stack;
				} else if (arg.sourceURL) {
					arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
				}
			}
			return arg;
		}

		function executeLogFn(args, logFn, level, name) {
			name = ([baseConfig.rootname].concat(name)).join(':');
			var logData = createLogData(name);
			var cfg = namedConfigs[name] || baseConfig;
			var timestamp = '';

			// HTTP logging
			if (baseConfig.httpPath && level <= cfg.httpThreshold) {
				var i, messages = [];
				for (i = 0; i < args.length; i++) {
					messages.push(args[i].toString());
				}

				logData.level = levels[level];
				logData.messages = messages;

				if (args[0] instanceof Error && $window.printStackTrace) {
					// requires stacktrace.js
					//logData['stacktrace'] = $window.printStackTrace({e: args[0]});
				}

				if (args[0] instanceof Error) {
					if (args[0].stack) {
						logData['stacktrace'] = formatError(args[0]);
					}
				}

				logHttp(logData);
			}

			// console logging
			if (level <= cfg.consoleThreshold) {

				// prepend an ISO timestamp and logger to the original log message
				if (cfg.consoleTimestamp) {
					timestamp = logData.timestamp + ' ';
				}
				if (angular.isString(args[0])) {
					args[0] = timestamp + '[' + name + '] ' + args[0];
				} else {
					args.unshift(timestamp + '[' + name + '] ');
				}

				logFn.apply(null, args);
			}
		}

		/**
		 * Wrap original log function
		 */
		function wrapLogFn(logFn, level, name) {
			var wrappedLogFn = function () {
				var args = Array.prototype.slice.call(arguments);
				return executeLogFn(args, logFn, level, name || ['$log']);
			};

			// support angular-mocks which assumes log messages captured in an array
			// https://github.com/angular/bower-angular-mocks/blob/master/angular-mocks.js
			wrappedLogFn.logs = [ ];

			return wrappedLogFn;
		}

		/**
		 * Generate name-specific logger instance
		 */
		function getLogger() {
			var name = Array.prototype.slice.call(arguments) || [];

			return {
				log: wrapLogFn(_$log.log, 4, name),
				info: wrapLogFn(_$log.info, 3, name),
				warn: wrapLogFn(_$log.warn, 2, name),
				debug: wrapLogFn(_$log.debug, 5, name),
				error: wrapLogFn(_$log.error, 1, name)
			};
		}

		this.enhance$log = function ($log, moduleName) {
			// capture the original functions of $log
			_$log = (function ($log) {
				return {
					log: $log.log,
					info: $log.info,
					warn: $log.warn,
					debug: $log.debug,
					error: $log.error
				};
			})($log);

			$log.debug = wrapLogFn($log.debug, 5);
			$log.log = wrapLogFn($log.log, 4);
			$log.info = wrapLogFn($log.info, 3);
			$log.warn = wrapLogFn($log.warn, 2);
			$log.error = wrapLogFn($log.error, 1);

			return $log;
		};

		this.$get = ['$window','$location', '$http', '$log', function ($window, $location, $http, $log) {
			var fefLog = {};

			setInit($window, $location, $log);

			fefLog.configure = configure;

			fefLog.getLogger = getLogger;

			fefLog.pageguid = function (pagename) {
				if (pagename) {
					generatePageGuid($http, pagename);
				}

				return rootGuid;
			};
/*
	// FUTURE usage concept - need to design a well behaved promise based API
			fefLog.component = function (options, promise) {
				var then = Date.now();
				var data = createLogData(baseConfig.rootname);
				delete data.url;
				data.componentName = options.name;
				data.level = 'component';
				return promise.then(function(result) {
					data.duration = (Date.now() - then);
					logHttp(data);
					return result;
				}, function(reason) {
					data.duration = (Date.now() - then);
					data.error = 1;
					logHttp(data);
					return reason;
				});
			};
*/
			return fefLog;
		}];
	}
})();
(function() {
    'use strict';
    angular.module('fef')
        .provider('fefLogger', FefLogProvider);
    function FefLogProvider() {
        var config = {
            consoleThreshold: 4,
            httpThreshold: 1,
            httpDomain: undefined,
            httpPath: '/demo/logs',
            delay: 250
        };
        var resource;

        var rootname = 'fef';
        var rootGuid = trmrguid();
        var $window, $location;

        function setInit(_window, _location) {
            $window = _window;
            $location = _location;
        }
        function formatError(arg, name) {
            if (arg instanceof Error) {
                if (arg.stack) {
                    arg = (arg.message && arg.stack.indexOf(arg.message) === -1) ? 'Error: ' + 
                    arg.message + '\n' + arg.stack : arg.stack;
                } else if (arg.sourceURL) {
                    arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
                }
            }
            return '[' + name+ '] ' + arg;
        }

        function consoleLog(type, parent, name) {
            var console = $window.console || {},
                logFn = console[type] || console.log || angular.noop;
            if (logFn.apply) {
                var args = [];
                angular.forEach(parent, function(arg) {
                    args.push(formatError(arg, name));
                });
                logFn.apply(console, args);
            }
        }

        function configure(_conf) {
            if (!_conf.consoleThreshold || !(_conf.consoleThreshold >= 1 && _conf.consoleThreshold <= 5)) {
                _conf.consoleThreshold = 4;
            }
            if (!_conf.httpThreshold || !(_conf.httpThreshold >= 1 && _conf.httpThreshold <= 5)) {
                _conf.httpThreshold = 1;
            }
            var keys = Object.keys(config);
            angular.forEach(keys, function (item) {
                if(_conf[item]){
                    config[item] = _conf[item];
                }
                
            });
        }

        function setResource(_resouce) {
            resource = _resouce;
        }

        function formatMessage(_type, level, name) {
                return function () {
                    var timestamp = (new Date()).toISOString();
                    var module = rootname;
                    if (name) {
                        module = module + ':' + name;
                    }
                    var log = {
                        root: rootGuid,
                        timestamp: timestamp,
                        message: [].slice.call(arguments) || '',
                        level: _type,
                        url: $location.absUrl(),
                        name: module
                    };
                    if (arguments[0] instanceof Error && window.printStackTrace) {
                        log.stacktrace = window.printStackTrace({
                            e: arguments[0]
                        });
                    }
                    if (config.httpPath && level <= config.httpThreshold) {
                        resource.save(log);
                    }
                    if (level <= config.consoleThreshold) {
                        switch (level) {
                        case 5:
                            consoleLog('debug',arguments, module);
                            break;
                        case 4:
                            consoleLog('log',arguments, module);
                            break;
                        case 3:
                            consoleLog('info',arguments, module);
                            break;
                        case 2:
                            consoleLog('warn',arguments, module);
                            break;
                        case 1:
                            consoleLog('error',arguments, module);
                            break;
                        }

                    }

                };
            }
            /*jshint bitwise: true*/
        function trmrguid() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        return {
            configure: configure,
            $get: ['$resource', '$location', '$window', function($resource, $location,$window) {
                var urlPath = config.httpPath;
                if(config.httpDomain){
                    urlPath = 'http://' + config.httpDomain + urlPath;
                }
                var WS = $resource(urlPath,
                    null, {
                        save: {
                            method: 'POST',
                            headers: {
                                common: {
                                    'x-cobalt-pcid': trmrguid()
                                }
                            }
                        }
                    });
                setResource(WS);
                setInit($window, $location);
                return {
                    debug: formatMessage('debug', 5),
                    log: formatMessage('log', 4),
                    info: formatMessage('info', 3),
                    warn: formatMessage('warn', 2),
                    error: formatMessage('error', 1),
                    getLogger: function(value) {
                        if (arguments.length > 1) {
                            var temp = Array.apply(null, arguments);
                            value = temp.join(':');
                        }
                        return {
                            debug: formatMessage('debug', 5, value),
                            log: formatMessage('log', 4,value),
                            info: formatMessage('info', 3, value),
                            warn: formatMessage('warn', 2, value),
                            error: formatMessage('error', 1, value)
                        };
                    }

                };
            }]
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.PromiseUtils', PromiseUtils);
    PromiseUtils.$inject = ['$q', '$timeout', 'fef.Utils'];

    function Throttler($q, $timeout, utils, invokeFunc, throttleDelay) {
        /// <summary>[Private] Internal implementation of fef.PromiseUtils.throttle</summary>
        /// <param name="$q" type="$q"></param>
        /// <param name="throttleDelay" type="Number"></param>
        /// <param name="invokeFunc" type="Function"></param>

        this._counter = 0;
        this.invoke = function(arg) {
            /// <signature>
            /// <summary>Kicks off the throttled action after the specified delay,
            /// but only if another invoke is not called again prior to the end of the delay.</summary>
            /// <returns type="Promise">A promise that is resolved if the invokeFunc is executed
            /// as a result of THIS invoke, else rejected if another invoke call cancels this one</returns>
            /// </signature>
            var self = this;
            var _deferred = $q.defer();
            if (!utils.exists(throttleDelay) || throttleDelay === 0) {
                invokeFunc(arg);
                _deferred.resolve({});
            } else {
                // works best for throttleDelays large enough to eliminate
                // the possibility of Number overflow.
                var _curCounter = self._counter + 1;
                this._counter = _curCounter;
                $timeout(function() {
                    if (_curCounter === self._counter) {
                        invokeFunc(arg);
                        _deferred.resolve({});
                    } else {
                        _deferred.reject({});
                    }
                }, throttleDelay);
            }
            return _deferred.promise;
        };
    }

    function PromiseUtils($q, $timeout, utils) {
        /// <param name="$q" type="$q" />

        this.parseRetryInfoJSON = function(statusCode, retryInfoJSON) {
            /// <signature>
            /// <summary>Utility to parse retry information from JSON in a common
            ///  format. </summary>
            /// <param name="statusCode" type="number" />
            /// <param name="retryInfoJSON" type="String" />
            /// <returns type="Object">The parsed retry information</returns>
            /// </signature>
            var ret = {
                retry: utils.exists(statusCode) && (statusCode === '503' || statusCode === 503)
            };

            if (utils.stringIsNonBlank(retryInfoJSON)) {
                try {
                    var body = JSON.parse(retryInfoJSON);
                    if (utils.exists(body)) {
                        if (utils.exists(body.retry)) {
                            ret.retry = (body.retry ? true : false) || ret.retry;
                        }
                        if (angular.isNumber(body.retryInMs)) {
                            ret.retryInMs = body.retryInMs;
                        }
                    }
                } catch (e) {
                    ret = null;
                }
            }
            return ret;
        };

        this.throttle = function(invokeFunc, throttleDelay) {
            /// <signature>
            /// <summary>Creates a Throttler object with an invoke function which
            /// you can call multiple times (e.g. in response to an ngChange event).
            /// The invokeFunc you pass in will be called, but only after throttleDelay,
            /// and only if no other invoke call is made within that time. Use this to,
            /// for instance, throttle live search requests or auto-fill services.
            /// </summary>
            /// <param name="invokeFunc" type="Function">The function to be executed.</param>
            /// <param name="throttleDelay" type="number">The amount of time in ms to wait before
            /// calling invokeFunc.</param>
            /// <returns type="fef.Throttler">An object with an invoke function which can be
            ///  called multiple times within throttleDelay, but results in only one call of
            ///  invokeFunc for that time window.</returns>
            /// </signature>

            return new Throttler($q, $timeout, utils, invokeFunc, throttleDelay);
        };

        this.resolvedPromise = function(value, delay) {
            /// <signature>
            /// <summary>Utility to get a resolved promise, optionally after
            ///   delay.</summary>
            /// <param name="value" type="Object">The value to resolve with.</param>
            /// <param name="delay" type="number" optional="true">Optional delay, in ms. If
            ///  no delay given, the returned promise will be resolved immediately.</param>
            /// <returns type="Promise">A Promise that will resolve with the exact
            ///  value you specify. If you specify a delay, the promise will be resolved
            ///  asynchronously after the delay you specify, in ms.</returns>
            /// </signature>
            var _resolvedPromiseImpl = function(_value) {
                var d = $q.defer();
                d.resolve(_value);
                return d.promise;
            };

            if (!utils.exists(delay)) {
                return _resolvedPromiseImpl(value);
            } else {
                return $timeout(function() {}, delay).then(function() {
                    return _resolvedPromiseImpl(value);
                });
            }
        };

        this.retry = function(retryFunc, retryCount, promise, parseRetryFunc) {
            /// <signature>
            /// <summary>Utility to attempt an action, and retry that action up to retryCount times
            ///  if unsuccessful.</summary>
            /// <param name="retryFunc" type="Function">A function which returns a promise. This
            ///  function will be called once initially, if you don't specify an initial promise,
            ///  and once afterward for each retry attempt.</param>
            /// <param name="retryCount" type="number">The number of times to retry the retryFunc.</param>
            /// <param name="promise" type="Promise">If you have an existing promise you'd like
            ///  to retry, pass it along here. Otherwise, pass null and retryFunc will be
            ///  called once to create the initial promise. </param>
            /// <param name="parseRetryFunc(error_Object)" type="Function">A function taking a single
            ///  argument (the error value of the promise) and returns a normalized retry info object,
            ///  used to determine whether to retry or not.</param>
            /// <returns type="Promise">A promise that resolves with the value of the original promise,
            ///  if successful after the retry attempts, else it returns the error result of the last
            ///  retry attempt promise.</returns>
            /// </signature>
            var self = this;

            // default retryCount to 2
            if (!utils.exists(retryCount) || !angular.isNumber(retryCount)) {
                retryCount = 2;
            }

            // create the promise if it doesn't exist already. This makes
            // it so the calling code can pass an anonymous function for
            // retryFunc, which is convenient.
            if (!utils.exists(promise)) {
                promise = retryFunc();
            }

            // use a reasonable default retry info parser
            if (!utils.exists(parseRetryFunc)) {
                parseRetryFunc = function(value) {
                    if (angular.isString(value)) {
                        return self.parseRetryInfoJSON(value);
                    } else {
                        return value;
                    }
                };
            }

            // if we have no more retries, then we'll return the original promise
            var ret = promise;
            if (retryCount > 0) {
                // we have some retries left, so intercept errors and retry if
                // the error indicates the request can be retried.
                ret = ret.then(null, function(error) {
                    var retryInfo = parseRetryFunc(error);
                    if (utils.exists(retryInfo)) {
                        // error response indicates we should attempt to retry
                        if (utils.exists(retryInfo.retryInMs) && typeof retryInfo.retryInMs === 'number') {
                            // delay the retry by the amount specified in the error response
                            return $timeout(function() {}, retryInfo.retryInMs).then(
                                function() {
                                    return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                                });
                        } else {
                            // no explicit retry time specified in the response, so retry immediately
                            return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                        }
                    } else {
                        // assume not a retryable error, throw it again.
                        return $q.reject(error);
                    }
                });
            } // else, we return the promise directly.
            return ret;
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.SanityChecks', SanityChecks);
    SanityChecks.$inject = [];

    function SanityChecks() {
        /**
         * @ngdoc method
         * @name fef.SanityChecks#checkConstructorUsage
         * @description Throws an error if the constructor function was called without
         * the new keyword. This could lead to inadvertently assigning global variables.
         *
         * @param {Object} _this Pass 'this' from the constructor function.
         * @param {function} constructor Pass a reference to the constructor function.
         */
        this.checkConstructorUsage = function(_this, constructor) {
            if (!(_this instanceof constructor)) {
                throw new Error('Constructor called as a function');
            }
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.Utils', Utils);
    Utils.$inject = [];

    function Utils() {
        var self = this;
        this.guid = function() {
            /// <summary>Creates a random guid string</summary>
            /// <returns type='String' />
            var s4 = function() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            };
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };

        this.exists = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is defined and non-null.</summary>
            /// <param name='value' type='Object' />
            /// <returns type='Boolean'>True, if value is defined and non-null.
            ///  False otherwise.</returns>
            /// </signature>
            return typeof value !== 'undefined' && value !== null;
        };

        // TODO: stringIsNonBlank and stringReplaceAll - should we move these to a new StringUtils service?

        this.stringIsNonBlank = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is a defined and non-null string
            /// with non-zero length.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'>True, if value is defined and non-null and a string
            /// of length greater than zero. False otherwise.</returns>
            /// </signature>
            return typeof value === 'string' && value.length > 0;
        };

        this.stringReplaceAll = function(sourceString, find, replace) {
            /// <signature>
            /// <summary>This is a global replace all within a string. Use this in
            /// place of the built-in function on strings when you want to replace all
            /// instances instead of the first one.</summary>
            /// <param name='sourceString' type='String'>The source string you want to work on.</param>
            /// <param name='find' type='String'>The substring to replace from sourceString.</param>
            /// <param name='replace' type='String'>The string to replace find with.</param>
            /// </signature>
            if (!self.exists(sourceString) || !self.exists(find) || !self.exists(replace)) {
                throw new Error('fef.Utils.stringReplaceAll: invalid argument(s)');
            }
            return sourceString.replace(new RegExp(find, 'g'), replace);
        };

        this.toBoolean = function(value) {
            /// <signature>
            /// <summary>Very lenient string-to-boolean converter.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'></returns>
            /// </signature>
            if (value && value.length !== 0) {
                var v = ('' + value).toLowerCase();
                value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
            } else {
                value = false;
            }
            return value;
        };

        this.nonEmptyStrings = function(array) {
            /// <summary>Creates a new array of strings from an existing array by filtering
            ///  out all null, undefined, empty string, and non-string values from the
            ///  original array.</summary>
            /// <param name='array' type='Array'>The original array.</param>
            /// <returns type='Array'>A new Array.</returns>

            return array.filter(this.stringIsNonBlank);
        };

        this.joinNonEmptyStrings = function(prefix, separator, args) {
            /// <summary>Creates a string out of an array of strings by first filtering out
            ///  the empty and non-string values of the original array, and if there are
            ///  any remaining strings in the array, prefixes the result with the specified
            ///  prefix, followed by the join of the remaining non-empty strings using
            ///  the specified separator. If no strings are left after filtering, an empty
            ///  string is returned.</summary>
            /// <param name='prefix' type='String'>The desired prefix of the result.</param>
            /// <param name='separator' type='String'>The desired separator to use when joining the
            ///  remaining non-empty strings after the prefix.</param>
            /// <param name='args' type='Array'>The original array.</param>
            /// <returns type='String'>A new string.</returns>
            var ret = '';
            if (!this.exists(prefix) || !this.exists(separator) || !this.exists(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: arguments must not be null.';
            }
            if (!angular.isString(prefix) || !angular.isString(separator)) {
                throw 'fef.Utils.joinNonEmptyStrings: prefix and separator arguments must be strings.';
            }
            if (!angular.isArray(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: args must be an array.';
            }
            var filtered = this.nonEmptyStrings(args);
            if (filtered.length > 0) {
                ret = prefix + filtered.join(separator);
            }
            return ret;
        };
    }

}());

/*!
 * angular-translate - v2.18.4 - 2021-01-14
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translatePartialLoaderProvider
 *
 * @description
 * By using a $translatePartialLoaderProvider you can configure a list of a needed
 * translation parts directly during the configuration phase of your application's
 * lifetime. All parts you add by using this provider would be loaded by
 * angular-translate at the startup as soon as possible.
 */
  .provider('$translatePartialLoader', $translatePartialLoader);

function $translatePartialLoader() {

  'use strict';

  /**
   * @constructor
   * @name Part
   *
   * @description
   * Represents Part object to add and set parts at runtime.
   */
  function Part(name, priority, urlTemplate) {
    this.name = name;
    this.isActive = true;
    this.tables = {};
    this.priority = priority || 0;
    this.langPromises = {};
    this.urlTemplate = urlTemplate;
  }

  /**
   * @name parseUrl
   * @method
   *
   * @description
   * Returns a parsed url template string and replaces given target lang
   * and part name it.
   *
   * @param {string|function} urlTemplate - Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   * @param {string} targetLang - Language key for language to be used.
   * @return {string} Parsed url template string
   */
  Part.prototype.parseUrl = function (urlTemplate, targetLang) {
    if (angular.isFunction(urlTemplate)) {
      return urlTemplate(this.name, targetLang);
    }
    return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
  };

  Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

    //locals
    var self = this;
    var lastLangPromise = this.langPromises[lang];
    var deferred = $q.defer();

    //private helper helpers
    var fetchData = function () {
      return $http(
        angular.extend({
            method : 'GET',
            url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
          },
          $httpOptions)
      );
    };

    //private helper
    var handleNewData = function (data) {
      self.tables[lang] = data;
      deferred.resolve(data);
    };

    //private helper
    var rejectDeferredWithPartName = function () {
      deferred.reject(self.name);
    };

    //private helper
    var tryGettingThisTable = function () {
      //data fetching logic
      fetchData().then(
        function (result) {
          handleNewData(result.data);
        },
        function (errorResponse) {
          if (errorHandler) {
            errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
          } else {
            rejectDeferredWithPartName();
          }
        });
    };

    //loading logic
    if (!this.tables[lang]) {
      //let's try loading the data
      if (!lastLangPromise) {
        //this is the first request - just go ahead and hit the server
        tryGettingThisTable();
      } else {
        //this is an additional request after one or more unfinished or failed requests
        //chain the deferred off the previous request's promise so that this request conditionally executes
        //if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
        lastLangPromise.then(deferred.resolve, tryGettingThisTable);
      }
      //retain a reference to the last promise so we can continue the chain if another request is made before any succeed
      //you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
      this.langPromises[lang] = deferred.promise;
    }
    else {
      //the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
      //this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
      deferred.resolve(this.tables[lang]);
    }
    return deferred.promise;
  };

  var parts = {};

  function hasPart(name) {
    return Object.prototype.hasOwnProperty.call(parts, name);
  }

  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  function isPartAvailable(name) {
    if (!isStringValid(name)) {
      throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
    }

    return (hasPart(name) && parts[name].isActive);
  }

  function deepExtend(dst, src) {
    for (var property in src) {
      if (src[property] && src[property].constructor &&
        src[property].constructor === Object) {
        dst[property] = dst[property] || {};
        deepExtend(dst[property], src[property]);
      } else {
        dst[property] = src[property];
      }
    }
    return dst;
  }

  function getPrioritizedParts() {
    var prioritizedParts = [];
    for (var part in parts) {
      if (parts[part].isActive) {
        prioritizedParts.push(parts[part]);
      }
    }
    prioritizedParts.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return prioritizedParts;
  }


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Registers a new part of the translation table to be loaded once the
   * `angular-translate` gets into runtime phase. It does not actually load any
   * translation data, but only registers a part to be loaded in the future.
   *
   * @param {string} name A name of the part to add
   * @param {int} [priority=0] Sets the load priority of this part.
   * @param {string|function} urlTemplate Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param
   * of the wrong type. Please, note that the `name` param has to be a
   * non-empty **string**.
   */
  this.addPart = function (name, priority, urlTemplate) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t add part, part name has to be a string!');
    }

    if (!hasPart(name)) {
      parts[name] = new Part(name, priority, urlTemplate);
    }
    parts[name].isActive = true;

    return this;
  };

  /**
   * @ngdocs function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Sets a translation table to the specified part. This method does not make the
   * specified part available, but only avoids loading this part from the server.
   *
   * @param {string} lang A language of the given translation table
   * @param {string} part A name of the target part
   * @param {object} table A translation table to set to the specified part
   *
   * @return {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass params
   * of the wrong type. Please, note that the `lang` and `part` params have to be a
   * non-empty **string**s and the `table` param has to be an object.
   */
  this.setPart = function (lang, part, table) {
    if (!isStringValid(lang)) {
      throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
    }
    if (!isStringValid(part)) {
      throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
    }
    if (typeof table !== 'object' || table === null) {
      throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
    }

    if (!hasPart(part)) {
      parts[part] = new Part(part);
      parts[part].isActive = false;
    }

    parts[part].tables[lang] = table;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Removes the previously added part of the translation data. So, `angular-translate` will not
   * load it at the startup.
   *
   * @param {string} name A name of the part to delete
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.deletePart = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t delete part, first arg has to be string.');
    }

    if (hasPart(name)) {
      parts[name].isActive = false;
    }

    return this;
  };


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Checks if the specific part is available. A part becomes available after it was added by the
   * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
   * asks the loader to that.
   *
   * @param {string} name A name of the part to check
   *
   * @returns {boolean} Returns **true** if the part is available now and **false** if not.
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.isPartAvailable = isPartAvailable;

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translatePartialLoader
   *
   * @requires $q
   * @requires $http
   * @requires $injector
   * @requires $rootScope
   * @requires $translate
   *
   * @description
   *
   * @param {object} options Options object
   *
   * @throws {TypeError}
   */
  this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
    function ($rootScope, $injector, $q, $http, $log) {

      /**
       * @ngdoc event
       * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
       * @eventOf pascalprecht.translate.$translatePartialLoader
       * @eventType broadcast on root scope
       *
       * @description
       * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
       * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
       * you get this event the translation table is not longer current and has to be updated.
       *
       * @param {string} name A name of the part which is a reason why the event was fired
       */

      var service = function (options) {
        if (!isStringValid(options.key)) {
          throw new TypeError('Unable to load data, a key is not a non-empty string.');
        }

        if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
          throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
        }

        var errorHandler = options.loadFailureHandler;
        if (errorHandler !== undefined) {
          if (!angular.isString(errorHandler)) {
            throw new Error('Unable to load data, a loadFailureHandler is not a string.');
          } else {
            errorHandler = $injector.get(errorHandler);
          }
        }

        var loaders = [],
          prioritizedParts = getPrioritizedParts();

        angular.forEach(prioritizedParts, function (part) {
          loaders.push(
            part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
          );
          part.urlTemplate = part.urlTemplate || options.urlTemplate;
        });

        // workaround for #1781
        var structureHasBeenChangedWhileLoading = false;
        var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          structureHasBeenChangedWhileLoading = true;
        });

        return $q.all(loaders)
          .then(function () {
            dirtyCheckEventCloser();
            if (structureHasBeenChangedWhileLoading) {
              if (!options.__retries) {
                // the part structure has been changed while loading (the origin ones)
                // this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
                // TODO maybe we can optimize this with the actual list of missing parts
                options.__retries = (options.__retries || 0) + 1;
                return service(options);
              } else {
                // the part structure has been changed again while loading (retried one)
                // because this could an infinite loop, this will not load another one again
                $log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
                  'while loading translations. You should consider using promises of $translate.use(lang) and ' +
                  '$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
                  'if possible.');
              }
            }
            var table = {};
            prioritizedParts = getPrioritizedParts();
            angular.forEach(prioritizedParts, function (part) {
              deepExtend(table, part.tables[options.key]);
            });
            return table;
          }, function () {
            dirtyCheckEventCloser();
            return $q.reject(options.key);
          });
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#addPart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Registers a new part of the translation table. This method does not actually perform any xhr
       * requests to get translation data. The new parts will be loaded in order of priority from the server next time
       * `angular-translate` asks the loader to load translations.
       *
       * @param {string} name A name of the part to add
       * @param {int} [priority=0] Sets the load priority of this part.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case the new part affected somehow on the loaders
       * state. This way it means that there are a new translation data available to be loaded from
       * the server.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.addPart = function (name, priority, urlTemplate) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t add part, first arg has to be a string');
        }

        if (!hasPart(name)) {
          parts[name] = new Part(name, priority, urlTemplate);
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        } else if (!parts[name].isActive) {
          parts[name].isActive = true;
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#deletePart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Deletes the previously added part of the translation data. The target part could be deleted
       * either logically or physically. When the data is deleted logically it is not actually deleted
       * from the browser, but the loader marks it as not active and prevents it from affecting on the
       * translations. If the deleted in such way part is added again, the loader will use the
       * previously loaded data rather than loading it from the server once more time. But if the data
       * is deleted physically, the loader will completely remove all information about it. So in case
       * of recycling this part will be loaded from the server again.
       *
       * @param {string} name A name of the part to delete
       * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
       * translation data physically. If the `removeData` if set to **false** the loaded data will not be
       * deleted physically and might be reused in the future to prevent an additional xhr requests.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case a part deletion process affects somehow on the
       * loaders state. This way it means that some part of the translation data is now deprecated and
       * the translation table has to be recompiled with the remaining translation parts.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
       * wrong type. Please, note that the `name` param has to be a non-empty **string** and
       * the `removeData` param has to be either **undefined** or **boolean**.
       */
      service.deletePart = function (name, removeData) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t delete part, first arg has to be string');
        }

        if (removeData === undefined) {
          removeData = false;
        } else if (typeof removeData !== 'boolean') {
          throw new TypeError('Invalid type of a second argument, a boolean expected.');
        }

        if (hasPart(name)) {
          var wasActive = parts[name].isActive;
          if (removeData) {
            var $translate = $injector.get('$translate');
            var cache = $translate.loaderCache();
            if (typeof(cache) === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }
            // Purging items from cache...
            if (typeof(cache) === 'object') {
              angular.forEach(parts[name].tables, function (value, key) {
                cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
              });
            }
            delete parts[name];
          } else {
            parts[name].isActive = false;
          }
          if (wasActive) {
            $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
          }
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if the registered translation part is loaded into the translation table.
       *
       * @param {string} name A name of the part
       * @param {string} lang A key of the language
       *
       * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
       */
      service.isPartLoaded = function (name, lang) {
        return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Gets names of the parts that were added with the `addPart`.
       *
       * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
       */
      service.getRegisteredParts = function () {
        var registeredParts = [];
        angular.forEach(parts, function (p) {
          if (p.isActive) {
            registeredParts.push(p.name);
          }
        });
        return registeredParts;
      };


      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if a target translation part is available. The part becomes available just after it was
       * added by the `addPart` method. Part's availability does not mean that it was loaded from the
       * server, but only that it was added to the loader. The available part might be loaded next
       * time the loader is called.
       *
       * @param {string} name A name of the part to delete
       *
       * @returns {boolean} Returns **true** if the part is available now and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.isPartAvailable = isPartAvailable;

      return service;

    }];

}

$translatePartialLoader.displayName = '$translatePartialLoader';
return 'pascalprecht.translate';

}));

/**
 * @license AngularJS v1.8.0
 * (c) 2010-2020 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var helpers = {
  blockTransitions: function(node, duration) {
    // we use a negative delay value since it performs blocking
    // yet it doesn't kill any existing transitions running on the
    // same element which makes this safe for class-based animations
    var value = duration ? '-' + duration + 's' : '';
    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
    return [TRANSITION_DELAY_PROP, value];
  }
};

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
      var timings = $$animateCache.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // if a css animation has no duration we
      // should mark that so that repeated addClass/removeClass calls are skipped
      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      $$animateCache.put(cacheKey, timings, hasDuration);

      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;
      var staggerCacheKey = 'stagger-' + cacheKey;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if ($$animateCache.count(cacheKey) > 0) {
        stagger = $$animateCache.get(staggerCacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          $$animateCache.put(staggerCacheKey, stagger, true);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        $$animateCache.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey, allowNoDuration) {
      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
        preparationClasses = null;
        return closeAndReturnNoopAnimator();
      }

      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : $$animateCache.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        helpers.blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (preparationClasses && !options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }

        if (activeClasses) {
          $$jqLite.removeClass(element, activeClasses);
        }

        blockKeyframeAnimations(node, false);
        helpers.blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          helpers.blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        if (ev.target !== node) {
          // Since TransitionEvent / AnimationEvent bubble up,
          // we have to ignore events by finished child animations
          return;
        }

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);

            timings = computeTimings(node, fullClassName, cacheKey, false);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function getEventData(options) {
    return {
      addClass: options.addClass,
      removeClass: options.removeClass,
      from: options.from,
      to: options.to
    };
  }

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$Map();
    var disabledElementsLookup = new $$Map();
    var animationsEnabled = null;

    function removeFromDisabledElementsLookup(evt) {
      disabledElementsLookup.delete(evt.target);
    }

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the `customFilter`/`classNameFilter` are set during the
    // provider/config stage therefore we can optimize here and setup helper functions
    var customFilter = $animateProvider.customFilter();
    var classNameFilter = $animateProvider.classNameFilter();
    var returnTrue = function() { return true; };

    var isAnimatableByFilter = customFilter || returnTrue;
    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      return classNameFilter.test(className);
    };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(targetParentNode, targetNode, event) {
      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, node) {
      if (phase === 'close' && !node.parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(node);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              if (!disabledElementsLookup.has(node)) {
                // The element is added to the map for the first time.
                // Create a listener to remove it on `$destroy` (to avoid memory leak).
                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
              }
              disabledElementsLookup.set(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(originalElement, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var element = stripCommentsFromElement(originalElement);
      var node = getDomNode(element);
      var parentNode = node && node.parentNode;

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // If animations are hard-disabled for the whole application there is no need to continue.
      // There are also situations where a directive issues an animation for a jqLite wrapper that
      // contains only comment nodes. In this case, there is no way we can perform an animation.
      if (!animationsEnabled ||
          !node ||
          !isAnimatableByFilter(node, event, initialOptions) ||
          !isAnimatableClassName(node, options)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // This is a hard disable of all animations the element itself, therefore  there is no need to
      // continue further past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
        close();
        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(node);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(node);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
        // happen if the animated element is a transcluded clone and also has a `templateUrl`
        // directive on it. Therefore, we must recreate `element` in order to interact with the
        // actual DOM nodes.
        // Note: We still need to use the old `node` for certain things, such as looking up in
        //       HashMaps where it was used as the key.

        element = stripCommentsFromElement(originalElement);

        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(node);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(node, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', getEventData(options));

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(node);
          }
          notifyProgress(runner, event, 'close', getEventData(options));
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parentNode, node, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, node);
            });
          } else {
            cleanupEventListeners(phase, node);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(node) {
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.delete(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(node) {
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.delete(node);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(node, parentNode, event) {
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);

      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
      var rootNodeDetected = (node === rootNode);
      var parentAnimationDetected = false;
      var elementDisabled = disabledElementsLookup.get(node);
      var animateChildren;

      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentNode = getDomNode(parentHost);
      }

      while (parentNode) {
        if (!rootNodeDetected) {
          // AngularJS doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootNodeDetected = (parentNode === rootNode);
        }

        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentNodeDisabled = disabledElementsLookup.get(parentNode);

          if (parentNodeDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentNodeDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyNodeDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyNodeDetected = (parentNode === bodyNode);
        }

        if (bodyNodeDetected && rootNodeDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootNodeDetected) {
          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentNode = getDomNode(parentHost);
            continue;
          }
        }

        parentNode = parentNode.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootNodeDetected && bodyNodeDetected;
    }

    function markElementAnimationState(node, state, details) {
      details = details || {};
      details.state = state;

      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.set(node, newValue);
    }
  }];
}];

/** @this */
var $$AnimateCacheProvider = function() {

  var KEY = '$$ngAnimateParentKey';
  var parentCounter = 0;
  var cache = Object.create(null);

  this.$get = [function() {
    return {
      cacheKey: function(node, method, addClass, removeClass) {
        var parentNode = node.parentNode;
        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
        var parts = [parentID, method, node.getAttribute('class')];
        if (addClass) {
          parts.push(addClass);
        }
        if (removeClass) {
          parts.push(removeClass);
        }
        return parts.join(' ');
      },

      containsCachedAnimationWithoutDuration: function(key) {
        var entry = cache[key];

        // nothing cached, so go ahead and animate
        // otherwise it should be a valid animation
        return (entry && !entry.isValid) || false;
      },

      flush: function() {
        cache = Object.create(null);
      },

      count: function(key) {
        var entry = cache[key];
        return entry ? entry.total : 0;
      },

      get: function(key) {
        var entry = cache[key];
        return entry && entry.value;
      },

      put: function(key, value, isValid) {
        if (!cache[key]) {
          cache[key] = { total: 1, value: value, isValid: isValid };
        } else {
          cache[key].total++;
          cache[key].value = value;
        }
      }
    };
  }];
};

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';
  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$Map();

      // this is done first beforehand so that the map
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.set(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          element: animation.element,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.set(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      if (isStructural) {
        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
      }

      setRunner(element, runner);

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
          var extraClasses = options.addClass;

          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);

          toBeSortedAnimations.push({
            element: element,
            domNode: getDomNode(element),
            fn: function triggerAnimationStart() {
              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that we've cached the animation status for this element
              // and it's in fact an invalid animation (something that has duration = 0)
              // then we should skip all the heavy work from here on
              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                closeFn();
                return;
              }

              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        var finalAnimations = sortAnimations(toBeSortedAnimations);
        for (var i = 0; i < finalAnimations.length; i++) {
          var innerArray = finalAnimations[i];
          for (var j = 0; j < innerArray.length; j++) {
            var entry = innerArray[j];
            var element = entry.element;

            // the RAFScheduler code only uses functions
            finalAnimations[i][j] = entry.fn;

            // the first row of elements shouldn't have a prepare-class added to them
            // since the elements are at the top of the animation hierarchy and they
            // will be applied without a RAF having to pass...
            if (i === 0) {
              element.removeData(PREPARE_CLASSES_KEY);
              continue;
            }

            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
            if (prepareClassName) {
              $$jqLite.addClass(element, prepareClassName);
            }
          }
        }

        $$rAFScheduler(finalAnimations);
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
        $$jqLite.addClass(element, tempClasses);

        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 550, // We use 550 here to ensure that the directive is caught before others,
                   // but after `ngIf` (at priority 600).
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          $transclude(function(clone, childScope) {
            previousElement = clone;
            previousScope = childScope;
            $animate.enter(clone, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .info({ angularVersion: '1.8.0' })
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animateCache', $$AnimateCacheProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);

/*
 * Copyright 2013 Ivan Pusic
 * Contributors:
 *   Matjaz Lipus
 */
angular.module('ivpusic.cookie', ['ipCookie']);
angular.module('ipCookie', ['ng']).
factory('ipCookie', ['$document',
  function ($document) {
    'use strict';
      
    function tryDecodeURIComponent(value) {
        try {
            return decodeURIComponent(value);
        } catch(e) {
              // Ignore any invalid uri component
        }
    }

    return (function () {
      function cookieFun(key, value, options) {

        var cookies,
          list,
          i,
          cookie,
          pos,
          name,
          hasCookies,
          all,
          expiresFor;

        options = options || {};
        var dec = options.decode || tryDecodeURIComponent;
        var enc = options.encode || encodeURIComponent;

        if (value !== undefined) {
          // we are setting value
          value = typeof value === 'object' ? JSON.stringify(value) : String(value);

          if (typeof options.expires === 'number') {
            expiresFor = options.expires;
            options.expires = new Date();
            // Trying to delete a cookie; set a date far in the past
            if (expiresFor === -1) {
              options.expires = new Date('Thu, 01 Jan 1970 00:00:00 GMT');
              // A new 
            } else if (options.expirationUnit !== undefined) {
              if (options.expirationUnit === 'hours') {
                options.expires.setHours(options.expires.getHours() + expiresFor);
              } else if (options.expirationUnit === 'minutes') {
                options.expires.setMinutes(options.expires.getMinutes() + expiresFor);
              } else if (options.expirationUnit === 'seconds') {
                options.expires.setSeconds(options.expires.getSeconds() + expiresFor);
              } else if (options.expirationUnit === 'milliseconds') {
                options.expires.setMilliseconds(options.expires.getMilliseconds() + expiresFor);
              } else {
                options.expires.setDate(options.expires.getDate() + expiresFor);
              }
            } else {
              options.expires.setDate(options.expires.getDate() + expiresFor);
            }
          }
          return ($document[0].cookie = [
            enc(key),
            '=',
            enc(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '',
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
          ].join(''));
        }

        list = [];
        all = $document[0].cookie;
        if (all) {
          list = all.split('; ');
        }

        cookies = {};
        hasCookies = false;

        for (i = 0; i < list.length; ++i) {
          if (list[i]) {
            cookie = list[i];
            pos = cookie.indexOf('=');
            name = cookie.substring(0, pos);
            value = dec(cookie.substring(pos + 1));
            if(angular.isUndefined(value))
              continue;

            if (key === undefined || key === name) {
              try {
                cookies[name] = JSON.parse(value);
              } catch (e) {
                cookies[name] = value;
              }
              if (key === name) {
                return cookies[name];
              }
              hasCookies = true;
            }
          }
        }
        if (hasCookies && key === undefined) {
          return cookies;
        }
      }
      cookieFun.remove = function (key, options) {
        var hasCookie = cookieFun(key) !== undefined;

        if (hasCookie) {
          if (!options) {
            options = {};
          }
          options.expires = -1;
          cookieFun(key, '', options);
        }
        return hasCookie;
      };
      return cookieFun;
    }());
  }
]);

/**
 * State-based routing for AngularJS
 * @version v0.4.3
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

// issue #2676 #2889
function silenceUncaughtInPromise (promise) {
  return promise.then(undefined, function() {}) && promise;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = silenceUncaughtInPromise(resolution.promise),
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;

      silenceUncaughtInPromise(result);
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = silenceUncaughtInPromise(invocation.promise);
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);



/**
 * @ngdoc object
 * @name ui.router.util.$templateFactoryProvider
 *
 * @description
 * Provider for $templateFactory. Manages which template-loading mechanism to
 * use, and will default to the most recent one ($templateRequest on Angular
 * versions starting from 1.3, $http otherwise).
 */
function TemplateFactoryProvider() {
  var shouldUnsafelyUseHttp = angular.version.minor < 3;

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
   * @methodOf ui.router.util.$templateFactoryProvider
   *
   * @description
   * Forces $templateFactory to use $http instead of $templateRequest. This
   * might cause XSS, as $http doesn't enforce the regular security checks for
   * templates that have been introduced in Angular 1.3. Note that setting this
   * to false on Angular older than 1.3.x will crash, as the $templateRequest
   * service (and the security checks) are not implemented on these versions.
   *
   * See the $sce documentation, section
   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
   * Impact on loading templates</a> for more details about this mechanism.
   *
   * @param {boolean} value
   */
  this.shouldUnsafelyUseHttp = function(value) {
    shouldUnsafelyUseHttp = !!value;
  };

  /**
   * @ngdoc object
   * @name ui.router.util.$templateFactory
   *
   * @requires $http
   * @requires $templateCache
   * @requires $injector
   *
   * @description
   * Service. Manages loading of templates.
   */
  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
}


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else {
      if(!shouldUnsafelyUseHttp) {
        return $injector.get('$templateRequest')(url);
      } else {
        return $http
          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
          .then(function(response) { return response.data; });
      }
    }
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
      pattern: /-?\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSupersededError = new Error('transition superseded');

    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) {
          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
          return TransitionSuperseded;
        }
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }).then(null, function (error) {
        // propagate TransitionSuperseded error without emitting $stateChangeCancel
        // as it was already emitted in the success handler above
        if (error === TransitionSupersededError) return TransitionSuperseded;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }

        return $q.reject(error);
      });

      silenceUncaughtInPromise(transition);
      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }

      return !params || objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && (!paramDef || paramDef.type.equals($stateParams[key], params[key]));
      }, true);
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      if (!params) { return true; }

      var keys = objectKeys(params);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], paramDef = state.params[key];
        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
          return false;
        }
      }

      return objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            result.$$resolveAs = view.resolveAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .constant("$state.runtime", { autoinject: true })
  .provider('$state', $StateProvider)
  // Inject $state to initialize when entering runtime. #2574
  .run(['$injector', function ($injector) {
    // Allow tests (stateSpec.js) to turn this off by defining this constant
    if ($injector.get("$state.runtime").autoinject) {
      $injector.get('$state');
    }
  }]);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @example
 * A view can be unnamed or named.
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre>
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * </pre>
 *
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * Example usage of $resolve in a view template
 * <pre>
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = function() {
      return {
        enter: function (element, target, cb) { target.after(element); cb(); },
        leave: function (element, cb) { element.remove(); cb(); }
      };
    };

    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics();
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope),
            inherited     = $element.inheritedData('$uiView');

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          if (previousEl) {
            previousEl.remove();
            previousEl = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }

          if (currentEl) {
            var $uiViewData = currentEl.data('$uiViewAnim');
            renderer.leave(currentEl, function() {
              $uiViewData.$$animLeave.resolve();
              previousEl = null;
            });

            previousEl = currentEl;
            currentEl = null;
          }
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            var animEnter = $q.defer(), animLeave = $q.defer();
            var viewAnimData = {
              $animEnter: animEnter.promise,
              $animLeave: animLeave.promise,
              $$animLeave: animLeave
            };

            clone.data('$uiViewAnim', viewAnimData);
            renderer.enter(clone, $element, function onUiViewEnter() {
              animEnter.resolve();
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      if (tElement.empty) {
        tElement.empty();
      } else {
        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
        tElement[0].innerHTML = null;
      }

      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          $element.html(initial);
          $compile($element.contents())(scope);
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var resolveData = angular.extend({}, locals);
        scope[locals.$$resolveAs] = resolveData;

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
          }
          if (isFunction(controller.$onInit)) controller.$onInit();
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var uiViewCreatedBy = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var unlinkInfoFn = null;
      var hookFn;

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };
      var unlinkInfoFn = null;
      var hookFn;

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        var deregister = addState(newState, newParams, uiSrefActive);
        update();
        return deregister;
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        var stateInfo = {
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        };

        states.push(stateInfo);
        activeClasses[stateHash] = activeClass;

        return function removeState() {
          var idx = states.indexOf(stateInfo);
          if (idx !== -1) states.splice(idx, 1);
        };
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);
/**
 * @license Angulartics
 * (c) 2013 Luis Farzati http://angulartics.github.io/
 * License: MIT
 */
(function(angular, analytics) {
'use strict';

var angulartics = window.angulartics || (window.angulartics = {});
angulartics.waitForVendorCount = 0;
angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
  if (!onTimeout) { angulartics.waitForVendorCount++; }
  if (!registerFn) { registerFn = containsField; containsField = undefined; }
  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
  }
  else {
    angulartics.waitForVendorCount--;
    registerFn(window[objectName]);
  }
};

/**
 * @ngdoc overview
 * @name angulartics
 */
angular.module('angulartics', [])
.provider('$analytics', $analytics)
.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
.directive('analyticsOn', ['$analytics', analyticsOn])
.config(['$provide', exceptionTrack]);

function $analytics() {
  var vm = this;

  var settings = {
    pageTracking: {
      autoTrackFirstPage: true,
      autoTrackVirtualPages: true,
      trackRelativePath: false,
      trackRoutes: true,
      trackStates: true,
      autoBasePath: false,
      basePath: '',
      excludedRoutes: [],
      queryKeysWhitelisted: [],
      queryKeysBlacklisted: [],
      filterUrlSegments: []
    },
    eventTracking: {},
    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
    trackExceptions: false,
    optOut: false,
    developerMode: false // Prevent sending data in local/development environment
  };

  // List of known handlers that plugins can register themselves for
  var knownHandlers = [
    'pageTrack',
    'eventTrack',
    'exceptionTrack',
    'transactionTrack',
    'setAlias',
    'setUsername',
    'setUserProperties',
    'setUserPropertiesOnce',
    'setSuperProperties',
    'setSuperPropertiesOnce',
    'incrementProperty',
    'userTimings',
    'clearCookies'
  ];
  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
  var cache = {};
  var handlers = {};
  var handlerOptions = {};

  // General buffering handler
  function bufferedHandler(handlerName){
    return function(){
      if(angulartics.waitForVendorCount){
        if(!cache[handlerName]){ cache[handlerName] = []; }
        cache[handlerName].push(arguments);
      }
    };
  }

  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
  function updateHandlers(handlerName, fn, options){
    if(!handlers[handlerName]){
      handlers[handlerName] = [];
    }
    handlers[handlerName].push(fn);
    handlerOptions[fn] = options;
    return function(){
      if(!this.settings.optOut) {
        var handlerArgs = Array.prototype.slice.apply(arguments);
        return this.$inject(['$q', angular.bind(this, function($q) {
          return $q.all(handlers[handlerName].map(function(handlerFn) {
            var options = handlerOptions[handlerFn] || {};
            if (options.async) {
              var deferred = $q.defer();
              var currentArgs = angular.copy(handlerArgs);
              currentArgs.unshift(deferred.resolve);
              handlerFn.apply(this, currentArgs);
              return deferred.promise;
            } else{
              return $q.when(handlerFn.apply(this, handlerArgs));
            }
          }, this));
        })]);
      }
    };
  }

  // The api (returned by this provider) gets populated with handlers below.
  var api = {
    settings: settings
  };

  // Opt in and opt out functions
  api.setOptOut = function(optOut) {
    this.settings.optOut = optOut;
    triggerRegister();
  };

  api.getOptOut = function() {
    return this.settings.optOut;
  };


  // Will run setTimeout if delay is > 0
  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
  // Plugins should take care to register handlers by order of precedence.
  function onTimeout(fn, delay){
    if(delay){
      setTimeout(fn, delay);
    } else {
      fn();
    }
  }

  var provider = {
    $get: ['$injector', function($injector) {
      return apiWithInjector($injector);
    }],
    api: api,
    settings: settings,
    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
    trackStates: function (value) { this.settings.pageTracking.trackStates = value; },
    trackRoutes: function (value) { this.settings.pageTracking.trackRoutes = value; },
    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
    queryKeysWhitelist: function(keys) { this.settings.pageTracking.queryKeysWhitelisted = keys; },
    queryKeysBlacklist: function(keys) { this.settings.pageTracking.queryKeysBlacklisted = keys; },
    filterUrlSegments: function(filters) { this.settings.pageTracking.filterUrlSegments = filters; },
    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
    withBase: function (value) {
      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
    },
    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
    trackExceptions: function (value) { this.settings.trackExceptions = value; },
    developerMode: function(value) { this.settings.developerMode = value; }
  };

  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
  function register(handlerName, fn, options){
    // Do not add a handler if developerMode is true
    if (settings.developerMode) {
        return;
    }
    api[handlerName] = updateHandlers(handlerName, fn, options);
    var handlerSettings = settings[handlerName];
    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
    angular.forEach(cache[handlerName], function (args, index) {
      onTimeout(function () { fn.apply(this, args); }, index * delay);
    });
  }

  function capitalize(input) {
      return input.replace(/^./, function (match) {
          return match.toUpperCase();
      });
  }

  //provide a method to inject services into handlers
  var apiWithInjector = function(injector) {
    return angular.extend(api, {
      '$inject': injector.invoke
    });
  };

  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
  function installHandlerRegisterFunction(handlerName){
    var registerName = 'register'+capitalize(handlerName);
    provider[registerName] = function(fn, options){
      register(handlerName, fn, options);
    };
    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
  }

  function startRegistering(_provider, _knownHandlers, _installHandlerRegisterFunction) {
    angular.forEach(_knownHandlers, _installHandlerRegisterFunction);

    for (var key in _provider) {
      vm[key] = _provider[key];
    }
  }

  // Allow $angulartics to trigger the register to update opt in/out
  var triggerRegister = function() {
    startRegistering(provider, knownHandlers, installHandlerRegisterFunction);
  };

  // Initial register
  startRegistering(provider, knownHandlers, installHandlerRegisterFunction);

}

function $analyticsRun($rootScope, $window, $analytics, $injector) {

  function matchesExcludedRoute(url) {
    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
        return true;
      }
    }
    return false;
  }

  function arrayDifference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }

  function filterQueryString(url, keysMatchArr, thisType){
    if (/\?/.test(url) && keysMatchArr.length > 0) {
      var urlArr = url.split('?');
      var urlBase = urlArr[0];
      var pairs = urlArr[1].split('&');
      var matchedPairs = [];

      for (var i = 0; i < keysMatchArr.length; i++) {
        var listedKey = keysMatchArr[i];
        for (var j = 0; j < pairs.length; j++) {
          if ((listedKey instanceof RegExp && listedKey.test(pairs[j])) || pairs[j].indexOf(listedKey) > -1) matchedPairs.push(pairs[j]);
        }
      }

      var matchedPairsArr = (thisType == 'white' ? matchedPairs : arrayDifference(pairs,matchedPairs));
      if(matchedPairsArr.length > 0){
        return urlBase + '?' + matchedPairsArr.join('&');
      }else{
        return urlBase;
      }
    } else {
      return url;
    }
  }

  function whitelistQueryString(url){
    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysWhitelisted, 'white');
  }

  function blacklistQueryString(url){
    return filterQueryString(url, $analytics.settings.pageTracking.queryKeysBlacklisted, 'black');
  }

  function filterUrlSegments(url){
    var segmentFiltersArr = $analytics.settings.pageTracking.filterUrlSegments;

    if (segmentFiltersArr.length > 0) {
      var urlArr = url.split('?');
      var urlBase = urlArr[0];

      var segments = urlBase.split('/');

      for (var i = 0; i < segmentFiltersArr.length; i++) {
        var segmentFilter = segmentFiltersArr[i];

        for (var j = 1; j < segments.length; j++) {
          /* First segment will be host/protocol or base path. */
          if ((segmentFilter instanceof RegExp && segmentFilter.test(segments[j])) || segments[j].indexOf(segmentFilter) > -1) {
            segments[j] = 'FILTERED';
          }
        }
      }

      return segments.join('/');
    } else {
      return url;
    }
  }

  function pageTrack(url, $location) {
    if (!matchesExcludedRoute(url)) {
      url = whitelistQueryString(url);
      url = blacklistQueryString(url);
      url = filterUrlSegments(url);
      $analytics.pageTrack(url, $location);
    }
  }

  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
    /* Only track the 'first page' if there are no routes or states on the page */
    var noRoutesOrStates = true;
    if ($injector.has('$route')) {
       var $route = $injector.get('$route');
       if ($route) {
        for (var route in $route.routes) {
          noRoutesOrStates = false;
          break;
        }
       } else if ($route === null){
        noRoutesOrStates = false;
       }
    } else if ($injector.has('$state')) {
      var $state = $injector.get('$state');
      if ($state.get().length > 1) noRoutesOrStates = false;
    }
    if (noRoutesOrStates) {
      if ($analytics.settings.pageTracking.autoBasePath) {
        $analytics.settings.pageTracking.basePath = $window.location.pathname;
      }
      $injector.invoke(['$location', function ($location) {
        if ($analytics.settings.pageTracking.trackRelativePath) {
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        } else {
          pageTrack($location.absUrl(), $location);
        }
      }]);
    }
  }

  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
    if ($analytics.settings.pageTracking.autoBasePath) {
      /* Add the full route to the base. */
      $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
    }
    var noRoutesOrStates = true;

    if ($analytics.settings.pageTracking.trackRoutes) {
      if ($injector.has('$route')) {
        var $route = $injector.get('$route');
        if ($route) {
          for (var route in $route.routes) {
            noRoutesOrStates = false;
            break;
          }
        } else if ($route === null){
          noRoutesOrStates = false;
        }
        $rootScope.$on('$routeChangeSuccess', function (event, current) {
          if (current && (current.$$route||current).redirectTo) return;
          $injector.invoke(['$location', function ($location) {
            var url = $analytics.settings.pageTracking.basePath + $location.url();
            pageTrack(url, $location);
          }]);
        });
      }
    }

    if ($analytics.settings.pageTracking.trackStates) {
      if ($injector.has('$state') && !$injector.has('$transitions')) {
        noRoutesOrStates = false;
        $rootScope.$on('$stateChangeSuccess', function (event, current) {
          $injector.invoke(['$location', function ($location) {
            var url = $analytics.settings.pageTracking.basePath + $location.url();
            pageTrack(url, $location);
          }]);
        });
      }
      if ($injector.has('$state') && $injector.has('$transitions')) {
        noRoutesOrStates = false;
        $injector.invoke(['$transitions', function($transitions) {
          $transitions.onSuccess({}, function($transition$) {
            var transitionOptions = $transition$.options();

            // only track for transitions that would have triggered $stateChangeSuccess
            if (transitionOptions.notify) {
              $injector.invoke(['$location', function ($location) {
                var url = $analytics.settings.pageTracking.basePath + $location.url();
                pageTrack(url, $location);
              }]);
            }
          });
        }]);
      }
    }

    if (noRoutesOrStates) {
      $rootScope.$on('$locationChangeSuccess', function (event, current) {
        if (current && (current.$$route || current).redirectTo) return;
        $injector.invoke(['$location', function ($location) {
          if ($analytics.settings.pageTracking.trackRelativePath) {
            var url = $analytics.settings.pageTracking.basePath + $location.url();
            pageTrack(url, $location);
          } else {
            pageTrack($location.absUrl(), $location);
          }
        }]);
      });
    }
  }
  if ($analytics.settings.developerMode) {
    angular.forEach($analytics, function(attr, name) {
      if (typeof attr === 'function') {
        $analytics[name] = function(){};
      }
    });
  }
}

function analyticsOn($analytics) {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attrs) {
      var eventType = $attrs.analyticsOn || 'click';
      var trackingData = {};

      angular.forEach($attrs.$attr, function(attr, name) {
        if (isProperty(name)) {
          trackingData[propertyName(name)] = $attrs[name];
          $attrs.$observe(name, function(value){
            trackingData[propertyName(name)] = value;
          });
        }
      });

      angular.element($element[0]).on(eventType, function ($event) {
        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
        trackingData.eventType = $event.type;

        if($attrs.analyticsIf){
          if(! $scope.$eval($attrs.analyticsIf)){
            return; // Cancel this event if we don't pass the analytics-if condition
          }
        }
        // Allow components to pass through an expression that gets merged on to the event properties
        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
        if($attrs.analyticsProperties){
          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
        }
        $analytics.eventTrack(eventName, trackingData);
      });
    }
  };
}

function exceptionTrack($provide) {
  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
    return function (error, cause) {
      var result = $delegate(error, cause);
      var $analytics = $injector.get('$analytics');
      if ($analytics.settings.trackExceptions) {
        $analytics.exceptionTrack(error, cause);
      }
      return result;
    };
  }]);
}

function isCommand(element) {
  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
}

function inferEventType(element) {
  if (isCommand(element)) return 'click';
  return 'click';
}

function inferEventName(element) {
  if (isCommand(element)) return element.innerText || element.value;
  return element.id || element.name || element.tagName;
}

function isProperty(name) {
  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
}

function propertyName(name) {
  var s = name.slice(9); // slice off the 'analytics' prefix
  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
    return s.substring(0, 1).toLowerCase() + s.substring(1);
  }
  else {
    return s;
  }
}
})(angular);

var bluemoon;
(function (bluemoon) {
    var analytics;
    (function (analytics) {
        'use strict';
        angular.module('bluemoon.analytics', ['angulartics']);
    })(analytics = bluemoon.analytics || (bluemoon.analytics = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=bluemoon-analytics-module.js.map;var bluemoon;
(function (bluemoon) {
    var analytics;
    (function (analytics) {
        'use strict';
        var BluemoonAnalyticsProvider = /** @class */ (function () {
            BluemoonAnalyticsProvider.$inject = ["$analyticsProvider"];
            function BluemoonAnalyticsProvider($analyticsProvider) {
                var _this = this;
                this.$analyticsProvider = $analyticsProvider;
                this.sendAnalyticsToProd = function (newValue, callback) {
                    _this.isDataGoingToProd = newValue;
                    var configObj = {
                        'version': '0.2.1',
                        'adapters': [
                            {
                                'type': 'Http',
                                'config': {
                                    'url': 'https://collector-product-insight.thomsonreuters.com/v1/data',
                                    'flush_period': 60000,
                                    'headers': {
                                        'X-PRODUCT-INSIGHTS-TOKEN': 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW'
                                    }
                                }
                            }
                        ]
                    };
                    if (!_this.isDataGoingToProd) {
                        //dev-bluemoon-client Product Insight Project ID
                        configObj
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW';
                    }
                    else {
                        //bluemoon-client Product Insight Project ID
                        configObj
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'vIVU3MIibpvd7DRjQGpdhSrRypYC66K1';
                    }
                    //Set the global object for the TRAAC JavaScript Library Config
                    window.TRAAC_CONFIG = configObj;
                    if (typeof callback === 'function' && callback) {
                        callback();
                    }
                };
                this.loadTRAACLibrary = function (callback) {
                    if (!window.TRAAC_CONFIG) {
                        console.error('Missing TRAAC config');
                    }
                    window.TRAAC = {
                        track: function (event) {
                            window.TRAAC_CONFIG.teq.push(event);
                        },
                        registerOnce: function (kvp) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'registerOnce',
                                'p1': kvp
                            });
                        },
                        register: function (kvp) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'register',
                                'p1': kvp
                            });
                        },
                        setUser: function (uid) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'setUser',
                                'p1': uid
                            });
                        },
                        clearUser: function () {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'clearUser'
                            });
                        },
                        deRegister: function (key) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'deRegister',
                                'p1': key
                            });
                        },
                        flush: function (callback, timeout) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'flush',
                                'p1': callback,
                                'p2': timeout
                            });
                        }
                    };
                    window.TRAAC_CONFIG.teq = [];
                    if (typeof callback === 'function' && callback) {
                        callback();
                    }
                };
                this.configAngulartics = function () {
                    _this.$analyticsProvider.registerSetUsername(function (userId) {
                        window.TRAAC.setUser(userId);
                    });
                    _this.$analyticsProvider.registerSetSuperPropertiesOnce(function (properties) {
                        window.TRAAC.registerOnce(properties);
                    });
                    _this.$analyticsProvider.registerSetSuperProperties(function (properties) {
                        window.TRAAC.register(properties);
                    });
                    _this.$analyticsProvider.registerPageTrack(function (path, extraInfo) {
                        window.TRAAC.track(function () {
                            var metaD = _this.breakupURL(path);
                            var event = window.TRAAC.keyValue('Page View', metaD);
                            return event.build();
                        });
                    });
                    _this.$analyticsProvider.registerEventTrack(function (action, properties) {
                        window.TRAAC.track(function () {
                            var event = window.TRAAC.keyValue(action, properties);
                            return event.build();
                        });
                    });
                };
                this.breakupURL = function (path) {
                    var tempParts = [];
                    var urlParts = path.split('/');
                    var urlData = {
                        page: '',
                        additionalPath: [],
                        urlParams: []
                    };
                    if (urlParts[0] === '' && urlParts[1] === '') {
                        urlData.page = '/';
                    }
                    else {
                        for (var i = 1; i < urlParts.length; i++) {
                            if (urlParts[i].indexOf('?') === -1) {
                                if (i === 1) {
                                    urlData.page = urlParts[i];
                                }
                                else {
                                    urlData.additionalPath.push(urlParts[i]);
                                }
                            }
                            else {
                                if (i === 1) {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') {
                                        urlData.page = tempParts[0];
                                    }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                                else {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') {
                                        urlData.additionalPath.push(tempParts[0]);
                                    }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                            }
                        }
                        urlData.additionalPath = urlData.additionalPath.join('/');
                    }
                    return urlData;
                };
                this.isDataGoingToProd = false;
            }
            BluemoonAnalyticsProvider.prototype.$get = function () {
                return {};
            };
            return BluemoonAnalyticsProvider;
        }());
        angular.module('bluemoon.analytics')
            .provider('bluemoonAnalytics', BluemoonAnalyticsProvider);
    })(analytics = bluemoon.analytics || (bluemoon.analytics = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=bluemoonAnalyticsProvider.js.map
(function (window) {
    var TRAACcoreIntervalID = setInterval(function () {
        if (typeof window.TRAAC_CONFIG !== 'undefined') {
            clearInterval(TRAACcoreIntervalID);
            !function (t, e) { "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.HttpAdapter = e() : t.HttpAdapter = e() }(this, function () { return function (t) { function e(n) { if (r[n]) return r[n].exports; var i = r[n] = { exports: {}, id: n, loaded: !1 }; return t[n].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports } var r = {}; return e.m = t, e.c = r, e.p = "", e(0) }([function (t, e, r) { "use strict"; function n(t) { return t && t.__esModule ? t : { "default": t } } function i(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var s = function () { function t(t, e) { for (var r = 0; r < e.length; r++) { var n = e[r]; n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n) } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e } }(), o = r(1), a = n(o), u = function () { function t(e) { i(this, t), !e.url, this.config = e, this.setFlushPeriod(e.flush_period), this.name = "http", this.errorCount = 0, this.eventQueue = [], this.setEventTimeout() } return s(t, [{ key: "setFlushPeriod", value: function (t) { void 0 === t ? this.FLUSH_PERIOD = 5e3 : this.FLUSH_PERIOD = t, this.async = this.FLUSH_PERIOD > 0 } }, { key: "setEventTimeout", value: function () { var t = this; this.errorCount > 4 && this.setFlushPeriod(15e3), this.async && setTimeout(function () { t.flushQueue() }, this.FLUSH_PERIOD) } }, { key: "flush", value: function () { this.flushQueue() } }, { key: "track", value: function (t, e) { var r = this, n = JSON.parse(JSON.stringify(t)); this.processEvent(n), e[t["event-id"] + "-http"] = new Promise(function (i) { r.eventQueue.push({ event: n, callback: function () { i(), delete e[t["event-id"] + "-http"] } }), r.async || r.flushQueue() }) } }, { key: "processEvent", value: function (t) { if (t.metadata) for (var e = 0; e < t.metadata.length; e++) t.metadata[e].key.indexOf("ga_") >= 0 && delete t.metadata[e]; delete t.tmpMetaData } }, { key: "flushQueue", value: function () { var t = this; if (0 === this.eventQueue.length) return void this.setEventTimeout(); var e = this.eventQueue; this.eventQueue = []; for (var r = [], n = 0; n < e.length; n++) r.push(e[n].event); var i = a["default"].post(this.config.url); if (this.config.headers) for (var s in this.config.headers) i.set(s, this.config.headers[s]); i.send(r).withCredentials().end(function (r, n) { var i = !0, s = !1, o = void 0; try { for (var a, u = e[Symbol.iterator]() ; !(i = (a = u.next()).done) ; i = !0) { var h = a.value; h.callback() } } catch (c) { s = !0, o = c } finally { try { !i && u["return"] && u["return"]() } finally { if (s) throw o } } r ? (t.errorCount++, t.eventQueue = e.concat(t.eventQueue), t.async || setTimeout(function () { t.flushQueue() }, 2e3)) : (t.errorCount = 0, t.setFlushPeriod(t.config.flush_period)), t.setEventTimeout() }) } }]), t }(); e["default"] = u, t.exports = e["default"] }, function (t, e, r) { function n() { } function i(t) { var e = {}.toString.call(t); switch (e) { case "[object File]": case "[object Blob]": case "[object FormData]": return !0; default: return !1 } } function s(t) { if (!_(t)) return t; var e = []; for (var r in t) null != t[r] && o(e, r, t[r]); return e.join("&") } function o(t, e, r) { return Array.isArray(r) ? r.forEach(function (r) { o(t, e, r) }) : void t.push(encodeURIComponent(e) + "=" + encodeURIComponent(r)) } function a(t) { for (var e, r, n = {}, i = t.split("&"), s = 0, o = i.length; o > s; ++s) r = i[s], e = r.split("="), n[decodeURIComponent(e[0])] = decodeURIComponent(e[1]); return n } function u(t) { var e, r, n, i, s = t.split(/\r?\n/), o = {}; s.pop(); for (var a = 0, u = s.length; u > a; ++a) r = s[a], e = r.indexOf(":"), n = r.slice(0, e).toLowerCase(), i = x(r.slice(e + 1)), o[n] = i; return o } function h(t) { return /[\/+]json\b/.test(t) } function c(t) { return t.split(/ *; */).shift() } function l(t) { return m(t.split(/ *; */), function (t, e) { var r = e.split(/ *= */), n = r.shift(), i = r.shift(); return n && i && (t[n] = i), t }, {}) } function p(t, e) { e = e || {}, this.req = t, this.xhr = this.req.xhr, this.text = "HEAD" != this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || "undefined" == typeof this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText, this.setStatusProperties(this.xhr.status), this.header = this.headers = u(this.xhr.getAllResponseHeaders()), this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this.setHeaderProperties(this.header), this.body = "HEAD" != this.req.method ? this.parseBody(this.text ? this.text : this.xhr.response) : null } function f(t, e) { var r = this; this._query = this._query || [], this.method = t, this.url = e, this.header = {}, this._header = {}, this.on("end", function () { var t = null, e = null; try { e = new p(r) } catch (n) { return t = new Error("Parser is unable to parse the response"), t.parse = !0, t.original = n, t.rawResponse = r.xhr && r.xhr.responseText ? r.xhr.responseText : null, t.statusCode = r.xhr && r.xhr.status ? r.xhr.status : null, r.callback(t) } if (r.emit("response", e), t) return r.callback(t, e); if (e.status >= 200 && e.status < 300) return r.callback(t, e); var i = new Error(e.statusText || "Unsuccessful HTTP response"); i.original = t, i.response = e, i.status = e.status, r.callback(i, e) }) } function d(t, e) { var r = w("DELETE", t); return e && r.end(e), r } var y, v = r(2), m = r(3), b = r(4), _ = r(5); y = "undefined" != typeof window ? window : "undefined" != typeof self ? self : this; var w = t.exports = r(6).bind(null, f); w.getXHR = function () { if (!(!y.XMLHttpRequest || y.location && "file:" == y.location.protocol && y.ActiveXObject)) return new XMLHttpRequest; try { return new ActiveXObject("Microsoft.XMLHTTP") } catch (t) { } try { return new ActiveXObject("Msxml2.XMLHTTP.6.0") } catch (t) { } try { return new ActiveXObject("Msxml2.XMLHTTP.3.0") } catch (t) { } try { return new ActiveXObject("Msxml2.XMLHTTP") } catch (t) { } return !1 }; var x = "".trim ? function (t) { return t.trim() } : function (t) { return t.replace(/(^\s*|\s*$)/g, "") }; w.serializeObject = s, w.parseString = a, w.types = { html: "text/html", json: "application/json", xml: "application/xml", urlencoded: "application/x-www-form-urlencoded", form: "application/x-www-form-urlencoded", "form-data": "application/x-www-form-urlencoded" }, w.serialize = { "application/x-www-form-urlencoded": s, "application/json": JSON.stringify }, w.parse = { "application/x-www-form-urlencoded": a, "application/json": JSON.parse }, p.prototype.get = function (t) { return this.header[t.toLowerCase()] }, p.prototype.setHeaderProperties = function (t) { var e = this.header["content-type"] || ""; this.type = c(e); var r = l(e); for (var n in r) this[n] = r[n] }, p.prototype.parseBody = function (t) { var e = w.parse[this.type]; return !e && h(this.type) && (e = w.parse["application/json"]), e && t && (t.length || t instanceof Object) ? e(t) : null }, p.prototype.setStatusProperties = function (t) { 1223 === t && (t = 204); var e = t / 100 | 0; this.status = this.statusCode = t, this.statusType = e, this.info = 1 == e, this.ok = 2 == e, this.clientError = 4 == e, this.serverError = 5 == e, this.error = 4 == e || 5 == e ? this.toError() : !1, this.accepted = 202 == t, this.noContent = 204 == t, this.badRequest = 400 == t, this.unauthorized = 401 == t, this.notAcceptable = 406 == t, this.notFound = 404 == t, this.forbidden = 403 == t }, p.prototype.toError = function () { var t = this.req, e = t.method, r = t.url, n = "cannot " + e + " " + r + " (" + this.status + ")", i = new Error(n); return i.status = this.status, i.method = e, i.url = r, i }, w.Response = p, v(f.prototype); for (var g in b) f.prototype[g] = b[g]; f.prototype.abort = function () { return this.aborted ? void 0 : (this.aborted = !0, this.xhr.abort(), this.clearTimeout(), this.emit("abort"), this) }, f.prototype.type = function (t) { return this.set("Content-Type", w.types[t] || t), this }, f.prototype.responseType = function (t) { return this._responseType = t, this }, f.prototype.accept = function (t) { return this.set("Accept", w.types[t] || t), this }, f.prototype.auth = function (t, e, r) { switch (r || (r = { type: "basic" }), r.type) { case "basic": var n = btoa(t + ":" + e); this.set("Authorization", "Basic " + n); break; case "auto": this.username = t, this.password = e } return this }, f.prototype.query = function (t) { return "string" != typeof t && (t = s(t)), t && this._query.push(t), this }, f.prototype.attach = function (t, e, r) { return this._getFormData().append(t, e, r || e.name), this }, f.prototype._getFormData = function () { return this._formData || (this._formData = new y.FormData), this._formData }, f.prototype.send = function (t) { var e = _(t), r = this._header["content-type"]; if (e && _(this._data)) for (var n in t) this._data[n] = t[n]; else "string" == typeof t ? (r || this.type("form"), r = this._header["content-type"], "application/x-www-form-urlencoded" == r ? this._data = this._data ? this._data + "&" + t : t : this._data = (this._data || "") + t) : this._data = t; return !e || i(t) ? this : (r || this.type("json"), this) }, p.prototype.parse = function (t) { return y.console, this.serialize(t), this }, p.prototype.serialize = function (t) { return this._parser = t, this }, f.prototype.callback = function (t, e) { var r = this._callback; this.clearTimeout(), r(t, e) }, f.prototype.crossDomainError = function () { var t = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc."); t.crossDomain = !0, t.status = this.status, t.method = this.method, t.url = this.url, this.callback(t) }, f.prototype.timeoutError = function () { var t = this._timeout, e = new Error("timeout of " + t + "ms exceeded"); e.timeout = t, this.callback(e) }, f.prototype.withCredentials = function () { return this._withCredentials = !0, this }, f.prototype.end = function (t) { var e = this, r = this.xhr = w.getXHR(), s = this._query.join("&"), o = this._timeout, a = this._formData || this._data; this._callback = t || n, r.onreadystatechange = function () { if (4 == r.readyState) { var t; try { t = r.status } catch (n) { t = 0 } if (0 == t) { if (e.timedout) return e.timeoutError(); if (e.aborted) return; return e.crossDomainError() } e.emit("end") } }; var u = function (t) { t.total > 0 && (t.percent = t.loaded / t.total * 100), t.direction = "download", e.emit("progress", t) }; this.hasListeners("progress") && (r.onprogress = u); try { r.upload && this.hasListeners("progress") && (r.upload.onprogress = u) } catch (c) { } if (o && !this._timer && (this._timer = setTimeout(function () { e.timedout = !0, e.abort() }, o)), s && (s = w.serializeObject(s), this.url += ~this.url.indexOf("?") ? "&" + s : "?" + s), this.username && this.password ? r.open(this.method, this.url, !0, this.username, this.password) : r.open(this.method, this.url, !0), this._withCredentials && (r.withCredentials = !0), "GET" != this.method && "HEAD" != this.method && "string" != typeof a && !i(a)) { var l = this._header["content-type"], p = this._parser || w.serialize[l ? l.split(";")[0] : ""]; !p && h(l) && (p = w.serialize["application/json"]), p && (a = p(a)) } for (var f in this.header) null != this.header[f] && r.setRequestHeader(f, this.header[f]); return this._responseType && (r.responseType = this._responseType), this.emit("request", this), r.send("undefined" != typeof a ? a : null), this }, w.Request = f, w.get = function (t, e, r) { var n = w("GET", t); return "function" == typeof e && (r = e, e = null), e && n.query(e), r && n.end(r), n }, w.head = function (t, e, r) { var n = w("HEAD", t); return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n }, w.del = d, w["delete"] = d, w.patch = function (t, e, r) { var n = w("PATCH", t); return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n }, w.post = function (t, e, r) { var n = w("POST", t); return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n }, w.put = function (t, e, r) { var n = w("PUT", t); return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n } }, function (t, e, r) { function n(t) { return t ? i(t) : void 0 } function i(t) { for (var e in n.prototype) t[e] = n.prototype[e]; return t } t.exports = n, n.prototype.on = n.prototype.addEventListener = function (t, e) { return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this }, n.prototype.once = function (t, e) { function r() { this.off(t, r), e.apply(this, arguments) } return r.fn = e, this.on(t, r), this }, n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function (t, e) { if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this; var r = this._callbacks["$" + t]; if (!r) return this; if (1 == arguments.length) return delete this._callbacks["$" + t], this; for (var n, i = 0; i < r.length; i++) if (n = r[i], n === e || n.fn === e) { r.splice(i, 1); break } return this }, n.prototype.emit = function (t) { this._callbacks = this._callbacks || {}; var e = [].slice.call(arguments, 1), r = this._callbacks["$" + t]; if (r) { r = r.slice(0); for (var n = 0, i = r.length; i > n; ++n) r[n].apply(this, e) } return this }, n.prototype.listeners = function (t) { return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [] }, n.prototype.hasListeners = function (t) { return !!this.listeners(t).length } }, function (t, e) { t.exports = function (t, e, r) { for (var n = 0, i = t.length, s = 3 == arguments.length ? r : t[n++]; i > n;) s = e.call(null, s, t[n], ++n, t); return s } }, function (t, e, r) { var n = r(5); e.clearTimeout = function () { return this._timeout = 0, clearTimeout(this._timer), this }, e.parse = function (t) { return this._parser = t, this }, e.timeout = function (t) { return this._timeout = t, this }, e.then = function (t, e) { return this.end(function (r, n) { r ? e(r) : t(n) }) }, e.use = function (t) { return t(this), this }, e.get = function (t) { return this._header[t.toLowerCase()] }, e.getHeader = e.get, e.set = function (t, e) { if (n(t)) { for (var r in t) this.set(r, t[r]); return this } return this._header[t.toLowerCase()] = e, this.header[t] = e, this }, e.unset = function (t) { return delete this._header[t.toLowerCase()], delete this.header[t], this }, e.field = function (t, e) { return this._getFormData().append(t, e), this } }, function (t, e) { function r(t) { return null != t && "object" == typeof t } t.exports = r }, function (t, e) { function r(t, e, r) { return "function" == typeof r ? new t("GET", e).end(r) : 2 == arguments.length ? new t("GET", e) : new t(e, r) } t.exports = r }]) }); !function (t, e) { if ("object" == typeof exports && "object" == typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else { var n = e(); for (var r in n) ("object" == typeof exports ? exports : t)[r] = n[r] } }(this, function () {
                return function (t) { function e(r) { if (n[r]) return n[r].exports; var o = n[r] = { exports: {}, id: r, loaded: !1 }; return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports } var n = {}; return e.m = t, e.c = n, e.p = "", e(0) }([function (t, e, n) { n(1), t.exports = n(298) }, function (t, e, n) { (function (t) { "use strict"; function e(t, e, n) { t[e] || Object[r](t, e, { writable: !0, configurable: !0, value: n }) } if (n(2), n(293), n(295), t._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed"); t._babelPolyfill = !0; var r = "defineProperty"; e(String.prototype, "padLeft", "".padStart), e(String.prototype, "padRight", "".padEnd), "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (t) { [][t] && e(Array, t, Function.call.bind([][t])) }) }).call(e, function () { return this }()) }, function (t, e, n) { n(3), n(52), n(53), n(54), n(55), n(57), n(60), n(61), n(62), n(63), n(64), n(65), n(66), n(67), n(68), n(70), n(72), n(74), n(76), n(79), n(80), n(81), n(85), n(87), n(89), n(92), n(93), n(94), n(95), n(97), n(98), n(99), n(100), n(101), n(102), n(103), n(105), n(106), n(107), n(109), n(110), n(111), n(113), n(114), n(115), n(116), n(117), n(118), n(119), n(120), n(121), n(122), n(123), n(124), n(125), n(126), n(131), n(132), n(136), n(137), n(138), n(139), n(141), n(142), n(143), n(144), n(145), n(146), n(147), n(148), n(149), n(150), n(151), n(152), n(153), n(154), n(155), n(156), n(157), n(159), n(160), n(166), n(167), n(169), n(170), n(171), n(175), n(176), n(177), n(178), n(179), n(181), n(182), n(183), n(184), n(187), n(189), n(190), n(191), n(193), n(195), n(197), n(198), n(199), n(201), n(202), n(203), n(204), n(211), n(214), n(215), n(217), n(218), n(221), n(222), n(224), n(225), n(226), n(227), n(228), n(229), n(230), n(231), n(232), n(233), n(234), n(235), n(236), n(237), n(238), n(239), n(240), n(241), n(242), n(244), n(245), n(246), n(247), n(248), n(249), n(251), n(252), n(253), n(254), n(255), n(256), n(257), n(258), n(260), n(261), n(263), n(264), n(265), n(266), n(269), n(270), n(271), n(272), n(273), n(274), n(275), n(276), n(278), n(279), n(280), n(281), n(282), n(283), n(284), n(285), n(286), n(287), n(288), n(291), n(292), t.exports = n(9) }, function (t, e, n) { "use strict"; var r = n(4), o = n(5), i = n(6), u = n(8), a = n(18), c = n(22).KEY, s = n(7), f = n(23), l = n(24), p = n(19), v = n(25), h = n(26), d = n(27), y = n(29), g = n(42), b = n(45), w = n(12), m = n(32), _ = n(16), O = n(17), x = n(46), j = n(49), E = n(51), P = n(11), S = n(30), M = E.f, k = P.f, A = j.f, T = r.Symbol, F = r.JSON, N = F && F.stringify, I = "prototype", C = v("_hidden"), R = v("toPrimitive"), D = {}.propertyIsEnumerable, L = f("symbol-registry"), U = f("symbols"), B = f("op-symbols"), G = Object[I], W = "function" == typeof T, V = r.QObject, z = !V || !V[I] || !V[I].findChild, J = i && s(function () { return 7 != x(k({}, "a", { get: function () { return k(this, "a", { value: 7 }).a } })).a }) ? function (t, e, n) { var r = M(G, e); r && delete G[e], k(t, e, n), r && t !== G && k(G, e, r) } : k, q = function (t) { var e = U[t] = x(T[I]); return e._k = t, e }, Y = W && "symbol" == typeof T.iterator ? function (t) { return "symbol" == typeof t } : function (t) { return t instanceof T }, K = function (t, e, n) { return t === G && K(B, e, n), w(t), e = _(e, !0), w(n), o(U, e) ? (n.enumerable ? (o(t, C) && t[C][e] && (t[C][e] = !1), n = x(n, { enumerable: O(0, !1) })) : (o(t, C) || k(t, C, O(1, {})), t[C][e] = !0), J(t, e, n)) : k(t, e, n) }, X = function (t, e) { w(t); for (var n, r = g(e = m(e)), o = 0, i = r.length; i > o;) K(t, n = r[o++], e[n]); return t }, H = function (t, e) { return void 0 === e ? x(t) : X(x(t), e) }, Q = function (t) { var e = D.call(this, t = _(t, !0)); return this === G && o(U, t) && !o(B, t) ? !1 : e || !o(this, t) || !o(U, t) || o(this, C) && this[C][t] ? e : !0 }, $ = function (t, e) { if (t = m(t), e = _(e, !0), t !== G || !o(U, e) || o(B, e)) { var n = M(t, e); return !n || !o(U, e) || o(t, C) && t[C][e] || (n.enumerable = !0), n } }, Z = function (t) { for (var e, n = A(m(t)), r = [], i = 0; n.length > i;) o(U, e = n[i++]) || e == C || e == c || r.push(e); return r }, tt = function (t) { for (var e, n = t === G, r = A(n ? B : m(t)), i = [], u = 0; r.length > u;) o(U, e = r[u++]) && (n ? o(G, e) : !0) && i.push(U[e]); return i }; W || (T = function () { if (this instanceof T) throw TypeError("Symbol is not a constructor!"); var t = p(arguments.length > 0 ? arguments[0] : void 0), e = function (n) { this === G && e.call(B, n), o(this, C) && o(this[C], t) && (this[C][t] = !1), J(this, t, O(1, n)) }; return i && z && J(G, t, { configurable: !0, set: e }), q(t) }, a(T[I], "toString", function () { return this._k }), E.f = $, P.f = K, n(50).f = j.f = Z, n(44).f = Q, n(43).f = tt, i && !n(28) && a(G, "propertyIsEnumerable", Q, !0), h.f = function (t) { return q(v(t)) }), u(u.G + u.W + u.F * !W, { Symbol: T }); for (var et = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), nt = 0; et.length > nt;) v(et[nt++]); for (var et = S(v.store), nt = 0; et.length > nt;) d(et[nt++]); u(u.S + u.F * !W, "Symbol", { "for": function (t) { return o(L, t += "") ? L[t] : L[t] = T(t) }, keyFor: function (t) { if (Y(t)) return y(L, t); throw TypeError(t + " is not a symbol!") }, useSetter: function () { z = !0 }, useSimple: function () { z = !1 } }), u(u.S + u.F * !W, "Object", { create: H, defineProperty: K, defineProperties: X, getOwnPropertyDescriptor: $, getOwnPropertyNames: Z, getOwnPropertySymbols: tt }), F && u(u.S + u.F * (!W || s(function () { var t = T(); return "[null]" != N([t]) || "{}" != N({ a: t }) || "{}" != N(Object(t)) })), "JSON", { stringify: function (t) { if (void 0 !== t && !Y(t)) { for (var e, n, r = [t], o = 1; arguments.length > o;) r.push(arguments[o++]); return e = r[1], "function" == typeof e && (n = e), !n && b(e) || (e = function (t, e) { return n && (e = n.call(this, t, e)), Y(e) ? void 0 : e }), r[1] = e, N.apply(F, r) } } }), T[I][R] || n(10)(T[I], R, T[I].valueOf), l(T, "Symbol"), l(Math, "Math", !0), l(r.JSON, "JSON", !0) }, function (t, e) { var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(); "number" == typeof __g && (__g = n) }, function (t, e) { var n = {}.hasOwnProperty; t.exports = function (t, e) { return n.call(t, e) } }, function (t, e, n) { t.exports = !n(7)(function () { return 7 != Object.defineProperty({}, "a", { get: function () { return 7 } }).a }) }, function (t, e) { t.exports = function (t) { try { return !!t() } catch (e) { return !0 } } }, function (t, e, n) { var r = n(4), o = n(9), i = n(10), u = n(18), a = n(20), c = "prototype", s = function (t, e, n) { var f, l, p, v, h = t & s.F, d = t & s.G, y = t & s.S, g = t & s.P, b = t & s.B, w = d ? r : y ? r[e] || (r[e] = {}) : (r[e] || {})[c], m = d ? o : o[e] || (o[e] = {}), _ = m[c] || (m[c] = {}); d && (n = e); for (f in n) l = !h && w && void 0 !== w[f], p = (l ? w : n)[f], v = b && l ? a(p, r) : g && "function" == typeof p ? a(Function.call, p) : p, w && u(w, f, p, t & s.U), m[f] != p && i(m, f, v), g && _[f] != p && (_[f] = p) }; r.core = o, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s }, function (t, e) { var n = t.exports = { version: "2.4.0" }; "number" == typeof __e && (__e = n) }, function (t, e, n) { var r = n(11), o = n(17); t.exports = n(6) ? function (t, e, n) { return r.f(t, e, o(1, n)) } : function (t, e, n) { return t[e] = n, t } }, function (t, e, n) { var r = n(12), o = n(14), i = n(16), u = Object.defineProperty; e.f = n(6) ? Object.defineProperty : function (t, e, n) { if (r(t), e = i(e, !0), r(n), o) try { return u(t, e, n) } catch (a) { } if ("get" in n || "set" in n) throw TypeError("Accessors not supported!"); return "value" in n && (t[e] = n.value), t } }, function (t, e, n) { var r = n(13); t.exports = function (t) { if (!r(t)) throw TypeError(t + " is not an object!"); return t } }, function (t, e) { t.exports = function (t) { return "object" == typeof t ? null !== t : "function" == typeof t } }, function (t, e, n) { t.exports = !n(6) && !n(7)(function () { return 7 != Object.defineProperty(n(15)("div"), "a", { get: function () { return 7 } }).a }) }, function (t, e, n) { var r = n(13), o = n(4).document, i = r(o) && r(o.createElement); t.exports = function (t) { return i ? o.createElement(t) : {} } }, function (t, e, n) { var r = n(13); t.exports = function (t, e) { if (!r(t)) return t; var n, o; if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o; if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o; if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o; throw TypeError("Can't convert object to primitive value") } }, function (t, e) { t.exports = function (t, e) { return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e } } }, function (t, e, n) { var r = n(4), o = n(10), i = n(5), u = n(19)("src"), a = "toString", c = Function[a], s = ("" + c).split(a); n(9).inspectSource = function (t) { return c.call(t) }, (t.exports = function (t, e, n, a) { var c = "function" == typeof n; c && (i(n, "name") || o(n, "name", e)), t[e] !== n && (c && (i(n, u) || o(n, u, t[e] ? "" + t[e] : s.join(String(e)))), t === r ? t[e] = n : a ? t[e] ? t[e] = n : o(t, e, n) : (delete t[e], o(t, e, n))) })(Function.prototype, a, function () { return "function" == typeof this && this[u] || c.call(this) }) }, function (t, e) { var n = 0, r = Math.random(); t.exports = function (t) { return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36)) } }, function (t, e, n) { var r = n(21); t.exports = function (t, e, n) { if (r(t), void 0 === e) return t; switch (n) { case 1: return function (n) { return t.call(e, n) }; case 2: return function (n, r) { return t.call(e, n, r) }; case 3: return function (n, r, o) { return t.call(e, n, r, o) } } return function () { return t.apply(e, arguments) } } }, function (t, e) { t.exports = function (t) { if ("function" != typeof t) throw TypeError(t + " is not a function!"); return t } }, function (t, e, n) { var r = n(19)("meta"), o = n(13), i = n(5), u = n(11).f, a = 0, c = Object.isExtensible || function () { return !0 }, s = !n(7)(function () { return c(Object.preventExtensions({})) }), f = function (t) { u(t, r, { value: { i: "O" + ++a, w: {} } }) }, l = function (t, e) { if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t; if (!i(t, r)) { if (!c(t)) return "F"; if (!e) return "E"; f(t) } return t[r].i }, p = function (t, e) { if (!i(t, r)) { if (!c(t)) return !0; if (!e) return !1; f(t) } return t[r].w }, v = function (t) { return s && h.NEED && c(t) && !i(t, r) && f(t), t }, h = t.exports = { KEY: r, NEED: !1, fastKey: l, getWeak: p, onFreeze: v } }, function (t, e, n) { var r = n(4), o = "__core-js_shared__", i = r[o] || (r[o] = {}); t.exports = function (t) { return i[t] || (i[t] = {}) } }, function (t, e, n) { var r = n(11).f, o = n(5), i = n(25)("toStringTag"); t.exports = function (t, e, n) { t && !o(t = n ? t : t.prototype, i) && r(t, i, { configurable: !0, value: e }) } }, function (t, e, n) { var r = n(23)("wks"), o = n(19), i = n(4).Symbol, u = "function" == typeof i, a = t.exports = function (t) { return r[t] || (r[t] = u && i[t] || (u ? i : o)("Symbol." + t)) }; a.store = r }, function (t, e, n) { e.f = n(25) }, function (t, e, n) { var r = n(4), o = n(9), i = n(28), u = n(26), a = n(11).f; t.exports = function (t) { var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {}); "_" == t.charAt(0) || t in e || a(e, t, { value: u.f(t) }) } }, function (t, e) { t.exports = !1 }, function (t, e, n) { var r = n(30), o = n(32); t.exports = function (t, e) { for (var n, i = o(t), u = r(i), a = u.length, c = 0; a > c;) if (i[n = u[c++]] === e) return n } }, function (t, e, n) { var r = n(31), o = n(41); t.exports = Object.keys || function (t) { return r(t, o) } }, function (t, e, n) { var r = n(5), o = n(32), i = n(36)(!1), u = n(40)("IE_PROTO"); t.exports = function (t, e) { var n, a = o(t), c = 0, s = []; for (n in a) n != u && r(a, n) && s.push(n); for (; e.length > c;) r(a, n = e[c++]) && (~i(s, n) || s.push(n)); return s } }, function (t, e, n) { var r = n(33), o = n(35); t.exports = function (t) { return r(o(t)) } }, function (t, e, n) { var r = n(34); t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) { return "String" == r(t) ? t.split("") : Object(t) } }, function (t, e) { var n = {}.toString; t.exports = function (t) { return n.call(t).slice(8, -1) } }, function (t, e) { t.exports = function (t) { if (void 0 == t) throw TypeError("Can't call method on  " + t); return t } }, function (t, e, n) { var r = n(32), o = n(37), i = n(39); t.exports = function (t) { return function (e, n, u) { var a, c = r(e), s = o(c.length), f = i(u, s); if (t && n != n) { for (; s > f;) if (a = c[f++], a != a) return !0 } else for (; s > f; f++) if ((t || f in c) && c[f] === n) return t || f || 0; return !t && -1 } } }, function (t, e, n) { var r = n(38), o = Math.min; t.exports = function (t) { return t > 0 ? o(r(t), 9007199254740991) : 0 } }, function (t, e) { var n = Math.ceil, r = Math.floor; t.exports = function (t) { return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t) } }, function (t, e, n) { var r = n(38), o = Math.max, i = Math.min; t.exports = function (t, e) { return t = r(t), 0 > t ? o(t + e, 0) : i(t, e) } }, function (t, e, n) { var r = n(23)("keys"), o = n(19); t.exports = function (t) { return r[t] || (r[t] = o(t)) } }, function (t, e) { t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",") }, function (t, e, n) { var r = n(30), o = n(43), i = n(44); t.exports = function (t) { var e = r(t), n = o.f; if (n) for (var u, a = n(t), c = i.f, s = 0; a.length > s;) c.call(t, u = a[s++]) && e.push(u); return e } }, function (t, e) { e.f = Object.getOwnPropertySymbols }, function (t, e) { e.f = {}.propertyIsEnumerable }, function (t, e, n) { var r = n(34); t.exports = Array.isArray || function (t) { return "Array" == r(t) } }, function (t, e, n) { var r = n(12), o = n(47), i = n(41), u = n(40)("IE_PROTO"), a = function () { }, c = "prototype", s = function () { var t, e = n(15)("iframe"), r = i.length, o = "<", u = ">"; for (e.style.display = "none", n(48).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write(o + "script" + u + "document.F=Object" + o + "/script" + u), t.close(), s = t.F; r--;) delete s[c][i[r]]; return s() }; t.exports = Object.create || function (t, e) { var n; return null !== t ? (a[c] = r(t), n = new a, a[c] = null, n[u] = t) : n = s(), void 0 === e ? n : o(n, e) } }, function (t, e, n) { var r = n(11), o = n(12), i = n(30); t.exports = n(6) ? Object.defineProperties : function (t, e) { o(t); for (var n, u = i(e), a = u.length, c = 0; a > c;) r.f(t, n = u[c++], e[n]); return t } }, function (t, e, n) { t.exports = n(4).document && document.documentElement }, function (t, e, n) { var r = n(32), o = n(50).f, i = {}.toString, u = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], a = function (t) { try { return o(t) } catch (e) { return u.slice() } }; t.exports.f = function (t) { return u && "[object Window]" == i.call(t) ? a(t) : o(r(t)) } }, function (t, e, n) { var r = n(31), o = n(41).concat("length", "prototype"); e.f = Object.getOwnPropertyNames || function (t) { return r(t, o) } }, function (t, e, n) { var r = n(44), o = n(17), i = n(32), u = n(16), a = n(5), c = n(14), s = Object.getOwnPropertyDescriptor; e.f = n(6) ? s : function (t, e) { if (t = i(t), e = u(e, !0), c) try { return s(t, e) } catch (n) { } return a(t, e) ? o(!r.f.call(t, e), t[e]) : void 0 } }, function (t, e, n) { var r = n(8); r(r.S, "Object", { create: n(46) }) }, function (t, e, n) { var r = n(8); r(r.S + r.F * !n(6), "Object", { defineProperty: n(11).f }) }, function (t, e, n) { var r = n(8); r(r.S + r.F * !n(6), "Object", { defineProperties: n(47) }) }, function (t, e, n) { var r = n(32), o = n(51).f; n(56)("getOwnPropertyDescriptor", function () { return function (t, e) { return o(r(t), e) } }) }, function (t, e, n) { var r = n(8), o = n(9), i = n(7); t.exports = function (t, e) { var n = (o.Object || {})[t] || Object[t], u = {}; u[t] = e(n), r(r.S + r.F * i(function () { n(1) }), "Object", u) } }, function (t, e, n) { var r = n(58), o = n(59); n(56)("getPrototypeOf", function () { return function (t) { return o(r(t)) } }) }, function (t, e, n) { var r = n(35); t.exports = function (t) { return Object(r(t)) } }, function (t, e, n) { var r = n(5), o = n(58), i = n(40)("IE_PROTO"), u = Object.prototype; t.exports = Object.getPrototypeOf || function (t) { return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null } }, function (t, e, n) { var r = n(58), o = n(30); n(56)("keys", function () { return function (t) { return o(r(t)) } }) }, function (t, e, n) { n(56)("getOwnPropertyNames", function () { return n(49).f }) }, function (t, e, n) { var r = n(13), o = n(22).onFreeze; n(56)("freeze", function (t) { return function (e) { return t && r(e) ? t(o(e)) : e } }) }, function (t, e, n) { var r = n(13), o = n(22).onFreeze; n(56)("seal", function (t) { return function (e) { return t && r(e) ? t(o(e)) : e } }) }, function (t, e, n) { var r = n(13), o = n(22).onFreeze; n(56)("preventExtensions", function (t) { return function (e) { return t && r(e) ? t(o(e)) : e } }) }, function (t, e, n) { var r = n(13); n(56)("isFrozen", function (t) { return function (e) { return r(e) ? t ? t(e) : !1 : !0 } }) }, function (t, e, n) { var r = n(13); n(56)("isSealed", function (t) { return function (e) { return r(e) ? t ? t(e) : !1 : !0 } }) }, function (t, e, n) { var r = n(13); n(56)("isExtensible", function (t) { return function (e) { return r(e) ? t ? t(e) : !0 : !1 } }) }, function (t, e, n) { var r = n(8); r(r.S + r.F, "Object", { assign: n(69) }) }, function (t, e, n) { "use strict"; var r = n(30), o = n(43), i = n(44), u = n(58), a = n(33), c = Object.assign; t.exports = !c || n(7)(function () { var t = {}, e = {}, n = Symbol(), r = "abcdefghijklmnopqrst"; return t[n] = 7, r.split("").forEach(function (t) { e[t] = t }), 7 != c({}, t)[n] || Object.keys(c({}, e)).join("") != r }) ? function (t, e) { for (var n = u(t), c = arguments.length, s = 1, f = o.f, l = i.f; c > s;) for (var p, v = a(arguments[s++]), h = f ? r(v).concat(f(v)) : r(v), d = h.length, y = 0; d > y;) l.call(v, p = h[y++]) && (n[p] = v[p]); return n } : c }, function (t, e, n) { var r = n(8); r(r.S, "Object", { is: n(71) }) }, function (t, e) { t.exports = Object.is || function (t, e) { return t === e ? 0 !== t || 1 / t === 1 / e : t != t && e != e } }, function (t, e, n) { var r = n(8); r(r.S, "Object", { setPrototypeOf: n(73).set }) }, function (t, e, n) { var r = n(13), o = n(12), i = function (t, e) { if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!") }; t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) { try { r = n(20)(Function.call, n(51).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array) } catch (o) { e = !0 } return function (t, n) { return i(t, n), e ? t.__proto__ = n : r(t, n), t } }({}, !1) : void 0), check: i } }, function (t, e, n) { "use strict"; var r = n(75), o = {}; o[n(25)("toStringTag")] = "z", o + "" != "[object z]" && n(18)(Object.prototype, "toString", function () { return "[object " + r(this) + "]" }, !0) }, function (t, e, n) { var r = n(34), o = n(25)("toStringTag"), i = "Arguments" == r(function () { return arguments }()), u = function (t, e) { try { return t[e] } catch (n) { } }; t.exports = function (t) { var e, n, a; return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = u(e = Object(t), o)) ? n : i ? r(e) : "Object" == (a = r(e)) && "function" == typeof e.callee ? "Arguments" : a } }, function (t, e, n) { var r = n(8); r(r.P, "Function", { bind: n(77) }) }, function (t, e, n) { "use strict"; var r = n(21), o = n(13), i = n(78), u = [].slice, a = {}, c = function (t, e, n) { if (!(e in a)) { for (var r = [], o = 0; e > o; o++) r[o] = "a[" + o + "]"; a[e] = Function("F,a", "return new F(" + r.join(",") + ")") } return a[e](t, n) }; t.exports = Function.bind || function (t) { var e = r(this), n = u.call(arguments, 1), a = function () { var r = n.concat(u.call(arguments)); return this instanceof a ? c(e, r.length, r) : i(e, r, t) }; return o(e.prototype) && (a.prototype = e.prototype), a } }, function (t, e) { t.exports = function (t, e, n) { var r = void 0 === n; switch (e.length) { case 0: return r ? t() : t.call(n); case 1: return r ? t(e[0]) : t.call(n, e[0]); case 2: return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]); case 3: return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]); case 4: return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]) } return t.apply(n, e) } }, function (t, e, n) { var r = n(11).f, o = n(17), i = n(5), u = Function.prototype, a = /^\s*function ([^ (]*)/, c = "name", s = Object.isExtensible || function () { return !0 }; c in u || n(6) && r(u, c, { configurable: !0, get: function () { try { var t = this, e = ("" + t).match(a)[1]; return i(t, c) || !s(t) || r(t, c, o(5, e)), e } catch (n) { return "" } } }) }, function (t, e, n) { "use strict"; var r = n(13), o = n(59), i = n(25)("hasInstance"), u = Function.prototype; i in u || n(11).f(u, i, { value: function (t) { if ("function" != typeof this || !r(t)) return !1; if (!r(this.prototype)) return t instanceof this; for (; t = o(t) ;) if (this.prototype === t) return !0; return !1 } }) }, function (t, e, n) { var r = n(8), o = n(82); r(r.G + r.F * (parseInt != o), { parseInt: o }) }, function (t, e, n) { var r = n(4).parseInt, o = n(83).trim, i = n(84), u = /^[\-+]?0[xX]/; t.exports = 8 !== r(i + "08") || 22 !== r(i + "0x16") ? function (t, e) { var n = o(String(t), 3); return r(n, e >>> 0 || (u.test(n) ? 16 : 10)) } : r }, function (t, e, n) {
                    var r = n(8), o = n(35), i = n(7), u = n(84), a = "[" + u + "]", c = "", s = RegExp("^" + a + a + "*"), f = RegExp(a + a + "*$"), l = function (t, e, n) { var o = {}, a = i(function () { return !!u[t]() || c[t]() != c }), s = o[t] = a ? e(p) : u[t]; n && (o[n] = s), r(r.P + r.F * a, "String", o) }, p = l.trim = function (t, e) { return t = String(o(t)), 1 & e && (t = t.replace(s, "")), 2 & e && (t = t.replace(f, "")), t }; t.exports = l
                }, function (t, e) { t.exports = "	\n\x0B\f\r   ᠎             　\u2028\u2029\ufeff" }, function (t, e, n) { var r = n(8), o = n(86); r(r.G + r.F * (parseFloat != o), { parseFloat: o }) }, function (t, e, n) { var r = n(4).parseFloat, o = n(83).trim; t.exports = 1 / r(n(84) + "-0") !== -(1 / 0) ? function (t) { var e = o(String(t), 3), n = r(e); return 0 === n && "-" == e.charAt(0) ? -0 : n } : r }, function (t, e, n) { "use strict"; var r = n(4), o = n(5), i = n(34), u = n(88), a = n(16), c = n(7), s = n(50).f, f = n(51).f, l = n(11).f, p = n(83).trim, v = "Number", h = r[v], d = h, y = h.prototype, g = i(n(46)(y)) == v, b = "trim" in String.prototype, w = function (t) { var e = a(t, !1); if ("string" == typeof e && e.length > 2) { e = b ? e.trim() : p(e, 3); var n, r, o, i = e.charCodeAt(0); if (43 === i || 45 === i) { if (n = e.charCodeAt(2), 88 === n || 120 === n) return NaN } else if (48 === i) { switch (e.charCodeAt(1)) { case 66: case 98: r = 2, o = 49; break; case 79: case 111: r = 8, o = 55; break; default: return +e } for (var u, c = e.slice(2), s = 0, f = c.length; f > s; s++) if (u = c.charCodeAt(s), 48 > u || u > o) return NaN; return parseInt(c, r) } } return +e }; if (!h(" 0o1") || !h("0b1") || h("+0x1")) { h = function (t) { var e = arguments.length < 1 ? 0 : t, n = this; return n instanceof h && (g ? c(function () { y.valueOf.call(n) }) : i(n) != v) ? u(new d(w(e)), n, h) : w(e) }; for (var m, _ = n(6) ? s(d) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), O = 0; _.length > O; O++) o(d, m = _[O]) && !o(h, m) && l(h, m, f(d, m)); h.prototype = y, y.constructor = h, n(18)(r, v, h) } }, function (t, e, n) { var r = n(13), o = n(73).set; t.exports = function (t, e, n) { var i, u = e.constructor; return u !== n && "function" == typeof u && (i = u.prototype) !== n.prototype && r(i) && o && o(t, i), t } }, function (t, e, n) { "use strict"; var r = n(8), o = n(38), i = n(90), u = n(91), a = 1..toFixed, c = Math.floor, s = [0, 0, 0, 0, 0, 0], f = "Number.toFixed: incorrect invocation!", l = "0", p = function (t, e) { for (var n = -1, r = e; ++n < 6;) r += t * s[n], s[n] = r % 1e7, r = c(r / 1e7) }, v = function (t) { for (var e = 6, n = 0; --e >= 0;) n += s[e], s[e] = c(n / t), n = n % t * 1e7 }, h = function () { for (var t = 6, e = ""; --t >= 0;) if ("" !== e || 0 === t || 0 !== s[t]) { var n = String(s[t]); e = "" === e ? n : e + u.call(l, 7 - n.length) + n } return e }, d = function (t, e, n) { return 0 === e ? n : e % 2 === 1 ? d(t, e - 1, n * t) : d(t * t, e / 2, n) }, y = function (t) { for (var e = 0, n = t; n >= 4096;) e += 12, n /= 4096; for (; n >= 2;) e += 1, n /= 2; return e }; r(r.P + r.F * (!!a && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !n(7)(function () { a.call({}) })), "Number", { toFixed: function (t) { var e, n, r, a, c = i(this, f), s = o(t), g = "", b = l; if (0 > s || s > 20) throw RangeError(f); if (c != c) return "NaN"; if (-1e21 >= c || c >= 1e21) return String(c); if (0 > c && (g = "-", c = -c), c > 1e-21) if (e = y(c * d(2, 69, 1)) - 69, n = 0 > e ? c * d(2, -e, 1) : c / d(2, e, 1), n *= 4503599627370496, e = 52 - e, e > 0) { for (p(0, n), r = s; r >= 7;) p(1e7, 0), r -= 7; for (p(d(10, r, 1), 0), r = e - 1; r >= 23;) v(1 << 23), r -= 23; v(1 << r), p(1, 1), v(2), b = h() } else p(0, n), p(1 << -e, 0), b = h() + u.call(l, s); return s > 0 ? (a = b.length, b = g + (s >= a ? "0." + u.call(l, s - a) + b : b.slice(0, a - s) + "." + b.slice(a - s))) : b = g + b, b } }) }, function (t, e, n) { var r = n(34); t.exports = function (t, e) { if ("number" != typeof t && "Number" != r(t)) throw TypeError(e); return +t } }, function (t, e, n) { "use strict"; var r = n(38), o = n(35); t.exports = function (t) { var e = String(o(this)), n = "", i = r(t); if (0 > i || i == 1 / 0) throw RangeError("Count can't be negative"); for (; i > 0; (i >>>= 1) && (e += e)) 1 & i && (n += e); return n } }, function (t, e, n) { "use strict"; var r = n(8), o = n(7), i = n(90), u = 1..toPrecision; r(r.P + r.F * (o(function () { return "1" !== u.call(1, void 0) }) || !o(function () { u.call({}) })), "Number", { toPrecision: function (t) { var e = i(this, "Number#toPrecision: incorrect invocation!"); return void 0 === t ? u.call(e) : u.call(e, t) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Number", { EPSILON: Math.pow(2, -52) }) }, function (t, e, n) { var r = n(8), o = n(4).isFinite; r(r.S, "Number", { isFinite: function (t) { return "number" == typeof t && o(t) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Number", { isInteger: n(96) }) }, function (t, e, n) { var r = n(13), o = Math.floor; t.exports = function (t) { return !r(t) && isFinite(t) && o(t) === t } }, function (t, e, n) { var r = n(8); r(r.S, "Number", { isNaN: function (t) { return t != t } }) }, function (t, e, n) { var r = n(8), o = n(96), i = Math.abs; r(r.S, "Number", { isSafeInteger: function (t) { return o(t) && i(t) <= 9007199254740991 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 }) }, function (t, e, n) { var r = n(8); r(r.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 }) }, function (t, e, n) { var r = n(8), o = n(86); r(r.S + r.F * (Number.parseFloat != o), "Number", { parseFloat: o }) }, function (t, e, n) { var r = n(8), o = n(82); r(r.S + r.F * (Number.parseInt != o), "Number", { parseInt: o }) }, function (t, e, n) { var r = n(8), o = n(104), i = Math.sqrt, u = Math.acosh; r(r.S + r.F * !(u && 710 == Math.floor(u(Number.MAX_VALUE)) && u(1 / 0) == 1 / 0), "Math", { acosh: function (t) { return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : o(t - 1 + i(t - 1) * i(t + 1)) } }) }, function (t, e) { t.exports = Math.log1p || function (t) { return (t = +t) > -1e-8 && 1e-8 > t ? t - t * t / 2 : Math.log(1 + t) } }, function (t, e, n) { function r(t) { return isFinite(t = +t) && 0 != t ? 0 > t ? -r(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t } var o = n(8), i = Math.asinh; o(o.S + o.F * !(i && 1 / i(0) > 0), "Math", { asinh: r }) }, function (t, e, n) { var r = n(8), o = Math.atanh; r(r.S + r.F * !(o && 1 / o(-0) < 0), "Math", { atanh: function (t) { return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2 } }) }, function (t, e, n) { var r = n(8), o = n(108); r(r.S, "Math", { cbrt: function (t) { return o(t = +t) * Math.pow(Math.abs(t), 1 / 3) } }) }, function (t, e) { t.exports = Math.sign || function (t) { return 0 == (t = +t) || t != t ? t : 0 > t ? -1 : 1 } }, function (t, e, n) { var r = n(8); r(r.S, "Math", { clz32: function (t) { return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32 } }) }, function (t, e, n) { var r = n(8), o = Math.exp; r(r.S, "Math", { cosh: function (t) { return (o(t = +t) + o(-t)) / 2 } }) }, function (t, e, n) { var r = n(8), o = n(112); r(r.S + r.F * (o != Math.expm1), "Math", { expm1: o }) }, function (t, e) { var n = Math.expm1; t.exports = !n || n(10) > 22025.465794806718 || n(10) < 22025.465794806718 || -2e-17 != n(-2e-17) ? function (t) { return 0 == (t = +t) ? t : t > -1e-6 && 1e-6 > t ? t + t * t / 2 : Math.exp(t) - 1 } : n }, function (t, e, n) { var r = n(8), o = n(108), i = Math.pow, u = i(2, -52), a = i(2, -23), c = i(2, 127) * (2 - a), s = i(2, -126), f = function (t) { return t + 1 / u - 1 / u }; r(r.S, "Math", { fround: function (t) { var e, n, r = Math.abs(t), i = o(t); return s > r ? i * f(r / s / a) * s * a : (e = (1 + a / u) * r, n = e - (e - r), n > c || n != n ? i * (1 / 0) : i * n) } }) }, function (t, e, n) { var r = n(8), o = Math.abs; r(r.S, "Math", { hypot: function (t, e) { for (var n, r, i = 0, u = 0, a = arguments.length, c = 0; a > u;) n = o(arguments[u++]), n > c ? (r = c / n, i = i * r * r + 1, c = n) : n > 0 ? (r = n / c, i += r * r) : i += n; return c === 1 / 0 ? 1 / 0 : c * Math.sqrt(i) } }) }, function (t, e, n) { var r = n(8), o = Math.imul; r(r.S + r.F * n(7)(function () { return -5 != o(4294967295, 5) || 2 != o.length }), "Math", { imul: function (t, e) { var n = 65535, r = +t, o = +e, i = n & r, u = n & o; return 0 | i * u + ((n & r >>> 16) * u + i * (n & o >>> 16) << 16 >>> 0) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { log10: function (t) { return Math.log(t) / Math.LN10 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { log1p: n(104) }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { log2: function (t) { return Math.log(t) / Math.LN2 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { sign: n(108) }) }, function (t, e, n) { var r = n(8), o = n(112), i = Math.exp; r(r.S + r.F * n(7)(function () { return -2e-17 != !Math.sinh(-2e-17) }), "Math", { sinh: function (t) { return Math.abs(t = +t) < 1 ? (o(t) - o(-t)) / 2 : (i(t - 1) - i(-t - 1)) * (Math.E / 2) } }) }, function (t, e, n) { var r = n(8), o = n(112), i = Math.exp; r(r.S, "Math", { tanh: function (t) { var e = o(t = +t), n = o(-t); return e == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (e - n) / (i(t) + i(-t)) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { trunc: function (t) { return (t > 0 ? Math.floor : Math.ceil)(t) } }) }, function (t, e, n) { var r = n(8), o = n(39), i = String.fromCharCode, u = String.fromCodePoint; r(r.S + r.F * (!!u && 1 != u.length), "String", { fromCodePoint: function (t) { for (var e, n = [], r = arguments.length, u = 0; r > u;) { if (e = +arguments[u++], o(e, 1114111) !== e) throw RangeError(e + " is not a valid code point"); n.push(65536 > e ? i(e) : i(((e -= 65536) >> 10) + 55296, e % 1024 + 56320)) } return n.join("") } }) }, function (t, e, n) { var r = n(8), o = n(32), i = n(37); r(r.S, "String", { raw: function (t) { for (var e = o(t.raw), n = i(e.length), r = arguments.length, u = [], a = 0; n > a;) u.push(String(e[a++])), r > a && u.push(String(arguments[a])); return u.join("") } }) }, function (t, e, n) { "use strict"; n(83)("trim", function (t) { return function () { return t(this, 3) } }) }, function (t, e, n) { "use strict"; var r = n(127)(!0); n(128)(String, "String", function (t) { this._t = String(t), this._i = 0 }, function () { var t, e = this._t, n = this._i; return n >= e.length ? { value: void 0, done: !0 } : (t = r(e, n), this._i += t.length, { value: t, done: !1 }) }) }, function (t, e, n) { var r = n(38), o = n(35); t.exports = function (t) { return function (e, n) { var i, u, a = String(o(e)), c = r(n), s = a.length; return 0 > c || c >= s ? t ? "" : void 0 : (i = a.charCodeAt(c), 55296 > i || i > 56319 || c + 1 === s || (u = a.charCodeAt(c + 1)) < 56320 || u > 57343 ? t ? a.charAt(c) : i : t ? a.slice(c, c + 2) : (i - 55296 << 10) + (u - 56320) + 65536) } } }, function (t, e, n) { "use strict"; var r = n(28), o = n(8), i = n(18), u = n(10), a = n(5), c = n(129), s = n(130), f = n(24), l = n(59), p = n(25)("iterator"), v = !([].keys && "next" in [].keys()), h = "@@iterator", d = "keys", y = "values", g = function () { return this }; t.exports = function (t, e, n, b, w, m, _) { s(n, e, b); var O, x, j, E = function (t) { if (!v && t in k) return k[t]; switch (t) { case d: return function () { return new n(this, t) }; case y: return function () { return new n(this, t) } } return function () { return new n(this, t) } }, P = e + " Iterator", S = w == y, M = !1, k = t.prototype, A = k[p] || k[h] || w && k[w], T = A || E(w), F = w ? S ? E("entries") : T : void 0, N = "Array" == e ? k.entries || A : A; if (N && (j = l(N.call(new t)), j !== Object.prototype && (f(j, P, !0), r || a(j, p) || u(j, p, g))), S && A && A.name !== y && (M = !0, T = function () { return A.call(this) }), r && !_ || !v && !M && k[p] || u(k, p, T), c[e] = T, c[P] = g, w) if (O = { values: S ? T : E(y), keys: m ? T : E(d), entries: F }, _) for (x in O) x in k || i(k, x, O[x]); else o(o.P + o.F * (v || M), e, O); return O } }, function (t, e) { t.exports = {} }, function (t, e, n) { "use strict"; var r = n(46), o = n(17), i = n(24), u = {}; n(10)(u, n(25)("iterator"), function () { return this }), t.exports = function (t, e, n) { t.prototype = r(u, { next: o(1, n) }), i(t, e + " Iterator") } }, function (t, e, n) { "use strict"; var r = n(8), o = n(127)(!1); r(r.P, "String", { codePointAt: function (t) { return o(this, t) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(37), i = n(133), u = "endsWith", a = ""[u]; r(r.P + r.F * n(135)(u), "String", { endsWith: function (t) { var e = i(this, t, u), n = arguments.length > 1 ? arguments[1] : void 0, r = o(e.length), c = void 0 === n ? r : Math.min(o(n), r), s = String(t); return a ? a.call(e, s, c) : e.slice(c - s.length, c) === s } }) }, function (t, e, n) { var r = n(134), o = n(35); t.exports = function (t, e, n) { if (r(e)) throw TypeError("String#" + n + " doesn't accept regex!"); return String(o(t)) } }, function (t, e, n) { var r = n(13), o = n(34), i = n(25)("match"); t.exports = function (t) { var e; return r(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t)) } }, function (t, e, n) { var r = n(25)("match"); t.exports = function (t) { var e = /./; try { "/./"[t](e) } catch (n) { try { return e[r] = !1, !"/./"[t](e) } catch (o) { } } return !0 } }, function (t, e, n) { "use strict"; var r = n(8), o = n(133), i = "includes"; r(r.P + r.F * n(135)(i), "String", { includes: function (t) { return !!~o(this, t, i).indexOf(t, arguments.length > 1 ? arguments[1] : void 0) } }) }, function (t, e, n) { var r = n(8); r(r.P, "String", { repeat: n(91) }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(37), i = n(133), u = "startsWith", a = ""[u]; r(r.P + r.F * n(135)(u), "String", { startsWith: function (t) { var e = i(this, t, u), n = o(Math.min(arguments.length > 1 ? arguments[1] : void 0, e.length)), r = String(t); return a ? a.call(e, r, n) : e.slice(n, n + r.length) === r } }) }, function (t, e, n) { "use strict"; n(140)("anchor", function (t) { return function (e) { return t(this, "a", "name", e) } }) }, function (t, e, n) { var r = n(8), o = n(7), i = n(35), u = /"/g, a = function (t, e, n, r) { var o = String(i(t)), a = "<" + e; return "" !== n && (a += " " + n + '="' + String(r).replace(u, "&quot;") + '"'), a + ">" + o + "</" + e + ">" }; t.exports = function (t, e) { var n = {}; n[t] = e(a), r(r.P + r.F * o(function () { var e = ""[t]('"'); return e !== e.toLowerCase() || e.split('"').length > 3 }), "String", n) } }, function (t, e, n) { "use strict"; n(140)("big", function (t) { return function () { return t(this, "big", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("blink", function (t) { return function () { return t(this, "blink", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("bold", function (t) { return function () { return t(this, "b", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("fixed", function (t) { return function () { return t(this, "tt", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("fontcolor", function (t) { return function (e) { return t(this, "font", "color", e) } }) }, function (t, e, n) { "use strict"; n(140)("fontsize", function (t) { return function (e) { return t(this, "font", "size", e) } }) }, function (t, e, n) { "use strict"; n(140)("italics", function (t) { return function () { return t(this, "i", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("link", function (t) { return function (e) { return t(this, "a", "href", e) } }) }, function (t, e, n) { "use strict"; n(140)("small", function (t) { return function () { return t(this, "small", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("strike", function (t) { return function () { return t(this, "strike", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("sub", function (t) { return function () { return t(this, "sub", "", "") } }) }, function (t, e, n) { "use strict"; n(140)("sup", function (t) { return function () { return t(this, "sup", "", "") } }) }, function (t, e, n) { var r = n(8); r(r.S, "Date", { now: function () { return (new Date).getTime() } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(58), i = n(16); r(r.P + r.F * n(7)(function () { return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({ toISOString: function () { return 1 } }) }), "Date", { toJSON: function (t) { var e = o(this), n = i(e); return "number" != typeof n || isFinite(n) ? e.toISOString() : null } }) }, function (t, e, n) {
                    "use strict"; var r = n(8), o = n(7), i = Date.prototype.getTime, u = function (t) { return t > 9 ? t : "0" + t }; r(r.P + r.F * (o(function () {
                        return "0385-07-25T07:06:39.999Z" != new Date(-5e13 - 1).toISOString();
                    }) || !o(function () { new Date(NaN).toISOString() })), "Date", { toISOString: function () { if (!isFinite(i.call(this))) throw RangeError("Invalid time value"); var t = this, e = t.getUTCFullYear(), n = t.getUTCMilliseconds(), r = 0 > e ? "-" : e > 9999 ? "+" : ""; return r + ("00000" + Math.abs(e)).slice(r ? -6 : -4) + "-" + u(t.getUTCMonth() + 1) + "-" + u(t.getUTCDate()) + "T" + u(t.getUTCHours()) + ":" + u(t.getUTCMinutes()) + ":" + u(t.getUTCSeconds()) + "." + (n > 99 ? n : "0" + u(n)) + "Z" } })
                }, function (t, e, n) { var r = Date.prototype, o = "Invalid Date", i = "toString", u = r[i], a = r.getTime; new Date(NaN) + "" != o && n(18)(r, i, function () { var t = a.call(this); return t === t ? u.call(this) : o }) }, function (t, e, n) { var r = n(25)("toPrimitive"), o = Date.prototype; r in o || n(10)(o, r, n(158)) }, function (t, e, n) { "use strict"; var r = n(12), o = n(16), i = "number"; t.exports = function (t) { if ("string" !== t && t !== i && "default" !== t) throw TypeError("Incorrect hint"); return o(r(this), t != i) } }, function (t, e, n) { var r = n(8); r(r.S, "Array", { isArray: n(45) }) }, function (t, e, n) { "use strict"; var r = n(20), o = n(8), i = n(58), u = n(161), a = n(162), c = n(37), s = n(163), f = n(164); o(o.S + o.F * !n(165)(function (t) { Array.from(t) }), "Array", { from: function (t) { var e, n, o, l, p = i(t), v = "function" == typeof this ? this : Array, h = arguments.length, d = h > 1 ? arguments[1] : void 0, y = void 0 !== d, g = 0, b = f(p); if (y && (d = r(d, h > 2 ? arguments[2] : void 0, 2)), void 0 == b || v == Array && a(b)) for (e = c(p.length), n = new v(e) ; e > g; g++) s(n, g, y ? d(p[g], g) : p[g]); else for (l = b.call(p), n = new v; !(o = l.next()).done; g++) s(n, g, y ? u(l, d, [o.value, g], !0) : o.value); return n.length = g, n } }) }, function (t, e, n) { var r = n(12); t.exports = function (t, e, n, o) { try { return o ? e(r(n)[0], n[1]) : e(n) } catch (i) { var u = t["return"]; throw void 0 !== u && r(u.call(t)), i } } }, function (t, e, n) { var r = n(129), o = n(25)("iterator"), i = Array.prototype; t.exports = function (t) { return void 0 !== t && (r.Array === t || i[o] === t) } }, function (t, e, n) { "use strict"; var r = n(11), o = n(17); t.exports = function (t, e, n) { e in t ? r.f(t, e, o(0, n)) : t[e] = n } }, function (t, e, n) { var r = n(75), o = n(25)("iterator"), i = n(129); t.exports = n(9).getIteratorMethod = function (t) { return void 0 != t ? t[o] || t["@@iterator"] || i[r(t)] : void 0 } }, function (t, e, n) { var r = n(25)("iterator"), o = !1; try { var i = [7][r](); i["return"] = function () { o = !0 }, Array.from(i, function () { throw 2 }) } catch (u) { } t.exports = function (t, e) { if (!e && !o) return !1; var n = !1; try { var i = [7], u = i[r](); u.next = function () { return { done: n = !0 } }, i[r] = function () { return u }, t(i) } catch (a) { } return n } }, function (t, e, n) { "use strict"; var r = n(8), o = n(163); r(r.S + r.F * n(7)(function () { function t() { } return !(Array.of.call(t) instanceof t) }), "Array", { of: function () { for (var t = 0, e = arguments.length, n = new ("function" == typeof this ? this : Array)(e) ; e > t;) o(n, t, arguments[t++]); return n.length = e, n } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(32), i = [].join; r(r.P + r.F * (n(33) != Object || !n(168)(i)), "Array", { join: function (t) { return i.call(o(this), void 0 === t ? "," : t) } }) }, function (t, e, n) { var r = n(7); t.exports = function (t, e) { return !!t && r(function () { e ? t.call(null, function () { }, 1) : t.call(null) }) } }, function (t, e, n) { "use strict"; var r = n(8), o = n(48), i = n(34), u = n(39), a = n(37), c = [].slice; r(r.P + r.F * n(7)(function () { o && c.call(o) }), "Array", { slice: function (t, e) { var n = a(this.length), r = i(this); if (e = void 0 === e ? n : e, "Array" == r) return c.call(this, t, e); for (var o = u(t, n), s = u(e, n), f = a(s - o), l = Array(f), p = 0; f > p; p++) l[p] = "String" == r ? this.charAt(o + p) : this[o + p]; return l } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(21), i = n(58), u = n(7), a = [].sort, c = [1, 2, 3]; r(r.P + r.F * (u(function () { c.sort(void 0) }) || !u(function () { c.sort(null) }) || !n(168)(a)), "Array", { sort: function (t) { return void 0 === t ? a.call(i(this)) : a.call(i(this), o(t)) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(0), i = n(168)([].forEach, !0); r(r.P + r.F * !i, "Array", { forEach: function (t) { return o(this, t, arguments[1]) } }) }, function (t, e, n) { var r = n(20), o = n(33), i = n(58), u = n(37), a = n(173); t.exports = function (t, e) { var n = 1 == t, c = 2 == t, s = 3 == t, f = 4 == t, l = 6 == t, p = 5 == t || l, v = e || a; return function (e, a, h) { for (var d, y, g = i(e), b = o(g), w = r(a, h, 3), m = u(b.length), _ = 0, O = n ? v(e, m) : c ? v(e, 0) : void 0; m > _; _++) if ((p || _ in b) && (d = b[_], y = w(d, _, g), t)) if (n) O[_] = y; else if (y) switch (t) { case 3: return !0; case 5: return d; case 6: return _; case 2: O.push(d) } else if (f) return !1; return l ? -1 : s || f ? f : O } } }, function (t, e, n) { var r = n(174); t.exports = function (t, e) { return new (r(t))(e) } }, function (t, e, n) { var r = n(13), o = n(45), i = n(25)("species"); t.exports = function (t) { var e; return o(t) && (e = t.constructor, "function" != typeof e || e !== Array && !o(e.prototype) || (e = void 0), r(e) && (e = e[i], null === e && (e = void 0))), void 0 === e ? Array : e } }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(1); r(r.P + r.F * !n(168)([].map, !0), "Array", { map: function (t) { return o(this, t, arguments[1]) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(2); r(r.P + r.F * !n(168)([].filter, !0), "Array", { filter: function (t) { return o(this, t, arguments[1]) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(3); r(r.P + r.F * !n(168)([].some, !0), "Array", { some: function (t) { return o(this, t, arguments[1]) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(4); r(r.P + r.F * !n(168)([].every, !0), "Array", { every: function (t) { return o(this, t, arguments[1]) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(180); r(r.P + r.F * !n(168)([].reduce, !0), "Array", { reduce: function (t) { return o(this, t, arguments.length, arguments[1], !1) } }) }, function (t, e, n) { var r = n(21), o = n(58), i = n(33), u = n(37); t.exports = function (t, e, n, a, c) { r(e); var s = o(t), f = i(s), l = u(s.length), p = c ? l - 1 : 0, v = c ? -1 : 1; if (2 > n) for (; ;) { if (p in f) { a = f[p], p += v; break } if (p += v, c ? 0 > p : p >= l) throw TypeError("Reduce of empty array with no initial value") } for (; c ? p >= 0 : l > p; p += v) p in f && (a = e(a, f[p], p, s)); return a } }, function (t, e, n) { "use strict"; var r = n(8), o = n(180); r(r.P + r.F * !n(168)([].reduceRight, !0), "Array", { reduceRight: function (t) { return o(this, t, arguments.length, arguments[1], !0) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(36)(!1), i = [].indexOf, u = !!i && 1 / [1].indexOf(1, -0) < 0; r(r.P + r.F * (u || !n(168)(i)), "Array", { indexOf: function (t) { return u ? i.apply(this, arguments) || 0 : o(this, t, arguments[1]) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(32), i = n(38), u = n(37), a = [].lastIndexOf, c = !!a && 1 / [1].lastIndexOf(1, -0) < 0; r(r.P + r.F * (c || !n(168)(a)), "Array", { lastIndexOf: function (t) { if (c) return a.apply(this, arguments) || 0; var e = o(this), n = u(e.length), r = n - 1; for (arguments.length > 1 && (r = Math.min(r, i(arguments[1]))), 0 > r && (r = n + r) ; r >= 0; r--) if (r in e && e[r] === t) return r || 0; return -1 } }) }, function (t, e, n) { var r = n(8); r(r.P, "Array", { copyWithin: n(185) }), n(186)("copyWithin") }, function (t, e, n) { "use strict"; var r = n(58), o = n(39), i = n(37); t.exports = [].copyWithin || function (t, e) { var n = r(this), u = i(n.length), a = o(t, u), c = o(e, u), s = arguments.length > 2 ? arguments[2] : void 0, f = Math.min((void 0 === s ? u : o(s, u)) - c, u - a), l = 1; for (a > c && c + f > a && (l = -1, c += f - 1, a += f - 1) ; f-- > 0;) c in n ? n[a] = n[c] : delete n[a], a += l, c += l; return n } }, function (t, e, n) { var r = n(25)("unscopables"), o = Array.prototype; void 0 == o[r] && n(10)(o, r, {}), t.exports = function (t) { o[r][t] = !0 } }, function (t, e, n) { var r = n(8); r(r.P, "Array", { fill: n(188) }), n(186)("fill") }, function (t, e, n) { "use strict"; var r = n(58), o = n(39), i = n(37); t.exports = function (t) { for (var e = r(this), n = i(e.length), u = arguments.length, a = o(u > 1 ? arguments[1] : void 0, n), c = u > 2 ? arguments[2] : void 0, s = void 0 === c ? n : o(c, n) ; s > a;) e[a++] = t; return e } }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(5), i = "find", u = !0; i in [] && Array(1)[i](function () { u = !1 }), r(r.P + r.F * u, "Array", { find: function (t) { return o(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(186)(i) }, function (t, e, n) { "use strict"; var r = n(8), o = n(172)(6), i = "findIndex", u = !0; i in [] && Array(1)[i](function () { u = !1 }), r(r.P + r.F * u, "Array", { findIndex: function (t) { return o(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(186)(i) }, function (t, e, n) { n(192)("Array") }, function (t, e, n) { "use strict"; var r = n(4), o = n(11), i = n(6), u = n(25)("species"); t.exports = function (t) { var e = r[t]; i && e && !e[u] && o.f(e, u, { configurable: !0, get: function () { return this } }) } }, function (t, e, n) { "use strict"; var r = n(186), o = n(194), i = n(129), u = n(32); t.exports = n(128)(Array, "Array", function (t, e) { this._t = u(t), this._i = 0, this._k = e }, function () { var t = this._t, e = this._k, n = this._i++; return !t || n >= t.length ? (this._t = void 0, o(1)) : "keys" == e ? o(0, n) : "values" == e ? o(0, t[n]) : o(0, [n, t[n]]) }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries") }, function (t, e) { t.exports = function (t, e) { return { value: e, done: !!t } } }, function (t, e, n) { var r = n(4), o = n(88), i = n(11).f, u = n(50).f, a = n(134), c = n(196), s = r.RegExp, f = s, l = s.prototype, p = /a/g, v = /a/g, h = new s(p) !== p; if (n(6) && (!h || n(7)(function () { return v[n(25)("match")] = !1, s(p) != p || s(v) == v || "/a/i" != s(p, "i") }))) { s = function (t, e) { var n = this instanceof s, r = a(t), i = void 0 === e; return !n && r && t.constructor === s && i ? t : o(h ? new f(r && !i ? t.source : t, e) : f((r = t instanceof s) ? t.source : t, r && i ? c.call(t) : e), n ? this : l, s) }; for (var d = (function (t) { t in s || i(s, t, { configurable: !0, get: function () { return f[t] }, set: function (e) { f[t] = e } }) }), y = u(f), g = 0; y.length > g;) d(y[g++]); l.constructor = s, s.prototype = l, n(18)(r, "RegExp", s) } n(192)("RegExp") }, function (t, e, n) { "use strict"; var r = n(12); t.exports = function () { var t = r(this), e = ""; return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e } }, function (t, e, n) { "use strict"; n(198); var r = n(12), o = n(196), i = n(6), u = "toString", a = /./[u], c = function (t) { n(18)(RegExp.prototype, u, t, !0) }; n(7)(function () { return "/a/b" != a.call({ source: "a", flags: "b" }) }) ? c(function () { var t = r(this); return "/".concat(t.source, "/", "flags" in t ? t.flags : !i && t instanceof RegExp ? o.call(t) : void 0) }) : a.name != u && c(function () { return a.call(this) }) }, function (t, e, n) { n(6) && "g" != /./g.flags && n(11).f(RegExp.prototype, "flags", { configurable: !0, get: n(196) }) }, function (t, e, n) { n(200)("match", 1, function (t, e, n) { return [function (n) { "use strict"; var r = t(this), o = void 0 == n ? void 0 : n[e]; return void 0 !== o ? o.call(n, r) : new RegExp(n)[e](String(r)) }, n] }) }, function (t, e, n) { "use strict"; var r = n(10), o = n(18), i = n(7), u = n(35), a = n(25); t.exports = function (t, e, n) { var c = a(t), s = n(u, c, ""[t]), f = s[0], l = s[1]; i(function () { var e = {}; return e[c] = function () { return 7 }, 7 != ""[t](e) }) && (o(String.prototype, t, f), r(RegExp.prototype, c, 2 == e ? function (t, e) { return l.call(t, this, e) } : function (t) { return l.call(t, this) })) } }, function (t, e, n) { n(200)("replace", 2, function (t, e, n) { return [function (r, o) { "use strict"; var i = t(this), u = void 0 == r ? void 0 : r[e]; return void 0 !== u ? u.call(r, i, o) : n.call(String(i), r, o) }, n] }) }, function (t, e, n) { n(200)("search", 1, function (t, e, n) { return [function (n) { "use strict"; var r = t(this), o = void 0 == n ? void 0 : n[e]; return void 0 !== o ? o.call(n, r) : new RegExp(n)[e](String(r)) }, n] }) }, function (t, e, n) { n(200)("split", 2, function (t, e, r) { "use strict"; var o = n(134), i = r, u = [].push, a = "split", c = "length", s = "lastIndex"; if ("c" == "abbc"[a](/(b)*/)[1] || 4 != "test"[a](/(?:)/, -1)[c] || 2 != "ab"[a](/(?:ab)*/)[c] || 4 != "."[a](/(.?)(.?)/)[c] || "."[a](/()()/)[c] > 1 || ""[a](/.?/)[c]) { var f = void 0 === /()??/.exec("")[1]; r = function (t, e) { var n = String(this); if (void 0 === t && 0 === e) return []; if (!o(t)) return i.call(n, t, e); var r, a, l, p, v, h = [], d = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), y = 0, g = void 0 === e ? 4294967295 : e >>> 0, b = new RegExp(t.source, d + "g"); for (f || (r = new RegExp("^" + b.source + "$(?!\\s)", d)) ; (a = b.exec(n)) && (l = a.index + a[0][c], !(l > y && (h.push(n.slice(y, a.index)), !f && a[c] > 1 && a[0].replace(r, function () { for (v = 1; v < arguments[c] - 2; v++) void 0 === arguments[v] && (a[v] = void 0) }), a[c] > 1 && a.index < n[c] && u.apply(h, a.slice(1)), p = a[0][c], y = l, h[c] >= g))) ;) b[s] === a.index && b[s]++; return y === n[c] ? !p && b.test("") || h.push("") : h.push(n.slice(y)), h[c] > g ? h.slice(0, g) : h } } else "0"[a](void 0, 0)[c] && (r = function (t, e) { return void 0 === t && 0 === e ? [] : i.call(this, t, e) }); return [function (n, o) { var i = t(this), u = void 0 == n ? void 0 : n[e]; return void 0 !== u ? u.call(n, i, o) : r.call(String(i), n, o) }, r] }) }, function (t, e, n) { "use strict"; var r, o, i, u = n(28), a = n(4), c = n(20), s = n(75), f = n(8), l = n(13), p = n(21), v = n(205), h = n(206), d = n(207), y = n(208).set, g = n(209)(), b = "Promise", w = a.TypeError, m = a.process, _ = a[b], m = a.process, O = "process" == s(m), x = function () { }, j = !!function () { try { var t = _.resolve(1), e = (t.constructor = {})[n(25)("species")] = function (t) { t(x, x) }; return (O || "function" == typeof PromiseRejectionEvent) && t.then(x) instanceof e } catch (r) { } }(), E = function (t, e) { return t === e || t === _ && e === i }, P = function (t) { var e; return l(t) && "function" == typeof (e = t.then) ? e : !1 }, S = function (t) { return E(_, t) ? new M(t) : new o(t) }, M = o = function (t) { var e, n; this.promise = new t(function (t, r) { if (void 0 !== e || void 0 !== n) throw w("Bad Promise constructor"); e = t, n = r }), this.resolve = p(e), this.reject = p(n) }, k = function (t) { try { t() } catch (e) { return { error: e } } }, A = function (t, e) { if (!t._n) { t._n = !0; var n = t._c; g(function () { for (var r = t._v, o = 1 == t._s, i = 0, u = function (e) { var n, i, u = o ? e.ok : e.fail, a = e.resolve, c = e.reject, s = e.domain; try { u ? (o || (2 == t._h && N(t), t._h = 1), u === !0 ? n = r : (s && s.enter(), n = u(r), s && s.exit()), n === e.promise ? c(w("Promise-chain cycle")) : (i = P(n)) ? i.call(n, a, c) : a(n)) : c(r) } catch (f) { c(f) } }; n.length > i;) u(n[i++]); t._c = [], t._n = !1, e && !t._h && T(t) }) } }, T = function (t) { y.call(a, function () { var e, n, r, o = t._v; if (F(t) && (e = k(function () { O ? m.emit("unhandledRejection", o, t) : (n = a.onunhandledrejection) ? n({ promise: t, reason: o }) : (r = a.console) && r.error && r.error("Unhandled promise rejection", o) }), t._h = O || F(t) ? 2 : 1), t._a = void 0, e) throw e.error }) }, F = function (t) { if (1 == t._h) return !1; for (var e, n = t._a || t._c, r = 0; n.length > r;) if (e = n[r++], e.fail || !F(e.promise)) return !1; return !0 }, N = function (t) { y.call(a, function () { var e; O ? m.emit("rejectionHandled", t) : (e = a.onrejectionhandled) && e({ promise: t, reason: t._v }) }) }, I = function (t) { var e = this; e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), A(e, !0)) }, C = function (t) { var e, n = this; if (!n._d) { n._d = !0, n = n._w || n; try { if (n === t) throw w("Promise can't be resolved itself"); (e = P(t)) ? g(function () { var r = { _w: n, _d: !1 }; try { e.call(t, c(C, r, 1), c(I, r, 1)) } catch (o) { I.call(r, o) } }) : (n._v = t, n._s = 1, A(n, !1)) } catch (r) { I.call({ _w: n, _d: !1 }, r) } } }; j || (_ = function (t) { v(this, _, b, "_h"), p(t), r.call(this); try { t(c(C, this, 1), c(I, this, 1)) } catch (e) { I.call(this, e) } }, r = function (t) { this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1 }, r.prototype = n(210)(_.prototype, { then: function (t, e) { var n = S(d(this, _)); return n.ok = "function" == typeof t ? t : !0, n.fail = "function" == typeof e && e, n.domain = O ? m.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && A(this, !1), n.promise }, "catch": function (t) { return this.then(void 0, t) } }), M = function () { var t = new r; this.promise = t, this.resolve = c(C, t, 1), this.reject = c(I, t, 1) }), f(f.G + f.W + f.F * !j, { Promise: _ }), n(24)(_, b), n(192)(b), i = n(9)[b], f(f.S + f.F * !j, b, { reject: function (t) { var e = S(this), n = e.reject; return n(t), e.promise } }), f(f.S + f.F * (u || !j), b, { resolve: function (t) { if (t instanceof _ && E(t.constructor, this)) return t; var e = S(this), n = e.resolve; return n(t), e.promise } }), f(f.S + f.F * !(j && n(165)(function (t) { _.all(t)["catch"](x) })), b, { all: function (t) { var e = this, n = S(e), r = n.resolve, o = n.reject, i = k(function () { var n = [], i = 0, u = 1; h(t, !1, function (t) { var a = i++, c = !1; n.push(void 0), u++, e.resolve(t).then(function (t) { c || (c = !0, n[a] = t, --u || r(n)) }, o) }), --u || r(n) }); return i && o(i.error), n.promise }, race: function (t) { var e = this, n = S(e), r = n.reject, o = k(function () { h(t, !1, function (t) { e.resolve(t).then(n.resolve, r) }) }); return o && r(o.error), n.promise } }) }, function (t, e) { t.exports = function (t, e, n, r) { if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!"); return t } }, function (t, e, n) { var r = n(20), o = n(161), i = n(162), u = n(12), a = n(37), c = n(164), s = {}, f = {}, e = t.exports = function (t, e, n, l, p) { var v, h, d, y, g = p ? function () { return t } : c(t), b = r(n, l, e ? 2 : 1), w = 0; if ("function" != typeof g) throw TypeError(t + " is not iterable!"); if (i(g)) { for (v = a(t.length) ; v > w; w++) if (y = e ? b(u(h = t[w])[0], h[1]) : b(t[w]), y === s || y === f) return y } else for (d = g.call(t) ; !(h = d.next()).done;) if (y = o(d, b, h.value, e), y === s || y === f) return y }; e.BREAK = s, e.RETURN = f }, function (t, e, n) { var r = n(12), o = n(21), i = n(25)("species"); t.exports = function (t, e) { var n, u = r(t).constructor; return void 0 === u || void 0 == (n = r(u)[i]) ? e : o(n) } }, function (t, e, n) { var r, o, i, u = n(20), a = n(78), c = n(48), s = n(15), f = n(4), l = f.process, p = f.setImmediate, v = f.clearImmediate, h = f.MessageChannel, d = 0, y = {}, g = "onreadystatechange", b = function () { var t = +this; if (y.hasOwnProperty(t)) { var e = y[t]; delete y[t], e() } }, w = function (t) { b.call(t.data) }; p && v || (p = function (t) { for (var e = [], n = 1; arguments.length > n;) e.push(arguments[n++]); return y[++d] = function () { a("function" == typeof t ? t : Function(t), e) }, r(d), d }, v = function (t) { delete y[t] }, "process" == n(34)(l) ? r = function (t) { l.nextTick(u(b, t, 1)) } : h ? (o = new h, i = o.port2, o.port1.onmessage = w, r = u(i.postMessage, i, 1)) : f.addEventListener && "function" == typeof postMessage && !f.importScripts ? (r = function (t) { f.postMessage(t + "", "*") }, f.addEventListener("message", w, !1)) : r = g in s("script") ? function (t) { c.appendChild(s("script"))[g] = function () { c.removeChild(this), b.call(t) } } : function (t) { setTimeout(u(b, t, 1), 0) }), t.exports = { set: p, clear: v } }, function (t, e, n) { var r = n(4), o = n(208).set, i = r.MutationObserver || r.WebKitMutationObserver, u = r.process, a = r.Promise, c = "process" == n(34)(u); t.exports = function () { var t, e, n, s = function () { var r, o; for (c && (r = u.domain) && r.exit() ; t;) { o = t.fn, t = t.next; try { o() } catch (i) { throw t ? n() : e = void 0, i } } e = void 0, r && r.enter() }; if (c) n = function () { u.nextTick(s) }; else if (i) { var f = !0, l = document.createTextNode(""); new i(s).observe(l, { characterData: !0 }), n = function () { l.data = f = !f } } else if (a && a.resolve) { var p = a.resolve(); n = function () { p.then(s) } } else n = function () { o.call(r, s) }; return function (r) { var o = { fn: r, next: void 0 }; e && (e.next = o), t || (t = o, n()), e = o } } }, function (t, e, n) { var r = n(18); t.exports = function (t, e, n) { for (var o in e) r(t, o, e[o], n); return t } }, function (t, e, n) { "use strict"; var r = n(212); t.exports = n(213)("Map", function (t) { return function () { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { get: function (t) { var e = r.getEntry(this, t); return e && e.v }, set: function (t, e) { return r.def(this, 0 === t ? 0 : t, e) } }, r, !0) }, function (t, e, n) { "use strict"; var r = n(11).f, o = n(46), i = n(210), u = n(20), a = n(205), c = n(35), s = n(206), f = n(128), l = n(194), p = n(192), v = n(6), h = n(22).fastKey, d = v ? "_s" : "size", y = function (t, e) { var n, r = h(e); if ("F" !== r) return t._i[r]; for (n = t._f; n; n = n.n) if (n.k == e) return n }; t.exports = { getConstructor: function (t, e, n, f) { var l = t(function (t, r) { a(t, l, e, "_i"), t._i = o(null), t._f = void 0, t._l = void 0, t[d] = 0, void 0 != r && s(r, n, t[f], t) }); return i(l.prototype, { clear: function () { for (var t = this, e = t._i, n = t._f; n; n = n.n) n.r = !0, n.p && (n.p = n.p.n = void 0), delete e[n.i]; t._f = t._l = void 0, t[d] = 0 }, "delete": function (t) { var e = this, n = y(e, t); if (n) { var r = n.n, o = n.p; delete e._i[n.i], n.r = !0, o && (o.n = r), r && (r.p = o), e._f == n && (e._f = r), e._l == n && (e._l = o), e[d]-- } return !!n }, forEach: function (t) { a(this, l, "forEach"); for (var e, n = u(t, arguments.length > 1 ? arguments[1] : void 0, 3) ; e = e ? e.n : this._f;) for (n(e.v, e.k, this) ; e && e.r;) e = e.p }, has: function (t) { return !!y(this, t) } }), v && r(l.prototype, "size", { get: function () { return c(this[d]) } }), l }, def: function (t, e, n) { var r, o, i = y(t, e); return i ? i.v = n : (t._l = i = { i: o = h(e, !0), k: e, v: n, p: r = t._l, n: void 0, r: !1 }, t._f || (t._f = i), r && (r.n = i), t[d]++, "F" !== o && (t._i[o] = i)), t }, getEntry: y, setStrong: function (t, e, n) { f(t, e, function (t, e) { this._t = t, this._k = e, this._l = void 0 }, function () { for (var t = this, e = t._k, n = t._l; n && n.r;) n = n.p; return t._t && (t._l = n = n ? n.n : t._t._f) ? "keys" == e ? l(0, n.k) : "values" == e ? l(0, n.v) : l(0, [n.k, n.v]) : (t._t = void 0, l(1)) }, n ? "entries" : "values", !n, !0), p(e) } } }, function (t, e, n) { "use strict"; var r = n(4), o = n(8), i = n(18), u = n(210), a = n(22), c = n(206), s = n(205), f = n(13), l = n(7), p = n(165), v = n(24), h = n(88); t.exports = function (t, e, n, d, y, g) { var b = r[t], w = b, m = y ? "set" : "add", _ = w && w.prototype, O = {}, x = function (t) { var e = _[t]; i(_, t, "delete" == t ? function (t) { return g && !f(t) ? !1 : e.call(this, 0 === t ? 0 : t) } : "has" == t ? function (t) { return g && !f(t) ? !1 : e.call(this, 0 === t ? 0 : t) } : "get" == t ? function (t) { return g && !f(t) ? void 0 : e.call(this, 0 === t ? 0 : t) } : "add" == t ? function (t) { return e.call(this, 0 === t ? 0 : t), this } : function (t, n) { return e.call(this, 0 === t ? 0 : t, n), this }) }; if ("function" == typeof w && (g || _.forEach && !l(function () { (new w).entries().next() }))) { var j = new w, E = j[m](g ? {} : -0, 1) != j, P = l(function () { j.has(1) }), S = p(function (t) { new w(t) }), M = !g && l(function () { for (var t = new w, e = 5; e--;) t[m](e, e); return !t.has(-0) }); S || (w = e(function (e, n) { s(e, w, t); var r = h(new b, e, w); return void 0 != n && c(n, y, r[m], r), r }), w.prototype = _, _.constructor = w), (P || M) && (x("delete"), x("has"), y && x("get")), (M || E) && x(m), g && _.clear && delete _.clear } else w = d.getConstructor(e, t, y, m), u(w.prototype, n), a.NEED = !0; return v(w, t), O[t] = w, o(o.G + o.W + o.F * (w != b), O), g || d.setStrong(w, t, y), w } }, function (t, e, n) { "use strict"; var r = n(212); t.exports = n(213)("Set", function (t) { return function () { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { add: function (t) { return r.def(this, t = 0 === t ? 0 : t, t) } }, r) }, function (t, e, n) { "use strict"; var r, o = n(172)(0), i = n(18), u = n(22), a = n(69), c = n(216), s = n(13), f = u.getWeak, l = Object.isExtensible, p = c.ufstore, v = {}, h = function (t) { return function () { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, d = { get: function (t) { if (s(t)) { var e = f(t); return e === !0 ? p(this).get(t) : e ? e[this._i] : void 0 } }, set: function (t, e) { return c.def(this, t, e) } }, y = t.exports = n(213)("WeakMap", h, d, c, !0, !0); 7 != (new y).set((Object.freeze || Object)(v), 7).get(v) && (r = c.getConstructor(h), a(r.prototype, d), u.NEED = !0, o(["delete", "has", "get", "set"], function (t) { var e = y.prototype, n = e[t]; i(e, t, function (e, o) { if (s(e) && !l(e)) { this._f || (this._f = new r); var i = this._f[t](e, o); return "set" == t ? this : i } return n.call(this, e, o) }) })) }, function (t, e, n) { "use strict"; var r = n(210), o = n(22).getWeak, i = n(12), u = n(13), a = n(205), c = n(206), s = n(172), f = n(5), l = s(5), p = s(6), v = 0, h = function (t) { return t._l || (t._l = new d) }, d = function () { this.a = [] }, y = function (t, e) { return l(t.a, function (t) { return t[0] === e }) }; d.prototype = { get: function (t) { var e = y(this, t); return e ? e[1] : void 0 }, has: function (t) { return !!y(this, t) }, set: function (t, e) { var n = y(this, t); n ? n[1] = e : this.a.push([t, e]) }, "delete": function (t) { var e = p(this.a, function (e) { return e[0] === t }); return ~e && this.a.splice(e, 1), !!~e } }, t.exports = { getConstructor: function (t, e, n, i) { var s = t(function (t, r) { a(t, s, e, "_i"), t._i = v++, t._l = void 0, void 0 != r && c(r, n, t[i], t) }); return r(s.prototype, { "delete": function (t) { if (!u(t)) return !1; var e = o(t); return e === !0 ? h(this)["delete"](t) : e && f(e, this._i) && delete e[this._i] }, has: function (t) { if (!u(t)) return !1; var e = o(t); return e === !0 ? h(this).has(t) : e && f(e, this._i) } }), s }, def: function (t, e, n) { var r = o(i(e), !0); return r === !0 ? h(t).set(e, n) : r[t._i] = n, t }, ufstore: h } }, function (t, e, n) { "use strict"; var r = n(216); n(213)("WeakSet", function (t) { return function () { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { add: function (t) { return r.def(this, t, !0) } }, r, !1, !0) }, function (t, e, n) { "use strict"; var r = n(8), o = n(219), i = n(220), u = n(12), a = n(39), c = n(37), s = n(13), f = n(4).ArrayBuffer, l = n(207), p = i.ArrayBuffer, v = i.DataView, h = o.ABV && f.isView, d = p.prototype.slice, y = o.VIEW, g = "ArrayBuffer"; r(r.G + r.W + r.F * (f !== p), { ArrayBuffer: p }), r(r.S + r.F * !o.CONSTR, g, { isView: function (t) { return h && h(t) || s(t) && y in t } }), r(r.P + r.U + r.F * n(7)(function () { return !new p(2).slice(1, void 0).byteLength }), g, { slice: function (t, e) { if (void 0 !== d && void 0 === e) return d.call(u(this), t); for (var n = u(this).byteLength, r = a(t, n), o = a(void 0 === e ? n : e, n), i = new (l(this, p))(c(o - r)), s = new v(this), f = new v(i), h = 0; o > r;) f.setUint8(h++, s.getUint8(r++)); return i } }), n(192)(g) }, function (t, e, n) { for (var r, o = n(4), i = n(10), u = n(19), a = u("typed_array"), c = u("view"), s = !(!o.ArrayBuffer || !o.DataView), f = s, l = 0, p = 9, v = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",") ; p > l;) (r = o[v[l++]]) ? (i(r.prototype, a, !0), i(r.prototype, c, !0)) : f = !1; t.exports = { ABV: s, CONSTR: f, TYPED: a, VIEW: c } }, function (t, e, n) { "use strict"; var r = n(4), o = n(6), i = n(28), u = n(219), a = n(10), c = n(210), s = n(7), f = n(205), l = n(38), p = n(37), v = n(50).f, h = n(11).f, d = n(188), y = n(24), g = "ArrayBuffer", b = "DataView", w = "prototype", m = "Wrong length!", _ = "Wrong index!", O = r[g], x = r[b], j = r.Math, E = r.RangeError, P = r.Infinity, S = O, M = j.abs, k = j.pow, A = j.floor, T = j.log, F = j.LN2, N = "buffer", I = "byteLength", C = "byteOffset", R = o ? "_b" : N, D = o ? "_l" : I, L = o ? "_o" : C, U = function (t, e, n) { var r, o, i, u = Array(n), a = 8 * n - e - 1, c = (1 << a) - 1, s = c >> 1, f = 23 === e ? k(2, -24) - k(2, -77) : 0, l = 0, p = 0 > t || 0 === t && 0 > 1 / t ? 1 : 0; for (t = M(t), t != t || t === P ? (o = t != t ? 1 : 0, r = c) : (r = A(T(t) / F), t * (i = k(2, -r)) < 1 && (r--, i *= 2), t += r + s >= 1 ? f / i : f * k(2, 1 - s), t * i >= 2 && (r++, i /= 2), r + s >= c ? (o = 0, r = c) : r + s >= 1 ? (o = (t * i - 1) * k(2, e), r += s) : (o = t * k(2, s - 1) * k(2, e), r = 0)) ; e >= 8; u[l++] = 255 & o, o /= 256, e -= 8); for (r = r << e | o, a += e; a > 0; u[l++] = 255 & r, r /= 256, a -= 8); return u[--l] |= 128 * p, u }, B = function (t, e, n) { var r, o = 8 * n - e - 1, i = (1 << o) - 1, u = i >> 1, a = o - 7, c = n - 1, s = t[c--], f = 127 & s; for (s >>= 7; a > 0; f = 256 * f + t[c], c--, a -= 8); for (r = f & (1 << -a) - 1, f >>= -a, a += e; a > 0; r = 256 * r + t[c], c--, a -= 8); if (0 === f) f = 1 - u; else { if (f === i) return r ? NaN : s ? -P : P; r += k(2, e), f -= u } return (s ? -1 : 1) * r * k(2, f - e) }, G = function (t) { return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0] }, W = function (t) { return [255 & t] }, V = function (t) { return [255 & t, t >> 8 & 255] }, z = function (t) { return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255] }, J = function (t) { return U(t, 52, 8) }, q = function (t) { return U(t, 23, 4) }, Y = function (t, e, n) { h(t[w], e, { get: function () { return this[n] } }) }, K = function (t, e, n, r) { var o = +n, i = l(o); if (o != i || 0 > i || i + e > t[D]) throw E(_); var u = t[R]._b, a = i + t[L], c = u.slice(a, a + e); return r ? c : c.reverse() }, X = function (t, e, n, r, o, i) { var u = +n, a = l(u); if (u != a || 0 > a || a + e > t[D]) throw E(_); for (var c = t[R]._b, s = a + t[L], f = r(+o), p = 0; e > p; p++) c[s + p] = f[i ? p : e - p - 1] }, H = function (t, e) { f(t, O, g); var n = +e, r = p(n); if (n != r) throw E(m); return r }; if (u.ABV) { if (!s(function () { new O }) || !s(function () { new O(.5) })) { O = function (t) { return new S(H(this, t)) }; for (var Q, $ = O[w] = S[w], Z = v(S), tt = 0; Z.length > tt;) (Q = Z[tt++]) in O || a(O, Q, S[Q]); i || ($.constructor = O) } var et = new x(new O(2)), nt = x[w].setInt8; et.setInt8(0, 2147483648), et.setInt8(1, 2147483649), !et.getInt8(0) && et.getInt8(1) || c(x[w], { setInt8: function (t, e) { nt.call(this, t, e << 24 >> 24) }, setUint8: function (t, e) { nt.call(this, t, e << 24 >> 24) } }, !0) } else O = function (t) { var e = H(this, t); this._b = d.call(Array(e), 0), this[D] = e }, x = function (t, e, n) { f(this, x, b), f(t, O, b); var r = t[D], o = l(e); if (0 > o || o > r) throw E("Wrong offset!"); if (n = void 0 === n ? r - o : p(n), o + n > r) throw E(m); this[R] = t, this[L] = o, this[D] = n }, o && (Y(O, I, "_l"), Y(x, N, "_b"), Y(x, I, "_l"), Y(x, C, "_o")), c(x[w], { getInt8: function (t) { return K(this, 1, t)[0] << 24 >> 24 }, getUint8: function (t) { return K(this, 1, t)[0] }, getInt16: function (t) { var e = K(this, 2, t, arguments[1]); return (e[1] << 8 | e[0]) << 16 >> 16 }, getUint16: function (t) { var e = K(this, 2, t, arguments[1]); return e[1] << 8 | e[0] }, getInt32: function (t) { return G(K(this, 4, t, arguments[1])) }, getUint32: function (t) { return G(K(this, 4, t, arguments[1])) >>> 0 }, getFloat32: function (t) { return B(K(this, 4, t, arguments[1]), 23, 4) }, getFloat64: function (t) { return B(K(this, 8, t, arguments[1]), 52, 8) }, setInt8: function (t, e) { X(this, 1, t, W, e) }, setUint8: function (t, e) { X(this, 1, t, W, e) }, setInt16: function (t, e) { X(this, 2, t, V, e, arguments[2]) }, setUint16: function (t, e) { X(this, 2, t, V, e, arguments[2]) }, setInt32: function (t, e) { X(this, 4, t, z, e, arguments[2]) }, setUint32: function (t, e) { X(this, 4, t, z, e, arguments[2]) }, setFloat32: function (t, e) { X(this, 4, t, q, e, arguments[2]) }, setFloat64: function (t, e) { X(this, 8, t, J, e, arguments[2]) } }); y(O, g), y(x, b), a(x[w], u.VIEW, !0), e[g] = O, e[b] = x }, function (t, e, n) { var r = n(8); r(r.G + r.W + r.F * !n(219).ABV, { DataView: n(220).DataView }) }, function (t, e, n) { n(223)("Int8", 1, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) {
                    "use strict"; if (n(6)) {
                        var r = n(28), o = n(4), i = n(7), u = n(8), a = n(219), c = n(220), s = n(20), f = n(205), l = n(17), p = n(10), v = n(210), h = n(38), d = n(37), y = n(39), g = n(16), b = n(5), w = n(71), m = n(75), _ = n(13), O = n(58), x = n(162), j = n(46), E = n(59), P = n(50).f, S = n(164), M = n(19), k = n(25), A = n(172), T = n(36), F = n(207), N = n(193), I = n(129), C = n(165), R = n(192), D = n(188), L = n(185), U = n(11), B = n(51), G = U.f, W = B.f, V = o.RangeError, z = o.TypeError, J = o.Uint8Array, q = "ArrayBuffer", Y = "Shared" + q, K = "BYTES_PER_ELEMENT", X = "prototype", H = Array[X], Q = c.ArrayBuffer, $ = c.DataView, Z = A(0), tt = A(2), et = A(3), nt = A(4), rt = A(5), ot = A(6), it = T(!0), ut = T(!1), at = N.values, ct = N.keys, st = N.entries, ft = H.lastIndexOf, lt = H.reduce, pt = H.reduceRight, vt = H.join, ht = H.sort, dt = H.slice, yt = H.toString, gt = H.toLocaleString, bt = k("iterator"), wt = k("toStringTag"), mt = M("typed_constructor"), _t = M("def_constructor"), Ot = a.CONSTR, xt = a.TYPED, jt = a.VIEW, Et = "Wrong length!", Pt = A(1, function (t, e) { return Ft(F(t, t[_t]), e) }), St = i(function () { return 1 === new J(new Uint16Array([1]).buffer)[0] }), Mt = !!J && !!J[X].set && i(function () { new J(1).set({}) }), kt = function (t, e) { if (void 0 === t) throw z(Et); var n = +t, r = d(t); if (e && !w(n, r)) throw V(Et); return r }, At = function (t, e) { var n = h(t); if (0 > n || n % e) throw V("Wrong offset!"); return n }, Tt = function (t) { if (_(t) && xt in t) return t; throw z(t + " is not a typed array!") }, Ft = function (t, e) { if (!(_(t) && mt in t)) throw z("It is not a typed array constructor!"); return new t(e) }, Nt = function (t, e) { return It(F(t, t[_t]), e) }, It = function (t, e) { for (var n = 0, r = e.length, o = Ft(t, r) ; r > n;) o[n] = e[n++]; return o }, Ct = function (t, e, n) { G(t, e, { get: function () { return this._d[n] } }) }, Rt = function (t) { var e, n, r, o, i, u, a = O(t), c = arguments.length, f = c > 1 ? arguments[1] : void 0, l = void 0 !== f, p = S(a); if (void 0 != p && !x(p)) { for (u = p.call(a), r = [], e = 0; !(i = u.next()).done; e++) r.push(i.value); a = r } for (l && c > 2 && (f = s(f, arguments[2], 2)), e = 0, n = d(a.length), o = Ft(this, n) ; n > e; e++) o[e] = l ? f(a[e], e) : a[e]; return o }, Dt = function () { for (var t = 0, e = arguments.length, n = Ft(this, e) ; e > t;) n[t] = arguments[t++]; return n }, Lt = !!J && i(function () { gt.call(new J(1)) }), Ut = function () { return gt.apply(Lt ? dt.call(Tt(this)) : Tt(this), arguments) }, Bt = { copyWithin: function (t, e) { return L.call(Tt(this), t, e, arguments.length > 2 ? arguments[2] : void 0) }, every: function (t) { return nt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, fill: function (t) { return D.apply(Tt(this), arguments) }, filter: function (t) { return Nt(this, tt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0)) }, find: function (t) { return rt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, findIndex: function (t) { return ot(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, forEach: function (t) { Z(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, indexOf: function (t) { return ut(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, includes: function (t) { return it(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, join: function (t) { return vt.apply(Tt(this), arguments) }, lastIndexOf: function (t) { return ft.apply(Tt(this), arguments) }, map: function (t) { return Pt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, reduce: function (t) { return lt.apply(Tt(this), arguments) }, reduceRight: function (t) { return pt.apply(Tt(this), arguments) }, reverse: function () { for (var t, e = this, n = Tt(e).length, r = Math.floor(n / 2), o = 0; r > o;) t = e[o], e[o++] = e[--n], e[n] = t; return e }, some: function (t) { return et(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0) }, sort: function (t) { return ht.call(Tt(this), t) }, subarray: function (t, e) { var n = Tt(this), r = n.length, o = y(t, r); return new (F(n, n[_t]))(n.buffer, n.byteOffset + o * n.BYTES_PER_ELEMENT, d((void 0 === e ? r : y(e, r)) - o)) } }, Gt = function (t, e) { return Nt(this, dt.call(Tt(this), t, e)) }, Wt = function (t) { Tt(this); var e = At(arguments[1], 1), n = this.length, r = O(t), o = d(r.length), i = 0; if (o + e > n) throw V(Et); for (; o > i;) this[e + i] = r[i++] }, Vt = { entries: function () { return st.call(Tt(this)) }, keys: function () { return ct.call(Tt(this)) }, values: function () { return at.call(Tt(this)) } }, zt = function (t, e) { return _(t) && t[xt] && "symbol" != typeof e && e in t && String(+e) == String(e) }, Jt = function (t, e) { return zt(t, e = g(e, !0)) ? l(2, t[e]) : W(t, e) }, qt = function (t, e, n) { return !(zt(t, e = g(e, !0)) && _(n) && b(n, "value")) || b(n, "get") || b(n, "set") || n.configurable || b(n, "writable") && !n.writable || b(n, "enumerable") && !n.enumerable ? G(t, e, n) : (t[e] = n.value, t) }; Ot || (B.f = Jt, U.f = qt), u(u.S + u.F * !Ot, "Object", { getOwnPropertyDescriptor: Jt, defineProperty: qt }), i(function () { yt.call({}) }) && (yt = gt = function () { return vt.call(this) }); var Yt = v({}, Bt); v(Yt, Vt), p(Yt, bt, Vt.values), v(Yt, { slice: Gt, set: Wt, constructor: function () { }, toString: yt, toLocaleString: Ut }), Ct(Yt, "buffer", "b"), Ct(Yt, "byteOffset", "o"), Ct(Yt, "byteLength", "l"), Ct(Yt, "length", "e"), G(Yt, wt, { get: function () { return this[xt] } }), t.exports = function (t, e, n, c) {
                            c = !!c; var s = t + (c ? "Clamped" : "") + "Array", l = "Uint8Array" != s, v = "get" + t, h = "set" + t, y = o[s], g = y || {}, b = y && E(y), w = !y || !a.ABV, O = {}, x = y && y[X], S = function (t, n) { var r = t._d; return r.v[v](n * e + r.o, St) }, M = function (t, n, r) { var o = t._d; c && (r = (r = Math.round(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r), o.v[h](n * e + o.o, r, St) }, k = function (t, e) { G(t, e, { get: function () { return S(this, e) }, set: function (t) { return M(this, e, t) }, enumerable: !0 }) }; w ? (y = n(function (t, n, r, o) {
                                f(t, y, s, "_d"); var i, u, a, c, l = 0, v = 0; if (_(n)) { if (!(n instanceof Q || (c = m(n)) == q || c == Y)) return xt in n ? It(y, n) : Rt.call(y, n); i = n, v = At(r, e); var h = n.byteLength; if (void 0 === o) { if (h % e) throw V(Et); if (u = h - v, 0 > u) throw V(Et) } else if (u = d(o) * e, u + v > h) throw V(Et); a = u / e } else a = kt(n, !0), u = a * e, i = new Q(u);
                                for (p(t, "_d", { b: i, o: v, l: u, e: a, v: new $(i) }) ; a > l;) k(t, l++)
                            }), x = y[X] = j(Yt), p(x, "constructor", y)) : C(function (t) { new y(null), new y(t) }, !0) || (y = n(function (t, n, r, o) { f(t, y, s); var i; return _(n) ? n instanceof Q || (i = m(n)) == q || i == Y ? void 0 !== o ? new g(n, At(r, e), o) : void 0 !== r ? new g(n, At(r, e)) : new g(n) : xt in n ? It(y, n) : Rt.call(y, n) : new g(kt(n, l)) }), Z(b !== Function.prototype ? P(g).concat(P(b)) : P(g), function (t) { t in y || p(y, t, g[t]) }), y[X] = x, r || (x.constructor = y)); var A = x[bt], T = !!A && ("values" == A.name || void 0 == A.name), F = Vt.values; p(y, mt, !0), p(x, xt, s), p(x, jt, !0), p(x, _t, y), (c ? new y(1)[wt] == s : wt in x) || G(x, wt, { get: function () { return s } }), O[s] = y, u(u.G + u.W + u.F * (y != g), O), u(u.S, s, { BYTES_PER_ELEMENT: e, from: Rt, of: Dt }), K in x || p(x, K, e), u(u.P, s, Bt), R(s), u(u.P + u.F * Mt, s, { set: Wt }), u(u.P + u.F * !T, s, Vt), u(u.P + u.F * (x.toString != yt), s, { toString: yt }), u(u.P + u.F * i(function () { new y(1).slice() }), s, { slice: Gt }), u(u.P + u.F * (i(function () { return [1, 2].toLocaleString() != new y([1, 2]).toLocaleString() }) || !i(function () { x.toLocaleString.call([1, 2]) })), s, { toLocaleString: Ut }), I[s] = T ? A : F, r || T || p(x, bt, F)
                        }
                    } else t.exports = function () { }
                }, function (t, e, n) { n(223)("Uint8", 1, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Uint8", 1, function (t) { return function (e, n, r) { return t(this, e, n, r) } }, !0) }, function (t, e, n) { n(223)("Int16", 2, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Uint16", 2, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Int32", 4, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Uint32", 4, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Float32", 4, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { n(223)("Float64", 8, function (t) { return function (e, n, r) { return t(this, e, n, r) } }) }, function (t, e, n) { var r = n(8), o = n(21), i = n(12), u = (n(4).Reflect || {}).apply, a = Function.apply; r(r.S + r.F * !n(7)(function () { u(function () { }) }), "Reflect", { apply: function (t, e, n) { var r = o(t), c = i(n); return u ? u(r, e, c) : a.call(r, e, c) } }) }, function (t, e, n) { var r = n(8), o = n(46), i = n(21), u = n(12), a = n(13), c = n(7), s = n(77), f = (n(4).Reflect || {}).construct, l = c(function () { function t() { } return !(f(function () { }, [], t) instanceof t) }), p = !c(function () { f(function () { }) }); r(r.S + r.F * (l || p), "Reflect", { construct: function (t, e) { i(t), u(e); var n = arguments.length < 3 ? t : i(arguments[2]); if (p && !l) return f(t, e, n); if (t == n) { switch (e.length) { case 0: return new t; case 1: return new t(e[0]); case 2: return new t(e[0], e[1]); case 3: return new t(e[0], e[1], e[2]); case 4: return new t(e[0], e[1], e[2], e[3]) } var r = [null]; return r.push.apply(r, e), new (s.apply(t, r)) } var c = n.prototype, v = o(a(c) ? c : Object.prototype), h = Function.apply.call(t, v, e); return a(h) ? h : v } }) }, function (t, e, n) { var r = n(11), o = n(8), i = n(12), u = n(16); o(o.S + o.F * n(7)(function () { Reflect.defineProperty(r.f({}, 1, { value: 1 }), 1, { value: 2 }) }), "Reflect", { defineProperty: function (t, e, n) { i(t), e = u(e, !0), i(n); try { return r.f(t, e, n), !0 } catch (o) { return !1 } } }) }, function (t, e, n) { var r = n(8), o = n(51).f, i = n(12); r(r.S, "Reflect", { deleteProperty: function (t, e) { var n = o(i(t), e); return n && !n.configurable ? !1 : delete t[e] } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(12), i = function (t) { this._t = o(t), this._i = 0; var e, n = this._k = []; for (e in t) n.push(e) }; n(130)(i, "Object", function () { var t, e = this, n = e._k; do if (e._i >= n.length) return { value: void 0, done: !0 }; while (!((t = n[e._i++]) in e._t)); return { value: t, done: !1 } }), r(r.S, "Reflect", { enumerate: function (t) { return new i(t) } }) }, function (t, e, n) { function r(t, e) { var n, a, f = arguments.length < 3 ? t : arguments[2]; return s(t) === f ? t[e] : (n = o.f(t, e)) ? u(n, "value") ? n.value : void 0 !== n.get ? n.get.call(f) : void 0 : c(a = i(t)) ? r(a, e, f) : void 0 } var o = n(51), i = n(59), u = n(5), a = n(8), c = n(13), s = n(12); a(a.S, "Reflect", { get: r }) }, function (t, e, n) { var r = n(51), o = n(8), i = n(12); o(o.S, "Reflect", { getOwnPropertyDescriptor: function (t, e) { return r.f(i(t), e) } }) }, function (t, e, n) { var r = n(8), o = n(59), i = n(12); r(r.S, "Reflect", { getPrototypeOf: function (t) { return o(i(t)) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Reflect", { has: function (t, e) { return e in t } }) }, function (t, e, n) { var r = n(8), o = n(12), i = Object.isExtensible; r(r.S, "Reflect", { isExtensible: function (t) { return o(t), i ? i(t) : !0 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Reflect", { ownKeys: n(243) }) }, function (t, e, n) { var r = n(50), o = n(43), i = n(12), u = n(4).Reflect; t.exports = u && u.ownKeys || function (t) { var e = r.f(i(t)), n = o.f; return n ? e.concat(n(t)) : e } }, function (t, e, n) { var r = n(8), o = n(12), i = Object.preventExtensions; r(r.S, "Reflect", { preventExtensions: function (t) { o(t); try { return i && i(t), !0 } catch (e) { return !1 } } }) }, function (t, e, n) { function r(t, e, n) { var c, p, v = arguments.length < 4 ? t : arguments[3], h = i.f(f(t), e); if (!h) { if (l(p = u(t))) return r(p, e, n, v); h = s(0) } return a(h, "value") ? h.writable !== !1 && l(v) ? (c = i.f(v, e) || s(0), c.value = n, o.f(v, e, c), !0) : !1 : void 0 === h.set ? !1 : (h.set.call(v, n), !0) } var o = n(11), i = n(51), u = n(59), a = n(5), c = n(8), s = n(17), f = n(12), l = n(13); c(c.S, "Reflect", { set: r }) }, function (t, e, n) { var r = n(8), o = n(73); o && r(r.S, "Reflect", { setPrototypeOf: function (t, e) { o.check(t, e); try { return o.set(t, e), !0 } catch (n) { return !1 } } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(36)(!0); r(r.P, "Array", { includes: function (t) { return o(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(186)("includes") }, function (t, e, n) { "use strict"; var r = n(8), o = n(127)(!0); r(r.P, "String", { at: function (t) { return o(this, t) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(250); r(r.P, "String", { padStart: function (t) { return o(this, t, arguments.length > 1 ? arguments[1] : void 0, !0) } }) }, function (t, e, n) { var r = n(37), o = n(91), i = n(35); t.exports = function (t, e, n, u) { var a = String(i(t)), c = a.length, s = void 0 === n ? " " : String(n), f = r(e); if (c >= f || "" == s) return a; var l = f - c, p = o.call(s, Math.ceil(l / s.length)); return p.length > l && (p = p.slice(0, l)), u ? p + a : a + p } }, function (t, e, n) { "use strict"; var r = n(8), o = n(250); r(r.P, "String", { padEnd: function (t) { return o(this, t, arguments.length > 1 ? arguments[1] : void 0, !1) } }) }, function (t, e, n) { "use strict"; n(83)("trimLeft", function (t) { return function () { return t(this, 1) } }, "trimStart") }, function (t, e, n) { "use strict"; n(83)("trimRight", function (t) { return function () { return t(this, 2) } }, "trimEnd") }, function (t, e, n) { "use strict"; var r = n(8), o = n(35), i = n(37), u = n(134), a = n(196), c = RegExp.prototype, s = function (t, e) { this._r = t, this._s = e }; n(130)(s, "RegExp String", function () { var t = this._r.exec(this._s); return { value: t, done: null === t } }), r(r.P, "String", { matchAll: function (t) { if (o(this), !u(t)) throw TypeError(t + " is not a regexp!"); var e = String(this), n = "flags" in c ? String(t.flags) : a.call(t), r = new RegExp(t.source, ~n.indexOf("g") ? n : "g" + n); return r.lastIndex = i(t.lastIndex), new s(r, e) } }) }, function (t, e, n) { n(27)("asyncIterator") }, function (t, e, n) { n(27)("observable") }, function (t, e, n) { var r = n(8), o = n(243), i = n(32), u = n(51), a = n(163); r(r.S, "Object", { getOwnPropertyDescriptors: function (t) { for (var e, n = i(t), r = u.f, c = o(n), s = {}, f = 0; c.length > f;) a(s, e = c[f++], r(n, e)); return s } }) }, function (t, e, n) { var r = n(8), o = n(259)(!1); r(r.S, "Object", { values: function (t) { return o(t) } }) }, function (t, e, n) { var r = n(30), o = n(32), i = n(44).f; t.exports = function (t) { return function (e) { for (var n, u = o(e), a = r(u), c = a.length, s = 0, f = []; c > s;) i.call(u, n = a[s++]) && f.push(t ? [n, u[n]] : u[n]); return f } } }, function (t, e, n) { var r = n(8), o = n(259)(!0); r(r.S, "Object", { entries: function (t) { return o(t) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(58), i = n(21), u = n(11); n(6) && r(r.P + n(262), "Object", { __defineGetter__: function (t, e) { u.f(o(this), t, { get: i(e), enumerable: !0, configurable: !0 }) } }) }, function (t, e, n) { t.exports = n(28) || !n(7)(function () { var t = Math.random(); __defineSetter__.call(null, t, function () { }), delete n(4)[t] }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(58), i = n(21), u = n(11); n(6) && r(r.P + n(262), "Object", { __defineSetter__: function (t, e) { u.f(o(this), t, { set: i(e), enumerable: !0, configurable: !0 }) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(58), i = n(16), u = n(59), a = n(51).f; n(6) && r(r.P + n(262), "Object", { __lookupGetter__: function (t) { var e, n = o(this), r = i(t, !0); do if (e = a(n, r)) return e.get; while (n = u(n)) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(58), i = n(16), u = n(59), a = n(51).f; n(6) && r(r.P + n(262), "Object", { __lookupSetter__: function (t) { var e, n = o(this), r = i(t, !0); do if (e = a(n, r)) return e.set; while (n = u(n)) } }) }, function (t, e, n) { var r = n(8); r(r.P + r.R, "Map", { toJSON: n(267)("Map") }) }, function (t, e, n) { var r = n(75), o = n(268); t.exports = function (t) { return function () { if (r(this) != t) throw TypeError(t + "#toJSON isn't generic"); return o(this) } } }, function (t, e, n) { var r = n(206); t.exports = function (t, e) { var n = []; return r(t, !1, n.push, n, e), n } }, function (t, e, n) { var r = n(8); r(r.P + r.R, "Set", { toJSON: n(267)("Set") }) }, function (t, e, n) { var r = n(8); r(r.S, "System", { global: n(4) }) }, function (t, e, n) { var r = n(8), o = n(34); r(r.S, "Error", { isError: function (t) { return "Error" === o(t) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { iaddh: function (t, e, n, r) { var o = t >>> 0, i = e >>> 0, u = n >>> 0; return i + (r >>> 0) + ((o & u | (o | u) & ~(o + u >>> 0)) >>> 31) | 0 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { isubh: function (t, e, n, r) { var o = t >>> 0, i = e >>> 0, u = n >>> 0; return i - (r >>> 0) - ((~o & u | ~(o ^ u) & o - u >>> 0) >>> 31) | 0 } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { imulh: function (t, e) { var n = 65535, r = +t, o = +e, i = r & n, u = o & n, a = r >> 16, c = o >> 16, s = (a * u >>> 0) + (i * u >>> 16); return a * c + (s >> 16) + ((i * c >>> 0) + (s & n) >> 16) } }) }, function (t, e, n) { var r = n(8); r(r.S, "Math", { umulh: function (t, e) { var n = 65535, r = +t, o = +e, i = r & n, u = o & n, a = r >>> 16, c = o >>> 16, s = (a * u >>> 0) + (i * u >>> 16); return a * c + (s >>> 16) + ((i * c >>> 0) + (s & n) >>> 16) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = r.key, u = r.set; r.exp({ defineMetadata: function (t, e, n, r) { u(t, e, o(n), i(r)) } }) }, function (t, e, n) { var r = n(211), o = n(8), i = n(23)("metadata"), u = i.store || (i.store = new (n(215))), a = function (t, e, n) { var o = u.get(t); if (!o) { if (!n) return; u.set(t, o = new r) } var i = o.get(e); if (!i) { if (!n) return; o.set(e, i = new r) } return i }, c = function (t, e, n) { var r = a(e, n, !1); return void 0 === r ? !1 : r.has(t) }, s = function (t, e, n) { var r = a(e, n, !1); return void 0 === r ? void 0 : r.get(t) }, f = function (t, e, n, r) { a(n, r, !0).set(t, e) }, l = function (t, e) { var n = a(t, e, !1), r = []; return n && n.forEach(function (t, e) { r.push(e) }), r }, p = function (t) { return void 0 === t || "symbol" == typeof t ? t : String(t) }, v = function (t) { o(o.S, "Reflect", t) }; t.exports = { store: u, map: a, has: c, get: s, set: f, keys: l, key: p, exp: v } }, function (t, e, n) { var r = n(277), o = n(12), i = r.key, u = r.map, a = r.store; r.exp({ deleteMetadata: function (t, e) { var n = arguments.length < 3 ? void 0 : i(arguments[2]), r = u(o(e), n, !1); if (void 0 === r || !r["delete"](t)) return !1; if (r.size) return !0; var c = a.get(e); return c["delete"](n), !!c.size || a["delete"](e) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = n(59), u = r.has, a = r.get, c = r.key, s = function (t, e, n) { var r = u(t, e, n); if (r) return a(t, e, n); var o = i(e); return null !== o ? s(t, o, n) : void 0 }; r.exp({ getMetadata: function (t, e) { return s(t, o(e), arguments.length < 3 ? void 0 : c(arguments[2])) } }) }, function (t, e, n) { var r = n(214), o = n(268), i = n(277), u = n(12), a = n(59), c = i.keys, s = i.key, f = function (t, e) { var n = c(t, e), i = a(t); if (null === i) return n; var u = f(i, e); return u.length ? n.length ? o(new r(n.concat(u))) : u : n }; i.exp({ getMetadataKeys: function (t) { return f(u(t), arguments.length < 2 ? void 0 : s(arguments[1])) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = r.get, u = r.key; r.exp({ getOwnMetadata: function (t, e) { return i(t, o(e), arguments.length < 3 ? void 0 : u(arguments[2])) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = r.keys, u = r.key; r.exp({ getOwnMetadataKeys: function (t) { return i(o(t), arguments.length < 2 ? void 0 : u(arguments[1])) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = n(59), u = r.has, a = r.key, c = function (t, e, n) { var r = u(t, e, n); if (r) return !0; var o = i(e); return null !== o ? c(t, o, n) : !1 }; r.exp({ hasMetadata: function (t, e) { return c(t, o(e), arguments.length < 3 ? void 0 : a(arguments[2])) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = r.has, u = r.key; r.exp({ hasOwnMetadata: function (t, e) { return i(t, o(e), arguments.length < 3 ? void 0 : u(arguments[2])) } }) }, function (t, e, n) { var r = n(277), o = n(12), i = n(21), u = r.key, a = r.set; r.exp({ metadata: function (t, e) { return function (n, r) { a(t, e, (void 0 !== r ? o : i)(n), u(r)) } } }) }, function (t, e, n) { var r = n(8), o = n(209)(), i = n(4).process, u = "process" == n(34)(i); r(r.G, { asap: function (t) { var e = u && i.domain; o(e ? e.bind(t) : t) } }) }, function (t, e, n) { "use strict"; var r = n(8), o = n(4), i = n(9), u = n(209)(), a = n(25)("observable"), c = n(21), s = n(12), f = n(205), l = n(210), p = n(10), v = n(206), h = v.RETURN, d = function (t) { return null == t ? void 0 : c(t) }, y = function (t) { var e = t._c; e && (t._c = void 0, e()) }, g = function (t) { return void 0 === t._o }, b = function (t) { g(t) || (t._o = void 0, y(t)) }, w = function (t, e) { s(t), this._c = void 0, this._o = t, t = new m(this); try { var n = e(t), r = n; null != n && ("function" == typeof n.unsubscribe ? n = function () { r.unsubscribe() } : c(n), this._c = n) } catch (o) { return void t.error(o) } g(this) && y(this) }; w.prototype = l({}, { unsubscribe: function () { b(this) } }); var m = function (t) { this._s = t }; m.prototype = l({}, { next: function (t) { var e = this._s; if (!g(e)) { var n = e._o; try { var r = d(n.next); if (r) return r.call(n, t) } catch (o) { try { b(e) } finally { throw o } } } }, error: function (t) { var e = this._s; if (g(e)) throw t; var n = e._o; e._o = void 0; try { var r = d(n.error); if (!r) throw t; t = r.call(n, t) } catch (o) { try { y(e) } finally { throw o } } return y(e), t }, complete: function (t) { var e = this._s; if (!g(e)) { var n = e._o; e._o = void 0; try { var r = d(n.complete); t = r ? r.call(n, t) : void 0 } catch (o) { try { y(e) } finally { throw o } } return y(e), t } } }); var _ = function (t) { f(this, _, "Observable", "_f")._f = c(t) }; l(_.prototype, { subscribe: function (t) { return new w(t, this._f) }, forEach: function (t) { var e = this; return new (i.Promise || o.Promise)(function (n, r) { c(t); var o = e.subscribe({ next: function (e) { try { return t(e) } catch (n) { r(n), o.unsubscribe() } }, error: r, complete: n }) }) } }), l(_, { from: function (t) { var e = "function" == typeof this ? this : _, n = d(s(t)[a]); if (n) { var r = s(n.call(t)); return r.constructor === e ? r : new e(function (t) { return r.subscribe(t) }) } return new e(function (e) { var n = !1; return u(function () { if (!n) { try { if (v(t, !1, function (t) { return e.next(t), n ? h : void 0 }) === h) return } catch (r) { if (n) throw r; return void e.error(r) } e.complete() } }), function () { n = !0 } }) }, of: function () { for (var t = 0, e = arguments.length, n = Array(e) ; e > t;) n[t] = arguments[t++]; return new ("function" == typeof this ? this : _)(function (t) { var e = !1; return u(function () { if (!e) { for (var r = 0; r < n.length; ++r) if (t.next(n[r]), e) return; t.complete() } }), function () { e = !0 } }) } }), p(_.prototype, a, function () { return this }), r(r.G, { Observable: _ }), n(192)("Observable") }, function (t, e, n) { var r = n(4), o = n(8), i = n(78), u = n(289), a = r.navigator, c = !!a && /MSIE .\./.test(a.userAgent), s = function (t) { return c ? function (e, n) { return t(i(u, [].slice.call(arguments, 2), "function" == typeof e ? e : Function(e)), n) } : t }; o(o.G + o.B + o.F * c, { setTimeout: s(r.setTimeout), setInterval: s(r.setInterval) }) }, function (t, e, n) { "use strict"; var r = n(290), o = n(78), i = n(21); t.exports = function () { for (var t = i(this), e = arguments.length, n = Array(e), u = 0, a = r._, c = !1; e > u;) (n[u] = arguments[u++]) === a && (c = !0); return function () { var r, i = this, u = arguments.length, s = 0, f = 0; if (!c && !u) return o(t, n, i); if (r = n.slice(), c) for (; e > s; s++) r[s] === a && (r[s] = arguments[f++]); for (; u > f;) r.push(arguments[f++]); return o(t, r, i) } } }, function (t, e, n) { t.exports = n(4) }, function (t, e, n) { var r = n(8), o = n(208); r(r.G + r.B, { setImmediate: o.set, clearImmediate: o.clear }) }, function (t, e, n) { for (var r = n(193), o = n(18), i = n(4), u = n(10), a = n(129), c = n(25), s = c("iterator"), f = c("toStringTag"), l = a.Array, p = ["NodeList", "DOMTokenList", "MediaList", "StyleSheetList", "CSSRuleList"], v = 0; 5 > v; v++) { var h, d = p[v], y = i[d], g = y && y.prototype; if (g) { g[s] || u(g, s, l), g[f] || u(g, f, d), a[d] = l; for (h in r) g[h] || o(g, h, r[h], !0) } } }, function (t, e, n) { (function (e, n) { !function (e) { "use strict"; function r(t, e, n, r) { var o = Object.create((e || i).prototype), u = new h(r || []); return o._invoke = l(t, n, u), o } function o(t, e, n) { try { return { type: "normal", arg: t.call(e, n) } } catch (r) { return { type: "throw", arg: r } } } function i() { } function u() { } function a() { } function c(t) { ["next", "throw", "return"].forEach(function (e) { t[e] = function (t) { return this._invoke(e, t) } }) } function s(t) { this.arg = t } function f(t) { function e(n, r, i, u) { var a = o(t[n], t, r); if ("throw" !== a.type) { var c = a.arg, f = c.value; return f instanceof s ? Promise.resolve(f.arg).then(function (t) { e("next", t, i, u) }, function (t) { e("throw", t, i, u) }) : Promise.resolve(f).then(function (t) { c.value = t, i(c) }, u) } u(a.arg) } function r(t, n) { function r() { return new Promise(function (r, o) { e(t, n, r, o) }) } return i = i ? i.then(r, r) : r() } "object" == typeof n && n.domain && (e = n.domain.bind(e)); var i; this._invoke = r } function l(t, e, n) { var r = j; return function (i, u) { if (r === P) throw new Error("Generator is already running"); if (r === S) { if ("throw" === i) throw u; return y() } for (; ;) { var a = n.delegate; if (a) { if ("return" === i || "throw" === i && a.iterator[i] === g) { n.delegate = null; var c = a.iterator["return"]; if (c) { var s = o(c, a.iterator, u); if ("throw" === s.type) { i = "throw", u = s.arg; continue } } if ("return" === i) continue } var s = o(a.iterator[i], a.iterator, u); if ("throw" === s.type) { n.delegate = null, i = "throw", u = s.arg; continue } i = "next", u = g; var f = s.arg; if (!f.done) return r = E, f; n[a.resultName] = f.value, n.next = a.nextLoc, n.delegate = null } if ("next" === i) n.sent = n._sent = u; else if ("throw" === i) { if (r === j) throw r = S, u; n.dispatchException(u) && (i = "next", u = g) } else "return" === i && n.abrupt("return", u); r = P; var s = o(t, e, n); if ("normal" === s.type) { r = n.done ? S : E; var f = { value: s.arg, done: n.done }; if (s.arg !== M) return f; n.delegate && "next" === i && (u = g) } else "throw" === s.type && (r = S, i = "throw", u = s.arg) } } } function p(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e) } function v(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e } function h(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(p, this), this.reset(!0) } function d(t) { if (t) { var e = t[m]; if (e) return e.call(t); if ("function" == typeof t.next) return t; if (!isNaN(t.length)) { var n = -1, r = function o() { for (; ++n < t.length;) if (b.call(t, n)) return o.value = t[n], o.done = !1, o; return o.value = g, o.done = !0, o }; return r.next = r } } return { next: y } } function y() { return { value: g, done: !0 } } var g, b = Object.prototype.hasOwnProperty, w = "function" == typeof Symbol ? Symbol : {}, m = w.iterator || "@@iterator", _ = w.toStringTag || "@@toStringTag", O = "object" == typeof t, x = e.regeneratorRuntime; if (x) return void (O && (t.exports = x)); x = e.regeneratorRuntime = O ? t.exports : {}, x.wrap = r; var j = "suspendedStart", E = "suspendedYield", P = "executing", S = "completed", M = {}, k = a.prototype = i.prototype; u.prototype = k.constructor = a, a.constructor = u, a[_] = u.displayName = "GeneratorFunction", x.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return e ? e === u || "GeneratorFunction" === (e.displayName || e.name) : !1 }, x.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, a) : (t.__proto__ = a, _ in t || (t[_] = "GeneratorFunction")), t.prototype = Object.create(k), t }, x.awrap = function (t) { return new s(t) }, c(f.prototype), x.async = function (t, e, n, o) { var i = new f(r(t, e, n, o)); return x.isGeneratorFunction(e) ? i : i.next().then(function (t) { return t.done ? t.value : i.next() }) }, c(k), k[m] = function () { return this }, k[_] = "Generator", k.toString = function () { return "[object Generator]" }, x.keys = function (t) { var e = []; for (var n in t) e.push(n); return e.reverse(), function r() { for (; e.length;) { var n = e.pop(); if (n in t) return r.value = n, r.done = !1, r } return r.done = !0, r } }, x.values = d, h.prototype = { constructor: h, reset: function (t) { if (this.prev = 0, this.next = 0, this.sent = this._sent = g, this.done = !1, this.delegate = null, this.tryEntries.forEach(v), !t) for (var e in this) "t" === e.charAt(0) && b.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = g) }, stop: function () { this.done = !0; var t = this.tryEntries[0], e = t.completion; if ("throw" === e.type) throw e.arg; return this.rval }, dispatchException: function (t) { function e(e, r) { return i.type = "throw", i.arg = t, n.next = e, !!r } if (this.done) throw t; for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r], i = o.completion; if ("root" === o.tryLoc) return e("end"); if (o.tryLoc <= this.prev) { var u = b.call(o, "catchLoc"), a = b.call(o, "finallyLoc"); if (u && a) { if (this.prev < o.catchLoc) return e(o.catchLoc, !0); if (this.prev < o.finallyLoc) return e(o.finallyLoc) } else if (u) { if (this.prev < o.catchLoc) return e(o.catchLoc, !0) } else { if (!a) throw new Error("try statement without catch or finally"); if (this.prev < o.finallyLoc) return e(o.finallyLoc) } } } }, abrupt: function (t, e) { for (var n = this.tryEntries.length - 1; n >= 0; --n) { var r = this.tryEntries[n]; if (r.tryLoc <= this.prev && b.call(r, "finallyLoc") && this.prev < r.finallyLoc) { var o = r; break } } o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null); var i = o ? o.completion : {}; return i.type = t, i.arg = e, o ? this.next = o.finallyLoc : this.complete(i), M }, complete: function (t, e) { if ("throw" === t.type) throw t.arg; "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = t.arg, this.next = "end") : "normal" === t.type && e && (this.next = e) }, finish: function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), v(n), M } }, "catch": function (t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n.tryLoc === t) { var r = n.completion; if ("throw" === r.type) { var o = r.arg; v(n) } return o } } throw new Error("illegal catch attempt") }, delegateYield: function (t, e, n) { return this.delegate = { iterator: d(t), resultName: e, nextLoc: n }, M } } }("object" == typeof e ? e : "object" == typeof window ? window : "object" == typeof self ? self : this) }).call(e, function () { return this }(), n(294)) }, function (t, e) { function n() { s && u && (s = !1, u.length ? c = u.concat(c) : f = -1, c.length && r()) } function r() { if (!s) { var t = setTimeout(n); s = !0; for (var e = c.length; e;) { for (u = c, c = []; ++f < e;) u && u[f].run(); f = -1, e = c.length } u = null, s = !1, clearTimeout(t) } } function o(t, e) { this.fun = t, this.array = e } function i() { } var u, a = t.exports = {}, c = [], s = !1, f = -1; a.nextTick = function (t) { var e = new Array(arguments.length - 1); if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n]; c.push(new o(t, e)), 1 !== c.length || s || setTimeout(r, 0) }, o.prototype.run = function () { this.fun.apply(null, this.array) }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = i, a.addListener = i, a.once = i, a.off = i, a.removeListener = i, a.removeAllListeners = i, a.emit = i, a.binding = function (t) { throw new Error("process.binding is not supported") }, a.cwd = function () { return "/" }, a.chdir = function (t) { throw new Error("process.chdir is not supported") }, a.umask = function () { return 0 } }, function (t, e, n) { n(296), t.exports = n(9).RegExp.escape }, function (t, e, n) { var r = n(8), o = n(297)(/[\\^$*+?.()|[\]{}]/g, "\\$&"); r(r.S, "RegExp", { escape: function (t) { return o(t) } }) }, function (t, e) { t.exports = function (t, e) { var n = e === Object(e) ? function (t) { return e[t] } : e; return function (e) { return String(e).replace(t, n) } } }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(); n(299); var u = n(303), a = (r(u), n(304)), c = r(a), s = n(305), f = r(s), l = n(322), p = r(l), v = n(326), h = r(v), d = n(327), y = r(d), g = n(328), b = r(g), w = n(329), m = r(w), _ = n(330), O = r(_), x = n(331), j = r(x), E = n(332), P = r(E), S = n(333), M = r(S), k = n(334), A = r(k), T = n(335), F = r(T), N = n(336), I = r(N), C = n(337), R = r(C), D = n(339), L = r(D), U = n(340), B = (r(U), n(341)), G = r(B), W = n(342), V = r(W), z = n(324), J = r(z), q = n(308), Y = r(q), K = n(314), X = r(K), H = n(313), Q = r(H), $ = n(309), Z = r($), tt = n(320), et = r(tt), nt = n(321), rt = r(nt), ot = n(343), it = r(ot), ut = function () { function t() { o(this, t), this.setInitialReferrer(), this.runAsyncEvents(), window.traacProviderManager = new it["default"], this.attachUnloadEvent() } return i(t, [{ key: "registerProvider", value: function (t, e) { window.traacProviderManager.addProvider(t, e) } }, { key: "attachUnloadEvent", value: function () { var t = this; window.addEventListener("unload", function () { t.flush() }) } }, { key: "track", value: function (t) { if ("function" == typeof t) window.traacProviderManager.run("track", t.call(window)); else if ("object" == typeof t && t.eventType) { var e = this[t.eventType](t.eventName, t.kvp).build(); window.traacProviderManager.run("track", e) } else "object" == typeof t && t["event-id"] && window.traacProviderManager.run("track", t) } }, { key: "flush", value: function (t, e) { window.traacProviderManager.run("flush", { callback: t || function () { }, timeout: e || 700 }) } }, { key: "register", value: function (t, e) { if (t && "object" == typeof t) { var n = c["default"].getJSON("traac"), r = {}; if (n) for (var o in n) r[o] = n[o]; for (var o in t) { if (r[o] && e) break; r[o] = t[o] } c["default"].set("traac", r, { expires: 365 }) } } }, { key: "registerOnce", value: function (t) { this.register(t, !0) } }, { key: "deRegister", value: function (t) { var e = c["default"].getJSON("traac"); e && e[t] && (delete e[t], c["default"].set("traac", e, { expires: 365 })) } }, { key: "setUser", value: function (t) { c["default"].set("traacUserId", t, { expires: 365 }) } }, { key: "clearUser", value: function () { c["default"].remove("traacUserId") } }, { key: "setInitialReferrer", value: function () { var t = c["default"].getJSON("traacRef") || {}, e = function (t) { var e = t.split("/"); return e.length >= 3 ? e[2] : void 0 }; document.referrer ? t["initial-referring-domain"] ? t["initial-referring-domain"] !== e(document.referrer) && (t["initial-referring-domain"] = e(document.referrer), t["initial-referrer"] = document.referrer) : (t["initial-referring-domain"] = e(document.referrer), t["initial-referrer"] = document.referrer) : t["initial-referring-domain"] || (t["initial-referring-domain"] = "$direct", t["initial-referrer"] = "$direct"), c["default"].set("traacRef", t, { expires: 365 }) } }, { key: "runAsyncEvents", value: function () { setTimeout(function () { for (var t = 0, e = TRAAC_CONFIG.teq.length; e > t; t++) "object" == typeof TRAAC_CONFIG.teq[t] && TRAAC_CONFIG.teq[t].method ? this[TRAAC_CONFIG.teq[t].method](TRAAC_CONFIG.teq[t].p1, TRAAC_CONFIG.teq[t].p2) : this.track(TRAAC_CONFIG.teq[t]) }.bind(this), 0) } }, { key: "set", value: function (t) { return new p["default"](t) } }, { key: "transact", value: function (t, e) { return new h["default"](t, e) } }, { key: "expressInterestOn", value: function (t) { return new y["default"](t) } }, { key: "authenticate", value: function (t, e, n) { return new b["default"](t, e, n) } }, { key: "refresh", value: function (t) { return new m["default"](t) } }, { key: "print", value: function (t) { return new O["default"](t) } }, { key: "search", value: function (t) { return new j["default"](t) } }, { key: "update", value: function (t) { return new P["default"](t) } }, { key: "delete", value: function (t) { return new M["default"](t) } }, { key: "consume", value: function (t) { return new A["default"](t) } }, { key: "produce", value: function (t) { return new F["default"](t) } }, { key: "download", value: function (t) { return new I["default"](t) } }, { key: "uiShow", value: function (t, e, n) { return new R["default"](t, e, n) } }, { key: "uiHide", value: function (t, e, n) { return new L["default"](t, e, n) } }, { key: "uiInteraction", value: function (t, e, n) { return new L["default"](t, e, n) } }, { key: "uiNavigation", value: function (t, e, n) { return new G["default"](t, e, n) } }, { key: "keyValue", value: function (t, e) { return new V["default"](t, e) } }, { key: "getEventCoreObject", value: function () { return new f["default"] } }, { key: "getUiLocationObject", value: function (t) { return new J["default"](t) } }, { key: "getBusinessDomainDefinitionObject", value: function (t, e) { return new Y["default"](t, e) } }, { key: "getSingleContextObject", value: function (t) { return new X["default"](t) } }, { key: "getPiiKeyValueObject", value: function (t, e) { return new Q["default"](t, e) } }, { key: "getBusinessDomainObject", value: function (t, e) { return new Z["default"](t, e) } }, { key: "getRelatedEventObject", value: function (t, e) { return new et["default"](t, e) } }, { key: "getRelatedBusinessDomainObject", value: function (t) { return new rt["default"](t) } }]), t }(); window.TRAAC = new ut }, function (t, e, n) {
                    var r; (function (t, o, i) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.2.1
	 */
                        (function () { "use strict"; function u(t) { return "function" == typeof t || "object" == typeof t && null !== t } function a(t) { return "function" == typeof t } function c(t) { H = t } function s(t) { tt = t } function f() { return function () { t.nextTick(d) } } function l() { return function () { X(d) } } function p() { var t = 0, e = new rt(d), n = document.createTextNode(""); return e.observe(n, { characterData: !0 }), function () { n.data = t = ++t % 2 } } function v() { var t = new MessageChannel; return t.port1.onmessage = d, function () { t.port2.postMessage(0) } } function h() { return function () { setTimeout(d, 1) } } function d() { for (var t = 0; Z > t; t += 2) { var e = ut[t], n = ut[t + 1]; e(n), ut[t] = void 0, ut[t + 1] = void 0 } Z = 0 } function y() { try { var t = n(301); return X = t.runOnLoop || t.runOnContext, l() } catch (e) { return h() } } function g(t, e) { var n = this, r = new this.constructor(w); void 0 === r[st] && L(r); var o = n._state; if (o) { var i = arguments[o - 1]; tt(function () { C(o, r, i, n._result) }) } else T(n, r, t, e); return r } function b(t) { var e = this; if (t && "object" == typeof t && t.constructor === e) return t; var n = new e(w); return S(n, t), n } function w() { } function m() { return new TypeError("You cannot resolve a promise with itself") } function _() { return new TypeError("A promises callback cannot return that same promise.") } function O(t) { try { return t.then } catch (e) { return vt.error = e, vt } } function x(t, e, n, r) { try { t.call(e, n, r) } catch (o) { return o } } function j(t, e, n) { tt(function (t) { var r = !1, o = x(n, e, function (n) { r || (r = !0, e !== n ? S(t, n) : k(t, n)) }, function (e) { r || (r = !0, A(t, e)) }, "Settle: " + (t._label || " unknown promise")); !r && o && (r = !0, A(t, o)) }, t) } function E(t, e) { e._state === lt ? k(t, e._result) : e._state === pt ? A(t, e._result) : T(e, void 0, function (e) { S(t, e) }, function (e) { A(t, e) }) } function P(t, e, n) { e.constructor === t.constructor && n === at && constructor.resolve === ct ? E(t, e) : n === vt ? A(t, vt.error) : void 0 === n ? k(t, e) : a(n) ? j(t, e, n) : k(t, e) } function S(t, e) { t === e ? A(t, m()) : u(e) ? P(t, e, O(e)) : k(t, e) } function M(t) { t._onerror && t._onerror(t._result), F(t) } function k(t, e) { t._state === ft && (t._result = e, t._state = lt, 0 !== t._subscribers.length && tt(F, t)) } function A(t, e) { t._state === ft && (t._state = pt, t._result = e, tt(M, t)) } function T(t, e, n, r) { var o = t._subscribers, i = o.length; t._onerror = null, o[i] = e, o[i + lt] = n, o[i + pt] = r, 0 === i && t._state && tt(F, t) } function F(t) { var e = t._subscribers, n = t._state; if (0 !== e.length) { for (var r, o, i = t._result, u = 0; u < e.length; u += 3) r = e[u], o = e[u + n], r ? C(n, r, o, i) : o(i); t._subscribers.length = 0 } } function N() { this.error = null } function I(t, e) { try { return t(e) } catch (n) { return ht.error = n, ht } } function C(t, e, n, r) { var o, i, u, c, s = a(n); if (s) { if (o = I(n, r), o === ht ? (c = !0, i = o.error, o = null) : u = !0, e === o) return void A(e, _()) } else o = r, u = !0; e._state !== ft || (s && u ? S(e, o) : c ? A(e, i) : t === lt ? k(e, o) : t === pt && A(e, o)) } function R(t, e) { try { e(function (e) { S(t, e) }, function (e) { A(t, e) }) } catch (n) { A(t, n) } } function D() { return dt++ } function L(t) { t[st] = dt++, t._state = void 0, t._result = void 0, t._subscribers = [] } function U(t) { return new mt(this, t).promise } function B(t) { var e = this; return new e($(t) ? function (n, r) { for (var o = t.length, i = 0; o > i; i++) e.resolve(t[i]).then(n, r) } : function (t, e) { e(new TypeError("You must pass an array to race.")) }) } function G(t) { var e = this, n = new e(w); return A(n, t), n } function W() { throw new TypeError("You must pass a resolver function as the first argument to the promise constructor") } function V() { throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.") } function z(t) { this[st] = D(), this._result = this._state = void 0, this._subscribers = [], w !== t && ("function" != typeof t && W(), this instanceof z ? R(this, t) : V()) } function J(t, e) { this._instanceConstructor = t, this.promise = new t(w), this.promise[st] || L(this.promise), $(e) ? (this._input = e, this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? k(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(), 0 === this._remaining && k(this.promise, this._result))) : A(this.promise, q()) } function q() { return new Error("Array Methods must be provided an Array") } function Y() { var t; if ("undefined" != typeof o) t = o; else if ("undefined" != typeof self) t = self; else try { t = Function("return this")() } catch (e) { throw new Error("polyfill failed because global object is unavailable in this environment") } var n = t.Promise; n && "[object Promise]" === Object.prototype.toString.call(n.resolve()) && !n.cast || (t.Promise = wt) } var K; K = Array.isArray ? Array.isArray : function (t) { return "[object Array]" === Object.prototype.toString.call(t) }; var X, H, Q, $ = K, Z = 0, tt = function (t, e) { ut[Z] = t, ut[Z + 1] = e, Z += 2, 2 === Z && (H ? H(d) : Q()) }, et = "undefined" != typeof window ? window : void 0, nt = et || {}, rt = nt.MutationObserver || nt.WebKitMutationObserver, ot = "undefined" == typeof self && "undefined" != typeof t && "[object process]" === {}.toString.call(t), it = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel, ut = new Array(1e3); Q = ot ? f() : rt ? p() : it ? v() : void 0 === et ? y() : h(); var at = g, ct = b, st = Math.random().toString(36).substring(16), ft = void 0, lt = 1, pt = 2, vt = new N, ht = new N, dt = 0, yt = U, gt = B, bt = G, wt = z; z.all = yt, z.race = gt, z.resolve = ct, z.reject = bt, z._setScheduler = c, z._setAsap = s, z._asap = tt, z.prototype = { constructor: z, then: at, "catch": function (t) { return this.then(null, t) } }; var mt = J; J.prototype._enumerate = function () { for (var t = this.length, e = this._input, n = 0; this._state === ft && t > n; n++) this._eachEntry(e[n], n) }, J.prototype._eachEntry = function (t, e) { var n = this._instanceConstructor, r = n.resolve; if (r === ct) { var o = O(t); if (o === at && t._state !== ft) this._settledAt(t._state, e, t._result); else if ("function" != typeof o) this._remaining--, this._result[e] = t; else if (n === wt) { var i = new n(w); P(i, t, o), this._willSettleAt(i, e) } else this._willSettleAt(new n(function (e) { e(t) }), e) } else this._willSettleAt(r(t), e) }, J.prototype._settledAt = function (t, e, n) { var r = this.promise; r._state === ft && (this._remaining--, t === pt ? A(r, n) : this._result[e] = n), 0 === this._remaining && k(r, this._result) }, J.prototype._willSettleAt = function (t, e) { var n = this; T(t, void 0, function (t) { n._settledAt(lt, e, t) }, function (t) { n._settledAt(pt, e, t) }) }; var _t = Y, Ot = { Promise: wt, polyfill: _t }; n(302).amd ? (r = function () { return Ot }.call(e, n, e, i), !(void 0 !== r && (i.exports = r))) : "undefined" != typeof i && i.exports ? i.exports = Ot : "undefined" != typeof this && (this.ES6Promise = Ot), _t() }).call(this)
                    }).call(e, n(294), function () { return this }(), n(300)(t))
                }, function (t, e) { t.exports = function (t) { return t.webpackPolyfill || (t.deprecate = function () { }, t.paths = [], t.children = [], t.webpackPolyfill = 1), t } }, function (t, e) { }, function (t, e) { t.exports = function () { throw new Error("define cannot be used indirect") } }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = function (t) { return "object" == typeof t && t.constructor && t.constructor.name ? t.constructor.name : typeof t }, t.exports = e["default"] }, function (t, e, n) { var r, o; !function (i) { r = i, o = "function" == typeof r ? r.call(e, n, e, t) : r, !(void 0 !== o && (t.exports = o)) }(function () { function t() { for (var t = 0, e = {}; t < arguments.length; t++) { var n = arguments[t]; for (var r in n) e[r] = n[r] } return e } function e(n) { function r(e, o, i) { var u; if ("undefined" != typeof document) { if (arguments.length > 1) { if (i = t({ path: "/" }, r.defaults, i), "number" == typeof i.expires) { var a = new Date; a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires), i.expires = a } try { u = JSON.stringify(o), /^[\{\[]/.test(u) && (o = u) } catch (c) { } return o = n.write ? n.write(o, e) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = encodeURIComponent(String(e)), e = e.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), e = e.replace(/[\(\)]/g, escape), document.cookie = [e, "=", o, i.expires && "; expires=" + i.expires.toUTCString(), i.path && "; path=" + i.path, i.domain && "; domain=" + i.domain, i.secure ? "; secure" : ""].join("") } e || (u = {}); for (var s = document.cookie ? document.cookie.split("; ") : [], f = /(%[0-9A-Z]{2})+/g, l = 0; l < s.length; l++) { var p = s[l].split("="), v = p[0].replace(f, decodeURIComponent), h = p.slice(1).join("="); '"' === h.charAt(0) && (h = h.slice(1, -1)); try { if (h = n.read ? n.read(h, v) : n(h, v) || h.replace(f, decodeURIComponent), this.json) try { h = JSON.parse(h) } catch (c) { } if (e === v) { u = h; break } e || (u[v] = h) } catch (c) { } } return u } } return r.set = r, r.get = function (t) { return r(t) }, r.getJSON = function () { return r.apply({ json: !0 }, [].slice.call(arguments)) }, r.defaults = {}, r.remove = function (e, n) { r(e, "", t(n, { expires: -1 })) }, r.withConverter = e, r } return e(function () { }) }) }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(306), a = r(u), c = n(303), s = (r(c), n(304)), f = r(s), l = n(307), p = r(l), v = n(308), h = r(v), d = n(309), y = r(d), g = n(314), b = r(g), w = n(316), m = r(w), _ = n(317), O = r(_), x = n(310), j = r(x), E = n(313), P = r(E), S = n(319), M = r(S), k = n(320), A = r(k), T = n(321), F = r(T), N = function () { function t() { o(this, t), this.model = {}, this.model["event-id"] = (0, p["default"])(), this.model["event-id"] = (0, p["default"])(), this.model.tmpMetaData = { flatteningMethod: "concise" }, this.setTimestamp(new Date), this.setSuperProperties(), this.setUser() } return i(t, [{ key: "revertFlatteningMethod", value: function () { this.model.tmpMetaData.flatteningMethod = "legacy" } }, { key: "setPrimaryBusinessDomainObjectType", value: function (t) { return t instanceof h["default"] && (this.model["primary-business-domain-object-type"] = t, this.revertFlatteningMethod()), this } }, { key: "setTimestamp", value: function (t) { return t ? "number" == typeof t ? this.model["event-timestamp"] = t : t instanceof Date && (this.model["event-timestamp"] = t.getTime() / 1e3) : this.model["event-timestamp"] = (new Date).getTime() / 1e3, this } }, { key: "setEventExternalName", value: function (t) { return this.model["event-external-name"] = t, this } }, { key: "setUser", value: function (t) { var e = f["default"].get("traacUserId"); if (e) { var n = new b["default"]("product"); t = t || "", n.setUser(new y["default"](new h["default"](t, "user"), new j["default"](e))), this.setContext(n) } } }, { key: "setEventOriginator", value: function (t) { return m["default"].indexOf(t) > -1 && (this.model["event-originiator"] = t, this.revertFlatteningMethod()), this } }, { key: "setRelatedEvents", value: function (t) { return t instanceof A["default"] && (this.model["related-events"] = this.model["related-events"] || [], this.model["related-events"].push(t), this.revertFlatteningMethod()), this } }, { key: "setContext", value: function (t) { return t instanceof b["default"] && (this.model.contexts = this.model.contexts || [], this.model.contexts.push(t)), this } }, { key: "setRelatedBusinessDomainObject", value: function (t) { return t instanceof F["default"] && (this.model["related-domain-objects"] = this.model["related-domain-objects"] || [], this.model["related-domain-objects"].push(t), this.revertFlatteningMethod()), this } }, { key: "setMetaData", value: function (t) { return t instanceof P["default"] && (this.model.metadata = this.model.metadata || [], this.model.metadata.push(t)), this } }, { key: "setPlatformContext", value: function () { var t = new O["default"], e = new b["default"]("platform"); e.setMetaData(new P["default"]("browser", t.getBrowser().name)), e.setMetaData(new P["default"]("browser-version", t.getBrowser().version)), e.setMetaData(new P["default"]("os", t.getOS().name)), e.setMetaData(new P["default"]("os-version", t.getOS().version)), e.setMetaData(new P["default"]("user-agent", t.getUA())), e.setMetaData(new P["default"]("current-url", window.location.href)), e.setMetaData(new P["default"]("viewport-height", M["default"].height)), e.setMetaData(new P["default"]("viewport-width", M["default"].width)), e.setMetaData(new P["default"]("screen-height", screen.height)), e.setMetaData(new P["default"]("screen-width", screen.width)), e.setMetaData(new P["default"]("traac-sdk", "javascript")), e.setMetaData(new P["default"]("traac-sdk-version", a["default"].version)), e.setMetaData(new P["default"]("traac-model-version", "2.2.6")), e.setMetaData(new P["default"]("traac-flattening-method", this.model.tmpMetaData.flatteningMethod)); var n = f["default"].getJSON("traacRef"); if (n) for (var r in n) e.setMetaData(new P["default"](r, n[r])); this.setContext(e) } }, { key: "setSuperProperties", value: function () { var t = f["default"].getJSON("traac"), e = new b["default"]("product"); if (t) { for (var n in t) e.setMetaData(new P["default"](n, t[n])); this.setContext(e) } } }, { key: "build", value: function () { return this.setPlatformContext(), this.model } }]), t }(); e["default"] = N, t.exports = e["default"] }, function (t, e) { t.exports = { name: "traac-web-core", version: "0.4.9", description: "Core library for web client traac integration.", scripts: { "build-dev": "webpack", build: "webpack && PROD_ENV=1 webpack" }, devDependencies: { "babel-core": "^5.8.25", "babel-loader": "^5.3.2", "json-loader": "^0.5.4", "node-libs-browser": "^0.5.3", webpack: "^1.12.2" }, dependencies: { "babel-polyfill": "latest", "es5-shim": "^4.1.14", "es6-promise": "^3.1.2", "js-cookie": "^2.0.3", "ua-parser-js": "^0.7.9" } } }, function (t, e) { "use strict"; function n() { return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) { var e = 16 * Math.random() | 0, n = "x" == t ? e : 3 & e | 8; return n.toString(16) }) } Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = n, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(303), a = (r(u), function () { function t(e, n) { o(this, t), this.setBusinessDomain(e), this.setBusinessObjectType(n) } return i(t, [{ key: "setBusinessDomain", value: function (t) { "string" == typeof t && (this["business-domain"] = t) } }, { key: "setBusinessObjectType", value: function (t) { "string" == typeof t && (this["business-object-type"] = t) } }]), t }()); e["default"] = a, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(308), a = r(u), c = n(310), s = r(c), f = n(313), l = r(f), p = n(303), v = (r(p), function () { function t(e, n) { o(this, t), this.setBusinessDomainType(e), this.setObjectId(n) } return i(t, [{ key: "setBusinessDomainType", value: function (t) { t instanceof a["default"] && (this["business-domain-type"] = t) } }, { key: "setObjectId", value: function (t) { t instanceof s["default"] && (this["object-id"] = t) } }, { key: "setMetaData", value: function (t) { t instanceof l["default"] && (this.metadata = this.metadata || [], this.metadata.push(t)) } }]), t }()); e["default"] = v, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(311), s = r(c), f = n(303), l = r(f), p = function (t) { function e(t, n, r) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this, n, r), void 0 !== t && this.setValue(t) } return i(e, t), u(e, [{ key: "setValue", value: function (t) { if ("string" === (0, l["default"])(t) || "number" === (0, l["default"])(t) || "boolean" === (0, l["default"])(t) || Array.isArray(t)) { if (Array.isArray(t)) for (var e = t.length, n = void 0, r = void 0, o = 0; e > o; o++) { if (n = (0, l["default"])(t[o]), "string" != n && "number" != n && "boolean" != n) return; if (0 === o) r = n; else if (n != r) return } this.value = t } } }]), e }(s["default"]); e["default"] = p, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(312), a = r(u), c = n(303), s = r(c), f = function () { function t(e, n) { o(this, t), this.setVisibility(e || "public"), n && this.setMask(n) } return i(t, [{ key: "setVisibility", value: function (t) { a["default"].indexOf(t) > -1 && (this.visibility = t) } }, { key: "setMask", value: function (t) { "string" === (0, s["default"])(t) && (this.mask = t) } }]), t }(); e["default"] = f, t.exports = e["default"] }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = ["public", "private", "masked"], t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(310), s = r(c), f = n(303), l = (r(f), function (t) { function e(t, n, r, i) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this, n, r, i), t && this.setKey(t) } return i(e, t), u(e, [{ key: "setKey", value: function (t) { "string" == typeof t && (this.key = t) } }]), e }(s["default"])); e["default"] = l, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(315), a = r(u), c = n(313), s = r(c), f = n(309), l = r(f), p = n(303), v = (r(p), function () { function t(e) { o(this, t), e && this.setContextType(e) } return i(t, [{ key: "setContextType", value: function (t) { a["default"].indexOf(t) > -1 && (this["context-type"] = t) } }, { key: "setMetaData", value: function (t) { t instanceof s["default"] && (this.metadata = this.metadata || [], this.metadata.push(t)) } }, { key: "setUser", value: function (t) { t instanceof l["default"] && (this.user = t) } }]), t }()); e["default"] = v, t.exports = e["default"] }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = ["temporal", "product", "geospatial", "platform"], t.exports = e["default"] }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = ["user", "business-process", "system"], t.exports = e["default"] }, function (t, e, n) { var r; !function (o, i) { "use strict"; var u = "0.7.10", a = "", c = "?", s = "function", f = "undefined", l = "object", p = "string", v = "major", h = "model", d = "name", y = "type", g = "vendor", b = "version", w = "architecture", m = "console", _ = "mobile", O = "tablet", x = "smarttv", j = "wearable", E = "embedded", P = { extend: function (t, e) { for (var n in e) -1 !== "browser cpu device engine os".indexOf(n) && e[n].length % 2 === 0 && (t[n] = e[n].concat(t[n])); return t }, has: function (t, e) { return "string" == typeof t ? -1 !== e.toLowerCase().indexOf(t.toLowerCase()) : !1 }, lowerize: function (t) { return t.toLowerCase() }, major: function (t) { return typeof t === p ? t.split(".")[0] : i } }, S = { rgx: function () { for (var t, e, n, r, o, u, a, c = 0, p = arguments; c < p.length && !u;) { var v = p[c], h = p[c + 1]; if (typeof t === f) { t = {}; for (r in h) h.hasOwnProperty(r) && (o = h[r], typeof o === l ? t[o[0]] = i : t[o] = i) } for (e = n = 0; e < v.length && !u;) if (u = v[e++].exec(this.getUA())) for (r = 0; r < h.length; r++) a = u[++n], o = h[r], typeof o === l && o.length > 0 ? 2 == o.length ? typeof o[1] == s ? t[o[0]] = o[1].call(this, a) : t[o[0]] = o[1] : 3 == o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? t[o[0]] = a ? a.replace(o[1], o[2]) : i : t[o[0]] = a ? o[1].call(this, a, o[2]) : i : 4 == o.length && (t[o[0]] = a ? o[3].call(this, a.replace(o[1], o[2])) : i) : t[o] = a ? a : i; c += 2 } return t }, str: function (t, e) { for (var n in e) if (typeof e[n] === l && e[n].length > 0) { for (var r = 0; r < e[n].length; r++) if (P.has(e[n][r], t)) return n === c ? i : n } else if (P.has(e[n], t)) return n === c ? i : n; return t } }, M = { browser: { oldsafari: { version: { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" } } }, device: { amazon: { model: { "Fire Phone": ["SD", "KF"] } }, sprint: { model: { "Evo Shift 4G": "7373KT" }, vendor: { HTC: "APA", Sprint: "Sprint" } } }, os: { windows: { version: { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2000: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" } } } }, k = { browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [d, b], [/\s(opr)\/([\w\.]+)/i], [[d, "Opera"], b], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]+)*/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i], [d, b], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[d, "IE"], b], [/(edge)\/((\d+)?[\w\.]+)/i], [d, b], [/(yabrowser)\/([\w\.]+)/i], [[d, "Yandex"], b], [/(comodo_dragon)\/([\w\.]+)/i], [[d, /_/g, " "], b], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i, /(qqbrowser)[\/\s]?([\w\.]+)/i], [d, b], [/(uc\s?browser)[\/\s]?([\w\.]+)/i, /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i, /JUC.+(ucweb)[\/\s]?([\w\.]+)/i], [[d, "UCBrowser"], b], [/(dolfin)\/([\w\.]+)/i], [[d, "Dolphin"], b], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[d, "Chrome"], b], [/XiaoMi\/MiuiBrowser\/([\w\.]+)/i], [b, [d, "MIUI Browser"]], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i], [b, [d, "Android Browser"]], [/FBAV\/([\w\.]+);/i], [b, [d, "Facebook"]], [/fxios\/([\w\.-]+)/i], [b, [d, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [b, [d, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [b, d], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [d, [b, S.str, M.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i], [d, b], [/(navigator|netscape)\/([\w\.-]+)/i], [[d, "Netscape"], b], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]+)*/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [d, b]], cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[w, "amd64"]], [/(ia32(?=;))/i], [[w, P.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[w, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[w, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[w, /ower/, "", P.lowerize]], [/(sun4\w)[;\)]/i], [[w, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[w, P.lowerize]]], device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [h, g, [y, O]], [/applecoremedia\/[\w\.]+ \((ipad)/], [h, [g, "Apple"], [y, O]], [/(apple\s{0,1}tv)/i], [[h, "Apple TV"], [g, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [g, h, [y, O]], [/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i], [h, [g, "Amazon"], [y, O]], [/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i], [[h, S.str, M.device.amazon.model], [g, "Amazon"], [y, _]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [h, g, [y, _]], [/\((ip[honed|\s\w*]+);/i], [h, [g, "Apple"], [y, _]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [g, h, [y, _]], [/\(bb10;\s(\w+)/i], [h, [g, "BlackBerry"], [y, _]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7)/i], [h, [g, "Asus"], [y, O]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[g, "Sony"], [h, "Xperia Tablet"], [y, O]], [/(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i], [[g, "Sony"], [h, "Xperia Phone"], [y, _]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [g, h, [y, m]], [/android.+;\s(shield)\sbuild/i], [h, [g, "Nvidia"], [y, m]], [/(playstation\s[34portablevi]+)/i], [h, [g, "Sony"], [y, m]], [/(sprint\s(\w+))/i], [[g, S.str, M.device.sprint.vendor], [h, S.str, M.device.sprint.model], [y, _]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [g, h, [y, O]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w+)*/i, /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i], [g, [h, /_/g, " "], [y, _]], [/(nexus\s9)/i], [h, [g, "HTC"], [y, O]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [h, [g, "Microsoft"], [y, m]], [/(kin\.[onetw]{3})/i], [[h, /\./g, " "], [g, "Microsoft"], [y, _]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w+)*/i, /(XT\d{3,4}) build\//i, /(nexus\s[6])/i], [h, [g, "Motorola"], [y, _]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [h, [g, "Motorola"], [y, O]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[g, "Samsung"], h, [y, O]], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i, /sec-((sgh\w+))/i], [[g, "Samsung"], h, [y, _]], [/(samsung);smarttv/i], [g, h, [y, x]], [/\(dtv[\);].+(aquos)/i], [h, [g, "Sharp"], [y, x]], [/sie-(\w+)*/i], [h, [g, "Siemens"], [y, _]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]+)*/i], [[g, "Nokia"], h, [y, _]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i], [h, [g, "Acer"], [y, O]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[g, "LG"], h, [y, O]], [/(lg) netcast\.tv/i], [g, h, [y, x]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w+)*/i], [h, [g, "LG"], [y, _]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [h, [g, "Lenovo"], [y, O]], [/linux;.+((jolla));/i], [g, h, [y, _]], [/((pebble))app\/[\d\.]+\s/i], [g, h, [y, j]], [/android.+;\s(glass)\s\d/i], [h, [g, "Google"], [y, j]], [/android.+(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:one|one[\s_]plus)?[\s_]*(?:\d\w)?)\s+build/i], [[h, /_/g, " "], [g, "Xiaomi"], [y, _]], [/\s(tablet)[;\/\s]/i, /\s(mobile)[;\/\s]/i], [[y, P.lowerize], g, h]], engine: [[/windows.+\sedge\/([\w\.]+)/i], [b, [d, "EdgeHTML"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [d, b], [/rv\:([\w\.]+).*(gecko)/i], [b, d]], os: [[/microsoft\s(windows)\s(vista|xp)/i], [d, b], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [d, [b, S.str, M.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[d, "Windows"], [b, S.str, M.os.windows.version]], [/\((bb)(10);/i], [[d, "BlackBerry"], b], [/(blackberry)\w*\/?([\w\.]+)*/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i, /linux;.+(sailfish);/i], [d, b], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i], [[d, "Symbian"], b], [/\((series40);/i], [d], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[d, "Firefox OS"], b], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w+)*/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i, /(hurd|linux)\s?([\w\.]+)*/i, /(gnu)\s?([\w\.]+)*/i], [d, b], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[d, "Chromium OS"], b], [/(sunos)\s?([\w\.]+\d)*/i], [[d, "Solaris"], b], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i], [d, b], [/(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i], [[d, "iOS"], [b, /_/g, "."]], [/(mac\sos\sx)\s?([\w\s\.]+\w)*/i, /(macintosh|mac(?=_powerpc)\s)/i], [[d, "Mac OS"], [b, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i, /(haiku)\s(\w+)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, /(unix)\s?([\w\.]+)*/i], [d, b]] }, A = function (t, e) { if (!(this instanceof A)) return new A(t, e).getResult(); var n = t || (o && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : a), r = e ? P.extend(k, e) : k; return this.getBrowser = function () { var t = S.rgx.apply(this, r.browser); return t.major = P.major(t.version), t }, this.getCPU = function () { return S.rgx.apply(this, r.cpu) }, this.getDevice = function () { return S.rgx.apply(this, r.device) }, this.getEngine = function () { return S.rgx.apply(this, r.engine) }, this.getOS = function () { return S.rgx.apply(this, r.os) }, this.getResult = function () { return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() } }, this.getUA = function () { return n }, this.setUA = function (t) { return n = t, this }, this.setUA(n), this }; A.VERSION = u, A.BROWSER = { NAME: d, MAJOR: v, VERSION: b }, A.CPU = { ARCHITECTURE: w }, A.DEVICE = { MODEL: h, VENDOR: g, TYPE: y, CONSOLE: m, MOBILE: _, SMARTTV: x, TABLET: O, WEARABLE: j, EMBEDDED: E }, A.ENGINE = { NAME: d, VERSION: b }, A.OS = { NAME: d, VERSION: b }, typeof e !== f ? (typeof t !== f && t.exports && (e = t.exports = A), e.UAParser = A) : "function" === s && n(318) ? (r = function () { return A }.call(e, n, e, t), !(r !== i && (t.exports = r))) : o.UAParser = A; var T = o.jQuery || o.Zepto; if (typeof T !== f) { var F = new A; T.ua = F.getResult(), T.ua.get = function () { return F.getUA() }, T.ua.set = function (t) { F.setUA(t); var e = F.getResult(); for (var n in e) T.ua[n] = e[n] } } }("object" == typeof window ? window : this) }, function (t, e) { (function (e) { t.exports = e }).call(e, {}) }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }); var n = window, r = document, o = r.documentElement, i = r.getElementsByTagName("body")[0], u = n.innerWidth || o.clientWidth || i.clientWidth, a = n.innerHeight || o.clientHeight || i.clientHeight; e["default"] = { width: u, height: a }, t.exports = e["default"] }, function (t, e, n) {
                    "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(303), a = (r(u), function () { function t(e, n) { o(this, t), this.setRelationshipType(e), this.setRelatedEventId(n) } return i(t, [{ key: "setRelationshipType", value: function (t) { "string" == typeof t && (this["relationship-type"] = t) } }, { key: "setRelatedEventId", value: function (t) { "string" == typeof t && (this["relationship-event-id"] = t) } }]), t }()); e["default"] = a, t.exports = e["default"];
                }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(309), s = r(c), f = n(303), l = (r(f), function (t) { function e(t) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), t && this.setRelationshipType(t) } return i(e, t), u(e, [{ key: "setRelationshipType", value: function (t) { "string" == typeof t && (this["relationship-type"] = t) } }]), e }(s["default"])); e["default"] = l, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("set") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(303), s = (r(c), n(305)), f = r(s), l = n(324), p = r(l), v = n(325), h = r(v), d = function (t) { function e() { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this) } return i(e, t), u(e, [{ key: "setEventMetaAction", value: function (t) { return h["default"].indexOf(t) > -1 && (this.model["event-meta-action"] = t, this.revertFlatteningMethod()), this } }, { key: "setEventAction", value: function (t) { return "string" == typeof t && (this.model["event-action"] = t, this.revertFlatteningMethod()), this } }, { key: "setUiLocation", value: function (t) { return t instanceof p["default"] && (this.model["ui-location"] = t, this.revertFlatteningMethod()), this } }]), e }(f["default"]); e["default"] = d, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(303), a = (r(u), function () { function t(e) { o(this, t), e && this.setName(e) } return i(t, [{ key: "setName", value: function (t) { "string" == typeof t && (this.name = t) } }]), t }()); e["default"] = a, t.exports = e["default"] }, function (t, e) { "use strict"; Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = ["ui-navigation", "ui-interaction", "ui-show", "ui-hide", "produce", "download", "consume", "delete", "update", "search", "print", "refresh", "authenticate", "express-interest-on", "set", "transact", "undefined"], t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t, n) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.model.success = n, this.setEventMetaAction("transact") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("express-interest-on") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = n(309), f = r(s), l = n(308), p = r(l), v = n(310), h = r(v), d = function (t) { function e(t, n, r) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("authenticate"), this.model.success = n, r && (this.model.user = new f["default"](new p["default"]("", "user"), new h["default"](r))) } return i(e, t), e }(c["default"]); e["default"] = d, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("refresh") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("print") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("search") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("update") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("delete") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("consume") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("produce") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = function (t) { function e(t) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("download") } return i(e, t), e }(c["default"]); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(323), s = r(c), f = n(338), l = r(f), p = function (t) { function e(t, n, r) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("ui-show"), n && this.setUIElement(n, r) } return i(e, t), u(e, [{ key: "setUIElement", value: function (t, e) { this.model["ui-element"] = new l["default"](t, e) } }]), e }(s["default"]); e["default"] = p, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var i = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), u = n(303), a = (r(u), n(324)), c = r(a), s = function () { function t(e, n) { o(this, t), e && (this.setName(e), n && this.setEnclosingUiLocation(n)) } return i(t, [{ key: "setName", value: function (t) { "string" == typeof t && (this.name = t) } }, { key: "setEnclosingUiLocation", value: function (t) { this.enclosingUILocation = new c["default"](t) } }]), t }(); e["default"] = s, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(323), s = r(c), f = n(338), l = r(f), p = function (t) { function e(t, n, r) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("ui-hide"), n && this.setUIElement(n, r) } return i(e, t), u(e, [{ key: "setUIElement", value: function (t, e) { this.model["ui-element"] = new l["default"](t, e) } }]), e }(s["default"]); e["default"] = p, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(323), s = r(c), f = n(338), l = r(f), p = function (t) { function e(t, n, r) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("ui-interaction"), n && this.setUIElement(n, r) } return i(e, t), u(e, [{ key: "setUIElement", value: function (t, e) { this.model["ui-element"] = new l["default"](t, e) } }]), e }(s["default"]); e["default"] = p, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), a = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, c = n(323), s = r(c), f = n(324), l = r(f), p = function (t) { function e(t, n, r) { o(this, e), a(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t), this.setEventMetaAction("ui-navigation"), n && this.setUILocationFrom(n), r && this.setUILocationTo(r) } return i(e, t), u(e, [{ key: "setUILocationFrom", value: function (t) { this.model["ui-location-from"] = new l["default"](t) } }, { key: "setUILocationTo", value: function (t) { this.model["ui-location-to"] = new l["default"](t) } }]), e }(s["default"]); e["default"] = p, t.exports = e["default"] }, function (t, e, n) { "use strict"; function r(t) { return t && t.__esModule ? t : { "default": t } } function o(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } function i(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e) } Object.defineProperty(e, "__esModule", { value: !0 }); var u = function (t, e, n) { for (var r = !0; r;) { var o = t, i = e, u = n; r = !1, null === o && (o = Function.prototype); var a = Object.getOwnPropertyDescriptor(o, i); if (void 0 !== a) { if ("value" in a) return a.value; var c = a.get; if (void 0 === c) return; return c.call(u) } var s = Object.getPrototypeOf(o); if (null === s) return; t = s, e = i, n = u, r = !0, a = s = void 0 } }, a = n(323), c = r(a), s = n(313), f = r(s), l = function (t) { function e(t, n) { o(this, e), u(Object.getPrototypeOf(e.prototype), "constructor", this).call(this), this.setEventExternalName(t); for (var r in n) if (n.hasOwnProperty(r)) { var i = n[r]; this.setMetaData(new f["default"](r, i)) } } return i(e, t), e }(c["default"]); e["default"] = l, t.exports = e["default"] }, function (t, e) { "use strict"; function n(t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") } Object.defineProperty(e, "__esModule", { value: !0 }); var r = function () { function t(t, e) { for (var n = 0; n < e.length; n++) { var r = e[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r) } } return function (e, n, r) { return n && t(e.prototype, n), r && t(e, r), e } }(), o = function () { function t() { n(this, t), this.registeredProviders = [], this.registerConfiguredAdapters(), this.eventCBQueue = [] } return r(t, [{ key: "registerConfiguredAdapters", value: function () { for (var t = 0, e = TRAAC_CONFIG.adapters.length; e > t; t++) this.addProvider(TRAAC_CONFIG.adapters[t].type, TRAAC_CONFIG.adapters[t].config) } }, { key: "addProvider", value: function (t, e) { var n = void 0; try { t += "Adapter", n = new window[t](e) } catch (r) { return } this.registeredProviders.push(n) } }, { key: "run", value: function (t, e) { var n = this; for (var r in this.registeredProviders) this.registeredProviders.hasOwnProperty(r) && this.registeredProviders[r][t](e, this.eventCBQueue); if ("flush" === t) { var o, i; !function () { var t = !1; setTimeout(function () { t || (t = !0, e.callback()) }, e.timeout), o = []; for (i in n.eventCBQueue) n.eventCBQueue.hasOwnProperty(i) && o.push(n.eventCBQueue[i]); Promise.all(o).then(function () { t || (t = !0, e.callback()) }) }() } } }]), t }(); e["default"] = o, t.exports = e["default"] }])
            });
        }
    }, 1000);
})(window);
/**!
 * AngularJS file upload/drop directive and service with progress and abort
 * @author  Danial  <danial.farid@gmail.com>
 * @version 3.2.4
 */
(function () {

var key, i;
function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
}

if (window.XMLHttpRequest && !window.XMLHttpRequest.__isFileAPIShim) {
    patchXHR('setRequestHeader', function (orig) {
        return function (header, value) {
            if (header === '__setXHR_') {
                var val = value(this);
                // fix for angular < 1.2.0
                if (val instanceof Function) {
                    val(this);
                }
            } else {
                orig.apply(this, arguments);
            }
        }
    });
}

var angularFileUpload = angular.module('angularFileUpload', []);

angularFileUpload.version = '3.2.4';
angularFileUpload.service('$upload', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
    function sendHttp(config) {
        config.method = config.method || 'POST';
        config.headers = config.headers || {};
        config.transformRequest = config.transformRequest || function (data, headersGetter) {
            if (window.ArrayBuffer && data instanceof window.ArrayBuffer) {
                return data;
            }
            return $http.defaults.transformRequest[0](data, headersGetter);
        };
        var deferred = $q.defer();
        var promise = deferred.promise;

        config.headers['__setXHR_'] = function () {
            return function (xhr) {
                if (!xhr) return;
                config.__XHR = xhr;
                config.xhrFn && config.xhrFn(xhr);
                xhr.upload.addEventListener('progress', function (e) {
                    e.config = config;
                    deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {
                        promise.progress_fn(e)
                    });
                }, false);
                //fix for firefox not firing upload progress end, also IE8-9
                xhr.upload.addEventListener('load', function (e) {
                    if (e.lengthComputable) {
                        e.config = config;
                        deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {
                            promise.progress_fn(e)
                        });
                    }
                }, false);
            };
        };

        $http(config).then(function (r) {
            deferred.resolve(r)
        }, function (e) {
            deferred.reject(e)
        }, function (n) {
            deferred.notify(n)
        });

        promise.success = function (fn) {
            promise.then(function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.error = function (fn) {
            promise.then(null, function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.progress = function (fn) {
            promise.progress_fn = fn;
            promise.then(null, null, function (update) {
                fn(update);
            });
            return promise;
        };
        promise.abort = function () {
            if (config.__XHR) {
                $timeout(function () {
                    config.__XHR.abort();
                });
            }
            return promise;
        };
        promise.xhr = function (fn) {
            config.xhrFn = (function (origXhrFn) {
                return function () {
                    origXhrFn && origXhrFn.apply(promise, arguments);
                    fn.apply(promise, arguments);
                }
            })(config.xhrFn);
            return promise;
        };

        return promise;
    }

    this.upload = function (config) {
        config.headers = config.headers || {};
        config.headers['Content-Type'] = undefined;
        config.transformRequest = config.transformRequest ?
            (Object.prototype.toString.call(config.transformRequest) === '[object Array]' ?
                config.transformRequest : [config.transformRequest]) : [];
        config.transformRequest.push(function (data) {
            var formData = new FormData();
            var allFields = {};
            for (key in config.fields) {
                if (config.fields.hasOwnProperty(key)) {
                    allFields[key] = config.fields[key];
                }
            }
            if (data) allFields['data'] = data;

            if (config.formDataAppender) {
                for (key in allFields) {
                    if (allFields.hasOwnProperty(key)) {
                        config.formDataAppender(formData, key, allFields[key]);
                    }
                }
            } else {
                for (key in allFields) {
                    if (allFields.hasOwnProperty(key)) {
                        var val = allFields[key];
                        if (val !== undefined) {
                            if (Object.prototype.toString.call(val) === '[object String]') {
                                formData.append(key, val);
                            } else {
                                if (config.sendObjectsAsJsonBlob && typeof val === 'object') {
                                    formData.append(key, new Blob([val], {type: 'application/json'}));
                                } else {
                                    formData.append(key, JSON.stringify(val));
                                }
                            }

                        }
                    }
                }
            }

            if (config.file != null) {
                var fileFormName = config.fileFormDataName || 'file';

                if (Object.prototype.toString.call(config.file) === '[object Array]') {
                    var isFileFormNameString = Object.prototype.toString.call(fileFormName) === '[object String]';
                    for (i = 0; i < config.file.length; i++) {
                        formData.append(isFileFormNameString ? fileFormName : fileFormName[i], config.file[i],
                            (config.fileName && config.fileName[i]) || config.file[i].name);
                    }
                } else {
                    formData.append(fileFormName, config.file, config.fileName || config.file.name);
                }
            }
            return formData;
        });

        return sendHttp(config);
    };

    this.http = function (config) {
        return sendHttp(config);
    };
}]);

angularFileUpload.directive('ngFileSelect', ['$parse', '$timeout', '$compile',
    function ($parse, $timeout, $compile) {
        return {
            restrict: 'AEC',
            require: '?ngModel',
            link: function (scope, elem, attr, ngModel) {
                linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile);
            }
        }
    }]);

function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile) {
    function isInputTypeFile() {
        return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
    }

    var isUpdating = false;
    function changeFn(evt) {
        if (!isUpdating) {
            isUpdating = true;
            try {
                var fileList = evt.__files_ || (evt.target && evt.target.files);
                var files = [], rejFiles = [];

                var accept = $parse(attr.ngAccept);
                for (i = 0; i < fileList.length; i++) {
                    var file = fileList.item(i);
                    if (isAccepted(scope, accept, file, evt)) {
                        files.push(file);
                    } else {
                        rejFiles.push(file);
                    }
                }
                updateModel($parse, $timeout, scope, ngModel, attr,
                    attr.ngFileChange || attr.ngFileSelect, files, rejFiles, evt);
                if (files.length == 0) evt.target.value = files;
                if (evt.target && evt.target.getAttribute('__ngf_gen__')) {
                    angular.element(evt.target).remove();
                }
            } finally {
                isUpdating = false;
            }
        }
    }

    function bindAttrToFileInput(fileElem) {
        if (attr.ngMultiple) fileElem.attr('multiple', $parse(attr.ngMultiple)(scope));
        if (attr['accept']) fileElem.attr('accept', attr['accept']);
        if (attr.ngCapture) fileElem.attr('capture', $parse(attr.ngCapture)(scope));
        if (attr.ngDisabled) fileElem.attr('disabled', $parse(attr.ngDisabled)(scope));

        fileElem.bind('change', changeFn);
    }

    function createFileInput(evt) {
        if (elem.attr('disabled')) {
            return;
        }
        var fileElem = angular.element('<input type="file">');

        for (var i = 0; i < elem[0].attributes.length; i++) {
            var attribute = elem[0].attributes[i];
            fileElem.attr(attribute.name, attribute.value);
        }

        if (isInputTypeFile()) {
            elem.replaceWith(fileElem);
            elem = fileElem;
        } else {
            fileElem.css('width', '0px').css('height', '0px').css('position', 'absolute')
                .css('padding', 0).css('margin', 0).css('overflow', 'hidden')
                .attr('tabindex', '-1').css('opacity', 0).attr('__ngf_gen__', true);
            if (elem.__ngf_ref_elem__) elem.__ngf_ref_elem__.remove();
            elem.__ngf_ref_elem__ = fileElem;
            elem.parent()[0].insertBefore(fileElem[0], elem[0]);
            elem.css('overflow', 'hidden');
        }

        bindAttrToFileInput(fileElem);

        return fileElem;
    }

    function resetModel(evt) {
        updateModel($parse, $timeout, scope, ngModel, attr,
            attr.ngFileChange || attr.ngFileSelect, [], [], evt, true);
    }

    function clickHandler(evt) {
        var fileElem = createFileInput(evt);
        if (fileElem) {
            resetModel(evt);

            fileElem[0].click();
        }
        if (isInputTypeFile()) {
            elem.bind('click', clickHandler);
            evt.preventDefault()
        }
    }

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
        window.FileAPI.ngfFixIE(elem, createFileInput, changeFn, resetModel);
    } else {
        elem.bind('click', clickHandler);
    }
}

angularFileUpload.directive('ngFileDrop', ['$parse', '$timeout', '$location', function ($parse, $timeout, $location) {
    return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
            linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location);
        }
    }
}]);

angularFileUpload.directive('ngNoFileDrop', function () {
    return function (scope, elem) {
        if (dropAvailable()) elem.css('display', 'none')
    }
});

//for backward compatibility
angularFileUpload.directive('ngFileDropAvailable', ['$parse', '$timeout', function ($parse, $timeout) {
    return function (scope, elem, attr) {
        if (dropAvailable()) {
            var fn = $parse(attr['ngFileDropAvailable']);
            $timeout(function () {
                fn(scope);
            });
        }
    }
}]);

function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location) {
    var available = dropAvailable();
    if (attr['dropAvailable']) {
        $timeout(function () {
            scope.dropAvailable ? scope.dropAvailable.value = available :
                scope.dropAvailable = available;
        });
    }
    if (!available) {
        if ($parse(attr.hideOnDropNotAvailable)(scope) == true) {
            elem.css('display', 'none');
        }
        return;
    }
    var leaveTimeout = null;
    var stopPropagation = $parse(attr.stopPropagation);
    var dragOverDelay = 1;
    var accept = $parse(attr.ngAccept);
    var disabled = $parse(attr.ngDisabled);
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
        // handling dragover events from the Chrome download bar
        if (navigator.userAgent.indexOf("Chrome") > -1) {
            var b = evt.dataTransfer.effectAllowed;
            evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
        }
        $timeout.cancel(leaveTimeout);
        if (!scope.actualDragOverClass) {
            actualDragOverClass = calculateDragOverClass(scope, attr, evt);
        }
        elem.addClass(actualDragOverClass);
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function () {
        if (disabled(scope)) return;
        leaveTimeout = $timeout(function () {
            elem.removeClass(actualDragOverClass);
            actualDragOverClass = null;
        }, dragOverDelay || 1);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
        elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        extractFiles(evt, function (files, rejFiles) {
            updateModel($parse, $timeout, scope, ngModel, attr,
                attr.ngFileChange || attr.ngFileDrop, files, rejFiles, evt)
        }, $parse(attr.allowDir)(scope) != false, attr.multiple || $parse(attr.ngMultiple)(scope));
    }, false);

    function calculateDragOverClass(scope, attr, evt) {
        var accepted = true;
        var items = evt.dataTransfer.items;
        if (items != null) {
            for (i = 0; i < items.length && accepted; i++) {
                accepted = accepted
                    && (items[i].kind == 'file' || items[i].kind == '')
                    && isAccepted(scope, accept, items[i], evt);
            }
        }
        var clazz = $parse(attr.dragOverClass)(scope, {$event: evt});
        if (clazz) {
            if (clazz.delay) dragOverDelay = clazz.delay;
            if (clazz.accept) clazz = accepted ? clazz.accept : clazz.reject;
        }
        return clazz || attr['dragOverClass'] || 'dragover';
    }

    function extractFiles(evt, callback, allowDir, multiple) {
        var files = [], rejFiles = [], items = evt.dataTransfer.items, processing = 0;

        function addFile(file) {
            if (isAccepted(scope, accept, file, evt)) {
                files.push(file);
            } else {
                rejFiles.push(file);
            }
        }

        if (items && items.length > 0 && $location.protocol() != 'file') {
            for (i = 0; i < items.length; i++) {
                if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
                    var entry = items[i].webkitGetAsEntry();
                    if (entry.isDirectory && !allowDir) {
                        continue;
                    }
                    if (entry != null) {
                        traverseFileTree(files, entry);
                    }
                } else {
                    var f = items[i].getAsFile();
                    if (f != null) addFile(f);
                }
                if (!multiple && files.length > 0) break;
            }
        } else {
            var fileList = evt.dataTransfer.files;
            if (fileList != null) {
                for (i = 0; i < fileList.length; i++) {
                    addFile(fileList.item(i));
                    if (!multiple && files.length > 0) break;
                }
            }
        }
        var delays = 0;
        (function waitForProcess(delay) {
            $timeout(function () {
                if (!processing) {
                    if (!multiple && files.length > 1) {
                        i = 0;
                        while (files[i].type == 'directory') i++;
                        files = [files[i]];
                    }
                    callback(files, rejFiles);
                } else {
                    if (delays++ * 10 < 20 * 1000) {
                        waitForProcess(10);
                    }
                }
            }, delay || 0)
        })();

        function traverseFileTree(files, entry, path) {
            if (entry != null) {
                if (entry.isDirectory) {
                    var filePath = (path || '') + entry.name;
                    addFile({name: entry.name, type: 'directory', path: filePath});
                    var dirReader = entry.createReader();
                    var entries = [];
                    processing++;
                    var readEntries = function () {
                        dirReader.readEntries(function (results) {
                            try {
                                if (!results.length) {
                                    for (i = 0; i < entries.length; i++) {
                                        traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
                                    }
                                    processing--;
                                } else {
                                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                                    readEntries();
                                }
                            } catch (e) {
                                processing--;
                                console.error(e);
                            }
                        }, function () {
                            processing--;
                        });
                    };
                    readEntries();
                } else {
                    processing++;
                    entry.file(function (file) {
                        try {
                            processing--;
                            file.path = (path ? path : '') + file.name;
                            addFile(file);
                        } catch (e) {
                            processing--;
                            console.error(e);
                        }
                    }, function () {
                        processing--;
                    });
                }
            }
        }
    }
}

function dropAvailable() {
    var div = document.createElement('div');
    return ('draggable' in div) && ('ondrop' in div);
}

function updateModel($parse, $timeout, scope, ngModel, attr, fileChange, files, rejFiles, evt, noDelay) {
    function update() {
        if (ngModel) {
            $parse(attr.ngModel).assign(scope, files);
            $timeout(function () {
                ngModel && ngModel.$setViewValue(files != null && files.length == 0 ? null : files);
            });
        }
        if (attr.ngModelRejected) {
            $parse(attr.ngModelRejected).assign(scope, rejFiles);
        }
        if (fileChange) {
            $parse(fileChange)(scope, {
                $files: files,
                $rejectedFiles: rejFiles,
                $event: evt
            });

        }
    }
    if (noDelay) {
        update();
    } else {
        $timeout(function () {
            update();
        });
    }
}

function isAccepted(scope, accept, file, evt) {
    var val = accept(scope, {$file: file, $event: evt});
    if (val == null) {
        return true;
    }
    if (angular.isString(val)) {
        var regexp = new RegExp(globStringToRegex(val), 'gi')
        val = (file.type != null && file.type.match(regexp)) ||
        (file.name != null && file.name.match(regexp));
    }
    return val;
}

function globStringToRegex(str) {
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
        return str.substring(1, str.length - 1);
    }
    var split = str.split(','), result = '';
    if (split.length > 1) {
        for (i = 0; i < split.length; i++) {
            result += '(' + globStringToRegex(split[i]) + ')';
            if (i < split.length - 1) {
                result += '|'
            }
        }
    } else {
        if (str.indexOf('.') == 0) {
            str = '*' + str;
        }
        result = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + '-]', 'g'), '\\$&') + '$';
        result = result.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
    }
    return result;
}

var ngFileUpload = angular.module('ngFileUpload', []);

for (key in angularFileUpload) {
    if (angularFileUpload.hasOwnProperty(key)) {
        ngFileUpload[key] = angularFileUpload[key];
    }
}

})();

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));
/*!
 * ngImgCrop v0.3.2
 * https://github.com/alexk111/ngImgCrop
 *
 * Copyright (c) 2016 Alex Kaul
 * License: MIT
 *
 * Generated at Tuesday, March 22nd, 2016, 6:50:38 PM
 */
(function() {
'use strict';

var crop = angular.module('ngImgCrop', []);

crop.factory('cropAreaCircle', ['cropArea', function(CropArea) {
  var CropAreaCircle = function() {
    CropArea.apply(this, arguments);

    this._boxResizeBaseSize = 20;
    this._boxResizeNormalRatio = 0.9;
    this._boxResizeHoverRatio = 1.2;
    this._iconMoveNormalRatio = 0.9;
    this._iconMoveHoverRatio = 1.2;

    this._boxResizeNormalSize = this._boxResizeBaseSize*this._boxResizeNormalRatio;
    this._boxResizeHoverSize = this._boxResizeBaseSize*this._boxResizeHoverRatio;

    this._posDragStartX=0;
    this._posDragStartY=0;
    this._posResizeStartX=0;
    this._posResizeStartY=0;
    this._posResizeStartSize=0;

    this._boxResizeIsHover = false;
    this._areaIsHover = false;
    this._boxResizeIsDragging = false;
    this._areaIsDragging = false;
  };

  CropAreaCircle.prototype = new CropArea();

  CropAreaCircle.prototype._calcCirclePerimeterCoords=function(angleDegrees) {
    var hSize=this._size/2;
    var angleRadians=angleDegrees * (Math.PI / 180),
        circlePerimeterX=this._x + hSize * Math.cos(angleRadians),
        circlePerimeterY=this._y + hSize * Math.sin(angleRadians);
    return [circlePerimeterX, circlePerimeterY];
  };

  CropAreaCircle.prototype._calcResizeIconCenterCoords=function() {
    return this._calcCirclePerimeterCoords(-45);
  };

  CropAreaCircle.prototype._isCoordWithinArea=function(coord) {
    return Math.sqrt((coord[0]-this._x)*(coord[0]-this._x) + (coord[1]-this._y)*(coord[1]-this._y)) < this._size/2;
  };
  CropAreaCircle.prototype._isCoordWithinBoxResize=function(coord) {
    var resizeIconCenterCoords=this._calcResizeIconCenterCoords();
    var hSize=this._boxResizeHoverSize/2;
    return(coord[0] > resizeIconCenterCoords[0] - hSize && coord[0] < resizeIconCenterCoords[0] + hSize &&
           coord[1] > resizeIconCenterCoords[1] - hSize && coord[1] < resizeIconCenterCoords[1] + hSize);
  };

  CropAreaCircle.prototype._drawArea=function(ctx,centerCoords,size){
    ctx.arc(centerCoords[0],centerCoords[1],size/2,0,2*Math.PI);
  };

  CropAreaCircle.prototype.draw=function() {
    CropArea.prototype.draw.apply(this, arguments);

    // draw move icon
    this._cropCanvas.drawIconMove([this._x,this._y], this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);

    // draw resize cubes
    this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover?this._boxResizeHoverRatio:this._boxResizeNormalRatio);
  };

  CropAreaCircle.prototype.processMouseMove=function(mouseCurX, mouseCurY) {
    var cursor='default';
    var res=false;

    this._boxResizeIsHover = false;
    this._areaIsHover = false;

    if (this._areaIsDragging) {
      this._x = mouseCurX - this._posDragStartX;
      this._y = mouseCurY - this._posDragStartY;
      this._areaIsHover = true;
      cursor='move';
      res=true;
      this._events.trigger('area-move');
    } else if (this._boxResizeIsDragging) {
        cursor = 'nesw-resize';
        var iFR, iFX, iFY;
        iFX = mouseCurX - this._posResizeStartX;
        iFY = this._posResizeStartY - mouseCurY;
        if(iFX>iFY) {
          iFR = this._posResizeStartSize + iFY*2;
        } else {
          iFR = this._posResizeStartSize + iFX*2;
        }

        this._size = Math.max(this._minSize, iFR);
        this._boxResizeIsHover = true;
        res=true;
        this._events.trigger('area-resize');
    } else if (this._isCoordWithinBoxResize([mouseCurX,mouseCurY])) {
        cursor = 'nesw-resize';
        this._areaIsHover = false;
        this._boxResizeIsHover = true;
        res=true;
    } else if(this._isCoordWithinArea([mouseCurX,mouseCurY])) {
        cursor = 'move';
        this._areaIsHover = true;
        res=true;
    }

    this._dontDragOutside();
    angular.element(this._ctx.canvas).css({'cursor': cursor});

    return res;
  };

  CropAreaCircle.prototype.processMouseDown=function(mouseDownX, mouseDownY) {
    if (this._isCoordWithinBoxResize([mouseDownX,mouseDownY])) {
      this._areaIsDragging = false;
      this._areaIsHover = false;
      this._boxResizeIsDragging = true;
      this._boxResizeIsHover = true;
      this._posResizeStartX=mouseDownX;
      this._posResizeStartY=mouseDownY;
      this._posResizeStartSize = this._size;
      this._events.trigger('area-resize-start');
    } else if (this._isCoordWithinArea([mouseDownX,mouseDownY])) {
      this._areaIsDragging = true;
      this._areaIsHover = true;
      this._boxResizeIsDragging = false;
      this._boxResizeIsHover = false;
      this._posDragStartX = mouseDownX - this._x;
      this._posDragStartY = mouseDownY - this._y;
      this._events.trigger('area-move-start');
    }
  };

  CropAreaCircle.prototype.processMouseUp=function(/*mouseUpX, mouseUpY*/) {
    if(this._areaIsDragging) {
      this._areaIsDragging = false;
      this._events.trigger('area-move-end');
    }
    if(this._boxResizeIsDragging) {
      this._boxResizeIsDragging = false;
      this._events.trigger('area-resize-end');
    }
    this._areaIsHover = false;
    this._boxResizeIsHover = false;

    this._posDragStartX = 0;
    this._posDragStartY = 0;
  };

  return CropAreaCircle;
}]);



crop.factory('cropAreaSquare', ['cropArea', function(CropArea) {
  var CropAreaSquare = function() {
    CropArea.apply(this, arguments);

    this._resizeCtrlBaseRadius = 10;
    this._resizeCtrlNormalRatio = 0.75;
    this._resizeCtrlHoverRatio = 1;
    this._iconMoveNormalRatio = 0.9;
    this._iconMoveHoverRatio = 1.2;

    this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius*this._resizeCtrlNormalRatio;
    this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius*this._resizeCtrlHoverRatio;

    this._posDragStartX=0;
    this._posDragStartY=0;
    this._posResizeStartX=0;
    this._posResizeStartY=0;
    this._posResizeStartSize=0;

    this._resizeCtrlIsHover = -1;
    this._areaIsHover = false;
    this._resizeCtrlIsDragging = -1;
    this._areaIsDragging = false;
  };

  CropAreaSquare.prototype = new CropArea();

  CropAreaSquare.prototype._calcSquareCorners=function() {
    var hSize=this._size/2;
    return [
      [this._x-hSize, this._y-hSize],
      [this._x+hSize, this._y-hSize],
      [this._x-hSize, this._y+hSize],
      [this._x+hSize, this._y+hSize]
    ];
  };

  CropAreaSquare.prototype._calcSquareDimensions=function() {
    var hSize=this._size/2;
    return {
      left: this._x-hSize,
      top: this._y-hSize,
      right: this._x+hSize,
      bottom: this._y+hSize
    };
  };

  CropAreaSquare.prototype._isCoordWithinArea=function(coord) {
    var squareDimensions=this._calcSquareDimensions();
    return (coord[0]>=squareDimensions.left&&coord[0]<=squareDimensions.right&&coord[1]>=squareDimensions.top&&coord[1]<=squareDimensions.bottom);
  };

  CropAreaSquare.prototype._isCoordWithinResizeCtrl=function(coord) {
    var resizeIconsCenterCoords=this._calcSquareCorners();
    var res=-1;
    for(var i=0,len=resizeIconsCenterCoords.length;i<len;i++) {
      var resizeIconCenterCoords=resizeIconsCenterCoords[i];
      if(coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius &&
         coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
        res=i;
        break;
      }
    }
    return res;
  };

  CropAreaSquare.prototype._drawArea=function(ctx,centerCoords,size){
    var hSize=size/2;
    ctx.rect(centerCoords[0]-hSize,centerCoords[1]-hSize,size,size);
  };

  CropAreaSquare.prototype.draw=function() {
    CropArea.prototype.draw.apply(this, arguments);

    // draw move icon
    this._cropCanvas.drawIconMove([this._x,this._y], this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);

    // draw resize cubes
    var resizeIconsCenterCoords=this._calcSquareCorners();
    for(var i=0,len=resizeIconsCenterCoords.length;i<len;i++) {
      var resizeIconCenterCoords=resizeIconsCenterCoords[i];
      this._cropCanvas.drawIconResizeCircle(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover===i?this._resizeCtrlHoverRatio:this._resizeCtrlNormalRatio);
    }
  };

  CropAreaSquare.prototype.processMouseMove=function(mouseCurX, mouseCurY) {
    var cursor='default';
    var res=false;

    this._resizeCtrlIsHover = -1;
    this._areaIsHover = false;

    if (this._areaIsDragging) {
      this._x = mouseCurX - this._posDragStartX;
      this._y = mouseCurY - this._posDragStartY;
      this._areaIsHover = true;
      cursor='move';
      res=true;
      this._events.trigger('area-move');
    } else if (this._resizeCtrlIsDragging>-1) {
      var xMulti, yMulti;
      switch(this._resizeCtrlIsDragging) {
        case 0: // Top Left
          xMulti=-1;
          yMulti=-1;
          cursor = 'nwse-resize';
          break;
        case 1: // Top Right
          xMulti=1;
          yMulti=-1;
          cursor = 'nesw-resize';
          break;
        case 2: // Bottom Left
          xMulti=-1;
          yMulti=1;
          cursor = 'nesw-resize';
          break;
        case 3: // Bottom Right
          xMulti=1;
          yMulti=1;
          cursor = 'nwse-resize';
          break;
      }
      var iFX = (mouseCurX - this._posResizeStartX)*xMulti;
      var iFY = (mouseCurY - this._posResizeStartY)*yMulti;
      var iFR;
      if(iFX>iFY) {
        iFR = this._posResizeStartSize + iFY;
      } else {
        iFR = this._posResizeStartSize + iFX;
      }
      var wasSize=this._size;
      this._size = Math.max(this._minSize, iFR);
      var posModifier=(this._size-wasSize)/2;
      this._x+=posModifier*xMulti;
      this._y+=posModifier*yMulti;
      this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
      res=true;
      this._events.trigger('area-resize');
    } else {
      var hoveredResizeBox=this._isCoordWithinResizeCtrl([mouseCurX,mouseCurY]);
      if (hoveredResizeBox>-1) {
        switch(hoveredResizeBox) {
          case 0:
            cursor = 'nwse-resize';
            break;
          case 1:
            cursor = 'nesw-resize';
            break;
          case 2:
            cursor = 'nesw-resize';
            break;
          case 3:
            cursor = 'nwse-resize';
            break;
        }
        this._areaIsHover = false;
        this._resizeCtrlIsHover = hoveredResizeBox;
        res=true;
      } else if(this._isCoordWithinArea([mouseCurX,mouseCurY])) {
        cursor = 'move';
        this._areaIsHover = true;
        res=true;
      }
    }

    this._dontDragOutside();
    angular.element(this._ctx.canvas).css({'cursor': cursor});

    return res;
  };

  CropAreaSquare.prototype.processMouseDown=function(mouseDownX, mouseDownY) {
    var isWithinResizeCtrl=this._isCoordWithinResizeCtrl([mouseDownX,mouseDownY]);
    if (isWithinResizeCtrl>-1) {
      this._areaIsDragging = false;
      this._areaIsHover = false;
      this._resizeCtrlIsDragging = isWithinResizeCtrl;
      this._resizeCtrlIsHover = isWithinResizeCtrl;
      this._posResizeStartX=mouseDownX;
      this._posResizeStartY=mouseDownY;
      this._posResizeStartSize = this._size;
      this._events.trigger('area-resize-start');
    } else if (this._isCoordWithinArea([mouseDownX,mouseDownY])) {
      this._areaIsDragging = true;
      this._areaIsHover = true;
      this._resizeCtrlIsDragging = -1;
      this._resizeCtrlIsHover = -1;
      this._posDragStartX = mouseDownX - this._x;
      this._posDragStartY = mouseDownY - this._y;
      this._events.trigger('area-move-start');
    }
  };

  CropAreaSquare.prototype.processMouseUp=function(/*mouseUpX, mouseUpY*/) {
    if(this._areaIsDragging) {
      this._areaIsDragging = false;
      this._events.trigger('area-move-end');
    }
    if(this._resizeCtrlIsDragging>-1) {
      this._resizeCtrlIsDragging = -1;
      this._events.trigger('area-resize-end');
    }
    this._areaIsHover = false;
    this._resizeCtrlIsHover = -1;

    this._posDragStartX = 0;
    this._posDragStartY = 0;
  };

  return CropAreaSquare;
}]);

crop.factory('cropArea', ['cropCanvas', function(CropCanvas) {
  var CropArea = function(ctx, events) {
    this._ctx=ctx;
    this._events=events;

    this._minSize=80;

    this._cropCanvas=new CropCanvas(ctx);

    this._image=new Image();
    this._x = 0;
    this._y = 0;
    this._size = 200;
  };

  /* GETTERS/SETTERS */

  CropArea.prototype.getImage = function () {
    return this._image;
  };
  CropArea.prototype.setImage = function (image) {
    this._image = image;
  };

  CropArea.prototype.getX = function () {
    return this._x;
  };
  CropArea.prototype.setX = function (x) {
    this._x = x;
    this._dontDragOutside();
  };

  CropArea.prototype.getY = function () {
    return this._y;
  };
  CropArea.prototype.setY = function (y) {
    this._y = y;
    this._dontDragOutside();
  };

  CropArea.prototype.getSize = function () {
    return this._size;
  };
  CropArea.prototype.setSize = function (size) {
    this._size = Math.max(this._minSize, size);
    this._dontDragOutside();
  };

  CropArea.prototype.getMinSize = function () {
    return this._minSize;
  };
  CropArea.prototype.setMinSize = function (size) {
    this._minSize = size;
    this._size = Math.max(this._minSize, this._size);
    this._dontDragOutside();
  };

  /* FUNCTIONS */
  CropArea.prototype._dontDragOutside=function() {
    var h=this._ctx.canvas.height,
        w=this._ctx.canvas.width;
    if(this._size>w) { this._size=w; }
    if(this._size>h) { this._size=h; }
    if(this._x<this._size/2) { this._x=this._size/2; }
    if(this._x>w-this._size/2) { this._x=w-this._size/2; }
    if(this._y<this._size/2) { this._y=this._size/2; }
    if(this._y>h-this._size/2) { this._y=h-this._size/2; }
  };

  CropArea.prototype._drawArea=function() {};

  CropArea.prototype.draw=function() {
    // draw crop area
    this._cropCanvas.drawCropArea(this._image,[this._x,this._y],this._size,this._drawArea);
  };

  CropArea.prototype.processMouseMove=function() {};

  CropArea.prototype.processMouseDown=function() {};

  CropArea.prototype.processMouseUp=function() {};

  return CropArea;
}]);

crop.factory('cropCanvas', [function() {
  // Shape = Array of [x,y]; [0, 0] - center
  var shapeArrowNW=[[-0.5,-2],[-3,-4.5],[-0.5,-7],[-7,-7],[-7,-0.5],[-4.5,-3],[-2,-0.5]];
  var shapeArrowNE=[[0.5,-2],[3,-4.5],[0.5,-7],[7,-7],[7,-0.5],[4.5,-3],[2,-0.5]];
  var shapeArrowSW=[[-0.5,2],[-3,4.5],[-0.5,7],[-7,7],[-7,0.5],[-4.5,3],[-2,0.5]];
  var shapeArrowSE=[[0.5,2],[3,4.5],[0.5,7],[7,7],[7,0.5],[4.5,3],[2,0.5]];
  var shapeArrowN=[[-1.5,-2.5],[-1.5,-6],[-5,-6],[0,-11],[5,-6],[1.5,-6],[1.5,-2.5]];
  var shapeArrowW=[[-2.5,-1.5],[-6,-1.5],[-6,-5],[-11,0],[-6,5],[-6,1.5],[-2.5,1.5]];
  var shapeArrowS=[[-1.5,2.5],[-1.5,6],[-5,6],[0,11],[5,6],[1.5,6],[1.5,2.5]];
  var shapeArrowE=[[2.5,-1.5],[6,-1.5],[6,-5],[11,0],[6,5],[6,1.5],[2.5,1.5]];

  // Colors
  var colors={
    areaOutline: '#fff',
    resizeBoxStroke: '#fff',
    resizeBoxFill: '#444',
    resizeBoxArrowFill: '#fff',
    resizeCircleStroke: '#fff',
    resizeCircleFill: '#444',
    moveIconFill: '#fff'
  };

  return function(ctx){

    /* Base functions */

    // Calculate Point
    var calcPoint=function(point,offset,scale) {
        return [scale*point[0]+offset[0], scale*point[1]+offset[1]];
    };

    // Draw Filled Polygon
    var drawFilledPolygon=function(shape,fillStyle,centerCoords,scale) {
        ctx.save();
        ctx.fillStyle = fillStyle;
        ctx.beginPath();
        var pc, pc0=calcPoint(shape[0],centerCoords,scale);
        ctx.moveTo(pc0[0],pc0[1]);

        for(var p in shape) {
            if (p > 0) {
                pc=calcPoint(shape[p],centerCoords,scale);
                ctx.lineTo(pc[0],pc[1]);
            }
        }

        ctx.lineTo(pc0[0],pc0[1]);
        ctx.fill();
        ctx.closePath();
        ctx.restore();
    };

    /* Icons */

    this.drawIconMove=function(centerCoords, scale) {
      drawFilledPolygon(shapeArrowN, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowW, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowS, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowE, colors.moveIconFill, centerCoords, scale);
    };

    this.drawIconResizeCircle=function(centerCoords, circleRadius, scale) {
      var scaledCircleRadius=circleRadius*scale;
      ctx.save();
      ctx.strokeStyle = colors.resizeCircleStroke;
      ctx.lineWidth = 2;
      ctx.fillStyle = colors.resizeCircleFill;
      ctx.beginPath();
      ctx.arc(centerCoords[0],centerCoords[1],scaledCircleRadius,0,2*Math.PI);
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    };

    this.drawIconResizeBoxBase=function(centerCoords, boxSize, scale) {
      var scaledBoxSize=boxSize*scale;
      ctx.save();
      ctx.strokeStyle = colors.resizeBoxStroke;
      ctx.lineWidth = 2;
      ctx.fillStyle = colors.resizeBoxFill;
      ctx.fillRect(centerCoords[0] - scaledBoxSize/2, centerCoords[1] - scaledBoxSize/2, scaledBoxSize, scaledBoxSize);
      ctx.strokeRect(centerCoords[0] - scaledBoxSize/2, centerCoords[1] - scaledBoxSize/2, scaledBoxSize, scaledBoxSize);
      ctx.restore();
    };
    this.drawIconResizeBoxNESW=function(centerCoords, boxSize, scale) {
      this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
      drawFilledPolygon(shapeArrowNE, colors.resizeBoxArrowFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowSW, colors.resizeBoxArrowFill, centerCoords, scale);
    };
    this.drawIconResizeBoxNWSE=function(centerCoords, boxSize, scale) {
      this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
      drawFilledPolygon(shapeArrowNW, colors.resizeBoxArrowFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowSE, colors.resizeBoxArrowFill, centerCoords, scale);
    };

    /* Crop Area */

    this.drawCropArea=function(image, centerCoords, size, fnDrawClipPath) {
      var xRatio=image.width/ctx.canvas.width,
          yRatio=image.height/ctx.canvas.height,
          xLeft=centerCoords[0]-size/2,
          yTop=centerCoords[1]-size/2;

      ctx.save();
      ctx.strokeStyle = colors.areaOutline;
      ctx.lineWidth = 2;
      ctx.beginPath();
      fnDrawClipPath(ctx, centerCoords, size);
      ctx.stroke();
      ctx.clip();

      // draw part of original image
      if (size > 0) {
          ctx.drawImage(image, xLeft*xRatio, yTop*yRatio, size*xRatio, size*yRatio, xLeft, yTop, size, size);
      }

      ctx.beginPath();
      fnDrawClipPath(ctx, centerCoords, size);
      ctx.stroke();
      ctx.clip();

      ctx.restore();
    };

  };
}]);

/**
 * EXIF service is based on the exif-js library (https://github.com/jseidelin/exif-js)
 */

crop.service('cropEXIF', [function() {
  var debug = false;

  var ExifTags = this.Tags = {

      // version tags
      0x9000 : "ExifVersion",             // EXIF version
      0xA000 : "FlashpixVersion",         // Flashpix format version

      // colorspace tags
      0xA001 : "ColorSpace",              // Color space information tag

      // image configuration
      0xA002 : "PixelXDimension",         // Valid width of meaningful image
      0xA003 : "PixelYDimension",         // Valid height of meaningful image
      0x9101 : "ComponentsConfiguration", // Information about channels
      0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

      // user information
      0x927C : "MakerNote",               // Any desired information written by the manufacturer
      0x9286 : "UserComment",             // Comments by user

      // related file
      0xA004 : "RelatedSoundFile",        // Name of related sound file

      // date and time
      0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
      0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
      0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
      0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
      0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

      // picture-taking conditions
      0x829A : "ExposureTime",            // Exposure time (in seconds)
      0x829D : "FNumber",                 // F number
      0x8822 : "ExposureProgram",         // Exposure program
      0x8824 : "SpectralSensitivity",     // Spectral sensitivity
      0x8827 : "ISOSpeedRatings",         // ISO speed rating
      0x8828 : "OECF",                    // Optoelectric conversion factor
      0x9201 : "ShutterSpeedValue",       // Shutter speed
      0x9202 : "ApertureValue",           // Lens aperture
      0x9203 : "BrightnessValue",         // Value of brightness
      0x9204 : "ExposureBias",            // Exposure bias
      0x9205 : "MaxApertureValue",        // Smallest F number of lens
      0x9206 : "SubjectDistance",         // Distance to subject in meters
      0x9207 : "MeteringMode",            // Metering mode
      0x9208 : "LightSource",             // Kind of light source
      0x9209 : "Flash",                   // Flash status
      0x9214 : "SubjectArea",             // Location and area of main subject
      0x920A : "FocalLength",             // Focal length of the lens in mm
      0xA20B : "FlashEnergy",             // Strobe energy in BCPS
      0xA20C : "SpatialFrequencyResponse",    //
      0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
      0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
      0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
      0xA214 : "SubjectLocation",         // Location of subject in image
      0xA215 : "ExposureIndex",           // Exposure index selected on camera
      0xA217 : "SensingMethod",           // Image sensor type
      0xA300 : "FileSource",              // Image source (3 == DSC)
      0xA301 : "SceneType",               // Scene type (1 == directly photographed)
      0xA302 : "CFAPattern",              // Color filter array geometric pattern
      0xA401 : "CustomRendered",          // Special processing
      0xA402 : "ExposureMode",            // Exposure mode
      0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
      0xA404 : "DigitalZoomRation",       // Digital zoom ratio
      0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
      0xA406 : "SceneCaptureType",        // Type of scene
      0xA407 : "GainControl",             // Degree of overall image gain adjustment
      0xA408 : "Contrast",                // Direction of contrast processing applied by camera
      0xA409 : "Saturation",              // Direction of saturation processing applied by camera
      0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
      0xA40B : "DeviceSettingDescription",    //
      0xA40C : "SubjectDistanceRange",    // Distance to subject

      // other tags
      0xA005 : "InteroperabilityIFDPointer",
      0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
  };

  var TiffTags = this.TiffTags = {
      0x0100 : "ImageWidth",
      0x0101 : "ImageHeight",
      0x8769 : "ExifIFDPointer",
      0x8825 : "GPSInfoIFDPointer",
      0xA005 : "InteroperabilityIFDPointer",
      0x0102 : "BitsPerSample",
      0x0103 : "Compression",
      0x0106 : "PhotometricInterpretation",
      0x0112 : "Orientation",
      0x0115 : "SamplesPerPixel",
      0x011C : "PlanarConfiguration",
      0x0212 : "YCbCrSubSampling",
      0x0213 : "YCbCrPositioning",
      0x011A : "XResolution",
      0x011B : "YResolution",
      0x0128 : "ResolutionUnit",
      0x0111 : "StripOffsets",
      0x0116 : "RowsPerStrip",
      0x0117 : "StripByteCounts",
      0x0201 : "JPEGInterchangeFormat",
      0x0202 : "JPEGInterchangeFormatLength",
      0x012D : "TransferFunction",
      0x013E : "WhitePoint",
      0x013F : "PrimaryChromaticities",
      0x0211 : "YCbCrCoefficients",
      0x0214 : "ReferenceBlackWhite",
      0x0132 : "DateTime",
      0x010E : "ImageDescription",
      0x010F : "Make",
      0x0110 : "Model",
      0x0131 : "Software",
      0x013B : "Artist",
      0x8298 : "Copyright"
  };

  var GPSTags = this.GPSTags = {
      0x0000 : "GPSVersionID",
      0x0001 : "GPSLatitudeRef",
      0x0002 : "GPSLatitude",
      0x0003 : "GPSLongitudeRef",
      0x0004 : "GPSLongitude",
      0x0005 : "GPSAltitudeRef",
      0x0006 : "GPSAltitude",
      0x0007 : "GPSTimeStamp",
      0x0008 : "GPSSatellites",
      0x0009 : "GPSStatus",
      0x000A : "GPSMeasureMode",
      0x000B : "GPSDOP",
      0x000C : "GPSSpeedRef",
      0x000D : "GPSSpeed",
      0x000E : "GPSTrackRef",
      0x000F : "GPSTrack",
      0x0010 : "GPSImgDirectionRef",
      0x0011 : "GPSImgDirection",
      0x0012 : "GPSMapDatum",
      0x0013 : "GPSDestLatitudeRef",
      0x0014 : "GPSDestLatitude",
      0x0015 : "GPSDestLongitudeRef",
      0x0016 : "GPSDestLongitude",
      0x0017 : "GPSDestBearingRef",
      0x0018 : "GPSDestBearing",
      0x0019 : "GPSDestDistanceRef",
      0x001A : "GPSDestDistance",
      0x001B : "GPSProcessingMethod",
      0x001C : "GPSAreaInformation",
      0x001D : "GPSDateStamp",
      0x001E : "GPSDifferential"
  };

  var StringValues = this.StringValues = {
      ExposureProgram : {
          0 : "Not defined",
          1 : "Manual",
          2 : "Normal program",
          3 : "Aperture priority",
          4 : "Shutter priority",
          5 : "Creative program",
          6 : "Action program",
          7 : "Portrait mode",
          8 : "Landscape mode"
      },
      MeteringMode : {
          0 : "Unknown",
          1 : "Average",
          2 : "CenterWeightedAverage",
          3 : "Spot",
          4 : "MultiSpot",
          5 : "Pattern",
          6 : "Partial",
          255 : "Other"
      },
      LightSource : {
          0 : "Unknown",
          1 : "Daylight",
          2 : "Fluorescent",
          3 : "Tungsten (incandescent light)",
          4 : "Flash",
          9 : "Fine weather",
          10 : "Cloudy weather",
          11 : "Shade",
          12 : "Daylight fluorescent (D 5700 - 7100K)",
          13 : "Day white fluorescent (N 4600 - 5400K)",
          14 : "Cool white fluorescent (W 3900 - 4500K)",
          15 : "White fluorescent (WW 3200 - 3700K)",
          17 : "Standard light A",
          18 : "Standard light B",
          19 : "Standard light C",
          20 : "D55",
          21 : "D65",
          22 : "D75",
          23 : "D50",
          24 : "ISO studio tungsten",
          255 : "Other"
      },
      Flash : {
          0x0000 : "Flash did not fire",
          0x0001 : "Flash fired",
          0x0005 : "Strobe return light not detected",
          0x0007 : "Strobe return light detected",
          0x0009 : "Flash fired, compulsory flash mode",
          0x000D : "Flash fired, compulsory flash mode, return light not detected",
          0x000F : "Flash fired, compulsory flash mode, return light detected",
          0x0010 : "Flash did not fire, compulsory flash mode",
          0x0018 : "Flash did not fire, auto mode",
          0x0019 : "Flash fired, auto mode",
          0x001D : "Flash fired, auto mode, return light not detected",
          0x001F : "Flash fired, auto mode, return light detected",
          0x0020 : "No flash function",
          0x0041 : "Flash fired, red-eye reduction mode",
          0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
          0x0047 : "Flash fired, red-eye reduction mode, return light detected",
          0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
          0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
          0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
          0x0059 : "Flash fired, auto mode, red-eye reduction mode",
          0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
          0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
      },
      SensingMethod : {
          1 : "Not defined",
          2 : "One-chip color area sensor",
          3 : "Two-chip color area sensor",
          4 : "Three-chip color area sensor",
          5 : "Color sequential area sensor",
          7 : "Trilinear sensor",
          8 : "Color sequential linear sensor"
      },
      SceneCaptureType : {
          0 : "Standard",
          1 : "Landscape",
          2 : "Portrait",
          3 : "Night scene"
      },
      SceneType : {
          1 : "Directly photographed"
      },
      CustomRendered : {
          0 : "Normal process",
          1 : "Custom process"
      },
      WhiteBalance : {
          0 : "Auto white balance",
          1 : "Manual white balance"
      },
      GainControl : {
          0 : "None",
          1 : "Low gain up",
          2 : "High gain up",
          3 : "Low gain down",
          4 : "High gain down"
      },
      Contrast : {
          0 : "Normal",
          1 : "Soft",
          2 : "Hard"
      },
      Saturation : {
          0 : "Normal",
          1 : "Low saturation",
          2 : "High saturation"
      },
      Sharpness : {
          0 : "Normal",
          1 : "Soft",
          2 : "Hard"
      },
      SubjectDistanceRange : {
          0 : "Unknown",
          1 : "Macro",
          2 : "Close view",
          3 : "Distant view"
      },
      FileSource : {
          3 : "DSC"
      },

      Components : {
          0 : "",
          1 : "Y",
          2 : "Cb",
          3 : "Cr",
          4 : "R",
          5 : "G",
          6 : "B"
      }
  };

  function addEvent(element, event, handler) {
      if (element.addEventListener) {
          element.addEventListener(event, handler, false);
      } else if (element.attachEvent) {
          element.attachEvent("on" + event, handler);
      }
  }

  function imageHasData(img) {
      return !!(img.exifdata);
  }

  function base64ToArrayBuffer(base64, contentType) {
      contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
      base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
      var binary = atob(base64);
      var len = binary.length;
      var buffer = new ArrayBuffer(len);
      var view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
      }
      return buffer;
  }

  function objectURLToBlob(url, callback) {
      var http = new XMLHttpRequest();
      http.open("GET", url, true);
      http.responseType = "blob";
      http.onload = function(e) {
          if (this.status == 200 || this.status === 0) {
              callback(this.response);
          }
      };
      http.send();
  }

  function getImageData(img, callback) {
      function handleBinaryFile(binFile) {
          var data = findEXIFinJPEG(binFile);
          var iptcdata = findIPTCinJPEG(binFile);
          img.exifdata = data || {};
          img.iptcdata = iptcdata || {};
          if (callback) {
              callback.call(img);
          }
      }

      if (img.src) {
          if (/^data\:/i.test(img.src)) { // Data URI
              var arrayBuffer = base64ToArrayBuffer(img.src);
              handleBinaryFile(arrayBuffer);

          } else if (/^blob\:/i.test(img.src)) { // Object URL
              var fileReader = new FileReader();
              fileReader.onload = function(e) {
                  handleBinaryFile(e.target.result);
              };
              objectURLToBlob(img.src, function (blob) {
                  fileReader.readAsArrayBuffer(blob);
              });
          } else {
              var http = new XMLHttpRequest();
              http.onload = function() {
                  if (this.status == 200 || this.status === 0) {
                      handleBinaryFile(http.response);
                  } else {
                      throw "Could not load image";
                  }
                  http = null;
              };
              http.open("GET", img.src, true);
              http.responseType = "arraybuffer";
              http.send(null);
          }
      } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
          var fileReader = new FileReader();
          fileReader.onload = function(e) {
              if (debug) console.log("Got file of length " + e.target.result.byteLength);
              handleBinaryFile(e.target.result);
          };

          fileReader.readAsArrayBuffer(img);
      }
  }

  function findEXIFinJPEG(file) {
      var dataView = new DataView(file);

      if (debug) console.log("Got file of length " + file.byteLength);
      if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
          if (debug) console.log("Not a valid JPEG");
          return false; // not a valid jpeg
      }

      var offset = 2,
          length = file.byteLength,
          marker;

      while (offset < length) {
          if (dataView.getUint8(offset) != 0xFF) {
              if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
              return false; // not a valid marker, something is wrong
          }

          marker = dataView.getUint8(offset + 1);
          if (debug) console.log(marker);

          // we could implement handling for other markers here,
          // but we're only looking for 0xFFE1 for EXIF data

          if (marker == 225) {
              if (debug) console.log("Found 0xFFE1 marker");

              return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

              // offset += 2 + file.getShortAt(offset+2, true);

          } else {
              offset += 2 + dataView.getUint16(offset+2);
          }

      }

  }

  function findIPTCinJPEG(file) {
      var dataView = new DataView(file);

      if (debug) console.log("Got file of length " + file.byteLength);
      if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
          if (debug) console.log("Not a valid JPEG");
          return false; // not a valid jpeg
      }

      var offset = 2,
          length = file.byteLength;

      var isFieldSegmentStart = function(dataView, offset){
          return (
              dataView.getUint8(offset) === 0x38 &&
              dataView.getUint8(offset+1) === 0x42 &&
              dataView.getUint8(offset+2) === 0x49 &&
              dataView.getUint8(offset+3) === 0x4D &&
              dataView.getUint8(offset+4) === 0x04 &&
              dataView.getUint8(offset+5) === 0x04
          );
      };

      while (offset < length) {

          if ( isFieldSegmentStart(dataView, offset )){

              // Get the length of the name header (which is padded to an even number of bytes)
              var nameHeaderLength = dataView.getUint8(offset+7);
              if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
              // Check for pre photoshop 6 format
              if(nameHeaderLength === 0) {
                  // Always 4
                  nameHeaderLength = 4;
              }

              var startOffset = offset + 8 + nameHeaderLength;
              var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

              return readIPTCData(file, startOffset, sectionLength);

              break;

          }

          // Not the marker, continue searching
          offset++;

      }

  }
  var IptcFieldMap = {
      0x78 : 'caption',
      0x6E : 'credit',
      0x19 : 'keywords',
      0x37 : 'dateCreated',
      0x50 : 'byline',
      0x55 : 'bylineTitle',
      0x7A : 'captionWriter',
      0x69 : 'headline',
      0x74 : 'copyright',
      0x0F : 'category'
  };
  function readIPTCData(file, startOffset, sectionLength){
      var dataView = new DataView(file);
      var data = {};
      var fieldValue, fieldName, dataSize, segmentType, segmentSize;
      var segmentStartPos = startOffset;
      while(segmentStartPos < startOffset+sectionLength) {
          if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
              segmentType = dataView.getUint8(segmentStartPos+2);
              if(segmentType in IptcFieldMap) {
                  dataSize = dataView.getInt16(segmentStartPos+3);
                  segmentSize = dataSize + 5;
                  fieldName = IptcFieldMap[segmentType];
                  fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                  // Check if we already stored a value with this name
                  if(data.hasOwnProperty(fieldName)) {
                      // Value already stored with this name, create multivalue field
                      if(data[fieldName] instanceof Array) {
                          data[fieldName].push(fieldValue);
                      }
                      else {
                          data[fieldName] = [data[fieldName], fieldValue];
                      }
                  }
                  else {
                      data[fieldName] = fieldValue;
                  }
              }

          }
          segmentStartPos++;
      }
      return data;
  }

  function readTags(file, tiffStart, dirStart, strings, bigEnd) {
      var entries = file.getUint16(dirStart, !bigEnd),
          tags = {},
          entryOffset, tag,
          i;

      for (i=0;i<entries;i++) {
          entryOffset = dirStart + i*12 + 2;
          tag = strings[file.getUint16(entryOffset, !bigEnd)];
          if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
          tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
      }
      return tags;
  }

  function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
      var type = file.getUint16(entryOffset+2, !bigEnd),
          numValues = file.getUint32(entryOffset+4, !bigEnd),
          valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
          offset,
          vals, val, n,
          numerator, denominator;

      switch (type) {
          case 1: // byte, 8-bit unsigned int
          case 7: // undefined, 8-bit byte, value depending on field
              if (numValues == 1) {
                  return file.getUint8(entryOffset + 8, !bigEnd);
              } else {
                  offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint8(offset + n);
                  }
                  return vals;
              }

          case 2: // ascii, 8-bit byte
              offset = numValues > 4 ? valueOffset : (entryOffset + 8);
              return getStringFromDB(file, offset, numValues-1);

          case 3: // short, 16 bit int
              if (numValues == 1) {
                  return file.getUint16(entryOffset + 8, !bigEnd);
              } else {
                  offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                  }
                  return vals;
              }

          case 4: // long, 32 bit int
              if (numValues == 1) {
                  return file.getUint32(entryOffset + 8, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                  }
                  return vals;
              }

          case 5:    // rational = two long values, first is numerator, second is denominator
              if (numValues == 1) {
                  numerator = file.getUint32(valueOffset, !bigEnd);
                  denominator = file.getUint32(valueOffset+4, !bigEnd);
                  val = new Number(numerator / denominator);
                  val.numerator = numerator;
                  val.denominator = denominator;
                  return val;
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                      denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                      vals[n] = new Number(numerator / denominator);
                      vals[n].numerator = numerator;
                      vals[n].denominator = denominator;
                  }
                  return vals;
              }

          case 9: // slong, 32 bit signed int
              if (numValues == 1) {
                  return file.getInt32(entryOffset + 8, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                  }
                  return vals;
              }

          case 10: // signed rational, two slongs, first is numerator, second is denominator
              if (numValues == 1) {
                  return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                  }
                  return vals;
              }
      }
  }

  function getStringFromDB(buffer, start, length) {
      var outstr = "";
      for (var n = start; n < start+length; n++) {
          outstr += String.fromCharCode(buffer.getUint8(n));
      }
      return outstr;
  }

  function readEXIFData(file, start) {
      if (getStringFromDB(file, start, 4) != "Exif") {
          if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
          return false;
      }

      var bigEnd,
          tags, tag,
          exifData, gpsData,
          tiffOffset = start + 6;

      // test for TIFF validity and endianness
      if (file.getUint16(tiffOffset) == 0x4949) {
          bigEnd = false;
      } else if (file.getUint16(tiffOffset) == 0x4D4D) {
          bigEnd = true;
      } else {
          if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
          return false;
      }

      if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
          if (debug) console.log("Not valid TIFF data! (no 0x002A)");
          return false;
      }

      var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

      if (firstIFDOffset < 0x00000008) {
          if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
          return false;
      }

      tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

      if (tags.ExifIFDPointer) {
          exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
          for (tag in exifData) {
              switch (tag) {
                  case "LightSource" :
                  case "Flash" :
                  case "MeteringMode" :
                  case "ExposureProgram" :
                  case "SensingMethod" :
                  case "SceneCaptureType" :
                  case "SceneType" :
                  case "CustomRendered" :
                  case "WhiteBalance" :
                  case "GainControl" :
                  case "Contrast" :
                  case "Saturation" :
                  case "Sharpness" :
                  case "SubjectDistanceRange" :
                  case "FileSource" :
                      exifData[tag] = StringValues[tag][exifData[tag]];
                      break;

                  case "ExifVersion" :
                  case "FlashpixVersion" :
                      exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                      break;

                  case "ComponentsConfiguration" :
                      exifData[tag] =
                          StringValues.Components[exifData[tag][0]] +
                          StringValues.Components[exifData[tag][1]] +
                          StringValues.Components[exifData[tag][2]] +
                          StringValues.Components[exifData[tag][3]];
                      break;
              }
              tags[tag] = exifData[tag];
          }
      }

      if (tags.GPSInfoIFDPointer) {
          gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
          for (tag in gpsData) {
              switch (tag) {
                  case "GPSVersionID" :
                      gpsData[tag] = gpsData[tag][0] +
                          "." + gpsData[tag][1] +
                          "." + gpsData[tag][2] +
                          "." + gpsData[tag][3];
                      break;
              }
              tags[tag] = gpsData[tag];
          }
      }

      return tags;
  }

  this.getData = function(img, callback) {
      if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;

      if (!imageHasData(img)) {
          getImageData(img, callback);
      } else {
          if (callback) {
              callback.call(img);
          }
      }
      return true;
  }

  this.getTag = function(img, tag) {
      if (!imageHasData(img)) return;
      return img.exifdata[tag];
  }

  this.getAllTags = function(img) {
      if (!imageHasData(img)) return {};
      var a,
          data = img.exifdata,
          tags = {};
      for (a in data) {
          if (data.hasOwnProperty(a)) {
              tags[a] = data[a];
          }
      }
      return tags;
  }

  this.pretty = function(img) {
      if (!imageHasData(img)) return "";
      var a,
          data = img.exifdata,
          strPretty = "";
      for (a in data) {
          if (data.hasOwnProperty(a)) {
              if (typeof data[a] == "object") {
                  if (data[a] instanceof Number) {
                      strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                  } else {
                      strPretty += a + " : [" + data[a].length + " values]\r\n";
                  }
              } else {
                  strPretty += a + " : " + data[a] + "\r\n";
              }
          }
      }
      return strPretty;
  }

  this.readFromBinaryFile = function(file) {
      return findEXIFinJPEG(file);
  }
}]);

crop.factory('cropHost', ['$document', 'cropAreaCircle', 'cropAreaSquare', 'cropEXIF', function($document, CropAreaCircle, CropAreaSquare, cropEXIF) {
  /* STATIC FUNCTIONS */

  // Get Element's Offset
  var getElementOffset=function(elem) {
      var box = elem.getBoundingClientRect();

      var body = document.body;
      var docElem = document.documentElement;

      var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

      var clientTop = docElem.clientTop || body.clientTop || 0;
      var clientLeft = docElem.clientLeft || body.clientLeft || 0;

      var top  = box.top +  scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;

      return { top: Math.round(top), left: Math.round(left) };
  };

  return function(elCanvas, opts, events){
    /* PRIVATE VARIABLES */

    // Object Pointers
    var ctx=null,
        image=null,
        theArea=null;

    // Dimensions
    var minCanvasDims=[100,100],
        maxCanvasDims=[300,300];

    // Result Image size
    var resImgSize=200;

    // Result Image type
    var resImgFormat='image/png';

    // Result Image quality
    var resImgQuality=null;

    /* PRIVATE FUNCTIONS */

    // Draw Scene
    function drawScene() {
      // clear canvas
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      if(image!==null) {
        // draw source image
        ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

        ctx.save();

        // and make it darker
        ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
        ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

        ctx.restore();

        // draw Area
        theArea.draw();
      }
    }

    // Resets CropHost
    var resetCropHost=function() {
      if(image!==null) {
        theArea.setImage(image);
        var imageDims=[image.width, image.height],
            imageRatio=image.width/image.height,
            canvasDims=imageDims;

        if(canvasDims[0]>maxCanvasDims[0]) {
          canvasDims[0]=maxCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        } else if(canvasDims[0]<minCanvasDims[0]) {
          canvasDims[0]=minCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        }
        if(canvasDims[1]>maxCanvasDims[1]) {
          canvasDims[1]=maxCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        } else if(canvasDims[1]<minCanvasDims[1]) {
          canvasDims[1]=minCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        }
        elCanvas.prop('width',canvasDims[0]).prop('height',canvasDims[1]).css({'margin-left': -canvasDims[0]/2+'px', 'margin-top': -canvasDims[1]/2+'px'});

        theArea.setX(ctx.canvas.width/2);
        theArea.setY(ctx.canvas.height/2);
        theArea.setSize(Math.min(200, ctx.canvas.width/2, ctx.canvas.height/2));
      } else {
        elCanvas.prop('width',0).prop('height',0).css({'margin-top': 0});
      }

      drawScene();
    };

    /**
     * Returns event.changedTouches directly if event is a TouchEvent.
     * If event is a jQuery event, return changedTouches of event.originalEvent
     */
    var getChangedTouches=function(event){
      if(angular.isDefined(event.changedTouches)){
        return event.changedTouches;
      }else{
        return event.originalEvent.changedTouches;
      }
    };

    var onMouseMove=function(e) {
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchmove') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseMove(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    var onMouseDown=function(e) {
      e.preventDefault();
      e.stopPropagation();
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchstart') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseDown(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    var onMouseUp=function(e) {
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchend') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseUp(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    this.getResultImageDataURI=function() {
      var temp_ctx, temp_canvas;
      temp_canvas = angular.element('<canvas></canvas>')[0];
      temp_ctx = temp_canvas.getContext('2d');
      temp_canvas.width = resImgSize;
      temp_canvas.height = resImgSize;
      if(image!==null){
        temp_ctx.drawImage(image, (theArea.getX()-theArea.getSize()/2)*(image.width/ctx.canvas.width), (theArea.getY()-theArea.getSize()/2)*(image.height/ctx.canvas.height), theArea.getSize()*(image.width/ctx.canvas.width), theArea.getSize()*(image.height/ctx.canvas.height), 0, 0, resImgSize, resImgSize);
      }
      if (resImgQuality!==null ){
        return temp_canvas.toDataURL(resImgFormat, resImgQuality);
      }
      return temp_canvas.toDataURL(resImgFormat);
    };

    this.setNewImageSource=function(imageSource) {
      image=null;
      resetCropHost();
      events.trigger('image-updated');
      if(!!imageSource) {
        var newImage = new Image();
        if(imageSource.substring(0,4).toLowerCase()==='http') {
          newImage.crossOrigin = 'anonymous';
        }
        newImage.onload = function(){
          events.trigger('load-done');

          cropEXIF.getData(newImage,function(){
            var orientation=cropEXIF.getTag(newImage,'Orientation');

            if([3,6,8].indexOf(orientation)>-1) {
              var canvas = document.createElement("canvas"),
                  ctx=canvas.getContext("2d"),
                  cw = newImage.width, ch = newImage.height, cx = 0, cy = 0, deg=0;
              switch(orientation) {
                case 3:
                  cx=-newImage.width;
                  cy=-newImage.height;
                  deg=180;
                  break;
                case 6:
                  cw = newImage.height;
                  ch = newImage.width;
                  cy=-newImage.height;
                  deg=90;
                  break;
                case 8:
                  cw = newImage.height;
                  ch = newImage.width;
                  cx=-newImage.width;
                  deg=270;
                  break;
              }

              canvas.width = cw;
              canvas.height = ch;
              ctx.rotate(deg*Math.PI/180);
              ctx.drawImage(newImage, cx, cy);

              image=new Image();
              image.src = canvas.toDataURL("image/png");
            } else {
              image=newImage;
            }
            resetCropHost();
            events.trigger('image-updated');
          });
        };
        newImage.onerror=function() {
          events.trigger('load-error');
        };
        events.trigger('load-start');
        newImage.src=imageSource;
      }
    };

    this.setMaxDimensions=function(width, height) {
      maxCanvasDims=[width,height];

      if(image!==null) {
        var curWidth=ctx.canvas.width,
            curHeight=ctx.canvas.height;

        var imageDims=[image.width, image.height],
            imageRatio=image.width/image.height,
            canvasDims=imageDims;

        if(canvasDims[0]>maxCanvasDims[0]) {
          canvasDims[0]=maxCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        } else if(canvasDims[0]<minCanvasDims[0]) {
          canvasDims[0]=minCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        }
        if(canvasDims[1]>maxCanvasDims[1]) {
          canvasDims[1]=maxCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        } else if(canvasDims[1]<minCanvasDims[1]) {
          canvasDims[1]=minCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        }
        elCanvas.prop('width',canvasDims[0]).prop('height',canvasDims[1]).css({'margin-left': -canvasDims[0]/2+'px', 'margin-top': -canvasDims[1]/2+'px'});

        var ratioNewCurWidth=ctx.canvas.width/curWidth,
            ratioNewCurHeight=ctx.canvas.height/curHeight,
            ratioMin=Math.min(ratioNewCurWidth, ratioNewCurHeight);

        theArea.setX(theArea.getX()*ratioNewCurWidth);
        theArea.setY(theArea.getY()*ratioNewCurHeight);
        theArea.setSize(theArea.getSize()*ratioMin);
      } else {
        elCanvas.prop('width',0).prop('height',0).css({'margin-top': 0});
      }

      drawScene();

    };

    this.setAreaMinSize=function(size) {
      size=parseInt(size,10);
      if(!isNaN(size)) {
        theArea.setMinSize(size);
        drawScene();
      }
    };

    this.setResultImageSize=function(size) {
      size=parseInt(size,10);
      if(!isNaN(size)) {
        resImgSize=size;
      }
    };

    this.setResultImageFormat=function(format) {
      resImgFormat = format;
    };

    this.setResultImageQuality=function(quality){
      quality = parseFloat(quality);
      if (!isNaN(quality) && quality>=0 && quality<=1){
        resImgQuality = quality;
      }
    };

    this.setAreaType=function(type) {
      var curSize=theArea.getSize(),
          curMinSize=theArea.getMinSize(),
          curX=theArea.getX(),
          curY=theArea.getY();

      var AreaClass=CropAreaCircle;
      if(type==='square') {
        AreaClass=CropAreaSquare;
      }
      theArea = new AreaClass(ctx, events);
      theArea.setMinSize(curMinSize);
      theArea.setSize(curSize);
      theArea.setX(curX);
      theArea.setY(curY);

      // resetCropHost();
      if(image!==null) {
        theArea.setImage(image);
      }

      drawScene();
    };

    /* Life Cycle begins */

    // Init Context var
    ctx = elCanvas[0].getContext('2d');

    // Init CropArea
    theArea = new CropAreaCircle(ctx, events);

    // Init Mouse Event Listeners
    $document.on('mousemove',onMouseMove);
    elCanvas.on('mousedown',onMouseDown);
    $document.on('mouseup',onMouseUp);

    // Init Touch Event Listeners
    $document.on('touchmove',onMouseMove);
    elCanvas.on('touchstart',onMouseDown);
    $document.on('touchend',onMouseUp);

    // CropHost Destructor
    this.destroy=function() {
      $document.off('mousemove',onMouseMove);
      elCanvas.off('mousedown',onMouseDown);
      $document.off('mouseup',onMouseMove);

      $document.off('touchmove',onMouseMove);
      elCanvas.off('touchstart',onMouseDown);
      $document.off('touchend',onMouseMove);

      elCanvas.remove();
    };
  };

}]);


crop.factory('cropPubSub', [function() {
  return function() {
    var events = {};
    // Subscribe
    this.on = function(names, handler) {
      names.split(' ').forEach(function(name) {
        if (!events[name]) {
          events[name] = [];
        }
        events[name].push(handler);
      });
      return this;
    };
    // Publish
    this.trigger = function(name, args) {
      angular.forEach(events[name], function(handler) {
        handler.call(null, args);
      });
      return this;
    };
  };
}]);

crop.directive('imgCrop', ['$timeout', 'cropHost', 'cropPubSub', function($timeout, CropHost, CropPubSub) {
  return {
    restrict: 'E',
    scope: {
      image: '=',
      resultImage: '=',

      changeOnFly: '=',
      areaType: '@',
      areaMinSize: '=',
      resultImageSize: '=',
      resultImageFormat: '@',
      resultImageQuality: '=',

      onChange: '&',
      onLoadBegin: '&',
      onLoadDone: '&',
      onLoadError: '&'
    },
    template: '<canvas></canvas>',
    controller: ['$scope', function($scope) {
      $scope.events = new CropPubSub();
    }],
    link: function(scope, element/*, attrs*/) {
      // Init Events Manager
      var events = scope.events;

      // Init Crop Host
      var cropHost=new CropHost(element.find('canvas'), {}, events);

      // Store Result Image to check if it's changed
      var storedResultImage;

      var updateResultImage=function(scope) {
        var resultImage=cropHost.getResultImageDataURI();
        if(storedResultImage!==resultImage) {
          storedResultImage=resultImage;
          if(angular.isDefined(scope.resultImage)) {
            scope.resultImage=resultImage;
          }
          scope.onChange({$dataURI: scope.resultImage});
        }
      };

      // Wrapper to safely exec functions within $apply on a running $digest cycle
      var fnSafeApply=function(fn) {
        return function(){
          $timeout(function(){
            scope.$apply(function(scope){
              fn(scope);
            });
          });
        };
      };

      // Setup CropHost Event Handlers
      events
        .on('load-start', fnSafeApply(function(scope){
          scope.onLoadBegin({});
        }))
        .on('load-done', fnSafeApply(function(scope){
          scope.onLoadDone({});
        }))
        .on('load-error', fnSafeApply(function(scope){
          scope.onLoadError({});
        }))
        .on('area-move area-resize', fnSafeApply(function(scope){
          if(!!scope.changeOnFly) {
            updateResultImage(scope);
          }
        }))
        .on('area-move-end area-resize-end image-updated', fnSafeApply(function(scope){
          updateResultImage(scope);
        }));

      // Sync CropHost with Directive's options
      scope.$watch('image',function(){
        cropHost.setNewImageSource(scope.image);
      });
      scope.$watch('areaType',function(){
        cropHost.setAreaType(scope.areaType);
        updateResultImage(scope);
      });
      scope.$watch('areaMinSize',function(){
        cropHost.setAreaMinSize(scope.areaMinSize);
        updateResultImage(scope);
      });
      scope.$watch('resultImageSize',function(){
        cropHost.setResultImageSize(scope.resultImageSize);
        updateResultImage(scope);
      });
      scope.$watch('resultImageFormat',function(){
        cropHost.setResultImageFormat(scope.resultImageFormat);
        updateResultImage(scope);
      });
      scope.$watch('resultImageQuality',function(){
        cropHost.setResultImageQuality(scope.resultImageQuality);
        updateResultImage(scope);
      });

      // Update CropHost dimensions when the directive element is resized
      scope.$watch(
        function () {
          return [element[0].clientWidth, element[0].clientHeight];
        },
        function (value) {
          cropHost.setMaxDimensions(value[0],value[1]);
          updateResultImage(scope);
        },
        true
      );

      // Destroy CropHost Instance when the directive is destroying
      scope.$on('$destroy', function(){
          cropHost.destroy();
      });
    }
  };
}]);
}());
/*!
 * uiCropper v1.0.4
 * https://crackerakiua.github.io/ui-cropper/
 *
 * Copyright (c) 2017 Alex Kaul
 * License: MIT
 *
 * Generated at Friday, September 8th, 2017, 10:00:18 AM
 */
(function() {
angular.module('uiCropper', []);

angular.module('uiCropper').factory('cropAreaCircle', ['cropArea', function(CropArea) {
    var CropAreaCircle = function() {
        CropArea.apply(this, arguments);

        this._boxResizeBaseSize = 25;
        this._boxResizeNormalRatio = 1;
        this._boxResizeHoverRatio = 1.2;
        this._iconMoveNormalRatio = 0.9;
        this._iconMoveHoverRatio = 1.2;

        this._boxResizeNormalSize = this._boxResizeBaseSize * this._boxResizeNormalRatio;
        this._boxResizeHoverSize = this._boxResizeBaseSize * this._boxResizeHoverRatio;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
        this._posResizeStartX = 0;
        this._posResizeStartY = 0;
        this._posResizeStartSize = 0;

        this._boxResizeIsHover = false;
        this._areaIsHover = false;
        this._boxResizeIsDragging = false;
        this._areaIsDragging = false;
    };

    CropAreaCircle.prototype = new CropArea();

    CropAreaCircle.prototype.getType = function() {
        return 'circle';
    };

    CropAreaCircle.prototype._calcCirclePerimeterCoords = function(angleDegrees) {
        var hSize = this._size.w / 2;
        var angleRadians = angleDegrees * (Math.PI / 180),
            circlePerimeterX = this.getCenterPoint().x + hSize * Math.cos(angleRadians),
            circlePerimeterY = this.getCenterPoint().y + hSize * Math.sin(angleRadians);
        return [circlePerimeterX, circlePerimeterY];
    };

    CropAreaCircle.prototype._calcResizeIconCenterCoords = function() {
        return this._calcCirclePerimeterCoords(-45);
    };

    CropAreaCircle.prototype._isCoordWithinArea = function(coord) {
        return Math.sqrt((coord[0] - this.getCenterPoint().x) * (coord[0] - this.getCenterPoint().x) + (coord[1] - this.getCenterPoint().y) * (coord[1] - this.getCenterPoint().y)) < this._size.w / 2;
    };
    CropAreaCircle.prototype._isCoordWithinBoxResize = function(coord) {
        var resizeIconCenterCoords = this._calcResizeIconCenterCoords();
        var hSize = this._boxResizeHoverSize / 2;
        return (coord[0] > resizeIconCenterCoords[0] - hSize && coord[0] < resizeIconCenterCoords[0] + hSize &&
            coord[1] > resizeIconCenterCoords[1] - hSize && coord[1] < resizeIconCenterCoords[1] + hSize);
    };

    CropAreaCircle.prototype._drawArea = function(ctx, centerCoords, size) {
        ctx.arc(centerCoords.x, centerCoords.y, size.w / 2, 0, 2 * Math.PI);
    };

    CropAreaCircle.prototype.draw = function() {
        CropArea.prototype.draw.apply(this, arguments);

        // draw move icon
        var center = this.getCenterPoint();
        this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

        // draw resize cubes
        this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover ? this._boxResizeHoverRatio : this._boxResizeNormalRatio);
    };

    CropAreaCircle.prototype.processMouseMove = function(mouseCurX, mouseCurY) {
        var cursor = 'default';
        var res = false;

        this._boxResizeIsHover = false;
        this._areaIsHover = false;

        if (this._areaIsDragging) {
            this.setCenterPointOnMove({
                x: mouseCurX - this._posDragStartX,
                y: mouseCurY - this._posDragStartY
            });
            this._areaIsHover = true;
            cursor = 'move';
            res = true;
            this._events.trigger('area-move');
        } else if (this._boxResizeIsDragging) {
            cursor = 'nesw-resize';
            var iFR, iFX, iFY;
            iFX = mouseCurX - this._posResizeStartX;
            iFY = this._posResizeStartY - mouseCurY;
            if (iFX > iFY) {
                iFR = this._posResizeStartSize.w + iFY * 2;
            } else {
                iFR = this._posResizeStartSize.w + iFX * 2;
            }

            var newNO = {},
                newSE = {};

            newNO.x = this.getCenterPoint().x - iFR * 0.5;
            newSE.x = this.getCenterPoint().x + iFR * 0.5;

            newNO.y = this.getCenterPoint().y - iFR * 0.5;
            newSE.y = this.getCenterPoint().y + iFR * 0.5;

            this.circleOnMove(newNO, newSE);
            this._boxResizeIsHover = true;
            res = true;
            this._events.trigger('area-resize');
        } else if (this._isCoordWithinBoxResize([mouseCurX, mouseCurY])) {
            cursor = 'nesw-resize';
            this._areaIsHover = false;
            this._boxResizeIsHover = true;
            res = true;
        } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
            cursor = 'move';
            this._areaIsHover = true;
            res = true;
        }

        //this._dontDragOutside();
        angular.element(this._ctx.canvas).css({
            'cursor': cursor
        });

        return res;
    };

    CropAreaCircle.prototype.processMouseDown = function(mouseDownX, mouseDownY) {
        if (this._isCoordWithinBoxResize([mouseDownX, mouseDownY])) {
            this._areaIsDragging = false;
            this._areaIsHover = false;
            this._boxResizeIsDragging = true;
            this._boxResizeIsHover = true;
            this._posResizeStartX = mouseDownX;
            this._posResizeStartY = mouseDownY;
            this._posResizeStartSize = this._size;
            this._events.trigger('area-resize-start');
        } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
            this._areaIsDragging = true;
            this._areaIsHover = true;
            this._boxResizeIsDragging = false;
            this._boxResizeIsHover = false;
            var center = this.getCenterPoint();
            this._posDragStartX = mouseDownX - center.x;
            this._posDragStartY = mouseDownY - center.y;
            this._events.trigger('area-move-start');
        }
    };

    CropAreaCircle.prototype.processMouseUp = function( /*mouseUpX, mouseUpY*/ ) {
        if (this._areaIsDragging) {
            this._areaIsDragging = false;
            this._events.trigger('area-move-end');
        }
        if (this._boxResizeIsDragging) {
            this._boxResizeIsDragging = false;
            this._events.trigger('area-resize-end');
        }
        this._areaIsHover = false;
        this._boxResizeIsHover = false;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
    };

    return CropAreaCircle;
}]);

angular.module('uiCropper').factory('cropAreaRectangle', ['cropArea', function (CropArea) {
    var CropAreaRectangle = function () {
        CropArea.apply(this, arguments);

        this._resizeCtrlBaseRadius = 15;
        this._resizeCtrlNormalRatio = 0.6;
        this._resizeCtrlHoverRatio = 0.70;
        this._iconMoveNormalRatio = 0.9;
        this._iconMoveHoverRatio = 1.2;

        this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
        this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
        this._posResizeStartX = 0;
        this._posResizeStartY = 0;
        this._posResizeStartSize = {
            w: 0,
            h: 0
        };

        this._resizeCtrlIsHover = -1;
        this._areaIsHover = false;
        this._resizeCtrlIsDragging = -1;
        this._areaIsDragging = false;
    };

    CropAreaRectangle.prototype = new CropArea();

    // return a type string
    CropAreaRectangle.prototype.getType = function () {
        return 'rectangle';
    };

    CropAreaRectangle.prototype._calcRectangleCorners = function () {
        var size = this.getSize();
        var se = this.getSouthEastBound();
        return [
            [size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
        ];
    };

    CropAreaRectangle.prototype._calcRectangleDimensions = function () {
        var size = this.getSize();
        var se = this.getSouthEastBound();
        return {
            left: size.x,
            top: size.y,
            right: se.x,
            bottom: se.y
        };
    };

    CropAreaRectangle.prototype._isCoordWithinArea = function (coord) {
        var rectangleDimensions = this._calcRectangleDimensions();
        return (coord[0] >= rectangleDimensions.left && coord[0] <= rectangleDimensions.right && coord[1] >= rectangleDimensions.top && coord[1] <= rectangleDimensions.bottom);
    };

    CropAreaRectangle.prototype._isCoordWithinResizeCtrl = function (coord) {
        var resizeIconsCenterCoords = this._calcRectangleCorners();
        var res = -1;
        for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
            var resizeIconCenterCoords = resizeIconsCenterCoords[i];
            if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius &&
                coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                res = i;
                break;
            }
        }
        return res;
    };

    CropAreaRectangle.prototype._drawArea = function (ctx, center, size) {
        ctx.rect(size.x, size.y, size.w, size.h);
    };

    CropAreaRectangle.prototype.draw = function () {
        CropArea.prototype.draw.apply(this, arguments);

        var center = this.getCenterPoint();
        // draw move icon
        this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

        // draw resize thumbs
        var resizeIconsCenterCoords = this._calcRectangleCorners();
        for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
            var resizeIconCenterCoords = resizeIconsCenterCoords[i];
            this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
        }
    };

    CropAreaRectangle.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
        var cursor = 'default';
        var res = false;

        this._resizeCtrlIsHover = -1;
        this._areaIsHover = false;

        if (this._areaIsDragging) {
            this.setCenterPointOnMove({
                x: mouseCurX - this._posDragStartX,
                y: mouseCurY - this._posDragStartY
            });
            this._areaIsHover = true;
            cursor = 'move';
            res = true;
            this._events.trigger('area-move');
        } else if (this._resizeCtrlIsDragging > -1) {
            var s = this.getSize();
            var se = this.getSouthEastBound();
            var posX = mouseCurX;
            switch (this._resizeCtrlIsDragging) {
                case 0: // Top Left
                    if (this._aspect) {
                        posX = se.x - ((se.y - mouseCurY) * this._aspect);
                    }
                    this.setSizeByCorners({
                        x: posX,
                        y: mouseCurY
                    }, {
                        x: se.x,
                        y: se.y
                    });
                    cursor = 'nwse-resize';
                    break;
                case 1: // Top Right
                    if (this._aspect) {
                        posX = s.x + ((se.y - mouseCurY) * this._aspect);
                    }
                    this.setSizeByCorners({
                        x: s.x,
                        y: mouseCurY
                    }, {
                        x: posX,
                        y: se.y
                    });
                    cursor = 'nesw-resize';
                    break;
                case 2: // Bottom Left
                    if (this._aspect) {
                        posX = se.x - ((mouseCurY - s.y) * this._aspect);
                    }
                    this.setSizeByCorners({
                        x: posX,
                        y: s.y
                    }, {
                        x: se.x,
                        y: mouseCurY
                    });
                    cursor = 'nesw-resize';
                    break;
                case 3: // Bottom Right
                    if (this._aspect) {
                        posX = s.x + ((mouseCurY - s.y) * this._aspect);
                    }
                    this.setSizeByCorners({
                        x: s.x,
                        y: s.y
                    }, {
                        x: posX,
                        y: mouseCurY
                    });
                    cursor = 'nwse-resize';
                    break;
            }

            this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
            res = true;
            this._events.trigger('area-resize');
        } else {
            var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
            if (hoveredResizeBox > -1) {
                switch (hoveredResizeBox) {
                    case 0:
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        cursor = 'nwse-resize';
                        break;
                }
                this._areaIsHover = false;
                this._resizeCtrlIsHover = hoveredResizeBox;
                res = true;
            } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                cursor = 'move';
                this._areaIsHover = true;
                res = true;
            }
        }

        angular.element(this._ctx.canvas).css({
            'cursor': cursor
        });

        return res;
    };

    CropAreaRectangle.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
        var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
        if (isWithinResizeCtrl > -1) {
            this._areaIsDragging = false;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = isWithinResizeCtrl;
            this._resizeCtrlIsHover = isWithinResizeCtrl;
            this._posResizeStartX = mouseDownX;
            this._posResizeStartY = mouseDownY;
            this._posResizeStartSize = this._size;
            this._events.trigger('area-resize-start');
        } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
            this._areaIsDragging = true;
            this._areaIsHover = true;
            this._resizeCtrlIsDragging = -1;
            this._resizeCtrlIsHover = -1;
            var center = this.getCenterPoint();
            this._posDragStartX = mouseDownX - center.x;
            this._posDragStartY = mouseDownY - center.y;
            this._events.trigger('area-move-start');
        }
    };

    CropAreaRectangle.prototype.processMouseUp = function (/*mouseUpX, mouseUpY*/) {
        if (this._areaIsDragging) {
            this._areaIsDragging = false;
            this._events.trigger('area-move-end');
        }
        if (this._resizeCtrlIsDragging > -1) {
            this._resizeCtrlIsDragging = -1;
            this._events.trigger('area-resize-end');
        }
        this._areaIsHover = false;
        this._resizeCtrlIsHover = -1;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
    };

    return CropAreaRectangle;
}]);

angular.module('uiCropper').factory('cropAreaSquare', ['cropArea', function(CropArea) {
    var CropAreaSquare = function() {
        CropArea.apply(this, arguments);

        this._resizeCtrlBaseRadius = 15;
        this._resizeCtrlNormalRatio = 0.6;
        this._resizeCtrlHoverRatio = 0.70;
        this._iconMoveNormalRatio = 0.9;
        this._iconMoveHoverRatio = 1.2;

        this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
        this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
        this._posResizeStartX = 0;
        this._posResizeStartY = 0;
        this._posResizeStartSize = 0;

        this._resizeCtrlIsHover = -1;
        this._areaIsHover = false;
        this._resizeCtrlIsDragging = -1;
        this._areaIsDragging = false;
    };

    CropAreaSquare.prototype = new CropArea();

    CropAreaSquare.prototype.getType = function() {
        return 'square';
    };

    CropAreaSquare.prototype._calcSquareCorners = function() {
        var size = this.getSize(),
            se = this.getSouthEastBound();
        return [
            [size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
        ];
    };

    CropAreaSquare.prototype._calcSquareDimensions = function() {
        var size = this.getSize(),
            se = this.getSouthEastBound();
        return {
            left: size.x,
            top: size.y,
            right: se.x,
            bottom: se.y
        };
    };

    CropAreaSquare.prototype._isCoordWithinArea = function(coord) {
        var squareDimensions = this._calcSquareDimensions();
        return (coord[0] >= squareDimensions.left && coord[0] <= squareDimensions.right && coord[1] >= squareDimensions.top && coord[1] <= squareDimensions.bottom);
    };

    CropAreaSquare.prototype._isCoordWithinResizeCtrl = function(coord) {
        var resizeIconsCenterCoords = this._calcSquareCorners();
        var res = -1;
        for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
            var resizeIconCenterCoords = resizeIconsCenterCoords[i];
            if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius &&
                coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                res = i;
                break;
            }
        }
        return res;
    };

    CropAreaSquare.prototype._drawArea = function(ctx, centerCoords, size) {
        ctx.rect(size.x, size.y, size.w, size.h);
    };

    CropAreaSquare.prototype.draw = function() {
        CropArea.prototype.draw.apply(this, arguments);

        // draw move icon
        var center = this.getCenterPoint();
        this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

        // draw resize cubes
        var resizeIconsCenterCoords = this._calcSquareCorners();
        for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
            var resizeIconCenterCoords = resizeIconsCenterCoords[i];
            this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
        }
    };

    CropAreaSquare.prototype._clampPoint = function(x, y) {
        var size = this._ctx.canvas.width;

        if(x < 0) {
            y -= Math.abs(x);
            x = 0;
        }

        if(y < 0) {
            x -= Math.abs(y);
            y = 0;
        }

        if(x > size) {
            y -= (size - x);
            x = size;
        }

        if(y > size) {
            x -= (size - y);
            y = size;
        }

        return {
            x: x,
            y: y
        };
    };

    CropAreaSquare.prototype.processMouseMove = function(mouseCurX, mouseCurY) {
        var cursor = 'default';
        var res = false;

        this._resizeCtrlIsHover = -1;
        this._areaIsHover = false;

        if (this._areaIsDragging) {
            this.setCenterPointOnMove({
                x: mouseCurX - this._posDragStartX,
                y: mouseCurY - this._posDragStartY
            });
            this._areaIsHover = true;
            cursor = 'move';
            res = true;
            this._events.trigger('area-move');
        } else if (this._resizeCtrlIsDragging > -1) {
            var xMulti, yMulti;
            switch (this._resizeCtrlIsDragging) {
                case 0: // Top Left
                    xMulti = -1;
                    yMulti = -1;
                    cursor = 'nwse-resize';
                    break;
                case 1: // Top Right
                    xMulti = 1;
                    yMulti = -1;
                    cursor = 'nesw-resize';
                    break;
                case 2: // Bottom Left
                    xMulti = -1;
                    yMulti = 1;
                    cursor = 'nesw-resize';
                    break;
                case 3: // Bottom Right
                    xMulti = 1;
                    yMulti = 1;
                    cursor = 'nwse-resize';
                    break;
            }
            var iFX = (mouseCurX - this._posResizeStartX) * xMulti,
                iFY = (mouseCurY - this._posResizeStartY) * yMulti,
                iFR;
            if (iFX > iFY) {
                iFR = this._posResizeStartSize.w + iFY;
            } else {
                iFR = this._posResizeStartSize.w + iFX;
            }
            var newSize = Math.max(this._minSize.w, iFR),
                newNO = {},
                newSE = {},
                newSO = {},
                newNE = {},
                s = this.getSize(),
                se = this.getSouthEastBound();

            switch (this._resizeCtrlIsDragging) {
                case 0: // Top Left
                    newNO.x = se.x - newSize;
                    newNO.y = se.y - newSize;

                    newNO = this._clampPoint(newNO.x, newNO.y);

                    this.setSizeByCorners(newNO, {
                        x: se.x,
                        y: se.y
                    });

                    cursor = 'nwse-resize';
                    break;
                case 1: // Top Right

                    newNE.x = s.x + newSize;
                    newNE.y = se.y - newSize;

                    newNE = this._clampPoint(newNE.x, newNE.y);

                    this.setSizeByCorners({
                        x: s.x,
                        y: newNE.y
                    }, {
                        x: newNE.x,
                        y: se.y
                    });

                    cursor = 'nesw-resize';
                    break;
                case 2: // Bottom Left
                    newSO.x = se.x - newSize;
                    newSO.y = s.y + newSize;

                    newSO = this._clampPoint(newSO.x, newSO.y);

                    this.setSizeByCorners({
                        x: newSO.x,
                        y: s.y
                    }, {
                        x: se.x,
                        y: newSO.y
                    });

                    cursor = 'nesw-resize';
                    break;
                case 3: // Bottom Right

                    newSE.x = s.x + newSize;
                    newSE.y = s.y + newSize;

                    newSE = this._clampPoint(newSE.x, newSE.y);

                    this.setSizeByCorners({
                        x: s.x,
                        y: s.y
                    }, newSE);

                    cursor = 'nwse-resize';
                    break;
            }
            this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
            res = true;
            this._events.trigger('area-resize');
        } else {
            var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
            if (hoveredResizeBox > -1) {
                switch (hoveredResizeBox) {
                    case 0:
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        cursor = 'nwse-resize';
                        break;
                }
                this._areaIsHover = false;
                this._resizeCtrlIsHover = hoveredResizeBox;
                res = true;
            } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                cursor = 'move';
                this._areaIsHover = true;
                res = true;
            }
        }

        angular.element(this._ctx.canvas).css({
            'cursor': cursor
        });

        return res;
    };

    CropAreaSquare.prototype.processMouseDown = function(mouseDownX, mouseDownY) {
        var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
        if (isWithinResizeCtrl > -1) {
            this._areaIsDragging = false;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = isWithinResizeCtrl;
            this._resizeCtrlIsHover = isWithinResizeCtrl;
            this._posResizeStartX = mouseDownX;
            this._posResizeStartY = mouseDownY;
            this._posResizeStartSize = this._size;
            this._events.trigger('area-resize-start');
        } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
            this._areaIsDragging = true;
            this._areaIsHover = true;
            this._resizeCtrlIsDragging = -1;
            this._resizeCtrlIsHover = -1;
            var center = this.getCenterPoint();
            this._posDragStartX = mouseDownX - center.x;
            this._posDragStartY = mouseDownY - center.y;
            this._events.trigger('area-move-start');
        }
    };

    CropAreaSquare.prototype.processMouseUp = function( /*mouseUpX, mouseUpY*/ ) {
        if (this._areaIsDragging) {
            this._areaIsDragging = false;
            this._events.trigger('area-move-end');
        }
        if (this._resizeCtrlIsDragging > -1) {
            this._resizeCtrlIsDragging = -1;
            this._events.trigger('area-resize-end');
        }
        this._areaIsHover = false;
        this._resizeCtrlIsHover = -1;

        this._posDragStartX = 0;
        this._posDragStartY = 0;
    };

    return CropAreaSquare;
}]);

angular.module('uiCropper').factory('cropArea', ['cropCanvas', function (CropCanvas) {
    var CropArea = function (ctx, events) {
        this._ctx = ctx;
        this._events = events;

        this._minSize = {
            x: 0,
            y: 0,
            w: 80,
            h: 80
        };

        this._initSize = undefined;
        this._initCoords = undefined;
        this._allowCropResizeOnCorners = false;

        this._forceAspectRatio = false;
        this._aspect = null;

        this._cropCanvas = new CropCanvas(ctx);

        this._image = new Image();
        this._size = {
            x: 0,
            y: 0,
            w: 150,
            h: 150
        };
    };

    /* GETTERS/SETTERS */

    CropArea.prototype.setAllowCropResizeOnCorners = function (bool) {
        this._allowCropResizeOnCorners = bool;
    };
    CropArea.prototype.getImage = function () {
        return this._image;
    };
    CropArea.prototype.setImage = function (image) {
        this._image = image;
    };
    CropArea.prototype.setForceAspectRatio = function (force) {
        this._forceAspectRatio = force;
    };
    CropArea.prototype.setAspect = function (aspect) {
        this._aspect = aspect;
    };
    CropArea.prototype.getAspect = function () {
        return this._aspect;
    };
    CropArea.prototype.getCanvasSize = function () {
        return {
            w: this._ctx.canvas.width,
            h: this._ctx.canvas.height
        };
    };
    CropArea.prototype.getSize = function () {
        return this._size;
    };
    CropArea.prototype.setSize = function (size) {
        size = this._processSize(size);
        this._size = this._preventBoundaryCollision(size);
    };
    CropArea.prototype.setSizeOnMove = function (size) {
        size = this._processSize(size);
        if (this._allowCropResizeOnCorners) {
            this._size = this._preventBoundaryCollision(size);
        } else {
            this._size = this._allowMouseOutsideCanvas(size);
        }
    };
    CropArea.prototype.circleOnMove = function (northWestCorner, southEastCorner) {
        var size = {
            x: northWestCorner.x,
            y: northWestCorner.y,
            w: southEastCorner.x - northWestCorner.x,
            h: southEastCorner.y - northWestCorner.y
        };
        var canvasH = this._ctx.canvas.height,
            canvasW = this._ctx.canvas.width;
        if (size.w > canvasW || size.h > canvasH) {
            if (canvasW < canvasH) {
                size.w = canvasW;
                size.h = canvasW;
            } else {
                size.w = canvasH;
                size.h = canvasH;
            }
        }
        if (size.x + size.w > canvasW) {
            size.x = canvasW - size.w;
        }
        if (size.y + size.h > canvasH) {
            size.y = canvasH - size.h;
        }
        if (size.x < 0) {
            size.x = 0;
        }
        if (size.y < 0) {
            size.y = 0;
        }
        if (this._minSize.w > size.w) {
            size.w = this._minSize.w;
            size.x = this._size.x;
        }
        if (this._minSize.h > size.h) {
            size.h = this._minSize.h;
            size.y = this._size.y;
        }
        this._size = size;
    };

    CropArea.prototype.setSizeByCorners = function (northWestCorner, southEastCorner) {

        var size = {
            x: northWestCorner.x,
            y: northWestCorner.y,
            w: southEastCorner.x - northWestCorner.x,
            h: southEastCorner.y - northWestCorner.y
        };
        this.setSize(size);
    };

    CropArea.prototype.getSouthEastBound = function () {
        return this._southEastBound(this.getSize());
    };

    CropArea.prototype.setMinSize = function (size) {
        this._minSize = this._processSize(size);
        this.setSize(this._minSize);
    };

    CropArea.prototype.getMinSize = function () {
        return this._minSize;
    };

    CropArea.prototype.getCenterPoint = function () {
        var s = this.getSize();
        return {
            x: s.x + (s.w / 2),
            y: s.y + (s.h / 2)
        };
    };

    CropArea.prototype.setCenterPoint = function (point) {
        var s = this.getSize();
        this.setSize({
            x: point.x - s.w / 2,
            y: point.y - s.h / 2,
            w: s.w,
            h: s.h
        });
    };

    CropArea.prototype.setCenterPointOnMove = function (point) {
        var s = this.getSize();
        this.setSizeOnMove({
            x: point.x - s.w / 2,
            y: point.y - s.h / 2,
            w: s.w,
            h: s.h
        });
    };

    CropArea.prototype.setInitSize = function (size) {
        this._initSize = this._processSize(size);
        this.setSize(this._initSize);
    };

    CropArea.prototype.getInitSize = function () {
        return this._initSize;
    };

    CropArea.prototype.setInitCoords = function (coords) {
        //add h/w-data to coords-object
        coords.h = this.getSize().h;
        coords.w = this.getSize().w;
        this._initCoords = this._processSize(coords);
        this.setSize(this._initCoords);
    };

    CropArea.prototype.getInitCoords = function () {
        return this._initCoords;
    };

    // return a type string
    CropArea.prototype.getType = function () {
        //default to circle
        return 'circle';
    };

    /* FUNCTIONS */
    CropArea.prototype._allowMouseOutsideCanvas = function (size) {
        var canvasH = this._ctx.canvas.height,
            canvasW = this._ctx.canvas.width;
        var newSize = {
            w: size.w,
            h: size.h,
        };
        if (size.x < 0) {
            newSize.x = 0;
        }
        else if (size.x + size.w > canvasW) {
            newSize.x = canvasW - size.w;
        }
        else {
            newSize.x = size.x;
        }
        if (size.y < 0) {
            newSize.y = 0;
        }
        else if (size.y + size.h > canvasH) {
            newSize.y = canvasH - size.h;
        }
        else {
            newSize.y = size.y;
        }
        return newSize;
    };

    CropArea.prototype._preventBoundaryCollision = function (size) {
        var canvasH = this._ctx.canvas.height,
            canvasW = this._ctx.canvas.width;

        var nw = {
            x: size.x,
            y: size.y
        };
        var se = this._southEastBound(size);

        // check northwest corner
        if (nw.x < 0) {
            nw.x = 0;
        }
        if (nw.y < 0) {
            nw.y = 0;
        }

        // check southeast corner
        if (se.x > canvasW) {
            se.x = canvasW;
        }
        if (se.y > canvasH) {
            se.y = canvasH;
        }

        var newSizeWidth = (this._forceAspectRatio) ? size.w : se.x - nw.x,
            newSizeHeight = (this._forceAspectRatio) ? size.h : se.y - nw.y;

        if (newSizeHeight > canvasH) {
            newSizeHeight = canvasH;
        }

        // save rectangle scale
        if (this._aspect) {
            newSizeWidth = newSizeHeight * this._aspect;
            if (nw.x + newSizeWidth > canvasW) {
                newSizeWidth = canvasW - nw.x;
                newSizeHeight = newSizeWidth / this._aspect;
                if (this._minSize.w > newSizeWidth) {
                    newSizeWidth = this._minSize.w;
                }
                if (this._minSize.h > newSizeHeight) {
                    newSizeHeight = this._minSize.h;
                }
                nw.x = canvasW - newSizeWidth;
            }
            if (nw.y + newSizeHeight > canvasH) {
                nw.y = canvasH - newSizeHeight;
            }
        }

        // save square scale
        if (this._forceAspectRatio) {
            newSizeWidth = newSizeHeight;
            if (nw.x + newSizeWidth > canvasW) {
                newSizeWidth = canvasW - nw.x;
                if (newSizeWidth < this._minSize.w) {
                    newSizeWidth = this._minSize.w;
                }
                newSizeHeight = newSizeWidth;
            }
        }

        var newSize = {
            x: nw.x,
            y: nw.y,
            w: newSizeWidth,
            h: newSizeHeight
        };

        //check size (if < min, adjust nw corner)
        if ((newSize.w < this._minSize.w) && !this._forceAspectRatio) {
            newSize.w = this._minSize.w;
            se = this._southEastBound(newSize);
            //adjust se corner, if it's out of bounds
            if (se.x > canvasW) {
                se.x = canvasW;
                //adjust nw corner according to min width
                nw.x = Math.max(se.x - canvasW, se.x - this._minSize.w);
                newSize = {
                    x: nw.x,
                    y: nw.y,
                    w: se.x - nw.x,
                    h: se.y - nw.y
                };
            }
        }

        if ((newSize.h < this._minSize.h) && !this._forceAspectRatio) {
            newSize.h = this._minSize.h;
            se = this._southEastBound(newSize);

            if (se.y > canvasH) {
                se.y = canvasH;
                //adjust nw corner according to min height
                nw.y = Math.max(se.y - canvasH, se.y - this._minSize.h);
                newSize = {
                    x: nw.x,
                    y: nw.y,
                    w: se.x - nw.x,
                    h: se.y - nw.y
                };
            }
        }

        if (this._forceAspectRatio) {
            //check if outside SE bound
            se = this._southEastBound(newSize);
            if (se.y > canvasH) {
                newSize.y = canvasH - newSize.h;
            }
            if (se.x > canvasW) {
                newSize.x = canvasW - newSize.w;
            }
        }

        return newSize;
    };

    CropArea.prototype._dontDragOutside = function () {
        var h = this._ctx.canvas.height,
            w = this._ctx.canvas.width;

        if (this._width > w) {
            this._width = w;
        }
        if (this._height > h) {
            this._height = h;
        }
        if (this._x < this._width / 2) {
            this._x = this._width / 2;
        }
        if (this._x > w - this._width / 2) {
            this._x = w - this._width / 2;
        }
        if (this._y < this._height / 2) {
            this._y = this._height / 2;
        }
        if (this._y > h - this._height / 2) {
            this._y = h - this._height / 2;
        }
    };

    CropArea.prototype._drawArea = function () {
    };

    CropArea.prototype._processSize = function (size) {
        // make this polymorphic to accept a single floating point number
        // for square-like sizes (including circle)
        if (typeof size === 'number') {
            size = {
                w: size,
                h: size
            };
        }
        var width = size.w;
        if (this._aspect) {
            width = size.h * this._aspect;
        }
        return {
            x: (typeof size.x === 'undefined') ? this.getSize().x : size.x,
            y: (typeof size.y === 'undefined') ? this.getSize().y : size.y,
            w: width || this._minSize.w,
            h: size.h || this._minSize.h
        };
    };

    CropArea.prototype._southEastBound = function (size) {
        return {
            x: size.x + size.w,
            y: size.y + size.h
        };
    };

    CropArea.prototype.draw = function () {
        // draw crop area
        this._cropCanvas.drawCropArea(this._image, this.getCenterPoint(), this._size, this._drawArea);
    };

    CropArea.prototype.processMouseMove = function () {
    };

    CropArea.prototype.processMouseDown = function () {
    };

    CropArea.prototype.processMouseUp = function () {
    };

    return CropArea;
}]);

angular.module('uiCropper').factory('cropCanvas', [function() {
    // Shape = Array of [x,y]; [0, 0] - center
    var shapeArrowNW = [
        [-0.5, -2],
        [-3, -4.5],
        [-0.5, -7],
        [-7, -7],
        [-7, -0.5],
        [-4.5, -3],
        [-2, -0.5]
    ];
    var shapeArrowNE = [
        [0.5, -2],
        [3, -4.5],
        [0.5, -7],
        [7, -7],
        [7, -0.5],
        [4.5, -3],
        [2, -0.5]
    ];
    var shapeArrowSW = [
        [-0.5, 2],
        [-3, 4.5],
        [-0.5, 7],
        [-7, 7],
        [-7, 0.5],
        [-4.5, 3],
        [-2, 0.5]
    ];
    var shapeArrowSE = [
        [0.5, 2],
        [3, 4.5],
        [0.5, 7],
        [7, 7],
        [7, 0.5],
        [4.5, 3],
        [2, 0.5]
    ];
    var shapeArrowN = [
        [-1.5, -2.5],
        [-1.5, -6],
        [-5, -6],
        [0, -11],
        [5, -6],
        [1.5, -6],
        [1.5, -2.5]
    ];
    var shapeArrowW = [
        [-2.5, -1.5],
        [-6, -1.5],
        [-6, -5],
        [-11, 0],
        [-6, 5],
        [-6, 1.5],
        [-2.5, 1.5]
    ];
    var shapeArrowS = [
        [-1.5, 2.5],
        [-1.5, 6],
        [-5, 6],
        [0, 11],
        [5, 6],
        [1.5, 6],
        [1.5, 2.5]
    ];
    var shapeArrowE = [
        [2.5, -1.5],
        [6, -1.5],
        [6, -5],
        [11, 0],
        [6, 5],
        [6, 1.5],
        [2.5, 1.5]
    ];

    // Colors
    var colors = {
        areaOutline: '#fff',
        resizeBoxStroke: '#bababa',
        resizeBoxFill: '#444',
        resizeBoxArrowFill: '#fff',
        resizeCircleStroke: '#bababa',
        resizeCircleFill: '#444',
        moveIconFill: '#fff'
    };

    var cropper = {
        strokeWidth: 1
    };

    return function(ctx) {

        /* Base functions */

        // Calculate Point
        var calcPoint = function(point, offset, scale) {
            return [scale * point[0] + offset[0], scale * point[1] + offset[1]];
        };

        // Draw Filled Polygon
        var drawFilledPolygon = function(shape, fillStyle, centerCoords, scale) {
            ctx.save();
            ctx.fillStyle = fillStyle;
            ctx.beginPath();
            var pc, pc0 = calcPoint(shape[0], centerCoords, scale);
            ctx.moveTo(pc0[0], pc0[1]);

            for (var p in shape) {
                if (p > 0) {
                    pc = calcPoint(shape[p], centerCoords, scale);
                    ctx.lineTo(pc[0], pc[1]);
                }
            }

            ctx.lineTo(pc0[0], pc0[1]);
            ctx.fill();
            ctx.closePath();
            ctx.restore();
        };

        /* Icons */

        this.drawIconMove = function(centerCoords, scale) {
            drawFilledPolygon(shapeArrowN, colors.moveIconFill, centerCoords, scale);
            drawFilledPolygon(shapeArrowW, colors.moveIconFill, centerCoords, scale);
            drawFilledPolygon(shapeArrowS, colors.moveIconFill, centerCoords, scale);
            drawFilledPolygon(shapeArrowE, colors.moveIconFill, centerCoords, scale);
        };

        this.drawIconResizeCircle = function(centerCoords, circleRadius, scale) {
            var scaledCircleRadius = circleRadius * scale;
            ctx.save();
            ctx.strokeStyle = colors.resizeCircleStroke;
            ctx.lineWidth = cropper.strokeWidth;
            ctx.fillStyle = colors.resizeCircleFill;
            ctx.beginPath();
            ctx.arc(centerCoords[0], centerCoords[1], scaledCircleRadius, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
            ctx.closePath();
            ctx.restore();
        };

        this.drawIconResizeBoxBase = function(centerCoords, boxSize, scale) {
            var scaledBoxSize = boxSize * scale;
            ctx.save();
            ctx.strokeStyle = colors.resizeBoxStroke;
            ctx.lineWidth = cropper.strokeWidth;
            ctx.fillStyle = colors.resizeBoxFill;
            ctx.fillRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
            ctx.strokeRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
            ctx.restore();
        };
        this.drawIconResizeBoxNESW = function(centerCoords, boxSize, scale) {
            this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
            drawFilledPolygon(shapeArrowNE, colors.resizeBoxArrowFill, centerCoords, scale);
            drawFilledPolygon(shapeArrowSW, colors.resizeBoxArrowFill, centerCoords, scale);
        };
        this.drawIconResizeBoxNWSE = function(centerCoords, boxSize, scale) {
            this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
            drawFilledPolygon(shapeArrowNW, colors.resizeBoxArrowFill, centerCoords, scale);
            drawFilledPolygon(shapeArrowSE, colors.resizeBoxArrowFill, centerCoords, scale);
        };

        /* Crop Area */

        this.drawCropArea = function(image, centerCoords, size, fnDrawClipPath) {
            var xRatio = Math.abs(image.width / ctx.canvas.width),
                yRatio = Math.abs(image.height / ctx.canvas.height),
                xLeft = Math.abs(centerCoords.x - size.w / 2),
                yTop = Math.abs(centerCoords.y - size.h / 2);

            ctx.save();
            ctx.strokeStyle = colors.areaOutline;
            ctx.lineWidth = cropper.strokeWidth;
            ctx.setLineDash([5, 5]);
            ctx.beginPath();
            fnDrawClipPath(ctx, centerCoords, size);
            ctx.stroke();
            ctx.clip();

            // draw part of original image
            if (size.w > 0) {
                ctx.drawImage(image, xLeft * xRatio, yTop * yRatio, Math.abs(size.w * xRatio), Math.abs(size.h * yRatio), xLeft, yTop, Math.abs(size.w), Math.abs(size.h));
            }

            ctx.beginPath();
            fnDrawClipPath(ctx, centerCoords, size);
            ctx.stroke();
            ctx.clip();

            ctx.restore();
        };

    };
}]);

/**
 * EXIF service is based on the exif-js library (https://github.com/jseidelin/exif-js)
 */
/*eslint-disable */
//Disable eslint as this is a 3rd party lib
angular.module('uiCropper').service('cropEXIF', [function () {
    var debug = false;

    var ExifTags = this.Tags = {

        // version tags
        0x9000: 'ExifVersion', // EXIF version
        0xA000: 'FlashpixVersion', // Flashpix format version

        // colorspace tags
        0xA001: 'ColorSpace', // Color space information tag

        // image configuration
        0xA002: 'PixelXDimension', // Valid width of meaningful image
        0xA003: 'PixelYDimension', // Valid height of meaningful image
        0x9101: 'ComponentsConfiguration', // Information about channels
        0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel

        // user information
        0x927C: 'MakerNote', // Any desired information written by the manufacturer
        0x9286: 'UserComment', // Comments by user

        // related file
        0xA004: 'RelatedSoundFile', // Name of related sound file

        // date and time
        0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
        0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
        0x9290: 'SubsecTime', // Fractions of seconds for DateTime
        0x9291: 'SubsecTimeOriginal', // Fractions of seconds for DateTimeOriginal
        0x9292: 'SubsecTimeDigitized', // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A: 'ExposureTime', // Exposure time (in seconds)
        0x829D: 'FNumber', // F number
        0x8822: 'ExposureProgram', // Exposure program
        0x8824: 'SpectralSensitivity', // Spectral sensitivity
        0x8827: 'ISOSpeedRatings', // ISO speed rating
        0x8828: 'OECF', // Optoelectric conversion factor
        0x9201: 'ShutterSpeedValue', // Shutter speed
        0x9202: 'ApertureValue', // Lens aperture
        0x9203: 'BrightnessValue', // Value of brightness
        0x9204: 'ExposureBias', // Exposure bias
        0x9205: 'MaxApertureValue', // Smallest F number of lens
        0x9206: 'SubjectDistance', // Distance to subject in meters
        0x9207: 'MeteringMode', // Metering mode
        0x9208: 'LightSource', // Kind of light source
        0x9209: 'Flash', // Flash status
        0x9214: 'SubjectArea', // Location and area of main subject
        0x920A: 'FocalLength', // Focal length of the lens in mm
        0xA20B: 'FlashEnergy', // Strobe energy in BCPS
        0xA20C: 'SpatialFrequencyResponse', //
        0xA20E: 'FocalPlaneXResolution', // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F: 'FocalPlaneYResolution', // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210: 'FocalPlaneResolutionUnit', // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214: 'SubjectLocation', // Location of subject in image
        0xA215: 'ExposureIndex', // Exposure index selected on camera
        0xA217: 'SensingMethod', // Image sensor type
        0xA300: 'FileSource', // Image source (3 == DSC)
        0xA301: 'SceneType', // Scene type (1 == directly photographed)
        0xA302: 'CFAPattern', // Color filter array geometric pattern
        0xA401: 'CustomRendered', // Special processing
        0xA402: 'ExposureMode', // Exposure mode
        0xA403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
        0xA404: 'DigitalZoomRation', // Digital zoom ratio
        0xA405: 'FocalLengthIn35mmFilm', // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406: 'SceneCaptureType', // Type of scene
        0xA407: 'GainControl', // Degree of overall image gain adjustment
        0xA408: 'Contrast', // Direction of contrast processing applied by camera
        0xA409: 'Saturation', // Direction of saturation processing applied by camera
        0xA40A: 'Sharpness', // Direction of sharpness processing applied by camera
        0xA40B: 'DeviceSettingDescription', //
        0xA40C: 'SubjectDistanceRange', // Distance to subject

        // other tags
        0xA005: 'InteroperabilityIFDPointer',
        0xA420: 'ImageUniqueID' // Identifier assigned uniquely to each image
    };

    var TiffTags = this.TiffTags = {
        0x0100: 'ImageWidth',
        0x0101: 'ImageHeight',
        0x8769: 'ExifIFDPointer',
        0x8825: 'GPSInfoIFDPointer',
        0xA005: 'InteroperabilityIFDPointer',
        0x0102: 'BitsPerSample',
        0x0103: 'Compression',
        0x0106: 'PhotometricInterpretation',
        0x0112: 'Orientation',
        0x0115: 'SamplesPerPixel',
        0x011C: 'PlanarConfiguration',
        0x0212: 'YCbCrSubSampling',
        0x0213: 'YCbCrPositioning',
        0x011A: 'XResolution',
        0x011B: 'YResolution',
        0x0128: 'ResolutionUnit',
        0x0111: 'StripOffsets',
        0x0116: 'RowsPerStrip',
        0x0117: 'StripByteCounts',
        0x0201: 'JPEGInterchangeFormat',
        0x0202: 'JPEGInterchangeFormatLength',
        0x012D: 'TransferFunction',
        0x013E: 'WhitePoint',
        0x013F: 'PrimaryChromaticities',
        0x0211: 'YCbCrCoefficients',
        0x0214: 'ReferenceBlackWhite',
        0x0132: 'DateTime',
        0x010E: 'ImageDescription',
        0x010F: 'Make',
        0x0110: 'Model',
        0x0131: 'Software',
        0x013B: 'Artist',
        0x8298: 'Copyright'
    };

    var GPSTags = this.GPSTags = {
        0x0000: 'GPSVersionID',
        0x0001: 'GPSLatitudeRef',
        0x0002: 'GPSLatitude',
        0x0003: 'GPSLongitudeRef',
        0x0004: 'GPSLongitude',
        0x0005: 'GPSAltitudeRef',
        0x0006: 'GPSAltitude',
        0x0007: 'GPSTimeStamp',
        0x0008: 'GPSSatellites',
        0x0009: 'GPSStatus',
        0x000A: 'GPSMeasureMode',
        0x000B: 'GPSDOP',
        0x000C: 'GPSSpeedRef',
        0x000D: 'GPSSpeed',
        0x000E: 'GPSTrackRef',
        0x000F: 'GPSTrack',
        0x0010: 'GPSImgDirectionRef',
        0x0011: 'GPSImgDirection',
        0x0012: 'GPSMapDatum',
        0x0013: 'GPSDestLatitudeRef',
        0x0014: 'GPSDestLatitude',
        0x0015: 'GPSDestLongitudeRef',
        0x0016: 'GPSDestLongitude',
        0x0017: 'GPSDestBearingRef',
        0x0018: 'GPSDestBearing',
        0x0019: 'GPSDestDistanceRef',
        0x001A: 'GPSDestDistance',
        0x001B: 'GPSProcessingMethod',
        0x001C: 'GPSAreaInformation',
        0x001D: 'GPSDateStamp',
        0x001E: 'GPSDifferential'
    };

    var StringValues = this.StringValues = {
        ExposureProgram: {
            0: 'Not defined',
            1: 'Manual',
            2: 'Normal program',
            3: 'Aperture priority',
            4: 'Shutter priority',
            5: 'Creative program',
            6: 'Action program',
            7: 'Portrait mode',
            8: 'Landscape mode'
        },
        MeteringMode: {
            0: 'Unknown',
            1: 'Average',
            2: 'CenterWeightedAverage',
            3: 'Spot',
            4: 'MultiSpot',
            5: 'Pattern',
            6: 'Partial',
            255: 'Other'
        },
        LightSource: {
            0: 'Unknown',
            1: 'Daylight',
            2: 'Fluorescent',
            3: 'Tungsten (incandescent light)',
            4: 'Flash',
            9: 'Fine weather',
            10: 'Cloudy weather',
            11: 'Shade',
            12: 'Daylight fluorescent (D 5700 - 7100K)',
            13: 'Day white fluorescent (N 4600 - 5400K)',
            14: 'Cool white fluorescent (W 3900 - 4500K)',
            15: 'White fluorescent (WW 3200 - 3700K)',
            17: 'Standard light A',
            18: 'Standard light B',
            19: 'Standard light C',
            20: 'D55',
            21: 'D65',
            22: 'D75',
            23: 'D50',
            24: 'ISO studio tungsten',
            255: 'Other'
        },
        Flash: {
            0x0000: 'Flash did not fire',
            0x0001: 'Flash fired',
            0x0005: 'Strobe return light not detected',
            0x0007: 'Strobe return light detected',
            0x0009: 'Flash fired, compulsory flash mode',
            0x000D: 'Flash fired, compulsory flash mode, return light not detected',
            0x000F: 'Flash fired, compulsory flash mode, return light detected',
            0x0010: 'Flash did not fire, compulsory flash mode',
            0x0018: 'Flash did not fire, auto mode',
            0x0019: 'Flash fired, auto mode',
            0x001D: 'Flash fired, auto mode, return light not detected',
            0x001F: 'Flash fired, auto mode, return light detected',
            0x0020: 'No flash function',
            0x0041: 'Flash fired, red-eye reduction mode',
            0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
            0x0047: 'Flash fired, red-eye reduction mode, return light detected',
            0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
            0x004D: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
            0x004F: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
            0x0059: 'Flash fired, auto mode, red-eye reduction mode',
            0x005D: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
            0x005F: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
        },
        SensingMethod: {
            1: 'Not defined',
            2: 'One-chip color area sensor',
            3: 'Two-chip color area sensor',
            4: 'Three-chip color area sensor',
            5: 'Color sequential area sensor',
            7: 'Trilinear sensor',
            8: 'Color sequential linear sensor'
        },
        SceneCaptureType: {
            0: 'Standard',
            1: 'Landscape',
            2: 'Portrait',
            3: 'Night scene'
        },
        SceneType: {
            1: 'Directly photographed'
        },
        CustomRendered: {
            0: 'Normal process',
            1: 'Custom process'
        },
        WhiteBalance: {
            0: 'Auto white balance',
            1: 'Manual white balance'
        },
        GainControl: {
            0: 'None',
            1: 'Low gain up',
            2: 'High gain up',
            3: 'Low gain down',
            4: 'High gain down'
        },
        Contrast: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard'
        },
        Saturation: {
            0: 'Normal',
            1: 'Low saturation',
            2: 'High saturation'
        },
        Sharpness: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard'
        },
        SubjectDistanceRange: {
            0: 'Unknown',
            1: 'Macro',
            2: 'Close view',
            3: 'Distant view'
        },
        FileSource: {
            3: 'DSC'
        },

        Components: {
            0: '',
            1: 'Y',
            2: 'Cb',
            3: 'Cr',
            4: 'R',
            5: 'G',
            6: 'B'
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }

    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = 'blob';
        http.onload = function (e) {
            if (this.status === 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            var iptcdata = findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }

        var fileReader = new FileReader();

        if (img.src) {

            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                fileReader.onload = function (e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            }
            var http = new XMLHttpRequest();
            http.onload = function () {
                if (this.status === 200 || this.status === 0) {
                    handleBinaryFile(http.response);
                } else {
                    throw 'Could not load image';
                }
                http = null;
            };
            http.open('GET', img.src, true);
            http.responseType = 'arraybuffer';
            try {
                http.send(null);
            } catch(e) {
            }
        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
            fileReader.onload = function (e) {
                if (debug) {
                    console.log('Got file of length ' + e.target.result.byteLength);
                }
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) {
            console.log('Got file of length ' + file.byteLength);
        }
        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
            if (debug) {
                console.log('Not a valid JPEG');
            }
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) !== 0xFF) {
                if (debug) {
                    console.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
                }
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) {
                console.log(marker);
            }

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker === 225) {
                if (debug) {
                    console.log('Found 0xFFE1 marker');
                }

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset + 2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) {
            console.log('Got file of length ' + file.byteLength);
        }
        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
            if (debug) {
                console.log('Not a valid JPEG');
            }
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;

        var isFieldSegmentStart = function (dataView, offset) {
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset + 1) === 0x42 &&
                dataView.getUint8(offset + 2) === 0x49 &&
                dataView.getUint8(offset + 3) === 0x4D &&
                dataView.getUint8(offset + 4) === 0x04 &&
                dataView.getUint8(offset + 5) === 0x04
            );
        };

        while (offset < length) {

            if (isFieldSegmentStart(dataView, offset)) {

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) {
                    nameHeaderLength += 1;
                }
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);
            }

            // Not the marker, continue searching
            offset++;

        }

    }

    var IptcFieldMap = {
        0x78: 'caption',
        0x6E: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7A: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0F: 'category'
    };

    function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        } else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    } else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }

    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) {
                console.log('Unknown tag: ' + file.getUint16(entryOffset, !bigEnd));
            }
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }

    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd),
            numValues = file.getUint32(entryOffset + 4, !bigEnd),
            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues === 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                }
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                vals = [];
                for (n = 0; n < numValues; n++) {
                    vals[n] = file.getUint8(offset + n);
                }
                return vals;

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues - 1);

            case 3: // short, 16 bit int
                if (numValues === 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                }
                offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                vals = [];
                for (n = 0; n < numValues; n++) {
                    vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                }
                return vals;

            case 4: // long, 32 bit int
                if (numValues === 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                }
                vals = [];
                for (n = 0; n < numValues; n++) {
                    vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                }
                return vals;

            case 5: // rational = two long values, first is numerator, second is denominator
                if (numValues === 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = {}; //@TODO need to inspect if this fix is really working
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                }
                vals = [];
                for (n = 0; n < numValues; n++) {
                    numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                    vals[n] = {}; //@TODO need to inspect if this fix is really working
                    vals[n].numerator = numerator;
                    vals[n].denominator = denominator;
                }
                return vals;

            case 9: // slong, 32 bit signed int
                if (numValues === 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                }
                vals = [];
                for (n = 0; n < numValues; n++) {
                    vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                }
                return vals;

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues === 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                }
                vals = [];
                for (n = 0; n < numValues; n++) {
                    vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                }
                return vals;
        }
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = '';
        for (var n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) !== 'Exif') {
            if (debug) {
                console.log('Not valid EXIF data! ' + getStringFromDB(file, start, 4));
            }
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) === 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) === 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) {
                console.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
            }
            return false;
        }

        if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
            if (debug) {
                console.log('Not valid TIFF data! (no 0x002A)');
            }
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) {
                console.log('Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd));
            }
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case 'LightSource':
                    case 'Flash':
                    case 'MeteringMode':
                    case 'ExposureProgram':
                    case 'SensingMethod':
                    case 'SceneCaptureType':
                    case 'SceneType':
                    case 'CustomRendered':
                    case 'WhiteBalance':
                    case 'GainControl':
                    case 'Contrast':
                    case 'Saturation':
                    case 'Sharpness':
                    case 'SubjectDistanceRange':
                    case 'FileSource':
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case 'ExifVersion':
                    case 'FlashpixVersion':
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case 'ComponentsConfiguration':
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case 'GPSVersionID':
                        gpsData[tag] = gpsData[tag][0] +
                            '.' + gpsData[tag][1] +
                            '.' + gpsData[tag][2] +
                            '.' + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        return tags;
    }

    this.getData = function (img, callback) {
        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) {
            return false;
        }

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    };

    this.getTag = function (img, tag) {
        if (!imageHasData(img)) {
            return;
        }
        return img.exifdata[tag];
    };

    this.getAllTags = function (img) {
        if (!imageHasData(img)) {
            return {};
        }
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };

    this.pretty = function (img) {
        if (!imageHasData(img)) {
            return '';
        }
        var a,
            data = img.exifdata,
            strPretty = '';
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] === 'object') {
                    if (data[a] instanceof Number) {
                        strPretty += a + ' : ' + data[a] + ' [' + data[a].numerator + '/' + data[a].denominator + ']\r\n';
                    } else {
                        strPretty += a + ' : [' + data[a].length + ' values]\r\n';
                    }
                } else {
                    strPretty += a + ' : ' + data[a] + '\r\n';
                }
            }
        }
        return strPretty;
    };

    this.readFromBinaryFile = function (file) {
        return findEXIFinJPEG(file);
    };
}]);

angular.module('uiCropper').factory('cropHost', ['$document', '$q', 'cropAreaCircle', 'cropAreaSquare', 'cropAreaRectangle', 'cropEXIF', function ($document, $q, CropAreaCircle, CropAreaSquare, CropAreaRectangle, cropEXIF) {
    /* STATIC FUNCTIONS */
    var colorPaletteLength = 8;
    
    // Get Element's Offset
    var getElementOffset = function (elem) {
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docElem = document.documentElement;

        var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

        var clientTop = docElem.clientTop || body.clientTop || 0;
        var clientLeft = docElem.clientLeft || body.clientLeft || 0;

        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return {
            top: Math.round(top),
            left: Math.round(left)
        };
    };

    return function (elCanvas, opts, events) {
        /* PRIVATE VARIABLES */

        // Object Pointers
        var ctx = null,
            image = null,
            theArea = null,
            initMax = null,
            isAspectRatio = null,
            self = this,

            // Dimensions
            minCanvasDims = [100, 100],
            maxCanvasDims = [300, 300],

            scalemode = null,

            // Result Image size
            resImgSizeArray = [],
            resImgSize = {
                w: 200,
                h: 200
            },
            areaMinRelativeSize = null,

            // Result Image type
            resImgFormat = 'image/png',

            // Result Image quality
            resImgQuality = null,

            forceAspectRatio = false;

        /* PRIVATE FUNCTIONS */
        this.setInitMax = function (bool) {
            initMax = bool;
        };
        this.setAllowCropResizeOnCorners = function (bool) {
            theArea.setAllowCropResizeOnCorners(bool);
        };
        // Draw Scene
        function drawScene() {
            // clear canvas
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

            if (image !== null) {
                // draw source image
                ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

                ctx.save();

                // and make it darker
                ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
                ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                ctx.restore();

                // draw Area
                theArea.draw();
            }
        }

        // Resets CropHost
        var resetCropHost = function () {
            if (image !== null) {
                theArea.setImage(image);
                var imageDims = [image.width, image.height],
                    imageRatio = image.width / image.height,
                    canvasDims = imageDims;

                if (canvasDims[0] > maxCanvasDims[0]) {
                    canvasDims[0] = maxCanvasDims[0];
                    canvasDims[1] = canvasDims[0] / imageRatio;
                } else if (canvasDims[0] < minCanvasDims[0]) {
                    canvasDims[0] = minCanvasDims[0];
                    canvasDims[1] = canvasDims[0] / imageRatio;
                }
                if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                    canvasDims[1] = maxCanvasDims[1];
                    canvasDims[0] = canvasDims[1] * imageRatio;
                } else if (canvasDims[1] < minCanvasDims[1]) {
                    canvasDims[1] = minCanvasDims[1];
                    canvasDims[0] = canvasDims[1] * imageRatio;
                }
                elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);
                if (scalemode === 'fixed-height') {
                    elCanvas.css({
                        'margin-left': -canvasDims[0] / 2 + 'px',
                        'margin-top': -canvasDims[1] / 2 + 'px'
                    });
                }

                var cw = ctx.canvas.width;
                var ch = ctx.canvas.height;

                var areaType = self.getAreaType();
                // enforce 1:1 aspect ratio for square-like selections
                if ((areaType === 'circle') || (areaType === 'square')) {
                    if (ch < cw) {
                        cw = ch;
                    }
                    ch = cw;
                } else if (areaType === 'rectangle' && isAspectRatio) {
                    var aspectRatio = theArea.getAspect(); // use `aspectRatio` instead of `resImgSize` dimensions bc `resImgSize` can be 'selection' string
                    if (cw / ch > aspectRatio) {
                        cw = aspectRatio * ch;
                    } else {
                        ch = aspectRatio * cw;
                    }
                }

                if (initMax) {
                    theArea.setSize({
                        w: cw,
                        h: ch
                    });
                } else if (undefined !== theArea.getInitSize()) {
                    theArea.setSize({
                        w: Math.min(theArea.getInitSize().w, cw / 2),
                        h: Math.min(theArea.getInitSize().h, ch / 2)
                    });
                } else {
                    theArea.setSize({
                        w: Math.min(200, cw / 2),
                        h: Math.min(200, ch / 2)
                    });
                }

                if (theArea.getInitCoords()) {
                    if (self.areaInitIsRelativeToImage) {
                        var ratio = image.width / canvasDims[0];
                        theArea.setSize({
                            w: theArea.getInitSize().w / ratio,
                            h: theArea.getInitSize().h / ratio,
                            x: theArea.getInitCoords().x / ratio,
                            y: theArea.getInitCoords().y / ratio
                        });
                    } else {
                        theArea.setSize({
                            w: theArea.getSize().w,
                            h: theArea.getSize().h,
                            x: theArea.getInitCoords().x,
                            y: theArea.getInitCoords().y
                        });
                    }
                } else {
                    theArea.setCenterPoint({
                        x: ctx.canvas.width / 2,
                        y: ctx.canvas.height / 2
                    });
                }

            } else {
                elCanvas.prop('width', 0).prop('height', 0).css({
                    'margin-top': 0
                });
            }

            drawScene();
        };

        var getChangedTouches = function (event) {
            if (angular.isDefined(event.changedTouches)) {
                return event.changedTouches;
            } else {
                return event.originalEvent.changedTouches;
            }
        };

        var onMouseMove = function (e) {
            if (image !== null) {
                var offset = getElementOffset(ctx.canvas),
                    pageX, pageY;
                if (e.type === 'touchmove') {
                    pageX = getChangedTouches(e)[0].pageX;
                    pageY = getChangedTouches(e)[0].pageY;
                } else {
                    pageX = e.pageX;
                    pageY = e.pageY;
                }
                theArea.processMouseMove(pageX - offset.left, pageY - offset.top);
                drawScene();
            }
        };

        var onMouseDown = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (image !== null) {
                var offset = getElementOffset(ctx.canvas),
                    pageX, pageY;
                if (e.type === 'touchstart') {
                    pageX = getChangedTouches(e)[0].pageX;
                    pageY = getChangedTouches(e)[0].pageY;
                } else {
                    pageX = e.pageX;
                    pageY = e.pageY;
                }
                theArea.processMouseDown(pageX - offset.left, pageY - offset.top);
                drawScene();
            }
        };

        var onMouseUp = function (e) {
            if (image !== null) {
                var offset = getElementOffset(ctx.canvas),
                    pageX, pageY;
                if (e.type === 'touchend') {
                    pageX = getChangedTouches(e)[0].pageX;
                    pageY = getChangedTouches(e)[0].pageY;
                } else {
                    pageX = e.pageX;
                    pageY = e.pageY;
                }
                theArea.processMouseUp(pageX - offset.left, pageY - offset.top);
                drawScene();
            }
        };

        var renderTempCanvas = function (ris, center) {
            var temp_ctx, temp_canvas;
            temp_canvas = angular.element('<canvas></canvas>')[0];
            temp_ctx = temp_canvas.getContext('2d');
            temp_canvas.width = ris.w;
            temp_canvas.height = ris.h;
            if (image !== null) {
                var x = (center.x - theArea.getSize().w / 2) * (image.width / ctx.canvas.width),
                    y = (center.y - theArea.getSize().h / 2) * (image.height / ctx.canvas.height),
                    areaWidth = theArea.getSize().w * (image.width / ctx.canvas.width),
                    areaHeight = theArea.getSize().h * (image.height / ctx.canvas.height);

                if (forceAspectRatio) {
                    temp_ctx.drawImage(image, x, y,
                        areaWidth,
                        areaHeight,
                        0,
                        0,
                        ris.w,
                        ris.h);
                } else {
                    var aspectRatio = areaWidth / areaHeight;
                    var resultHeight, resultWidth;

                    if (aspectRatio > 1) {
                        resultWidth = ris.w;
                        resultHeight = resultWidth / aspectRatio;
                    } else {
                        resultHeight = ris.h;
                        resultWidth = resultHeight * aspectRatio;
                    }

                    temp_canvas.width = resultWidth;
                    temp_canvas.height = resultHeight;

                    temp_ctx.drawImage(image,
                        x,
                        y,
                        areaWidth,
                        areaHeight,
                        0,
                        0,
                        Math.round(resultWidth),
                        Math.round(resultHeight));
                }

            }
            return temp_canvas;

        };

        var renderImageToDataURL = function (getResultImageSize) {
            var temp_canvas,
                retObj = {
                    dataURI: null,
                    imageData: null
                };
            temp_canvas = renderTempCanvas(getResultImageSize, theArea.getCenterPoint());
            if (image !== null) {
                if (resImgQuality !== null) {
                    retObj.dataURI = temp_canvas.toDataURL(resImgFormat, resImgQuality);
                } else {
                    retObj.dataURI = temp_canvas.toDataURL(resImgFormat);
                }
            }
            return retObj;
        };

        this.getResultImage = function () {
            if (resImgSizeArray.length === 0) {
                return renderImageToDataURL(this.getResultImageSize());
            }

            var arrayResultImages = [];
            for (var i = 0; i < resImgSizeArray.length; i++) {
                arrayResultImages.push({
                    dataURI: renderImageToDataURL(resImgSizeArray[i]).dataURI,
                    w: resImgSizeArray[i].w,
                    h: resImgSizeArray[i].h
                });
            }

            return arrayResultImages;
        };

        this.getResultImageDataBlob = function () {
            var temp_canvas,
                _p = $q.defer();
            temp_canvas = renderTempCanvas(this.getResultImageSize(), theArea.getCenterPoint());
            if (resImgQuality !== null) {
                temp_canvas.toBlob(function (blob) {
                    _p.resolve(blob);
                }, resImgFormat, resImgQuality);
            } else {
                temp_canvas.toBlob(function (blob) {
                    _p.resolve(blob);
                }, resImgFormat);
            }

            return _p.promise;
        };

        this.getAreaCoords = function () {
            return theArea.getSize();
        };

        this.getArea = function () {
            return theArea;
        };

        this.setNewImageSource = function (imageSource) {
            image = null;
            resetCropHost();
            if (imageSource) {
                var newImage = new Image();
                newImage.onload = function () {
                    events.trigger('load-done');

                    cropEXIF.getData(newImage, function () {
                        var orientation = cropEXIF.getTag(newImage, 'Orientation');

                        if ([3, 6, 8].indexOf(orientation) > -1) {
                            var canvas = document.createElement('canvas'),
                                ctx = canvas.getContext('2d'),
                                cw = newImage.width,
                                ch = newImage.height,
                                cx = 0,
                                cy = 0,
                                deg = 0,
                                rw = 0,
                                rh = 0;
                            rw = cw;
                            rh = ch;
                            switch (orientation) {
                                case 3:
                                    cx = -newImage.width;
                                    cy = -newImage.height;
                                    deg = 180;
                                    break;
                                case 6:
                                    cw = newImage.height;
                                    ch = newImage.width;
                                    cy = -newImage.height;
                                    rw = ch;
                                    rh = cw;
                                    deg = 90;
                                    break;
                                case 8:
                                    cw = newImage.height;
                                    ch = newImage.width;
                                    cx = -newImage.width;
                                    rw = ch;
                                    rh = cw;
                                    deg = 270;
                                    break;
                            }

                            //// canvas.toDataURL will only work if the canvas isn't too large. Resize to 1000px.
                            var maxWorH = 1000;
                            if (cw > maxWorH || ch > maxWorH) {
                                var p = 0;
                                if (cw > maxWorH) {
                                    p = (maxWorH) / cw;
                                    cw = maxWorH;
                                    ch = p * ch;
                                } else if (ch > maxWorH) {
                                    p = (maxWorH) / ch;
                                    ch = maxWorH;
                                    cw = p * cw;
                                }

                                cy = p * cy;
                                cx = p * cx;
                                rw = p * rw;
                                rh = p * rh;
                            }

                            canvas.width = cw;
                            canvas.height = ch;
                            ctx.rotate(deg * Math.PI / 180);
                            ctx.drawImage(newImage, cx, cy, rw, rh);

                            image = new Image();
                            image.onload = function () {
                                resetCropHost();
                                events.trigger('image-updated');
                            };

                            image.src = canvas.toDataURL(resImgFormat);
                        } else {
                            image = newImage;
                            events.trigger('image-updated');
                        }
                        resetCropHost();
                    });
                };
                newImage.onerror = function () {
                    events.trigger('load-error');
                };
                events.trigger('load-start');
                if (imageSource instanceof window.Blob) {
                    newImage.src = URL.createObjectURL(imageSource);
                } else {
                    if (imageSource.substring(0, 4).toLowerCase() === 'http' || imageSource.substring(0, 2) === '//') {
                        newImage.crossOrigin = 'anonymous';
                    }
                    newImage.src = imageSource;
                }
            }
        };

        this.setMaxDimensions = function (width, height) {
            maxCanvasDims = [width, height];

            if (image !== null) {
                var curWidth = ctx.canvas.width,
                    curHeight = ctx.canvas.height;

                var imageDims = [image.width, image.height],
                    imageRatio = image.width / image.height,
                    canvasDims = imageDims;

                if (canvasDims[0] > maxCanvasDims[0]) {
                    canvasDims[0] = maxCanvasDims[0];
                    canvasDims[1] = canvasDims[0] / imageRatio;
                } else if (canvasDims[0] < minCanvasDims[0]) {
                    canvasDims[0] = minCanvasDims[0];
                    canvasDims[1] = canvasDims[0] / imageRatio;
                }
                if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                    canvasDims[1] = maxCanvasDims[1];
                    canvasDims[0] = canvasDims[1] * imageRatio;
                } else if (canvasDims[1] < minCanvasDims[1]) {
                    canvasDims[1] = minCanvasDims[1];
                    canvasDims[0] = canvasDims[1] * imageRatio;
                }
                elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);

                if (scalemode === 'fixed-height') {
                    elCanvas.css({
                        'margin-left': -canvasDims[0] / 2 + 'px',
                        'margin-top': -canvasDims[1] / 2 + 'px'
                    });
                }

                var ratioNewCurWidth = ctx.canvas.width / curWidth,
                    ratioNewCurHeight = ctx.canvas.height / curHeight,
                    ratioMin = Math.min(ratioNewCurWidth, ratioNewCurHeight);

                //TODO: use top left corner point
                var center = theArea.getCenterPoint();
                theArea.setSize({
                    w: theArea.getSize().w * ratioMin,
                    h: theArea.getSize().h * ratioMin
                });
                theArea.setCenterPoint({
                    x: center.x * ratioNewCurWidth,
                    y: center.y * ratioNewCurHeight
                });

            } else {
                elCanvas.prop('width', 0).prop('height', 0).css({
                    'margin-top': 0
                });
            }

            drawScene();

        };

        this.setAreaMinSize = function (size) {
            if (angular.isUndefined(size)) {
                return;
            } else if (typeof size === 'number' || typeof size === 'string') {
                size = {
                    w: parseInt(parseInt(size), 10),
                    h: parseInt(parseInt(size), 10)
                };
            } else {
                size = {
                    w: parseInt(size.w, 10),
                    h: parseInt(size.h, 10)
                };
            }
            if (!isNaN(size.w) && !isNaN(size.h)) {
                theArea.setMinSize(size);
                drawScene();
            }
        };

        this.setAreaMinRelativeSize = function (size) {
            if (image === null || angular.isUndefined(size)) {
                return;
            }

            var canvasSize = theArea.getCanvasSize();

            if (typeof size === 'number' || typeof size === 'string') {
                areaMinRelativeSize = {
                    w: size,
                    h: size
                };
                size = {
                    w: canvasSize.w / (image.width / parseInt(parseInt(size), 10)),
                    h: canvasSize.h / (image.height / parseInt(parseInt(size), 10))
                };
            } else {
                areaMinRelativeSize = size;
                size = {
                    w: canvasSize.w / (image.width / parseInt(parseInt(size.w), 10)),
                    h: canvasSize.h / (image.height / parseInt(parseInt(size.h), 10))
                };
            }

            if (!isNaN(size.w) && !isNaN(size.h)) {
                theArea.setMinSize(size);
                drawScene();
            }
        };

        this.setAreaInitSize = function (size) {
            if (angular.isUndefined(size)) {
                return;
            } else if (typeof size === 'number' || typeof size === 'string') {
                size = {
                    w: parseInt(parseInt(size), 10),
                    h: parseInt(parseInt(size), 10)
                };
            } else {
                size = {
                    w: parseInt(size.w, 10),
                    h: parseInt(size.h, 10)
                };
            }
            if (!isNaN(size.w) && !isNaN(size.h)) {
                theArea.setInitSize(size);
                drawScene();
            }
        };

        this.setAreaInitCoords = function (coords) {
            if (angular.isUndefined(coords)) {
                return;
            } else {
                coords = {
                    x: parseInt(coords.x, 10),
                    y: parseInt(coords.y, 10)
                };
            }
            if (!isNaN(coords.x) && !isNaN(coords.y)) {
                theArea.setInitCoords(coords);
                drawScene();
            }
        };

        this.setMaxCanvasDimensions = function (maxCanvasDimensions) {
            if (!angular.isUndefined(maxCanvasDimensions)) {
                var newMaxCanvasDims = [];
                if (typeof maxCanvasDimensions === 'number' || typeof maxCanvasDimensions === 'string') {
                    newMaxCanvasDims = [
                        parseInt(parseInt(maxCanvasDimensions), 10),
                        parseInt(parseInt(maxCanvasDimensions), 10)
                    ];
                } else {
                    newMaxCanvasDims = [
                        parseInt(maxCanvasDimensions.w, 10),
                        parseInt(maxCanvasDimensions.h, 10)
                    ];
                }
                if ((!isNaN(newMaxCanvasDims[0]) &&
                    newMaxCanvasDims[0] > 0 &&
                    newMaxCanvasDims[0] > minCanvasDims[0]) &&
                    (!isNaN(newMaxCanvasDims[1]) &&
                    newMaxCanvasDims[1] > 0 &&
                    newMaxCanvasDims[1] > minCanvasDims[1])) {
                    maxCanvasDims = newMaxCanvasDims;
                }
            }
        };

        this.setMinCanvasDimensions = function (minCanvasDimensions) {
            if (!angular.isUndefined(minCanvasDimensions)) {
                var newMinCanvasDims = [];
                if (typeof minCanvasDimensions === 'number' || typeof minCanvasDimensions === 'string') {
                    newMinCanvasDims = [
                        parseInt(parseInt(minCanvasDimensions), 10),
                        parseInt(parseInt(minCanvasDimensions), 10)
                    ];
                } else {
                    newMinCanvasDims = [
                        parseInt(minCanvasDimensions.w, 10),
                        parseInt(minCanvasDimensions.h, 10)
                    ];
                }
                if ((!isNaN(newMinCanvasDims[0]) &&
                    newMinCanvasDims[0] >= 0) &&
                    (!isNaN(newMinCanvasDims[1]) &&
                    newMinCanvasDims[1] >= 0)) {
                    minCanvasDims = newMinCanvasDims;
                }
            }
        };

        this.setScalemode = function (value) {
            scalemode = value;
        };

        this.getScalemode = function () {
            return scalemode;
        };

        this.getResultImageSize = function () {
            if (resImgSize === 'selection') {
                return theArea.getSize();
            }

            if (resImgSize === 'max') {
                // We maximize the rendered size
                var zoom = 1;
                if (image && ctx && ctx.canvas) {
                    zoom = image.width / ctx.canvas.width;
                }
                var size = {
                    w: zoom * theArea.getSize().w,
                    h: zoom * theArea.getSize().h
                };

                if (areaMinRelativeSize) {
                    if (size.w < areaMinRelativeSize.w) {
                        size.w = areaMinRelativeSize.w;
                    }
                    if (size.h < areaMinRelativeSize.h) {
                        size.h = areaMinRelativeSize.h;
                    }
                }

                return size;
            }

            return resImgSize;
        };

        this.setResultImageSize = function (size) {
            if (angular.isArray(size)) {
                resImgSizeArray = size.slice();
                size = {
                    w: parseInt(size[0].w, 10),
                    h: parseInt(size[0].h, 10)
                };
                return;
            }
            if (angular.isUndefined(size)) {
                return;
            }
            //allow setting of size to "selection" for mirroring selection's dimensions
            if (angular.isString(size)) {
                resImgSize = size;
                return;
            }
            //allow scalar values for square-like selection shapes
            if (angular.isNumber(size)) {
                size = parseInt(size, 10);
                size = {
                    w: size,
                    h: size
                };
            }
            size = {
                w: parseInt(size.w, 10),
                h: parseInt(size.h, 10)
            };
            if (!isNaN(size.w) && !isNaN(size.h)) {
                resImgSize = size;
                drawScene();
            }
        };

        this.setResultImageFormat = function (format) {
            resImgFormat = format;
        };

        this.setResultImageQuality = function (quality) {
            quality = parseFloat(quality);
            if (!isNaN(quality) && quality >= 0 && quality <= 1) {
                resImgQuality = quality;
            }
        };

        // returns a string of the selection area's type
        this.getAreaType = function () {
            return theArea.getType();
        };

        this.setAreaType = function (type) {
            var center = theArea.getCenterPoint();
            var curSize = theArea.getSize(),
                curMinSize = theArea.getMinSize(),
                curX = center.x,
                curY = center.y;

            var AreaClass = CropAreaCircle;
            if (type === 'square') {
                AreaClass = CropAreaSquare;
            } else if (type === 'rectangle') {
                AreaClass = CropAreaRectangle;
            }
            theArea = new AreaClass(ctx, events);
            theArea.setMinSize(curMinSize);
            theArea.setSize(curSize);
            if (type === 'square' || type === 'circle') {
                forceAspectRatio = true;
                theArea.setForceAspectRatio(true);
            } else {
                forceAspectRatio = false;
                theArea.setForceAspectRatio(false);
            }

            //TODO: use top left point
            theArea.setCenterPoint({
                x: curX,
                y: curY
            });

            // resetCropHost();
            if (image !== null) {
                theArea.setImage(image);
            }

            drawScene();
        };

        this.getDominantColor = function (uri) {
            var imageDC = new Image(),
                colorThief = new ColorThief(),
                dominantColor = null,
                _p = $q.defer();
            imageDC.src = uri;
            imageDC.onload = function () {
                dominantColor = colorThief.getColor(imageDC);
                _p.resolve(dominantColor);
            };

            return _p.promise;
        };

        this.getPalette = function (uri) {
            var imageDC = new Image(),
                colorThief = new ColorThief(),
                palette = null,
                _p = $q.defer();
            imageDC.src = uri;
            imageDC.onload = function () {
                palette = colorThief.getPalette(imageDC, colorPaletteLength);
                _p.resolve(palette);
            };

            return _p.promise;
        };

        this.setPaletteColorLength = function (lg) {
            colorPaletteLength = lg;
        };

        this.setAspect = function (aspect) {
            isAspectRatio = true;
            theArea.setAspect(aspect);
            var minSize = theArea.getMinSize();
            minSize.w = minSize.h * aspect;
            theArea.setMinSize(minSize);
            var size = theArea.getSize();
            size.w = size.h * aspect;
            theArea.setSize(size);
        };

        /* Life Cycle begins */

        // Init Context var
        ctx = elCanvas[0].getContext('2d');

        // Init CropArea
        theArea = new CropAreaCircle(ctx, events);

        // Init Mouse Event Listeners
        $document.on('mousemove', onMouseMove);
        elCanvas.on('mousedown', onMouseDown);
        $document.on('mouseup', onMouseUp);

        // Init Touch Event Listeners
        $document.on('touchmove', onMouseMove);
        elCanvas.on('touchstart', onMouseDown);
        $document.on('touchend', onMouseUp);

        // CropHost Destructor
        this.destroy = function () {
            $document.off('mousemove', onMouseMove);
            elCanvas.off('mousedown', onMouseDown);
            $document.off('mouseup', onMouseUp);

            $document.off('touchmove', onMouseMove);
            elCanvas.off('touchstart', onMouseDown);
            $document.off('touchend', onMouseUp);

            elCanvas.remove();
        };
    };
}]);

angular.module('uiCropper').factory('cropPubSub', [function() {
    return function() {
        var events = {};
        // Subscribe
        this.on = function(names, handler) {
            names.split(' ').forEach(function(name) {
                if (!events[name]) {
                    events[name] = [];
                }
                events[name].push(handler);
            });
            return this;
        };
        // Publish
        this.trigger = function(name, args) {
            angular.forEach(events[name], function(handler) {
                handler.call(null, args);
            });
            return this;
        };
    };
}]);

angular.module('uiCropper').directive('uiCropper', ['$timeout', 'cropHost', 'cropPubSub', function ($timeout, CropHost, CropPubSub) {
    return {
        restrict: 'E',
        scope: {
            image: '=',
            resultImage: '=',
            resultArrayImage: '=?',
            resultBlob: '=?',
            urlBlob: '=?',
            chargement: '=?',
            cropject: '=?',
            maxCanvasDimensions: '=?',
            minCanvasDimensions: '=?',
            canvasScalemode: '@?', /* String. If set to 'full-width' the directive uses all width available */
            /* and the canvas expands in height as much as it need to maintain the aspect ratio */
            /* if set to 'fixed-height', the directive is restricted by a parent element in height */

            changeOnFly: '=?',
            liveView: '=?',
            initMaxArea: '=?',
            areaCoords: '=?',
            areaType: '@',
            areaMinSize: '=?',
            areaInitSize: '=?',
            areaInitCoords: '=?',
            areaInitIsRelativeToImage: '=?', /* Boolean: If true the areaInitCoords and areaInitSize is scaled according to canvas size. */
            /* No matter how big/small the canvas is, the resultImage remains the same */
            /* Example: areaInitCoords are {x: 100, y: 100}, areaInitSize {w: 100, h: 100}   */
            /* Image is 1000x1000
             /* if canvas is 500x500 Crop coordinates will be x: 50, y: 50, w: 50, h: 50 */
            /* if canvas is 100x100 crop coordinates will be x: 10, y: 10, w: 10, h: 10 */
            areaMinRelativeSize: '=?',
            resultImageSize: '=?',
            resultImageFormat: '@',
            resultImageQuality: '=?',

            aspectRatio: '=?',
            allowCropResizeOnCorners: '=?',

            dominantColor: '=?',
            paletteColor: '=?',
            paletteColorLength: '=?',

            onChange: '&',
            onLoadBegin: '&',
            onLoadDone: '&',
            onLoadError: '&'
        },
        template: '<canvas></canvas>',
        controller: ['$scope', function ($scope) {
            $scope.events = new CropPubSub();
        }],
        link: function (scope, element) {
            // Init Events Manager
            var events = scope.events;

            // Init Crop Host
            var cropHost = new CropHost(element.find('canvas'), {}, events);

            if (scope.canvasScalemode) {
                cropHost.setScalemode(scope.canvasScalemode);
            } else {
                cropHost.setScalemode('fixed-height');
            }

            element.addClass(cropHost.getScalemode());

            // Store Result Image to check if it's changed
            var storedResultImage;

            var updateAreaCoords = function (scope) {
                scope.areaCoords = cropHost.getAreaCoords();
            };

            var updateResultImage = function (scope, force, callback) {
                if (scope.image !== '' && (!scope.liveView.block || force)) {
                    var resultImageObj = cropHost.getResultImage();
                    var resultImage;
                    if (angular.isArray(resultImageObj)) {
                        resultImage = resultImageObj[0].dataURI;
                        scope.resultArrayImage = resultImageObj;
                    } else {
                        resultImage = resultImageObj.dataURI;
                    }

                    var urlCreator = window.URL || window.webkitURL;
                    if (storedResultImage !== resultImage) {
                        storedResultImage = resultImage;
                        scope.resultImage = resultImage;
                        if (scope.liveView.callback) {
                            scope.liveView.callback(resultImage);
                        }
                        if (callback) {
                            callback(resultImage);
                        }
                        cropHost.getResultImageDataBlob().then(function (blob) {
                            scope.resultBlob = blob;
                            scope.urlBlob = urlCreator.createObjectURL(blob);
                        });

                        if (scope.resultImage) {
                            cropHost.getDominantColor(scope.resultImage).then(function (dominantColor) {
                                scope.dominantColor = dominantColor;
                            });
                            cropHost.getPalette(scope.resultImage).then(function (palette) {
                                scope.paletteColor = palette;
                            });
                        }

                        updateAreaCoords(scope);
                        scope.onChange({
                            $dataURI: scope.resultImage
                        });
                    }
                }
            };

            if (scope.liveView && typeof scope.liveView.block === 'boolean') {
                scope.liveView.render = function (callback) {
                    updateResultImage(scope, true, callback);
                };
            } else {
                scope.liveView = {block: false};
            }

            var updateCropject = function (scope) {
                var areaCoords = cropHost.getAreaCoords();

                var dimRatio = {
                    x: cropHost.getArea().getImage().width / cropHost.getArea().getCanvasSize().w,
                    y: cropHost.getArea().getImage().height / cropHost.getArea().getCanvasSize().h
                };

                scope.cropject = {
                    canvasSize: cropHost.getArea().getCanvasSize(),
                    areaCoords: areaCoords,
                    cropWidth: areaCoords.w,
                    cropHeight: areaCoords.h,
                    cropTop: areaCoords.y,
                    cropLeft: areaCoords.x,
                    cropImageWidth: Math.round(areaCoords.w * dimRatio.x),
                    cropImageHeight: Math.round(areaCoords.h * dimRatio.y),
                    cropImageTop: Math.round(areaCoords.y * dimRatio.y),
                    cropImageLeft: Math.round(areaCoords.x * dimRatio.x)
                };
            };

            // Wrapper to safely exec functions within $apply on a running $digest cycle
            var fnSafeApply = function (fn) {
                return function () {
                    $timeout(function () {
                        scope.$apply(function (scope) {
                            fn(scope);
                        });
                    });
                };
            };

            // Will get the users language settings, and return the appropriate loading text
            var printLoadMsg = function () {
                var language = window.navigator.userLanguage || window.navigator.language;

                switch (language) {
                    case 'nl':
                    case 'nl_NL':
                        return 'Aan het laden';

                    case 'fr':
                    case 'fr-FR':
                        return 'Chargement';

                    case 'es':
                    case 'es-ES':
                        return 'Cargando';

                    case 'ca':
                    case 'ca-ES':
                        return 'Càrrega';

                    case 'de':
                    case 'de-DE':
                        return 'Laden';
                        
                    case 'pt':
                    case 'pt-BR':
                        return 'Carregando';

                    default:
                        return 'Loading';
                }
            };

            if (!scope.chargement) {
                scope.chargement = printLoadMsg();
            }
            var displayLoading = function () {
                element.append('<div class="loading"><span>' + scope.chargement + '...</span></div>');
            };

            // Setup CropHost Event Handlers
            events
                .on('load-start', fnSafeApply(function (scope) {
                    scope.onLoadBegin({});
                }))
                .on('load-done', fnSafeApply(function (scope) {
                    var children = element.children();
                    angular.forEach(children, function (child) {
                        if (angular.element(child).hasClass('loading')) {
                            angular.element(child).remove();
                        }
                    });
                    updateCropject(scope);
                    scope.onLoadDone({});
                }))
                .on('load-error', fnSafeApply(function (scope) {
                    scope.onLoadError({});
                }))
                .on('area-move area-resize', fnSafeApply(function (scope) {
                    if (scope.changeOnFly === true) {
                        updateResultImage(scope);
                    }
                    updateCropject(scope);
                }))
                .on('image-updated', fnSafeApply(function (scope) {
                    cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                }))
                .on('area-move-end area-resize-end image-updated', fnSafeApply(function (scope) {
                    updateResultImage(scope);
                    updateCropject(scope);
                }));

            // Sync CropHost with Directive's options
            scope.$watch('image', function (newVal) {
                if (newVal) {
                    displayLoading();
                }
                // cancel timeout if necessary
                if (scope.timeout !== null) {
                    $timeout.cancel(scope.timeout);
                }
                scope.timeout = $timeout(function () {
                    scope.timeout = null;
                    cropHost.setInitMax(scope.initMaxArea);
                    cropHost.setNewImageSource(scope.image);
                }, 100);
            });
            scope.$watch('areaType', function () {
                cropHost.setAreaType(scope.areaType);
                updateResultImage(scope);
            });
            scope.$watch('areaMinSize', function () {
                cropHost.setAreaMinSize(scope.areaMinSize);
                updateResultImage(scope);
            });
            scope.$watch('areaMinRelativeSize', function () {
                if (scope.image !== '') {
                    cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                    updateResultImage(scope);
                }
            });
            scope.$watch('areaInitSize', function () {
                cropHost.setAreaInitSize(scope.areaInitSize);
                updateResultImage(scope);
            });
            scope.$watch('areaInitCoords', function () {
                cropHost.setAreaInitCoords(scope.areaInitCoords);
                cropHost.areaInitIsRelativeToImage = scope.areaInitIsRelativeToImage;
                updateResultImage(scope);
            });
            scope.$watch('maxCanvasDimensions', function () {
                cropHost.setMaxCanvasDimensions(scope.maxCanvasDimensions);
            });
            scope.$watch('minCanvasDimensions', function () {
                cropHost.setMinCanvasDimensions(scope.minCanvasDimensions);
            });
            scope.$watch('resultImageFormat', function () {
                cropHost.setResultImageFormat(scope.resultImageFormat);
                updateResultImage(scope);
            });
            scope.$watch('resultImageQuality', function () {
                cropHost.setResultImageQuality(scope.resultImageQuality);
                updateResultImage(scope);
            });
            scope.$watch('resultImageSize', function () {
                cropHost.setResultImageSize(scope.resultImageSize);
                updateResultImage(scope);
            });
            scope.$watch('paletteColorLength', function () {
                cropHost.setPaletteColorLength(scope.paletteColorLength);
            });
            scope.$watch('aspectRatio', function () {
                if (typeof scope.aspectRatio === 'string' && scope.aspectRatio !== '') {
                    scope.aspectRatio = parseInt(scope.aspectRatio);
                }
                if (scope.aspectRatio) {
                    cropHost.setAspect(scope.aspectRatio);
                }
            });
            scope.$watch('allowCropResizeOnCorners', function () {
                if (scope.allowCropResizeOnCorners) {
                    cropHost.setAllowCropResizeOnCorners(scope.allowCropResizeOnCorners);
                }
            });

            // Update CropHost dimensions when the directive element is resized
            scope.$watch(
                function () {
                    if (cropHost.getScalemode() === 'fixed-height') {
                        return [element[0].clientWidth, element[0].clientHeight];
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        return element[0].clientWidth;
                    }
                },
                function (value) {

                    if (cropHost.getScalemode() === 'fixed-height') {
                        if (value[0] > 0 && value[1] > 0) {
                            cropHost.setMaxDimensions(value[0], value[1]);
                            updateResultImage(scope);
                        }
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        if (value > 0) {
                            cropHost.setMaxDimensions(value);
                        }
                    }
                },
                true
            );

            // Destroy CropHost Instance when the directive is destroying
            scope.$on('$destroy', function () {
                cropHost.destroy();
            });
        }
    };
}]);

}());

/* canvas-toBlob.js
 * A canvas.toBlob() implementation.
 * 2013-12-27
 * 
 * By Eli Grey, http://eligrey.com and Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See https://github.com/eligrey/canvas-toBlob.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/canvas-toBlob.js/blob/master/canvas-toBlob.js */

(function(view) {
    "use strict";
    var
        Uint8Array = view.Uint8Array,
        HTMLCanvasElement = view.HTMLCanvasElement,
        canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype,
        is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i,
        to_data_url = "toDataURL",
        base64_ranks, decode_base64 = function(base64) {
            var
                len = base64.length,
                buffer = new Uint8Array(len / 4 * 3 | 0),
                i = 0,
                outptr = 0,
                last = [0, 0],
                state = 0,
                save = 0,
                rank, code, undef;
            while (len--) {
                code = base64.charCodeAt(i++);
                rank = base64_ranks[code - 43];
                if (rank !== 255 && rank !== undef) {
                    last[1] = last[0];
                    last[0] = code;
                    save = (save << 6) | rank;
                    state++;
                    if (state === 4) {
                        buffer[outptr++] = save >>> 16;
                        if (last[1] !== 61 /* padding character */ ) {
                            buffer[outptr++] = save >>> 8;
                        }
                        if (last[0] !== 61 /* padding character */ ) {
                            buffer[outptr++] = save;
                        }
                        state = 0;
                    }
                }
            }
            // 2/3 chance there's going to be some null bytes at the end, but that
            // doesn't really matter with most image formats.
            // If it somehow matters for you, truncate the buffer up outptr.
            return buffer;
        };
    if (Uint8Array) {
        base64_ranks = new Uint8Array([
            62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51
        ]);
    }
    if (HTMLCanvasElement && !canvas_proto.toBlob) {
        canvas_proto.toBlob = function(callback, type /*, ...args*/ ) {
            if (!type) {
                type = "image/png";
            }
            if (this.mozGetAsFile) {
                callback(this.mozGetAsFile("canvas", type));
                return;
            }
            if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
                callback(this.msToBlob());
                return;
            }

            var
                args = Array.prototype.slice.call(arguments, 1),
                dataURI = this[to_data_url].apply(this, args),
                header_end = dataURI.indexOf(","),
                data = dataURI.substring(header_end + 1),
                is_base64 = is_base64_regex.test(dataURI.substring(0, header_end)),
                blob;
            if (Blob.fake) {
                // no reason to decode a data: URI that's just going to become a data URI again
                blob = new Blob
                if (is_base64) {
                    blob.encoding = "base64";
                } else {
                    blob.encoding = "URI";
                }
                blob.data = data;
                blob.size = data.length;
            } else if (Uint8Array) {
                if (is_base64) {
                    blob = new Blob([decode_base64(data)], {
                        type: type
                    });
                } else {
                    blob = new Blob([decodeURIComponent(data)], {
                        type: type
                    });
                }
            }
            if (typeof callback !== 'undefined') {
                callback(blob);
            }
        };

        if (canvas_proto.toDataURLHD) {
            canvas_proto.toBlobHD = function() {
                to_data_url = "toDataURLHD";
                var blob = this.toBlob();
                to_data_url = "toDataURL";
                return blob;
            }
        } else {
            canvas_proto.toBlobHD = canvas_proto.toBlob;
        }
    }
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));


/*!
 * Color Thief v2.0
 * by Lokesh Dhakar - http://www.lokeshdhakar.com
 *
 * Thanks
 * ------
 * Nick Rabinowitz - For creating quantize.js.
 * John Schulz - For clean up and optimization. @JFSIII
 * Nathan Spady - For adding drag and drop support to the demo page.
 *
 * License
 * -------
 * Copyright 2011, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
 *
 */
(function() {
    /*!
     * Color Thief v2.0
     * by Lokesh Dhakar - http://www.lokeshdhakar.com
     *
     * Thanks
     * ------
     * Nick Rabinowitz - For creating quantize.js.
     * John Schulz - For clean up and optimization. @JFSIII
     * Nathan Spady - For adding drag and drop support to the demo page.
     *
     * License
     * -------
     * Copyright 2011, 2015 Lokesh Dhakar
     * Released under the MIT license
     * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
     *
     */

    /*
      CanvasImage Class
      Class that wraps the html image element and canvas.
      It also simplifies some of the canvas context manipulation
      with a set of helper functions.
    */
    var CanvasImage = function(image) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');

        document.body.appendChild(this.canvas);

        this.width = this.canvas.width = image.width;
        this.height = this.canvas.height = image.height;

        this.context.drawImage(image, 0, 0, this.width, this.height);
    };

    CanvasImage.prototype.clear = function() {
        this.context.clearRect(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.update = function(imageData) {
        this.context.putImageData(imageData, 0, 0);
    };

    CanvasImage.prototype.getPixelCount = function() {
        return this.width * this.height;
    };

    CanvasImage.prototype.getImageData = function() {
        return this.context.getImageData(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.removeCanvas = function() {
        this.canvas.parentNode.removeChild(this.canvas);
    };

    var ColorThief = function() {};
    window.ColorThief = ColorThief;

    /*
     * getColor(sourceImage[, quality])
     * returns {r: num, g: num, b: num}
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar
     * colors and return the base color from the largest cluster.
     *
     * Quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster a color will be returned but the greater the likelihood that it will not be the visually
     * most dominant color.
     *
     * */
    ColorThief.prototype.getColor = function(sourceImage, quality) {
        var palette = this.getPalette(sourceImage, 5, quality);
        var dominantColor = palette[0];
        return dominantColor;
    };

    /*
     * getPalette(sourceImage[, colorCount, quality])
     * returns array[ {r: num, g: num, b: num}, {r: num, g: num, b: num}, ...]
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar colors.
     *
     * colorCount determines the size of the palette; the number of colors returned. If not set, it
     * defaults to 10.
     *
     * BUGGY: Function does not always return the requested amount of colors. It can be +/- 2.
     *
     * quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster the palette generation but the greater the likelihood that colors will be missed.
     *
     *
     */
    ColorThief.prototype.getPalette = function(sourceImage, colorCount, quality) {

        if (typeof colorCount === 'undefined') {
            colorCount = 10;
        }
        if (typeof quality === 'undefined' || quality < 1) {
            quality = 10;
        }

        // Create custom CanvasImage object
        var image = new CanvasImage(sourceImage);
        var imageData = image.getImageData();
        var pixels = imageData.data;
        var pixelCount = image.getPixelCount();

        // Store the RGB values in an array format suitable for quantize function
        var pixelArray = [];
        for (var i = 0, offset, r, g, b, a; i < pixelCount; i = i + quality) {
            offset = i * 4;
            r = pixels[offset + 0];
            g = pixels[offset + 1];
            b = pixels[offset + 2];
            a = pixels[offset + 3];
            // If pixel is mostly opaque and not white
            if (a >= 125) {
                if (!(r > 250 && g > 250 && b > 250)) {
                    pixelArray.push([r, g, b]);
                }
            }
        }

        // Send array to quantize function which clusters values
        // using median cut algorithm
        var cmap = MMCQ.quantize(pixelArray, colorCount);
        var palette = cmap ? cmap.palette() : null;

        // Clean up
        image.removeCanvas();

        return palette;
    };

    /*!
     * quantize.js Copyright 2008 Nick Rabinowitz.
     * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
     */

    // fill out a couple protovis dependencies
    /*!
     * Block below copied from Protovis: http://mbostock.github.com/protovis/
     * Copyright 2010 Stanford Visualization Group
     * Licensed under the BSD License: http://www.opensource.org/licenses/bsd-license.php
     */
    if (!pv) {
        var pv = {
            map: function(array, f) {
                var o = {};
                return f ? array.map(function(d, i) {
                    o.index = i;
                    return f.call(o, d);
                }) : array.slice();
            },
            naturalOrder: function(a, b) {
                return (a < b) ? -1 : ((a > b) ? 1 : 0);
            },
            sum: function(array, f) {
                var o = {};
                return array.reduce(f ? function(p, d, i) {
                    o.index = i;
                    return p + f.call(o, d);
                } : function(p, d) {
                    return p + d;
                }, 0);
            },
            max: function(array, f) {
                return Math.max.apply(null, f ? pv.map(array, f) : array);
            }
        };
    }

    /**
     * Basic Javascript port of the MMCQ (modified median cut quantization)
     * algorithm from the Leptonica library (http://www.leptonica.com/).
     * Returns a color map you can use to map original pixels to the reduced
     * palette. Still a work in progress.
     *
     * @author Nick Rabinowitz
     * @example

    // array of pixels as [R,G,B] arrays
    var myPixels = [[190,197,190], [202,204,200], [207,214,210], [211,214,211], [205,207,207]
                    // etc
                    ];
    var maxColors = 4;

    var cmap = MMCQ.quantize(myPixels, maxColors);
    var newPalette = cmap.palette();
    var newPixels = myPixels.map(function(p) {
        return cmap.map(p);
    });

     */
    var MMCQ = (function() {
        // private constants
        var sigbits = 5,
            rshift = 8 - sigbits,
            maxIterations = 1000,
            fractByPopulations = 0.75;

        // get reduced-space color index for a pixel
        function getColorIndex(r, g, b) {
            return (r << (2 * sigbits)) + (g << sigbits) + b;
        }

        // Simple priority queue
        function PQueue(comparator) {
            var contents = [],
                sorted = false;

            function sort() {
                contents.sort(comparator);
                sorted = true;
            }

            return {
                push: function(o) {
                    contents.push(o);
                    sorted = false;
                },
                peek: function(index) {
                    if (!sorted) sort();
                    if (index === undefined) index = contents.length - 1;
                    return contents[index];
                },
                pop: function() {
                    if (!sorted) sort();
                    return contents.pop();
                },
                size: function() {
                    return contents.length;
                },
                map: function(f) {
                    return contents.map(f);
                },
                debug: function() {
                    if (!sorted) sort();
                    return contents;
                }
            };
        }

        // 3d color space box
        function VBox(r1, r2, g1, g2, b1, b2, histo) {
            var vbox = this;
            vbox.r1 = r1;
            vbox.r2 = r2;
            vbox.g1 = g1;
            vbox.g2 = g2;
            vbox.b1 = b1;
            vbox.b2 = b2;
            vbox.histo = histo;
        }
        VBox.prototype = {
            volume: function(force) {
                var vbox = this;
                if (!vbox._volume || force) {
                    vbox._volume = ((vbox.r2 - vbox.r1 + 1) * (vbox.g2 - vbox.g1 + 1) * (vbox.b2 - vbox.b1 + 1));
                }
                return vbox._volume;
            },
            count: function(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._count_set || force) {
                    var npix = 0,
                        i, j, k;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                var index = getColorIndex(i, j, k);
                                npix += (histo[index] || 0);
                            }
                        }
                    }
                    vbox._count = npix;
                    vbox._count_set = true;
                }
                return vbox._count;
            },
            copy: function() {
                var vbox = this;
                return new VBox(vbox.r1, vbox.r2, vbox.g1, vbox.g2, vbox.b1, vbox.b2, vbox.histo);
            },
            avg: function(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._avg || force) {
                    var ntot = 0,
                        mult = 1 << (8 - sigbits),
                        rsum = 0,
                        gsum = 0,
                        bsum = 0,
                        hval,
                        i, j, k, histoindex;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                histoindex = getColorIndex(i, j, k);
                                hval = histo[histoindex] || 0;
                                ntot += hval;
                                rsum += (hval * (i + 0.5) * mult);
                                gsum += (hval * (j + 0.5) * mult);
                                bsum += (hval * (k + 0.5) * mult);
                            }
                        }
                    }
                    if (ntot) {
                        vbox._avg = [~~(rsum / ntot), ~~(gsum / ntot), ~~(bsum / ntot)];
                    } else {
                        //                    console.log('empty box');
                        vbox._avg = [~~(mult * (vbox.r1 + vbox.r2 + 1) / 2), ~~(mult * (vbox.g1 + vbox.g2 + 1) / 2), ~~(mult * (vbox.b1 + vbox.b2 + 1) / 2)];
                    }
                }
                return vbox._avg;
            },
            contains: function(pixel) {
                var vbox = this,
                    rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                return (rval >= vbox.r1 && rval <= vbox.r2 &&
                    gval >= vbox.g1 && gval <= vbox.g2 &&
                    bval >= vbox.b1 && bval <= vbox.b2);
            }
        };

        // Color map
        function CMap() {
            this.vboxes = new PQueue(function(a, b) {
                return pv.naturalOrder(
                    a.vbox.count() * a.vbox.volume(),
                    b.vbox.count() * b.vbox.volume()
                );
            });
        }
        CMap.prototype = {
            push: function(vbox) {
                this.vboxes.push({
                    vbox: vbox,
                    color: vbox.avg()
                });
            },
            palette: function() {
                return this.vboxes.map(function(vb) {
                    return vb.color;
                });
            },
            size: function() {
                return this.vboxes.size();
            },
            map: function(color) {
                var vboxes = this.vboxes;
                for (var i = 0; i < vboxes.size(); i++) {
                    if (vboxes.peek(i).vbox.contains(color)) {
                        return vboxes.peek(i).color;
                    }
                }
                return this.nearest(color);
            },
            nearest: function(color) {
                var vboxes = this.vboxes,
                    d1, d2, pColor;
                for (var i = 0; i < vboxes.size(); i++) {
                    d2 = Math.sqrt(
                        Math.pow(color[0] - vboxes.peek(i).color[0], 2) +
                        Math.pow(color[1] - vboxes.peek(i).color[1], 2) +
                        Math.pow(color[2] - vboxes.peek(i).color[2], 2)
                    );
                    if (d2 < d1 || d1 === undefined) {
                        d1 = d2;
                        pColor = vboxes.peek(i).color;
                    }
                }
                return pColor;
            },
            forcebw: function() {
                // XXX: won't  work yet
                var vboxes = this.vboxes;
                vboxes.sort(function(a, b) {
                    return pv.naturalOrder(pv.sum(a.color), pv.sum(b.color));
                });

                // force darkest color to black if everything < 5
                var lowest = vboxes[0].color;
                if (lowest[0] < 5 && lowest[1] < 5 && lowest[2] < 5)
                    vboxes[0].color = [0, 0, 0];

                // force lightest color to white if everything > 251
                var idx = vboxes.length - 1,
                    highest = vboxes[idx].color;
                if (highest[0] > 251 && highest[1] > 251 && highest[2] > 251)
                    vboxes[idx].color = [255, 255, 255];
            }
        };

        // histo (1-d array, giving the number of pixels in
        // each quantized region of color space), or null on error
        function getHisto(pixels) {
            var histosize = 1 << (3 * sigbits),
                histo = new Array(histosize),
                index, rval, gval, bval;
            pixels.forEach(function(pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                index = getColorIndex(rval, gval, bval);
                histo[index] = (histo[index] || 0) + 1;
            });
            return histo;
        }

        function vboxFromPixels(pixels, histo) {
            var rmin = 1000000,
                rmax = 0,
                gmin = 1000000,
                gmax = 0,
                bmin = 1000000,
                bmax = 0,
                rval, gval, bval;
            // find min/max
            pixels.forEach(function(pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                if (rval < rmin) rmin = rval;
                else if (rval > rmax) rmax = rval;
                if (gval < gmin) gmin = gval;
                else if (gval > gmax) gmax = gval;
                if (bval < bmin) bmin = bval;
                else if (bval > bmax) bmax = bval;
            });
            return new VBox(rmin, rmax, gmin, gmax, bmin, bmax, histo);
        }

        function medianCutApply(histo, vbox) {
            if (!vbox.count()) return;

            var rw = vbox.r2 - vbox.r1 + 1,
                gw = vbox.g2 - vbox.g1 + 1,
                bw = vbox.b2 - vbox.b1 + 1,
                maxw = pv.max([rw, gw, bw]);
            // only one pixel, no split
            if (vbox.count() == 1) {
                return [vbox.copy()];
            }
            /* Find the partial sum arrays along the selected axis. */
            var total = 0,
                partialsum = [],
                lookaheadsum = [],
                i, j, k, sum, index;
            if (maxw == rw) {
                for (i = vbox.r1; i <= vbox.r2; i++) {
                    sum = 0;
                    for (j = vbox.g1; j <= vbox.g2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(i, j, k);
                            sum += (histo[index] || 0);
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else if (maxw == gw) {
                for (i = vbox.g1; i <= vbox.g2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(j, i, k);
                            sum += (histo[index] || 0);
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else { /* maxw == bw */
                for (i = vbox.b1; i <= vbox.b2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.g1; k <= vbox.g2; k++) {
                            index = getColorIndex(j, k, i);
                            sum += (histo[index] || 0);
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            }
            partialsum.forEach(function(d, i) {
                lookaheadsum[i] = total - d;
            });

            function doCut(color) {
                var dim1 = color + '1',
                    dim2 = color + '2',
                    left, right, vbox1, vbox2, d2, count2 = 0;
                for (i = vbox[dim1]; i <= vbox[dim2]; i++) {
                    if (partialsum[i] > total / 2) {
                        vbox1 = vbox.copy();
                        vbox2 = vbox.copy();
                        left = i - vbox[dim1];
                        right = vbox[dim2] - i;
                        if (left <= right)
                            d2 = Math.min(vbox[dim2] - 1, ~~(i + right / 2));
                        else d2 = Math.max(vbox[dim1], ~~(i - 1 - left / 2));
                        // avoid 0-count boxes
                        while (!partialsum[d2]) d2++;
                        count2 = lookaheadsum[d2];
                        while (!count2 && partialsum[d2 - 1]) count2 = lookaheadsum[--d2];
                        // set dimensions
                        vbox1[dim2] = d2;
                        vbox2[dim1] = vbox1[dim2] + 1;
                        //                    console.log('vbox counts:', vbox.count(), vbox1.count(), vbox2.count());
                        return [vbox1, vbox2];
                    }
                }

            }
            // determine the cut planes
            return maxw == rw ? doCut('r') :
                maxw == gw ? doCut('g') :
                doCut('b');
        }

        function quantize(pixels, maxcolors) {
            // short-circuit
            if (!pixels.length || maxcolors < 2 || maxcolors > 256) {
                //            console.log('wrong number of maxcolors');
                return false;
            }

            // XXX: check color content and convert to grayscale if insufficient

            var histo = getHisto(pixels),
                histosize = 1 << (3 * sigbits);

            // check that we aren't below maxcolors already
            var nColors = 0;
            histo.forEach(function() {
                nColors++;
            });
            if (nColors <= maxcolors) {
                // XXX: generate the new colors from the histo and return
            }

            // get the beginning vbox from the colors
            var vbox = vboxFromPixels(pixels, histo),
                pq = new PQueue(function(a, b) {
                    return pv.naturalOrder(a.count(), b.count());
                });
            pq.push(vbox);

            // inner function to do the iteration
            function iter(lh, target) {
                var ncolors = 1,
                    niters = 0,
                    vbox;
                while (niters < maxIterations) {
                    vbox = lh.pop();
                    if (!vbox.count()) { /* just put it back */
                        lh.push(vbox);
                        niters++;
                        continue;
                    }
                    // do the cut
                    var vboxes = medianCutApply(histo, vbox),
                        vbox1 = vboxes[0],
                        vbox2 = vboxes[1];

                    if (!vbox1) {
                        //                    console.log("vbox1 not defined; shouldn't happen!");
                        return;
                    }
                    lh.push(vbox1);
                    if (vbox2) { /* vbox2 can be null */
                        lh.push(vbox2);
                        ncolors++;
                    }
                    if (ncolors >= target) return;
                    if (niters++ > maxIterations) {
                        //                    console.log("infinite loop; perhaps too few pixels!");
                        return;
                    }
                }
            }

            // first set of colors, sorted by population
            iter(pq, fractByPopulations * maxcolors);

            // Re-sort by the product of pixel occupancy times the size in color space.
            var pq2 = new PQueue(function(a, b) {
                return pv.naturalOrder(a.count() * a.volume(), b.count() * b.volume());
            });
            while (pq.size()) {
                pq2.push(pq.pop());
            }

            // next set - generate the median cuts using the (npix * vol) sorting.
            iter(pq2, maxcolors - pq2.size());

            // calculate the actual colors
            var cmap = new CMap();
            while (pq2.size()) {
                cmap.push(pq2.pop());
            }

            return cmap;
        }

        return {
            quantize: quantize
        };
    })();

    /**
     * Export class to global
     */
    if (typeof define === 'function' && define.amd) {
        define([], function() {
            return ColorThief;
        }); // for AMD loader
    } else if (typeof exports === 'object') {
        module.exports = ColorThief; // for CommonJS
    } else {
        this.ColorThief = ColorThief;
    }
}.call(this));


/**
 * Mega pixel image rendering library for iOS6 Safari
 *
 * Fixes iOS6 Safari's image file rendering issue for large size image (over mega-pixel),
 * which causes unexpected subsampling when drawing it in canvas.
 * By using this library, you can safely render the image with proper stretching.
 *
 * Copyright (c) 2012 Shinichi Tomita <shinichi.tomita@gmail.com>
 * Released under the MIT license
 */
(function () {

    /**
     * Detect subsampling in loaded image.
     * In iOS, larger images than 2M pixels may be subsampled in rendering.
     */
    function detectSubsampling(img) {
        var iw = img.naturalWidth, ih = img.naturalHeight;
        if (iw * ih > 1024 * 1024) { // subsampling may happen over megapixel image
            var canvas = document.createElement('canvas');
            canvas.width = canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, -iw + 1, 0);
            // subsampled image becomes half smaller in rendering size.
            // check alpha channel value to confirm image is covering edge pixel or not.
            // if alpha value is 0 image is not covering, hence subsampled.
            return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
        } else {
            return false;
        }
    }

    /**
     * Detecting vertical squash in loaded image.
     * Fixes a bug which squash image vertically while drawing into canvas for some images.
     */
    function detectVerticalSquash(img, iw, ih) {
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = ih;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, 1, ih).data;
        // search image edge pixel position in case it is squashed vertically.
        var sy = 0;
        var ey = ih;
        var py = ih;
        while (py > sy) {
            var alpha = data[(py - 1) * 4 + 3];
            if (alpha === 0) {
                ey = py;
            } else {
                sy = py;
            }
            py = (ey + sy) >> 1;
        }
        var ratio = (py / ih);
        return (ratio === 0) ? 1 : ratio;
    }

    /**
     * Rendering image element (with resizing) and get its data URL
     */
    function renderImageToDataURL(img, options, doSquash) {
        var canvas = document.createElement('canvas');
        renderImageToCanvas(img, canvas, options, doSquash);
        return canvas.toDataURL('image/jpeg', options.quality || 0.8);
    }

    /**
     * Rendering image element (with resizing) into the canvas element
     */
    function renderImageToCanvas(img, canvas, options, doSquash) {
        var iw = img.naturalWidth, ih = img.naturalHeight;
        if ((iw + ih) === false) {
            return;
        }
        var width = options.width, height = options.height;
        var ctx = canvas.getContext('2d');
        ctx.save();
        transformCoordinate(canvas, ctx, width, height, options.orientation);
        var subsampled = detectSubsampling(img);
        if (subsampled) {
            iw /= 2;
            ih /= 2;
        }
        var d = 1024; // size of tiling canvas
        var tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = tmpCanvas.height = d;
        var tmpCtx = tmpCanvas.getContext('2d');
        var vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1;
        var dw = Math.ceil(d * width / iw);
        var dh = Math.ceil(d * height / ih / vertSquashRatio);
        var sy = 0;
        var dy = 0;
        while (sy < ih) {
            var sx = 0;
            var dx = 0;
            while (sx < iw) {
                tmpCtx.clearRect(0, 0, d, d);
                tmpCtx.drawImage(img, -sx, -sy);
                ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
                sx += d;
                dx += dw;
            }
            sy += d;
            dy += dh;
        }
        ctx.restore();
        tmpCanvas = tmpCtx = null;
    }

    /**
     * Transform canvas coordination according to specified frame size and orientation
     * Orientation value is from EXIF tag
     */
    function transformCoordinate(canvas, ctx, width, height, orientation) {
        switch (orientation) {
            case 5:
            case 6:
            case 7:
            case 8:
                canvas.width = height;
                canvas.height = width;
                break;
            default:
                canvas.width = width;
                canvas.height = height;
        }
        switch (orientation) {
            case 2:
                // horizontal flip
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                // 180 rotate left
                ctx.translate(width, height);
                ctx.rotate(Math.PI);
                break;
            case 4:
                // vertical flip
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                // vertical flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                // 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -height);
                break;
            case 7:
                // horizontal flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(width, -height);
                ctx.scale(-1, 1);
                break;
            case 8:
                // 90 rotate left
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-width, 0);
                break;
            default:
                break;
        }
    }

    var URL = window.URL && window.URL.createObjectURL ? window.URL :
        window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL :
            null;

    /**
     * MegaPixImage class
     */
    function MegaPixImage(srcImage) {
        if (window.Blob && srcImage instanceof Blob) {
            if (!URL) {
                throw Error('No createObjectURL function found to create blob url');
            }
            var img = new Image();
            img.src = URL.createObjectURL(srcImage);
            this.blob = srcImage;
            srcImage = img;
        }
        if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
            var _this = this;
            srcImage.onload = srcImage.onerror = function () {
                var listeners = _this.imageLoadListeners;
                if (listeners) {
                    _this.imageLoadListeners = null;
                    for (var i = 0, len = listeners.length; i < len; i++) {
                        listeners[i]();
                    }
                }
            };
            this.imageLoadListeners = [];
        }
        this.srcImage = srcImage;
    }

    /**
     * Rendering megapix image into specified target element
     */
    MegaPixImage.prototype.render = function (target, options, callback) {
        if (this.imageLoadListeners) {
            var _this = this;
            this.imageLoadListeners.push(function () {
                _this.render(target, options, callback);
            });
            return;
        }
        options = options || {};
        var imgWidth = this.srcImage.naturalWidth, imgHeight = this.srcImage.naturalHeight,
            width = options.width, height = options.height,
            maxWidth = options.maxWidth, maxHeight = options.maxHeight,
            doSquash = !this.blob || this.blob.type === 'image/jpeg';
        if (width && !height) {
            height = (imgHeight * width / imgWidth) << 0;
        } else if (height && !width) {
            width = (imgWidth * height / imgHeight) << 0;
        } else {
            width = imgWidth;
            height = imgHeight;
        }
        if (maxWidth && width > maxWidth) {
            width = maxWidth;
            height = (imgHeight * width / imgWidth) << 0;
        }
        if (maxHeight && height > maxHeight) {
            height = maxHeight;
            width = (imgWidth * height / imgHeight) << 0;
        }
        var opt = {width: width, height: height};
        for (var k in options) {
            opt[k] = options[k];
        }

        var tagName = target.tagName.toLowerCase();
        if (tagName === 'img') {
            target.src = renderImageToDataURL(this.srcImage, opt, doSquash);
        } else if (tagName === 'canvas') {
            renderImageToCanvas(this.srcImage, target, opt, doSquash);
        }
        if (typeof this.onrender === 'function') {
            this.onrender(target);
        }
        if (callback) {
            callback();
        }
        if (this.blob) {
            this.blob = null;
            URL.revokeObjectURL(this.srcImage.src);
        }
    };

    /**
     * Export class to global
     */
    if (typeof define === 'function' && define.amd) {
        define([], function () {
            return MegaPixImage;
        }); // for AMD loader
    } else if (typeof exports === 'object') {
        module.exports = MegaPixImage; // for CommonJS
    } else {
        this.MegaPixImage = MegaPixImage;
    }

}.call(this));
/**
 * Thomson Reuters Authenticator Web Component v4.0.4
 * @license Copyright 2017 Thomson Reuters. All rights reserved.
 * Must support IE9+, Chrome, Firefox, Safari
 * Minimal dependencies
 */
/**
 * Console-polyfill.
 * @license MIT license.
 * https://github.com/paulmillr/console-polyfill
 * Make it safe to do console.log() always.
 * 0.2.3
 */
(function(global) {
  'use strict';
  if (!global.console) {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function() {};
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
  while (method = methods.pop()) if (typeof con[method] !== 'function') con[method] = dummy;
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

/**
 * MDN CustomEvent polyfill IE9+
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

})();

/**
 * MDN Array.from polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 6, 22.1.2.1
// Reference: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

/**
 * classList.js: Cross-browser full element.classList implementation.
 * 2014-07-23
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/

if ("document" in self) {

// Full polyfill for browsers with no classList support
if (!("classList" in document.createElement("_"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
    classListProp = "classList"
  , protoProp = "prototype"
  , elemCtrProto = view.Element[protoProp]
  , objCtr = Object
  , strTrim = String[protoProp].trim || function () {
    return this.replace(/^\s+|\s+$/g, "");
  }
  , arrIndexOf = Array[protoProp].indexOf || function (item) {
    var
        i = 0
      , len = this.length
    ;
    for (; i < len; i++) {
      if (i in this && this[i] === item) {
        return i;
      }
    }
    return -1;
  }
  // Vendors: please allow content code to instantiate DOMExceptions
  , DOMEx = function (type, message) {
    this.name = type;
    this.code = DOMException[type];
    this.message = message;
  }
  , checkTokenAndGetIndex = function (classList, token) {
    if (token === "") {
      throw new DOMEx(
          "SYNTAX_ERR"
        , "An invalid or illegal string was specified"
      );
    }
    if (/\s/.test(token)) {
      throw new DOMEx(
          "INVALID_CHARACTER_ERR"
        , "String contains an invalid character"
      );
    }
    return arrIndexOf.call(classList, token);
  }
  , ClassList = function (elem) {
    var
        trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
      , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
      , i = 0
      , len = classes.length
    ;
    for (; i < len; i++) {
      this.push(classes[i]);
    }
    this._updateClassName = function () {
      elem.setAttribute("class", this.toString());
    };
  }
  , classListProto = ClassList[protoProp] = []
  , classListGetter = function () {
    return new ClassList(this);
  }
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
  return this[i] || null;
};
classListProto.contains = function (token) {
  token += "";
  return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
  ;
  do {
    token = tokens[i] + "";
    if (checkTokenAndGetIndex(this, token) === -1) {
      this.push(token);
      updated = true;
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.remove = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
    , index
  ;
  do {
    token = tokens[i] + "";
    index = checkTokenAndGetIndex(this, token);
    while (index !== -1) {
      this.splice(index, 1);
      updated = true;
      index = checkTokenAndGetIndex(this, token);
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.toggle = function (token, force) {
  token += "";

  var
      result = this.contains(token)
    , method = result ?
      force !== true && "remove"
    :
      force !== false && "add"
  ;

  if (method) {
    this[method](token);
  }

  if (force === true || force === false) {
    return force;
  } else {
    return !result;
  }
};
classListProto.toString = function () {
  return this.join(" ");
};

if (objCtr.defineProperty) {
  var classListPropDesc = {
      get: classListGetter
    , enumerable: true
    , configurable: true
  };
  try {
    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
  } catch (ex) { // IE 8 doesn't support enumerable:true
    if (ex.number === -0x7FF5EC54) {
      classListPropDesc.enumerable = false;
      objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
    }
  }
} else if (objCtr[protoProp].__defineGetter__) {
  elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(self));

} else {
// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
  "use strict";

  var testElement = document.createElement("_");

  testElement.classList.add("c1", "c2");

  // Polyfill for IE 10/11 and Firefox <26, where classList.add and
  // classList.remove exist but support only one argument at a time.
  if (!testElement.classList.contains("c2")) {
    var createMethod = function(method) {
      var original = DOMTokenList.prototype[method];

      DOMTokenList.prototype[method] = function(token) {
        var i, len = arguments.length;

        for (i = 0; i < len; i++) {
          token = arguments[i];
          original.call(this, token);
        }
      };
    };
    createMethod('add');
    createMethod('remove');
  }

  testElement.classList.toggle("c3", false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains("c3")) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function(token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };

  }

  testElement = null;
}());

}

}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

/**
 * MDN Element.matches() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
/**
 * MDN String trim polyfill
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/trim
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

/**
 * MDN Array.isArray polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

/**
 * MDN lastElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/lastElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("lastElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "lastElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = nodes.length - 1; i >= 0; --i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN firstElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/firstElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("firstElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "firstElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = 0, l = nodes.length; i < l; ++i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN previousElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/previousElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("previousElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "previousElementSibling", {
        get: function(){
            var e = this.previousSibling;
            while(e && 1 !== e.nodeType)
                e = e.previousSibling;
            return e;
        }
    });
}

/**
 * MDN nextElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/nextElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("nextElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "nextElementSibling", {
        get: function(){
            var e = this.nextSibling;
            while(e && 1 !== e.nodeType)
                e = e.nextSibling;
            return e;
        }
    });
}

/**
 * MDN Object.keys polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */

if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

/**
 * MDN Array forEach polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    var T, k;

    if (this === null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

/**
 * MDN addEventListener polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function() {
  if (!Event.prototype.preventDefault) {
    Event.prototype.preventDefault=function() {
      this.returnValue=false;
    };
  }
  if (!Event.prototype.stopPropagation) {
    Event.prototype.stopPropagation=function() {
      this.cancelBubble=true;
    };
  }
  if (!Element.prototype.addEventListener) {
    var eventListeners=[];

    var addEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var self=this;
      var wrapper=function(e) {
        e.target=e.srcElement;
        e.currentTarget=self;
        if (typeof listener.handleEvent != 'undefined') {
          listener.handleEvent(e);
        } else {
          listener.call(self,e);
        }
      };
      if (type=="DOMContentLoaded") {
        var wrapper2=function(e) {
          if (document.readyState=="complete") {
            wrapper(e);
          }
        };
        document.attachEvent("onreadystatechange",wrapper2);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper2});

        if (document.readyState=="complete") {
          var e=new Event();
          e.srcElement=window;
          wrapper2(e);
        }
      } else {
        this.attachEvent("on"+type,wrapper);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper});
      }
    };
    var removeEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var counter=0;
      while (counter<eventListeners.length) {
        var eventListener=eventListeners[counter];
        if (eventListener.object==this && eventListener.type==type && eventListener.listener==listener) {
          if (type=="DOMContentLoaded") {
            this.detachEvent("onreadystatechange",eventListener.wrapper);
          } else {
            this.detachEvent("on"+type,eventListener.wrapper);
          }
          eventListeners.splice(counter, 1);
          break;
        }
        ++counter;
      }
    };
    Element.prototype.addEventListener=addEventListener;
    Element.prototype.removeEventListener=removeEventListener;
    if (HTMLDocument) {
      HTMLDocument.prototype.addEventListener=addEventListener;
      HTMLDocument.prototype.removeEventListener=removeEventListener;
    }
    if (Window) {
      Window.prototype.addEventListener=addEventListener;
      Window.prototype.removeEventListener=removeEventListener;
    }
  }
})();
/*
 * underscore.template 0.1.7
 * Extracted template from Underscore, use '_.template' without full underscore source.
 * https://github.com/superRaytin/underscore.template
 *
 * Copyright 2015-present, Leon Shi
 * Released under the MIT license.
*/

!function e(r,n,t){function o(u,i){if(!n[u]){if(!r[u]){var c="function"==typeof require&&require;if(!i&&c)return c(u,!0);if(a)return a(u,!0);throw new Error("Cannot find module '"+u+"'")}var f=n[u]={exports:{}};r[u][0].call(f.exports,function(e){var n=r[u][1][e];return o(n?n:e)},f,f.exports,e,r,n,t)}return n[u].exports}for(var a="function"==typeof require&&require,u=0;u<t.length;u++)o(t[u]);return o}({1:[function(e,r,n){"use strict";function t(e,r,n){return a(e,r,n)}var o=e("./underscore.template"),a=o.template;t._=o,r.exports=t,"function"==typeof define&&define.amd?define(function(){return t}):("undefined"!=typeof window||"undefined"!=typeof navigator)&&(window.UnderscoreTemplate=t)},{"./underscore.template":2}],2:[function(e,r,n){"use strict";var t={},o=Array.prototype,a=Object.prototype,u=o.slice,i=a.toString,c=a.hasOwnProperty,f=o.forEach,l=Object.keys,s=Array.isArray,p=function(){},v=p.each=p.forEach=function(e,r,n){if(null!=e)if(f&&e.forEach===f)e.forEach(r,n);else if(e.length===+e.length){for(var o=0,a=e.length;a>o;o++)if(r.call(n,e[o],o,e)===t)return}else for(var u=p.keys(e),o=0,a=u.length;a>o;o++)if(r.call(n,e[u[o]],u[o],e)===t)return};p.keys=l||function(e){if(e!==Object(e))throw new TypeError("Invalid object");var r=[];for(var n in e)p.has(e,n)&&r.push(n);return r},p.defaults=function(e){return v(u.call(arguments,1),function(r){if(r)for(var n in r)void 0===e[n]&&(e[n]=r[n])}),e},p.isArray=s||function(e){return"[object Array]"===i.call(e)},p.has=function(e,r){if(!p.isArray(r))return null!=e&&c.call(e,r);for(var n=r.length,t=0;n>t;t++){var o=r[t];if(null==e||!c.call(e,o))return!1;e=e[o]}return!!n};var _={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}},h={escape:new RegExp("["+p.keys(_.escape).join("")+"]","g")};p.each(["escape"],function(e){p[e]=function(r){return null==r?"":(""+r).replace(h[e],function(r){return _[e][r]})}}),p.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var g=/(.)^/,y={"'":"'","\\":"\\","\r":"r","\n":"n","	":"t","\u2028":"u2028","\u2029":"u2029"},d=/\\|'|\r|\n|\t|\u2028|\u2029/g;p.template=function(e,r,n){var t;n=p.defaults({},n,p.templateSettings);var o=new RegExp([(n.escape||g).source,(n.interpolate||g).source,(n.evaluate||g).source].join("|")+"|$","g"),a=0,u="__p+='";e.replace(o,function(r,n,t,o,i){return u+=e.slice(a,i).replace(d,function(e){return"\\"+y[e]}),n&&(u+="'+\n((__t=("+n+"))==null?'':_.escape(__t))+\n'"),t&&(u+="'+\n((__t=("+t+"))==null?'':__t)+\n'"),o&&(u+="';\n"+o+"\n__p+='"),a=i+r.length,r}),u+="';\n",n.variable||(u="with(obj||{}){\n"+u+"}\n"),u="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+u+"return __p;\n";try{t=new Function(n.variable||"obj","_",u)}catch(i){throw i.source=u,i}if(r)return t(r,p);var c=function(e){return t.call(this,e,p)};return c.source="function("+(n.variable||"obj")+"){\n"+u+"}",c},r.exports=p},{}]},{},[1]);!function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a){this.message=a}function e(a){var b=String(a).replace(/=+$/,"");if(b.length%4==1)throw new d("'atob' failed: The string to be decoded is not correctly encoded.");for(var c,e,g=0,h=0,i="";e=b.charAt(h++);~e&&(c=g%4?64*c+e:e,g++%4)?i+=String.fromCharCode(255&c>>(-2*g&6)):0)e=f.indexOf(e);return i}var f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";d.prototype=new Error,d.prototype.name="InvalidCharacterError",b.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||e},{}],2:[function(a,b,c){function d(a){return decodeURIComponent(e(a).replace(/(.)/g,function(a,b){var c=b.charCodeAt(0).toString(16).toUpperCase();return c.length<2&&(c="0"+c),"%"+c}))}var e=a("./atob");b.exports=function(a){var b=a.replace(/-/g,"+").replace(/_/g,"/");switch(b.length%4){case 0:break;case 2:b+="==";break;case 3:b+="=";break;default:throw"Illegal base64url string!"}try{return d(b)}catch(c){return e(b)}}},{"./atob":1}],3:[function(a,b,c){"use strict";var d=a("./base64_url_decode");b.exports=function(a,b){if("string"!=typeof a)throw new Error("Invalid token specified");b=b||{};var c=b.header===!0?0:1;return JSON.parse(d(a.split(".")[c]))}},{"./base64_url_decode":2}],4:[function(a,b,c){(function(b){var c=a("./lib/index");"function"==typeof b.window.define&&b.window.define.amd?b.window.define("jwt_decode",function(){return c}):b.window&&(b.window.jwt_decode=c)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/index":3}]},{},[4]);/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(row), "y": String(col)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";			
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();
(function(window) {
  'use strict';

  var respHeaderParsePtn = /([^\r\n:]+):\s*([^\r\n]+)/g;
  var queryStrParsePtn = /([^=&]+)(?:=([^&]*))?/g;
  var intPtn = /^[1-9]\d*$/; // digits-only, not starting with 0
  var spacePtn = /^\s+$/;
  var insPosToTraversalMap = {
    beforebegin: 'previousElementSibling',
    afterbegin: 'firstElementChild',
    beforeend: 'lastElementChild',
    afterend: 'nextElementSibling',
  };

  var stateHistory;

  // variable height elem centering
  // use fieldset for component-wide disable support
  /* jshint multistr: true */
  var html = '\
    <fieldset id="trta1" class="tr-auth-dialog">\
      <div class="trta1-outer">\
        <!--img src="tr-logo.svg" class="trta1-logo trta1-print-only"-->\
        <div class="trta1-middle">\
          <div id="trta1-browsehappy">\
            <h1 t8>Thomson Reuters</h1>\
            <h2 t8>Your Browser is not supported</h2>\
            <p t8>To log in to Onvio, please use one of the supported internet browsers below.</p>\
            <ul>\
              <li id="trta1-chrome-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.chrome %>">Google Chrome</a></li>\
              <li id="trta1-firefox-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.firefox %>">Mozilla Firefox</a></li>\
              <li id="trta1-edge-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.edge %>">Microsoft Edge</a></li>\
              <li id="trta1-safari-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.safari %>">Apple Safari</a></li>\
            </ul>\
            <div class="trta1-btn-group">\
              <button t8 class="trta1-btn-primary trta1-outdated-browser-btn">Ignore warning</button>\
            </div>\
            <div class="trta1-icon-warning"></div>\
          </div>\
        </div>\
      </div>\
    </fieldset>\
  ';
  /* jshint multistr: false */

  /* translation fn */
  function getTranslateFn(locale) {
    locale = locale || 'en-US';
    return function(key) {
      var strings = window.trAuth.submodules.locales[locale];
      return (strings && strings[key.trim()]) || key.trim();
    };
  }

  function getRootElem() {
    // Document.getElementById will not select element in shadow dom
    if (window.trAuth.shadowDomElem) {
      return window.trAuth.shadowDomElem.querySelector('#trta1');
    }
    return document.getElementById('trta1');
  }

  /* Utils */

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function isTagType(elem, tagType) {
    return elem.tagName.toLowerCase() === tagType.toLowerCase();
  }

  // based on angular.js baseExtend
  function objAssignDeep(dst) {
    for (var i = 1, ii = arguments.length; i < ii; ++i) {
      var obj = arguments[i];
      if (!isObject(obj) && !Array.isArray(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];

        if (isObject(src)) {
          if (src.nodeName) {
            // don't deep clone dom nodes!
            dst[key] = src;
          } else {
            if (!isObject(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
            objAssignDeep(dst[key], src);
          }
        } else {
          dst[key] = src;
        }
      }
    }
    return dst;
  }

  function seekObjPath(name, context, create) {
    var i, segs = name.split('.'), len = segs.length, seg, last = context || window;
    for (i = 0; i < len; i++) {
      seg = segs[i];
      if(!isObject(last[seg]) && !(create && typeof last[seg] === 'undefined')) return null;
      last = last[seg] = last[seg] || {};
    }
    return last;
  }

  // careful since this uses innerHTML to render
  function openPrintWindow(content, title) {
    var w = window.open('', 'trta1-print-window');
    w.document.body.innerHTML = content;
    if (title) w.document.title = title;
    // IWebBrowser2 control might fail
    try {
      if (w.focus) w.focus();
      if (w.print) w.print();
    } catch(e) {}
  }

  var errorEventTypePattern = /^trta1-[^*]+-error$/;
  function trigger(type, detail, target) {
    var event = new CustomEvent(type, { bubbles: true, cancelable: true, detail: detail });
    target = target || getRootElem() || window;

    // dispatch to browser
    target.dispatchEvent(event);

    // trigger wildcard error
    if (errorEventTypePattern.test(type)) {
      trigger('trta1-*-error', detail, target);
    }

    // log special events
    if (type.indexOf('tr') === 0) {
      if (window.trAuth.debug) {
        window.console.log(type, event);
      }
    }
  }

  function extractFormData(form, overrides) {
    var name, nameMap = overrides.namedFieldMap,
      namedFields = form.querySelectorAll('input[name], button[name], select[name], textarea[name]');

    return Array.from(namedFields).reduce(function(obj, namedField) {
      if (namedField.hasAttribute('tr-nosend')) { return obj; } // skip sending these fields
      name = nameMap && nameMap[namedField.name] || namedField.name;
      if (namedField.hasAttribute('tr-noconvert')) { // don't run fromString
        obj[name] = namedField.value;
      } else {
        obj[name] = fromString(namedField.value);
      }
      return obj;
    }, {});
  }

  function toFormUrlEncoded(obj) {
    return Object.keys(obj).reduce(function(prev, key) {
      if (obj[key] != null) { // coerce undefined
        prev.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
      return prev;
    }, []).join('&').replace(/%20/g, '+');
  }

  function normalizeXhrResponse(xhr) {
    var headers = {}, contentType, data;

    if (xhr.getAllResponseHeaders)
      xhr.getAllResponseHeaders().replace(respHeaderParsePtn, function(pair, key, value) {
        headers[key.toLowerCase()] = value;
      });

    // if json, parse
    contentType = headers['content-type'];
    if (contentType && contentType.indexOf('application/json') === 0) {
      data = JSON.parse(xhr.responseText);
    } else {
      data = xhr.responseText;
    }

    return {
      // IE9 will sometimes return 1223 instead of 204, slege hammer it
      status: xhr.status === 1223 ? 204 : xhr.status,
      statusText: xhr.statusText,
      headers: headers,
      data: data
    };
  }

  // defensive get/set sugar for localStorage, mostly bc of this
  // https://kadoppe.com/archives/2013/04/ccleaner-ie-cookie-localstorage.html
  function store(key, value) {
    if (typeof value !== 'undefined') { // set
      try {
        return window.localStorage.setItem(key, value);
      } catch(e) {
        return undefined;
      }
    } else { // get
      try {
        return window.localStorage.getItem(key);
      } catch(e) {
        return null;
      }
    }
  }

  // does simple bool and int conversions e.g. 'true' -> true, '12' -> 12
  // assumes all field values should be trimmed of leading/trailing spaces
  function fromString(value) {
    if (typeof value !== 'string') return value;

    value = value.trim();
    if (value === 'true') value = true;
    else if (value === 'false') value = false;
    else if (intPtn.test(value)) {
      var num = parseInt(value, 10);
      if (!isNaN(num)) value = num;
    }
    return value;
  }

  function removeNodes(els) {
    if (!els || els.length === 0) return;
    if (typeof els.length === 'undefined') els.parentNode.removeChild(els);
    else Array.from(els).forEach(function(el) {
      el.parentNode.removeChild(el);
    });
  }

  function getFieldLabelTextNode(field) {
    // note: assumes label element contains field
    var label = closestTagName(field, 'label');
    if (!label) return null;
    var child = label.firstChild;
    while (child) {
      if (child.nodeType === 1) child = child.firstChild;
      if (child.nodeType === 3 && !spacePtn.test(child.nodeValue)) return child;
      child = child.nextSibling;
    }
  }

  function template(htmlTemplate, options) {
    return function(data) {
      return window.UnderscoreTemplate(htmlTemplate)(objAssignDeep({}, (options && options.templateData ? options.templateData : undefined), data));
    };
  }

  function walk(el, fn) {
    fn(el);
    el = el.firstElementChild;
    while(el) {
      walk(el, fn);
      el = el.nextElementSibling;
    }
  }

  function localizeElem(elem, $t) {
    walk(elem, function(el) {
      if (el.hasAttribute('t8')) {
        var title = el.getAttribute('title');
        var placeholder = el.getAttribute('placeholder');
        var ariaLabel = el.getAttribute('aria-label');

        if (title) {
          el.setAttribute('title', $t(title));
        }
        if (placeholder) {
          el.setAttribute('placeholder', $t(placeholder));
        }
        if (ariaLabel) {
          el.setAttribute('aria-label', $t(ariaLabel));
        }
        // note: since we are not using user supplied data we do not need to sanitize
        el.innerHTML = $t(el.innerHTML);
      }
    });
    return elem;
  }

  function toElem(htmlToEl) {
    var container = document.createElement('div');
    // note: since we are not using user supplied data we do not need to sanitize
    container.innerHTML = htmlToEl;
    return container.firstElementChild;
  }

  function renderTemplate(tmpl, data, target, position, locale) {
    var $t = getTranslateFn(locale);
    var htmlTemplate = (typeof tmpl === 'function') ? tmpl(objAssignDeep({}, data, { $t: $t, locale: locale })) : tmpl;
    var elem = toElem(htmlTemplate);
    var localizedElem = localizeElem(elem, $t);

    target = target || getRootElem().querySelector('.trta1-middle');
    position = position || 'beforeend';

    target.insertAdjacentElement(position, localizedElem);
    return target[insPosToTraversalMap[position]];
  }

  function loadScript(src) {
    var head = document.getElementsByTagName('head')[0],
      script = head.querySelector('script[src="' + src + '"]');

    // remove if found so we can get it to re-execute as some scripts need
    if (script) removeNodes(script);

    script = document.createElement('script');
    script.src = src;
    head.appendChild(script);
  }

  // exponential backoff in seconds
  function calcBackoff(attempts, min, max) {
    var delay = Math.round((1 / 2) * (Math.pow(2, attempts) - 1));
    min = min || 1; // 1s default min
    max = max || 300; // 5m default max
    return Math.min(max, Math.max(min, delay));
  }

  function requestTimeout(fn, delay) {
    var start = new Date().getTime(),
      handle = {};

    function loop(){
      var current = new Date().getTime(),
        delta = current - start;

      if (delta >= delay) {
        fn.call();
      } else {
        handle.value = window.requestAnimationFrame(loop);
      }
    }

    handle.value = window.requestAnimationFrame(loop);
    return handle;
  }

  function cancelRequestTimeout(handle) {
    window.cancelAnimationFrame(handle.value);
  }

  // delay and timeout in seconds
  function pollFormRequest(form, testFn, successFn, timeoutFn, errorFn, delay, timeout, leadingEdge, continueOnError) {
    var endTime = Number(new Date()) + (timeout || 40) * 1e3, // 40s default timeout
      typePrefix = (form.id || form.name) + '-',
      evtTypes = typePrefix + 'success ' + typePrefix + 'error',
      attempts = 0,
      adjustedDelay,
      timer,
      unlisten = listen(evtTypes, testResponse, form),
      cancelFn = function() {
        if (timer) {
          cancelRequestTimeout(timer);
          timer = null;
        }
        if (unlisten) {
          unlisten();
          unlisten = null;
        }
      };

    delay = delay || 2; // 2s default delay

    // prepare for possible trailing edge
    timer = requestTimeout(function() {
      // first attempt
      attempts++;
      trigger('submit', null, form);
    }, leadingEdge ? 0 : delay * 1e3);

    function testResponse(resp) {
      if (/-success$/.test(resp.type)) {
        if (testFn(resp)) { // if condition met, exit
          cancelFn();
          if (successFn) successFn(resp);
          return;
        }
        // success = no adjustment
        adjustedDelay = delay;
      } else { // error = exponentially backoff delay
        if (continueOnError !== true) {
          cancelFn();
          if (errorFn) errorFn(resp);
          return;
        }
        adjustedDelay = delay + calcBackoff(attempts);
      }
      if (Number(new Date()) < endTime) { // not timed out
        timer = requestTimeout(function() {
          attempts++;
          trigger('submit', null, form);
        }, adjustedDelay * 1e3);
      } else { // timed out
        cancelFn();
        if (timeoutFn) {
          // wait till next loop to get around async form request result firing after
          setTimeout(timeoutFn, 0, resp);
        }
        return;
      }
    }

    return cancelFn;
  }

  function makeFormRequest(form, options, successFn, errorFn, doneFn) {
    var overrides = options.formOverrides && options.formOverrides[form.name] || {};

    var method = overrides.method || form.getAttribute('method'),
      action = overrides.action || form.getAttribute('action');

    if (!method || !action) return;

    method = method.toUpperCase();

    var xhr = new XMLHttpRequest(),
      headers = objAssignDeep(
        {},
        options.headers,
        overrides.headers
      ),
      formData = objAssignDeep(
        { type: options.type, sp: options.sp },
        options.payload,
        overrides.payload,
        extractFormData(form, overrides)
      ),
      sendData, contentType;

    if (method === 'GET') {
      action += (action.indexOf('?') > -1 ? '&' : '?') + toFormUrlEncoded(formData);
    } else {
      contentType = headers['content-type'];

      if (contentType && contentType.indexOf('application/x-www-form-urlencoded') === 0) {
        sendData = toFormUrlEncoded(formData);
      } else { // detault to json
        sendData = JSON.stringify(formData);
      }
    }

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        var resp = normalizeXhrResponse(xhr);
        if (overrides.statusMap && overrides.statusMap[resp.status]) {
          resp.status = overrides.statusMap[resp.status];
        }

        var isSuccess = resp.status >= 200 && resp.status <= 299;

        if (!isSuccess) {
          // note: we redirect on status 4xx rather than 3xx so we can drive it
          // from the client-side component avoiding CORS
          var isRedirect = getPrimaryErrorReason(resp) === 'REDIRECT';
          var locationHdr = resp.headers.location;

          if (isRedirect && locationHdr) {
            // redirect and exit
            location.href = locationHdr;
            return;
          }

          // put this here so we can modify normalized response obj
          // note: this works and the handler fires on next cycle, go figure
          xhr.ontimeout = function() {
            resp.status = 500; // normally 0, making 500 to trigger offline mode in desktop
            resp.statusText = 'timeout';
          };
        }

        // allow ontimeout a chance to refine resp by deferring events till next cycle
        setTimeout(function() {
          form.trAuthLastResponse = resp;
          if (isSuccess) {
            if (successFn) successFn(resp);
          } else {
            if (errorFn) errorFn(resp);
          }
          if (doneFn) doneFn(resp);
        }, 0);
      }
    };

    updateFormState(form, 'processing', options);
    xhr.open(method, action);
    xhr.timeout = overrides.timeout || 60000; // 60s
    // set headers
    Object.keys(headers).forEach(function(key) {
      xhr.setRequestHeader(key, headers[key]);
    });
    try {
      xhr.send(sendData);
    } catch(e) {
      errorFn();
    }
  }

  function getSecondaryError(resp) {
    var secondary, secondaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      secondaries = resp.data.errors.filter(function(err) {
        return !err.primary;
      });
      // if not marked, assume the first error is the primary
      secondary = (secondaries && secondaries[0]) || resp.data.errors[0];
    }
    return secondary;
  }

  function getPrimaryError(resp) {
    var primary, primaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      primaries = resp.data.errors.filter(function(err) {
        return err.primary;
      });
      // if not marked, assume the first error is the primary
      primary = (primaries && primaries[0]) || resp.data.errors[0];
    }
    return primary;
  }

  function getPrimaryErrorReason(resp) {
    var reason, primary = getPrimaryError(resp);
    if (primary) {
      reason = primary.reason;
    } else if (resp.data && resp.data.error && typeof resp.data.error === 'string' && resp.data.error.split('_').length) {
      reason = resp.data.error;
    }
    return reason;
  }

  function getLastFormResp(form) {
    if (typeof form === 'string') {
      return document.forms[form].trAuthLastResponse;
    } else {
      return form.trAuthLastResponse;
    }
  }

  function getFormStateMsgs(form, options) {
    var formOverrideMsgs;
    // if there are overrides look them up
    if (options && options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].formStateMessages;
    }
    // get reason to message map
    return objAssignDeep({}, options.formStateMessages, formOverrideMsgs || {});
  }

  function getFormStateMessage(form, state, options, detail) {
    var msg, reason, msgs,
      dfault = 'default'; // get around ie8 keyword prob after min

    if (isObject(detail)) {
      // if we have more error detail, use it
      // otherwise, use statusText
      // otherwise, use status (HTTP/2)
      reason = getPrimaryErrorReason(detail) || detail.statusText.toLowerCase() || detail.status.toString();
    } else if (typeof detail === 'string') {
      reason = detail;
    } else {
      reason = dfault;
    }

    if (options) {
      msgs = getFormStateMsgs(form, options);

      /*eslint dot-notation: ["error", { "allowKeywords": false }]*/
      msg = msgs[state] && (msgs[state][reason] || msgs[state][dfault]);
    }
    return msg;
  }

  // html disable attrib at a form level doesn't work but it will at the root fieldset
  function toggleFormDisable(form, state) {
    var root = getRootElem();
    if (typeof state !== 'boolean') state = !root.disabled;
    root[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
  }

  function updateFormMsg(form, msg) {
      // safe way to avoid possible xss
      form.querySelector('.trta1-form-msg').textContent = msg;
  }

  // states: processing, success, error
  function updateFormState(form, state, options, detail) {
    var msg;

    // clear state classes
    form.classList.remove('trta1-processing', 'trta1-success', 'trta1-error');
    // remove error and validation msgs
    removeNodes(form.querySelectorAll('.trta1-form-msg, .trta1-validation-msg'));
    // clear disable or set for processing
    if (!form.classList.contains('trta1-nodisable')) {
      toggleFormDisable(form, state === 'processing');
    }

    // if default, return
    if (state === 'default') {
      form.classList.remove('trta1-submitted');
      return;
    }

    form.classList.add('trta1-' + state);
    msg = getFormStateMessage(form, state, options, detail);
    if (!form.classList.contains('trta1-not-display-success') || state !== "success") {
      if (msg) {
        if(!form.classList.contains('trta1-not-display-wait') || state !== 'processing' ){
          var msgContainer = document.createElement('div');
          msgContainer.classList.add('trta1-form-msg');
          form.insertAdjacentElement('afterbegin', msgContainer);
          updateFormMsg(form, msg);
        }
      }
    }

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-' + state, detail, form);

    // change form on state
    var gotoForm = form.getAttribute('tr-goto-on' + state);
    if (gotoForm) {
      changeForm(gotoForm, form.parentElement, detail);
    }
  }

  function exitForm(form, detail) {
    if (!form) return;

    updateFormState(form, 'default'); // reset form state
    // form.reset(); // clear fields
    form.classList.remove('trta1-active-form');
    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-exit', detail, form);
  }

  function changeForm(formName, context, detail) {
    var form, prevForm;

    if (!formName) return false;

    context = context || getRootElem();
    prevForm = context.querySelector('.trta1-active-form');

    // handle $pecial targets
    switch (formName) {
      case 'trta1-$back':
        formName = stateHistory[stateHistory.length - 2];
        break;
      case 'trta1-$start':
        formName = stateHistory[0];
        break;
      case 'trta1-$close':
        trigger('tr-dialog-user-closed', {form: prevForm.name});
        exitForm(prevForm, detail);
        destroy();
        return;
      case 'trta1-$retry':
        trigger('submit', null, prevForm);
        return;
    }

    // resolve form
    if (typeof formName === 'string') {
      form = context.querySelector('form[name=' + formName + ']');
    } else {
      form = formName;
    }
    if (!form) return false;

    // exit prev
    exitForm(prevForm, detail);

    form.classList.add('trta1-active-form');
    stateHistory.push(formName);

    focusFirstEnabledField(form, function(field) {
      // primary buttons only
      if (isTagType(field, 'button')) return field.classList.contains('trta1-btn-primary');
      // empty fields only
      return field.value.length === 0;
    });

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-enter', detail, form);

    // autosubmit
    if (form.getAttribute('tr-autosubmit') !== null) {
      trigger('submit', null, form);
    }

    return true;
  }

  function focusFirstEnabledField(context, filter) {
    var fields = context.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
    var filtered, field;

    if (!fields.length) return;

    field = fields[0];

    // give time for autofill to complete
    setTimeout(function() {
      // filter inside timeout in case you are filtering on value
      if (filter) {
        filtered = Array.from(fields).filter(filter);
        field = filtered[0];
      }
      if (!field) return;

      // if focus and/or select is available use it
      // sometimes it's available but IWebBrowser2 control fails
      try {
        if (field.focus) field.focus();
        if (field.select) field.select();
      } catch(e) {}
    }, 250);
  }

  function processOverrides(options, rootElem) {
    if (options.formOverrides) {
      Object.keys(options.formOverrides).forEach(function(formName) {
        var form = rootElem.querySelector('form[name=' + formName + ']'), overrides;
        if (!form) return;

        overrides = options.formOverrides[formName];
        overrides.payload = overrides.payload || {};

        // process values
        if (overrides.values) {
          Object.keys(overrides.values).forEach(function(fieldName) {
            var value = overrides.values[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].value = value;
          });
        }

        // process types
        if (overrides.types) {
          Object.keys(overrides.types).forEach(function(fieldName) {
            var value = overrides.types[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].type = value;
          });
        }

        // process labels
        if (overrides.labels) {
          Object.keys(overrides.labels).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            var value = overrides.labels[fieldName];
            // jshint eqnull:true
            if (!field || value == null) return;

            if (field.placeholder) field.placeholder = value;
            getFieldLabelTextNode(field).nodeValue = value;
          });
        }

        // process hide
        if (overrides.hide) {
          Object.keys(overrides.hide).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.hide[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');

            if (isTagType(field.parentElement, 'label')) {
              field = field.parentElement;
            }
            field.classList[overrides.hide[fieldName] ? 'add' : 'remove']('trta1-hide');
          });
        }

        // process disable
        if (overrides.disable) {
          Object.keys(overrides.disable).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.disable[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
          });
        }
      });
    }
  }

  // expects typical format from location.search, i.e. expects leading '?'
  // no complex types supported e.g. Object, Array
  function parseQueryStr(qStr) {
    var qObj = {};
    qStr.substring(1).replace(/\+/g, ' ').replace(queryStrParsePtn, function(pair, key, value) {
      qObj[decodeURIComponent(key)] = fromString(decodeURIComponent(value));
    });
    return qObj;
  }

  function getValidationState(field) {
    for (var state in field.validity) {
      if (field.validity[state] === true) return state;
    }
  }

  function getValidationMessage(form, field, options) {
    var formOverrideMsgs;
    if (options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].validationMessages;
    }
    var msgs = objAssignDeep({}, options.validationMessages, formOverrideMsgs);
    return msgs[getValidationState(field)] || field.validationMessage;
  }

  function clearFieldValidation(field, form) {
    removeNodes(form.querySelector('[name=' + field.name + '] + .trta1-validation-msg'));
  }

  function renderFieldValidation(field, form, options) {
    var msg, labelTextNode, labelText;
    var msgContainer = form.querySelector('[name=' + field.name + '] + .trta1-validation-msg');

    labelTextNode = getFieldLabelTextNode(field);
    labelText = labelTextNode && labelTextNode.nodeValue.trim() || 'This field';
    msg = getValidationMessage(form, field, options)
      .replace('{{label}}', labelText)
      .replace('{{title}}', field.title || options.state.$t('Invalid value entered.'));

    if (!msgContainer) {
      msgContainer = document.createElement('div');
      msgContainer.classList.add('trta1-validation-msg');
      field.insertAdjacentElement('afterend', msgContainer);
    }
    msgContainer.textContent = msg;
  }

  function validateForm(form, options) {
    if (!form.checkValidity) return true; // not supported, let server validate
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = form.checkValidity();

    // clear old msgs
    removeNodes(form.querySelectorAll('.trta1-validation-msg'));

    // if invalid, setup msgs
    if (!isValid) {
      Array.from(form.querySelectorAll('input:invalid, button:invalid, select:invalid, textarea:invalid')).forEach(function(field) {
        renderFieldValidation(field, form, options);
      });
    }

    return isValid;
  }

  function validateField(field, options) {
    if (!field.checkValidity) return true; // not supported, let server validate

    var form = closestTagName(field, 'form');
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = field.checkValidity();

    // if invalid, setup msgs
    if (!isValid) {
      renderFieldValidation(field, form, options);
    } else {
      clearFieldValidation(field, form);
    }

    return isValid;
  }

  function closestTagName(elem, tagName) {
    var parent = elem.parentElement;
    if (!parent) return null;
    if (isTagType(parent, tagName)) return parent;
    return closestTagName(parent, tagName);
  }

  function listen(types, fn, el, once) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.addEventListener(type, once ? function onceFn(evt) {
        unlisten(types, onceFn, el);
        fn.call(this, evt);
      } : fn, false);
    });
    return function() { unlisten(types, fn, el); };
  }

  function unlisten(types, fn, el) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.removeEventListener(type, fn, false);
    });
  }

  // here so IE8 parts are happy, since classList polyfill doesn't work
  function classListAdd(el, classes) {
    el.className += ' ' + classes;
  }

  var ieAgent = (function() {
    var msie = navigator.userAgent.match(/MSIE (\d+)/);
    var trident = navigator.userAgent.match(/Trident\/(\d+)/);
    var result = {
      ie: false,
      ver: 0,
      emul: 0,
      compat: false
    };

    if (msie) {
      result.ie = true;
      result.ver = result.emul = parseInt(msie[1], 10);
    }

    // IE8+ has the more accurate trident
    if (trident) {
      result.ie = true;
      result.ver = parseInt(trident[1], 10) + 4;
      result.emul = result.emul || result.ver;
    }

    result.compat = result.ver !== result.emul;

    return result;
  })();

  // note: only based on msie version for now
  function isBrowserSupported(options) {
    return !isUnsupportedBrowser(options);
  }
  function isOutdatedBrowser(options) {
    if (options.outdatedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsieWarn;
  }
  function isUnsupportedBrowser(options) {
    if (options.unsupportedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsie;
  }

  function inputPlaceholderIsSupported() {
    return 'placeholder' in document.createElement('input');
  }

  /* Setup */
  function moduleReady(context, options) {
    var h1 = context.querySelector('h1');
    if (options.title && h1) {
      h1.textContent = options.title;
    }

    processOverrides(options, context);

    // display start form from param or first named form
    // todo: remove deprecated startSection
    changeForm(options.startingForm || options.startSection || context.querySelector('form[name]'), context);
  }

  function getDefaultOptions(locale) {
    var browserDownloads = {
      'en-US': {
        edge: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
        chrome: 'https://www.google.com/chrome',
        firefox: 'https://www.mozilla.com/en-US/firefox/',
        safari: 'https://support.apple.com/downloads/#safari'
      },
      'es-AR': {
        edge: 'https://www.microsoft.com/es-ar/windows/microsoft-edge',
        chrome: 'https://www.google.com.mx/intl/es-419/chrome/browser/desktop/',
        firefox: 'https://www.mozilla.org/es-AR/firefox/',
        safari: 'https://www.apple.com/la/safari/'
      },
      'pt-BR': {
        edge: 'https://www.microsoft.com/pt-br/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/pt-BR/chrome/',
        firefox: 'https://www.mozilla.org/pt-BR/firefox/',
        safari: 'http://www.apple.com/br/safari/'
      },
      'fr-CA': {
        edge: 'https://www.microsoft.com/fr-ca/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/fr_ca/chrome/browser/',
        firefox: 'https://www.mozilla.org/fr/firefox/',
        safari: 'https://www.apple.com/ca/fr/safari/'
      },
      'en-GB': {
        edge: ' https://www.microsoft.com/en-gb/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_uk/chrome/browser/',
        firefox: 'https://www.mozilla.org/en-GB/firefox/',
        safari: 'https://www.apple.com/uk/safari/'
      },
      'en-AU': {
        edge: 'http://www.microsoft.com/en-au/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_au/chrome/browser/',
        firefox: 'https://www.mozilla.org/en-US/firefox/',
        safari: 'http://www.apple.com/au/safari/'
      },
      'en-BR': {
        edge: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en-BR/chrome/',
        firefox: 'https://www.mozilla.org/en-US/firefox/',
        safari: 'https://support.apple.com/downloads/#safari  '
      },
      'en-CA': {
        edge: 'https://www.microsoft.com/en-ca/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_ca/chrome/browser/',
        firefox: 'https://www.mozilla.com/en-CA/firefox/',
        safari: 'https://www.apple.com/ca/safari/'
      }
    }
    var browserLinks = browserDownloads[locale] || browserDownloads['en-US'];
    var $t = getTranslateFn(locale);
    return {
      minimumMsie: 11,
      minimumMsieWarn: 11,
      locale: 'en-US',
      headers: {
        'content-type': 'application/json;charset=utf-8',
        'accept': 'application/json'
      },
      formStateMessages: {
        'processing': {
          'default': $t('Please wait.')
        },
        'success': {
          'default': $t('Success!')
        },
        'error': {
          'default': $t('An unexpected error occurred. Please try again.'),
          /* Custom service error reasons */
          // this redirect error should not show up unless something went wrong
          'REDIRECT': $t('An unexpected error occurred while redirecting your request.'),
          /* Custom client-side keys */
          'timeout': $t('The server did not respond in time. Please try again.'),
          /* Http statusText.toLowerCase() for AWS since it lowercases response
             as well as status codes for HTTP/2 since it is missing statusText */
          'bad request': $t('An error occurred with your request. Please try again.'),
          '400': $t('An error occurred with your request. Please try again.'),
        }
      },
      // ValidityState keys
      validationMessages: {
        // 'badInput': '',
        // 'customError': '',
        'patternMismatch': '{{title}}',
        // 'rangeOverflow': '',
        // 'rangeUnderflow': '',
        // 'stepMismatch': '',
        // 'tooLong': '',
        'typeMismatch': $t('Please provide a valid {{label}}.'),
        'valueMissing': $t('{{label}} is required.')
      },
      templateData: { browserLinks: browserLinks },
      state: {
        $t: $t,
        exitCode: 1 // unixy exit code: 0 success, !0 fail; default to fail
      }
    };
  }

  function init(options) {
    destroy();

    var rootElem = renderTemplate(template(html, options), options.templateData, options.targetElem || document.body, options.insertPosition, options.locale),
      browserSupported = isBrowserSupported(options);

    stateHistory = [];
    // component states
    if (isUnsupportedBrowser(options)) classListAdd(rootElem, 'trta1-unsupported-browser');
    else if (isOutdatedBrowser(options)) classListAdd(rootElem, 'trta1-outdated-browser');
    if (options.msieOnly) classListAdd(rootElem, 'trta1-msie-only');
    if (options.disallowIE) classListAdd(rootElem, 'trta1-no-ie');
    if (options.offline) classListAdd(rootElem, 'trta1-offline');
    if (!options.targetElem) classListAdd(rootElem, 'trta1-modal');

    if (options.title) {
      // note: use innerText instead of textContent because this is in the IE8 execution path
      rootElem.querySelector('h1').innerText = options.title;
    }

    if (browserSupported) {
      if (options.type || options.sp) {
        // yucky but necesary for backwards compatibility
        var type = /netfirm|csweb/.test(options.sp) ? options.sp : options.type;
        if (type === 'netfirm') {
          if (options.locale === 'en-CA' || options.locale === 'fr-CA') {
            type += 'dt';
          } else if (options.locale === 'en-UK') {
            type += 'digita';
          }
        }
        rootElem.classList.add('trta1-type-' + type.toLowerCase());
      }

      if (!inputPlaceholderIsSupported()) rootElem.classList.add('trta1-placeholder-unsupported');

      listen('submit', function(evt) {
        var form = evt.target;
        evt.preventDefault();

        form.classList.add('trta1-submitted');

        if (!validateForm(form, options)) {
          focusFirstEnabledField(form, function(field) {
            return !field.validity.valid;
          });
          return;
        }

        // valid, make request
        makeFormRequest(
          form,
          options,
          function(resp) { updateFormState(form, 'success', options, resp); },
          function(resp) { updateFormState(form, 'error', options, resp); },
          function(resp) { trigger((form.id || form.name) + '-' + 'done', resp, form); }
        );
      });

      listen('input propertychange', function(evt) {
        var field = evt.target;
        validateField(field, options);
      });

      listen('click', function(evt) {
        var dest;

        if (rootElem.disabled) {
          evt.preventDefault();
          return;
        }

        dest = evt.target.getAttribute('data-trta1-dest');
        if (!dest) return;
        if (changeForm(dest)) {
          evt.preventDefault();
        }
      });

      // handle outdated browser ignore button click
      listen('click', function() {
        rootElem.classList.remove('trta1-outdated-browser');
      }, rootElem.querySelector('.trta1-outdated-browser-btn'));

    }

    classListAdd(document.documentElement, 'trta1-active');
    if (!options.targetElem) classListAdd(document.documentElement, 'trta1-modal-active');

    return browserSupported;
  }

  function destroy() {
    var rootElem = getRootElem();
    if (!rootElem) return;
    trigger('tr-dialog-before-destroy');
    removeNodes(rootElem);
    document.documentElement.classList.remove('trta1-active');
    document.documentElement.classList.remove('trta1-modal-active');
    stateHistory = [];
  }

  /* Export */
  // NOTE: trid is deprecated
  window.trAuth = window.trid = {
    version: '4.0.4',
    debug: false,
    locales: [],
    getRootElem: getRootElem,
    isBrowserSupported: isBrowserSupported,
    getDefaultOptions: getDefaultOptions,
    getTranslateFn: getTranslateFn,
    trigger: trigger,
    seekObjPath: seekObjPath,
    openPrintWindow: openPrintWindow,
    validateForm: validateForm,
    toggleFormDisable: toggleFormDisable,
    loadScript: loadScript,
    focusFirstEnabledField: focusFirstEnabledField,
    changeForm: changeForm,
    pollFormRequest: pollFormRequest,
    updateFormMsg: updateFormMsg,
    updateFormState: updateFormState,
    getLastFormResp: getLastFormResp,
    getFormStateMsgs: getFormStateMsgs,
    fromString: fromString,
    store: store,
    removeNodes: removeNodes,
    objAssignDeep: objAssignDeep,
    listen: listen,
    unlisten: unlisten,
    template: template,
    classListAdd: classListAdd,
    renderTemplate: renderTemplate,
    parseQueryStr: parseQueryStr,
    getPrimaryError: getPrimaryError,
    getSecondaryError: getSecondaryError,
    moduleReady: moduleReady,
    init: init,
    destroy: destroy,
    modules: {}
  };
})(window);
this.trAuth = this.trAuth || {};
this.trAuth.submodules = (function () {
  'use strict';

  var template = "<form name=\"trta1-mfa-approvecode\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_/validate\" class=\"trta1-nodisable\" novalidate>\n  <div class=\"trta1-approve-push-only\">\n    <h3 t8>Check your device!</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\n    </div>\n    <fieldset>\n      <p><span t8>Didn&apos;t get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or </span>\n        <input t8 required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-code\" tr-nosend placeholder=\"Enter code\" autocomplete=\"off\" maxlength=\"9\"><button t8>Go</button>\n      </p>\n      <p t8>No phone? Contact your firm&apos;s administrator</p>\n    </fieldset>\n  </div>\n  <div class=\"trta1-approve-code-only\">\n    <h3 t8>Enter your authentication code</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Enter the authentication code displayed by your multi-factor device or provided to you.</p>\n      <p t8>You have set up the following multi-factor methods:</p>\n      <ul></ul>\n    </div>\n    <label><span t8>Code</span><br>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-nonpush-code\" tr-nosend autocomplete=\"off\" maxlength=\"9\">\n    </label>\n    <button t8 class=\"trta1-btn-primary\">Go</button>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <a t8 data-trta1-dest=\"<%= cancelDestForm %>\" href=\"javascript:void(0)\">Cancel Request</a>\n  </div>\n</form>\n";

  function init(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfa-approvecode]');

    trAuth.listen('trta1-mfa-approvecode-enter', function(evt) {
      var factors = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options).factors;
      var pushCodeInput = form.elements['mfa-manual-code'];
      var nonPushCodeInput = form.elements['mfa-manual-nonpush-code'];
      var factorNamesList = form.querySelector('.trta1-approve-code-only ul');
      var pushFactors = factors.filter(function(factor) {
        return factor.type === 'P'; // P = Push
      });
      var nonPushDeviceFactors = factors.filter(function(factor) {
        // H = Hardware device, A = Auth card, T = Third party TOTP app
        return /^(H|A|T)$/.test(factor.type);
      });
      // if no factors, error. Should only occur if MFA killswitch is on
      if(!pushFactors.length && !nonPushDeviceFactors.length) {
        trAuth.updateFormState(evt.target, 'error', options);
      }

      form.classList.add('trta1-approve-' + (pushFactors.length ? 'push' : 'code'));
      if (pushFactors.length) {
        pushCodeInput.required = true;
        nonPushCodeInput.required = false;
      } else {
        trAuth.removeNodes(factorNamesList.children);
        nonPushDeviceFactors.forEach(function(factor) {
          var li = document.createElement('li');
          li.textContent = factor.name;
          factorNamesList.appendChild(li);
        });

        pushCodeInput.required = false;
        nonPushCodeInput.required = true;
      }
      trAuth.focusFirstEnabledField(form, function(field) {
        return field.required === true;
      });
    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var code = form.elements['mfa-manual-code'].value.replace(/\s/g, '') ||
        form.elements['mfa-manual-nonpush-code'].value.replace(/\s/g, '');
      var approveHdrs = trAuth.seekObjPath('formOverrides.trta1-mfa-approvecode.headers', options, true);
      var mfarId = trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;

      form.action = form.action.replace(/[^/]+(?=\/validate$)/, mfarId);

      approveHdrs.authorization = 'OTP ' + code;
    }, rootElem.querySelector('form[name=trta1-mfa-approvecode]'));

    trAuth.listen('trta1-mfa-approvecode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfa-approvecode-exit', function(evt) {
      form.reset();
    }, rootElem);
  }

  var approveCode = {
    template: template,
    init: init
  };

  var Back = "Back";
  var Cancel = "Cancel";
  var Choose = "Choose";
  var Code = "Code";
  var Copy = "Copy";
  var Done = "Done";
  var Finish = "Finish";
  var Go = "Go";
  var Next = "Next";
  var OK = "OK";
  var Password = "Password";
  var Print = "Print";
  var Reset = "Reset";
  var Retry = "Retry";
  var or = "or";
  var enCA = {
    "A few minutes.": "A few minutes.",
    "Acknowledge and Ignore Warning": "Acknowledge and Ignore Warning",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.",
    "After installing and opening the app, click Next.": "After installing and opening the app, click Next.",
    "An error occurred with your request. Please try again.": "An error occurred with your request. Please try again.",
    "An unexpected error occurred while redirecting your request.": "An unexpected error occurred while redirecting your request.",
    "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approve your request<br> in the Thomson Reuters Authenticator app",
    "At least 1 digit (0-9)": "At least 1 digit (0-9)",
    "At least 1 lowercase letter (a-z)": "At least 1 lowercase letter (a-z)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)",
    "At least 1 uppercase letter (A-Z)": "At least 1 uppercase letter (A-Z)",
    Back: Back,
    "Back To Sign In": "Back To Sign In",
    "CS Professional Suite Security Help": "CS Professional Suite Security Help",
    Cancel: Cancel,
    "Cancel Request": "Cancel Request",
    "Change My Password": "Change My Password",
    "Change my password": "Change my password",
    "Check your device!": "Check your device!",
    Choose: Choose,
    "Choose multi-factor option": "Choose multi-factor option",
    Code: Code,
    "Confirm New Password": "Confirm New Password",
    Copy: Copy,
    "Contact your Onvio administrator": "Contact your Onvio administrator",
    "Deactivated account. Contact your administrator or accountant.": "Deactivated account. Contact your administrator or accountant.",
    "Device ID": "Device ID",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>",
    "Do it later": "Do it later",
    "Do you want to change it now?": "Do you want to change it now?",
    Done: Done,
    "Download and install Thomson Reuters Authenticator app": "Download and install Thomson Reuters Authenticator app",
    "Download and install an alternate multi-factor app": "Download and install an alternate multi-factor app",
    "Email Address": "Email Address",
    "Email Address (Thomson Reuters ID)": "Email Address (Thomson Reuters ID)",
    "Emergency Access Codes": "Emergency Access Codes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Emergency codes copied to the clipboard for pasting to a safe place.",
    "End of support for Windows 7, Server 2008 / 2008 R2": "End of support for Windows 7, Server 2008 / 2008 R2",
    "Enter code": "Enter code",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.",
    "Enter the authentication code displayed by the Authenticator app.": "Enter the authentication code displayed by the Authenticator app.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Enter the authentication code displayed by your multi-factor device or provided to you.",
    "Enter the code displayed by your alternate multi-factor app.": "Enter the code displayed by your alternate multi-factor app.",
    "Enter the one-time code displayed on your multi-factor device.": "Enter the one-time code displayed on your multi-factor device.",
    "Enter your authentication code": "Enter your authentication code",
    "Error copying emergency codes to the clipboard.": "Error copying emergency codes to the clipboard.",
    "Finding your paired device.": "Finding your paired device.",
    Finish: Finish,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "Generating QR code.": "Generating QR code.",
    "Generating emergency codes.": "Generating emergency codes.",
    "Get Started": "Get Started",
    "Let's get started": "Let's get started",
    Go: Go,
    "Go To Sign In": "Go To Sign In",
    "Hide typing": "Hide typing",
    "How long will it take to set up?": "How long will it take to set up?",
    "How will this affect me?": "How will this affect me?",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.",
    "Ignore warning": "Ignore warning",
    "Incorrect Device ID or Code. Please try again.": "Incorrect Device ID or Code. Please try again.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect Email Address or Password. Please try again.",
    "Incorrect Login or Password. Please try again.": "Incorrect Login or Password. Please try again.",
    "Increase security for your account": "Increase security for your account",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructions for resetting your password have been sent to your registered email address.",
    "Internet Access Required": "Internet Access Required",
    "Invalid code. Please try again.": "Invalid code. Please try again.",
    "Invalid value entered.": "Invalid value entered.",
    "Leading or trailing spaces": "Leading or trailing spaces",
    "Learn More About New Security Measures": "Learn More About New Security Measures",
    "Learn more about Emergency Access Codes": "Learn more about Emergency Access Codes",
    "Learn more about multi-factor authentication.": "Learn more about multi-factor authentication.",
    "Learn more about multi-factor devices": "Learn more about multi-factor devices",
    "Learn more about these new security measures.": "Learn more about these new security measures.",
    "Learn more about third-party MFA apps": "Learn more about third-party MFA apps",
    "Learn which MFA option is right for you": "Learn which MFA option is right for you",
    "Make your account even more secure!": "Make your account even more secure!",
    "Manage Account": "Manage Account",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Microsoft Window Server 2008 / 2008 R2 Announcement",
    "Microsoft Windows 7 Announcement": "Microsoft Windows 7 Announcement",
    "Missing data required to reset password. Please try again.": "Missing data required to reset password. Please try again.",
    "Missing data required to unlock account. Please try again.": "Missing data required to unlock account. Please try again.",
    "Missing firmId parameter.": "Missing firmId parameter.",
    "Multi-Factor Authentication Setup": "Multi-Factor Authentication Setup",
    "Multi-factor authentication required": "Multi-factor authentication required",
    "Multifactor authentication is currently unavailable.": "Multifactor authentication is currently unavailable.",
    "My Multi-Factor App": "My Multi-Factor App",
    "Name this multi-factor option": "Name this multi-factor option",
    "Need an account? Contact your administrator.": "Need an account? Contact your administrator.",
    "Need an account? Create one now.": "Need an account? Create one now.",
    "New Password": "New Password",
    Next: Next,
    "Next steps after setting up MFA": "Next steps after setting up MFA",
    "No phone? Contact your firm's administrator": "No phone? Contact your firm's administrator",
    "Notifying your paired device.": "Notifying your paired device.",
    OK: OK,
    "ONVIO Sign In Security Help": "ONVIO Sign In Security Help",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.",
    "Outdated Operating System Detected": "Outdated Operating System Detected",
    "Pairing Successful!": "Pairing Successful!",
    Password: Password,
    "Password contains prohibited characters": "Password contains prohibited characters",
    "Password is too similar to a common or blacklisted password.": "Password is too similar to a common or blacklisted password.",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.",
    "Passwords Don't Match": "Passwords Don't Match",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.",
    "Please change your password.": "Please change your password.",
    "Please choose a password you have not already used.": "Please choose a password you have not already used.",
    "Please complete the required fields.": "Please complete the required fields.",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Please enter your email address.": "Please enter your email address.",
    "Please enter your login and email address.": "Please enter your login and email address.",
    "Please provide a valid password.": "Please provide a valid password.",
    "Please provide a valid {{label}}.": "Please provide a valid {{label}}.",
    "Please wait while we sign you into your account…": "Please wait while we sign you into your account…",
    "Please wait.": "Please wait.",
    "Please wait…": "Please wait…",
    Print: Print,
    "Receive notifications on your mobile device and sign in with a single touch.": "Receive notifications on your mobile device and sign in with a single touch.",
    "Registering your device.": "Registering your device.",
    "Remind Me Later": "Remind Me Later",
    Reset: Reset,
    "Reset My Password": "Reset My Password",
    "Reset Password": "Reset Password",
    "Retrieving authentication token.": "Retrieving authentication token.",
    "Retrieving device info.": "Retrieving device info.",
    Retry: Retry,
    "Save Emergency Access Codes": "Save Emergency Access Codes",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile",
    "Scan Code": "Scan Code",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Sequential letters or numbers such as \"abc\" or \"123\"",
    "Set Up Now": "Set Up Now",
    "Show typing": "Show typing",
    "Sign back in": "Sign back in",
    "Sign In": "Sign In",
    "Sign in with your NetStaff CS account": "Sign in with your NetStaff CS account",
    "Sign in with your Thomson Reuters ID": "Sign in with your Thomson Reuters ID",
    "Sorry, there was an issue on our end. Please try again.": "Sorry, there was an issue on our end. Please try again.",
    "Your registration link has expired. Please contact the firm for a new one.": "Your registration link has expired. Please contact the firm for a new one.",
    "Step 1": "Step 1",
    "Step 2": "Step 2",
    "Success!": "Success!",
    "System Status": "System Status",
    "Tell me how": "Tell me how",
    "Continue to sign in page": "Continue to sign in page",
    "Sign in": "Sign in",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.",
    "The server did not respond in time. Please try again.": "The server did not respond in time. Please try again.",
    "There was an error sending the email. Please try again.": "There was an error sending the email. Please try again.",
    "These codes are like the key to your office - keep them in a safe place only you can access!": "These codes are like the key to your office - keep them in a safe place only you can access!",
    "This option requires you to enter a code each time you sign in.": "This option requires you to enter a code each time you sign in.",
    "Thomson Reuters": "Thomson Reuters",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Thomson Reuters Authenticator Card": "Thomson Reuters Authenticator Card",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:",
    "Timed out waiting for device approval. Resend notification or enter code.": "Timed out waiting for device approval. Resend notification or enter code.",
    "Timed out waiting for scan. Please go back and try again.": "Timed out waiting for scan. Please go back and try again.",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.",
    "To log in to Onvio, please use one of the supported internet browsers below.": "To log in to Onvio, please use one of the supported internet browsers below.",
    "To sign in, please connect this computer to the internet then restart the application.": "To sign in, please connect this computer to the internet then restart the application.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Too many sign in attempts. Please check for unlock email or try later.",
    "Unlocking your account.": "Unlocking your account.",
    "Use Thomson Reuters Authenticator (recommended)": "Use Thomson Reuters Authenticator (recommended)",
    "Use a multi-factor device": "Use a multi-factor device",
    "Use a multi-factor device like a card that displays a code to enter.": "Use a multi-factor device like a card that displays a code to enter.",
    "Use a third-party multi-factor app": "Use a third-party multi-factor app",
    "Use your alternate multi-factor app to scan the code below.": "Use your alternate multi-factor app to scan the code below.",
    "Validate your alternate multi-factor app": "Validate your alternate multi-factor app",
    "Validate your multi-factor device": "Validate your multi-factor device",
    "Words from the dictionary": "Words from the dictionary",
    "You can generate more codes by signing in and accessing your profile.": "You can generate more codes by signing in and accessing your profile.",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You have set up the following multi-factor methods:": "You have set up the following multi-factor methods:",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You're signed out": "You're signed out",
    "You've been authenticated.": "You've been authenticated.",
    "You've been signed out due to inactivity. Sign in to resume.": "You've been signed out due to inactivity. Sign in to resume.",
    "You've exceeded maximum usage time. Please sign in again.": "You've exceeded maximum usage time. Please sign in again.",
    "You've successfully changed your password.": "You've successfully changed your password.",
    "Your Browser is not supported": "Your Browser is not supported",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.",
    "Your account has been unlocked.": "Your account has been unlocked.",
    "Your account is locked. Please contact your administrator.": "Your account is locked. Please contact your administrator.",
    "Your firm's license is inactive": "Your firm's license is inactive",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.",
    "Your password should <strong>not</strong> use:": "Your password should <strong>not</strong> use:",
    "Your password will expire <em>today</em>.": "Your password will expire <em>today</em>.",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.",
    "Your password will expire in <em>1</em> day.": "Your password will expire in <em>1</em> day.",
    "Your password will expire soon": "Your password will expire soon",
    "Your session is ending soon": "Your session is ending soon",
    "Your session will end in:": "Your session will end in:",
    "Your user ID": "Your user ID",
    "You don't have access": "You don't have access",
    or: or,
    "{{label}} is required.": "{{label}} is required.",
    "Sign-in Help": "Sign-in Help",
    "View system status": "View system status",
    "Your firm's license is no longer active. Please contact your administrator.": "Your firm's license is no longer active. Please contact your administrator.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Please enter a valid password. Your password cannot contain personal information associated with your account.",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Centre </a> for possible solutions",
    "Contact your Onvio administrator.": "Contact your Onvio administrator.",
    "Contact your administrator.": "Contact your administrator.",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requires two-step verification. You only have to configure this once, and it won't take long.",
    "Please close this window and try again.": "Please close this window and try again.",
    "Read about account security": "Read about account security",
    "Secure your account": "Secure your account",
    "Set up two-step verification": "Set up two-step verification",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You don't have access to this product": "You do not have access to this product",
    "Select the module you wish to access and try again": "Select the product you wish to access and try again:",
    "Client Center": "Client Centre",
    "Employee Portal": "Employee Portal"
  };

  var Password$1 = "Contraseña";
  var Back$1 = "Atrás";
  var OK$1 = "Aceptar";
  var Reset$1 = "Restablecer";
  var Retry$1 = "Volver a intentarlo";
  var Cancel$1 = "Cancelar";
  var Next$1 = "Siguiente";
  var Go$1 = "Continuar";
  var Close = "Cerrar";
  var Done$1 = "Listo";
  var Choose$1 = "Elegir";
  var Code$1 = "Código";
  var Finish$1 = "Finalizar";
  var Copy$1 = "Copia";
  var Print$1 = "Imprimir";
  var or$1 = "o";
  var Download = "Descargar";
  var esAR = {
    "Email Address (Thomson Reuters ID)": "Correo Electrónico (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Inicie sesion con su Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Su Thomson Reuters ID es el correo electrónico para ingresar a Onvio y/o a su cuenta de CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Inicie sesion con su NetStaff CS cuenta",
    Password: Password$1,
    "Reset Password": "Restablecer Contraseña",
    "Manage Account": "Administrar Cuenta",
    "CS Professional Suite Security Help": "Ayuda con la seguridad de CS Professional Suite",
    "Need an account? Contact your administrator": "¿Necesita una cuenta? Comuníquese con el administrador",
    "ONVIO Sign In Security Help": "Ayuda con la seguridad del inicio de sesión en ONVIO",
    "Need an account? Please create a new account": "¿Necesita una cuenta? Cree una cuenta nueva",
    "Internet Access Required": "Se requiere acceso a Internet",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "A fin de ayudar a proteger la información confidencial de su estudio contable y sus clientes, y de cumplir con los nuevos requisitos del IRS, Thomson Reuters agrega nombres de usuario y contraseñas al acceso a nuestros productos contables y tributarios.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para iniciar sesión, conecte esta computadora a Internet y después vuelva a iniciar la aplicación.",
    "Learn more about these new security measures.": "Obtener más información sobre estas nuevas medidas de seguridad.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable pueda obtener acceso a este software, uno de los administradores del estudio contable debe actualizar sus cuentas en <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Obtener más información sobre las nuevas medidas de seguridad",
    "Please enter your email address.": "Ingrese su dirección de correo electrónico.",
    "Please enter your login and email address.": "Ingrese su información de inicio de sesión y su dirección de correo electrónico.",
    Back: Back$1,
    "Reset My Password": "Restablecer mi contraseña",
    "Continue to sign in page": "Continuar a la página de inicio de sesión",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "Instructions for resetting your password have been sent to your registered email address.": "Se le han enviado instrucciones para restablecer su contraseña a la dirección de correo electrónico registrada.",
    "Go To Sign In": "Ir al inicio de sesión",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, cree una nueva contraseña que cumpla <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Su contraseña ha expirado. Por favor, cree una nueva que cumpla <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Su contraseña <strong>debe</strong> tener <span>al menos 8 caracteres</span>, incluyendo todo lo siguiente:",
    "At least 1 uppercase letter (A-Z)": "Al menos 1 letra mayúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Al menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Al menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Al menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Su contraseña <strong>no debe </strong> contener:",
    "Leading or trailing spaces": "Espacios al inicio o al final",
    "Words from the dictionary": "Palabras incluidas en el diccionario",
    "Your user ID": "Su código de usuario",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras o números consecutivos, tales como \"abc\" or \"123\"",
    "Show typing": "Mostrar Caracteres",
    "Hide typing": "Ocultar Caracteres",
    "New Password": "Contraseña Nueva",
    "Confirm New Password": "Confirmar Contraseña Nueva",
    "Change My Password": "Cambiar mi Contraseña",
    "You've successfully changed your password.": "Cambió correctamente su contraseña.",
    OK: OK$1,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inicie sesión</a> y cambie su contraseña.",
    "Back To Sign In": "Volver a Inicio de sesión",
    "Unlocking your account.": "Desbloqueo de la cuenta.",
    "Your password will expire soon": "Su contraseña caduca pronto",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Su contraseña caducará en <em id=\"trta1-pwdexpdays\">2</em> días.",
    "Your password will expire in <em>1</em> day.": "Su contraseña caduca dentro de <em>1</em> día.",
    "Your password will expire <em>today</em>.": "Su contraseña caduca <em>hoy</em>.",
    "Do you want to change it now?": "¿Desea cambiarla ahora?",
    "Change my password": "Cambiar mi contraseña",
    "Do it later": "Más tarde",
    "Your session is ending soon": "Su sesión finaliza pronto",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$1,
    "Multi-factor authentication required": "La autenticación de múltiples factores es obligatoria",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "El estudio requiere que se habilite la autenticación de múltiples factores antes de iniciar sesión. Por favor complete el asistente de configuración de autenticación de múltiples factores para continuar.",
    "Set Up Now": "Configurar Ahora",
    "Finding your paired device.": "Buscando el dispositivo sincronizado.",
    Retry: Retry$1,
    "Notifying your paired device.": "Notificando al dispositivo sincronizado.",
    "Check your device!": "Revise su dispositivo.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprobar su solicitud<br> en la aplicación Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">introduzca un código</a>",
    "No phone? Contact your firm's administrator": "¿No tiene teléfono? Comuníquese con el administrador de su estudio contable",
    "Cancel Request": "Cancelar solicitud",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o",
    "Enter code": "Ingresar código",
    "Retrieving authentication token.": "Recuperando token de autenticación.",
    "You've been authenticated.": "Ya está autenticado.",
    "Please wait while we sign you into your account…": "Espere mientras se inicia la sesión en su cuenta...",
    "Multifactor authentication is currently unavailable.": "La autenticación de múltiples factores no está disponible en este momento.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Está utilizando un navegador <strong>obsoleto</strong>. Actualice su navegador para mejorar la seguridad.",
    "Multi-factor Authentication Setup": "Configuración de autenticación de múltiples factores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Mejore la seguridad de su cuenta</strong> Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>¿Cuánto tiempo demora la configuración?</strong> Unos minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>¿En qué me afectará esto?</strong> Tendrá que aprobar cada solicitud de inicio de sesión con su teléfono inteligente una vez al día y cada vez que cierre sesión.",
    Cancel: Cancel$1,
    "Get Started": "Empezar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale la aplicación Thomson Reuters Authenticator en su teléfono inteligente o tablet.",
    "Download on the Apple App Store": "Descarguela de la App Store de Apple",
    "Get it on Google Play": "Consígala en Google Play",
    Next: Next$1,
    "Generating QR code.": "Generando código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra la aplicación Thomson Reuters Authenticator y escanee el código QR de abajo.",
    "Retrieving device info.": "Recuperando información del dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Sincronizó su cuenta con <strong id=\"trta1-mfs-devicename\">este dispositivo</strong>. Deberá aprobar cada solicitud de registro en este dispositivo una vez al día y después de cada vez que cierre la sesión.",
    "Got It": "Entendido",
    "Please wait…": "Espere...",
    "Enter your authentication code": "Ingrese el código de autenticación",
    "Invalid code. Please enter a valid authentication code.": "Código no válido  Ingrese un código de autenticación válido.",
    "Enter the code provided by your adminstrator": "Ingrese el código que le dio su administrador",
    "Set up your mobile device": "Configure su dispositivo móvil",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "La contraseña debe tener un mínimo de 8 caracteres y contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo, sin espacios iniciales o finales.",
    "Incorrect Email Address or Password. Please try again.": "Dirección de correo electrónico o contraseña incorrectos. Vuelva a intentarlo.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Demasiados intentos de inicio de sesión. Verifique si su correo electrónico se encuentra bloqueado o intente nuevamente más tarde.",
    "Please change your password.": "Por favor, cambie su contraseña.",
    "Please complete the required fields.": "Por favor complete los campos requeridos.",
    "Deactivated account. Contact your administrator or accountant.": "Cuenta desactivada. Póngase en contacto con su administrador o contador.",
    "There was an error sending the email. Please try again.": "Se ha producido un error al enviar el correo electrónico. Vuelva a intentarlo. ",
    "Please choose a password you have not already used.": "Elija una contraseña que no haya utilizado con anterioridad.",
    "Your account has been unlocked.": "Su cuenta se ha desbloqueado.",
    "You've been signed out due to inactivity. Sign in to resume.": "Ha sido desconectado debido a su inactividad. Inicie sesión para reanudar.",
    "You've exceeded maximum usage time. Please sign in again.": "Ha excedido el tiempo máximo de uso. Inicie sesión nuevamente.",
    "Incorrect Login or Password. Please try again.": "Usuario o contraseña incorrectos. Vuelva a intentarlo.",
    "Missing data required to reset password. Please try again.": "Faltan los datos necesarios para restablecer la contraseña. Vuelva a intentarlo.",
    "Missing data required to unlock account. Please try again.": "Faltan los datos necesarios para desbloquear su cuenta. Vuelva a intentarlo.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tiempo de espera agotado para la aprobación del dispositivo. Reenvíe la notificación o introduzca un código.",
    "Invalid code. Please try again.": " Código inválido. Vuelva a intentarlo.",
    "Passwords Don't Match": "Las contraseñas no coinciden",
    "Please wait.": "Por favor espere.",
    "Success!": "¡Correcto!",
    "An unexpected error occurred. Please try again.": "Se ha producido un error inesperado. Vuelva a intentarlo.",
    "An unexpected error occurred while redirecting your request.": "Se ha producido un error inesperado al redireccionar la solicitud.",
    "The server did not respond in time. Please try again.": "El servidor no respondió a tiempo. Vuelva a intentarlo.",
    "An error occurred with your request. Please try again.": "Se ha producido un error en su solicitud. Vuelva a intentarlo.",
    "Please provide a valid {{label}}.": "Proporcione un {{label}} válido.",
    "{{label}} is required.": "{{label}} es requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tiempo de espera agotado. Por favor, regrese y vuelva a intentarlo.",
    "Your account is locked. Please contact your administrator.": "Su cuenta se encuentra bloqueada. Póngase en contacto con el administrador.",
    Go: Go$1,
    "Sorry, there was an issue on our end. Please try again.": "Hemos tenido un problema. Por favor, inténtelo de nuevo.",
    "Your registration link has expired. Please contact the firm for a new one.": "Su enlace de registro ha caducado. Contáctese con el Estudio Contable para obtener uno nuevo.",
    "Make your account even more secure!": "¡Haga que su cuenta sea aún más segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Agregue un nivel adicional de seguridad en caso de que su contraseña se encuentre en peligro. Confirme su identidad mediante su dispositivo móvil.",
    "Learn more about multi-factor authentication.": "Más información acerca de la autenticación de múltiples factores.",
    "Remind Me Later": "Recordarme Más Tarde",
    Close: Close,
    Done: Done$1,
    "Update Password": "Actualizar Contraseña",
    "Please enter your email address to update your password.": "Por favor, ingrese su dirección de correo electrónico para actualizar su contraseña.",
    "Sign In": "Iniciar sesión",
    "Please provide a valid password.": "Proporcione una contraseña válida.",
    "Password contains prohibited characters.": "La constraseña posee caracteres no válidos.",
    "Password is too similar to a common or blacklisted password.": "Esta contraseña es similar a una contraseña muy común o en la lista de no permitidas.",
    "Ignore warning": "Ignorar esta advertencia",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Su navegador no es compatible para su uso con esta aplicación. Por favor intente de nuevo usando la última versión de uno de los siguientes navegadores.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Usar un navegador que ya no es compatible con el proveedor es un riesgo de seguridad. Haga clic en uno de los enlaces a continuación para actualizar a un navegador actual.",
    "Your Browser is Outdated": "Su navegador no está actualizado",
    "A few minutes.": "Unos pocos minutos.",
    "After installing and opening the app, click Next.": "Después de instalar y abrir la aplicación, haga clic en Siguiente.",
    Choose: Choose$1,
    "Choose multi-factor option": "Elija la opción multifactor",
    Code: Code$1,
    "Download and install Thomson Reuters Authenticator app": "Descargue e instale la aplicación Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Descargue e instale una aplicación alternativa de múltiples factores",
    "Enter the authentication code displayed by the Authenticator app.": "Ingrese el código de autenticación que muestra la aplicación Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Ingrese el código que muestra su aplicación de múltiples factores.",
    Finish: Finish$1,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable acceda a este software, uno de los administradores de su estudio debe actualizar sus cuentas en <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "¿Cuánto tiempo demora la configuración?",
    "How will this affect me?": "¿En qué me afectará esto?",
    "Increase security for your account": "Aumente la seguridad de su cuenta",
    "Invalid value entered.": "Valor inválido ingresado.",
    "Learn more about third-party MFA apps": "Obtenga más información acerca de las aplicaciones de autenticación de múltiples factores de terceros",
    "Learn which MFA option is right for you": "Conozca la opción de autenticación de múltiples factores adecuada para usted",
    "My Multi-Factor App": "Mi aplicación de múltiples factores",
    "Name this multi-factor option": "Nombre esta opción de múltiples factores",
    "Need an account? Contact your administrator.": "¿Necesita una cuenta? Comuníquese con el administrador",
    "Need an account? Create one now.": "¿Necesita una cuenta? Cree una ahora",
    "Next steps after setting up MFA": "Próximos pasos después de configurar la autenticación de múltiples factores",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "En su dispositivo móvil, abra la tienda de aplicaciones y descargue e instale la aplicación <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "Pairing Successful!": "¡Sincronización exitosa!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Mejore la seguridad de su cuenta. Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Reciba notificaciones en su dispositivo móvil e inicie sesión con un solo toque.",
    "Registering your device.": "Registrando su dispositivo",
    "Scan Code": "Escanear código",
    "Step 1": "Paso 1",
    "Step 2": "Paso 2",
    "Tell me how": "Dime cómo",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "El método alternativo debe ser compatible con una sola contraseña basada en el tiempo (TOTP). Descargue ahora en <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> o <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Esta opción requiere que ingrese un código cada vez que inicie sesión.",
    "Thomson Reuters Authenticator": "Authenticator de Thomson Reuters",
    "Use Thomson Reuters Authenticator (recommended)": "Utilice Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Utilice una aplicación de múltiples factores de terceros",
    "Use your alternate multi-factor app to scan the code below.": "Use su aplicación alternativa de múltiples factores para escanear el código a continuación.",
    "Validate your alternate multi-factor app": "Valide su aplicación alternativa de múltiples factores",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Puede utilizar Thomson Reuters Authenticator (recomendado) o una aplicación de múltiples factores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Ha configurado una autenticación de múltiples factores para su cuenta. Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">inicie sesión</a> y cambie su contraseña.",
    Copy: Copy$1,
    "Emergency Access Codes": "Códigos de acceso de emergencia",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Los códigos de emergencia fueron copiados en el portapapeles para pegarlos en un lugar seguro.",
    "Generating emergency codes.": "Generando códigos de emergencia.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si pierde el acceso a su dispositivo móvil, puede usar uno de estos códigos de emergencia para iniciar sesión en su cuenta. Cada código puede usarse solo una vez.",
    "Missing firmId parameter.": "Falta el parámetro firmId.",
    "Multi-Factor Authentication Setup": "Configuración de la autenticación de múltiples factores",
    Print: Print$1,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Estos códigos son como la llave de su oficina: ¡guárdelos en un lugar seguro al que solo usted pueda acceder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Use uno de estos códigos cuando este dispositivo sea inaccesible. Imprima o guarde los códigos en una ubicación segura. Cada código solo se puede usar una vez, pero se pueden generar más códigos en su perfil de cuenta.",
    "You can generate more codes by signing in and accessing your profile.": "Puede generar más códigos iniciando sesión y accediendo a su perfil.",
    "Error copying emergency codes to the clipboard.": "Error al copiar códigos de emergencia al portapapeles.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Ingrese el código de autenticación que se muestra en su dispositivo de factores múltiples o que le ha sido proporcionado.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "You have set up the following multi-factor methods:": "Ha configurado los siguientes métodos de múltiples factores:",
    "Device ID": "Código del dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Ingrese el código del dispositivo de 9 caracteres que comienza con las letras TR de la parte posterior de su tarjeta Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Ingrese el código de único acceso que se muestra en su dispositivo de múltiples factores.",
    "Learn more about multi-factor devices": "Conozca más sobre dispositivos de múltiples factores",
    "Use a multi-factor device": "Utilice un dispositivo de múltiples factores",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilice un dispositivo de múltiples factores como una tarjeta que muestra un código para ingresar.",
    "Validate your multi-factor device": "Valide su dispositivo de múltiples factores",
    "Incorrect Device ID or Code. Please try again.": "ID o código incorrecto del dispositivo. Por favor, vuelva a intentarlo.",
    "Thomson Reuters Authenticator Card": "Tarjeta de Authenticator de Thomson Reuters",
    "Save Emergency Access Codes": "Guardar códigos de acceso de emergencia",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Guarde o imprima estos códigos en una ubicación segura para usar cuando su dispositivo MFA principal no esté disponible (por ejemplo, si obtiene un teléfono nuevo). Puede usar cada código solo una vez, pero puede generar más códigos en el perfil de su cuenta",
    or: or$1,
    Download: Download,
    "Learn more about Emergency Access Codes": "Más información sobre los códigos de acceso de emergencia",
    "Sign-in Help": "Ayuda para Iniciar sesión",
    "System Status": "Estado del sistema",
    "Your Browser is not supported": "Su navegador no es compatible",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Para iniciar sesión en Onvio, utilice uno de los navegadores de Internet compatibles de la lista.",
    "Your firm's license is no longer active. Please contact your administrator.": "Su licencia del Estudio ya no está activa. Por favor, póngase en contacto con su administrador.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Por favor introduzca una contraseña válida. La contraseña no puede contener información personal asociada a su cuenta.",
    "Your firm's license is inactive": "La licencia de su Estudio Contable está inactiva",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Consulte la <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Ayuda y el Centro de instrucciones </a> para encontrar posibles soluciones",
    "Acknowledge and Ignore Warning": "Reconocer e ignorar la advertencia",
    "Contact your Onvio administrator.": "Póngase en contacto con su administrador de Onvio.",
    "Contact your administrator.": "Póngase en contacto con su administrador.",
    "Email Address": "Dirección de Correo Electrónico",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fin del soporte para Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Empecemos",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Anuncio de Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Anuncio de Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requiere verificación en dos pasos. Solo tienes que configurar esto una vez, y no tomará mucho tiempo.",
    "Password contains prohibited characters": "La contraseña contiene caracteres prohibidos.",
    "Please close this window and try again.": "Por favor cierre esta ventana y vuelva a intentarlo.",
    "Read about account security": "Obtén más información sobre la seguridad de la cuenta",
    "Secure your account": "Tu cuenta no está verificada",
    "Set up two-step verification": "Configurar la verificación en dos pasos",
    "Sign back in": "Volver a iniciar sesión",
    "Sign in": "Iniciar sesión",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters ya no admitirá sus productos en los sistemas operativos Windows 7 o Windows Server 2008 o 2008 R2 a partir del 14 de enero de 2020. Le recomendamos encarecidamente que actualice cualquier estación de trabajo o servidor que requiera acceso a los productos de Thomson Reuters a un sistema operativo compatible antes del 14 de enero de 2020. Encuentre más información en los siguientes enlaces:",
    "View system status": "Ver el estado del sistema",
    "You don't have access": "No tienes acceso",
    "You're signed out": "Está deslogueado",
    "You don't have access to this product": "No tenés acceso a este producto",
    "Select the module you wish to access and try again": "Seleccioná el módulo al que deseás acceder y volvé a intentarlo:",
    "Client Center": "Portal Cliente",
    "Employee Portal": "Portal del empleado"
  };

  var Password$2 = "Mot de passe";
  var Back$2 = "Retour";
  var OK$2 = "OK";
  var Reset$2 = "Réinitialiser";
  var Retry$2 = "Réessayez";
  var Cancel$2 = "Annuler";
  var Next$2 = "Suivant";
  var Go$2 = "Aller";
  var Close$1 = "Fermer";
  var Done$2 = "Terminé";
  var Choose$2 = "Choisir";
  var Code$2 = "Code";
  var Finish$2 = "Terminer";
  var Copy$2 = "Copier";
  var Print$2 = "Imprimer";
  var or$2 = "ou";
  var Download$1 = "Télécharger";
  var frCA = {
    "Email Address (Thomson Reuters ID)": "Adresse Courriel (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Connectez-vous avec votre Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Votre Thomson Reuters ID est l’adresse courriel que vous utilisez pour vous connecter à votre compte Onvio.",
    "Sign in with your NetStaff CS account": "Connectez-vous avec votre compte DT Portail-Client",
    Password: Password$2,
    "Reset Password": "Réinitialiser le mot de passe",
    "Manage Account": "Gestion de compte",
    "CS Professional Suite Security Help": "Aide relative à la sécurité de la Suite Professionnelle DT",
    "Need an account? Contact your administrator": "Besoin d’un compte? Contactez votre administrateur.",
    "ONVIO Sign In Security Help": "Aide relative à la sécurité de la connexion ONVIO",
    "Need an account? Please create a new account": "Besoin d’un compte? Veuillez créer un nouveau compte",
    "Internet Access Required": "Connexion Internet requise",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Pour aider à protéger les données confidentielles de votre cabinet et de vos clients, Thomson Reuters ajoute des noms d’utilisateurs et des mots de passe pour que vous puissiez avoir accès aux produits d’impôt et de comptabilité.",
    "To sign in, please connect this computer to the internet then restart the application.": "Pour vous connecter, veuillez connecter cet ordinateur à Internet et redémarrer l’application.",
    "Learn more about these new security measures.": "Renseignez-vous sur ces nouvelles mesures de sécurité.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre cabinet ait accès à ce logiciel, un des administrateurs de votre cabinet doit mettre à niveau les comptes.",
    "Learn More About New Security Measures": "Renseignez-vous sur les nouvelles mesures de sécurité",
    "Please enter your email address.": "Veuillez saisir votre adresse courriel.",
    "Please enter your login and email address.": "Veuillez saisir votre identifiant de connexion et votre adresse courriel.",
    Back: Back$2,
    "Reset My Password": "Réinitialiser mon mot de passe",
    "Continue to sign in page": "Continuer vers la page de connexion",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-fr/staff/core/setup/thomson-reuters-account.htm",
    "Instructions for resetting your password have been sent to your registered email address.": "Des directives pour réinitialiser votre mot de passe ont été envoyées à l’adresse courriel que vous avez enregistrée.",
    "Go To Sign In": "Allez dans Connexion",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Veuillez créer un nouveau mot de passe qui répond aux <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Votre mot de passe est échu. Veuillez en créer un nouveau qui répond aux <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Votre mot de passe <strong>doit</strong> comporter <span>au moins 8 caractères</span>, incluant tous les caractères suivants :",
    "At least 1 uppercase letter (A-Z)": "Au moins une lettre majuscule (A-Z)",
    "At least 1 lowercase letter (a-z)": "Au moins une lettre minuscule (a-z)",
    "At least 1 digit (0-9)": "Au moins un chiffre (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Au moins un symbole (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Votre mot de passe ne doit <strong>pas</strong> contenir :",
    "Leading or trailing spaces": "Des espaces à gauche ou à droite",
    "Words from the dictionary": "Des mots du dictionnaire",
    "Your user ID": "Votre ID utilisateur",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Des lettres ou des chiffres en séquence comme abc ou \"abc\" or \"123\"",
    "Show typing": "Afficher la saisie",
    "Hide typing": "Cacher la saisie",
    "New Password": "Nouveau mot de passe",
    "Confirm New Password": "Confirmer le nouveau mot de passe",
    "Change My Password": "Changer mon mot de passe",
    "You've successfully changed your password.": "Vous avez changé votre mot de passe avec succès.",
    OK: OK$2,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez vous <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">connecter</a> et changer votre mot de passe.",
    "Back To Sign In": "Retour à la connexion",
    "Unlocking your account.": "Déverrouillage de votre compte.",
    "Your password will expire soon": "Votre mot de passe viendra bientôt à échéance",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Votre mot de passe arrive à échéance dans <em id=\"trta1-pwdexpdays\">2</em> jours.",
    "Your password will expire in <em>1</em> day.": "Votre mot de passe viendra à échéance dans <em>un</em> jour.",
    "Your password will expire <em>today</em>.": "Votre mot de passe vient à échéance <em>aujourd’hui</em>.",
    "Do you want to change it now?": "Voulez-vous le changer maintenant?",
    "Change my password": "Changer maintenant",
    "Do it later": "Plus tard",
    "Your session is ending soon": "Votre session se termine bientôt",
    "Your session will end in:": "Votre session se termine dans :",
    Reset: Reset$2,
    "Multi-factor authentication required": "Authentification multifacteurs requise",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "Le cabinet exige que vous activiez l'authentification multifacteurs avant de vous connecter. Veuillez compléter l'assistant de configuration de l'authentification multifacteurs pour continuer.",
    "Set Up Now": "Configurer",
    "Finding your paired device.": "Trouvez votre appareil jumelé.",
    Retry: Retry$2,
    "Notifying your paired device.": "Notification de votre appareil jumelé en cours.",
    "Check your device!": "Vérifiez votre appareil!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approuvez votre demande<br> dans l’application Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">saisissez un code</a>",
    "No phone? Contact your firm's administrator": "Vous n’avez pas de téléphone? Contactez l’administrateur de votre cabinet",
    "Cancel Request": "Annuler la demande",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou",
    "Enter code": "Saisissez le code",
    "Retrieving authentication token.": "Récupération du jeton d’authentification",
    "You've been authenticated.": "Vous avez été authentifié.",
    "Please wait while we sign you into your account…": "Veuillez patienter pendant que nous vous connectons à votre compte…",
    "Multifactor authentication is currently unavailable.": "L’authentification multifacteurs n’est présentement pas disponible.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Vous utilisez un navigateur <strong>obsolète</strong>. Veuillez actualiser le navigateur pour améliorer la sécurité.",
    "Multi-factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Augmentez la sécurité de votre compte</strong> Les mots de passe peuvent être piratés, mais utiliser l’authentification multifacteurs ajoute un autre niveau de sécurité à votre compte.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Combien de temps prendra la configuration?</strong> Quelques minutes.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>De quelle façon cela m’affectera-t-il?</strong> Vous devrez approuver chaque demande de connexion sur votre téléphone intelligent une fois par jour et après chaque déconnexion.",
    Cancel: Cancel$2,
    "Get Started": "Commencer",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installez l’application Thomson Reuters Authenticator sur votre téléphone intelligent ou tablette.",
    "Download on the Apple App Store": "Téléchargez sur le magasin App Store d’Apple.",
    "Get it on Google Play": "Obtenez l’application sur Google Play",
    Next: Next$2,
    "Generating QR code.": "Génération d’un code QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Ouvrez l’application Thomson Reuters Authenticator et balayez le code QR ci-dessous.",
    "Retrieving device info.": "Récupération des informations sur l’appareil",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Vous avez jumelé votre compte avec <strong id=\"trta1-mfs-devicename\">cet appareil</strong>. Vous devrez approuver chaque demande d’ouverture de session sur cet appareil une fois par jour et après chaque déconnexion.",
    "Got It": "J’ai compris",
    "Please wait…": "Veuillez patienter…",
    "Enter your authentication code": "Saisissez votre code d’authentification",
    "Invalid code. Please enter a valid authentication code.": "Code invalide. Veuillez saisir un code d’authentification valide.",
    "Enter the code provided by your adminstrator": "Saisissez le code fourni par votre administrateur",
    "Set up your mobile device": "Configurez votre appareil mobile",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole, sans espace avant ou arrière.",
    "Incorrect Email Address or Password. Please try again.": "Adresse électronique incorrecte ou mot de passe incorrect. Veuillez réessayer.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Trop de tentatives de connexion. Veuillez vérifier si vous avez reçu un courriel de déverrouillage ou essayez plus tard.",
    "Please change your password.": "Veuillez modifier votre mot de passe.",
    "Please complete the required fields.": "Veuillez remplir les champs requis.",
    "Deactivated account. Contact your administrator or accountant.": "Compte désactivé. Communiquez avec votre administrateur ou votre comptable.",
    "There was an error sending the email. Please try again.": "Une erreur s'est produite lors de l'envoi du courriel. Veuillez réessayer.",
    "Please choose a password you have not already used.": "Choisissez un mot de passe que vous n'avez pas déjà utilisé.",
    "Your account has been unlocked.": "Votre compte a été débloqué.",
    "You've been signed out due to inactivity. Sign in to resume.": "Vous avez été déconnecté en raison de l'inactivité. Connectez-vous pour reprendre.",
    "You've exceeded maximum usage time. Please sign in again.": "Vous avez dépassé le temps d'utilisation maximum. Veuillez vous connecter à nouveau.",
    "Incorrect Login or Password. Please try again.": "Identifiant ou mot de passe incorrect. Veuillez réessayer.",
    "Missing data required to reset password. Please try again.": "Données manquantes requises pour réinitialiser le mot de passe. Veuillez réessayer.",
    "Missing data required to unlock account. Please try again.": "Données manquantes requises pour déverrouiller le compte. Veuillez réessayer.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Temporisé en attendant l'approbation de l'appareil. Renvoyez une notification ou saisissez un code.",
    "Invalid code. Please try again.": "Code invalide. Veuillez réessayer.",
    "Passwords Don't Match": "Les mots de passe ne correspondent pas",
    "Please wait.": "Veuillez patienter.",
    "Success!": "Succès!",
    "An unexpected error occurred. Please try again.": "Une erreur inattendue s’est produite. Veuillez réessayer.",
    "An unexpected error occurred while redirecting your request.": "Une erreur inattendue s'est produite lors de la redirection de votre demande.",
    "The server did not respond in time. Please try again.": "Le serveur n'a pas répondu à temps. Veuillez réessayer.",
    "An error occurred with your request. Please try again.": "Une erreur s'est produite avec votre demande. Veuillez réessayer.",
    "Please provide a valid {{label}}.": "Veuillez fournir un {{label}} valide.",
    "{{label}} is required.": "{{label}} est requis.",
    "Timed out waiting for scan. Please go back and try again.": "Temporisé en attente de numérisation. Veuillez revenir en arrière et réessayer.",
    "Your account is locked. Please contact your administrator.": "Votre compte est verrouillé. Veuillez contacter votre administrateur.",
    Go: Go$2,
    "Sorry, there was an issue on our end. Please try again.": "Désolé, nous avons éprouvé un problème de notre côté. Veuillez réessayer.",
    "Your registration link has expired. Please contact the firm for a new one.": "Le lien de votre inscription est expiré. Veuillez communiquer avec le cabinet pour en recevoir un nouveau.",
    "Make your account even more secure!": "Sécurisez encore plus votre compte!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Ajoutez un niveau de sécurité supplémentaire au cas où la sécurité de votre mot de passe s'avérait compromise. Confirmez votre identité à l'aide de votre appareil mobile.",
    "Learn more about multi-factor authentication.": "En savoir plus sur l'authentification multifacteurs.",
    "Remind Me Later": "Rappelez-moi plus tard",
    Close: Close$1,
    Done: Done$2,
    "Update Password": "Mettre à jour le mot de passe",
    "Please enter your email address to update your password.": "Veuillez saisir votre adresse courriel pour mettre à jour votre mot de passe.",
    "Sign In": "Se connecter",
    "Please provide a valid password.": "Veuillez fournir un mot de passe valide.",
    "Password contains prohibited characters.": "Le mot de passe contient des caractères interdits.",
    "Password is too similar to a common or blacklisted password.": "Ce mot de passe est trop similaire à un mot de passe commun ou interdit.",
    "Ignore warning": "Ignorer l'avertissement",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Votre navigateur n'est pas pris en charge avec cette application. Veuillez réessayer en utilisant la dernière version de l'un des navigateurs suivants.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "L'utilisation d'un navigateur qui n'est plus pris en charge par le fournisseur constitue un risque de sécurité. Cliquez sur l'un des liens ci-dessous pour passer à un navigateur plus récent.",
    "Your Browser is Outdated": "Votre navigateur est obsolète",
    "A few minutes.": "Quelques minutes.",
    "After installing and opening the app, click Next.": "Après avoir installé et ouvert l'application, cliquer sur Suivant.",
    Choose: Choose$2,
    "Choose multi-factor option": "Choisir l'option multifacteurs",
    Code: Code$2,
    "Download and install Thomson Reuters Authenticator app": "Télécharger et installer l'application Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Télécharger et installer une autre application multifacteurs",
    "Enter the authentication code displayed by the Authenticator app.": "Saisir le code d'authentification affiché par l'application Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Saisir le code affiché par votre application multifacteurs alternative.",
    Finish: Finish$2,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre entreprise puisse accéder à ce logiciel, l'un des administrateurs de votre entreprise doit mettre à niveau vos comptes sur <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Combien de temps prendra la configuration?",
    "How will this affect me?": "De quelle façon cela m’affectera-t-il?",
    "Increase security for your account": "Augmenter la sécurité de votre compte",
    "Invalid value entered.": "Valeur invalide saisie.",
    "Learn more about third-party MFA apps": "Pour en savoir plus sur les applications AFM tierces",
    "Learn which MFA option is right for you": "Découvrez quelle option AFM vous convient",
    "My Multi-Factor App": "Mon application multifacteurs",
    "Name this multi-factor option": "Nommer cette option multifacteurs",
    "Need an account? Contact your administrator.": "Besoin d’un compte? Contactez votre administrateur.",
    "Need an account? Create one now.": "Besoin d’un compte? Créez-en un maintenant",
    "Next steps after setting up MFA": "Prochaines étapes après avoir configuré l'AFM",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Sur votre appareil mobile, ouvrez la boutique d'applications, téléchargez et installez l'application <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "Pairing Successful!": "Appariement réussi !",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Les mots de passe peuvent être piratés, mais l'utilisation de l’authentification multifacteurs ajoute un niveau de sécurité supplémentaire à votre compte.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Recevez des notifications sur votre appareil mobile et connectez-vous avec une seule touche.",
    "Registering your device.": "Enregistrer votre appareil.",
    "Scan Code": "Scanner le code",
    "Step 1": "Étape 1",
    "Step 2": "Étape 2",
    "Tell me how": "Dites-moi comment",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/us/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=en-us\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=en\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/ca/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/fr/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Cette option nécessite que vous saisissiez un code chaque fois que vous vous connectez.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Utiliser Thomson Reuters Authenticator (recommandé)",
    "Use a third-party multi-factor app": "Utiliser une application multifacteurs tierce",
    "Use your alternate multi-factor app to scan the code below.": "Utiliser votre application multifacteurs alternative pour scanner le code ci-dessous.",
    "Validate your alternate multi-factor app": "Valider votre application multifacteurs alternative",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Vous pouvez utiliser Thomson Reuters Authenticator (recommandé) ou une autre application multifacteurs.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous avez configuré l'authentification multifacteurs pour votre compte. Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">vous connecter</a> et modifier votre mot de passe.",
    Copy: Copy$2,
    "Emergency Access Codes": "Codes d'accès d'urgence",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Codes d'urgence copiés dans le presse-papiers pour être collés dans un endroit sûr.",
    "Generating emergency codes.": "Générer des codes d'urgence",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si vous perdez l'accès à votre appareil mobile, vous pouvez utiliser l'un de ces codes d'urgence pour vous connecter à votre compte. Chaque code ne peut être utilisé qu'une seule fois.",
    "Missing firmId parameter.": "Paramètre firmId manquant",
    "Multi-Factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    Print: Print$2,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Ces codes sont comme la clé de votre bureau - gardez-les dans un endroit sûr auquel vous seul pouvez accéder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilisez l'un de ces codes lorsque cet appareil est inaccessible. Imprimez ou enregistrez les codes dans un emplacement sécurisé. Chaque code ne peut être utilisé qu'une seule fois, mais d'autres codes peuvent être générés dans votre profil de compte.",
    "You can generate more codes by signing in and accessing your profile.": "Vous pouvez générer plus de codes en vous connectant et en accédant à votre profil.",
    "Error copying emergency codes to the clipboard.": "Erreur lors de la copie des codes d'urgence dans le presse-papiers.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Saisissez le code d'authentification affiché par votre appareil multifacteurs ou qui vous a été fourni.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "You have set up the following multi-factor methods:": "Vous avez configuré les méthodes multifacteurs suivantes :",
    "Device ID": "Identifiant d'appareil",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Saisissez l'identifiant d'appareil à 9 caractères commençant par les lettres TR à l'arrière de votre carte Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Saisissez le code unique affiché sur votre appareil multifacteurs.",
    "Learn more about multi-factor devices": "Pour en savoir plus sur les appareils multifacteurs",
    "Use a multi-factor device": "Utilisez un appareil multifacteurs",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilisez un appareil multifacteur comme une carte qui affiche un code à saisir.",
    "Validate your multi-factor device": "Validez votre appareil multifacteurs",
    "Incorrect Device ID or Code. Please try again.": "Identifiant d'appareil ou code incorrect. Veuillez réessayer.",
    "Thomson Reuters Authenticator Card": "Carte Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Enregistrer les codes d'accès d'urgence",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Enregistrez ou imprimez ces codes dans un emplacement sécurisé pour pouvoir les utiliser lorsque votre périphérique d'AFM principal n'est pas disponible (par exemple, si vous avez un nouveau téléphone). Vous ne pouvez utiliser chaque code qu'une seule fois, mais vous pouvez générer plus de codes dans votre profil de compte.",
    or: or$2,
    Download: Download$1,
    "Learn more about Emergency Access Codes": "Pour en savoir plus sur les codes d'accès d'urgence",
    "Sign-in Help": "Aide relative à la connexion",
    "System Status": "État du système",
    "Your Browser is not supported": "Votre navigateur n’est pas pris en charge",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Pour vous connecter à Onvio, veuillez utiliser un des navigateurs Internet pris en charge ci-dessous.",
    "Your firm's license is no longer active. Please contact your administrator.": "La licence de votre cabinet n'est plus active. Veuillez communiquer avec votre administrateur.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Veuillez saisir un mot de passe valide. Votre mot de passe ne peut pas contenir de renseignements personnels associés à votre compte.",
    "Your firm's license is inactive": "La licence de votre cabinet est inactive",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Reportez-vous au Centre <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> d'aide et de documentation </a> pour connaître les solutions possibles.",
    "Acknowledge and Ignore Warning": "Confirmer et ignorer l'avertissement",
    "Contact your Onvio administrator.": "Contactez votre administrateur Onvio.",
    "Contact your administrator.": "Contactez votre administrateur.",
    "Email Address": "Adresse courriel",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fin de la prise en charge de Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Commençons",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Annonce de Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Annonce de Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio nécessite une vérification en deux étapes. Vous n'avez qu'à le configurer une seule fois, et cela ne prendra pas longtemps.",
    "Password contains prohibited characters": "Le mot de passe contient des caractères interdits",
    "Please close this window and try again.": "Veuillez fermer cette fenêtre et essayer de nouveau.",
    "Read about account security": "En savoir plus sur la sécurité du compte",
    "Secure your account": "Sécuriser votre compte",
    "Set up two-step verification": "Configurer la vérification en deux étapes",
    "Sign back in": "Se reconnecter",
    "Sign in": "Se connecter",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters ne prendra plus en charge ses produits sur les systèmes d'exploitation Windows 7 ou Windows Server 2008 ou 2008 R2 à compter du 14 janvier 2020. Nous vous invitons vivement à mettre à niveau tous les postes de travail ou serveurs nécessitant l'accès aux produits Thomson Reuters vers un système d'exploitation pris en charge avant le 14 janvier 2020. Vous trouverez plus d'informations sur les liens ci-dessous :",
    "View system status": "Afficher l’état du système",
    "You don't have access": "Vous n'avez pas accès",
    "You're signed out": "Vous êtes déconnecté",
    "You don't have access to this product": "Vous n'avez pas accès à ce produit",
    "Select the module you wish to access and try again": "Sélectionnez le module auquel vous souhaitez accéder et réessayez :",
    "Client Center": "Centre-Client",
    "Employee Portal": "Portail des employés"
  };

  var Password$3 = "Wachtwoord";
  var Back$3 = "Terug";
  var OK$3 = "OK";
  var Reset$3 = "Resetten";
  var Retry$3 = "Opnieuw proberen";
  var Cancel$3 = "Annuleren";
  var Next$3 = "Volgende";
  var Go$3 = "Volgende";
  var Close$2 = "Afsluiten";
  var Done$3 = "Gereed";
  var Choose$3 = "Selecteer";
  var Code$3 = "Code";
  var Finish$3 = "Afwerking";
  var Copy$3 = "Kopiëren";
  var Print$3 = "Afdrukken";
  var nlNL = {
    "Email Address (Thomson Reuters ID)": "E-mailadres (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Meld u aan met uw Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Uw Thomson Reuters ID is het e-mailadres dat u gebruikt om u aan te melden bij uw Onvio- en / of CS Web-account (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Meld u aan met uw NetStaff CS account",
    Password: Password$3,
    "Reset Password": "Wachtwoord Resetten",
    "Manage Account": "Account beheren",
    "CS Professional Suite Security Help": "Helpfunctie Beveiliging CS Professional Suite",
    "Need an account? Contact your administrator": "Heeft u een account nodig? Neem contact op met uw beheerder",
    "ONVIO Sign In Security Help": "Helpfunctie Beveiliging ONVIO Inloggen",
    "Need an account? Please create a new account": "Heeft u een account nodig? Maak een nieuw account aan",
    "Internet Access Required": "Internetverbinding vereist",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Om de vertrouwelijke gegevens van uw kantoor en uw klanten te helpen beschermen en ter naleving van de nieuwe IRS-vereisten, voegt Thomson Reuters gebruikersnamen en wachtwoorden toe om toegang te krijgen tot onze Belasting &amp; Boekhouding producten.",
    "To sign in, please connect this computer to the internet then restart the application.": "Om in te loggen, verbind deze computer met het internet en herstart de toepassing.",
    "Learn more about these new security measures.": "Meer informatie over deze nieuwe beveiligingsmaatregelen.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Om voor uw kantoor toegang te krijgen tot deze software, dient een van uw kantoorbeheerders uw accounts te upgraden voor <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Meer Informatie Over Nieuwe Beveiligingsmaatregelen",
    "Please enter your email address.": "Voer uw e-mailadres in.",
    "Please enter your login and email address.": "Voer uw login en e-mailadres in.",
    Back: Back$3,
    "Reset My Password": "Reset mijn wachtwoord",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructies voor het resetten van uw wachtwoord zijn naar uw geregistreerde e-mailadres verzonden.",
    "Go To Sign In": "Ga naar inloggen",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Maak een nieuw wachtwoord dat voldoet aan de <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Je wachtwoord is verlopen. Maak een nieuwe die voldoet aan de <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Uw wachtwoord <strong>moet</strong> minstens <span>8 tekens</span> met inbegrip van alle van de volgende:",
    "At least 1 uppercase letter (A-Z)": "Ten minste 1 hoofdletter (A-Z)",
    "At least 1 lowercase letter (a-z)": "Ten minste 1 kleine letter (a-z)",
    "At least 1 digit (0-9)": "Ten minste 1 getal (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Ten minste 1 symbool (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Uw wachtwoord moet <strong>niet</strong> bevatten:",
    "Leading or trailing spaces": "Spaties ervoor of erna",
    "Words from the dictionary": "Woorden uit het woordenboek",
    "Your user ID": "Uw gebruikers-ID",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Opeenvolgende letters of getallen zoals \"abc\" or \"123\"",
    "Show typing": "Typen tonen",
    "Hide typing": "Typen verbergen",
    "New Password": "Nieuw wachtwoord",
    "Confirm New Password": "Bevestig nieuw wachtwoord",
    "Change My Password": "Wijzig mijn wachtwoord",
    "You've successfully changed your password.": "U hebt uw wachtwoord met succes gewijzigd.",
    OK: OK$3,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inloggen</a> en uw wachtwoord te wijzigen.",
    "Back To Sign In": "Terug Naar Inloggen",
    "Unlocking your account.": "Bezig met het ontgrendelen van uw account.",
    "Your password will expire soon": "Uw wachtwoord zal binnenkort vervallen",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Uw wachtwoord zal verlopen in <em id=\"trta1-pwdexpdays\">2</em> dagen.",
    "Your password will expire in <em>1</em> day.": "Uw wachtwoord vervalt over <em>1</em> dag.",
    "Your password will expire <em>today</em>.": "Uw wachtwoord vervalt <em>vandaag</em>.",
    "Do you want to change it now?": "Wilt u het nu wijzigen?",
    "Change my password": "Wijzig mijn wachtwoord",
    "Do it later": "Doe het later",
    "Your session is ending soon": "Uw sessie zal spoedig vervallen",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$3,
    "Multi-factor authentication required": "Multi-factor authenticatie is vereist",
    "Your firm now requires all staff and administrators to sign in with multi-factor authentication.": "Uw kantoor vereist nu dat alle personeelsleden en beheerders inloggen met multi-factor authenticatie.",
    "You need to set up multi-factor authentication before continuing.": "U dient multi-factor authenticatie in te stellen voordat u verder gaat.",
    "Set Up Now": "Stel Nu In",
    "Finding your paired device.": "Zoeken naar uw gekoppelde apparaat.",
    Retry: Retry$3,
    "Notifying your paired device.": "Bezig met het sturen van een melding naar uw gekoppelde apparaat.",
    "Check your device!": "Controleer uw apparaat!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Uw verzoek goedkeuren<br> in de Thomson Reuters Authenticator app",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">voer code in</a>",
    "No phone? Contact your firm's administrator": "Geen telefoon? Neem contact op met uw kantoorbeheerder",
    "Cancel Request": "Verzoek annuleren",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of",
    "Enter code": "Code invoeren",
    "Retrieving authentication token.": "Bezig met het ophalen van authenticatietoken.",
    "Success!": "Succes!",
    "You've been authenticated.": "U bent geauthenticeerd.",
    "Please wait while we sign you into your account…": "Even geduld tewijl wij u inloggen op uw account…",
    "Multifactor authentication is currently unavailable.": "Multifactor authenticatie is op dit moment niet beschikbaar.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "U gebruikt een <strong>verouderde</strong> browser. Upgrade uw browser om de bescherming te verbeteren.",
    "Multi-factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Verbeter de beveiliging van uw account</strong> Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Hoe lang duurt het om dit in te stellen?</strong> Minuten.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Welke consequenties heeft dit voor mij?</strong> U dient elk inlogverzoek op uw smartphone één keer per dag goed te keuren, en elke keer nadat u bent uitgelogd.",
    Cancel: Cancel$3,
    "Get Started": "Aan de slag",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installeer de Thomson Reuters Authenticator app op uw smartphone of tablet.",
    "Download on the Apple App Store": "Downloaden in de Apple App Store",
    "Get it on Google Play": "Downloaden via Google Play",
    Next: Next$3,
    "Generating QR code.": "Bezig met het genereren van de QR-code.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Open de Thomson Reuters Authenticator app en scan de hieronder vermelde QR-code hieronder.",
    "Retrieving device info.": "Bezig met het ophalen van apparaatgegevens.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "U hebt uw account gekoppeld aan <strong id=\"trta1-mfs-devicename\">dit apparaat</strong>. U dient elke inlogpoging op dit apparaat eenmaal per dag en na elke keer dat u uitlogt goed te keuren.",
    "Got It": "Begrepen",
    "Please wait…": "Even geduld…",
    "Enter your authentication code": "Voer uw authenticatiecode in",
    "Invalid code. Please enter a valid authentication code.": "Ongeldige code. Voer een geldige authenticatiecode in.",
    "Enter the code provided by your adminstrator": "Voer de door uw beheerder verstrekte code in",
    "Set up your mobile device": "Stel uw mobiele apparaat in",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Wachtwoord moet minimaal 8 tekens bevatten en tenminste één hoofdletter, een kleine letter, een cijfer en een symbool bevatten, zonder voor- of achterliggende spaties.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect e-mailadres of wachtwoord. Probeer het opnieuw.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Te veel aanmeldpogingen. Controleer voor ontvangst van een ontgrendel e-mail of probeer het later.",
    "Please change your password.": "Wijzig alstublieft uw wachtwoord.",
    "Please complete the required fields.": "Vul alstublieft de vereiste velden in.",
    "Deactivated account. Contact your administrator or accountant.": "Uw account is gedeactiveerd. Neem contact op met uw beheerder.",
    "There was an error sending the email. Please try again.": "Er is een fout opgetreden bij het versturen van de e-mail. Probeer het opnieuw.",
    "Please choose a password you have not already used.": "Kies alstublieft een wachtwoord dat u nog niet hebt gebruikt.",
    "Your account has been unlocked.": "Uw account is ontgrendeld.",
    "You've been signed out due to inactivity. Sign in to resume.": "Je bent uitgelogd vanwege inactiviteit. Log in om door te gaan.",
    "You've exceeded maximum usage time. Please sign in again.": "U heeft de maximale gebruikstijd overschreden. Log opnieuw in.",
    "Incorrect Login or Password. Please try again.": "Onjuiste gebruikersnaam of wachtwoord. Probeer het opnieuw.",
    "Missing data required to reset password. Please try again.": "Ontbrekende gegevens die nodig zijn om wachtwoord te resetten. Probeer het opnieuw.",
    "Missing data required to unlock account. Please try again.": "Ontbrekende gegevens die nodig zijn om het account te ontgrendelen. Probeer het opnieuw.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Wachten op apparaat goedkeuring time-out. Stuur melding opnieuw of voer code in.",
    "Invalid code. Please try again.": "Ongeldige code. Probeer het opnieuw.",
    "Passwords Don't Match": "Wachtwoorden komen niet overeen",
    "Please wait.": "Even geduld aub.",
    "An unexpected error occurred. Please try again.": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    "An unexpected error occurred while redirecting your request.": "Er is een onverwachte fout opgetreden tijdens het doorverwijzen van uw aanvraag.",
    "The server did not respond in time. Please try again.": "De server reageerde niet op tijd. Probeer het opnieuw.",
    "An error occurred with your request. Please try again.": "Er is een fout opgetreden bij uw aanvraag. Probeer het opnieuw.",
    "Please provide a valid {{label}}.": "Geef een geldige {{label}} op.",
    "{{label}} is required.": "{{label}} is verplicht.",
    "Timed out waiting for scan. Please go back and try again.": "Wachten op scan timed-out. Ga terug en probeer het opnieuw.",
    "Your account is locked. Please contact your administrator.": "Uw account is geblokkeerd. Neem contact op met uw beheerder.",
    Go: Go$3,
    "Sorry, there was an issue on our end. Please try again.": "Sorry, was er een probleem aan onze kant. Probeer het opnieuw.",
    "Your registration link has expired. Please contact the firm for a new one.": "Uw registratielink is vervallen. Neem contact op met uw kantoor voor een nieuwe.",
    "Make your account even more secure!": "Maak uw account nog veiliger!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Voeg een extra beveiligingsniveau toe voor het geval dat uw wachtwoord ooit gecompromitteerd raakt. Bevestig uw identiteit met behulp van uw mobiele apparaat.",
    "Learn more about multi-factor authentication.": "Meer informatie over multi-factor authenticatie.",
    "Remind Me Later": "Herinner Me Later",
    Close: Close$2,
    Done: Done$3,
    "Update Password": "Wachtwoord Updaten",
    "Please enter your email address to update your password.": "Vul uw e-mailadres in om uw wachtwoord te updaten.",
    "Sign In": "Inloggen",
    "Please provide a valid password.": "Voer een geldig wachtwoord in.",
    "Password contains prohibited characters.": "Wachtwoord bevat verboden tekens.",
    "Password is too similar to a common or blacklisted password.": "Dit wachtwoord lijkt te veel op een gemeen of op de zwarte lijst gezet wachtwoord.",
    "Ignore warning": "Waarschuwing negeren",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Uw browser wordt niet ondersteund voor gebruik met deze applicatie. Probeer het opnieuw met de nieuwste versie van een van de volgende browsers.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Het gebruik van een browser die niet meer door de leverancier wordt ondersteund, is een beveiligingsrisico. Klik op een van de onderstaande links om een upgrade naar een huidige browser uit te voeren.",
    "Your Browser is Outdated": "Uw browser is verouderd",
    "A few minutes.": "Een paar minuten?",
    "After installing and opening the app, click Next.": "Klik na het installeren en openen van de app op Volgende.",
    Choose: Choose$3,
    "Choose multi-factor option": "Kies een multi-factor optie",
    Code: Code$3,
    "Download and install Thomson Reuters Authenticator app": "Download en installeer de app Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Download en installeer een alternatieve multi-factor-app",
    "Enter the authentication code displayed by the Authenticator app.": "Voer de verificatiecode in die wordt weergegeven door de Authenticator-app.",
    "Enter the code displayed by your alternate multi-factor app.": "Voer de code in die wordt weergegeven door uw alternatieve multi-factor app.",
    Finish: Finish$3,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Voor uw bedrijf om toegang tot deze software te krijgen, moet een van de beheerders van uw bedrijf uw accounts upgraden op <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Hoe lang duurt het om dit in te stellen?",
    "How will this affect me?": "Welke consequenties heeft dit voor mij?",
    "Increase security for your account": "Verhoog de beveiliging voor uw account",
    "Invalid value entered.": "Ongeldige waarde ingevoerd.",
    "Learn more about third-party MFA apps": "Meer informatie over MFA-apps van derden",
    "Learn which MFA option is right for you": "Ontdek welke MFA-optie voor u geschikt is",
    "My Multi-Factor App": "Mijn Multi-Factor-app",
    "Name this multi-factor option": "Noem deze multi-factoroptie",
    "Need an account? Contact your administrator.": "Heeft u een account nodig? Neem contact op met uw beheerder.",
    "Need an account? Create one now.": "Heeft u een account nodig? Maak deze nu aan.",
    "Next steps after setting up MFA": "Volgende stappen na het instellen van MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Open de app store op uw mobiele apparaat en download en installeer de app <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de <b>Thomson Reuters Authenticator-app</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "Pairing Successful!": "koppeling was succesvol.",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Verbeter de beveiliging van uw account Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Ontvang meldingen op uw mobiele apparaat en log in met één aanraking.",
    "Registering your device.": "Uw apparaat registreren.",
    "Scan Code": "scancode",
    "Step 1": "Stap 1",
    "Step 2": "Stap 2",
    "Tell me how": "Vertel me hoe",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "De alternatieve methode moet op tijd gebaseerd eenmalig wachtwoord (TOTP) zijn. Download nu op de <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> of <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Voor deze optie moet u elke keer dat u inlogt een code invoeren.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Gebruik Thomson Reuters Authenticator (aanbevolen)",
    "Use a third-party multi-factor app": "Gebruik een multi-factor app van derden",
    "Use your alternate multi-factor app to scan the code below.": "Gebruik uw alternatieve multi-factor app om de onderstaande code te scannen.",
    "Validate your alternate multi-factor app": "Valideer uw alternatieve multi-factor-app",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "U kunt Thomson Reuters Authenticator gebruiken (aanbevolen) of een andere app met meerdere factoren.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "U hebt multi-factor authenticatie voor uw account ingesteld. U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">in te loggen</a> en uw wachtwoord te wijzigen.",
    Copy: Copy$3,
    "Emergency Access Codes": "Noodtoegangscodes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Noodcodes gekopieerd naar het klembord om op een veilige plek te plakken.",
    "Generating emergency codes.": "Alarmcodes genereren.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Als u de toegang tot uw mobiele apparaat verliest, kunt u een van deze noodcodes gebruiken om u aan te melden bij uw account. Elke code mag slechts één keer worden gebruikt.",
    "Missing firmId parameter.": "Ontbrekende firmId-parameter.",
    "Multi-Factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    Print: Print$3,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Deze codes zijn als de sleutel tot uw kantoor - bewaar ze op een veilige plek die alleen toegankelijk is voor u!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Gebruik een van deze codes wanneer dit apparaat niet toegankelijk is. Druk de codes af of sla ze op naar een veilige locatie. Elke code kan slechts één keer worden gebruikt, maar er kunnen meer codes in uw accountprofiel worden gegenereerd.",
    "You can generate more codes by signing in and accessing your profile.": "U kunt meer codes genereren door u aan te melden en toegang te krijgen tot uw profiel.",
    "Error copying emergency codes to the clipboard.": "Fout bij het kopiëren van noodcodes naar het klembord.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Voer de verificatiecode in die wordt weergegeven door uw multi-factor apparaat of aan u wordt verstrekt.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de app <b>Thomson Reuters Authenticator</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "You have set up the following multi-factor methods:": "U hebt de volgende multifactormethoden ingesteld:"
  };

  var Password$4 = "Senha";
  var Back$4 = "Voltar";
  var OK$4 = "OK";
  var Reset$4 = "Redefinir";
  var Retry$4 = "Tentar novamente";
  var Cancel$4 = "Cancelar";
  var Next$4 = "Avançar";
  var Go$4 = "Continuar";
  var Close$3 = "Fechar";
  var Done$4 = "Concluído";
  var Choose$4 = "Escolher";
  var Code$4 = "Código";
  var Finish$4 = "Finalizar";
  var Copy$4 = "Copiar";
  var Print$4 = "Imprimir";
  var or$3 = "ou";
  var Download$2 = "Download";
  var ptBR = {
    "Email Address (Thomson Reuters ID)": "Endereço de E-mail (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Logue com seu Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Seu Thomson Reuters ID é o endereço de e-mail que você utiliza para logar em sua conta Onvio e/ou CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Logue com seu NetStaff CS conta",
    Password: Password$4,
    "Reset Password": "Redefinir Senha",
    "Manage Account": "Gerenciar Conta",
    "CS Professional Suite Security Help": "Ajuda sobre Segurança do CS Professional Suite",
    "Need an account? Contact your administrator": "Precisa de uma conta? Entre em contato com seu administrador",
    "ONVIO Sign In Security Help": "Ajuda sobre Segurança de Registro do ONVIO",
    "Need an account? Please create a new account": "Precisa de uma conta? Crie uma conta nova",
    "Internet Access Required": "Acesso à Internet Exigido",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Para ajudar a proteger os dados confidenciais que pertencem à sua empresa e a seus clientes, e cumprir com os novos requisitos de IRS, a Thomson Reuters está adicionando nomes de usuário e senhas para acessar nossos produtos Tributários &amp; Contábeis.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para se registrar, conecte este computador à Internet e, em seguida, reinicie o aplicativo.",
    "Learn more about these new security measures.": "Saiba mais sobre essas novas medidas de segurança.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que sua empresa acesse esse software, um dos administradores da sua empresa precisa fazer upgrade de suas contas em <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Saiba Mais sobre Novas Medidas de Segurança",
    "Please enter your email address.": "Insira seu endereço de e-mail.",
    "Please enter your login and email address.": "Insira seu login e endereço de e-mail.",
    Back: Back$4,
    "Reset My Password": "Redefinir Minha Senha",
    "Instructions for resetting your password have been sent to your registered email address.": "Instruções para a redefinição da sua senha foram enviadas para seu endereço de e-mail registrado.",
    "Go To Sign In": "Ir para Login",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, crie uma nova senha que atenda <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Sua senha expirou. Por favor, crie uma nova que atenda <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Sua senha <strong>deve</strong> ter <span>pelo menos 8 caracteres</span>, incluindo todos os seguintes:",
    "At least 1 uppercase letter (A-Z)": "Pelo menos 1 letra maiúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Pelo menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Pelo menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Pelo menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Sua senha <strong>não</strong> deve conter:",
    "Leading or trailing spaces": "Espaços iniciais ou finais",
    "Words from the dictionary": "Palavras do dicionário",
    "Your user ID": "Sua identificação de usuário",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras ou números sequenciais como \"abc\" or \"123\"",
    "Show typing": "Exibir digitação",
    "Hide typing": "Ocultar digitação",
    "New Password": "Nova Senha",
    "Confirm New Password": "Confirmar Nova Senha",
    "Change My Password": "Alterar Minha Senha",
    "You've successfully changed your password.": "Você alterou sua senha com êxito.",
    OK: OK$4,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Sua senha precisa ser atualizada. Por favor <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">login</a> e altere sua senha.",
    "Back To Sign In": "Retornar ao Login",
    "Unlocking your account.": "Desbloqueio da sua conta.",
    "Your password will expire soon": "Sua senha expirará em breve",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Sua senha expirará em <em id=\"trta1-pwdexpdays\">2</em> dias.",
    "Your password will expire in <em>1</em> day.": "Sua senha expirará em <em>1</em> dia.",
    "Your password will expire <em>today</em>.": "Sua senha expirará <em>hoje</em>.",
    "Do you want to change it now?": "Deseja alterá-la agora?",
    "Change my password": "Alterar minha senha",
    "Do it later": "Fazer isso depois",
    "Your session is ending soon": "Sua sessão será encerrada em breve",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$4,
    "Multi-factor authentication required": "Autenticação multifatores exigida",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "O escritório exige que você habilite a autenticação multi-fatores antes de fazer login. Por favor, complete o assistente de configuração de autenticação multi-fatores para continuar.",
    "Set Up Now": "Configurar Agora",
    "Finding your paired device.": "Localização do seu dispositivo emparelhado.",
    Retry: Retry$4,
    "Notifying your paired device.": "Notificar seu dispositivo emparelhado.",
    "Check your device!": "Verifique seu dispositivo!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprovar sua solicitação<br> no aplicativo Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">insira o código</a>",
    "No phone? Contact your firm's administrator": "Está sem telefone? Entre em contato com o administrador da empresa",
    "Cancel Request": "Cancelar Solicitação",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou",
    "Enter code": "Inserir código",
    "Retrieving authentication token.": "Recuperação do token de autenticação.",
    "Success!": "Sucesso!",
    "Continue to sign in page": "Continuar para a página de cadastro",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You've been authenticated.": "Você foi autenticado.",
    "Please wait while we sign you into your account…": "Espere enquanto registramos você em sua conta...",
    "Multifactor authentication is currently unavailable.": "No momento, a autenticação multifatores está indisponível.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Você está usando um navegador <strong>desatualizado</strong>. Por favor, atualize seu navegador para aprimorar a segurança.",
    "Multi-factor Authentication Setup": "Configuração da Autenticação Multifatores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Aumente a segurança da sua conta</strong> Senhas podem ser hackeadas, mas o uso da autenticação multifatores acrescenta outra camada de segurança à sua conta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Quanto tempo demorará para configurar?</strong> Minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Como isso irá me afetar?</strong> Você precisará aprovar cada solicitação de login em seu smartphone uma vez por dia e depois de cada logout.",
    Cancel: Cancel$4,
    "Get Started": "Iniciar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale o aplicativo Thomson Reuters Authenticator em seu smartphone ou tablet.",
    "Download on the Apple App Store": "Fazer Download na Apple App Store",
    "Get it on Google Play": "Obtê-lo no Google Play",
    Next: Next$4,
    "Generating QR code.": "Geração do código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra o aplicativo Thomson Reuters Authenticator e digitalize o código QR abaixo.",
    "Retrieving device info.": "Recuperação das informações do dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Você emparelhou sua conta com <strong id=\"trta1-mfs-devicename\">nesse dispositivo</strong>. Você precisará aprovar cada solicitação de login nesse dispositivo uma vez por dia e depois de cada vez que você desconectar.",
    "Got It": "Entendi",
    "Please wait…": "Aguarde...",
    "Enter your authentication code": "Insira seu código de autenticação",
    "Invalid code. Please enter a valid authentication code.": "Código inválido. Insira um código de autenticação válido.",
    "Enter the code provided by your adminstrator": "Inserir o código fornecido pelo seu administrador",
    "Set up your mobile device": "Configurar seu dispositivo móvel",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "A senha deve ter um mínimo de 8 caracteres e conter pelo menos uma letra maiúscula, uma letra minúscula, um dígito e um símbolo, sem espaços no conteúdo.",
    "Incorrect Email Address or Password. Please try again.": "Endereço de email ou senha incorretos. Por favor, tente novamente.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Muitas tentativas de login. Verifique se há e-mail de desbloqueio ou tente mais tarde.",
    "Please change your password.": "Por favor, altere sua senha.",
    "Please complete the required fields.": "Complete os campos obrigatórios.",
    "Deactivated account. Contact your administrator or accountant.": "Conta desativada. Contate o usuário administrador ou seu contador.",
    "There was an error sending the email. Please try again.": "Ocorreu um erro ao enviar o e-mail. Por favor, tente novamente.",
    "Please choose a password you have not already used.": "Escolha uma senha que você ainda não usou.",
    "Your account has been unlocked.": "Sua conta foi desbloqueada.",
    "You've been signed out due to inactivity. Sign in to resume.": "Você foi desconectado devido à inatividade. Faça login para continuar.",
    "You've exceeded maximum usage time. Please sign in again.": "Você excedeu o tempo máximo de uso. Faça login novamente.",
    "Incorrect Login or Password. Please try again.": "Login ou senha incorretos. Por favor, tente novamente.",
    "Missing data required to reset password. Please try again.": "Faltam dados obrigatórios para redefinir a senha. Por favor, tente novamente.",
    "Missing data required to unlock account. Please try again.": "Faltam dados obrigatórios para desbloquear sua conta. Por favor, tente novamente.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tempo de espera esgotado para aprovação do dispositivo. Reenvie a notificação ou insira o código.",
    "Invalid code. Please try again.": "Código inválido. Por favor, tente novamente.",
    "Passwords Don't Match": "As senhas não coincidem",
    "Please wait.": "Por favor, espere.",
    "An unexpected error occurred. Please try again.": "Um erro inesperado ocorreu. Por favor, tente novamente.",
    "An unexpected error occurred while redirecting your request.": "Ocorreu um erro inesperado ao redirecionar sua solicitação.",
    "The server did not respond in time. Please try again.": "O servidor não respondeu a tempo. Por favor, tente novamente.",
    "An error occurred with your request. Please try again.": "Ocorreu um erro com sua solicitação. Por favor, tente novamente.",
    "Please provide a valid {{label}}.": "Forneça um {{label}} válido.",
    "{{label}} is required.": "{{label}} é requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tempo de espera esgotado para varredura. Por favor volte e tente novamente.",
    "Your account is locked. Please contact your administrator.": "Sua conta foi bloqueada. Entre em contato com o administrador.",
    Go: Go$4,
    "Sorry, there was an issue on our end. Please try again.": "Desculpe, ocorreu um problema do nosso lado. Por favor, tente novamente.",
    "Your registration link has expired. Please contact the firm for a new one.": "Seu link de registro expirou. Entre em contato com a firma para obter um novo.",
    "Make your account even more secure!": "Torne sua conta ainda mais segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Adicione um nível extra de segurança para caso sua senha seja comprometida. Confirme a sua identidade usando seu dispositivo móvel.",
    "Learn more about multi-factor authentication.": "Saiba mais sobre a autenticação de dois fatores.",
    "Remind Me Later": "Lembrar Mais Tarde",
    Close: Close$3,
    Done: Done$4,
    "Update Password": "Atualizar Senha",
    "Please enter your email address to update your password.": "Por favor, informe seu endereço de e-mail para atualizar sua senha.",
    "Sign In": "Entrar",
    "Please provide a valid password.": "Forneça uma senha válida.",
    "Password contains prohibited characters.": "A senha contém caracteres proibidos.",
    "Password is too similar to a common or blacklisted password.": "Esta senha é muito comum ou considerada como insegura.",
    "Ignore warning": "Ignorar aviso",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Seu navegador não é compatível para uso desta aplicação. Por favor, tente novamente usando a versão mais recente de um dos navegadores seguintes.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Utilizar um navegador que não possui mais suporte pelo fornecedor é um risco a segurança. \n Clique em um dos links abaixo para atualizar para um navegador atual.",
    "Your Browser is Outdated": "Seu navegador está desatualizado",
    "A few minutes.": "Em alguns minutos",
    "After installing and opening the app, click Next.": "Depois de instalar e abrir o aplicativo, clique em Avançar.",
    Choose: Choose$4,
    "Choose multi-factor option": "Escolha a opção multi-fatores",
    Code: Code$4,
    "Download and install Thomson Reuters Authenticator app": "Baixe e instale o aplicativo Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Baixe e instale um aplicativo de autentificação multi-fatores alternativo",
    "Enter the authentication code displayed by the Authenticator app.": "Digite o código de autenticação exibido pelo aplicativo Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Digite o código exibido pelo seu aplicativo multi-fatores alternativo.",
    Finish: Finish$4,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para sua empresa acessar esse software, um dos administradores do seu escritório precisa fazer a atualização das suas contas em <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Quanto tempo demorará para configurar?",
    "How will this affect me?": "Como isso irá me afetar?",
    "Increase security for your account": "Aumentar a segurança da sua conta",
    "Invalid value entered.": "Valor inválido digitado",
    "Learn more about third-party MFA apps": "Saiba mais sobre aplicativos MFA de terceiros",
    "Learn which MFA option is right for you": "Saiba qual é a opção de MFA certa para você",
    "My Multi-Factor App": "Meu aplicativo multi-fatores",
    "Name this multi-factor option": "Nomeie esta opção multi-fatores",
    "Need an account? Contact your administrator.": "Precisa de uma conta? Entre em contato com seu administrador",
    "Need an account? Create one now.": "Precisa de uma conta? Criar uma agora",
    "Next steps after setting up MFA": "Próximas etapas após configurar o MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "No seu dispositivo móvel, abra a loja de aplicativos, baixe e instale o aplicativo <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o <b>aplicativo Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para verificar o código abaixo.",
    "Pairing Successful!": "Emparelhamento bem sucedido!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Senhas podem ser hackeadas, mas o uso da autenticação multi-fatores acrescenta outra camada de segurança à sua conta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Receba notificações no seu dispositivo móvel e faça login com um único toque.",
    "Registering your device.": "Registrando seu dispositivo.",
    "Scan Code": "Digitalizar Código QR",
    "Step 1": "Passo 1",
    "Step 2": "Passo 2",
    "Tell me how": "Me diga como",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "O método alternativo deve ser compatível geração de chaves de validação baseadas no tempo (TOTP). Faça o download agora no <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Essa opção exige que você insira um código toda vez que fizer login.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Use o Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Use um aplicativo de autenticação multi-fatores de terceiros",
    "Use your alternate multi-factor app to scan the code below.": "Use seu aplicativo de autenticação multi-fatores alternativo para digitalizar o código abaixo.",
    "Validate your alternate multi-factor app": "Valide seu aplicativo de autenticação multi-fatores alternativo",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Você pode usar o Thomson Reuters Authenticator (recomendado) ou um aplicativo de autenticação multi-fatores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Você configurou a autenticação multi-fatores para sua conta. Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Sua senha precisa ser atualizada. <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">Faça login</a> e altere sua senha.",
    Copy: Copy$4,
    "Emergency Access Codes": "Códigos de acesso de emergência",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Códigos de emergência copiados da área de transferência para colar em um local seguro.",
    "Generating emergency codes.": "Gerando códigos de emergência.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Se você perder o acesso no seu dispositivo móvel, poderá usar um desses códigos de emergência para fazer login na sua conta. Cada código pode ser usado apenas uma vez.",
    "Missing firmId parameter.": "Parâmetro de firmId ausente.",
    "Multi-Factor Authentication Setup": "Configuração da autenticação multi-fatores",
    Print: Print$4,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Esses códigos são como a chave do seu escritório - mantenha-os em um local seguro que só você pode acessar!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilize um desses códigos quando este dispositivo estiver inacessível. Imprima ou salve os códigos em um local seguro. Cada código só pode ser usado uma vez, mas mais códigos podem ser gerados no perfil da sua conta.",
    "You can generate more codes by signing in and accessing your profile.": "Você pode gerar mais códigos fazendo login e acessando seu perfil.",
    "Error copying emergency codes to the clipboard.": "Erro ao copiar códigos de emergência para a área de transferência.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Digite o código de autenticação exibido pelo seu dispositivo multi-fatores ou o código fornecido a você.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o aplicativo <b>Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para escanear o código abaixo.",
    "You have set up the following multi-factor methods:": "Você configurou os seguintes métodos de multi-fatores:",
    "Device ID": "ID do dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Digite o ID do dispositivo com 9 caracteres, começando com as letras TR na parte de trás do seu cartão do Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Digite o código único exibido no seu dispositivo multifator.",
    "Learn more about multi-factor devices": "Saiba mais sobre dispositivos multifator",
    "Use a multi-factor device": "Use um dispositivo multifator",
    "Use a multi-factor device like a card that displays a code to enter.": "Use um dispositivo multifator que exibe um código para inserir como um cartão.",
    "Validate your multi-factor device": "Valide seu dispositivo multifator",
    "Incorrect Device ID or Code. Please try again.": "ID ou código do dispositivo incorreto. Por favor, tente novamente.",
    "Thomson Reuters Authenticator Card": "Cartão do Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Salvar códigos de acesso de emergência",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Salve ou imprima esses códigos em um local seguro para uso quando seu dispositivo MFA principal estiver indisponível (por exemplo, se você estiver com um novo telefone). Você pode usar cada código apenas uma vez, mas pode gerar mais códigos no perfil da sua conta",
    or: or$3,
    Download: Download$2,
    "Learn more about Emergency Access Codes": "Saiba mais sobre códigos de acesso de emergência",
    "Sign-in Help": "Ajuda de Login",
    "System Status": "Status do sistema",
    "Your Browser is not supported": "Seu navegador não é suportado",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Para se conectar no Onvio, por favor utilize um dos navegadores suportados abaixo.",
    "Your firm's license is no longer active. Please contact your administrator.": "A licença do seu escritório não está mais ativa. Entre em contato com o administrador.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Por favor insira uma senha válida. Sua senha não pode conter informações pessoais associados à sua conta.",
    "Your firm's license is inactive": "A licença da sua empresa está inativa",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Consulte a <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Ajuda e Como Centralizar </a> para possíveis soluções",
    "Acknowledge and Ignore Warning": "Reconhecer e Ignorar Aviso",
    "Contact your Onvio administrator.": "Entre em contato com o administrador do Onvio.",
    "Contact your administrator.": "Entre em contato com o administrador.",
    "Email Address": "Endereço de E-mail",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fim do suporte para Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Vamos começar",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Comunicado do Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Anúncio do Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "O Onvio requer verificação em duas etapas. Você só tem que configurar isso uma vez, e não vai demorar muito.",
    "Password contains prohibited characters": "A senha contém caracteres proibidos",
    "Please close this window and try again.": "Feche esta janela e tente novamente.",
    "Read about account security": "Leia sobre a segurança da conta",
    "Secure your account": "Proteja a sua conta",
    "Set up two-step verification": "Configurar a verificação em duas etapas",
    "Sign back in": "Iniciar sessão novamente",
    "Sign in": "Entrar",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "A Thomson Reuters deixará de oferecer suporte a seus produtos em sistemas operacionais Windows 7 ou Windows Server 2008 ou 2008 R2 a partir de 14 de janeiro de 2020. Recomendamos vivamente que atualize quaisquer estações de trabalho ou servidores que necessitem de acesso aos produtos Thomson Reuters para um sistema operacional suportado antes de 14 de janeiro de 2020. Por favor, encontre mais informações nos links abaixo:",
    "View system status": "Situação do sistema",
    "You don't have access": "Você não tem acesso",
    "You're signed out": "Você está desconectado",
    "You don't have access to this product": "Você não tem acesso a este produto",
    "Select the module you wish to access and try again": "Selecione o produto que deseja acessar e tente novamente:",
    "Client Center": "Portal do Cliente",
    "Employee Portal": "Portal do Empregado"
  };

  var Back$5 = "Back";
  var Cancel$5 = "Cancel";
  var Choose$5 = "Choose";
  var Code$5 = "Code";
  var Copy$5 = "Copy";
  var Done$5 = "Done";
  var Finish$5 = "Finish";
  var Go$5 = "Go";
  var Next$5 = "Next";
  var OK$5 = "OK";
  var Password$5 = "Password";
  var Print$5 = "Print";
  var Reset$5 = "Reset";
  var Retry$5 = "Retry";
  var or$4 = "or";
  var enGB = {
    "A few minutes.": "A few minutes.",
    "Acknowledge and Ignore Warning": "Acknowledge and Ignore Warning",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.",
    "After installing and opening the app, click Next.": "After installing and opening the app, click Next.",
    "An error occurred with your request. Please try again.": "An error occurred with your request. Please try again.",
    "An unexpected error occurred while redirecting your request.": "An unexpected error occurred while redirecting your request.",
    "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approve your request<br> in the Thomson Reuters Authenticator app",
    "At least 1 digit (0-9)": "At least 1 digit (0-9)",
    "At least 1 lowercase letter (a-z)": "At least 1 lowercase letter (a-z)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)",
    "At least 1 uppercase letter (A-Z)": "At least 1 uppercase letter (A-Z)",
    Back: Back$5,
    "Back To Sign In": "Back To Sign In",
    "CS Professional Suite Security Help": "CS Professional Suite Security Help",
    Cancel: Cancel$5,
    "Cancel Request": "Cancel Request",
    "Change My Password": "Change My Password",
    "Change my password": "Change my password",
    "Check your device!": "Check your device!",
    Choose: Choose$5,
    "Choose multi-factor option": "Choose multi-factor option",
    Code: Code$5,
    "Confirm New Password": "Confirm New Password",
    Copy: Copy$5,
    "Contact your Onvio administrator": "Contact your Onvio administrator",
    "Deactivated account. Contact your administrator or accountant.": "Deactivated account. Contact your administrator or accountant.",
    "Device ID": "Device ID",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>",
    "Do it later": "Do it later",
    "Do you want to change it now?": "Do you want to change it now?",
    Done: Done$5,
    "Download and install Thomson Reuters Authenticator app": "Download and install Thomson Reuters Authenticator app",
    "Download and install an alternate multi-factor app": "Download and install an alternate multi-factor app",
    "Email Address": "Email Address",
    "Email Address (Thomson Reuters ID)": "Email Address (Thomson Reuters ID)",
    "Emergency Access Codes": "Emergency Access Codes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Emergency codes copied to the clipboard for pasting to a safe place.",
    "End of support for Windows 7, Server 2008 / 2008 R2": "End of support for Windows 7, Server 2008 / 2008 R2",
    "Enter code": "Enter code",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.",
    "Enter the authentication code displayed by the Authenticator app.": "Enter the authentication code displayed by the Authenticator app.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Enter the authentication code displayed by your multi-factor device or provided to you.",
    "Enter the code displayed by your alternate multi-factor app.": "Enter the code displayed by your alternate multi-factor app.",
    "Enter the one-time code displayed on your multi-factor device.": "Enter the one-time code displayed on your multi-factor device.",
    "Enter your authentication code": "Enter your authentication code",
    "Error copying emergency codes to the clipboard.": "Error copying emergency codes to the clipboard.",
    "Finding your paired device.": "Finding your paired device.",
    Finish: Finish$5,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "Generating QR code.": "Generating QR code.",
    "Generating emergency codes.": "Generating emergency codes.",
    "Get Started": "Get Started",
    "Let's get started": "Let's get started",
    Go: Go$5,
    "Go To Sign In": "Go To Sign In",
    "Hide typing": "Hide typing",
    "How long will it take to set up?": "How long will it take to set up?",
    "How will this affect me?": "How will this affect me?",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.",
    "Ignore warning": "Ignore warning",
    "Incorrect Device ID or Code. Please try again.": "Incorrect Device ID or Code. Please try again.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect Email Address or Password. Please try again.",
    "Incorrect Login or Password. Please try again.": "Incorrect Login or Password. Please try again.",
    "Increase security for your account": "Increase security for your account",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructions for resetting your password have been sent to your registered email address.",
    "Internet Access Required": "Internet Access Required",
    "Invalid code. Please try again.": "Invalid code. Please try again.",
    "Invalid value entered.": "Invalid value entered.",
    "Leading or trailing spaces": "Leading or trailing spaces",
    "Learn More About New Security Measures": "Learn More About New Security Measures",
    "Learn more about Emergency Access Codes": "Learn more about Emergency Access Codes",
    "Learn more about multi-factor authentication.": "Learn more about multi-factor authentication.",
    "Learn more about multi-factor devices": "Learn more about multi-factor devices",
    "Learn more about these new security measures.": "Learn more about these new security measures.",
    "Learn more about third-party MFA apps": "Learn more about third-party MFA apps",
    "Learn which MFA option is right for you": "Learn which MFA option is right for you",
    "Make your account even more secure!": "Make your account even more secure!",
    "Manage Account": "Manage Account",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Microsoft Window Server 2008 / 2008 R2 Announcement",
    "Microsoft Windows 7 Announcement": "Microsoft Windows 7 Announcement",
    "Missing data required to reset password. Please try again.": "Missing data required to reset password. Please try again.",
    "Missing data required to unlock account. Please try again.": "Missing data required to unlock account. Please try again.",
    "Missing firmId parameter.": "Missing firmId parameter.",
    "Multi-Factor Authentication Setup": "Multi-Factor Authentication Setup",
    "Multi-factor authentication required": "Multi-factor authentication required",
    "Multifactor authentication is currently unavailable.": "Multifactor authentication is currently unavailable.",
    "My Multi-Factor App": "My Multi-Factor App",
    "Name this multi-factor option": "Name this multi-factor option",
    "Need an account? Contact your administrator.": "Need an account? Contact your administrator.",
    "Need an account? Create one now.": "Need an account? Create one now.",
    "New Password": "New Password",
    Next: Next$5,
    "Next steps after setting up MFA": "Next steps after setting up MFA",
    "No phone? Contact your firm's administrator": "No phone? Contact your firm's administrator",
    "Notifying your paired device.": "Notifying your paired device.",
    OK: OK$5,
    "ONVIO Sign In Security Help": "ONVIO Sign In Security Help",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.",
    "Outdated Operating System Detected": "Outdated Operating System Detected",
    "Pairing Successful!": "Pairing Successful!",
    Password: Password$5,
    "Password contains prohibited characters": "Password contains prohibited characters",
    "Password is too similar to a common or blacklisted password.": "Password is too similar to a common or blacklisted password.",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.",
    "Passwords Don't Match": "Passwords Don't Match",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.",
    "Please change your password.": "Please change your password.",
    "Please choose a password you have not already used.": "Please choose a password you have not already used.",
    "Please complete the required fields.": "Please complete the required fields.",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Please enter your email address.": "Please enter your email address.",
    "Please enter your login and email address.": "Please enter your login and email address.",
    "Please provide a valid password.": "Please provide a valid password.",
    "Please provide a valid {{label}}.": "Please provide a valid {{label}}.",
    "Please wait while we sign you into your account…": "Please wait while we sign you into your account…",
    "Please wait.": "Please wait.",
    "Please wait…": "Please wait…",
    Print: Print$5,
    "Receive notifications on your mobile device and sign in with a single touch.": "Receive notifications on your mobile device and sign in with a single touch.",
    "Registering your device.": "Registering your device.",
    "Remind Me Later": "Remind Me Later",
    Reset: Reset$5,
    "Reset My Password": "Reset My Password",
    "Reset Password": "Reset Password",
    "Retrieving authentication token.": "Retrieving authentication token.",
    "Retrieving device info.": "Retrieving device info.",
    Retry: Retry$5,
    "Save Emergency Access Codes": "Save Emergency Access Codes",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile",
    "Scan Code": "Scan Code",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Sequential letters or numbers such as \"abc\" or \"123\"",
    "Set Up Now": "Set Up Now",
    "Show typing": "Show typing",
    "Sign back in": "Sign back in",
    "Sign In": "Sign In",
    "Sign in with your NetStaff CS account": "Sign in with your NetStaff CS account",
    "Sign in with your Thomson Reuters ID": "Sign in with your Thomson Reuters ID",
    "Sorry, there was an issue on our end. Please try again.": "Sorry, there was an issue on our end. Please try again.",
    "Your registration link has expired. Please contact the firm for a new one.": "Your registration link has expired. Please contact the firm for a new one.",
    "Step 1": "Step 1",
    "Step 2": "Step 2",
    "Success!": "Success!",
    "System Status": "System Status",
    "Tell me how": "Tell me how",
    "Continue to sign in page": "Continue to sign in page",
    "Sign in": "Sign in",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.",
    "The server did not respond in time. Please try again.": "The server did not respond in time. Please try again.",
    "There was an error sending the email. Please try again.": "There was an error sending the email. Please try again.",
    "These codes are like the key to your office - keep them in a safe place only you can access!": "These codes are like the key to your office - keep them in a safe place only you can access!",
    "This option requires you to enter a code each time you sign in.": "This option requires you to enter a code each time you sign in.",
    "Thomson Reuters": "Thomson Reuters",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Thomson Reuters Authenticator Card": "Thomson Reuters Authenticator Card",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:",
    "Timed out waiting for device approval. Resend notification or enter code.": "Timed out waiting for device approval. Resend notification or enter code.",
    "Timed out waiting for scan. Please go back and try again.": "Timed out waiting for scan. Please go back and try again.",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.",
    "To log in to Onvio, please use one of the supported internet browsers below.": "To log in to Onvio, please use one of the supported internet browsers below.",
    "To sign in, please connect this computer to the internet then restart the application.": "To sign in, please connect this computer to the internet then restart the application.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Too many sign in attempts. Please check for unlock email or try later.",
    "Unlocking your account.": "Unlocking your account.",
    "Use Thomson Reuters Authenticator (recommended)": "Use Thomson Reuters Authenticator (recommended)",
    "Use a multi-factor device": "Use a multi-factor device",
    "Use a multi-factor device like a card that displays a code to enter.": "Use a multi-factor device like a card that displays a code to enter.",
    "Use a third-party multi-factor app": "Use a third-party multi-factor app",
    "Use your alternate multi-factor app to scan the code below.": "Use your alternate multi-factor app to scan the code below.",
    "Validate your alternate multi-factor app": "Validate your alternate multi-factor app",
    "Validate your multi-factor device": "Validate your multi-factor device",
    "Words from the dictionary": "Words from the dictionary",
    "You can generate more codes by signing in and accessing your profile.": "You can generate more codes by signing in and accessing your profile.",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You have set up the following multi-factor methods:": "You have set up the following multi-factor methods:",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You're signed out": "You're signed out",
    "You've been authenticated.": "You've been authenticated.",
    "You've been signed out due to inactivity. Sign in to resume.": "You've been signed out due to inactivity. Sign in to resume.",
    "You've exceeded maximum usage time. Please sign in again.": "You've exceeded maximum usage time. Please sign in again.",
    "You've successfully changed your password.": "You've successfully changed your password.",
    "Your Browser is not supported": "Your Browser is not supported",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.",
    "Your account has been unlocked.": "Your account has been unlocked.",
    "Your account is locked. Please contact your administrator.": "Your account is locked. Please contact your administrator.",
    "Your firm's license is inactive": "Your firm's license is inactive",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.",
    "Your password should <strong>not</strong> use:": "Your password should <strong>not</strong> use:",
    "Your password will expire <em>today</em>.": "Your password will expire <em>today</em>.",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.",
    "Your password will expire in <em>1</em> day.": "Your password will expire in <em>1</em> day.",
    "Your password will expire soon": "Your password will expire soon",
    "Your session is ending soon": "Your session is ending soon",
    "Your session will end in:": "Your session will end in:",
    "Your user ID": "Your user ID",
    "You don't have access": "You don't have access",
    or: or$4,
    "{{label}} is required.": "{{label}} is required.",
    "Sign-in Help": "Sign-in Help",
    "View system status": "View system status",
    "Your firm's license is no longer active. Please contact your administrator.": "Your firm's license is no longer active. Please contact your administrator.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Please enter a valid password. Your password cannot contain personal information associated with your account.",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Centre </a> for possible solutions",
    "Contact your Onvio administrator.": "Contact your Onvio administrator.",
    "Contact your administrator.": "Contact your administrator.",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requires two-step verification. You only have to configure this once, and it won't take long.",
    "Please close this window and try again.": "Please close this window and try again.",
    "Read about account security": "Read about account security",
    "Secure your account": "Secure your account",
    "Set up two-step verification": "Set up two-step verification",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You don't have access to this product": "You do not have access to this product",
    "Select the module you wish to access and try again": "Select the product you wish to access and try again:",
    "Client Center": "Client Centre",
    "Employee Portal": "Employee Portal"
  };

  var locales = {
    'en-CA': enCA,
    'es-AR': esAR,
    'fr-CA': frCA,
    'nl-NL': nlNL,
    'pt-BR': ptBR,
    'en-GB': enGB
  };

  var template$1 = "<form name=\"trta1-mfs-choosetype\">\n  <h3 t8>Choose multi-factor option</h3>\n  <div class=\"trta1-form-instructions\">\n    <p t8>You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdt-only\" href=\"http://cs.thomsonreuters.com/ua/netfirm/admin_drtax_<%= dtHelpLocale %>/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n    </p>\n  </div>\n  <div class=\"trta1-carousel\">\n    <button class=\"trta1-carousel-left-nav\" aria-label=\"Previous options\">&lt;</button>\n    <ul>\n      <li class=\"mfs-choose-tr-auth-app trta1-carousel-item-selected\">\n        <h4 t8>Use Thomson Reuters Authenticator (recommended)</h4>\n        <div class=\"tr-auth-app-bg trta1-clearfix\">\n          <p t8>Receive notifications on your mobile device and sign in with a single touch.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-third-party-app\">\n        <h4 t8>Use a third-party multi-factor app</h4>\n        <div class=\"thirdparty-app-bg trta1-clearfix\">\n          <p t8>This option requires you to enter a code each time you sign in.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-3p-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-device\">\n        <h4 t8>Use a multi-factor device</h4>\n        <div class=\"device-bg trta1-clearfix\">\n          <p t8>Use a multi-factor device like a card that displays a code to enter.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-pairdevice\">Choose</button>\n        </div>\n      </li>\n    </ul>\n    <button class=\"trta1-carousel-right-nav\" aria-label=\"Next option\">&gt;</button>\n  </div>\n  <div class=\"trta1-carousel-pos-indicator\">\n  </div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-intro\" type=\"button\">Back</button></div>\n  </div>\n</form>\n";

  var CAROUSEL_ITEM_SELECTED_CLASS = 'trta1-carousel-item-selected';
  var CAROUSEL_POS_SELECTED_CLASS = 'trta1-carousel-pos-selected';

  function init$1(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-choosetype]');
    var carouselLeftNav = form.querySelector('.trta1-carousel-left-nav');
    var carouselRightNav = form.querySelector('.trta1-carousel-right-nav');
    var carouselPosIndicator = form.querySelector('.trta1-carousel-pos-indicator');
    var carouselItemSelectedIdx = 0;
    var chooseDeviceOption = form.querySelector('.mfs-choose-device');
    var chooseThirdPartyAppOption = form.querySelector('.mfs-choose-third-party-app');

    // toggle showing device (card) option based on enableMFACards setting
    chooseDeviceOption.classList[options.enableMFACards ? 'remove' : 'add']('trta1-hide');
    // toggle showing device (third-party app) option based on enableThirdPartyApp setting
    chooseThirdPartyAppOption.classList[options.enableThirdPartyApp ? 'remove' : 'add']('trta1-hide');

    var visibleCarouselItems = form.querySelectorAll('.trta1-carousel li:not(.trta1-hide)');

    // create carousel indicators
    var ul = document.createElement('ul');
    ul.classList += ' trta1-carousel-items';
    for (var i = 0; i < visibleCarouselItems.length; i++) {
      var option = i + 1;
      var li = document.createElement('li');
      var button = document.createElement('button');
      button.setAttribute('id', 'indicatorButton'+i);
      if (i === 0) {
        button.setAttribute('aria-current', 'Show option ' + option);
        button.classList.add('trta1-carousel-pos-selected');
      } else {
        button.setAttribute('aria-label', 'Show option ' + option);
      }
      li.appendChild(button);
      ul.appendChild(li);
    }

    carouselPosIndicator.appendChild(ul);

    if(visibleCarouselItems.length < 2) {
      carouselLeftNav.classList.add('trta1-hide');
      carouselRightNav.classList.add('trta1-hide');
      carouselPosIndicator.classList.add('trta1-hide');
    }

    trAuth.listen('click', function(evt) {
      if (evt.target.matches('.mfs-choose-tr-auth-app button')) {
        options.state.mfsChosenType = 'tr-app';
      } else if (evt.target.matches('.mfs-choose-third-party-app button')) {
        options.state.mfsChosenType = '3p-app';
      }
    }, form);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('prev');
    }, carouselLeftNav);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('next');
    }, carouselRightNav);

    trAuth.listen('click', function(evt) {
      if (evt.target.tagName.toLowerCase() !== 'button') { return; }
      var positions = Array.from(carouselPosIndicator.querySelectorAll('button'));
      selectCarouselItem(positions.indexOf(evt.target));
    }, carouselPosIndicator);

    function selectRelativeCarouselItem(direction) {
      var modifier;
      if(direction === 'next') {
        modifier = 1;
      } else {
        modifier = (direction === 'prev') ? -1 : 0;
      }
      carouselItemSelectedIdx += modifier;
      var totalItems = visibleCarouselItems.length;
      carouselItemSelectedIdx = carouselItemSelectedIdx < 0 ? totalItems - 1 : carouselItemSelectedIdx;
      selectCarouselItem(carouselItemSelectedIdx % totalItems);
    }

    function selectCarouselItem(idx) {
      var items = visibleCarouselItems;
      var positions = carouselPosIndicator.querySelectorAll('button');
      form.querySelector('.' + CAROUSEL_ITEM_SELECTED_CLASS).classList.remove(CAROUSEL_ITEM_SELECTED_CLASS);
      form.querySelector('.' + CAROUSEL_POS_SELECTED_CLASS).classList.remove(CAROUSEL_POS_SELECTED_CLASS);
      items[idx].classList.add(CAROUSEL_ITEM_SELECTED_CLASS);
      positions[idx].classList.add(CAROUSEL_POS_SELECTED_CLASS);
      changeIndicatorButtonAriaAttributeValue(idx);
    }

    function changeIndicatorButtonAriaAttributeValue(index) {
      for (var i = 0; i < visibleCarouselItems.length; i++) {
        var option = i + 1;
        var button = document.querySelector('#indicatorButton'+i);
        if (i === index) {
          button.setAttribute('aria-current', 'Show option ' + option);
          button.removeAttribute('aria-label');
        } else {
          button.setAttribute('aria-label', 'Show option ' + option);
          button.removeAttribute('aria-current');
        }
      }
    }
  }

  var chooseType = {
    template: template$1,
    init: init$1
  };

  var template$2 = "<form name=\"trta1-mfs-emergencycodes\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/emergency-codes\" tr-autosubmit novalidate>\n  <div class=\"trta1-processing-only trta1-error-only\">\n    <div class=\"trta1-form-instructions\">\n      <p t8>Generating emergency codes.</p>\n    </div>\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" type=\"button\">Cancel</button></div>\n      <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n    </div>\n  </div>\n  <div class=\"trta1-success-only\">\n    <h3 t8>Save Emergency Access Codes</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile</p>\n      <p t8 class=\"trta1-print-only\">If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.</p>\n      <p t8 class=\"trta1-print-only\">You can generate more codes by signing in and accessing your profile.</p>\n      <div>\n          <p class=\"trta1-icon-warning trta1-print\"></p>\n          <p t8 class=\"trta1-print\">These codes are like the key to your office - keep them in a safe place only you can access!</p>\n      </div>\n      <p>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only help-link\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/generate-own-temporary-access-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only help-link\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdigita-only help-link\" href=\"http://cs.thomsonreuters.com/ua/netfirm/nc_user_digita_<%= digitaHelpLocale %>/common/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdt-only help-link\" href=\"http://cs.thomsonreuters.com/ua/netfirm/nc_user_drtax_<%= dtHelpLocale %>/common/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n      </p>\n    </div>\n    <ul class=\"mfs-ecodes-list trta1-print\"></ul>\n    <ul class=\"mfs-ecodes-links\">\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-copy-btn\">Copy</button></li>\n      <span t8>or</span>\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-print-btn\">Print</button></li>\n    </ul>\n    <div t8 class=\"trta1-form-msg-warning mfs-ecodes-copied-msg\">Emergency codes copied to the clipboard for pasting to a safe place.</div>\n    <div t8 class=\"trta1-form-msg-error mfs-ecodes-copy-failed-msg\">Error copying emergency codes to the clipboard.</div>\n    <input type=\"hidden\" name=\"type\" value=\"C\">\n    <input type=\"hidden\" name=\"address\" value=\"COTP\">\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" class=\"trta1-btn-secondary mfs-ecodes-done-btn\" disabled=\"disabled\">Done</button></div>\n    </div>\n  </div>\n</form>\n";

  function init$2(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-emergencycodes]');
    var codesList = form.querySelector('.mfs-ecodes-list');
    var printLink = form.querySelector('.mfs-ecodes-print-btn');
    var copyLink = form.querySelector('.mfs-ecodes-copy-btn');
    var copiedMsg = form.querySelector('.mfs-ecodes-copied-msg');
    var copyFailedMsg = form.querySelector('.mfs-ecodes-copy-failed-msg');
    var doneBtn = form.querySelector('.mfs-ecodes-done-btn');
    var exitBtn = rootElem.querySelector('.trta1-dialog-close');

    trAuth.listen('trta1-mfs-emergencycodes-success', function(evt) {
      options.state.emergencyCodesClipboardText = '';
      exitBtn.classList.add('trta1-hide');
      trAuth.removeNodes(codesList.childNodes);
      evt.detail.data.forEach(function(factor) {
        var li = document.createElement('li');
        var formattedSecret = factor.otpSecret.substring(0, 4) + ' ' + factor.otpSecret.substring(4);
        var text = document.createTextNode(formattedSecret + '\r');
        options.state.emergencyCodesClipboardText += formattedSecret + '\r\n';
        li.appendChild(text);
        codesList.appendChild(li);
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-error', function(evt) {
      // if user isn't yet fully authenticated, close and require auth
      if(evt.detail.status === 403){
        trAuth.changeForm('trta1-$close');
      }
    }, rootElem);

    trAuth.listen('click', function() {
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
      var html = '<style>\
      body { margin: 40px; font-family: sans-serif; }\
      .trta1-icon-warning:before { font-size: 1.5em; content: "⚠"; vertical-align: middle; }\
      ul { list-style: none; }\
      li:before { font-size: 1.5em; content: "☐"; vertical-align: baseline; margin: 5px; }\
    </style>';
      // Render print elements into a blank tab/window.
      // WARNING: no user generated content, otherwise there is an XSS risk!
      Array.from(rootElem.querySelectorAll('h1, h2')).concat(
        Array.from(form.querySelectorAll('h3, .trta1-print, .trta1-print-only'))
      ).forEach(function(el) {
        html += el.outerHTML;
      });
      trAuth.openPrintWindow(html, options.state.$t('Emergency Access Codes'));
    }, printLink);

    trAuth.listen('click', function() {
      copyReset();

      if ('clipboard' in window.navigator) {
        navigator.clipboard.writeText(options.state.emergencyCodesClipboardText)
          .then(copySuccess)
          .catch(clipboardCopyFallback);
      } else {
        clipboardCopyFallback();
      }
    }, copyLink);

    trAuth.listen('click', function() {
      trAuth.trigger('tr-mfs-success');
    }, doneBtn, true);

    function clipboardCopyFallback() {
      var input = document.createElement('textarea');
      document.body.appendChild(input);
      input.value = options.state.emergencyCodesClipboardText;

      // sadly focus and select will sometimes fail in IWebBrowser2 (embedded)
      try {
        input.focus();
        input.select();
        // enable Done button
        doneBtn['removeAttribute']('disabled', 'disabled');
      } catch(e) {
        copyFail();
        return;
      }

      var success = document.execCommand('copy');
      document.body.removeChild(input);
      success ? copySuccess() : copyFail();
    }
    function copyReset() {
      copiedMsg.style.display = 'none';
      copyFailedMsg.style.display = 'none';
    }
    function copySuccess() {
      copiedMsg.classList.add('trta1-form-msg');
      copiedMsg.style.display = 'block';
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
    }
    function copyFail() {
      copyFailedMsg.classList.add('trta1-form-msg');
      copyFailedMsg.style.display = 'block';
    }
  }

  var emergencyCodes = {
    template: template$2,
    init: init$2
  };

  var template$3 = "<form name=\"trta1-mfs-pairdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/device\" novalidate tr-goto-onsuccess=\"trta1-mfs-devicelookup\">\n  <h3 t8>Validate your multi-factor device</h3>\n  <div>\n    <h4 t8>Step 1</h4>\n    <p t8>Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/learn-about-multi-factor-devices.htm\">Learn more about multi-factor devices</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa\">Learn more about multi-factor devices</a>\n    </p>\n    <label>\n      <div t8>Device ID</div>\n      <input required pattern=\"(t|T)(r|R)\\s?\\d{3}\\s?\\d{4}\" name=\"rawDeviceId\" autocomplete=\"off\" maxlength=\"11\" tr-nosend>\n    </label>\n  </div>\n  <div>\n    <h4 t8>Step 2</h4>\n    <p t8>Enter the one-time code displayed on your multi-factor device.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3}\\s?\\d{3}\" name=\"rawCode\" autocomplete=\"off\" maxlength=\"7\" tr-nosend>\n    </label>\n  </div>\n  <input type=\"hidden\" name=\"type\" value=\"A\">\n  <input type=\"hidden\" name=\"deviceId\">\n  <input type=\"hidden\" name=\"code\" tr-noconvert>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$3(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-pairdevice]');
    var rawDeviceIdInput = form.querySelector('[name=rawDeviceId]');
    var rawCodeInput = form.querySelector('[name=rawCode]');
    var deviceIdInput = form.querySelector('[name=deviceId]');
    var codeInput = form.querySelector('[name=code]');

    trAuth.listen('submit', function() {
      deviceIdInput.value = rawDeviceIdInput.value.replace(/\s/g, '').toUpperCase();
      codeInput.value = rawCodeInput.value.replace(/\s/g, '');
    }, form);

    trAuth.listen('trta1-mfs-pairdevice-success', function(evt) {
      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-error', function() {
      trAuth.focusFirstEnabledField(form, function(field) {
        return field === rawCodeInput;
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-exit', function() {
      form.reset();
    }, rootElem);
  }

  var pairDevice = {
    template: template$3,
    init: init$3
  };

  var template$4 = "<form name=\"trta1-mfs-registerdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/_id_/register\" tr-goto-onsuccess=\"trta1-mfs-devicelookup\" tr-autosubmit novalidate>\n<div class=\"trta1-form-instructions\">\n  <p t8>Registering your device.</p>\n</div>\n<div class=\"trta1-btn-group\">\n  <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n  <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n</div>\n</form>\n";

  function init$4(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-registerdevice]');

    trAuth.listen('submit', function(evt) {
      var factorData = options.state.factorData;
      var registerPayload = trAuth.seekObjPath('formOverrides.trta1-mfs-registerdevice.payload', options, true);
      var deviceName = options.state.mfsChosenType === 'tr-app-totp' ?
        options.state.$t('Thomson Reuters Authenticator'):
        options.state.$t('My Multi-Factor App');

      form.action = form.action.replace(/[^\/]+\/register$/, factorData.factorId + '/register');
      registerPayload.mfarId = factorData.mfarId;
      registerPayload.factor = { name: deviceName, address: '' };
    }, form);
  }

  var registerDevice = {
    template: template$4,
    init: init$4
  };

  var template$5 = "<form name=\"trta1-mfs-scancode\" method=\"get\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_\" class=\"trta1-nodisable\" novalidate>\n  <h3 t8 class=\"mfs-type-tr-app-only\">Scan Code</h3>\n  <h3 t8 class=\"mfs-type-3p-app-only\">Validate your alternate multi-factor app</h3>\n  <div class=\"mfs-type-tr-app-only\">\n    <p t8>Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.</p>\n  </div>\n  <div class=\"mfs-type-3p-app-only\">\n    <h4 t8>Step 1</h4>\n    <p t8>Use your alternate multi-factor app to scan the code below.</p>\n  </div>\n  <div class=\"trta1-mfs-qrcode\"></div>\n  <div class=\"mfs-manual-code-container\">\n    <h4 t8 class=\"mfs-type-3p-app-only\">Step 2</h4>\n    <p t8 class=\"mfs-type-3p-app-only\">Enter the code displayed by your alternate multi-factor app.</p>\n    <p t8 class=\"mfs-type-tr-app-only\">Enter the authentication code displayed by the Authenticator app.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfs-manual-code\" autocomplete=\"off\" maxlength=\"9\" tr-nosend>\n    </label>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$5(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-scancode]');
    var cancelScanPoll;

    trAuth.listen('trta1-mfs-scancode-enter', function(event) {
      // if we haven't already gotten a code, go gen
      if (!options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-gencode', rootElem);
        return;
      }

      var chosenType = options.state.mfsChosenType || 'tr-app';
      var manualCodeContainer = form.querySelector('.mfs-manual-code-container');
      var manualCode = manualCodeContainer.querySelector('[name=mfs-manual-code]');
      var factorData = options.state.factorData;
      var nextBtn = form.querySelector('.trta1-next-btn-container');

      // reset tr-app-totp to tr-app
      if (chosenType === 'tr-app-totp') options.state.mfsChosenType = 'tr-app';

      form.action = form.action.replace(/\/requests\/.*$/, '/requests/' + factorData.mfarId);
      form.classList.remove('mfs-type-tr-app', 'mfs-type-3p-app');
      form.classList.add('mfs-type-' + chosenType);

      if (chosenType === 'tr-app') {
        manualCodeContainer.style.display = 'none';
        nextBtn.style.display = 'none';

        manualCode.required = false;

        // poll for success
        cancelScanPoll = trAuth.pollFormRequest(
          form,
          // test fn
          function(evt) {
            return evt.detail.data.status === 'SUCCEEDED';
          },
          // success fn
          function() {
            options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
            trAuth.changeForm('trta1-mfs-devicelookup', rootElem);
          },
          // timeout fn
          function() {
            trAuth.updateFormState(form, 'error', options, 'timeout');
            manualCodeContainer.style.display = 'block';
            manualCode.required = true;
            nextBtn.style.display = 'block';
            // switch to totp mode so user can enter code
            options.state.mfsChosenType = 'tr-app-totp';
          },
          null, // errorFn
          2, // delay
          60 // timeout seconds

          // roll with defaults for rest of params
          // leadingEdge = false, continueOnError = false
        );
      } else { // 3rd-party-app
        manualCodeContainer.style.display = 'block';
        nextBtn.style.display = 'block';
        manualCode.required = true;
      }

    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var headers = trAuth.seekObjPath('formOverrides.trta1-mfs-scancode.headers', options, true),
        factorData = options.state.factorData;

      if (options.state.mfsChosenType === 'tr-app') {
        form.method = 'get';
        form.action = form.action.replace(/(\/validate)?$/, '');
        delete headers.authorization;

      } else { // type is 3p-app or tr-app-totp
        var code = form.elements['mfs-manual-code'].value.replace(/\s/g, '');
        form.method = 'post';
        form.action = form.action.replace(/(\/validate)?$/, '/validate');
        headers.authorization = 'OTP ' + code + ':' + factorData.factorId;
      }
    }, form);

    trAuth.listen('trta1-mfs-scancode-success', function(evt) {
      if (options.state.mfsChosenType === 'tr-app') return;
      // type is 3p-app or tr-app-totp
      form.reset();
      options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
      trAuth.changeForm('trta1-mfs-registerdevice', rootElem);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-exit', function(evt) {
      if (cancelScanPoll) {
        cancelScanPoll();
        cancelScanPoll = null;
      }
      form.reset();
    }, rootElem);
  }

  var scanCode = {
    template: template$5,
    init: init$5
  };

  var index = {
    approveCode: approveCode,
    locales: locales,
    chooseType: chooseType,
    emergencyCodes: emergencyCodes,
    pairDevice: pairDevice,
    registerDevice: registerDevice,
    scanCode: scanCode
  };

  return index;

}());
//# sourceMappingURL=bundle.js.map
(function(window) {
  'use strict';

  var trAuth = window.trAuth;
  var unsupportedOperatingSystems = ['6001', '6002', '6003', '7600', '7601'];

  var MFA_NAG_DISMISS_KEY = 'tr-auth-mfnag-dismissday';
  var MFA_SHOULD_NAG_KEY = 'tr-auth-mfnag-display';
  var FIRM_IS_LOCKED_OUT = 'Firm is locked out.';
  var mfaLocation;
  var signInLocation;

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trid-auth">\
      <h1 t8>Thomson Reuters</h1>\
      <h2 t8 class="trta1-netfirm-subhead">Sign in with your NetStaff CS account</h2>\
      <h2 class="trta1-trid-subhead">\
        <span t8>Sign in with your Thomson Reuters ID</span>\
        <span class="trta1-icon-question"></span>\
        <p t8 class="trta1-trid-help trta1-visually-hidden">Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.</p>\
      </h2>\
      <form id="trta1-auth" name="trta1-signin" method="post" action="<%= authSvcHost %>/api/auth/v2/login" novalidate>\
        <label>\
          <span t8 id="tr-auth-uid-label" class="trta1-placeholder-label">Email Address (Thomson Reuters ID)</span>\
          <span class="trta1-icon-user">\
            <input t8 type="email" name="uid" aria-labelledby="tr-auth-uid-label" data-qe-id="trauth-signin-uid" placeholder="Email Address (Thomson Reuters ID)" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
          </span>\
        </label>\
        <label>\
          <span t8 id="tr-auth-pwd-label" class="trta1-placeholder-label">Password</span>\
          <span class="trta1-icon-lock">\
            <input t8 type="password" name="pwd" aria-labelledby="tr-auth-pwd-label" data-qe-id="trauth-signin-pwd" placeholder="Password" required pattern=".*\\S+.*" maxlength="50">\
          </span>\
          <span class="trta1-align-right"><a t8 id="trta1-resetpwd-link" data-trta1-dest="trta1-reqpwdreset" href="javascript:void(0)">Reset Password</a></span>\
        </label>\
        <div class="trta1-btn-group">\
          <button t8 name="signinBtn" data-qe-id="trauth-signin-btn" class="trta1-btn-primary" tr-nosend>Sign In</button>\
        </div>\
        <footer class="trta1-signin-trid-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount/login.aspx">Manage Account</a><br>\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
          <p t8>Need an account? Contact your administrator.</p>\
        </footer>\
        <footer class="trta1-signin-netfirm-footer">\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-signin-onvio-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm"><%= onvioHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-signin-csweb-footer">\
          <a t8 href="<%= cswebHost %>/myaccount/nu.aspx">Need an account? Create one now.</a>\
          <label class="trta1-system-status-link"><a t8 target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a></label>\
        </footer>\
      </form>\
      <form id="trta1-auth0-signin" class="trta1-auth0-signin-redirect-screen" name="trta1-auth0-signin" novalidate>\
        <div class="trta1-btn-group">\
          <button t8 id="trta1-auth0-continue-signin-btn" class="trta1-btn-primary" tr-nosend>Continue to sign in page</button>\
        </div>\
        <footer class="trta1-auth0-signin-trid-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount/login.aspx">Manage Account</a><br>\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
          <p t8>Need an account? Contact your administrator.</p>\
        </footer>\
        <footer class="trta1-auth0-signin-netfirm-footer">\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-auth0-signin-onvio-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm"><%= onvioHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-auth0-signin-csweb-footer">\
          <a t8 href="<%= cswebHost %>/myaccount/nu.aspx">Need an account? Create one now.</a>\
          <label class="trta1-system-status-link"><a t8 target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a></label>\
        </footer>\
      </form>\
      <form id="trta1-auth-redirect" class="trta1-signin-redirect-screen auth0-login-form" name="trta1-signin-auth0-redirect" novalidate>\
        <h3 t8 class="SignOn-card-heading">Let\'s get started</h3>\
        <div class="trta1-btn-group">\
          <button t8 id="trauth-continue-signin-btn" class="trid-auth-continue-ciam-button trta1-btn-primary SignOn-card-button SignOn-card-button-login" tr-nosend>Sign in</button>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form id="trta1-auth-redirect-signout" class="trta1-signin-redirect-screen auth0-login-form" name="trta1-signin-auth0-redirect-signout" novalidate>\
        <h3 t8 class="SignOn-card-heading">You\'re signed out</h3>\
        <div class="trta1-btn-group">\
          <button t8 id="trauth-continue-signout-btn" class="trid-auth-continue-ciam-button trta1-btn-primary SignOn-card-button SignOn-card-button-login" tr-nosend>Sign back in</button>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-mfnag">\
        <h3><p t8>Make your account even more secure!</p></h3>\
        <div class="trta1-form-instructions shield-bg">\
          <p t8>Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-overview.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/mfa-reminder.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-dt-help"><a t8 target="_blank" rel="noopener" href="http://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/drtax-mfa-overview.htm">Learn more about multi-factor authentication.</a></p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-mfs-later">Remind Me Later</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-offlinerequirement">\
        <h3 t8 class="trta1-icon-warning">Internet Access Required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>To sign in, please connect this computer to the internet then restart the application.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn more about these new security measures.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm">Learn more about these new security measures.</a></p>\
        </div>\
      </form>\
      <form name="trta1-migrationcheck" method="get" action="<%= authSvcHost %>/api/auth/v1/firms/migration" tr-autosubmit tr-goto-onerror="trta1-signin" novalidate>\
      </form>\
      <form name="trta1-intro">\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>For your firm to access this software, one of your firm&apos;s administrators needs to upgrade your accounts at <a target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount">cs.thomsonreuters.com/myaccount</a>.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <a t8 target="_blank" rel="noopener" class="trta1-btn-primary" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn More About New Security Measures</a>\
        </div>\
      </form>\
      <form name="trta1-reqpwdreset" method="post" action="<%= authSvcHost %>/api/auth/v1/password/reset" tr-goto-onsuccess="trta1-pwdresetreqsent" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please enter your email address.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-netfirm trta1-hide">\
          <p t8>Please enter your login and email address.</p>\
        </div>\
        <label><span t8>Email Address (Thomson Reuters ID)</span>\
          <input type="email" name="uid" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
        </label>\
        <label class="trta1-hide"><span t8>Email Address</span>\
          <input type="email" name="email" required maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false" disabled>\
        </label>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Reset My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-operating-system-check" tr-autosubmit method="get" action="<%= authSvcHost %>/api/reminder/v1/nag/_id_">\
      </form>\
      <form name="trta1-unsupported-operating-system" method="" action="<%= authSvcHost %>/api/reminder/v1/nag/">\
        <h3 t8>Outdated Operating System Detected</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button id="trta1-dismissosnag" t8 class="trta1-btn-primary">Acknowledge and Ignore Warning</button>\
        </div>\
        <div class="os-help-links">\
          <ul>\
            <li><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/account-and-application-mgmt/systems/windows-7-end-of-support.htm">End of support for Windows 7, Server 2008 / 2008 R2</li></a>\
            <li><a t8 target="_blank" rel="noopener" href="https://www.microsoft.com/en-us/windows/windows-7-end-of-life-support-information?icid=CXSMC_win7upgrade">Microsoft Windows 7 Announcement</li></a>\
            <li><a t8 target="_blank" rel="noopener" href="https://www.microsoft.com/en-us/cloud-platform/windows-server-2008">Microsoft Window Server 2008 / 2008 R2 Announcement</li></a>\
          </ul>\
        </div>\
      </form>\
      <form name="trta1-pwdresetreqsent">\
        <div class="trta1-form-instructions">\
          <p t8>Instructions for resetting your password have been sent to your registered email address.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset" method="put" action="<%= authSvcHost %>/api/profiles/v2/password/reset" tr-goto-onsuccess="trta1-pwdreset-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please create a new password that meets <a id="trta1-toggle-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-pwdexpired trta1-hide">\
          <p t8>Your password has expired. Please create a new one that meets <a id="trta1-toggle-expired-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div id="trta1-pwd-requirements" class="trta1-hide">\
          <p t8>Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:</p>\
          <ul>\
            <li t8>At least 1 uppercase letter (A-Z)</li>\
            <li t8>At least 1 lowercase letter (a-z)</li>\
            <li t8>At least 1 digit (0-9)</li>\
            <li t8>At least 1 symbol (e.g. ! @ # $ % ^ & *)</li>\
          </ul>\
          <p t8>Your password should <strong>not</strong> use:</p>\
          <ul>\
            <li t8>Leading or trailing spaces</li>\
            <li t8>Words from the dictionary</li>\
            <li t8>Your user ID</li>\
            <li t8>Sequential letters or numbers such as "abc" or "123"</li>\
          </ul>\
        </div>\
        <span class="trta1-align-right">\
          <a t8 id="trta1-pwd-showtyping" href="javascript:void(0)">Show typing</a>\
          <a t8 id="trta1-pwd-hidetyping" class="trta1-hide" href="javascript:void(0)">Hide typing</a>\
        </span>\
        <label><span t8>New Password</span>\
          <input type="password" t8 name="password" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z\\d\\s])\\S.{6,}\\S$" required maxlength="50" title="Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.">\
        </label>\
        <label><span t8>Confirm New Password</span>\
          <input type="password" name="password2" required maxlength="50">\
        </label>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset My Password</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-pwdexpired trta1-btn-group-pwdexpiring trta1-hide">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Change My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-complete">\
        <div class="trta1-form-instructions">\
          <p t8>You&apos;ve successfully changed your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetcompleteokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-netfirm">\
        <div class="trta1-form-instructions">\
          <p t8>Your password needs to be updated. Please <a target="_blank" rel="noopener" href="<%= netfirmWebHost %>">log in</a> and change your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Back To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetnetfirmokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock" method="put" action="<%= authSvcHost %>/api/auth/v1/login/unblock" tr-autosubmit tr-goto-onsuccess="trta1-requnlock-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Unlocking your account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock-complete">\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
       <form name="trta1-pwdexpiring">\
        <h3 t8>Your password will expire soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8 id="trta1-pwdexpirestwoormoredays-txt">Your password will expire in <em id="trta1-pwdexpdays">2</em> days.</p>\
          <p t8 id="trta1-pwdexpiresoneday-txt" class="trta1-hide">Your password will expire in <em>1</em> day.</p>\
          <p t8 id="trta1-pwdexpireszerodays-txt" class="trta1-hide">Your password will expire <em>today</em>.</p>\
          <p t8>Do you want to change it now?</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-chgpwdnowbtn">Change my password</button></div>\
          <div><button t8 class="trta1-btn-primary" id="trta1-chgpwdlaterbtn">Do it later</button></div>\
        </div>\
      </form>\
      <form name="trta1-sessionending">\
        <h3 t8>Your session is ending soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Your session will end in:</p>\
          <p id="trta1-signout-countdown">2:00</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset</button>\
        </div>\
      </form>\
      <form name="trta1-mfsrequired">\
        <h3 t8>Multi-factor authentication required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfarequired-screen" class="auth0-login-form">\
        <h3 t8 class="SignOn-card-heading">Secure your account</h3>\
        <div class="trta1-form-instructions SignOn-card-supportingText ">\
          <p t8>Onvio requires two-step verification. You only have to configure this once, and it won\'t take long.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-mfa-required" class="trta1-mfa-required SignOn-card-button">Set up two-step verification</button></div>\
          <div>\
            <a t8 href="<%= aboutAccountSecLink %>" target="_blank" class="SignOn-card-link">Read about account security</a>\
          </div>\
        </div>\
      </form>\
      <form name="trta1-account-error-screen">\
        <div class="trta1-form-instructions">\
           <p t8>Your firm\'s license is no longer active. Please contact your administrator.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-back-to-signin">Back</button></div>\
        </div>\
      </form>\
      <form class="auth0-login-form" name="trta1-account-error-auth0-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <div class="trta1-form-instructions-no-access-to-module trta1-hide">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access to this product</h3>\
          <p t8 class="SignOn-card-supportingText">Select the module you wish to access and try again</p>\
          <div class="SignOn-card-productLinks">\
            <a t8 class="SignOn-card-link" target="_blank" rel="noopener" href="<%= clientCenterLink %>">Client Center</a>\
            <a t8 class="SignOn-card-link" target="_blank" rel="noopener" href="<%= employeePortalLink %>">Employee Portal</a>\
            <a class="SignOn-card-link" target="_blank" rel="noopener" href="<%= onBalanceLink %>">OnBalance</a>\
          </div>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-firm-lock-credit-hold-screen">\
        <div class="trta1-form-instructions">\
           <p t8>Your firm\'s license is no longer active. Please contact your administrator.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-back-to-signin">Back</button></div>\
        </div>\
      </form>\
      <form class="auth0-login-form" name="trta1-firm-lock-credit-hold-new-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form class="auth0-login-form" name="trta1-firm-lock-new-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-technology-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">Your firm\'s license is inactive</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-mfa-choosedevice" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Finding your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-notifydevice" method="post" action="<%= authSvcHost %>/api/mfa/v1/requests" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Notifying your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-awaitapproval" method="get" action="<%= authSvcHost %>/api/mfa/v1/requests/_id_" class="trta1-nodisable" novalidate>\
        <h3 t8>Check your device!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\
        </div>\
        <fieldset>\
          <p t8>Didn&apos;t get a notification? <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-choosedevice">Resend it</a> or <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-approvecode">enter a code</a>\
          </p>\
          <p t8>No phone? Contact your firm&apos;s administrator</p>\
        </fieldset>\
        <div class="trta1-btn-group">\
          <a t8 data-trta1-dest="<%= cancelDestForm %>" href="javascript:void(0)">Cancel Request</a>\
        </div>\
      </form>\
      <form name="trta1-mfa-retrievetoken" method="post" action="<%= authSvcHost %>/api/auth/v1/jwt/mfa/_id_" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving authentication token.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-postauth">\
      </form>\
      <form name="trta1-authcomplete">\
        <h3 t8 class="success-shield-bg">Success!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>You\'ve been authenticated.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
      <form name="trta1-auth0-signin-redirect" method="post" action="<%= authSvcHost %>/api/security/v1/oidc/login" tr-autosubmit novalidate class="trta1-not-display-success">\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-auth0-redirect" method="get" action="<%= authSvcHost %>/api/security/v2/environments" tr-autosubmit>\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-auth0-code-exchange" class="trta1-not-display-wait" method="post" action="<%= authSvcHost %><%= auth0Endpoint %>" tr-autosubmit>\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-mfa-unavailable">\
        <div class="trta1-form-instructions">\
          <p t8>Multifactor authentication is currently unavailable.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
      <form name="trta1-elevated-mfa-unavailable">\
        <div class="trta1-form-instructions">\
          <p t8>Multifactor authentication is currently unavailable.</p>\
          <p t8>Please close this window and try again.</p>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.approveCode.template +

      '<div class="trta1-debug"></div>\
    </section>\
  ';
  /* jshint multistr: false */

  function prepDataForMfaForms(opts, uid, jwt) {
    // set uid for device notify name
    var notifyPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', opts, true);
    notifyPayload.name = uid;

    if (jwt) {
      [
        'formOverrides.trta1-mfa-choosedevice.headers',
        'formOverrides.trta1-mfa-notifydevice.headers',
        'formOverrides.trta1-mfa-awaitapproval.headers',
        'formOverrides.trta1-mfa-retrievetoken.headers'
      ].forEach(function(overridePath) {
        trAuth.seekObjPath(overridePath, opts, true).authorization = 'Bearer ' + jwt;
      });
    }
  }

  function prepareAuthSuccessData(evt, opts) {
    var token, uds, data = null;

    if (!opts.offline) {
      token = evt.detail.data && evt.detail.data.tokenValue;
      uds = evt.detail.data && evt.detail.data.uds;
      if (token) {
        data = { data: {
          token: token,
          decodedToken: window.jwt_decode(token),
          uds: uds
        }};
      }
    }
    return data;
  }

  function init(options) {
    var rootElem, signinForm, pwdResetForm, pwdExpiringForm, resetPwds, signinUidInput, signinPwdInput,
      signinMsgs, reqPwdResetForm, systemStatusOption, signinAuth0Forms, systemStatusOptionAuth0;

    options = options || { locale: 'en-US' };

    window.trAuth.shadowDomElem = options.shadowDomElem;

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      templateData: {// This template data will be translated later so do not delete the translations keys that come in the json file related to the template data
        cswebHost: 'https://cs.thomsonreuters.com',
        onvioHelpDomain: 'https://onvio.us',
        onvioHelpLinkText: 'ONVIO Sign In Security Help',
        csHelpLinkText: 'CS Professional Suite Security Help',
        onvioHelpUserType: 'staff',
        onvioHelpSubDirectory: 'core/setup',
        authSvcHost: 'https://onvio.us',
        netfirmWebHost: 'https://secure.netlinksolution.com',
        cancelDestForm: 'trta1-$start',
        clientCenterLink: 'https://onvio.com.br',
        employeePortalLink: 'https://onvio.com.br/portaldoempregado/auth',
        onBalanceLink: 'https://onbalance.thomsonreuters.com.br',
        systemStatusLink: '',
        appMessageAdministrator: getAppMessageAdministrator(options.sp),
        aboutAccountSecLink: retrieveAboutAccountSecLink(),
        signInHelpLink: $t('https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm'),
        auth0Endpoint: fetchAuthCodeSessionsV2IACStatus() ? '/api/security/v2/oidc/auth-code/session' : '/api/security/v1/oidc/auth-code/session',
      },
      flow: { type: 'auth', data: {} },
      formStateMessages: {
        'error': {
          /* Custom service reason keys */
          // https://git.sami.int.thomsonreuters.com/bluemoon/authentication-aggregator/blob/develop/authentication-aggregator-lib/src/main/java/com/tr/bluemoon/auth/LoginErrorCode.java
          'INVALID_CREDENTIALS': $t('Incorrect Email Address or Password. Please try again.'),
          'ACCOUNT_LOCKED_OUT': $t('Too many sign in attempts. Please check for unlock email or try later.'),
          'RATE_LIMIT_REACHED': $t('Too many sign in attempts. Please check for unlock email or try later.'),
          'PASSWORD_EXPIRED': $t('Please change your password.'),
          'MISSING_PARAMETER': $t('Please complete the required fields.'),
          // 'USER_NOT_FOUND': '',
          'USER_INACTIVE': $t('Deactivated account. Contact your administrator or accountant.'),
          'EMAIL_SEND_ERROR': $t('There was an error sending the email. Please try again.'),
          // 'INVALID_TOKEN': '',
          'PASSWORD_ALREADY_USED': $t('Please choose a password you have not already used.'),
          // these should default to unknown error as something went wrong if you see them
          // 'MFA_SETUP_REQUIRED': '',
          // 'MFA_AUTHENTICATION_REQUIRED': '',
          'INVALID_PASSWORD_FORMAT': $t('Please change your password.'),
          // Contact not found.
          'CONTACT_NOT_FOUND_EXCEPTION': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Wrong primary product.
          'PRIMARY_PRODUCT_MISMATCHING': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Firm is locked out.
          'FIRM_CREDIT_HOLD': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Firm is locked out.
          'FIRM_LOCKED_OUT': $t('Your firm\'s license is no longer active. Please contact your administrator.'),

          /* Custom client-side keys */
          'ourIssueTryAgain': $t('Sorry, there was an issue on our end. Please try again.'),
          'unlockAcct': $t('Your account has been unlocked.'),
          'inactivitySignout': $t('You\'ve been signed out due to inactivity. Sign in to resume.'),
          'forcedSignout': $t('You\'ve exceeded maximum usage time. Please sign in again.'),
          'expiredRegistration': $t('Your registration link has expired. Please contact the firm for a new one.'),
          'invalidCredentialsNetfirm': $t('Incorrect Login or Password. Please try again.')
        }
      },
      formOverrides: {
        'trta1-signin': {
          statusMap: {
            '404': 500
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER_FIRM_ID': $t('Missing firmId parameter.'),
            }
          }
        },
        'trta1-auth0-code-exchange': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
        'trta1-pwdreset': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to reset password. Please try again.'),
              'PASSWORD_VIOLATES_RULES': $t('Please provide a valid password.'),
              'PASSWORD_CONTAINS_PROHIBITED_CHARS': $t('Password contains prohibited characters'),
              'PASSWORD_TOO_COMMON': $t('Password is too similar to a common or blacklisted password.'),
              'PASSWORD_CONTAINS_USERINFO': $t('Please enter a valid password. Your password cannot contain personal information associated with your account.'),
            }
          }
        },
        'trta1-requnlock': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to unlock account. Please try again.'),
            }
          }
        },
        'trta1-mfa-awaitapproval': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': { 'timeout': $t('Timed out waiting for device approval. Resend notification or enter code.') }
          }
        },
        'trta1-mfa-approvecode': {
          formStateMessages: {
            'error': {
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // Verify if it is from desktop app and for onvio and trid
    if (options.sp === 'csdesktop' && (options.type === 'onvio' || options.type === 'trid' || options.type === 'netfirm') ) {
      // Make a get request to get IACs
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/security/v2/environments', false);
      xhr.send();
      // Check if Auth0 is enabled
      try {
        var iac = JSON.parse(xhr.responseText);
        var isAuth0enabled = iac.InfrastructureAccessControls.indexOf('Platform_DisableAuth0Phase3') == -1;
        // If Auth0 is enabled show the new 'continue to sign in button'
        if(isAuth0enabled){
          options.startingForm = 'trta1-auth0-signin';
        }
      } catch (error){
        // If there is an error just continue and it will show the legacy form
        window.console.log('Could not get IACs, so continue with the previous flow');
      }
    }

    if(options.auth0Code && options.auth0State) {
      options.flow = { type: 'auth0-code-exchange', data: { auth0Code: options.auth0Code, auth0State: options.auth0State } };
    }

    if(!options.auth0Code && options.auth0State) {
      options.startingForm = 'trta1-account-error-auth0-screen';
    }

    // setup flow data
    switch (options.flow.type) {
      case 'auth-elevated':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        break;
      case 'auth-2nd-factor':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        options.templateData.cancelDestForm = 'trta1-$close';
        break;
      case 'auth0-code-exchange':
        if (!options.flow.data.auth0Code) break;
        options.startingForm = 'trta1-auth0-code-exchange';
        break;
    }

    if (options.isLogout == 'true'){
      options.startingForm = 'trta1-signin-auth0-redirect-signout';
    }

    // Add system status link to templateData
    if (options.statusPage) {
      options.templateData.systemStatusLink = options.statusPage.url;
      options.templateData.onvioHelpLinkText = 'Sign-in Help';
      options.templateData.csHelpLinkText = 'Sign-in Help';
    }

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;
    // add in computed template data, e.g. onvioHelpLangCode
    var templateData = trAuth.objAssignDeep({}, options.templateData, { onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),  dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),  digitaHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_') });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), templateData, null, null, options.locale);

    // cached selectors
    signinForm = rootElem.querySelector('form[name=trta1-signin]');
    signinUidInput = signinForm.elements.uid;
    signinPwdInput = signinForm.elements.pwd;
    reqPwdResetForm = rootElem.querySelector('form[name="trta1-reqpwdreset"]');
    pwdResetForm = rootElem.querySelector('form[name="trta1-pwdreset"]');
    pwdExpiringForm = rootElem.querySelector('form[name="trta1-pwdexpiring"]');
    resetPwds = pwdResetForm.querySelectorAll('[name=password], [name=password2]');
    systemStatusOption = signinForm.querySelectorAll('.trta1-system-status-link');

    // toggle system status link based on statusPage.url setting
    Array.from(systemStatusOption).forEach(function(item, index) {
      systemStatusOption[index].classList[options.statusPage && options.statusPage.url ? 'remove' : 'add']('trta1-hide');
    });

    if(hideSystemStatus()) {
      // Select the two Auth0 forms one for login and one for logout
      signinAuth0Forms = rootElem.querySelectorAll('form[name=trta1-signin-auth0-redirect], form[name=trta1-signin-auth0-redirect-signout], form[name=trta1-account-error-auth0-screen]');
      Array.from(signinAuth0Forms).forEach(function(item, ind) {
        // Pickup the system status link and hide it
        systemStatusOptionAuth0 =  signinAuth0Forms[ind].querySelectorAll('.trta1-system-status-link');
        Array.from(systemStatusOptionAuth0).forEach(function(item, index) {
          systemStatusOptionAuth0[index].classList.add('trta1-hide');
        });
      });
    }

    // initialize submodules
    trAuth.submodules.approveCode.init(rootElem, options, trAuth);

    // dynamic options
    if (options.type === 'netfirm') {
      // create if it doesn't exist
      signinMsgs = trAuth.seekObjPath('formOverrides.trta1-signin.formStateMessages.error', options, true);
      signinMsgs.INVALID_CREDENTIALS = defaultOptions.formStateMessages.error.invalidCredentialsNetfirm;
    }

    function storeSigninData(uid, pwd) {
      // save off values for post mfa success retrieval, #8442
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      signinVals.uid = uid || signinUidInput.value;
      signinVals.pwd = pwd || signinPwdInput.value;
    }
    function clearSigninData() {
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      // keep uid, so user doesn't have to enter it again
      // signinVals.uid = undefined;
      signinVals.pwd = undefined;
    }

    // events
    trAuth.listen('trta1-auth-enter', function(evt) {
      if (options.inactivitySignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'inactivitySignout');
      if (options.forcedSignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'forcedSignout');
      if (options.expiredRegistration === true)
        trAuth.updateFormState(evt.target, 'error', options, 'expiredRegistration');
    }, signinForm);

    trAuth.listen('submit', function(evt) {
      var form = evt.target;
      form.classList.add('trta1-submitted');
      if (!trAuth.validateForm(form, options)) {
        trAuth.focusFirstEnabledField(form, function(field) {
          return !field.validity.valid;
        });
        return;
      }
    }, signinForm);

    trAuth.listen('trta1-auth-exit', function() {
      signinPwdInput.value = '';
    }, signinForm);

    // CXG - New entry point for NetFirm MFA nag
    trAuth.listen('trta1-auth-mfnag', function(evt) {
      var detail  = { key: evt.detail.data.tokenValue };

      // create so that it can be used down the line...
      var data = { authSuccessEvt: { detail: { data: { tokenValue : evt.detail.data.tokenValue}}}};
      options.data = data;

      // save off values for post mfa success retrieval, #8442
      storeSigninData();

      prepDataForMfaForms(options, signinUidInput.value, detail.key);
      trAuth.changeForm('trta1-mfnag', rootElem, detail);
    }, signinForm);

    trAuth.listen('trta1-auth-error', function(evt) {
      var primaryError = trAuth.getPrimaryError(evt.detail), detail;

      // trigger auth section error event
      trAuth.trigger('tr-auth-error', evt.detail);

      if (!primaryError) return;

      detail  = { type: primaryError.reason, key: primaryError.key };

      // handle primary reason
      switch (detail.type) {
        case 'MISSING_PARAMETER':
          var msgs = trAuth.getFormStateMsgs(signinForm, options), msg;
          if (detail.key === 'firmId') {
            msg = msgs.error.MISSING_PARAMETER_FIRM_ID;
            trAuth.updateFormMsg(signinForm, msg);
          } else { // some other param is missing; validate
            trAuth.validateForm(signinForm, options);
          }
          break;
        case FIRM_IS_LOCKED_OUT:
          trAuth.updateFormMsg(signinForm, defaultOptions.formStateMessages.error.FIRM_LOCKED_OUT);
          break;
        case 'INVALID_CREDENTIALS':
        case 'RATE_LIMIT_REACHED':
          // assume pwd is invalid for user convenience
          trAuth.focusFirstEnabledField(signinForm, function(field) {
            return field === signinPwdInput;
          });
          break;
        case 'PASSWORD_EXPIRED':
        case 'INVALID_PASSWORD_FORMAT':
        case 'PASSWORD_VIOLATES_RULES':
        case 'PASSWORD_CONTAINS_PROHIBITED_CHARS':
        case 'PASSWORD_CONTAINS_USERINFO':
        case 'PASSWORD_TOO_COMMON':
          // todo: when services support pwd reset for NF users remove this
          if (/^(netfirm|netfirmrest)$/i.test(primaryError.domain)) {
            trAuth.changeForm('trta1-pwdreset-netfirm', rootElem, detail);
            break;
          }
          trAuth.changeForm('trta1-pwdreset', rootElem, detail);
          break;
        case 'MFA_SETUP_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value);
          trAuth.changeForm('trta1-mfsrequired', rootElem, detail);
          break;
        case 'MFA_AUTHENTICATION_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value, detail.key);
          trAuth.changeForm('trta1-mfa-choosedevice', rootElem, detail);
          break;
      }
    }, signinForm);

    trAuth.listen('trta1-mfa-choosedevice-success', function(evt) {
      trAuth.changeForm('trta1-mfa-notifydevice', rootElem, evt.detail);
    }, rootElem);

    function shouldNag() {
      var store = trAuth.store(MFA_SHOULD_NAG_KEY);
      return store && (store === 'true');
    }

    function shouldNagOS() {
      // if not VO and os is not supported && not nagged yet
      return !options.isVO &&
             options.osCurrentBuildNumber &&
             unsupportedOperatingSystems.indexOf(options.osCurrentBuildNumber.toString()) > -1 &&
             !options.osNagged &&
             !options.osChecked;
    }

    // Responsible for kicking off the process of setting up MFA
    function setupMFA(formName, authKey) {
      trAuth.listen('click', function(evt) {
        evt.preventDefault();
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;

        // unload auth, trigger mfs
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-intro',
          templateData: {
            uid: uid
          },
          enableMFACards: false,
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes') {
              opts.startingForm = 'trta1-mfa-choosedevice';
              opts.templateData.cancelDestForm = 'trta1-signin';
              opts.generateCodes = true;
              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);

      }, rootElem.querySelector('form[name=' + formName + '] .trta1-mfs-go'), true);
    }

    function getMfNagKey() {
      var key, overrides, uid;

      // retrieve the uid
      overrides = options.formOverrides['trta1-signin'];
      if (overrides.values && overrides.values.uid) {
        uid = overrides.values.uid;
        key = MFA_NAG_DISMISS_KEY + '-' + uid;
      }

      return key;
    }

    function getMfarId() {
      return trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;
    }

    function getTruid() {
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var token = authSuccessEvt &&
                  authSuccessEvt.detail &&
                  authSuccessEvt.detail.data &&
                  authSuccessEvt.detail.data.tokenValue;
      if(!token) {
        return null;
      }
      var decodedJWT = window.jwt_decode(token);
      var truid = decodedJWT.sub;
      return truid;
    }

    trAuth.listen('trta1-mfa-approvecode-success', function() {
      secondFactorRequestSuccessful(getMfarId());
    }, rootElem);

    function secondFactorRequestSuccessful(mfarId) {
      if (options.flow.type === 'auth-2nd-factor') {
        var token = options.flow.data.jwt;
        var detail = { data: {
          mfarId: mfarId,
          token: token,
          decodedToken: window.jwt_decode(token)
        }};

        options.state.exitCode = 0; // success

        // todo: deprecate; for now keep backwards compat with 1.23.0
        detail.data.jwt = token;
        trAuth.trigger('tr-auth-2nd-factor-success', detail);
        // end

        trAuth.trigger('tr-auth-success', detail);

        trAuth.modules.auth.destroy();
      } else { // get Onvio full priv JWT
        trAuth.changeForm('trta1-mfa-retrievetoken', rootElem);
      }
    }

    // .trta1-mfs-go button click
    trAuth.listen('trta1-mfsrequired-enter', function(evt) {
      setupMFA('trta1-mfsrequired', evt.detail.key);
    }, rootElem);

    trAuth.listen('trta1-auth-success', function() {
      storeSigninData();
    }, signinForm);

    trAuth.listen('trta1-migrationcheck-success', function(evt) {
      var destForm = evt.detail.data.migrationStarted === true ? 'trta1-signin' : 'trta1-intro';
      trAuth.changeForm(destForm, rootElem);
    }, rootElem);

    trAuth.listen('trta1-pwdreset-enter', function(evt) {
      var type = evt.detail && evt.detail.type,
        cpid = evt.detail && evt.detail.key,
        auth = evt.detail && evt.detail.auth,
        payload, headers;

      if (type === 'PASSWORD_EXPIRED') {
        pwdResetForm.classList.add('trta1-pwdexpired');
      } else if (type === 'PASSWORD_EXPIRING') {
        pwdResetForm.classList.add('trta1-pwdexpiring');
      }
      if (cpid) {
        payload = trAuth.seekObjPath('formOverrides.trta1-pwdreset.payload', options, true);
        payload.cpid = cpid;
      }
      if (auth) {
        /*
          Profiles does not have an endpoint to accept a JWT for PW reset. We
          are going to send that case to AuthAgg, since long term we want all PW
          reset going there anyway
        */
        var action = evt.target && evt.target.action;
        if(action) {
          var actionHost = action.substring(0, action.indexOf('api'));
          evt.target.action = actionHost + 'api/auth/v1/password';
          evt.target.querySelector("[name=password]").name = 'pwd';
          evt.target.querySelector("[name=password2]").name = 'pwd2';
          headers = trAuth.seekObjPath('formOverrides.trta1-pwdreset.headers', options, true);
          headers.authorization = 'Bearer ' + auth;
          headers['content-type'] = 'application/json;charset=utf-8';
        }
      }
    }, rootElem);

    trAuth.listen('trta1-pwdreset-exit', function() {
      // clean up state from trta1-pwdreset-enter
      pwdResetForm.classList.remove('trta1-pwdexpired');
      pwdResetForm.classList.remove('trta1-pwdexpiring');
    }, pwdResetForm);

    // trAuth.listen('trta1-pwdreset-success', function() {
      // todo: figure out a better way to do auto login after pwd reset
      // var uid = options.formOverrides['trta1-pwdreset'].payload.uid;
      // if (uid) {
      //   signinUidInput.value = uid;
      //   signinPwdInput.value = pwdResetForm.elements.pwd.value;
      //   trAuth.changeForm('trta1-signin', rootElem);
      //   trAuth.trigger('submit', null, signinForm);
      // } else {
      // }
    // }, pwdResetForm);

    trAuth.listen('trta1-reqpwdreset-enter', function() {
      // sync email/login from signin
      reqPwdResetForm.elements.uid.value = signinUidInput.value;
    }, reqPwdResetForm);

    trAuth.listen('trta1-requnlock-complete-enter', function(evt) {
      trAuth.updateFormState(evt.target, 'success', options, 'unlockAcct');
    }, rootElem);

    // validation for password reset pwd pwdconfirm match
    trAuth.listen('input propertychange', function(evt) {
      if (resetPwds[1].setCustomValidity) { // feature check so IE9 won't throw
        if(resetPwds[0].value !== resetPwds[1].value) {
          resetPwds[1].setCustomValidity($t('Passwords Don\'t Match'));
        } else {
          resetPwds[1].setCustomValidity('');
        }
      }
      if (evt.target === resetPwds[0]) {
        trAuth.trigger('propertychange', null, resetPwds[1]);
      }
    }, pwdResetForm);

    // show/hide toggles for pwdReset
    trAuth.listen('click', function(evt) {
      switch(evt.target.id) {
        case 'trta1-toggle-pwd-requirements':
        case 'trta1-toggle-expired-pwd-requirements':
          pwdResetForm.querySelector('#trta1-pwd-requirements').classList.toggle('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-showtyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'text';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.nextElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-hidetyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'password';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.previousElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
      }
    }, pwdResetForm);

    // factor types
    // P=TRPushApp, T=3rdPartyTOTPApp, C=emergencyAccessCode, B=24hrBackupCode
    var factorTypeValue = { P: 1, T: 2, C: 3, B: 4 };
    var unsupportedFactorValue = 10;
    trAuth.listen('trta1-mfa-notifydevice-enter', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      // copy and sort factors
      // so that the last 'push' device registered sorts to top
      formPayload.factors = evt.detail.data.slice().sort(function (a, b) {
        var aCreateDate = new Date(a.registered),
          bCreateDate = new Date(b.registered);

        // ascending order on factor value, descending order on create time
        // accommodate not-yet-supported factors
        return (factorTypeValue[a.type] || unsupportedFactorValue) - (factorTypeValue[b.type] || unsupportedFactorValue) ||
          bCreateDate.getTime() - aCreateDate.getTime();
      });
    }, rootElem);

    trAuth.listen('trta1-mfa-notifydevice-success', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      var pushFactors = formPayload.factors.filter(function(factor) {
        return factor.type === 'P';
      });

      // If there are no emergency access codes, generate them after MFA
      // var hasCodes = formPayload.factors.filter(function(factor){
      //   return factor.type === 'C';
      // }).length > 0;
      // options.generateCodes = !hasCodes;

      // Only occurs when killswitch is on. If so, trigger success
      if (evt.detail.data && evt.detail.data.status === 'SUCCEEDED'){
        options.flow.type = 'auth-2nd-factor'
        secondFactorRequestSuccessful();
        return;
      }

      trAuth.changeForm('trta1-mfa-' + (pushFactors.length ? 'awaitapproval': 'approvecode'), rootElem, evt.detail);
    }, rootElem);

    var cancelAwaitApprovalPoll;
    trAuth.listen('trta1-mfa-awaitapproval-enter', function(evt) {
      var form = evt.target;
      var mfarId = getMfarId();

      form.action = form.action.replace(/\/[^/]*$/, '/' + mfarId);

      // poll for success
      cancelAwaitApprovalPoll = trAuth.pollFormRequest(
        form,
        // test fn
        function(evt) {
          return evt.detail.data.status === 'SUCCEEDED';
        },
        // success fn
        function() {
          secondFactorRequestSuccessful(mfarId);
        },
        // timeout fn
        function() {
          trAuth.updateFormState(form, 'error', options, 'timeout');
          /*
            Just double checking that we are stand in the correct form.
            The service provider is desktop only for now
            The help link will be available for US only at this time,
              so the isAValidDomain() function just check if the domain is a US one
          */
          if(form.name==="trta1-mfa-awaitapproval" && options.sp==="csdesktop" && isAValidDomain()){
            /* Doing this to make sure that the hyperlink will be added as html and not as plain text */
            form.querySelector('.trta1-form-msg').innerHTML+= "<br>" + $t("Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions");
          }
        }
        // roll with defaults for rest of params
        // errorFn = null, delay = 2, timeout = 40, leadingEdge = false, continueOnError = false
      );

    }, rootElem);

    trAuth.listen('trta1-mfa-awaitapproval-exit', function() {
      if (cancelAwaitApprovalPoll) {
        cancelAwaitApprovalPoll();
        cancelAwaitApprovalPoll = null;
      }
    }, rootElem);

    trAuth.listen('trta1-mfa-retrievetoken-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + getMfarId());
    }, rootElem);

    trAuth.listen('trta1-operating-system-check-enter', function(evt) {
      var form = evt.target;
      var nagPayload = trAuth.seekObjPath('formOverrides.trta1-operating-system-check.payload', options, true);
      nagPayload.key = 'Windows7';
      form.action = form.action.replace(/\/[^/]*$/, '/' + getTruid());
    }, rootElem);

    trAuth.listen('trta1-operating-system-check-success', function(evt) {
      var nextForm = 'trta1-postauth';
      var nagData = evt.detail && evt.detail.data
      evt.detail.data.windowsNag = nagData[0];
      if(!evt.detail.data.windowsNag){
        nextForm = 'trta1-unsupported-operating-system';
      } else {
        var nagDismissDate = getStartOfDaySysTime(evt.detail.data.windowsNag.lastNaggedAt);
        var today = getStartOfDaySysTime();
        var daysSinceNag = Math.max(0, Math.round((today - nagDismissDate) / (24 * 60 * 60 * 1000)));
        if( daysSinceNag >= 14 ) {
          nextForm = 'trta1-unsupported-operating-system';
        }
      }
      options.osChecked = true;
      trAuth.changeForm(nextForm, rootElem, evt.detail);
    }, rootElem);

    // os nag check fails
    trAuth.listen('trta1-operating-system-check-error', function(evt) {
      trAuth.changeForm('trta1-authcomplete', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-unsupported-operating-system-enter', function(evt) {

      var form = evt.target;
      var lastWindowsNagTime = evt.detail.data[0];
      form.setAttribute('method', (lastWindowsNagTime ? 'PUT' : 'POST'));
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var token = authSuccessEvt &&
                  authSuccessEvt.detail &&
                  authSuccessEvt.detail.data &&
                  authSuccessEvt.detail.data.tokenValue;
      trAuth.seekObjPath('formOverrides.trta1-unsupported-operating-system.headers', options, true).authorization = 'Bearer ' + token;
      var nagPayload = trAuth.seekObjPath('formOverrides.trta1-unsupported-operating-system.payload', options, true);
      nagPayload.lastNaggedAt = new Date().toISOString();
      nagPayload.userId = getTruid();
      if(lastWindowsNagTime && lastWindowsNagTime.id) nagPayload.id = lastWindowsNagTime.id;
      nagPayload.key = 'Windows7';

    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-code-exchange.payload', options, true).code = options.auth0Code;
      trAuth.seekObjPath('formOverrides.trta1-auth0-code-exchange.payload', options, true).state = options.auth0State;
    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-success', function(evt) {
      trAuth.trigger('tr-auth-success', prepareAuthSuccessData(evt, options));
      trAuth.trigger('trta1-auth0-complete-hidden-success', evt.detail);
      trAuth.modules.auth.destroy();
    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-error', function (evt) {

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/security/v2/environments', false);
      xhr.send();
      var isAuth0enabled;
      // Check if Auth0 is enabled
      try {
        var iac = JSON.parse(xhr.responseText);
        isAuth0enabled = iac.InfrastructureAccessControls.indexOf('Platform_DisableAuth0Phase2') == -1;

      } catch (error){

      }

      var primaryError = trAuth.getPrimaryError(evt.detail), detail;

      // trigger auth section error event
      // trAuth.trigger('tr-auth-error', evt.detail);

      if (!primaryError) return;

      detail  = { type: primaryError.reason };
      var location = evt.detail && evt.detail.headers && evt.detail.headers.location;

      if(detail.type === 'MFA_AUTHENTICATION_REQUIRED') {
        mfaLocation = location;
        trAuth.changeForm('trta1-mfarequired-screen', rootElem);
      }

      if((detail.type === 'CONTACT_NOT_FOUND_EXCEPTION' || detail.type === 'PRIMARY_PRODUCT_MISMATCHING')) {
        if(isAuth0enabled) {
          trAuth.changeForm('trta1-account-error-auth0-screen', rootElem);

          // show/hide no access to product card
          showNoAccessToProductCard(rootElem, options.type);
        } else{
          trAuth.changeForm('trta1-account-error-screen', rootElem);
        }
        signInLocation = location;
      }

      if(detail.type === 'FIRM_CREDIT_HOLD') {
        if(isAuth0enabled) {
            trAuth.changeForm('trta1-firm-lock-credit-hold-new-screen', rootElem);
          } else{
            trAuth.changeForm('trta1-firm-lock-credit-hold-screen', rootElem);
          }
        signInLocation = location;
      }

      if(detail.type === 'FIRM_LOCKED_OUT') {
        if(isAuth0enabled) {
            trAuth.changeForm('trta1-firm-lock-new-screen', rootElem);
          } else{
            trAuth.changeForm('trta1-firm-lock-credit-hold-screen', rootElem);
          }
        signInLocation = location;
      }
    }, rootElem);
    trAuth.listen('click', function() {
       if(mfaLocation) {
         window.location.href = mfaLocation;
       } else {
         // error, no location in header
         // go to legacy sign-in, may need to update later
         trAuth.changeForm('trta1-signin', rootElem);
       }
    }, rootElem.querySelector('#trta1-mfa-required'));
    trAuth.listen('click', function(evt) {
      window.location = '/login';
    }, rootElem.querySelector('#trta1-back-to-signin'));
    trAuth.listen('trta1-auth0-redirect-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).type = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).sp = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).redirectUri = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).adjustHash = undefined;
    }, rootElem);
    trAuth.listen('trta1-auth0-redirect-error', function(evt) {
      trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
    }, rootElem);

    trAuth.listen('trta1-auth0-redirect-success', function(evt) {

      var IACs = evt.detail && evt.detail.data && evt.detail.data.InfrastructureAccessControls;
      if(IACs) {
        var isAuth0Phase2Disabled = IACs.includes('Platform_DisableAuth0Phase2');
        if(isAuth0Phase2Disabled) {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        } else {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        }
      } else {
        trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
      }

    }, rootElem);

    trAuth.listen('click', function (){
      retrieveAuth0LoginUri(options.type, options.sp, options.auth0Redirect || location.protocol + '//' + location.host, options.adjustHash)
        .then(function (response) {
          var location = response.headers.get('location');
          if(location) {
            window.location.href = location;
          } else {
            trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
          }
        }).catch(function() {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        });
    }, rootElem.querySelector('#trauth-continue-signin-btn'));

    trAuth.listen('click', function (){
      retrieveAuth0LoginUri(options.type, options.sp, options.auth0Redirect || location.protocol + '//' + location.host, options.adjustHash)
        .then(function (response) {
          var location = response.headers.get('location');
          if(location) {
            window.location.href = location;
          } else {
            trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
          }
        }).catch(function() {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        });
    }, rootElem.querySelector('#trauth-continue-signout-btn'));

    trAuth.listen('trta1-auth0-signin-redirect-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-signin-redirect.payload', options, true).redirectUri = location.origin + location.pathname;
    }, rootElem);
    trAuth.listen('trta1-auth0-signin-redirect-error', function(evt) {
      trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
    }, rootElem);

    trAuth.listen('trta1-auth0-signin-redirect-success', function(evt) {
      var location = evt.detail && evt.detail.headers && evt.detail.headers.location;
      if(location) {
        window.location.href = location;
      } else {
        // error, no location in header
        // go to auth0 sign-in again
        trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
      }
    }, rootElem);

    trAuth.listen('click', function (){
      trAuth.changeForm('trta1-auth0-signin-redirect', rootElem);
    }, rootElem.querySelector('#trta1-auth0-continue-signin-btn'));

    function getStartOfDaySysTime(sysTime) {
      return (new Date((new Date(sysTime || +new Date())).toDateString())).getTime();
    }

    /**
      Listener that will be called after successful login and/or multi-factor authentiation
      cxg
    **/
    trAuth.listen('trta1-auth-success trta1-mfa-retrievetoken-success', function(evt) {

      // save off the successfully authentication event
      trAuth.seekObjPath('data', options, true).authSuccessEvt = evt;
      rootElem.classList.add('trta1-authcomplete');

      // if codes are required, generate
      if(options.generateCodes) {
        var authKey = evt.detail.data.tokenValue;
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-emergencycodes-check',
          templateData: {
            uid: uid
          },
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes' || evt.detail.form === 'trta1-mfs-emergencycodes-check') {
              opts.startingForm = 'trta1-postauth';
              var data = { authSuccessEvt: { detail: { data: { tokenValue : authKey}}}};
              opts.data = data;
              opts.templateData.cancelDestForm = 'trta1-signin';

              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);
      }
      var nextForm = 'trta1-postauth';

      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem);

    trAuth.listen('trta1-postauth-enter', function(evt) {
      var doMultiFactorNag = false,
        nextForm = 'trta1-authcomplete',
        daysTillExp,
        dismissDay,
        mfnagStoredDate,
        mfnagDismissDate,
        daysTillNag;
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var authSuccessEvtType = authSuccessEvt && authSuccessEvt.type;
      var exp = authSuccessEvt.detail && authSuccessEvt.detail.data && authSuccessEvt.detail.data.passwordExpiration;
      var detail = evt.detail;
      // if authentication is successful (without mfa), need to check if we need to nag the user about setting up mfa
      if(!options.disableMfaNag && authSuccessEvtType && authSuccessEvtType === 'trta1-auth-success') {
        var mfNagKey = getMfNagKey();
        // retrieve the stored dismiss date and compare it to today
        if(mfNagKey) {
          mfnagStoredDate = trAuth.store(mfNagKey);
        } else {
          mfnagStoredDate = trAuth.store(MFA_NAG_DISMISS_KEY);
        }

        if(mfnagStoredDate === null) {
          // since we have no date, automatically nag
          doMultiFactorNag = true;
          nextForm = 'trta1-mfnag';
        } else {
          mfnagDismissDate = new Date(mfnagStoredDate);

          // calculate the number of days from dismiss day
          daysTillNag = Math.round(Math.abs(((new Date()).getTime() - mfnagDismissDate.getTime()) / (24 * 60 * 60 * 1000)));
          if(daysTillNag > 30) {
            doMultiFactorNag = true;
            nextForm = 'trta1-mfnag';
          }
        }
      }

      // store the mfa nag incase pwd expiration is needed
      trAuth.store(MFA_SHOULD_NAG_KEY, doMultiFactorNag.toString());

      if( shouldNagOS() ){
        nextForm = 'trta1-operating-system-check';
      }

      // check for password expiring soon
      if (!options.pwdNagged && typeof exp === 'number') {
        daysTillExp = Math.max(0, Math.round((getStartOfDaySysTime(exp) - getStartOfDaySysTime()) / (24 * 60 * 60 * 1000))); // 1 day in ms
        dismissDay = trAuth.store('tr-auth-pwdexp-dismissday');

        if (
          // 5 or less days
          daysTillExp <= 5 &&
          (
            // desktop and first launch (desktop can't use localStorage)
            (options.sp === 'csdesktop' && options.payload.launchReason === 'InitialLogin') ||
            // not desktop and not dismissed today
            (options.sp !== 'csdesktop' && dismissDay !== (new Date()).toDateString())
          )
        ) {
          nextForm = 'trta1-pwdexpiring';
          if(detail && detail.data) {
            detail.data.daysTillPwdExp = daysTillExp;
          } else {
            detail = { data: { daysTillPwdExp: daysTillExp } };
          }
        }
      }
      trAuth.changeForm(nextForm, rootElem, detail);
    }, rootElem);

    /**
      Listener that will be called when the password reset completion screen is displayed
    **/
    trAuth.listen('click', function() {
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-pwdresetcompleteokbtn'));

    trAuth.listen('click', function() {
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-pwdresetnetfirmokbtn'));

    trAuth.listen('click', function() {
      options.osNagged = true;
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-dismissosnag'));

    /**
      Listener that will be called when the mfa nag screen is displayed
    **/
    trAuth.listen('trta1-mfnag-enter', function(evt) {
      // CXG - I needed the ability to setup nag for NetFirm
      if(options.type === 'netfirm') {
        setupMFA('trta1-mfnag', evt.detail.key || evt.detail.data.tokenValue);
      } else {
        var authSuccessEvt = options.data.authSuccessEvt;
        setupMFA('trta1-mfnag', authSuccessEvt.detail.data.tokenValue);
      }
    }, rootElem);

    // setup mfa...do it later
    trAuth.listen('click', function(evt) {
      var mfNagKey = getMfNagKey();
      if(mfNagKey) {
        trAuth.store(mfNagKey, (new Date()).toDateString());
      } else {
        trAuth.store(MFA_NAG_DISMISS_KEY, (new Date()).toDateString());
      }

      var nextForm = 'trta1-postauth';
      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem.querySelector('#trta1-mfs-later'));


    trAuth.listen('trta1-pwdexpiring-enter', function(evt) {
      options.pwdNagged = true;
      var daysTillExp = evt.detail && evt.detail.data.daysTillPwdExp;
      if (typeof daysTillExp !== 'number') return;

      pwdExpiringForm.querySelector('#trta1-pwdexpdays').textContent = daysTillExp;
      pwdExpiringForm.classList[daysTillExp === 0 ? 'add' : 'remove']('trta1-pwdexpireszerodays');
      pwdExpiringForm.classList[daysTillExp === 1 ? 'add' : 'remove']('trta1-pwdexpiresoneday');
    }, rootElem);

    // pwdexpiring do it later
    trAuth.listen('click', function(evt) {
      trAuth.store('tr-auth-pwdexp-dismissday', (new Date()).toDateString());
      var nextForm = 'trta1-postauth';

      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem.querySelector('#trta1-chgpwdlaterbtn'));

    // pwdexpiring change now
    trAuth.listen('click', function(evt) {
      evt.preventDefault();

      // todo: when services support pwd reset for NF users remove this
      if (/^(netfirm|netfirmrest)$/i.test(options.data.authSuccessEvt.detail.data.domain)) {
        trAuth.changeForm('trta1-pwdreset-netfirm', rootElem);
      } else {
        trAuth.changeForm('trta1-pwdreset', rootElem, {
          auth: options.data.authSuccessEvt.detail.data.tokenValue,
          type: 'PASSWORD_EXPIRING'
        });
      }
    }, rootElem.querySelector('#trta1-chgpwdnowbtn'));

    trAuth.listen('trta1-authcomplete-enter', function() {
      // set values in DOM for desktop to retrieve, #8442
      var form = rootElem.querySelector('form[name=trta1-signin]'),
        overrides = options.formOverrides['trta1-signin'];
      if (overrides.values) {
        Object.keys(overrides.values).forEach(function(fieldName) {
          var value = overrides.values[fieldName];
          // jshint eqnull:true
          if (value == null) return;

          form.elements[fieldName].value = value;
        });
      }

      setTimeout(function() {
        options.state.exitCode = 0; // success
        // trigger auth section success event

        trAuth.trigger('tr-auth-success', prepareAuthSuccessData(options.data.authSuccessEvt, options));
        // delay to next execution cycle so event can bubble
        setTimeout(function() {
          // blank out uid/pwd to keep things secure
          signinUidInput.value = '';
          signinPwdInput.value = '';
        });
      }, 125); // wait 1/8 beat
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.auth.destroy(true);
    }
    trAuth.modules.auth.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-auth-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-auth-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    // setup debug
    if (options.payload && options.payload.firmId) {
      var el;
      if (window.trAuth.shadowDomElem) {
        el = window.trAuth.shadowDomElem;
      } else {
        el = document;
      }
      el.querySelector('.trta1-debug').textContent = 'fid:' + options.payload.firmId;
    }

    // ready
    document.documentElement.classList.add('trta1-auth-active');
    trAuth.trigger('tr-auth-ready', options);
    trAuth.moduleReady(rootElem, options);

    return trAuth.getRootElem();
  }

  trAuth.modules.auth = {
    init: init
  };

  function retrieveAuth0LoginUri(type, sp, redirectUri, adjustHash) {
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    var cookieLangValue = (document.cookie.match('(^|; )BMLanguageCode=([^;]*)') || '')[2];
    var locale;

    switch (domain) {
      case '.com.ar':
        locale = 'es-AR';
        break;
      case '.com.br':
        locale = (cookieLangValue)? cookieLangValue: 'pt-BR';
        break;
      case '.co.uk':
        locale = 'en-GB';
        break;
      case '.ca':
        locale = (cookieLangValue)? cookieLangValue: 'en-CA';
        break;
      case '.us':
      default:
        locale = 'en-US';
        break;
    }

    // Set default locale for onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
    domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
    switch (domain) {
      case '.com.br':
        locale = 'pt-BR';
        break;
      case '.com.ar':
        locale = 'es-AR';
        break;
    }

    // Take the proper locale to test in localhost
    if(window.location.hostname.toLowerCase() === 'localhost'){
      locale = (cookieLangValue)? cookieLangValue: 'en-US';
    }

    return fetch('/api/security/v1/oidc/login', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        type: type,
        sp: sp,
        redirectUri: redirectUri,
        adjustHash: adjustHash,
        lang: locale
      })
    });
  }

  function isAValidDomain(){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];

    switch (domain) {
      case '.us': return true;
      default: return false;
    }
  }

  function hideSystemStatus(){
    var url = window.location.origin;
    var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    // Disable system status link on BR and AR region, is enabled for any other region
    switch (domain) {
      case '.com.br':
          return true;
      case '.com.ar':
          return true;
      case '.ca':
          return true;
    }
    // Disable system status link in onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
    domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
    switch (domain) {
      case '.com.br':
        return true;
      case '.com.ar':
        return true;
    }
    return false;
  }

  function retrieveAboutAccountSecLink(){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];

    switch (domain) {
      case '.co.uk':
        return '/ua/help/gb-en/staff/core/setup/2sv-overview.htm';
      case '.us':
      default:
        return '/ua/help/us-en/staff/core/setup/2sv-overview.htm';
    }
  }

  // Return the message Contact your Onvio administrator.
  function getAppMessageAdministrator(type){
    switch (type) {
      case 'employeeportal':
      case 'onbalance':
        return 'Contact your administrator.';
      // For onvio and other cases
      default:
        return 'Contact your Onvio administrator.';
    }
  }

  function showNoAccessToProductCard(rootElem, type){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    if (domain !== '.com.br') return;

    if (type === 'onvio') {
      // hide basic instructions card
      var accountErrorBasicInstructionsCard = rootElem.querySelector('form.auth0-login-form[name="trta1-account-error-auth0-screen"] div.trta1-form-instructions');
      accountErrorBasicInstructionsCard.classList.add('trta1-hide');

      // show select module instructions card
      var accountErrorNoAccessToModulesCard = rootElem.querySelector('form.auth0-login-form[name="trta1-account-error-auth0-screen"] div.trta1-form-instructions-no-access-to-module');
      accountErrorNoAccessToModulesCard.classList.remove('trta1-hide');
    }
  }

  function fetchAuthCodeSessionsV2IACStatus() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/security/v2/environments', false);
    xhr.send();

    // check in iacs if Platform_EnableOnvioSTID is there if yes return true.This will call v2/oidc/auth-code/session endpoint in place
    // of v1/oidc/auth-code/session to get OnvioSTID (new jwt)
    try {
      var iac = JSON.parse(xhr.responseText);
      var isV2Enabled = iac.InfrastructureAccessControls.indexOf('Platform_EnableOnvioSTID') != -1;
      return isV2Enabled;
    } catch (error) {
      // If there is an error just continue and it will show the legacy form
      window.console.log('Could not get IACs, so continue with the previous flow');
      return false;
    }
  }

})(window);
(function(window) {
  'use strict';

  var trAuth = window.trAuth;

  var appleStoreLangCodeMap = {
    'en-US': 'en-us',
    'en-AU': 'en-us',
    'en-CA': 'en-us',
    'en-GB': 'en-us',
    'en-IN': 'en-us',
    'es-AR': 'es-mx',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl-nl',
    'pt-BR': 'pt-br'
  };
  var googleStoreLangCodeMap = {
    'en-US': 'en',
    'en-AU': 'en',
    'en-CA': 'en',
    'en-GB': 'en',
    'en-IN': 'en',
    'es-AR': 'es-419',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl',
    'pt-BR': 'pt-br'
  };

  var otpauthTemplate = 'otpauth://totp/<%= env %>Thomson%20Reuters%20ID:<%= uid %>?secret=<%= otpSecret %>&issuer=<%= env %>Thomson%20Reuters%20ID&algorithm=SHA1&digits=6&period=30&a=<%= factorId %>&m=<%= mfarId %>&url=<%= url %>';

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trta1-mfs" aria-label="Multi-Factor Authentication Setup">\
      <h1 t8 class="trta1-print-only" area-hidden="true">Thomson Reuters</h1>\
      <h2 t8 role="heading">Multi-Factor Authentication Setup</h2>\
      <button data-trta1-dest="trta1-$close" class="trta1-dialog-close" autofocus aria-label="Close" role="button" aria-hidden="true">&times;</button>\
      <form name="trta1-mfs-intro">\
        <div class="trta1-form-instructions" tabindex="-1">\
          <h3 class="trta1-heading-inner" t8>Increase security for your account</h3>\
          <p t8>Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.</p>\
          <h3 class="trta1-heading-inner" t8>How long will it take to set up?</h3>\
          <p t8>A few minutes.</p>\
          <h3 class="trta1-heading-inner" t8>How will this affect me?</h3>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$close" type="button" aria-label="cancel">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" class="trta1-btn-primary-get" aria-label="Get Started">Get Started</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-install">\
        <h3 t8>Download and install Thomson Reuters Authenticator app</h3>\
        <div class="trta1-form-instructions">\
          <p t8>On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.</p>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#app">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
          </p>\
          <ul class="shield-bg">\
            <li><a target="_blank" rel="noopener" class="trta1-appleStore-link" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>" style="display:inline-block;overflow:hidden;background:url(//linkmaker.itunes.apple.com/assets/shared/badges/<%= appleStoreLangCode %>/appstore-lrg.svg) no-repeat;width:135px;height:40px;background-size:contain;"></a></li>\
            <li><a target="_blank" rel="noopener" class="trta1-googleStore-link" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>"><img src="https://play.google.com/intl/en_us/badges/images/generic/<%= googleStoreLangCode %>_badge_web_generic.png"></a></li>\
            <!--li><a t8 id="trta1-authapp-email-link" href="javascript:void(0)">Email me a link</a></li-->\
          </ul>\
          <p t8>After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-3p-install">\
        <h3 t8>Download and install an alternate multi-factor app</h3>\
        <div class="trta1-form-instructions">\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
          </p>\
          <p t8>The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target="_blank" rel="noopener" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>">Apple App Store</a> or the <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>">Google Play Store</a>.</p>\
          <p t8 class="thirdparty-app-bg">After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-gencode" method="post" action="<%= authSvcHost %>/api/mfa/v1/factors" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Generating QR code.</p>\
        </div>\
        <input type="hidden" name="type" value="T">\
        <input type="hidden" name="address" value="TOTP">\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-devicelookup" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" tr-autosubmit tr-goto-onsuccess="trta1-mfs-paired" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving device info.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-emergencycodes-check" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
      </form>\
      <form name="trta1-mfs-paired" method="put" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" novalidate>\
        <div class="trta1-form-instructions">\
          <h3 t8 class="success-shield-bg">Pairing Successful!</h3>\
          <p t8>You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
          <!--p t8>You have paired your account with <b id="trta1-mfs-devicename">this device</b>.</p>\
          <h4 t8>What can I expect?</h4>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account. To add or remove a paired device, go to your account settings.</p>\
          <h4 t8>What\'s left to do?</h4>\
          <p t8>Name your device. Confirm the pairing. Generate emergency access codes.</p>\
          <h4 t8>Need help?</h4>\
          <p><a t8 target="_blank" rel="noopener" href="">Learn more about the new security system.</a></p-->\
          <label><span t8>Name this multi-factor option</span>\
            <input type="text" name="device-name" required pattern=".*\\S+.*" maxlength="250" tr-nosend>\
          </label>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
          </p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8>Finish</button>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.chooseType.template +
    trAuth.submodules.scanCode.template +
    trAuth.submodules.registerDevice.template +
    trAuth.submodules.emergencyCodes.template +
    trAuth.submodules.pairDevice.template +

    '</section>\
  ';
  /* jshint multistr: false */

  function init(options) {
    var rootElem, qrCodeContainer, deviceNameInput;

    options = options || { locale: 'en-US' };

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      enableMFACards: false,
      enableThirdPartyApp: true,
      templateData: {
        authSvcHost: 'https://onvio.us',
        onvioHelpDomain: 'https://onvio.us',
        onvioHelpUserType: 'staff',
        cancelDestForm: 'trta1-$start',
      },
      formOverrides: {
        'trta1-mfs-gencode': {
          payload: {
            name: 'device'
          }
        },
        'trta1-mfs-scancode': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': {
              'timeout': $t('Timed out waiting for scan. Please go back and try again.'),
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        },
        'trta1-mfs-pairdevice': {
          formStateMessages: {
            'error': {
              'bad request': $t('Incorrect Device ID or Code. Please try again.'),
              '400': $t('Incorrect Device ID or Code. Please try again.'),
              'unauthorized': $t('Incorrect Device ID or Code. Please try again.'),
              '401': $t('Incorrect Device ID or Code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;

    var tmplData = trAuth.objAssignDeep({}, options.templateData, {
      onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),
      dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),
      digitaHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),
      appleStoreCountryCode: options.locale.split('-')[1].toLowerCase(),
      appleStoreLangCode: appleStoreLangCodeMap[options.locale],
      googleStoreLangCode: googleStoreLangCodeMap[options.locale]
    });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), tmplData, null, null, options.locale);

    qrCodeContainer = rootElem.querySelector('.trta1-mfs-qrcode');
    deviceNameInput = rootElem.querySelector('form[name=trta1-mfs-paired] input[name=device-name]');

    // initialize submodules
    trAuth.submodules.chooseType.init(rootElem, options, trAuth);
    trAuth.submodules.scanCode.init(rootElem, options, trAuth);
    trAuth.submodules.registerDevice.init(rootElem, options, trAuth);
    trAuth.submodules.emergencyCodes.init(rootElem, options, trAuth);
    trAuth.submodules.pairDevice.init(rootElem, options, trAuth);

    trAuth.listen('trta1-mfs-gencode-enter', function(evt) {
      // if we've already got a code, continue
      if (options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-scancode', rootElem);
        return;
      }

      trAuth.trigger('submit', null, evt.target);
    }, rootElem);

    trAuth.listen('trta1-mfs-gencode-success', function(evt) {
      var tmpl = otpauthTemplate,
        svcUrl = options.templateData.authSvcHost,
        qrTmplDataOverrides = { uid: encodeURIComponent(options.templateData.uid) },
        // note: not an ideal way to get ENV
        env = svcUrl.replace(/^https?:\/\/([^/]+).*$/, function(url, host) {
          env = host.split('.')[0];
          if (/^(ci|demo|qed)$/.test(env)) return env.toUpperCase() + '%20';
          if (/^(localhost(:\d+)?|\d+)$/.test(env)) return 'LOCAL';
          return ''; // leave PROD blank
        }),
        qrText;

      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;

      // add proper override data to qrText based on env
      if (env === 'LOCAL') {
        // default svc url to demo
        qrTmplDataOverrides.url = encodeURIComponent('https://demo.onvio.us');
        qrTmplDataOverrides.env = 'DEMO%20';
      } else { // otherwise
        qrTmplDataOverrides.url = encodeURIComponent(svcUrl);
        qrTmplDataOverrides.env = env;
      }

      qrText = trAuth.template(tmpl, options)(trAuth.objAssignDeep({}, evt.detail.data, qrTmplDataOverrides));
      // Clean up since QRCode lib won't if it created nodes previously
      while (qrCodeContainer.firstChild) {
        qrCodeContainer.removeChild(qrCodeContainer.firstChild);
      }
      options.state.qrCode = new window.QRCode(qrCodeContainer, {
          text: qrText,
          width: 207,
          height: 207,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : window.QRCode.CorrectLevel.L
      });

      // remove tooltip that qrCode puts in
      qrCodeContainer.removeAttribute('title');
      trAuth.changeForm('trta1-mfs-scancode', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-devicelookup-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + options.state.factorData.factorId);
    }, rootElem);

    trAuth.listen('trta1-mfs-paired-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + trAuth.getLastFormResp('trta1-mfs-devicelookup').data.id);
      var deviceName = evt.detail.data && evt.detail.data.name || options.state.$t('Thomson Reuters Authenticator Card');
      if (deviceName) {
        // plug device name into paragraph
        // rootElem.querySelector('#trta1-mfs-devicename').textContent = deviceName;
        deviceNameInput.value = deviceName;
      }
    }, rootElem);

    trAuth.listen('submit', function() {
      var factor = trAuth.getLastFormResp('trta1-mfs-devicelookup').data;
      factor.name = deviceNameInput.value;
      trAuth.seekObjPath('formOverrides.trta1-mfs-paired', options, true).payload = factor;
    }, rootElem.querySelector('form[name=trta1-mfs-paired]'));

    trAuth.listen('trta1-mfs-paired-success', function(evt) {
      trAuth.changeForm('trta1-mfs-emergencycodes-check', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-check-success', function(evt){
      var hasCodes = evt.detail.data && evt.detail.data.filter(function(factor){
        return factor.type === 'C';
      }).length > 0;
      if(!hasCodes) {
        trAuth.changeForm('trta1-mfs-emergencycodes', rootElem, evt.detail);
      } else {
        // go to success
        options.state.exitCode = 0; // success
        trAuth.trigger('tr-mfs-success');
        // pause for 1/2 beat before closing dialog so user can see success
        setTimeout(trAuth.changeForm, 500, 'trta1-$close');
      }
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.mfs.destroy(true);
    }
    trAuth.modules.mfs.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-mfs-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-mfs-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    document.documentElement.classList.add('trta1-mfs-active');
    trAuth.trigger('tr-mfs-ready');
    trAuth.moduleReady(rootElem, options);
    return trAuth.getRootElem();
  }

  trAuth.modules.mfs = {
    init: init
  };

})(window);

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */

window.matchMedia || (window.matchMedia = function() {
    "use strict";

    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);

    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;

        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';

        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }

                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }

    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. MIT license */
(function(){
    // Bail out for browsers that have addListener support
    if (window.matchMedia && window.matchMedia('all').addListener) {
        return false;
    }

    var localMatchMedia = window.matchMedia,
        hasMediaQueries = localMatchMedia('only all').matches,
        isListening     = false,
        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
        handleChange    = function(evt) {
            // Debounce
            clearTimeout(timeoutID);

            timeoutID = setTimeout(function() {
                for (var i = 0, il = queries.length; i < il; i++) {
                    var mql         = queries[i].mql,
                        listeners   = queries[i].listeners || [],
                        matches     = localMatchMedia(mql.media).matches;

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
                    if (matches !== mql.matches) {
                        mql.matches = matches;

                        for (var j = 0, jl = listeners.length; j < jl; j++) {
                            listeners[j].call(window, mql);
                        }
                    }
                }
            }, 30);
        };

    window.matchMedia = function(media) {
        var mql         = localMatchMedia(media),
            listeners   = [],
            index       = 0;

        mql.addListener = function(listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
            if (!hasMediaQueries) {
                return;
            }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
            if (!isListening) {
                isListening = true;
                window.addEventListener('resize', handleChange, true);
            }

            // Push object only if it has not been pushed already
            if (index === 0) {
                index = queries.push({
                    mql         : mql,
                    listeners   : listeners
                });
            }

            listeners.push(listener);
        };

        mql.removeListener = function(listener) {
            for (var i = 0, il = listeners.length; i < il; i++){
                if (listeners[i] === listener){
                    listeners.splice(i, 1);
                }
            }
        };

        return mql;
    };
}());

/*
 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
 */
(function(window, angular, undefined) {
'use strict';

angular.module("matchmedia-ng", []).
    provider('matchmedia', function (){

        ///////////////////////////////////////////////////////////////////////
        // Configuration
        ///////////////////////////////////////////////////////////////////////
        /**
         *
         * these settings can be changed by injecting matchmediaProvider into
         * the config function of your module and
         * changing the matchmediaProvider.rules with your own rule key value
         * pairs E.G.

         *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
         *  }]);
         *
         * default values taken from twitter bootstrap :
         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
         */
        var matchmedia = {
            rules: {
                print : "print",
                screen : "screen",
                phone : "(max-width: 767px)",
                tablet : "(min-width: 768px) and (max-width: 979px)",
                desktop : "(min-width: 980px)",
                portrait : "(orientation: portrait)",
                landscape : "(orientation: landscape)"
            }
        };
        matchmedia.$get = ['$window','safeApply', 'logger', function($window, safeApply, logger) {

            logger.log('Creating matchmedia');

            ///////////////////////////////////////////////////////////////////////
            // Private Methods
            ///////////////////////////////////////////////////////////////////////
            function createSafeListener(cb, $scope){
                return function(mediaQueryList){
                    safeApply(function() {
                        cb(mediaQueryList);
                    },$scope);
                };
            }

            ///////////////////////////////////////////////////////////////////////
            // Public Methods
            ///////////////////////////////////////////////////////////////////////
            //should never be called directly, but is available for custom calls.
            var matchmediaService = {};

            /**
             * @param {string} query media query to listen on.
             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            matchmediaService.on = function(query, listener, $scope) {
                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia('all').addListener;
                if(supportsMatchMedia) {
                    logger.log('adding listener for query: '+ query);
                    var mediaQueryList = $window.matchMedia(query);
                    var handler = createSafeListener(listener, $scope);
                    mediaQueryList.addListener(handler);
                    //immediately return the current mediaQueryList;
                    handler(mediaQueryList);

                    return function() {
                        logger.log('removing listener from query: '+ query);
                        mediaQueryList.removeListener(handler);

                    };
                }
            };
            /**
             * @param {string} query media query to test.
             * @returns {mediaQueryList} Returns a boolean.
             */
            matchmediaService.is = function(query) {
                logger.log('test query: '+ query);
                return $window.matchMedia(query).matches;
            };



            ///////////////////////////////////////////////////////////////////////
            // Aliased Methods
            ///////////////////////////////////////////////////////////////////////
            matchmediaService.onPrint = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.print,listener, $scope);
            };
            matchmediaService.onScreen = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.screen,listener, $scope);
            };
            matchmediaService.onPhone = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.phone,listener, $scope);
            };
            matchmediaService.onTablet = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.tablet,listener, $scope);
            };
            matchmediaService.onDesktop = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.desktop,listener, $scope);
            };
            matchmediaService.onPortrait = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.portrait,listener, $scope);
            };
            matchmediaService.onLandscape = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.landscape,listener, $scope);
            };

            matchmediaService.isPrint = function(){
                return matchmediaService.is(matchmedia.rules.print);
            };
            matchmediaService.isScreen = function(){
                return matchmediaService.is(matchmedia.rules.screen);
            };
            matchmediaService.isPhone = function(){
                return matchmediaService.is(matchmedia.rules.phone);
            };
            matchmediaService.isTablet = function(){
                return matchmediaService.is(matchmedia.rules.tablet);
            };
            matchmediaService.isDesktop = function(){
                return matchmediaService.is(matchmedia.rules.desktop);
            };
            matchmediaService.isPortrait = function(){
                return matchmediaService.is(matchmedia.rules.portrait);
            };
            matchmediaService.isLandscape = function(){
                return matchmediaService.is(matchmedia.rules.landscape);
            };
            return matchmediaService;
        }];
        return matchmedia;
    })
    .directive('ajMatchmedia', ['matchmedia', function(matchmedia) {
        return {
            restrict: 'E',
            scope: {
                'queryListener': '&',
                'queryMatches': '='
            },
            link: function(scope, element, attrs, controllers) {
                var deregister;

                if (attrs.on && attrs.queryListener) {
                    if (attrs.on.slice(0, 2) === 'on' && matchmedia[attrs.on] !== 'undefined') {
                        deregister = matchmedia[attrs.on](function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    } else {
                        deregister = matchmedia.on(attrs.on, function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    }
                    scope.$on('$destroy', deregister);
                } else if (attrs.is && attrs.queryMatches) {
                    if (attrs.is.slice(0, 2) === 'is' && matchmedia[attrs.is] !== 'undefined') {
                        scope.queryMatches = matchmedia[attrs.is]();
                    } else {
                        scope.queryMatches = matchmedia.is(attrs.is);
                    }
                }
            }
        };
    }])
    .factory('safeApply', ['$rootScope',function($rootScope) {
        return function(fn, $scope) {
            $scope = $scope || $rootScope;
            var phase = $scope.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
                if (fn) {
                    $scope.$eval(fn);
                }
            } else {
                if (fn) {
                    $scope.$apply(fn);
                } else {
                    $scope.$apply();
                }
            }
        };
    }])
    .provider('logger', function(){
        this.DEVMODE = false;

        this.setDEVMODE = function(devmode){
            this.DEVMODE = devmode;
        };

        this.$get = ['$window', '$log', function($window, $log) {
            var DEVMODE = this.DEVMODE;
            var logger = {};
            logger.log = function(){
                if (DEVMODE) $log.info(arguments);
            };
            logger.always = function(){
                $log.info(arguments);
            };
            return logger;
        }];
    });
})(window, window.angular);

/**
 * @license
 * NavMore <https://github.com/pinkhominid/navmore>
 * A navigation list decorator that produces a responsive horizontal nav menu.
 * Written with ES5 and CSS3. No dependencies.
 *
 * Copyright pinkhominid
 * Released under MIT License <https://raw.githubusercontent.com/pinkhominid/navmore/master/LICENSE>
 *
 * Chrome/Firefox/Safari/Opera/Edge/IE11
 *
 * TODO
 * fix msie
 * support keyboard navigation
 * support varied nav item tags
 * improve animation
 * calc'ed height of droplist
 * a way to denote items outside of viewport in sub-lists (e.g. gradients)
 */

;(function(window) {
  var document = window.document;

  window.navmore = function(nav) {
    var mainList = nav.querySelector('ul');
    var moreItem = createElementFromString('<li class="hidden"><a class="navmore-moreitem" href="javascript:void(0)">More&hellip;</a><ul></ul></li>');
    var moreList = moreItem.querySelector('ul');
    var navItemTagNames = 'A, H1'; // NOTE: css currently supports A, H1
    var selected;
    var unthrottleResize;

    function init() {
      mainList.appendChild(moreItem);
      nav.classList.add('navmore');
      // add top-level interactive elements to tabindex
      forEachFirstChildByTagName(mainList, navItemTagNames, addToTabIndex);

      // Public API
      nav.navmore = {
        reset: reorgNav, // recalc/rerender nav items
        collapse: collapse, // collapse dropped menus
        getSelected: getSelected, // get selected hierarchy as array [leaf, ..., root]
        setSelected: setSelected, // set selected leaf item then update hierarchy
        setMoreItemText: setMoreItemText, // update the text for the more item
        destroy: destroy // cleanup all traces of navmore
      };

      // listeners
      unthrottleResize = throttle('resize', 'optimizedResize');
      window.addEventListener('optimizedResize', reorgNav, false);
      window.addEventListener('click', handleTap, false);
      window.addEventListener('keypress', handleKeyPress, false);

      /* bootstrap */
      reorgNav();
    }

    /* BEHAVIORS */

    function isFlex() {
      return nav.classList.contains('navmore-flex') || nav.classList.contains('navmore-flexgrow');
    }

    function isNavLeafItem(target) {
      // has href and not javascript:void(0)
      return target.href && target.href.indexOf('http') === 0;
    }

    function handleTap(e) {
      // retarget tap to account for nested elements
      var target = retargetBubbleEventByTagName(e, mainList, navItemTagNames);
      if (!target) {
        collapse();
        return;
      }

      var isLeaf = isNavLeafItem(target);
      // toggle tapped navItem focus
      if (!isLeaf && isItemFocused(target)) {
        // clear focus for tapped navItem and all descendants
        forEachDescendantsByTagName(target.parentNode, navItemTagNames, blurItem);
        // remove nested descendants from tabindex
        removeNestedFromTabIndex(target.parentNode);
        return;
      }

      collapse();
      removeNestedFromTabIndex();

      if (isLeaf) {
        setSelected(target);
      } else { // is branch
        // focus ancestor navItems
        forEachAncestorSiblingsByTagName(target, mainList, 'UL', navItemTagNames, focusItem);
        // if list is nested, add parent list to tabindex
        var upperLevelList = getClosestAncestorByTagName(target, mainList, 'UL');
        if(upperLevelList) {
          forEachFirstChildByTagName(upperLevelList, navItemTagNames, addToTabIndex);
        }
        var parentList = getClosestAncestorByTagName(target, mainList, 'LI');
        // make nested list items selectable via keyboard
        forEachFirstChildByTagName(parentList.querySelector('ul'), navItemTagNames, addToTabIndex);
        // focus tapped navItem
        focusItem(target);
      }
    }

    function handleKeyPress(e) {
      var key = e.which || e.keyCode;
      // treat "enter" press like tap
      if (key === 13) {
        handleTap(e);
      }
    }

    function getLastMainItem() {
      var lastMainItem = moreList.parentElement.previousElementSibling;
      return lastMainItem ? lastMainItem.firstElementChild : null;
    }

    function getFirstMoreItem() {
      var firstMoreItem = moreList.firstElementChild;
      return firstMoreItem ? firstMoreItem.firstElementChild : null;
    }

    function reorgNav() {
      var lastMainItem = getLastMainItem(),
        firstMoreItem = getFirstMoreItem();

      // move items from moreList to mainList
      while (firstMoreItem && (!lastMainItem || !isOverflowing(lastMainItem))) {
        mainList.insertBefore(firstMoreItem.parentElement, moreItem);

        lastMainItem = firstMoreItem;
        firstMoreItem = getFirstMoreItem();
        // update while removing from moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // move items from mainList to moreList
      while (lastMainItem && isOverflowing(lastMainItem)) {
        moreList.insertBefore(lastMainItem.parentElement, moreList.firstElementChild);

        lastMainItem = getLastMainItem();
        // update while adding to moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // updates
      if (moreList.childElementCount > 0 && selected) {
        // refresh selected
        setSelected(selected);
      }
    }

    function updateMoreItemHidden() {
        moreItem.classList[moreList.childElementCount === 0 ? 'add' : 'remove']('hidden');
    }

    function isOverflowing(lastMainItem) {
      if (isFlex()) {
        return getAutoClientWidth(lastMainItem) > lastMainItem.clientWidth;
      } else {
        return mainList.scrollWidth > mainList.clientWidth;
      }
    }

    function collapse() {
      // clear focus for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, blurItem);
    }

    function removeNestedFromTabIndex(target) {
      // get nested lists, for each nested list, remove links from tabindex
      forEachDescendantsByTagName(target || mainList, 'UL', function(list){
        forEachDescendantsByTagName(list, navItemTagNames, removeFromTabIndex);
      });
    }

    function setSelected(item) {
      // clear selected for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, deselectItem);

      if (!item) {
        selected = null;
      } else if (item && hasTagName(item, navItemTagNames) && isNavLeafItem(item)) {
        // store selected
        selected = item;
        // mark navItem as selected
        selectItem(item);
        // mark ancestor navItems as selected
        forEachAncestorSiblingsByTagName(item, mainList, 'UL', navItemTagNames, selectItem);
      }

      return nav;
    }

    /* returns array of selected items ordered from leaf (bottom) to root (top) */
    function getSelected() {
      return Array.prototype.slice.call(mainList.querySelectorAll('.selected')).reverse();
    }

    function setMoreItemText(text) {
      moreItem.firstChild.textContent = text;
      reorgNav();
    }

    function destroy() {
      mainList.removeChild(moreItem);
      nav.classList.remove('navmore');

      delete nav.navmore;

      unthrottleResize();
      window.removeEventListener('optimizedResize', reorgNav, false);
      window.removeEventListener('click', handleTap, false);
      window.removeEventListener('keypress', handleKeyPress, false);
    }

    /* BOOTSTRAP */
    init();

    return nav;
  };

  /* UTILS */

  // from MDN with modifications
  // https://developer.mozilla.org/en-US/docs/Web/Events/resize
  function throttle(type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function() {
      if (running) { return; }
      running = true;
      requestAnimationFrame(function() {
        triggerEvent(name, obj);
        running = false;
      });
    };
    var removeFunc = function() {
      obj.removeEventListener(type, func);
    };
    obj.addEventListener(type, func, false);
    return removeFunc;
  }

  // MDN
  function triggerEvent(name, obj) {
    var evt;
    try { evt = new CustomEvent(name); }
    catch(e) {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }
    obj.dispatchEvent(evt);
  }

  function createElementFromString(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    return div.firstChild;
  }

  function getAutoClientWidth(el) {
    var text = el.textContent.trim(),
      style = window.getComputedStyle(el),
      /* get font values separately for firefox :( */
      font = [
        style.getPropertyValue('font-weight'),
        style.getPropertyValue('font-size'),
        style.getPropertyValue('font-family')
      ],
      padLeft = parseInt(style.getPropertyValue('padding-left')),
      padRight = parseInt(style.getPropertyValue('padding-right'));

    return Math.floor(getTextWidth(text, font.join(' ')) + padLeft + padRight);
  }

  // http://stackoverflow.com/a/21015393
  function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  }

  function hasTagName(node, tagNames) {
    // tagNames is comma delimited
    return tagNames.split(/\s*,\s*/).indexOf(node.tagName) > -1;
  }

  function retargetBubbleEventByTagName(evt, stopNode, tagNames) {
    var target = evt.target;
    if (!target.nodeType || !stopNode.contains(target)) return null;
    if (!hasTagName(target, tagNames)) {
      return getClosestAncestorByTagName(target, stopNode, tagNames);
    }
    return target;
  }

  function getClosestAncestorByTagName(startNode, stopNode, tagNames) {
    while (startNode) {
      startNode = startNode.parentNode;
      if (!stopNode.contains(startNode) || startNode === stopNode) {
        break;
      }
      if (hasTagName(startNode, tagNames)) {
        return startNode;
      }
    }
    return null;
  }

  function forEachFirstChildByTagName(startNode, tagNames, fn) {
    var children = startNode.children
    for (i = 0; i < children.length; i++) {
      if(children[i].firstElementChild && hasTagName(children[i].firstElementChild, tagNames)) {
        fn(children[i].firstElementChild);
      }
    }
  }

  function forEachDescendantsByTagName(startNode, tagNames, fn) {
    var descendants = startNode.querySelectorAll(tagNames), i;
    for (i = 0; i < descendants.length; i++) {
      fn(descendants[i]);
    }
  }

  function forEachAncestorSiblingsByTagName(startNode, stopNode, ancestorTags, focusTags, fn) {
    var ancestor, i, node;
    do {
      ancestor = getClosestAncestorByTagName(startNode, stopNode, ancestorTags);
      if (ancestor) {
        for (i = 0; i < ancestor.parentNode.children.length; i++) {
          node = ancestor.parentNode.children[i];
          if (hasTagName(node, focusTags)) {
            fn(node);
          }
        }
      }
      startNode = ancestor;
    } while (startNode);
  }

  function focusItem(item) {
    item.classList.add('focused');
  }

  function isItemFocused(item) {
    return item.classList.contains('focused');
  }

  function blurItem(item) {
    item.classList.remove('focused');
  }

  function selectItem(item) {
    item.classList.add('selected');
  }

  function deselectItem(item) {
    item.classList.remove('selected');
  }
  function removeFromTabIndex(item) {
    item.tabIndex = -1;
  }
  function addToTabIndex(item) {
    item.tabIndex = 0;
  }

})(window);

(function(w){
    'use strict';
    // https://gist.github.com/joelambert/1002116
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    w.requestInterval = function(fn, delay){
        var start = new Date().getTime(),
            handle = {};

        function loop(){
            var current = new Date().getTime(),
                delta = current - start;

            if(delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }

            handle.value = w.requestAnimationFrame(loop);
        }

        handle.value = w.requestAnimationFrame(loop);
        return handle;
    };

    /**
     * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {(int|object)} handle The callback function
     */
    w.clearRequestInterval = function(handle){
        w.cancelAnimationFrame(handle.value);
    };
})(window);

// http://james.padolsey.com/javascript/element-datastorage/
(function(w){
    'use strict';

    var cache = [0],
        expando = 'data' + (+new Date());

    function data(elem) {

        var cacheIndex = elem[expando],
            nextCacheIndex = cache.length;

        if(!cacheIndex) {
            cacheIndex = elem[expando] = nextCacheIndex;
            cache[cacheIndex] = {};
        }

        return cache[cacheIndex];

    }

    w.bmDataCache = data;

})(window);

/* Adapted from https://github.com/thorst/jquery-idletimer

MIT License

Copyright (c) 2013 Paul Irish

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE. */
(function(w){
    'use strict';

    w.bmIdleTimer = function(firstParam, elem){
        var opts;

        if(typeof firstParam === 'object'){
            opts = firstParam;
            firstParam = null;
        } else if(typeof firstParam === 'number'){
            opts = { timeout: firstParam };
            firstParam = null;
        }

        // element to watch
        elem = elem || document;
        opts = opts || {};

        opts = extendObject({
            idle: false,                // indicates if the user is idle
            timeout: 30000,             // the amount of time (ms) before the user is considered idle
            events: [
                'mousemove',
                'keydown',
                'wheel',
                'DOMMouseScroll',
                'mousewheel',
                'mousedown',
                'touchstart',
                'touchmove',
                'MSPointerDown',
                'MSPointerMove'
            ] // define active events
        }, opts);

        var obj = w.bmDataCache(elem).idleTimerObj || {};

        /* (intentionally not documented)
         * Toggles the idle state and fires an appropriate event.
         * @return {void}
         */
        // var toggleIdleState = function(e){
        var toggleIdleState = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // toggle the state
            obj.idle = !obj.idle;

            // store toggle state date time
            obj.olddate = +new Date();

            // create a custom event, with state and name space
            var evt;
            var evtName = (obj.idle ? 'idle' : 'active') + '.bmIdleTimer';

            // create custom event based on browser support
            try {
                evt = new CustomEvent(evtName);
            } catch(e) {
                evt = document.createEvent('Event');
                evt.initEvent(evtName, true, true);
            }

            // trigger event on object with elem and copy of obj
            elem.dispatchEvent(evt, extendObject({}, obj));
        };

        /**
         * Handle event triggers
         * @return {void}
         * @method event
         * @static
         */
        var handleEvent = function(e){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused, ignore events for now
            if(obj.remaining !== null){
                return;
            }

            /*
            mousemove is kinda buggy, it can be triggered when it should be idle.
            Typically is happening between 115 - 150 milliseconds after idle triggered.
            @psyafter & @kaellis report "always triggered if using modal (jQuery ui, with overlay)"
            @thorst has similar issues on ios7 "after $.scrollTop() on text area"
            */
            if (e.type === 'mousemove') {
                // if coord are same, it didn't move
                if (e.pageX === obj.pageX && e.pageY === obj.pageY) {
                    return;
                }
                // if coord don't exist how could it move
                if (typeof e.pageX === 'undefined' && typeof e.pageY === 'undefined') {
                    return;
                }
                // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
                var elapsed = (+new Date()) - obj.olddate;
                if (elapsed < 200) {
                    return;
                }
            }

            // clear any existing timeout
            clearTimeout(obj.tId);

            // if the idle timer is enabled, flip
            if (obj.idle) {
                toggleIdleState(e);
            }

            // store when user was last active
            obj.lastActive = +new Date();

            // update mouse coord
            obj.pageX = e.pageX;
            obj.pageY = e.pageY;

            // set a new timeout
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        };

        /**
         * Restore initial settings and restart timer
         * @return {void}
         * @method reset
         * @static
         */
        var reset = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // reset settings
            obj.idle = obj.idleBackup;
            obj.olddate = +new Date();
            obj.lastActive = obj.olddate;
            obj.remaining = null;

            // reset Timers
            clearTimeout(obj.tId);
            if (!obj.idle) {
                obj.tId = setTimeout(toggleIdleState, obj.timeout);
            }
        };

        /**
         * Store remaining time, stop timer
         * You can pause from an idle OR active state
         * @return {void}
         * @method pause
         * @static
         */
        var pause = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused
            if(obj.remaining !== null){ return; }

            // define how much is left on the timer
            obj.remaining = obj.timeout - ((+new Date()) - obj.olddate);

            // clear any existing timeout
            clearTimeout(obj.tId);
        };

        /**
         * Start timer with remaining value
         * @return {void}
         * @method resume
         * @static
         */
        var resume = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this isn't paused yet
            if(obj.remaining === null){ return; }

            // start timer
            if (!obj.idle){
                obj.tId = setTimeout(toggleIdleState, obj.remaining);
            }

            // clear remaining
            obj.remaining = null;
        };

        /**
         * Stops the idle timer. This removes appropriate event handlers
         * and cancels any pending timeouts.
         * @return {void}
         * @method destroy
         * @static
         */
        var destroy = function(){
            //clear any pending timeouts
            var obj = w.bmDataCache(elem).idleTimerObj || {};
            clearTimeout(obj.tId);

            //Remove data
            delete w.bmDataCache(elem).idleTimerObj;

            //detach the event handlers
            opts.events.forEach(function(eventName){
                elem.removeEventListener(eventName, idleTimerHandler);
            });
        };

        /**
        * Returns the time until becoming idle
        * @return {number}
        * @method remainingtime
        * @static
        */
        var remainingtime = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            //If idle there is no time remaining
            if (obj.idle){ return 0; }

            //If its paused just return that
            if (obj.remaining !== null){ return obj.remaining; }

            //Determine remaining, if negative idle didn't finish flipping, just return 0
            var remaining = obj.timeout - ((+new Date()) - obj.lastActive);
            if(remaining < 0){ remaining = 0; }

            //If this is paused return that number, else return current remaining
            return remaining;
        };

        // determine which function to call
        if(firstParam === null && typeof obj.idle !== 'undefined'){
            // they think they want to init, but it already is, just reset
            reset();
            return elem;
        } else if(firstParam === null){
            // they want to init
        } else if(firstParam !== null && typeof obj.idle === 'undefined'){
            // they want to do something, but it isnt init
            // not sure the best way to handle this
            return false;
        } else if(firstParam === 'destroy'){
            destroy();
            return elem;
        } else if(firstParam === 'pause'){
            pause();
            return elem;
        } else if(firstParam === 'resume'){
            resume();
            return elem;
        } else if(firstParam === 'reset'){
            reset();
            return elem;
        } else if(firstParam === 'getRemainingTime'){
            return remainingtime();
        } else if(firstParam === 'getElapsedTime'){
            return (+new Date()) - obj.olddate;
        } else if(firstParam === 'getLastActiveTime'){
            return obj.lastActive;
        } else if(firstParam === 'isIdle'){
            return obj.idle;
        }

        /* (intentionally not documented)
         * Handles a user event indicating that the user isn't idle. namespaced with internal idleTimer
         * @param {Event} event A DOM2-normalized event object.
         * @return {void}
         */
        opts.events.forEach(function(eventName){
            // elem.addEventListener(eventName + '._idleTimer', idleTimerHandler, false);
            elem.addEventListener(eventName, idleTimerHandler, false);
        });

        // Internal Object Properties, This isn't all necessary, but we
        // explicitly define all keys here so we know what we are working with
        obj = extendObject({}, {
            olddate : +new Date(),          // the last time state changed
            lastActive: +new Date(),       // the last time timer was active
            idle : opts.idle,               // current state
            idleBackup : opts.idle,         // backup of idle parameter since it gets modified
            timeout : opts.timeout,         // the interval to change state
            remaining : null,               // how long until state changes
            tId : null,                     // the idle timer setTimeout
            pageX : null,                   // used to store the mouse coord
            pageY : null
        });

        // set a timeout to toggle state. May wish to omit this in some situations
        if (!obj.idle) {
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        }

        // store our instance on the object
        w.bmDataCache(elem).idleTimerObj = obj;

        return elem;

        /////////////

        // Extend a JavaScript object with the key/value pairs of another.
        // https://plainjs.com/javascript/utilities/merge-two-javascript-objects-19/
        function extendObject(obj, src) {
            Object.keys(src).forEach(function(key){
                obj[key] = src[key];
            });

            return obj;
        }

        function idleTimerHandler(e){
            handleEvent(e);
        }
    };
})(window);

(function(w){
    'use strict';

    /**
     * var jid = q.push(function (done, data) { console.log(data); done(); }, 30000, 'hello world!'); // log 'hello world!' every 30 secs
     * q.stop(jid); // disable specified job
     * q.start(jid); // enabled specified job
     * q.stop(); // disable all jobs
     * q.start(); // enable all jobs
     */
    w.bmJobQueue = function(resolution){
        var tId, q = [], self = this,
        // use Joe Lambert's requestInterval if available
        intervalFn = w.requestInterval || setInterval,
        clearFn = w.clearRequestInterval || clearInterval;

        resolution = resolution || 5000;

        // if we have the bmIdleTimer plugin, make Q smarter about idle states
        if(w.bmIdleTimer && w.bmDataCache){
          // does the document element already have idleTimer data
          if(!w.bmDataCache(w.document).idleTimerObj){
            w.bmIdleTimer(180000); // make sure it's started, 3 min idle
          }

          // event listeners to respond to bmIdleTimer events
          w.document.addEventListener('idle.bmIdleTimer', function(){ self.stop(); }, false);
          w.document.addEventListener('active.bmIdleTimer', function(){ self.start(); }, false);
        }

        this.push = function(fn, interval, data, context){
            var job;

            if(fn){
                if(!q.length){
                    self.start(); // start processing once we get first job
                }

                job = {fn: fn, interval: interval || 0, context: context || window, enabled: 1, running: 0, last: 0, data: data };
                runJob(job);
                q.push(job);

                return q.length; // jobId
            } else {
                return null;
            }
        };

        this.start = function(jobId){
            var job;
            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.enabled = 1;
                }
            } else if(!tId){
                mainLoop();
                tId = intervalFn(mainLoop, resolution);
            }
        };

        this.stop = function(jobId){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                  job.enabled = 0;
                }
            } else if(tId){
                clearFn(tId); tId = null;
            }
        };

        this.remove = function(jobId){
            if(jobId){
              q[jobId - 1] = null;
            }
        };

        this.update = function(jobId, fn, interval, data, context){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.fn = fn || job.fn;
                    job.interval = interval !== undefined ? interval : job.interval;
                    job.data = data !== undefined ? data : job.data;
                    job.context = context !== undefined ? context : job.context;
                }
            }
        };

        /////////////

        function mainLoop(){
            var i, job;

            for (i = 0; i < q.length; i++){
                job = q[i];

                if(job && job.enabled && !job.running && (+new Date() - job.last >= job.interval)){
                    runJob(job);
                }
            }
        }

        function runJob(job){
            job.running = 1;
            job.fn.call(job.context, function (){ // callback
                job.running = 0;
                job.last = +new Date();
            }, job.data);
        }
    };
})(window);

/**
 * Top-level module for bluemoon-components
 */
(function(window, angular) {
    'use strict';

    // The following is an HTTPS guarantee for all Blue Moon apps.
    // The ideal, of course, is this happens via server redirect.
    if (window.location.protocol === 'http:') {
        // TODO: copied from environment.js, needs to DRYed and broken out to be available immediately
        var hostname = location.hostname.toLowerCase(),
            isCiEnv = /^ci\./.test(hostname),
            isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname);

        if (!isCiEnv && !isLocalEnv) { // limit to DEMO+
            window.location.protocol = 'https';
        }
    }

    // blank module for dev, overwritten for dist
    angular.module('bluemoon.components.templates', []);

    angular.module('bluemoon.components', [
        'bluemoon.components.templates',
        'bluemoon.components.app',
        'bluemoon.components.header',
        'bluemoon.components.staffHeader',
        'bluemoon.components.nav',
        'bluemoon.components.main',
        'bluemoon.components.busyLoader',
        'bluemoon.components.bluemoonForceDesktop',
        'bluemoon.components.i18n',
        'bluemoon.components.bluemoonRequiredMark',
        'bluemoon.components.modal',
        'bluemoon.help',
        'bmPermission',
        'bmLicense',
        'bmAccess',
        'bmEnvironment',
        'bmUser',
        'bmUserTermsSignatory',
        'bmPreferenceService',
        'bmImageUploadModal',
        'bmProfilePhoto',
        'bmViewPortalBanner'
    ]);

})(window, window.angular);

(function(angular) {
    'use strict';

    var util = {

        // http://stackoverflow.com/a/8809472
        generateUUID: function() {
            /* jshint ignore:start */
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16)%16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r&0x7 | 0x8)).toString(16);
            });
            return uuid;
            /* jshint ignore:end */
        },

        // TRMR gotta be different
        generateTRMRGUID: function(uuid) {
            if (!uuid) { uuid = util.generateUUID(); }
            return uuid.replace(/-/g, '');
        },

        // Simple cookie handling (doesn't encode/decode)
        cookie: function(key, val, path, infinite) {
            if (val === undefined) { // get
                return (document.cookie.match('(^|; )' + key + '=([^;]*)') || 0)[2];
            }

            var pathSeg = path ? '; path=' + path : '';
            var expiresSeg = infinite ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '';

            if (val === null) { // delete
                document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' + pathSeg;
            } else { // set
                document.cookie = key + '=' + val + pathSeg + expiresSeg;
            }
        },

        // Given an object tree, return flat Array of dot-notated, compound keys
        // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> ['a1.b1','a1.b2.c1','a2'])
        flattenKeys: function(obj, filter) {
            var flat = [];
            function traverse(obj, key) {
                var compound;
                for (var prop in obj) {
                    compound = key ? key + '.' + prop : prop;
                    if (typeof obj[prop] === 'object') {
                        traverse(obj[prop], compound);
                    } else {
                        if (filter) {
                            if (!filter(obj, prop, compound)) { continue; }
                        }
                        flat.push(compound);
                    }
                }
            }
            traverse(obj);
            return flat;
        },

        // overwritten by angular.extend
        extend: function() {
            throw new Error('Not implemented.');
        },

        // http://stackoverflow.com/a/9229821
        // some consumers don't use underscore/lodash
        uniq: function(a) {
            var seen = {};
            var out = [];
            var len = a.length;
            var j = 0;
            for(var i = 0; i < len; i++) {
                 var item = a[i];
                 if(seen[item] !== 1) {
                       seen[item] = 1;
                       out[j++] = item;
                 }
            }
            return out;
        },

        // safe way to decode html entities in a string w/o opening yourself up to script injection
        decodeHtmlEntities: function(str) {
            var txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        },

        isNullOrEmpty: function(str){
            return angular.isUndefined(str) || str === null || str === '';
        },

        // https://developer.mozilla.org/en-US/docs/Web/API/Location
        parseUri: function(href){
            if(util.isNullOrEmpty(href)){
                return undefined;
            }

            var url = document.createElement('a');
            url.href = href;
            return url;

            // url.href;      https://developer.mozilla.org/en-US/search?q=URL#search-results-close-container
            // url.protocol;  https:
            // url.host;      developer.mozilla.org
            // url.hostname;  developer.mozilla.org
            // url.port;      (blank - https assumes port 443)
            // url.pathname;  /en-US/search
            // url.search;    ?q=URL
            // url.hash;      #search-results-close-container
            // url.origin;    https://developer.mozilla.org
        },
        /**
         * https://gist.github.com/maxwihlborg/1911a28f988444db3ddc
         * Simple debounce function; usage:
         *
         * Create a function that only can be called once every 500 ms
         *
         *      var df = debounce(function() {
         *          ... func body ...
         *      }, 500)
         *
         * Bind the function to an event
         *
         *      document.addEventListener('keydown', df);
         *
         * @param fn   {function} function you want to debounce
         * @param wait {number}   interval wait in ms
         */
        debounce: function(fn, wait) {
            var timeout;
            return function() {
                var ctx = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    fn.apply(ctx, args);
                }, wait || 100);
            };
        },
        //  reference - https://github.com/PunitSoniME/alt-lodash/blob/main/src/object/get.ts
        getValueFromKey: function(object, path, defaultValue) {
            // If path is not defined or it has false value
            if (!path) { return undefined; }
            // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
            // Regex explained: https://regexr.com/58j0k
            var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);

            if (pathArray === null) { return defaultValue; }
            // Find value
            var result = (pathArray).reduce(function(prevObj, key) { return prevObj && prevObj[key]; },
                object
            );
            // If found value is undefined return default value; otherwise return the value
            return result === undefined ? defaultValue : result;
        }
    };

    /* ANGULAR */
    util.extend = angular.extend;

    angular.module('bluemoon.components.util', [])
        .value('bmUtil', util);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmTokenStorage', [])
    .service('bmTokenStorage', ['bmUtil', function (bmUtil) {
        var storageKey = 'onvio-uds-token';
        var cookieKey = 'UDSLongToken';
        this.clean = function() {
            if (window.localStorage) {
                window.localStorage.removeItem(storageKey);
            }
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(storageKey);
            }
            bmUtil.cookie(cookieKey, null);
            bmUtil.cookie(cookieKey, null, '/');
        };

        this.set = function(token) {
            if (window.localStorage) {
                window.localStorage.setItem(storageKey, token);
            }
            if (window.sessionStorage) {
                window.sessionStorage.setItem(storageKey, token);
            }
            bmUtil.cookie(cookieKey, token, '/');
        };
        this.get = function(){
            return bmUtil.cookie(cookieKey) || window.sessionStorage.getItem(storageKey);
        };
    }]);
  })(window.angular);

(function(window, angular){
    'use strict';

    angular.module('bluemoon.components.i18n', ['pascalprecht.translate', 'bluemoon.components.util', 'bmEnvironment'])

        .config(['$httpProvider', '$translateProvider', 'bmEnvCountryDefaultLang', function($httpProvider, $translateProvider, countryDefaultLang) {
            $httpProvider.interceptors.push('bmHttpAcceptLangInterceptor');

            $translateProvider.useStorage('languageStorageManager');
            $translateProvider.preferredLanguage(countryDefaultLang);
            $translateProvider.fallbackLanguage('en-US');
        }])

        .value('bmLanguageCookieName', 'BMLanguageCode')

        .factory(
            'languageStorageManager',
            ['bmUtil', 'bmLanguageCookieName', 'bmEnvCountryDefaultLang', function(bmUtil, bmLanguageCookieName, defaultLang) {

                var factory = {};

                var languageCookieOptions = {
                    name: bmLanguageCookieName,
                    path: '/',
                    infinite: 'true',
                };

                function set(name, value){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    bmUtil.cookie(name, value, languageCookieOptions.path, languageCookieOptions.infinite);
                }

                factory.set = set;
                factory.put = set;

                factory.get = function(name){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    return bmUtil.cookie(name) || defaultLang;
                };

                return factory;
            }]
        )

        .factory('bmLanguageManager', ['$q', '$translate', 'languageStorageManager', 'bmEnvironment', 'bmEnvCountryDefaultLang',
            function($q, $translate, languageStorageManager, bmEnvironment, bmEnvCountryDefaultLang){

            var factory = {
                getLoadedLanguageAsync: getLoadedLanguageAsync,
                getLanguagesAsync: getLanguagesAsync,
                setUserLanguageAsync: setUserLanguageAsync,
                getCurrentLanguage: getCurrentTranslateLanguageCode,
                updatedUserLanguage: ''
            };

            var languageLoadRetry = 0;

            return factory;

            //////////

            function getLoadedLanguageAsync(){
                var currentLanguage;
                var currentLanguageCode = getCurrentTranslateLanguageCode();

                return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                    if(angular.isUndefined(languages) || languages.length === 0){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    for(var counter = 0; counter < languages.length; counter++){
                        if(languages[counter].code === currentLanguageCode){
                            currentLanguage = languages[counter];
                            break;
                        }
                    }

                    // Was a current supported language found?
                    if(angular.isDefined(currentLanguage)){
                        return currentLanguage;
                    }

                    languageLoadRetry++;

                    // Avoid an endless loop
                    if(languageLoadRetry > 1){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    // Set translate to default language and try again
                    return $translate.use(bmEnvCountryDefaultLang).then(function(){
                        return getLoadedLanguageAsync();
                    });
                });
            }

            function getLanguagesAsync(includeLoadedLanguage){
                return getLanguageListAsync(includeLoadedLanguage).then(function(languages){
                    return languages;
                });
            }

            function setUserLanguageAsync(languageCode){
                var deferred, curr = getCurrentTranslateLanguageCode();
                if (curr !== languageCode) {
                    return $translate.use(languageCode).then(function(){
                        languageStorageManager.set('BMLanguageCode', languageCode);
                        factory.updatedUserLanguage = languageCode;
                    });
                } else {
                    deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
            }

            //////////

            function getLanguageListAsync(includeLoadedLanguage){
                var languageList = [];

                return getLoadedLanguageAsync().then(function(currentLanguage){
                    var currentLanguageCode = currentLanguage.code;

                    return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                        if(angular.isUndefined(languages)){
                            return languageList;
                        }

                        for(var counter = 0; counter < languages.length; counter++){
                            if(languages[counter].code === currentLanguageCode && !includeLoadedLanguage){
                                continue;
                            }

                            // Get the translated description for the loaded language
                            angular.extend(languages[counter], getTranslatedDescription(languages[counter], currentLanguageCode));

                            languageList.push(languages[counter]);
                        }

                        return languageList;
                    });
                });
            }

            function getCurrentTranslateLanguageCode(){
                var currentLanguageCode = $translate.proposedLanguage();

                if(angular.isUndefined(currentLanguageCode)){
                    currentLanguageCode = $translate.use();
                }

                return currentLanguageCode;
            }

            function getTranslatedDescription(language, translateCode){
                // Default to the language description itself
                var description = {
                    translatedDescription: language.description
                };

                if(angular.isUndefined(language.translations)){
                    return description;
                }

                for(var counter = 0; counter < language.translations.length; counter++){
                    if(language.translations[counter].code === translateCode){
                        description.translatedDescription = language.translations[counter].description;
                        break;
                    }
                }

                return description;
            }
        }])

        .directive('bmLanguageSelect', ['bmLanguageManager', '$timeout', function(bmLanguageManager, $timeout){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/i18n/language-select.2js.html',
                scope: {
                    selectedLanguageCode: '=',
                    name: '@',
                    includeEmptyOption: '&',
                    selectionRequired: '&',
                    onChange: '&',
                    ngDisabled: '='
                },
                link: function (scope, element) {
                    function loadLangList() {
                        bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                            scope.languageList = languages;

                            // Create local scope in order to not overwrite data bound scope value
                            scope.selectedLanguage = {
                                code: scope.selectedLanguageCode
                            };
                        });
                    }

                    loadLangList();

                    scope.$watch('selectedLanguageCode', function(newValue, oldValue) {
                        if (newValue && newValue !== oldValue) {
                            scope.selectedLanguage = {
                                code: newValue
                            };

                            scope.selectionChanged();
                        }
                    });

                    scope.$on('bmLanguageChangeSuccess', loadLangList);

                    // Set watches here so can actually pass attribute as a boolean
                    scope.$watch('includeEmptyOption()', function(newValue){
                        scope.showEmpty = newValue;
                    });

                    scope.$watch('selectionRequired()', function(newValue){
                        scope.required = newValue;
                    });

                    scope.$watch('ngDisabled', function(newValue){
                        scope.disabled = newValue;
                    });

                    scope.selectionChanged = function(){
                        // Set data bound value to new selection
                        scope.selectedLanguageCode = scope.selectedLanguage.code;

                        if(typeof scope.onChange !== 'undefined'){
                            // Hack to have model updated before change is fired (ngModelOptions failed)
                            $timeout(function(){
                                scope.onChange({ language: scope.selectedLanguageCode });
                            }, 0);
                        }
                    };

                    // copied straight from bento select control
                    // Add IE and Firefox version for better UI look and feel
                    if (window.navigator.userAgent.search(/MSIE 9/gi) !== -1) {
                      element.addClass('ie9');
                    } else if (window.navigator.userAgent.search(/MSIE 10/gi) !== -1) {
                      element.addClass('ie10');
                    } else if (window.navigator.userAgent.search(/Firefox/gi) !== -1) {
                      element.addClass('firefox');
                      element.append('<div class="bento-select-border"></div>');
                    }
                }
            };
        }])

        //  This is a workaround for https://github.com/angular-translate/angular-translate/issues/855
        .service('GlobalTranslateRefreshService', ['$translate', function($translate) {

            var _translationRefreshPromise;

            this.refresh = function() {
                return !_translationRefreshPromise ?
                    (_translationRefreshPromise = $translate.refresh()) :
                    _translationRefreshPromise;
            };
        }])

        .run(['$rootScope', function($rootScope){
            $rootScope.$on('$translateChangeSuccess', function(event, args){
                $rootScope.$broadcast('bmLanguageChangeSuccess', { language: args.language });
            });
        }])

        .service('bmHttpAcceptLangInterceptor', HttpAcceptLangInterceptor);

    function HttpAcceptLangInterceptor(languageStorageManager) {
        this.request = function(conf) {
            if (!conf.headers['Accept-Language']) {
                var lang = languageStorageManager.get();

                if (lang) {
                    conf.headers['Accept-Language'] = lang;
                }
            }
            return conf;
        };
    }

    HttpAcceptLangInterceptor.$inject = ['languageStorageManager'];
})(window, window.angular);

(function(MessageFormat){
    'use strict';

    if (MessageFormat && MessageFormat.plurals) {
        // This is similar to the "en" entry from version 0.3.1 of the messageformat.js file
        MessageFormat.plurals.xx = function (n) {
            return n === 1 ? 'one' : 'other';
        };
    }

})(window.MessageFormat);

/**
 * Blue Moon Components - session module
 */
(function(angular) {
    'use strict';

    var tokenType = 'UDSLongToken',
        staffDestUrl = '/staff/',
        clientDestUrl = '/client/',
        atendimentoClientDestUrl = '/atendimento-client/',
        clientBetaDestUrl = '/clientcenter/',
        employeePortalDestUrl = '/portaldoempregado/',
        employeeDestUrl = '/samba-employee-center/',
        employerDestUrl = '/samba-employer-center/',
        esalesCustomerDestUrl = '/samba-esales-customer-center/',
        destinationQueryStringKey = 'd',
        destinationStorageKey = 'bmViewPortalReturnUrl',
        clientMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/client',
        refAccountantMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/accountant',
        viewPortalUrlV1 = '/api/security/v1/sessions/view-portal',
        viewPortalUrlV2 = '/api/security/v2/sessions/view-portal',
        exitViewPortalUrl = '/api/security/v1/sessions/view-portal/exit',
        checkPointARUrl = '/sso/',
        sambaDestUrl = '/smb/',
        emergingAccountsUrl = '/ustax/#/dashboard',
        grantsMap = {
            // staff
            'Applications.Onvio': 'staff',
            'OnvioSetup.Contacts': 'staff.setup.contacts',
            'OnvioSetup.Messages': 'staff.setup.messages',
            'OnvioSetup.Appearances': 'staff.setup.appearances',
            'OnvioSetup.Offices': 'staff.setup.offices',
            'OnvioSetup.Staff': 'staff.setup.staff',
            'OnvioSetup.Clients': 'staff.setup.clients',
            'OnvioSetup.Firm': 'staff.setup.firm',
            'OnvioDrive.Documents': 'staff.documents',
            'OnvioDrive.FirmDocuments': 'staff.documents.firm',
            'OnvioDrive.MyDocuments': 'staff.documents.my',
            'OnvioDrive.ClientDocuments': 'staff.documents.client',
            // client
            'Platform.ccVnext': 'client.beta',
            'Applications.OnvioClientHub': 'client',
            'OnvioClientDrive.Drive': 'client.documents',
            'TaxCenter.Tax': 'client.tax',
            'MyPayClientOnboarding.ClientOnboarding' : 'client.mypayonboarding',
            'MyPayOnboarding.ReferringAccountant': 'staff.mypayonboarding.refaccountant',
            'Applications.Samba' : 'samba',
            // employee portal employee
            'BREmployeePortal.BREmployeePortal':'employeeportal.employee',
            // employee
            'SaMBa.Employee': 'samba.employee.center',
            // employer
            'SaMBa.Employer': 'samba.employer.center',
            //esales
            'SaMBa.ESalesCenter': 'samba.employer.center',
            'SaMBa.ESalesCustomerCenter': 'samba.esales.customer.center',
            // csadmin
            'AuthApp.UberAdmin': 'csadmin',
            'AuthApp.Admin': 'csadmin',
            'AuthApp.Staff': 'csadmin',
            // Emerging Accounts
            'USTax.PlatformEA': 'emergingaccounts'
        },
        userUrl = '/api/profiles/v1/users',
        deleteSessionUrl = '/api/security/v1/sessions/logout',
        deleteOIDCSessionUrl = '/api/security/v2/oidc/logout',
        cookieDeepLink = 'bmDeepLink',
        cookieCheckPoint = 'bmCheckPointOrigin';

    // Use separate data object to eliminate circular dependencies in interceptors
    function AuthenticatedSessionData($q) {
        var self = this;

        this.deferred = {
            all: $q.defer(),
            meta: $q.defer(),
            bindings: $q.defer()
        };

        // synchronous access
        this.meta = {};
        this.bindings = {};

        // asynchronous access
        this.get = function() {
            return self.deferred.all.promise;
        };
        this.getMeta = function() {
            return self.deferred.meta.promise;
        };
        this.getBindings = function() {
            return self.deferred.bindings.promise;
        };
    }

    function AuthenticatedSession(
        $window,
        $document,
        $log,
        $location,
        $q,
        $http,
        $rootScope,
        $uibModal,
        httpAuthInterceptor,
        sessionMetadataUrl,
        sessionMetadataUrlV2,
        sessionBindingsUrl,
        authWaypointUrl,
        defaultDestinationUrl,
        ssoUrl,
        ssoTokenKey,
        authenticatedSessionData,
        bmUtil,
        bmTheme,
        bmLanguageManager,
        bmEnvironmentConst,
        bmEnvironment,
        bmAccess,
        csWebLoginUriMap,
        bmTokenStorage) {

        var unloadCancelledTimeout;
        var self = this;
        var destroying = false;

        // data
        self.data = authenticatedSessionData;

        // methods
        self.create = create;
        self.createWithJwt = createWithJwt;
        self.createWithOptions = createWithOptions;
        self.createWithLongToken = createWithLongToken;
        self.createViaSsoToken = createViaSsoToken;
        self.load = load;
        self.loadMeta = loadMeta;
        self.loadBindings = loadBindings;
        self.destroy = destroy;
        self.destroyAuth0 = destroyAuth0;
        self.getRequestedDestination = getRequestedDestination;
        self.viewPortal = viewPortal;
        self.exitViewPortal = exitViewPortal;
        self.switchAccountWithLongToken = switchAccountWithLongToken;

        function create(uid, pwd, beforeRedirectAction) {
            var options = {data: {
                username: uid,
                password: pwd
            }};
            return createWithOptions(options, beforeRedirectAction);
        }

        function createViaSsoToken(token) {
            var options = {
                method: 'GET',
                url: ssoUrl + '?' + ssoTokenKey + '=' + token
            };
            return createWithOptions(options);
        }

        function createWithJwt(jwt) {
            return createWithOptions({
                method: 'POST',
                url: '/api/security/v2/sessions/jwt',
                headers: { Authorization: 'Bearer ' + jwt }
            });
        }

        function createWithOptions(options, beforeRedirectAction) {
            var defaultOptions = {
                method: 'POST',
                url: sessionMetadataUrlV2,
                bmNoAuth: true
            };
            var promise = $http(angular.extend(defaultOptions, options));

            // if attempting to create a new session, dump old token
            bmTokenStorage.clean();

            promise.then(function(resp) {
                createWithLongToken(resp.data.LongToken, beforeRedirectAction);
            });

            return promise;
        }

        function createWithLongToken(longToken, beforeRedirectAction){
            var preferredDest = getRequestedDestination($location);
            var cookieValue = (document.cookie.match('(^|; )' + cookieDeepLink + '=([^;]*)') || '')[2];
            // success, propagate token to apps in other tabs/windows
            bmTokenStorage.set(longToken);

            updateUserLanguage();

            if (cookieValue !== undefined) {
                var deepLink = $window.location.origin + cookieValue;
                // Delete the bmDeepLink cookie
                document.cookie = cookieDeepLink + '=/; path=/; Max-Age=0; Secure';
                if (beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        $window.location.href = deepLink;
                    });
                } else {
                    $window.location.href = deepLink;
                }
            } else if (!preferredDest) {
                // get bindings to determine where to send user
                loadBindings().then(function () {
                    self.destUrl = '';
                    var grants = self.data.bindings.Grants,
                        access = self.data.bindings.Access;

                    if (isSamba(grants)) {
                        self.destUrl = sambaDestUrl;
                    } else if (isEmergingAccounts(grants)) {
                        self.destUrl = emergingAccountsUrl;
                    } else if (isCheckPoint() || isAuth0CheckPoint()) {
                        //Redirect at checkpointAr login url with SSO Token
                        beforeRedirectAction = evaluateBeforeDirectionExecution.bind(self, beforeRedirectAction, longToken);
                    } else if (isStaff(grants)) {
                        self.destUrl = staffDestUrl;
                    } else if (isMyPayOnboardingClient(grants)) {
                        self.destUrl = clientMyPayOnboardingUrl;
                    } else if (isClientBeta(grants, access)) {
                        self.destUrl = clientBetaDestUrl;
                    } else if (isAtendimentoClient(grants)) {
                        self.destUrl = atendimentoClientDestUrl;
                    } else if (isClient(grants)) {
                        self.destUrl = clientDestUrl;
                    } else if (isMyPayOnboardingRefAccountant(grants)) {
                        self.destUrl = refAccountantMyPayOnboardingUrl;
                    } else if (isEmployeePortalEmployee(grants)) {
                        self.destUrl = employeePortalDestUrl;
                    } else if (isEmployee(grants)) {
                        self.destUrl = employeeDestUrl;
                    } else if (isEmployer(grants)) {
                        self.destUrl = employerDestUrl;
                    } else if (isEsalesCustomerCenter(grants)) {
                        self.destUrl = esalesCustomerDestUrl;
                    } else if (isStaffDocumentsBasic(grants)) {
                        // OnvioDocumentsBasic
                        self.destUrl = staffDestUrl;
                    } else if (isCsAdmin(grants)) {
                        // redirect to an actual CSWeb uri - #8747
                        self.destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                    }
                    if (beforeRedirectAction) {
                        beforeRedirectAction().finally(function afterAction() {
                            // goto destination page after completion of promise
                            gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                        });
                    } else {
                        // goto destination page
                        gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                    }
                });
            } else {
                if (beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        // goto destination page after completion of promise
                        gotoDestinationPage($window, $location, defaultDestinationUrl);
                    });
                } else {
                    // goto destination page
                    gotoDestinationPage($window, $location, defaultDestinationUrl);
                }
            }

        }

        function switchAccountWithLongToken(longToken, beforeRedirectAction){
            // dump old token
            bmTokenStorage.clean();

            // propagate new token to apps in other tabs/windows
            bmTokenStorage.set(longToken);

            updateUserLanguage();
            // get bindings to determine where to send user
            // purposely set cache to false in order to get updated token
            loadBindings({ cache: false }).then(function (){
                var destUrl,
                    grants = self.data.bindings.Grants,
                    access = self.data.bindings.Access;

                if (isSamba(grants)) {
                    destUrl = sambaDestUrl;
                } else if (isStaff(grants)){
                    destUrl = staffDestUrl;
                } else if(isMyPayOnboardingClient(grants)) {
                    destUrl = clientMyPayOnboardingUrl;
                } else if (isClientBeta(grants, access)) {
                    destUrl = clientBetaDestUrl;
                } else if (isAtendimentoClient(grants)) {
                    destUrl = atendimentoClientDestUrl;
                } else if (isClient(grants)) {
                    destUrl = clientDestUrl;
                } else if(isMyPayOnboardingRefAccountant(grants)) {
                    destUrl = refAccountantMyPayOnboardingUrl;
                } else if(isEmployeePortalEmployee(grants)) {
                    destUrl = employeePortalDestUrl;
                } else if (isEmployee(grants)) {
                    destUrl = employeeDestUrl;
                } else if (isEmployer(grants)) {
                    destUrl = employerDestUrl;
                } else if (isEsalesCustomerCenter(grants)){
                    destUrl = esalesCustomerDestUrl;
                } else if (isStaffDocumentsBasic(grants)){
                    // OnvioDocumentsBasic
                    destUrl = staffDestUrl;
                } else if (isCsAdmin(grants)) {
                    // redirect to an actual CSWeb uri - #8747
                    destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                }

                if(beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        // goto destination page after completion of promise
                        gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                    });
                } else {
                    // goto destination page
                    gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                }
            });
        }

        function viewPortal(contactId, companyId, userId) {
            var viewPortalUrl = viewPortalUrlV2;
            return bmAccess.has('ClientCenterV2PreviewToggle').then(function() {
                // If using V2 of the toggle, there's no need to use V2 of the view portal end point
                viewPortalUrl = viewPortalUrlV1;
            })
            .catch(angular.noop)
            .finally(function() {
                var req = $http.post(viewPortalUrl, { id: contactId, companyId: companyId, userId: userId });
                req.then(
                    function(resp) {
                        // replace session token with new impersonated session token
                        bmTokenStorage.set(resp.data.LongToken);
                        // store full origin url so we can return
                        window.sessionStorage.setItem(destinationStorageKey, location.href);
                        // TODO: don't hardcode destination, look up and take them to home context
                        bmAccess.has('ClientCenterVnext').then(function() {
                            window.location.href = clientBetaDestUrl;
                        }).catch(function() {
                            if (bmEnvironment.isBrCountryCode()){
                                window.location.href = atendimentoClientDestUrl;
                            } else {
                                window.location.href = clientDestUrl;
                            }
                        });
                    },
                    function(resp) {
                        if (resp.status === 403 && !!resp.data && !!resp.data.message && resp.data.message === 'CC_USER_HAS_BETA') {
                            resp.config.global = false;
                            window.location.href = clientBetaDestUrl;
                        }
                    }
                );
                return req;
            });
        }

        function exitViewPortal() {
            var req = $http.post(exitViewPortalUrl);
            req.then(function(resp) {
                // replace session token with new impersonated session token
                bmTokenStorage.set(resp.data.LongToken);
                // return to origin url or staff
                var returnUrl = window.sessionStorage.getItem(destinationStorageKey) || staffDestUrl;
                window.sessionStorage.removeItem(destinationStorageKey);
                window.location.href = returnUrl;
            });
            return req;
        }

        function updateUserLanguage() {
            var promise, lang = bmLanguageManager.updatedUserLanguage;

            if (lang) {
                promise = loadMeta().then(function(resp) {
                    return $http({
                        method: 'PUT', // PATCH?
                        url: userUrl + '/' + resp.data.PrismGuid,
                        data: {
                            language: lang,
                            firstName: resp.data.FirstName,
                            lastName: resp.data.LastName,
                            email: resp.data.EmailAddress
                        }
                    });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                promise = deferred.promise;
            }

            return promise;
        }

        function isStaff(grants) {
            return grants.indexOf('staff') > -1;
        }

        function isClientBeta(grants, access) {
            return ((grants.indexOf('client.beta') > -1) || (access.indexOf('ClientCenterVnext') > -1)) && isClient(grants);
        }

        function isAtendimentoClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants) && bmEnvironment.isBrCountryCode();
        }

        function isClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingClient(grants){
            return grants.indexOf('client.mypayonboarding') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingRefAccountant(grants){
            return grants.indexOf('staff.mypayonboarding.refaccountant') > -1;
        }

        function isSamba(grants){
            return grants.indexOf('samba') > -1 && !isMyPayOnboardingClient(grants) && !isEmployee(grants) && !isEmployer(grants) &&!isEsalesCustomerCenter(grants);
        }

        function isEmployeePortalEmployee(grants) {
            return grants.indexOf('employeeportal.employee') > -1 && bmEnvironment.isBrCountryCode();
        }

        function isEmployee(grants){
            return grants.indexOf('samba.employee.center') > -1;
        }

        function isEmployer(grants){
            return grants.indexOf('samba.employer.center') > -1;
        }

        function isEsalesCustomerCenter(grants){
            return grants.indexOf('samba.esales.customer.center') > -1;
        }

        function isStaffDocumentsBasic(grants){
            return grants.indexOf('staff.setup.firm') > -1 && grants.indexOf('staff.setup.clients') > -1;
        }

        function isCsAdmin(grants){
            return grants.indexOf('csadmin') > -1;
        }

        function isCheckPoint(){
            return $location.search().mafUrl;
        }

        function isAuth0CheckPoint() {
            // If cookie bmCheckPointOrigin exists
            // The function bmUtil.cookie always returns string or undefined
            return ((bmUtil.cookie(cookieCheckPoint) !== undefined) && (bmUtil.cookie(cookieCheckPoint) !== ''));
        }

        function isEmergingAccounts(grants){
            return grants.indexOf('emergingaccounts') > -1;
        }

        function evaluateBeforeDirectionExecution(beforeRedirectAction, longToken){
            if(beforeRedirectAction){
                 return beforeRedirectAction()
                 .then(setAuthCheckpointUrl.bind(self, longToken));
             } else {
                  return setAuthCheckpointUrl(longToken);
             }
        }

        function setAuthCheckpointUrl(longToken){
            var defer = $q.defer();
            getCheckpointARSso(longToken).then(function(ssoUrl){
                self.destUrl = getCheckpointUrl(ssoUrl);
                defer.resolve();
            });
            return defer.promise;
        }

        // Get SSO token with UDS Long token for CheckpointAR vertical
        function getCheckpointARSso(longToken) {
            return $http({
                method: 'POST',
                url: '/api/security/v1/sso',
                data: {
                    Vertical: 'CheckpointAR',
                    Path: checkPointARUrl
                },
                headers: { Authorization: 'UDSLongToken' + longToken }
            });
        }

        //Return checkpoint url with mafUrl place in cookie bmCheckPointOrigin and SSOTotken
        function getCheckpointUrl(SsoUrl) {
            var startingUrl;
            if($location.search().mafUrl){
                startingUrl = $location.search().mafUrl;
            } else {
                startingUrl = bmUtil.cookie(cookieCheckPoint);
                bmUtil.cookie(cookieCheckPoint, null);
            }
            return SsoUrl.data.Url + '&redirect=' + startingUrl;
        }

        function loadMeta(conf) {
            var meta = $http.get(sessionMetadataUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.meta.CreatedDateTime) {
                self.data.meta = {};
                self.data.deferred.meta = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            meta.then(function(resp) {
                var data = resp.data;

                // convenience data
                if (data.FirstName) {
                    data.FullName = data.FirstName + ' ' + data.LastName;
                    data.Initials = data.FirstName.charAt(0) + data.LastName.charAt(0);
                } else {
                    data.FullName = data.LastName;
                    data.Initials = data.LastName.charAt(0);
                }

                self.data.meta = data;
                self.data.deferred.meta.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.meta.reject(resp);
            });

            return meta;
        }

        function loadBindings(conf) {
            var bindings = $http.get(sessionBindingsUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.bindings.ApplicationConfiguration) {
                self.data.bindings = {};
                self.data.deferred.bindings = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            bindings.then(function(resp) {
                var data = resp.data,
                    frpMap = data.FeatureResourcePermissions.FeatureResourcePermissionsMap,
                    iacs = data.InfrastructureAccessControls;

                // add grants array for convenience
                data.Grants = bmUtil.flattenKeys(frpMap, filterGrants).map(function(key) {
                    return grantsMap[key];
                });

                // add iac array
                data.Access = iacs;

                // persist theme identifier (companyId) in a cookie for pre-auth branding (e.g. login page)
                if (isClient(data.Grants) || isStaff(data.Grants)) {
                    bmTheme.persistTheme(data.ApplicationConfiguration.CompanyId);
                }

                self.data.bindings = data;
                self.data.deferred.bindings.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.bindings.reject(resp);
            });

            return bindings;
        }

        function load(conf) {
            var meta = loadMeta(conf),
                bindings = loadBindings(conf),
                all = $q.all([meta, bindings]);

            all.then(function() {
                self.data.deferred.all.resolve(authenticatedSessionData);
            }, function(resp) {
                self.data.deferred.all.reject(resp);
            });

            return self.data.deferred.all.promise;
        }

        function filterGrants(obj, prop) {
            return obj[prop] === 'Granted';
        }

        function destroy(waypointUrl) {
            destroying = true;

            // goto login page, no return dest
            gotoWaypointPage($window, waypointUrl || authWaypointUrl);

            // goto login page, set return dest to current url - no hash location
            // gotoWaypointPage($window, authWaypointUrl, $window.location.href.split('#')[0]);
        }

        function destroyAuth0(waypointUrl) {
            destroying = true;
            destroySession();
            $window.location.href = waypointUrl;
        }

        function destroySession() {
            var token;
            $window.clearTimeout(unloadCancelledTimeout);
            if (destroying) {
                token = bmTokenStorage.get();
                bmTokenStorage.clean();
                $window.sessionStorage.clear();
                if(navigator.sendBeacon) {
                    if(isOnvioSTIDEnabled()) {
                        // use send beacon to send delete request
                        var param = new Blob(
                            [],
                            {type : 'application/json'}
                          );
                          navigator.sendBeacon(deleteOIDCSessionUrl, param);
                    } else {
                        // use send beacon to send delete request
                      var params = new Blob(
                        [JSON.stringify({'longToken': token})],
                        {type : 'application/json'}
                      );
                      navigator.sendBeacon(deleteSessionUrl, params);
                    }
                } else if(isOnvioSTIDEnabled()) {
                    destroyOnvioSTIDSession();
                } else {
                    // make synchronous session delete request ($http can't do sync)
                    // to guarantee this occurs before unloading
                    var req = new $window.XMLHttpRequest();
                    req.open('DELETE', sessionMetadataUrl, false); // false = synchronous
                    req.setRequestHeader('Authorization', tokenType + ' ' + token);
                    req.send(null);
                    $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
                }
            }
        }

        function getRequestedDestination() {
            var dest = $location.search()[destinationQueryStringKey], hash;
            if (dest) {
                hash = $location.hash();
                if (hash) {
                    // concat hash for full dest
                    dest = dest + '#' + hash;
                }
                dest = decodeURIComponent(dest);
            }
            return dest;
        }

        function gotoDestinationPage($window, $location, fallbackUrl) {
            $window.location.href = getRequestedDestination($location) || fallbackUrl;
        }

        function destroyOnvioSTIDSession() {
            // make synchronous session delete request ($http can't do sync)
            // to guarantee this occurs before unloading
            var request = new $window.XMLHttpRequest();
            request.open('POST', deleteOIDCSessionUrl, false); // false = synchronous
            request.withCredentials = true;
            request.send();
        }

        function isOnvioSTIDEnabled(){
            return bmAccess.has('Platform_EnableOnvioSTID').then(function(){
                return true;
            }).catch(function(){
                return false;
            });
        }

        $window.addEventListener('beforeunload', function() {
            unloadCancelledTimeout = $window.setTimeout(function() {
                // unload was cancelled, reset state
                destroying = false;
            }, 1000);
        }, false);

        $window.addEventListener('unload', function() {
            destroySession();
        }, false);
    }

    function HttpAnalyticsInterceptor(bmUtil, $rootScope) {
        this.request = function(conf) {
            var callId = bmUtil.generateUUID();
            var chainId = bmUtil.generateUUID();
            conf.headers['x-call-id'] = callId;
            conf.headers['x-chain-id'] = chainId;
            $rootScope.$emit('$httpRequestEvent', {
                url: conf.url,
                method: conf.method,
                'x-call-id': callId,
                'x-chain-id': chainId
            });
            return conf;
        };
    }

    function HttpTimeoutInterceptor(httpTimeout) {
        this.request = function(conf) {
            if (angular.isUndefined(conf.timeout)) {
                conf.timeout = httpTimeout;
            }
            return conf;
        };
    }

    function HttpAuthInterceptorProvider() {
        var redirect = true,
            auth = true;

        this.auth = function(val) {
            auth = val;
        };
        this.redirect = function(val) {
            redirect = val;
        };

        this.$get = ['$window', '$location', '$document', '$q', 'authWaypointUrl', 'bmTokenStorage','bmEnvironmentConst', 'bmUtil','$injector',
            function($window, $location, $document, $q, authWaypointUrl, bmTokenStorage, bmEnvironmentConst, bmUtil, $injector) {

                return {
                    request: function(conf) {
                        if (auth && conf.bmNoAuth !== true) {
                            var token = bmTokenStorage.get();

                            if (token) {
                                conf.headers.Authorization = tokenType + ' ' + token;
                            }
                        }
                        return conf;
                    },
                    responseError: function(resp) {
                        if (resp.status === 401 && redirect && resp.config.bmAuthRedirect !== false) {
                            $injector.get('bmAccess').not('Platform_DisableAuth0Phase2').then(function () {
                                var origin = $window.location.origin;
                                var domain = origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
                                var auth0ClientIdLogout = bmEnvironmentConst.auth0ClientId;
                                // If it is CA and have fr-CA we use the region locale Auth0 client ID
                                if (domain === '.ca' && bmUtil.cookie('BMLanguageCode') === 'fr-CA') {
                                    auth0ClientIdLogout = bmEnvironmentConst.auth0RegionLocaleClientId;
                                }

                                // for development purposes
                                if (bmEnvironmentConst.isLocalType) {
                                    origin = origin + '/login';
                                }

                                createAuth0Client({ domain: bmEnvironmentConst.auth0Domain, client_id: auth0ClientIdLogout }).then(function(auth0) { // jshint ignore:line
                                    resp.config.global = false;
                                    // Validate that pathname includes / at the end
                                    var trailingSlash = ($window.location.pathname.search(/\/$/) !== -1) ? '' : '/';
                                    var destinationUrl = $window.location.pathname + trailingSlash + $window.location.search + $window.location.hash;
                                    // remove 'notfound' at the end if it exists
                                    destinationUrl = destinationUrl.replace(/\/notfound$/, '/');
                                    // Create cookie on this space
                                    // if dest, encode it in waypoint so we can return after auth
                                    document.cookie = cookieDeepLink + '=' + destinationUrl + '; path=/; Max-Age=7200; Secure';

                                    // Limit of minutes to clear the session for csdesktop app
                                    var minutes = 6;
                                    if($location.search().timestamp){
                                        var now = new Date();
                                        var timeRequested = new Date(decodeURIComponent($location.search().timestamp).substring(0,19));

                                        if(!(timeRequested instanceof Date) || isNaN(timeRequested)){
                                            auth0.logout({returnTo: origin});
                                        }
                                        var timeDiff = Math.abs(now - timeRequested);
                                        minutes = Math.floor(timeDiff / (1000 * 60));
                                    }

                                    // Validate if it's from csdesktop and the timestamp to skip the logout
                                    if($location.search().from === 'csdesktop' && minutes <= 5){
                                        // If the url is for migration dashboard remove the additional parameters
                                        // to avoid the url be double encoded at the end by the MFE migration dashboard
                                        if(destinationUrl.indexOf('dashboard') !== -1){
                                            var fixedDestinationUrl = destinationUrl.substring(0, destinationUrl.indexOf('dashboard') + 9);
                                            document.cookie = cookieDeepLink + '=' + fixedDestinationUrl + '; path=/; Max-Age=7200; Secure';
                                        }
                                        gotoWaypointPage($window, origin);
                                    } else {
                                        auth0.logout({returnTo: origin});
                                    }
                                });
                            }).catch(angular.noop);
                            $injector.get('bmAccess').has('Platform_DisableAuth0Phase2').then(function() {
                                // don't get caught up in the global error handler
                                resp.config.global = false;
                                // goto login page, set return dest to current url
                                gotoWaypointPage($window, authWaypointUrl, $window.location.href);
                            }).catch(angular.noop);
                        }
                        return $q.reject(resp);
                    }
                };
            }];
        }

    var globalHttpServerError = { type: 'danger', msg: 'A server error ocurred.', closeable: true };
    function HttpLogInterceptor($timeout, $q, $rootScope) {
        this.responseError = function(resp) {
            // bump to next event loop, so error/catch can disable it if handled
            $timeout(function() {
                if (resp.config.global !== false) {
                    // make copy and add response obj
                    var errCopy = angular.copy(globalHttpServerError);
                    errCopy.detail = resp;

                    if (!$rootScope.bmErrors) {
                        $rootScope.bmErrors = [];
                    }

                    $rootScope.bmErrors.unshift(errCopy);
                }
            });
            return $q.reject(resp);
        };
    }

    function gotoWaypointPage($window, waypointUrl, destinationUrl) {
        var href = waypointUrl;

        // if dest, encode it in waypoint so we can return after auth
        if (destinationUrl) {
            // remove 'notfound' at the end if it exists
            destinationUrl = destinationUrl.replace(/\/notfound$/, '/');
            // append hash if necessary
            if (waypointUrl.indexOf('#') === -1) {
                href += '#/';
            }
            // append appropriate "hashSearch" delimiter
            href += /#.*\?/.test(waypointUrl) ? '&' : '?';
            // append dest as "hashSearch" param
            href += destinationQueryStringKey + '=' + encodeURIComponent(destinationUrl);
        }

        $window.location.href = href;
    }

    function config($httpProvider) {
        $httpProvider.interceptors.push('HttpAuthInterceptor');
        $httpProvider.interceptors.push('HttpLogInterceptor');
        $httpProvider.interceptors.push('HttpTimeoutInterceptor');
        $httpProvider.interceptors.push('HttpAnalyticsInterceptor');
    }

    //This function is used for the domain switch between linked accounts.
    function processSsoLogin($log, ssoUrl, ssoTokenKey, bmTokenStorage, ssoToken) {
        var ssoApi = ssoUrl + '?' + ssoTokenKey + '=' + ssoToken + '&pre-created=true';
        var request = new XMLHttpRequest();
        /* A synchronous XHR is made to retrieve the long token before other calls can be successfully made.
           Future improvement: a more elegant approach is to use an asynchronous call (which is more pattern consistent)
           and use the event trigger to manually boostrap the Angular(JS) components */
        $log.info('A synchronous XHR is used to retrieve the sso long token before all other calls can be made');
        request.open('GET', ssoApi, false);
        request.send(null);
        if (request.status === 200) {
          var longToken = (JSON.parse(request.responseText)).LongToken;
          bmTokenStorage.clean();
          bmTokenStorage.set(longToken);
        } else {
          $log.info('Sso login failed: ' + request.responseText);
        }
    }

    function run($window, $location, $timeout, $rootScope, $http, $translate, $log, bmUtil, bmTokenStorage, authenticatedSessionData, bmAnalyticsService, ssoUrl, ssoTokenKey) {
        var ssoToken = $location.search().token;
        if (ssoToken) {
            processSsoLogin($log, ssoUrl, ssoTokenKey, bmTokenStorage, ssoToken);
        }

        authenticatedSessionData.get().then(function(data) {
            $http.defaults.headers.common['x-company-id'] = data.bindings.ApplicationConfiguration.CompanyId;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-userguid'] = data.meta.PrismGuid;
            // x-user-id will replace x-cobalt-security-userguid
            $http.defaults.headers.common['x-user-id'] = data.meta.PrismGuid;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-sessionid'] = data.meta.SessionId;
            // x-session-id will replace x-cobalt-security-sessionid
            $http.defaults.headers.common['x-session-id'] = data.meta.SessionId;
        });

        logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService);

        // delay till next event loop so all initial requests have same rootGuid
        // regardless of redirection
        $timeout(function() {
            $rootScope.$on('$stateChangeSuccess', setRouteId);
            $rootScope.$on('$routeChangeSuccess', setRouteId);
        });

        // localize global http response error msg
        function localize() {
            $translate('bm.session.servererror').then(function(val) {
                globalHttpServerError.msg = val;
            });
        }
        $timeout(function() {
            localize(); // localize now (well..next cycle, to get around refresh bug)
            $rootScope.$on('bmLanguageChangeSuccess', localize); // localize on lang change
        });

        function logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService) {
            $rootScope.$on('$httpRequestEvent', function(evt, data) {
                bmAnalyticsService.track('Browser HTTP request', data);
            });
        }

        function setRouteId() {
            var uuid = bmUtil.generateUUID();
            var guid = bmUtil.generateTRMRGUID(uuid);
            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-pcid'] = guid;
            // x-route-id will replace x-cobalt-pcid
            $http.defaults.headers.common['x-route-id'] = uuid;
        }

        // bootstrap a value for startup requests
        setRouteId();
    }

    // ANGULAR

    AuthenticatedSessionData.$inject = ['$q'];

    AuthenticatedSession.$inject = [
        '$window',
        '$document',
        '$log',
        '$location',
        '$q',
        '$http',
        '$rootScope',
        '$uibModal',
        'HttpLogInterceptor',
        'sessionMetadataUrl',
        'sessionMetadataUrlV2',
        'sessionBindingsUrl',
        'authWaypointUrl',
        'defaultDestinationUrl',
        'ssoUrl',
        'ssoTokenKey',
        'AuthenticatedSessionData',
        'bmUtil',
        'bmTheme',
        'bmLanguageManager',
        'bmEnvironmentConst',
        'bmEnvironment',
        'bmAccess',
        'csWebLoginUriMap',
        'bmTokenStorage'
    ];

    HttpLogInterceptor.$inject = [
        '$timeout',
        '$q',
        '$rootScope'
    ];

    HttpTimeoutInterceptor.$inject = [
        'httpTimeout'
    ];

    HttpAnalyticsInterceptor.$inject = [
        'bmUtil',
        '$rootScope'
    ];

    config.$inject = ['$httpProvider'];

    run.$inject = ['$window',
        '$location',
        '$timeout',
        '$rootScope',
        '$http',
        '$translate',
        '$log',
        'bmUtil',
        'bmTokenStorage',
        'AuthenticatedSessionData',
        'bmAnalyticsService',
        'ssoUrl',
        'ssoTokenKey'
    ];

    angular.module('bluemoon.components.session', [
        'bluemoon.components.util',
        'bmTokenStorage',
        'bluemoon.components.theme',
        'bluemoon.components.i18n',
        'pascalprecht.translate',
        'bmEnvironment',
        'bluemoon.components.analytics'
    ])

        .value('sessionMetadataUrl', '/api/security/v1/sessions')
        .value('sessionMetadataUrlV2', '/api/security/v2/sessions')
        .value('sessionBindingsUrl', '/api/security/v1/session-bindings')
        .value('ssoUrl', '/api/security/v1/sso')
        .value('authWaypointUrl', '/login/')
        .value('defaultDestinationUrl', staffDestUrl)
        .value('ssoTokenKey', 'token')
        .value('httpTimeout', 60000) // 60 seconds
        .value('csWebLoginUriMap', {
            'LOCAL': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'UNKNOWN': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'CI': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'DEMO': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'QED': 'https://cswebqa.int.thomsonreuters.com/myaccount/login.aspx',
            'PROD': 'https://cs.thomsonreuters.com/myaccount/login.aspx'
        })
        .service('AuthenticatedSession', AuthenticatedSession)
        .service('AuthenticatedSessionData', AuthenticatedSessionData)
        .provider('HttpAuthInterceptor', HttpAuthInterceptorProvider)
        .service('HttpLogInterceptor', HttpLogInterceptor)
        .service('HttpTimeoutInterceptor', HttpTimeoutInterceptor)
        .service('HttpAnalyticsInterceptor', HttpAnalyticsInterceptor)

        .config(config)
        .run(run);

})(window.angular);

/**
 * Blue Moon Components - theme module
 */
(function(angular) {
    'use strict';

    angular.module('bluemoon.components.theme', ['bluemoon.components.util'])
        .value('bmThemeCookieName', 'bmTheme')
        .value('bmThemeType', 'staff') // default to staff
        .value('bmThemeUrl', '/api/profiles/v1/themes')
        .value('bmThemeHeaderUrl', '/api/profiles/v1/themes/header')
        .service('bmTheme', Theme);

    Theme.$inject = [
        '$http',
        '$document',
        '$q',
        'bmThemeUrl',
        'bmThemeHeaderUrl',
        'bmThemeType',
        'bmUtil',
        'bmEnvironment',
        'bmThemeCookieName'
    ];

    function Theme($http, $document, $q, themeUrl, themeHeaderUrl, themeType, util, env, themeCookieName) {
        var self = this,
            promise;

        // properties
        self.data = {
            themeType: themeType
            // header: {...}
            // advert: {...}
        };
        self.useTheme = (themeType === 'client' || !!util.cookie(themeCookieName));

        // methods
        self.load = load;
        self.loadHeader = loadHeader;

        // available for theme override
        self.applyTheme = applyTheme;

        self.persistTheme = persistTheme;

        function persistTheme(companyId) {
            util.cookie(themeCookieName, companyId, '/', true);
        }

        function loadHeader(companyId, refresh) {
            return load(companyId, themeHeaderUrl, refresh);
        }

        // todo: figure out best way to differentiate staff/client/employee
        function load(params, url, refresh) {

            // todo: make sure params match the promise
            if (!refresh && promise) { return promise; }

            url = url || themeUrl;

            if (self.useTheme) {
                if (!angular.isDefined(params)) {
                    params = util.cookie(themeCookieName);
                }
                if (angular.isDefined(params)) {
                    if (typeof params !== 'object') {
                        params = { company: params }; // default to company
                    }
                    // if the response is cached refreshed data will be incorrect
                    promise = $http.get(url, { params: params });
                    promise.then(function(resp) {
                        self.data.header = resp.data;
                    });
                }
            }

            if (!promise) {
                var deferred = $q.defer();
                promise = deferred.promise;
                self.data.header = null;
                deferred.resolve({ data: self.data });
            }

            promise.then(function() {
                resolveAdvertData();
            });

            return promise;
        }

        // Note: this is something that could and maybe should be pushed behind the service
        // layer as it's biz logic that is spilling out to the client
        function resolveAdvertData() {
            var img, txt, href, useAdvert = false, country = env.getCountryCode();

            if (self.data.header) {
                txt = self.data.header.loginPageText;
                img = self.data.header.loginPageImage;
                useAdvert = !!(txt || img);
            }

            if (!self.useTheme && !txt && !img) {
                switch (country) {
                    case 'us':
                        /* NOTE: can't drive it from data due to versioning of img, supply country
                           so consumer can construct a class and declare an image path in css.
                           This should be refactored to use server-side img data which is more
                           consistent with the way we do branding logos. */
                        // img = 'components/img/synergy2015.jpg';
                        href = 'http://cs.thomsonreuters.com/SYNERGY/';
                        break;
                    case 'uk':
                        // see above coment
                        // img = 'components/img/synergy2015-gb.jpg';
                        href = 'https://www.digita.com';
                        break;
                    case 'ca':
                        // add when ready
                        break;
                }
                if (href) {
                    useAdvert = true;
                }
            }

            if (useAdvert) {
                self.data.advert = { country: country, img: img, text: txt, href: href };
            }
        }

        function applyTheme() {
            // todo: should apply theme try to load the theme first?
            var html = angular.element($document[0].documentElement);
            var colors = self.data.header ? self.data.colors : undefined;

            if (!colors) { return; }

            var head = html.find('head'),
                headerFill = normalizeHex(colors.headerFillColor),
                headerText = normalizeHex(colors.headerTextColor),
                altHeaderFill = hexToRgba('#888888', 0.2),
                //altHeaderText = (headerText === '#ffffff' ? '#ddd' : hexToRgba(headerText, 0.5)),
                buttonFill = normalizeHex(colors.buttonFillColor),
                buttonText = normalizeHex(colors.buttonTextColor),
                // todo: sanitize css values, move selectors to appropriate components?
                // try to template this as html
                style = angular.element([
                    '<style>',
                        '.btn.btn-primary {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ' !important;',
                            'border-color:', 'rgba(0,0,0,.2) !important', ';', // ?
                        '}',
                        '.btn.btn-primary:hover {',
                            'border-color:', 'rgba(0,0,0,.4) !important', ';', // ?
                        '}',
                        '.nav-pills > li.active > a,',
                        '.nav-pills > li > a:hover,',
                        '.nav-pills > li > a:focus {',
                            'color:', buttonFill, ' !important;',
                        '}',
                        'bm-nav ul a.bm-header-active {',
                            'border-color:', buttonFill, ' !important;',
                        '}',
                        'bm-header {',
                            'background-color:', headerFill, ';',
                            'color:', headerText, ';',
                        '}',
                        'bm-header header h1 em {',
                            'color:', buttonFill, ';',
                        '}',
                        'bm-header a {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header-active a > .bm-icon,',
                        'bm-header a .bm-profile-photo .initials {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:focus {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header a:hover > .bm-icon,',
                        'bm-header a:focus > .bm-icon,',
                        'bm-header [dropdown].open > a > .bm-icon {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:hover,',
                        '.mask-active .bm-header-nav-toggle,',
                        'bm-header [dropdown].open > a {',
                            'color:', headerText, ';',
                            'background-color:', altHeaderFill, ';',
                        '}',
                        'bm-header .dropdown-menu > li > a:hover,',
                        'bm-header .dropdown-menu > li > a:focus,',
                        'bm-header .dropdown-menu > .active > a,',
                        'bm-header .dropdown-menu > .active > a:hover,',
                        'bm-header .dropdown-menu > .active > a:focus {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ';',
                        '}',
                    '</style>'
                ].join(''));

            head.append(style);
        }
    }

    // variation on http://stackoverflow.com/a/5624139
    function normalizeHex(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        return hex.toLowerCase();
    }
    function hexToRgba(hex, a) {
        hex = normalizeHex(hex);
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? 'rgba(' +
            parseInt(result[1], 16) + ',' +
            parseInt(result[2], 16) + ',' +
            parseInt(result[3], 16) + ',' +
            a + ')'
        : null;
    }

})(window.angular);

(function(window, angular){
    'use strict';

    var queue = new window.bmJobQueue();

    angular.module('bmJobQueue', [])
    .value('bmJobQueue', queue);
})(window, window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation', []);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').factory('PasswordValidationFactory', passwordValidation);
    passwordValidation.$inject = ['$q', '$translate', '$http', 'bmEnvironment'];

    function passwordValidation($q, $translate, $http, bmEnvironment) {
        return {
            loadPasswordRules: function() {
                var deferred = $q.defer();
                bmEnvironment.getRoute('ProfileServices').then(function(url){
                    url += '/v2/password/rules';
                    $http.get(url, {headers: { 'Accept': 'application/json' }}).then(function(response){
                        var pwReqs = response.data;

                        var translatePromises = [
                            $translate('bm.password.validation.characterRule'),
                            $translate('bm.password.validation.numberRule'),
                            $translate('bm.password.validation.lowerCaseRule'),
                            $translate('bm.password.validation.upperCaseRule'),
                            $translate('bm.password.validation.specialCharactersRule'),
                            $translate('bm.password.validation.containsProhibitedCharacters')
                        ];

                        $q.all(translatePromises).then(function(translations){

                            deferred.resolve(
                                {
                                    charClassReq: pwReqs.classes,
                                    charLengthReq: pwReqs.chars,
                                    rules:
                                    {
                                        characterLengthRule:
                                        {
                                            label : translations[0],
                                            test : function (password) {
                                                return password && password.length >= pwReqs.chars;
                                            }
                                        },
                                        characterTypeRules: [
                                            {
                                                label : translations[1],
                                                test : function (password) {
                                                    return password && /[0-9]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[2],
                                                test : function (password) {
                                                    return password && /[a-z]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[3],
                                                test : function (password) {
                                                    return password && /[A-Z]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[4] + ' ` ~ ! @ # $ % ^ & * ( ) _ - + < = > { } [ ] \\ | : ; " \' , . ? /',
                                                test : function (password) {
                                                    return password && /[`~\!@#\$%\^&\*\(\)_\-+<=>{}\[\]\\\|:;\"\',\.\?\/]+/.test(password);
                                                }
                                            }
                                        ],
                                        prohibitedCharacterRule:
                                        {
                                            label : translations[5],
                                            test : function (password) {
                                                return password && /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(password);
                                            },
                                            getInvalidChars : function (password) {
                                                var matches = new Set();
                                                var pattern = /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/g;
                                                var match = pattern.exec(password);

                                                while(match){
                                                    matches.add(match[0]);
                                                    match = pattern.exec(password);
                                                }
                                                return Array.from(matches);
                                            }

                                        }
                                    }
                                }
                            );
                        });
                    });

                });
                return deferred.promise;
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').directive('bmPasswordValidation', passwordValidation);
    passwordValidation.$inject = ['PasswordValidationFactory'];

    function passwordValidation(PasswordValidationFactory) {
        return {
            restrict: 'EA',
            templateUrl: 'components/password-validation/password-validation.2js.html',
            scope: {
                password: '=password'
            },
            controller: ['$scope', function ($scope) {
                PasswordValidationFactory.loadPasswordRules().then(function (resp) {
                    angular.extend($scope, resp);
                });
            }]
        };
    }
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonRequiredMark', ['pascalprecht.translate'])
        .filter('bluemoonRequiredMark', bluemoonRequiredMark)
        .filter('bmRequiredMark', bluemoonRequiredMark);

    bluemoonRequiredMark.$inject = ['$translate'];
    function bluemoonRequiredMark($translate) {
        return function(input, makeRequired) {
            if(typeof makeRequired === 'undefined' || makeRequired === null) {
                makeRequired = true;
            }
            if(angular.isFunction(input)) {
                input = input();
            }
            if (!makeRequired) {
                return input;
            }
            return $translate.instant(
                'Bluemoon.Components.BluemoonRequiredMark.RequiredFieldLabel',
                { 'n0': input });
        };
    }
}(window.angular));

/// <reference path="~/node_modules/angular/angular.js" />
(function(angular) {
    'use strict';
    var module = angular.module('bluemoon.components.ConfirmNavigationController', []);
    module.controller('bluemoon.components.ConfirmNavigationController',
        ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.ok = function() {
                //alert("ok clicked");
                $uibModalInstance.close(false);
            };

            $scope.save = function() {
                //alert("save clicked");
                $uibModalInstance.close(true);
            };

            $scope.cancel = function() {
                //alert("cancel clicked");
                $uibModalInstance.dismiss('cancel');
            };
        }]);

}(window.angular));

/// <reference path="~/node_modules/angular/angular.js" />
(function(angular) {
    'use strict';
    angular.module('bluemoon.components.SaveInProgressModalController', [])
        .controller('bluemoon.components.SaveInProgressModalController',
    [
        '$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);

}(window.angular));

(function(window, angular, Rx) {
    'use strict';
    // this service is based on this article:
    // http://markcampbell.me/tutorial/2013/10/08/preventing-navigation-in-an-angularjs-project.html
    var NavigationUtils = (function() {
        var _$inject = [
            '$injector',
            '$rootScope',
            '$location',
            '$log',
            '$uibModal',
            'fef.Utils',
            'fef.PromiseUtils',
            '$translate'
        ];

        function NavigationUtilsImpl(
            $injector,
            $rootScope,
            $location,
            $log,
            $uibModal,
            utils,
            promiseUtils,
            $translate) {

            var preventNavigation = false;
            var preventNavigationUrl = null;
            var dialogOpen = false;
            var onSaveFunc = null;
            var _promise = null;
            var _assumeSave = false;
            var $state = $injector.has('$state') ? $injector.get('$state') : null;

            this.allowNavigation = function() {
                preventNavigation = false;
                onSaveFunc = null;
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = null;
                }
            };

            this.preventNavigation = function(saveFunc, assumeSave) {
                var self = this;
                if(utils.exists(saveFunc) && !angular.isFunction(saveFunc)) {
                    throw new Error('NavigationUtils.preventNavigation: invalid argument saveFunc. Was expecting a function or null/undefined.');
                }

                if(!utils.exists(assumeSave)) {
                    assumeSave = false;
                }
                _assumeSave = assumeSave;
                onSaveFunc = saveFunc;
                preventNavigation = true;
                preventNavigationUrl = $location.absUrl();
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = function(e) {
                        var ret = self.handleOnBeforeUnload(e);
                        e.returnValue = ret;
                        return ret;
                    };
                }
            };

            /**
             * Captures the required information prior to preventing a state change so it can be re-issued at a later date
             */
            this.pauseStateChange = function (toState, toParams, fromState, fromParams) {
                return {
                    toState: toState ? toState.name : undefined,
                    toParams: toParams ? angular.copy(toParams) : {},
                    fromState: fromState ? fromState.name : undefined,
                    fromParams: fromParams ? angular.copy(fromParams) : {},
                };
            };

            /**
             * Continues a state change that was previously prevented (usually whilst another process such as saving takes place before navigating away)
             */
            this.continueStateChange = function ($state, stateChange) {

                // When working with multiple levels, the id parameter will need to be specified to avoid conflict (e.g. id -> childId -> grandChildId)
                var idStateParam = $state.params.idParam || 'id';

                if(
                    /* originally coming from a 'new' item */
                    stateChange.fromParams[idStateParam] === 'new' &&
                    /* going to a 'new' item */
                    stateChange.toParams[idStateParam] === 'new' &&
                    /* the current state has been updated with an id that is not 'new' (i.e. has been saved) */
                    $state.params[idStateParam] !== 'new' &&
                    /* VERY SPECIFIC: when going to a different state (to avoid a situation such as 'Save & New' updating the id incorrectlly) */
                    stateChange.toState !== stateChange.fromState &&
                    /* VERY SPECIFIC: when coming from the 'general' tab */
                    stateChange.fromState.substr(stateChange.fromState.length - 8, 8) === '.general' &&
                    /* VERY SPECIFIC: when going to a sibling or child state */
                    stateChange.toState.substr(0, stateChange.fromState.length - 8) === stateChange.fromState.substr(0, stateChange.fromState.length - 8)
                    ) {
                    // Update the params to include the newly saved item id
                    stateChange.toParams[idStateParam] = $state.params[idStateParam];
                }

                $state.go(stateChange.toState, stateChange.toParams);

            };

            /**
             * DEPRECATED. Pass a saveFunc to preventNavigation instead.
             */
            this.setPromise = function(promise) {
                _promise = promise;
            };

            var locationChangeStartSubject = new Rx.ReplaySubject(1);
            /**
             * DEPRECATED (probably)
             */
            this.locationChangeStart = function() {
                return this.locationChangeStartSubject.asObservable();
            };

            if(typeof $state !== 'undefined' && $state !== null) {
                this.handleStateChangeStart = function(event, toState, toParams, fromState, fromParams) {
                    var self = this;
                    // tried to navigate while the dialog is open. go ahead and prevent it.
                    // User must dismiss the dialog before continuing.
                    // We only want one dialog at a time. This might catch a double click on
                    // the back button, for instance.
                    if(dialogOpen) {
                        event.preventDefault();
                        return;
                    }

                    if(preventNavigation) {
                        event.preventDefault();
                        dialogOpen = true;
                        var modalInstance;
                        // Capture the parts of the state change that we paused so it can be continued later
                        var pausedStateChange = self.pauseStateChange(toState, toParams, fromState, fromParams);
                        var finishNavigation = function() {
                            dialogOpen = false;
                            preventNavigation = false;
                            // Continue the paused state change
                            self.continueStateChange($state, pausedStateChange);
                        };

                        if(_assumeSave) {
                            if(utils.exists(_promise)) {
                                throw new Error('NavigationUtils.handleStateChangeStart: setting the promise not supported when assumeSave is set to true.');
                            }

                            if(!utils.exists(onSaveFunc)) {
                                throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                            }
                            var savePromise = onSaveFunc();
                            savePromise['finally'](function() {
                                dialogOpen = false;
                            });

                            return savePromise.then(function() {
                                finishNavigation();
                            });
                        } else {
                            if(_promise !== null) {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                                    controller: 'bluemoon.components.SaveInProgressModalController'
                                });
                                modalInstance.result.then(function() {

                                })['finally'](function() {
                                    dialogOpen = false;
                                });

                                return _promise.then(
                                    function() { // success
                                        modalInstance.dismiss('cancel');
                                        finishNavigation();
                                    },
                                    function() { // error
                                        modalInstance.opened.then(function() {
                                            modalInstance.dismiss('cancel');
                                        });
                                    }
                                );

                            } else {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                                    controller: 'bluemoon.components.ConfirmNavigationController'
                                });
                                modalInstance.result.then(function(saveClicked) {
                                    if(saveClicked) {
                                        if(!utils.exists(onSaveFunc)) {
                                            throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                        }
                                        return onSaveFunc().then(function() {
                                            finishNavigation();
                                        });
                                    } else {
                                        finishNavigation();
                                    }
                                    return promiseUtils.resolvedPromise();
                                })['finally'](function() {
                                    dialogOpen = false;
                                });
                            }
                        }
                    } else {
                        self.allowNavigation();
                    }
                };
            }

            /**
             * DEPRECATED. Use handleStateChangeStart for now.
             */
            this.handleLocationChangeStart = function(event, next, current) {
                var self = this;
                if(_assumeSave) {
                    throw new Error('NavigationUtils.handleLocationChangeStart: assumeSave option not yet supported. Use handleStateChangeStart instead.');
                }
                locationChangeStartSubject.onNext({
                    event: event,
                    next: next,
                    current: current
                });

                // tried to navigate while the dialog is open. go ahead and prevent it.
                // User must dismiss the dialog before continuing.
                // We only want one dialog at a time. This might catch a double click on
                // the back button, for instance.
                if(dialogOpen) {
                    event.preventDefault();
                    return;
                }

                if(preventNavigationUrl !== current || preventNavigationUrl === null) {
                    self.allowNavigation();
                    return;
                }

                if(preventNavigation) {
                    event.preventDefault();
                    dialogOpen = true;
                    var modalInstance;

                    var finishNavigation = function() {
                        preventNavigation = false;
                        var indexOfUrl = $location.absUrl().indexOf($location.url(), 0);
                        var newUrl = next.substr(indexOfUrl, next.length - indexOfUrl);
                        $location.url(newUrl);
                    };

                    if (_promise !== null) {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                            controller: 'bluemoon.components.SaveInProgressModalController'
                        });
                        modalInstance.result.then(function() {

                        })['finally'](function() {
                            dialogOpen = false;
                        });

                        return _promise.then(
                            function() { // success
                                modalInstance.dismiss('cancel');
                                finishNavigation();
                            },
                            function() { // error
                                modalInstance.opened.then(function() {
                                    modalInstance.dismiss('cancel');
                                });
                            }
                        );

                    } else {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                            controller: 'bluemoon.components.ConfirmNavigationController'
                        });
                        modalInstance.result.then(function(saveClicked) {
                            if (saveClicked) {
                                if (!utils.exists(onSaveFunc)) {
                                    throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                }
                                return onSaveFunc().then(function() {
                                    finishNavigation();
                                });
                            } else {
                                finishNavigation();
                            }
                            return promiseUtils.resolvedPromise();
                        })['finally'](function() {
                            dialogOpen = false;
                        });
                    }
                } else {
                    self.allowNavigation();
                }
            };

            this.handleOnBeforeUnload = function(e) {
                // What should we do if the dialog is already open?
                // probably still bring up the browser dialog over the top of it.
                if(preventNavigation && $location.absUrl() === preventNavigationUrl) {
                    e.returnValue = $translate.instant('Bluemoon.Components.NavigationUtils.ConfirmNavigation.BrowserMessage');
                    return e.returnValue;
                }
                e.preventDefault();
            };

            /**
             * Intended to be called on $stateChangeStart in an application. It will look for a redirectTo property on a state
             * object which is a string indicating the name of another state which should be redirected to instead of loading the first state.
             * One use case for this is where we had a state previously and then introduced child states and we want to make
             * the parent state redirect to a child as the default state if you try to go to the parent.
             **/
            this.useRedirectToIfPresentOnState = function(event, toState, toParams){
                if (toState.redirectTo) {
                    event.preventDefault();

                    // location: 'replace' will "update url and also replace last history record",
                    // which fixes a bug where the back button gets stuck on redirected pages.
                    $state.go(toState.redirectTo, toParams, {location: 'replace'});
                }
            };
        }
        NavigationUtilsImpl.$inject = _$inject;
        return NavigationUtilsImpl;
    }());

    angular.module('bluemoon.components.NavigationUtils', [
        'fef',
        'ui.bootstrap.modal',
        'pascalprecht.translate',
        'bluemoon.components.ConfirmNavigationController',
        'bluemoon.components.SaveInProgressModalController'
    ]).service('bluemoon.components.NavigationUtils', NavigationUtils);

}(window, window.angular, window.Rx));

(function() {
    'use strict';
    var ValidationUtils = (function() {
        function ValidationUtils($parse, $q, $translate, utils, bmUtil, notifications) {
            this.$parse = $parse;
            this.$q = $q;
            this.$translate = $translate;
            this.utils = utils;
            this.notifications = notifications;
            this.bmUtil = bmUtil;
        }
        ValidationUtils.prototype.processValidationErrors = function(data, response) {
            if(!this.utils.exists(response)) {
                throw new Error('bmValidationUtils: response is required.');
            }
            if(!this.utils.exists(response.error) || !this.utils.exists(response.error.errors) || !this.utils.exists(data)) {
                return;
            }
            for(var i = 0; i < response.error.errors.length; i++) {
                var error = response.error.errors[i];
                // following the JsonPath root object convention.

                var newLocationValue = null;
                var errorParentObject = data;

                if(error.location.indexOf('$.') === 0) {
                    newLocationValue = error.location.substring(2);
                    errorParentObject = this.bmUtil.getValueFromKey(data, newLocationValue);
                }
                if(!this.utils.exists(errorParentObject)) {
                    console.error('Provided error location did not match data. error[' + i + '].location: ' + error.location + ' data: ' + JSON.stringify(data));
                    continue;
                }
                this.setErrorForField(errorParentObject, error.locationField, error);
            }
        };

        ValidationUtils.prototype.getErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.getErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                var fieldError = data.$error[fieldName];
                if(this.utils.exists(fieldError)) {
                    return fieldError.message;
                }
            }
            return '';
        };
        ValidationUtils.prototype.setErrorForField = function (data, fieldName, error) {
            if (angular.isString(error)) {
                error = { message: error };
            }
            if(!this.utils.exists(data.$error)) {
                data.$error = {};
            }
            if(fieldName) {
                data.$error[fieldName] = error;
            } else {
                data.$error.$row = error;
            }
        };

        ValidationUtils.prototype.clearErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.clearErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                data.$error[fieldName] = undefined;
            }
        };

        ValidationUtils.prototype.clearErrors = function(request) {
            for(var field in request) {
                if(request.hasOwnProperty(field)) {
                    if(field === '$error') {
                        request[field] = undefined;
                    } else {
                        var val = request[field];
                        if(val !== null && typeof val === 'object') {
                            this.clearErrors(val);
                        }
                    }
                }
            }
        };

        ValidationUtils.prototype.processErrors = function(data, errorResult, suppressErrors) {
            var error = null;
            var showError = suppressErrors ? false : true;

            if(data === null && errorResult.status === -1) {
                // This occurs when the service is too slow
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.NoResponseError');
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;
            } else if(typeof errorResult === 'string') {
                // error is a plain string, assume that's the error to display?
                error = errorResult;
            } else if (this.utils.exists(errorResult) && this.utils.exists(errorResult.data) && this.utils.exists(errorResult.status) && this.utils.exists(errorResult.headers) && typeof errorResult.headers === 'function' && errorResult.status !== 401 && errorResult.status !== 403 && (errorResult.status < 500 || errorResult.status >= 600)) {
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;

                // it's probably an http error. Authorization related errors are handled
                // elsewhere, and result in a redirection, so we don't do anything here for those
                var headers = errorResult.headers();
                var contentType = headers['content-type'];
                contentType = contentType || headers['Content-Type'];
                contentType = contentType || headers['CONTENT-TYPE'];
                if(!this.utils.exists(contentType) || contentType.indexOf('application/json') < 0) {
                    error = errorResult.statusText;
                } else {
                    if(typeof errorResult.data === 'object') {
                        // it's an object, so for now assume it's a validation
                        // error and process it directly.
                        this.processValidationErrors(data, errorResult.data);
                        if(this.utils.exists(errorResult.data.error) && this.utils.exists(errorResult.data.error.message)) {
                            error = errorResult.data.error.message;
                        }
                    } else if(typeof errorResult.data === 'string') {
                        error = errorResult.data;
                    }
                }
            } else {
                showError = false;
            }
            if(!this.utils.stringIsNonBlank(error)) {
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError');
            }
            if(showError) {
                this.notifications.setError(error);
            }
        };

        ValidationUtils.prototype.errorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                return _this.getErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.clearErrorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                _this.clearErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.validatePromise = function(data, promise, suppressErrors) {
            var _this = this;
            return promise.then(function(value) {
                if(_this.utils.exists(data) && _this.utils.exists(value)) {
                    var rawData = data;
                    rawData.id = value.id;
                    rawData.created = value.created;
                    rawData.updated = value.updated;
                    rawData.deleted = value.deleted;
                }
                return value;
            }, function(error) {
                _this.processErrors(data, error, suppressErrors);
                return _this.$q.reject(error);
            });
        };
        ValidationUtils.$inject = ['$parse', '$q', '$translate', 'fef.Utils', 'bmUtil', 'bluemoon.components.Notifications'];
        return ValidationUtils;
    })();
    angular.module('bmValidationUtils', [
        'fef',
        'pascalprecht.translate',
        'bluemoon.components.Notifications',
        'bluemoon.components.util'
    ]).service('bmValidationUtils', ValidationUtils);
})();

(function() {
    'use strict';
    var HttpUtils = (function() {
        function HttpUtils($q, utils, bmValidationUtils) {
            this.$q = $q;
            this.utils = utils;
            this.bmValidationUtils = bmValidationUtils;
        }
        HttpUtils.prototype.getDataFromHttpResponse = function(response) {
            if(this.utils.exists(response)) {
                if(this.utils.exists(response.status) && response.status >= 400) {
                    return this.$q.reject(response);
                }
                if(this.utils.exists(response.data)) {
                    return response.data;
                } else {
                    return null;
                }
            }
            return null;
        };
        HttpUtils.prototype.unwrapHttpPromise = function(promise) {
            var _this = this;
            return promise.then(function(response) { return _this.getDataFromHttpResponse(response); });
        };
        HttpUtils.prototype.unwrapAndValidateHttpPromise = function(data, promise, suppressErrors) {
            return this.bmValidationUtils.validatePromise(data, this.unwrapHttpPromise(promise), suppressErrors);
        };
        HttpUtils.prototype.getStrippedObject = function(resource, prefix, suffix) {
            var _this = this;
            if(!this.utils.exists(resource) || typeof resource !== 'object') {
                return resource;
            }
            if(!this.utils.exists(prefix)) {
                prefix = '$';
            }
            if(!this.utils.exists(suffix)) {
                suffix = 'Expanded';
            }
            var _prefix = prefix.replace(/\$/g, '\\$');
            var _suffix = suffix.replace(/\$/g, '\\$');
            var copy = angular.copy(resource);
            var prefixRegex = new RegExp('^' + _prefix + '.+$', 'g');
            var suffixRegex = new RegExp('^.+' + _suffix + '$', 'g');
            Object.keys(resource).forEach(function(propertyName) {
                var property = resource[propertyName];
                var acopy = copy;
                if((angular.isString(propertyName) && _this.utils.stringIsNonBlank(_prefix) && propertyName.match(prefixRegex)) || (angular.isString(propertyName) && _this.utils.stringIsNonBlank(_suffix) && propertyName.match(suffixRegex))) {
                    delete acopy[propertyName];
                } else if(typeof property === 'object') {
                    acopy[propertyName] = _this.getStrippedObject(property, prefix, suffix);
                }
            });
            return copy;
        };
        HttpUtils.$inject = [
            '$q',
            'fef.Utils',
            'bmValidationUtils'
        ];
        return HttpUtils;
    })();
    angular.module('bmHttpUtils', [
        'fef',
        'bmValidationUtils'
    ]).service('bmHttpUtils', HttpUtils);
})();

(function(window, angular, Rx) {
    'use strict';

    var Alert = (function() {
        function AlertImpl(type, message) {
            if(type !== 'error' && type !== 'info' && type !== 'success') {
                throw new Error('bluemoon.components.Alert: error type must be either \'error\' or \'info\'.');
            }
            if(!angular.isString(message)) {
                throw new Error('bluemoon.components.Alert: error message must be a string');
            }
            this.type = type;
            this.message = message;
        }

        AlertImpl.isAlert = function(obj) {
            return typeof obj === 'undefined' || obj === null ||
                (angular.isObject(obj) &&
                angular.isString(obj.type) &&
                (obj.type === 'error' || obj.type === 'info' || obj.type === 'success') &&
                angular.isString(obj.message));
        };

        return AlertImpl;
    }());

    var Toast = (function() {
        function ToastImpl(message) {
            this.message = message;
        }

        ToastImpl.isToast = function(obj) {
            return angular.isObject(obj) && angular.isString(obj.message);
        };

        return ToastImpl;
    }());

    var Notifications = (function() {
        var _$inject = ['fef.SanityChecks', 'fef.Utils'];
        function NotificationsImpl(sanityChecks, utils) {
            /// <param name="sanityChecks" type="fef.SanityChecks" />
            /// <param name="utils" type="fef.Utils" />
            sanityChecks.checkConstructorUsage(this, NotificationsImpl);
            var self = this;

            /** @private */
            this._utils = utils;

            // I'm not using a caching subject here instead of a field pair,
            // because this is just a simple service.

            /** @private */
            this._alert = null;
            /** @private */
            this._alertStream = new Rx.Subject();
            this._alertStream.subscribe(function(alert) {
                self._alert = alert;
            });

            /** @private */
            this._toastStream = new Rx.Subject();
        }
        NotificationsImpl.$inject = _$inject;

        /**
         * Constructor function for an Alert.
         */
        NotificationsImpl.prototype.Alert = Alert;

        /**
         * Constructor function for a Toast.
         */
        NotificationsImpl.prototype.Toast = Toast;

        /**
         * Set the global alert. Replaces any existing message. Subscribers
         * to the error stream will be notified that the error message changed.
         * @param {Alert} alert The message to set, or null/undefined to clear the error.
         */
        NotificationsImpl.prototype.setAlert = function(alert) {
            if(!Alert.isAlert(alert)) {
                throw new Error('bluemoon.components.Notifications: alert object was badly formed.');
            }
            this._alertStream.onNext(angular.copy(alert));
        };

        /**
         * Set the global error alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} errorMessage The error message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setError = function(errorMessage) {
            if(this._utils.exists(errorMessage) && !angular.isString(errorMessage)) {
                throw new Error('Notifications.setError: errorMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(errorMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('error', errorMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} infoMessage The info message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setInfo = function(infoMessage) {
            if(this._utils.exists(infoMessage) && !angular.isString(infoMessage)) {
                throw new Error('Notifications.setInfo: infoMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(infoMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('info', infoMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error, info or success alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} successMessage The success message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setSuccess = function(successMessage) {
            if(this._utils.exists(successMessage) && !angular.isString(successMessage)) {
                throw new Error('Notifications.setSuccess: successMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(successMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('success', successMessage));
            }
        };

        /**
         * Gets the current alert.
         * @returns {Alert}
         */
        NotificationsImpl.prototype.getAlert = function() {
            return angular.copy(this._alert);
        };

        /**
         * Gets the event stream for changes to the error message.
         * @returns {Rx.Observable}
         * @example
         * var subscription = notifications.errorStream().subscribe(function(errorMessage) {
         *   alert('Error: ' + errorMessage);
         * });
         */
        NotificationsImpl.prototype.alertStream = function() {
            return this._alertStream.asObservable();
        };

        /**
         * An event stream of 'error' type alerts.
         * @returns {Rx.Observable} Observable of Alert objects.
         */
        NotificationsImpl.prototype.errorAlertStream = function() {
            var self = this;
            return self.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'error';
            });
        };

        /**
         * An event stream of 'info' type alerts.
         */
        NotificationsImpl.prototype.infoAlertStream = function() {
            var self = this;
            return this.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'info';
            });
        };

        /**
         * Add a new toast object to the list. Any subscribers to the toast
         * stream will be notified that a new toast was added.
         * @param {Object} toastObj The new toast object. TODO: define this interface?
         */
        NotificationsImpl.prototype.addToast = function(toastObj) {
            if(!Toast.isToast(toastObj)) {
                throw new Error('Notifications.addToast: toastObject was badly formed.');
            }
            this._toastStream.onNext(angular.copy(toastObj));
        };

        /**
         * Event stream representing new toasts as they are added.
         * @example
         * var subscription = notifications.toastStream().subscribe(function(toast) {
         *   alert('toast: ' + toast);
         * });
         */
        NotificationsImpl.prototype.toastStream = function() {
            return this._toastStream.asObservable();
        };

        return NotificationsImpl;
    }());

    angular.module('bluemoon.components.Notifications', ['fef']).service('bluemoon.components.Notifications',
        Notifications);

}(window, window.angular, window.Rx));

(function(angular) {
    'use strict';

    var httpStatusCodes = {
        'continue'                        : 100, // [RFC7231,Section6.2.1]
        'switchingProtocols'              : 101, // [RFC7231,Section6.2.2]
        'processing'                      : 102, // [RFC2518]
        'ok'                              : 200, // [RFC7231,Section6.3.1]
        'created'                         : 201, // [RFC7231,Section6.3.2]
        'accepted'                        : 202, // [RFC7231,Section6.3.3]
        'nonAuthoritativeInformation'     : 203, // [RFC7231,Section6.3.4]
        'noContent'                       : 204, // [RFC7231,Section6.3.5]
        'resetContent'                    : 205, // [RFC7231,Section6.3.6]
        'partialContent'                  : 206, // [RFC7233,Section4.1]
        'multiStatus'                     : 207, // [RFC4918]
        'alreadyReported'                 : 208, // [RFC5842]
        'imUsed'                          : 226, // [RFC3229]
        'multipleChoices'                 : 300, // [RFC7231,Section6.4.1]
        'movedPermanently'                : 301, // [RFC7231,Section6.4.2]
        'found'                           : 302, // [RFC7231,Section6.4.3]
        'seeOther'                        : 303, // [RFC7231,Section6.4.4]
        'notModified'                     : 304, // [RFC7232,Section4.1]
        'useProxy'                        : 305, // [RFC7231,Section6.4.5]
        'temporaryRedirect'               : 307, // [RFC7231,Section6.4.7]
        'permanentRedirect'               : 308, // [RFC7238]
        'badRequest'                      : 400, // [RFC7231,Section6.5.1]
        'unauthorized'                    : 401, // [RFC7235,Section3.1]
        'paymentRequired'                 : 402, // [RFC7231,Section6.5.2]
        'forbidden'                       : 403, // [RFC7231,Section6.5.3]
        'notFound'                        : 404, // [RFC7231,Section6.5.4]
        'methodNotAllowed'                : 405, // [RFC7231,Section6.5.5]
        'notAcceptable'                   : 406, // [RFC7231,Section6.5.6]
        'proxyAuthenticationRequired'     : 407, // [RFC7235,Section3.2]
        'requestTimeout'                  : 408, // [RFC7231,Section6.5.7]
        'conflict'                        : 409, // [RFC7231,Section6.5.8]
        'gone'                            : 410, // [RFC7231,Section6.5.9]
        'lengthRequired'                  : 411, // [RFC7231,Section6.5.10]
        'preconditionFailed'              : 412, // [RFC7232,Section4.2]
        'payloadTooLarge'                 : 413, // [RFC7231,Section6.5.11]
        'uriTooLong'                      : 414, // [RFC7231,Section6.5.12]
        'unsupportedMediaType'            : 415, // [RFC7231,Section6.5.13]
        'requestedRangeNotSatisfiable'    : 416, // [RFC7233,Section4.4]
        'expectationFailed'               : 417, // [RFC7231,Section6.5.14]
        'unprocessableEntity'             : 422, // [RFC4918]
        'locked'                          : 423, // [RFC4918]
        'failedDependency'                : 424, // [RFC4918]
        'upgradeRequired'                 : 426, // [RFC7231,Section6.5.15]
        'preconditionRequired'            : 428, // [RFC6585]
        'tooManyRequests'                 : 429, // [RFC6585]
        'requestHeaderFieldsTooLarge'     : 431, // [RFC6585]
        'internalServerError'             : 500, // [RFC7231,Section6.6.1]
        'notImplemented'                  : 501, // [RFC7231,Section6.6.2]
        'badGateway'                      : 502, // [RFC7231,Section6.6.3]
        'serviceUnavailable'              : 503, // [RFC7231,Section6.6.4]
        'gatewayTimeout'                  : 504, // [RFC7231,Section6.6.5]
        'httpVersionNotSupported'         : 505, // [RFC7231,Section6.6.6]
        'variantAlsoNegotiates'           : 506, // [RFC2295]
        'insufficientStorage'             : 507, // [RFC4918]
        'loopDetected'                    : 508, // [RFC5842]
        'notExtended'                     : 510, // [RFC2774]
        'networkAuthenticationRequired'   : 511  // [RFC6585]
    };
    angular.module('bluemoon.components.httpStatusCodes', [])
        .constant('bluemoon.components.httpStatusCodes', httpStatusCodes);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmHttpCache', [])
    .factory('bmHttpCacheHelper', bmHttpCacheHelper)
    .config(configInterceptor);

    /////////

    bmHttpCacheHelper.$inject = ['$cacheFactory'];

    // bmCache config value is time in milliseconds
    // clear cache, pass with value as 0 or less
    // can specifically call clear cache method
    function bmHttpCacheHelper($cacheFactory){
        var lookup = {};

        return {
            request: checkRequest,
            response: checkResponse,
            invalidateHttpCache: invalidateHttpCache
        };

        /////////

        function checkRequest(conf){
            // not setting the config cache property will result in a fresh request and the
            // response will not affect the value stored in cache. any subsequent requests that set
            // set the config cache property will receive what was stored in cache. consumers must
            // invalidate the cache as necessary in order to not receive stale data.

            // would conf really ever be undefined?
            if(!conf){
                return conf;
            }

            // only cache GET requests and those that specify bmCache
            // would method really ever be undefined?
            if((conf.method && conf.method.toUpperCase() !== 'GET') || angular.isUndefined(conf.bmCache)){
                return cleanRequestConfig(conf);
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(conf.url);

            // always opting in to store response in cache if bmCache is defined in http config
            conf.cache = true;

            // no response stored in cache yet so move on
            // the response will be stored in cache
            if(!cacheVal){
                return conf;
            }

            // do we have a stale cached value?
            var timeNow = Date.now();
            var cachedTime = lookup[conf.url];

            // difference between the time now and the cached time greater than the stale interval
            // or the stale interval is being reset specifically
            if(angular.isUndefined(cachedTime) ||  conf.bmCache <= 0 || ((timeNow - cachedTime) > conf.bmCache)){
                invalidateHttpCache(conf.url);
            }

            // the response will be stored in cache
            return conf;
        }

        function checkResponse(resp){
            // track the initial date/time of when response was put into cache
            // this is not a running cache timer
            if(resp && resp.config && resp.config.bmCache && !lookup[resp.config.url]){
                lookup[resp.config.url] = Date.now();
            }

            return resp;
        }

        // allow for invalidating cache brute force
        function invalidateHttpCache(url){
            if(!url){
                return;
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(url);

            // remove from http cache
            if(cacheVal){
                httpDefaultCache.remove(url);
            }

            // remove from hash lookup
            if(lookup[url]){
                delete lookup[url];
            }
        }

        function cleanRequestConfig(conf){
            if(conf && conf.bmCache){
                delete conf.bmCache;
            }

            return conf;
        }
    }

    ///////////

    configInterceptor.$inject = ['$httpProvider'];

    function configInterceptor($httpProvider){
        $httpProvider.interceptors.push('bmHttpCacheHelper');
    }
})(window.angular);

angular.module('bluemoon.components.templates', ['components/bm-image-upload-modal/bm-image-upload-modal.2js.html', 'components/bm-user-availability/bm-user-availability.2js.html', 'components/checkpoint-engage/checkpoint-engage.2js.html', 'components/client-notifications/client-notifications-list.2js.html', 'components/header/bm-staff-custom-header.2js.html', 'components/header/bm-staff-header.2js.html', 'components/header/documents-header-button.2js.html', 'components/header/header.2js.html', 'components/header/timer-header-button.2js.html', 'components/help/help.2js.html', 'components/i18n/language-select.2js.html', 'components/linked-accounts/linked-accounts-dialog.2js.html', 'components/linked-accounts/linked-accounts.2js.html', 'components/linking-merge/linking-merge-modal.2js.html', 'components/main/main.2js.html', 'components/modal/modal-base.2js.html', 'components/modal/modal-default.2js.html', 'components/multi-factor-user/multi-factor-user-settings.2js.html', 'components/multi-factor-user/multi-factor-user.2js.html', 'components/multi-factor/multi-factor-profile-modal.2js.html', 'components/multi-factor/multi-factor-profile.2js.html', 'components/nav/nav.2js.html', 'components/navigation-utils/confirm-navigation.2js.html', 'components/navigation-utils/save-in-progress-modal.2js.html', 'components/not-found/bm-staff-not-found.2js.html', 'components/password-validation/password-validation.2js.html', 'components/preview-trial-widget/preview-trial-widget.2js.html', 'components/privacy-policy/privacy-policy.2js.html', 'components/profile-photo-select/profile-photo-select.2js.html', 'components/session/cc-vnext-modal.2js.html', 'components/support-id/support-id.2js.html', 'components/terms-signatory/terms-signatory-modal.2js.html', 'components/view-portal-banner/view-portal-banner.2js.html', 'my-account/link-auth/link-auth-modal.2js.html', 'my-account/my-account-licensee.2js.html', 'my-account/my-account-skinny.2js.html', 'my-account/my-account.2js.html', 'security-questions/security-questions.2js.html', 'update-password/update-password.2js.html', 'user-profile/view-profile-modal.2js.html']);

angular.module("components/bm-image-upload-modal/bm-image-upload-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-image-upload-modal/bm-image-upload-modal.2js.html",
    "<div class=\"bento-modal bm-image-upload-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-closeButton\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\"><h2>{{vm.uploadTitleText}}</h2></div>\n" +
    "    <div class=\"modal-body bm-modal-body\">\n" +
    "        <!-- make it look like bento-alert -->\n" +
    "        <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "                <span>\n" +
    "                    {{alert.msg}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-class=\"{'bm-flex-row center-vertically' : vm.hasOptions}\">\n" +
    "            <div ng-class=\"{'col-md-8 col-sm-8 col-xs-8' : vm.hasOptions}\">\n" +
    "                <!-- progress indicator -->\n" +
    "                <div class=\"profile-progress\" ng-if=\"vm.progress !== 0\">\n" +
    "                    <span translate=\"bm.components.common.uploading\"></span>\n" +
    "                    <div class=\"bento-progressbar\">\n" +
    "                    <div uib-progressbar value=\"vm.progress\" animate=\"true\" type=\"vm.progressType\">{{vm.progress}}%</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- photo drop/select -->\n" +
    "                <div ng-if=\"!vm.selectedImageSrc && vm.progress === 0\">\n" +
    "                    <div ng-file-drop ng-file-select ng-model=\"vm.selectedFile\" class=\"drop-box align-center\" drag-over-class=\"drag-over\" ng-multiple=\"false\" allow-dir=\"true\" accept=\"'image/*'\" ng-accept=\"'image/*'\" ng-capture=\"'camera'\" ng-file-change=\"vm.fileOnChange($files, $event, $rejectedFiles)\">\n" +
    "                        <i class=\"glyphicon glyphicon-picture\"></i>\n" +
    "                        <div class=\"drop-box-text\">{{vm.dragImageText}}</div>\n" +
    "                        <div class=\"drop-box-text\">\n" +
    "                            - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                        </div>\n" +
    "                        <div class=\"drop-box-text\">\n" +
    "                            <button class=\"btn btn-default btn-dynamic btn-text-ellipsis\" tabindex=\"0\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-browseImageButton\">{{vm.uploadImageButtonText}}</button>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.currentImage && vm.deletable\" class=\"drop-box-text\">\n" +
    "                            - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.currentImage && vm.deletable\" class=\"align-center\">\n" +
    "                        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.delete()\">\n" +
    "                            {{vm.deleteImageButtonText}}\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- photo crop -->\n" +
    "                <div ng-if=\"vm.selectedImageSrc && vm.progress === 0\">\n" +
    "                    <div>\n" +
    "                        <span translate=\"bm.image.upload.cropPhotoInstructions\"></span> {{vm.saveImageButtonText}}.\n" +
    "                    </div>\n" +
    "                    <div class=\"crop-area\">\n" +
    "                        <ui-cropper\n" +
    "                            image=\"vm.selectedImageSrc\"\n" +
    "                            result-image=\"vm.croppedImage\"\n" +
    "                            area-type=\"{{ vm.cropShape }}\"\n" +
    "                            aspect-ratio=\"vm.aspectRatio\"\n" +
    "                            area-min-size=\"vm.areaMinSize\"\n" +
    "                            area-init-size=\"vm.areaInitSize\"\n" +
    "                            result-image-size=\"vm.resultImageSize\"></ui-cropper>\n" +
    "                    </div>\n" +
    "                    <div class=\"crop-area-text\">\n" +
    "                        <a ng-href=\"\" tabindex=\"0\" ng-click=\"vm.selectedImageSrc = undefined\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-uploadAnotherImageLink\">{{vm.uploadAnotherImageText}}</a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- photo location -->\n" +
    "            <div class=\"col-md-4 col-sm-4 col-xs-4\" ng-if=\"vm.hasOptions\">\n" +
    "                <div ng-if=\"vm.options.label\">\n" +
    "                    {{vm.options.label}}\n" +
    "                </div>\n" +
    "                <p>\n" +
    "                    <div ng-repeat=\"choice in vm.options.choices\">\n" +
    "                        <div class=\"option-choice\">\n" +
    "                            <input class=\"option-choice-checkbox\" type=\"checkbox\" name=\"{{choice}}\" value=\"{{choice}}\" ng-checked=\"$first\" ng-click=\"optionChoiceCheckboxClick($event)\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-{{choice}}\">\n" +
    "                            <label for=\"{{choice}}\">{{choice}}</label>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer clearfix\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.save()\" ng-disabled=\"!vm.selectedImageSrc\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-setImageButton\">\n" +
    "            {{vm.saveImageButtonText}}\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancel()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-cancelButton\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/bm-user-availability/bm-user-availability.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-user-availability/bm-user-availability.2js.html",
    "<div class=\"bm-availability clearfix\">\n" +
    "    <span class=\"dropdown bento-dropdown pull-left\" uib-dropdown>\n" +
    "      <button class=\"dropdown-toggle btn btn-default btn-icon\" uib-dropdown-toggle>\n" +
    "        <span class=\"bm-inline-dot bm-selected-dot\" ng-class=\"'bm-' + selectedDot + '-dot'\"></span>\n" +
    "        <span class=\"sr-only\" translate=\"bm.header.profileMenu.StatusSelectOptions\"></span>\n" +
    "        <i class=\"bento-icon-chevron-down\"></i>\n" +
    "      </button>\n" +
    "      <ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left bm-availability-dots clearfix\">\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Available' }}\" ng-click=\"changeStatus('Available','green')\">\n" +
    "                <div class=\"bm-dot bm-green-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.available}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Away' }}\" ng-click=\"changeStatus('Away','yellow')\">\n" +
    "                <div class=\"bm-dot bm-yellow-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.away}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Busy' }}\" ng-click=\"changeStatus('Busy','red')\">\n" +
    "                <div class=\"bm-dot bm-red-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.busy}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </span>\n" +
    "    <label for=\"bmAvailablity\" class=\"sr-only\" translate=\"bm.header.profileMenu.UserStatus\"></label>\n" +
    "    <input type=\"text\" name=\"bmAvailablity\" id=\"bmAvailablity\" ng-model=\"availabilityText\" ng-blur=\"changeStatusText()\" class=\"form-control bm-availability-text-box pull-left\" />\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/checkpoint-engage/checkpoint-engage.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/checkpoint-engage/checkpoint-engage.2js.html",
    "<form name=\"$ctrl.checkpointForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.checkpoint.header\"></h3>\n" +
    "  <!-- error display - make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"$ctrl.alerts.length > 0\">\n" +
    "    <div ng-repeat=\"alert in $ctrl.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "      <span>\n" +
    "        {{alert.msg}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <!-- creds not entered -->\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.uid.$error.required && $ctrl.checkpointForm.uid.$touched }\">\n" +
    "        <label for=\"uid\"><span translate=\"bm.header.checkpoint.userName\"></span> *</label>\n" +
    "        <input type=\"text\" class=\"form-control\" id=\"uid\" name=\"uid\" ng-model=\"$ctrl.userData.uid\" required maxlength=\"50\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.userNameRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.pwd.$error.required && $ctrl.checkpointForm.pwd.$touched }\">\n" +
    "        <label for=\"pwd\"><span translate=\"bm.header.viewProfile.password\"></span> *</label>\n" +
    "        <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" ng-model=\"$ctrl.userData.pwd\" required maxlength=\"50\" />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.passwordRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-10\">\n" +
    "      <label class=\"checkbox\">\n" +
    "        <input type=\"checkbox\" ng-model=\"$ctrl.userData.agree\" /> <span translate=\"bm.header.checkpoint.agreeLicense\"></span>\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-required bm-required-fields\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "  </div>\n" +
    "  <!-- creds already entered -->\n" +
    "  <div class=\"row bm-checkpoint-remove-text\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      {{$ctrl.removeText}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.saveUserData()\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.deleteUserData()\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\" translate=\"bm.components.common.remove\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.actions.cancelUserData()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/client-notifications/client-notifications-list.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/client-notifications/client-notifications-list.2js.html",
    "<div class=\"bm-ntfs-virt-list\" bm-flex-col>\n" +
    "    <p ng-if=\"hasZeroItems && !isLoading\" class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroNotifications\"></p>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" class=\"bm-ntfs-settings bm-animate-if\">\n" +
    "        <a ng-href=\"\" ng-click=\"markAllNotificationsRead()\" translate=\"bm.header.profileMenu.markAllNotificationsRead\"></a>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" id=\"bm-ntfs-vertical-container\" bm-flex-grow>\n" +
    "        <div ng-repeat=\"item in notifications\" class=\"bm-ntfs-repeated-item bm-animate-if\" ng-class=\"{'bm-last-notification': $last}\" bm-notifications-last-repeat-task bm-flex-row>\n" +
    "            <div class=\"bm-ntfs-indicator-col\" bm-flex-col>\n" +
    "                <div class=\"bm-ntfs-indicator-item\">\n" +
    "                    <i class=\"glyphicon glyphicon-info-sign\"></i>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-message-col\" bm-flex-col flex-grow>\n" +
    "                <div class=\"bm-ntfs-text\" ng-click=\"markNotificationRead(item,$event)\" ng-class=\"{'bm-ntfs-text-unread': item.unread}\">\n" +
    "                    <div ng-bind-html=\"item.onvioNotificationText\"></div>\n" +
    "                    <div class=\"bm-ntfs-date\">\n" +
    "                        {{ getFormattedTime(item.timestamp) }}\n" +
    "                        <a ng-href=\"\" class=\"bm-ntfs-mark\" ng-click=\"markNotificationRead(item,$event)\">\n" +
    "                            <span ng-if=\"item.unread\" translate=\"bm.header.profileMenu.markNotificationsRead\"></span>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-delete-col\" bm-flex-col>\n" +
    "                <div>\n" +
    "                    <a ng-href=\"\" ng-click=\"deleteNotification(item, $index)\"><i class=\"bento-icon-close-x\" uib-tooltip=\"{{deleteTranslated}}\" tooltip-placement=\"left\" tooltip-class=\"bm-ntfs-delete-tooltip\" tooltip-popup-delay=\"500\" aria-hidden=\"true\"></i></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/header/bm-staff-custom-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/bm-staff-custom-header.2js.html",
    "<bm-header class=\"custom-header\">\n" +
    "    <em data-translate=\"bm.staffHeader.brandName\"></em>\n" +
    "    <span data-translate=\"bm.staffHeader.productName\"></span>\n" +
    "    <bm-header-icon><ng-transclude ng-transclude-slot=\"icon\"></ng-transclude></bm-header-icon>\n" +
    "    <bm-header-profile><ng-transclude ng-transclude-slot=\"profile\"></ng-transclude></bm-header-profile>\n" +
    "</bm-header>\n" +
    "");
}]);

angular.module("components/header/bm-staff-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/bm-staff-header.2js.html",
    "<bm-header>\n" +
    "    <em data-translate=\"bm.staffHeader.brandName\"></em>\n" +
    "    <span data-translate=\"bm.staffHeader.productName\"></span>\n" +
    "</bm-header>\n" +
    "");
}]);

angular.module("components/header/documents-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/documents-header-button.2js.html",
    "<li bm-if-perm=\"OnvioDrive.Documents\">\n" +
    "    <a role=\"link\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Documents' | translate }}\" data-qe-id=\"bm-components-bmDocumentsHeaderButton\" ng-click=\"openDocuments()\"\n" +
    "        title=\"{{ 'Bluemoon.Shell.Navigation.Documents' | translate }}{{clientSpecificTitle}}\">\n" +
    "        <i class=\"bento-icon-file-room\"></i></a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/header/header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/header.2js.html",
    "<header ng-click=\"header.clearAppMenuActive()\" bm-flex-row>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-left-menu\" bm-flex-row>\n" +
    "        <li bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "            <a href role=\"link\" aria-label=\"{{ 'bm.header.appMenu.toggle' | translate }}\" id=\"bm-header-app-menu-toggle\" class=\"bm-header-app-menu-toggle\" title=\"{{ 'bm.header.appMenu.toggle' | translate }}\" ng-click=\"header.toggleAppMenuActive()\">\n" +
    "                <i class=\"bento-icon-hamburger-menu\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "    <!-- header image and text not required for huge? -->\n" +
    "    <div class=\"title_container\">\n" +
    "        <!-- <img ng-if=\"header.theme.header.headerImage\" ng-src=\"{{ header.theme.header.headerImage }}\"> -->\n" +
    "        <span ng-transclude></span> <!-- <span ng-bind=\"header.theme.header.headerLine1\"></span> -->\n" +
    "    </div>\n" +
    "    <!-- App specific menu items !-->\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-center-menu\" bm-flex-grow bm-flex-row>\n" +
    "        <!-- Preview / Trial mode message -->\n" +
    "        <li bm-if-perm-some=\"['Platform.Trial', 'Platform.PreviewMode']\">\n" +
    "            <preview-trial-widget></preview-trial-widget>\n" +
    "        </li>\n" +
    "        <!-- onvio messenger shortcut -->\n" +
    "        <li ng-if=\"header.showBRMessenger\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-onvioMessengerButton\" href=\"javascript:void(0)\" ng-click=\"header.openOnvioMessenger()\" title=\"{{ 'bm.header.shell.onvioMessengerBtn' | translate }}\" >\n" +
    "                <i class=\"bento-icon-bubble\"></i>\n" +
    "                <span ng-if=\"header.onvioMessengerUnreadNotificationsCount > 0\" class=\"badge bm-badge-active\">{{ header.onvioMessengerUnreadNotificationsCount }}</span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <!-- client dashboard icon -->\n" +
    "        <li ng-if=\"header.hasClientDashboard\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-clientDashboardButton\" role=\"link\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.ClientDashboard' | translate }}\" target=\"_blank\" href=\"/staff/#/client-dashboard{{header.clientSpecificUrl}}\" title=\"{{ 'Bluemoon.Shell.Navigation.ClientDashboard' | translate }}{{header.clientSpecificTitle}}\"><i class=\"bento-icon-vcard\"></i></a>\n" +
    "        </li>\n" +
    "        <li html-element-id=\"bm-header-timer-button\" bm-timer-header-button=\"header.isTimerDropdownOpen\" client-specific-title=\"header.clientSpecificTitle\"></li>\n" +
    "        <li bm-documents-header-button not-staff-client=\"header.notStaffClient\" client-specific-url=\"header.clientSpecificUrl\" client-specific-title=\"header.clientSpecificTitle\"></li>\n" +
    "    </ul>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-right-menu bm-header-right-menu-items\" bm-flex-row>\n" +
    "        <li ng-if=\"header.isEligibleForPendoGuidanceHub\" data-qe-id=\"{{ header.mfaQeId }}\">\n" +
    "            <a href=\"javascript:void(0)\" aria-label=\"{{ 'bm.header.pendo.resourceCenter' | translate}}\" title=\"{{ 'bm.header.pendo.resourceCenter' | translate}}\" data-qe-id=\"{{ header.pendoGuidanceHubDataQeId }}\">\n" +
    "                <i class=\"pendo-resource-center-icon\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-has-no-access=\"PlatformHideHelp\">\n" +
    "            <bm-help-dropdown is-dropdown-open=\"header.isHelpDropdownOpen\"></bm-help-dropdown>\n" +
    "        </li>\n" +
    "        <li class=\"new-notification-icon-container\" ng-if=\"header.enableNewNotificationPanelIAC === true\">\n" +
    "            <a role=\"link\" href=\"javascript:void(0)\" id=\"new-notification-icon-button\" data-qe-id=\"{{ header.newNotificationIconQeId }}\"\n" +
    "            aria-label=\"{{ 'bm.header.profileMenu.notifications' | translate }}\">\n" +
    "                <i class=\"new-notification-icon\"></i>\n" +
    "                <span class=\"badge new-notification-count\"></span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <!-- Begining of the linked accounts header -->\n" +
    "        <li id=\"bmLinkedAccountsDropdown\" ng-if=\"header.hasAccountSwitchingIAC && !header.hasNewDesignIAC \">\n" +
    "            <div ng-show=\"header.linkedAccountFound\">\n" +
    "            <!-- Dropdown Menu-->\n" +
    "            <div id=\"bmLinkedAccountsMenu\" uib-dropdown is-open=\"header.isLinkedAccountsDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "                <a ng-if=\"header.showLinkedAccountsMenu\" ng-disabled=\"header.disableLinkedAccountsMenu\" id=\"bm-header-linked-accounts-dropdown-toggle\" uib-dropdown-toggle>\n" +
    "                    <span class=\"bm-header-linked-accounts-dropdown\"\n" +
    "                        title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                    </span>\n" +
    "                    <i ng-if=\"header.showLinkedAccountsMenu\" class=\"bento-icon-caret-down\"></i>\n" +
    "                </a>\n" +
    "                <span ng-if=\"!header.showLinkedAccountsMenu\" class=\"bm-header-linked-accounts-dropdown bm-header-linked-account-span\"\n" +
    "                    title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                </span>\n" +
    "\n" +
    "                <!-- <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-linked-accounts\"> -->\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-linked-accounts\">\n" +
    "                    <li id=\"bmLinkedAccountDropdownMenuHeader\" class=\"dropdown-menu-section-heading-linked-accounts\"><span translate=\"bm.header.linkedAccounts.header\"></span>\n" +
    "                        <span style=\"float: right\"><a class=\"linked-accounts-manager-link\" ng-click=\"header.openManageLinkedAccountsDialog()\" translate=\"bm.header.viewProfile.linkedAccounts.manage\"></a></span>\n" +
    "                    </li>\n" +
    "                    <!-- <li class=\"divider\"></li> -->\n" +
    "                    <li ng-repeat=\"linkedAccount in header.linkedAccounts\">\n" +
    "                        <div class=\"divider\"></div>\n" +
    "                        <div class=\"dropdown-menu-item-linked-accounts\" ng-click=\"header.switchAccount(linkedAccount.linkedAccountId)\"\n" +
    "                            title=\"{{linkedAccount.displayedName}}&#013{{linkedAccount.companyName}}\">\n" +
    "                            <div id=\"linkedAccountAccountName\" class=\"bm-menu-linked-accounts-item\">{{linkedAccount.displayedName}}</div>\n" +
    "                            <div class=\"bm-menu-linked-accounts-item\">{{linkedAccount.companyName}}</div>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <!-- End of linked accounts header -->\n" +
    "        <li ng-if=\"header.enableNewNotificationPanelIAC === true\" class=\"new-header-menu\" ng-transclude=\"icon\" uib-dropdown>\n" +
    "            <a href id=\"bm-header-profile-dropdown-toggle\" uib-dropdown-toggle title=\"{{ 'bm.header.userMenu.toggle' | translate }}\">\n" +
    "                <i class=\"bento-icon-user\" ng-if=\"!header.user.photo && !header.user.initials\"></i>\n" +
    "                <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"true\"></bm-profile-photo-select>\n" +
    "            </a>\n" +
    "\n" +
    "            <ul class=\"dropdown-menu header-custom-dropdown\" uib-dropdown-menu>\n" +
    "                <li role=\"menuitem\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-view-profile\" id=\"bm-header-profile-menu-viewLink\" ng-click=\"header.openProfileModal()\" translate=\"bm.header.profileMenu.viewProfile\"></a>\n" +
    "                </li>\n" +
    "                <li role=\"menuitem\" bm-if-perm=\"OnvioSetup.UserPreferences\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-user-preferences\" ng-if=\"header.hasPrefs\" ng-click=\"header.showUserPreferences()\" id=\"bm-header-profile-menu-viewPreferences\"\n" +
    "                    translate=\"bm.userPreferences\"></a>\n" +
    "                </li>\n" +
    "                <li class=\"divider menu-divider\"></li>\n" +
    "                \n" +
    "                <li role=\"menuitem\">\n" +
    "                    <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"false\" is-new-menu=\"true\"></bm-profile-photo-select>\n" +
    "                </li>\n" +
    "                \n" +
    "                <li role=\"menuitem\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-sign-out\" id=\"bm-header-signout-link\" ng-click=\"header.signOut()\" translate=\"bm.header.userMenu.signOut\"></a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "          \n" +
    "        <li ng-if=\"header.enableNewNotificationPanelIAC === false\" ng-transclude=\"icon\" ng-click=\"header.toggleProfileMenuActive()\">\n" +
    "            <a href id=\"bm-header-profile-dropdown-toggle\" title=\"{{ 'bm.header.userMenu.toggle' | translate }}\">\n" +
    "                <i class=\"bento-icon-user\" ng-if=\"!header.user.photo && !header.user.initials\"></i>\n" +
    "                <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"true\"></bm-profile-photo-select>\n" +
    "                <span ng-if=\"header.totalUnreadCount > 0\" class=\"badge bm-header-profile-badge\">{{header.totalUnreadCount}}</span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</header>\n" +
    "<div id=\"bm-header-app-menu\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive }\">\n" +
    "    <header>\n" +
    "        <h2 translate=\"bm.header.appsMenu.title\"></h2>\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearAppMenuActive()\" id=\"bm-header-menu-close-btn\"  aria-label=\"{{'bm.header.appMenu.CloseMenuBtn' | translate }}\">\n" +
    "            <span class=\"sr-only\" translate=\"bm.header.appMenu.CloseMenuBtn\"></span>\n" +
    "            <i class=\"bento-icon-close-x bm-header-menu-close-btn-icon\"></i>\n" +
    "        </button>\n" +
    "    </header>\n" +
    "    <ul>\n" +
    "        <li bm-if-perm-some=\"['Applications.K1Analyzer', 'UltraTaxCS.UTPLicense']\">\n" +
    "            <div class=\"bm-header-section-title\">\n" +
    "                <span translate=\"bm.header.appsMenu.OnvioApplications\" bm-flex-grow></span>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRPayroll\">\n" +
    "            <a href=\"/br-payroll\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brPayroll | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brPayroll\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BREscrita\">\n" +
    "            <a href=\"/br-escrita-fiscal\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brTax | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brTax\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRAccounting\">\n" +
    "            <a href=\"/br-accounting\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brAccounting | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brAccounting\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRProcess\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.GesttaProcess}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.gesttaprocess' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.gesttaprocess\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"!header.allClientsNewPortalDoClienteIAC && ((header.hasNewPortalDoClienteIAC && !header.hasNewPortalDoClienteFRP) ||\n" +
    "		!header.hasNewPortalDoClienteIAC)\">\n" +
    "            <a bm-if-perm=\"Applications.BRAtendimento\" href=\"/atendimento/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.atendimentoProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.atendimentoProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "		<li ng-if=\"header.allClientsNewPortalDoClienteIAC || (header.hasNewPortalDoClienteIAC && header.hasNewPortalDoClienteFRP)\">\n" +
    "			<a bm-if-perm=\"Applications.BRAtendimento\" href=\"/br-portal-do-cliente/\" data-qe-id=\"br-portal-do-cliente-menu-item\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.atendimentoProductName' | translate }}\">\n" +
    "				<span translate=\"bm.header.appsMenu.atendimentoProductName\" bm-flex-grow></span>\n" +
    "				<i class=\"bento-icon-newtab\"></i>\n" +
    "			</a>\n" +
    "		</li>\n" +
    "        <li ng-if=\"header.hasMessengerIAC\">\n" +
    "            <a href=\"/br-messenger/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.messengerProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.messengerProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Onvio\">\n" +
    "            <a id=\"bm-header-apps-staff-link\" href=\"/staff/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.staffProductNameCenter' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.staffProductNameCenter\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioClientHub\">\n" +
    "            <a ng-if=\"!(header.hasCCVNextIAC || header.hasCCVNextFRP)\" id=\"bm-header-apps-client-link\" href=\"/client/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a ng-if=\"header.hasCCVNextIAC || header.hasCCVNextFRP\" href=\"/clientcenter/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USAdvisoryTools\">\n" +
    "            <a href=\"/advisory/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.advisoryToolsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.advisoryToolsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USFixedAssets\">\n" +
    "            <a href=\"/fixedassets/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.fixedAssetsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.fixedAssetsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.autaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.autaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CATax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/staff/#/setup/core/projects?orderBy=projectNumber%20desc\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.cataxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.cataxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/staff/#/setup/core/projects?orderBy=projectNumber%20desc\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.uktaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.uktaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ustaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ustaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CATaxDashboard\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTaxDashboard', 'Applications.USTaxDashboard', 'Applications.UKTaxDashboard']\" href=\"/catax/hub/#/dashboard\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.caTaxDashboardProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.caTaxDashboardProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTaxDashboard', 'Applications.USTaxDashboard', 'Applications.UKTaxDashboard']\" href=\"/catax/hub/#/dashboard\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.taxDashboardProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.taxDashboardProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.MyPayOnboarding\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/staff\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayOnboardingProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayOnboardingProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKSecretarial\">\n" +
    "            <a href=\"/secretarial/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukSecretarialProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukSecretarialProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKCompanyFormations\">\n" +
    "            <a href=\"/formations/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukCompanyFormationsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukCompanyFormationsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.GTPT\">\n" +
    "            <a href=\"/gptp/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.gtptSeed' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.gtptSeed\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"MyPayOnboarding.ReferringAccountant\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/accountant\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayReferringAcct' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayReferringAcct\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm-some=\"['Applications.TrialBalance','Applications.CheckpointEngage']\">\n" +
    "            <!-- show trial balance if user has both -->\n" +
    "            <a bm-if-perm=\"Applications.TrialBalance\" href=\"/trialbalance/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.TrialBalance' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.TrialBalance\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <!-- otherwise, show checkpoint -->\n" +
    "            <a bm-if-not-perm=\"Applications.TrialBalance\" href=\"/checkpoint/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.checkpointEngageProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.checkpointEngageProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-VAT\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-VAT']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-VAT' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-VAT\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Payroll\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Payroll']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Payroll' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Payroll\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Accounting\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Accounting']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Accounting' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Accounting\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-FixedAssets\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-FixedAssets']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-FixedAssets' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-FixedAssets\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Integra\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.Integra}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.Integra' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.Integra\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CheckpointAR\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.CheckpointAR}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.CheckpointAR' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.CheckpointAR\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARTaxAmnesty\">\n" +
    "            <a href=\"/amnesty/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arTaxAmnestyProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arTaxAmnestyProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARGrossIncomeTax\">\n" +
    "            <a href=\"/ar-gross-income-tax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arGrossIncomeTaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arGrossIncomeTaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARInvestmentAccounts\">\n" +
    "            <a href=\"/arinvestmentaccountsapplication/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arInvestmentAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arInvestmentAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Accounts\">\n" +
    "            <a href=\"/accounts/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKVAT\">\n" +
    "            <a href=\"/ukvat/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukVat' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukVat\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRBoxE\">\n" +
    "            <a href=\"/boxe/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.brBoxE' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.brBoxE\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUActivityStatements\">\n" +
    "            <a href=\"/auactivitystatements/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.activityStatements | translate }}\">\n" +
    "                <span translate=\"bm.header.appMenu.activityStatements\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioBRSupport\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.OnvioBRSupport}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.OnvioBRSupport' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.OnvioBRSupport\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARIncomeTax\">\n" +
    "            <a href=\"/ar-tax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.arIncomeTax | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arIncomeTax\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CLEcomex\">\n" +
    "            <a href=\"/cl-ecomex\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.ecomex | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ecomex\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.PEEcomex\">\n" +
    "            <a href=\"/pe-ecomex\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.ecomex | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ecomex\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ConfirmationAV\">\n" +
    "            <a href=\"/confirmationav\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.confirmationassetverification | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.confirmationassetverification\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm-some=\"['Applications.K1Analyzer', 'UltraTaxCS.UTPLicense']\">\n" +
    "            <div class=\"bm-header-section-title\">\n" +
    "                <span translate=\"bm.header.appsMenu.OtherApplications\" bm-flex-grow></span>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.K1Analyzer\">\n" +
    "            <a target=\"_blank\" ng-click=\"header.launchK1Analyzer($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.K1Analyzer' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.K1Analyzer\" bm-flex-grow></span>\n" +
    "                <div id=\"k1analyzer\" bento-busy-loader=\"header.isLoaderBusy\" bento-busy-loader-size=\"small\">\n" +
    "                    <i class=\"bento-icon-newtab\" ng-class=\"{'bm-visibility-hidden': header.isLoaderBusy}\"></i>\n" +
    "                </div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <ng-container bm-if-has-no-access=\"CoreDisableEfileDashboardWidget\">\n" +
    "            <li bmp-if-firm-permission=\"UltraTaxCS.UTPLicense\">\n" +
    "                <a target=\"_blank\" ng-click=\"header.launchUltraTaxEfileUrl($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.UltraETax' | translate }}\">\n" +
    "                    <span translate=\"bm.header.appsMenu.UltraETax\" bm-flex-grow></span>\n" +
    "                    <div id=\"ultraETax\" bento-busy-loader=\"header.isLoaderBusy\" bento-busy-loader-size=\"small\">\n" +
    "                        <i class=\"bento-icon-newtab\" ng-class=\"{'bm-visibility-hidden': header.isLoaderBusy}\"></i>\n" +
    "                    </div>\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ng-container>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<div id=\"bm-header-profile-menu\" ng-transclude=\"profile\" bm-flex-col ng-class=\"{ 'bm-header-profile-menu-active': header.profileMenuActive }\">\n" +
    "    <header class=\"clearfix\">\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearProfileMenuActive()\" aria-label=\"{{'bm.header.profileMenu.CloseProfileMenuBtn' | translate}}\">\n" +
    "            <span class=\"sr-only\" translate=\"bm.header.profileMenu.CloseProfileMenuBtn\"></span>\n" +
    "            <i class=\"bento-icon-close-x bm-header-menu-close-btn-icon\"></i>\n" +
    "        </button>\n" +
    "        <h2 id=\"bm-header-profile-menu-userName\" ng-bind=\"header.user.fullName\"></h2>\n" +
    "        <p id=\"bm-header-profile-menu-email\" ng-bind=\"header.user.email\" title=\"{{ 'bm.header.profileMenu.emailTooltip' | translate }}\"></p>\n" +
    "        <a href ng-if=\"header.enableNewNotificationPanelIAC === false\" id=\"bm-header-profile-menu-viewLink\" ng-click=\"header.openProfileModal()\" translate=\"bm.header.profileMenu.viewProfile\"></a>\n" +
    "        <div bm-if-perm=\"OnvioSetup.UserPreferences\">\n" +
    "            <a href ng-if=\"header.hasPrefs && header.enableNewNotificationPanelIAC === false\" ng-click=\"header.showUserPreferences()\" id=\"bm-header-profile-menu-viewPreferences\"\n" +
    "                translate=\"bm.userPreferences\"></a>\n" +
    "        </div>\n" +
    "        <div bento-alert bento-alert-object=\"alerts\"></div>\n" +
    "        <bm-profile-photo-select image=\"header.user.photo\" shape=\"circle\" ng-click=\"header.clearProfileMenuActive()\"></bm-profile-photo-select>\n" +
    "        <button role=\"button\" id=\"bm-header-signout-link\" class=\"btn btn-primary\" ng-click=\"header.signOut()\" translate=\"bm.header.userMenu.signOut\"></button>\n" +
    "    </header>\n" +
    "    <div bm-if-not-perm=\"USTax.PlatformEA\" id=\"bm-header-profile-menu-setAvail\" class=\"clearfix\">\n" +
    "        <bm-user-availability></bm-user-availability>\n" +
    "    </div>\n" +
    "    <uib-tabset id=\"bm-header-profile-menu-tabs\" class=\"tabs-top\" bm-flex-grow bm-flex-col>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.notifications\"></span><span ng-if=\"header.unreadNotificationsCount > 0\" class=\"badge\">{{ header.unreadNotificationsCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <bm-client-notifications-list></bm-client-notifications-list>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.messages\"></span><span ng-if=\"header.unreadMessagesCount > 0\" class=\"badge\">{{ header.unreadMessagesCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <p class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroMessages\"></p>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "<div class=\"bm-header-modal-mask\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive, 'bm-header-profile-menu-active': header.profileMenuActive }\" ng-click=\"header.clearMenuActive()\"></div>\n" +
    "");
}]);

angular.module("components/header/timer-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/timer-header-button.2js.html",
    "<li bm-if-perm=\"TimeAndBilling.TimeAndExpense\" ng-show=\"vm.timerDirectiveLoaded\">\n" +
    "    <span uib-dropdown auto-close=\"disabled\" is-open=\"vm.isTimerDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-center bm-header-dropdown\">\n" +
    "        <a data-qe-id=\"bm-components-bmTimerHeaderButton\" role=\"link\" aria-label=\"{{ 'bm.header.timers.toggle' | translate }}\" href uib-dropdown-toggle title=\"{{ 'bm.header.timers.toggle' | translate }}{{vm.clientSpecificTitle}}\"><i class=\"bento-icon-stopwatch\"></i><span class=\"badge\" ng-class=\"{ 'bm-badge-active': vm.badge.active}\">{{vm.badge.number}}</span><span class=\"bm-header-menu-item-text\" translate=\"bm.header.timers.toggle\"></span></a>\n" +
    "        <div class=\"dropdown-menu dropdown-menu-center bm-timer-center\">\n" +
    "            <time-and-expense-timer id=\"bm-header-timer-control\" time-and-expense-timer-is-dropdown-open=\"vm.isTimerDropdownOpen\", time-and-expense-timer-badge=\"vm.badge\"/>\n" +
    "        </div>\n" +
    "    </span>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/help/help.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/help/help.2js.html",
    "<span id=\"bm-header-help-dropdown\" uib-dropdown is-open=\"help.isHelpDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "    <a id=\"bm-header-help-dropdown-toggle\" role=\"link\" aria-label=\"{{ 'bm.header.helpMenu.toggle' | translate }}\" href uib-dropdown-toggle title=\"{{ 'bm.header.helpMenu.toggle' | translate }}\" data-qe-id=\"bm-components-bmhelpdropdown-onvio-center-main-menu-onvio-help\">\n" +
    "        <i class=\"bento-icon-question\"></i>\n" +
    "        <span class=\"bm-header-menu-item-text\" translate=\"bm.header.helpMenu.toggle\"></span>\n" +
    "    </a>\n" +
    "    <ul class=\"dropdown-menu\" ng-controller=\"HelpCtrl\"\n" +
    "        ng-class=\"{'dropdown-menu-right': !useMenuLeft, 'dropdown-menu-left': useMenuLeft}\">\n" +
    "        <!-- Search field -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon\" ng-click=\"helpSearch()\">\n" +
    "                    <span class=\"glyphicon glyphicon-search\"></span>\n" +
    "                </span>\n" +
    "                <label class=\"sr-only\" for=\"bm-header-help-search\" translate=\"bm.header.helpMenu.searchLabel\"></label>\n" +
    "                <input bento-reset type=\"text\" id=\"bm-header-help-search\" class=\"form-control\" placeholder=\"{{ searchInput.placeholderTxt }}\" ng-model=\"searchInput.text\" ng-keypress=\"searchKeyPress($event)\">\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li class=\"divider\"></li>\n" +
    "        <!-- Suggested Topics -->\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.topicsHeading\"></li>\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" ng-repeat=\"menu in help.topics\">\n" +
    "            <a ng-href=\"{{ formatTopicUrl(help, menu.url) }}\" target=\"_blank\">{{menu.title}}</a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" class=\"divider\"></li>\n" +
    "        <!-- Additional assistance -->\n" +
    "        <li class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.assistanceHeading\"></li>\n" +
    "        <li ng-if=\"currentCountry === 'AR'\" >\n" +
    "            <a ng-href=\"{{ arHelpAndTrainingLink }}\" target=\"_blank\" rel=”noreferrer noopener” translate=\"bm.header.helpMenu.arHelpAndTrainingLink\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"help && help.howToUrl && currentCountry !== 'AR'\" >\n" +
    "            <a ng-href=\"{{ howToLink() }}\" target=\"_blank\" translate=\"bm.header.helpMenu.siteLinkText\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{alertsAndNoticesLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.alertsAndNotices\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{videoLibraryLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.videoLibrary\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{contactSupportLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.contactSupport\"></a>\n" +
    "        </li>\n" +
    "        <!-- <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{communityLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.community\"></a>\n" +
    "        </li> -->\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{ideaIncubatorLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.ideaIncubator\"></a>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- privacy policy -->\n" +
    "        <li>\n" +
    "            <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "        </li>\n" +
    "        <!-- support id -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <bm-support-id-link aria-hidden=\"true\"></bm-support-id-link>\n" +
    "        </li>\n" +
    "        <li ng-if=\"currentCountry === 'AR'\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-ar-service-request\" ng-href=\"javascript:void(0)\" translate=\"bm.header.helpMenu.arServiceRequest\" ng-click=\"openEstudioOneSupport()\"></a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</span>\n" +
    "");
}]);

angular.module("components/i18n/language-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/i18n/language-select.2js.html",
    "<div bento-select>\n" +
    "    <select\n" +
    "        id=\"{{ name }}\"\n" +
    "        name=\"{{ name }}\"\n" +
    "        class=\"form-control\"\n" +
    "        ng-model=\"selectedLanguage\"\n" +
    "        ng-change=\"selectionChanged()\"\n" +
    "        ng-required=\"required\"\n" +
    "        ng-options=\"language.translatedDescription for language in languageList track by language.code\"\n" +
    "        ng-disabled=\"disabled\">\n" +
    "        <option value=\"\" ng-if=\"showEmpty\"></option>\n" +
    "    </select>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/linked-accounts/linked-accounts-dialog.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts-dialog.2js.html",
    "<div>\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeDialog()\">\n" +
    "    	<i class=\"bento-icon-close-x\"></i>\n" +
    "  	</button>\n" +
    "	<bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "</div>");
}]);

angular.module("components/linked-accounts/linked-accounts.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts.2js.html",
    "<div>\n" +
    "<form id=\"linkedAccountsForm\" name=\"vm.linkedAccountsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "	<div id=\"formView\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "	<h3 class=\"bm-modal-title\" translate=\"bm.header.linkedAccounts.header\"></h3>\n" +
    "	<!-- Alerts -->\n" +
    "	<div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "		<div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success' : alert.type === 'success', 'alert-warning' : alert.type === 'warning', 'alert-info' : alert.type === 'info', 'alert-danger' : alert.type === 'danger'}\">\n" +
    "			<span>\n" +
    "				{{alert.msg}}\n" +
    "			</span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <button id=\"bmcAddAccountButton\" ng-click=\"vm.openMergeLinkingAccountDialog()\">\n" +
    "            <i id=\"bmcAddAccountIcon\" class=\"bento-icon-add\"></i> <label id=\"bmcAddAccount\" translate=\"bm.linkedAccounts.add\"></label>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "\n" +
    "	<div id=\"linkedAccountsMainView\" ng-if=\"vm.user\">\n" +
    "		<div class=\"row\">\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\">\n" +
    "					<label bm-if-has-access=\"Platform_DisableAuth0Phase2\"><span translate=\"bm.components.linkedAccounts.emailAddressMsg\"></span>&nbsp;<span id=\"userEmail\">{{vm.user.email}}</span></label>\n" +
    "                    <label bm-if-has-no-access=\"Platform_DisableAuth0Phase2\"><span translate=\"bm.components.linkedAccounts.emailAddressMsgAuth0\"></span>&nbsp;<span id=\"userEmail\">{{vm.user.email}}</span></label>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\" id=\"noLinkedAccountsRow\" ng-if=\"vm.showAccounts == false\">\n" +
    "			<span translate=\"bm.components.linkedAccounts.noAccounts\"></span>\n" +
    "		</div>\n" +
    "		<!-- Flexgrid -->\n" +
    "		<div class=\"row\" id=\"linkedAccountsRow\" ng-if=\"vm.showAccounts\">\n" +
    "			<wj-flex-grid\n" +
    "				control=\"vm.flexgrid\"\n" +
    "				items-source=\"vm.gridData\"\n" +
    "				items-source-changed=\"refreshGrid(this.flexgrid)\"\n" +
    "				class=\"bmLinkedAccountsFlexgrid\">\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.active' | translate}}\" binding=\"active\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\"></wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.home' | translate}}\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<input type=\"radio\" ng-change=\"vm.defaultChanged()\" ng-model=\"vm.selectedDefaultLinkAccountId\" value=\"{{$item.linkedAccountId}}\">\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedaccounts.accountName' | translate}}\" binding=\"accountName\" is-read-only=\"true\"> </wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"175\" max-width=\"175\" header=\"{{'bm.components.linkedAccounts.nickname' | translate}}\" binding=\"displayedNickname\" is-read-only=\"false\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<div class=\"columnDisplayedNickname\">\n" +
    "							<div class=\"bmLinkedAccountsNickname\">\n" +
    "								<span id=\"accountName\" ng-if=\"$item.displayedNickname === ''\" translate=\"bm.components.linkedaccounts.accountName\"></span>\n" +
    "								<span ng-if=\"$item.displayedNickname !== ''\">{{$item.displayedNickname}}</span>\n" +
    "							</div>\n" +
    "							<div clase=\"bmLinkedAccountsEdit\">\n" +
    "								<span class=\"bento-icon-edit grid-action-item\"\n" +
    "									ng-click=\"\"\n" +
    "									data-tooltip-placement=\"top\"\n" +
    "									data-tooltip-trigger=\"mouseenter\"\n" +
    "									data-uib-tooltip=\"{{'bm.components.linkedAccounts.edit' | translate}}\"\n" +
    "									data-tooltip-append-to-body=\"true\">\n" +
    "								</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedAccounts.firm' | translate}}\" binding=\"companyName\" is-read-only=\"true\"></wj-flex-grid-column>\n" +
    "			</wj-flex-grid>\n" +
    "		</div>\n" +
    "		<!-- End of grid -->\n" +
    "		<div class=\"row\"><p>\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\" id=\"linkedAccountDetail\">\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.activeAccount\"></span>\n" +
    "					</label>\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.homeAccount\"></span>\n" +
    "					</label>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</p></div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveLinkedAccounts()\" ng-show=\"vm.user && (vm.linkedAccounts.length > 0)\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "		<button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelLinkedAccounts()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "	</div>\n" +
    "</form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/linking-merge/linking-merge-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linking-merge/linking-merge-modal.2js.html",
    "<form name=\"vm.linkingAccountForm\" role=\"form\" class=\"css-form was-validated\">\n" +
    "    <div class=\"bento-modal bm-profile\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeAddAccount()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\" translate=\"bm.linkingAccountMerge.title\"></div>\n" +
    "        <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success' : alert.type === 'success', 'alert-warning' : alert.type === 'warning', 'alert-info' : alert.type === 'info', 'alert-danger' : alert.type === 'danger'}\">\n" +
    "                <span>\n" +
    "                    {{alert.msg}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body bm-modal-body\">\n" +
    "            <div class=\"form-group\">\n" +
    "                <label><span translate=\"bm.linkingAccountMerge.info\"></span><br><strong><span id=\"userEmail\">{{vm.user.email}}</span></strong></label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\"><span translate=\"bm.linkingMerge.email\"></span> *</label>\n" +
    "                <input type=\"input\" class=\"form-control\"  placeholder=\"name@domain.com\" id=\"email\" name=\"email\" ng-model = \"vm.linkingAccount.uid\" required maxlength=\"250\" />\n" +
    "                <div class=\"msg\" translate=\"bm.linkingAccountForm.emailRequired\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"pwd\"><span translate=\"bm.header.viewProfile.password\"></span> *</label>\n" +
    "                <input type=\"password\"  class=\"form-control\" id=\"pwd\" name=\"pwd\" ng-model = \"vm.linkingAccount.pwd\" required maxlength=\"200\" />\n" +
    "                <div class=\"msg invalid-feedback\" translate=\"bm.header.checkpoint.passwordRequired\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.addLinkingAccount()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "            <button type=\"button\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.closeAddAccount()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/main/main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/main/main.2js.html",
    "<main ng-transclude></main>\n" +
    "");
}]);

angular.module("components/modal/modal-base.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-base.2js.html",
    "<button ng-if=\"showClose\" type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div ng-include=\"templateUrl\"></div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button ng-repeat=\"button in buttons\" ng-class=\"[ 'btn', (!!button.primary ? 'btn-primary' : 'btn-default') ]\" ng-click=\"(button.dismiss === true ? $dismiss(button.value) : $close(button.value))\">{{button.text}}</button>\n" +
    "</div>");
}]);

angular.module("components/modal/modal-default.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-default.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{vars.title}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        {{vars.body}}\n" +
    "	</p>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user-settings.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user-settings.2js.html",
    "<div id=\"mfaUserSettingsDiv\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\">\n" +
    "		<span translate=\"bm.components.mfa.user.name\"></span>\n" +
    "	</div>	\n" +
    "	<div class=\"modal-body\">\n" +
    "		<div id=\"mfaModalBody\">\n" +
    "			<!-- <div id=\"busyLoading\"  ng-show=\"vm.isLoading\"> -->\n" +
    "			<div id=\"busyLoading\" ng-show=\"vm.busyLoading\">\n" +
    "				<p><span translate=\"bm.components.common.loading\"></span>...</p>\n" +
    "			</div>\n" +
    "			<div id=\"noDevice\"  ng-show=\"(!vm.busyLoading) && (vm.registeredFactors.length == 0)\">\n" +
    "				<p><span translate=\"bm.components.mfa.user.nodevice\"></span>.</p>\n" +
    "			</div>\n" +
    "			<div id=\"hasDevice\" ng-show=\"vm.registeredFactors.length > 0\">\n" +
    "				<div><p>\n" +
    "					<span translate=\"bm.components.mfa.user.device\"></span>: \n" +
    "					<div id=\"userDevice\">{{vm.userDevice}}</div>\n" +
    "				</p></div>\n" +
    "				<div>\n" +
    "					<p translate=\"bm.components.mfa.user.lostphone\"></p>\n" +
    "					<!-- Lost phone or don't have access to the Thomson Reuters Authetication app? -->\n" +
    "					<!-- Generate a temporary, 24-hour numerical code -->\n" +
    "					<p translate=\"bm.components.mfa.user.invalidate\"></p>\n" +
    "					<!-- for use in place of the app. Generating a code for this user will invalidate any previously-generated codes that you created for their account -->\n" +
    "				</div>\n" +
    "				<button class=\"btn btn-primary\" ng-click=\"vm.generateAccessCode()\" translate=\"bm.components.mfa.user.generate\"></button>\n" +
    "				<div ng-if=\"vm.authCode\" id=\"temporaryAccessCodeDiv\">\n" +
    "					<span translate=\"bm.components.mfa.user.tempcode\"></span>:<span id=\"temporaryAccessCodeLBL\">{{vm.authCode}}</span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button class=\"btn btn-primary\" ng-click=\"vm.close()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user.2js.html",
    "<div id=\"mfaUserDiv\" ng-show=\"vm.isMfaAvailable\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">			\n" +
    "			<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">\n" +
    "			<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-default\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\"></button>			\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "<!-- \n" +
    "	<div>\n" +
    "		<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-primary\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\">	\n" +
    "		</button>\n" +
    "		<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "	</div>\n" +
    " -->	\n" +
    "</div>");
}]);

angular.module("components/multi-factor/multi-factor-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile-modal.2js.html",
    "<form name=\"vm.confirmDeviceForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body\">\n" +
    "      <p translate=\"bm.header.viewProfile.mfaConfirmRemove\" ng-if=\"vm.modalAction === 'remove'\"></p>\n" +
    "      <p translate=\"bm.components.header.viewProfile.mfaConfirmAdd\" ng-if=\"vm.modalAction === 'add'\"></p>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <div class=\"form-group\" ng-class=\"{'has-error' : vm.confirmDeviceForm.userPassword.$invalid && ((vm.confirmDeviceForm.userPassword.$touched && vm.confirmDeviceForm.userPassword.$dirty) || vm.confirmDeviceForm.$submitted)}\">\n" +
    "            <label for=\"userPassword\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "            <input class=\"form-control\" type=\"password\" id=\"userPassword\" name=\"userPassword\" ng-model=\"vm.user.password\" bm-focus=\"true\" required />\n" +
    "            <div class=\"msg\" ng-messages=\"vm.confirmDeviceForm.userPassword.$error\" ng-if=\"vm.confirmDeviceForm.userPassword.$touched || vm.confirmDeviceForm.$submitted\">\n" +
    "              <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "          </div>\n" +
    "          </div>\n" +
    "          * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.confirmDevice()\" translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></button>\n" +
    "      <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancelDevice()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/multi-factor/multi-factor-profile.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile.2js.html",
    "<div class=\"bm-mfa-profile\">\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"bm.header.viewProfile.multifactorTitle\"></h3>\n" +
    "    <div class=\"row bm-lg-top-margin\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <span ng-if=\"$ctrl.required\" translate=\"bm.header.viewProfile.mfaRequired\"></span>\n" +
    "          <span ng-if=\"!$ctrl.required\" translate=\"bm.header.viewProfile.mfaOptional\"></span>\n" +
    "          <!-- TODO: NEED THE CORRECT LINK HERE FOR MFA HELP -->\n" +
    "          <a role=\"button\" class=\"btn btn-link btn-icon\" target=\"_blank\" ng-href=\"{{$ctrl.helpLink || '/ua/help/' + $ctrl.helpLangCode + '/staff/core/common/mfa-overview.htm'}}\">\n" +
    "            <span class=\"btn-icon-text\" translate=\"bm.header.viewProfile.mfaLearnMore\"></span>\n" +
    "            <i class=\"bento-icon-arrow-forward\"></i>\n" +
    "          </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaOptions.header\"></h4>\n" +
    "        <div translate=\"bm.header.viewProfile.mfaOptions.description\" ng-if=\"$ctrl.mutliFactorComplete\"></div>\n" +
    "        <div class=\"device-container\">\n" +
    "          <div translate=\"bm.header.viewProfile.mfaAccountNotPaired\" ng-if=\"!$ctrl.mutliFactorComplete\"></div>\n" +
    "          <div ng-repeat=\"factor in $ctrl.devices\">\n" +
    "              <span>{{factor.name}}</span>\n" +
    "              <a role=\"button\" class=\"btn btn-link btn-icon\" ng-click=\"$ctrl.actions.openConfirmModal('remove', factor)\" ng-if=\"!$ctrl.required || $ctrl.required && $ctrl.devices.length > 1\">\n" +
    "                <i class=\"bento-icon-remove\"></i>\n" +
    "              </a>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <a role=\"button\" class=\"add-link\" ng-href=\"\" ng-click=\"$ctrl.actions.openConfirmModal('add')\" translate=\"bm.header.viewProfile.mfaAddOption\"></a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\" ng-if=\"$ctrl.mutliFactorComplete\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaEmergencyCodes.header\"></h4>\n" +
    "        <p translate=\"bm.header.viewProfile.mfaEmergencyCodes.desc\"></p>\n" +
    "        <button type=\"button\" class=\"btn btn-default\" translate=\"bm.header.viewProfile.mfaEmergencyCodes.generate\" ng-click=\"$ctrl.actions.openConfirmModal('generate')\"></button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  ");
}]);

angular.module("components/nav/nav.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/nav/nav.2js.html",
    "<nav class=\"navmore-flex\" ng-transclude></nav>\n" +
    "");
}]);

angular.module("components/navigation-utils/confirm-navigation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/confirm-navigation.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.Title' | translate}}\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <!-- TODO: These strings should be under FEF namespace -->\n" +
    "	<button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"save()\">{{'Bluemoon.Components.Common.Actions.Save' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"ok()\">{{'Bluemoon.Components.Common.Actions.DoNotSave' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"cancel()\">{{'Bluemoon.Components.Common.Actions.Cancel' | translate}}</button>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("components/navigation-utils/save-in-progress-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/save-in-progress-modal.2js.html",
    "<div class=\"modal-header\">\n" +
    "    <h3>{{'Bluemoon.Components.SaveInProgressModal.Title' | translate}}</h3>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "    <p>{{'Bluemoon.Components.SaveInProgressModal.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/not-found/bm-staff-not-found.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/not-found/bm-staff-not-found.2js.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row\">\n" +
    "        <h4 data-translate=\"Bluemoon.Components.Staff.NotFound.MainText\"></h4><br/>\n" +
    "        <a class=\"btn btn-primary\" href=\"/staff/#/\" data-translate=\"Bluemoon.Components.Staff.NotFound.GoToDashboard\"></a>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/password-validation/password-validation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/password-validation/password-validation.2js.html",
    "<div class=\"bm-password-validation\">\n" +
    "    <span translate>bm.password.validation.mustHaveStart</span> <span class=\"{{rules.characterLengthRule.test(password) ? 'passing' : 'failing-required'}}\" translate=\"bm.password.validation.characterRule\" translate-value-val=\"{{charLengthReq}}\"></span> <span translate=\"bm.password.validation.mustHaveEnd\" translate-value-val=\"{{charClassReq}}\"></span>\n" +
    "    <ul>\n" +
    "        <div ng-repeat=\"rule in rules.characterTypeRules\">\n" +
    "            <li class=\"{{ rule.test(password) ? 'passing' : 'failing-optional' }}\">{{ rule.label }}</li>\n" +
    "        </div>\n" +
    "    </ul>\n" +
    "    <p/>\n" +
    "    <span translate>bm.password.validation.excludeTitle</span>\n" +
    "    <ul>\n" +
    "        <li translate>bm.password.validation.excludeWords</li>\n" +
    "        <li translate>bm.password.validation.excludeUserId</li>\n" +
    "        <li translate>bm.password.validation.excludeSequential</li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/preview-trial-widget/preview-trial-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/preview-trial-widget/preview-trial-widget.2js.html",
    "<div id=\"previewTrialWidget\" class=\"previewMode\" ng-if=\"vm.preview\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.previewMode.intro\"></span> <span class=\"orange\" translate=\"bm.header.previewTrial.previewMode.preview\"></span> <span translate=\"bm.header.previewTrial.previewMode.mode\"></span></p>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div id=\"previewTrialWidget\" class=\"trialMode\" ng-if=\"vm.trial\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.trialMode.intro\"></span> {{vm.days}} <span translate=\"bm.header.previewTrial.trialMode.days\"></span></p>\n" +
    "		<a role=\"button\" class=\"btn\" ng-href=\"{{vm.modeButtonLink}}\" translate=\"bm.header.previewTrial.trialMode.button\"></a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/privacy-policy/privacy-policy.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/privacy-policy/privacy-policy.2js.html",
    "<a href=\"{{$ctrl.privacyUri}}\" target=\"_blank\" translate=\"bm.components.privacyPolicy\"></a>\n" +
    "");
}]);

angular.module("components/profile-photo-select/profile-photo-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/profile-photo-select/profile-photo-select.2js.html",
    "<div ng-class=\"{ 'menu-for-new-profile': vm.isNewMenu }\">\n" +
    "    <div class=\"bm-profile-photo\" ng-class=\"{ 'img-circle' : vm.shape === 'circle', 'lg-photo' : vm.size === 'large', 'sm-photo' : vm.size === 'small' }\" ng-if=\"!vm.isNewMenu\">\n" +
    "        <span class=\"initials\" ng-if=\"!vm.selectEnabled && vm.initials && !vm.image\">{{ vm.initials }}</span>\n" +
    "        <div class=\"silhouette\" ng-style=\"vm.selectedStyle\" ng-if=\"!vm.selectEnabled && vm.image\"></div>\n" +
    "        <a class=\"select-profile\" data-qe-id=\"bm-components-bmHeader-change-photo\" href=\"\" ng-click=\"vm.openPhotoModal()\" ng-if=\"vm.selectEnabled\">\n" +
    "            <div class=\"silhouette\" ng-style=\"vm.selectedStyle\"></div>\n" +
    "            <span class=\"silhouette-change\" translate=\"bm.header.accountDialog.addProfileImage\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- For new profile menu, we need only text -->\n" +
    "    <a class=\"select-profile\" data-qe-id=\"bm-components-bmHeader-change-photo\" href=\"\" ng-click=\"vm.openPhotoModal()\" ng-if=\"vm.isNewMenu && vm.selectEnabled\">\n" +
    "        <div class=\"silhouette\" ng-style=\"vm.selectedStyle\"></div>\n" +
    "        <span class=\"silhouette-change\" translate=\"bm.header.accountDialog.addProfileImage\"></span>\n" +
    "    </a>\n" +
    "\n" +
    "    <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "</div>");
}]);

angular.module("components/session/cc-vnext-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/session/cc-vnext-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "	Client Preview Unavailable for Beta Users\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        We are still developing the client preview for the beta version of\n" +
    "        Client Center. We will notify you as we release new features so that\n" +
    "        you can give us your valuable feedback.<br/><br/>\n" +
    "\n" +
    "        If you need to view your client’s portal, close this message,\n" +
    "        change the Client Center Version switch to \"Current\" above the\n" +
    "        client's Client Center Access toggle, save your changes, and then click\n" +
    "        preview again. You won’t lose any data if you switch.\n" +
    "	</p>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"$close()\">Ok</button>\n" +
    "</div>");
}]);

angular.module("components/support-id/support-id.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/support-id/support-id.2js.html",
    "<div ng-show=\"$ctrl.enabled\">\n" +
    "    <a ng-click=\"$ctrl.showId=!$ctrl.showId\" href=\"\" target=\"_blank\" translate=\"bm.components.supportId\"></a>\n" +
    "\n" +
    "    <div ng-show=\"$ctrl.showId\" class=\"support-id-display input-group\">\n" +
    "        <span class=\"input-group-addon\" ng-click=\"$ctrl.copyToClip();\">\n" +
    "            <span class=\"glyphicon glyphicon-copy\"></span>\n" +
    "        </span>\n" +
    "        <input id=\"support-id-text\" type=\"text\" placeholder=\"loading\" ng-model=\"$ctrl.supportId\" readonly>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/terms-signatory/terms-signatory-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/terms-signatory/terms-signatory-modal.2js.html",
    "<div class=\"bento-modal bm-terms-signatory\">\n" +
    "    <div class=\"modal-header\" translate>\n" +
    "        bm.terms.signatory.title\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"bm-signatory-view\" ng-bind-html=\"vm.displayText\"></div>\n" +
    "        <span class=\"bm-signatory-instructions\" translate>\n" +
    "            bm.terms.signatory.instructions\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.setAgreement(true)\" translate>\n" +
    "            bm.terms.signatory.agree\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.setAgreement(false)\" translate>\n" +
    "            bm.terms.signatory.disagree\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/view-portal-banner/view-portal-banner.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/view-portal-banner/view-portal-banner.2js.html",
    "<header ng-class=\"{ 'unresolved-theme': banner.unresolvedTheme }\">\n" +
    "    <div id=\"view-portal-banner-left-side\">\n" +
    "        <span translate=\"bm.viewPortalBanner.viewingMsg\"></span><span> {{ banner.uname }}</span>\n" +
    "    </div>\n" +
    "    <div id=\"view-portal-banner-right-side\">\n" +
    "        <button class=\"btn btn-default\" translate=\"bm.viewPortalBanner.doneBtn\" ng-click=\"banner.exitViewPortalMode()\"></button>\n" +
    "    </div>\n" +
    "</header>\n" +
    "");
}]);

angular.module("my-account/link-auth/link-auth-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/link-auth/link-auth-modal.2js.html",
    "<form name=\"vm.verifyLoginForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "    <h3 class=\"modal-header\" translate=\"BM.Components.EmailInUseHeader\"></h3>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p translate=\"BM.Components.AccountLinkDescription\"></p>\n" +
    "        <!-- Commenting out for now, but may be needed for later -->\n" +
    "        <!-- <a translate=\"BM.Components.TRID\"></a> -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-8\">\n" +
    "                <div class=\"form-group\" ng-class=\"{'has-error' : vm.verifyLogin.pwd.$invalid && ((vm.verifyLogin.pwd.$touched && vm.verifyLogin.pwd.$dirty) || vm.verifyLogin.$submitted)}\">\n" +
    "                    <label for=\"pwd\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "                    <input class=\"form-control\" type=\"password\" id=\"pwd\" name=\"pwd\" ng-model=\"vm.pwd\" bm-focus=\"true\" required />\n" +
    "                    <div class=\"msg\" ng-messages=\"vm.verifyLogin.pwd.$error\" ng-if=\"vm.verifyLogin.pwd.$touched || vm.verifyLogin.$submitted\">\n" +
    "                        <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.linkAccounts()\" translate=\"Bluemoon.Components.Common.Actions.LinkAccounts\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.changeEmail()\" translate=\"Bluemoon.Components.Common.Actions.ChangeEmail\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "\n" +
    "");
}]);

angular.module("my-account/my-account-licensee.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-licensee.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- show a banner that looks like an alert -->\n" +
    "  <div ng-if=\"vm.user\" class=\"bento-alert-container bm-profile-btm-margin\">\n" +
    "    <div class=\"alert bento-alert alert-info\" role=\"alert\" translate=\"bm.header.viewProfile.licenseeBanner\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row bm-profile-btm-margin\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <span translate=\"bm.header.viewProfile.nameLabel\"></span>: {{ vm.localUser.fullName }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "      * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account-skinny.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-skinny.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-maxlength=\"250\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.firstName.$error.required || vm.myAccountForm.firstName.$error.maxlength) && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required ng-maxlength=\"100\" />\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\" bm-if-has-no-access=\"BR_HideProfileMiddleName\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.lastName.$error.required || vm.myAccountForm.lastName.$error.maxlength) && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" ng-maxlength=\"100\" required />\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" bento-toolbar class=\"navbar navbar-default bento-toolbar bento-custom-toolbar-refresh-button\"\n" +
    "     toolbar-data=\"vm.toolbarButtons\">\n" +
    "  </div>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- Error -->\n" +
    "  <!-- make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"!vm.showTerms && vm.alerts.length > 0\">\n" +
    "      <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "          <span>\n" +
    "              {{alert.msg}}\n" +
    "          </span>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "  <div class=\"bm-animate-if\" ng-if=\"vm.showTerms\">\n" +
    "    <h3 translate=\"bm.terms.signatory.title\"></h3>\n" +
    "    <div class=\"bm-terms-signatory\">\n" +
    "      <div class=\"bm-signatory-view\" ng-bind-html=\"vm.termsDisplayText\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user && !vm.showTerms\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <div>\n" +
    "              <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' ng-maxlength=\"250\" bm-validate-email required>\n" +
    "          </div>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-8 col-md-6\">\n" +
    "            <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span></label>\n" +
    "            <p>{{vm.localUser.email}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    <!-- name -->\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.firstName.$error.required || vm.myAccountForm.firstName.$error.maxlength) && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required ng-maxlength=\"100\"/>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\" bm-if-has-no-access=\"BR_HideProfileMiddleName\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.lastName.$error.required || vm.myAccountForm.lastName.$error.maxlength) && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" required ng-maxlength=\"100\"/>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-8 col-md-6\">\n" +
    "            <label for=\"userId\"><span translate=\"bm.header.viewProfile.nameLabel\"></span></label>\n" +
    "            <p>{{vm.localUser.firstName + ' ' + vm.localUser.lastName}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    <!-- language -->\n" +
    "    <div class=\"row\" ng-if=\"vm.languageList.length > 1\">\n" +
    "      <div class=\"col-sm-8 col-md-4\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.myAccountForm.language.$dirty && vm.myAccountForm.language.$invalid }\">\n" +
    "            <label for=\"language\"><span translate=\"bm.header.accountDialog.languageLabel\"></span> *</label>\n" +
    "            <bm-language-select name=\"language\" selected-language-code=\"vm.localUser.language\" include-empty-option=\"false\" selection-required=\"true\" on-change=\"vm.languageChanged(language)\"></bm-language-select>\n" +
    "            <div class=\"msg\" translate=\"bm.header.accountDialog.languageRequiredError\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <button ng-if=\"vm.isVisibleLanguageUpdateButton()\" type=\"submit\" class=\"btn btn-primary bm-animate-if bm-update-button-account-info\" ng-click=\"vm.updateLanguageCIAM()\" translate=\"Bluemoon.Components.Common.Actions.Update\"></button>\n" +
    "    </div>\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <p bm-if-has-no-access=\"Platform_DisableAuth0Phase2\"><span translate=\"BM.Components.AccountInformation.ManageAccountLabel\"></span></p>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button ng-if=\"vm.isVisibleSaveButton()\" type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" type=\"link\" class=\"btn btn-primary bm-animate-if\"><a translate=\"Bluemoon.Components.Common.Actions.Manage\" href=\"{{vm.auth0ProfileUrl}}\" target=\"_blank\"></a><i class=\"bento-icon-arrow-forward\"></i></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" ng-if=\"!vm.showTerms\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=true\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && !vm.showTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=false\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && vm.showTerms\" translate=\"bm.header.accountDialog.hideTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" href=\"{{vm.termsLink}}\" target=\"_blank\" ng-if=\"vm.showStaffTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("security-questions/security-questions.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("security-questions/security-questions.2js.html",
    "<form name=\"vm.securityQuestionsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.SecurityQuestions.Header\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.questions.length > 0\">\n" +
    "      <div ng-repeat=\"question in vm.questions\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.questionError !== ''}\">\n" +
    "              <label for=\"question{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.QuestionTag\"></span> {{ $index + 1 }} *</label>\n" +
    "              <div bento-select>\n" +
    "                <select\n" +
    "                  name=\"question{{ $index + 1 }}\"\n" +
    "                  id=\"question{{ $index + 1 }}\"\n" +
    "                  ng-model=\"question.selectedQuestion\"\n" +
    "                  ng-options=\"masterQuestion.question for masterQuestion in question.masterList track by masterQuestion.questionId\"\n" +
    "                  ng-change=\"vm.processQuestionSelect($index, question)\"\n" +
    "                  class=\"form-control\">\n" +
    "                  <option value=\"\"></option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "              <div class=\"msg\">{{ question.questionError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.answerError !== '', 'bm-form-group-pair': ($index + 1) !== vm.questions.length }\">\n" +
    "              <label for=\"answer{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.AnswerTag\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"answer{{ $index + 1 }}\" name=\"answer{{ $index + 1 }}\" ng-model=\"question.answer\" ng-blur=\"vm.validateAnswer(question, false)\" ng-focus=\"vm.clearDefaultAnswer(question)\" />\n" +
    "              <div class=\"msg\">{{ question.answerError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.questions.length > 0\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.saveQuestions()\" ng-if=\"vm.questions.length > 0\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelQuestions()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("update-password/update-password.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("update-password/update-password.2js.html",
    "<form name=\"vm.updatePasswordForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.UpdatePassword\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.updatePasswordForm.currentPassword.$error.required && vm.updatePasswordForm.currentPassword.hasVisited }\">\n" +
    "                <label for=\"currentPassword\"><span translate=\"BM.Components.UpdatePassword.CurrentPassword\"></span> *</label>\n" +
    "                <a href class=\"pull-right no-underline\" ng-click=\"vm.showPassword = !vm.showPassword\">\n" +
    "                 <span ng-if=\"vm.showPassword == true\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Hide\">\n" +
    "                    </span>\n" +
    "                </span>\n" +
    "                <span ng-if =\"vm.showPassword == false || vm.showPassword == undefined\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Show\">\n" +
    "                    </span>\n" +
    "                </span></a>\n" +
    "                <input class=\"form-control\" id=\"currentPassword\" name=\"currentPassword\" bm-focus=\"true\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.currentPassword\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\" translate=\"BM.Components.UpdatePassword.CurrentPassword.Instructions\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.newPasswordError !== ''}\">\n" +
    "                <label for=\"newPassword\" ><span translate=\"BM.Components.UpdatePassword.NewPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"newPassword\" name=\"newPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.newPassword\" ng-blur=\"vm.validatePasswordFields(false)\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\">{{ vm.newPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.newPasswordError === '' && vm.passwordIsValidated\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordAcceptable\"></span>\n" +
    "                </div>\n" +
    "                <div bm-password-validation password=\"vm.newPassword\" ng-show=\"vm.updatePasswordForm.newPassword.hasFocus\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.isConfirmPasswordInvalid()}\">\n" +
    "                 <label for=\"confirmPassword\"><span translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.confirmPassword\" ng-blur=\"vm.setConfirmPasswordOutOfFocus()\" ng-focus=\"vm.setConfirmPasswordInFocus()\" maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\">{{ vm.confirmPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.isConfirmPasswordValid() && vm.newPasswordError === ''\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordConfirmed\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.savePassword()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelPassword()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("user-profile/view-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("user-profile/view-profile-modal.2js.html",
    "<div class=\"bento-modal bm-profile\">\n" +
    "  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeProfile()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\" translate=\"bm.header.userMenu.toggle\"></div>\n" +
    "  <div class=\"modal-body bm-modal-body\">\n" +
    "    <uib-tabset class=\"tabs-left bm-tab-animation\">\n" +
    "      <!-- account information -->\n" +
    "      <uib-tab data-qe-id=\"bm-profile-acct-tab\" deselect=\"vm.tabDeselect('account')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.account\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedAccount\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-my-account-info languages=\"vm.languages\" user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-my-account-info>\n" +
    "      </uib-tab>\n" +
    "      <!-- change password -->\n" +
    "      <uib-tab bm-if-has-access=\"Platform_DisableAuth0Phase2\" data-qe-id=\"bm-profile-chgpwd-tab\" deselect=\"vm.tabDeselect('password')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.password\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedPassword\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-update-password user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-update-password>\n" +
    "      </uib-tab>\n" +
    "      <!-- linked accounts -->\n" +
    "      <uib-tab data-qe-id=\"bm-profile-linked-accts-tab\" select=\"vm.tabSelect('linkedAccounts')\" deselect=\"vm.tabDeselect('linkedAccounts')\" bm-if-has-access=\"PPE-AccountSwitching\">\n" +
    "        <uib-tab-heading>\n" +
    "            <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "              <span translate=\"bm.header.viewProfile.linkedAccounts\"></span>\n" +
    "              <i class=\"bento-icon-warning bm-multi-tab-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedLinkedAccounts\"></i>\n" +
    "            </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "      </uib-tab>\n" +
    "      <!-- multifactor authentication -->\n" +
    "      <uib-tab bm-if-has-access=\"Platform_DisableAuth0Phase2\" data-qe-id=\"bm-profile-mfa-tab\" deselect=\"vm.tabDeselect('multi')\" bm-if-has-access=\"Platform_Enable2FA\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.multifactorTitle\"></span>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-multifactor-profile user-data=\"vm.user\"></bm-multifactor-profile>\n" +
    "      </uib-tab>\n" +
    "      <!-- checkpoint engage credentials -->\n" +
    "      <uib-tab bm-if-perm=\"Applications.CheckpointEngage\" data-qe-id=\"bm-profile-ce-creds-tab\" deselect=\"vm.tabDeselect('checkpoint')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "            <span translate=\"bm.header.viewProfile.checkPointCredentials\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedCheckpoint\"></i>\n" +
    "          </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-checkpoint-credentials shared-data=\"vm.sharedProfile\"></bm-checkpoint-credentials>\n" +
    "      </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

/**
 * Blue Moon Components - App Directive
 */

// Global bluemoon-components-app
var bmcomponents;

(function(angular){
    'use strict';

    bmcomponents = angular.module('bluemoon.components.app', [
        'matchmedia-ng',
        'bluemoon.components.session',
        'bmUser'
    ])
        // PROD perf boost (missing fn in 1.2.25)
        // .config(['$compileProvider', function ($compileProvider) {
        //     var isNotProd = !/^onvio/.test(location.hostname);
        //     $compileProvider.debugInfoEnabled(isNotProd);
        // }])
        .directive('bmApp', bmApp);

    // guid used for replace in build process
    bmcomponents.version = '32.2.5';

    bmApp.$inject = ['$document', '$log', 'matchmedia', 'AuthenticatedSession', 'bmUser'];

    function bmApp($document, $log, matchmedia, authenticatedSession, bmUser) {

        return {
            restrict: 'EA',
            controller: [function() {}],
            link: function (scope, element, attrs) {
                var html = $document.find('html');

                if (attrs.bmApp !== 'pre-auth') {
                    /* load intrinsic post-auth objects */
                    authenticatedSession.load().then(function(data) {
                        $log.log('session:', { meta: data.meta, bindings: data.bindings });
                    }).finally(function() {
                        html.addClass('bm-resolved');
                    });
                    bmUser.load();
                }

                /* Mobile first cumulative media classes */

                /* Large devices (large desktops, 1200px and up) */
                var offMatchLg = matchmedia.on('(min-width: 1200px)', function(mql){
                    html.toggleClass('media-screen-lg-min', mql.matches);
                });
                /* Medium devices (desktops, 992px and up) */
                var offMatchMd = matchmedia.on('(min-width: 992px)', function(mql){
                    html.toggleClass('media-screen-md-min', mql.matches);
                });
                /* Small devices (tablets, 768px and up) */
                var offMatchSm = matchmedia.on('(min-width: 768px)', function(mql){
                    html.toggleClass('media-screen-sm-min', mql.matches);
                });
                /* XSmall default (phones, 0px and up) */
                var offMatchXs = matchmedia.on('(min-width: 0px)', function(mql){
                    html.toggleClass('media-screen-xs-min', mql.matches);
                });

                // cleanup
                element.on('$destroy', function () {
                    offMatchXs();
                    offMatchSm();
                    offMatchMd();
                    offMatchLg();
                });
            }
        };
    }

})(window.angular);

/**
 * Blue Moon Components - Header Directive
 */
(function(angular){
    'use strict';

    function bmHeader($window, $document, $rootScope, bmUtil, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/header.2js.html',
            scope: {
                notStaffClient: '<?'
            },
            transclude: {
                'profile': '?bmHeaderProfile',
                'icon': '?bmHeaderIcon',
            },
            require: '^bmApp',
            controller: bmHeaderCtrl,
            controllerAs: 'header',

            link: function (scope, element, attrs) {
                var html = angular.element($document[0].documentElement);
                var appLinkList = element[0].querySelector('#bm-header-app-menu ul');
                var appMenu = element[0].querySelector('#bm-header-app-menu');
                var profileMenu = element[0].querySelector('#bm-header-profile-menu');

                if (angular.isDefined(attrs.hidemenus)) {
                    scope.header.hideMenus = true;
                }

                // get app menu links after they render,
                // and disable the link that is the current app
                authenticatedSessionData.getBindings().then(function () {
                    setTimeout(function () {
                        var appLinks = appLinkList.querySelectorAll('a');
                        [].forEach.call(appLinks, function(link) {
                            if (link.href && location.href.indexOf(link.href) === 0) {
                                //jshint scripturl:true
                                link.href = 'javascript:void(0)';
                                link.target = '';
                                link.classList.add('selected');
                                return false;
                            }
                        });
                    }, 0);
                });

                scope.header.toggleLeftMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('left-menu-mask-active', force);
                };

                scope.header.toggleRightMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('right-menu-mask-active', force);
                };

                function windowResized() {
                    var applyNeeded = false;

                    if (scope.header.isAppsDropdownOpen ||
                        scope.header.isMsgsDropdownOpen ||
                        scope.header.isHelpDropdownOpen ||
                        scope.header.isTimerDropdownOpen ||
                        scope.header.isUserDropdownOpen ||
                        scope.header.isLinkedAccountsDropdownOpen) {

                        scope.header.closeDropDowns();
                        applyNeeded = true;
                    }

                    if (applyNeeded) {
                        scope.$apply();
                    }
                }

                // perform window resize actions
                $window.addEventListener('resize', windowResized, false);

                var offLocationChangeStart = $rootScope.$on('$locationChangeStart', bmUtil.debounce(scope.header.clearMenuActive, 500));

                var offLocationChangeSuccess = $rootScope.$on('$locationChangeSuccess', bmUtil.debounce(scope.header.updateCustomizedLinks, 500));

                var offLoadSuccess = $rootScope.$on('$viewContentLoaded', bmUtil.debounce(scope.header.updateCustomizedLinks, 500));

                // listeners
                var rmProfPhotoSelectedEvtListener = scope.$on('bmProfilePhotoSelected', scope.header.user.save);

                // authenticatedSessionData.getBindings().then(function(data) {
                //     theme.loadHeader(data.ApplicationConfiguration.CompanyId);
                // });

                // to remove menus from DOM for assistive technologies not to list them
                // and exclude them from page focus flow when menus are closed
                scope.header.updateDisplayState([appMenu, profileMenu], false)();
                var offMenuOpen = $rootScope.$on('bmAppMenuOpened', scope.header.updateDisplayState([appMenu], true));
                var offProfileMenuOpen = $rootScope.$on('bmProfileMenuOpened', scope.header.updateDisplayState([profileMenu], true));
                var offMenuClose = $rootScope.$on('bmAppClosedDropdowns', scope.header.updateDisplayState([appMenu, profileMenu], false));

                // cleanup
                element.on('$destroy', function () {
                    $window.removeEventListener('resize', windowResized, false);
                    offLocationChangeStart();
                    offLocationChangeSuccess();
                    offLoadSuccess();
                    rmProfPhotoSelectedEvtListener();
                    offMenuOpen();
                    offProfileMenuOpen();
                    offMenuClose();
                });
            }
        };
    }

    function bmHeaderCtrl(
        $window,
        $log,
        $rootScope,
        $q,
        $timeout,
        $uibModal,
        $location,
        $translate,
        $scope,
        authenticatedSession,
        bmUser,
        theme,
        myAccountService,
        bmAccess,
        bmPermission,
        bmLicense,
        bmModal,
        bmJobQueue,
        notificationsManager,
        bmTokenStorage,
        bmAnalyticsService,
        csScheduleItemViewV3Standalone,
        LinkedAccountsService,
        dmsClientService,
        $injector,
        $document,
        $http,
        bmMultifactorService,
        bmEnvironmentConst,
        bmEnvironment,
        bmUtil
    )
    {
        var self = this; // jshint ignore:line
        self.session = authenticatedSession.data;
        self.user = bmUser;
        self.theme = theme.data;
        self.hasStaffApp = false;
        self.hasClientApp = false;
        self.appMenuActive = false;
        self.profileMenuActive = false;
        self.totalUnreadCount = 0;
        self.unreadNotificationsCount = -1;
        self.unreadMessagesCount = -1;
        self.showBRMessenger = false;
        self.onvioMessengerUnreadNotificationsCount = -1;
        self.wsocketGestta = undefined;
        self.hasClientDashboard = false;
        self.clientSpecificUrl = '';
        self.clientSpecificTitle = '';
        self.notStaffClient = undefined;
        self.hasPrefs = false;
        self.isHelpDropdownOpen = false;
        // needed for linked accounts
        self.linkedAccounts = [];
        self.selectedLinkedAccount = undefined;

        self.showLinkedAccountsMenu = false;
        self.linkedAccountFound = false;
        self.sharedProfile = {};
        self.isLoaderBusy = false;
        self.hasCCVNextIAC = false;
        self.hasMessengerIAC = false;
        self.hasNewPortalDoClienteIAC = false;
        self.allClientsNewPortalDoClienteIAC = false;
        self.hasCCVNextFRP = false;
        self.hasNewPortalDoClienteFRP = false;
        self.hasNewDesignIAC = false;
        self.hasAccountSwitchingIAC = false;
        self.isUsCountryCode = $injector.get('bmEnvironment').isUsCountryCode();
        self.isUkCountryCode = $injector.get('bmEnvironment').isUkCountryCode();
        self.isArCountryCode = $injector.get('bmEnvironment').isArCountryCode();
        self.pendoGuidanceHubDataQeId = 'pendo-resource-center-icon-';
        self.mfaQeId = '';
        self.newNotificationIconQeId = 'new-notification-';
        if(self.isUsCountryCode){
            self.isEligibleForPendoGuidanceHub = $window.location.pathname.startsWith('/staff') || $window.location.pathname.startsWith('/ustax') || $window.location.pathname.startsWith('/trialbalance') ;
        } else if(self.isUkCountryCode){
            self.isEligibleForPendoGuidanceHub = $window.location.pathname.startsWith('/accounts');
        } else if(self.isArCountryCode){
            self.isEligibleForPendoGuidanceHub = true;
        } else {
            self.isEligibleForPendoGuidanceHub = false;
        }
        self.enableNewNotificationPanelIAC = null;
        setGuidanceHubDataQedValue();
        var linkedAccountSessionToken;
        var userJwt;
        // optional dependency on $state for user-preferences
        var $state = $injector.has('$state') ? $injector.get('$state') : null;

        bmAccess.has('ClientCenterVnext').then(function() {
            self.hasCCVNextIAC = true;
        }).catch(function() {
            self.hasCCVNextIAC = false;
        });

        bmAccess.has('Platform_NewNotificationPanel').then(function() {
            self.enableNewNotificationPanelIAC = true;
        }).catch(function () {
            self.enableNewNotificationPanelIAC = false;
        });

        bmAccess.has('BR_ShowOnvioMessenger').then(function() {
            self.hasMessengerIAC = true;
        }).catch(function() {
            self.hasMessengerIAC = false;
        });

        bmAccess.has('BR_ShowPortalDoClienteAllClients').then(function() {
			self.allClientsNewPortalDoClienteIAC = true;
		}).catch(function() {
			self.allClientsNewPortalDoClienteIAC = false;
		});

        bmAccess.has('BR_ShowPortalDoCliente').then(function() {
			self.hasNewPortalDoClienteIAC = true;
		}).catch(function() {
			self.hasNewPortalDoClienteIAC = false;
		});

        bmAccess.has('Platform_NewProfilePanel').then(function() {
            self.hasNewDesignIAC = true;
        }).catch(function() {
            self.hasNewDesignIAC = false;
        });

        bmAccess.has('PPE-AccountSwitching').then(function() {
            self.hasAccountSwitchingIAC = true;
        }).catch(function() {
            self.hasAccountSwitchingIAC = false;
        });

        bmPermission.has('Platform.ccVnext').then(function() {
            self.hasCCVNextFRP = true;
        }).catch(function() {
            self.hasCCVNextFRP = false;
        });

        bmPermission.has('OnvioBR.BR_PortalDoCliente').then(function() {
            self.hasNewPortalDoClienteFRP = true;
        }).catch(function() {
            self.hasNewPortalDoClienteFRP = false;
        });

        self.hasApps = function() {
            var frp = authenticatedSession.data.bindings.FeatureResourcePermissions;
            return frp ? Object.keys(frp.FeatureResourcePermissionsMap.Applications).length > 1 : false;
        };
        self.clearMenuActive = function() {
            self.clearAppMenuActive();
            self.clearProfileMenuActive();
        };
        self.clearAppMenuActive = function() {
            if (self.appMenuActive) {
                self.appMenuActive = false;
                self.toggleLeftMenuMaskActive(self.appMenuActive);
                bmAnalyticsService.track('Header App Menu Closed', { label: 'closeAppList' });
            }
        };
        self.clearProfileMenuActive = function() {
            if (self.profileMenuActive) {
                self.profileMenuActive = false;
                self.toggleRightMenuMaskActive(self.profileMenuActive);
                $rootScope.$broadcast('bmProfileMenuClosed');
            }
        };
        self.toggleAppMenuActive = function() {
            $timeout(function() {
                self.appMenuActive = !self.appMenuActive;
                self.toggleLeftMenuMaskActive(self.appMenuActive);

                if(self.appMenuActive){
                    $rootScope.$broadcast('bmAppMenuOpened');
                    bmAnalyticsService.track('Header App Menu Opened', { label: 'openAppList' });
                }
            });

            var interval = setInterval(function() {
                var closeBtn = document.getElementById('bm-header-menu-close-btn');
                if (closeBtn) {
                    closeBtn.focus();
                    clearInterval(interval);
                }
            }, 250);
        };
        self.toggleProfileMenuActive = function() {
            self.profileMenuActive = !self.profileMenuActive;
            self.toggleRightMenuMaskActive(self.profileMenuActive);

            if(self.profileMenuActive){
                $rootScope.$broadcast('bmProfileMenuOpened');
            }
        };
        self.closeDropDowns = function() {
            self.isAppsDropdownOpen = false;
            self.isMsgsDropdownOpen = false;
            self.isHelpDropdownOpen = false;
            self.isTimerDropdownOpen = false;
            self.isUserDropdownOpen = false;
            self.isLinkedAccountsDropdownOpen = false;

            $rootScope.$broadcast('bmAppClosedDropdowns');
        };

        self.updateDisplayState = function(els, state) {
            return function () {
                var defaultValue = ''; // value (e.g flex) that specified in css before update of display state
                var value = state ? defaultValue : 'none';
                els.forEach(function (el) {
                    if (el) {
                        // timeout to compensate css trnsition delay
                        $timeout(function() { el.style.display = value; }, 100);
                    }
                });
            };
        };

        $scope.$on('update-top-nav-buttons', function(event, opt) {
            if(opt.clientId) {
                var clientId = opt.clientId;
                self.updateCustomizedLinks(clientId);
            }
        });

        self.updateCustomizedLinks = function(clientId) {
            self.updateCustomizedProjectLinks();
            self.updateCustomizedDocumentsLink(clientId);
            self.updateCustomizedClientDashboardLink(clientId);
        };
        self.updateCustomizedProjectLinks = function() {
            var currentUrl = $location.path();

            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';

            // inspect the new url for /projects/UUID
            // if we find it, load the project and update client dashboard link
            if(currentUrl.indexOf('/projects/') > -1) {
                // get everything after that and check for a UUID
                var substring = currentUrl.substring(currentUrl.indexOf('/projects/') + 10);
                if(substring.length > 32) {
                    substring = substring.substring(0, 32);
                }
                if(substring.match(/\w{32}/)) {
                    // assuming we didn't find anything that isn't a word character, try loading the project
                    csScheduleItemViewV3Standalone.get({'scheduleItemId': substring, expand: 'clientView.name,clientView.id'}).then(function(scheduleItems) {
                        var scheduleItem = scheduleItems && scheduleItems.data && scheduleItems.data.items && scheduleItems.data.items[0];
                        if(scheduleItem && scheduleItem.clientView && scheduleItem.clientView.id && scheduleItem.clientView.name) {
                            self.clientSpecificUrl = '/' + scheduleItem.clientView.id;
                            self.clientSpecificTitle = ': ' + scheduleItem.clientView.name;
                        }
                    });
                }
            }
        };

        self.updateCustomizedDocumentsLink = function(clientId) {
            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';
            if(clientId && clientId.length === 32 && clientId.match(/\w{32}/)) {
                setClientData(clientId);
            } else {
                if(self.notStaffClient && self.notStaffClient.isNotStaffApplication && self.notStaffClient.clientId !== '') {
                    setClientData(self.notStaffClient.clientId);
                    return;
                }
                // find case insensitive /client/
                var currentUrl = $location.path().toLowerCase();
                if(currentUrl.indexOf('/clients/') > -1) {
                    // for tree nav not enabled
                    setClientSpecificUrlAndTitle(currentUrl, '/clients/');
                } else if(currentUrl.indexOf('/client/') > -1) {
                    // for tree nav enabled
                    setClientSpecificUrlAndTitle(currentUrl, '/client/');
                }
            }
        };

        function setClientSpecificUrlAndTitle(currentUrl, clientString) {
            var offsetLength = clientString.length;
            var substring = currentUrl.substring(currentUrl.indexOf(clientString) + offsetLength);
            if (substring.length >= 32) {
                // revert clientId back to upper case
                substring = substring.substring(0, 32).toUpperCase();
                if (substring.match(/\w{32}/)) {
                    dmsClientService.getCached(substring).then(function (result) {
                        if (result && result.data && result.data.name && result.data.id) {
                            self.clientSpecificUrl = '/' + result.data.id;
                            self.clientSpecificTitle = ': ' + result.data.name;
                        }
                    });
                }
            }
        }

        self.updateCustomizedClientDashboardLink = function(clientId) {
            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';
            if(clientId && clientId.length === 32 && clientId.match(/\w{32}/)) {
                setClientData(clientId);
            } else {
                if(self.notStaffClient && self.notStaffClient.isNotStaffApplication && self.notStaffClient.clientId !== '') {
                    setClientData(self.notStaffClient.clientId);
                    return;
                }
                var currentUrl = $location.url();
        // inspect the new url for /projects/UUID
        // if we find it, load the project and update client dashboard link
                if(currentUrl.indexOf('/client-dashboard') > -1) {
        // get everything after that and check for a UUID
                   var startIndexOfClientIdQueryParameter = 18;
                   var lengthOfClientId = 32;
                   var startIndexOfClientId = 9;
                   var lastIndexOfClientIdQueryParameter = 41;
                   var substring = currentUrl.substring(currentUrl.indexOf('/client-dashboard') + startIndexOfClientIdQueryParameter);
                        if(substring.length >= lengthOfClientId) {
                                     substring = substring.substring(startIndexOfClientId, lastIndexOfClientIdQueryParameter);
                         if(substring.match(/\w{32}/)) {
                    // assuming we didn't find anything that isn't a word character, try loading the project
                             setClientData(substring);
                }
            }
        }
    }
};

        function setClientData(clientId) {
            dmsClientService.getCached(clientId).then(function(result) {
                if(result && result.data && result.data.name && result.data.id) {
                    self.clientSpecificUrl = '/' + result.data.id;
                    self.clientSpecificTitle = ': ' + result.data.name;
                }
            });
        }

        var jwt; // cache jwt
        self.sso = function($event) {
            var link = $event.currentTarget;
            var href = link.href;
            var tokenType = 'UDSLongToken';
            var token = bmTokenStorage.get();
            if (!jwt) { // lazy jwt
                // get jwt given a UDSLongToken
                // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                // not great, but the deprecation warning is a bluff
                var xhr = new $window.XMLHttpRequest();
                xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                    jwt = JSON.parse(xhr.responseText).token;
                };
                xhr.send();
                $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
            }
            if (!jwt) { return; }
            link.href = href + (/\?/.test(href) ? '&' : '?') + 'token=' + jwt;
            // don't leave jwt laying around
            setTimeout(function() { link.href = href; }, 0);
        };

        self.getUserJwt = function() {
            var dfd = $q.defer();
            if (userJwt) {
                // Get cached user jwt
                dfd.resolve(userJwt);
            } else {
                // Request user jwt
                bmMultifactorService.getUserJwtToken(self.contactId).then(function (response) {
                    userJwt = response.data.token;
                    dfd.resolve(userJwt);
                });
            }
            return dfd.promise;
        };

        self.launchApp = function($event) {
            var link = $event.currentTarget;
            var href = link.href;

            bmAnalyticsService.track('External App Launched', {
                app: $event.currentTarget.parentElement.getAttribute('bm-if-perm'),
                url: href,
                label: 'appLaunch'
            });

            self.clearAppMenuActive();
        };
        self.launchK1Analyzer = function() {
            self.isLoaderBusy = true;
            // Get user's jwt token
            self.getUserJwt().then(function (jwt) {
                // Check if user is authorized in K1
                $http({
                    method: 'POST',
                    bmNoAuth: true,
                    url: '/api/auth/v1/external-login/k1-analyzer',
                    headers: { Authorization: 'Bearer ' + jwt },
                    data: {'emsFirmId': self.emsFirmId}
                }).then(function(response){
                    // Retrieve launch url
                    var link = response.headers('Location');
                    // Launch K1 analyzer app in new tab
                    self.isLoaderBusy = false;
                    self.clearAppMenuActive();
                    var win = window.open(link, '_blank');
                    win.focus();
                }, function() {
                    self.isLoaderBusy = false;
                    self.clearAppMenuActive();
                });
            });
        };

        self.launchUltraTaxEfileUrl = function() {
            var ultrataxEfileUrl = 'https://www.ultratax.com/#e-file';
            window.open(ultrataxEfileUrl, '_blank');
        };

        self.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        self.showUserPreferences = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    $state.go('user-preferences');
                });
        };

        self.openProfileModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    self.openViewProfileDialog();
                });
        };
        self.openViewProfileDialog = function(){
            // if profileevent attribute is specified, fire event, clear menu, return
            if($scope.profileEvent && $document[0].body) {
                $document[0].body.dispatchEvent(new Event('bm-profile-launched'));
                self.clearProfileMenuActive();
                return;
            }
            var modalOptions = {
                templateUrl: 'user-profile/view-profile-modal.2js.html',
                controller: 'bmViewProfileCtrl as vm',
                backdrop: 'static',
                windowClass: 'bm-custom-profile-modal',
                size: 'lg',
                resolve: {
                    languages: function(){
                        return [];
                    },
                    user: function(){
                        return undefined;
                    }
                }
            };

            self.clearProfileMenuActive();

            modalOptions.resolve = {
                languages: function(){
                    return myAccountService.getLanguageListAsync();
                },
                user: function(){
                    return myAccountService.getMyUserSettingsAsync().then(function(resp){
                        return resp.data;
                    });
                }
            };

            openModalWithOptions(modalOptions);
        };
        self.signOutTRAccount = function () {
            getLogoutUrl().then(function(logoutUrl){
                authenticatedSession.destroy(logoutUrl);
              }, function(){
                  authenticatedSession.destroy();
              });
        };
        self.signOut = function() {
          // Identify the environment
          bmAccess.has('Platform_DisableAuth0Phase2').then(function () {
            self.clearProfileMenuActive();
            self.closeDropDowns();
            // If Auth0 is disable just sign out
            self.signOutTRAccount();
          }).catch(function () {
            // Auth0 is enabled
            self.closeDropDowns();
            // For development purposes we choose the /login url
            var url = $window.location.origin;
            var redirectURL =
                (bmEnvironmentConst.isLocalType ?
                url + '/login'
                :url + '/#/logout');
            var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
            var auth0ClientIdLogout = bmEnvironmentConst.auth0ClientId;
            // If it is CA and have fr-CA we use the region locale Auth0 client ID
            if (domain === '.ca' && bmUtil.cookie('BMLanguageCode') === 'fr-CA') {
                auth0ClientIdLogout = bmEnvironmentConst.auth0RegionLocaleClientId;
            }
            var logoutUrl =
                'https://' + bmEnvironmentConst.auth0Domain +
                '/v2/logout?client_id=' + auth0ClientIdLogout +
                '&returnTo=' + redirectURL;
            authenticatedSession.destroyAuth0(logoutUrl);
          });
        };

        function openModalWithOptions(modalOptions){
            self.closeDropDowns();
            var instance = $uibModal.open(modalOptions);
            return instance;
        }

        function getLogoutUrl(){
            var themeParams;

            if(self.companyId){
                themeParams = { company: self.companyId };
            }

            return theme.load(themeParams).then(function(){
                if(theme.data && theme.data.header && theme.data.header.logoutUrl){
                    return theme.data.header.logoutUrl;
                }
            });
        }

        function setGuidanceHubDataQedValue() {
            if(self.isArCountryCode) {
                self.pendoGuidanceHubDataQeId += 'onvio-center-ar';
            } else if($window.location.pathname.startsWith('/trialbalance')) {
                self.pendoGuidanceHubDataQeId += 'trialbalance';
            } else if($window.location.pathname.startsWith('/accounts')) {
                self.pendoGuidanceHubDataQeId += 'accounts';
            } else {
                self.pendoGuidanceHubDataQeId += 'onvio-center';
            }

            var isMFAEnabled = bmUtil.cookie('mfa_enrolled') === 'true';
            self.mfaQeId = 'onvio-mfa-' + (isMFAEnabled ? 'enabled' : 'disabled');
        }

        function getUnreadCountJob(){
            // returns the job id
            return bmJobQueue.push(function(done){
                notificationsManager.getUnreadNotificationCounts().then(function(data){
                    updateNotificationsCount(data);

                    // job is done running
                    done();
                }, function(){
                    updateNotificationsCount();

                    // job is done running
                    done();
                });
            }, 240000, '** Notifications Refreshed **'); // refresh every 4 minutes
        }

        function updateNotificationsCount(data){
            if(angular.isUndefined(data)){
                self.totalUnreadCount = 0;
                self.unreadNotificationsCount = 0;
                self.unreadMessagesCount = 0;
            } else {
                self.unreadNotificationsCount = data.notifications || 0;
                self.unreadMessagesCount = data.messages || 0;
                self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
            }
        }

        $scope.$on('bmUpdateCompanyStaffServices', function(event, args) {
            if (args.firmName) {
                setupLinkedAccounts(args.firmName);
            }
        });

        /* Start Linked Accounts Functions */
        function setupLinkedAccounts(broadcastFirmName) {
            var pos = 0;
            var posFound = -1;

            for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                //nickname
                if(!self.linkedAccounts[pos].displayedNickname || self.linkedAccounts[pos].displayedNickname === '') {
                    self.linkedAccounts[pos].displayedNickname = '';
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].accountName;
                } else {
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].displayedNickname;
                }
            }

            // setup view
            if(self.linkedAccounts.length > 1) {
                for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                    if(self.linkedAccounts[pos].contactId === self.contactId) {
                        self.linkedAccountFound = true;
                        self.selectedLinkedAccount = self.linkedAccounts[pos];
                        posFound = pos;
                        pos = self.linkedAccounts.length;
                    }
                }
                // remove the account that were logged into
                if(posFound >= 0) {
                    self.linkedAccounts.splice(posFound, 1);
                }

                // if accounts still exist, display menu
                if(self.linkedAccounts.length > 0) {
                    self.showLinkedAccountsMenu = true;
                }
            } else {
                self.selectedLinkedAccount = self.linkedAccounts[0];
                self.showLinkedAccountsMenu = false;
                self.linkedAccountFound = true;
            }
            if (broadcastFirmName) {
                self.selectedLinkedAccount.companyName = broadcastFirmName;
            }
        }

        self.switchAccount = function(linkedAccountId) {
            $scope.$emit('bm-busy-loading-on');

            LinkedAccountsService.createLinkedAccountSession(linkedAccountId).then(function(response){
                if (response.data.RedirectingDomain) {
                    // redirect the window to the new domain with the sso token
                    var ssoUrl = response.data.RedirectingDomain;
                    var routingPath = response.data.RoutingPath;
                    if (routingPath) {
                      // remove the first '/' if it exists
                      var subPath = (routingPath.startsWith('/') && ssoUrl.endsWith('/')) ? routingPath.substring(1) : routingPath;
                      ssoUrl = ssoUrl + subPath;
                    }
                    if (ssoUrl.indexOf('#') < 0) {
                       // add '#' if it does not exist
                       ssoUrl = ssoUrl + '#/';
                    }
                    ssoUrl = ssoUrl + '?token=' + response.data.SsoTokenId;
                    $window.location.href = ssoUrl;
                } else {
                    // load the new session on the same domain
                    linkedAccountSessionToken = response.data.LongToken;
                    authenticatedSession.switchAccountWithLongToken(linkedAccountSessionToken);
                }
                $scope.$emit('bm-busy-loading-off');
            }).catch(function(error){
                console.log(error);
                $scope.$emit('bm-busy-loading-off');
            });
        };

        self.openManageLinkedAccountsDialog = function() {
            $log.info('Go manage the accounts');

            var modalOptions = {
                templateUrl: 'components/linked-accounts/linked-accounts-dialog.2js.html',
                controller: 'LinkedAccountsDialogCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function(){
                        return undefined;
                    },
                    sharedProfile: function(){
                        return {};
                    }
                }
            };

            modalOptions.resolve = {
                user: function(){
                    return self.user;
                },
                sharedProfile: function(){
                    return self.sharedProfile;
                }
            };

            openModalWithOptions(modalOptions);
        };
        /* End Linked Accounts Functions */

        self.openOnvioMessenger = function() {
            bmEnvironment.getRoute('OnvioBRMessenger').then(function(url){
                var jwt;
                var tokenType = 'UDSLongToken';
                var token = bmTokenStorage.get();
                if (!jwt) { // lazy jwt
                    // get jwt given a UDSLongToken
                    // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                    // not great, but the deprecation warning is a bluff
                    var xhr = new $window.XMLHttpRequest();
                    xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                    xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                        jwt = JSON.parse(xhr.responseText).token;
                    };
                    xhr.send();
                    $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
                }
                if (!jwt) { return; }
                url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + jwt;
                // don't leave jwt laying around
                setTimeout(function() { $window.open(url, '_blank'); }, 0);
            });
        };

        self.getOnvioMessengerUnreadNotifications = function () {
            bmEnvironment.getRoute('GesttaWebSocket').then(function(url){
                var token = bmTokenStorage.get();
                $http({
                    method: 'POST',
                    url: '/api/br-messenger/v1/socket',
                    data: {},
                    headers: { Authorization: 'UDSLongToken' + token }
                }).then(function(gesttaToken){
                    var substractedToken = gesttaToken.data.token.split(' ')[1];
                    url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + substractedToken;
                    try {
                        self.wsocketGestta = new WebSocket(url);
                        self.wsocketGestta.addEventListener('message', function(event) {
                            var responseObject = JSON.parse(event.data);
                            var contactId = self.contactId;
                            var notifCount = responseObject.data.metadata[contactId];
                            if (notifCount && typeof notifCount === 'number') {
                                self.onvioMessengerUnreadNotificationsCount = responseObject.data.metadata[contactId];
                            } else {
                                self.onvioMessengerUnreadNotificationsCount = 0;
                            }
                            $scope.$apply();
                        });
                    } catch(_e) {}
                }).catch(function(){
                    self.onvioMessengerUnreadNotificationsCount = 0;
                });
            });
        };

        function init(){
            self.closeDropDowns();

            if($scope.notStaffClient){
                self.notStaffClient = $scope.notStaffClient;
            }

            if(authenticatedSession.data){
                authenticatedSession.data.getBindings().then(function(data){
                    self.companyId = data.ApplicationConfiguration.CompanyId;
                    self.emsFirmId = data.ApplicationConfiguration.EmsFirmId;

                    // linked accounts
                    self.contactId = data.ApplicationConfiguration.ContactId;
                    LinkedAccountsService.getActiveOnvioLinkedAccounts().then(function(response){
                        self.linkedAccounts = response.data;
                        setupLinkedAccounts();
                    }).catch(function(error){
                        console.log(error);
                        self.linkedAccounts = [];
                        self.linkedAccountFound = false;
                    });

                });

                var notificationCountFetchJobIdWatch = $scope.$watch(function() { return self.enableNewNotificationPanelIAC; }, function(newValue) {
                    if(newValue === false) {
                        // start up the job for getting unread count
                        var jid = getUnreadCountJob();

                        bmJobQueue.start(jid); // enabled specified job

                        // kill the job when profile menu is open
                        $rootScope.$on('bmProfileMenuOpened', function(){
                            bmJobQueue.stop(jid);
                            bmJobQueue.remove(jid);

                            // get the most up-to-date counts so lists in tabs match header
                            notificationsManager.getUnreadNotificationCounts().then(function(data){
                                updateNotificationsCount(data);
                            });
                        });

                        // create new job and start is up so count is immediately refreshed
                        $rootScope.$on('bmProfileMenuClosed', function(){
                            jid = getUnreadCountJob();
                            bmJobQueue.start(jid);
                        });
                        notificationCountFetchJobIdWatch();
                    }
                });

                // update count when an item is read
                $rootScope.$on('bmNotificationMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadNotificationsCount = 0;
                    } else if(self.unreadNotificationsCount > 0){
                        self.unreadNotificationsCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // update count when an item is read
                $rootScope.$on('bmMessagesMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadMessagesCount = 0;
                    } else if(self.unreadMessagesCount > 0){
                        self.unreadMessagesCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // close nav menus when a bound html link is selected
                $rootScope.$on('bmNotificationHtmlClick', function(){
                    self.clearMenuActive();
                });
            }

            bmPermission.has('Applications.Onvio').then(function(){
                self.hasStaffApp = true;
            }).catch(angular.noop);

            bmPermission.has('Applications.OnvioClientHub').then(function(){
                self.hasClientApp = true;
            }).catch(angular.noop);

            try {
                angular.module('bm.userPreferences');
                $injector.get('userPreferencesService')
                    .hasPreferences()
                    .then(function(hasPrefs) {self.hasPrefs = hasPrefs;})
                    .catch(function() {self.hasPrefs = false;});
            } catch(e) {
                self.hasPrefs = false;
            }

            // must have IAC and FR
            // not available to users with documents basic
            bmAccess.has('Client_Dashboard').then(function(){
                return bmLicense.has('Onvio.ClientDashboard').then(function(){
                    return bmPermission.has('Onvio.ClientDashboard').then(function(){
                        return bmLicense.not('Applications.OnvioDocumentsBasic').then(function(){
                            return bmPermission.not('GFR.ClientFlow').then(function(){
                                self.hasClientDashboard = true;
                            });
                        });
                    });
                });
            }).catch(function() {
                self.hasClientDashboard = false;
                bmAnalyticsService.track('bmHeader: bmAccess.has(\'Client_Dashboard\') failed');
            });

            bmEnvironment.getEnvironmentAsync().then(function(env) {
                if (env.countryCode === 'AR') {
                    bmPermission.has(['Applications.BRChat'], true)
                        .then(function(hasPerm) {
                            self.showBRMessenger = hasPerm;
                            self.getOnvioMessengerUnreadNotifications();
                        });
                }
            });

            $rootScope.$on('$destroy', function() {
                if (self.wsocketGestta) {
                    self.wsocketGestta.close();
                }
            });
        }

        init();
    }

    bmHeader.$inject = ['$window', '$document', '$rootScope', 'bmUtil', 'AuthenticatedSessionData'];

    bmHeaderCtrl.$inject = [
        '$window',
        '$log',
        '$rootScope',
        '$q',
        '$timeout',
        '$uibModal',
        '$location',
        '$translate',
        '$scope',
        'AuthenticatedSession',
        'bmUser',
        'bmTheme',
        'myAccountService',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmModal',
        'bmJobQueue',
        'bmClientNotificationsListManager',
        'bmTokenStorage',
        'bmAnalyticsService',
        'csScheduleItemViewV3Standalone',
        'LinkedAccountsService',
        'dmsClientService',
        '$injector',
        '$document',
        '$http',
        'bmMultifactorService',
        'bmEnvironmentConst',
        'bmEnvironment',
        'bmUtil'
    ];

    angular.module('bluemoon.components.header', [
        'ui.bootstrap',
        'bento.services',
        'bento.select',
        'bento.tabs',
        'bluemoon.components.session',
        'bluemoon.components.theme',
        'bluemoon.passwordValidation',
        'bluemoon.components.header.timerButton',
        'bluemoon.components.header.documentsButton',
        'bmViewProfile',
        'bmUser',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmUserAvailability',
        'bmClientNotificationsList',
        'bluemoon.components.analytics',
        'bmPrivacyPolicy',
        'bmSupportId',
        'csScheduleItemViewV3Standalone',
        'bmLinkedAccounts',
        'bmPreviewTrialWidget',
        'pascalprecht.translate'
    ])

    .directive('bmHeader', bmHeader);

})(window.angular);

/**
 * Blue Moon Components - View Portal Banner Directive
 */
(function(angular){
    'use strict';

    function bmViewPortalBanner($document, sessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/view-portal-banner/view-portal-banner.2js.html',
            transclude: true,
            require: '^bmApp',
            controller: bmViewPortalBannerCtrl,
            controllerAs: 'banner',
            link: function () {
                sessionData.getMeta().then(function(data) {
                    if (data.EmulateePrismGuid) {
                        var html = angular.element($document[0].documentElement)[0];
                        html.classList.add('bm-view-portal-mode');
                    }
                });
            }
        };
    }

    function bmViewPortalBannerCtrl(session, sessionData, theme) {
        var self = this; // jshint ignore:line

        // don't resolve (render) until theme is loaded
        self.unresolvedTheme = true;
        sessionData.getBindings().then(function(data) {
            theme.loadHeader(data.ApplicationConfiguration.CompanyId).then(function() {
                self.unresolvedTheme = false;
            });
        });

        sessionData.getMeta().then(function(data) {
            self.uname = data.FullName;
        });

        self.exitViewPortalMode = function() {
            session.exitViewPortal();
        };
    }

    bmViewPortalBanner.$inject = ['$document', 'AuthenticatedSessionData'];
    bmViewPortalBannerCtrl.$inject = ['AuthenticatedSession', 'AuthenticatedSessionData', 'bmTheme'];

    angular.module('bmViewPortalBanner', [
        'bluemoon.components.session'
    ])

    .directive('bmViewPortalBanner', bmViewPortalBanner);

})(window.angular);

/**
 * Blue Moon Components - Timer Header Button directive.
 * This is the timer menu that is to appear in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    function bmTimerHeaderButton($timeout) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/timer-header-button.2js.html',
            scope: {
                isTimerDropdownOpen: '=bmTimerHeaderButton',
                clientSpecificTitle: '=clientSpecificTitle',
                htmlElementId: '@'
            },
            link: function(scope, element) {
                // If we don't have the TimeAndExpense Timer code loaded, don't show this button at all.
                var unwatch = scope.$watch(function () { return element[0].querySelector('#bm-header-timer-control'); },
                    function (timerElement) {
                        if (timerElement && timerElement.childElementCount > 0) {
                            scope.vm.timerDirectiveLoaded = true;
                            unwatch();

                            // add an id to the main element if defined
                            if(angular.isDefined(scope.vm.htmlElementId)){
                                element.attr('id', scope.vm.htmlElementId);
                            }
                        }
                    });
                $timeout(function () {
                    // After a while, give up. No point in wasting cpu cycles by watching this forever.
                    unwatch();
                }, 6000);
            },
            bindToController: true,
            controller: function() {
                this.timerDirectiveLoaded = false;
            },
            controllerAs: 'vm'
        };
    }
    bmTimerHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.timerButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
    ])

    .directive('bmTimerHeaderButton', bmTimerHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Documents Header Button directive.
 * This is the documents icon that takes the use to Documnets that is to appear
 in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    var _$inject = ['$state', 'bmPermission', 'bmAccess', '$q'];
    var bmDocumentsHeaderButton = function($state, bmPermission, bmAccess, $q) {
        return {
            scope: {
                clientSpecificUrl: '=',
                clientSpecificTitle: '=',
                notStaffClient: '<?'
            },
            templateUrl: 'components/header/documents-header-button.2js.html',
            link: function(scope) {
                scope.openDocuments = function () {
                    var notWithinStaff = scope.notStaffClient !== undefined && scope.notStaffClient.isNotStaffApplication;
                    var url = notWithinStaff ? '/staff/#/documents/all' : $state.href('allDocsRootList');
                    if(scope.clientSpecificUrl && scope.clientSpecificUrl.length > 32) {
                        var clientIdString = scope.clientSpecificUrl.substring(1, 33);
                        if(clientIdString.match(/\w{32}/)) {
                            if (notWithinStaff) {
                                var promises = [
                                    bmPermission.has('OnvioDrive.SuppressTree'),
                                    bmAccess.has('DMS_HideTreeView')
                                ];

                                return $q.all(promises).then(function() {
                                    url = '/staff/#/documents/clients/' + clientIdString + '/storage';
                                    window.open(url, '_blank');
                                },function() {
                                    url = '/staff/#/documents/client/' + clientIdString;
                                    window.open(url, '_blank');
                                });
                            } else {
                                url = $state.href('clientStorageList', {
                                    clientId: clientIdString
                                });
                                window.open(url, '_blank');
                            }
                        } else {
                            window.open(url, '_blank');
                        }
                    } else {
                        window.open(url, '_blank');
                    }
                };
            }
        };
    };

    bmDocumentsHeaderButton.$inject = _$inject;

    // bmDocumentsHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.documentsButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
        'bmAccess'
    ])

    .directive('bmDocumentsHeaderButton', bmDocumentsHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Staff Header Directive
 */
(function(angular){
    'use strict';

    function bmStaffHeader() {
        return {
            restrict: 'EA',
            templateUrl: 'components/header/bm-staff-header.2js.html',
            scope: {
                profileEvent: '@profileEvent'
            }
        };
    }

    function bmStaffCustomHeader() {
        return {
            restrict: 'EA',
            templateUrl: 'components/header/bm-staff-custom-header.2js.html',
            transclude: {
                'profile': '?bmStaffCustomHeaderProfile',
                'icon': '?bmStaffCustomHeaderIcon',
            },
            scope: {
                profileEvent: '@profileEvent'
            },
        };
    }

    angular.module('bluemoon.components.staffHeader', [
        'bluemoon.components.header'
    ])

    .directive('bmStaffHeader', bmStaffHeader)
    .directive('bmStaffCustomHeader', bmStaffCustomHeader);

})(window.angular);

(function(angular) {
    'use strict';
    /*jshint sub:true*/
    // DEPRECATED - Use csScheduleItemViewV3Standalone
    angular.module('csScheduleItemV6Standalone', ['bluemoon.components.session']).service('csScheduleItemV6Standalone',
        ['$http', 'AuthenticatedSessionData',
        function($http, authenticatedSessionData) {
            return {
                get: function(params) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v6/companies/{companyId}/schedule-items/{scheduleItemId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{scheduleItemId}/g, paramsCopy['scheduleItemId']);

                        var query = {
                            'expand': paramsCopy['expand']
                        };
                        return $http({ url: url, method: 'GET', params: query, headers: {} });
                    });
                }

            };
        }]);
}(window.angular));

(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csScheduleItemViewV3Standalone', ['bluemoon.components.session']).service('csScheduleItemViewV3Standalone',
        ['$http', 'AuthenticatedSessionData',
        function($http, authenticatedSessionData) {
            return {
                get: function(params) {

                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v3/companies/{companyId}/schedule-item-views/search';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var body = {
                            'excludeCount': true,
                            'expand': paramsCopy['expand'],
                            'filterSearchSort': {
                                'search': paramsCopy['scheduleItemId'],
                                'searchBy': 'id'
                            },
                            'includeAllOwners': true
                        };
                        return $http({ url: url, method: 'POST', data: body, headers: {} });
                    });
                }
            };
        }]);
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonForceDesktop', [])
    .directive('bluemoonForceDesktop', bluemoonForceDesktop)
    .directive('bmForceDesktop', bluemoonForceDesktop);

    bluemoonForceDesktop.$inject = ['$window'];
    function bluemoonForceDesktop($window) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element) {
                var w = angular.element($window);
                scope.getWindowSize = function() {
                    return { 'width': $window.innerWidth };
                };
                scope.$watch(scope.getWindowSize, function(newValue) {
                    // TODO - bootstrap medium and higher for now.
                    // Still want 'force-desktop' past bootstrap large,
                    // but at some point a HD screen may not want 'force-desktop'
                    if (newValue.width >= 992 /*&& newValue.width < 1200*/) {
                        element.addClass('force-desktop');
                    } else {
                        element.removeClass('force-desktop');
                    }
                }, true);

                w.bind('resize', function() {
                    scope.$apply();
                });
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    function BmAnalyticsConfigProvider() {

        var provider = this;

        /* Remove permission via FRP. All environments (except local) should report */
        // provider.hasPermission = ['bmPermission', 'bmAnalyticsFRP', function(bmPermission, bmAnalyticsFRP){
        // return bmPermission.has(bmAnalyticsFRP);
        // }];
        provider.hasPermission = ['$q', function ($q) {
            var deferred = $q.defer();
            deferred.resolve(true);
            return deferred.promise;
        }];

        provider.$get = function () {
            return provider;
        };
    }

    // Product Insight integration #7833
    function productInsightIntegration(module) {
        module
            .config([
                'bmEnvironmentConst',
                'bluemoonAnalyticsProvider',
                function (env, bluemoonAnalyticsProvider) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        bluemoonAnalyticsProvider.sendAnalyticsToProd(env.isProdType, function () {
                            bluemoonAnalyticsProvider.loadTRAACLibrary(function () {
                                bluemoonAnalyticsProvider.configAngulartics();
                            });
                        });
                    }
                }
            ])
            .run([
                'bmEnvironmentConst',
                'AuthenticatedSessionData',
                '$analytics',
                function (env, session, $analytics) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        $analytics.setSuperProperties({
                            // NOTE: 'app' should be set by consumer
                            //'app': 'My Application Name in Human Readable Form',
                            'server': location.protocol + '//' + location.host,
                            'environment': env.type.toLowerCase()
                        });
                        session.getMeta().then(function (data) {
                            $analytics.setSuperProperties({
                                'uid': data.PrismGuid
                            });
                        }).catch(function () {
                            angular.noop('ng161');
                        });
                    }
                }
            ]);
    }

    function BmAnalyticsService($window, $analytics, $rootScope, $location, $injector, authenticatedSessionData, bmAnalyticsConfig) {
        var service = this;

        var performEventTracking = function (eventName, eventInfo) {
            service.defaultData().then(function (data) {
                var fullData = angular.extend({}, data, eventInfo);
                $analytics.eventTrack(eventName, fullData);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        var performPageViewedTracking = function (event, current) {
            service.defaultStateData().then(function (data) {
                data.controller = current.controller;
                data.state = current.name;
                data.page = $analytics.settings.pageTracking.basePath + $location.url();

                //NOTE: Could do pageTrack(url) but it wouldn't give us nearly as much info as I'm doing here.
                $analytics.eventTrack('Page Viewed', data);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.track = function (eventName, eventInfo) {
            service.ready().then(function () {
                performEventTracking(eventName, eventInfo);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.init = function () {
            service.ready().then(function () {
                $rootScope.$on('$stateChangeSuccess', function (event, current) {
                    performPageViewedTracking(event, current);
                });
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    category: 'bluemoon-event',
                    label: 'custom-event',
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultStateData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.hasPermission = function () {
            return $injector.invoke(bmAnalyticsConfig.hasPermission);
        };

        service.ready = function () {
            return service.hasPermission();
        };
    }

    BmAnalyticsService.$inject = ['$window', '$analytics', '$rootScope', '$location', '$injector', 'AuthenticatedSessionData', 'bmAnalyticsConfig'];

    function BmAnalyticsDirective(bmAnalyticsService) {

        function link(scope) {
            bmAnalyticsService.track(scope.eventName, scope.eventInfo);
        }

        return {
            restrict: 'EA',
            replace: true,
            scope: {
                eventName: '@',
                eventInfo: '@'
            },
            link: link
        };
    }

    BmAnalyticsDirective.$inject = ['bmAnalyticsService'];

    function BmAnalyticsOnDirective($q, $compile, analyticsService) {

        function link(scope, element, attr) {

            function getAnalyticsAttribute(bmAnalyticsAttribute) {
                return bmAnalyticsAttribute.replace('bm-analytics', 'analytics');
            }

            analyticsService.ready().then(function () {

                var promisesToWaitFor = [];

                angular.forEach(attr.$attr, function (bmAnalyticsAttr) {
                    if (bmAnalyticsAttr.indexOf('bm-analytics-') === 0) {
                        if (bmAnalyticsAttr === 'bm-analytics-properties') {
                            promisesToWaitFor.push(analyticsService.defaultData().then(function (data) {
                                var properties = attr[attr.$normalize(bmAnalyticsAttr)];
                                var fullData = properties ? angular.extend({}, data, JSON.parse(properties)) : '';
                                element.attr(getAnalyticsAttribute(bmAnalyticsAttr), JSON.stringify(fullData));
                            }));
                        } else if (bmAnalyticsAttr === 'bm-analytics-if') {
                            scope.analyticsIf = function () {
                                return scope.$eval(attr[attr.$normalize(bmAnalyticsAttr)]);
                            };
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), 'analyticsIf()');
                        } else {
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), attr[attr.$normalize(bmAnalyticsAttr)]);
                        }
                    }
                });

                $q.all(promisesToWaitFor).then(function () {
                    element.removeAttr('bm-analytics-on');
                    if (element.attr('bm-analytics-properties') === undefined) {
                        analyticsService.defaultData().then(function (data) {
                            element.attr(getAnalyticsAttribute('bm-analytics-properties'), JSON.stringify(data));
                            $compile(element)(scope);
                        });
                    } else {
                        $compile(element)(scope);
                    }
                });
            }).catch(function () {
                angular.noop('ng161');
            });

        }

        return {
            restrict: 'A',
            replace: true,
            link: link
        };
    }

    BmAnalyticsOnDirective.$inject = ['$q', '$compile', 'bmAnalyticsService'];

    var bmAnalyticsFRP = 'Onvio.Analytics';

    var module = angular.module('bluemoon.components.analytics', [
        'angulartics',
        'bluemoon.analytics',
        'bmEnvironment',
        'bmPermission',
        'bluemoon.components.session'
    ])
        .constant('bmAnalyticsFRP', bmAnalyticsFRP)
        .provider('bmAnalyticsConfig', BmAnalyticsConfigProvider)
        .service('bmAnalyticsService', BmAnalyticsService)
        .directive('bmAnalytics', BmAnalyticsDirective)
        .directive('bmAnalyticsOn', BmAnalyticsOnDirective)
        .config(['$analyticsProvider', function ($analyticsProvider) {
            $analyticsProvider.virtualPageviews(false);
        }])
        .run(['bmAnalyticsService', function (bmAnalyticsService) {
            bmAnalyticsService.init();
        }]);

    productInsightIntegration(module);

})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFocusOnEvent
     *
     *  Requires: onvio.setup.common.ITouchUtils, fef.Utils, bluemoon.components.Notifications
     *
     *  Scope type: none
     *
     *  Arguments:
     *      The main argument is an expression that evaluates to an angular event name (string).
     *      The bmFocusOnEventWithTouch argument (optional, default false) is an expression that evaluates to true or false.
     *        If true, the focus behavior will be enabled even on touch devices and hybrids where the user
     *        is currently using touch. Otherwise, the focus behavior will be disabled on these devices.
     *      The bmFocusOnEventElementSelector argument (optional, default undefined) is an expression that evaluates to a string.
     *        If provided, the focus behavior will apply to the first descendent that is returned by the provided element selector
     *        Otherwise, the focus behavior will apply to the element that this directive is on.
     *
     *  Description:
     *  Directive to listen for an event on scope (specified as an argument)
     *  and focus the element whenever the event fires. Does a $scope.$on on
     *  the element's scope, given the main argument as the event name, and
     *  gives the element focus when that event occurs. $broadcast that event
     *  from the element's scope (or one of its parent scopes), or $emit it from
     *  a child scope under the element, to cause the element to gain focus.
     */
    angular.module('bmFocusOnEvent',
        [
            'bluemoon.components.Notifications',
            'fef',
            'bmTouchUtils'
        ]).directive('bmFocusOnEvent', [
            '$timeout',
            '$log',
            'bluemoon.components.Notifications',
            'fef.Utils',
            'bmTouchUtils',
            function(
                $timeout,
                $log,
                notifications,
                utils,
                touchUtils
            ) {
                return {
                    link: function($scope, element, attrs) {
                        var enabledOnTouch = false;
                        var elementSelector;
                        var focused = false;
                        if(!utils.exists(attrs.bmFocusOnEvent)) {
                            throw new Error('bmFocusOnEvent requires an event argument');
                        }

                        if(utils.exists(attrs.bmFocusOnEventWithTouch)) {
                            enabledOnTouch = $scope.$eval(attrs.bmFocusOnEventWithTouch);
                        }
                        if (utils.exists(attrs.bmFocusOnEventElementSelector)) {
                            elementSelector = $scope.$eval(attrs.bmFocusOnEventElementSelector);
                        }
                        var deregister = null;
                        var getEventName = function() {
                            return $scope.$eval(attrs.bmFocusOnEvent);
                        };

                        var registerListener = function() {
                            if(deregister !== null) {
                                deregister();
                                deregister = null;
                            }
                            var eventName = getEventName();
                            if (utils.exists(eventName)) {
                                deregister = $scope.$on(eventName, function() {
                                    var focusElement = element;
                                    if (enabledOnTouch || !touchUtils.touchUsed()) {
                                        if (elementSelector) {
                                            focusElement = element.find(elementSelector);
                                            if (!focusElement) {
                                                // Don't do anything if the element could not be found.
                                                return;
                                            }
                                        }
                                        focused = false;
                                        focusElement.bind('focus', function(event) {
                                            focused = true;
                                            focusElement.unbind(event);
                                        });

                                        focusElement.focus();

                                        // If we are in a headless browser, focus() won't do anything.
                                        // But we still want to fire the events.
                                        // So, if the focus event hasn't yet been fired, do that here.
                                        if(!focused) {
                                            focusElement.triggerHandler('focus');
                                        }
                                    }
                                });
                            }
                        };

                        $scope.$watch(attrs.bmFocusOnEvent, registerListener);
                        registerListener();
                    }
                };
            }]);

}(window.angular));

(function() {
    'use strict';
    angular.module('bmFocusOnLink',
        ['bmTouchUtils', 'fef', 'bluemoon.components.Notifications'])
        .directive('bmFocusOnLink', [
        '$timeout',
        '$log',
        'bluemoon.components.Notifications',
        'fef.Utils',
        'bmTouchUtils',
        '$rootScope',
        function($timeout, $log, notifications, utils, touchUtils, $rootScope) {
            return {
                link: function(scope, instanceElement, instanceAttributes) {
                    var enabledAttribute = instanceAttributes.bmFocusOnLink;
                    if(!utils.stringIsNonBlank(enabledAttribute)) {
                        enabledAttribute = 'true';
                    }
                    var enabled = scope.$eval(enabledAttribute);
                    if(enabled) {
                        var enabledOnTouch = instanceAttributes.bmFocusOnLinkWithTouch;
                        if(!utils.exists(enabledOnTouch)) {
                            enabledOnTouch = false;
                        } else {
                            enabledOnTouch = scope.$eval(enabledOnTouch);
                        }
                        // the timeout is to allow the scope digest cycle to settle.
                        // otherwise the selection state may get lost as bindings
                        // fire callbacks and so on.
                        $timeout(function() {
                            var focusElement = function() {
                                if(enabledOnTouch || !touchUtils.touchUsed()) {
                                    instanceElement.focus();
                                    if(utils.exists(instanceElement.select) && angular.isFunction(instanceElement.select)) {
                                        instanceElement.select();
                                    }
                                }
                            };
                            // Focus only works if the control is visible.
                            if(instanceElement.is(':visible')) {
                                focusElement();
                            } else {
                                // Wait until the control becomes visible before trying to focus it.
                                var unwatch = $rootScope.$watch(function() { return instanceElement.is(':visible'); }, function(newValue) {
                                    if(newValue) {
                                        focusElement();
                                        if(utils.exists(unwatch)) {
                                            unwatch();
                                            unwatch = undefined;
                                        }
                                    }
                                });
                                // We run out of digest cycles in some cases (typically trying to add on most screens)
                                // So, trigger a digest every so-often if the control is visible and we haven't focused it yet.
                                var digestFunc = function() {
                                    if(utils.exists(unwatch)) {
                                        if(instanceElement.is(':visible')) {
                                            $rootScope.$digest();
                                        } else {
                                            $timeout(digestFunc, 250);
                                        }
                                    }
                                };
                                $timeout(digestFunc, 250);
                                // After some amount of time of being unable to focus the element, just give up.
                                $timeout(function() {
                                    if(utils.exists(unwatch)) {
                                        unwatch();
                                        unwatch = undefined;
                                    }
                                }, 2000);
                            }
                        }, 10);
                    }
                }
            };
        }
        ]);
}());

(function(angular){
    'use strict';

    // TODO: USE THIS TEMPORARILY UNTIL BENTO SELECT SUPPORTS CHANGE EVENT
    var module = angular.module('bmForceModelChange', []);

    module.directive('bmForceModelChange',function(){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr) {
                scope.$watch(attr.ngModel, function(newValue, oldValue){
                    if(newValue && oldValue && newValue !== oldValue){
                        scope.$eval(attr.bmForceModelChange);
                    }
                });
            }
        };
    });
})(window.angular);

(function($) {
    'use strict';
    /* istanbul ignore next */
    var TouchUtils = (function() {
        function TouchUtils() {
            var _this = this;
            this._touchUsed = false;
            this._touchSupported = false;
            var onTouch = function() {
                _this._touchUsed = true;
            };
            var onNonTouch = function() {
                _this._touchUsed = false;
            };
            // Source: https://hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
            if(('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)) {
                this._touchSupported = true;
                //var body = $('body');
                // This doesn't appear to be working #research
                $('body').on('pointerdown', function(event) {
                    if(event.pointerType === 'touch') {
                        onTouch();
                    } else {
                        onNonTouch();
                    }
                });
                $('body').on('pointermove', function(event) {
                    if(event.pointerType !== 'touch') {
                        onNonTouch();
                    }
                });
                $('body').bind('touchstart', function() {
                    onTouch();
                });
                $('body').bind('onmousemove', function() {
                    onNonTouch();
                });
            }
        }
        TouchUtils.prototype.touchSupported = function() {
            return this._touchSupported;
        };
        /**
         * Not currently working. #research
         */
        TouchUtils.prototype.touchUsed = function() {
            return this._touchUsed;
        };
        TouchUtils.$inject = [];
        return TouchUtils;
    })();
    angular.module('bmTouchUtils', []).service('bmTouchUtils', TouchUtils);
}(window.$));

(function(angular) {
    'use strict';

    angular.module('bmRightClick', [])

    .directive('bmRightClick', function($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.bmRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    fn(scope, {$event:event});
                });
            });
        };
    });

}(window.angular));

/**
 * Blue Moon Components - Nav Directive
 */
(function(angular){
    'use strict';
    var titleSeparator = '|';
    var docTitleReplacePtn = new RegExp('^.+\\s\\' + titleSeparator + '\\s');

    function bmNav($window, $document, $location, $rootScope, $timeout, $translate, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/nav/nav.2js.html',
            transclude: true,
            link: function(scope, element, attrs) {
                var nav,
                    doc = $document[0],
                    syncDocTitle,
                    offLocChgSuccess,
                    unwatchDocTitle,
                    offLangChgSuccess;

                var keyCodes = { esc: 27 };

                element.on({ keydown: function(e) {
                    if (e.which === keyCodes.esc) {
                        var selectedTree = Array.from(element.get(0).querySelectorAll('.focused'));
                        var rootActiveMenuEl = Array.isArray(selectedTree) && selectedTree[0];
                        nav.navmore.collapse();
                        if (rootActiveMenuEl) {
                            rootActiveMenuEl.focus();
                        }
                    }
                }});

                // update active nav item after binding data is loaded and allowed nav items show
                authenticatedSessionData.getBindings().then(function() {
                    // wait till next event loop
                    $timeout(function() {
                        // snapshot static configuration
                        syncDocTitle = scope.$eval(attrs.syncDocTitle) === true;

                        // init navigation menu
                        nav = $window.navmore(element.find('nav')[0]);
                        localizeMoreNavItem($translate, nav);

                        // update active nav item on startup
                        updateSelectedNavItem($rootScope, doc, nav, $location.absUrl());

                        // update active nav item on location change success
                        offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function (e, url) {
                            updateSelectedNavItem($rootScope, doc, nav, url);
                            // update document title
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        // update more item text on lang change
                        offLangChgSuccess = scope.$on('bmLanguageChangeSuccess', function() {
                            localizeMoreNavItem($translate, nav);
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        if (syncDocTitle) {
                            unwatchDocTitle = $rootScope.$watch(
                                function() {
                                    return doc.title;
                                },
                                function() {
                                    syncDocumentTitleWithNavSelection(doc, nav);
                                }
                            );
                            syncDocumentTitleWithNavSelection(doc, nav);
                        }
                    });
                });

                // cleanup
                element.on('$destroy', function () {
                    if (offLocChgSuccess) {
                        offLocChgSuccess();
                    }
                    if (offLangChgSuccess) {
                        offLangChgSuccess();
                    }
                    if (unwatchDocTitle) {
                        unwatchDocTitle();
                    }
                });
            }
        };

        function syncDocumentTitleWithNavSelection(doc, nav) {
            if (!nav || !nav.navmore) { return; }

            // find top-level selected nav item and use the text (post translation) to update the doc title

            var navSelectedArray = nav.navmore.getSelected();
            if (!navSelectedArray.length) { return; }

            var navSelectedText = navSelectedArray[navSelectedArray.length - 1].textContent.trim();
            if (!navSelectedText) { return; }

            var newTitle = navSelectedText + ' ' + titleSeparator + ' ' + doc.title.replace(docTitleReplacePtn, '');
            if (newTitle === doc.title) { return; }

            // offer subscribers a chance to cancel
            var detail = { oldValue: doc.title, newValue: newTitle, cancel: false };
            $rootScope.$emit('bmNavDocumentTitleBeforeChange', detail);
            if (detail.cancel) { return; }

            doc.title = newTitle;
        }
    }

    function localizeMoreNavItem($translate, nav) {
        $translate('bm.nav.more.item').then(function(more) {
            nav.navmore.setMoreItemText(more);
        });
    }

    function updateSelectedNavItem($rootScope, doc, nav, url) {
        var active = findActiveNavItem(nav, url);
        if (active) {
            // close expanded lists
            nav.navmore.collapse();
            // update selected nav item
            nav.navmore.setSelected(active);
            // fire event with new selection
            $rootScope.$broadcast('bmNavSelectionChanged', {
                selected: nav.navmore.getSelected()
            });
        }
    }

    // sync active nav item with location
    function findActiveNavItem(nav, url) {
        var i, j, candidates, candidate, candidateHrefNoQuery, matches, lastHrefChar, nextUrlChar, bestMatch,
            urlNoQuery = '#' + url.split('?')[0].split('#')[1];

        // find match candidates
        candidates = angular.element(nav).find('a');
        if (!candidates.length) { return; }

        // gather matches
        matches = [];
        for (i = 0; i < candidates.length; i++) {
            candidate = candidates[i];
            if (!candidate.hasAttribute('href')) { continue; }

            // Get all the hrefs represented by this parent link
            var hrefs = ((candidate.getAttribute('href') || '') + ',' + (candidate.getAttribute('bm-href-aliases') || '')).split(',');
            for(j = 0; j < hrefs.length; j++) {

                // strip off query string
                candidateHrefNoQuery = hrefs[j].split('?')[0];
                lastHrefChar = candidateHrefNoQuery.charAt(hrefs[j].length - 1);
                nextUrlChar = urlNoQuery.charAt(candidateHrefNoQuery.length);
                if (urlNoQuery.indexOf(candidateHrefNoQuery) === 0 &&
                    (lastHrefChar === '/' || !nextUrlChar.length || nextUrlChar === '/' || nextUrlChar === '?')) {
                        matches.push({ link: candidate, href: hrefs[j] });
                }
            }
        }

        // find best (longest) match
        for (i = 0; i < matches.length; i++) {
            if (!bestMatch) {
                bestMatch = matches[i];
            } else if (matches[i].href.length > bestMatch.href.length) {
                bestMatch = matches[i];
            }
        }

        return !!bestMatch ? bestMatch.link : undefined;
    }

    bmNav.$inject = ['$window', '$document', '$location', '$rootScope', '$timeout', '$translate', 'AuthenticatedSessionData'];

    angular.module('bluemoon.components.nav', [
        'bluemoon.components.session',
        'pascalprecht.translate'
    ])

    .directive('bmNav', bmNav);

})(window.angular);

/**
 * Blue Moon Components - Staff Not Found Directive
 */
(function(angular){
    'use strict';

    function bmStaffNotFound() {
        return {
            restrict: 'EA',
            templateUrl: 'components/not-found/bm-staff-not-found.2js.html'
        };
    }

    angular.module('bluemoon.components.staffNotFound', [
    ])

    .directive('bmStaffNotFound', bmStaffNotFound);

})(window.angular);

/**
 * Blue Moon Components - Main Directive
 */
(function(angular){
    'use strict';

    function bmMain() {

        return {
            restrict: 'EA',
            templateUrl: 'components/main/main.2js.html',
            transclude: true,
            controller: [function () {
            }],
            controllerAs: 'main',
            link: function () {
            }
        };
    }

    bmMain.$inject = [];

    angular.module('bluemoon.components.main', [
    ])

    .directive('bmMain', bmMain);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.components.busyLoader', [
        'bento.busyloader'
    ])

    .value('bluemoon.components.busyLoader.defaultStartOffsetDefault', 2000)
    .value('bluemoon.components.busyLoader.defaultSize', 'default')

    .service('bmBusyLoaderDefaults', ['$injector',
        'bluemoon.components.busyLoader.defaultStartOffsetDefault',
        'bluemoon.components.busyLoader.defaultSize',
        function($injector, defaultStartOffset, defaultSize) {

            var _getValueFunction = function(key, defaultValue) {
                return function() {
                    return $injector.has(key) ? $injector.get(key) : defaultValue;
                };
            };

            this.startOffset = _getValueFunction('bluemoon.components.busyLoader.startOffset', defaultStartOffset);
            this.size = _getValueFunction('bluemoon.components.busyLoader.size', defaultSize);
    }])

    .directive('bmBusyLoader', [
        '$timeout',
        '$bentoBusyLoader',
        '$rootScope',
        'bmBusyLoaderDefaults',
        function (
            $timeout,
            $bentoBusyLoader,
            $rootScope,
            bmBusyLoaderDefaults){
            return {
                restrict: 'A',
                scope: {
                    bmBusyLoader: '='
                },
                link: function(scope, element){

                    var _defaults = {
                        offset: bmBusyLoaderDefaults.startOffset(),
                        size: bmBusyLoaderDefaults.size()
                    };

                    var _options = angular.extend({}, _defaults,
                        scope.bmBusyLoader || {});

                    var _requestTracker = 0;

                    //  Bento replaces style positions with relative, let's undo that
                    var _originalStylePosition = element[0].style.position;

                    var _busyLoader = $bentoBusyLoader.getNewLoader(element, _options.size);

                    if (_originalStylePosition) {
                        element[0].style.position = _originalStylePosition;
                    }

                    var _busyLoaderTimeout;

                    var _showLoader = function() {
                        _busyLoaderTimeout = $timeout(function(){
                            _busyLoader.show();
                        }, _options.offset);
                    };

                    var _hideLoader = function() {
                        $timeout.cancel(_busyLoaderTimeout);
                        _busyLoader.hide();
                    };

                    scope.$parent.$on('bm-busy-loading-on', function(event) {
                        if (!_requestTracker) {
                            _showLoader();
                        }
                        _requestTracker++;

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    scope.$parent.$on('bm-busy-loading-off', function(event, options) {

                        var opt = angular.extend({}, options, {});

                        if (_requestTracker === 1 || opt.forceOff) {
                            _hideLoader();
                        }

                        _requestTracker = opt.forceOff ? 0 : Math.max(0, _requestTracker - 1);

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    $rootScope.$on('$stateChangeStart', function(){
                        _hideLoader();
                        _requestTracker = 0;
                    });
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.focus', [])

    .directive('bmFocus', ['$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    scope.$watch(attrs.bmFocus, function(value) {
                        if(value) {
                            $timeout(function() {
                                element[0].focus();
                            }, 700);
                        }
                    });
                }
            };
        }
    ]);
}(window.angular));

(function(angular) {
    'use strict';

    function Permission($q, authenticatedSessionData) {
        var self = this;

        // Can be use for route resolve to determine if you have permission.
        // For example,
        // resolve: {
        //     auth: function() {
        //         return bmPermission.has('OnvioDrive.MyDocuments').catch(function () {
        //             $state.go('notfound');
        //         })
        //     }
        // }
        self.has = function(perms, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = false;

                if (angular.isArray(perms)) {
                    perms[hasEvery ? 'every' : 'some'](function(perm) {
                        granted = grants[perm] === 'Granted';
                        return granted;
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(perms) {
            return self.has(perms);
        };

        self.hasEvery = function(perms) {
            return self.has(perms, true);
        };

        self.not = function(perms, hasEvery){
            var deferred = $q.defer();
            self.has(perms, hasEvery).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(perms){
            return self.not(perms);
        };

        self.notEvery = function(perms){
            return self.not(perms, true);
        };

        self.hasFirmLicense = function(licenses, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = data.ApplicationConfiguration.Licenses;
                var granted = false;

                if (angular.isArray(licenses)) {
                    licenses[hasEvery ? 'every' : 'some'](function(license) {
                        granted = grants.indexOf(license) > -1;
                        return granted;
                    });
                } else if (typeof licenses === 'string') {
                    granted = grants.indexOf(licenses) > -1;
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSomeFirmLicense = function(licenses) {
            return self.hasFirmLicense(licenses);
        };

        // has will reject promise on false value,
        // isGranted will resolve with one or many true/false values
        self.isGranted = function(perms) {
            var deferred = $q.defer();
            authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = null;

                if (angular.isArray(perms)) {
                    granted = perms.map(function(perm) {
                        return grants[perm] === 'Granted';
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                deferred.resolve(granted);
            });
            return deferred.promise;
        };
    }

    // Given an Object tree, return flat Object with compound, dot-notated keys
    // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> {'a1.b1':'x','a1.b2.c1':'y','a2':'z'})
    function flattenObj(obj, filter) {
        var flat = {};
        function traverse(obj, key) {
            var compound, val;
            for (var prop in obj) {
                compound = key ? key + '.' + prop : prop;
                val = obj[prop];
                if (typeof val === 'object') {
                    traverse(val, compound);
                } else {
                    if (filter) {
                        if (!filter(obj, prop, compound)) { continue; }
                    }
                    flat[compound] = val;
                }
            }
        }
        traverse(obj);
        return flat;
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function permissionDirective($animate, bmPermission) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfPermWatchAction(value) {
                handlePermAttrChange('bmIfPerm', value);
            }

            function bmIfPermEveryWatchAction(value) {
                handlePermAttrChange('bmIfPermEvery', value);
            }

            function bmIfPermSomeWatchAction(value) {
                handlePermAttrChange('bmIfPermSome', value);
            }

            function bmIfNotPermWatchAction(value){
                handlePermAttrChange('bmIfNotPerm', value);
            }

            function bmIfNotPermSomeWatchAction(value){
                handlePermAttrChange('bmIfNotPermSome', value);
            }

            function bmIfNotPermEveryWatchAction(value){
                handlePermAttrChange('bmIfNotPermEvery', value);
            }

            function bmIfFirmLicenseSomeWatchAction(value) {
                handlePermAttrChange('bmIfFirmLicenseSome', value);
            }

            function handlePermAttrChange(type, value) {
                bmPermission[type === 'bmIfPermEvery' ? 'hasEvery' : type === 'bmIfNotPermEvery' ? 'notEvery' : type === 'bmIfNotPerm' || type === 'bmIfNotPermSome' ? 'not' : 'has'](value || $attr[type]).then(function() {
                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfPerm) {
                var unwatchIfPerm = $scope.$watch($attr.bmIfPerm, bmIfPermWatchAction);
            }
            if ($attr.bmIfPermEvery) {
                var unwatchIfPermEvery = $scope.$watch($attr.bmIfPermEvery, bmIfPermEveryWatchAction);
            }
            if ($attr.bmIfPermSome) {
                var unwatchIfPermSome = $scope.$watch($attr.bmIfPermSome, bmIfPermSomeWatchAction);
            }
            if($attr.bmIfNotPerm){
                var unwatchIfNotPerm = $scope.$watch($attr.bmIfNotPerm, bmIfNotPermWatchAction);
            }
            if($attr.bmIfNotPermSome){
                var unwatchIfNotPermSome = $scope.$watch($attr.bmIfNotPermSome, bmIfNotPermSomeWatchAction);
            }
            if ($attr.bmIfNotPermEvery) {
                var unwatchIfNotPermEvery = $scope.$watch($attr.bmIfNotPermEvery, bmIfNotPermEveryWatchAction);
            }
             if ($attr.bmIfFirmLicenseSome) {
                var unwatchIfFirmLicenseSome = $scope.$watch($attr.bmIfFirmLicenseSome, bmIfFirmLicenseSomeWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfPerm) { unwatchIfPerm(); }
                if (unwatchIfPermEvery) { unwatchIfPermEvery(); }
                if (unwatchIfPermSome) { unwatchIfPermSome(); }
                if (unwatchIfNotPerm) { unwatchIfNotPerm(); }
                if (unwatchIfNotPermSome) { unwatchIfNotPermSome(); }
                if (unwatchIfNotPermEvery) { unwatchIfNotPermEvery(); }
                if (unwatchIfFirmLicenseSome) { unwatchIfFirmLicenseSome(); }
            });
        }
      };
    }

    Permission.$inject = ['$q', 'AuthenticatedSessionData'];
    permissionDirective.$inject = ['$animate', 'bmPermission'];

    angular.module('bmPermission', ['bluemoon.components.session'])
        .service('bmPermission', Permission)
        .directive('bmIfPerm', permissionDirective)
        .directive('bmIfPermSome', permissionDirective)
        .directive('bmIfPermEvery', permissionDirective)
        .directive('bmIfNotPerm', permissionDirective)
        .directive('bmIfNotPermSome', permissionDirective)
        .directive('bmIfNotPermEvery', permissionDirective)
        .directive('bmIfFirmLicenseSome', permissionDirective);

 })(window.angular);

(function(angular) {
    'use strict';

    function Access($q, bmEnvironment) {
        var self = this;

        // Can be used for route resolve to determine if you have access.
        // For example,
        // resolve: {
        //     selfReg: bmAccess.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        self.has = function(accessControls, hasEvery) {
            return bmEnvironment.getEnvironmentAsync().then(function(data) {
                var grants = data.InfrastructureAccessControls;
                var granted = false;
                if (angular.isArray(accessControls)) {
                    accessControls[hasEvery ? 'every' : 'some'](function(accessControl) {
                        if (grants) {
                            granted = grants.indexOf(accessControl) > -1;
                        } else {
                            granted = false;
                        }
                        return granted;
                    });
                } else if (typeof accessControls === 'string') {
                    if (grants) {
                        granted = grants.indexOf(accessControls) > -1;
                    }
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(accessControls) {
            return self.has(accessControls);
        };

        self.hasEvery = function(accessControls) {
            return self.has(accessControls, true);
        };

        self.not = function(accessControls){
            var deferred = $q.defer();
            self.has(accessControls).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(accessControls){
            return self.not(accessControls);
        };

        self.notEvery = function(accessControls){
            return self.not(accessControls, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function accessDirective($animate, bmAccess) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasAccessWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccess', value);
            }

            function bmIfHasAccessEveryWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessEvery', value);
            }

            function bmIfHasAccessSomeWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessSome', value);
            }

            function bmIfHasNoAccessWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccess', value);
            }

            function bmIfHasNoAccessSomeWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessSome', value);
            }

            function bmIfHasNoAccessEveryWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessEvery', value);
            }

            function handleAccessAttrChange(type, value) {
                bmAccess[type === 'bmIfHasAccessEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoAccessEvery' ? 'notEvery'
                    : type === 'bmIfHasNoAccess' || type === 'bmIfHasNoAccessSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasAccess) {
                var unwatchIfHasAccess = $scope.$watch($attr.bmIfHasAccess, bmIfHasAccessWatchAction);
            }
            if ($attr.bmIfHasAccessEvery) {
                var unwatchIfHasAccessEvery = $scope.$watch($attr.bmIfHasAccessEvery, bmIfHasAccessEveryWatchAction);
            }
            if ($attr.bmIfHasAccessSome) {
                var unwatchIfHasAccessSome = $scope.$watch($attr.bmIfHasAccessSome, bmIfHasAccessSomeWatchAction);
            }
            if($attr.bmIfHasNoAccess){
                var unwatchIfHasNoAccess = $scope.$watch($attr.bmIfHasNoAccess, bmIfHasNoAccessWatchAction);
            }
            if($attr.bmIfHasNoAccessSome){
                var unwatchIfHasNoAccessSome = $scope.$watch($attr.bmIfHasNoAccessSome, bmIfHasNoAccessSomeWatchAction);
            }
            if ($attr.bmIfHasNoAccessEvery) {
                var unwatchIfHasNoAccessEvery = $scope.$watch($attr.bmIfHasNoAccessEvery, bmIfHasNoAccessEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasAccess) { unwatchIfHasAccess(); }
                if (unwatchIfHasAccessEvery) { unwatchIfHasAccessEvery(); }
                if (unwatchIfHasAccessSome) { unwatchIfHasAccessSome(); }
                if (unwatchIfHasNoAccess) { unwatchIfHasNoAccess(); }
                if (unwatchIfHasNoAccessSome) { unwatchIfHasNoAccessSome(); }
                if (unwatchIfHasNoAccessEvery) { unwatchIfHasNoAccessEvery(); }
            });
        }
      };
    }

    Access.$inject = ['$q', 'bmEnvironment'];
    accessDirective.$inject = ['$animate', 'bmAccess'];

    angular.module('bmAccess', ['bmEnvironment'])
        .service('bmAccess', Access)
        .directive('bmIfHasAccess', accessDirective)
        .directive('bmIfHasAccessSome', accessDirective)
        .directive('bmIfHasAccessEvery', accessDirective)
        .directive('bmIfHasNoAccess', accessDirective)
        .directive('bmIfHasNoAccessSome', accessDirective)
        .directive('bmIfHasNoAccessEvery', accessDirective);

 })(window.angular);

(function(angular, location){
    'use strict';

    // NOTE: May need updating when adding domains
    var countryDefaultLangMap = {
        'ar': 'es-AR',
        'au': 'en-AU',
        'br': 'pt-BR',
        'ca': 'en-CA',
        'in': 'en-IN',
        'nl': 'nl-NL',
        'uk': 'en-GB',
        'us': 'en-US'
    };

    var tldCountryOverrideMap = {
        'com': 'us'
    };

    // NOTE: Must be updated when adding languages
    var supportedLanguages = [
        {
            // standardized language code
            code: 'en-US',
            // description in given language
            description: 'English (United States)',
            // countries where this language is available
            countryCodes: [
                'us'
            ],
            // description translations for other languages supported in country
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ѕƭăƭȅš)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-GB',
            description: 'English (United Kingdom)',
            countryCodes: [
                'uk'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ќɨƞɠɗǒɱ)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-AU',
            description: 'English (Australia)',
            countryCodes: [
                'au'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ăʊšƭɾăļɨă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-CA',
            description: 'English (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'fr-CA',
                    description: 'Anglais (Canada)'
                }
            ]
        },
        {
            code: 'en-IN',
            description: 'English (India)',
            countryCodes: [
                'in'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (ɨƞɗɨă)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'fr-CA',
            description: 'Français (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƒɾăƞçăɨš (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'en-CA',
                    description: 'French (Canada)'
                }
            ]
        },
        {
            code: 'es-AR',
            description: 'Español (Argentina)',
            countryCodes: [
                'ar'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃšρăñǒļ (Ăɾɠȅƞƭɨƞă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'pt-BR',
            description: 'Português (Brasil)',
            countryCodes: [
                'br'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƥǒɾƭʊɠʊêš (ßɾăšɨļ)!!!!!!]'
                }
            ]
        },
        {
            code: 'nl-NL',
            description: 'Nederlands (Nederland)',
            countryCodes: [
                'nl'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[ƞêɗêɾļăƞɗš (ƞêɗêɾļăƞɗ)!!!!!!]'
                }
            ]
        },
        {
            code: 'xx-XX',
            description: '[Ƥšȅʊɗǒļǒĉăļɨʐȅɗ!!!!!]',
            countryCodes: [
                'us',
                'uk',
                'ca',
                'au',
                'in',
                'ar',
                'br',
                'nl'
            ],
            translations: [
                {
                    code: 'en-US',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-GB',
                    description: 'Pseudolocalised'
                },
                {
                    code: 'en-CA',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-AU',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-IN',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'es-AR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'fr-CA',
                    description: 'Pseudo Localisée'
                },
                {
                    code: 'pt-BR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'nl-NL',
                    description: 'Pseudo Gelokaliseerde'
                }
            ]
        }
    ];

    var auth0Constants = {
        domain: {
            prod: 'auth.thomsonreuters.com',
            nonProd: 'auth-nonprod.thomsonreuters.com'
        },
        onvioUSClientId: {
            prod: 'aFY7lhJ8020mivBuWVPTvGOfwCY1j0PT',
            nonProd: 'z4IjNxMseVlWLLG6KFKmf7gBaboyEWUD'
        },
        profileUrl: {
            prod: 'https://www.thomsonreuters.com',
            nonProd: 'https://www-tr-com-uat-ams.ewp.thomsonreuters.com'
        },
        myPayClientId: {
            prod: '',
            nonProd: 'S7fKW3nlDZjS0laPAwhxAOs5z3ArkLqw'
        },
        onvioUKClientId: {
            prod: 'Z4qxWZaRjgEWS1ojEqoT8GgqvRH8FuGP',
            nonProd: 'l244e5WqhQcNL7XVlkKwN4kjGyD0MdVA'
        },
        onvioCAClientId: {
            prod: 'ikcbw5dmEbuTgjiJAVi5LmiZUdMZW5Gf',
            nonProd: 'FkcfkiCZRQkdIaVOCclV4enlVTfcZVbC'
        },
        onvioCAFrClientId: {
            prod: 'QuwZR3WYIpX2miq5NpUaifgZU4SABrXc',
            nonProd: 'lMJEtc9AiJruheyGJXXdvRIgizN2TDqq'
        },
        onvioBRClientId:{
            prod: 'GBUpPpOUwBf4phSv9eIqF2xi8LSPsktK',
            nonProd: '58MkBk3Hrrzfl5gfVwjYdYOa2R6TIuGJ'
        },
        onvioBREnUsClientId:{
            prod: 'ghG5mUTaFVbHQaKwPUlGxk9MH8dUYnyr',
            nonProd: 'LJJM3fQVAKKe3SYP6c3oDdzRMPW97bDp'
        },
        onvioARClientId:{
            prod: 'cyG9HEnbS6Jt9LRVxYCDDA32HZuQDKc4',
            nonProd: 'hzFeIrZunDs73ZxKDXHNxzhoF0fgfV3h'
        },
        onbalanceBRClientId:{
            prod: 'XXWYWfoH35jr8OVLWRY5SI49UL03qpgu',
            nonProd: 'dqQWzOB6s1hZHUOunf3DD3272BTgxh2k'
        },
        onbalanceARClientId:{
            prod: 'p4HlqCux83nuFtGkLcgdpscTtA2KxVBu',
            nonProd: '8IDNPKg6WC2zpe88fbrlLQZMZqcNXIrL'
        }
    };

    var domainCountryCodePtn = /\.([a-z]+)$/,
        hostname = location.hostname.toLowerCase(),
        isProdEnv = !/^(lab\d*|qa\d*|sat\d*|localhost|\d+)\b/.test(hostname),
        isLowerEnv = /^(lab\d*|qa\d*|sat\d*)\b/.test(hostname),
        isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname),
        envType = isProdEnv ?
            'PROD' : isLowerEnv ?
                hostname.replace(/^(lab\d*|qa\d*|sat\d*)\..*/, '$1').toUpperCase() : isLocalEnv ?
                    'LOCAL' : 'UNKNOWN',
        isQedOrProd = /(PROD|SAT)/.test(envType),
        auth0DomainValue = isProdEnv ? auth0Constants.domain.prod: auth0Constants.domain.nonProd,
        auth0ClientIdValue = getAuth0ClientId(),
        auth0RegionLocaleClientIdValue = getAuth0RegionLocaleClientId(),
        auth0ProfileUrlValue = isProdEnv ? auth0Constants.profileUrl.prod: auth0Constants.profileUrl.nonProd;

    var environmentConst = {
        // caveat: if you use a machine IP address these will be false
        isProdType: isProdEnv,
        isQedOrProdType: isQedOrProd,
        // "lower" = lab, qa, or QED
        // caveat: if naming scheme stays from Onvio standard it will be false
        isLowerType: isLowerEnv,
        // caveat: if you use your IP address it will be false
        isLocalType: isLocalEnv,
        // possible values: 'PROD', 'QED', 'qa', 'lab', 'LOCAL', 'UNKNOWN'
        type: envType,
        defaultLang: getCountryDefaultLanguage(),
        auth0Domain: auth0DomainValue,
        auth0ClientId: auth0ClientIdValue,
        auth0RegionLocaleClientId: auth0RegionLocaleClientIdValue,
        auth0ProfileUrl: auth0ProfileUrlValue
    };

    function Environment($q, $http, $location, bmEnvironmentUrl){
        var factory = {
            load: getEnvironmentAsync,
            getEnvironmentAsync: getEnvironmentAsync,
            getSupportedLanguagesAsync: getSupportedLanguagesAsync,
            getCountryDefaultLanguage: getCountryDefaultLanguage,
            getCountryCode: getCountryCode,
            getPrimaryProduct: getPrimaryProduct,
            getRoute: getRoute,
            // older function-style prop to be deprecated, replaced by envConst
            isQedOrProdDomain: testQedOrProdDomain,

            /* Generated functions are available for each key in
               countryDefaultLangMap. For example,

               isUsCountryCode()
               isUkCountryCode()
               isCaCountryCode()
               isArCountryCode()
               isBrCountryCode()
            */
        };

        var environmentDeferred;

        generateCountryTestFns();
        return factory;

        ////////////////////////////////

        function testQedOrProdDomain(){
            return isQedOrProd;
        }

        function generateCountryTestFns() {
            var currentCode = getCountryCode();
            Object.keys(countryDefaultLangMap).forEach(function(code) {
                factory['is' + code.charAt(0).toUpperCase() + code.charAt(1) + 'CountryCode'] = function() {
                    return code === currentCode;
                };
            });
        }

        function getEnvironmentAsync(){
            if(environmentDeferred){
                return environmentDeferred.promise;
            }

            environmentDeferred = $q.defer();

            $http({
                method: 'GET',
                url: bmEnvironmentUrl,
                cache: true
            }).then(function(resp){
                environmentDeferred.resolve(resp.data);
            }, function(){
                environmentDeferred.resolve({});
            });

            return environmentDeferred.promise;
        }

        function getSupportedLanguagesAsync(){
            var languageList = [];
            var baseLanguages = angular.copy(supportedLanguages);

            return getEnvironmentAsync().then(function(environment){
                var locales = angular.isDefined(environment.locales) ? environment.locales : getDomainBasedLocales();

                for(var langIndex = 0; langIndex < baseLanguages.length; langIndex++){
                    if(locales.indexOf(baseLanguages[langIndex].code) >= 0){
                        languageList.push(baseLanguages[langIndex]);
                    }
                }

                return languageList;
            });
        }

        function getPrimaryProduct(){
            // default to onvio for now. may need to default to a product based on domain at some point?
            return getEnvironmentAsync().then(function(environment){
                return (environment.primaryProduct || 'onvio') || 'onvio';
            });
        }

        function getDomainBasedLocales(){
            var locales = [];
            var countryCode = getCountryCode();
            var baseLanguages = angular.copy(supportedLanguages);

            for(var counter = 0; counter < baseLanguages.length; counter++){
                if(baseLanguages[counter].countryCodes.indexOf(countryCode) >= 0){
                    locales.push(baseLanguages[counter].code);
                }
            }

            return locales;
        }

        function getRoute(routeName){
            if(angular.isUndefined(routeName) || routeName === ''){
                return $q.when('');
            }

            return getEnvironmentAsync().then(function(data){
                if(data.RoutingTable && data.RoutingTable[routeName]){
                    return data.RoutingTable[routeName];
                }

                return '';
            });
        }
    }

    function getCountryCode() {
        var matches = domainCountryCodePtn.exec(hostname);
        var tld = (matches && matches[1].toLowerCase()) || 'us';
        return tldCountryOverrideMap[tld] || tld;
    }

    // can't use $location service in config phase.
    // we need to set the default lang in angular translate during config
    function getCountryDefaultLanguage() {
        return countryDefaultLangMap[getCountryCode()] || 'en-US';
    }

    function getAuth0ClientId() {
        var url = window.location.origin;
        var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
        switch (domain) {
            case '.us':
                return isProdEnv ? auth0Constants.onvioUSClientId.prod: auth0Constants.onvioUSClientId.nonProd;
            case '.co.uk':
                return isProdEnv ? auth0Constants.onvioUKClientId.prod: auth0Constants.onvioUKClientId.nonProd;
            case '.ca':
                return isProdEnv ? auth0Constants.onvioCAClientId.prod: auth0Constants.onvioCAClientId.nonProd;
            case '.com.br':
                return isProdEnv ? auth0Constants.onvioBRClientId.prod: auth0Constants.onvioBRClientId.nonProd;
            case '.com.ar':
                return isProdEnv ? auth0Constants.onvioARClientId.prod: auth0Constants.onvioARClientId.nonProd;
        }
        domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('mypaysolutions')[1];
        switch (domain) {
            case '.com':
                return isProdEnv ? auth0Constants.myPayClientId.prod: auth0Constants.myPayClientId.nonProd;
        }
        // Validate onbalance domain onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
        domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
        switch (domain) {
            case '.com.br':
                return isProdEnv ? auth0Constants.onbalanceBRClientId.prod : auth0Constants.onbalanceBRClientId.nonProd;
            case '.com.ar':
                return isProdEnv ? auth0Constants.onbalanceARClientId.prod : auth0Constants.onbalanceARClientId.nonProd;
        }
        // For localhost projects
        // Validate pathname for samba project /smb and returns default onbalance BR client id
        if (window.location.pathname.indexOf('/smb') > -1) {
            return isProdEnv ? auth0Constants.onbalanceBRClientId.prod: auth0Constants.onbalanceBRClientId.nonProd;
        }
        return isProdEnv ? auth0Constants.onvioUSClientId.prod: auth0Constants.onvioUSClientId.nonProd;
    }

    function getAuth0RegionLocaleClientId() {
        // Later we could include other domains like .com.br with different locale
        return isProdEnv ? auth0Constants.onvioCAFrClientId.prod: auth0Constants.onvioCAFrClientId.nonProd;
    }

    Environment.$inject = ['$q', '$http', '$location', 'bmEnvironmentUrl'];
    angular.module('bmEnvironment', [])
        .factory('bmEnvironment', Environment)
        .constant('bmEnvironmentConst', environmentConst)
        .value('bmEnvironmentUrl', '/api/security/v2/environments')
        // todo: deprecate bmEnvCountryDefaultLang since it's under bmEnvironmentConst
        .constant('bmEnvCountryDefaultLang', getCountryDefaultLanguage())
        .constant('bmSupportedLanguagesMetadata', supportedLanguages);

})(window.angular, window.location);

(function(angular){
    'use strict';

    angular.module('bmUserTermsSignatory', [
        'ui.bootstrap',
        'bluemoon.components.session',
        'bmUser'
    ])
    .factory('bmUserSignatory', bmUserSignatory)
    .controller('bmTermsSignatoryCtrl', bmTermsSignatoryCtrl)
    .directive('bmTermsSignatory',['$uibModal', 'AuthenticatedSession', 'bmUserSignatory', function($uibModal, session, bmUserSignatory){
        return {
            restrict: 'EA',
            link: function(){
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    // Any signatories required?
                    if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isUndefined(signatory.signatory)){
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/terms-signatory/terms-signatory-modal.2js.html',
                            controller: 'bmTermsSignatoryCtrl as vm',
                            size: 'lg',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                termsText: function(){
                                    return signatory.terms.text;
                                }
                            }
                        });

                        modalInstance.result.then(function(isSigned){
                            if(isSigned){
                                // Process signatory
                                bmUserSignatory.setSignatoryForTermsAsync(signatory.terms.id);
                            } else {
                                // Redirect to login page
                                session.destroy();
                            }
                        });
                    }
                }, function(response){
                    if (response) {
                        // Don't propogate error
                        response.config.global = false;
                    }
                });
            }
        };
    }]);

    //////////

    bmUserSignatory.$inject = ['$log', '$q', '$http','bmUser', 'AuthenticatedSessionData'];
    function bmUserSignatory($log, $q, $http, bmUser, sessionData){
        var factory = {
            getRequiredUserSignatoryAsync: getRequiredUserSignatoryAsync,
            setSignatoryForTermsAsync: setSignatoryForTermsAsync
        };

        return factory;

        //////////

        function getRequiredUserSignatoryAsync(){
            var signatory = { terms: undefined, signatory: undefined };

            return sessionData.getMeta().then(function(data) {
                // don't require user to accept terms if 'viewing portal as'
                if (!angular.isUndefined(data.EmulateePrismGuid)) {
                    return signatory;
                }

                return bmUser.load().then(function(){

                    return loadActiveTermsAsync(bmUser.companyId, bmUser.language).then(function(terms){
                        if(angular.isUndefined(terms)){
                            return signatory;
                        }

                        signatory.terms = terms;

                        return loadUserSignatoryForTermsAsync(bmUser, terms.id).then(function(data){
                            signatory.signatory = data;
                            return signatory;
                        });
                    });
                });
            });
        }

        function setSignatoryForTermsAsync(termsId){
            return bmUser.load().then(function(){
                return $http({
                    method: 'POST',
                    url: '/api/profiles/v1/companies/' + bmUser.companyId + '/terms/' + termsId + '/signatories',
                    headers: {
                        'Accept-Language': bmUser.language
                    },
                    data: { termsId: termsId, bluid: bmUser.bluId }
                }).then(function(response){
                    return response;
                }, function(response){
                    response.config.global = false;
                });
            });
        }

        //////////

        function loadActiveTermsAsync(companyId, language){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + companyId + '/terms/active',
                headers: {
                    'Accept-Language': language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no active terms found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for active terms is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }

        function loadUserSignatoryForTermsAsync(user, termsId){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + user.companyId + '/terms/' + termsId + '/signatories/' + user.bluId,
                headers: {
                    'Accept-Language': user.language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no signatory found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for signatories is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }
    }

    //////////

    bmTermsSignatoryCtrl.$inject = ['$sce', '$uibModalInstance', 'termsText'];
    function bmTermsSignatoryCtrl($sce, $uibModalInstance, termsText){
        /*jshint validthis:true */
        var vm = this;
        vm.setAgreement = setAgreement;
        vm.displayText = $sce.trustAsHtml(convertTermsTextToHtml(termsText));

        //////////

        function setAgreement(agreed){
            $uibModalInstance.close(agreed);
        }

        function convertTermsTextToHtml(text){
            return text.replace(/\r\n|\n\r|\n|\r/g, '<br />');
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    /* EXPORT */
    angular.module('bmUser', ['bluemoon.myAccount', 'bluemoon.components.util', 'bluemoon.components.i18n'])
        .service('bmUser', User);

    User.$inject = ['$window', 'myAccountService', 'bmUtil', 'bmLanguageManager', 'bmLanguageCookieName'];

    /**
     * Intrinsic current user
     */
    function User(window, usersService, util, langMgr, langCookieName) {
        var self = this;
        var imgDataPrefix = 'data:image;base64,';
        var loadPromise;

        /* PROPS */
        function init() {
            // id (string, optional): TRuid associated with this user in IAM,
            self.id = '';
            // email (string, optional): Email address,
            self.email = '';
            // firstName (string, optional): User's given name,
            self.firstName = '';
            // middleName (string, optional): User's middle name,
            self.middleName = '';
            // lastName (string, optional): User's last or family name,
            self.lastName = '';
            // suffix (string, optional): Post-nominal letters appended to a user's common name,
            self.suffix = '';
            // language (string, optional): User's first language,
            self.language = '';
            // photo (string, optional): User's profile photo,
            self.photo = '';
            // bluId (string, optional): BLUid or PrismGuid associated with this user,
            self.bluId = '';
            // companyId (string, optional): CompanyId associated with this user,
            self.companyId = '';
            // contactId (string, optional): ContactId associated with this user,
            self.contactId = '';
            // licensee (boolean, optional): User is a licensee for CSWeb
            self.licensee = false;
        }

        /* COMPUTEDS */
        window.Object.defineProperties(self, {
            'fullName': {
                enumerable: true,
                get: function() {
                    var delimiter = ' ';
                    // if (useMiddle === true && self.middleName) { delimiter += self.middleName + delimiter; }
                    return (self.firstName + delimiter + self.lastName).trim();
                }
            },
            'initials': {
                enumerable: true,
                get: function() {
                    var delimiter = '';
                    // if (useMiddle === true && self.middleName) { delimiter = self.middleName.charAt(0); }
                    return self.firstName.charAt(0) + delimiter + self.lastName.charAt(0);
                }
            },
            'languages': {
                enumerable: true,
                get: function() {
                    var prefs = [];

                    // cookie
                    var cookiePref = util.cookie(langCookieName);
                    if (cookiePref) { prefs.push(cookiePref); }

                    // service data
                    var asyncPref = self.language;
                    if (asyncPref) { prefs.push(asyncPref); }

                    // browser prefs
                    var navPrefs = window.navigator.languages;
                    if (navPrefs && navPrefs.length) {
                        prefs = prefs.concat(navPrefs);
                    } else {
                        // msie < 11
                        navPrefs = window.navigator.browserLanguage;
                        if (navPrefs) { prefs.push(navPrefs); }
                    }

                    return util.uniq(prefs); // elim dupes
                }
            }
        });

        /* METHODS */
        self.init = init;
        self.load = function(reload) {
            if (!loadPromise || reload === true) {
                loadPromise = usersService.getMyUserSettingsAsync();
                loadPromise.then(function(resp) {
                    if (resp.data.photo) {
                        resp.data.photo = imgDataPrefix + resp.data.photo;
                    }
                    // update data
                    util.extend(self, resp.data);

                    if (self.language) {
                        // update current lang to user's pref
                        langMgr.setUserLanguageAsync(self.language);
                    }
                });
            }

            return loadPromise;
        };
        self.save = function() {
            var obj;

            if (self.photo) {
                obj = angular.copy(self);
                obj.photo = obj.photo.split(';base64,')[1];
            } else {
                obj = self;
            }

            return usersService.saveUserAsync(obj);
        };

        init();
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmFileReader', []);
})(window.angular);

(function(angular, FileReader){
    // http://odetocode.com/blogs/scott/archive/2013/07/03/building-a-filereader-service-for-angularjs-the-service.aspx
    // Note: Possible shim for IE 9 https://github.com/moxiecode/moxie
    'use strict';

    angular.module('bmFileReader').factory('bmFileReader', fileReader);
    fileReader.$inject = ['$q'];

    function fileReader($q)
    {
        return {
            readAsDataURL: readAsDataURL
        };

        /////////////

        function readAsDataURL(file, scope){
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);
            return deferred.promise;
        }

        function onLoad(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.resolve(reader.result);
                });
            };
        }

        function onError(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.reject(reader.result);
                });
            };
        }

        function onProgress(reader, scope){
            return function(event){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$broadcast('fileProgress',
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        }

        function getReader(deferred, scope){
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        }
    }
})(window.angular, window.FileReader);

(function(angular){
    'use strict';

    angular.module('bmFileReader').directive('fileUploadPreview', filePreview);

    // TODO: COMPLETELY COPIED FROM STAFF. NEED TO REMOVE FROM STAFF.
    function filePreview(){
        return {
            scope: {
                previewCallback: '&previewCallback'
            },
            link: function(scope, element){
                element.bind('change', function(e){
                    var file = (e.srcElement || e.target).files[0];

                    // User defined callback to handle result of file read
                    scope.previewCallback({file: file});
                });
            }
        };
    }
})(window.angular);

(function (angular, Math) {
    'use strict';

    angular.module('bmImageUploadModal', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'angularFileUpload',
        'bmFileReader',
        'uiCropper',
        'bento.services',
        'bento.progressbar'
    ])

    .controller('bmImageUploadModalCtrl', [
        '$q', '$scope', '$uibModalInstance', '$translate', '$timeout', 'bmFileReader', 'config',
        function ($q, $scope, $uibModalInstance, $translate, $timeout, bmFileReader, config) {
            /*jshint validthis:true */
            var vm = this;

            vm.fileOnChange = fileOnChange;
            vm.close = closeModal;
            vm.save = saveImage;
            vm.cancel = cancelModal;
            vm.delete = deleteImage;
            vm.resetAlerts = resetAlerts;
            vm.croppedImage = '';
            vm.progress = 0;
            vm.aspectRatio = Number(config.aspectRatio);

            vm.blockingObject = { block: true };

            vm.cropper = {
                cropWidth: $scope.rectangleWidth,
                cropHeight: $scope.rectangleHeight
            };

            vm.rectangleWidth = 100;
            vm.rectangleHeight = 100;
            vm.areaInitSize = angular.isDefined(config.areaInitSize) ? config.areaInitSize : { w: vm.cropper.cropWidth, h: vm.cropper.cropHeight };
            vm.areaMinSize = angular.isDefined(config.areaMinSize) ? config.areaInitSize : undefined;
            vm.resultImageSize = angular.isDefined(config.resultImageSize) ? config.resultImageSize : undefined;

            vm.progressType = 'danger';
            vm.alerts = [];
            vm.cropShape = angular.isDefined(config.cropShape) && config.cropShape !== 'circle' ? config.cropShape : 'circle';
            vm.currentImage = angular.isDefined(config.image) && config.image !== '';
            vm.deletable = config.deletable;
            vm.options = angular.isDefined(config.options) ? config.options : undefined;
            vm.hasOptions = vm.options && vm.options.choices && vm.options.choices.length > 0;
            if(vm.hasOptions) {
                vm.options.selectedValue = vm.options.choices[0];
            }

            // configurable text options
            var promises = [
                $translate('bm.image.upload.title'),
                $translate('bm.image.upload.dragImage'),
                $translate('bm.image.upload.uploadImageButton'),
                $translate('bm.image.upload.deleteImageButton'),
                $translate('bm.image.upload.uploadAnotherImage'),
                $translate('bm.image.upload.saveImageButton')
            ];

            $q.all(promises).then(function (values) {
                vm.uploadTitleText = angular.isDefined(config.uploadTitleText) ? config.uploadTitleText : values[0];
                vm.dragImageText = angular.isDefined(config.dragImageText) ? config.dragImageText : values[1];
                vm.uploadImageButtonText = angular.isDefined(config.uploadImageButtonText) ? config.uploadImageButtonText : values[2];
                vm.deleteImageButtonText = angular.isDefined(config.deleteImageButtonText) ? config.deleteImageButtonText : values[3];
                vm.uploadAnotherImageText = angular.isDefined(config.uploadAnotherImageText) ? config.uploadAnotherImageText : values[4];
                vm.saveImageButtonText = angular.isDefined(config.saveImageButtonText) ? config.saveImageButtonText : values[5];
            });

            $scope.$on('fileProgress', function (e, progress) {
                var progressValue = Math.round((progress.loaded / progress.total) * 100);
                var progressType;

                if (progressValue < 25) {
                    progressType = 'danger';
                } else if (progressValue < 50) {
                    progressType = 'warning';
                } else if (progressValue < 75) {
                    progressType = 'info';
                } else {
                    progressType = 'success';
                }

                setProgress(progressValue, progressType);
            });

            $scope.optionChoiceCheckboxClick = function optionChoiceCheckboxClick(event) {
                $scope.vm.options.selectedValue = event.currentTarget.value;
                // force exactly one checkbox to be checked
                var checkboxes = document.querySelectorAll('input[class="option-choice-checkbox"]');
                checkboxes.forEach(function(item) {
                    if (item !== event.currentTarget) {
                        item.checked = false;
                    } else {
                        item.checked = true;
                    }
                });
            };
            ///////////

            function fileOnChange(files, event, rejectedFiles) {
                resetAlerts();

                if (files && files.length > 0) {
                    // Only selection/drop of one image
                    if (files.length > 1) {
                        $translate('bm.header.profileDialog.multipleFileMessage').then(function (value) {
                            addAlert(value, 'warning');
                        });

                        return;
                    }

                    bmFileReader.readAsDataURL(files[0], $scope).then(function (result) {
                        setProgress();

                        if (result.indexOf('data:image') >= 0) {
                            vm.selectedImageSrc = result;
                            return;
                        }

                        $translate('bm.header.profileDialog.invalidFileMessage').then(function (value) {
                            addAlert(value, 'warning');
                        });
                    }, function () {
                        setProgress();

                        $translate('bm.header.profileDialog.fileReadMessage').then(function (value) {
                            addAlert(value, 'danger');
                        });
                    });
                } else if (angular.isDefined(rejectedFiles) && rejectedFiles.length > 0) {
                    $translate('bm.header.profileDialog.invalidFileMessage').then(function (value) {
                        addAlert(value, 'warning');
                    });
                }
            }

            function setProgress(progress, progressType) {
                // Needed to update watch parameters set on scope for bento-progressbar
                $timeout(function () {
                    vm.progress = progress || 0;
                    vm.progressType = progressType || 'danger';
                }, 0);
            }

            function saveImage() {
                $uibModalInstance.close({ image: vm.croppedImage, selectedOptionValue: vm.hasOptions ? vm.options.selectedValue : undefined });
            }

            function closeModal() {
                $uibModalInstance.dismiss('close');
            }

            function deleteImage() {
                $uibModalInstance.close('');
            }

            function cancelModal() {
                $uibModalInstance.dismiss('cancel');
            }

            function addAlert(message, type) {
                resetAlerts();
                vm.alerts.push({ msg: message, type: type, closeable: true });
            }

            function resetAlerts() {
                vm.alerts = [];
            }
        }])

    .directive('bmImageUploadModal', ['$uibModal', function ($uibModal) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                    api: '='
                },
                link: function (scope) {
                    // provide an api to allow public configuration to  consumer directives
                    scope.internalApi = scope.api || {};

                    // public method for opening upload modal
                    scope.internalApi.openImageUploadModal = function (config) {
                        // setup the modal dialog
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/bm-image-upload-modal/bm-image-upload-modal.2js.html',
                            controller: 'bmImageUploadModalCtrl as vm',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                config: function () {
                                    return config;
                                }
                            }
                        });

                        modalInstance.result.then(function (result) {
                            // return the selected option
                            if(angular.isDefined(config.options) && angular.isDefined(config.options.selectedChoiceCallback)) {
                                config.options.selectedChoiceCallback(result.selectedOptionValue);
                            }
                            if(result === '') {
                                // to remove selected image
								config.imageUploadCallback('');
							} else {
                                 // return the selected image
                                config.imageUploadCallback(result.image);
                            }
                        }, function () {
                            // return nothing for consumer response to cancel action
                            if(angular.isDefined(config.options) && angular.isDefined(config.options.selectedChoiceCallback)) {
                                config.options.selectedChoiceCallback();
                            }
                            config.imageUploadCallback();
                        });
                    };
                }
            };
        }]);
})(window.angular, window.Math);

(function(angular){
    'use strict';

    angular.module('bmProfilePhoto', [
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bmImageUploadModal'
    ])

    .controller('bmProfilePhotoSelectCtrl', ['bmPermission', 'bmModal','$q', '$scope', '$timeout', '$rootScope', '$translate', function(bmPermission, bmModal,$q, $scope, $timeout, $rootScope, $translate){
        /*jshint validthis:true */
        var vm = this;
        var uploadConfig = {
            imageUploadCallback: imageUploadCallback
        };
        vm.isNewMenu = angular.isDefined(vm.isNewMenu) ? vm.isNewMenu : false;
        // pick up translated strings
        $rootScope.$on('$bmLanguageChangeSuccess', function () {
            uploadConfig.uploadTitleText = $translate.instant('bm.header.profileDialog.header');
            uploadConfig.dragImageText = $translate.instant('bm.header.profileDialog.dragPhoto');
            uploadConfig.uploadImageButtonText = $translate.instant('bm.header.profileDialog.selectPhoto');
            uploadConfig.deleteImageButtonText = $translate.instant('bm.header.profileDialog.deletePhoto');
            uploadConfig.uploadAnotherImageText = $translate.instant('bm.header.profileDialog.uploadAnotherPhoto');
            uploadConfig.saveImageButtonText = $translate.instant('bm.header.profileDialog.setAsProfilePhoto');
        });

        // provide a shared api with the upload controller for sharing open function
        vm.imageUploadApi = vm.imageUploadApi || {};

        vm.openProfileSelect = function(){
            if(!vm.selectEnabled){
                return;
            }

            uploadConfig.image = vm.image;
            uploadConfig.cropShape = vm.cropShape;
            uploadConfig.deletable = true;
            vm.imageUploadApi.openImageUploadModal(uploadConfig);
        };

        $scope.$watch('vm.image', function(newValue, oldValue){
            if(angular.isDefined(newValue)){
                if(newValue !== ''){
                    vm.selectedStyle = { 'background-image' : 'url(' + newValue + ')' };
                } else if(angular.isDefined(oldValue) && oldValue !== '') {
                    // remove old photo style
                    vm.selectedStyle = undefined;
                }
            }
        });

        $scope.$watch('vm.viewOnly()', function(newValue){
            vm.selectEnabled = !newValue;
        });

        /////////////
        vm.openPhotoModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    vm.showUnauthorizedModal();
                }).catch(function () {
                    vm.openProfileSelect();
                });
        };
        vm.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        function imageUploadCallback(profileImage){
            // undefined value means the photo selection was dismissed with no changes being made
            if(angular.isUndefined(profileImage)){
                return;
            }

            vm.image = profileImage;
            $timeout(function() {
                $scope.$emit('bmProfilePhotoSelected', profileImage);
            });
        }
    }])

    .directive('bmProfilePhotoSelect',[function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'components/profile-photo-select/profile-photo-select.2js.html',
            scope: {
                image: '=',
                size: '@',
                shape: '@',
                cropShape: '@',
                viewOnly: '&',
                initials: '@',
                isNewMenu: '=?'
            },
            controller: 'bmProfilePhotoSelectCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular){
    'use strict';

    var module = angular.module('bmUserAvailability', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmUser'
    ]);

    module.directive('bmUserAvailability', ['$q', '$translate', '$rootScope', 'bmStaffAvailabilityManager',
        function($q, $translate, $rootScope, staffAvailabilityManager){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/bm-user-availability/bm-user-availability.2js.html',
                scope: {
                },
                link: function(scope){
                    var user;

                    // set defaults
                    scope.statusText = {};
                    scope.selectedDot = 'gray';
                    scope.availabilityText = '';
                    scope.changeStatus = changeStatus;
                    scope.changeStatusText = changeStatusText;

                    // only load/refresh status when the profile menu is opened
                    $rootScope.$on('bmProfileMenuOpened', function(){
                        loadViewData();
                    });

                    ///////////////

                    function loadViewData(){
                        var promises = [
                            $translate('bm.header.status.available'),
                            $translate('bm.header.status.away'),
                            $translate('bm.header.status.busy'),
                            $translate('bm.header.status.offline'),
                            $translate('bm.header.status.idle'),
                            $translate('bm.header.status.online')
                        ];

                        $q.all(promises).then(function(results){
                            scope.statusText.available = results[0];
                            scope.statusText.away = results[1];
                            scope.statusText.busy = results[2];
                            scope.statusText.offline = results[3];

                            // call after translations in case an error is thrown and rejects $q.all
                            staffAvailabilityManager.getUserAvailability().then(function(userAvailability){
                                user = userAvailability;
                                setStatusDisplay(userAvailability);
                            }, function(){
                                user = {};
                                setStatusDisplay(undefined);
                            });
                        });
                    }

                    function setStatusDisplay(userAvailability){
                        if(angular.isUndefined(userAvailability)){
                            $translate(scope.statusText.offline).then(function(str) {
                                scope.availabilityText = str;
                            });
                            scope.selectedDot = 'gray';
                            return;
                        }

                        if(angular.isUndefined(userAvailability.statusMessage) || userAvailability.statusMessage === ''){
                            userAvailability.statusMessage = userAvailability.status;
                        }

                        var transId = 'bm.header.status.' + userAvailability.statusMessage.toLowerCase();
                        $translate(transId, {}, '', userAvailability.statusMessage).then(function(str) {
                            scope.availabilityText = str;
                        });

                        switch(userAvailability.status){
                            case 'Away':
                                scope.selectedDot = 'yellow';
                                break;
                            case 'Available':
                            case 'Online':
                                scope.selectedDot = 'green';
                                break;
                            case 'Busy':
                                scope.selectedDot = 'red';
                                break;
                            default:
                                scope.selectedDot = 'gray';
                        }
                    }

                    function changeStatus(status, color){
                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.statusText[status.toLowerCase()];
                        updatedUser.status = status;

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;
                            scope.selectedDot = color;
                            scope.availabilityText = updatedUser.statusMessage;
                        });
                    }

                    function changeStatusText(){
                        // did the text even change?
                        if(scope.availabilityText === user.statusMessage){
                            return;
                        }

                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.availabilityText;

                        if(scope.selectedDot === 'gray'){
                            updatedUser.status = 'Available';
                        }

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;

                            if(scope.selectedDot === 'gray'){
                                scope.selectedDot = 'green';
                            }
                        });
                    }
                }
            };
        }
    ]);

    module.factory('bmStaffAvailabilityManager', availablityManager);
    availablityManager.$inject = ['$http', 'bmUser'];

    function availablityManager($http, bmUser){
        var factory = {
            getUserAvailability: getUserAvailability,
            updateUserStatus: updateUserStatus
        };

        var api = '/api/profiles/v1/staff-availability';

        return factory;

        //////////

        function getUserAvailability(){
            return bmUser.load().then(function(){
                return $http.get(api + '/' + bmUser.contactId).then(function(resp){
                    if(angular.isUndefined(resp) || angular.isUndefined(resp.data) || angular.isUndefined(resp.data.staffAvailability) === 0){
                        return undefined;
                    }

                    var people = resp.data.staffAvailability;
                    var user = people.filter(function(person){
                        return person.self;
                    });

                    return user.length === 0 ? undefined : user[0];
                });
            });
        }

        function updateUserStatus(user){
            return $http({
                method: 'PUT',
                url: api,
                data: user
            });
        }
    }
})(window.angular);

(function(w, angular){
  'use strict';

  var module = angular.module('bmClientNotificationsList', ['pascalprecht.translate', 'bmJobQueue']);
  var notificationOptions = {
    itemsPerPage: 50,
    pageNumber: 1,
    scroller: undefined,
    scrollerWrapper: undefined,
    onScrollHandler: undefined,
    allLoaded: false,
    cleanUpScroller: undefined
  };

  // find the location of the element within the view
  function getOffset(el) {
    el = el.getBoundingClientRect();

    // rounding because IE is dumb
    return {
      left: w.Math.round(el.left + (w.scrollX || w.pageXOffset)),
      top: w.Math.round(el.top + (w.scrollY || w.pageYOffset)),
      bottom: w.Math.round(el.bottom + (w.scrollY  || w.pageYOffset))
    };
  }

  // taken directly from underscore _.now
  var now = Date.now || function(){
    return new Date().getTime();
  };

  // taken directly from underscore _.throttle
  var throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;

    if(!options){
      options = {};
    }

    var later = function(){
      previous = options.leading === false ? 0 : Date.now || now();
      timeout = null;
      result = func.apply(context, args);

      if(!timeout){
        context = args = null;
      }
    };

    var getNow = function(){
      return now;
    };

    return function(){
      var now = getNow();

      if(!previous && options.leading === false){
        previous = now;
      }

      var remaining = wait - (now - previous);
      context = this;
      args = arguments;

      if(remaining <= 0 || remaining > wait){
        if (timeout){
          clearTimeout(timeout);
          timeout = null;
        }

        previous = now;
        result = func.apply(context, args);

        if(!timeout){
          context = args = null;
        }
      } else if(!timeout && options.trailing !== false){
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  };

  module.directive('bmClientNotificationsList', ['$window', '$timeout', '$translate', 'bmClientNotificationsListManager', 'bmLanguageManager',
      function($window, $timeout, $translate, notificationsManager, bmLanguageManager){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'components/client-notifications/client-notifications-list.2js.html',
      link: function($scope){
        var itemsPerPage = notificationOptions.itemsPerPage;
        var scrollHandler = onScrollHandler;
        var notificationMap;

        $scope.isLoading = false;
        $scope.hasZeroItems = true;
        $scope.markAllNotificationsRead = markAllNotificationsRead;
        $scope.markNotificationRead = markNotificationRead;
        $scope.deleteNotification = deleteNotification;
        $scope.getFormattedTime = getFormattedTime;

        // respond to profile menu events for loading notifications
        $scope.$on('bmProfileMenuOpened', handleOpenedMenu);
        $scope.$on('bmProfileMenuClosed', handleClosedMenu);

        // get translated tooltip for delete notification
        $translate('bm.components.common.delete').then(function(value){
          $scope.deleteTranslated = value;
        }, function(){
          $scope.deleteTranslated = 'Delete';
        });

        $scope.notifications = [];
        notificationOptions.scrollerWrapper = 'bm-ntfs-vertical-container';

        ////////////

        function loadNotifications(whichPage){
          $scope.isLoading = true;

          return notificationsManager.getNotificationList(whichPage, itemsPerPage).then(function(data){
            if(angular.isDefined(data) && angular.isDefined(data.items) && data.items.length > 0){
                $scope.hasZeroItems = false;
                notificationMap = notificationMap || {};

                // sort the items to display by most current descending
                data.items.sort(sortByDatesDescending);

                var currentItem;
                var newItems = [];

                // weed out any dupes
                for(var counter = 0; counter < data.items.length; counter++){
                  currentItem = data.items[counter];

                  // already loaded this notification?
                  if(notificationMap[currentItem.id]){
                    continue;
                  }

                  notificationMap[currentItem.id] = currentItem.id;
                  newItems.push(currentItem);
                }

                if(newItems.length > 0){
                  $scope.notifications = $scope.notifications.concat(newItems);
                }

                // hedge our bets just in case more notifications are returned than the total
                // or there are a bunch of dupes
                if($scope.notifications.length >= data.totalItems || data.items.length < itemsPerPage){
                  notificationOptions.allLoaded = true;
                } else if(angular.isUndefined(notificationOptions.onScrollHandler)){
                  // setup scroll handler to fire paging/scrolling events
                  notificationOptions.onScrollHandler = scrollHandler;
                }

                $scope.isLoading = false;
              } else {
                $scope.hasZeroItems = $scope.notifications.length === 0;
                $scope.isLoading = false;
              }
          }, function(){
              $scope.hasZeroItems = $scope.notifications.length === 0;
              $scope.isLoading = false;
          });
        }

        function onScrollHandler(){
          if(!$scope.isLoading && !notificationOptions.allLoaded){
            // get the viewport position of the last element
            var elements = document.querySelectorAll('.bm-last-notification');
            var element = elements[0];
            var positionFromTop = getOffset(element).top;

            // get the viewport position of the wrapper
            var wrapperElement = document.getElementById(notificationOptions.scrollerWrapper);
            var wrapperOffsets = getOffset(wrapperElement);

            // TODO: COULD TRY TO CALCULATE A BETTER LOADING SCENARIO USING WRAPPER HEIGHT
            // var wrapperHeight = wrapperOffsets.bottom - wrapperOffsets.top;

            // near the bottom of the scroller area - within 300 pixels (approximately 5 items) of the bottom
            if(positionFromTop - wrapperOffsets.bottom < 300){
              // TODO: THIS IS GOING TO NEED TO BE MORE COMPLICATED LOGIC
              loadNotifications(Math.floor($scope.notifications.length / itemsPerPage) + 1);
            }
          }
        }

        function handleOpenedMenu(){
          // always reload notifications when menu is opened in order to sync across sessions
          loadNotifications(1);
        }

        function handleClosedMenu(){
          // reset the notification settings so everything is reloaded fresh
          // give the profile menu some time to close before reset
          $timeout(function(){
            $scope.notifications = [];
            $scope.hasZeroItems = true;
            notificationMap = {};

            // remove notifications and cleanup
            if(angular.isDefined(notificationOptions.cleanUpScroller)){
              notificationOptions.cleanUpScroller();
            }
          }, 200);
        }

        function markAllNotificationsRead(){
          notificationsManager.markAllNotificationsRead().then(function(){
            // loop through current infiniteItems and mark them all as read
            angular.forEach($scope.notifications, function(notification){
              notification.unread = false;

              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead', { all: true });
            });
          });
        }

        function markNotificationRead(notification, event){
          var isBoundHtmlClick = angular.isDefined(event.target.href) && event.target.href !== '';

          // already read?
          if(!notification.unread){
            if(isBoundHtmlClick){
              $scope.$emit('bmNotificationHtmlClick');
            }

            return;
          }

          notificationsManager.markNotificationRead(notification).then(function(){
            notification.unread = false;

            if(isBoundHtmlClick){
              // close of menu will trigger unread count update
              $scope.$emit('bmNotificationHtmlClick');
            } else {
              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead');
            }
          });
        }

        function deleteNotification(notification, index){
          notificationsManager.deleteNotification(notification).then(function(){
            $scope.notifications.splice(index, 1);
            delete notificationMap[notification.id];

            // update count badges if deleted item was unread
            if(notification.unread){
              $scope.$emit('bmNotificationMarkedAsRead');
            }

            if($scope.notifications.length === 0){
              $scope.hasZeroItems = true;
            }

            // force a load of notifications if list is getting small as scroll event won't fire
            if(!$scope.isLoading && !notificationOptions.allLoaded && $scope.notifications.length < 30){
              loadNotifications(1);
            }
          });
        }

        function getFormattedTime(time){
          if(!time){
            return '';
          }

          if($window.moment){
            $window.moment.locale(bmLanguageManager.getCurrentLanguage());
            var now = $window.moment.utc();
            var notificationTime = $window.moment.utc(time);

            // today
            if(now.diff(notificationTime, 'days') <= 0){
              return notificationTime.from(now);
            }

            // different year
            if(now.diff(notificationTime, 'years') > 0){
              return notificationTime.format('MMMM D, YYYY');
            }

            return notificationTime.format('MMMM D');
          }

          return (new Date(time)).toLocaleString();
        }

        function sortByDatesDescending(first, second){
          var firstDate = (new Date(first.timestamp)).getTime();
          var secondDate = (new Date(second.timestamp)).getTime();

          if(isNaN(firstDate) && isNaN(secondDate)){
            return 0;
          }

          if(isNaN(firstDate)){
            return 1;
          }

          if(isNaN(secondDate)){
            return -1;
          }

          return secondDate - firstDate;
        }
      }
    };
  }]);

  module.directive('bmNotificationsLastRepeatTask', [function(){
    return function(scope) {
      // only 1 item in the list?
      if(scope.$first && scope.$last){
        return;
      }

      // initialize scroll events once the last repeated element is in the dom
      if(scope.$last){
        if(angular.isUndefined(notificationOptions.scroller) && angular.isDefined(notificationOptions.onScrollHandler)){
          var throttledScroll = throttle(notificationOptions.onScrollHandler);

          // reference the wrapper element
          notificationOptions.scroller = w.document.getElementById(notificationOptions.scrollerWrapper);
          notificationOptions.scroller.onscroll = throttledScroll;
          notificationOptions.cleanUpScroller = function(){
            notificationOptions.scroller.onscroll = null;
            notificationOptions.scroller = undefined;
            notificationOptions.onScrollHandler = undefined;
            notificationOptions.allLoaded = false;
          };
        }
      }
    };
  }]);

  module.factory('bmClientNotificationsListManager', notificationsManager);
  notificationsManager.$inject = ['$http'];

  function notificationsManager($http){
    var api = '/api/notifications/v1/notifications';

    return {
        getNotificationList: getNotificationList,
        getUnreadNotificationCounts: getUnreadNotificationCounts,
        markNotificationRead: markNotificationRead,
        markAllNotificationsRead: markAllNotificationsRead,
        deleteNotification: deleteNotification
    };

    //////////////////

    function getNotificationList(pageNumber, itemsPerPage){
        if(angular.isUndefined(pageNumber)){
          pageNumber = notificationOptions.pageNumber;
        }

        if(angular.isUndefined(itemsPerPage)){
          itemsPerPage = notificationOptions.itemsPerPage;
        }

        var httpConfig = {
            method: 'GET',
            url: api + '?types=direct&itemsPerPage=' + itemsPerPage + '&pageNumber=' + pageNumber
        };

        return $http(httpConfig).then(function(response){
            return response.data;
        });
    }

    function getUnreadNotificationCounts(){
      // cache for 5 seconds
      return $http({
        method: 'GET',
        url: api + '/unread',
        bmCache: 5000
      }).then(function(response) {
        return response.data;
      }, function(response){
        response.config.global = false;
      });
    }

    function markNotificationRead(notification){
      return $http({
        method: 'POST',
        url: api + '/read/' + notification.id
      });
    }

    function markAllNotificationsRead(){
      return $http({
        method: 'POST',
        url: api + '/read'
      });
    }

    function deleteNotification(notification){
      return $http({
        method: 'DELETE',
        url: api + '/' + notification.id
      });
    }
  }
})(window, window.angular);

(function(RegExp, angular){
  'use strict';

  // https://code.angularjs.org/1.5.11/docs/guide/forms - modifying built-in validators
  angular.module('bmValidateEmail', [])
  .directive('bmValidateEmail', function(){
    // taken from staff center contact setup validation
    var EMAIL_REGEXP = new RegExp('^((([a-z]|\\d|[!#\\$%&\'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&\'\\*\\+\\-' +
      '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
      '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
      '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
      '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
      '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

    return {
      require: 'ngModel',
      restrict: '',
      link: function(scope, elm, attrs, ctrl) {
        // only apply the validator if ngModel is present and Angular has added the email validator
        if (ctrl && ctrl.$validators.email){
          // this will overwrite the default Angular email validator
          ctrl.$validators.email = function(modelValue){
              //The above regex is handling all special chars except DOT(.), so just added that condition check below.
            return ctrl.$isEmpty(modelValue) || ((EMAIL_REGEXP.test(modelValue) && modelValue.charAt(modelValue.length - 1) !== '.'));
          };
        }
      }
    };
  });
})(window.RegExp, window.angular);

(function(angular){
  'use strict';

  angular.module('bmCheckpointCredentials', [
    'pascalprecht.translate',
    'bento.modern',
    'bmPermission'
  ])
  .constant('bmCheckpointRoutes', {
    checkpointSetCredsApi: '/api/workpapers/v1/CheckpointLogin',
    checkpointExistsApi: '/api/workpapers/v1/CheckpointLogin/exists',
    checkpointSessionApi: '/api/smart/integration/v1/sessions'
  })
  .service('bmCheckpointManager', bmCheckpointManager)
  .component('bmCheckpointCredentials', {
    bindings: {
      sharedData: '='
    },
    templateUrl: 'components/checkpoint-engage/checkpoint-engage.2js.html',
    controller: CheckpointCredentialsController,
  });

  // Component Implementation
  CheckpointCredentialsController.$inject = ['$scope', '$translate', 'bmPermission', 'bmCheckpointManager'];
  function CheckpointCredentialsController($scope, $translate, bmPermission, bmCheckpointManager){
    /*jshint validthis:true */
    var ctrl = this;
    var masterData = { uid: '', pwd: '', agree: false };
    var loadedCreds;

    ctrl.$onInit = init;

    /////////////////////////

    function init(){
      ctrl.hasPermission = false;
      ctrl.credsExist = false;
      ctrl.alerts = [];
      ctrl.userData = angular.copy(masterData);
      // ctrl.entitlementData = {};

      // 2-way bound data object to pass information between tabs
      ctrl.sharedLocal = ctrl.sharedData;
      ctrl.sharedLocal.hasUnsavedCheckpoint = false;

      // Create method publicly available through 2-way data bound object
      ctrl.sharedLocal.setCheckpointDirty = setCheckpointDirty;

      // supported actions
      ctrl.actions = {
        saveUserData: saveUserData,
        cancelUserData: cancelUserData,
        deleteUserData: deleteUserData
      };

      // load up checkpoint credentials
      bmPermission.has('Applications.CheckpointEngage').then(function(){
        bmCheckpointManager.getCheckpointCredentials().then(function(creds){
          if(angular.isDefined(creds) && creds.Exists){
            ctrl.credsExist = true;
            loadedCreds = creds;

            bmCheckpointManager.getCheckpointEntitlementDataForSession().then(function(entitlementData){
              $translate('bm.header.checkpoint.removeTextWithName', { 'n0': entitlementData.fullName }).then(function(value){
                ctrl.removeText = value;
              });
            }, function(){
              $translate('bm.header.checkpoint.removeText').then(function(value){
                ctrl.removeText = value;
              });
            });

          } else {
            ctrl.credsExist = false;
          }

          ctrl.hasPermission = true;
        }, function(){
          ctrl.hasPermission = false;
          $translate('bm.header.checkpoint.permissionDenied').then(function(value){
            addAlert(value, 'danger');
          });
        });
      }, function(){
        ctrl.hasPermission = false;
        $translate('bm.header.checkpoint.permissionDenied').then(function(value){
          addAlert(value, 'danger');
        });
      });
    }

    function saveUserData(){
      resetAlerts();

      // is the form valid?
      if(ctrl.checkpointForm.$invalid){
        setFormValidity();
        return;
      }

      // agreed to license?
      if(ctrl.userData.agree === false){
        $translate('bm.header.checkpoint.licenseRequired').then(function(msg){
          addAlert(msg, 'danger');
        });

        return;
      }

      // all good, let's save the credentials
      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.saveCheckpointCredentials({
        'apiversion': 1,
        'data': {
          'kind': 'credentials',
          'accessKey': '',
          'userName': ctrl.userData.uid,
          'password': ctrl.userData.pwd
        }
      }).then(function(result){
        $scope.$emit('bm-busy-loading-off');
        // add name to results for remove text display
        result.name = ctrl.userData.uid;
        handleSaveSuccessDisplay(result);
      }, function(error){
        $scope.$emit('bm-busy-loading-off');
        handleSaveErrorDisplay(error);
      });
    }

    function cancelUserData(){
      if(ctrl.sharedLocal.resetOnCancel){
        // clear the user data and reset form
        resetAlerts();
        resetEntryForm(true);
      }

      $scope.$emit('bmProfileCancelAction');
    }

    function resetEntryForm(resetData){
      if(resetData){
        ctrl.userData = angular.copy(masterData);
      }

      ctrl.checkpointForm.$setPristine();
      ctrl.checkpointForm.uid.$setPristine();
      ctrl.checkpointForm.uid.$setValidity('required', true);
      ctrl.checkpointForm.pwd.$setPristine();
      ctrl.checkpointForm.pwd.$setValidity('required', true);
    }

    function deleteUserData(){
      resetAlerts();

      // make sure the creds are loaded
      if(angular.isUndefined(loadedCreds)){
        handleDeleteErrorDisplay();
        return;
      }

      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.deleteCheckpointCredentials(loadedCreds.UserDataId).then(function(){
        $scope.$emit('bm-busy-loading-off');
        handleDeleteSuccessDisplay();
      }, function(reject){
        $scope.$emit('bm-busy-loading-off');

        var error = { message: 'error' };

        // get the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          error = reject.data.error;

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }
        }

        handleDeleteErrorDisplay(error);
      });
    }

    function setFormValidity(){
      $translate('BM.Components.IncompleteForm').then(function(msg){
        addAlert(msg, 'danger');
      });

      // toggle all validation messages
      if(ctrl.checkpointForm.uid.$error.required){
        ctrl.checkpointForm.uid.$setDirty();
        ctrl.checkpointForm.uid.$setTouched();
      }

      if(ctrl.checkpointForm.pwd.$error.required){
        ctrl.checkpointForm.pwd.$setDirty();
        ctrl.checkpointForm.pwd.$setTouched();
      }
    }

    function handleSaveSuccessDisplay(data){
      // wipe form entry
      resetEntryForm(true);

      if(angular.isUndefined(data)){
        handleSaveErrorDisplay(data);
        return;
      }

      if(data.message === 'success'){
        $translate('bm.header.checkpoint.saveSuccessful').then(function(value){
          addAlert(value, 'success');
        });
      } else {
        addAlert(data.message, 'success');
      }

      // setup as creds already entered
      $translate('bm.header.checkpoint.removeText', { 'n0': data.name }).then(function(value){
        ctrl.removeText = value;
      });

      ctrl.credsExist = true;
      loadedCreds = {
        Exists: true,
        UserDataId: data.Id
      };

      ctrl.sharedLocal.hasUnsavedCheckpoint = false;
    }

    function handleSaveErrorDisplay(data){
      // generic error message
      if(angular.isUndefined(data) || data.message === 'error'){
        $translate('bm.header.checkpoint.saveError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function handleDeleteSuccessDisplay(){
      ctrl.credsExist = false;
      loadedCreds = null;

      $translate('bm.header.checkpoint.deleteSuccessful').then(function(value){
        addAlert(value, 'success');
      });
    }

    function handleDeleteErrorDisplay(data){
      if(angular.isUndefined(data) || data.message === 'error'){
       $translate('bm.header.checkpoint.deleteError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function setCheckpointDirty(){
      var isClean = angular.equals(masterData, ctrl.userData);
      resetAlerts();

      // only reset the form if its visible
      if(ctrl.hasPermission && !ctrl.credsExist){
        resetEntryForm(false);
      }

      ctrl.sharedLocal.hasUnsavedCheckpoint = !isClean;
    }

    function addAlert(message, type){
      resetAlerts();
      ctrl.alerts.push({ msg: message, type: type, closeable: true, timeout: 2500 });
    }

    function resetAlerts(){
      ctrl.alerts.length = 0;
    }
  }

  // Service Implementation
  bmCheckpointManager.$inject = ['$q', '$http', 'bmCheckpointRoutes'];
  function bmCheckpointManager($q, $http, apiRoutes){
    /*jshint validthis:true */
    var self = this;

    self.getCheckpointCredentials = getCheckpointCredentials;
    self.saveCheckpointCredentials = saveCheckpointCredentials;
    self.deleteCheckpointCredentials = deleteCheckpointCredentials;
    self.getCheckpointEntitlementDataForSession = getCheckpointEntitlementDataForSession;

    ////////////////////////////

    function getCheckpointCredentials() {
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointExistsApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }

    function saveCheckpointCredentials(creds){
      var deferred = $q.defer();

      if(angular.isUndefined(creds)){
        deferred.reject('NOCREDS');
        return deferred.promise;
      }

      $http({
        method: 'POST',
        url: apiRoutes.checkpointSetCredsApi,
        headers: {'Content-Type': 'application/json'},
        data: creds,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        if(angular.isDefined(resp) && angular.isDefined(resp.data)){
          var data = resp.data.data || {};

          if(angular.isUndefined(data.message) || data.message === ''){
            data.message = 'success';
          }

          deferred.resolve(data);
        }

        // handle as generic success
        deferred.resolve();
      }, function(reject){
        // return the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          var error = reject.data.error || {};

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }

          deferred.reject(error);
        }

        // handle as generic error
        deferred.reject();
      });

      return deferred.promise;
    }

    function deleteCheckpointCredentials(userDataId){
      var deferred = $q.defer();

      if(angular.isUndefined(userDataId)){
        deferred.reject('NOUSERDATAID');
        return deferred.promise;
      }

      return $http({
        method: 'DELETE',
        url: apiRoutes.checkpointSetCredsApi + '/' + userDataId,
        global: false
      });
    }

    function getCheckpointEntitlementDataForSession(){
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointSessionApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPreferenceService', [
    'bmEnvironment',
    'bluemoon.components.util'
  ])
  .service('bmPreferenceService', PreferenceService);

  PreferenceService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'bmUtil'];
  function PreferenceService($window, $q, $http, environment, bmUtil){
    /*jshint validthis:true */
    var self = this;

    self.getPreferences = getPreferences;
    self.getPreference = getPreference;
    self.addPreference = addPreference;
    self.removePreference = removePreference;

    ////////////////////////////

    // use the profile api returned from environments
    function getUserPreferenceApi(){
      return $q.when('/api/profiles/v1/preferences');
    }

    function getCompanyPreferenceApi(companyId){
      return $q.when('/api/profiles/v1/companies/' + companyId + '/preferences');
    }

    function getPreferences(companyId) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreferences();
      } else {
        return getCompanyPreferences(companyId);
      }
    }

    function getCompanyPreferences(companyId) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http.get(api).then(function(preferences){
          return preferences;
        });
      });
    }

    function getPreference(companyId, application, category) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreference(application, category);
      } else {
        return getCompanyPreference(companyId, application, category);
      }
    }

    function addPreference(companyId, preference) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return addUserPreference(preference);
      } else {
        return addCompanyPreference(companyId, preference);
      }
    }

    function getCompanyPreference(companyId, application, category) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application, category: category}
        });
      });
    }

    function getUserPreference(application, category){
      return getUserPreferenceApi().then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application || '', category: category || ''}
        });
      });
    }

    function addCompanyPreference(companyId, preference) {
      return getCompanyPreference(companyId, preference.application, preference.category).then(function(response){
        var preferences = response.data;
        if(bmUtil.isNullOrEmpty(preferences) || preferences.length === 0){
          return createPreference(companyId, preference);
        } else {
          var preferenceId = preferences[0].id;
          return updatePreference(companyId, preference, preferenceId);
        }
      });
    }

    function createPreference(companyId, preference){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'POST',
          url: api,
          data: preference
        });
      });
    }

    function updatePreference(companyId, preference, preferenceId){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'PUT',
          url: api + '/' + preferenceId,
          data: preference
        });
      });
    }

    function removePreference() {
      // TODO
    }
    function getUserPreferences() {
      // TODO
    }
    function addUserPreference() {
      // TODO
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorService', [
    'bmEnvironment',
    'bmAccess',
    'bmPreferenceService',
    'bluemoon.components.session',
    'bluemoon.components.util'
  ])
  .service('bmMultifactorService', MultifactorService);

  MultifactorService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'AuthenticatedSession', 'bmAccess', 'bmPreferenceService', 'bmUtil', 'languageStorageManager'];
  function MultifactorService($window, $q, $http, environment, session, bmAccess, preferenceService, bmUtil, langMgr){
    /*jshint validthis:true */
    var self = this;
    var authApi;
    var mfaApi;
    var productOptions;
    // TODO: COULD SET THIS AS A CONSTANT
    var products = {
      onvio: {
        sp: 'onvio',
        type: 'ONVIO'
      },
      auth: {
        sp: 'csweb',
        type: 'CSWEB'
      }
    };

    self.getFactors = getFactors;
    self.deleteFactors = deleteFactors;
    self.deleteFactor = deleteFactor;
    self.initFactorSetup = initFactorSetup;
    self.verifyLoginData = verifyLoginData;
    self.getAllFactors = getAllFactors;
    self.enableMultifactorAuthCode = enableMultifactorAuthCode;
    self.registerMultifactorAuthCode = registerMultifactorAuthCode;
    self.getUserJwtToken = getUserJwtToken;

    self.staffRequired = staffRequired;
    self.clientsRequired = clientsRequired;
    self.userRequired = userRequired;
    self.setStaffRequired = setStaffRequired;
    self.setClientsRequired = setClientsRequired;
    self.getMfaStaffPreference = getMfaStaffPreference;
    self.getMfaClientPreference = getMfaClientPreference;

    ////////////////////////////

    function getMfaProductOptions(){
      if(productOptions){
        return $q.when(productOptions);
      }

      return environment.getPrimaryProduct().then(function(productName){
        // default to onvio options
        productOptions = products[productName] ? products[productName] : products.onvio;
        return productOptions;
      });
    }

    // use the auth api returned from environments
    // ex. AuthenticationAggregatorServices: "https://demo.onvio.us/api/auth"
    function getAuthApiRoute(){
      if(authApi){
        return $q.when(authApi);
      }

      // make this work for local development
      if($window.location.host === 'localhost:9000'){
        authApi = 'https://localhost:9000';
        return $q.when(authApi);
      }

      return environment.getRoute('AuthenticationAggregatorServices').then(function(api){
        // make sure to use the protocol used by the browser host and not the route host
        var routeUri = bmUtil.parseUri(api);
        var hostUri = bmUtil.parseUri($window.location);
        authApi = hostUri.protocol + '//' + routeUri.host;
        return authApi;
      });
    }

    // use the mfa api returned from environments
    function getMfaApi(){
      if(mfaApi){
        return $q.when(mfaApi);
      }

      return getAuthApiRoute().then(function(api){
        mfaApi = api + '/api/mfa';
        return mfaApi;
      });
    }

    function getJwtToken(){
      // TODO: AT SOMEPOINT WE MAY NEED TO EXPLICITY FIND IT BASED ON PRODUCT TYPE
      // TO AVOID CLASHING CACHE OR EXPIRED TOKENS
      // onvio uses session storage
      var token = $window.sessionStorage.getItem('tr-auth-token');

      // csweb uses local storage
      if(bmUtil.isNullOrEmpty(token)){
        token = $window.localStorage.getItem('tr-auth-token');
      }

      return token;
    }

    function getBaseFactorsConfig(jwtToken){
      var jwt = jwtToken ? jwtToken : getJwtToken();

      if(jwt === null || angular.isUndefined(jwt) || jwt === ''){
        return null;
      }

      return {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-prevent-unauthorized': true,
          'Authorization': 'Bearer ' + jwt
        }
      };
    }

    function getFactors(allTypes){
      var config = getBaseFactorsConfig();

      if(config === null){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      // must have IAC in order to actually make request for factors
      // TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
      return bmAccess.has('Platform_Enable2FA').then(function(){
        return getMfaApi().then(function(api){
          config.url = api + '/v1/factors';
          // don't set errors as global
          config.global = false;

          return $http(config).then(function(resp){
            // really only want factors that are registered and devices
            var factors = [];

            // filter out any 24-hour codes
            if(angular.isArray(resp.data) && resp.data.length > 0){
              factors = resp.data.filter(function(factor){
                return allTypes ? true : angular.isString(factor.type) && factor.type.toUpperCase() !== 'B';
              });
            }

            return factors;
          }, function(){
            // TODO: MAY NEED TO HANDLE THIS DIFFERENTLY
            // send back an empty array if data failed to load
            return [];
          });
        });
      }).catch(function(){
        return [];
      });
    }

    function deleteFactors(factors, jwtToken){
      var deferred = $q.defer();
      if(!angular.isArray(factors) || factors.length === 0){
        deferred.reject('NOFACTORS');
        return deferred.promise;
      }

      var config = jwtToken ? getBaseFactorsConfig(jwtToken) : getBaseFactorsConfig();

      if(config === null){
        deferred.reject();
        return deferred.promise;
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        // need to send a delete for each factor
        var promises = [];

        angular.forEach(factors, function(factor){
          var factorConfig = angular.copy(config);
          factorConfig.url = factorConfig.url + factor.id;
          promises.push($http(factorConfig));
        });

        return $q.all(promises);
      });
    }
    function deleteFactor(factor){

      var config = getBaseFactorsConfig();

      if(config === null){
        $q.reject();
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        var factorConfig = angular.copy(config);
        factorConfig.url = factorConfig.url + factor.id;
        return $http(factorConfig);
      });
    }

    function enableMFACards() {
        return bmAccess.has('Platform_EnableMFACards').then(function() {
            return $q.resolve(true);
        }, function() {
            return $q.resolve(false);
        });
    }

    function initFactorSetup(email, showEmergencyCodesForm){
      var currentLang;

      return enableMFACards().then(function(enableMFACards) {
        return getAuthApiRoute().then(function(api){
          return getMfaProductOptions().then(function(options){
            currentLang = langMgr.get();
            var initSettings = {
              // targetElem: <targetContainer>,
              type: options.type,
              sp: options.sp,
              locale: currentLang,
              enableMFACards: enableMFACards,
              templateData: {
                authSvcHost: api,
                uid: email
              },
              headers: {
                authorization: 'Bearer ' + getJwtToken()
              }
            };
            if (showEmergencyCodesForm) {
              initSettings.startingForm = 'trta1-mfs-emergencycodes';
            }
            return $window.trAuth.modules.mfs.init(initSettings);
          });
        });
      });
    }

    function verifyLoginData(data){
      if(angular.isUndefined(data) || bmUtil.isNullOrEmpty(data.uid) || bmUtil.isNullOrEmpty(data.pwd)){
        var deferred = $q.defer();
        deferred.reject();
        return deferred.promise;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      // set the type just to be safe
      if(angular.isUndefined(data.type) || bmUtil.isNullOrEmpty(data.type)){
        data.type = 'TRID';
      }

      return getAuthApiRoute().then(function(api){
        return $http({
          method: 'POST',
          url: api + '/api/auth/v1/login/authentication',
          data: data,
          global: false
        });
      });
    }

    function staffRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }

      return getMfaStaffPreference(companyId).then(function(response){
          if(angular.isArray(response.data) && response.data.length > 0) {
            // there should only be one mfa-staff preference
            var preference = response.data[0];
            return preference.value && preference.value.required || false;
          }
          return false;
      });
    }

    function setStaffRequired(companyId, staffRequired) {
      if(angular.isUndefined(companyId) || angular.isUndefined(staffRequired)) {
        return $q.reject();
      }

      return setMfaStaffPreference(companyId, staffRequired);
    }

    function clientsRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }
      return getMfaClientPreference(companyId).then(function(response){
        if(angular.isArray(response.data) && response.data.length > 0) {
          // there should only be one mfa-client preference
          var preference = response.data[0];
          return preference.value && preference.value.required || false;
        }
        return false;
      });
    }

    function setClientsRequired(companyId, clientsRequired){
      if(angular.isUndefined(companyId) || angular.isUndefined(clientsRequired)) {
        $q.reject();
      }

      return setMfaClientPreference(companyId, clientsRequired);
    }

    function getMfaStaffPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-staff';
      return preferenceService.getPreference(companyId, application, category);
    }

    function setMfaStaffPreference(companyId, staffRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-staff',
        value: { required: staffRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function setMfaClientPreference(companyId, clientsRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-client',
        value: { required: clientsRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function getMfaClientPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-client';
      return preferenceService.getPreference(companyId, application, category);
    }

    function userRequired(){
      // TODO: DOES THIS APPLY TO CSWEB???
      var companyId = session.data.bindings.ApplicationConfiguration.CompanyId;
      var grants = session.data.bindings.Grants;
      var isStaff = grants.indexOf('staff') > -1;
      var isClient = grants.indexOf('client') > -1;
      var promises = [
        staffRequired(companyId),
        clientsRequired(companyId)
      ];

      return $q.all(promises).then(function(results){
        var staffIsRequired = results[0];
        var clientIsRequired = results[1];

        return (isClient && clientIsRequired) || (isStaff && staffIsRequired);
      }, function(){
        return false;
      });
    }

    function getAllFactors(jwtToken) {
      if(jwtToken === null || angular.isUndefined(jwtToken) || jwtToken === ''){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      var config = {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-prevent-unauthorized': true,
          'Authorization': 'Bearer ' + jwtToken
        }
      };

      return getMfaApi().then(function(api) {
        api = api + '/v1/factors';
        config.url = api;

        var factors = [];
        return $http(config).then(function(resp){
          if(angular.isArray(resp.data) && resp.data.length > 0){
            factors = resp.data;
          }
          factors = sortAuthCodeList(factors);
          return factors;
        });
      }).catch(function(){
        return [];
      });
    }

    function getUserJwtToken(contactId) {
      if(angular.isUndefined(contactId)){
        var deferred = $q.defer();
        deferred.reject({ data: 'Invalid contact - unable to get jwt token' });
        return deferred.promise;
      }

      var securityApi = '/api/security/v1/jwt/contacts/';
      var url = securityApi + contactId;
      var options = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      return $http.post(url, options);
    }

    function enableMultifactorAuthCode(jwtToken) {
      var data = {'type': 'B', 'address': '24-hour code'};
      var options = {
        headers: {'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + jwtToken,
            'x-prevent-unauthorized': true,
            'Cache-Control': 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function registerMultifactorAuthCode(jwtToken, inputData) {
      var factor = {
        'name' : '24-hour code',
        'address' : 'Support'
      };
      var data = {
        'mfarId' : inputData.mfarId,
        'factor' : factor
      };
      var options = {
        headers : {
          'Content-Type' : 'application/json',
          'Accept' : 'application/json',
          'Authorization' : 'Bearer' + ' ' + jwtToken,
          'x-prevent-unauthorized': true,
          'Cache-Control' : 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
        timeout : 60000000
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors/' + inputData.factorId + '/register';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function sortAuthCodeList(authCodeList) {
      authCodeList.sort(function(a,b) {
        a = new Date(a.registered);
        b = new Date(b.registered);
        return b - a;
      });

      return authCodeList;
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile', [
    'ui.bootstrap',
    'pascalprecht.translate',
    'bento.modern',
    'bluemoon.components.util',
    'bmMultifactorService',
  ])
  .component('bmMultifactorProfile', {
    bindings: {
      userData: '<',
      helpLink: '@'
    },
    templateUrl: 'components/multi-factor/multi-factor-profile.2js.html',
    controller: MultifactorProfileController,
  });

  MultifactorProfileController.$inject = ['$window', '$rootScope', '$scope', '$timeout', '$translate', '$uibModal', 'bmMultifactorService', 'languageStorageManager'];
  function MultifactorProfileController($window, $rootScope, $scope, $timeout, $translate, $uibModal, mfaService, languageStorageManager){
    /*jshint validthis:true */
    var ctrl = this;
    var andText = 'and';
    var prefLang = languageStorageManager.get() || 'en-US';

    ctrl.$onInit = init;
    ctrl.helpLangCode = prefLang.toLowerCase().split('-').reverse().join('-');

    ////////////////////////////

    function init(){
      ctrl.user = ctrl.userData;
      ctrl.factors = [];
      ctrl.pairedDeviceText = '';
      ctrl.actions = {
        openConfirmModal: openConfirmModal,
        cancelProfile: cancelProfile
      };

      mfaService.userRequired().then(function(required){
        ctrl.required = required;
      });

      $timeout(function() {
        // localize now (well..next cycle, to get around refresh bug)
        localize();

        // localize on lang change (next cycle to debounce)
        $rootScope.$on('bmLanguageChangeSuccess', localize);
      }, 0);
    }

    function localize(){
      // set factors after text is translated
      $translate('bm.header.viewProfile.And').then(function(value){
        andText = value;
      }).finally(function(){
        setFactors();
      });
    }

    function setFactors(){
      // reset current list of factors
      ctrl.factors = [];

      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        setMultiComplete();
      });
    }

    function setMultiComplete(){
      ctrl.devices = ctrl.factors.filter(function(factor) {
        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
      });
      ctrl.mutliFactorComplete = angular.isArray(ctrl.factors) && ctrl.factors.length > 0;
      // set paired device text
      if(ctrl.mutliFactorComplete){
        if(ctrl.factors.length === 1){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '."';
        } else if(ctrl.factors.length === 2){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '" ' + andText + ' "' + ctrl.factors[1].name + '."';
        } else {
          var isLast = false;

          for(var index = 0; index < ctrl.factors.length; index++){
            isLast = index === ctrl.factors.length - 1;

            if(index !== 0){
              ctrl.pairedDeviceText+= ', ';
            }

            ctrl.pairedDeviceText+= (isLast ? andText + ' ' : '') + '"' + ctrl.factors[index].name + (isLast ? '."' : '"');
          }
        }
      }
    }

    function cancelProfile(){
      $scope.$emit('bmProfileCancelAction');
    }

    function openConfirmModal(action, factor){
      var modalInstance = $uibModal.open({
        templateUrl: 'components/multi-factor/multi-factor-profile-modal.2js.html',
        controller: 'bmMfaConfirmDeviceCtrl as vm',
        backdrop: 'static',
        resolve: {
          action: function(){
            return action;
          },
          factor: function(){
            return factor;
          },
          // TODO: DO WE NEED THIS USER?
          user: function(){
            return ctrl.user;
          }
        }
      });

      modalInstance.result.then(function(isConfirmed){
        if(isConfirmed){
          if(action === 'add'){
            startMultiSetup(action);
          } else if(action === 'remove') {
            deleteFactor(factor);
          } else if (action === 'generate') {
            generateEmergencyCodes();
          }
        }
      });
    }
    function generateEmergencyCodes() {
      mfaService.initFactorSetup(ctrl.user.email, true);
    }
    function removeMulti(){
      $rootScope.$emit('bm-busy-loading-on');
      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        mfaService.deleteFactors(ctrl.factors).then(function(){
          setFactors();
          $rootScope.$emit('bm-busy-loading-off');
        }, function(){
          $rootScope.$emit('bm-busy-loading-off');
        });
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
      });
    }
    function deleteFactor(factor){
      $rootScope.$emit('bm-busy-loading-on');
      mfaService.deleteFactor(factor).then(function(){
        setFactors();
        $rootScope.$emit('bm-busy-loading-off');
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
      });
    }

    function startMultiSetup(action) {
      // make sure to use the local copy of email as it can be updated on account tab
      mfaService.initFactorSetup(ctrl.user.email).then(function(mfaDialog) {
        mfaDialog.addEventListener('tr-mfs-exit', function() {
          // done in $timeout in order for scope to update
          $timeout(function() {
            // remove existing factors first just to keep the added factor in the list
            // at this time only allowing 1 device to be setup
            // don't want to remove existing devices until new device is setup through auth component
            if (action === 'remove') {
              removeMulti();
            } else {
              setFactors();
            }
          }, 0);
        });
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile').controller('bmMfaConfirmDeviceCtrl', confirmModalCtrl);

  confirmModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'bmMultifactorService', '$translate', 'bmUtil', 'action', 'user'];
  function confirmModalCtrl($rootScope, $uibModalInstance, mfaService, $translate, bmUtil, action, user){
    /*jshint validthis:true */
    var vm = this;
    vm.confirmDevice = confirmDevice;
    vm.cancelDevice = cancelDevice;
    vm.modalAction = bmUtil.isNullOrEmpty(action) ? 'add' : action;
    vm.user = { password: ''};

    ///////////

    function confirmDevice(){
      if(vm.confirmDeviceForm.$invalid || vm.confirmDeviceForm.userPassword.$invalid){
        return;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      var userData = { uid: user.email, pwd: vm.user.password, type: 'TRID' };

      mfaService.verifyLoginData(userData).then(function(){
        closeModal(true);
      }, function(){
        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text){
          // TODO: IF THIS GOES TO A COMPONENT CHANGE TO NOT USE bmErrors
          if (!$rootScope.bmErrors){
            $rootScope.bmErrors = [];
          }

          $rootScope.bmErrors.push({type: 'danger', msg: text, timeout: 2500, closeable: true});
        });
      });
    }

    function cancelDevice(){
      closeModal(false);
    }

    function closeModal(isConfirmed){
      $uibModalInstance.close(isConfirmed);
    }
  }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser', ['bento.modern']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserCtrl', MultifactorUserCtrl);
	MultifactorUserCtrl.$inject = ['$uibModal', 'bmAccess'];

	function MultifactorUserCtrl($uibModal, bmAccess){
        /*jshint validthis:true */
		var vm = this;

		// scope variables
		vm.isMfaAvailable = false;
		vm.contact = {};

		// scope functions
		vm.openMfaSettingsModal = openMfaSettingsModal;

		localStorage.setItem('Platform_Enable2FA', true);

		this.$onChanges = function(changes) {
			if (changes.contact.currentValue && changes.contact.currentValue.id) {
				initialize();
			}
		};

		function openMfaSettingsModal() {
			$uibModal.open({
				templateUrl: 'components/multi-factor-user/multi-factor-user-settings.2js.html',
				controller: 'MultifactorUserSettingsCtrl',
				controllerAs: 'vm',
				backdrop: 'static',
				size: 'md',
				resolve: {
					contactInfo: function(){
						return {
							id: vm.contact.id
						};
					}
				}
			});
		}

		function initialize() {
			// must have IAC in order to actually make request for factors
			// TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
			bmAccess.has('Platform_DisableAuth0Phase2').then(function(){
				if(vm.contact.userId) {
					//multifactorUserService.contact = vm.contact;

					// TODO: will need to lookup the companies mfa settings here
					vm.isMfaAvailable = true;
				}
			}).catch(angular.noop);
		}
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser')
        .component('bmMultifactorUser', {
            templateUrl: 'components/multi-factor-user/multi-factor-user.2js.html',
            bindings: {
                contact: '<'
            },
            controller: 'MultifactorUserCtrl',
            controllerAs: 'vm'
        });
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserSettingsCtrl', multifactorUserSettingsCtrl);
    multifactorUserSettingsCtrl.$inject = ['$window', '$scope', '$uibModalInstance', 'bmMultifactorService', 'contactInfo'];

    function multifactorUserSettingsCtrl($window, $scope, $uibModalInstance, bmMultifactorService, contactInfo) {
        /*jshint validthis:true */
        var vm = this;
        vm.userDevice = 'Some Device';
        vm.authCode = '';
        vm.registeredFactors = [];
        vm.busyLoading = true;
        vm.contactInfo = contactInfo;

        var jwt = '';
        var registeredAuthCodes = [];
        var temporaryAuthCode = '';

        // functiion
        vm.close = closeModal;
        vm.generateAccessCode = generateAccessCode;

        // setup
        init();

        function init() {
            getJwtToken();
        }

        function closeModal() {
            $uibModalInstance.close();
        }

        function generateAccessCode() {
            if(registeredAuthCodes.length > 0) {
                removeAuthFactorAndRegenerate();
            } else {
                createAuthFactorAndRegister();
            }
        }

        function getJwtToken() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.getUserJwtToken(contactInfo.id).then(function(resp){
                jwt = resp.data.token;
                getFactors();
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function getFactors() {
            bmMultifactorService.getAllFactors(jwt).then(function(data){
                if(angular.isArray(data) && data.length > 0){
                    vm.registeredFactors = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
                    });

                    registeredAuthCodes = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() === 'B';
                    });

                    if(angular.isArray(vm.registeredFactors) && vm.registeredFactors.length > 0){
                        var registeredDevice;
                        var registeredDeviceList;
                        for(var pos = 0; pos < vm.registeredFactors.length; pos++) {
                            registeredDevice = vm.registeredFactors[pos];
                            if(pos === 0) {
                                registeredDeviceList = registeredDevice.name;
                            } else {
                                registeredDeviceList = registeredDeviceList + ', ' + registeredDevice.name;
                            }
                        }
                        vm.userDevice = registeredDeviceList;
                    }
                }
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function removeAuthFactorAndRegenerate() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.deleteFactors(registeredAuthCodes, jwt).then(function(){
                registeredAuthCodes = [];
                createAuthFactorAndRegister();
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function createAuthFactorAndRegister() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.enableMultifactorAuthCode(jwt).then(function(response){
                var authFactor = response.data;
                var otpSecret = authFactor.otpSecret;
                temporaryAuthCode = otpSecret.substring(0, 4) + ' ' + otpSecret.substring(4);
                registerMultifactorAuthCode(authFactor);
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function registerMultifactorAuthCode(authFactor) {
            bmMultifactorService.registerMultifactorAuthCode(jwt, authFactor).then(function(response){
                var data = response.data;
                data.id = authFactor.factorId;
                registeredAuthCodes = [];
                registeredAuthCodes.push(data);
                vm.authCode = temporaryAuthCode;
                $scope.$emit('bm-busy-loading-off');
            }, function() {
                $scope.$emit('bm-busy-loading-off');
                //window.alert('Error in registerMultifactorAuthCode');
            });
        }
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPrivacyPolicy', [
    'pascalprecht.translate',
    'bluemoon.components.i18n'])
  .value('bmPrivacyPolicyUriMap', {
    'en-US': 'https://www.thomsonreuters.com/en/privacy-statement.html',
    'fr-CA': 'https://www.thomsonreuters.com/fr-ca/privacy-statement.html',
    'nl-NL': 'https://www.thomsonreuters.com/nl/privacy.html',
    'es-AR': 'https://www.thomsonreuters.com/es/declaracion-de-privacidad.html',
    'pt-BR': 'https://www.thomsonreuters.com/pt/declaracao-de-privacidade.html'
  })
  .component('bmPrivacyPolicyLink', {
    templateUrl: 'components/privacy-policy/privacy-policy.2js.html',
    controller: privacyPolicyLink,
  })
  .service('bmPrivacyPolicyService', privacyPolicyService);

  ////////////

  // Component implementation
  privacyPolicyLink.$inject = ['$scope', 'bmPrivacyPolicyService', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyLink($scope, privacyService, privacyUriMap){
    /*jshint validthis:true */
    var ctrl = this;

    ctrl.$onInit = init;

    //////////////////////////////

    function init(){
      // load up initial version of privacy policy
      setPrivacyUri();

      // add language change event watch to change text when lanuage changes
      $scope.$on('bmLanguageChangeSuccess', setPrivacyUri);
    }

    function setPrivacyUri(){
      privacyService.getPrivacyPolicyUri().then(function(uri){
        ctrl.privacyUri = uri;
      }, function(){
        // fall back to US for any errors
        ctrl.privacyUri = privacyUriMap['en-US'];
      });
    }
  }

  // Service implementation
  privacyPolicyService.$inject = ['bmLanguageManager', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyService(languageManager, privacyPolicyUriMap){
    /*jshint validthis:true */
    var self = this;

    self.getPrivacyPolicyUri = getPrivacyPolicyUri;

    //////////////////////

    function getPrivacyPolicyUri(){
      return languageManager.getLoadedLanguageAsync().then(function(language){
        return privacyPolicyUriMap[language.code] || privacyPolicyUriMap['en-US'];
      });
    }
  }
})(window.angular);

// Depends on IAC: OnvioSupportID

(function(angular){
  'use strict';

  angular.module('bmSupportId', [
    'pascalprecht.translate',
    'bluemoon.components.i18n',
    'bluemoon.components.analytics'])
  .component('bmSupportIdLink', {
    templateUrl: 'components/support-id/support-id.2js.html',
    controller: supportIdLink,
  })
  .service('bmSupportIdService', supportIdService);

  // Component implementation
  supportIdLink.$inject = ['bmSupportIdService', 'bmAccess', 'bmAnalyticsService'];
  function supportIdLink(supportIdService, bmAccess, bmAnalyticsService){
    /*jshint validthis:true */
    var ctrl = this;
    ctrl.$onInit = init;

    function init(){
      ctrl.enabled = false;
      ctrl.showId = false;
      ctrl.supportId = '';

      ctrl.copyToClip = copyToClip;
      ctrl.loadSupportId = loadSupportId;

      bmAccess.has('OnvioSupportID').then(function(access){
        ctrl.enabled = access;
        // Initial support ID load
        ctrl.loadSupportId();
      }).catch(function() {
        ctrl.enabled = false;
        bmAnalyticsService.track('bmSupportIdService: bmAccess.has(\'OnvioSupportId\') failed');
      });
    }

    function loadSupportId () {
      ctrl.supportId = supportIdService.getRouteId();
    }

    function copyToClip () {
      document.getElementById('support-id-text').select();
      document.execCommand('copy');
    }
  }

  // Service implementation
  function supportIdService(){
    /*jshint validthis:true */
    var self = this;
    self.getRouteId = getRouteId;

    function getRouteId () {
      var inj = window.angular.element(document.querySelector('[ng-app], [data-ng-app], html, body')).injector();
      var routeId = inj.get('$http').defaults.headers.common['x-route-id'];
      return routeId;
    }
  }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help', [
        'bmEnvironment',
        'pascalprecht.translate'
    ]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help')
        .controller('HelpCtrl',
            ['$scope', '$rootScope', '$window', '$timeout', '$translate', 'helpService', 'bmEnvironment', 'bmUtil',
                function ($scope, $rootScope, $window, $timeout, $translate, helpService, bmEnv, bmUtil) {
                    var defaultUrlPrefix = '/ua/help';
                    var sambaUrlPrefix = '/ua/smb';
                    var isOpened = false;
                    updateComponentData('', '', {}, []);
                    setEnvironmentLinks();
                    $scope.searchInput = { text: '', placeholderTxt: $translate.instant('bm.header.helpMenu.searchLabel') };

                    function updateHelpData() {
                        updateComponentData('', '', {}, []);
                        helpService.load($scope.location).then(function (resp) {
                            updateComponentData(
                                resp.data.baseUrl,
                                resp.data.howToUrl,
                                resp.data.parameters,
                                resp.data.topics
                            );
                        });
                    }

                    function updateComponentData(baseUrl, howToUrl, parameters, topics) {
                        $scope.help = $scope.help ? $scope.help : {};
                        $scope.help.baseUrl = baseUrl;
                        $scope.help.howToUrl = howToUrl;
                        $scope.help.parameters = parameters;
                        $scope.help.topics = topics;
                    }

                    $scope.offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function () {
                        if (isOpened) {
                            updateHelpData();
                        }
                    });
                    $rootScope.$on('bmLanguageChangeSuccess', function () {
                        $scope.searchInput.placeholderTxt = $translate.instant('bm.header.helpMenu.searchLabel');
                    });
                    $scope.$on('$destroy', function () {
                        if ($scope.offLocChgSuccess) {
                            $scope.offLocChgSuccess();
                        }
                    });

                    $scope.$watch('help.isHelpDropdownOpen', function (opened) {
                        if (opened !== isOpened) {
                            isOpened = opened === true;
                            if (isOpened) {
                                updateHelpData();
                            }
                        }
                    });

                    $scope.formatSearchUrl = function (primaryProduct) {
                        var prefix;
                        switch (primaryProduct) {
                            case 'samba':
                            case 'recibos':
                                prefix = sambaUrlPrefix;
                                break;
                            default:
                                prefix = defaultUrlPrefix;
                                break;
                        }
                        var url = prefix + '/search_handler.htm?q=' + encodeURIComponent($scope.searchInput.text);

                        if ($scope.help && $scope.help.parameters) {
                            url += '&' + $scope.formatHelpParametersSuffix($scope.help);
                        }

                        return url;
                    };

                    $scope.formatHelpParametersSuffix = function (help) {
                        var suffix = '';
                        if (help.parameters) {
                            var skipAmperasand = true;
                            angular.forEach(help.parameters, function (value, key) {
                                if (skipAmperasand) {
                                    skipAmperasand = false;
                                } else {
                                    suffix += '&';
                                }

                                suffix += key + '=' + encodeURIComponent(value);
                            });
                        }

                        return suffix;
                    };

                    $scope.formatTopicUrl = function (help, menuUrl) {
                        var url = help.baseUrl + menuUrl;
                        if (help.parameters) {
                            url += '?' + $scope.formatHelpParametersSuffix(help);
                        }

                        return url;
                    };

                    $scope.helpSearch = function () {
                        // if recibos, update help path; #7986
                        bmEnv.load().then(function (data) {
                            var url = $scope.formatSearchUrl(data.primaryProduct);
                            $window.open(url, '_blank');
                        });
                    };

                    $scope.searchKeyPress = function ($event) {
                        if ($event && $event.keyCode === 13) { // Enter key
                            $timeout(function () {
                                $scope.helpSearch();
                            });
                        }
                    };

                    $scope.howToLink = function () {
                        if ($scope.help) {
                            var url = $scope.help.howToUrl;

                            if ($scope.help && $scope.help.parameters) {
                                url += '?' + $scope.formatHelpParametersSuffix($scope.help);
                            }

                            return url;
                        }

                        return '';
                    };

                    function setEnvironmentLinks () {
                        var country = bmEnv.getCountryCode();
                        $scope.countryCode = country;

                        bmEnv.getEnvironmentAsync().then(function (data) {
                            $scope.currentCountry = data.countryCode;
                        });

                        $scope.arHelpAndTrainingLink = 'https://clientes.thomsonreuters.com.ar/';

                        switch (country) {
                            default:
                                $scope.ideaIncubatorLink = 'http://ideaincubator.ideas.aha.io';
                                $scope.communityLink = 'https://tax.thomsonreuters.com/en/community';
                                $scope.contactSupportLink = 'https://onvio.us/ua/help/us-en/staff/core/common/contacting-our-support-team.htm';
                                $scope.alertsAndNoticesLink = 'https://onvio.us/ua/help/us-en/staff/core/solutions/onvio-current-information-and-alerts.htm';
                                $scope.videoLibraryLink = 'https://onvio.us/ua/help/us-en/staff/core/video-library-core.htm';
                                break;
                        }
                    }

                    $scope.openEstudioOneSupport = function() {
                        bmEnv.getRoute('EstudioOne-Support').then(function(url){
                            var jwt;
                            var tokenType = 'UDSLongToken';
                            var token = bmUtil.cookie(tokenType);

                            if (!jwt) { // lazy jwt
                                // get jwt given a UDSLongToken
                                // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                                // not great, but the deprecation warning is a bluff
                                var xhr = new $window.XMLHttpRequest();
                                xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                                xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                                xhr.onreadystatechange = function() {
                                    if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                                    jwt = JSON.parse(xhr.responseText).token;
                                };
                                xhr.send();
                            }

                            if (!jwt) { return; }
                            url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + jwt;
                            // don't leave jwt laying around
                            setTimeout(function() { $window.open(url, '_blank'); }, 0);
                        });
                    };
                }
            ]);
})(window.angular);

/**
 * Blue Moon Components - Help Dropdown Directive
 */
(function (angular) {
    'use strict';

    bmHelpDropdown.$inject = [];
    function bmHelpDropdown() {
        return {
            scope: {
                isDropdownOpen: '=?',
                location: '@?', // the remaining URL after the '#' ex. '/staff/setup/clients'. If absent, defaults to current location
                useMenuLeft: '=?' // Uses a left menu instead
            },
            templateUrl: 'components/help/help.2js.html',
            controller: 'HelpCtrl',
            controllerAs: 'help'
        };
    }

    angular.module('bluemoon.help').directive('bmHelpDropdown', bmHelpDropdown);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.help')
        .factory('helpService', ['$q', '$http', '$location',
            function ($q, $http, $location) {
                return {
                    load: function(location) {
                        if (location && typeof location !== 'string') {
                            throw new Error('Error: location argument should be a non-empty string');
                        }
                        var endpoint = '/api/profiles/v1/help';

                        // If a location was given, use it instead of the current url
                        var currentUrl = $location.absUrl();
                        if (location) {
                            currentUrl = $location.protocol() + '://' + $location.host() + location;
                        }
                        // Debug code to test on localhost
                        if ($location.host() === 'localhost') {
                            currentUrl = 'https://ci.onvio.us/staff/#' + (location ? location : $location.url());
                        }

                        var parameters = '?location=' + encodeURIComponent(currentUrl);
                        var config = {
                            url: endpoint + parameters,
                            method: 'GET',
                            cache: true
                        };

                        return $http(config).then(
                            function(resp) {
                                var defer = $q.defer();
                                defer.resolve(resp);
                                return defer.promise;
                            },
                            function(resp) {
                                resp.config.global = false;
                                return $q.reject(resp);
                            });
                    }
                };
            }
        ]);
})(window.angular);

(function (angular) {
    'use strict';

    var licenseApiUrl = '/api/provisioning/v1/licenses';

    function License($http, $q) {
        var self = this;

        // Can be used for route resolve to determine if you have license.
        // For example,
        // resolve: {
        //     selfReg: bmLicense.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        var grants = null;
        var grantsBlockedDefers = null;

        self.load = function () {
            if (grants) {
                return $q.when(grants);
            }

            // We need to run the query.
            // But, someone else may be currently running it, at which point we will just wait for that one call to finish.
            if (!grantsBlockedDefers) {
                grantsBlockedDefers = [];

                $http.get(licenseApiUrl).then(function (resp) {
                    // map into a format we prefer
                    grants = resp.data.featureResources.map(function (val) {
                        return val.feature + '.' + val.resource;
                    });

                    // Resolve all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.resolve(grants);
                    });
                    return grants;
                }).catch(function () {
                    // Trigger failure to all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.reject();
                    });
                }).finally(function () {
                    // Reset back to the original state.
                    grantsBlockedDefers = undefined;
                });
            }

            // Add ourselves to the list of promises waiting on the query.
            var currentDefer = $q.defer();
            grantsBlockedDefers.push(currentDefer);
            return currentDefer.promise;
        };

        self.hasSync = function (licenses, hasEvery) {
            if (!grants) {
                throw new Error('grants not loaded yet. You must use load() first.');
            }
            var granted = false;
            if (angular.isArray(licenses)) {
                licenses[hasEvery ? 'every' : 'some'](function (license) {
                    if (grants) {
                        granted = grants.indexOf(license) > -1;
                    } else {
                        granted = false;
                    }
                    return granted;
                });
            } else if (typeof licenses === 'string') {
                if (grants) {
                    granted = grants.indexOf(licenses) > -1;
                }
            }
            return granted;
        };
        self.has = function (licenses, hasEvery) {
            return self.load().then(function () {
                var granted = self.hasSync(licenses, hasEvery);
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(licenses) {
            return self.has(licenses);
        };

        self.hasEvery = function(licenses) {
            return self.has(licenses, true);
        };

        self.not = function(licenses){
            var deferred = $q.defer();
            self.has(licenses).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(licenses){
            return self.not(licenses);
        };

        self.notEvery = function(licenses){
            return self.not(licenses, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function licenseDirective($animate, bmLicense) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasLicenseWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicense', value);
            }

            function bmIfHasLicenseEveryWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseEvery', value);
            }

            function bmIfHasLicenseSomeWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseSome', value);
            }

            function bmIfHasNoLicenseWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicense', value);
            }

            function bmIfHasNoLicenseSomeWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseSome', value);
            }

            function bmIfHasNoLicenseEveryWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseEvery', value);
            }

            function handleLicenseAttrChange(type, value) {
                bmLicense[type === 'bmIfHasLicenseEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoLicenseEvery' ? 'notEvery'
                    : type === 'bmIfHasNoLicense' || type === 'bmIfHasNoLicenseSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasLicense) {
                var unwatchIfHasLicense = $scope.$watch($attr.bmIfHasLicense, bmIfHasLicenseWatchAction);
            }
            if ($attr.bmIfHasLicenseEvery) {
                var unwatchIfHasLicenseEvery = $scope.$watch($attr.bmIfHasLicenseEvery, bmIfHasLicenseEveryWatchAction);
            }
            if ($attr.bmIfHasLicenseSome) {
                var unwatchIfHasLicenseSome = $scope.$watch($attr.bmIfHasLicenseSome, bmIfHasLicenseSomeWatchAction);
            }
            if($attr.bmIfHasNoLicense){
                var unwatchIfHasNoLicense = $scope.$watch($attr.bmIfHasNoLicense, bmIfHasNoLicenseWatchAction);
            }
            if($attr.bmIfHasNoLicenseSome){
                var unwatchIfHasNoLicenseSome = $scope.$watch($attr.bmIfHasNoLicenseSome, bmIfHasNoLicenseSomeWatchAction);
            }
            if ($attr.bmIfHasNoLicenseEvery) {
                var unwatchIfHasNoLicenseEvery = $scope.$watch($attr.bmIfHasNoLicenseEvery, bmIfHasNoLicenseEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasLicense) { unwatchIfHasLicense(); }
                if (unwatchIfHasLicenseEvery) { unwatchIfHasLicenseEvery(); }
                if (unwatchIfHasLicenseSome) { unwatchIfHasLicenseSome(); }
                if (unwatchIfHasNoLicense) { unwatchIfHasNoLicense(); }
                if (unwatchIfHasNoLicenseSome) { unwatchIfHasNoLicenseSome(); }
                if (unwatchIfHasNoLicenseEvery) { unwatchIfHasNoLicenseEvery(); }
            });
        }
      };
    }

    License.$inject = ['$http', '$q'];
    licenseDirective.$inject = ['$animate', 'bmLicense'];

    angular.module('bmLicense', ['bluemoon.components.session'])
        .service('bmLicense', License)
        .directive('bmIfHasLicense', licenseDirective)
        .directive('bmIfHasLicenseSome', licenseDirective)
        .directive('bmIfHasLicenseEvery', licenseDirective)
        .directive('bmIfHasNoLicense', licenseDirective)
        .directive('bmIfHasNoLicenseSome', licenseDirective)
        .directive('bmIfHasNoLicenseEvery', licenseDirective);

 })(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.myAccount', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bluemoon.components.util',
        'bmUserTermsSignatory',
        'bmHttpCache',
        'bmValidateEmail',
        'LinkedAccountsService'
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.myAccount').controller('MyAccountCtrl', myAccountCtrl);
    myAccountCtrl.$inject = ['$q', '$sce','$scope', '$window', '$uibModal', '$translate', 'bmUtil','bmAccess', 'myAccountService', 'bmUserSignatory', 'helpService', 'bmEnvironmentConst'];

    function myAccountCtrl($q, $sce, $scope, $window, $uibModal, $translate, bmUtil, bmAccess, myAccountService, bmUserSignatory, helpService, bmEnvironmentConst) {
        /*jshint validthis:true */
        var vm = this;
        var isSkinny = vm.display === 'skinny';
        var licenseeDisplay = false;
        var linkModalOpen = false;

        this.$onInit = function() {
            vm.saveUser = saveUser;
            vm.cancelUser = cancelUser;
            vm.validateUserId = validateUserId;
            vm.getTemplateUrl = getTemplateUrl;
            vm.openAccountLinkModal = openAccountLinkModal;
            vm.userIdError = '';
            vm.termsLink = '';
            vm.showStaffTerms = false;
            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedAccount = false;
            vm.isVisibleSaveButton = isVisibleSaveButton;
            vm.isVisibleLanguageUpdateButton = isVisibleLanguageUpdateButton;
            vm.updateLanguageCIAM = updateLanguageCIAM;
            var profileLanguage = (bmUtil.cookie('BMLanguageCode') !== undefined) ? bmUtil.cookie('BMLanguageCode') : bmEnvironmentConst.defaultLang;
            vm.auth0ProfileUrl = bmEnvironmentConst.auth0ProfileUrl + '/' + profileLanguage + '/profile';

            initializeView();
        };

        loadPlatformDisableAuth0Phase2Access();
        loadPlatformNotifyUpdatedEmail();

        function initializeView(){
            resetAlerts();

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setAccountDirty = function(){
                setFormState();
            };

            // should terms link appear
            bmAccess.has('Platform_DisplayOnvioTerms').then(function() {
                vm.showStaffTerms = true;
                getTermsLink().then(function(termsLink) {
                    vm.termsLink = termsLink;
                });
            }).catch(angular.noop);
            // Make sure user settings were resolved
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }

            // Set languages - passed on directive property
            vm.languageList = vm.languages;

            // Create a copy of the original user in order to track changes on save
            vm.localUser = angular.copy(vm.user);

            vm.savingUserInProgress = false;

            if(angular.isUndefined(vm.localUser.language)){
                vm.localUser.language = 'en-US';
            }

            // set a full name for display if it doesn't exist
            if(angular.isUndefined(vm.localUser.fullName)) {
                vm.localUser.fullName = (vm.localUser.firstName + ' ' + vm.localUser.lastName).trim();
            }
            vm.initialEmail = vm.localUser.email;
            // for skinny display - no terms necessary to be loaded
            if(!isSkinny){
                // load up any terms and conditions information
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    setTermsDisplay(signatory);
                });
            }
        }

        // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
        function getTemplateUrl(displayType){
            // skinny displayType is used for CSWeb

            // lean towards onvio base template
            var baseTemplate = displayType === 'skinny' ? 'my-account/my-account-skinny.2js.html' : 'my-account/my-account.2js.html';

            // user not loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                return baseTemplate;
            }

            // licensee version
            if(displayType === 'skinny' && vm.user.licensee){
                licenseeDisplay = true;
                return 'my-account/my-account-licensee.2js.html';
            }

            // stick with non-licensee version
            return baseTemplate;
        }

        function getTermsLink() {
            return helpService.load().then( function(response) {
                return (response.data.baseUrl.substring(0, response.data.baseUrl.indexOf('core')) + 'general-articles/terms-conditions-onvio.htm');
            });
        }

        function setTermsDisplay(signatory){
            if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isDefined(signatory.signatory)){
                vm.hasTermsSignatory = true;
                vm.termsDisplayText = $sce.trustAsHtml(signatory.terms.text);
            }
        }

        function loadPlatformDisableAuth0Phase2Access () {
            vm.hasDisableAuth0Phase2 = false;
            bmAccess.has('Platform_DisableAuth0Phase2').then(function() {
                vm.hasDisableAuth0Phase2 = true;
            }).catch(function () {
                vm.hasDisableAuth0Phase2 = false;
            });
        }

        function loadPlatformNotifyUpdatedEmail () {
            vm.hasNotifyUpdatedEmail = false;
            bmAccess.has('Platform_NotifyUpdatedEmail').then(function() {
                vm.hasNotifyUpdatedEmail = true;
            }).catch(function () {
                vm.hasNotifyUpdatedEmail = false;
            });
        }

        function isVisibleSaveButton() {
            vm.hasTerms = vm.user && !vm.showTerms;
            return vm.hasTerms && vm.hasDisableAuth0Phase2;
        }

        function isVisibleLanguageUpdateButton() {
            return vm.languageList.length > 1 && !vm.hasDisableAuth0Phase2;
        }

        function updateLanguageCIAM() {
            var language = { language: vm.localUser.language };
            saveUserLanguageCIAM(language);
        }

        function saveUserLanguageCIAM(language){
            resetAlerts();
            $scope.$emit('bm-busy-loading-on');
            myAccountService.saveUserLanguage(language).then(function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('bm.header.viewProfile.account.saveSuccessful').then(function(value){
                    addAlert(value, 'success');
                    $window.location.reload();
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('Bluemoon.Components.ValidationUtils.GenericValidationError').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        vm.toolbarButtons = [{
            label : $translate.instant('onvio.setup.migrations.refresh'),
            icon  : 'bento-icon-refresh',
            action: function () {
                myAccountService.getMyUserSettingsAsync().then(function(resp) {
                   vm.localUser = resp.data;
                   vm.initialEmail = vm.localUser.email;
               });
            }
        }];

        function saveUser(){
            resetAlerts();
            cleanUserData();
            validateUserId(true);

            if(vm.userIdError !== ''){
                setFormInvalid();
                return;
            }

            validateUserIdAsync().then(function(){
                // do no want to save if the linking modal dialog is open
                if(linkModalOpen === false) {
                    if(vm.userIdError !== '' || vm.myAccountForm.$invalid){
                        setFormInvalid();
                        return;
                    }

                    var userToSave = getCleanUserSaveData(vm.localUser);
                    vm.savingUserInProgress = true;
                    var emailInUseVerify = vm.localUser.email !== vm.user.email;
                    $scope.$emit('bm-busy-loading-on');
                    myAccountService.saveUserCombined(userToSave, emailInUseVerify).then(function(){
                        $scope.$emit('bm-busy-loading-off');
                        vm.myAccountForm.$setPristine();
                        vm.sharedLocal.hasUnsavedAccount = false;

                        // keep user objects in sync
                        vm.user = angular.copy(vm.localUser);

                        // Always persist the language just in case there is an out-of-sync condition between saved settings and UI
                        myAccountService.persistLanguageAsync(userToSave.language);

                        if(!vm.hasNotifyUpdatedEmail || (vm.initialEmail === vm.localUser.email.trim()) ){
                            $translate('bm.header.viewProfile.account.saveSuccessful').then(function(value){
                                addAlert(value, 'success');
                            });
                        } else {
                            $translate('bm.header.viewProfile.account.emailChangedNotification').then(function(value){
                                addAlert(value, 'success');
                            });
                        }
                        vm.savingUserInProgress = false;
                    }, function(error){
                        $scope.$emit('bm-busy-loading-off');
                        // TODO: REPLACE THIS WITH A USEFUL ERROR MESSAGE
                        addAlert(error.data, 'danger');
                    });
                }
            }, function(){
                setFormInvalid();
            });
        }
        function openAccountLinkModal(uid) {
            linkModalOpen = true;
            var modalInstance = $uibModal.open({
                templateUrl: 'my-account/link-auth/link-auth-modal.2js.html',
                controller: 'LinkAuthCtrl as vm',
                backdrop: 'static',
                resolve: {
                    uid: function() {
                        return uid;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                if(result !== 'change email') {
                    linkModalOpen = false;
                }
            }, function(reason) {
                linkModalOpen = false;
                resetAlerts();
                if(angular.isDefined(reason)) {
                    if(reason !== 'change email') {
                        addAlert(reason, 'danger');
                    }
                }
            });
        }

        function getCleanUserSaveData(user){
            return {
                email: user.email,
                firstName: user.firstName,
                middleName: angular.isUndefined(user.middleName) ? '' : user.middleName,
                lastName: user.lastName,
                language: user.language
            };
        }

        function cleanUserData() {
            // TODO: HACK TO AVOID BAMS INTEGRATION. PASS IN NAME PARSER METHODS
            if(angular.isDefined(vm.localUser.fullName)) {
                vm.localUser.fullName = vm.localUser.fullName.trim();
            }

            if(angular.isDefined(vm.localUser.email)) {
                vm.localUser.email = vm.localUser.email.trim();
            }
            if(angular.isDefined(vm.localUser.firstName)) {
                vm.localUser.firstName = vm.localUser.firstName.trim();
            }
            if(angular.isDefined(vm.localUser.middleName)) {
                vm.localUser.middleName = vm.localUser.middleName.trim();
            }
            if(angular.isDefined(vm.localUser.lastName)) {
                vm.localUser.lastName = vm.localUser.lastName.trim();
            }
        }

        function setFormInvalid(){
            var alert = '';
            $translate('BM.Components.IncompleteForm').then(function(data){
                alert = data;
                addAlert(alert, 'danger');
            });

            // fields don't exist on licensee display
            if(licenseeDisplay){
                return;
            }

            // Toggle all validation messages
            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.lastName.$error.required){
               vm.myAccountForm.lastName.$dirty = true;
            }

            // skinny form doesn't have language field
            if(!isSkinny && vm.myAccountForm.language.$error.required){
               vm.myAccountForm.language.$dirty = true;
            }
        }

        function allowAccountMergingAsync() {
            // check for access to account switching merging IAC
            return bmAccess.has('PPE-AccountSwitchingMerge');

        }

        function validateUserId(isFormSubmit){
            vm.userIdError = '';

            var emailBeforeAt = vm.myAccountForm.userId.$viewValue.split('@')[0];
            if(emailBeforeAt.length > 64) {
                $translate('BM.Components.EmailUserNameLengthExceededError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }
            // User id required
            if(vm.myAccountForm.userId.$error.required){
                $translate('BM.Components.EnterEmailAddressError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            if(vm.myAccountForm.userId.$invalid){
                $translate('BM.Components.EnterValidEmailError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            // We don't want to check the email when the 'on-blur' event is called if we are allowed to merge accounts
            allowAccountMergingAsync().catch(function() {
                if(isFormSubmit === false && linkModalOpen === false){
                    validateUserIdAsync();
                }
            });
        }

        function validateUserIdAsync(){
            $scope.$emit('bm-busy-loading-on');
            return myAccountService.loginAlreadyUsedAsync(vm.localUser.email).then(function(response){
                $scope.$emit('bm-busy-loading-off');
                var data = response.data;

                if(angular.isDefined(data) && data.results === 'found' && vm.user.email !== vm.localUser.email && !vm.savingUserInProgress){
                    return allowAccountMergingAsync().then(function() {
                        openAccountLinkModal(vm.localUser.email);
                    }, function() {
                        $translate('BM.Components.EmailInUseError').then(function(data){
                            vm.userIdError = data;
                        });
                    });
                }
            }, function(error){
                $scope.$emit('bm-busy-loading-off');

                var emailBeforeAt = vm.myAccountForm.userId.$viewValue.split('@')[0];
                if(emailBeforeAt.length > 64) {
                    $translate('BM.Components.EmailUserNameLengthExceededError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                }

                if(vm.myAccountForm.userId.$error.required){
                    $translate('BM.Components.EnterEmailAddressError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                } else if(vm.myAccountForm.userId.$invalid){
                    $translate('BM.Components.EnterValidEmailError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                } else {
                    $translate('BM.Components.UnableToValidateEmailError').then(function(data){
                        vm.userIdError = data + error.data;
                  });
                }
            });
        }

        function cancelUser(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(isSkinny || licenseeDisplay){
                alert.closeable = !licenseeDisplay;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){

            var newUser = getCleanUserSaveData(vm.localUser);
            var initialUser = getCleanUserSaveData(vm.user);
            var isClean = angular.equals(newUser, initialUser);

            if(isClean){
                resetAlerts();
                // this assumes the initial value of email was valid
                vm.userIdError = '';
                vm.myAccountForm.$setPristine();
            } else {
                vm.myAccountForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedAccount = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').factory('myAccountService', myAccountService);
    myAccountService.$inject = ['$q','$http', '$rootScope', '$translate', 'AuthenticatedSessionData', 'bmLanguageManager', 'bmHttpCacheHelper'];

    function myAccountService($q, $http, $rootScope, $translate, authenticatedSessionData, bmLanguageManager, bmHttpCacheHelper){
        var factory = {
            getUserSettingsAsync: getUserSettingsAsync,
            getMyUserSettingsAsync: getMyUserSettingsAsync,
            getNameSuffixListAsync: getNameSuffixListAsync,
            getNamePrefixListAsync: getNamePrefixListAsync,
            getLanguageListAsync: getLanguageListAsync,
            saveUserAsync: saveUserAsync,
            saveUser: saveUser,
            saveUserCombined: saveUserCombined,
            persistLanguageAsync: persistLanguageAsync,
            loginAlreadyUsedAsync: loginAlreadyUsedAsync,
            saveUserLanguage: saveUserLanguage
        };

        var userApi =  '/api/profiles/v1/users';
        return factory;

        //////////

        function getUserSettingsAsync(userTruId){
            if(angular.isUndefined(userTruId)){
                return $translate('bm.account.service.unableToLoadUser').then(function(val){
                    return getRejectedPromise(val);
                });

            }

            // cache for 10 seconds
            return $http({
                method: 'GET',
                url: userApi + '/' + userTruId,
                bmCache: 10000
            });
        }

        function getMyUserSettingsAsync(){
            var promises = [
                getUserTruidFromSession(),
                getCompanyIdFromSession(),
                getContactIdFromSession()
            ];

            return $q.all(promises).then(function(data){
                return getUserSettingsAsync(data[0]).then(function(response){
                    // Persist the user data in order to keep it all in one place
                    if(angular.isDefined(response) && angular.isDefined(response.data)){
                        response.data.bluId = data[0];
                        response.data.companyId = data[1];
                        response.data.contactId = data[2];
                    }

                    return response;
                });
            });
        }

        function getNameSuffixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-suffixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNamePrefixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-prefixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNameAdditionsList(languageCode, baseUrl){
            if(angular.isUndefined(languageCode) || languageCode === ''){
                languageCode = 'en-US';
            }

            var url = baseUrl + '?language=' + encodeURIComponent(languageCode);

            // cache for 10 minutes
            return $http({
                method: 'GET',
                url: url,
                bmNoAuth: true,
                bmCache: 600000
            }).then(function(response){
                var list = [];

                if(angular.isUndefined(response.data) || angular.isUndefined(response.data.values)){
                    return list;
                }

                var values = response.data.values;

                for(var counter = 0; counter < values.length; counter++){
                    list.push({
                        id: counter,
                        description: values[counter]
                    });
                }

                return list;
            });
        }

        function getLanguageListAsync(){
            return bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                return languages;
            });
        }

        function saveUserAsync(user){
            return getUserTruidFromSession().then(function(userTruId) {

                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }

                return loginAlreadyUsedAsync(user.email).then(function(response){
                    if(response.data.results === 'found'){
                        return $translate('BM.Components.EmailInUseError').then(function(val){
                            return getRejectedPromise(val);
                        });
                    }

                    return $http({
                        method: 'PUT',
                        url: userApi + '/' + userTruId,
                        data: user
                    }).then(function(){
                        bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                    });
                });
            });
        }

        function saveUser(user) {
            return getUserTruidFromSession().then(function(userTruId){
                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId,
                    data: user
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                });
            });
        }

        function saveUserCombined(user, emailInUseVerify){
            return getUserTruidFromSession().then(function(userTruId) {

                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }

                if (emailInUseVerify) {
                    return loginAlreadyUsedAsync(user.email).then(function(response){
                        if(response.data.results === 'found'){
                            return $translate('BM.Components.EmailInUseError').then(function(val){
                                return getRejectedPromise(val);
                            });
                        }

                        return $http({
                            method: 'PUT',
                            url: userApi + '/' + userTruId,
                            data: user
                        }).then(function(){
                            bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                        });
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId,
                    data: user
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                });
            });
        }

        function saveUserLanguage(language) {
            return getUserTruidFromSession().then(function(userTruId){
                if(angular.isUndefined(userTruId)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId + '/language',
                    data: language
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId + '/language');
                });
            });
        }

        function persistLanguageAsync(languageCode){
            var curr = bmLanguageManager.getCurrentLanguage();
            if (curr !== languageCode) {
                return bmLanguageManager.setUserLanguageAsync(languageCode).then(function() {
                    $rootScope.$broadcast('bmLanguageChangeByUserSuccess', { language: languageCode });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }
        }

        function getRejectedPromise(rejectReason){
            var deferred = $q.defer();

            if(angular.isString(rejectReason)){
                deferred.reject({ data: rejectReason });
            } else {
                $translate('bm.account.service.unableToProcessUserInfo').then(function(val){
                    deferred.reject({ data: val });
                });
            }

            return deferred.promise;
        }

        function loginAlreadyUsedAsync(email) {
            // No need to verify if email is same as what's in session
            return getEmailAddressFromSession().then(function(sessionEmail) {
                if(angular.isDefined(sessionEmail) && angular.isDefined(email) && email.toLowerCase() === sessionEmail.toLowerCase()){
                    var deferred = $q.defer();

                    deferred.resolve({
                        data: {
                            results: 'notfound'
                        }
                    });

                    return deferred.promise;
                }

                return $http({
                    method: 'GET',
                    url: userApi + '/login-in-use?login=' + encodeURIComponent(email)
                });
            });

        }

        function getUserTruidFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.PrismGuid;
            });
        }

        function getEmailAddressFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.EmailAddress;
            });
        }

        function getCompanyIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.CompanyId;
                }

                return undefined;
            });
        }

        function getContactIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.ContactId;
                }

                return undefined;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').directive('bmMyAccountInfo', [function(){
        return {
            restrict: 'E',
            replace: true,
            template: function(elem, attrs){
                // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
                return '<ng-include src="vm.getTemplateUrl(\'' + attrs.display + '\')"/>';
            },
            scope: {
                languages: '=',
                user: '=',
                sharedData: '=',
                display: '@'
            },
            controller: 'MyAccountCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular) {
    'use strict';
        angular.module('bluemoon.myAccount').controller('LinkAuthCtrl', linkAuthCtrl);
        linkAuthCtrl.$inject = [
            'bmAccess',
            '$templateRequest',
            '$scope',
            '$translate',
            '$location',
            '$uibModalInstance',
            'AuthenticatedSession',
            'bmMultifactorService',
            'LinkedAccountsService',
            'myAccountService',
            'languageStorageManager',
            '$compile',
            '$rootScope',
            'uid'
        ];
        function linkAuthCtrl(
            bmAccess,
            $templateRequest,
            $scope,
            $translate,
            $location,
            $uibModalInstance,
            session,
            mfaService,
            linkedAccountsService,
            myAccountService,
            langMgr,
            $compile,
            $rootScope,
            uid
        ) {
            /*jshint validthis:true */
            var vm = this;
            vm.linkAccounts = linkAccounts;
            vm.closeModal = closeModal;
            vm.changeEmail = changeEmail;
            vm.pwd = '';
            vm.isLoaderBusy = false;

            var linkingResult = 'change email';

            function linkAccounts() {
                if (vm.verifyLoginForm.$valid) {
                    vm.isLoaderBusy = true;
                    // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
                    var userData = { uid: uid, pwd: vm.pwd, type: 'TRID' };
                    mfaService.verifyLoginData(userData).then(function(){
                        linkedAccountsService.linkExistingAccountWithLogin(userData.uid).then(function(linkedResp) {
                            linkingResult = linkedResp.data.LongToken;
                            session.switchAccountWithLongToken(linkingResult);
                            vm.isLoaderBusy = false;
                            closeModal();
                        }, function(error){
                            linkingResult = 'change email';
                            vm.isLoaderBusy = false;
                            if(error.status === 400) {
                                showLinkingError(error.data.message);
                            } else {
                                $translate('BM.Components.SorryTryAgainLater').then(function(text) {
                                    showLinkingError(text);
                                });
                            }
                        });
                    }, function(){
                        vm.isLoaderBusy = false;
                        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text) {
                            showLinkingError(text);
                        });
                    });
                }
            }

            function closeModal() {
                clearErrors();
                $uibModalInstance.close(linkingResult);
            }

            function changeEmail() {
                clearErrors();
                $uibModalInstance.dismiss('change email');
            }

            function showLinkingError(text) {
                clearErrors();
                $rootScope.bmErrors.splice(0, $rootScope.bmErrors.length);
                $rootScope.bmErrors.push({type: 'danger', msg: text, closeable: true});
            }

            function clearErrors() {
                if (!$rootScope.bmErrors) {
                    $rootScope.bmErrors = [];
                }
                $rootScope.bmErrors = [];
            }
        }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.updatePassword', [
        'bluemoon.components.session',
        'bluemoon.passwordValidation',
        'pascalprecht.translate',
        'bluemoon.components.focus'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').controller('UpdatePasswordCtrl', updatePassword);

    updatePassword.$inject = ['$translate', '$scope', 'bmAccess', 'PasswordFactory', 'PasswordValidationFactory'];

    function updatePassword($translate, $scope, bmAccess, PasswordFactory, PasswordValidationFactory){
        /*jshint validthis:true */
        var vm = this;

        var confirmPasswordMsgNoData = '';
        var confirmPasswordMsgNoMatch = '';
        var reusedPasswordError = '';
        var commonPasswordError = '';

        this.$onInit = function(){
            vm.savePassword = savePassword;
            vm.cancelPassword = cancelPassword;
            vm.validatePasswordFields = validatePasswordFields;
            vm.validateConfirmPassword = validateConfirmPassword;
            vm.setConfirmPasswordInFocus = setConfirmPasswordInFocus;
            vm.setConfirmPasswordOutOfFocus = setConfirmPasswordOutOfFocus;
            vm.isConfirmPasswordInvalid = isConfirmPasswordInvalid;
            vm.isConfirmPasswordValid = isConfirmPasswordValid;
            vm.closeAlert = closeAlert;

            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
            vm.confirmPasswordInFocus = false;

            $translate('BM.Components.PasswordMatchError').then(function(data){
                confirmPasswordMsgNoMatch = data;
            });
            $translate('BM.Components.NoDataEnteredError').then(function(data){
                confirmPasswordMsgNoData = data;
            });
            $translate('BM.Components.PasswordUsedPreviouslyError').then(function(data){
                reusedPasswordError = data;
            });
            $translate('BM.Components.PasswordTooCommonError').then(function(data){
                commonPasswordError = data;
            });

            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedPassword = false;

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setPasswordDirty = function(){
                setFormState();
            };

            vm.isSkinny = vm.sharedLocal.skinny === true; // controls how alerts are displayed
            vm.alerts = [];

            // Load up password validation rules
            PasswordValidationFactory.loadPasswordRules().then(function(response){
                angular.extend(vm, response);
            });

            // If appropriate, check for the existence of the user data
            bmAccess.has('PPE-AccountSwitching').then(function(){
                checkForUser();
            }).catch(angular.noop);
        };

        function checkForUser(){
            // Make sure a user is loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }
        }

        function savePassword(){
            resetAlerts();

            // Validate the form
            validatePasswordFields(true);

            if(vm.updatePasswordForm.$invalid || vm.passwordIsValidated !== true || vm.confirmIsValidated !== true){
                // Toggle all validation messages
                if(vm.updatePasswordForm.currentPassword.$error.required){
                   vm.updatePasswordForm.currentPassword.$dirty = true;
                   vm.updatePasswordForm.currentPassword.hasVisited = true;
                }

                $translate('BM.Components.IncompleteForm').then(function(value){
                    addAlert(value, 'danger');
                });

                return;
            }

            $scope.$emit('bm-busy-loading-on');
            PasswordFactory.savePassword(vm.currentPassword, vm.newPassword).then(function(){
                $scope.$emit('bm-busy-loading-off');
                resetEntryForm();
                vm.sharedLocal.hasUnsavedPassword = false;

                bmAccess.has('PPE-AccountSwitching').then(function(){
                    if (vm.user && vm.user.email) {
                        $translate('BM.Components.PasswordUpdateSuccessful').then(function (value) {
                            value = value + ' ' + vm.user.email;
                            addAlert(value, 'success');
                        });
                    } else {
                        $translate('bm.header.viewProfile.password.saveSuccessful').then(function (value) {
                            addAlert(value, 'success');
                        });
                    }
                }, function() {
                    $translate('bm.header.viewProfile.password.saveSuccessful').then(function(value){
                        addAlert(value, 'success');
                    });
                });
            }, function(response) {
                $scope.$emit('bm-busy-loading-off');

                response.config.global = false;
                if (response.status === 401) {
                    $translate('BM.Components.PasswordInvalidError').then(function(value){
                        addAlert(value, 'danger');
                    });
                } else if (response.data.error === 'PASSWORD_CONTAINS_USERINFO') {
                    $translate('BM.Components.PasswordContainsPersonalInfo').then(function(value){
                        addAlert(value, 'danger');
                    });
                } else {
                    $translate('BM.Components.PasswordUpdateError').then(function(value){
                        addAlert(value, 'danger');
                    });
                }
            });
        }

        function validatePasswordFields(isSubmit){
            validatePassword(isSubmit);
            validateConfirmPassword(isSubmit);
        }

        function validatePassword(isSubmit){
            // Reset the validation message
            vm.newPasswordError = '';
            vm.passwordIsValidated = false;

            // Password required
            if(vm.updatePasswordForm.newPassword.$error.required){
                $translate('BM.Components.EnterPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            if(angular.isUndefined(vm.rules) || vm.rules.length === 0) {
                return;
            }

            // run the rules
            // first, the character length rule because it's required
            var lengthRule = vm.rules.characterLengthRule;
            if(!lengthRule.test(vm.newPassword)) {
                $translate('BM.Components.ValidPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            } else {
                // second, the character type rules
                var rulesPassed = 0;
                for(var pos = 0; pos < vm.rules.characterTypeRules.length; pos++) {
                    var currentRule = vm.rules.characterTypeRules[pos];
                    if(currentRule.test(vm.newPassword)) {
                        rulesPassed++;
                    }
                }
                if(rulesPassed < vm.charClassReq) {
                    $translate('BM.Components.ValidPasswordError').then(function(data){
                        vm.newPasswordError = data;
                    });
                    return;
                }
            }

            if(vm.rules.prohibitedCharacterRule.test(vm.newPassword)){
                vm.newPasswordError = vm.rules.prohibitedCharacterRule.label + ': ' + vm.rules.prohibitedCharacterRule.getInvalidChars(vm.newPassword).join(', ');
                return;
            }

            if(isSubmit && (vm.currentPassword === vm.newPassword)){
                $translate('BM.Components.NewPasswordMatchError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            PasswordFactory.verifyNewPassword(vm.newPassword).then(function(response){
                if (response.data.usedPreviously) {
                    vm.newPasswordError = reusedPasswordError;
                } else if (response.data.tooCommon) {
                    vm.newPasswordError = commonPasswordError;
                }
            });

            vm.passwordIsValidated = true;
        }

        function validateConfirmPassword(isSubmit){
            // Reset the validation message
            vm.confirmPasswordError = '';
            vm.confirmIsValidated = false;

            // Has anything even been entered? Only show message on submit of form.
            if(isSubmit && (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '')){
                vm.confirmPasswordError = confirmPasswordMsgNoData;
                return;
            }

            if((angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '')){
                return;
            }

            if(vm.confirmPassword !== vm.newPassword){
                vm.confirmPasswordError = confirmPasswordMsgNoMatch;
                return;
            }

            vm.confirmIsValidated = true;
        }

        function isConfirmPasswordValid() {
            var isValid = false;
            var newPwd = '';
            var confirmPwd = '';

            if(vm.confirmPassword) {
                if(!vm.updatePasswordForm.newPassword.$error.required) {
                    newPwd = vm.newPassword;
                    confirmPwd = vm.confirmPassword;

                    if((confirmPwd.length === newPwd.length) && (confirmPwd === newPwd)) {
                        isValid = true;
                    }
                }
            }
            return isValid;
        }

        function isConfirmPasswordInvalid() {
            var isInvalid = true;
            var newPwd = '';
            var confirmPwd = '';
            vm.confirmIsValidated = false;

            // Get the data to check
            if(angular.isUndefined(vm.newPassword)){
                newPwd = '';
            } else {
                newPwd = vm.newPassword;
            }
            if(angular.isUndefined(vm.confirmPassword)){
                confirmPwd = '';
            } else {
                confirmPwd = vm.confirmPassword;
            }

            // check the data
            if(vm.confirmPasswordInFocus) {
                vm.updatePasswordForm.confirmPassword.$dirty = true;

                if(confirmPwd === newPwd) {
                    vm.confirmPasswordError = '';
                    isInvalid = false;
                } else if(newPwd.slice(0, confirmPwd.length) !== confirmPwd) {
                    if(confirmPwd === '') {
                        vm.confirmPasswordError = confirmPasswordMsgNoData;
                    } else {
                       vm.confirmPasswordError = confirmPasswordMsgNoMatch;

                    }
                } else {
                     vm.confirmPasswordError = '';
                     isInvalid = false;
                }
            } else {
                if(vm.updatePasswordForm.confirmPassword.$dirty) {
                    vm.confirmPasswordError = '';
                    validateConfirmPassword(true);
                }

                if(vm.confirmPasswordError === '') {
                    isInvalid = false;
                }
            }

            return isInvalid;
        }

        function setConfirmPasswordInFocus() {
            vm.confirmPasswordInFocus = true;
            vm.confirmPasswordError = '';
        }

        function setConfirmPasswordOutOfFocus() {
            vm.confirmPasswordInFocus = false;
        }

        function resetEntryForm(){
            vm.currentPassword = '';
            vm.newPassword = '';
            vm.confirmPassword = '';
            vm.updatePasswordForm.$setPristine();
            vm.passwordIsValidated = false;
            vm.confirmIsValidated = false;

            // clear any validation messages
            vm.updatePasswordForm.currentPassword.$setValidity('required', true);
            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(vm.isSkinny){
                alert.closeable = true;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }

        function closeAlert(index){
            vm.alerts.splice(index, 1);
        }

        function cancelPassword(){
            if(vm.sharedLocal.resetOnCancel){
                vm.currentPassword = '';
                vm.newPassword = '';
                vm.confirmPassword = '';

                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function setFormState(){
            var isClean = (angular.isUndefined(vm.currentPassword) || vm.currentPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '') &&
                (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '');

            if(isClean){
                resetEntryForm();
                resetAlerts();
            } else {
                vm.updatePasswordForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedPassword = !isClean;
        }
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').factory('PasswordFactory', passwordFactory);
    passwordFactory.$inject = ['$http'];

    function passwordFactory($http){
        var factory = {
            savePassword: savePassword,
            verifyNewPassword: verifyNewPassword
        };
        var passwordApi = '/api/profiles/v1/password';
        var passwordVerifyApi = '/api/profiles/v2/password/check';

        return factory;

        //////////

        function savePassword(oldPassword, newPassword){
            return $http({
                method: 'PUT',
                url: passwordApi,
                data: { oldPassword: oldPassword, newPassword: newPassword },
                headers: {'x-prevent-unauthorized': true},
                bmAuthRedirect: false // disable 401 redirection
            });
        }

        function verifyNewPassword(password){
            return $http({
                method: 'POST',
                url: passwordVerifyApi,
                headers: {'Content-Type': 'application/json'},
                data: {
                    password: password
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').directive('bmUpdatePassword', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'update-password/update-password.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'UpdatePasswordCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.securityQuestions', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bmForceModelChange',
        'bmHttpCache'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').controller('SecurityQuestionsCtrl', securityQuestions);
    securityQuestions.$inject = ['$q', '$scope', '$translate', 'SecurityQuestionsFactory'];

    function securityQuestions($q, $scope, $translate, SecurityQuestionsFactory){
        /*jshint validthis:true */
        var vm = this;
        var questionCounter;
        var answerInitValue;
        var masterQuestions = vm.master;
        var initialUserQuestions = vm.userQuestions;

        vm.saveQuestions = saveQuestions;
        vm.cancelQuestions = cancelQuestions;
        vm.processQuestionSelect = processQuestionSelect;
        vm.validateAnswer = validateAnswer;
        vm.clearDefaultAnswer = clearDefaultAnswer;

        var selectQuestionError = 'Please select a question.';
        var enterAnswerError = 'Please enter an answer.';
        var loadSecurityQuestionsError = 'Unable to load security question information. Please try again.';
        var loadSecurityEnounteredError = 'An error was encountered while loading security questions.';
        var entryDataLoadError = 'Unable to load form entry data. Please try again.';
        var noSecurityQuestionsSetupError = 'Please setup your security questions.';

        // 2-way bound data object to pass information between tabs
        vm.sharedLocal = vm.sharedData;
        vm.sharedLocal.hasUnsavedQuestions = false;

        translateErrors();
        initializeView();

        //////////

        function translateErrors(){
            $translate('BM.Components.Security.SelectQuestionError').then(function(data){
                selectQuestionError = data;
            });
            $translate('BM.Components.Security.EnterAnswerError').then(function(data){
                enterAnswerError = data;
            });
            $translate('BM.Components.Security.LoadSecurityQuestionsError').then(function(data){
                loadSecurityQuestionsError = data;
            });
            $translate('BM.Components.Security.LoadSecurityEnounteredError').then(function(data){
                loadSecurityEnounteredError = data;
            });
            $translate('BM.Components.Security.EntryDataLoadError').then(function(data){
                entryDataLoadError = data;
            });

            $translate('BM.Components.Security.NoSecurityQuestionsSetupError').then(function(data){
                noSecurityQuestionsSetupError = data;
            });
        }

        function initializeView(){
            resetAlerts();
            vm.questions = [];

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setQuestionsDirty = function(){
                setFormState();
            };

            // assumes user never setup any questions
            if(angular.isUndefined(initialUserQuestions)){
                initialUserQuestions = getDefaultUserQuestions();
                addAlert(noSecurityQuestionsSetupError, 'danger');
            } else {
                // Note: These characters in javascript seem bad
                answerInitValue = '●●●●●●●●●●●●●●●●●●●●';
            }

            if(angular.isUndefined(masterQuestions) || initialUserQuestions.length === 0){
                addAlert(loadSecurityQuestionsError, 'danger');
                return;
            }

            vm.questions = getBindableData(angular.copy(initialUserQuestions));
            filterMasterQuestions();
        }

        function getDefaultUserQuestions(){
            return [
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' }
            ];
        }

        function saveQuestions(){
            resetAlerts();

            // Just make sure
            if(angular.isUndefined(vm.questions) || vm.questions.length === 0){
                addAlert(entryDataLoadError, 'danger');
                return;
            }

            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                // Note: Validation messages will be set when isFormValid is processed
                var alert = '';
                 $translate('BM.Components.IncompleteForm').then(function(data){
                    alert = data;
                    addAlert(alert, 'danger');
                });
                return;
            }

            var questionsToSave = getSaveData(angular.copy(vm.questions));

            $scope.$emit('bm-busy-loading-on');
            SecurityQuestionsFactory.saveQuestions(questionsToSave).then(function(){
                $scope.$emit('bm-busy-loading-off');
                vm.sharedLocal.hasUnsavedQuestions = false;
                initialUserQuestions = angular.copy(vm.questions);
                $translate('bm.header.viewProfile.questions.saveSuccessful').then(function(value){
                    addAlert(value, 'success');
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('BM.Components.IncorrectSecurityQuestion').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        function cancelQuestions(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function processQuestionSelect(listIndex, question){
            validateQuestion(question);

            // Answer is required if question is changed in a list
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === answerInitValue){
                question.answer = '';
            }

            // Filter the master questions list for each question
            filterMasterQuestions(listIndex);
        }

        function filterMasterQuestions(listIndex){
            // listIndex = <select> list that the value was changed in
            // Need to filter selected questions out of other master lists so the same question can't be selected twice
            var currentQuestionList;

            for(questionCounter = 0; questionCounter < vm.questions.length; questionCounter++){
                // Don't need skip the list that was just selected
                if(angular.isDefined(listIndex) && questionCounter === listIndex){
                    continue;
                }

                // Get a filtered list
                currentQuestionList = angular.copy(masterQuestions);
                currentQuestionList = currentQuestionList.filter(notAlreadySelected);

                // The first time through will not have a master list of questions
                if(angular.isUndefined(vm.questions[questionCounter].masterList)){
                    vm.questions[questionCounter].masterList = currentQuestionList;
                    continue;
                }

                var removeCounter = vm.questions[questionCounter].masterList.length;
                var questionIdAsInt = parseInt(vm.questions[questionCounter].selectedQuestion.questionId);

                // Clear the existing array without creating a new array object as this will kill scope
                while(removeCounter > 0){
                    removeCounter--;
                    // Don't clear the selected question
                    if(vm.questions[questionCounter].masterList[removeCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    vm.questions[questionCounter].masterList.splice(removeCounter, 1);
                }

                // Append to the array without creating a new array object
                for(var addCounter = 0; addCounter < currentQuestionList.length; addCounter++){
                    if(currentQuestionList[addCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    if(currentQuestionList[addCounter].questionId < questionIdAsInt){
                        vm.questions[questionCounter].masterList.unshift(currentQuestionList[addCounter]);
                    } else {
                        vm.questions[questionCounter].masterList.push(currentQuestionList[addCounter]);
                    }
                }
            }
        }

        function notAlreadySelected(element){
            var alreadySelected = false;
            var questionIdAsInt;

            for(var counter = 0; counter < vm.questions.length; counter++){
                if(alreadySelected){
                    break;
                }

                if(vm.questions[counter].selectedQuestion === null){
                    continue;
                }

                questionIdAsInt = parseInt(vm.questions[counter].selectedQuestion.questionId);
                // questionCounter is global and represents the current list being filtered
                alreadySelected = (element.questionId === questionIdAsInt && questionIdAsInt !== vm.questions[questionCounter].selectedQuestion.questionId);
            }

            return !alreadySelected;
        }

        function clearDefaultAnswer(question){
            if(question.answer === answerInitValue){
                question.answer = '';
            }
        }

        function validateFormEntry(questions){
            var isValid = true;

            angular.forEach(questions, function(question){
                validateQuestion(question);
                validateAnswer(question);

                if(question.questionError !== '' || question.answerError !== ''){
                    isValid = false;
                }
            });

            return isValid;
        }

        function validateQuestion(question){
            if(angular.isUndefined(question)){
                question.questionError = selectQuestionError;
                return;
            }

            if(angular.isUndefined(question) || question.selectedQuestion === null || angular.isUndefined(question.selectedQuestion) || question.selectedQuestion.questionId === ''){
                question.questionError = selectQuestionError;
                return;
            }

            // set unloaded question to the selected question
            if(question.questionId === ''){
                question.questionId = question.selectedQuestion.questionId;
                question.question = question.selectedQuestion.question;
            }

            question.questionError = '';
        }

        function validateAnswer(question){
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === ''){
                question.answerError = enterAnswerError;
                return;
            }

            question.answerError = '';
        }

        function getBindableData(questions){
            angular.forEach(questions, function(question){
                question.answer = answerInitValue;
                question.answerError = '';
                question.questionError = '';

                // Store the selected question separately for the model
                // http://stackoverflow.com/questions/28133187/angularjs-select-cleared-after-selecting-value
                if(angular.isUndefined(question.selectedQuestion)){
                    question.selectedQuestion = question;
                }
            });

            return questions;
        }

        function getSaveData(questionList){
            var questionsToSave = {};
            var questions = [];

            angular.forEach(questionList, function(saveQuestion, index){
                if(angular.isUndefined(saveQuestion.selectedQuestion)){
                    questions.push({
                        questionId: saveQuestion.questionId,
                        question: saveQuestion.question,
                        answer: saveQuestion.answer
                    });
                } else {
                    questions.push({
                        questionId: parseInt(saveQuestion.selectedQuestion.questionId),
                        question: getQuestionTextFromId(saveQuestion.selectedQuestion.questionId),
                        answer: (saveQuestion.answer === answerInitValue) ? initialUserQuestions[index].answer : saveQuestion.answer
                    });
                }
            });

            questionsToSave.questions = questions;
            return questionsToSave;
        }

        function getQuestionTextFromId(questionId){
            var questionText;

            for(var counter = 0; counter < masterQuestions.length; counter++){
                if(parseInt(questionId) === masterQuestions[counter].questionId){
                    questionText = masterQuestions[counter].question;
                    break;
                }
            }

            return questionText;
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type });
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){
            // Is the form valid?
            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                vm.sharedLocal.hasUnsavedQuestions = true;
                return;
            }

            var saveData = getSaveData(vm.questions);
            var initialData = getSaveData(initialUserQuestions);
            var isClean = angular.equals(saveData, initialData);

            if(isClean){
                resetAlerts();
            }

            vm.sharedLocal.hasUnsavedQuestions = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').factory('SecurityQuestionsFactory', securityQuestionsFactory);
    securityQuestionsFactory.$inject = ['$q','$http', 'AuthenticatedSessionData', 'bmHttpCacheHelper'];

    function securityQuestionsFactory($q, $http, authenticatedSessionData, bmHttpCacheHelper){
        var factory = {
            getSecurityQuestions: getSecurityQuestions,
            getUserSecurityQuestions: getUserSecurityQuestions,
            getMyUserSecurityQuestions: getMyUserSecurityQuestions,
            saveQuestions: saveQuestions
        };

        var questionsApi = '/api/profiles/v1/security-questions';

        // cache for 10 minutes
        var baseHttpConfig = {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            },
            bmCache: 600000
        };

        return factory;

        //////////

        function getUserSecurityQuestions(emailAddress){
            if(angular.isUndefined(emailAddress)){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            var apiUrl = questionsApi + '/' + emailAddress;
            return $http.get(apiUrl, baseHttpConfig);
        }

        function getMyUserSecurityQuestions(){
            var myEmail = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

            return getUserSecurityQuestions(myEmail);
        }

        function getSecurityQuestions(){
            return $http.get(questionsApi, baseHttpConfig);
        }

        function saveQuestions(questions){
            return $http.put(questionsApi, questions).then(function(){
                var emailAddress = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

                // invalidate any user questions stored in cache
                if(angular.isDefined(emailAddress)){
                    bmHttpCacheHelper.invalidateHttpCache(questionsApi + '/' + emailAddress);
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').directive('bmSecurityQuestions', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'security-questions/security-questions.2js.html',
            scope: {
                master: '=',
                userQuestions: '=',
                sharedData: '='
            },
            controller: 'SecurityQuestionsCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmPermission',
        'bluemoon.myAccount',
        'bluemoon.securityQuestions',
        'bluemoon.updatePassword',
        'bmCheckpointCredentials',
        'bmMultifactorProfile',
        'bmLinkedAccounts'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile').controller('bmViewProfileCtrl', bmViewProfileCtrl);
    bmViewProfileCtrl.$inject = ['$scope', '$translate', '$uibModalInstance', 'languages', 'user'];

    function bmViewProfileCtrl($scope, $translate, $uibModalInstance, languages, user){
        /*jshint validthis:true */
        var vm = this;
        vm.languages = languages;
        vm.user = user;

        // object used to share methods between profile directives
        vm.sharedProfile = {};

        vm.closeProfile = closeProfile;
        vm.tabDeselect = tabDeselect;
        vm.tabSelect = tabSelect;

        $scope.$on('bmLanguageChangeSuccess', loadTranslations);
        $scope.$on('bmProfileCancelAction', function(){
            closeProfile();
        });

        loadTranslations();

        //////////

        function loadTranslations(){
            $translate('bm.header.viewProfile.unsavedChanges').then(function(value){
                vm.translatedUnsaved = value;
            }, function(){
                vm.translatedUnsaved = 'Unsaved Changes';
            });
        }

        function closeProfile(){
            $uibModalInstance.dismiss('close');
        }

        function tabSelect(whichTab){
            switch(whichTab){
                case 'linkedAccounts':
                    vm.sharedProfile.refreshLinkedAccounts();
                    break;
                default:
                    break;
            }
        }

        function tabDeselect(whichTab){
            switch(whichTab){
                case 'account':
                    vm.sharedProfile.setAccountDirty();
                    break;
                case 'password':
                    vm.sharedProfile.setPasswordDirty();
                    break;
                case 'checkpoint':
                    vm.sharedProfile.setCheckpointDirty();
                    break;
                case 'linkedAccounts':
                    vm.sharedProfile.setLinkedAccountsDirty();
                    break;
                default:
                    break;
            }
        }
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.timeZoneOffsetInterceptor', [])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('bmHttpTimeZoneOffsetInterceptor');
        }])
        .service('bmHttpTimeZoneOffsetInterceptor', function () {
            var headerKey = 'User-Time-Zone-Offset-Minutes';
            this.request = function (conf) {
                if (!conf.headers[headerKey]) {
                    conf.headers[headerKey] = new Date().getTimezoneOffset();
                }
                return conf;
            };
        });
})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFormatOnBlur
     *
     *  Requires: ngModel
     *
     *  Scope type: none
     *
     *  Description:
     *  Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     *  a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     */
    angular.module('bmFormatOnBlur', ['bento.services'])
        .directive('bmFormatOnBlur', ['$bentoServices',
            function($bentoServices) {
                return {
                    require: 'ngModel',
                    priority: 10,
                    link: function($scope, element, attrs, ctrl) {
                        // when we lose focus, revert to old value if new value is invalid,
                        // then reformat the view.
                        element.bind('blur', function() {
                            $bentoServices.safeApply($scope, angular.noop);

                            // re-run the formatter chain on the $modelValue
                            if(!ctrl.$invalid) {
                                ctrl.$viewValue = ctrl.$modelValue;
                                for(var i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                                    ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                                }

                                // re-render the view
                                ctrl.$render();
                            }
                        });
                    }
                };
    }]);

}(window.angular));

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts', ['bento.modern', 'LinkedAccountsService', 'wj', 'bmLinkingMerge']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsCtrl', LinkedAccountsCtrl);
	LinkedAccountsCtrl.$inject = ['$scope', '$translate', '$bentoBusyLoader', '$uibModal', 'LinkedAccountsService'];

    function LinkedAccountsCtrl($scope, $translate, $bentoBusyLoader, $uibModal, LinkedAccountsService){

        /*jshint validthis:true */
		var vm = this;

		this.$onInit = function(){
			vm.saveLinkedAccounts = saveLinkedAccounts;
			vm.cancelLinkedAccounts = cancelLinkedAccounts;
			vm.defaultChanged = defaultChanged;
			vm.openMergeLinkingAccountDialog = openMergeLinkingAccountDialog;

			vm.linkedAccounts = [];
			vm.gridData = [];
			vm.alerts = [];
			vm.linkedAccountsSummaryMsg = '';
			vm.selectedDefaultLinkAccountId = '0';
			vm.flexgrid = undefined;
			vm.hasOneAccount = false;
			vm.showAccounts = true;
			vm.isLoaderBusy = false;

			// 2-way bound data object to pass information between tabs
			vm.sharedLocal = vm.sharedData;
			vm.sharedLocal.hasUnsavedLinkedAccounts = false;

			initializeView();
		};

		function initializeView() {
			resetAlerts();

			// Create method publicly available through 2-way data bound object
			vm.sharedLocal.setLinkedAccountsDirty = function(){
				setFormState();
			};

			vm.sharedLocal.refreshLinkedAccounts = function(){
				if(vm.linkedAccounts.length === 0) {
					loadData();
				}
			};

			// Only used when it's called in a dialog by itself. It will not when called when viewing profile.
			if(vm.sharedLocal.loadLinkedAccounts) {
				loadData();
			}
		}

		function loadData() {
			// Make sure the user was resolved
			if(angular.isUndefined(vm.user) || vm.user === ''){
				$translate('BM.Components.AccountInformation.LoadError').then(function(alert){
					addAlert(alert, 'danger');
				});

				return;
			} else {
				loadLinkedAccounts();
			}
		}

        function openMergeLinkingAccountDialog() {
            var modalOptions = {
                templateUrl: 'components/linking-merge/linking-merge-modal.2js.html',
                controllerUrl: 'components/linking-merge/linking-merge-controller',
                controller: 'bmLinkingMergeCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function () {
                        return undefined;
                    },
                    sharedProfile: function () {
                        return {};
                    }
                }
            };
            var instance = $uibModal.open(modalOptions)
				.result.then(function () {
					$translate('bm.linkingMerge.success').then(function (value) {
                        addAlert(value, 'success');
                    });
					loadLinkedAccounts();
				}, function () {
					// do nothing on popup dismissal.
				});

            return instance;

        }

		function loadLinkedAccounts() {
			vm.isLoaderBusy = true;
			LinkedAccountsService.getAllOnvioLinkedAccounts().then(function(response){
				vm.linkedAccounts = response.data;

				// if no accounts, do not show grid
				if(vm.linkedAccounts && vm.linkedAccounts.length < 1) {
					vm.showAccounts = false;
				}

				// if only one account, disable active and default values
				if(vm.linkedAccounts && vm.linkedAccounts.length < 2) {
					vm.hasOneAccount = true;
				}

				// find the default account
				for(var pos1 = 0; pos1 < vm.linkedAccounts.length; pos1++) {
					var someLinkedAccount = vm.linkedAccounts[pos1];
					if(someLinkedAccount.home) {
						vm.selectedDefaultLinkAccountId = someLinkedAccount.linkedAccountId;
					}

					if(!someLinkedAccount.displayedNickname || someLinkedAccount.displayedNickname === '') {
						vm.linkedAccounts[pos1].displayedNickname = '';
					}
				}

				vm.gridData = vm.linkedAccounts;
				vm.gridData = new wijmo.collections.CollectionView(vm.gridData);  // jshint ignore: line
				vm.gridData.trackChanges = true;
				vm.isLoaderBusy = false;

			}).catch(function(error){
				addAlert(error.message, 'danger');
				vm.isLoaderBusy = false;
				console.log(error);
			});
		}

		function addAlert(message, type){
			resetAlerts();

			var alert = { msg: message, type: type, closeable: true };
			vm.alerts.push(alert);
		}

		function resetAlerts(){
			vm.alerts = [];
		}

		function convertToJson(itemsEdited) {
			var jsonObject = {
				linkedAccountsToUpdate : []
			};

			for(var pos = 0; pos < itemsEdited.length; pos++) {
				var item = itemsEdited[pos];
				jsonObject.linkedAccountsToUpdate.push(item);
			}

			return jsonObject;
		}

		function saveLinkedAccounts() {
			resetAlerts();

			var items = vm.gridData.items;
			var itemsEdited = vm.gridData.itemsEdited;

			// Check for edited items
			if(itemsEdited && itemsEdited.length > 0) {
				// check to make sure all items are valid
				if(hasValidData(items)) {
					// conver to json
					var jsonAccounts = convertToJson(itemsEdited);

					vm.isLoaderBusy = true;
					LinkedAccountsService.updateLinkedAccounts(jsonAccounts).then(function(){
						vm.isLoaderBusy = false;
						$translate('bm.components.linkedAccounts.updateSuccsessful').then(function(msg){
							addAlert(msg, 'success');
						});
					}).catch(function(error){
						vm.isLoaderBusy = false;
						console.log(error);
					});
				}
			}
		}

		function hasValidData(items) {
			var isValid = true;

			if(!hasActiveAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActive').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have at least one active account selected.', 'danger');
				});
			} else if(!hasActiveHomeAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActiveHome').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have an active account marked as home.', 'danger');
				});
			} else if(!hasValidNickname(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.invalidNickname').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: The nickname must be less then 50 characters.', 'danger');
				});

			}
			return isValid;
		}

		function hasActiveAccount(items) {
			var hasOneActiveAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active) {
					hasOneActiveAccount = true;
				}
			}

			return hasOneActiveAccount;
		}

		function hasActiveHomeAccount(items) {
			var activeHomeAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active && items[pos].home) {
					activeHomeAccount = true;
				}
			}

			return activeHomeAccount;
		}

		function hasValidNickname(items) {
			var validNickname = true;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].displayedNickname && items[pos].displayedNickname.length > 50) {
					validNickname = false;
				}
			}

			return validNickname;
		}

		function cancelLinkedAccounts() {
			if(vm.sharedLocal.resetOnCancel) {
				initializeView();
				setFormState();
			}
			resetAlerts();
			$scope.$emit('bmProfileCancelAction');
		}

		function setFormState(){
			var hasChanges = false;

			if(!angular.isUndefined(vm.gridData.itemsEdited)) {
				if(vm.gridData.itemsEdited.length > 0) {
					hasChanges = true;
				}
			}

			if(hasChanges){
				vm.linkedAccountsForm.$setDirty();
			} else {
				resetAlerts();
			}

			vm.sharedLocal.hasUnsavedLinkedAccounts = hasChanges;
		}

		$scope.$watch('selectedDefaultLinkAccountId', function() {
			defaultChanged();
		});

		function defaultChanged() {
			if(vm.flexgrid && (vm.selectedDefaultLinkAccountId !== 0)) {
				var cv = vm.flexgrid.collectionView;
				for(var pos = 0; pos < cv.items.length; pos++) {
					var item = cv.items[pos];
					if((item.linkedAccountId === vm.selectedDefaultLinkAccountId) && (!item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = true;
						cv.items[pos].active = true;
						cv.commitEdit();
						cv.refresh();
					} else if((item.linkedAccountId !== vm.selectedDefaultLinkAccountId) && (item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = false;
						cv.commitEdit();
						cv.refresh();
					}
				}
			}
		}
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts').directive('bmLinkedAccounts', bmLinkedAccounts);
    bmLinkedAccounts.$inject = [];

    function bmLinkedAccounts(){
        return {
            restrict: 'EA',
            templateUrl: 'components/linked-accounts/linked-accounts.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'LinkedAccountsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            replace: true
        };
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('LinkedAccountsService', []).service('LinkedAccountsService', LinkedAccountsService);

  LinkedAccountsService.$inject = ['$q', '$http'];
  function LinkedAccountsService($q, $http){
    /*jshint validthis:true */
    var self = this;
	var mergeAccountsApi = '/api/profiles/v2/accounts/merge';
    var linkedAccountsApi = '/api/profiles/v1/accounts';
	var linkedAccountsSessionApi = '/api/security/v2/sessions/accounts';
	var linkExistingAccountApi = '/api/profiles/v1/accounts/merge';

    self.linkAccounts = linkAccounts;
    self.getLinkedAccounts = getLinkedAccounts;
	self.getActiveLinkedAccounts = getActiveLinkedAccounts;
    self.getActiveOnvioLinkedAccounts = getActiveOnvioLinkedAccounts;
    self.getAllOnvioLinkedAccounts = getAllOnvioLinkedAccounts;
    self.updateLinkedAccounts = updateLinkedAccounts;
	self.createLinkedAccountSession = createLinkedAccountSession;
	self.linkExistingAccount = linkExistingAccount;
    self.linkExistingAccountWithLogin = linkExistingAccountWithLogin;

    function linkAccounts(linkingAccount) {
        return $http({
            method: 'PUT',
            url: mergeAccountsApi,
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
            data: linkingAccount
        });
    }

	function getLinkedAccounts() {
		// no need to send the bluid, it will be retrieved from
		return $http({
			method: 'GET',
			url: linkedAccountsApi,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveLinkedAccounts() {
		var linkedAccountsUrl = linkedAccountsApi + '?active=true';
		return $http({
			method: 'GET',
			url: linkedAccountsUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveOnvioLinkedAccounts() {
        var linkedAccountsUrl = linkedAccountsApi + '?active=true&hideNonOnvio=true';
        return $http({
            method: 'GET',
            url: linkedAccountsUrl,
            headers: {'Accept': 'application/json'}
        });
    }

	function getAllOnvioLinkedAccounts() {
        var linkedAccountsUrl = linkedAccountsApi + '?hideNonOnvio=true';
        return $http({
            method: 'GET',
            url: linkedAccountsUrl,
            headers: {'Accept': 'application/json'}
        });
    }

	function updateLinkedAccounts(linkedAccounts){
		return $http({
			method: 'PUT',
			url: linkedAccountsApi,
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			data: linkedAccounts.linkedAccountsToUpdate
		});
	}

	function createLinkedAccountSession(linkedAcccountId) {
		var apiUrl = linkedAccountsSessionApi + '/' + linkedAcccountId;
		return $http({
			method: 'POST',
			url: apiUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function linkExistingAccount(bluid) {
		var config = {
			method: 'PUT',
			url: linkExistingAccountApi + '/' + bluid,
		};
		return $http(config);
	}

    function linkExistingAccountWithLogin(email) {
        var config = {
            method: 'PUT',
            url: linkExistingAccountApi + '?login=' + encodeURIComponent(email)
        };

        return $http(config).then(
            function(resp) {
                var defer = $q.defer();
                defer.resolve(resp);
                return defer.promise;
            },
            function(resp) {
                resp.config.global = false;
                return $q.reject(resp);
            }
        );
    }

  }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsDialogCtrl', LinkedAccountsDialogCtrl);
	LinkedAccountsDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'user', 'sharedProfile' ];

	function LinkedAccountsDialogCtrl($scope, $uibModalInstance, user, sharedProfile){
		/*jshint validthis:true */
		var vm = this;

		vm.user = undefined;
		vm.sharedProfile = {};

		vm.user = user;
		vm.sharedProfile = sharedProfile;
		vm.sharedProfile.loadLinkedAccounts = true;
		vm.closeDialog = closeDialog;

        $scope.$on('bmProfileCancelAction', function(){
            closeDialog();
        });

        function closeDialog(){
            $uibModalInstance.dismiss('close');
        }
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkingMerge', [
        'ui.bootstrap',
        'pascalprecht.translate'

    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts').controller('bmLinkingMergeCtrl', bmLinkingMergeCtrl);
    bmLinkingMergeCtrl.$inject = ['$translate', '$http', '$window', '$uibModalInstance', 'bmUser', 'LinkedAccountsService'];

    function bmLinkingMergeCtrl($translate, $http, $window, $uibModalInstance, user, LinkedAccountsService){
        /*jshint validthis:true */
        var vm = this;
        vm.user = user;
        vm.linkingAccount = {pwd: '', uid: ''};

        vm.addLinkingAccount = addLinkingAccount;

        vm.closeAddAccount = closeAddAccount;
        vm.clearFields = clearFields;
        vm.alerts = [];
        vm.emailRegex =  new RegExp('^((([a-z]|\\d|[!#\\$%&\'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&\'\\*\\+\\-' +
        '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
        '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
        '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
        '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
        '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
        '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
        '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

        function clearFields() {
            vm.linkingAccountForm.pwd = '';
            vm.linkingAccountForm.uid = '';
        }

        function addLinkingAccount() {
            resetAlerts();

            if (vm.linkingAccountForm.$invalid) {

                setFormValidity();
                return;
            }

            if(!vm.emailRegex.test(vm.linkingAccount.uid)){
                $translate('bm.linkingMerge.wrongEmailFormat').then(function (value) {
                    addAlert(value, 'danger');
                });
                return;
            }

            LinkedAccountsService.linkAccounts(vm.linkingAccount)
            .then(function(){
                $uibModalInstance.close();
                $window.location.reload();
            })
            .catch(function(response){
                // don't get caught up in the global error handler
                response.config.global = false;

                if(response.status === 400 && response.data.Message[0] === 'Unable to confirm your password. Please try again.'){
                    $translate('bm.linkingMerge.wrongPassword').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else if (response.status === 400 && response.data.Message[0] === 'Cannot link accounts that are in the same company'){
                    $translate('bm.linkingMerge.wrongCompanyAlert').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else if (response.status === 400 && response.data.Message[0] === 'Deactivated account. Please contact your administrator'){
                    $translate('bm.linkingMerge.deactivatedAccountAlert').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else {
                    addAlert(response.data.Message[0], 'danger');
                }
            });
        }

        function setFormValidity(){
            if(vm.linkingAccountForm.uid.$error.required){
                vm.linkingAccountForm.uid.$setDirty();
                vm.linkingAccountForm.uid.$setTouched();
            }

            if(vm.linkingAccountForm.pwd.$error.required){
                vm.linkingAccountForm.pwd.$setDirty();
                vm.linkingAccountForm.pwd.$setTouched();
            }
        }

        function closeAddAccount(){
            clearFields();
            resetAlerts();
            $uibModalInstance.dismiss('close');
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type, closeable: true, timeout: 2500 });
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }

    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget', []);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').component('previewTrialWidget', {
        templateUrl: 'components/preview-trial-widget/preview-trial-widget.2js.html',
        controller: previewTrialWidgetCtrl,
        controllerAs: 'vm'
    });

    previewTrialWidgetCtrl.$inject = ['previewTrialService', '$translate', '$q', 'bmUtil', 'bmPermission'];
    function previewTrialWidgetCtrl(previewTrialService, $translate, $q, bmUtil, bmPermission) {
        /*jshint validthis:true */
        var vm = this;

        vm.$onInit = onInit;
        function onInit(){
            vm.days = ''; // fall back for 404 error on ProvisioningServices trial api
            vm.lang = getLang();
            bmPermission.has('Platform.Trial').then(function() {
                getRemainingDays().then(function(days){
                    vm.days = days;
                    setMessage();
                });
            }).catch(angular.noop);
            bmPermission.has('Platform.PreviewMode').then(function() {
                setMessage();
            }).catch(angular.noop);
        }
        function setMessage() {
            bmPermission.has('Platform.Trial').then(function() {
                vm.trial = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/purchase';
            }).catch(angular.noop);
            bmPermission.has('Platform.PreviewMode').then(function() {
                vm.preview = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/signup';
            }).catch(angular.noop);
        }
        function getLang(){
            var lang = bmUtil.cookie('BMLanguageCode');
            return lang.slice(0,2);
        }
        function getRemainingDays() {
            return getTrialExpiration().then(function(expirationDate){
                var today = new Date();
                var expiration = new Date(expirationDate);
                var diff = Math.abs(expiration.getTime() - today.getTime());
                var days = Math.floor(diff / (1000 * 3600 * 24));
                return days;
            });
        }
        function getTrialExpiration(){
            return previewTrialService.getTrialExpiration().then(function(resp){
                return resp.data.expireDate;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').factory('previewTrialService', previewTrialService);
    previewTrialService.$inject = ['$http'];

    function previewTrialService($http) {
		var factory = {
			getTrialExpiration: getTrialExpiration
		};

		return factory;

		function getTrialExpiration() {
			return $http({
				method: 'GET',
				url: '/api/provisioning/v1/trials'
			});
		}
    }

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.modal', ['ui.bootstrap', 'bento.modern']).service('bmModal', [ '$uibModal', function($uibModal) {

        /*
         * Displays a customizable modal.
         *
         * Config object properties:
         *
         * templateUrL: String, optional. Path to the template that should be used for this modal.
         *      If blank, a default template will be used that takes two variables: title and body.
         * showClose: boolean, optional. If true, a close button will be shown in the top-right corner
         *      of the modal. Defaults to true.
         * vars: Map of variables used in the modal template, available to the template as $scope.vars
         * buttons: An array of button config objects:
         *      text: String. Displayed on the button.
         *      value: Any. Supplied to handlers as an argument.
         *      dismiss: Boolean, optional. Determines button click behavior.
         *               If false, onClosed is called when this button is clicked.
         *               If true, onDismissed is called when this button is clicked.
         *               Defaults to false.
         * onClosed: function(any). A handler called when the modal is closed. Takes a button value as an argument.
         * onDismissed: function(any). A handler called when the modal is dismissed. Takes a button value as an argument.
         *
         * returns: The modal that was generated as a bento $uibModalInstance.
         */
        this.modal = function(config){

            if(!config){
                config = {};
            }

            var modal = $uibModal.open({
                templateUrl: 'components/modal/modal-base.2js.html',
                controller: ['$scope', function($scope){

                    $scope.templateUrl = (!config.templateurl ? 'components/modal/modal-default.2js.html' : config.templateUrl);
                    $scope.vars = (!angular.isObject(config.vars) ? {title: 'Default Modal Title', body: 'This is the default modal body. Your config is missing the vals object.'} : config.vars);
                    $scope.buttons = (!angular.isObject(config.buttons) ? [{text: 'Default Button', value: 'default'}] : config.buttons);
                    $scope.showClose = (!config.showClose ? true : config.showClose);

                }]
            });

            modal.result.then(
                function(result){
                    if(!!config.onClosed){
                        config.onClosed(result);
                    }
                }, function(reason){
                    if(!!config.onDismissed){
                        config.onDismissed(reason);
                    }
                }
            );

            return modal;

        };
    }]);

}(window.angular));

// Adapted from christopherthielen's qdecorator
// https://github.com/angular-ui/ui-router/issues/2889

// Prints out unhandled promise rejection stack traces to the console.
// Only works when you are not using minification (because it parses the stack traces).
// Also only tested with Chrome.

// Decorate the $q service when app starts
angular.module('bmUnhandledPromiseRejectionTracer', ['bmEnvironment'])
.decorator('$q', ['$delegate', 'bmEnvironmentConst', function($delegate, bmEnvironmentConst) {
  'use strict';

  // Pass thru if we are not in local dev mode
  if (!bmEnvironmentConst.isLocalType) { return $delegate; }

  // Create a sample promise.
  var promise = $delegate.when();

  // Access the `Promise` prototype (nonstandard, but works)
  var promisePrototoype = Object.getPrototypeOf(promise);
  var isPromisePrototype = typeof promisePrototoype === 'object' &&
    ['then', 'catch', 'finally'].reduce(function(acc, key) {
      return acc && !!promisePrototoype[key];
    }, true);

  if (isPromisePrototype) {
    // The angular $q promise implementation sets `$$state` once in its Promise constructor:
    //
    // function Promise() {
    //   this.$$state = { status: 0 };
    // }
    //
    // Hijack the promise behavior by adding a setter for `$$state` on the Promise prototype.
    // The setter is run each time a promise is created (via any method: $q.when(), promise.then(), etc).
    //
    // The setter records the stack trace in which the promise was created.
    Object.defineProperty(promisePrototoype, '$$state', {
      set: function($$state) {
        this._$$state = $$state;

        if (typeof $$state._status === 'undefined') {
          this._value = this.value;
          this._logged = false;

          // Define a getter for `Promise.$$state.value`
          // ('value' is the resolved or rejected value)
          Object.defineProperty($$state, 'value', {
            enumerable: true,
            set: function(val) {
              this._value = val;
            },
            get: function() {
              // Check if this is the "Possibly unhandled rejection" handler. return the stack trace instead
              if (this.status === 2 && this.pur && new Error().stack.includes('processChecks')) {
                if (!this._logged) {
                  this._logged = true;
                  console.error(this._value);
                }
                return this._context;
              }
              return this._value;
            },
          });
        }

        // Create an Error object and use its stack trace
        $$state._context = new Error('Possibly unhandled rejection (promise creation stack)');
      },
      get: function() {
        return this._$$state;
      },
      enumerable: true,
    });

    // Whenever promise.then() (or .catch or .finally) is called, a new promise is created.
    // Add the chained-from-promise's stack to the new promise's stack to allow analysis of the full promise chain
    var realThenFn = promisePrototoype.then;
    promisePrototoype.then = function() {
      var chainedPromise = realThenFn.apply(this, arguments);

      var prevContext = this.$$state && this.$$state._context;
      var chainedContext = chainedPromise.$$state && chainedPromise.$$state._context;

      if (chainedContext) {
        try {
          chainedContext.stack =  chainedContext.stack +
            '\nPromise Chained from:\n' +
            prevContext.stack;
        } catch (ignored) {}
      }
      return chainedPromise;
    };
  }

  return $delegate;
}]);

/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	(function (angular) {

	  'use strict';

	  var module = angular.module('bmContactNameParser', []);

	  module.factory('bmContactNameParser', contactNameParser);
	  contactNameParser.$inject = [];

	  function contactNameParser() {
	    // replaces with generated code
	    var parser = __webpack_require__(1);
	    return parser;
	  }
	})(window.angular);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	function log(text) {}
	//console.log(text);


	//This function is used to allow for IE11 compatibility. Its functionality is the same as endsWith
	function endsWith(str, suffix) {
		return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}

	//This function is used to allow for IE11 compatibility. Its functionality is the same as startsWith
	function startsWith(str, prefix) {
		return str.substr(0, prefix.length) === prefix;
	}

	function allLanguageMapValues(map) {
		var result = [],
		    lang = void 0,
		    addBoth = function addBoth(value) {
			var noPeriods = value.replace(/\./g, "");

			if (result.indexOf(value) < 0) {
				result.push(value);
			}

			if (value !== noPeriods && result.indexOf(noPeriods) < 0) {
				result.push(noPeriods);
			}
		};

		for (lang in map) {
			map[lang].forEach(addBoth);
		}

		return result.sort();
	}

	var nameConcatenators = ["and", "&", "+", "or", "'n", "/", "of", "the"],
	    lastNameModifiers = ["della", "du", "pietro", "st.", "ter", "vanden", "vere", "bar", "ben", "da", "dal", "de la", "de", "del", "den", "der", "di", "ibn", "la", "le", "san", "st", "ste", "van", "van der", "van den", "vel", "von", "von der", "mac", "mc", "les"],
	    firstNameModifiers = ["el"],
	    prefixes = {
		"base": ["Mss.", "Mses", "Mx.", "Prof.", "The", "Master", "Fr.", "Dent", "B.C.", "P.A.", "Dent.", "Hon.", "Sir"],
		"fr-CA": ["Dr", "M.", "Madame", "Mademoiselle", "Mlle", "Mme", "Monsieur"],
		"en-US": ["Dr.", "Mr.", "Mrs.", "Ms."],
		"en-CA": ["Dr.", "Mr.", "Mrs.", "Ms."],
		"en-GB": ["Dr", "Miss", "Mr", "Mrs", "Ms", "Prof", "Reverend"],
		"en-AU": ["Dr", "Miss", "Mr", "Mrs", "Ms", "Prof", "Reverend"],
		"es-AR": ["Señor", "Señora", "Señorita"],
		"pt-BR": ["Senhor", "Senhora", "Senhorita"],
		"xx-XX": ["[Ďɾ.!!!!!]", "[ʍɾ.!!!!!]", "[ʍɾš.!!!!!]", "[ʍš.!!!!!]"]
	},
	    suffixes = {
		"base": ["Ph.D"],
		"fr-CA": ["Esq", "Esquire", "I", "II", "III", "IV", "V", "VI", "Jr", "Sr"],
		"en-US": ["C.P.A.", "D.D.S.", "Esq.", "Esquire", "I", "II", "III", "IV", "V", "VI", "Jr.", "M.D.", "Ph.D.", "Sr."],
		"en-CA": ["C.P.A.", "D.D.S.", "Esq.", "Esquire", "I", "II", "III", "IV", "V", "VI", "Jr.", "M.D.", "Ph.D.", "Sr."],
		"en-GB": ["Esq", "Esquire", "I", "II", "III", "IV", "V", "VI", "Jr", "Sr"],
		"en-AU": ["Esq", "Esquire", "I", "II", "III", "IV", "V", "VI", "Jr", "Sr"],
		"es-AR": ["I", "II", "III", "IV", "V", "VI"],
		"pt-BR": ["I", "II", "III", "IV", "V", "VI", "Jr", "Sr"],
		"xx-XX": ["[Ĉ.Ƥ.Ă.!!!!!]", "[Ď.Ď.Ѕ.!!!!!]", "[Ʃšƣ.!!!!!]", "[Ʃšƣʊɨɾȅ!!!!!]", "[ĵɾ.!!!!!]", "[ʍ.Ď.!!!!!]", "[Ƥɧ.Ď.!!!!!]", "[Ѕɾ.!!!!!]"]
	},
	    knownPrefixes = allLanguageMapValues(prefixes),
	    knownSuffixes = allLanguageMapValues(suffixes),
	    char = Char();

	function equalsCaseInsensitive(a, b) {
		// TODO: Fix this. See http://stackoverflow.com/questions/177719/javascript-case-insensitive-search
		return a && b && a.toUpperCase() === b.toUpperCase();
	}

	function containsCaseInsensitive(array, value) {
		var result = false;
		array.forEach(function (text) {
			if (equalsCaseInsensitive(text, value)) {
				result = true;
			}
		});

		return result;
	}

	function isConcatenator(word) {
		return containsCaseInsensitive(nameConcatenators, word);
	}

	function isKnownPrefix(firstWord) {
		return containsCaseInsensitive(knownPrefixes, firstWord);
	}

	function isKnownSuffix(lastWord) {
		return containsCaseInsensitive(knownSuffixes, lastWord);
	}

	/* 
	C# Conversion:
		using System;
				
	public class Program
	{
		public static void Main()
		{
			String result = "";
			for(Int32 i = 0; i < 0xffff; i += 1)
			{
				Char c = (Char)i;
				if(Char.IsSeparator(c))
				{
					result += "0x"+i.ToString("X4") + ", ";
					Console.Write(c);
				}
			}
			Console.WriteLine(result);
		}
	}
	*/

	function Char() {
		return {
			IsSeparator: function IsSeparator(char) {
				var codes = [0x0020, 0x00A0, 0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x2028, 0x2029, 0x202F, 0x205F, 0x300],
				    code = char.charCodeAt(0);
				return codes.indexOf(code) >= 0;
			},
			IsWhiteSpace: function IsWhiteSpace(char) {
				var codes = [0x0009, 0x000A, 0x000B, 0x000C, 0x000D, 0x0020, 0x0085, 0x00A0, 0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x2028, 0x2029, 0x202F, 0x205F, 0x3000],
				    code = char.charCodeAt(0);
				return codes.indexOf(code) >= 0;
			}
		};
	}

	// Returns [lastWord, rest]
	function lastWord(fullName) {
		var rest = fullName.trim(),
		    last = rest.length - 1,
		    i = void 0,
		    c = void 0;

		for (i = last; i > 0; i -= 1) {
			c = rest[i];
			if (char.IsSeparator(c) && i === last) {
				last -= 1;
			} else if (char.IsWhiteSpace(c) || char.IsSeparator(c) || c === ',') {
				return [rest.substr(i + 1, last - i), rest.substr(0, i)];
			}
		}

		return [rest, ""];
	}

	// Returns [firstWord, rest]
	function firstWord(fullName) {
		var rest = fullName.trim(),
		    start = 0,
		    i = void 0,
		    c = void 0,
		    isSeparator = void 0;

		for (i = start; i < rest.length; i += 1) {
			c = rest[i];
			isSeparator = char.IsSeparator(c);
			if (isSeparator === true && i === start) {
				start += 1;
			} else if (char.IsWhiteSpace(c) === true || isSeparator === true || c === ',') {
				return [rest.substr(start, i - start), rest.substr(i).trim()];
			}
		}

		// No separators encountered, it is all the first word.
		return [rest, ""];
	}

	// returns [parens, rest]
	function getLastParenthesizedPart(fullName) {
		var nesting = 0,
		    i = void 0,
		    c = void 0;

		if (endsWith(fullName, ")")) {
			for (i = fullName.length - 1; i >= 0; i -= 1) {
				c = fullName[i];
				if (c === ")") {
					nesting += 1;
				} else if (c === "(") {
					nesting -= 1;
					if (nesting === 0) {
						return [fullName.substr(i), fullName.substr(0, i).trim()];
					}
				}
			}
		}

		return ["", fullName];
	}

	// returns [firstName, rest]
	function getFirstName(input) {
		var _firstWord = firstWord(input),
		    _firstWord2 = _slicedToArray(_firstWord, 2),
		    firstName = _firstWord2[0],
		    fullName = _firstWord2[1];

		if (containsCaseInsensitive(firstNameModifiers, firstName)) {
			var _firstWord3 = firstWord(fullName),
			    _firstWord4 = _slicedToArray(_firstWord3, 2),
			    next = _firstWord4[0],
			    withoutNext = _firstWord4[1];

			if (next.length > 0) {
				firstName = joinStrings([firstName, next]);
				fullName = withoutNext;
			}
		}

		var _firstWord5 = firstWord(fullName),
		    _firstWord6 = _slicedToArray(_firstWord5, 2),
		    concatenator = _firstWord6[0],
		    rest = _firstWord6[1];

		if (isConcatenator(concatenator)) {
			var p = void 0;

			var _getFirstName = getFirstName(rest);

			var _getFirstName2 = _slicedToArray(_getFirstName, 2);

			p = _getFirstName2[0];
			rest = _getFirstName2[1];

			if (p.length > 0) {
				fullName = rest;
				firstName = joinStrings([firstName, concatenator, p]);
			}
		}

		return [firstName, fullName];
	}

	// returns [lastName, rest]
	function getLastName(input) {
		var _lastWord = lastWord(input),
		    _lastWord2 = _slicedToArray(_lastWord, 2),
		    lastName = _lastWord2[0],
		    fullName = _lastWord2[1];

		var _lastWord3 = lastWord(fullName),
		    _lastWord4 = _slicedToArray(_lastWord3, 2),
		    prior = _lastWord4[0],
		    withoutPrior = _lastWord4[1];

		var _lastWord5 = lastWord(withoutPrior),
		    _lastWord6 = _slicedToArray(_lastWord5, 2),
		    secondPrior = _lastWord6[0],
		    withoutTwoPrior = _lastWord6[1];

		var twoPrior = joinStrings([secondPrior, prior]);

		if (containsCaseInsensitive(lastNameModifiers, twoPrior)) {
			lastName = joinStrings([twoPrior, lastName]);
			fullName = withoutTwoPrior;
		} else if (containsCaseInsensitive(lastNameModifiers, prior)) {
			lastName = joinStrings([prior, lastName]);
			fullName = withoutPrior;
		}

		var _lastWord7 = lastWord(fullName),
		    _lastWord8 = _slicedToArray(_lastWord7, 2),
		    concatenator = _lastWord8[0],
		    rest = _lastWord8[1];

		if (isConcatenator(concatenator)) {
			var p = void 0;

			var _getLastName = getLastName(rest);

			var _getLastName2 = _slicedToArray(_getLastName, 2);

			p = _getLastName2[0];
			rest = _getLastName2[1];

			if (p.length > 0) {
				fullName = rest;
				lastName = joinStrings([p, concatenator, lastName]);
			}
		}

		return [lastName, fullName];
	}

	function getSuffix(fullName) {
		var _lastWord9 = lastWord(fullName),
		    _lastWord10 = _slicedToArray(_lastWord9, 2),
		    suffix = _lastWord10[0],
		    rest = _lastWord10[1];

		if (isKnownSuffix(suffix) || startsWith(suffix, "(") && endsWith(suffix, ")")) {
			return [suffix, rest];
		}
		return ["", fullName];
	}

	// returns [prefix, rest]
	function getPrefix(fullName) {
		var _firstWord7 = firstWord(fullName),
		    _firstWord8 = _slicedToArray(_firstWord7, 2),
		    prefix = _firstWord8[0],
		    rest = _firstWord8[1];

		if (isKnownPrefix(prefix)) {
			fullName = rest;

			var _firstWord9 = firstWord(rest),
			    _firstWord10 = _slicedToArray(_firstWord9, 2),
			    concatenator = _firstWord10[0],
			    withoutNext = _firstWord10[1];

			if (isConcatenator(concatenator)) {
				var _firstWord11 = firstWord(withoutNext),
				    _firstWord12 = _slicedToArray(_firstWord11, 2),
				    nextPrefix = _firstWord12[0],
				    withoutNextPrefix = _firstWord12[1];

				if (nextPrefix.length > 0) {
					fullName = withoutNextPrefix;
					return [joinStrings([prefix, concatenator, nextPrefix]), fullName];
				}
			}
			return [prefix, fullName];
		}

		return ["", fullName];
	}

	function joinStrings(parts) {
		var result = "";
		parts.forEach(function (part) {
			if (typeof part === "string" && part.length > 0) {
				if (result.length === 0) result += part;else result += " " + part;
			}
		});

		return result;
	}

	function parseWithoutState(fullName) {
		fullName = fullName.trim();

		var suffix = void 0;

		// Separate periods
		//            fullName = fullName.Replace(".", ". ").Replace(")", ") ").Trim(); 
		// This code was modified to support added suffixes and prefixes such as D.D.S, C.P.A., Ph.D, B.C., P.A.
		// The Replace(".", ". ") is added after getLastParenthesizedPartsuffix and prefix has been found (line 101-102) and prior to parsing rest of name
		var _getLastParenthesized = getLastParenthesizedPart(fullName);

		var _getLastParenthesized2 = _slicedToArray(_getLastParenthesized, 2);

		suffix = _getLastParenthesized2[0];
		fullName = _getLastParenthesized2[1];
		fullName = fullName.replace(")", ") ").trim();

		// remove multiple spaces
		fullName = fullName.replace("\x07", " ").replace("  ", " \x07").replace("\x07 ", "").replace("\x07", "");

		var first = "";
		var last = "";

		var prefix = void 0;
		var secondSuffix = void 0;

		var _getPrefix = getPrefix(fullName);

		var _getPrefix2 = _slicedToArray(_getPrefix, 2);

		prefix = _getPrefix2[0];
		fullName = _getPrefix2[1];

		var _getSuffix = getSuffix(fullName);

		var _getSuffix2 = _slicedToArray(_getSuffix, 2);

		secondSuffix = _getSuffix2[0];
		fullName = _getSuffix2[1];


		suffix = joinStrings([secondSuffix, suffix]);

		// If there was a comma in front of the suffix, remove the comma.
		if (suffix.length > 0 && endsWith(fullName, ",")) {
			fullName = fullName.substr(0, fullName.length - 1).trim();
		}

		var firstComma = fullName.indexOf(",");
		if (firstComma >= 0) {
			last = fullName.substr(0, firstComma).trim();
			fullName = fullName.substr(firstComma + 1).trim();

			// sometimes the name starts with a suffix, then a comma : "Jr, Bob Smith"  In this case what we thought was going to be the last name is only a suffix
			// It could also be "Smith Jr., Bob
			var thirdSuffix = void 0;

			var _getSuffix3 = getSuffix(last);

			var _getSuffix4 = _slicedToArray(_getSuffix3, 2);

			thirdSuffix = _getSuffix4[0];
			last = _getSuffix4[1];

			suffix = joinStrings([thirdSuffix, suffix]);

			// There is now a new start to the fullName, so look for prefix at the start.
			var nextPrefix = void 0;

			var _getPrefix3 = getPrefix(fullName);

			var _getPrefix4 = _slicedToArray(_getPrefix3, 2);

			nextPrefix = _getPrefix4[0];
			fullName = _getPrefix4[1];

			prefix = joinStrings([prefix, nextPrefix]);
		}

		// This code was modified/added to support added suffixes and prefixes such as D.D.S, C.P.A., Ph.D, B.C., P.A.
		// Needs to add the space, but remove if there ends up already being a space after the "."
		fullName = fullName.replace(".", ". ").trim();
		fullName = fullName.replace("\x07", " ").replace("  ", " \x07").replace("\x07 ", "").replace("\x07", "");

		if (prefix.length === 0) {
			var _getFirstName3 = getFirstName(fullName);

			var _getFirstName4 = _slicedToArray(_getFirstName3, 2);

			first = _getFirstName4[0];
			fullName = _getFirstName4[1];
		}

		if (last.length === 0) {
			var _getLastName3 = getLastName(fullName);

			var _getLastName4 = _slicedToArray(_getLastName3, 2);

			last = _getLastName4[0];
			fullName = _getLastName4[1];
		}

		if (prefix.length !== 0) {
			var _getFirstName5 = getFirstName(fullName);

			var _getFirstName6 = _slicedToArray(_getFirstName5, 2);

			first = _getFirstName6[0];
			fullName = _getFirstName6[1];
		}

		var middle = fullName.trim();

		if (suffix.length > 0 && prefix.length === 0 && middle.length === 0 && first.length > 0 && last.length === 0) {
			last = first;
			first = "";
		}

		return [prefix, first, middle, last, suffix];
	}

	function firstOrDefault(list) {
		if (list.length > 0) return list[0];
		return null;
	}

	function isNullOrEmpty(text) {
		return text === null || text === "";
	}

	function arrangeNames(oldFirstNameList, oldMiddleNameList, newFirstNameList, newMiddleNameList) {
		var found = false;
		oldFirstNameList.forEach(function (name) {
			if (name === firstOrDefault(newFirstNameList)) {
				found = true;
			} else {
				for (var position = 0; position < newMiddleNameList.length; position += 1) {
					if (name === newMiddleNameList[position]) {
						var numOfItems = position + 1;
						while (numOfItems > 0) {
							newFirstNameList.push(newMiddleNameList.shift());
							numOfItems -= 1;
							found = true;
						}
					}
				}
			}
		});

		if (found || isNullOrEmpty(firstOrDefault(newMiddleNameList))) return;

		oldMiddleNameList.forEach(function (name) {
			for (var position = 0; position < newMiddleNameList.length; position += 1) {
				var numOfParts = position - oldMiddleNameList.indexOf(name);
				if (name !== newMiddleNameList[position] || numOfParts <= 0) {} else {
					while (numOfParts > 0) {
						newFirstNameList.push(newMiddleNameList.shift());
						numOfParts -= 1;
					}
				}
			}
		});
	}

	// contact == [prefix, firstName, middleName, lastName, suffix]
	function parseWithState(fullName, contact) {
		if (fullName === joinStrings(contact)) return contact;

		var _parseWithoutState = parseWithoutState(fullName),
		    _parseWithoutState2 = _slicedToArray(_parseWithoutState, 5),
		    prefix = _parseWithoutState2[0],
		    newFirstName = _parseWithoutState2[1],
		    newMiddleName = _parseWithoutState2[2],
		    newLastName = _parseWithoutState2[3],
		    suffix = _parseWithoutState2[4];

		// If any changes to the prefix or suffix, then Parse() will take care of those

		// Each of the name properties will need to be put in its own list


		var oldFirstNameParts = contact[1].split(' ');
		var newFirstNameParts = newFirstName.split(' ');
		var oldMiddleNameParts = contact[2].split(' ');
		var newMiddleNameParts = newMiddleName.split(' ');
		var oldLastNameParts = contact[3].split(' ');
		var newLastNameParts = newLastName.split(' ');

		// Arrange First Name
		arrangeNames(oldFirstNameParts, oldMiddleNameParts, newFirstNameParts, newMiddleNameParts);
		// Arrange Middle Name
		arrangeNames(oldMiddleNameParts, oldLastNameParts, newMiddleNameParts, newLastNameParts);

		// need to reverse the last name and middle name to be able to use the arrange method
		oldLastNameParts.reverse();
		newMiddleNameParts.reverse();

		// Arrange Last Name
		arrangeNames(oldLastNameParts, oldMiddleNameParts, newLastNameParts, newMiddleNameParts);

		// Un-reverse the previously reversed lists
		newMiddleNameParts.reverse();
		newLastNameParts.reverse();

		// join the new parts for the first and middle name
		var first = newFirstNameParts.join(" ").trim();
		var middle = newMiddleNameParts.join(" ").trim();
		var last = newLastNameParts.join(" ").trim();

		return [prefix, first, middle, last, suffix];
	}

	// contact == [prefix, first, middle, last, suffix];
	function format(fullName, contact) {
		var builder = "";

		// All we are looking for here is name format order. Is it last name first, or first name first?
		// case: fullname = 'Van  Winkel, First Middle' (has 2 spaces, but Parse will remove the extra space)
		// compare: 'Van  Winkel,' != 'Van Winkel,'
		// regardless of Van Winkel or Van    Winkel, it is still last name first format, so remove all spaces and compare:
		// 'VanWinkel,' == 'VanWinkel,' should get rid of any possible white space problems
		var parsedFullName = parseWithoutState(fullName);
		fullName = fullName.replace(/\s/g, "");
		var lastName = parsedFullName[3].replace(/\s/g, "");

		// String.IsNullOrEmpty is from a test case of previous unit tests ", First Middle"
		// If No Last Name but a comma starts name, then it is First Middle not , First Middle (unless I read it wrong [totally possible])

		//Just append each of the 5 parts in proper format, then remove extra whitespace. Gets rid of costly If's
		if (!isNullOrEmpty(lastName) && startsWith(fullName, lastName + ",")) {
			builder += joinStrings([contact[3] + ",", contact[0], contact[1], contact[2], contact[4]]);
		} else {
			builder += joinStrings([contact[0], contact[1], contact[2], contact[3], contact[4]]);
		}
		lastName = builder.replace(/\s+/g, " ");
		return lastName.trim();
	}

	function coalesce(first, second) {
		if (first === undefined || first === null) return second;
		return first;
	}

	// Returns [prefix, givenName, additionalName, familyName, suffix]
	function contactToTuple(nameInfo) {
		return [coalesce(nameInfo.prefix, ""), coalesce(nameInfo.givenName, ""), coalesce(nameInfo.additionalName, ""), coalesce(nameInfo.familyName, ""), coalesce(nameInfo.suffix, "")];
	}

	/**
	 *
	 * @param {String[]} tuple - [prefix, givenName, additionalName, familyName, suffix]
	 */
	function tupleToContact(tuple) {
		var result = {};
		result.prefix = coalesce(tuple[0], "");
		result.givenName = coalesce(tuple[1], "");
		result.additionalName = coalesce(tuple[2], "");
		result.familyName = coalesce(tuple[3], "");
		result.suffix = coalesce(tuple[4], "");
		return result;
	}

	/**
	 * Builds a full name from the parts of the name.
	 * 
	 * @param {Object} nameInfo - An object that has both the name parts and optionally the prior fullName.
	 * @param {string} nameInfo.prefix
	 * @param {string} nameInfo.givenName
	 * @param {string} nameInfo.additionalName
	 * @param {string} nameInfo.familyName
	 * @param {string} nameInfo.suffix
	 * @param {string=} nameInfo.fullName - [optional] The last value of the formatted name. If present this is used to attempt to format the new full name similar to the prior full name.
	 */
	function formatName(nameInfo) {
		var tuple = contactToTuple(nameInfo);
		var result = tupleToContact(tuple);
		result.fullName = format(coalesce(nameInfo.fullName, ""), tuple);
		return result;
	}

	/**
	 * Parses a full name into the parts of the name.
	 * 
	 * @param {Object} nameInfo - An object that has both the fullName and optionally the prior name parts.
	 * @param {string} nameInfo.fullName - The last value of the formatted name. If present this is used to attempt to format the new full name similar to the prior full name.
	 * @param {string=} nameInfo.prefix
	 * @param {string=} nameInfo.givenName
	 * @param {string=} nameInfo.additionalName
	 * @param {string=} nameInfo.familyName
	 * @param {string=} nameInfo.suffix
	 */
	function parseName(nameInfo) {
		var tuple = contactToTuple(nameInfo);
		var fullName = coalesce(nameInfo.fullName, "");
		var parsed;
		if (tuple[0] === "" && tuple[1] === "" && tuple[2] === "" && tuple[3] === "" && tuple[4] === "") parsed = parseWithoutState(fullName, tuple);else parsed = parseWithState(fullName, tuple);
		var result = tupleToContact(parsed);
		result.fullName = fullName;
		return result;
	}

	module.exports = {
		parseWithoutState: parseWithoutState,
		parseWithState: parseWithState,
		format: format,
		formatName: formatName,
		parseName: parseName,
		getLastParenthesizedPart: getLastParenthesizedPart,
		char: char,
		firstWord: firstWord,
		lastWord: lastWord,
		isKnownSuffix: isKnownSuffix,
		knownPrefixes: knownPrefixes,
		knownSuffixes: knownSuffixes
	};

/***/ })
/******/ ]);
(function (angular, FastClick) {
    'use strict';

    angular.module('bluemoon.login', [
            'ui.bootstrap',
            'bento.modern',
            'ui.router',
            'pascalprecht.translate',
            'ipCookie',
            'bluemoon.login.templates',
            'bluemoon.components',
            'ngSanitize',
            'fef',
            'bluemoon.forgottenPassword',
            'onvio-userRegistration',
            'samba-Registration',
            'bluemoon.registrationConfirmation',
            'bmProfilePhoto',
            'ngMessages',
            'cs.user.admin',
            'bmExpiredTrial',
            'bmPasswordValidator'
        ])

        .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {
            // change AngularJS 1.6 default hash prefix from '!' to ''
            $locationProvider.hashPrefix('');

            // Always redirect to a default page if route is not valid
            $urlRouterProvider.otherwise('/');

            $stateProvider
                // Main view
                .state('main', {
                    url: '/',
                    templateUrl: 'main/main.2js.html',
                    controller: 'MainCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        processSso: ['$q', 'AuthenticatedSession', 'ssoTokenKey', processSso],
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                .state('logout', {
                    url: '/logout',
                    templateUrl: 'main/main.2js.html',
                    controller: 'MainCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        processSso: ['$q', 'AuthenticatedSession', 'ssoTokenKey', processSso],
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                /**
                 *
                 * Auth0 PoC. Deprecated for now since changes are in TR Auth and user-login directive
                 *
                */
                // .state('auth0', {
                //     url: '/auth0',
                //     templateUrl: 'main/main.2js.html',
                //     controller: 'MainCtrl',
                //     controllerAs: 'vm',
                //     resolve: {
                //         getAuth0Session: ['$http', '$state', 'bmAccess', getAuth0Session]
                //     }
                // })

                // Registration view
                .state('registration', {
                    url: '/registration',
                    templateUrl: 'registration/user-registration.2js.html',
                    controller: 'UserRegistrationCtrl as vm',
                    resolve: {
                        resolvedUser: ['userRegistrationService', function(userRegistrationService){
                            return getResolvedUser(userRegistrationService);
                        }],
                        securityQuestionList: ['userRegistrationService', function(userRegistrationService){
                            return getSecurityQuestions(userRegistrationService);
                        }]
                    }
                })

                // Registration with pin view
                .state('registration-pin', {
                    url: '/registration-pin',
                    templateUrl: 'registration/user-registration.2js.html',
                    controller: 'UserRegistrationCtrl as vm',
                    resolve: {
                        resolvedUser: ['userRegistrationService', function(userRegistrationService){
                            return getResolvedUser(userRegistrationService);
                        }],
                        securityQuestionList: ['userRegistrationService', function(userRegistrationService){
                            return getSecurityQuestions(userRegistrationService);
                        }]
                    }
                })

                // Registration confirmation
                .state('registration-confirmation', {
                    url: '/registration-confirmation',
                    templateUrl: 'registration/confirmation/registration-confirmation.2js.html',
                    controller: 'RegistrationConfirmationCtrl'
                })

                // Registration complete
                .state('registration-complete', {
                    url: '/registration-complete',
                    templateUrl: 'registration/complete/registration-complete.2js.html',
                    controller: 'RegistrationCompleteCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        resolvedUser: ['userRegistrationService', function(userRegistrationService){
                            return getResolvedUser(userRegistrationService);
                        }],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })
                .state('link-registration', {
                    url: '/link-registration',
                    templateUrl: 'registration/link-registration/link-registration.2js.html',
                    controller: 'LinkRegistrationCtrl as vm',
                    resolve: {
                        resolvedUser: ['userRegistrationService', function(userRegistrationService){
                            return getResolvedUser(userRegistrationService);
                        }],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })
                .state('self-registration', {
                    url: '/self-registration',
                    templateUrl: 'registration/self-registration/self-registration.2js.html',
                    controller: 'SelfRegistrationCtrl as vm',
                    resolve: {
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                .state('user-self-registration', {
                    url: '/user-self-registration',
                    templateUrl: 'registration/self-registration/self-registration.2js.html',
                    controller: 'SelfRegistrationCtrl as vm',
                    resolve: {
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                .state('forgot-password', {
                    url: '/forgot-password',
                    templateUrl: 'forgot-password/provide-email.2js.html',
                    controller: 'ProvideEmailCtrl as vm',
                    resolve: {
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                .state('change-password', {
                    url: '/reset-signin',
                    templateUrl: 'forgot-password/change-password.2js.html',
                    controller: 'ChangePasswordCtrl as vm',
                    resolve: {
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                })

                // CS desktop Auth0 screen
                .state('desktop', {
                    url: '/browser-auth',
                    templateUrl: 'csdesktop/desktop.2js.html',
                    controller: 'DesktopCtrl',
                    controllerAs: 'vm'
                })

                // CS desktop Auth0 screen
                .state('desktop-logout', {
                    url: '/{path:csdesktop|dtdesktop|digitadesktop}/logout',
                    templateUrl: 'csdesktop/logout/cs-desktop-logout.2js.html',
                    controller: 'DesktopLogoutCtrl',
                    controllerAs: 'vm'
                })

                // Registration for SaMBa Payslips
                  .state('registration-smb', {
                      url: '/registration-smb',
                      templateUrl: 'registration-smb/registration.2js.html',
                      controller: 'RegistrationCtrl as vm'
                })

                // Expired Trial - extend or buy now
                  .state('expired-trial', {
                    url: '/expired-trial',
                    templateUrl: './components/expired-trial/expired-trial.2js.html',
                    controller: 'ExpiredTrialCtrl as vm',
                    params: {
                        renew: null
                    },
                    resolve: {
                        themeHeader: ['$q', '$location', 'bmTheme', getTheme],
                        product: ['bmPrimaryProductFactory', getProduct]
                    }
                  })

                    .state('unsupported-browser-smb', {
                        url: '/unsupported-browser-smb',
                        templateUrl: 'unsupported-browser-smb/unsupported-browser-smb.html',
                        controller: 'UnsupportedBrowserSmbController as vm'
                    });
                ///////////

                function getResolvedUser(userRegistrationService){
                    return userRegistrationService.load().then(function(user){
                        return user;
                    }, function(){
                        return undefined;
                    });
                }

                function getSecurityQuestions(userRegistrationService){
                    return userRegistrationService.loadTabSecurityQuestions().then(function(response){
                        return response.data;
                    }, function(){
                        return undefined;
                    });
                }
        }])

        .config(['$translateProvider', '$translatePartialLoaderProvider', 'HttpAuthInterceptorProvider', function($translateProvider, $translatePartialLoaderProvider, httpAuthInterceptorProvider){
            // disable 401 redirection for login app, bc it's only needed post authentication
            httpAuthInterceptorProvider.redirect(false);

            // protect against possible XSS - http://angular-translate.github.io/docs/#/guide/19_security
            $translateProvider.useSanitizeValueStrategy('escapeParameters');
            $translateProvider.useLoader('$translatePartialLoader', {
                urlTemplate: '{part}/{lang}.json'
            });
            $translatePartialLoaderProvider.addPart('i18n');
        }])

        .run([
            '$document',
            '$rootScope',
            '$bentoTranslate',
            'languageStorageManager',
            function(
                $document,
                $rootScope,
                $bentoTranslate,
                languageStorageManager) {

            FastClick.attach($document[0].body);

            // grab copy of bentoEnglish before it disappears forever
            var bentoEnglish = angular.copy($bentoTranslate.getTranslation());
            // get bluemoon startup lang
            var currentLanguage = languageStorageManager.get();
            var loadBentoTranslations = function(lang, init) {
                // Don't try to load lang files for en-* since they are hardcoded in JS,
                // otherwise errors you can't suppress will show. Also, no xx-XX pseudo.
                if (!lang || /^(en|xx)-/.test(lang)) {
                    if (!init) {
                        $bentoTranslate.setTranslation(bentoEnglish);
                    }
                } else {
                    $bentoTranslate.load('node_modules/nucleus-i18n/dist/bento/' + lang + '.json');
                }
            };

            // sync bento to bluemoon startup lang
            loadBentoTranslations(currentLanguage, true);

            $rootScope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
                if(changeArgs.language !== currentLanguage){
                    currentLanguage = changeArgs.language;
                    loadBentoTranslations(changeArgs.language);
                }
            });
        }]);

        // todo: run this when deployed to prod for perf boost
        // see https://docs.angularjs.org/guide/production
        // .config(['$compileProvider', function ($compileProvider) {
        //     $compileProvider.debugInfoEnabled(false);
        // }]);

    var themePromise;

    function getTheme($q, $location, theme) {
        // already loaded theme?
        if(!themePromise){
            themePromise = $q.defer();
        }

        // If firmId is provided on post-hash query params, use it to load theme.
        // External login forms utilize this technique to get proper branding
        // of login page on failed login redirects.
        var firmId = $location.search().firmId;

        // as of HUGE, we are no longer applying themes to the login page
        theme.applyTheme = angular.noop;
        theme.useTheme = true;

        if (angular.isDefined(firmId)) {
            theme.load({ firm: firmId }).then(function(theTheme){
                themePromise.resolve(verifyTheme(theTheme.data));
            },function(){
                themePromise.resolve(verifyTheme());
            });
        } else {
            theme.load().then(function(theTheme){
                themePromise.resolve(verifyTheme(theTheme.data));
            }, function(){
                themePromise.resolve(verifyTheme());
            });
        }

        return themePromise.promise;
    }

    function verifyTheme(themeData){
        themeData = themeData || {};

        if(!themeData.loginBackground || themeData.loginBackground === ''){
            themeData.loginBackground = 'grass';
        }

        return themeData;
    }

    function processSso($q, session, ssoTokenKey) {
        var continueToManualAuth = $q.defer();
        var dest = session.getRequestedDestination();
        if (!dest) {
            continueToManualAuth.resolve();
        } else {
            var tokenPtn = new RegExp('(?:\\?|&)' + ssoTokenKey + '=([^&]+)'),
                matches = tokenPtn.exec(dest),
                token = matches && matches[1];
            if (!token) {
                continueToManualAuth.resolve();
            } else {
                // if success, don't continue to manual authentication. redirect to app will occur
                // if fail, continue
                session.createViaSsoToken(token).then(angular.noop, continueToManualAuth.resolve);
            }
        }
        return continueToManualAuth.promise;
    }

    /**
     *
     * Auth0 PoC. Deprecated for now since changes are in TR Auth and user-login directive
     *
     */
    // function getAuth0Session($http, $state, bmAccess) {
    //     return bmAccess.has('Platform_DisableAuth0Phase2').then(function(){
    //         $state.go('main');
    //     }).catch(function() {
    //         return $http.post('api/security/v1/oidc/login', {type: 'onvio', sp: 'onvio', redirectUri: 'https://localhost:9001/#/auth0'}).then(function (resp) {
    //             if(resp.headers().location) {
    //                 window.location.href = resp.headers().location;
    //             } else {
    //                 $state.go('^');
    //             }
    //         }).catch(function() {
    //             $state.go('^');
    //         });
    //     });
    // }

    function getProduct(bmPrimaryProductFactory){
        // make sure primary product is loaded early
        return bmPrimaryProductFactory.getPrimaryProduct();
    }

}(window.angular, window.FastClick));

angular.module('bluemoon.login.templates', ['components/account-link-auth/account-link-auth.2js.html', 'components/cookie-policy/cookie-policy.2js.html', 'components/expired-trial/expired-trial.2js.html', 'components/forgotten-password/email-confirmation.2js.html', 'components/forgotten-password/password-changed-confirmation.2js.html', 'components/forgotten-password/reset-password.2js.html', 'components/forgotten-password/select-reset-password-method.2js.html', 'components/password-input/password-input.2js.html', 'components/password-input/password-rules-popover.2js.html', 'components/templates/bento-alert-custom.2js.html', 'components/terms/terms-accept.2js.html', 'components/userlogin/userlogin-smb.2js.html', 'components/userlogin/userlogin.2js.html', 'cs-user-admin/login/cs-user-login.2js.html', 'cs-user-admin/registration/cs-user-notfound.2js.html', 'cs-user-admin/registration/cs-user-registration-account.2js.html', 'cs-user-admin/registration/cs-user-registration-complete.2js.html', 'cs-user-admin/registration/cs-user-registration.2js.html', 'csdesktop/desktop.2js.html', 'csdesktop/logout/cs-desktop-logout.2js.html', 'forgot-password/change-password.2js.html', 'forgot-password/provide-email.2js.html', 'main/main.2js.html', 'registration-smb/registration-smb-linked.2js.html', 'registration-smb/registration-smb-new.2js.html', 'registration-smb/registration.2js.html', 'registration/account-info/account-info.2js.html', 'registration/change-registration-email/change-registration-email.2js.html', 'registration/complete/registration-complete.2js.html', 'registration/confirmation/registration-confirmation.2js.html', 'registration/link-registration/link-registration.2js.html', 'registration/personal-id/personal-id.2js.html', 'registration/security-questions/security-questions.2js.html', 'registration/self-registration/self-registration.2js.html', 'registration/user-registration.2js.html']);

angular.module("components/account-link-auth/account-link-auth.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/account-link-auth/account-link-auth.2js.html",
    "<div id=\"acct-link\" bento-busy-loader=\"vm.isLoaderBusy\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-3\">\n" +
    "            <form role=\"form\" name=\"form\" class=\"bm-link-form\" novalidate>\n" +
    "                <label for=\"password\" translate=\"Password\"></label>:\n" +
    "                <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"vm.pwd\" required maxlength=\"50\" />\n" +
    "                <a ng-if =\"vm.disableEditingFeatures == false || vm.disableEditingFeatures == undefined\" id=\"bmlogin-loginform-forgotpwd-link\" ng-href=\"\" data-qe-id=\"bmlogin-loginform-forgotpwd-link\" ng-click=\"openForgottenPasswordDialog()\" translate=\"BM.Login.Form.ForgotPassword\"></a>\n" +
    "                <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                    <span ng-show=\"vm.error.incomplete\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "                    <span ng-show=\"vm.error.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "                    <span ng-show=\"vm.error.forbidden\" translate=\"BM.Login.Directive.Error.Forbidden\"></span>\n" +
    "                    <span ng-show=\"vm.error.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 info-max-width\">\n" +
    "            <hr>\n" +
    "            <button id=\"bm-link-btn\" ng-click=\"registerLinkedAccount(vm.user, vm.pwd)\" class=\"btn btn-primary link-acct-btn\">\n" +
    "                <i class=\"bento-icon-link\"></i>\n" +
    "                <span translate=\"Link Accounts\"></span>\n" +
    "            </button>\n" +
    "            <button ng-if =\"vm.disableEditingFeatures == false || vm.disableEditingFeatures == undefined\" id=\"bm-change-email-btn\" ng-click=\"openChangeEmailModal(vm.uid)\" class=\"btn btn-secondary\" translate=\"Change Email Address\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/cookie-policy/cookie-policy.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/cookie-policy/cookie-policy.2js.html",
    "<span translate=\"Our site uses cookies to improve your online experience. They were placed on your computer when you accessed this website. You can change your cookie settings through your browser.\"></span>\n" +
    "<a href=\"{{$ctrl.cookiePolicyUri}}\" target=\"_blank\" translate=\"Cookie policy\"></a>\n" +
    "");
}]);

angular.module("components/expired-trial/expired-trial.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/expired-trial/expired-trial.2js.html",
    "<div bento-alert bento-alert-object=\"vm.extendAlert\" bento-alert-close=\"closeAlert($index)\"></div>\n" +
    "<div class=\"onvio-expired-trial-box\">\n" +
    "  <em translate=\"BM.Login.Form.CompanyName\"></em>\n" +
    "  <span class=\"bm-product-name\" translate=\"BM.Login.Directive.ProductName\"></span>\n" +
    "  <h1 id=\"expiredTrialHeader\" translate=\"BM.Login.ExtendTrial.Header\"></h1>\n" +
    "  <ul ng-if=\"vm.allowExtend\">\n" +
    "    <li translate=\"BM.Login.ExtendTrial.Body.PurchaseTime\"></li>\n" +
    "    <li translate=\"BM.Login.ExtendTrial.Body.MoreTime\"></li>\n" +
    "  </ul>\n" +
    "  <p ng-if=\"!vm.allowExtend\" translate=\"BM.Login.ExtendTrial.Body.PurchaseOnly\"></p>\n" +
    "  <div id=\"button-group\">\n" +
    "    <a role=\"button\" class=\"btn btn-primary\" id=\"buyNow\" ng-href=\"/trial/{{vm.lang}}/purchase\" translate=\"BM.Login.ExtendTrial.Button.BuyNow\">\n" +
    "    </a>\n" +
    "    <button ng-if=\"vm.allowExtend\" class=\"btn btn-default\" id=\"extendTrial\" ng-click=\"vm.extendTrial()\" translate=\"BM.Login.ExtendTrial.Button.ExtendTrial\">\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("components/forgotten-password/email-confirmation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/forgotten-password/email-confirmation.2js.html",
    "<form role=\"form\" name=\"emailConfirmForm\" class=\"css-form\" novalidate>\n" +
    "    <div class=\"bento-modal\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "          <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\" translate=\"BM.Login.ResetPasswordEmailConfirmation.Header\"></div>\n" +
    "        <div class=\"modal-body\" translate=\"BM.Login.EmailResetInstructions\"></div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button type=\"submit\" role=\"button\" class=\"btn btn-primary\" ng-click=\"close()\" translate=\"BM.Login.ResetPasswordConfirmation.Close\" bm-focus=\"true\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/forgotten-password/password-changed-confirmation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/forgotten-password/password-changed-confirmation.2js.html",
    "<form role=\"form\" name=\"passwordConfirmForm\" class=\"css-form\" novalidate>\n" +
    "    <div class=\"bento-modal\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "          <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\" translate=\"BM.Login.ResetPasswordConfirmation.Header\"></div>\n" +
    "        <div class=\"modal-body\" translate=\"BM.Login.ResetPasswordConfirmation.Message\"></div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button type=\"submit\" role=\"button\" class=\"btn btn-primary\" ng-click=\"close()\" translate=\"BM.Login.ResetPasswordConfirmation.Close\" bm-focus=\"true\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/forgotten-password/reset-password.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/forgotten-password/reset-password.2js.html",
    "<form id=\"reset-password-form\" role=\"form\" class=\"css-form\" name=\"vm.resetPasswordForm\" novalidate>\n" +
    "  <div class=\"bento-modal\">\n" +
    "    <button id=\"emailConfirmForm-closeButton\" type=\"button\" class=\"close\" ng-click=\"vm.close()\" bm-focus=\"true\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"BM.Login.ResetPassword.Header\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "      <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.alerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"vm.closeAlert($index)\">\n" +
    "          {{alert.msg}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"password-instructions\" ng-show=\"vm.requirePasswordChange\">\n" +
    "        <label><span translate=\"BM.Login.ResetPassword.Instructions\"></span></label>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-md-6\">\n" +
    "          <div class=\"form-group\" data-ng-class=\"{'has-error': vm.resetPasswordForm.password.$touched && vm.resetPasswordForm.password.$invalid }\">\n" +
    "            <div>\n" +
    "              <label for=\"password\"><span translate=\"BM.Login.ResetPassword.NewPassword\"></span> *</label>\n" +
    "              <button id=\"showTypingButton\" class=\"btn-link pull-right no-underline\" ng-click=\"vm.togglePassword()\">\n" +
    "                <span ng-if=\"vm.showPassword == true\">\n" +
    "                    <span translate=\"BM.Login.ResetPassword.Hide\"></span>\n" +
    "                </span>\n" +
    "                <span ng-if =\"vm.showPassword == false || vm.showPassword == undefined\">\n" +
    "                    <span translate=\"BM.Login.ResetPassword.Show\"></span>\n" +
    "                </span>\n" +
    "              </button>\n" +
    "              <input password-validator required class=\"form-control\" type=\"{{vm.showPassword ? 'text' : 'password'}}\" id=\"password\" name=\"password\" data-ng-model=\"vm.data.password\" ng-focus=\"vm.setPasswordInScope()\" ng-blur=\"vm.setPasswordOutOfScope()\" autocomplete=\"off\" required maxlength=\"50\"\n" +
    "                aria-required=\"true\" aria-invalid=\"vm.resetPasswordForm.password.$invalid && !vm.resetPasswordForm.password.$pending && (vm.resetPasswordForm.password.$touched || vm.resetPasswordForm.$submitted)\"\n" +
    "                aria-describedby=\"password-alert password-rules\">\n" +
    "              <!-- password acceptable -->\n" +
    "              <div id=\"msg-valid-password\" ng-if=\"vm.resetPasswordForm.password.$valid\">\n" +
    "                <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                <span translate=\"BM.Login.ResetPassword.PasswordAcceptable\" id=\"password-alert\"></span>\n" +
    "              </div>\n" +
    "              <!-- password check in progress -->\n" +
    "              <div id=\"msg-password-pending\" ng-if=\"vm.resetPasswordForm.password.$pending\" bento-busy-loader=\"vm.resetPasswordForm.password.$pending\" bento-busy-loader-size=\"small\">&nbsp;</div>\n" +
    "              <!-- password validation messages -->\n" +
    "              <div class=\"msg\" id=\"password-alert\" ng-messages=\"vm.resetPasswordForm.password.$error\" ng-if=\"vm.resetPasswordForm.password.$invalid && !vm.resetPasswordForm.password.$pending && (vm.resetPasswordForm.password.$touched || vm.resetPasswordForm.$submitted)\">\n" +
    "                <span ng-message=\"required\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                <span ng-message=\"invalidPasswordLength\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                <span ng-message=\"invalidPasswordRules\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                <span ng-message=\"invalidPasswordCharacters\">{{ vm.getProhibitedCharsMessage() }} </span>\n" +
    "                <span ng-message=\"invalidPasswordCommon\">{{ 'BM.Login.ResetPassword.PasswordTooCommon' | translate }}</span>\n" +
    "                <span ng-message=\"invalidPasswordUsed\">{{ 'BM.Login.ResetPassword.PasswordUsedPreviously' | translate }}</span>\n" +
    "              </div>\n" +
    "              <div bm-password-validation password=\"vm.data.password\" ng-show=\"vm.resetPasswordForm.password.hasFocus\" id=\"password-rules\"></div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"form-group\" id=\"confirm-password-div\" data-ng-class=\"{'has-error': vm.isConfirmPasswordInvalid()}\">\n" +
    "            <div>\n" +
    "              <label for=\"confirm\"><span translate=\"BM.Login.ResetPassword.ConfirmPassword\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"{{vm.showPassword ? 'text' : 'password'}}\" id=\"confirm\" name=\"confirm\" data-ng-model=\"vm.data.confirm\" autocomplete=\"off\" maxlength=\"50\" ng-focus=\"vm.setConfirmInScope()\" ng-blur=\"vm.setConfirmOutOfScope()\" required\n" +
    "                aria-required=\"true\" aria-invalid=\"vm.isConfirmPasswordValid() && vm.resetPasswordForm.password.$valid\"\n" +
    "                aria-describedby=\"confirm-password-alert\">\n" +
    "              <div class=\"msg\" id=\"confirm-password-alert\" ng-if=\"vm.formMsgUnconfirmedPassword\">{{vm.formMsgUnconfirmedPassword}}</div>\n" +
    "              <div id=\"msg-valid-password\" ng-if=\"vm.isConfirmPasswordValid() && vm.resetPasswordForm.password.$valid\">\n" +
    "                <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                <span translate=\"BM.Login.ResetPassword.PasswordConfirmed\" id=\"confirm-password-alert\"></span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button type=\"button\" role=\"button\" class=\"btn btn-default pull-left\" ng-click=\"vm.back()\" aria-label=\"Back\" ng-if=\"vm.isResetFromSecurityQuestions()\">\n" +
    "        <i class=\"glyphicons chevron-left\"></i>\n" +
    "        <span class=\"btn-icon-text\" translate=\"BM.Login.ResetPassword.BackBtn\"></span>\n" +
    "      </button>\n" +
    "      <button type=\"submit\" role=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.next()\" aria-label=\"Next\">\n" +
    "        <span class=\"btn-icon-text\" translate=\"BM.Login.ResetPassword.NextBtn\"></span>\n" +
    "        <i class=\"glyphicons chevron-right\"></i>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/forgotten-password/select-reset-password-method.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/forgotten-password/select-reset-password-method.2js.html",
    "<form role=\"form\" class=\"css-form\" name=\"$parent.form1\" novalidate>\n" +
    "  <div class=\"bento-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"BM.Login.ResetPassword\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "      <div class=\"form-group\" ng-class=\"{'has-error': errorMessage !== ''}\">\n" +
    "          <label for=\"email\">\n" +
    "            <span translate=\"BM.Login.PasswordResetMethod\"></span> *\n" +
    "          </label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"email\" name=\"email\" data-ng-model=\"data.email\" value=\"\"  bm-focus=\"focusSelectResetPassword\" ng-focus=\"prepForValidation()\" ng-blur=\"validateEmail()\" autocomplete=\"off\" required />\n" +
    "          <div class=\"msg\">{{errorMessage}}</div>\n" +
    "      </div>\n" +
    "      * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" role=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"next()\" aria-label=\"Next\">\n" +
    "        <span class=\"btn-icon-text\" translate=\"BM.Login.ResetSecurityNextButton\"></span>\n" +
    "        <i class=\"glyphicons chevron-right\"></i>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/password-input/password-input.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/password-input/password-input.2js.html",
    "<!-- TODO: FINISH THIS IMPLEMENTATION -->\n" +
    "<!-- <div class=\"input-group\">\n" +
    "    <label for=\"password\"><span translate=\"BM.Login.Directive.Password\"></span><span class=\"required-mark\">*</span></label>\n" +
    "    <input class=\"form-control\" type=\"password\" id=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"vm.model.password\" ng-change=\"vm.validatePassword()\" ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 250, 'blur': 0 } }\" />\n" +
    "    <span class=\"input-group-btn\">\n" +
    "        <button class=\"btn btn-default\" type=\"button\">\n" +
    "            <i\n" +
    "                uib-popover-template=\"vm.popover.templateUrl\"\n" +
    "                popover-title=\"{{vm.popover.title}}\"\n" +
    "                tabindex=\"-1\"\n" +
    "                popover-placement=\"right\"\n" +
    "                class=\"bento-icon-question\">\n" +
    "            </i>\n" +
    "        </button>\n" +
    "    </span>\n" +
    "</div> -->\n" +
    "");
}]);

angular.module("components/password-input/password-rules-popover.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/password-input/password-rules-popover.2js.html",
    "<div class=\"bm-pop-password-rules\">\n" +
    "    <div class=\"bm-pop-password-header\">\n" +
    "        <span translate=\"bm.login.password.header\"></span>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        <ul>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.charLengthOk}\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.charLengthOk\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.charLengthOk\"></i>\n" +
    "                <span translate=\"bm.login.password.charLengthRule\" translate-value-val=\"{{vm.charLengthReq}}\"></span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <div class=\"bm-pop-password-header\" ng-if=\"vm.showCharClassRuleCheck\">\n" +
    "        <span translate=\"bm.login.password.charClassRule\" translate-value-val=\"{{vm.charClassReq}}\"></span>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        <ul>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.numberOk}\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.numberOk\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.numberOk\"></i>\n" +
    "                <span translate=\"bm.login.password.number\"></span>\n" +
    "            </li>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.lowerCaseOk}\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.lowerCaseOk\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.lowerCaseOk\"></i>\n" +
    "                <span translate=\"bm.login.password.lowerCase\"></span>\n" +
    "            </li>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.upperCaseOk}\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.upperCaseOk\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.upperCaseOk\"></i>\n" +
    "                <span translate=\"bm.login.password.upperCase\"></span>\n" +
    "            </li>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.specialCharOk}\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.specialCharOk\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.specialCharOk\"></i>\n" +
    "                <span translate=\"bm.login.password.specialChar\"></span>\n" +
    "            </li>\n" +
    "            <li ng-class=\"{'bm-login-rule-ok': vm.passwordChecks.passwordCommon}\" ng-show=\"vm.useCommonPasswordsFilter\">\n" +
    "                <i class=\"bento-icon-close-x\" ng-show=\"!vm.passwordChecks.passwordCommon\"></i>\n" +
    "                <i class=\"bento-icon-checkmark\" ng-show=\"vm.passwordChecks.passwordCommon\"></i>\n" +
    "                <span translate=\"bm.login.password.passwordCommon\"></span>\n" +
    "            </li>\n" +
    "        <ul>\n" +
    "    </div>\n" +
    "    <div class=\"bm-pop-password-suggestions\">\n" +
    "        <span translate=\"bm.login.password.suggestions\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/templates/bento-alert-custom.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/templates/bento-alert-custom.2js.html",
    "<!-- TODO: SCOPE VARIABLE DOESN\"T WORK HERE SO CLOSEABLE AND TYPE AREN'T SUPPORTED -->\n" +
    "<!-- SHOULD SWITCH TO NOT USING INLINE ALERTS OR INVESTIGATE SCOPE ISSUES -->\n" +
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "    <span aria-hidden=\"true\"><i class=\"bento-icon-close-x\"></i></span>\n" +
    "    <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("components/terms/terms-accept.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/terms/terms-accept.2js.html",
    "<div>\n" +
    "    <input type=\"checkbox\" ng-change=\"$ctrl.checkboxClick()\" ng-model='$ctrl.accepted' name=\"termsAccepted\">\n" +
    "    <span translate=\"bm.registration.AcceptTerms\"></span>\n" +
    "    <a href='{{$ctrl.termsUri}}' target='_blank' translate=\"bm.registration.TermsOfUse\"></a>\n" +
    "    <span>&nbsp;*</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/userlogin/userlogin-smb.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/userlogin/userlogin-smb.2js.html",
    "<!-- LOGIN FOR ARGENTINA -->\n" +
    "<div ng-show=\"isARLoginOB  && !hasEnableAuth0Phase2\">\n" +
    "    <div class=\"onbalance-brand\">\n" +
    "        <div class=\"onbalance-product-name-ar\" translate=\"bm.login.employeePortalProductName\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"bm-view-instructions\" translate=\"bm.login.sambaEmailPasswordInstructions\" ng-if=\"product.passwordChangeState\"></div>\n" +
    "    <form role=\"form\" name=\"form\" class=\"css-form bm-login-form\" novalidate>\n" +
    "        <div class=\"form-group-ar \">\n" +
    "            <label for=\"uid\"><span translate=\"BM.Registration.EmailAddress\"></span><span class=\"required-mark\">*</span></label>\n" +
    "            <input type=\"text\" class=\"form-control-ar\" id=\"uid\" name=\"uid\" data-qe-id=\"bmlogin-loginform-uid-input\" ng-model=\"uid\" required maxlength=\"255\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        </div>\n" +
    "        <div class=\"form-group-ar pt-1\">\n" +
    "            <label for=\"pwd\"><span translate=\"BM.Login.Directive.Password\"></span><span class=\"required-mark\">*</span></label>\n" +
    "            <input type=\"password\" class=\"form-control-ar\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"pwd\" required maxlength=\"50\" />\n" +
    "        </div>\n" +
    "        <a class=\"forgot-pswd\" href=\"\" ng-click=\"openForgottenPasswordDialog()\" translate=\"bm.login.sambaforgotPassword\"></a>\n" +
    "        <div class=\"bm-btn-signin-wrap text-center\">\n" +
    "            <button type=\"submit\" class=\"btn btn-ar\" id=\"sign-in\" ng-click=\"signIn(uid, pwd)\" translate=\"BM.Login.Directive.Button.SignIn\"></button>\n" +
    "            <button type=\"button\" class=\"btn btn-ar\" translate=\"bm.login.common.cancel\" ng-click=\"cancelPasswordChangeState()\" ng-if=\"product.passwordChangeState\"></button>\n" +
    "        </div>\n" +
    "        <div id=\"msgs\" ng-show=\"error\" class=\"alert alert-error\">\n" +
    "            <span ng-show=\"error.incomplete\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "            <span ng-show=\"error.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "            <span ng-show=\"error.forbidden\" translate=\"BM.Login.Directive.Error.OnbalanceForbidden\"></span>\n" +
    "            <span ng-show=\"error.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "            <span ng-show=\"error.expiredLink\" translate=\"BM.Registration.ExpiredLink\"></span>\n" +
    "            <span ng-show=\"error.expiredCpid\" translate=\"BM.Login.Directive.Error.ExpiredCPID\"></span>\n" +
    "            <span ng-show=\"error.inactive\" translate=\"BM.Login.Directive.Error.InactiveUser\"></span>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "    <div class=\"bottom-links-ar\" ng-if=\"!product.passwordChangeState\">\n" +
    "        <i><a class=\"bottom-links-ar\" ng-href=\"/api/security/overrides\" bm-if-has-access=\"IAC-PPE-AllowOverrides\" data-qe-id=\"bmlogin-loginform-session-overrides-link\" translate=\"BM.Login.Form.SessionOverrides\"></a></i>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- LOGIN UI FOR BRAZIL -->\n" +
    "<div ng-show=\"!isARLoginOB && !hasEnableAuth0Phase2\">\n" +
    "    <div class=\"onbalance-brand\">\n" +
    "        <div class=\"bm-thomsonreuters\"></div>\n" +
    "        <div class=\"onbalance-product-name\">ONBALANCE<sup>TM</sup></div>\n" +
    "    </div>\n" +
    "    <h1 class=\"bm-login-view-title\" translate=\"bm.login.sambaEmailTitle\" ng-if=\"!product.passwordChangeState && !displayConnectTitle\"></h1>\n" +
    "    <h1 class=\"bm-login-connect-title\" translate=\"bm.login.sambaConnectTitle\" ng-if=\"!product.passwordChangeState && displayConnectTitle\"></h1>\n" +
    "    <h1 class=\"bm-login-view-title\" translate=\"bm.login.sambaEmailPasswordTitle\" ng-if=\"product.passwordChangeState\"></h1>\n" +
    "    <div class=\"bm-view-instructions\" translate=\"bm.login.sambaEmailPasswordInstructions\" ng-if=\"product.passwordChangeState\"></div>\n" +
    "    <form role=\"form\" name=\"form\" class=\"css-form bm-login-form\" novalidate>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"uid\"><span translate=\"BM.Registration.EmailAddress\"></span><span class=\"required-mark\">*</span></label>\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"uid\" name=\"uid\" data-qe-id=\"bmlogin-loginform-uid-input\" ng-model=\"uid\" required maxlength=\"255\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"pwd\"><span translate=\"BM.Login.Directive.Password\"></span><span class=\"required-mark\">*</span></label>\n" +
    "            <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"pwd\" required maxlength=\"50\" />\n" +
    "        </div>\n" +
    "        <a href=\"\" ng-click=\"openForgottenPasswordDialog()\" translate=\"bm.login.sambaforgotPassword\"></a>\n" +
    "        <div class=\"bm-btn-signin-wrap\">\n" +
    "            <button type=\"submit\" class=\"btn btn-primary bm-btn-signin\" id=\"sign-in\" ng-click=\"signIn(uid, pwd)\" translate=\"BM.Login.Directive.Button.SignIn\"></button>\n" +
    "            <button type=\"button\" class=\"bm-samba-cancel-btn btn btn-link\" translate=\"bm.login.common.cancel\" ng-click=\"cancelPasswordChangeState()\" ng-if=\"product.passwordChangeState\"></button>\n" +
    "        </div>\n" +
    "        <div id=\"msgs\" ng-show=\"error\" class=\"alert alert-error\">\n" +
    "            <span ng-show=\"error.incomplete\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "            <span ng-show=\"error.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "            <span ng-show=\"error.forbidden\" translate=\"BM.Login.Directive.Error.OnbalanceForbidden\"></span>\n" +
    "            <span ng-show=\"error.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "            <span ng-show=\"error.expiredLink\" translate=\"BM.Registration.ExpiredLink\"></span>\n" +
    "            <span ng-show=\"error.expiredCpid\" translate=\"BM.Login.Directive.Error.ExpiredCPID\"></span>\n" +
    "            <span ng-show=\"error.inactive\" translate=\"BM.Login.Directive.Error.InactiveUser\"></span>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "    <div class=\"bottom-links\" ng-if=\"!product.passwordChangeState\">\n" +
    "        <div bm-if-has-access=\"IAC-SMB-Registration\">\n" +
    "            <span translate=\"bm.login.sambaDontHaveAccount\"></span>\n" +
    "            <a ng-href=\"{{ selfRegistrationUrl }}\" data-qe-id=\"bmlogin-loginform-selfreg-link\" translate=\"bm.login.sambaStartTrial\" class=\"bm-samba-register\"></a>\n" +
    "        </div>\n" +
    "        <div ng-if=\"countryCode === 'us'\">\n" +
    "            <span translate=\"bm.login.sambaStatus\"></span>\n" +
    "            <a target=\"_blank\" ng-href=\"https://taxprofessionals-status.hostedtax.thomsonreuters.com/\" data-qe-id=\"bmlogin-status-check\" translate=\"BM.Login.StatusLink\" class=\"bm-samba-register\"></a>\n" +
    "        </div>\n" +
    "        <i><a ng-href=\"/api/security/overrides\" bm-if-has-access=\"IAC-PPE-AllowOverrides\" data-qe-id=\"bmlogin-loginform-session-overrides-link\" translate=\"BM.Login.Form.SessionOverrides\"></a></i>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-show=\"hasEnableAuth0Phase2\">\n" +
    "    <span>\n" +
    "        <h1 class=\"bm-login-title-visually-hidden\" translate=\"BM.Login.Form.CompanyName\"></h1>\n" +
    "        <em translate=\"BM.Login.Form.CompanyName\"></em>\n" +
    "        <span bm-if-has-no-access=\"ARLoginOB\" class=\"bm-product-name\" translate=\"BM.Login.Directive.SambaProductName\"></span>\n" +
    "        <span bm-if-has-access=\"ARLoginOB\" class=\"bm-product-name samba-ar-product-name\" translate=\"bm.login.employeePortalProductName\"></span>\n" +
    "    </span>\n" +
    "    <div id=\"trAuthTarget\"></div>\n" +
    "    <div class=\"bottom-links\">\n" +
    "        <i><a ng-href=\"/api/security/overrides\" bm-if-has-access=\"IAC-PPE-AllowOverrides\" data-qe-id=\"bmlogin-loginform-session-overrides-link\" translate=\"BM.Login.Form.SessionOverrides\"></a></i>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/userlogin/userlogin.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/userlogin/userlogin.2js.html",
    "<div>\n" +
    "    <!-- default name = TR Onvio -->\n" +
    "    <span bm-if-has-no-access=\"myPaySolutions\">\n" +
    "        <h1 class=\"bm-login-title-visually-hidden\" translate=\"BM.Login.Form.CompanyName\"></h1>\n" +
    "        <em translate=\"BM.Login.Form.CompanyName\"></em>\n" +
    "        <span class=\"bm-product-name\" translate=\"BM.Login.Directive.ProductName\"></span>\n" +
    "    </span>\n" +
    "    <!-- myPay Solutions -->\n" +
    "    <span bm-if-has-access=\"myPaySolutions\">\n" +
    "        <span class=\"bm-product-name mypay-solutions\" translate=\"myPay Solutions\"></span><sup>&reg;</sup>\n" +
    "    </span>\n" +
    "    <div id=\"trAuthTarget\"></div>\n" +
    "    <form role=\"form\" name=\"form\" class=\"css-form bm-login-form\" novalidate>\n" +
    "        <div class=\"form-group\">\n" +
    "            <i class=\"bento-icon-user\"></i>\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"uid\" name=\"uid\" data-qe-id=\"bmlogin-loginform-uid-input\" ng-model=\"uid\" required maxlength=\"250\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <i class=\"bento-icon-lock\"></i>\n" +
    "            <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"pwd\" required maxlength=\"50\" />\n" +
    "        </div>\n" +
    "        <button type=\"submit\" class=\"btn btn-primary bm-btn-signin\" id=\"sign-in\" ng-click=\"signIn(uid, pwd)\" translate=\"BM.Login.Directive.Button.SignIn\">\n" +
    "        </button>\n" +
    "        <div id=\"msgs\" ng-show=\"error\" class=\"alert alert-error\">\n" +
    "            <span ng-show=\"error.incomplete\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "            <span ng-show=\"error.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "            <span ng-show=\"error.forbidden\" translate=\"BM.Login.Directive.Error.Forbidden\"></span>\n" +
    "            <span ng-show=\"error.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "            <span ng-show=\"error.expiredLink\" translate=\"BM.Registration.ExpiredLink\"></span>\n" +
    "            <span ng-show=\"error.expiredCpid\" translate=\"BM.Login.Directive.Error.ExpiredCPID\"></span>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "    <div class=\"bottom-links\">\n" +
    "        <a id=\"bmlogin-loginform-forgotpwd-link\" ng-href=\"\" data-qe-id=\"bmlogin-loginform-forgotpwd-link\" ng-click=\"openForgottenPasswordDialog()\" translate=\"BM.Login.Form.ForgotPassword\"></a>\n" +
    "        <i><a ng-href=\"/api/security/overrides\" bm-if-has-access=\"IAC-PPE-AllowOverrides\" data-qe-id=\"bmlogin-loginform-session-overrides-link\" translate=\"BM.Login.Form.SessionOverrides\"></a></i>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("cs-user-admin/login/cs-user-login.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("cs-user-admin/login/cs-user-login.2js.html",
    "<div ng-controller=\"CsUserLoginCtrl as ctrl\"></div>\n" +
    "");
}]);

angular.module("cs-user-admin/registration/cs-user-notfound.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("cs-user-admin/registration/cs-user-notfound.2js.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row csu-margin-top-row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <div class=\"csu-page-header csu-margin-bottom-row\" translate=\"CS Professional Suite User Registration\"></div>\n" +
    "          <h4 translate=\"We're sorry. Your registration could not be verified. Please contact your administrator.\"></h4>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("cs-user-admin/registration/cs-user-registration-account.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("cs-user-admin/registration/cs-user-registration-account.2js.html",
    "<h1 translate=\"Account Information\"></h1>\n" +
    "<!-- user name -->\n" +
    "<div class=\"row csu-margin-top-row\">\n" +
    "  <div class=\"col-sm-4\">\n" +
    "    <div class=\"form-group\">\n" +
    "      <label for=\"fullName\" translate=\"Name\"></label>\n" +
    "      <div class=\"csu-read-only-control\" id=\"fullName\" name=\"fullName\">{{$ctrl.user.fullName}}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<!-- user email -->\n" +
    "<div class=\"row\">\n" +
    "  <div class=\"col-sm-4\">\n" +
    "    <div class=\"form-group\">\n" +
    "      <label for=\"email\" translate=\"Email\"></label>\n" +
    "      <div class=\"csu-read-only-control\" id=\"email\" name=\"email\">{{$ctrl.user.userId}}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<h1 translate=\"Create Password\"></h1>\n" +
    "<form role=\"form\" name=\"$ctrl.csAcctInfoForm\" autocomplete=\"off\" class=\"css-form cs-user-form\" novalidate>\n" +
    "  <div class=\"row\">\n" +
    "    <!-- password and confirm password -->\n" +
    "    <div class=\"col-sm-6\">\n" +
    "      <!-- password -->\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <div class=\"form-group\" ng-class=\"{'has-error' : $ctrl.csAcctInfoForm.password.$invalid && $ctrl.csAcctInfoForm.password.$touched && !$ctrl.hasFocusPassword}\">\n" +
    "            <label for=\"password\"><span translate=\"BM.Login.ResetPassword.NewPassword\"></span> *</label>\n" +
    "            <a href class=\"pull-right no-underline\" ng-click=\"$ctrl.showPassword = !$ctrl.showPassword\">\n" +
    "              <span ng-if=\"$ctrl.showPassword == false || $ctrl.showPassword == undefined\" translate=\"BM.Registration.ShowTyping\"></span>\n" +
    "              <span ng-if=\"$ctrl.showPassword == true\" translate=\"BM.Registration.HideTyping\"></span>\n" +
    "            </a>\n" +
    "            <input class=\"form-control\" type=\"{{ $ctrl.showPassword ? 'text' : 'password' }}\" id=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"$ctrl.user.password\" ng-model-options=\"{ allowInvalid: true }\" password-validator required maxlength=\"50\" bm-focus=\"$ctrl.hasFocusPassword\" ng-focus=\"$ctrl.hasFocusPassword = true\" ng-blur=\"$ctrl.hasFocusPassword = false\" />\n" +
    "            <!-- password validation messages -->\n" +
    "            <div class=\"msg\" ng-messages=\"$ctrl.csAcctInfoForm.password.$error\" ng-if=\"$ctrl.csAcctInfoForm.password.$touched || $ctrl.csAcctInfoForm.$submitted\">\n" +
    "              <span ng-message=\"required\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "              <span ng-message=\"invalidPasswordLength\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "              <span ng-message=\"invalidPasswordRules\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "            </div>\n" +
    "            <!-- password acceptable -->\n" +
    "            <div id=\"msg-valid-password\" ng-if=\"($ctrl.csAcctInfoForm.password.$touched || $ctrl.csAcctInfoForm.$submitted) && $ctrl.csAcctInfoForm.password.$valid && !$ctrl.hasFocusPassword\">\n" +
    "              <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "              <span translate=\"BM.Registration.PasswordAcceptable\"></span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <!-- confirm password -->\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <div class=\"form-group\" ng-class=\"{'has-error' : $ctrl.csAcctInfoForm.confirmPassword.$invalid && ($ctrl.csAcctInfoForm.confirmPassword.$touched || $ctrl.csAcctInfoForm.confirmPassword.$dirty) }\">\n" +
    "            <label for=\"confirmPassword\"><span translate=\"BM.Registration.ConfirmPass\"></span> *</label>\n" +
    "            <input class=\"form-control\" type=\"{{ $ctrl.showPassword ? 'text' : 'password' }}\" id=\"confirmPassword\" autocomplete=\"off\" name=\"confirmPassword\" ng-model=\"$ctrl.user.confirmPassword\" required maxlength=\"50\" value-compare-validator share-validate=\"$ctrl.user.password\" ng-focus=\"$ctrl.actions.setConfirmValidity()\" ng-blur=\"$ctrl.actions.verifyConfirm()\" />\n" +
    "            <!-- confirm password validation messages -->\n" +
    "            <div class=\"msg\" ng-messages=\"$ctrl.csAcctInfoForm.confirmPassword.$error\" ng-if=\"$ctrl.csAcctInfoForm.confirmPassword.$touched || $ctrl.csAcctInfoForm.confirmPassword.$dirty || $ctrl.csAcctInfoForm.$submitted\">\n" +
    "              <span ng-message=\"required\">{{ 'BM.Login.ResetPassword.PasswordNoData' | translate }}</span>\n" +
    "              <span ng-message=\"invalidComparison\">{{ 'BM.Login.ResetPassword.PasswordsDoNotMatch' | translate }}</span>\n" +
    "            </div>\n" +
    "            <!-- confirm password acceptable -->\n" +
    "            <div id=\"msg-valid-password\"  ng-if=\"($ctrl.csAcctInfoForm.confirmPassword.$touched || $ctrl.csAcctInfoForm.confirmPassword.$dirty || $ctrl.csAcctInfoForm.$submitted) && $ctrl.csAcctInfoForm.confirmPassword.$valid && $ctrl.user.password === $ctrl.user.confirmPassword\">\n" +
    "              <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "              <span translate=\"BM.Registration.PassConfirmedText\"></span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"row csu-margin-top-row csu-margin-bottom-row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- password validation rule display -->\n" +
    "    <div class=\"col-sm-6\">\n" +
    "      <div translate=\"Password Requirements\" class=\"csu-label\"></div>\n" +
    "      <div id=\"passwordvalidation\" class=\"csu-password-validate\" bm-password-validation password=\"$ctrl.user.password\"></div>\n" +
    "      <!-- <div id=\"passwordvalidation\" bm-password-validation password=\"$ctrl.user.password\" ng-if=\"$ctrl.csAcctInfoForm.password.hasFocus\"></div> -->\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("cs-user-admin/registration/cs-user-registration-complete.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("cs-user-admin/registration/cs-user-registration-complete.2js.html",
    "<div class=\"row csu-margin-top-row csu-margin-bottom-row-lg\">\n" +
    "  <div class=\"col-md-8\">\n" +
    "    <div translate=\"You’ve successfully registered your CS Web account.\"></div>\n" +
    "    <div>\n" +
    "      <span translate=\"If you need to update your account, visit\"></span> <a href=\"https://cs.thomsonreuters.com\" target=\"_blank\" translate=\"cs.thomsonreuters.com\"></a>.\n" +
    "    </div>\n" +
    "    <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "    <bm-login-cookie-policy aria-hidden=\"true\"></bm-login-cookie-policy>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-if=\"0\">\n" +
    "    <!-- temporarily remove MFA -->\n" +
    "    <h1 translate=\"Want more security for your account?\" bm-if-has-access=\"Platform_Enable2FA\"></h1>\n" +
    "    <div class=\"row csu-margin-bottom-row-lg\" bm-if-has-access=\"Platform_Enable2FA\">\n" +
    "      <div class=\"col-md-8\">\n" +
    "        <div class=\"csu-margin-bottom-row\" translate=\"Passwords are not as safe as you think they are. Download the Thomson Reuters' Authenticator app to your smartphone and add multi-factor authentication to increase the security of your account and require approval of each sign-in attempt from your smartphone.\"></div>\n" +
    "        <div>\n" +
    "          <span translate=\"If your firm requires multi-factor authentication, you’ll set it up the first time you sign in. If multi-factor authentication is not required, you can enable it by updating your profile at\"></span> <a href=\"https://cs.thomsonreuters.com\" target=\"_blank\" translate=\"cs.thomsonreuters.com\"></a>.\n" +
    "        </div>\n" +
    "        <!-- temporarily remove MFA setup -->\n" +
    "        <div ng-if=\"0\">\n" +
    "          <a role=\"button\" class=\"btn btn-primary csu-reg-btn\" ng-href=\"\" ng-click=\"$ctrl.actions.startMultiSetup()\" translate=\"Add Multi-Factor Authentication\" ng-if=\"!$ctrl.mutliFactorComplete\"></a>\n" +
    "          <a role=\"button\" class=\"btn btn-primary csu-reg-btn\" ng-href=\"\" ng-disabled=\"true\" ng-if=\"$ctrl.mutliFactorComplete\">\n" +
    "            <i class=\"bento-icon-checkmark\"></i>\n" +
    "            <span translate=\"Completed\"></span>\n" +
    "          </a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("cs-user-admin/registration/cs-user-registration.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("cs-user-admin/registration/cs-user-registration.2js.html",
    "<div class=\"csu-reg-body\" ng-if=\"!$ctrl.showLinkingScreen\" ng-show=\"$ctrl.isTemplateVisible\">\n" +
    "    <div class=\"csu-reg-content\">\n" +
    "        <div class=\"csu-page-header\">{{$ctrl.wizardTitle}}</div>\n" +
    "        <div bento-alert bento-alert-object=\"$ctrl.alerts\"></div>\n" +
    "        <div bento-wizard\n" +
    "          ng-keypress=\"$ctrl.actions.onWizardKeypress($event)\"\n" +
    "          on-change=\"$ctrl.actions.onStepChange(step)\"\n" +
    "          use-side-arrows=\"true\"\n" +
    "          current-step=\"$ctrl.currentStep\"\n" +
    "          total-step=\"$ctrl.totalSteps\"\n" +
    "          hide-default-buttons=\"true\"\n" +
    "        >\n" +
    "            <ol class=\"steps\">\n" +
    "                <li ng-class=\"{'csu-no-cursor': $ctrl.isLastStep()}\" ng-if=\"$ctrl.actions.getStepDisplay('account')\">\n" +
    "                    <span class=\"title\" translate=\"Account Information\"></span>\n" +
    "                    <span class=\"description\" translate=\"Verify account information\"></span>\n" +
    "                </li>\n" +
    "                <li ng-if=\"$ctrl.actions.getStepDisplay('complete')\">\n" +
    "                    <span class=\"title\" translate=\"Registration Complete\"></span>\n" +
    "                    <span class=\"description\" translate=\"Add additional security measures\"></span>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "            <ul class=\"contents\">\n" +
    "                <li ng-if=\"$ctrl.actions.getStepDisplay('account')\">\n" +
    "                    <cs-user-registration-account user=\"$ctrl.user\" on-get-valid=\"$ctrl.isAccountValid(isValid)\"></cs-user-registration-account>\n" +
    "                </li>\n" +
    "                <li ng-if=\"$ctrl.actions.getStepDisplay('complete')\">\n" +
    "                    <cs-user-registration-complete user=\"$ctrl.user\"></cs-user-registration-complete>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <div class=\"csu-reg-btns\">\n" +
    "                <button class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.actions.next()\" ng-if=\"!$ctrl.hideNextButton\">\n" +
    "                    {{$ctrl.nextButtonText}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"csu-reg-body\" ng-if=\"$ctrl.showLinkingScreen\" ng-show=\"$ctrl.isTemplateVisible\">\n" +
    "    <div class=\"csu-reg-content\">\n" +
    "        <div id=\"link-registration\" class=\"bento-container\">\n" +
    "            <div class=\"registration-body col-md-12\">\n" +
    "                <div id=\"moduleHeader\">{{$ctrl.wizardTitle}}</div>\n" +
    "                <h2 translate=\"BM.Registration.AccountInformationHeader\"></h2>\n" +
    "                <div class=\"info-banner\">\n" +
    "                    <i class=\"bento-icon-info\"></i>\n" +
    "                    <span translate=\"BM.Registration.EmailAlreadyRegistered\"></span>\n" +
    "                </div>\n" +
    "                <!-- user name -->\n" +
    "                <div class=\"row csu-margin-top-row\">\n" +
    "                    <div class=\"col-sm-4\">\n" +
    "                        <div class=\"form-group\">\n" +
    "                            <label for=\"fullName\" translate=\"Name\"></label>\n" +
    "                            <div class=\"csu-read-only-control\" id=\"fullName\" name=\"fullName\">{{$ctrl.user.fullName}}\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- user email -->\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-sm-4\">\n" +
    "                        <div class=\"form-group\">\n" +
    "                            <label for=\"email\" translate=\"Email\"></label>\n" +
    "                            <div class=\"csu-read-only-control\" id=\"email\" name=\"email\">{{$ctrl.user.userId}}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <p\n" +
    "                    translate=\"To use this email address to access all your accounts, enter your password and click Link Accounts. To access this account with a different email address, click Change Email Address.\">\n" +
    "                </p>\n" +
    "                <h2 translate=\"Enter Password\"></h2>\n" +
    "                <bm-account-link-auth user=\"$ctrl.user\" product=\"$ctrl.product\" disable-editing-features=\"$ctrl.disableEditingFeatures\"></bm-account-link-auth>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"csu-reg-footer\">\n" +
    "    <div class=\"csu-footer-wrap clearfix\">\n" +
    "        <div class=\"csu-footer-logo\">\n" +
    "            <a href=\"https://tax.thomsonreuters.com/\"></a>\n" +
    "        </div>\n" +
    "        <ul class=\"csu-footer-links\">\n" +
    "            <li>\n" +
    "                <a href=\"http://thomsonreuters.com/\" translate=\"ThomsonReuters.com\"></a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <a href=\"https://tax.thomsonreuters.com/sitemap/\" translate=\"Site Map\"></a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <a href=\"http://careers.thomsonreuters.com/\" translate=\"Careers\"></a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "                <a href=\"http://thomsonreuters.com/terms_of_use/\" translate=\"Terms & Conditions\"></a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("csdesktop/desktop.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("csdesktop/desktop.2js.html",
    "<div class=\"bm-desktop-flex-wrap\">\n" +
    "    <div class=\"bm-desktop-content-box\" role=\"main\">\n" +
    "        <span class=\"bm-desktop-company-name\" aria-live=\"polite\" translate=\"BM.Login.Form.CompanyName\"></span>\n" +
    "        <span class=\"bm-desktop-product-name\" aria-live=\"polite\" translate=\"BM.Login.Desktop.ProductName\"\n" +
    "            alt=\"{{ 'BM.Login.Desktop.ProductName' | translate }}\"></span>\n" +
    "        <div ng-if=\"!vm.containsError\" class=\"bm-desktop-message\" aria-live=\"polite\">\n" +
    "            <div aria-hidden=\"true\" class=\"bm-desktop-success-image\"></div>\n" +
    "            <h1 id=\"bm-desktop-event\" class=\"bm-desktop-event\" translate=\"BM.Login.Desktop.SignIn.Success.Title\"></h1>\n" +
    "            <p class=\"bm-desktop-success-message\" translate=\"BM.Login.Desktop.SignIn.Success.Message\"></p>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.containsError\" class=\"bm-desktop-message\" aria-live=\"polite\">\n" +
    "            <div aria-hidden=\"true\" class=\"bm-desktop-error-image\"></div>\n" +
    "            <h1 id=\"bm-desktop-event\" class=\"bm-desktop-event\" translate=\"BM.Login.Desktop.SignIn.Error.Title\"></h1>\n" +
    "            <p class=\"bm-desktop-error-message\" translate=\"BM.Login.Desktop.SignIn.Error.Message\"></p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("csdesktop/logout/cs-desktop-logout.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("csdesktop/logout/cs-desktop-logout.2js.html",
    "<div class=\"bm-desktop-flex-wrap\">\n" +
    "    <div class=\"bm-desktop-content-box\" role=\"main\">\n" +
    "        <span class=\"bm-desktop-company-name\" aria-live=\"polite\" translate=\"BM.Login.Form.CompanyName\"></span>\n" +
    "        <span class=\"bm-desktop-product-name\" aria-live=\"polite\" translate=\"BM.Login.Desktop.ProductName\"\n" +
    "            alt=\"{{ 'BM.Login.Desktop.ProductName' | translate }}\"></span>\n" +
    "        <div class=\"bm-desktop-message\" aria-live=\"polite\">\n" +
    "            <div aria-hidden=\"true\" class=\"bm-desktop-error-image\"></div>\n" +
    "            <h1 id=\"bm-desktop-event\" class=\"bm-desktop-event\" translate=\"BM.Login.Desktop.Logout.Error.Title\"></h1>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("forgot-password/change-password.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("forgot-password/change-password.2js.html",
    "<ng-container ng-show=\"!isARLoginOB\">\n" +
    "    <div class=\"bm-flex-wrap bm-{{vm.productName}} bm-{{vm.backgroundName}}-back\">\n" +
    "        <main>\n" +
    "            <div class=\"bm-login-content-box\">\n" +
    "                <div>\n" +
    "                    <!--Only display onbalance branding if name is samba -->\n" +
    "                    <div class=\"onbalance-brand\" ng-if=\"vm.productName === 'samba'\">\n" +
    "                        <div class=\"bm-thomsonreuters\"></div>\n" +
    "                        <div class=\"onbalance-product-name\">ONBALANCE<sup>TM</sup></div>\n" +
    "                    </div>\n" +
    "                    <div class=\"bm-product-name\" ng-bind=\"vm.getViewTitle()\" ng-if=\"vm.productName !== 'samba'\"></div>\n" +
    "                    <h1 class=\"bm-login-view-title\" translate=\"bm.login.changePasswordTitle\"></h1>\n" +
    "                </div>\n" +
    "                <div class=\"bm-view-instructions\" translate=\"bm.login.enterPasswordInstructions\" ng-if=\"!vm.requiredChange\"></div>\n" +
    "                <div class=\"bm-view-instructions\" translate=\"BM.Login.ResetPassword.Instructions\" ng-if=\"vm.requiredChange\"></div>\n" +
    "                <form role=\"form\" name=\"vm.changePasswordForm\" class=\"css-form bm-login-form\" novalidate>\n" +
    "                    <div class=\"form-group\">\n" +
    "                        <!-- TODO: IMPLEMENT THIS AS DIRECTIVE -->\n" +
    "                        <div class=\"input-group\">\n" +
    "                            <label for=\"password\"><span translate=\"BM.Login.ResetPassword.NewPassword\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                            <input class=\"form-control\" type=\"password\" id=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"vm.newPassword\" ng-change=\"vm.validatePassword()\" ng-model-options=\"{ allowInvalid: true }\" ng-focus=\"vm.enterNewPasswordField()\" autofocus required password-validator/>\n" +
    "                            <span class=\"input-group-btn\">\n" +
    "                                <!-- use anchor tag for firefox functionality -->\n" +
    "                                <a tabindex=\"-1\" class=\"btn btn-default\" role=\"button\">\n" +
    "                                    <i\n" +
    "                                        uib-popover-template=\"vm.popover.templateUrl\"\n" +
    "                                        popover-is-open=\"vm.passwordHelpPopoverOpen\"\n" +
    "                                        tabindex=\"-1\"\n" +
    "                                        popover-placement=\"right\"\n" +
    "                                        class=\"bento-icon-question\">\n" +
    "                                    </i>\n" +
    "                                </a>\n" +
    "                            </span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"form-group\">\n" +
    "                        <label for=\"confirm\"><span translate=\"BM.Registration.ConfirmPass\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                        <input type=\"password\" class=\"form-control\" id=\"confirm\" name=\"confirm\" ng-model=\"vm.confirmPassword\" required autocomplete=\"off\" />\n" +
    "                    </div>\n" +
    "                    <div class=\"bm-btn-signin-wrap\">\n" +
    "                        <button type=\"submit\" class=\"btn btn-primary bm-btn-signin\" id=\"sign-in\" ng-click=\"vm.submit()\" translate=\"bm.login.changePasswordButton\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                        <span ng-show=\"vm.error.noMatch\" translate=\"BM.Login.ResetPassword.PasswordsDoNotMatch\"></span>\n" +
    "                        <span ng-show=\"vm.error.provideRequired\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "                        <span ng-show=\"vm.error.resetError\" translate=\"BM.Login.ResetPassword.ErrorOccurredResetPassword\"></span>\n" +
    "                        <span ng-show=\"vm.error.resetErrorInfo\" translate=\"BM.Login.ResetPassword.containsUserInfo\"></span>\n" +
    "                        <span ng-show=\"vm.error.usedPrevious\" translate=\"BM.Login.ResetPassword.PasswordUsedPreviously\"></span>\n" +
    "                        <span ng-show=\"vm.error.provideValid\" translate=\"BM.Login.ResetPassword.ProvideValidPassword\"></span>\n" +
    "                        <span ng-show=\"vm.error.prohibitedCharacters\">{{vm.rules.prohibitedCharacterRule.label}}: {{vm.prohibitedChars.join(', ')}}</span>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "        </main>\n" +
    "        <footer>\n" +
    "                <div ng-if=\"vm.productName === 'samba'\" class=\"cityscape-image\"></div>\n" +
    "                <div class=\"footer-content-wrapper\">\n" +
    "                    <div class=\"bento-footer\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "        </footer>\n" +
    "    </div>\n" +
    "</ng-container>\n" +
    "\n" +
    "<ng-container ng-show=\"isARLoginOB\">\n" +
    "    <main>\n" +
    "        <div class=\"container ar text-center\">\n" +
    "            <div class=\"row\">\n" +
    "                <div  class=\" col-md-offset-4 col-md-4 product-title\">\n" +
    "                    <div translate=\"bm.login.employeePortalProductName\"></div>\n" +
    "                    <div class=\"bm-product-name\" ng-bind=\"vm.getViewTitle()\" ng-if=\"vm.productName !== 'samba'\"></div>\n" +
    "                    <h1 class=\"product-subtitle-forgot\" translate=\"bm.login.changePasswordTitle\"></h1>\n" +
    "                    <div class=\"product-subtitle\" translate=\"bm.login.enterPasswordInstructions\" ng-if=\"!vm.requiredChange\"></div>\n" +
    "                    <div class=\"product-subtitle\" translate=\"BM.Login.ResetPassword.Instructions\" ng-if=\"vm.requiredChange\"></div>\n" +
    "                    <form role=\"form\" name=\"vm.changePasswordForm\" novalidate>\n" +
    "                        <div class=\"col-md-offset-1 col-md-10 form-group text-left\">                        \n" +
    "                            <div class=\"row form-ar\">\n" +
    "                                <label class=\"label-ar-forgot\" for=\"password\"><span translate=\"BM.Login.ResetPassword.NewPassword\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                                <input class=\"form-control input-ar-forgot\" type=\"password\" id=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"vm.newPassword\" ng-change=\"vm.validatePassword()\" ng-model-options=\"{ allowInvalid: true }\" ng-focus=\"vm.enterNewPasswordField()\" autofocus required password-validator/>\n" +
    "                            </div>\n" +
    "                            <div class=\"row form-ar\">\n" +
    "                                <label class=\"label-ar-forgot\" for=\"confirm\" ng-if=\"vm.requiredChange\"><span translate=\"BM.Registration.ConfirmPass\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                                <label class=\"label-ar-forgot\" for=\"confirm\" ng-if=\"!vm.requiredChange\"><span translate=\"BM.Login.ResetPassword.ConfirmPassword\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                                <input type=\"password\" class=\"form-control input-ar-forgot\" id=\"confirm\" name=\"confirm\" ng-model=\"vm.confirmPassword\" required autocomplete=\"off\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"bm-btn-signin-wrap\">\n" +
    "                            <button type=\"submit\" class=\"btn btn-ar mt\" id=\"sign-in\" ng-click=\"vm.submit()\" translate=\"bm.login.changePasswordButton\">\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                        <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                            <span ng-show=\"vm.error.noMatch\" translate=\"BM.Login.ResetPassword.PasswordsDoNotMatch\"></span>\n" +
    "                            <span ng-show=\"vm.error.provideRequired\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "                            <span ng-show=\"vm.error.resetError\" translate=\"BM.Login.ResetPassword.ErrorOccurredResetPassword\"></span>\n" +
    "                            <span ng-show=\"vm.error.resetErrorInfo\" translate=\"BM.Login.ResetPassword.containsUserInfo\"></span>\n" +
    "                            <span ng-show=\"vm.error.usedPrevious\" translate=\"BM.Login.ResetPassword.PasswordUsedPreviously\"></span>\n" +
    "                            <span ng-show=\"vm.error.provideValid\" translate=\"BM.Login.ResetPassword.ProvideValidPassword\"></span>\n" +
    "                            <span ng-show=\"vm.error.prohibitedCharacters\">{{vm.rules.prohibitedCharacterRule.label}}: {{vm.prohibitedChars.join(', ')}}</span>\n" +
    "                        </div>\n" +
    "                    </form>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </main>\n" +
    "    <div class=\"footer-employee\">\n" +
    "        <div class=\"container\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 left\">\n" +
    "                </div>\n" +
    "                <div class=\"col-md-auto txt-message text-left\">\n" +
    "                    <p>&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                    <div class=\"txt-message\">\n" +
    "                        <bm-privacy-policy-link ></bm-privacy-policy-link>\n" +
    "                      </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-container>\n" +
    "\n" +
    "");
}]);

angular.module("forgot-password/provide-email.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("forgot-password/provide-email.2js.html",
    "<ng-container ng-show=\"!isARLoginOB\">\n" +
    "    <div class=\"bm-flex-wrap bm-{{vm.productName}} bm-{{vm.backgroundName}}-back\">\n" +
    "        <main>\n" +
    "            <div class=\"bm-login-content-box smb-reset-password\" ng-class=\"{'smb-reset-confirm': vm.confirmed}\">\n" +
    "                <div ng-if=\"vm.productName === 'samba'\" class=\"onbalance-header-container\">\n" +
    "                    <!--Only display onbalance branding if name is samba -->\n" +
    "                    <div class=\"onbalance-brand\">\n" +
    "                        <div class=\"bm-thomsonreuters\"></div>\n" +
    "                        <div class=\"onbalance-product-name\">ONBALANCE<sup>TM</sup></div>\n" +
    "                    </div>                \n" +
    "                    <h1  class=\"onbalance-login-view-title\" ng-show=\"!vm.sentPasswordRest\" translate=\"BM.Login.Form.ForgotPassword\"></h1>\n" +
    "                    <span  class=\"onbalance-forgot-password-message\" ng-show=\"!vm.sentPasswordRest\" translate=\"BM.Login.sambaForgotPasswordMessage\"></span>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.productName !== 'samba'\">\n" +
    "                    <div class=\"bm-product-name\" ng-bind=\"vm.getViewTitle()\" ng-if=\"vm.productName !== 'samba'\"></div>\n" +
    "                    <h1 ng-if=\"vm.productName !== 'samba'\" class=\"bm-login-view-title\" translate=\"bm.login.forgotPasswordTitle\"></h1>\n" +
    "                </div>\n" +
    "                <form role=\"form\" name=\"vm.provideEmailForm\" class=\"css-form bm-login-form\" novalidate ng-if=\"!vm.confirmed\">\n" +
    "                    <div ng-if=\"vm.productName === 'samba'\" ng-show=\"!vm.sentPasswordRest\" class=\"onbalance-form-group\">\n" +
    "                        <div class=\"form-group-wrapper\">\n" +
    "                            <label for=\"uid\" class=\"onbalance-enter-instructions\" translate=\"bm.login.sambaEmailLabel\"></label>\n" +
    "                            <input type=\"email\" class=\"form-control\" id=\"uid\" name=\"uid\" ng-model=\"vm.email\" required maxlength=\"255\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.productName !== 'samba'\" class=\"form-group\">\n" +
    "                            <label for=\"uid\" class=\"bm-enter-instructions\" translate=\"bm.login.enterEmailInstructions\"></label>\n" +
    "                            <input type=\"email\" class=\"form-control\" id=\"uid\" name=\"uid\" ng-model=\"vm.email\" required maxlength=\"255\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "                    </div>\n" +
    "                    <div class=\"bm-btn-signin-wrap\">\n" +
    "                        <button ng-if=\"vm.productName !== 'samba'\" type=\"submit\" class=\"btn btn-primary bm-btn-signin\" id=\"sign-in\" ng-click=\"vm.doResetAction()\" translate=\"BM.Login.ResetPassword\">\n" +
    "                        </button>\n" +
    "                        <button ng-if=\"vm.productName === 'samba'\" ng-show=\"!vm.sentPasswordRest\" type=\"submit\" class=\"btn btn-primary bm-btn-signin onbalance-btn\" id=\"sign-in\" ng-click=\"vm.doResetAction()\" translate=\"BM.Login.sambaResetPasswordButton\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                        <span ng-show=\"vm.error.incomplete\" translate=\"BM.Components.EnterValidEmailError\"></span>\n" +
    "                        <span ng-show=\"vm.error.verifyFailed\" translate=\"BM.Login.VerifyEmailError\"></span>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "                <div ng-if=\"vm.confirmed && vm.productName !== 'samba'\" class=\"bm-email-reset-confirm\">{{vm.confirmedMessage}}</div>\n" +
    "                <div ng-if=\"vm.confirmed && vm.productName === 'samba'\" ng-show=\"vm.sentPasswordRest\" class=\"onbalance-reset-confirm\"> \n" +
    "                    <div class=\"onbalance-sent-email-container\">\n" +
    "                        <div class=\"onbalance-checkmark-container\">\n" +
    "                            <img class=\"onbalance-checkmark\">\n" +
    "                        </div>\n" +
    "                        <div class=\"onbalance-sent-email\" translate=\"BM.Login.sambaSentEmail\"></div>\n" +
    "                    </div>\n" +
    "                    <div class=\"onbalance-reset-message\" translate=\"BM.Login.sambaResetMessage\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.productName !== 'samba'\" class=\"bottom-links\">\n" +
    "                    <div>\n" +
    "                        <a ui-sref=\"main\" translate=\"bm.login.backToSignIn\" class=\"bm-samba-register\"></a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.productName === 'samba'\" class=\"onbalance-bottom-links\">\n" +
    "                        <div ng-show=\"!vm.sentPasswordRest\">\n" +
    "                            <a ui-sref=\"main\" translate=\"bm.login.backToSignIn\" class=\"bm-samba-register\"></a>\n" +
    "                        </div>\n" +
    "                        <div ng-show=\"vm.sentPasswordRest\">\n" +
    "                            <button ui-sref=\"main\" translate=\"bm.login.backToSignIn\" class=\"btn btn-primary bm-btn-signin onbalance-reset-btn\"></button>\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "                    \n" +
    "            </div>\n" +
    "        </main>\n" +
    "        <footer>\n" +
    "            <div ng-if=\"vm.productName === 'samba'\" class=\"cityscape-image\"></div>\n" +
    "            <div class=\"footer-content-wrapper\">\n" +
    "                <div class=\"bento-footer\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            </footer>\n" +
    "        </footer>\n" +
    "    </div>\n" +
    "</ng-container>\n" +
    "\n" +
    "<!-- Registration for Argentina -->\n" +
    "<ng-container ng-show=\"isARLoginOB\" >\n" +
    "    <main class=\"container ar text-center\">\n" +
    "        <div class=\"row\">\n" +
    "            <div  class=\" col-md-offset-4 col-md-4 product-title\">                \n" +
    "                <div translate=\"bm.login.employeePortalProductName\"></div>\n" +
    "                <h1  class=\"product-subtitle-forgot\" ng-show=\"!vm.sentPasswordRest\" translate=\"BM.Login.Form.ForgotPassword\"></h1>\n" +
    "                <span  class=\"product-subtitle\" ng-show=\"!vm.sentPasswordRest\" translate=\"BM.Login.sambaForgotPasswordMessage\"></span>\n" +
    "                <form role=\"form\" name=\"vm.provideEmailForm\" novalidate ng-if=\"!vm.confirmed\">\n" +
    "                    <div ng-show=\"!vm.sentPasswordRest\" class=\"col-md-offset-1 col-md-10 form-group text-left\">\n" +
    "                        <div class=\"row form-ar\">\n" +
    "                            <label for=\"uid\" class=\"label-ar-forgot\" translate=\"bm.login.sambaEmailLabel\"></label>\n" +
    "                            <input type=\"email\" class=\"form-control input-ar-forgot\" id=\"uid\" name=\"uid\" ng-model=\"vm.email\" required maxlength=\"255\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row form-ar\">\n" +
    "                        <button ng-show=\"!vm.sentPasswordRest\" type=\"submit\" class=\"btn btn-ar mt\" id=\"sign-in\" ng-click=\"vm.doResetAction()\" translate=\"BM.Login.sambaResetPasswordButton\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                        <span ng-show=\"vm.error.incomplete\" translate=\"BM.Components.EnterValidEmailError\"></span>\n" +
    "                        <span ng-show=\"vm.error.verifyFailed\" translate=\"BM.Login.VerifyEmailError\"></span>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "                <div ng-show=\"vm.sentPasswordRest\" > \n" +
    "                    <div>\n" +
    "                        <img class=\"employee-portal-checkmark\">\n" +
    "                        <div class=\"onbalance-sent-email\" translate=\"BM.Login.sambaSentEmail\"></div>\n" +
    "                    </div>\n" +
    "                    <div class=\"send-mail\" translate=\"BM.Login.sambaResetMessage\">\n" +
    "                    </div>\n" +
    "\n" +
    "                    \n" +
    "                </div>\n" +
    "                <div class=\"back-login\">\n" +
    "                        <div ng-show=\"!vm.sentPasswordRest\">\n" +
    "                            <a ui-sref=\"main\" translate=\"bm.login.backToSignIn\" class=\"back-login\"></a>\n" +
    "                        </div>\n" +
    "                        <div ng-show=\"vm.sentPasswordRest\">\n" +
    "                            <button ui-sref=\"main\" translate=\"bm.login.backToSignIn\" class=\"btn btn-ar mt\"></button>\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "                \n" +
    "        </div>\n" +
    "    </main>\n" +
    "    <div class=\"footer-employee\">\n" +
    "        <div class=\"container\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 left\">\n" +
    "                </div>\n" +
    "                <div class=\"col-md-auto txt-message text-left\">\n" +
    "                    <p>&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                    <div class=\"txt-message\">\n" +
    "                        <bm-privacy-policy-link ></bm-privacy-policy-link>\n" +
    "                      </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-container>\n" +
    "\n" +
    "");
}]);

angular.module("main/main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/main.2js.html",
    "<div class=\"bm-flex-wrap bm-{{vm.productName}} bm-{{vm.backgroundName}}-back\">\n" +
    "    <main>\n" +
    "        <div id=\"bm-login-content-box-main\" class=\"bm-login-content-box\" ng-class=\"{'login': !vm.expiredTrial, 'ar_employee_portal_auth0': vm.isArEmployeePortal}\">\n" +
    "            <expired-trial allow-extend=\"vm.allowExtend\" ng-if=\"vm.expiredTrial\"></expired-trial>\n" +
    "            <onvio-login class=\"bm-login-wrap\" product=\"vm.loadedProduct\" logout=\"{{vm.isLogout}}\"\n" +
    "                ng-if=\"!vm.expiredTrial\"></onvio-login>\n" +
    "        </div>\n" +
    "    </main>\n" +
    "    <!-- hide footer here instead of css so doesn't end up in dom -->\n" +
    "    <footer ng-if=\"vm.hasFooter()\">\n" +
    "        <div bm-if-has-no-access=\"ARLoginOB\" ng-if=\"vm.productName === 'samba'\" class=\"cityscape-image\"></div>\n" +
    "\n" +
    "        <!-- Common footer -->\n" +
    "        <div bm-if-has-no-access=\"ARLoginOB\" class=\"footer-content-wrapper\">\n" +
    "            <div class=\"bento-footer\">\n" +
    "                <div class=\"bento-footer-logo TR-footer-logo\">\n" +
    "                    <div class=\"TR-logoWhite--horizontal\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-fine-prints\">\n" +
    "                    <div class=\"footer-fine-prints-content\">\n" +
    "                        <div ng-if=\"vm.productName !== 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.CopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.productName === 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <p bm-if-has-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                translate=\"BM.Login.Common.MyPayCopyrightNotice\"></p>\n" +
    "                    </div>\n" +
    "                    <div class=\"bento-footer-copyright-links\">\n" +
    "                        <bm-privacy-policy-link></bm-privacy-policy-link>\n" +
    "                        <a ng-if=\"vm.productName !== 'samba'\" ng-href=\"{{vm.contactEmail}}\"\n" +
    "                            translate=\"BM.Login.Common.ContactUs\"></a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-options\" ng-if=\"vm.hasLangSwitch\">\n" +
    "                    <i class=\"bento-icon-earth\"></i>\n" +
    "                    <div uib-dropdown class=\"bento-dropdown dropdown-menu-right dropup\">\n" +
    "                        <button uib-dropdown-toggle class=\"btn btn-default\">\n" +
    "                            <span>{{selectedLanguage}}</span>\n" +
    "                            <i class=\"bento-icon-caret-down\"></i>\n" +
    "                        </button>\n" +
    "                        <div class=\"dropdown-menu\" uib-dropdown-menu>\n" +
    "                            <ul class=\"dropdown-scroll\">\n" +
    "                                <li ng-repeat=\"language in vm.languageList\"><a\n" +
    "                                        ng-click=\"vm.setLanguage(language)\">{{language.description}}</a></li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Footer for Argentina without Auth0 -->\n" +
    "        <div bm-if-has-access-every=\"['ARLoginOB','Platform_DisableAuth0Phase2']\" class=\"footer-content-wrapper footer-ar\">\n" +
    "            <div class=\"bento-footer footer-ar\">\n" +
    "                <div class=\"bento-footer-logo TR-footer-logo-ar\">\n" +
    "                    <div class=\"TR-logoWhite--horizontal\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-fine-prints\">\n" +
    "                    <div class=\"footer-fine-prints-content-ar\">\n" +
    "                        <div ng-if=\"vm.productName !== 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.CopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.productName === 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <p bm-if-has-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                translate=\"BM.Login.Common.MyPayCopyrightNotice\"></p>\n" +
    "                    </div>\n" +
    "                    <div class=\"bento-footer-copyright-links\">\n" +
    "                        <bm-privacy-policy-link></bm-privacy-policy-link>\n" +
    "                        <a ng-if=\"vm.productName !== 'samba'\" ng-href=\"{{vm.contactEmail}}\"\n" +
    "                            translate=\"BM.Login.Common.ContactUs\"></a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-options\" ng-if=\"vm.hasLangSwitch\">\n" +
    "                    <i class=\"bento-icon-earth\"></i>\n" +
    "                    <div uib-dropdown class=\"bento-dropdown dropdown-menu-right dropup\">\n" +
    "                        <button uib-dropdown-toggle class=\"btn btn-default\">\n" +
    "                            <span>{{selectedLanguage}}</span>\n" +
    "                            <i class=\"bento-icon-caret-down\"></i>\n" +
    "                        </button>\n" +
    "                        <div class=\"dropdown-menu\" uib-dropdown-menu>\n" +
    "                            <ul class=\"dropdown-scroll\">\n" +
    "                                <li ng-repeat=\"language in vm.languageList\"><a\n" +
    "                                        ng-click=\"vm.setLanguage(language)\">{{language.description}}</a></li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Footer for Argentina with Auth0 -->\n" +
    "        <div ng-show=\"vm.isArEmployeePortal\" bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" class=\"footer-content-wrapper\">\n" +
    "            <div class=\"bento-footer\">\n" +
    "                <div class=\"bento-footer-logo TR-footer-logo\">\n" +
    "                    <div class=\"TR-logoWhite--horizontal\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-fine-prints\">\n" +
    "                    <div class=\"footer-fine-prints-content\">\n" +
    "                        <div ng-if=\"vm.productName !== 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.CopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.productName === 'samba'\">\n" +
    "                            <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                    translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                        </div>\n" +
    "                        <p bm-if-has-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span\n" +
    "                                translate=\"BM.Login.Common.MyPayCopyrightNotice\"></p>\n" +
    "                    </div>\n" +
    "                    <div class=\"bento-footer-copyright-links\">\n" +
    "                        <bm-privacy-policy-link></bm-privacy-policy-link>\n" +
    "                        <a ng-if=\"vm.productName !== 'samba'\" ng-href=\"{{vm.contactEmail}}\"\n" +
    "                            translate=\"BM.Login.Common.ContactUs\"></a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-options\" ng-if=\"vm.hasLangSwitch\">\n" +
    "                    <i class=\"bento-icon-earth\"></i>\n" +
    "                    <div uib-dropdown class=\"bento-dropdown dropdown-menu-right dropup\">\n" +
    "                        <button uib-dropdown-toggle class=\"btn btn-default\">\n" +
    "                            <span>{{selectedLanguage}}</span>\n" +
    "                            <i class=\"bento-icon-caret-down\"></i>\n" +
    "                        </button>\n" +
    "                        <div class=\"dropdown-menu\" uib-dropdown-menu>\n" +
    "                            <ul class=\"dropdown-scroll\">\n" +
    "                                <li ng-repeat=\"language in vm.languageList\"><a\n" +
    "                                        ng-click=\"vm.setLanguage(language)\">{{language.description}}</a></li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </footer>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration-smb/registration-smb-linked.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration-smb/registration-smb-linked.2js.html",
    "<div ng-show=\"!isARLoginOB\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-3 form-group\" ng-class=\"{ 'has-error': vm.errorLinking !== '' }\">\n" +
    "            <h2 translate=\"Enter Password\"></h2>\n" +
    "            <label for=\"password\" translate=\"Password\"></label>:\n" +
    "            <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"vm.model.password\" required maxlength=\"50\" />\n" +
    "            <a id=\"bmlogin-loginform-forgotpwd-link\" ng-href=\"\" data-qe-id=\"bmlogin-loginform-forgotpwd-link\" ng-click=\"vm.openForgottenPasswordDialog()\" translate=\"BM.Login.Form.ForgotPassword\"></a>\n" +
    "            <div id=\"msgs\" ng-show=\"vm.errorLinking\" class=\"msg\">\n" +
    "                <span ng-show=\"vm.errorLinking.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "                <span ng-show=\"vm.errorLinking.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-show=\"isARLoginOB\">\n" +
    "    <div class=\"row form-ar\">\n" +
    "        <div class=\"col-md-offset-1 col-md-10 form-group text-left\" ng-class=\"{ 'has-error': vm.errorLinking !== '' }\">\n" +
    "            <h2 translate=\"Enter Password\" class=\"title-ar\"></h2>\n" +
    "            <label class=\"label-ar\" for=\"password\" translate=\"Password\"></label>:\n" +
    "            <input type=\"password\" class=\"form-control input-ar\" id=\"pwd\" name=\"pwd\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"vm.model.password\" required maxlength=\"50\" />\n" +
    "            <a class=\"forgot-pswd-ar\" id=\"bmlogin-loginform-forgotpwd-link\" ng-href=\"\" data-qe-id=\"bmlogin-loginform-forgotpwd-link\" ng-click=\"vm.openForgottenPasswordDialog()\" translate=\"BM.Login.Form.ForgotPassword\"></a>\n" +
    "            <div id=\"msgs\" ng-show=\"vm.errorLinking\" class=\"msg\">\n" +
    "                <span ng-show=\"vm.errorLinking.invalid\" translate=\"BM.Login.Directive.Error.InvalidSignIn\"></span>\n" +
    "                <span ng-show=\"vm.errorLinking.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration-smb/registration-smb-new.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration-smb/registration-smb-new.2js.html",
    "<div  ng-show=\"!isARLoginOB\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-6 form-group\" ng-class=\"{ 'has-error': vm.newPasswordError !== '' }\">\n" +
    "                <h2 translate=\"Enter Password\"></h2>\n" +
    "                <label for=\"newPassword\" translate=\"Registration.Password.field.newPassword\"></label>\n" +
    "                <input class=\"form-control\" id=\"newPassword\" name=\"newPassword\"\n" +
    "                ng-model=\"vm.model.newPassword\" ng-blur=\"newPasswordFocus=false; vm.validatePassword(false);\"\n" +
    "                ng-focus=\"newPasswordFocus=true\" required maxlength=\"50\" type=\"password\"/>\n" +
    "                <div class=\"msg\">{{ vm.newPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.newPasswordError === '' && vm.passwordIsValidated\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"Registration.Password.passwordAcceptable\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"bm-password-validation\" ng-show=\"newPasswordFocus\">\n" +
    "                    <span translate=\"Registration.Password.mustHaveStart\"></span>\n" +
    "                    <span class=\"{{vm.rules.characterLengthRule.test(vm.model.newPassword) ? 'passing' : 'failing-required'}}\" translate=\"Registration.Password.characterRule\" translate-value-val=\"{{vm.charLengthReq}}\"></span> <span translate=\"Registration.Password.mustHaveEnd\" translate-value-val=\"{{vm.charClassReq}}\"></span>\n" +
    "                    <ul>\n" +
    "                        <div ng-repeat=\"rule in vm.rules.characterTypeRules\">\n" +
    "                            <li class=\"{{ rule.test(vm.model.newPassword) ? 'passing' : 'failing-optional' }}\">{{ rule.label }}</li>\n" +
    "                        </div>\n" +
    "                    </ul>\n" +
    "                    <p/>\n" +
    "                    <span translate=\"Registration.Validations.excludeTitle\"></span>\n" +
    "                        <ul>\n" +
    "                        <li translate=\"Registration.Validations.excludeWords\"></li>\n" +
    "                        <li translate=\"Registration.Validations.excludeUserId\"></li>\n" +
    "                        <li translate=\"Registration.Validations.excludeSequential\"></li>\n" +
    "                        </ul>\n" +
    "                </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-6 form-group\" ng-class=\"{ 'has-error': vm.confirmPasswordError !== '' }\">\n" +
    "            <label for=\"confirmPassword\" translate=\"Registration.Password.field.confirmPassword\"></label>\n" +
    "            <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.model.confirmPassword\" ng-blur=\"vm.setConfirmPasswordOutOfFocus(); validateConfirmPassword(false);\" ng-focus=\"vm.setConfirmPasswordInFocus()\" maxlength=\"50\" type=\"password\"/>\n" +
    "            <div ng-show=\"!vm.confirmIsValidated\" class=\"msg\">{{ vm.confirmPasswordError }}</div>\n" +
    "            <div class=\"bm-msg-valid\" ng-show=\"vm.confirmIsValidated\">\n" +
    "            <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "            <span translate=\"Registration.Password.passwordConfirmed\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-show=\"isARLoginOB\">\n" +
    "    <div class=\"row form-ar\">      \n" +
    "        <div class=\"col-md-offset-1 col-md-10 form-group text-left\" ng-class=\"{ 'has-error': vm.newPasswordError !== '' }\">\n" +
    "                <h2 translate=\"Enter Password\" class=\"title-ar\"></h2>\n" +
    "                <label class=\"label-ar\" for=\"newPassword\" translate=\"Registration.Password.field.newPassword\"></label>\n" +
    "                <input class=\"form-control input-ar\" id=\"newPassword\" name=\"newPassword\"\n" +
    "                ng-model=\"vm.model.newPassword\" ng-blur=\"newPasswordFocus=false; vm.validatePassword(false);\"\n" +
    "                ng-focus=\"newPasswordFocus=true\" required maxlength=\"50\" type=\"password\"/>\n" +
    "                <div class=\"msg\">{{ vm.newPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.newPasswordError === '' && vm.passwordIsValidated\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"Registration.Password.passwordAcceptable\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"bm-password-validation\" ng-show=\"newPasswordFocus\">\n" +
    "                    <span translate=\"Registration.Password.mustHaveStart\"></span>\n" +
    "                    <span class=\"{{vm.rules.characterLengthRule.test(vm.model.newPassword) ? 'passing' : 'failing-required'}}\" translate=\"Registration.Password.characterRule\" translate-value-val=\"{{vm.charLengthReq}}\"></span> <span translate=\"Registration.Password.mustHaveEnd\" translate-value-val=\"{{vm.charClassReq}}\"></span>\n" +
    "                    <ul>\n" +
    "                        <div ng-repeat=\"rule in vm.rules.characterTypeRules\">\n" +
    "                            <li class=\"{{ rule.test(vm.model.newPassword) ? 'passing' : 'failing-optional' }}\">{{ rule.label }}</li>\n" +
    "                        </div>\n" +
    "                    </ul>\n" +
    "                    <span translate=\"Registration.Validations.excludeTitle\"></span>\n" +
    "                        <ul>\n" +
    "                        <li translate=\"Registration.Validations.excludeWords\"></li>\n" +
    "                        <li translate=\"Registration.Validations.excludeUserId\"></li>\n" +
    "                        <li translate=\"Registration.Validations.excludeSequential\"></li>\n" +
    "                        </ul>\n" +
    "                </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row form-ar\">\n" +
    "        <div class=\"col-md-offset-1 col-md-10 form-group text-left\" ng-class=\"{ 'has-error': vm.confirmPasswordError !== '' }\">\n" +
    "            <label class=\"label-ar\" for=\"confirmPassword\" translate=\"Registration.Password.field.confirmPassword\"></label>\n" +
    "            <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.model.confirmPassword\" ng-blur=\"vm.setConfirmPasswordOutOfFocus(); validateConfirmPassword(false);\" ng-focus=\"vm.setConfirmPasswordInFocus()\" maxlength=\"50\" type=\"password\"/>\n" +
    "            <div ng-show=\"!vm.confirmIsValidated\" class=\"msg\">{{ vm.confirmPasswordError }}</div>\n" +
    "            <div class=\"bm-msg-valid\" ng-show=\"vm.confirmIsValidated\">\n" +
    "            <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "            <span translate=\"Registration.Password.passwordConfirmed\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("registration-smb/registration.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration-smb/registration.2js.html",
    "<div ng-show=\"!isARLoginOB\">\n" +
    "    <div id=\"link-registration\" class=\"bento-container\" bento-busy-loader=\"vm.isLoaderBusy\">\n" +
    "        <div class=\"registration-body col-md-10\">\n" +
    "            <div id=\"moduleHeader\" translate=\"BM.RegisterAccount.Header\"></div>\n" +
    "            <h2 translate=\"BM.Registration.AccountInformationHeader\"></h2>\n" +
    "            <div class=\"info-banner\" ng-if=\"vm.accountExists\">\n" +
    "                <i class=\"bento-icon-info\"></i>\n" +
    "                <span translate=\"BM.Registration.EmailAlreadyRegistered\"></span>\n" +
    "            </div>\n" +
    "            <div translate=\"Name\"></div>\n" +
    "            <p><span>{{vm.model.firstName}}</span> <span>{{vm.model.lastName}}</span></p>\n" +
    "            <div translate=\"Login Email Address\"></div>\n" +
    "            <p>{{vm.model.email}}</p>\n" +
    "            <div ng-if=\"vm.accountExists\">\n" +
    "                <p translate=\"To use this email address to access all your accounts, enter your password and click Link Accounts. To access this account with a different email address, click Change Email Address.\">\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    <a href=\"/ua/help/us-en/client/core/common/manage-linked-accounts.htm\" translate=\"Learn more about linking accounts.\" target=\"_blank\"></a>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "            <form id=\"vm.formRegistration\" name=\"vm.formRegistration\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "                <div ng-if=\"vm.accountExists\" ng-include=\"'registration-smb/registration-smb-linked.2js.html'\"></div>\n" +
    "                <div ng-if=\"!vm.accountExists\" ng-include=\"'registration-smb/registration-smb-new.2js.html'\"></div>\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-12\">\n" +
    "                        <hr>\n" +
    "                        <button ng-click=\"vm.completeRegistration()\" class=\"btn btn-primary\" ng-class=\"vm.accountExists ? link-acct-btn : ''\">\n" +
    "                            <i ng-if=\"vm.accountExists\" class=\"bento-icon-link\"></i>\n" +
    "                            <span>{{vm.accountExists ? 'Link Accounts' : 'Register Me' | translate }}</span>\n" +
    "                        </button>\n" +
    "                        <button ng-if=\"vm.accountExists\" id=\"bm-change-email-btn\" ng-click=\"vm.openChangeEmailModal()\" class=\"btn btn-secondary\" translate=\"Change Email Address\"></button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Registration for Argentina -->\n" +
    "<div ng-show=\"isARLoginOB\" class=\"container ar text-center\">\n" +
    "\n" +
    "    <div id=\"link-registration\" >\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-offset-3 col-md-6 product-title\">\n" +
    "                <div translate=\"bm.login.employeePortalProductName\"></div>\n" +
    "                <div id=\"moduleHeader\" translate=\"BM.RegisterAccount.Header\"></div>\n" +
    "                <div class=\"info-banner-ar\" ng-if=\"vm.accountExists\">\n" +
    "                    <i class=\"bento-icon-info\"></i>\n" +
    "                    <span translate=\"BM.Registration.EmailAlreadyRegistered\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"name-email\">\n" +
    "                    <p>{{ 'Name' | translate}}: <span>{{vm.model.firstName}}</span> <span>{{vm.model.lastName}}</span></br>\n" +
    "                    {{ 'Login Email Address' | translate }}: <span>{{vm.model.email}}</span></p>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.accountExists\" class=\"txt-message-ar\">\n" +
    "                    <p translate=\"To use this email address to access all your accounts, enter your password and click Link Accounts. To access this account with a different email address, click Change Email Address.\">\n" +
    "                    </p>\n" +
    "                    <p>\n" +
    "                        <a href=\"/ua/help/us-en/client/core/common/manage-linked-accounts.htm\" translate=\"Learn more about linking accounts.\" target=\"_blank\"></a>\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "                <form id=\"vm.formRegistration\" name=\"vm.formRegistration\" role=\"form\" novalidate>\n" +
    "                    <div ng-if=\"vm.accountExists\" ng-include=\"'registration-smb/registration-smb-linked.2js.html'\"></div>\n" +
    "                    <div ng-if=\"!vm.accountExists\" ng-include=\"'registration-smb/registration-smb-new.2js.html'\"></div>\n" +
    "                    <div class=\"col-md-offset-1 checkbox-ar text-left\">\n" +
    "                        <input type=\"checkbox\" name=\"termsEmployeePortalAccepted\" ng-model=\"termsChecked\">\n" +
    "                        <span translate=\"bm.registration.AcceptTerms\"></span>\n" +
    "                        <a href=\"{{termsUri}}\" target='_blank' translate=\"bm.registration.TermsOfUseEmployeePortal\"></a><br>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div>\n" +
    "                            <button ng-disabled=\"!termsChecked\" ng-click=\"vm.completeRegistration()\" class=\"btn btn-ar\" ng-class=\"vm.accountExists ? link-acct-btn : ''\">\n" +
    "                                <i ng-if=\"vm.accountExists\" class=\"bento-icon-link\"></i>\n" +
    "                                <span>{{vm.accountExists ? 'Link Accounts' : 'Register Me' | translate }}</span>\n" +
    "                            </button>\n" +
    "                            <button ng-disabled=\"!termsChecked\" ng-if=\"vm.accountExists\" id=\"bm-change-email-btn\" ng-click=\"vm.openChangeEmailModal()\" class=\"btn btn-ar\" translate=\"Change Email Address\"></button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class=\"footer-employee\">\n" +
    "        <div class=\"container\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 left\">\n" +
    "                </div>\n" +
    "                <div class=\"col-md-auto txt-message text-left\">\n" +
    "                    <p>&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                    <div class=\"txt-message\">\n" +
    "                        <bm-privacy-policy-link ></bm-privacy-policy-link>\n" +
    "                      </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration/account-info/account-info.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/account-info/account-info.2js.html",
    "<form role=\"form\" name=\"vm.acctInfoForm\" autocomplete=\"off\" class=\"css-form\" novalidate>\n" +
    "    <h2 translate=\"BM.Registration.AccountInformationHeader\"></h2>\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.acctInfoAlerts.length > 0\">\n" +
    "        <div uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.acctInfoAlerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"vm.clearAcctInfoAlert($index)\">{{alert.msg}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"row account-info-spacing\">\n" +
    "        <!-- first name -->\n" +
    "        <div class=\"col-sm-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.firstName.$invalid && vm.acctInfoForm.firstName.$touched }\">\n" +
    "                <label for=\"firstName\"><span translate=\"BM.Registration.FirstName\"></span> *</label>\n" +
    "                <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" data-qe-id=\"bmlogin-reg-firstname-input\" ng-model=\"vm.localUser.firstName\" maxlength=\"100\" required/>\n" +
    "                <div class=\"msg\" ng-messages=\"vm.acctInfoForm.firstName.$error\" ng-if=\"vm.acctInfoForm.firstName.$touched || vm.acctInfoForm.$submitted\">\n" +
    "                    <span ng-message=\"required\">{{ 'BM.Registration.FirstNameError' | translate }}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.lastName.$invalid && vm.acctInfoForm.lastName.$touched }\">\n" +
    "                <label for=\"lastName\"><span translate=\"BM.Registration.LastName\"></span> *</label>\n" +
    "                <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" data-qe-id=\"bmlogin-reg-lastname-input\" ng-model=\"vm.localUser.lastName\" maxlength=\"100\" required/>\n" +
    "                <div class=\"msg\" ng-messages=\"vm.acctInfoForm.lastName.$error\" ng-if=\"vm.acctInfoForm.lastName.$touched || vm.acctInfoForm.$submitted\">\n" +
    "                    <span ng-message=\"required\">{{ 'BM.Registration.LastNameError' | translate }}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- user id -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-3\">\n" +
    "            <div bm-if-has-access=\"PPE-AccountSwitching\" class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.userId.$invalid && vm.acctInfoForm.userId.$touched}\">\n" +
    "                <label for=\"userId\"><span translate=\"BM.Registration.EmailAddress\"></span></label>\n" +
    "                <p type=\"email\" id=\"userId\" name=\"userId\">{{vm.localUser.userId}}</p>\n" +
    "            </div>\n" +
    "            <div bm-if-has-no-access=\"PPE-AccountSwitching\" class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.userId.$invalid && vm.acctInfoForm.userId.$touched}\">\n" +
    "                <label for=\"userId\"><span translate=\"BM.Registration.EmailAddress\"></span> *</label>\n" +
    "                <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" data-qe-id=\"bmlogin-reg-uid-input\" autocomplete=\"off\" ng-model=\"vm.localUser.userId\" ng-blur=\"vm.validateUserId()\" ng-model-options=\"{ debounce: 500, blur: 0 }\" required email-validator bm-focus=\"vm.hasFocusEmail\" />\n" +
    "                <div class=\"msg\" ng-messages=\"vm.acctInfoForm.userId.$error\" ng-if=\"vm.acctInfoForm.userId.$touched || vm.acctInfoForm.$submitted\">\n" +
    "                    <span ng-message=\"required\">{{ 'BM.Login.EmailRequiredError' | translate }}</span>\n" +
    "                    <span ng-message=\"email\">{{ 'BM.Login.EnterValidEmailError' | translate }}</span>\n" +
    "                    <span ng-message=\"emailInUse\">{{ 'BM.Login.EmailInUseError' | translate }}</span>\n" +
    "                    <span ng-message=\"unableToVerifyEmail\">{{ 'BM.Login.VerifyEmailError' | translate }}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- password -->\n" +
    "    <h2 translate=\"Create Password\"></h2>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <div class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.password.$invalid && vm.acctInfoForm.password.$touched }\">\n" +
    "                        <label for=\"password\"><span translate=\"BM.Login.ResetPassword.NewPassword\"></span> *</label>\n" +
    "                        <a href class=\"pull-right no-underline\" ng-click=\"vm.showPassword = !vm.showPassword\">\n" +
    "                            <span ng-if=\"vm.showPassword == false || vm.showPassword == undefined\" translate=\"BM.Registration.ShowTyping\"></span>\n" +
    "                            <span ng-if=\"vm.showPassword == true\" translate=\"BM.Registration.HideTyping\"></span>\n" +
    "                        </a>\n" +
    "                        <input class=\"form-control\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" id=\"password\" name=\"password\" data-qe-id=\"bmlogin-reg-pwd-input\" autocomplete=\"off\" ng-model=\"vm.localUser.password\" ng-model-options=\"{ updateOn: 'default blur', allowInvalid: true }\" password-validator required maxlength=\"50\" bm-focus=\"vm.hasFocusPassword\" ng-change=\"vm.updateInvalidChars()\" ng-focus=\"vm.hasFocusPassword = true\" ng-blur=\"vm.hasFocusPassword = false\" />\n" +
    "                        <!-- password acceptable -->\n" +
    "                        <div id=\"msg-valid-password\" ng-if=\"(vm.acctInfoForm.password.$touched || vm.acctInfoForm.$submitted) && vm.acctInfoForm.password.$valid\">\n" +
    "                            <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                            <span translate=\"BM.Registration.PasswordAcceptable\"></span>\n" +
    "                        </div>\n" +
    "                        <!-- password check in progress -->\n" +
    "                        <div id=\"msg-password-pending\" ng-if=\"vm.acctInfoForm.password.$pending\" bento-busy-loader=\"vm.acctInfoForm.password.$pending\" bento-busy-loader-size=\"small\">&nbsp;</div>\n" +
    "                        <!-- password validation messages -->\n" +
    "                        <div class=\"msg\" ng-messages=\"vm.acctInfoForm.password.$error\" ng-if=\"vm.acctInfoForm.password.$invalid && !vm.acctInfoForm.password.$pending && (vm.acctInfoForm.password.$touched || vm.acctInfoForm.$submitted)\">\n" +
    "                            <span ng-message=\"required\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                            <span ng-message=\"invalidPasswordLength\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                            <span ng-message=\"invalidPasswordRules\">{{ 'BM.Login.ResetPassword.ProvideValidPassword' | translate }}</span>\n" +
    "                            <span ng-message=\"invalidPasswordCharacters\">{{ vm.passwordRules.prohibitedCharacterRule.label }} : {{vm.invalidChars.join(\", \")}} </span>\n" +
    "                            <span ng-message=\"invalidPasswordCommon\">{{ 'BM.Login.ResetPassword.PasswordTooCommon' | translate }}</span>\n" +
    "                            <span ng-message=\"invalidPasswordUsed\">{{ 'BM.Login.ResetPassword.PasswordUsedPreviously' | translate }}</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        <!-- confirm password -->\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <div class=\"form-group\" ng-class=\"{'has-error' : vm.acctInfoForm.confirmPassword.$invalid && (vm.acctInfoForm.confirmPassword.$touched || vm.acctInfoForm.confirmPassword.$dirty) }\">\n" +
    "                        <label for=\"confirmPassword\"><span translate=\"BM.Registration.ConfirmPass\"></span> *</label>\n" +
    "                        <input class=\"form-control\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" id=\"confirmPassword\" autocomplete=\"off\" name=\"confirmPassword\" data-qe-id=\"bmlogin-reg-pwdconfirm-input\" ng-model=\"vm.localUser.confirmPassword\" required maxlength=\"50\" value-compare-validator share-validate=\"vm.localUser.password\" ng-focus=\"vm.setConfirmValidity()\" ng-blur=\"vm.verifyConfirm()\" />\n" +
    "                        <!-- confirm password validation messages -->\n" +
    "                        <div class=\"msg\" ng-messages=\"vm.acctInfoForm.confirmPassword.$error\" ng-if=\"vm.acctInfoForm.confirmPassword.$touched || vm.acctInfoForm.confirmPassword.$dirty || vm.acctInfoForm.$submitted\">\n" +
    "                            <span ng-message=\"required\">{{ 'BM.Login.ResetPassword.PasswordNoData' | translate }}</span>\n" +
    "                            <span ng-message=\"invalidComparison\">{{ 'BM.Login.ResetPassword.PasswordsDoNotMatch' | translate }}</span>\n" +
    "                        </div>\n" +
    "                        <!-- confirm password acceptable -->\n" +
    "                        <div id=\"msg-valid-password\"  ng-if=\"(vm.acctInfoForm.confirmPassword.$touched || vm.acctInfoForm.confirmPassword.$dirty || vm.acctInfoForm.$submitted) && vm.acctInfoForm.confirmPassword.$valid && vm.localUser.password === vm.localUser.confirmPassword\">\n" +
    "                            <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                            <span translate=\"BM.Registration.PassConfirmedText\"></span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.requireTerms && vm.user.contextType === 'staff'\" class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    <bm-terms accepted=\"vm.termsAccepted\" language=\"vm.localUser.language\"></bm-terms>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <br>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-12\">\n" +
    "                    * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <p translate=\"Password Requirements\"></p>\n" +
    "            <!-- password validation rule display -->\n" +
    "            <div id=\"passwordvalidation\" bm-password-validation password=\"vm.localUser.password\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <hr>\n" +
    "</form>\n" +
    "");
}]);

angular.module("registration/change-registration-email/change-registration-email.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/change-registration-email/change-registration-email.2js.html",
    "<h2 translate=\"Change Email Address\"></h2>\n" +
    "<hr>\n" +
    "<form role=\"form\" ng-submit=\"changeEmail()\" name=\"acctInfoForm\" autocomplete=\"off\" class=\"css-form\" novalidate>\n" +
    "    <p translate=\"Please enter the email address you want to use with your account.\"></p>\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error' : acctInfoForm.email.$invalid && acctInfoForm.email.$touched}\">\n" +
    "        <label translate=\"BM.Login.Form.UserName\" for=\"email\"></label>: *\n" +
    "        <input\n" +
    "            class=\"form-control\"\n" +
    "            id=\"email\"\n" +
    "            name=\"email\"\n" +
    "            type=\"email\"\n" +
    "            ng-model=\"email\"\n" +
    "            required\n" +
    "        />\n" +
    "        <div class=\"msg\" ng-messages=\"acctInfoForm.email.$error\" ng-if=\"acctInfoForm.email.$touched\">\n" +
    "            <span ng-message=\"required\">{{ 'BM.Login.EmailRequiredError' | translate }}</span>\n" +
    "            <span ng-message=\"email\">{{ 'BM.Components.EnterValidEmailError' | translate }}</span>\n" +
    "        </div>\n" +
    "        <span>* </span><span translate=\"BM.Login.RequiredField\"></span>\n" +
    "        <hr>\n" +
    "        <button type=\"submit\" ng-disabled=\"acctInfoForm.email.$invalid\" class=\"btn btn-primary\" translate=\"bm.login.changePasswordButton\"></button>\n" +
    "        <button ng-click=\"dismissModal()\" class=\"btn btn-secondary\" translate=\"bm.login.common.cancel\"></button>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("registration/complete/registration-complete.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/complete/registration-complete.2js.html",
    "<div class=\"bento-container\">\n" +
    "    <div class=\"registration-body\">\n" +
    "		<div id=\"moduleHeader\" translate=\"Success! You're Done.\"></div>\n" +
    "		<h2 translate=\"BM.Registration.AccountInformationHeader\"></h2>\n" +
    "		<p translate=\"You've successfully registered your account.\"></p>\n" +
    "		<div translate=\"Name\"></div>\n" +
    "		<p><span>{{vm.user.firstName}}</span><span> {{vm.user.lastName}}</span></p>\n" +
    "		<div translate=\"BM.Login.Form.UserName\"></div>\n" +
    "		<p>{{vm.user.userId}}</p>\n" +
    "		<bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "		<bm-login-cookie-policy aria-hidden=\"true\"></bm-login-cookie-policy>\n" +
    "        <div ng-if=\"0\">\n" +
    "            <!-- temporarily remove MFA -->\n" +
    "            <div bm-if-has-access=\"Platform_Enable2FA\">\n" +
    "                <h2 translate=\"Want more security for your account?\"></h2>\n" +
    "                <p translate=\"Passwords are not as safe as you think they are. Download the Thomson Reuters' Authenticator app to your smartphone and add multi-factor authentication to increase the security of your account and require approval of each sign-in attempt from your smartphone.\"></p>\n" +
    "                <p translate=\"If your firm requires multi-factor authentication, you’ll set it up the first time you sign in. If multi-factor authentication is not required, you can enable it by updating your profile after you sign in.\"></p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "		<hr>\n" +
    "	    <button ng-click=\"vm.done()\" class=\"btn btn-primary\" translate=\"Done\"></button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration/confirmation/registration-confirmation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/confirmation/registration-confirmation.2js.html",
    "<div ng-controller=\"RegistrationConfirmationCtrl as ctrl\">\n" +
    "<div class=\"bento-container\">\n" +
    "    <h2 translate=\"Registration Confirmation redirect page\"></h2>\n" +
    "    <div class=\"row\">\n" +
    "        <div bento-busy-loader=\"isLoaderBusy\">Loader</div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration/link-registration/link-registration.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/link-registration/link-registration.2js.html",
    "<div id=\"link-registration\" class=\"bento-container\">\n" +
    "    <div class=\"registration-body col-md-10\">\n" +
    "        <div id=\"moduleHeader\" translate=\"BM.RegisterAccount.Header\"></div>\n" +
    "		<h2 translate=\"BM.Registration.AccountInformationHeader\"></h2>\n" +
    "        <div class=\"info-banner info-max-width\">\n" +
    "            <i class=\"bento-icon-info\"></i>\n" +
    "            <span translate=\"BM.Registration.EmailAlreadyRegistered\"></span>\n" +
    "        </div>\n" +
    "		<div translate=\"Name\"></div>\n" +
    "        <p><span>{{vm.user.firstName}}</span> <span>{{vm.user.lastName}}</span></p>\n" +
    "		<div translate=\"Login Email Address\"></div>\n" +
    "		<p>{{vm.user.userId}}</p>\n" +
    "		<p translate=\"To use this email address to access all your accounts, enter your password and click Link Accounts. To access this account with a different email address, click Change Email Address.\">\n" +
    "        </p>\n" +
    "        <p>\n" +
    "            <a href=\"/ua/help/{{ vm.helpLangCode }}/client/core/common/manage-linked-accounts.htm\" translate=\"Learn more about linking accounts.\" target=\"_blank\"></a>\n" +
    "        </p>\n" +
    "        <h2 translate=\"Enter Password\"></h2>\n" +
    "		<bm-account-link-auth user=\"vm.user\" product=\"vm.loadedProduct\"></bm-account-link-auth>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration/personal-id/personal-id.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/personal-id/personal-id.2js.html",
    "<form role=\"form\" name=\"vm.pinForm\" autocomplete=\"off\" class=\"css-form\" novalidate>\n" +
    "    <h2 translate=\"BM.Registration.PinHeader\"></h2>\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.pinAlerts.length > 0\">\n" +
    "        <div uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.pinAlerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"vm.clearPinAlert($index)\">\n" +
    "          {{alert.msg}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-5\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : vm.pinForm.pin.$invalid && vm.pinForm.pin.$touched}\">\n" +
    "                <label for=\"pin\">{{ vm.localUser.prompt }} *</label>\n" +
    "                <input id=\"pin\" data-qe-id=\"bmlogin-reg-pin-input\" name=\"pin\" class=\"form-control\" type=\"text\" ng-model=\"vm.localUser.pin\" ng-model-options=\"{ debounce: 200, blur: 0 }\" bm-focus=\"true\" required pin-validator />\n" +
    "                <div class=\"msg\" ng-messages=\"vm.pinForm.pin.$error\" ng-if=\"vm.pinForm.pin.$touched || vm.pinForm.$submitted\">\n" +
    "                    <span ng-message=\"required\">{{ 'bm.registration.pin.required' | translate }}</span>\n" +
    "                    <span ng-message=\"pinInvalid\">{{ 'bm.registration.pin.invalid' | translate }}</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-5\">\n" +
    "            * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("registration/security-questions/security-questions.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/security-questions/security-questions.2js.html",
    "<form name=\"vm.securityQuestionsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "	<h2 translate=\"BM.Registration.SecurityHeader\"></h2>\n" +
    "	<div class=\"bento-alert-container\" ng-if=\"vm.securityQuestionAlerts.length > 0\">\n" +
    "      <div uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.securityQuestionAlerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"vm.clearSecurityQuestionAlert($index)\">\n" +
    "          {{alert.msg}}\n" +
    "      </div>\n" +
    "  </div>\n" +
    "	<div ng-repeat=\"question in vm.localUser.questions\">\n" +
    "		<ng-form name=\"questionForm\">\n" +
    "	        <div class=\"row\">\n" +
    "	          <div class=\"col-sm-5\">\n" +
    "	            <div class=\"form-group\"ng-class=\"{'has-error' : questionForm.question.$invalid && (questionForm.question.$touched || vm.securityQuestionsForm.$submitted)}\">\n" +
    "			  		<label for=\"question\"><span translate=\"BM.Registration.SecurityQuestion\"></span> {{ $index + 1 }}*</label>\n" +
    "			      	<div bento-select>\n" +
    "			        	<select\n" +
    "			                name=\"question\"\n" +
    "			                id=\"question\"\n" +
    "                            data-qe-id=\"bmlogin-reg-secquestion-select-{{$index}}\"\n" +
    "			                class=\"form-control\"\n" +
    "			                ng-model=\"question.selectedQuestion\"\n" +
    "			                ng-options=\"masterQuestion.question for masterQuestion in question.masterList track by masterQuestion.questionId\"\n" +
    "			                ng-change=\"vm.processQuestionSelect($index)\" required>\n" +
    "			            	<option ng-disabled=\"true\" value=\"\" translate>BM.Registration.SelectSecurityQuestion</option>\n" +
    "			        	</select>\n" +
    "			      	</div>\n" +
    "					<div class=\"msg\" ng-messages=\"questionForm.question.$error\" ng-if=\"questionForm.question.$touched || vm.securityQuestionsForm.$submitted\">\n" +
    "			            <span ng-message=\"required\">{{ 'BM.Registration.SelectQuestion' | translate }}</span>\n" +
    "			    	</div>\n" +
    "	            </div>\n" +
    "	          </div>\n" +
    "	        </div>\n" +
    "	        <div class=\"row\">\n" +
    "	          <div class=\"col-sm-5\">\n" +
    "	            <div class=\"form-group\" ng-class=\"{ 'has-error': (questionForm.answer.$invalid && (questionForm.answer.$touched || vm.securityQuestionsForm.$submitted)), 'bm-form-group-pair': ($index + 1) !== vm.localUser.questions.length }\">\n" +
    "	              <label for=\"answer\"><span translate=\"BM.Registration.SecurityAnswer\"></span>*</label>\n" +
    "	              <input class=\"form-control\" type=\"text\" id=\"answer\" name=\"answer\" data-qe-id=\"bmlogin-reg-secanswer-input-{{$index}}\" ng-model=\"question.answer\" required />\n" +
    "	              <div class=\"msg\" ng-messages=\"questionForm.answer.$error\" ng-if=\"questionForm.answer.$touched || vm.securityQuestionsForm.$submitted\">\n" +
    "			            <span ng-message=\"required\">{{ 'BM.Registration.SecurityAnswerPrompt' | translate }}</span>\n" +
    "			    	</div>\n" +
    "	            </div>\n" +
    "	          </div>\n" +
    "	        </div>\n" +
    "        </ng-form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        * <span translate=\"BM.Login.RequiredField\"></span>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("registration/self-registration/self-registration.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/self-registration/self-registration.2js.html",
    "<div class=\"bm-flex-wrap bm-{{vm.productName}} bm-{{vm.backgroundName}}-back\">\n" +
    "  <main>\n" +
    "    <div class=\"bm-login-content-box\">\n" +
    "        <div>\n" +
    "            <!--Only display onbalance branding if name is samba -->\n" +
    "            <div class=\"onbalance-brand\" ng-if=\"vm.productName === 'samba'\">\n" +
    "                <div class=\"bm-thomsonreuters\"></div>\n" +
    "                <div class=\"onbalance-product-name\" ng-click=\"vm.productNameClicked()\" ng-class=\"{'onbalance-product-name-brazil': vm.bmEnvironment.isBrCountryCode() }\">ONBALANCE<sup>TM</sup></div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-product-name\" translate=\"bm.login.sambaProductName\" ng-if=\"vm.productName !== 'samba'\"></div>\n" +
    "            <h1 class=\"bm-login-view-title bm-login-padded-title\" translate=\"bm.login.sambaTrialTitle\" ng-if=\"!vm.displayConnectTitle\"></h1>\n" +
    "            <h1 class=\"bm-login-connect-title bm-login-padded-title\" translate=\"bm.login.sambaTrialConnectTitle\" ng-if=\"vm.displayConnectTitle\"></h1>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"bm-login-linking-banner\" ng-if=\"vm.showLinkingScreen\" translate=\"BM.Registration.LinkBanner\"></div>\n" +
    "\n" +
    "        <form role=\"form\" name=\"vm.registerForm\" class=\"css-form bm-login-form\" novalidate>\n" +
    "            <!-- footer check really is looking at product name -->\n" +
    "            <!-- <div class=\"form-group\" ng-if=\"vm.hasFooter()\"> -->\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"fullName\"><span translate=\"BM.Registration.FullName\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                <input ng-if=\"!vm.showLinkingScreen\" type=\"text\" class=\"form-control\" id=\"fullName\" name=\"fullName\" ng-model=\"vm.fullName\" ng-change=\"vm.nameChanged()\" required maxlength=\"50\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "                <div ng-if=\"vm.showLinkingScreen\">{{ vm.fullName }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\"><span translate=\"BM.Registration.EmailAddress\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                <input class=\"form-control\" ng-if=\"!vm.showLinkingScreen\" type=\"email\" id=\"email\" name=\"email\" autocomplete=\"off\" ng-model=\"vm.model.email\" ng-blur=\"vm.emailChanged()\" maxlength=\"255\"/>\n" +
    "                <div ng-if=\"vm.showLinkingScreen\">{{ vm.model.email }}</div>\n" +
    "            </div>\n" +
    "            <!-- In the case that we are showing the linking screen, we don't want to do any password validations. This should behave more like the sign in screen -->\n" +
    "            <div class=\"form-group\" ng-if=\"vm.showLinkingScreen\">\n" +
    "                <label for=\"password\"><span translate=\"BM.Login.Directive.Password\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" data-qe-id=\"bmlogin-loginform-pwd-input\" ng-model=\"vm.model.password\" required maxlength=\"50\" />\n" +
    "            </div>\n" +
    "            <div class=\"password-links\" ng-if=\"vm.showLinkingScreen\">\n" +
    "                <a id=\"bmlogin-loginform-forgotpwd-link\" ng-href=\"\" data-qe-id=\"bmlogin-loginform-forgotpwd-link\" ng-click=\"vm.openForgottenPasswordDialog()\" translate=\"BM.Login.Form.ForgotPassword\"></a>\n" +
    "            </div>\n" +
    "            <!-- TODO: IMPLEMENT THIS AS DIRECTIVE -->\n" +
    "            <div class=\"input-group\" ng-if=\"!vm.showLinkingScreen\">\n" +
    "                <label for=\"password\"><span translate=\"BM.Login.Directive.Password\"></span><span class=\"required-mark\">*</span></label>\n" +
    "                <input class=\"form-control\" type=\"password\" id=\"password\" name=\"password\" autocomplete=\"off\" ng-model=\"vm.model.password\" ng-change=\"vm.validatePassword()\" ng-focus=\"vm.enterNewPasswordField()\" ng-model-options=\"{ allowInvalid: true }\" required password-validator/>\n" +
    "                <span class=\"input-group-btn\">\n" +
    "                    <!-- use anchor tag for firefox functionality -->\n" +
    "                    <a tabindex=\"-1\" class=\"btn btn-default\" role=\"button\">\n" +
    "                        <i\n" +
    "                            uib-popover-template=\"vm.popover.templateUrl\"\n" +
    "                            popover-is-open=\"vm.passwordHelpPopoverOpen\"\n" +
    "                            tabindex=\"-1\"\n" +
    "                            popover-placement=\"right\"\n" +
    "                            class=\"bento-icon-question\">\n" +
    "                        </i>\n" +
    "                    </a>\n" +
    "                </span>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"correspondence\" bm-if-has-access=\"PromotionalContentConsent\">\n" +
    "                <input id=\"correspondence-checkbox\" type=\"checkbox\" ng-model=\"vm.allowCorrespondence\" name=\"termsAccepted\">\n" +
    "                <label for=\"correspondence-checkbox\"><span translate=\"bm.login.sambaCorrespondenceMessage\"></span></label>\n" +
    "            </div>\n" +
    "\n" +
    "            <span translate=\"bm.login.sambaRegisterTerms\"></span> <a ng-href=\"{{vm.termsAndConditions}}\" target=\"_blank\" translate=\"bm.login.sambaTermsConditions\"></a>\n" +
    "            <div id=\"msgs\" ng-show=\"vm.error\" class=\"alert alert-error\">\n" +
    "                <span ng-show=\"vm.error.unknown\" translate=\"BM.Login.Directive.Error.TryAgain\"></span>\n" +
    "                <span ng-show=\"vm.error.incomplete\" translate=\"BM.Login.Directive.Error.Incomplete\"></span>\n" +
    "                <span ng-show=\"vm.error.provideValidPassword\" translate=\"BM.Login.ResetPassword.ProvideValidPassword\"></span>\n" +
    "                <span ng-show=\"vm.error.prohibitedCharacters\">{{vm.rules.prohibitedCharacterRule.label}}: {{vm.prohibitedChars.join(', ')}}</span>\n" +
    "                <span ng-show=\"vm.error.provideValidEmail\" translate=\"BM.Login.ValidEmailError\"></span>\n" +
    "                <span ng-show=\"vm.error.provideName\" translate=\"BM.Login.FirstAndLastNameError\"></span>\n" +
    "                <span ng-show=\"vm.error.emailNotUnique\" translate=\"BM.Login.Directive.Error.UniqueEmail\"></span>\n" +
    "            </div>\n" +
    "            <div class=\"bm-btn-signin-wrap\">\n" +
    "                <button type=\"submit\" class=\"btn btn-primary bm-btn-signin\" id=\"register\" ng-click=\"vm.submit()\" translate=\"bm.login.sambaRegisterTrial\" ng-disabled=\"vm.active\">\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "        <div class=\"bottom-links bottom-link-center\">\n" +
    "            <div>\n" +
    "                <div ng-if=\"!vm.hideSignIn && !vm.showLinkingScreen\">\n" +
    "                    <span translate=\"bm.login.sambaAlreadyHaveAccount\"></span>\n" +
    "                    <a ng-href=\"{{vm.signInUrl}}\" data-qe-id=\"bmlogin-loginform-selfreg-link\" translate=\"BM.Login.Directive.Button.SignIn\" class=\"bm-samba-register\"></a>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.showLinkingScreen\">\n" +
    "                    <span translate=\"bm.login.useDifferentAccount\"></span>\n" +
    "                    <a data-qe-id=\"bmlogin-loginform-selfreg-link\" translate=\"bm.login.createNewAccountWithDifferentEmail\" class=\"bm-samba-register\" ng-click=\"vm.hideLinking()\"></a>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.bmEnvironment.isBrCountryCode()\">\n" +
    "                    <span translate=\"BM.Registration.OnbalanceHelpText\"></span>\n" +
    "                    <a href=\"http://www.onbalance.com.br/videos/como-iniciar-o-uso-do-onbalance/\" target=\"_blank\" translate=\"BM.Registration.ClickHere\"></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  </main>\n" +
    "\n" +
    "  <!-- hide footer here instead of css so doesn't end up in dom -->\n" +
    "  <footer ng-if=\"vm.hasFooter()\">\n" +
    "    <div ng-if=\"vm.productName === 'samba'\" class=\"cityscape-image\"></div>\n" +
    "    <div class=\"footer-content-wrapper\">\n" +
    "        <div class=\"bento-footer\">\n" +
    "            <div class=\"bento-footer-logo\">\n" +
    "                <div class=\"bento-tr-logo-white\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"bento-footer-fine-prints\">\n" +
    "                <div class=\"footer-fine-prints-content\">\n" +
    "                    <div ng-if=\"vm.productName !== 'samba'\">\n" +
    "                        <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.CopyrightNotice\"></span></p>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.productName === 'samba'\">\n" +
    "                        <p bm-if-has-no-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.OnBalanceCopyrightNotice\"></span></p>\n" +
    "                    </div>\n" +
    "                    <p bm-if-has-access=\"myPaySolutions\">&copy; {{vm.copyrightYear}} <span translate=\"BM.Login.Common.MyPayCopyrightNotice\"></p>\n" +
    "                </div>\n" +
    "                <div class=\"bento-footer-copyright-links\" >\n" +
    "                    <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "                    <a ng-href=\"mailto:{{vm.contactEmail}}?subject=Onvio Login\" ng-if=\"vm.productName !== 'samba'\" translate=\"BM.Login.Common.ContactUs\"></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bento-footer-options\" ng-if=\"vm.hasLangSwitch\">\n" +
    "                <i class=\"bento-icon-earth\"></i>\n" +
    "                <div uib-dropdown class=\"bento-dropdown dropdown-menu-right dropup\">\n" +
    "                  <button uib-dropdown-toggle class=\"btn btn-default\">\n" +
    "                    <span>{{selectedLanguage}}</span>\n" +
    "                    <i class=\"bento-icon-caret-down\"></i>\n" +
    "                  </button>\n" +
    "                  <div class=\"dropdown-menu\" uib-dropdown-menu>\n" +
    "                    <ul class=\"dropdown-scroll\">\n" +
    "                      <li ng-repeat=\"language in vm.languageList\"><a ng-click=\"vm.setLanguage(language)\">{{language.description}}</a></li>\n" +
    "                    </ul>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  </footer>\n" +
    "</div>\n" +
    "");
}]);

angular.module("registration/user-registration.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("registration/user-registration.2js.html",
    "<div class=\"bento-container\">\n" +
    "    <div bento-busy-loader=\"vm.isLoaderBusy\">\n" +
    "        <div class=\"registration-body\">\n" +
    "            <div id=\"moduleHeader\" translate=\"BM.RegisterAccount.Header\"></div>\n" +
    "            <div class=\"bento-alert-container\" ng-if=\"vm.registrationAlerts.length > 0\">\n" +
    "                <div uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.registrationAlerts\" ng-class=\"'alert-' + (alert.type || 'warning')\">\n" +
    "                  {{alert.msg}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.user\">\n" +
    "                <div ng-if=\"vm.user && vm.user.prompt\">\n" +
    "                    <bm-personal-id user=\"vm.user\"></bm-personal-id>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <bm-login-account-info user=\"vm.user\"></bm-login-account-info>\n" +
    "                </div>\n" +
    "                <button ng-click=\"vm.completeRegistration()\" class=\"btn btn-primary\" translate=\"Register Me\"></button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

(function (angular) {
    'use strict';

    angular.module('bluemoon.login')

    .controller('AppCtrl', [
        'bmUtil',
        'bmTheme',
        '$rootScope',
        '$scope',
        '$timeout',
        '$translate',
        'bmPrimaryProductFactory',
        'bmEnvironment',
        function (util, theme, $rootScope, $scope, $timeout, $translate, productFactory, env) {

        var self = this;

        this.theme = theme;
        this.alerts = [];
        this.productDisplayName = '';
        this.primaryProduct = '';

        env.getEnvironmentAsync().then(function(data) {
            self.productDisplayName = data.productDisplayName;
            self.primaryProduct = data.primaryProduct;
            self.documentLanguage = getDocumentLanguage(data.countryCode);
        });

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState){
            // update product change password indicator for custom sign in view
            productFactory.setChangePasswordState(fromState.name === 'change-password' && toState.name === 'main');

            // delay till next cycle since bm-busy-loader auto hides loader on $stateChangeStart
            $timeout(function() {
                $scope.$emit('bm-busy-loading-on');
            });
        });
        $rootScope.$on('$stateChangeSuccess', function(){
            // delay till next cycle since $stateChangeStart above delays
            $timeout(function() {
                $scope.$emit('bm-busy-loading-off');
            });
        });
        $rootScope.$on('$stateChangeError', function(){
            // delay till next cycle since $stateChangeStart above delays
            $timeout(function() {
                $scope.$emit('bm-busy-loading-off');
            });
            $translate('BM.Login.UnexpectedError').then(function(str) {
                self.alerts.push({
                    type: 'danger',
                    msg: str,
                    closeable: true
                });
            });
        });

        function getDocumentLanguage(countryCode) {
            // We set document's language base on the region
            // We skipped to place this directly from the cookie
            // otherwise it should be validated against the array of permitted languages
            var cookieCountryCode = (document.cookie.match('(^|; )BMLanguageCode=([^;]*)') || '')[2];
            switch(countryCode){
                case 'US':
                    return 'en-US';
                case 'GB':
                    return 'en-GB';
                case 'AR':
                    return 'es-AR';
                case 'BR':
                    if(cookieCountryCode === 'en-US'){
                        return 'en-US';
                    }
                    return 'pt-BR';
                case 'CA':
                    if(cookieCountryCode === 'fr-CA'){
                        return 'fr-CA';
                    }
                    return 'en-CA';
            }
            return 'en-US';
        }

    }]);
})(window.angular);

(function (angular, trAuth) {
    'use strict';

    angular.module('bluemoon.login').controller('MainCtrl', MainCtrl);
    MainCtrl.$inject = [
        '$location',
        '$uibModal',
        'bmLanguageManager',
        'ResetPasswordService',
        '$scope',
        '$translate',
        'bmUtil',
        'LockedLoginService',
        'bmEnvironment',
        'bmSupportedLanguagesMetadata',
        'bmEnvironmentConst',
        'themeHeader',
        'product',
        'bmAccess',
        '$state'
    ];

    function MainCtrl($location, $uibModal, bmLanguageManager, ResetPasswordService, $scope, $translate, bmUtil, LockedLoginService, bmEnvironment, bmSupportedLanguagesMetadata, bmEnvironmentConst, themeHeader, product, bmAccess, $state) {
        var vm = this;

        vm.hasLangSwitch = false;
        vm.setLanguage = setLanguage;
        vm.hasFooter = hasFooter;
        vm.copyrightYear = (new Date()).getFullYear();
        vm.isArEmployeePortal = false;

        initViewModel();

        /////////////

        function initViewModel(){
            //if the url is /logout send the flag to tr-auth
            vm.isLogout = ($location.url().indexOf('/logout') !== -1)? true: false;
            vm.loadedProduct = product;
            vm.backgroundName = themeHeader.loginBackground;
            vm.productName = product.name;
            vm.backgroundName = product.background || themeHeader.loginBackground;
            var cookieCheckPoint = 'bmCheckPointOrigin';
            if($location.search().mafUrl){
                document.cookie = cookieCheckPoint + '=' + $location.search().mafUrl + '; path=/; Max-Age=7200; SameSite=Strict; Secure;';
            }

            if(vm.productName === 'samba' && !trAuth.isBrowserSupported({minimumMsie:12})) {
                $state.go('unsupported-browser-smb');
            }

            // Make sure languages are loaded first
            setLanguageListAsync();
            handleResetPassword();
            handleRegisteredUser();
            setStartingLanguage();
            setEnvironmentLinks();
            isArEmployeePortalEnabled();
        }

        $scope.$on('bmLoginFailExpiredTrial', function(event, args){
            vm.expiredTrial = true;
            vm.allowExtend = args;
        });

        function setEnvironmentLinks(){
            vm.privacyLink = 'https://onvio.us/ua/help/us-en/staff/core/privacy-statement.htm';
            var country = bmEnvironment.getCountryCode();
            switch (country) {
                case 'uk':
                    vm.contactEmail = 'mailto:digita.support@thomsonreuters.com?subject=Onvio Login';
                    break;
                case 'ca':
                    if($scope.selectedLanguage === 'Français (Canada)') {
                        vm.contactEmail = 'https://www.thomsonreuters.ca/fr/onvio/help-support.html#need-to-talk';
                    } else {
                        vm.contactEmail = 'https://www.thomsonreuters.ca/en/onvio/help-support.html#need-to-talk';
                    }
                    break;
                case 'nl':
                    vm.contactEmail = 'mailto:SupportNL@thomsonreuters.com?subject=Onvio Login';
                    break;
                case 'ar':
                    vm.contactEmail = 'mailto:contacto.onvio@thomsonreuters.com?subject=Onvio Login';
                    break;
                case 'br':
                    vm.contactEmail = 'mailto:OnvioSuporteBR@thomsonreuters.com?subject=Onvio Login';
                    break;
                case 'in':
                    vm.contactEmail = 'mailto:OnvioSupportIN@thomsonreuters.com?subject=Onvio Login';
                    break;
                case 'au':
                    vm.contactEmail = 'mailto:SupportANZ@thomsonreuters.com?subject=Onvio Login';
                    break;
                default:
                    vm.contactEmail = 'mailto:Onvio.SupportUS@ThomsonReuters.com?subject=Onvio Login';
                    break;
            }
        }

        function setStartingLanguage(){
            var languageCode;
            var languageUrlParam = $location.search().lang;
            if(languageUrlParam) {
                //To be used to specify language when visiting from another site like the spearhead marketing site
                var lang;
                for(var x = 0; x < bmSupportedLanguagesMetadata.length; x++) {
                    if(languageUrlParam === bmSupportedLanguagesMetadata[x].code) {
                        lang = bmSupportedLanguagesMetadata[x];
                    }
                }
                if(lang) {
                    languageCode = languageUrlParam;
                    setLanguage(lang);
                } else {
                    languageCode = setStartingLanguageHelper();
                }
                $location.search('lang', null);
            } else {
                languageCode = setStartingLanguageHelper();
            }

            for (var languages in bmSupportedLanguagesMetadata) {
                if (bmSupportedLanguagesMetadata[languages].code === languageCode) {
                    $scope.selectedLanguage = bmSupportedLanguagesMetadata[languages].description;
                }
            }
        }

        function setStartingLanguageHelper() {
            if (bmUtil.cookie('BMLanguageCode') !== undefined) {
                return bmUtil.cookie('BMLanguageCode');
            } else {
                return bmEnvironmentConst.defaultLang;
            }
        }

        function setLanguage(language){
            $scope.selectedLanguage = language.description;
            bmLanguageManager.setUserLanguageAsync(language.code).then(function(){
                setLanguageListAsync();
            });
        }

        function hasFooter(){
            return product.showFooter;
        }

        function handleResetPassword(){
            // Check if there is a change password id (cid) on the URL
            var search = $location.search();

            if (search) {
                if (search.cid) {
                    // Validate the cid
                    ResetPasswordService.validateCpid(search.cid).then(function() {
                        // Set the cid to be used later
                        ResetPasswordService.setEmailCPID(search.cid);

                        // samba uses a full view instead of a modal
                        if(product.forgotRoute){
                            $location.url(product.resetRoute);
                        } else {
                            // Go to the set password page
                            $uibModal.open({
                                templateUrl: 'components/forgotten-password/reset-password.2js.html',
                                controller: 'resetPasswordCtrl',
                                backdrop: 'static'
                            });
                        }
                    }, function(response) {
                        if (response.status === 409) {
                            $scope.error = {};
                            $scope.error.expiredCpid = true;
                        }
                    });
                } else if (search.blid) {
                    LockedLoginService.unlockLogin(search.blid);
                } else if (search.error) {
                    $scope.error = {};
                    $scope.error.expiredLink = true;
                }
            }
        }

        function setLanguageListAsync(){
            // Only get languages
            return bmLanguageManager.getLanguagesAsync(false).then(function(languages){
                vm.languageList = languages;
                vm.hasLangSwitch = angular.isDefined(vm.languageList) && vm.languageList.length > 0;
                setEnvironmentLinks();
            });
        }

        function handleRegisteredUser(){
            var cname = 'BMRegisteredUser';

            var userId = bmUtil.cookie(cname);
            if(userId) {
                $scope.uid = userId;
            }
        }
        // Argentina change Onbalance name to Employee Portal
        function isArEmployeePortalEnabled() {
            bmAccess.has('ARLoginOB').then(function(res){
                vm.isArEmployeePortal = res;
            }, function(err) {
                vm.isArEmployeePortal = err;
            });
        }
    }
})(window.angular, window.trAuth);

(function(angular){
    'use strict';

    angular.module('bluemoon.login').factory('bmPrimaryProductFactory', primaryProduct);
    primaryProduct.$inject = ['$q', 'bmEnvironment'];

    function primaryProduct($q, bmEnvironment){
        var productDeferred = $q.defer();
        var productConfig;
        var factory = {
            getPrimaryProduct: getPrimaryProduct,
            setChangePasswordState: setChangePasswordState,
            setBackground: setBackground
        };

        // TODO: THIS CAN EXPAND WITH MORE PROPERTIES AS NECESSARY
        var products = {
            onvio: {
                name: 'onvio',
                useCustomPasswordChange: false,
                showFooter: true,
                signInTemplateUrl: 'components/userlogin/userlogin.2js.html',
                useSignInPlaceholders: true
            },
            recibos: {
                name: 'samba',
                background: 'samba',
                useCustomPasswordChange: true,
                showFooter: true,
                resetRoute: '/reset-signin',
                forgotRoute: '/forgot-password',
                signInTemplateUrl: 'components/userlogin/userlogin-smb.2js.html'
            },
            samba: {
                name: 'samba',
                background: 'samba',
                useCustomPasswordChange: true,
                showFooter: true,
                resetRoute: '/reset-signin',
                forgotRoute: '/forgot-password',
                signInTemplateUrl: 'components/userlogin/userlogin-smb.2js.html'
            },
            auth: {
                name: 'auth',
                signInTemplateUrl: 'cs-user-admin/login/cs-user-login.2js.html'
            }
        };

        load();

        return factory;

        ///////////////////////

        function load(){
            bmEnvironment.getPrimaryProduct().then(function(productName){
                productConfig = products[productName] ? products[productName] : products.onvio;
                productDeferred.resolve(productConfig);
            }, function(){
                // default to onvio config
                productConfig = products.onvio;
                productDeferred.resolve(productConfig);
            });
        }

        function getPrimaryProduct(){
            // TODO: HOW TO UPDATE THE CURRENT PRODUCT
            if(productConfig){
                productDeferred.resolve(productConfig);
            }

            return productDeferred.promise;
        }

        function setChangePasswordState(isChange){
            if(productConfig){
                productConfig.passwordChangeState = isChange;
            }
        }

        function setBackground(background){
            if(productConfig){
                productConfig.background = background;
            }
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    var i18nPartialLoaderErrorHandler = function($q){
        return function () {
            return $q.when({});
        };
    };

    i18nPartialLoaderErrorHandler.$inject = ['$q'];
    angular.module('bluemoon.login').factory('i18nPartialLoaderErrorHandler', i18nPartialLoaderErrorHandler);
})(window.angular);

(function (angular) {
    'use strict';

    function parseQueryStr(search) {
        search = search[0] === '?' ? search.substring(1) : search;
        var result = {};
        search.split('&').forEach(function (param) {
            if (param) {
                var parts = param.split('=');
                result[decodeURIComponent(parts[0])] = parts[1] ? decodeURIComponent(parts[1]) : undefined;
            }
        });
        return result;
    }

    angular.module('bluemoon.login')

        .directive('onvioLogin',[
            '$rootScope',
            '$q',
            '$templateRequest',
            '$compile',
            '$translate',
            'AuthenticatedSession',
            '$http',
            'SelectResetPasswordMethodService',
            'ResetPasswordService',
            'bmUtil',
            'bmAccess',
            'bmEnvironment',
            'bmEnvironmentConst',
            'bmPrimaryProductFactory',
            'languageStorageManager',
            '$state',
            'bmTokenStorage',
            '$location',
            function(
                $rootScope,
                $q,
                $templateRequest,
                $compile,
                $translate,
                session,
                $http,
                selectResetPasswordMethodService,
                ResetPasswordService,
                bmUtil,
                bmAccess,
                bmEnvironment,
                bmEnvConst,
                productFactory,
                langMgr,
                $state,
                bmTokenStorage,
                $location
            ) {
                return {
                    restrict: 'EA',
                    scope: {
                        product: '=product',
                        isLogout: '@logout'
                    },
                    link: function(scope, element, attrs) {
                        var uidInput;
                        var pwdInput;
                        attrs.$observe('product', function(){
                            if(angular.isUndefined(scope.product) || scope.product === null){
                                return;
                            }

                            loadTemplate();
                        });

                        scope.cancelPasswordChangeState = function(){
                            // TODO: POSSIBLY BETTER TO REFRESH STATE SO BACK HISTORY CLEARED OF PASSWORD CHANGED VIEW?
                            scope.product.passwordChangeState = false;
                            productFactory.setChangePasswordState(false);
                        };

                        function useTrAuthComponent() {
                            return bmAccess.has('Platform_Enable2FA').then(function() {
                                return $q.resolve(true);
                            }, function() {
                                // This validation is for auth0 release on US when the IACs failed
                                // For testing purposes we use || location.hostname === 'localhost' in the if below
                                var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
                                // Apply the same for Onbalance domains onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
                                var obDomain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
                                if(domain === '.us' || domain === '.com.br' || domain === '.com.ar' || obDomain === '.com.br'){
                                    var signInButton = angular.element(document.querySelector('#sign-in'));
                                    signInButton.attr('disabled', 'disabled');
                                }
                                return $q.resolve(false);
                            });
                        }
                        function enableMFACards() {
                            return bmAccess.has('Platform_EnableMFACards').then(function() {
                                return $q.resolve(true);
                            }, function() {
                                return $q.resolve(false);
                            });
                        }
                        function disableMfaNag() {
                            return bmAccess.has('Platform_BypassMFA').then(function() {
                                return $q.resolve(true);
                            }, function() {
                                return $q.resolve(false);
                            });
                        }
                        function getAuthRoute() {
                            return bmEnvironment.getRoute('AuthenticationAggregatorServices').then(function(route) {
                                return $q.resolve(route);
                            }, function() {
                                return $q.resolve(null);
                            });
                        }
                        function isBrowserOutdated() {
                            return bmAccess.has('Platform_EvergreenBrowsersOnly').then(function() {
                                var userBrowser = window.bowser && window.bowser.getParser(navigator.userAgent) || undefined;
                                if( !userBrowser ) { return $q.resolve(false); } // if we can't get browser let them through
                                if( userBrowser.isBrowser('Internet Explorer') ) { return $q.resolve(true); } // do not allow ie
                                if( userBrowser.satisfies({chrome: '<=72'}) ) { return $q.resolve(true); } // do not allow old version of chrome
                            }, function() {
                                return $q.resolve(false);
                            });
                        }
                        function isAuth0Enabled() {
                            return bmAccess.has('Platform_DisableAuth0Phase2').then(function(){
                                return $q.resolve(false);
                            }, function() {
                                return $q.resolve(true);
                            });
                        }

                        function isMyPayEnabled() {
                            return bmAccess.has('myPaySolutions').then(function(){
                                return $q.resolve(true);
                            }, function() {
                                return $q.resolve(false);
                            });
                        }

                        function loadTemplate(){
                            var templateUrl = scope.product.signInTemplateUrl;

                            // dynamically load html template based on product-name
                            // https://jellekralt.com/2015/08/13/dynamically-load-a-templateurl-in-an-angular-directive/
                            $templateRequest(templateUrl).then(function(html){
                                // convert the html to dom node and append to directive
                                var template = angular.element(html);
                                element.append(template);
                                $compile(template)(scope);

                                var loginForm = element[0].querySelector('.bm-login-form');
                                var forgotPwdLink = element[0].querySelector('#bmlogin-loginform-forgotpwd-link') || { style: {} };

                                var trAuthTarget = element[0].querySelector('#trAuthTarget');
                                loginForm.style.display = forgotPwdLink.style.display = 'none';
                                // template must be loaded and compiled before setting attributes
                                useTrAuthComponent().then(function(useAuth) {
                                    if (useAuth) {
                                        $q.all({
                                            route: getAuthRoute(),
                                            enableMFACards: enableMFACards(),
                                            disableMfaNag: disableMfaNag(),
                                            isBrowserOutdated: isBrowserOutdated(),
                                            isAuth0: isAuth0Enabled(),
                                            isMyPay: isMyPayEnabled(),
                                        }).then(function(results) {
                                            var queryString = parseQueryStr(location.search);
                                            if(results.isAuth0){
                                                document.documentElement.classList.add('auth0-login');
                                            }
                                            window.addEventListener('trta1-auth0-complete-hidden-success', function() {
                                                document.getElementById('bm-login-content-box-main').style.visibility = 'hidden';
                                            });
                                            renderMfaComponent(trAuthTarget, session, results.enableMFACards, results.disableMfaNag, results.isBrowserOutdated, $rootScope, langMgr, bmEnvConst, results.route, queryString.jwt, queryString.flow, bmTokenStorage, scope.expiredRegistration, $location, results.isAuth0, scope.isLogout, results.isMyPay, scope.product.name, scope.isARLoginOB);
                                        });
                                    } else {
                                        loginForm.style.display = forgotPwdLink.style.display = 'block';
                                        setTemplateInfo();
                                    }
                                });
                            });
                        }

                        function setTemplateInfo() {
                            uidInput = element[0].querySelector('#uid');
                            pwdInput = element[0].querySelector('#pwd');

                            scope.$on('bm-signin-failed', function() {
                                // select all password input text
                                pwdInput.select();
                            });

                            // input placeholders set dynamically to get around translate key flash
                            setPlaceholders();
                            scope.$on('bmLanguageChangeSuccess', setPlaceholders);

                        }

                        function setPlaceholders() {
                            // no placeholders for samba
                            if(!scope.product.useSignInPlaceholders){
                                return;
                            }

                            $translate('BM.Login.Form.UserName').then(function(str) {
                                // decode numeric html encoding, since attribute values don't like em
                                str = bmUtil.decodeHtmlEntities(str);
                                uidInput.setAttribute('placeholder', str);
                            });
                            $translate('BM.Login.Directive.Password').then(function(str) {
                                // decode numeric html encoding, since attribute values don't like em
                                str = bmUtil.decodeHtmlEntities(str);
                                pwdInput.setAttribute('placeholder', str);
                            });
                        }
                    },
                    controller: ['$document', '$scope', '$location', '$uibModal', '$bentoBusyLoader', 'bmEnvironment',
                            function ($document, $scope, $location, $uibModal, $bentoBusyLoader, bmEnvironment) {

                        $scope.isARLoginOB = false;
                        bmAccess.has('ARLoginOB').then(function (res) {
                            $scope.isARLoginOB = res;
                        }).catch(function (err) {
                            $scope.isARLoginOB = err;
                        });

                        $scope.hasEnableAuth0Phase2 = false;
                        // Validate if Auth0 is enabled to show tr-auth component
                        bmAccess.has('Platform_DisableAuth0Phase2').then(function(res){
                            $scope.hasEnableAuth0Phase2 = !res;
                        }, function(err) {
                            $scope.hasEnableAuth0Phase2 = !err;
                        });

                        var env;
                        bmEnvironment.getEnvironmentAsync().then(function(data) {
                            env = data;
                        });
                        $scope.countryCode = bmEnvironment.getCountryCode();

                        $scope.displayConnectTitle = $location.search().mapId;
                        if($scope.displayConnectTitle && $scope.product.name === 'samba') {
                            //Append current url parameters to self registration url
                            $scope.selfRegistrationUrl = $location.url().replace($location.path(), $state.href('self-registration'));
                        } else {
                            $scope.selfRegistrationUrl = $state.href('self-registration');
                        }

                        $scope.expiredRegistration = false;
                        if ($location.search().error === 'BM.Registration.ExpiredLink') {
                            $scope.expiredRegistration = true;
                            $location.search({'error': null});
                        }

                        $scope.getViewTitle = function() {
                            var title = '';
                            // for whatever reason recibos should not have a title
                            if (env && env.primaryProduct !== 'recibos') {
                                title = env.productDisplayName;
                            }
                            return title;
                        };

                        //A helper function that handles errors upon signin
                        function signInErrorHelper(result) {
                            $scope.error = {};
                            $scope.$broadcast('bm-signin-failed');
                            switch (result.status) {
                                case 401:
                                    // Password Expiration
                                    if (result.data &&
                                        result.data.subcode === 101 &&
                                        result.data.data.length > 0) {

                                        $scope.error = null;

                                        // Set the cid to be used later
                                        ResetPasswordService.setEmailCPID(result.data.data[0].value);
                                        ResetPasswordService.setRequired(true);

                                        // samba uses a full view instead of a modal
                                        if($scope.product && $scope.product.resetRoute && $scope.product.resetRoute !== ''){
                                            if($scope.product.name === 'samba' && $scope.displayConnectTitle) {
                                                //Append current url parameters to reset password url and visit this route
                                                $location.url($scope.product.resetRoute + $location.url().replace($location.path(), ''));
                                            } else {
                                                $location.url($scope.product.resetRoute);
                                            }
                                        } else {
                                            // Go to the set password page
                                            $uibModal.open({
                                                templateUrl: 'components/forgotten-password/reset-password.2js.html',
                                                controller: 'resetPasswordCtrl',
                                                backdrop: 'static'
                                            });
                                        }
                                    } else if(isCreditHoldError(result.data) || isFirmLockError(result.data)) {
                                        $scope.error.forbidden = true;
                                        break;
                                    } else if(isExpiredTrialAllowExtensionError(result.data)) {
                                        var token = result.data.data[0].value;
                                        sessionStorage.setItem('bmExpiredTrialToken', token);
                                        $rootScope.$broadcast('bmLoginFailExpiredTrial', true);
                                    } else if(isExpiredTrialNoExtensionError(result.data)) {
                                        $rootScope.$broadcast('bmLoginFailExpiredTrial', false);
                                    } else { // Invalid login
                                        $scope.error.invalid = true;
                                    }
                                    break;
                                case 403:
                                    $scope.error.forbidden = true;
                                    break;
                                case 404:
                                    $scope.error.inactive = true;
                                    break;
                                default:
                                    $scope.error.unknown = true;
                            }
                        }

                        function isCreditHoldError(response) {
                            return response &&
                            response.subcode === 102 &&
                            response.data.length > 0;
                        }

                        function isFirmLockError(response) {
                            return response &&
                            response.subcode === 103 &&
                            response.data.length > 0;
                        }

                        function isExpiredTrialAllowExtensionError(response) {
                            return response && response.subcode === 105;
                        }

                        function isExpiredTrialNoExtensionError(response) {
                            return response && response.subcode === 106;
                        }

                        $scope.signIn = function (uid, pwd) {
                            $scope.error = null;

                            if ($scope.form.$valid) {
                                var busyLoader = $bentoBusyLoader.getNewLoader($document[0].body);
                                busyLoader.show();
                                //Make calls to linking endpoints for ultraTax or Onvio
                                if($scope.product.name === 'samba' && $location.search().mapId) {
                                    //Get uds longtoken for linking endpoints without redirecting or loading bindings.
                                    //TODO: We'll want to add this functionality to get a uds longtoken without redirecting in bluemoon-components in the future.
                                    var options = {
                                        data: {
                                            username: uid,
                                            password: pwd
                                        }
                                    };

                                    var defaultOptions = {
                                        method: 'POST',
                                        url: '/api/security/v1/sessions',
                                        bmNoAuth: true
                                    };

                                    bmTokenStorage.clean();

                                    $http(angular.extend(defaultOptions, options)).then(function callLinking(resp) {
                                        var token = resp.data.LongToken;
                                        //Call update endpoint in UltraTaxSmbServices
                                        var mappingOptions = {
                                            data: {
                                                email: uid,
                                                feature: 'Onbalance'
                                            }
                                        };
                                        switch($scope.countryCode){
                                            case 'ar':
                                                mappingOptions.data.resource = 'ARBasic';
                                                break;
                                            case 'uk':
                                                mappingOptions.data.resource = 'UKSelfEmployed';
                                                break;
                                            default:
                                                mappingOptions.data.resource = 'USSelfEmployed';
                                                break;
                                        }
                                        // We are using bmNoAuth here, because we are fetching a new udsLongToken
                                        // and we want to avoid using token that may be stored in the cookies
                                        var mappingDefaultOptions = {
                                            method: 'PUT',
                                            url: '/api/smbcenter/v1/registration/' + $location.search().mapId,
                                            headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'UDSLongToken ' + token
                                            },
                                            bmNoAuth: true
                                        };
                                        if($location.search().ultraTax) {
                                            mappingDefaultOptions.url = '/api/ultrataxsmb/v1/link/' + $location.search().mapId;
                                        }

                                        $http(angular.extend(mappingDefaultOptions, mappingOptions)).then(function signInAndRedirect() {
                                            bmTokenStorage.clean();
                                            session.createWithLongToken(token).catch(function(result) {
                                                signInErrorHelper(result);
                                                busyLoader.hide();
                                            });
                                        }).catch(function mappingError() {
                                            busyLoader.hide();
                                            $scope.error.invalid = true;
                                        });
                                    }).catch(function securityFail(result) {
                                        signInErrorHelper(result);
                                        busyLoader.hide();
                                    });
                                } else {
                                    //Normal Sign In
                                    bmTokenStorage.clean();
                                    session.create(uid, pwd).catch(function(result) {
                                        signInErrorHelper(result);
                                        busyLoader.hide();
                                    });
                                }
                            } else {
                                $scope.error = { incomplete: true };
                            }
                        };

                        $scope.openForgottenPasswordDialog = function() {
                            $scope.userData = {
                                email : '',
                            };

                            if((!angular.isUndefined($scope.uid)) && ($scope.uid !== '')) {
                                $scope.userData.email = $scope.uid;
                            }

                            selectResetPasswordMethodService.setUserData($scope.userData);

                            // samba uses a full view instead of a modal
                            if($scope.product && $scope.product.forgotRoute && $scope.product.forgotRoute !== ''){
                                $location.url($scope.product.forgotRoute);
                                return;
                            }

                            $uibModal.open({
                                templateUrl: 'components/forgotten-password/select-reset-password-method.2js.html',
                                controller: 'forgottenPasswordCtrl',
                                backdrop: 'static'
                            });
                        };

                        /* handle startup states, like from external login */
                        if ($location.search().forgot) {
                            // clear
                            $location.search('forgot', null);
                            $scope.openForgottenPasswordDialog();
                        }
                        if (!$scope.error || !$scope.error.expiredLink) {
                            var error = $location.search().error;
                            if (error) {
                                $scope.error = {};
                                // todo: refactor to support subcodes as above and DRY up
                                switch(parseInt(error)) {
                                    case 401:
                                        $scope.error.invalid = true;
                                        break;
                                    case 403:
                                        $scope.error.forbidden = true;
                                        break;
                                    default:
                                        $scope.error.unknown = true;
                                        break;
                                }
                                // clear
                                $location.search('error', null);
                            }
                        }
                    }]
                };
            }
        ]);
    function renderMfaComponent(el, session, enableMFACards, disableMfaNag, isBrowserOutdated, $scope, langMgr, bmEnvConst, route, jwt, flow, bmTokenStorage, expiredRegistration, $location, isAuth0, isLogout, isMyPay, productName, isOnbalanceAR) {
        var currentLang = langMgr.get();
        var options = {
            type: (isMyPay && isAuth0) ? 'mypay' : (productName === 'samba') ? getOnbalanceProductName(isOnbalanceAR):'onvio',
            sp: (isMyPay && isAuth0) ? 'mypay' : (productName === 'samba') ? getOnbalanceProductName(isOnbalanceAR):'onvio',
            startingForm: isAuth0 ? 'trta1-auth0-redirect' : null,
            adjustHash: isAuth0 ? true : false,
            auth0Redirect: isAuth0 ? getRedirectToLoginPage(location.host) : null,
            auth0Code: $location.search().code,
            auth0State: $location.search().state,
            isLogout: isLogout,
            locale: currentLang,
            targetElem: el,
            payload: {},
            enableMFACards: enableMFACards,
            disableMfaNag: disableMfaNag,
            unsupportedBrowser: isBrowserOutdated,
            disallowIE: isBrowserOutdated,
            expiredRegistration: expiredRegistration,
            templateData: {
                cswebHost: '', // no-op value
                authSvcHost: getAuthSvcHost(route, bmEnvConst.isLocalType),
                onvioHelpDomain: getAuthSvcHost(route, bmEnvConst.isLocal),
                netfirmWebHost: '' // no-op value
            },
            flow: {
                type: flow,
                data: {
                    jwt: jwt
                }
            },
            formOverrides: {
                'trta1-mfa-notifydevice': {
                    payload: {
                      issuer: 'Onvio'
                    }
                }
            },
            mfsOptions: {
                targetElem: null
            }
        };

        if (currentLang === 'en-US') {
            options.statusPage = {
                url: 'https://taxprofessionals-status.hostedtax.thomsonreuters.com/'
            };
        } else if (currentLang === 'en-GB') {
            options.statusPage = {
                url: 'https://tr-taxprofessionals-uk.statuspage.io/'
            };
        }

        window.trAuth.modules.auth.init(options);
        options.expiredRegistration = false;
        $scope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
            if(changeArgs.language !== currentLang){
                currentLang = changeArgs.language;
                window.trAuth.modules.auth.destroy();
                // Reset statusPage
                delete options.statusPage;
                if (currentLang === 'en-US') {
                    options.statusPage = {
                        url: 'https://taxprofessionals-status.hostedtax.thomsonreuters.com/'
                    };
                } else if (currentLang === 'en-GB') {
                    options.statusPage = {
                        url: 'https://tr-taxprofessionals-uk.statuspage.io/'
                    };
                }
                window.trAuth.modules.auth.init(angular.extend({}, options, { locale: currentLang }));
            }
        });

        window.addEventListener('tr-auth-success', function(evt) {
            var token = evt.detail.data.token;
            var uds = evt.detail.data.uds;
            bmTokenStorage.clean();
            sessionStorage.setItem('tr-auth-token', token);
            // Since this is Onvio, we should use uds if available, fall back to JWT if not
            if(uds) {
                session.createWithLongToken(uds);
            } else if(token) {
                session.createWithJwt(token);
            }
        });

        function getAuthSvcHost(routeURL, isLocal) {
            // todo: look at bmEnvironment.getRoute and see if it handles local path resolve yet
            if (isLocal || !routeURL) {
                return location.protocol + '//' + location.host;
            } else {
                // remove the path since the auth component expects protocol + domain only
                return routeURL.replace(/^(https?:\/\/[^\/]+).*$/, '$1');
            }
        }

        /*
          Appends /login to the host and returns that String if we are on localhost.
          This allows Auth0 to redirect to the login page upon successful authentication
        */
        function getRedirectToLoginPage(host) {
            if (host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1) {
                return location.protocol + '//' + host + '/login';
            }
            return null;
        }
        // Validate product name in onbalance BR and AR
        function getOnbalanceProductName(isOnbalanceAR) {
            // If we are on localhost and the product is onbalance AR, return employeeportal
            if (location.host.indexOf('localhost') !== -1 && isOnbalanceAR) {
                return 'employeeportal';
            }

            var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
            if (domain === '.com.ar') {
                return 'employeeportal';
            }
            return 'onbalance';
        }
    }
}(window.angular));

(function(angular){
    'use strict';

    angular.module('bmExpiredTrial', ['bmTokenStorage']);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmExpiredTrial').component('expiredTrial', {
        templateUrl: 'components/expired-trial/expired-trial.2js.html',
        controller: expiredTrialCtrl,
        controllerAs: 'vm',
        bindings: {
            allowExtend: '='
        }
    });

    expiredTrialCtrl.$inject = ['$window', 'expiredTrialService', '$translate', 'bmUtil', '$bentoBusyLoader', '$document'];
    function expiredTrialCtrl($window, expiredTrialService, $translate, bmUtil, $bentoBusyLoader, $document) {
        /*jshint validthis:true */
        var vm = this;
        vm.extendTrial = extendTrial;

        vm.$onInit = onInit;
        function onInit(){
            vm.lang = getLang();
            vm.token = sessionStorage.getItem('bmExpiredTrialToken');
            sessionStorage.removeItem('bmExpiredTrialToken');
            getTranslatedStrings();
        }
        function getLang() {
            var fullCode = bmUtil.cookie('BMLanguageCode') || 'en-US';
            // we just need the first segment for pathing
            return fullCode.split('-')[0];
        }

        function getTranslatedStrings() {
            return $translate([
                'BM.Login.ExtendTrial.Alert.Success',
                'BM.Login.ExtendTrial.Alert.Failure'
            ]).then(function(strings) {
                vm.successMessage = strings['BM.Login.ExtendTrial.Alert.Success'];
                vm.failureMessage = strings['BM.Login.ExtendTrial.Alert.Failure'];
            });
        }

        function extendFailure() {
            // Prevent inproper access to Staff App
            expiredTrialService.deleteSession();
            vm.extendAlert = [{
                type: 'danger',
                msg: vm.failureMessage,
                closeable: true
            }];
        }

        function extendSuccess() {
            vm.extendAlert = [{
                type: 'success',
                msg: vm.successMessage,
                closeable: true
            }];
            $window.location.href = '/staff/';
        }

        function extendTrial() {
            var busyLoader = $bentoBusyLoader.getNewLoader($document[0].body);
            busyLoader.show();
            expiredTrialService.createSession(vm.token).then(function(){
                expiredTrialService.getTrialExpiration().then(function(resp){
                    var today = new Date();
                    var extensionDate = today.toISOString();
                    resp.data.extensionDate = extensionDate;
                    expiredTrialService.extendTrial(resp.data).then(function(){
                        busyLoader.hide();
                        extendSuccess();
                    }).catch(function() {
                        busyLoader.hide();
                        extendFailure();
                    });
                }).catch(function(){
                    busyLoader.hide();
                    extendFailure();
                });
            }).catch(function(){
                busyLoader.hide();
                extendFailure();
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmExpiredTrial').factory('expiredTrialService', expiredTrialService);
    expiredTrialService.$inject = ['$http', 'bmTokenStorage'];

    function expiredTrialService($http, bmTokenStorage) {
		var factory = {
			getTrialExpiration: getTrialExpiration,
			extendTrial: extendTrial,
			deleteSession: deleteSession,
			createSession: createSession
		};

		return factory;

		function getTrialExpiration() {
			return $http({
				method: 'GET',
				url: '/api/provisioning/v1/trials'
			});
		}
		function extendTrial(trialData) {
			return $http({
				method: 'PUT',
				url: '/api/provisioning/v1/trials/' + trialData.id,
				data: trialData
			});
		}
		function deleteSession() {
			bmTokenStorage.clean();

			return $http({
				method: 'DELETE',
				url: '/api/security/v1/sessions'
			});
		}
		// Duplicate createWithJwt from components to prevent redirect
		function createWithJwt(jwt) {
            return $http({
                method: 'POST',
                url: '/api/security/v2/sessions/jwt',
                headers: { Authorization: 'Bearer ' + jwt }
            });
        }

		function createSession(jwt) {
			// Delete previous session data if exists
			bmTokenStorage.clean();

			var promise = createWithJwt(jwt);

            promise.then(function(resp) {
                bmTokenStorage.set(resp.data.LongToken);
            });

            return promise;
		}
    }

})(window.angular);

(function (angular) {
	'use strict';

	angular.module('bluemoon.forgottenPassword', ['bluemoon.components.focus']);

})(window.angular);

(function(angular){
  'use strict';

  angular.module('bluemoon.forgottenPassword').factory('ResetPasswordEmailService', resetPasswordEmailService);
  resetPasswordEmailService.$inject = ['$http'];

  function resetPasswordEmailService($http){
    var factory = {
      load: load
    };

    return factory;

    //////////////////////

    function load(email){
      return $http.get('/api/profiles/v1/password/reset?email=' + encodeURIComponent(email));
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bluemoon.forgottenPassword').factory('ResetPasswordService', resetPasswordService);
  resetPasswordService.$inject = ['$http'];

  function resetPasswordService($http){
    var factory = {
      requirePasswordChange: false,
      setCPID: setCPID,
      setEmailCPID: setEmailCPID,
      setRequired: setRequired,
      reset: reset,
      verifyNewPassword: verifyNewPassword,
      validateCpid: validateCpid
    };

    return factory;

    /////////////////////////////////

    function setCPID(cpidData){
      factory.cpidData = cpidData;
    }

    function setEmailCPID(cpidEmailData){
      factory.cpidEmailData = cpidEmailData;
    }

    function setRequired(requirePasswordChange){
      factory.requirePasswordChange = requirePasswordChange;
    }

    function reset(cpid, password){
      var config = {
        method: 'PUT',
        url: '/api/profiles/v2/password/reset',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          cpid: cpid,
          password: password
        }
      };

      return $http(config);
    }

    // keep for reference purpose - should migrate to reset
    //function resetV1(cpid, password){
    //  var config = {
    //    method: 'PUT',
    //    url: '/api/profiles/v1/password/reset',
    //    headers: {
    //      'Content-Type': 'application/x-www-form-urlencoded'
    //    },
    //    data: 'cpid=' + cpid + '&password=' + (encodeURIComponent(password))
    //  };
    //
    //  return $http(config);
    //}

    function verifyNewPassword(cpid, password){
      var config = {
        method: 'POST',
        url: '/api/profiles/v2/password/check-history',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          cpid: cpid,
          password: password
        }
      };

      return $http(config);
    }

    // keep for reference purpose - should migrate to verifyNewPassword
    //function verifyNewPasswordV1(cpid, password){
    //  var config = {
    //    method: 'POST',
    //    url: '/api/profiles/v1/password/check-history?cpid=' + cpid,
    //    headers: {
    //      'Content-Type': 'application/x-www-form-urlencoded'
    //    },
    //    data: 'password=' + (encodeURIComponent(password))
    //  };
    //
    //  return $http(config);
    //}

    function validateCpid(cpid){
      var config = {
        method: 'POST',
        url: '/api/profiles/v1/password/validate?cpid=' + cpid
      };

      return $http(config);
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bluemoon.forgottenPassword').factory('LockedLoginService', lockedLoginService);
  lockedLoginService.$inject = ['$http'];

  function lockedLoginService($http){
    var factory = {
      unlockLogin: unlockLogin
    };

    return factory;

    ///////////////////////

    function unlockLogin(lockId){
      return $http.post('/api/profiles/v1/users/locked/' + lockId);
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bluemoon.forgottenPassword').factory('SelectResetPasswordMethodService', selectResetPasswordMethodService);

  function selectResetPasswordMethodService(){
    var factory = {
      setUserData: setUserData
    };

    return factory;

    ///////////////////////

    function setUserData(userData){
      factory.userData = userData;
    }
  }
})(window.angular);

(function (angular) {
	'use strict';

	angular.module('bluemoon.forgottenPassword')

		.controller('forgottenPasswordCtrl', ['$scope', '$translate', '$uibModal', '$uibModalInstance',
            'SelectResetPasswordMethodService', 'ResetPasswordEmailService',
            function ($scope, $translate, $uibModal, $uibModalInstance, selectResetPasswordMethodService, ResetPasswordEmailService) {

                $scope.data = {
                    email : '',
                    resetMethod : 'email'
                };
                $scope.errorMessage = '';
                // default the email address if one was provided
                var userData = selectResetPasswordMethodService.userData;
                if(userData.email) {
                    $scope.data.email = userData.email;
                }

                $scope.alerts = [];

                $scope.focusSelectResetPassword = true;
                $scope.isValidEmail = true;

                $scope.close = function () {
                    $uibModalInstance.close();
                };

                $scope.back = function () {
                    $scope.close();
                };

                $scope.next = function () {
                    if ($scope.validateForm()) {
                    // Open the next dialog
						$scope.$emit('bm-busy-loading-on');
                        ResetPasswordEmailService.load($scope.data.email).then(function(){
							$scope.$emit('bm-busy-loading-off');

                            // Close the current dialog
                            $scope.focusSelectResetPassword = false;
                            $uibModalInstance.close();

                            // Send the email
                            $uibModal.open({
                                templateUrl: 'components/forgotten-password/email-confirmation.2js.html',
                                controller: 'confirmationCtrl',
                                backdrop: 'static'
                            });
                        },
                        function () {
							$scope.$emit('bm-busy-loading-off');
                            $scope.alerts = [
                                {type: 'error', msg: 'We are unable to verify your email address. Please check your information and try again.'}
                            ];
                            //see if error message required
                            $scope.verifyEmail();
                            $scope.form1.email.$invalid  = true;
                            $scope.isValidEmail = false;
                        });
                    }
                };

                $scope.validateForm = function () {
					$scope.validateEmail();
                    if ($scope.form1.$invalid) {
                            $scope.form1.email.$dirty = true;

                        return false;
                    }

                    return true;
                };

                $scope.validateEmail = function() {
                    $scope.form1.email.$dirty = true;
                    $scope.errorMessage = '';
                    if($scope.form1.email.$error.required) { // No email entered
                        $scope.errorMessage = 'Please enter your email address.';
                         $translate('BM.Login.EmailRequiredError').then(function(data){
                            $scope.errorMessage = data;
                        });
                    } else if($scope.form1.email.$invalid || !$scope.form1.email.$valid) {
                        $scope.errorMessage = 'Please enter a valid email address.';
                        $translate('BM.Login.ValidEmailError').then(function(data){
                            $scope.errorMessage = data;
                        });
                    } else {
                            $scope.errorMessage = '';
                    }
                };

                $scope.verifyEmail = function(){
                    if($scope.alerts.length > 0) {
                         $translate('BM.Login.ResetPasswordEmailServiceError').then(function(data){
                            $scope.errorMessage = data;
                        });
                    }
                };

                $scope.prepForValidation = function() {
                    $scope.form1.email.$dirty = false;
                    $scope.form1.email.$invalid = false;
                    $scope.errorMessage = '';
                };
            }
        ]);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.forgottenPassword')

        .controller('resetPasswordCtrl', ['$scope', '$translate', '$uibModal', '$uibModalInstance', 'PasswordValidationFactory', 'ResetPasswordService',
            function ($scope, $translate, $uibModal, $uibModalInstance, PasswordValidationFactory, ResetPasswordService) {

                var vm = this;

                vm.data = {
                    password  : '',
                    confirm : ''
                };

                vm.prohibitedChars = [];

                vm.cpidData = ResetPasswordService.cpidData;
                vm.cpidEmailData = ResetPasswordService.cpidEmailData;
                vm.showPassword = false;
                vm.visitedPassword = false;
                vm.formMsgUnconfirmedPassword = '';
                vm.confirmInScope = false;
                vm.hasFocusPassword = false;
                vm.focusResetPassword = true;
                vm.passwordUsedBefore = false;
                vm.passwordTooCommon = false;
                vm.passwordRulesData = {};

                var formSubmitted = false;

                var msgErrorOccurredResettingPassword = '';
                var msgConfirmPasswordInvalidData = '';
                var msgConfirmPasswordNoData = '';
                var msgUserInfoPwdError = '';

                vm.requirePasswordChange = ResetPasswordService.requirePasswordChange;

                PasswordValidationFactory.loadPasswordRules().then(function (resp) {
                    angular.extend(vm.passwordRulesData, resp);
                });

                vm.setConfirmInScope = function() {
                    vm.confirmInScope = true;
                };

                vm.setConfirmOutOfScope = function() {
                    translateErrors();
                    vm.confirmInScope = false;
                };

                vm.setPasswordInScope = function() {
                    vm.hasFocusPassword = true;
                };

                vm.setPasswordOutOfScope = function() {
                    vm.hasFocusPassword = false;
                    translateErrors();
                };

                vm.closeAlert = function (index){
                    vm.alerts.splice(index, 1);
                };

                vm.close = function () {
                    $uibModalInstance.close();
                };

                vm.back = function () {
                    // Close the current dialog
                    $uibModalInstance.close();
                };

                vm.next = function () {
                    translateErrors();
                    if (vm.resetPasswordForm.$valid && vm.isConfirmPasswordValid()) {
                        ResetPasswordService.reset(getCpid(), vm.data.password).then (function () {
                            // Close the current dialog
                            $uibModalInstance.close();

                            // Go to the set password page
                            $uibModal.open({
                                templateUrl: 'components/forgotten-password/password-changed-confirmation.2js.html',
                                controller: 'confirmationCtrl',
                                backdrop: 'static'
                            });
                        },
                        function (err) {
                            if(err.data.error === 'PASSWORD_CONTAINS_USERINFO'){
                                vm.alerts = [{type: 'danger', msg: msgUserInfoPwdError}];
                            } else {
                                vm.alerts = [{type: 'danger', msg: msgErrorOccurredResettingPassword}];
                            }
                        });
                    }
                };

                vm.togglePassword = function () {
                    vm.showPassword = !(vm.showPassword);
                };

                vm.validateForm = function () {
                    var isValid = false;
                    formSubmitted = true;

                    if(!vm.resetPasswordForm.password.$dirty) {
                        vm.resetPasswordForm.password.$dirty = true;
                    }
                    if(!vm.resetPasswordForm.confirm.$dirty) {
                        vm.resetPasswordForm.confirm.$dirty = true;
                    }

                    if(vm.resetPasswordForm.$valid) {
                        if(vm.isConfirmPasswordValid()) {
                            isValid = true;
                        }
                    }

                    return isValid;

                };

                vm.isConfirmPasswordValid = function() {
                    var isValid = false;
                    var firstPassword = '';
                    var secondPassword = '';

                    if(vm.data.confirm) {
                        vm.data.confirm = vm.data.confirm.trim();
                    }

                    if(vm.data.confirm) {
                        if(!vm.resetPasswordForm.password.$error.required) {
                            firstPassword = vm.data.password;
                            secondPassword = vm.data.confirm;

                            if((secondPassword.length === firstPassword.length) && (secondPassword === firstPassword)) {
                                isValid = true;
                            }
                        }
                    }
                    return isValid;
                };

                vm.isConfirmPasswordInvalid = function() {
                    var hasError = false;
                    var firstPassword = '';
                    var secondPassword = '';

                    // Get the data to check
                    if(angular.isUndefined(vm.data.password)){
                        firstPassword = '';
                    } else {
                        firstPassword = vm.data.password;
                    }
                    if(angular.isUndefined(vm.data.confirm)){
                        secondPassword = '';
                    } else {
                        secondPassword = vm.data.confirm;
                    }

                    // check the data
                    if(vm.confirmInScope) {
                        vm.resetPasswordForm.confirm.$dirty = true;

                        if(secondPassword === firstPassword) {
                            vm.formMsgUnconfirmedPassword = '';
                        } else if(firstPassword.slice(0, secondPassword.length) !== secondPassword) {
                            hasError = true;
                            if(secondPassword === '') {
                                vm.formMsgUnconfirmedPassword = msgConfirmPasswordNoData;
                            } else {
                               vm.formMsgUnconfirmedPassword = msgConfirmPasswordInvalidData;
                            }
                        } else {
                            vm.formMsgUnconfirmedPassword = '';
                        }
                    } else {
                        if((firstPassword !== secondPassword) && vm.resetPasswordForm.confirm.$dirty) {
                            hasError = true;
                            if(secondPassword === '') {
                                vm.formMsgUnconfirmedPassword = msgConfirmPasswordNoData;
                            } else {
                               vm.formMsgUnconfirmedPassword = msgConfirmPasswordInvalidData;
                            }
                        } else if((secondPassword === '') && vm.resetPasswordForm.confirm.$dirty) {
                            hasError = true;
                            vm.formMsgUnconfirmedPassword = msgConfirmPasswordNoData;
                        }
                    }

                    return hasError && vm.resetPasswordForm.password.$valid;
                };

                vm.isResetFromSecurityQuestions = function() {
                    var result = true;

                    if(!vm.cpidData) {
                        result = false;
                    }

                    return result;
                };

                vm.getProhibitedCharsMessage = function() {
                    return vm.passwordRulesData.rules.prohibitedCharacterRule.label + ' : ' +
                    vm.passwordRulesData.rules.prohibitedCharacterRule.getInvalidChars(vm.resetPasswordForm.password.$viewValue).join(' ');
                };

                function getCpid(){
                    if(!!vm.cpidData && !!vm.cpidData.cpid) {
                        return vm.cpidData.cpid;
                    } else {
                        return !!vm.cpidEmailData ? vm.cpidEmailData : undefined;
                    }
                }

                function translateErrors(){
                    $translate('BM.Login.ResetPassword.PasswordsDoNotMatch').then(function(data){
                        msgConfirmPasswordInvalidData = data;
                    });
                    $translate('BM.Login.ResetPassword.PasswordNoData').then(function(data){
                        msgConfirmPasswordNoData = data;
                    });
                    $translate('BM.Login.ResetPassword.ErrorOccurredResetPassword').then(function(data){
                        msgErrorOccurredResettingPassword = data;
                    });
                    $translate('BM.Login.ResetPassword.PasswordContainsPersonalInfo').then(function(data){
                        msgUserInfoPwdError = data;
                    });
                }

                $scope.vm = vm;
                $scope.getCpid = getCpid;
            }
        ]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.forgottenPassword')

        .controller('confirmationCtrl', ['$scope', '$uibModal', '$uibModalInstance',
            function ($scope, $uibModal, $uibModalInstance) {

                $scope.close = function () {
                    $uibModalInstance.close();
                };
            }
        ]);

})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmLoginCookiePolicy', [
    'pascalprecht.translate',
    'bmPrivacyPolicy'
  ])
  .component('bmLoginCookiePolicy', {
    templateUrl: 'components/cookie-policy/cookie-policy.2js.html',
    controller: cookiePolicy,
  });

  ////////////

  // Component implementation
  cookiePolicy.$inject = ['$scope', 'bmPrivacyPolicyService', 'bmPrivacyPolicyUriMap'];
  function cookiePolicy($scope, privacyService, privacyUriMap){
    /*jshint validthis:true */
    var ctrl = this;

    ctrl.$onInit = init;

    //////////////////////////////

    function init(){
      // load up initial version of cookie policy
      setCookiePolicyUri();

      // add language change event watch to change text when lanuage changes
      $scope.$on('bmLanguageChangeSuccess', setCookiePolicyUri);
    }

    function setCookiePolicyUri(){
      privacyService.getPrivacyPolicyUri().then(function(uri){
        ctrl.cookiePolicyUri = uri + '/#cookies';
      }, function(){
        // fall back to US for any errors
        ctrl.cookiePolicyUri = privacyUriMap['en-US']  + '/#cookies';
      });
    }
  }
})(window.angular);

(function (angular) {
	'use strict';
	angular.module('bmAccountLinkAuth', [])
	.component('bmAccountLinkAuth', {
		templateUrl: 'components/account-link-auth/account-link-auth.2js.html',
		controller: accountLinkAuth,
		controllerAs: 'vm',
		bindings: {
			user: '<',
			product: '<',
            disableEditingFeatures: '<'
		}
	});
	accountLinkAuth.$inject = [
		'bmAccess',
		'$templateRequest',
		'$element',
		'$scope',
        '$location',
        '$uibModal',
		'AuthenticatedSession',
        'ResetPasswordService',
        'SelectResetPasswordMethodService',
        'userRegistrationService',
        '$state',
        'bmMultifactorService'
	];
	function accountLinkAuth(
		bmAccess,
		$templateRequest,
		$element,
		$scope,
        $location,
        $uibModal,
		session,
        ResetPasswordService,
        selectResetPasswordMethodService,
        userRegistrationService,
        $state,
        mfaService
	) {
        /*jshint validthis:true */
		var vm = this;

		this.$onInit = function() {
            vm.isLoaderBusy = false;
            vm.uid = vm.user.userId;
		};

        $scope.openChangeEmailModal = function(uid) {
            var changeEmailModalInstance = $uibModal.open({
                templateUrl: 'registration/change-registration-email/change-registration-email.2js.html',
                controller: 'ChangeRegistrationEmailCtrl',
                backdrop: 'static',
                resolve: {
                    uid: function() {
                        return uid;
                    }
                },
            });
            changeEmailModalInstance.result.then(function(result) {
                vm.user.userId = result;
                userRegistrationService.setUserInfo(vm.user);
                userRegistrationService.validateUserIdIsUnique(result).then(function (response){
                        if(response.data.results === 'not_found'){
                            //go to regular registration with updated uid as url param
                            var changedEmail = encodeURIComponent(result);
                            $location.url('registration?token=' + $location.search().token + '&uid=' + changedEmail);
                        }
                });
            });
        };
        $scope.registerLinkedAccount = function(user, pwd) {
            vm.isLoaderBusy = true;
            var userData = { uid: user.userId, pwd: pwd, type: 'TRID' };
            mfaService.verifyLoginData(userData).then(function() {
                vm.isLoaderBusy = false;
                user.linkedAccount = true;
                user.password = pwd;
                vm.isLoaderBusy = true;
                userRegistrationService.createUser(user).then(function(){
                    vm.isLoaderBusy = false;
                    $state.go('registration-complete');
                }, function() {
                    vm.isLoaderBusy = false;
                    vm.error = { unknown: true };
                });
            }, function() {
                vm.isLoaderBusy = false;
                vm.error = { invalid: true };
            });
        };
        $scope.linkAccounts = function (uid, pwd) {
            $scope.error = null;
            if ($scope.form.$valid) {
                session.create(uid, pwd).then(function() {
                    // AccountLinkingService
                }).catch(function(result) {
                    $scope.error = {};
                    $scope.$broadcast('bm-signin-failed');
                    switch (result.status) {
                        case 401:
                            // Password Expiration
                            if (result.data &&
                                result.data.subcode === 101 &&
                                result.data.data.length > 0) {

                                $scope.error = null;

                                // Set the cid to be used later
                                ResetPasswordService.setEmailCPID(result.data.data[0].value);
                                ResetPasswordService.setRequired(true);

                                // samba uses a full view instead of a modal
                                if($scope.product && $scope.product.resetRoute && $scope.product.resetRoute !== ''){
                                    $location.url($scope.product.resetRoute);
                                } else {
                                    // Go to the set password page
                                    $uibModal.open({
                                        templateUrl: 'components/forgotten-password/reset-password.2js.html',
                                        controller: 'resetPasswordCtrl',
                                        backdrop: 'static'
                                    });
                                }
                           } /* Credit Hold */ else if(result.data &&
                                result.data.subcode === 102 &&
                                result.data.data.length > 0) {
                                $scope.error.forbidden = true;
                                break;
                            } /* Firm Lock */ else if(result.data &&
                                result.data.subcode === 103 &&
                                result.data.data.length > 0) {
                                $scope.error.forbidden = true;
                                break;
                            }/* Invalid Login */ else {
                                $scope.error.invalid = true;
                            }

                            break;
                        case 403:
                            $scope.error.forbidden = true;
                            break;
                        default:
                            $scope.error.unknown = true;
                    }
                });
            } else {
                $scope.error = { incomplete: true };
            }
        };
        $scope.openForgottenPasswordDialog = function() {
            $scope.userData = {
                email : '',
            };

            if((!angular.isUndefined($scope.uid)) && ($scope.uid !== '')) {
                $scope.userData.email = $scope.uid;
            }

            selectResetPasswordMethodService.setUserData($scope.userData);

            // samba uses a full view instead of a modal
            if($scope.product && $scope.product.forgotRoute && $scope.product.forgotRoute !== ''){
                $location.url($scope.product.forgotRoute);
                return;
            }

            //If IAC is enabled continue to the popup for change password otherwise redirect to CIAM account
            bmAccess.has('Platform_3709696').then(function(){
                $uibModal.open({
                    templateUrl: 'components/forgotten-password/select-reset-password-method.2js.html',
                    controller: 'forgottenPasswordCtrl',
                    backdrop: 'static'
                });
            }, function() {
                //open the CIAM account page
                window.open('https://account.thomsonreuters.com/en-us/profile', '_blank');
            });

        };
	}
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmTerms', [
    'pascalprecht.translate',
    'bluemoon.help'
  ])
  .component('bmTerms', {
    templateUrl: 'components/terms/terms-accept.2js.html',
    controller: termsAccept,
    bindings: {
      accepted: '<',
      language: '<'
    }
  });

  termsAccept.$inject = ['$rootScope'];
  function termsAccept($rootScope){
    /*jshint validthis:true */
    var ctrl = this;
    ctrl.checkboxClick = checkboxClick;
    ctrl.$onInit = init;

    function init(){
      // default to AR since they're the only ones right now
      ctrl.language = ctrl.language ? ctrl.language : 'es-AR';
      ctrl.langCodeMap = {
        'en-US': 'us-en',
        'es-AR': 'ar-es'
      };
      ctrl.termsUri = getOnvioTermsUri();
    }

    function checkboxClick() {
      var accepted = ctrl.accepted;
      $rootScope.$broadcast('acceptTermsChange', {accepted: accepted});
    }

    function getOnvioTermsUri(){
      //eventually this may need to access profiles/help endpoint to get the url
      return '/ua/help/' + ctrl.langCodeMap[ctrl.language] + '/staff/general-articles/terms-conditions-onvio.htm';
    }
  }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPasswordValidator', []).directive('passwordValidator', ['PasswordValidationFactory', '$q', '$http', '$timeout',
        function(PasswordValidationFactory, $q, $http, $timeout){
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ngModel) {
                    var passwordRules;
                    var usedTimeout;
                    var commonTimeout;
                    var delay = 500; // time to wait before executing async validators, in milliseconds

                    // Load up password validation rules
                    PasswordValidationFactory.loadPasswordRules().then(function(response){
                        passwordRules = response.rules;

                        ngModel.$validators.invalidPasswordLength = function(value) {
                            return passwordRules.characterLengthRule.test(value);
                        };

                        ngModel.$validators.invalidPasswordRules = function(value) {
                            var rulesPassed = 0;
                            var currentRule;

                            for(var pos = 0; pos < passwordRules.characterTypeRules.length; pos++) {
                                currentRule = passwordRules.characterTypeRules[pos];

                                if(currentRule.test(value)) {
                                    rulesPassed++;
                                }
                            }

                            return rulesPassed >= response.charClassReq;
                        };

                        ngModel.$validators.invalidPasswordCharacters = function(value) {
                            return !(passwordRules.prohibitedCharacterRule.test(value));
                        };
                    });

                    ngModel.$asyncValidators.invalidPasswordUsed = function(modelValue){

                        // if a previously-set timeout exists, cancel it.
                        if(!!usedTimeout){
                            $timeout.cancel(usedTimeout);
                            usedTimeout = undefined;
                        }

                        // ignore this rule if the model is empty,
                        // the model element's scope does not contain the necessary accessor function,
                        // or the provided accessor function returns an undefined/null value.
                        if(ngModel.$isEmpty(modelValue) || typeof scope.getCpid !== 'function' || !(scope.getCpid())){
                            return $q.resolve();
                        }

                        // create our deferred object
                        var def = $q.defer();

                        // create a new timeout for this validator
                        // we only want to fire off a request when we think the user is done typing
                        usedTimeout = $timeout( function(){
                            var config = {
                                method: 'POST',
                                url: '/api/profiles/v2/password/check-history',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: {
                                    cpid: scope.getCpid(),
                                    password: modelValue
                                }
                            };

                            $http(config).then(
                                function(response){
                                    // mark the field as touched so our messages appear if need be
                                    // this is to fix a bug caused by snapping KB focus to an element
                                    ngModel.$setTouched();

                                    if(!!response.data && !!response.data.usedPreviously){
                                        def.reject();
                                    } else {
                                        def.resolve();
                                    }
                                },
                                function(){
                                    // mark the field as touched so our messages appear if need be
                                    // this is to fix a bug caused by snapping KB focus to an element
                                    ngModel.$setTouched();

                                    def.resolve();
                                }
                            );
                        }, delay);

                        // return our deferred object as a promise
                        return def.promise;
                    };

                    ngModel.$asyncValidators.invalidPasswordCommon = function(modelValue){

                        // if a previously-set timeout exists, cancel it.
                        if(!!commonTimeout){
                            $timeout.cancel(commonTimeout);
                            commonTimeout = undefined;
                        }

                        // ignore this rule if the model is empty
                        if(ngModel.$isEmpty(modelValue)){
                            return $q.resolve();
                        }

                        // create our deferred object
                        var def = $q.defer();

                        // create a new timeout for this validator
                        // we only want to fire off a request when we think the user is done typing
                        commonTimeout = $timeout( function(){
                            var config = {
                                method: 'POST',
                                url: '/api/profiles/v2/password/check-common',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: {
                                    password: modelValue
                                }
                            };

                            $http(config).then(
                                function(response){
                                    // mark the field as touched so our messages appear if need be
                                    // this is to fix a bug caused by snapping KB focus to an element
                                    ngModel.$setTouched();

                                    if(!!response.data && !!response.data.tooCommon){
                                        def.reject();
                                    } else {
                                        def.resolve();
                                    }
                                },
                                function(){
                                    // mark the field as touched so our messages appear if need be
                                    // this is to fix a bug caused by snapping KB focus to an element
                                    ngModel.$setTouched();

                                    // resolve the promise because otherwise the "password too common" error will be visible
                                    def.resolve();
                                }
                            );
                        }, delay);

                        // return our deferred object as a promise
                        return def.promise;
                    };
                }
            };
        }]
    );
})(window.angular);

(function (angular) {
	'use strict';

	angular.module(
		'onvio-userRegistration',
	[
		'ui.bootstrap',
		'bento.services',
		'bento.wizard',
		'bluemoon.passwordValidation',
		'bento.select',
		'bluemoon.components',
		'bmContactNameParser',
		'bmPrivacyPolicy',
		'bmLoginCookiePolicy',
        'bmTerms',
        'bmAccountLinkAuth'
	]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module(
		'samba-Registration',
		[
			'ui.bootstrap',
			'bento.services',
			'bento.wizard',
			'bluemoon.passwordValidation',
			'bento.select',
      'bluemoon.components'
		]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('pinValidator', ['$rootScope', '$q', 'userRegistrationService',
        function($rootScope, $q, userRegistrationService){
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ngModel) {
                    ngModel.$asyncValidators.pinInvalid = function(modelValue, viewValue){
                        var value = modelValue || viewValue;
                        return validatePinAsync(value);
                    };

                    function validatePinAsync(value){
                        var deferred = $q.defer();

                        $rootScope.$emit('bm-busy-loading-on');

                        userRegistrationService.validatePin(value).then(function(){
                            $rootScope.$emit('bm-busy-loading-off');
                            deferred.resolve();
                        }, function(){
                            $rootScope.$emit('bm-busy-loading-off');
                            deferred.reject();
                        });

                        return deferred.promise;
                    }
                }
            };
        }]
    );
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('emailValidator', ['$rootScope', '$q', 'userRegistrationService',
        function($rootScope, $q, userRegistrationService){
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ngModel) {
                    ngModel.$validators.unableToVerifyEmail = function(){
                        return true;
                    };

                    ngModel.$asyncValidators.emailInUse = function(modelValue, viewValue){
                        var value = modelValue || viewValue;
                        ngModel.$setValidity('unableToVerifyEmail', true);
                        return validateUserIdAsync(value);
                    };

                    function validateUserIdAsync(value){
                        var deferred = $q.defer();

                        $rootScope.$emit('bm-busy-loading-on');

                        userRegistrationService.validateUserIdIsUnique(value).then(function(response){
                            $rootScope.$emit('bm-busy-loading-off');
                            var data = response.data;

                            if(angular.isUndefined(data) || angular.isUndefined(data.results)){
                                ngModel.$setValidity('unableToVerifyEmail', false);
                                deferred.resolve();
                            } else if(data.results === 'found') {
                                deferred.reject();
                            } else {
                                deferred.resolve();
                            }
                        }, function(){
                            $rootScope.$emit('bm-busy-loading-off');
                            ngModel.$setValidity('unableToVerifyEmail', false);
                            deferred.resolve();
                        });

                        return deferred.promise;
                    }
                }
            };
        }]
    );
})(window.angular);

(function (angular){
	'use strict';

	angular.module('onvio-userRegistration').controller('RegistrationCompleteCtrl', registrationComplete);
	registrationComplete.$inject = ['resolvedUser', 'product', 'bmTheme', '$window', '$state', 'bmEnvironment','bmEnvironmentConst'];

	function registrationComplete(resolvedUser, product, theme, $window, $state, bmEnvironment, bmEnvironmentConst){
		/*jshint validthis:true */
		var vm = this;
		vm.user = resolvedUser;
		vm.product = product;
		vm.done = done;
		vm.ccVnext = false;
		vm.isAuth0Enabled = false;
		var logoutUrl;

		// load up the theme for the user to get the signout url for redirect
		theme.applyTheme = angular.noop;
		theme.useTheme = true;

		theme.load({ company: resolvedUser.companyId }).then(function(){
			var themeHeader = (angular.isDefined(theme.data) && theme.data.header !== null && angular.isDefined(theme.data.header)) ? theme.data.header : {};

			if(angular.isDefined(themeHeader.logoutUrl) && themeHeader.logoutUrl !== ''){
				logoutUrl = themeHeader.logoutUrl;
			}
		});
		// check CCVNext IAC
		bmEnvironment.getEnvironmentAsync().then(function(env) {
			vm.ccVNext = env.InfrastructureAccessControls.includes('ClientCenterVnext');
		}).catch(function() {
			vm.ccVNext = false;
		});

        bmEnvironment.getEnvironmentAsync().then(function(env) {
			vm.isAuth0Enabled = env.InfrastructureAccessControls.includes('Platform_DisableAuth0Phase2');
		}).catch(function() {
			vm.isAuth0Enabled = false;
		});

		//return to login
		function done() {
			// Create a cookie for the login page
			var path = '/';

			if(angular.isDefined(vm.user) && angular.isDefined(vm.user.userId)) {
				setRegistrationCookie('BMRegisteredUser', vm.user.userId, 2, path);
			}

			// If the user belongs to CSWeb, redirect to the CSWeb login page
			if (vm.product.name === 'auth') {
				var csWebUrl = getMappingCsWebUrl();
				$window.location.href = 'https://' + csWebUrl + '/myaccount/login.aspx';
				// Return otherwise the function will continue to execute
				return;
			}

			// theme the login if appropriate
			// redirect to client or staff login
			if ((vm.user.contextType === 'client' || vm.user.contextType === 'staff') && vm.user.companyId) {
				theme.persistTheme(vm.user.companyId);

				if(logoutUrl){
					$window.location.href = logoutUrl;
				} else if (vm.user.group === 'BR_CLIENT_EMPLOYEE') {
					// forward to portal do empregado route of Brazil Employee Portal (Only Brazil has this GROUP)
					$window.location.href = 'https://' + $window.location.host + '/portaldoempregado/auth';
				} else if (vm.user.contextType === 'client' && vm.ccVNext && vm.user.group !== 'CLIENT_MYPAY' && vm.user.group !== 'REFERRING_ACCOUNTANT') {
					// forward to company route of CCVNext for contextType of client without mypay groups in ClientCenterVnext envvironments
					$window.location.href = 'https://' + $window.location.host + '/clientcenter/company/' + vm.user.companyId;
				} else {
				// sledgehammer to pick up client theming
					$window.location.hash = '';
					$window.location.reload();
				}
			} else if (vm.user.contextType === 'client' && vm.ccVNext && vm.user.group !== 'CLIENT_MYPAY' && vm.user.group !== 'REFERRING_ACCOUNTANT') {
				// Forward to CCVNext for contextType of client without mypay groups in ClientCenterVnext environments
				$window.location.href = 'https://' + $window.location.host + '/clientcenter';
            } else if(!vm.isAuth0Enabled){
                var ulrOidc = 'https://' + $window.location.host + '/api/security/v1/oidc/login';
                $window.location.href = ulrOidc;
            } else {
				// Redirect to the login page
				$state.go('main');
			}
		}

		function setRegistrationCookie(cname, cvalue, exmins, path) {
			var d = new Date();
			d.setTime(d.getTime() + (exmins * 60 * 1000));

			var expires = 'expires=' + d.toUTCString();
			document.cookie = cname + '=' + cvalue + '; ' + expires + '; ' + path;
		}

		function getMappingCsWebUrl() {
			var url = 'cs.thomsonreuters.com';
			switch (bmEnvironmentConst.type) {
				case 'CI':
					url = 'cswebdev.int.thomsonreuters.com';
					break;
				case 'DEMO':
					url = 'cswebdev.int.thomsonreuters.com';
					break;
				case 'QED':
					url = 'cswebqa.int.thomsonreuters.com';
					break;
				default:
					url = 'cs.thomsonreuters.com';
					break;
			}
			return url;
		}
	}

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('onvio-userRegistration').controller('LinkRegistrationCtrl', linkRegistration);
    linkRegistration.$inject = [
        '$scope',
        '$location',
        '$uibModal',
        '$translate',
        'bmAccess',
        'languageStorageManager',
        'resolvedUser',
        'product'
    ];

    function linkRegistration($scope, $location, $uibModal, $translate, bmAccess, langMgr, resolvedUser, product){
        /*jshint validthis:true */
        var vm = this;
        var prefLang = langMgr.get() || 'en-US';
        vm.user = resolvedUser;
        vm.loadedProduct = product;
        vm.helpLangCode = prefLang.toLowerCase().split('-').reverse().join('-');
        // handle no user data
        if(angular.isUndefined(resolvedUser) ){
            $translate('bm.registration.load.error').then(function(value){
               vm.registrationAlerts.push({ type: 'danger', msg: value, closeable: false});
            });

            return;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').controller('ChangeRegistrationEmailCtrl', changeRegistrationEmailCtrl);

    changeRegistrationEmailCtrl.$inject = ['$scope', '$uibModalInstance'];
    function changeRegistrationEmailCtrl($scope, $uibModalInstance){
        /*jshint validthis:true */
        $scope.email = '';
        $scope.changeEmail = function() {
            $uibModalInstance.close($scope.email);
        };

        $scope.dismissModal = function() {
            $uibModalInstance.dismiss();
        };
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('valueCompareValidator', [function(){
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ngModel){
                    var compare;
                    var currentValue;

                    scope.$watch(attr.shareValidate, function(newValue){
                        // store value for comparison
                        compare = newValue;

                        /* since this is a dependent field, set the validitity of the comparison when the value
                        being compared is changed */
                        if(angular.isDefined(currentValue)){
                            ngModel.$setValidity('invalidComparison', currentValue === compare);
                        }
                    }, true);

                    ngModel.$validators.invalidComparison = function(value) {
                        // store current value for comparison with shared value
                        currentValue = value;

                        // new value undefined means that the compare field is not valid
                        if(angular.isUndefined(compare)){
                            return false;
                        }

                        // for password comparison only show the error if typed value differs from the start of the value to compare
                        // return value === compare;s
                        var startsWith = angular.isUndefined(value) ? false : compare.slice(0, value.length) === value;

                        return startsWith || value === compare;
                    };
                }
            };
        }]
    );
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('onvio-userRegistration')

        .factory('userRegistrationService', ['$rootScope', '$http', '$q', '$location', 'bmLanguageManager', 'myAccountService', 'bmContactNameParser',
            function ($rootScope, $http, $q, $location, bmLanguageManager, myAccountService, bmContactNameParser) {
                var user;
                var questionCounter;
                var masterQuestionsList;
                var baseUser;

                var factory = {
                    user : user,
                    load: load,
                    loadCompleteUser: loadCompleteUser,
                    loadTabAccountPrefixInfo: loadTabAccountPrefixInfo,
                    loadTabAccountSuffixInfo: loadTabAccountSuffixInfo,
                    loadTabSecurityQuestions: loadTabSecurityQuestions,
                    setUserInfo: setUserInfo,
                    validatePin: validatePin,
                    validateUserIdIsUnique: validateUserIdIsUnique,
                    updateConsentToContactPreference: updateConsentToContactPreference,
                    createUser: createUser,
                    createCompany: createCompany,
                    filterMasterQuestions: filterMasterQuestions,
                    createCompanyOnSelfRegistration: createCompanyOnSelfRegistration,
                    registerTrialRemovalTask: registerTrialRemovalTask
                };

                return factory;

                //////////

                function loadCompleteUser(){
                    return load().then(function(){
                        if(angular.isUndefined(user)){
                            return undefined;
                        }

                        return setUserQuestions().then(function(){
                            return user;
                        });
                    });
                }

                function setUserQuestions(){
                    // TODO: MAKE SURE USER IS LOADED HERE
                    return loadTabSecurityQuestions().then(function(response){
                        if(angular.isUndefined(user.questions) || user.questions.length === 0){
                            var defaultQuestion = { questionId: '', question: '', answer: '', selectedQuestion: undefined };
                            user.questions = [defaultQuestion, angular.copy(defaultQuestion), angular.copy(defaultQuestion)];
                        } else {
                            // reset the current user questions
                            angular.forEach(user.questions, function(userQuestion){
                                userQuestion.questionId = '';
                                userQuestion.question = '';
                                userQuestion.answer = '';
                                userQuestion.selectedQuestion = undefined;

                                // Clear the existing array without creating a new array object as this will kill scope
                                if(angular.isDefined(userQuestion.masterList) && userQuestion.masterList.length > 0){
                                    var removeCounter = userQuestion.masterList.length;

                                    while(removeCounter > 0){
                                        removeCounter--;
                                        userQuestion.masterList.splice(removeCounter, 1);
                                    }
                                }
                            });
                        }

                        masterQuestionsList = response.data;
                        filterMasterQuestions();
                    });
                }

                function filterMasterQuestions(listIndex, workingUser){
                    baseUser = angular.isUndefined(workingUser) ? user : workingUser;

                    // listIndex = list that the value was changed in
                    // Need to filter selected questions out of other master lists so the same question can't be selected twice
                    var currentQuestionList;

                    for(questionCounter = 0; questionCounter < baseUser.questions.length; questionCounter++){
                        // Don't need to filter - skip the list that was just selected
                        if(angular.isDefined(listIndex) && questionCounter === listIndex){
                            continue;
                        }

                        // Get a filtered list
                        currentQuestionList = angular.copy(masterQuestionsList);
                        currentQuestionList = currentQuestionList.filter(notAlreadySelected);

                        // The first time through will not have a master list of questions
                        if(angular.isUndefined(baseUser.questions[questionCounter].masterList)){
                            baseUser.questions[questionCounter].masterList = currentQuestionList;
                            continue;
                        }

                        var removeCounter = baseUser.questions[questionCounter].masterList.length;
                        var questionIdAsInt = -1;

                        // has a question been selected yet
                        if(angular.isDefined(baseUser.questions[questionCounter].selectedQuestion) &&
                            angular.isDefined(baseUser.questions[questionCounter].selectedQuestion.questionId)){
                                questionIdAsInt = parseInt(baseUser.questions[questionCounter].selectedQuestion.questionId);
                        }

                        // Clear the existing array without creating a new array object as this will kill scope
                        while(removeCounter > 0){
                            removeCounter--;
                            // Don't clear the selected question
                            if(baseUser.questions[questionCounter].masterList[removeCounter].questionId === questionIdAsInt){
                                continue;
                            }

                            baseUser.questions[questionCounter].masterList.splice(removeCounter, 1);
                        }

                        // Append to the array without creating a new array object
                        for(var addCounter = 0; addCounter < currentQuestionList.length; addCounter++){
                            if(currentQuestionList[addCounter].questionId === questionIdAsInt){
                                continue;
                            }

                            if(currentQuestionList[addCounter].questionId < questionIdAsInt){
                                baseUser.questions[questionCounter].masterList.unshift(currentQuestionList[addCounter]);
                            } else {
                                baseUser.questions[questionCounter].masterList.push(currentQuestionList[addCounter]);
                            }
                        }
                    }
                }

                function notAlreadySelected(element){
                    var alreadySelected = false;
                    var questionIdAsInt;

                    for(var counter = 0; counter < baseUser.questions.length; counter++){
                        if(alreadySelected){
                            break;
                        }

                        if(angular.isUndefined(baseUser.questions[counter].selectedQuestion)){
                            alreadySelected = false;
                            continue;
                        }

                        questionIdAsInt = parseInt(baseUser.questions[counter].selectedQuestion.questionId);

                        // questionCounter is global and represents the current list being filtered
                        if(element.questionId === questionIdAsInt){
                            if(angular.isUndefined(baseUser.questions[questionCounter].selectedQuestion)){
                                alreadySelected = true;
                                continue;
                            }

                            alreadySelected = (questionIdAsInt !== baseUser.questions[questionCounter].selectedQuestion.questionId);
                            continue;
                        }

                        alreadySelected = false;
                    }

                    return !alreadySelected;
                }

                function load(){
                    var path = '/api/profiles/v1/registration';
                    var url = path + '?token=' + encodeURIComponent($location.search().token);

                    return $http({
                        method: 'GET',
                        url: url
                    }).then(function(resp) {
                        if (resp.data.user){
                            if(resp.data.user.language){
                                bmLanguageManager.setUserLanguageAsync(resp.data.user.language);
                            }
                            if (resp.data.type) {
                                resp.data.user.contextType = resp.data.type;
                                resp.data.user.group = $location.search().group;
                            }
                            setUserInfo(resp.data.user, resp.data.prompt);
                        }

                        return user;
                    });
                }

                function loadTabAccountPrefixInfo(language) {
                    return myAccountService.getNamePrefixListAsync(language || 'en-US');
                }

                function loadTabAccountSuffixInfo(language) {
                    return myAccountService.getNameSuffixListAsync(language || 'en-US');
                }

                function loadTabSecurityQuestions() {
                    var url = '/api/profiles/v1/security-questions';

                    return $http({
                        method: 'GET',
                        url: url
                    });
                }

                //Requires udslongtoken set in authorization header.
                function updateConsentToContactPreference() {
                    var url = '/api/samba-contact/v1/contacts/preferences/consent-to-contact?consent=true';

                    return $http({
                        method: 'PUT',
                        url: url
                    });
                }

                function createUser(userIn){
                    if(userIn) {
                        user = userIn;
                    }
                    user.testData = true;

                    var path = '/api/profiles/v1/registration';
                    var token = $location.search().token;
                    var url = path + '?token=' + encodeURIComponent(token);

                    if (user.pin) {
                        url += '&pin=' + encodeURIComponent(user.pin);
                    }

                    // photo must only be the base64 string
                    var photo = '';

                    if(angular.isDefined(user.photo) && user.photo !== ''){
                        var split = user.photo.split(',');
                        photo = split[1];
                    }

                    var opts = {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    };

                    var questions = [];

                    angular.forEach(user.questions, function(question){
                        if(angular.isDefined(question.selectedQuestion)){
                            questions.push({
                                questionId: question.selectedQuestion.questionId,
                                answer: question.answer
                            });
                        }
                    });

                    if (angular.isUndefined(user.linkedAccount)) {
                        user.linkedAccount = false;
                    }

                    var data = {
                        email: user.userId,
                        password: user.password,
                        prefix: user.prefix,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        middleName: user.middleName,
                        suffix: user.suffix,
                        language: user.language,
                        bluemoonFirmId: user.bluemoonFirmId,
                        photo: photo,
                        questions: questions,
                        linkedAccount: user.linkedAccount
                    };

                    return $http.put(url, data, opts);
                }

                function registerTrialRemovalTask(companyId) {
                    var body = {
                        companyId: companyId
                    };
                    return $http.post('/api/samba-company/v1/scheduled-job/new-company-provisioned', body);
                }

                function setUserInfo(userInfo, prompt){
                    if(angular.isUndefined(user)){
                        user = {};
                    }

                    user.prompt = prompt;

                    if(angular.isUndefined(userInfo)){
                        return;
                    }

                    var nameInfo = bmContactNameParser.formatName({
                        prefix: userInfo.prefix,
                        givenName: userInfo.firstName,
                        additionalName: userInfo.middleName,
                        familyName: userInfo.lastName,
                        suffix: userInfo.suffix
                    });

                    user.firmId = userInfo.firmId;
                    user.userId = userInfo.email ? userInfo.email : userInfo.userId;
                    user.password = userInfo.password;
                    user.confirmPassword = userInfo.confirmPassword;
                    user.prefix = nameInfo.prefix;
                    user.firstName = nameInfo.givenName;
                    user.middleName = nameInfo.additionalName;
                    user.lastName = nameInfo.familyName;
                    user.suffix = nameInfo.suffix;
                    user.language = userInfo.language;
                    user.companyId = userInfo.companyId;
                    user.contextType = userInfo.contextType;
                    user.group = userInfo.group;
                    user.bluemoonFirmId = userInfo.bluemoonFirmId;

                    // added for cs-user-admin
                    user.fullName = nameInfo.fullName;

                    // user photo comes in as base64 string without image info
                    if(angular.isDefined(userInfo.photo) && userInfo.photo !== ''){
                        if(userInfo.photo.indexOf('data:image') === -1){
                            user.photo = 'data:image;base64,' + userInfo.photo;
                        } else {
                            user.photo = userInfo.photo;
                        }
                    } else {
                        user.photo = undefined;
                    }
                }

                function validatePin(pin){
                    var path = '/api/profiles/v1/registration/validate';
                    var url = path + '?token=' + encodeURIComponent($location.search().token);

                    return $http({
                        method: 'POST',
                        url: url,
                        data: 'pin=' + pin,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    });
                }

                function validateUserIdIsUnique(email) {
                    var path = '/api/profiles/v1/users/login-in-use';
                    var url = path + '?login=' + encodeURIComponent(email) +
                        '&token=' + encodeURIComponent($location.search().token);

                    return $http({
                        method: 'GET',
                        url: url
                    });
                }

                // create a new company and owner
                // this endpoint will generate an registration email and send it to the email
                function createCompany(companyInfo, products){
                    var url = '/api/sm-core/v1/companies';

                    return $http({
                        method: 'POST',
                        url: url,
                        data: {
                            name: companyInfo.companyName,
                            owner: {
                                firstName: companyInfo.firstName,
                                lastName: companyInfo.lastName,
                                preferredLocale: companyInfo.preferredLocale,
                                emailAddress: companyInfo.email
                            },
                            selectedProducts: products
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                }

                // create company from samba self registration: company name not needed from input
                function createCompanyOnSelfRegistration(registrationInfo, products, createSession) {
                    var url = '/api/provisioning/v1/company';
                    if(createSession) {
                        url = url + '?createSession=true';
                    }
                    var companyData = {
                            firmName: registrationInfo.companyName,
                            firstName: registrationInfo.firstName,
                            lastName: registrationInfo.lastName,
                            language: registrationInfo.preferredLocale,
                            email: registrationInfo.email,
                            password: registrationInfo.password,
                            selectedProducts: products
                    };
                    if(registrationInfo.mapId){
                        companyData.mapId = registrationInfo.mapId;
                    }
                    if(registrationInfo.mapCallbackUrl){
                        companyData.mapCallbackUrl = registrationInfo.mapCallbackUrl;
                    }
                    if(registrationInfo.linkedAccount) {
                        companyData.linkedAccount = registrationInfo.linkedAccount;
                    }
                    return $http({
                        method: 'POST',
                        url: url,
                        data: companyData,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                }

            }
        ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('bmRegSecurityQuestions',
        [
            function(){
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        user: '=',
                        questions: '='
                    },
                    templateUrl: 'registration/security-questions/security-questions.2js.html',
                    controller: 'RegistrationSecurityQuestionsCtrl',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]
    );
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('onvio-userRegistration').controller('RegistrationSecurityQuestionsCtrl', securityQuestionCtrl);
    securityQuestionCtrl.$inject = ['$rootScope', '$translate', 'userRegistrationService'];

    function securityQuestionCtrl($rootScope, $translate, userRegistrationService){
        /*jshint validthis:true */
        var vm = this;
        var questionCounter;

        vm.processQuestionSelect = processQuestionSelect;
        vm.clearSecurityQuestionAlert = clearSecurityQuestionAlert;
        vm.securityQuestionAlerts = [];

        // objects set on directive scope
        vm.localUser = vm.user;

        // initialize questions on user
        vm.localUser.questions = [
            { questionId: '', question: '', answer: '', selectedQuestion: undefined },
            { questionId: '', question: '', answer: '', selectedQuestion: undefined },
            { questionId: '', question: '', answer: '', selectedQuestion: undefined }
        ];

        // Create methods publicly available through 2-way data bound object
        vm.localUser.setSecurityQuestionAlert = function(alert){
            clearSecurityQuestionAlert('all');

            if(angular.isDefined(alert)){
                vm.securityQuestionAlerts.push(alert);
            }
        };

        vm.localUser.areSecurityQuestionsValid = function(){
            clearSecurityQuestionAlert('all');

            var valid = getFormFieldValidity();

            // set any validation errors
            if(!valid){
                $translate('BM.Registration.Security.ReviewMarkedFieldsError').then(function(value){
                    vm.securityQuestionAlerts.push({ type: 'danger', msg: value });
                });
            }

            return valid;
        };

        $rootScope.$on('bmLanguageChangeSuccess', loadTranslatedQuestionsList);

        filterMasterQuestions();

        ///////////

        function clearSecurityQuestionAlert(index){
            if(index === 'all'){
                vm.securityQuestionAlerts = [];
                return;
            }

            vm.securityQuestionAlerts.splice(index, 1);
        }

        function getFormFieldValidity(){
            // set form as dirty in order to display any validation messages
            vm.securityQuestionsForm.$setSubmitted();
            return vm.securityQuestionsForm.$valid;
        }

        function filterMasterQuestions(listIndex){
            // listIndex = <select> list that the value was changed in
            // Need to filter selected questions out of other master lists so the same question can't be selected twice
            var currentQuestionList;

            for(questionCounter = 0; questionCounter < vm.localUser.questions.length; questionCounter++){
                // Don't need skip the list that was just selected
                if(angular.isDefined(listIndex) && questionCounter === listIndex){
                    continue;
                }

                // Get a filtered list
                currentQuestionList = angular.copy(vm.questions);
                currentQuestionList = currentQuestionList.filter(notAlreadySelected);

                // The first time through will not have a master list of questions
                if(angular.isUndefined(vm.localUser.questions[questionCounter].masterList)){
                    vm.localUser.questions[questionCounter].masterList = currentQuestionList;
                    continue;
                }

                var removeCounter = vm.localUser.questions[questionCounter].masterList.length;
                var questionIdAsInt = -1;

                // has a question been selected yet
                if(angular.isDefined(vm.localUser.questions[questionCounter].selectedQuestion) &&
                    angular.isDefined(vm.localUser.questions[questionCounter].selectedQuestion.questionId)){
                        questionIdAsInt = parseInt(vm.localUser.questions[questionCounter].selectedQuestion.questionId);
                }

                // Clear the existing array without creating a new array object as this will kill scope
                while(removeCounter > 0){
                    removeCounter--;
                    // Don't clear the selected question
                    if(vm.localUser.questions[questionCounter].masterList[removeCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    vm.localUser.questions[questionCounter].masterList.splice(removeCounter, 1);
                }

                // Append to the array without creating a new array object
                for(var addCounter = 0; addCounter < currentQuestionList.length; addCounter++){
                    if(currentQuestionList[addCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    if(currentQuestionList[addCounter].questionId < questionIdAsInt){
                        vm.localUser.questions[questionCounter].masterList.unshift(currentQuestionList[addCounter]);
                    } else {
                        vm.localUser.questions[questionCounter].masterList.push(currentQuestionList[addCounter]);
                    }
                }
            }
        }

        function notAlreadySelected(element){
            var alreadySelected = false;
            var questionIdAsInt;

            for(var counter = 0; counter < vm.localUser.questions.length; counter++){
                if(alreadySelected){
                    break;
                }

                if(angular.isUndefined(vm.localUser.questions[counter].selectedQuestion)){
                    alreadySelected = false;
                    continue;
                }

                questionIdAsInt = parseInt(vm.localUser.questions[counter].selectedQuestion.questionId);

                // questionCounter is global and represents the current list being filtered
                if(element.questionId === questionIdAsInt){
                    if(angular.isUndefined(vm.localUser.questions[questionCounter].selectedQuestion)){
                        alreadySelected = true;
                        continue;
                    }

                    alreadySelected = (questionIdAsInt !== vm.localUser.questions[questionCounter].selectedQuestion.questionId);
                    continue;
                }

                alreadySelected = false;
            }

            return !alreadySelected;
        }

        function processQuestionSelect(listIndex){
            // Filter the master questions list for each question
            filterMasterQuestions(listIndex);
        }

        function loadTranslatedQuestionsList(){
            userRegistrationService.loadTabSecurityQuestions().then(function(response){
                // reset the list of questions and answers for the user
                // load up the new questions in the lists
                angular.forEach(vm.localUser.questions, function(userQuestion){
                    userQuestion.questionId = '';
                    userQuestion.question = '';
                    userQuestion.answer = '';
                    userQuestion.selectedQuestion = undefined;

                    // Clear the existing array without creating a new array object as this will kill scope
                    if(angular.isDefined(userQuestion.masterList) && userQuestion.masterList.length > 0){
                        var removeCounter = userQuestion.masterList.length;

                        while(removeCounter > 0){
                            removeCounter--;
                            userQuestion.masterList.splice(removeCounter, 1);
                        }
                    }
                });

                // load up the questions display again
                vm.questions = response.data;
                filterMasterQuestions();
            });
         }
    }
})(window.angular);

(function(angular){
    'use strict';

    // TODO: HOW TO HANDLE CREATE USER ERROR ON WIZARD? LET USER GO BACK?

	angular.module('onvio-userRegistration').controller('UserRegistrationCtrl', userRegistration);
    userRegistration.$inject = [
        '$rootScope',
        'bmAccess',
        '$location',
        '$timeout',
        '$state',
        '$translate',
        'resolvedUser',
        'userRegistrationService'
    ];

    function userRegistration(
        $rootScope,
        bmAccess,
        $location,
        $timeout,
        $state,
        $translate,
        resolvedUser,
        userRegistrationService
    ){
        /*jshint validthis:true */
        var vm = this;
        vm.isLoaderBusy = false;
        vm.user = resolvedUser;

        //if email is passed as url param, use that instead of registration token email
        vm.user.userId = $location.search().uid ? decodeURIComponent($location.search().uid) : resolvedUser.userId;
        vm.completeRegistration = completeRegistration;
        vm.checkAcctInfoValid = checkAcctInfoValid;
        vm.acctInfoValid = false;
        vm.registrationAlerts = [];

        this.$onInit = function() {
            $rootScope.$on('formFieldChange', function() {
                vm.acctInfoValid = checkAcctInfoValid();
            });
            //require terms to be accepted
            areTermsRequired(vm.user.contextType).then(function(termsRequired){
                vm.requireTerms = termsRequired;
            });
        };

        // handle no user or question data
        if(angular.isUndefined(resolvedUser) ){
            $translate('bm.registration.load.error').then(function(value){
               vm.registrationAlerts.push({ type: 'danger', msg: value, closeable: false});
            });

            return;
        }

        //////////
        function checkAcctInfoValid() {
            if(vm.user.isAcctInfoValid) {
                return vm.user.isAcctInfoValid();
            }
            return false;
        }
        function areTermsRequired(userContext){
            return bmAccess.has('Platform_DisplayOnvioTerms').then(function(){
                return userContext === 'staff';
            });
        }
        function completeRegistration() {
            vm.acctInfoValid = checkAcctInfoValid();

            if(!vm.acctInfoValid){
                return false;
            }

            // clear any error messages
            clearWizardAlerts();

            if(!vm.user.prompt){
                vm.isLoaderBusy = true;
                userRegistrationService.createUser().then(function(){
                    vm.isLoaderBusy = false;
                    $state.go('registration-complete');
                }, function(err){
                    vm.isLoaderBusy = false;
                    if (err.data.error === 'PASSWORD_CONTAINS_USERINFO') {
                        $translate('BM.Login.ResetPassword.PasswordContainsPersonalInfo').then(function (value) {
                            vm.user.setAcctInfoAlert({type: 'danger', msg: value});
                        });
                    } else {
                        $translate('BM.Registration.ContactAdminError').then(function (value) {
                            vm.user.setAcctInfoAlert({type: 'danger', msg: value});
                        });
                    }
                    return false;
                });
            }
        }

        function clearWizardAlerts(){
            if(vm.user.prompt){
                vm.user.setPinAlert();
            }
            vm.user.setAcctInfoAlert();
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('bmPersonalId',
        [
            function(){
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        user: '='
                    },
                    templateUrl: 'registration/personal-id/personal-id.2js.html',
                    controller: 'PersonalIdCtrl',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]
    );
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('onvio-userRegistration').controller('PersonalIdCtrl', personalIdCtrl);
    personalIdCtrl.$inject = ['$translate'];

    function personalIdCtrl($translate){
        /*jshint validthis:true */
        var vm = this;

        vm.clearPinAlert = clearPinAlert;

        // user object set on directive scope
        vm.localUser = vm.user;
        vm.pinAlerts = [];

        vm.localUser.setPinAlert = function(alert){
            clearPinAlert('all');

            if(angular.isDefined(alert)){
                vm.pinAlerts.push(alert);
            }
        };

        vm.localUser.isPinValid = function(){
            clearPinAlert('all');

            var valid = getFormFieldValidity();

            // set any validation errors
            if(!valid){
                $translate('BM.Registration.Security.ReviewMarkedFieldsError').then(function(value){
                    vm.pinAlerts.push({ type: 'danger', msg: value });
                });
            }

            return valid;
        };

        ///////////

        function clearPinAlert(index){
            if(index === 'all'){
                vm.pinAlerts = [];
                return;
            }

            vm.pinAlerts.splice(index, 1);
        }

        function getFormFieldValidity(){
            // set pin inputs as touched in order to display any validation messages
            vm.pinForm.pin.$setTouched();
            return vm.pinForm.pin.$valid;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('onvio-userRegistration').directive('bmLoginAccountInfo',
        [
            function(){
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        user: '='
                    },
                    templateUrl: 'registration/account-info/account-info.2js.html',
                    controller: 'AccountInfoCtrl',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]
    );
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('onvio-userRegistration').controller('AccountInfoCtrl', accountInfo);
    accountInfo.$inject = ['$q', '$rootScope', '$translate', '$http', 'bmLanguageManager', 'userRegistrationService', 'bmAccess', 'PasswordValidationFactory'];

    function accountInfo($q, $rootScope, $translate, $http, bmLanguageManager, userRegistrationService, bmAccess, PasswordValidationFactory){
        /*jshint validthis:true */
        var vm = this;
        vm.loadDependentFields = loadDependentFields;
        vm.changeLanguage = changeLanguage;
        vm.clearAcctInfoAlert = clearAcctInfoAlert;
        vm.setConfirmValidity = setConfirmValidity;
        vm.verifyPassword = verifyPassword;
        vm.verifyConfirm = verifyConfirm;
        vm.updateInvalidChars = updateInvalidChars;

        vm.acctInfoAlerts = [];
        vm.languageList = [];
        vm.termsAccepted = false;

        vm.invalidChars = [];

        this.$onInit = function() {
            initAccountInfo();
            $rootScope.$on('acceptTermsChange', function(event, data) {
                vm.termsAccepted = data.accepted;
                $rootScope.$broadcast('formFieldChange');
            });

            //import password validation rules
            PasswordValidationFactory.loadPasswordRules().then(function(response){
                vm.passwordRules = response.rules;
            });
        };

        //////////

        function initAccountInfo(){
            // user object set on directive scope
            vm.localUser = vm.user;
            //require terms to be accepted
            areTermsRequired(vm.localUser.contextType).then(function(termsRequired){
                vm.requireTerms = termsRequired;
            });
            // initialize required fields
            vm.localUser.password = '';
            vm.localUser.confirmPassword = '';

            // Create methods publicly available through 2-way data bound object
            vm.localUser.setAcctInfoAlert = function(alert){
                clearAcctInfoAlert('all');

                if(angular.isDefined(alert)){
                  vm.acctInfoAlerts.push(alert);
                }
            };

            vm.localUser.isAcctInfoValid = function(){
                clearAcctInfoAlert('all');

                // needed to have password display validation message
                vm.hasFocusPassword = false;

                var valid = getFormFieldValidity();

                // set any validation errors
                if(!valid){
                    $translate('BM.Registration.Security.ReviewMarkedFieldsError').then(function(value){
                        vm.acctInfoAlerts.push({ type: 'danger', msg: value });
                    });
                }

                return valid;
            };

            if(angular.isDefined(vm.localUser) && angular.isDefined(vm.localUser.userId) && vm.localUser.userId !== ''){
                vm.hasFocusEmail = false;
                vm.hasFocusPassword = true;
            } else {
                vm.hasFocusEmail = true;
                vm.hasFocusPassword = false;
            }
        }
        function areTermsRequired(userContext){
            return bmAccess.has('Platform_DisplayOnvioTerms').then(function(){
                return userContext === 'staff';
            });
        }
        // clear validation messages for confirm password field on focus
        function setConfirmValidity(){
            // first time focus
            if(vm.acctInfoForm.confirmPassword.$untouched && !vm.acctInfoForm.confirmPassword.$dirty){
                return;
            }

            // clear validation messages if value not entered
            if(vm.acctInfoForm.confirmPassword.$viewValue === ''){
                vm.acctInfoForm.confirmPassword.$setPristine();
                vm.acctInfoForm.confirmPassword.$setUntouched();
                vm.acctInfoForm.confirmPassword.$setValidity('required', true);
                vm.acctInfoForm.confirmPassword.$setValidity('invalidComparison', true);
                return;
            }

            // trigger validators in order to set or clear validation message
            vm.acctInfoForm.confirmPassword.$validate();
        }

        function verifyPassword(){
            if(vm.localUser.password !== ''){
                userRegistrationService.isPasswordTooCommon(vm.localUser.password).then(
                    function(response){
                        vm.passwordTooCommon = !!response.data && response.data.tooCommon;
                    }, function(){
                    }
                );
            } else {
                vm.passwordTooCommon = false;
            }
        }

        // verify display of validation messages on blur of field
        function verifyConfirm(){
            if(vm.acctInfoForm.confirmPassword.$valid){
                if(vm.acctInfoForm.confirmPassword.$viewValue === ''){
                    vm.acctInfoForm.confirmPassword.$setValidity('required', false);
                } else if(vm.acctInfoForm.confirmPassword.$viewValue !== vm.acctInfoForm.password.$viewValue){
                    vm.acctInfoForm.confirmPassword.$setValidity('invalidComparison', false);
                }
            }
        }

        function clearAcctInfoAlert(index){
            if(index === 'all'){
                vm.acctInfoAlerts = [];
                return;
            }

            vm.acctInfoAlerts.splice(index, 1);
        }
        function termsRequiredAndAccepted() {
            if (vm.requireTerms) {
                return vm.termsAccepted;
            }
            return true;
        }
        function getFormFieldValidity(){
            // set all validated inputs as touched in order to display any validation messages

            // only set userId in absence of PPE_AccountSwitching
            var userIdValid = true;
            if (vm.acctInfoForm.userId){
                vm.acctInfoForm.userId.$setTouched();
                userIdValid = vm.acctInfoForm.userId.$valid;
            }
            vm.acctInfoForm.password.$setTouched();
            vm.acctInfoForm.confirmPassword.$setTouched();
            vm.acctInfoForm.firstName.$setTouched();
            vm.acctInfoForm.lastName.$setTouched();

            return termsRequiredAndAccepted() && userIdValid && vm.acctInfoForm.password.$valid &&
                vm.acctInfoForm.confirmPassword.$valid && vm.acctInfoForm.firstName.$valid &&
                vm.acctInfoForm.lastName.$valid;
        }

        function changeLanguage() {
            clearAcctInfoAlert('all');
            vm.localUser.language = vm.selectedLanguageValue.code;
            bmLanguageManager.setUserLanguageAsync(vm.selectedLanguageValue.code);
        }

        function loadDependentFields(language) {
           $q.all([userRegistrationService.loadTabAccountPrefixInfo(language), userRegistrationService.loadTabAccountSuffixInfo(language)]).then(function(response){
               vm.prefixList = loadDependentFieldResults(response[0], vm.selectedPrefix);
               vm.suffixList = loadDependentFieldResults(response[1], vm.selectedSuffix);
           });
        }

        function loadDependentFieldResults(list, selected){
           // Always add selected value if available
           var shouldAddSelected = angular.isDefined(selected) && angular.isDefined(selected.description) && selected.description !== '';
           var selectedExists = false;

           for(var index = 0; index < list.length; index++){
               if(shouldAddSelected && list[index].description === selected.description){
                   selectedExists = true;
                   break;
               }
           }

           // Always keep the selected value in the list
           if(shouldAddSelected && !selectedExists){
               list.push({
                   id: list.length,
                   description: selected.description
               });
           }

           return list;
        }

        function updateInvalidChars(){
            vm.invalidChars = vm.passwordRules.prohibitedCharacterRule.getInvalidChars(vm.localUser.password);
        }

    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.registrationConfirmation', []);

})(window.angular);

(function (angular) {
    'use strict';

	angular.module('bluemoon.registrationConfirmation')

		.factory('registrationConfirmationService', ['$http',
			function ($http) {

				return {
					verify: function(token) {
                        var server = '';// 'http://localhost:8080';
                        var path = '/api/profiles/v1/registration';
                        var url = server + path + '?token=' + encodeURIComponent(token);

                        return $http({
                            method: 'GET',
                            url: url
                        });
					}
				};
			}
		]);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.registrationConfirmation').controller('RegistrationConfirmationCtrl', registrationConfirm);
    registrationConfirm.$inject = [
        '$scope',
        '$location',
        '$bentoBusyLoader',
        'bmAccess',
        'registrationConfirmationService',
        'userRegistrationService',
        '$window'
    ];

    function registrationConfirm($scope, $location, $bentoBusyLoader, bmAccess, registrationConfirmationService, userRegistrationService, $window){
        $scope.isLoaderBusy = true;

        registrationConfirmationService.verify($location.search().token).then(function (resp) {
            var data = resp.data;

            if(angular.isDefined(data)){
                userRegistrationService.setUserInfo(data.user, data.prompt);
                //registration already completed
                if(data.path === '/') {
                    if ($location.search().group === 'BR_CLIENT_EMPLOYEE') {
                        $window.location.href = 'https://' + $window.location.host + '/portaldoempregado/auth';
                    } else {
                        $location.url(data.path);
                    }
                } else if(data.path.indexOf('error=') !== -1 && $location.path() !== '/') {
                    $location.url(data.path);
                }
            }

            var tokenMarker = angular.isDefined(data) && angular.isDefined(data.path) && data.path.indexOf('?') === -1 ?
                '?token=' : '&token=';
            var group = angular.isDefined($location.search().group) ? '&group=' + $location.search().group : '';

            userRegistrationService.validateUserIdIsUnique(data.user.email).then(function (response){
                bmAccess.has('PPE-AccountSwitching').then(function() {
                    //If user's email exists, route to link registration to allow them to link accounts
                    if(response.data.results === 'found'){
                        $location.url('/link-registration' + tokenMarker + $location.search().token + group);
                    } else {
                         $location.url(data.path + tokenMarker + $location.search().token + group);
                    }
                }, function(){
                     $location.url(data.path + tokenMarker + $location.search().token + group);
                });
            });
        });
    }
})(window.angular);

(function (angular, trAuth) {
    'use strict';

    angular.module('onvio-userRegistration').controller('SelfRegistrationCtrl', selfRegistration);
    selfRegistration.$inject = ['$scope', '$translate', 'bmLanguageManager', 'bmEnvironment', 'userRegistrationService', 'PasswordValidationFactory', 'AuthenticatedSession', 'themeHeader', 'product', '$state', 'bmContactNameParser', '$location', '$rootScope', 'bmAccess', '$window', 'SelectResetPasswordMethodService', 'bmUtil', 'bmSupportedLanguagesMetadata', '$timeout', 'bmTokenStorage'];

    function selfRegistration($scope, $translate, bmLanguageManager, bmEnvironment, userRegistrationService, PasswordValidationFactory, session, themeHeader, product, $state, bmContactNameParser, $location, $rootScope, bmAccess, $window, selectResetPasswordMethodService, bmUtil, bmSupportedLanguagesMetadata, $timeout, bmTokenStorage){
        /*jshint validthis:true */
        var vm = this;
        var passwordValid;
        var emailNotUnique = false;
        var defaultLanguage = bmEnvironment.getCountryDefaultLanguage();
        var countryCode = bmEnvironment.getCountryCode();
        vm.active = false;
        vm.hasFooter = hasFooter;
        vm.submit = submit;
        vm.register = register;
        vm.validatePassword = validatePassword;
        vm.bmEnvironment = bmEnvironment;
        vm.emailChanged = emailChanged;
        vm.passwordHelpPopoverOpen = false;
        vm.prohibitedChars = [];
        vm.showLinkingScreen = false;
        vm.copyrightYear = (new Date()).getFullYear();
        vm.openForgottenPasswordDialog = openForgottenPasswordDialog;

        //String that binds to fullName field
        vm.fullName = '';

        //Empty model
        vm.model = {
            firstName: '',
            lastName: '',
            companyName: '',
            email: '',
            password: '',
            preferredLocale: ''
        };

        vm.user = {};

        var searchObject = $location.search();
        vm.displayConnectTitle = searchObject.mapId;
        if(vm.displayConnectTitle) {
            //Append current url parameters to sign in screen url.
            vm.signInUrl = $location.url().replace($location.path(), $state.href('main'));
        } else {
            vm.signInUrl = $state.href('main');
        }

        vm.registerUserOnly = $state.includes('user-self-registration');
        //Set mapId if it exists
        if(searchObject && searchObject.mapId){
            //Do all necessary validations needed for the mapId.
            vm.model.mapId = searchObject.mapId;
        }

        //Set hideSignIn if acs integration is needed
        if(searchObject && searchObject.mapId && searchObject.acs) {
            vm.hideSignIn = true;
        }

        // set the default language
        vm.model.preferredLocale = setStartingLanguage();

        // load up validation rules for  passwords
        PasswordValidationFactory.loadPasswordRules().then(function(response){
            // this creates vm.rules
            angular.extend(vm, response);
        });

        vm.passwordChecks = {};

        // setup password popover properties
        vm.popover = {
            templateUrl: 'components/password-input/password-rules-popover.2js.html'
        };

        //Create a empty error object
        resetErrors();

        //Clear the errors when the model change
        $scope.$watchCollection('vm.model', resetErrors);

        vm.hasLangSwitch = false;
        vm.setLanguage = setLanguage;

        initViewModel();

        /////////////

        function initViewModel(){
            vm.productName = product.name;
            vm.backgroundName = product.background || themeHeader.loginBackground;

            redirectIfInvalidAccess();

            if(vm.productName === 'samba' && !trAuth.isBrowserSupported({minimumMsie:12})) {
                $state.go('unsupported-browser-smb');
            }
            // Make sure languages are loaded first
            setLanguageListAsync();
            setEnvironmentLinks();
            getCommonPasswordsIAC();
            getAccountSwitchingIAC();

            if(bmEnvironment.isBrCountryCode()) {
                vm.showCharClassRuleCheck = true;
            }
        }

        function redirectIfInvalidAccess() {
            if(vm.productName === 'samba' && !vm.registerUserOnly){
                bmAccess.not('IAC-SMB-Registration').then(function hasAccess(){
                    if(bmEnvironment.isBrCountryCode()){
                        $state.go('main');
                    }
                });
            }
        }

        function isValidOnbalanceProduct(productName) {
            if(productName === 'ONBALANCEUSBASIC' ||
                productName === 'ONBALANCEUSSELFEMPLOYED' ||
                productName === 'ONBALANCEBRBASIC' ||
                productName === 'ONBALANCEARBASIC' ||
                productName === 'ONBALANCEUKSELFEMPLOYED' ||
                productName === 'ONBALANCEUKBASIC' ||
                productName === 'ONBALANCENLBASIC' ||
                productName === 'ONBALANCECABASIC' ||
                productName === 'ONBALANCEAUBASIC' ) {
                    return true;
            }
            return false;
        }

        function getCommonPasswordsIAC() {
            bmAccess.has('Platform_CommonPasswordsFilter').then(function () {
                //Use common passwords filter
                vm.useCommonPasswordsFilter = true;
            });
        }

        function getAccountSwitchingIAC() {
            bmAccess.has('PPE-AccountSwitching').then(function () {
                vm.accountSwitchingAllowed = true;
            });
        }

        // Assign the proper OnBalance product based on the country code
        function assignProduct() {
            if( isValidOnbalanceProduct(searchObject.onbalanceProduct) ) {
                vm.selectedProducts.push(searchObject.onbalanceProduct);
            } else {
                switch(countryCode){
                    case 'us': vm.selectedProducts.push('ONBALANCEUSSELFEMPLOYED'); break;
                    case 'br': vm.selectedProducts.push('ONBALANCEBRBASIC'); break;
                    case 'ar': vm.selectedProducts.push('ONBALANCEARBASIC'); break;
                    case 'uk': vm.selectedProducts.push('ONBALANCEUKSELFEMPLOYED'); break;
                    case 'nl': vm.selectedProducts.push('ONBALANCENLBASIC'); break;
                    case 'ca': vm.selectedProducts.push('ONBALANCECABASIC'); break;
                    case 'au': vm.selectedProducts.push('ONBALANCEAUBASIC'); break;
                }
            }
        }

        //TODO: Add this functionality in a service or a more common place. Right now this is also implemented in the sign in screen.
        function openForgottenPasswordDialog() {
            var userData = {
                email : '',
            };

            if((!angular.isUndefined(vm.model.email)) && (vm.model.email !== '')) {
                userData.email = vm.model.email;
            }

            selectResetPasswordMethodService.setUserData(userData);

            if(product.forgotRoute && product.forgotRoute !== ''){
                $location.url(product.forgotRoute);
                return;
            }
        }

        function register(){
            // clear display of any errors
            resetErrors();

            //Include one last check for common passwords

            var inputIsValid = vm.validateInput();
            if(!inputIsValid){
                return;
            }

            $scope.$emit('bm-busy-loading-on');
            vm.model.companyName = $translate.instant('BM.Registration.sambaCompanyName');
            vm.active = true;

            vm.selectedProducts = ['SAMBAMICRO'];
            if(searchObject && searchObject.type){
                //We plan on having more types in the future for other ONBALANCE products.
                switch(searchObject.type){
                    case 'MTD': vm.selectedProducts[0] = 'ONBALANCEMTD'; break;
                    default: vm.selectedProducts[0] = 'SAMBAMICRO'; break;
                }
            }
            assignProduct();
            //If the company has already been created, then we are only registering a user
            //Otherwise we need to create the whole company
            if( vm.registerUserOnly ) {
                vm.registerUser();
            } else {
                // call the service to create the new company and contact
                //Provide a callback url if linking to another TR product
                if(searchObject.ultraTax && searchObject.mapId) {
                    vm.model.mapCallbackUrl = '/v1/utmapping/' + searchObject.mapId;
                } else if(searchObject.acs && searchObject.mapId ) {
                    vm.model.mapCallbackUrl = '/v1/acsmapping/' + searchObject.mapId;
                }

                if(vm.showLinkingScreen) {
                    vm.model.linkedAccount = true;
                }

                userRegistrationService.createCompanyOnSelfRegistration(vm.model, vm.selectedProducts, true).then(function(result){
                    vm.active = false;

                    // LOG USER IN DIRECTLY ONCE WEB SERVICE IS UPDATED
                    signIn(result.data.udsLongToken);
                }, function(error){
                    if(vm.accountSwitchingAllowed && error && error.data.code === 409 && (bmEnvironment.isUkCountryCode() || bmEnvironment.isBrCountryCode() || bmEnvironment.isUsCountryCode() || bmEnvironment.isArCountryCode())) {
                        vm.showLinkingScreen = true;
                        vm.active = false;
                        $scope.$emit('bm-busy-loading-off');
                    } else if(error && error.data.code === 401 && vm.showLinkingScreen) {
                        vm.active = false;
                        $scope.$emit('bm-busy-loading-off');
                        vm.error = {
                            provideValidPassword: true
                        };
                    } else if(error && error.data.code === 409 && !vm.accountSwitchingAllowed) {
                        //When linking isn't allowed and email already exists
                        $scope.$emit('bm-busy-loading-off');
                        vm.active = false;
                        vm.error = {
                            emailNotUnique: true
                        };
                    } else {
                        $scope.$emit('bm-busy-loading-off');
                        vm.active = false;
                        vm.error = {
                            unknown: true
                        };
                    }
                });
            }

        }

        function submit() {
            //Handle all logic we want to execute before executing registration
            if(vm.useCommonPasswordsFilter && passwordValid && !vm.showLinkingScreen) {
                //Run the async validator one last time so that the UI correctly updates.
                vm.registerForm.password.$asyncValidators.invalidPasswordCommon(vm.model.password).then(function notCommon() {
                    vm.passwordChecks.passwordCommon = true;
                    vm.register();
                }, function isCommon() {
                    vm.passwordChecks.passwordCommon = false;
                    passwordValid = false;
                    vm.register();
                });
            } else {
                vm.register();
            }
        }

        //Signs the user in after registration. The email and password should already be valid.
        //There will be no need to check to see if the password should be reset.
        //If udslongtoken is already provided, just set cookies and redirect.
        function signIn(udsLongToken){
            var beforeRedirectAction;
            //Only make call when checkbox is checked.
            if(vm.allowCorrespondence) {
                beforeRedirectAction = userRegistrationService.updateConsentToContactPreference;
            }

            if(udsLongToken) {
                //If we already have the udslongtoken, we can just set the cookie and redirect.
                bmTokenStorage.clean();
                session.createWithLongToken(udsLongToken, beforeRedirectAction);
            } else {
                session.create(vm.model.email, vm.model.password, beforeRedirectAction).catch(function onFail() {
                    //A hack to fix a race condition related to TRID. If session creation fails once, we try again after waiting 1 second. We believe that 1 second should be enough of a delay for most TRID related failures.
                    //This is a temporary change that is intended to fix a problem in PROD. We expect for this logic to be moved to the back end in the future.
                    $timeout(function delay() {
                        session.create(vm.model.email, vm.model.password, beforeRedirectAction).catch(function onFail() {
                            //Go to the main page regardless of the type of error when the login fails.
                            $state.go('main');
                        });
                    }, 1000);
                });
            }
        }

        function hasFooter(){
            return product.showFooter;
        }

        function setEnvironmentLinks(){
            //Terms and conditions will vary for different products
            vm.termsAndConditions = 'https://onvio.us/ua/help/us-en/staff/core/privacy-statement.htm';
            if(vm.productName === 'samba'){
                switch(countryCode){
                    case 'us':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com/ua/smb/us-en/admin/core/common/terms-of-use.htm';
                        break;
                    case 'br':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com.br/ua/smb/br-pt/admin/core/common/terms-of-use.htm';
                        break;
                    case 'ar':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com.ar/ua/smb/ar-es/admin/core/common/terms-of-use.htm';
                        break;
                    case 'uk':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.co.uk/ua/smb/gb-en/admin/core/common/terms-of-use.htm';
                        break;
                    case 'nl':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com/ua/smb/nl-nl/admin/core/common/terms-of-use.htm';
                        break;
                    case 'ca':
                        if(vm.model.preferredLocale === 'fr-CA') {
                            vm.termsAndConditions = 'https://onbalance.thomsonreuters.com.ca/ua/smb/ca-fr/admin/core/common/terms-of-use.htm';
                        } else {
                            vm.termsAndConditions = 'https://onbalance.thomsonreuters.com.ca/ua/smb/ca-en/admin/core/common/terms-of-use.htm';
                        }
                        break;
                    case 'au':
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com.au/ua/smb/au-en/admin/core/common/terms-of-use.htm';
                        break;
                    default:
                        vm.termsAndConditions = 'https://onbalance.thomsonreuters.com/ua/smb/us-en/admin/core/common/terms-of-use.htm';
                        break;
                }
            }

            if(bmEnvironment.isUkCountryCode()){
                vm.contactEmail = 'digita.support@thomsonreuters.com';
            } else if(bmEnvironment.isCaCountryCode()){
                vm.contactEmail = 'dt.support@thomsonreuters.com';
            } else {
                vm.contactEmail = 'Onvio.SupportUS@ThomsonReuters.com';
            }
        }

        function setLanguage(language){
            vm.model.preferredLocale = language.code;
            $scope.selectedLanguage = language.description;
            setEnvironmentLinks();
            bmLanguageManager.setUserLanguageAsync(language.code).then(function(){
                setLanguageListAsync();
            });
        }

        function setLanguageListAsync(){
            // Only get languages
            return bmLanguageManager.getLanguagesAsync(false).then(function(languages){
                vm.languageList = languages;
                vm.hasLangSwitch = angular.isDefined(vm.languageList) && vm.languageList.length > 0;
            });
        }

        function setStartingLanguage() {
            var languageCode;
            if (bmUtil.cookie('BMLanguageCode') !== undefined) {
                languageCode = bmUtil.cookie('BMLanguageCode');
            } else {
                languageCode = defaultLanguage;
            }

            for (var languages in bmSupportedLanguagesMetadata) {
                if (bmSupportedLanguagesMetadata[languages].code === languageCode) {
                    $scope.selectedLanguage = bmSupportedLanguagesMetadata[languages].description;
                    break;
                }
            }

            return languageCode;
        }

        function emailChanged() {
            if(vm.registerUserOnly) {
                vm.active = true;
                $rootScope.$emit('bm-busy-loading-on');
                userRegistrationService.validateUserIdIsUnique(vm.model.email).then(function(response){
                    if(response.data.results === 'found'){
                        emailNotUnique = true;
                        vm.error = { emailNotUnique: true };
                    } else {
                        emailNotUnique = false;
                        resetErrors();
                    }
                }).finally(function(){
                    $scope.$emit('bm-busy-loading-off');
                    vm.active = false;
                });
            }
        }

        vm.nameChanged = function nameChanged() {
            var toBeParsed = { fullName: vm.fullName };
            var parsedOutput = bmContactNameParser.parseName(toBeParsed);

            //Map to model
            vm.model.firstName = parsedOutput.givenName;
            vm.model.lastName = parsedOutput.familyName;
        };

        function isComplete(model){
            return model.firstName !== '' && model.lastName !== '' && model.email !== '';
        }

        function resetErrors(){
            vm.error = null;
        }

        vm.hideLinking = function hideLinking() {
            vm.showLinkingScreen = false;
        };

        vm.registerUser = function registerUser(){
                $rootScope.$emit('bm-busy-loading-on');
                var companyId = '';
                userRegistrationService.load().then(function(user){
                    if(!angular.isDefined(user)) {
                        $scope.$emit('bm-busy-loading-off');
                        vm.active = false;
                        vm.error = {
                            unknown: true
                        };
                    }
                    user.password = vm.model.password;
                    user.userId = vm.model.email;
                    user.firstName = vm.model.firstName;
                    user.lastName = vm.model.lastName;
                    companyId = user.companyId;
                    userRegistrationService.createUser(user).then(function(){
                        $rootScope.$emit('bm-busy-loading-off');
                        vm.active = false;
                        // When we register a new user, we need to register a task that will remove
                        // the trial frp once the trial time has expired
                        userRegistrationService.registerTrialRemovalTask(companyId);

                        // LOG USER IN DIRECTLY ONCE WEB SERVICE IS UPDATED
                        signIn();
                    },function(){
                        $scope.$emit('bm-busy-loading-off');
                        vm.active = false;
                        vm.error = {
                            unknown: true
                        };
                     });
                }, function(){
                    $scope.$emit('bm-busy-loading-off');
                    vm.active = false;
                    vm.error = {
                        unknown: true
                    };
                });
        };

        vm.validateInput = function validateInput() {
            // When linking, we just want to validate that a password was provided.
            if(vm.showLinkingScreen && vm.model.password) {
                return true;
            } else if(vm.showLinkingScreen) {
                passwordValid = false;
            }

            if(!vm.model.firstName || !vm.model.lastName){
                vm.error = { provideName: true };
                return false;
            }

            if (!isComplete(vm.model)){
                vm.error = { incomplete: true };
                return false;
            }

            if(!passwordValid){
                vm.error = { provideValidPassword: true };
                return false;
            }

            if(vm.prohibitedChars.length > 0){
                vm.error = { prohibitedCharacters: true };
                return false;
            }

            // email should not give value in model if invalid entry
            if(vm.registerForm.email.$error.email){
                vm.error = { provideValidEmail: true };
                return false;
            }

            if(emailNotUnique){
                vm.error = { emailNotUnique: true };
                return false;
            }
            return true;
        };

        vm.productNameClicked = function productNameClicked() {
            if(bmEnvironment.isBrCountryCode()) {
                $window.open('http://www.onbalance.com.br', '_blank');
            }
            return;
        };

        vm.enterNewPasswordField = function enterNewPasswordField() {
            if(vm.productName === 'samba') {
                vm.passwordHelpPopoverOpen = true;
            }
        };

        function validatePassword(){
            // test all password rules
            if(!vm.model.password || vm.model.password === ''){
                // reset all checks if password not entered
                vm.passwordChecks = {};
                return;
            }

            // char length
            vm.passwordChecks.charLengthOk = vm.rules.characterLengthRule.test(vm.model.password);

            var rulesTestResults = [];
            var rulesPassed = 0;

            for(var count = 0; count < vm.rules.characterTypeRules.length; count++){
                rulesTestResults.push(vm.rules.characterTypeRules[count].test(vm.model.password));

                if(rulesTestResults[count]){
                    rulesPassed++;
                }
            }

            // number
            vm.passwordChecks.numberOk = rulesTestResults[0];

            // lower case
            vm.passwordChecks.lowerCaseOk = rulesTestResults[1];

            // upper case
            vm.passwordChecks.upperCaseOk = rulesTestResults[2];

            // special character
            vm.passwordChecks.specialCharOk = rulesTestResults[3];

            // meets required number of character classes?
            vm.passwordChecks.numClassesOk = rulesPassed >= vm.charClassReq;

            //contains prohibited characters?
            vm.prohibitedChars = vm.rules.prohibitedCharacterRule.getInvalidChars(vm.model.password);
            vm.passwordChecks.prohibitedChars = vm.prohibitedChars.length > 0;

            if(vm.useCommonPasswordsFilter) {
                //Since the password validator directive uses a timeout, we don't need to worry about performance when this is called multiple times in a row.
                vm.registerForm.password.$asyncValidators.invalidPasswordCommon(vm.model.password).then(function notCommon() {
                    vm.passwordChecks.passwordCommon = true;
                }, function isCommon() {
                    vm.passwordChecks.passwordCommon = false;
                });
            }

            if(vm.useCommonPasswordsFilter) {
                passwordValid = vm.passwordChecks.charLengthOk && vm.passwordChecks.numClassesOk && vm.passwordChecks.passwordCommon;
            } else {
                passwordValid = vm.passwordChecks.charLengthOk && vm.passwordChecks.numClassesOk;
            }
        }

    }
})(window.angular, window.trAuth);

(function(angular){
    'use strict';

    angular.module('bluemoon.login').controller('ProvideEmailCtrl', provideEmail);
    provideEmail.$inject = ['$q', '$scope', '$translate', 'bmEnvironment', 'SelectResetPasswordMethodService', 'ResetPasswordEmailService', 'themeHeader', 'product', 'bmAccess'];

    function provideEmail($q, $scope, $translate, bmEnvironment, resetMethodService, resetEmailService, themeHeader, product, bmAccess){
        /*jshint validthis:true */
        var vm = this;
        var userData = resetMethodService.userData;
        $scope.isARLoginOB = false;
        bmAccess.has('ARLoginOB').then(function (res) {
            $scope.isARLoginOB = res;
        }).catch(function (err) {
            $scope.isARLoginOB = err;
        });
        vm.copyrightYear = (new Date()).getFullYear();

        vm.confirmed = false;
        vm.email = userData && userData.email ? userData.email : '';

        vm.productName = product.name;
        vm.backgroundName = product.background || themeHeader.loginBackground;

        vm.doResetAction = doResetAction;
        vm.sentPasswordRest = false;

        var env;
        bmEnvironment.getEnvironmentAsync().then(function(data) {
            env = data;
        });

        vm.getViewTitle = function() {
            var title = '';
            // for whatever reason recibos should not have a title
            if (env && env.primaryProduct !== 'recibos') {
                title = env.productDisplayName;
            }
            return title;
        };

        /////////////////////////////

        function doResetAction(){
            // reset errors
            vm.error = null;

            // make sure the email enter is valid
            if(!vm.provideEmailForm.$valid){
                vm.error = { incomplete: true };
                return;
            }

            $scope.$emit('bm-busy-loading-on');
            resetEmailService.load(vm.email).then(function(){
                $scope.$emit('bm-busy-loading-off');

                var promises = [
                    $translate('bm.login.emailResetPrefix'),
                    $translate('bm.login.emailResetSuffix')
                ];

                $q.all(promises).then(function(translations){
                    vm.confirmed = true;
                    vm.confirmedMessage = translations[0] + ' ' + vm.email + ' ' + translations[1];
                });
            },
            function(){
                $scope.$emit('bm-busy-loading-off');
                vm.error = { verifyFailed: true };
            });

            vm.sentPasswordRest = true;
        }

        if(userData){
            return true;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.login').controller('ChangePasswordCtrl', changePassword);
    changePassword.$inject = ['$q', '$scope', '$state', '$translate', 'ResetPasswordService', 'PasswordValidationFactory', 'themeHeader', 'product', 'bmEnvironment', '$location', 'bmAccess'];

    function changePassword($q, $scope, $state, $translate, ResetPasswordService, PasswordValidationFactory, themeHeader, product, bmEnvironment, $location, bmAccess){
        /*jshint validthis:true */
        var vm = this;
        var passwordValid;
        var env;

        $scope.isARLoginOB = false;
        bmAccess.has('ARLoginOB').then(function (res) {
            $scope.isARLoginOB = res;
        }).catch(function (err) {
            $scope.isARLoginOB = err;
        });
        vm.copyrightYear = (new Date()).getFullYear();

        vm.productName = product.name;
        vm.backgroundName = product.background || themeHeader.loginBackground;
        vm.requiredChange = ResetPasswordService.requirePasswordChange;
        vm.submit = submit;
        vm.validatePassword = validatePassword;
        vm.getViewTitle = getViewTitle;
        vm.passwordHelpPopoverOpen = false;

        vm.prohibitedChars = [];

        // info stored in reset service
        var cpidData = ResetPasswordService.cpidData;
        var cpidEmailData = ResetPasswordService.cpidEmailData;
        var cpidToReset;
        if(cpidData) {
            cpidToReset = cpidData.cpid;
        } else {
            cpidToReset = cpidEmailData ? cpidEmailData : '';
        }
        // load up validation rules for  passwords
        PasswordValidationFactory.loadPasswordRules().then(function(response){
            // this creates vm.rules
            angular.extend(vm, response);
        });

        bmEnvironment.getEnvironmentAsync().then(function(data) {
            env = data;
        });

        vm.passwordChecks = {};

        vm.enterNewPasswordField = function enterNewPasswordField() {
            if(product.name === 'samba'){
                vm.passwordHelpPopoverOpen = true;
            }
        };

        // setup password popover properties
        vm.popover = {
            templateUrl: 'components/password-input/password-rules-popover.2js.html'
        };

        initViewModel();

        ///////////////////////////////
        function initViewModel(){
            getCommonPasswordsIAC();

            if(bmEnvironment.isBrCountryCode()) {
                vm.showCharClassRuleCheck = true;
            }
        }

        function getViewTitle(){
            var title = '';

            // for whatever reason recibos should not have a title
            if (env && env.primaryProduct !== 'recibos') {
                title = env.productDisplayName;
            }

            return title;
        }

        function getCommonPasswordsIAC() {
            bmAccess.has('Platform_CommonPasswordsFilter').then(function () {
                //Use common passwords filter
                vm.useCommonPasswordsFilter = true;
            });
        }

        function submit() {
            //Handle all logic we want to execute before executing password change
            if(vm.useCommonPasswordsFilter && passwordValid) {
                vm.changePasswordForm.password.$asyncValidators.invalidPasswordCommon(vm.newPassword).then(function notCommon() {
                    vm.passwordChecks.passwordCommon = true;
                    processChange();
                }, function isCommon() {
                    vm.passwordChecks.passwordCommon = false;
                    passwordValid = false;
                    processChange();
                });
            } else {
                processChange();
            }
        }

        function processChange(){
            // reset errors
            vm.error = null;

            $scope.$emit('bm-busy-loading-on');
            checkFormValid().then(function(){
                ResetPasswordService.reset(cpidToReset, vm.newPassword).then(function(){
                    $scope.$emit('bm-busy-loading-off');

                    // go to sign in route - should have custom title with instructions
                    if(product.name === 'samba' && $location.search().ultraTax){
                        //Append current url parameters to sign in url and visit route
                        $location.url($state.href('main') + $location.url().replace($location.path(), ''));
                    } else {
                        $state.go('main');
                    }
                },
                function (err) {
                    if(err.data.error === 'PASSWORD_CONTAINS_USERINFO'){
                        vm.error = { resetErrorInfo: true };
                    } else {
                        vm.error = { resetError: true };
                    }
                    $scope.$emit('bm-busy-loading-off');
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function checkFormValid(){
            var deferred = $q.defer();
            var password = vm.newPassword ? vm.newPassword.trim() : '';
            var confirm = vm.confirmPassword ? vm.confirmPassword.trim() : '';

            // make sure required fields have data
            // and validate against password rules
            if(!password || !confirm){
                // required?
                vm.error = { provideRequired: true };
                deferred.reject();
            } else if(password !== confirm){
                // passwords match?
                vm.error = { noMatch: true };
                deferred.reject();
            } else if(!vm.rules.characterLengthRule.test(password) || !passwordValid){
                // character length rule
                vm.error = { provideValid: true };
                deferred.reject();
            } else {
                // character type rules
                var rulesPassed = 0;

                for(var pos = 0; pos < vm.rules.characterTypeRules.length; pos++) {
                    var rule = vm.rules.characterTypeRules[pos];

                    if(rule.test(password)) {
                        rulesPassed++;
                    }
                }

                if(rulesPassed < vm.charClassReq){
                    vm.error = { provideValid: true };
                    deferred.reject();
                } else {
                    // password used before?
                    ResetPasswordService.verifyNewPassword(cpidToReset, password).then(function(response){
                        if(response.data.usedPreviously){
                            vm.error = { usedPrevious: true };
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }
                    });
                }
            }

            return deferred.promise;
        }

        // validates entry on popover
        function validatePassword(){
            // test all password rules
            if(!vm.newPassword || vm.newPassword === ''){
                // reset all checks if password not entered
                vm.passwordChecks = {};
                return;
            }

            // char length
            vm.passwordChecks.charLengthOk = vm.rules.characterLengthRule.test(vm.newPassword);

            var rulesTestResults = [];
            var rulesPassed = 0;

            for(var count = 0; count < vm.rules.characterTypeRules.length; count++){
                rulesTestResults.push(vm.rules.characterTypeRules[count].test(vm.newPassword));

                if(rulesTestResults[count]){
                    rulesPassed++;
                }
            }

            // number
            vm.passwordChecks.numberOk = rulesTestResults[0];

            // lower case
            vm.passwordChecks.lowerCaseOk = rulesTestResults[1];

            // upper case
            vm.passwordChecks.upperCaseOk = rulesTestResults[2];

            // special character
            vm.passwordChecks.specialCharOk = rulesTestResults[3];

			// meets required number of character classes?
            vm.passwordChecks.numClassesOk = rulesPassed >= vm.charClassReq;

            //contains prohibited characters?
            vm.prohibitedChars = vm.rules.prohibitedCharacterRule.getInvalidChars(vm.newPassword);
            vm.passwordChecks.prohibitedChars = vm.prohibitedChars.length > 0;

            //Since the password validator directive uses a timeout, we don't need to worry about performance when this is called multiple times in a row.
            if(vm.useCommonPasswordsFilter) {
                vm.changePasswordForm.password.$asyncValidators.invalidPasswordCommon(vm.newPassword).then(function notCommon() {
                    vm.passwordChecks.passwordCommon = true;
                }, function isCommon() {
                    vm.passwordChecks.passwordCommon = false;
                });
            }

            if(vm.useCommonPasswordsFilter) {
                passwordValid = vm.passwordChecks.charLengthOk && vm.passwordChecks.numClassesOk && (!vm.passwordChecks.prohibitedChars) && vm.passwordChecks.passwordCommon;
            } else {
                passwordValid = vm.passwordChecks.charLengthOk && vm.passwordChecks.numClassesOk && (!vm.passwordChecks.prohibitedChars);
            }
        }

    }

})(window.angular);

(function (angular) {
    'use strict';

angular.module('samba-Registration')

    .factory('registrationService', ['$http','$location',
        function ($http, $location) {
              var factory = {
                get : get,
                update: update,
                getSecurityQuestions: getSecurityQuestions,
                getRegistration: getRegistration,
                setRegistration: setRegistration,
                setSecurityQuestions: setSecurityQuestions,
                verify: verify
            };

            return factory;

            //////////

            function get(token) {
             var endpointUrl = '/api/profiles/v1/registration/{0}';
              return $http({
                method: 'GET',
                url: endpointUrl.replace('{0}', token),
                bmAuthRedirect: false
              });
            }

            function update(token) {
             var endpointUrl = '/api/profiles/v1/registration/{0}';
              return $http({
                method: 'PUT',
                url: endpointUrl.replace('{0}', token),
                bmAuthRedirect: false
              });
            }

            function getSecurityQuestions() {
              return $http({
                method: 'GET',
                url: '/api/profiles/v1/security-questions',
                bmAuthRedirect: false
              });
            }

            function setRegistration(model) {

              var path = '/api/profiles/v1/registration';
              var token = $location.search().token;
              var url = path + '?token=' + encodeURIComponent(token);

              // photo must only be the base64 string
              var photo = '';

              var opts = {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              };

              var data = {
                  email: model.email,
                  password: model.linkedAccount ? model.password : model.newPassword,
                  prefix: undefined,
                  firstName: model.firstName,
                  lastName: model.lastName,
                  middleName: model.middleName,
                  suffix: undefined,
                  language: model.language,
                  photo: photo,
                  questions: model.securityQuestions,
                  linkedAccount: model.linkedAccount
              };

              return $http.put(url, data, opts);
            }

            function setSecurityQuestions() {
              return $http({
                method: 'GET',
                url: '/api/profiles/v1/security-questions',
                bmAuthRedirect: false
              });
            }

            function getRegistration(token) {
              var endpointUrl = 'api/profiles/v1/registration?token={0}';
              return $http({
                method: 'GET',
                url: endpointUrl.replace('{0}', token),
                bmAuthRedirect: false
              });
            }

            function verify(token) {
              var server = '';// 'http://localhost:8080';
              var path = '/api/profiles/v1/registration';
              var url = server + path + '?token=' + encodeURIComponent(token);

              return $http({
                  method: 'GET',
                  url: url
              });
            }

          }
        ]);
})(window.angular);

(function RegistrationCRUDScope(angular) {
  'use strict';
  angular.module('samba-Registration').controller('RegistrationCtrl', ['$scope', '$translate', 'registrationService', 'bmAccess', '$location', '$state', '$http','userRegistrationService','$uibModal','SelectResetPasswordMethodService', function RegistrationCtrl($scope, $translate, registrationService, bmAccess, $location,  $state, $http,userRegistrationService,$uibModal,SelectResetPasswordMethodService) {
    var that = this;
    $scope.isARLoginOB = false;
    bmAccess.has('ARLoginOB').then(function (res) {
        $scope.isARLoginOB = res;
    }).catch(function (err) {
        $scope.isARLoginOB = err;
    });
    that.copyrightYear = (new Date()).getFullYear();

    $scope.termsUri = '/ua/smb/-pdfs/ar-es/terms-and-conditions.pdf';

    /*Errors variables*/
    var confirmPasswordMsgNoData = '';
    var confirmPasswordMsgNoMatch = '';
    that.validateConfirmPassword = validateConfirmPassword;
    that.setConfirmPasswordOutOfFocus = setConfirmPasswordOutOfFocus;
    that.newPasswordError = '';
    var reusedPasswordError = '';
    that.confirmPasswordError = '';
    that.currentStep = 0;
    that.finishOk = false;
    that.model = {};
    that.model.firstName = '';
    that.model.lastName = '';
    that.model.middleName = '';
    that.model.email = '';
    that.goLogin = goLogin;
    that.accountLinkingPermission = 'PPE-AccountSwitching';

    that.workWithDataRegistration = function workWithDataRegistration(response){
      if (!response || !response.data || (response.data.path && (response.data.path === '/' || response.data.path === '/?error=BM.Registration.ExpiredLink'))) {
          that.goLogin();
        } else {
          that.setModel(response);
          that.validateAccount();
        }
    };

    that.setModel = function setModel(response){
        //Set model with data recovered throught token
        that.model.firstName = response.data.user.firstName;
        that.model.lastName = response.data.user.lastName;
        that.model.middleName = response.data.user.middleName;
        that.model.email = response.data.user.email;
        that.model.securityQuestions = [];
        that.model.language = response.data.user.language;
    };

    that.checkAccountExits = function checkAccountExits(response){
      var isPrevAccount =  response.data.results === 'found';
      that.accountExists = false;
      bmAccess.has(that.accountLinkingPermission)
        .then(that.hasAccountLinkingPermission.bind(that, isPrevAccount))
        .catch(that.hasAccountLinkingPermission);
    };

    that.hasAccountLinkingPermission = function hasAccountLinkingPermission(isPrevAccount, hasAccess){
        //If user's email exists, route to link registration to allow them to link accounts
        hasAccess = hasAccess ? true : false;
        that.accountExists = hasAccess && isPrevAccount;
        that.isLoaderBusy = false;
    };

    that.validateAccount = function validateAccount(){
      userRegistrationService.validateUserIdIsUnique(that.model.email).then(that.checkAccountExits);
    };

    that.getRegistration = function getRegistration(){
      that.token = $location.url().split('=')[1];
      that.isLoaderBusy = true;
      registrationService.getRegistration(that.token).then(that.workWithDataRegistration);
    };

    that.getRegistration();
    //Validate fields passwords on next step clic event
    that.completeRegistration = function completeRegistration() {
      if(!that.accountExists){
        validatePassword(false);
        validateConfirmPassword(false);
        if (!that.passwordIsValidated || that.confirmPasswordError !== '') {
          that.failedValidation();
          return;
        }
      }
      that.isLoaderBusy = true;
      //Update user data
      registrationService.verify(that.token).then(function (resp) {
        var data = resp.data;

        if(angular.isDefined(data)){
          that.model.linkedAccount = that.accountExists;
          registrationService.setRegistration(that.model).then(function onThen(response) {
              $scope.isLoaderBusy = false;
              if (response.status !== 200) {
                return;
              }
              goLogin();
          }).catch( function onCatch(res){
            if(that.accountExists) { that.errorLinking = { unknown: true }; }
            if (res.data.code === 400 && res.data.error === 'PASSWORD_CONTAINS_USERINFO') {
                $translate('Registration.Password.containsUserInfo').then(function onThen(translateData) {
                    that.newPasswordError = translateData;
                });
            }
            that.isLoaderBusy = false;
            console.log(res);
          });
        } else {
          if(that.accountExists){
            that.isLoaderBusy = false;
            that.errorLinking = { invalid: true };
          }
        }
      });
    };

    //Translates for some error messages
    $translate('Registration.Password.passwordMatchError').then(function onThen(data) {
      confirmPasswordMsgNoMatch = data;
    });
    $translate('Registration.Password.noDataEnteredError').then(function onThen(data) {
      confirmPasswordMsgNoData = data;
    });
    $translate('Registration.Password.passwordUsedPreviouslyError').then(function onThen(data) {
      reusedPasswordError = data;
    });

    //Start rules for password
    that.alerts = [];

    var rules = {
      characterLengthRule: {
        label: '',
        test: function onTest() {
          return that.model.newPassword && that.model.newPassword.length >= that.charLengthReq;
        }
      },
      characterTypeRules: [{
        label: '',
        test: function onTest() {
          return that.model.newPassword && /[0-9]/.test(that.model.newPassword);
        }
      },
      {
        label: '',
        test: function onTest() {
          return that.model.newPassword && /[a-z]/.test(that.model.newPassword);
        }
      },
      {
        label: '',
        test: function onTest() {
          return that.model.newPassword && /[A-Z]/.test(that.model.newPassword);
        }
      },
      {
        label: '',
        test: function onTest() {
          return that.model.newPassword && /[`~\!@#\$£%\^&\*\(\)_\-+={}\[\]\\\|:;\\"\\',\.\?]+/.test(that.model.newPassword);
        }
      }],
      prohibitedCharacterRule:
      {
        label : '',
        test : function () {
          return that.model.newPassword && /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(that.model.newPassword);
        },
        getInvalidChars : function () {
          var matches = new Set();
          var pattern = /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/g;
          var match = pattern.exec(that.model.newPassword);

          while(match){
            matches.add(match[0]);
            match = pattern.exec(that.model.newPassword);
          }
          return Array.from(matches);
        }
      }
    };

    //Translate rules messages
    $translate('Registration.Password.characterRule').then(function onThen(data) { rules.characterLengthRule.label = data; });
    $translate('Registration.Password.numberRule').then(function onThen(data) { rules.characterTypeRules[0].label = data; });
    $translate('Registration.Password.lowerCaseRule').then(function onThen(data) { rules.characterTypeRules[1].label = data; });
    $translate('Registration.Password.upperCaseRule').then(function onThen(data) { rules.characterTypeRules[2].label = data; });
    $translate('Registration.Password.specialCharactersRule').then(function onThen(data) { rules.characterTypeRules[3].label = data + ' ` ~ ! @ # $ £ % ^ & * ( ) _ - + = { } [ ] \\ | : ; " \' , . ? /'; });
    $translate('Registration.Password.containsProhibitedCharacters').then(function onThen(data) { rules.prohibitedCharacterRule.label = data; });

    that.rules = rules;

    $http.get('/api/profiles/v2/password/rules', { headers: { 'Accept': 'application/json' } }).then(function(response){
        that.charLengthReq = response.data.chars;
        that.charClassReq = response.data.classes;
    });

    that.setConfirmPasswordInFocus = function setConfirmPasswordInFocus() {
      that.confirmPasswordInFocus = true;
      that.confirmPasswordError = '';
    };

    function setConfirmPasswordOutOfFocus() {
      that.confirmPasswordInFocus = false;
    }

    //Functions for validate password
    that.validatePasswordFields = function validatePasswordFields(isSubmit) {
      validatePassword(isSubmit);
      validateConfirmPassword(isSubmit);
    };

    function validatePassword() {
      // Reset the validation message
      that.newPasswordError = '';
      that.passwordIsValidated = false;
      // Password required
      if (that.formRegistration.newPassword.$error.required && that.formRegistration.newPassword.$viewValue === '') {
        $translate('Registration.Validations.requiredNotFilled').then(function onThen(data) {
          that.newPasswordError = data;
        });
        return;
      }
      if (angular.isUndefined(that.rules) || that.rules.length === 0) {
        return;
      }
      // run the rules
      // first, the character length rule because it's required
      var lengthRule = that.rules.characterLengthRule;
      if (!lengthRule.test()) {
        $translate('Registration.Password.validPasswordError').then(function onThen(data) {
          that.newPasswordError = data;
        });
        return;
      } else {
        // second, the character type rules because we only need 2 out of 4
        var rulesPassed = 0;
        for (var pos = 0; pos < that.rules.characterTypeRules.length; pos++) {
          var currentRule = that.rules.characterTypeRules[pos];
          if (currentRule.test()) {
            rulesPassed++;
          }
        }
        if (rulesPassed < that.charClassReq) {
          $translate('Registration.Password.validPasswordError').then(function onThen(data) {
            that.newPasswordError = data;
          });
          return;
        }

        that.prohibitedChars = that.rules.prohibitedCharacterRule.getInvalidChars();
        if (that.prohibitedChars.length > 0){
          that.newPasswordError = that.rules.prohibitedCharacterRule.label + ': ' + that.prohibitedChars.join(', ');
          return;
        }
      }

      that.passwordIsValidated = true;
    }

    //Validate confirm password field with password rules
    function validateConfirmPassword(isSubmit) {
      // Reset the validation message
      that.confirmPasswordError = '';
      that.confirmIsValidated = false;

      // Has anything even been entered? Only show message on submit of form.
      if (isSubmit && (angular.isUndefined(that.model.confirmPassword) || that.model.confirmPassword === '')) {
        that.confirmPasswordError = confirmPasswordMsgNoData;
        return;
      }

      if ((angular.isUndefined(that.model.confirmPassword) || that.model.confirmPassword === '') &&
          (angular.isUndefined(that.model.newPassword) || that.model.newPassword === '')) {
        return;
      }

      if (that.model.confirmPassword !== that.model.newPassword) {
        that.confirmPasswordError = confirmPasswordMsgNoMatch;
        return;
      }

      that.confirmIsValidated = true;
    }

    that.failedValidation = function failedValidation() {
      //that.formRegistration.firstName.$setTouched();
      //that.formRegistration.lastName.$setTouched();
      //return alertsManager.error('Registration.Validations.IncompleteForm', true);
    };

    function goLogin() {
      // Redirect to the login page
      $state.go('main');
    }

    that.openForgottenPasswordDialog = function openForgottenPasswordDialog() {
      var userData = {
        email:''
      };

      if(that.model.email && that.model.email !== '') {
          userData.email = that.model.email;
      }

      SelectResetPasswordMethodService.setUserData(userData);

      $uibModal.open({
          templateUrl: 'components/forgotten-password/select-reset-password-method.2js.html',
          controller: 'forgottenPasswordCtrl',
          backdrop: 'static'
      });
    };

    that.openChangeEmailModal = function openChangeEmailModal() {
      var changeEmailModalInstance = $uibModal.open({
          templateUrl: 'registration/change-registration-email/change-registration-email.2js.html',
          controller: 'ChangeRegistrationEmailCtrl',
          backdrop: 'static',
          resolve: {
              uid: function() {
                  return that.model.email;
              }
          },
      });
      changeEmailModalInstance.result.then(function(result) {
          that.model.email = result;
          that.isLoaderBusy = true;
          that.validateAccount();
      });
    };
  }]);

})(angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.login').controller('UnsupportedBrowserSmbController', unsupportedBrowserSmb);
    unsupportedBrowserSmb.$inject = [];

    function unsupportedBrowserSmb(){
        /*jshint validthis:true */
        var vm = this;
        vm.copyrightYear = (new Date()).getFullYear();
    }
})(window.angular);


(function (angular) {
    'use strict';

    angular.module('cs.user.admin', [
        'ngMessages',
        'ui.bootstrap',
        'bento.modern',
        'ui.router',
        'pascalprecht.translate',
        'onvio-userRegistration',
        'bluemoon.passwordValidation',
        'bluemoon.components.util',
        'bmAccess',
        'bmPrivacyPolicy',
        'bmLoginCookiePolicy',
        'bmTokenStorage'
    ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('registration-cs-user', {
                url: '/cs-user-registration',
                template: '<cs-user-registration class="csu-reg" user="$resolve.user" product="$resolve.product"></cs-user-registration>',
                resolve: {
                    user: ['$state', '$location', 'userRegistrationService', function ($state, $location, userRegistrationService) {
                        return userRegistrationService.loadCompleteUser().then(function (user) {
                            if (angular.isDefined(user)) {
                                // set admin based on querystring
                                var query = $location.search();
                                user.isAdmin = angular.isDefined(query.admin) && query.admin === 'true';
                                return user;
                            }
                            $state.go('registration-cs-notfound');
                        }, function () {
                            $state.go('registration-cs-notfound');
                        });
                    }],
                    product: ['bmPrimaryProductFactory', getProduct]
                }
            })
            .state('registration-cs-notfound', {
                url: '/cs-user-notfound',
                templateUrl: 'cs-user-admin/registration/cs-user-notfound.2js.html'
            });
    }])
        .value('cs.user.admin.CsToAuthHostMap', {
            'cswebdev.int.thomsonreuters.com': 'https://demo.onvio.us',
            'cswebdev.thomson.com': 'https://demo.onvio.us',
            'cswebqa.int.thomsonreuters.com': 'https://qed.onvio.us',
            'csqa.thomson.com': 'https://qed.onvio.us',
            'cs.thomsonreuters.com': 'https://onvio.us'
        });

        function getProduct(bmPrimaryProductFactory){
            // Make sure primary product is loaded early
            return bmPrimaryProductFactory.getPrimaryProduct();
        }
})(window.angular);

(function(angular){
  'use strict';

  // TODO: IF THE USER HAPPENS TO NOT LOAD NEED TO HANDLE THIS ERROR
  angular.module('cs.user.admin').controller('CsUserLoginCtrl', csUserLoginCtrl);

  csUserLoginCtrl.$inject = ['$window', 'cs.user.admin.CsToAuthHostMap', 'bmTokenStorage'];
  function csUserLoginCtrl($window, csToAuthHostMap, bmTokenStorage){
    /*jshint validthis:true */
    var ctrl = this;
    var listenerAdded = false;

    ctrl.actions = {};

    // dump old tokens
    bmTokenStorage.clean();
    $window.localStorage.removeItem('tr-auth-token');

    $window.trAuth.modules.auth.init({
      templateData: {
        cswebHost: location.host,
        authSvcHost: csToAuthHostMap[location.host] || 'ci.onvio.us'
      },
      formOverrides: {
        'trta1-signin': {
          action: '/api/auth/v1/login',
          nameMap: {
            uid: 'username',
            pwd: 'password'
          }
        }
      }
    });

    // only add the listener once
    if(!listenerAdded){
      listenerAdded = true;

      $window.addEventListener('tr-auth-success', function(evt) {
        // stuff jwt in local storage and redirect
        $window.localStorage.setItem('tr-auth-token', evt.detail.data.token);
        $window.location.href = '/profile/';
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  // TODO: IF THE USER HAPPENS TO NOT LOAD NEED TO HANDLE THIS ERROR
  angular.module('cs.user.admin').component('csUserRegistration', {
    bindings: {
        user: '<',
        product: '<'
    },
    templateUrl: 'cs-user-admin/registration/cs-user-registration.2js.html',
    controller: CsUserRegistrationCtrl,
  });

  CsUserRegistrationCtrl.$inject = ['$window', '$rootScope', '$q', '$timeout', '$translate', 'userRegistrationService', 'languageStorageManager', 'bmAccess'];
  function CsUserRegistrationCtrl($window, $rootScope, $q, $timeout, $translate, userRegistrationService, langMgr, bmAccess){
    /*jshint validthis:true */
    var ctrl = this;
    var isSaving = false;

    // can use this array to show/hide steps as needed
    var stepsToDisplay = ['account', 'complete'];
    var savingStep = 'account';

    var accountIsValid;
    var lastStep = 0;

    var accountTitle;
    var completeTitle;
    var completeStepsInOrder;
    var reviewMarkedFields;
    var registerMeButtonText;
    var nextButtonText;
    var saveRegistrationErrorText;

    var prefLang = langMgr.get() || 'en-US';
    ctrl.helpLangCode = prefLang.toLowerCase().split('-').reverse().join('-');
    ctrl.isTemplateVisible = false;
    ctrl.showLinkingScreen = false;
    ctrl.disableEditingFeatures = true;
    ctrl.currentStep = 0;
    ctrl.totalSteps = 2;
    ctrl.alerts = [];

    ctrl.actions = {
      next: next,
      onWizardKeypress: onWizardKeypress,
      onStepChange: onStepChange,
      getStepDisplay: getStepDisplay
    };

    ctrl.isAccountValid = isAccountValid;
    ctrl.isLastStep = isLastStep;

    $timeout(function(){
      // localize now (well..next cycle, to get around refresh bug)
      localize();

      // localize on lang change (next cycle to debounce)
      $rootScope.$on('bmLanguageChangeSuccess', localize);
    }, 0);

    /////////////////////////////

    this.$onInit = function() {
        // Check if the user id is unique
        userRegistrationService.validateUserIdIsUnique(ctrl.user.userId).then(function (response){
            $rootScope.$broadcast('bm-busy-loading-on');
            bmAccess.has('PPE-AccountSwitching').then(function() {
                // Set the flag to true once initialization is complete
                ctrl.isTemplateVisible = true;
                // If user's email exists, route to link registration to allow them link accounts
                if(response.data.results === 'found'){
                    ctrl.showLinkingScreen = true;
                }
                $rootScope.$broadcast('bm-busy-loading-off');
            }, function(){
                ctrl.isTemplateVisible = true;
                $rootScope.$broadcast('bm-busy-loading-off');
            });
        }, function(){
            // Set the flag to true even if there's an error to avoid blocking the template
            ctrl.isTemplateVisible = true;
            $rootScope.$broadcast('bm-busy-loading-off');
        });
    };

    function localize(){
      // translate both here so i18n picks up the keys
      $translate ([
        'BM.Registration.Security.CompleteStepsInOrder',
        'BM.Registration.Security.ReviewMarkedFieldsError',
        'Done',
        'Register Me',
        'Help',
        'BM.Registration.ContactAdminError',
        'Register your CS Professional Suite Web Account',
        'Success! You\'re Done.'
      ]).then(function(values){
        completeStepsInOrder = values['BM.Registration.Security.CompleteStepsInOrder'];
        reviewMarkedFields = values['BM.Registration.Security.ReviewMarkedFieldsError'];
        nextButtonText = values.Done;
        registerMeButtonText = values['Register Me'];
        ctrl.helpTooltip = values.Help;
        saveRegistrationErrorText = values['BM.Registration.ContactAdminError'];
        accountTitle = values['Register your CS Professional Suite Web Account'];
        completeTitle = values['Success! You\'re Done.'];
        setButtonState(ctrl.currentStep);
      });
    }

    function isAccountValid(isValid){
      accountIsValid = isValid;
    }

    function isLastStep(){
      return ctrl.currentStep === ctrl.totalSteps - 1;
    }

    function onWizardKeypress(e){
      if(e.which === 13 && !isSaving){
        next();
      }
    }

    function next(){
      // wizard done, redirect to login page on click of done
      if(isLastStep()){
        if ($window.xprops && $window.xprops.registrationComplete) {
            $window.xprops.registrationComplete();
        } else {
            $window.location = '/myaccount/login.aspx';
        }
        return;
      }

      if(isRegStepValid(stepsToDisplay[ctrl.currentStep])){
        if(stepsToDisplay[ctrl.currentStep] === savingStep){
          // disable enter key
          isSaving = true;

          // save the registration - create the user
          $rootScope.$broadcast('bm-busy-loading-on');
          userRegistrationService.createUser().then(function(){
            $rootScope.$broadcast('bm-busy-loading-off');
            ctrl.currentStep++;
            lastStep = ctrl.currentStep;
            setButtonState(ctrl.currentStep);
          }, function(){
            $rootScope.$broadcast('bm-busy-loading-off');
            ctrl.alerts.push({ msg: saveRegistrationErrorText, type: 'danger', closeable: true, timeout: 2500 });
            isSaving = false;
          });
        } else {
          ctrl.currentStep++;
          lastStep = ctrl.currentStep;
          setButtonState(ctrl.currentStep);
        }
      }
    }

    function onStepChange(step){
      // this method has already incremented ctrl.currentStep
      if(step === ctrl.totalSteps - 1){
        // skipping steps?
        if(step - lastStep > 1){
          ctrl.alerts.push({ msg: completeStepsInOrder, type: 'danger', closeable: true, timeout: 2500 });
          return false;
        }
      }

      // already on the last step
      if(lastStep === ctrl.totalSteps - 1){
        return false;
      }

      var stepToCheck = step - 1;

      if(isRegStepValid(stepsToDisplay[stepToCheck])){
        if(stepsToDisplay[stepToCheck] === savingStep){
          // disable enter key
          isSaving = true;

          // save the registration - create the user
          $rootScope.$broadcast('bm-busy-loading-on');
          return userRegistrationService.createUser().then(function(){
            $rootScope.$broadcast('bm-busy-loading-off');
            setButtonState(step);
            lastStep = step;
            return true;
          }, function(){
            $rootScope.$broadcast('bm-busy-loading-off');
            ctrl.alerts.push({ msg: saveRegistrationErrorText, type: 'danger', closeable: true, timeout: 2500 });
            isSaving = false;
            return false;
          });
        } else {
          setButtonState(step);
          lastStep = step;
          return true;
        }
      }

      return false;
    }

    function getStepDisplay(name){
      return stepsToDisplay.indexOf(name) >= 0;
    }

    function setButtonState(stepIndex){
      // change next button text for complete screen
      ctrl.nextButtonText = stepsToDisplay[ctrl.currentStep] === savingStep ? registerMeButtonText : nextButtonText;

      // change the page title depending on the step
      ctrl.wizardTitle = stepIndex === ctrl.totalSteps - 1 ? completeTitle : accountTitle;
    }

    function isRegStepValid(stepName){
      var stepIsValid = true;

      if (stepName === 'account') {
          stepIsValid = angular.isFunction(accountIsValid) ? accountIsValid() : false;
      }

      if(!stepIsValid){
        ctrl.alerts.push({ msg: reviewMarkedFields, type: 'danger', closeable: true, timeout: 2500 });
        return false;
      }

      return true;
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('cs.user.admin').component('csUserRegistrationAccount', {
    bindings: {
        user: '=',
        onGetValid: '&'
    },
    templateUrl: 'cs-user-admin/registration/cs-user-registration-account.2js.html',
    controller: CsUserRegistrationAccountCtrl,
  });

  CsUserRegistrationAccountCtrl.$inject = [];
  function CsUserRegistrationAccountCtrl(){
    /*jshint validthis:true */
    var ctrl = this;
    var userForm;

    ctrl.$onInit = function(){
      ctrl.showPassword = false;
      ctrl.hasFocusPassword = false;

      ctrl.actions = {
        setConfirmValidity: setConfirmValidity,
        verifyConfirm: verifyConfirm
      };

      // setup validate method that will be call by parent
      var getValid = {
        isValid: function(){

          // set all validated inputs as touched in order to display any validation messages
          userForm.password.$setTouched();
          userForm.confirmPassword.$setTouched();

          if(angular.isUndefined(userForm.password.$viewValue)){
            // userForm.password.$setValidity('required', false);
            // trigger validators in order to set or clear validation message
            userForm.password.$setViewValue('');
            userForm.password.$validate();
          }

          return userForm.password.$valid && userForm.confirmPassword.$valid;
        }
      };

      // pass object back to parent
      ctrl.onGetValid({isValid: getValid.isValid});
    };

    ctrl.$postLink = function(){
      userForm = ctrl.csAcctInfoForm;
    };

    /////////////////////////////

    function setConfirmValidity(){
      // first time focus
      if(userForm.confirmPassword.$untouched && !userForm.confirmPassword.$dirty){
        return;
      }

      // clear validation messages if value not entered
      if(userForm.confirmPassword.$viewValue === ''){
        userForm.confirmPassword.$setPristine();
        userForm.confirmPassword.$setUntouched();
        userForm.confirmPassword.$setValidity('required', true);
        userForm.confirmPassword.$setValidity('invalidComparison', true);
        return;
      }

      // trigger validators in order to set or clear validation message
      userForm.confirmPassword.$validate();
    }

    function verifyConfirm(){
      if(!userForm.confirmPassword.$valid){
        return;
      }

      if(userForm.confirmPassword.$viewValue === ''){
        userForm.confirmPassword.$setValidity('required', false);
      } else if(userForm.confirmPassword.$viewValue !== userForm.password.$viewValue){
        userForm.confirmPassword.$setValidity('invalidComparison', false);
      }
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  // TODO: IF THE USER HAPPENS TO NOT LOAD NEED TO HANDLE THIS ERROR
  angular.module('cs.user.admin').component('csUserRegistrationComplete', {
    bindings: {
        user: '='
    },
    templateUrl: 'cs-user-admin/registration/cs-user-registration-complete.2js.html',
    controller: CsUserRegistrationCompleteCtrl,
  });

  CsUserRegistrationCompleteCtrl.$inject = ['$window', '$timeout', 'csUserMultiFactor'];
  function CsUserRegistrationCompleteCtrl($window, $timeout, mfaService){
    /*jshint validthis:true */
    var ctrl = this;
    var listenerAdded = false;

    ctrl.$onInit = function(){
      ctrl.actions = {
        startMultiSetup: startMultiSetup
      };

      ctrl.mutliFactorComplete = false;
    };

    ///////////////////////////

    function startMultiSetup(){
      mfaService.initFactorSetup(ctrl.user);

      // only add the listener once
      if(!listenerAdded){
        listenerAdded = true;

        $window.addEventListener('tr-mfs-success', function() {
          // done in $timeout in order for scope to udpate
          $timeout(function(){
            ctrl.mutliFactorComplete = true;
          }, 0);
        });
      }
    }
  }

  // multi-factor service for grabbing jwt token
  angular.module('cs.user.admin').service('csUserMultiFactor', multiFactor);

  multiFactor.$inject = ['$window', '$http', 'cs.user.admin.CsToAuthHostMap'];
  function multiFactor($window, $http, csToAuthHostMap){
    /*jshint validthis:true */
    var self = this;
    var authSvcHost = csToAuthHostMap[$window.location.host] || 'http://localhost:9000';
    var api = authSvcHost + '/api/auth/v1/login';

    self.initFactorSetup = initFactorSetup;

    //////////////////////////

    function initFactorSetup(user){
      // make sure the user is valid
      if(angular.isUndefined(user)){
        return;
      }

      $http({
        method: 'POST',
        url: api,
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        data: { firmId: user.firmId, uid: user.userId, pwd: user.password }
      }).then(function(resp){
        // did a jwt get returned?
        $window.trAuth.modules.mfs.init({
          // targetElem: <targetContainer>,
          templateData: {
            authSvcHost: authSvcHost,
            uid: user.userId
          },
          headers: {
            authorization: 'Bearer ' + resp.data.tokenValue
          }
        });
      });
    }
  }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.login').controller('DesktopCtrl', DesktopCtrl);
    DesktopCtrl.$inject = [
        '$location',
        'bmLanguageManager',
        '$scope',
        '$translate',
        '$timeout',
        '$sce',
        'bmUtil',
        'bmSupportedLanguagesMetadata',
        'bmEnvironmentConst',
    ];

    function DesktopCtrl($location, bmLanguageManager, $scope, $translate, $timeout, $sce, bmUtil, bmSupportedLanguagesMetadata, bmEnvironmentConst) {
        var vm = this;
        vm.containsError = true;

        initViewModel();

        /////////////

        function initViewModel(){
            // Make sure languages are loaded first
            var languageUrlParam = $location.search().lang;
            setLanguageListAsync();
            setStartingLanguage();

            var alertSection = angular.element(document.querySelector('div[bento-alert]'));
            alertSection[0].remove();
            // Validate that includes code and state
            if($location.search().code && $location.search().state){
                vm.containsError = false;
                $timeout(function() {
                    var product = 'csdesktop';
                    var url = window.location.origin;
                    var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
                    // Change protocol base on region and language
                    switch (domain) {
                        case '.ca':
                            product = (languageUrlParam === 'fr-CA') ? 'dtfrdesktop' : 'dtendesktop';
                            break;
                        case '.co.uk':
                            product = 'digitadesktop';
                            break;
                        default:
                            product = 'csdesktop';
                            break;
                    }
                    var urlDesktop = 'com.thomsonreuters.' + product + '://v1/oidc/login/callback?state=' + $location.search().state + '&code=' + $location.search().code;
                    window.location = $sce.trustAsResourceUrl(urlDesktop);
                }, 1200);
            } else {
                vm.containsError = true;
            }
        }

        function setStartingLanguage(){
            var languageCode;
            var languageUrlParam = $location.search().lang;
            if(languageUrlParam) {
                //To be used to specify language when visiting from another site like the spearhead marketing site
                var lang;
                for(var x = 0; x < bmSupportedLanguagesMetadata.length; x++) {
                    if(languageUrlParam === bmSupportedLanguagesMetadata[x].code) {
                        lang = bmSupportedLanguagesMetadata[x];
                    }
                }
                if(lang) {
                    languageCode = languageUrlParam;
                    setLanguage(lang);
                } else {
                    languageCode = setStartingLanguageHelper();
                }
                $location.search('lang', null);
            } else {
                languageCode = setStartingLanguageHelper();
            }

            for (var languages in bmSupportedLanguagesMetadata) {
                if (bmSupportedLanguagesMetadata[languages].code === languageCode) {
                    $scope.selectedLanguage = bmSupportedLanguagesMetadata[languages].description;
                }
            }
        }

        function setStartingLanguageHelper() {
            if (bmUtil.cookie('BMLanguageCode') !== undefined) {
                return bmUtil.cookie('BMLanguageCode');
            } else {
                return bmEnvironmentConst.defaultLang;
            }
        }

        function setLanguage(language){
            $scope.selectedLanguage = language.description;
            bmLanguageManager.setUserLanguageAsync(language.code).then(function(){
                setLanguageListAsync();
            });
        }

        function setLanguageListAsync(){
            // Only get languages
            return bmLanguageManager.getLanguagesAsync(false).then(function(languages){
                vm.languageList = languages;
                vm.hasLangSwitch = angular.isDefined(vm.languageList) && vm.languageList.length > 0;
            });
        }

    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.login').controller('DesktopLogoutCtrl', DesktopLogoutCtrl);
    DesktopLogoutCtrl.$inject = [
        '$location',
        'bmLanguageManager',
        '$scope',
        '$translate',
        '$timeout',
        'bmUtil',
        'bmSupportedLanguagesMetadata',
        'bmEnvironmentConst',
    ];

    function DesktopLogoutCtrl($location, bmLanguageManager, $scope, $translate, $timeout, bmUtil, bmSupportedLanguagesMetadata, bmEnvironmentConst) {
        var vm = this;

        initViewModel();

        function initViewModel(){
            // Make sure languages are loaded first
            var languageUrlParam = $location.search().lang;
            setLanguageListAsync();
            setStartingLanguage();

            var alertSection = angular.element(document.querySelector('div[bento-alert]'));
            alertSection[0].remove();
            $timeout(function() {
                var product = 'csdesktop';
                var url = window.location.origin;
                var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
                // Change protocol base on region and language
                switch (domain) {
                    case '.ca':
                        product = (languageUrlParam === 'fr-CA') ? 'dtfrdesktop' : 'dtendesktop';
                        break;
                    case '.co.uk':
                        product = 'digitadesktop';
                        break;
                    default:
                        product = 'csdesktop';
                        break;
                }
                var urlDesktop = 'com.thomsonreuters.' + product + '://v1/oidc/logout/callback';
                window.location = urlDesktop;
            }, 1200);
        }

        function setStartingLanguage(){
            var languageCode;
            var languageUrlParam = $location.search().lang;
            if(languageUrlParam) {
                //To be used to specify language when visiting from another site like the spearhead marketing site
                var lang;
                for(var x = 0; x < bmSupportedLanguagesMetadata.length; x++) {
                    if(languageUrlParam === bmSupportedLanguagesMetadata[x].code) {
                        lang = bmSupportedLanguagesMetadata[x];
                    }
                }
                if(lang) {
                    languageCode = languageUrlParam;
                    setLanguage(lang);
                } else {
                    languageCode = setStartingLanguageHelper();
                }
                $location.search('lang', null);
            } else {
                languageCode = setStartingLanguageHelper();
            }

            for (var languages in bmSupportedLanguagesMetadata) {
                if (bmSupportedLanguagesMetadata[languages].code === languageCode) {
                    $scope.selectedLanguage = bmSupportedLanguagesMetadata[languages].description;
                }
            }
        }

        function setStartingLanguageHelper() {
            if (bmUtil.cookie('BMLanguageCode') !== undefined) {
                return bmUtil.cookie('BMLanguageCode');
            } else {
                return bmEnvironmentConst.defaultLang;
            }
        }

        function setLanguage(language){
            $scope.selectedLanguage = language.description;
            bmLanguageManager.setUserLanguageAsync(language.code).then(function(){
                setLanguageListAsync();
            });
        }

        function setLanguageListAsync(){
            // Only get languages
            return bmLanguageManager.getLanguagesAsync(false).then(function(languages){
                vm.languageList = languages;
                vm.hasLangSwitch = angular.isDefined(vm.languageList) && vm.languageList.length > 0;
            });
        }

    }
})(window.angular);
